var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key2, value) => {
  __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
  return value;
};
import { Comment, Fragment, Text, isVNode, defineComponent, reactive, getCurrentInstance, onMounted, onUpdated, onUnmounted, watch, inject, computed, unref, createVNode, provide, Transition as Transition$2, TransitionGroup as TransitionGroup$1, Teleport, ref, render, h as h$2, nextTick, watchEffect, withDirectives, resolveDirective, onBeforeUnmount, cloneVNode, toRef, withModifiers, vShow, onBeforeMount, createTextVNode, isRef, toRefs, shallowRef, toRaw, useAttrs, onBeforeUpdate, camelize as camelize$1, onActivated, renderSlot, readonly, resolveComponent, openBlock, createBlock, normalizeProps, guardReactiveProps, createSlots, renderList, withCtx, mergeProps, normalizeClass, toDisplayString, createCommentVNode, createElementVNode, resolveDynamicComponent, createElementBlock, normalizeStyle, pushScopeId, popScopeId, withKeys, getCurrentScope, onScopeDispose, warn } from "vue";
import QRCode, { toDataURL } from "qrcode";
import JsBarcode from "jsbarcode";
var _default = "";
var index$N = "";
var index$M = "";
var index$L = "";
var index$K = "";
var index$J = "";
var index$I = "";
var index$H = "";
var index$G = "";
var index$F = "";
var index$E = "";
var index$D = "";
var index$C = "";
var index$B = "";
var index$A = "";
var index$z = "";
var index$y = "";
var index$x = "";
var index$w = "";
var index$v = "";
var index$u = "";
var index$t = "";
var index$s = "";
var index$r = "";
var index$q = "";
var index$p = "";
var index$o = "";
var index$n = "";
var index$m = "";
var index$l = "";
var index$k = "";
var index$j = "";
var index$i = "";
var index$h = "";
var index$g = "";
var index$f = "";
var index$e = "";
var index$d = "";
var index$c = "";
var base = "";
var elEmpty = "";
var elVirtualList = "";
var elScrollbar = "";
var elTableV2 = "";
function _defineProperty$R(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function ownKeys$2(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source), true).forEach(function(key2) {
      _defineProperty$R(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
var isFunction$3 = function isFunction(val) {
  return typeof val === "function";
};
var isArray$4 = Array.isArray;
var isString$2 = function isString(val) {
  return typeof val === "string";
};
var isObject$5 = function isObject(val) {
  return val !== null && _typeof$2(val) === "object";
};
var onRE = /^on[^a-z]/;
var isOn = function isOn2(key2) {
  return onRE.test(key2);
};
var cacheStringFunction = function cacheStringFunction2(fn) {
  var cache2 = Object.create(null);
  return function(str) {
    var hit = cache2[str];
    return hit || (cache2[str] = fn(str));
  };
};
var camelizeRE = /-(\w)/g;
var camelize = cacheStringFunction(function(str) {
  return str.replace(camelizeRE, function(_2, c2) {
    return c2 ? c2.toUpperCase() : "";
  });
});
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cacheStringFunction(function(str) {
  return str.replace(hyphenateRE, "-$1").toLowerCase();
});
var hasOwnProperty$e = Object.prototype.hasOwnProperty;
var hasOwn$1 = function hasOwn(val, key2) {
  return hasOwnProperty$e.call(val, key2);
};
function resolvePropValue(options, props2, key2, value) {
  var opt = options[key2];
  if (opt != null) {
    var hasDefault = hasOwn$1(opt, "default");
    if (hasDefault && value === void 0) {
      var defaultValue = opt.default;
      value = opt.type !== Function && isFunction$3(defaultValue) ? defaultValue() : defaultValue;
    }
    if (opt.type === Boolean) {
      if (!hasOwn$1(props2, key2) && !hasDefault) {
        value = false;
      } else if (value === "") {
        value = true;
      }
    }
  }
  return value;
}
function toPx(val) {
  if (typeof val === "number")
    return "".concat(val, "px");
  return val;
}
function renderHelper(v2) {
  var props2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var defaultV = arguments.length > 2 ? arguments[2] : void 0;
  if (typeof v2 === "function") {
    return v2(props2);
  }
  return v2 !== null && v2 !== void 0 ? v2 : defaultV;
}
function classNames() {
  var classes = [];
  for (var i2 = 0; i2 < arguments.length; i2++) {
    var value = i2 < 0 || arguments.length <= i2 ? void 0 : arguments[i2];
    if (!value)
      continue;
    if (isString$2(value)) {
      classes.push(value);
    } else if (isArray$4(value)) {
      for (var _i = 0; _i < value.length; _i++) {
        var inner = classNames(value[_i]);
        if (inner) {
          classes.push(inner);
        }
      }
    } else if (isObject$5(value)) {
      for (var name2 in value) {
        if (value[name2]) {
          classes.push(name2);
        }
      }
    }
  }
  return classes.join(" ");
}
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key2) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key2) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return function() {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      get: function() {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    class_1.prototype.get = function(key2) {
      var index2 = getIndex(this.__entries__, key2);
      var entry = this.__entries__[index2];
      return entry && entry[1];
    };
    class_1.prototype.set = function(key2, value) {
      var index2 = getIndex(this.__entries__, key2);
      if (~index2) {
        this.__entries__[index2][1] = value;
      } else {
        this.__entries__.push([key2, value]);
      }
    };
    class_1.prototype.delete = function(key2) {
      var entries = this.__entries__;
      var index2 = getIndex(entries, key2);
      if (~index2) {
        entries.splice(index2, 1);
      }
    };
    class_1.prototype.has = function(key2) {
      return !!~getIndex(this.__entries__, key2);
    };
    class_1.prototype.clear = function() {
      this.__entries__.splice(0);
    };
    class_1.prototype.forEach = function(callback, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a2 = this.__entries__; _i < _a2.length; _i++) {
        var entry = _a2[_i];
        callback.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle$1(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = function() {
  function ResizeObserverController2() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
  }
  ResizeObserverController2.prototype.addObserver = function(observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    if (!this.connected_) {
      this.connect_();
    }
  };
  ResizeObserverController2.prototype.removeObserver = function(observer) {
    var observers2 = this.observers_;
    var index2 = observers2.indexOf(observer);
    if (~index2) {
      observers2.splice(index2, 1);
    }
    if (!observers2.length && this.connected_) {
      this.disconnect_();
    }
  };
  ResizeObserverController2.prototype.refresh = function() {
    var changesDetected = this.updateObservers_();
    if (changesDetected) {
      this.refresh();
    }
  };
  ResizeObserverController2.prototype.updateObservers_ = function() {
    var activeObservers = this.observers_.filter(function(observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    activeObservers.forEach(function(observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  ResizeObserverController2.prototype.connect_ = function() {
    if (!isBrowser || this.connected_) {
      return;
    }
    document.addEventListener("transitionend", this.onTransitionEnd_);
    window.addEventListener("resize", this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener("DOMSubtreeModified", this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  ResizeObserverController2.prototype.disconnect_ = function() {
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener("transitionend", this.onTransitionEnd_);
    window.removeEventListener("resize", this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener("DOMSubtreeModified", this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  ResizeObserverController2.prototype.onTransitionEnd_ = function(_a2) {
    var _b = _a2.propertyName, propertyName = _b === void 0 ? "" : _b;
    var isReflowProperty = transitionKeys.some(function(key2) {
      return !!~propertyName.indexOf(key2);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  ResizeObserverController2.getInstance = function() {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController2();
    }
    return this.instance_;
  };
  ResizeObserverController2.instance_ = null;
  return ResizeObserverController2;
}();
var defineConfigurable = function(target, props2) {
  for (var _i = 0, _a2 = Object.keys(props2); _i < _a2.length; _i++) {
    var key2 = _a2[_i];
    Object.defineProperty(target, key2, {
      value: props2[key2],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position2) {
    var value = styles["border-" + position2 + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position2 = positions_1[_i];
    var value = styles["padding-" + position2];
    paddings[position2] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a2) {
  var x2 = _a2.x, y2 = _a2.y, width = _a2.width, height = _a2.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x2,
    y: y2,
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: height + y2,
    left: x2
  });
  return rect;
}
function createRectInit(x2, y2, width, height) {
  return { x: x2, y: y2, width, height };
}
var ResizeObservation = function() {
  function ResizeObservation2(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  ResizeObservation2.prototype.isActive = function() {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  ResizeObservation2.prototype.broadcastRect = function() {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation2;
}();
var ResizeObserverEntry = function() {
  function ResizeObserverEntry2(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    defineConfigurable(this, { target, contentRect });
  }
  return ResizeObserverEntry2;
}();
var ResizeObserverSPI = function() {
  function ResizeObserverSPI2(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();
    if (typeof callback !== "function") {
      throw new TypeError("The callback provided as parameter 1 is not a function.");
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  ResizeObserverSPI2.prototype.observe = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    this.controller_.refresh();
  };
  ResizeObserverSPI2.prototype.unobserve = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  ResizeObserverSPI2.prototype.disconnect = function() {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  ResizeObserverSPI2.prototype.gatherActive = function() {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function(observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  ResizeObserverSPI2.prototype.broadcastActive = function() {
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    var entries = this.activeObservations_.map(function(observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  ResizeObserverSPI2.prototype.clearActive = function() {
    this.activeObservations_.splice(0);
  };
  ResizeObserverSPI2.prototype.hasActive = function() {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI2;
}();
var observers = typeof WeakMap !== "undefined" ? new WeakMap() : new MapShim();
var ResizeObserver$2 = function() {
  function ResizeObserver2(callback) {
    if (!(this instanceof ResizeObserver2)) {
      throw new TypeError("Cannot call a class as a function.");
    }
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver2;
}();
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method4) {
  ResizeObserver$2.prototype[method4] = function() {
    var _a2;
    return (_a2 = observers.get(this))[method4].apply(_a2, arguments);
  };
});
var index$b = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$2;
}();
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit$2(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$2(o2, minLen);
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(arr, i2) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i2) || _unsupportedIterableToArray$2(arr, i2) || _nonIterableRest$2();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$2(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread();
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
var root$1 = root;
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
var objectProto$f = Object.prototype;
var hasOwnProperty$d = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var objectTag$4 = "[object Object]";
var funcProto$2 = Function.prototype, objectProto$d = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$c = objectProto$d.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);
function isPlainObject$2(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$4) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$c.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
var isValid$1 = function isValid(value) {
  return value !== void 0 && value !== null && value !== "";
};
var isValid$2 = isValid$1;
var initDefaultProps = function initDefaultProps2(types2, defaultProps2) {
  var propTypes2 = _extends$2({}, types2);
  Object.keys(defaultProps2).forEach(function(k2) {
    var prop = propTypes2[k2];
    if (prop) {
      if (prop.type || prop.default) {
        prop.default = defaultProps2[k2];
      } else if (prop.def) {
        prop.def(defaultProps2[k2]);
      } else {
        propTypes2[k2] = {
          type: prop,
          default: defaultProps2[k2]
        };
      }
    } else {
      throw new Error("not have ".concat(k2, " prop"));
    }
  });
  return propTypes2;
};
var initDefaultProps$1 = initDefaultProps;
var splitAttrs = function splitAttrs2(attrs) {
  var allAttrs = Object.keys(attrs);
  var eventAttrs = {};
  var onEvents = {};
  var extraAttrs = {};
  for (var i2 = 0, l2 = allAttrs.length; i2 < l2; i2++) {
    var key2 = allAttrs[i2];
    if (isOn(key2)) {
      eventAttrs[key2[2].toLowerCase() + key2.slice(3)] = attrs[key2];
      onEvents[key2] = attrs[key2];
    } else {
      extraAttrs[key2] = attrs[key2];
    }
  }
  return {
    onEvents,
    events: eventAttrs,
    extraAttrs
  };
};
var parseStyleText = function parseStyleText2() {
  var cssText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var camel = arguments.length > 1 ? arguments[1] : void 0;
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  if (_typeof$2(cssText) === "object")
    return cssText;
  cssText.split(listDelimiter).forEach(function(item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      if (tmp.length > 1) {
        var k2 = camel ? camelize(tmp[0].trim()) : tmp[0].trim();
        res[k2] = tmp[1].trim();
      }
    }
  });
  return res;
};
var hasProp = function hasProp2(instance2, prop) {
  return instance2[prop] !== void 0;
};
var flattenChildren = function flattenChildren2() {
  var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var filterEmpty2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  var temp = Array.isArray(children) ? children : [children];
  var res = [];
  temp.forEach(function(child) {
    if (Array.isArray(child)) {
      res.push.apply(res, _toConsumableArray(flattenChildren2(child, filterEmpty2)));
    } else if (child && child.type === Fragment) {
      res.push.apply(res, _toConsumableArray(flattenChildren2(child.children, filterEmpty2)));
    } else if (child && isVNode(child)) {
      if (filterEmpty2 && !isEmptyElement(child)) {
        res.push(child);
      } else if (!filterEmpty2) {
        res.push(child);
      }
    } else if (isValid$2(child)) {
      res.push(child);
    }
  });
  return res;
};
var getSlot$1 = function getSlot(self2) {
  var name2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (isVNode(self2)) {
    if (self2.type === Fragment) {
      return name2 === "default" ? flattenChildren(self2.children) : [];
    } else if (self2.children && self2.children[name2]) {
      return flattenChildren(self2.children[name2](options));
    } else {
      return [];
    }
  } else {
    var res = self2.$slots[name2] && self2.$slots[name2](options);
    return flattenChildren(res);
  }
};
var findDOMNode = function findDOMNode2(instance2) {
  var _a2;
  var node = ((_a2 = instance2 === null || instance2 === void 0 ? void 0 : instance2.vnode) === null || _a2 === void 0 ? void 0 : _a2.el) || instance2 && (instance2.$el || instance2);
  while (node && !node.tagName) {
    node = node.nextSibling;
  }
  return node;
};
var getOptionProps = function getOptionProps2(instance2) {
  var res = {};
  if (instance2.$ && instance2.$.vnode) {
    var props2 = instance2.$.vnode.props || {};
    Object.keys(instance2.$props).forEach(function(k2) {
      var v2 = instance2.$props[k2];
      var hyphenateKey = hyphenate(k2);
      if (v2 !== void 0 || hyphenateKey in props2) {
        res[k2] = v2;
      }
    });
  } else if (isVNode(instance2) && _typeof$2(instance2.type) === "object") {
    var originProps = instance2.props || {};
    var _props = {};
    Object.keys(originProps).forEach(function(key2) {
      _props[camelize(key2)] = originProps[key2];
    });
    var options = instance2.type.props || {};
    Object.keys(options).forEach(function(k2) {
      var v2 = resolvePropValue(options, _props, k2, _props[k2]);
      if (v2 !== void 0 || k2 in _props) {
        res[k2] = v2;
      }
    });
  }
  return res;
};
var getComponent = function getComponent2(instance2) {
  var prop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : instance2;
  var execute = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
  var com = void 0;
  if (instance2.$) {
    var temp = instance2[prop];
    if (temp !== void 0) {
      return typeof temp === "function" && execute ? temp(options) : temp;
    } else {
      com = instance2.$slots[prop];
      com = execute && com ? com(options) : com;
    }
  } else if (isVNode(instance2)) {
    var _temp = instance2.props && instance2.props[prop];
    if (_temp !== void 0 && instance2.props !== null) {
      return typeof _temp === "function" && execute ? _temp(options) : _temp;
    } else if (instance2.type === Fragment) {
      com = instance2.children;
    } else if (instance2.children && instance2.children[prop]) {
      com = instance2.children[prop];
      com = execute && com ? com(options) : com;
    }
  }
  if (Array.isArray(com)) {
    com = flattenChildren(com);
    com = com.length === 1 ? com[0] : com;
    com = com.length === 0 ? void 0 : com;
  }
  return com;
};
function getEvents() {
  var ele = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var on2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  var props2 = {};
  if (ele.$) {
    props2 = _extends$2(_extends$2({}, props2), ele.$attrs);
  } else {
    props2 = _extends$2(_extends$2({}, props2), ele.props);
  }
  return splitAttrs(props2)[on2 ? "onEvents" : "events"];
}
function getClass(ele) {
  var props2 = (isVNode(ele) ? ele.props : ele.$attrs) || {};
  var tempCls = props2.class || {};
  var cls = {};
  if (typeof tempCls === "string") {
    tempCls.split(" ").forEach(function(c2) {
      cls[c2.trim()] = true;
    });
  } else if (Array.isArray(tempCls)) {
    classNames(tempCls).split(" ").forEach(function(c2) {
      cls[c2.trim()] = true;
    });
  } else {
    cls = _extends$2(_extends$2({}, cls), tempCls);
  }
  return cls;
}
function getStyle(ele, camel) {
  var props2 = (isVNode(ele) ? ele.props : ele.$attrs) || {};
  var style2 = props2.style || {};
  if (typeof style2 === "string") {
    style2 = parseStyleText(style2, camel);
  } else if (camel && style2) {
    var res = {};
    Object.keys(style2).forEach(function(k2) {
      return res[camelize(k2)] = style2[k2];
    });
    return res;
  }
  return style2;
}
function isEmptyElement(c2) {
  return c2 && (c2.type === Comment || c2.type === Fragment && c2.children.length === 0 || c2.type === Text && c2.children.trim() === "");
}
function filterEmpty() {
  var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var res = [];
  children.forEach(function(child) {
    if (Array.isArray(child)) {
      res.push.apply(res, _toConsumableArray(child));
    } else if (child.type === Fragment) {
      res.push.apply(res, _toConsumableArray(child.children));
    } else {
      res.push(child);
    }
  });
  return res.filter(function(c2) {
    return !isEmptyElement(c2);
  });
}
function isValidElement(element) {
  if (Array.isArray(element) && element.length === 1) {
    element = element[0];
  }
  return element && element.__v_isVNode && _typeof$2(element.type) !== "symbol";
}
function getPropsSlot(slots, props2) {
  var prop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "default";
  var _a2, _b;
  return (_a2 = props2[prop]) !== null && _a2 !== void 0 ? _a2 : (_b = slots[prop]) === null || _b === void 0 ? void 0 : _b.call(slots);
}
var ResizeObserver$1 = defineComponent({
  name: "ResizeObserver",
  props: {
    disabled: Boolean,
    onResize: Function
  },
  emits: ["resize"],
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var state = reactive({
      width: 0,
      height: 0,
      offsetHeight: 0,
      offsetWidth: 0
    });
    var currentElement = null;
    var resizeObserver = null;
    var destroyObserver = function destroyObserver2() {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
    var onResize = function onResize2(entries) {
      var onResize3 = props2.onResize;
      var target = entries[0].target;
      var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
      var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
      var fixedWidth = Math.floor(width);
      var fixedHeight = Math.floor(height);
      if (state.width !== fixedWidth || state.height !== fixedHeight || state.offsetWidth !== offsetWidth || state.offsetHeight !== offsetHeight) {
        var size = {
          width: fixedWidth,
          height: fixedHeight,
          offsetWidth,
          offsetHeight
        };
        _extends$2(state, size);
        if (onResize3) {
          Promise.resolve().then(function() {
            onResize3(_extends$2(_extends$2({}, size), {
              offsetWidth,
              offsetHeight
            }), target);
          });
        }
      }
    };
    var instance2 = getCurrentInstance();
    var registerObserver = function registerObserver2() {
      var disabled = props2.disabled;
      if (disabled) {
        destroyObserver();
        return;
      }
      var element = findDOMNode(instance2);
      var elementChanged = element !== currentElement;
      if (elementChanged) {
        destroyObserver();
        currentElement = element;
      }
      if (!resizeObserver && element) {
        resizeObserver = new index$b(onResize);
        resizeObserver.observe(element);
      }
    };
    onMounted(function() {
      registerObserver();
    });
    onUpdated(function() {
      registerObserver();
    });
    onUnmounted(function() {
      destroyObserver();
    });
    watch(function() {
      return props2.disabled;
    }, function() {
      registerObserver();
    }, {
      flush: "post"
    });
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)[0];
    };
  }
});
var raf$1 = function raf(callback) {
  return setTimeout(callback, 16);
};
var caf = function caf2(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf$1 = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id);
      callback();
    } else {
      var realId = raf$1(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
}
wrapperRaf.cancel = function(id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};
var tuple$1 = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
var withInstall$2 = function withInstall(comp) {
  var c2 = comp;
  c2.install = function(app) {
    app.component(c2.displayName || c2.name, comp);
  };
  return comp;
};
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, "passive", {
    get: function get2() {
      supportsPassive = true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e2) {
}
var supportsPassive$1 = supportsPassive;
function addEventListenerWrap(target, eventType, cb, option2) {
  if (target && target.addEventListener) {
    var opt = option2;
    if (opt === void 0 && supportsPassive$1 && (eventType === "touchstart" || eventType === "touchmove" || eventType === "wheel")) {
      opt = {
        passive: false
      };
    }
    target.addEventListener(eventType, cb, opt);
  }
  return {
    remove: function remove() {
      if (target && target.removeEventListener) {
        target.removeEventListener(eventType, cb);
      }
    }
  };
}
var enUS$1 = {
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "",
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages"
};
var locale$2 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "Ok",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: true,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
var CalendarLocale = locale$2;
var locale$1 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
var TimePicker$3 = locale$1;
var locale = {
  lang: _extends$2({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, CalendarLocale),
  timePickerLocale: _extends$2({}, TimePicker$3)
};
var enUS = locale;
var typeTemplate$1 = "${label} is not a valid ${type}";
var localeValues = {
  locale: "en",
  Pagination: enUS$1,
  DatePicker: enUS,
  TimePicker: TimePicker$3,
  Calendar: enUS,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No Data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate$1,
        method: typeTemplate$1,
        array: typeTemplate$1,
        object: typeTemplate$1,
        number: typeTemplate$1,
        date: typeTemplate$1,
        boolean: typeTemplate$1,
        integer: typeTemplate$1,
        float: typeTemplate$1,
        regexp: typeTemplate$1,
        email: typeTemplate$1,
        url: typeTemplate$1,
        hex: typeTemplate$1
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  }
};
var defaultLocale = localeValues;
var LocaleReceiver = defineComponent({
  name: "LocaleReceiver",
  props: {
    componentName: String,
    defaultLocale: {
      type: [Object, Function]
    },
    children: {
      type: Function
    }
  },
  setup: function setup2(props2, _ref) {
    var slots = _ref.slots;
    var localeData2 = inject("localeData", {});
    var locale2 = computed(function() {
      var _props$componentName = props2.componentName, componentName = _props$componentName === void 0 ? "global" : _props$componentName, defaultLocale$1 = props2.defaultLocale;
      var locale3 = defaultLocale$1 || defaultLocale[componentName || "global"];
      var antLocale = localeData2.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends$2(_extends$2({}, typeof locale3 === "function" ? locale3() : locale3), localeFromContext || {});
    });
    var localeCode = computed(function() {
      var antLocale = localeData2.antLocale;
      var localeCode2 = antLocale && antLocale.locale;
      if (antLocale && antLocale.exist && !localeCode2) {
        return defaultLocale.locale;
      }
      return localeCode2;
    });
    return function() {
      var children = props2.children || slots.default;
      var antLocale = localeData2.antLocale;
      return children === null || children === void 0 ? void 0 : children(locale2.value, localeCode.value, antLocale);
    };
  }
});
function useLocaleReceiver(componentName, defaultLocale$1, propsLocale) {
  var localeData2 = inject("localeData", {});
  var componentLocale = computed(function() {
    var antLocale = localeData2.antLocale;
    var locale2 = unref(defaultLocale$1) || defaultLocale[componentName || "global"];
    var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
    return _extends$2(_extends$2(_extends$2({}, typeof locale2 === "function" ? locale2() : locale2), localeFromContext || {}), unref(propsLocale) || {});
  });
  return [componentLocale];
}
var Empty$3 = function Empty() {
  var _useConfigInject = useConfigInject("empty", {}), getPrefixCls2 = _useConfigInject.getPrefixCls;
  var prefixCls2 = getPrefixCls2("empty-img-default");
  return createVNode("svg", {
    "class": prefixCls2,
    "width": "184",
    "height": "152",
    "viewBox": "0 0 184 152"
  }, [createVNode("g", {
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("g", {
    "transform": "translate(24 31.67)"
  }, [createVNode("ellipse", {
    "class": "".concat(prefixCls2, "-ellipse"),
    "cx": "67.797",
    "cy": "106.89",
    "rx": "67.797",
    "ry": "12.668"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls2, "-path-1"),
    "d": "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls2, "-path-2"),
    "d": "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    "transform": "translate(13.56)"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls2, "-path-3"),
    "d": "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls2, "-path-4"),
    "d": "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  }, null)]), createVNode("path", {
    "class": "".concat(prefixCls2, "-path-5"),
    "d": "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }, null), createVNode("g", {
    "class": "".concat(prefixCls2, "-g"),
    "transform": "translate(149.65 15.383)"
  }, [createVNode("ellipse", {
    "cx": "20.654",
    "cy": "3.167",
    "rx": "2.849",
    "ry": "2.815"
  }, null), createVNode("path", {
    "d": "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }, null)])])]);
};
Empty$3.PRESENTED_IMAGE_DEFAULT = true;
var DefaultEmptyImg = Empty$3;
var Simple = function Simple2() {
  var _useConfigInject = useConfigInject("empty", {}), getPrefixCls2 = _useConfigInject.getPrefixCls;
  var prefixCls2 = getPrefixCls2("empty-img-simple");
  return createVNode("svg", {
    "class": prefixCls2,
    "width": "64",
    "height": "41",
    "viewBox": "0 0 64 41"
  }, [createVNode("g", {
    "transform": "translate(0 1)",
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("ellipse", {
    "class": "".concat(prefixCls2, "-ellipse"),
    "fill": "#F5F5F5",
    "cx": "32",
    "cy": "33",
    "rx": "32",
    "ry": "7"
  }, null), createVNode("g", {
    "class": "".concat(prefixCls2, "-g"),
    "fill-rule": "nonzero",
    "stroke": "#D9D9D9"
  }, [createVNode("path", {
    "d": "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }, null), createVNode("path", {
    "d": "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    "fill": "#FAFAFA",
    "class": "".concat(prefixCls2, "-path")
  }, null)])])]);
};
Simple.PRESENTED_IMAGE_SIMPLE = true;
var SimpleEmptyImg = Simple;
function e$1(e2, t2) {
  for (var n2 = 0; n2 < t2.length; n2++) {
    var r2 = t2[n2];
    r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
  }
}
function t$2(t2, n2, r2) {
  return n2 && e$1(t2.prototype, n2), r2 && e$1(t2, r2), t2;
}
function n$2() {
  return (n$2 = Object.assign || function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];
      for (var r2 in n2)
        Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
    }
    return e2;
  }).apply(this, arguments);
}
function r$2(e2, t2) {
  e2.prototype = Object.create(t2.prototype), e2.prototype.constructor = e2, e2.__proto__ = t2;
}
function i$1(e2, t2) {
  if (e2 == null)
    return {};
  var n2, r2, i2 = {}, o2 = Object.keys(e2);
  for (r2 = 0; r2 < o2.length; r2++)
    t2.indexOf(n2 = o2[r2]) >= 0 || (i2[n2] = e2[n2]);
  return i2;
}
function o$1(e2) {
  return ((t2 = e2) != null && typeof t2 == "object" && Array.isArray(t2) === false) == 1 && Object.prototype.toString.call(e2) === "[object Object]";
  var t2;
}
var u$1 = Object.prototype, a$1 = u$1.toString, f$1 = u$1.hasOwnProperty, c$1 = /^\s*function (\w+)/;
function l$1(e2) {
  var t2, n2 = (t2 = e2 == null ? void 0 : e2.type) !== null && t2 !== void 0 ? t2 : e2;
  if (n2) {
    var r2 = n2.toString().match(c$1);
    return r2 ? r2[1] : "";
  }
  return "";
}
var s$1 = function(e2) {
  var t2, n2;
  return o$1(e2) !== false && typeof (t2 = e2.constructor) == "function" && o$1(n2 = t2.prototype) !== false && n2.hasOwnProperty("isPrototypeOf") !== false;
}, v$1 = function(e2) {
  return e2;
}, y$1 = v$1;
var d$1 = function(e2, t2) {
  return f$1.call(e2, t2);
}, h$1 = Number.isInteger || function(e2) {
  return typeof e2 == "number" && isFinite(e2) && Math.floor(e2) === e2;
}, b$1 = Array.isArray || function(e2) {
  return a$1.call(e2) === "[object Array]";
}, O$1 = function(e2) {
  return a$1.call(e2) === "[object Function]";
}, g$1 = function(e2) {
  return s$1(e2) && d$1(e2, "_vueTypes_name");
}, m$1 = function(e2) {
  return s$1(e2) && (d$1(e2, "type") || ["_vueTypes_name", "validator", "default", "required"].some(function(t2) {
    return d$1(e2, t2);
  }));
};
function j$1(e2, t2) {
  return Object.defineProperty(e2.bind(t2), "__original", { value: e2 });
}
function _$1(e2, t2, n2) {
  var r2;
  n2 === void 0 && (n2 = false);
  var i2 = true, o2 = "";
  r2 = s$1(e2) ? e2 : { type: e2 };
  var u2 = g$1(r2) ? r2._vueTypes_name + " - " : "";
  if (m$1(r2) && r2.type !== null) {
    if (r2.type === void 0 || r2.type === true)
      return i2;
    if (!r2.required && t2 === void 0)
      return i2;
    b$1(r2.type) ? (i2 = r2.type.some(function(e3) {
      return _$1(e3, t2, true) === true;
    }), o2 = r2.type.map(function(e3) {
      return l$1(e3);
    }).join(" or ")) : i2 = (o2 = l$1(r2)) === "Array" ? b$1(t2) : o2 === "Object" ? s$1(t2) : o2 === "String" || o2 === "Number" || o2 === "Boolean" || o2 === "Function" ? function(e3) {
      if (e3 == null)
        return "";
      var t3 = e3.constructor.toString().match(c$1);
      return t3 ? t3[1] : "";
    }(t2) === o2 : t2 instanceof r2.type;
  }
  if (!i2) {
    var a2 = u2 + 'value "' + t2 + '" should be of type "' + o2 + '"';
    return n2 === false ? (y$1(a2), false) : a2;
  }
  if (d$1(r2, "validator") && O$1(r2.validator)) {
    var f2 = y$1, v2 = [];
    if (y$1 = function(e3) {
      v2.push(e3);
    }, i2 = r2.validator(t2), y$1 = f2, !i2) {
      var p2 = (v2.length > 1 ? "* " : "") + v2.join("\n* ");
      return v2.length = 0, n2 === false ? (y$1(p2), i2) : p2;
    }
  }
  return i2;
}
function T$1(e2, t2) {
  var n2 = Object.defineProperties(t2, { _vueTypes_name: { value: e2, writable: true }, isRequired: { get: function() {
    return this.required = true, this;
  } }, def: { value: function(e3) {
    return e3 !== void 0 || this.default ? O$1(e3) || _$1(this, e3, true) === true ? (this.default = b$1(e3) ? function() {
      return [].concat(e3);
    } : s$1(e3) ? function() {
      return Object.assign({}, e3);
    } : e3, this) : (y$1(this._vueTypes_name + ' - invalid default value: "' + e3 + '"'), this) : this;
  } } }), r2 = n2.validator;
  return O$1(r2) && (n2.validator = j$1(r2, n2)), n2;
}
function w$1(e2, t2) {
  var n2 = T$1(e2, t2);
  return Object.defineProperty(n2, "validate", { value: function(e3) {
    return O$1(this.validator) && y$1(this._vueTypes_name + " - calling .validate() will overwrite the current custom validator function. Validator info:\n" + JSON.stringify(this)), this.validator = j$1(e3, this), this;
  } });
}
function k$1(e2, t2, n2) {
  var r2, o2, u2 = (r2 = t2, o2 = {}, Object.getOwnPropertyNames(r2).forEach(function(e3) {
    o2[e3] = Object.getOwnPropertyDescriptor(r2, e3);
  }), Object.defineProperties({}, o2));
  if (u2._vueTypes_name = e2, !s$1(n2))
    return u2;
  var a2, f2, c2 = n2.validator, l2 = i$1(n2, ["validator"]);
  if (O$1(c2)) {
    var v2 = u2.validator;
    v2 && (v2 = (f2 = (a2 = v2).__original) !== null && f2 !== void 0 ? f2 : a2), u2.validator = j$1(v2 ? function(e3) {
      return v2.call(this, e3) && c2.call(this, e3);
    } : c2, u2);
  }
  return Object.assign(u2, l2);
}
function P$1(e2) {
  return e2.replace(/^(?!\s*$)/gm, "  ");
}
var x$1 = function() {
  return w$1("any", {});
}, A$1 = function() {
  return w$1("function", { type: Function });
}, E$1 = function() {
  return w$1("boolean", { type: Boolean });
}, N$1 = function() {
  return w$1("string", { type: String });
}, q$1 = function() {
  return w$1("number", { type: Number });
}, S$1 = function() {
  return w$1("array", { type: Array });
}, V$1 = function() {
  return w$1("object", { type: Object });
}, F$1 = function() {
  return T$1("integer", { type: Number, validator: function(e2) {
    return h$1(e2);
  } });
}, D$1 = function() {
  return T$1("symbol", { validator: function(e2) {
    return typeof e2 == "symbol";
  } });
};
function L$1(e2, t2) {
  if (t2 === void 0 && (t2 = "custom validation failed"), typeof e2 != "function")
    throw new TypeError("[VueTypes error]: You must provide a function as argument");
  return T$1(e2.name || "<<anonymous function>>", { validator: function(n2) {
    var r2 = e2(n2);
    return r2 || y$1(this._vueTypes_name + " - " + t2), r2;
  } });
}
function Y$1(e2) {
  if (!b$1(e2))
    throw new TypeError("[VueTypes error]: You must provide an array as argument.");
  var t2 = 'oneOf - value should be one of "' + e2.join('", "') + '".', n2 = e2.reduce(function(e3, t3) {
    if (t3 != null) {
      var n3 = t3.constructor;
      e3.indexOf(n3) === -1 && e3.push(n3);
    }
    return e3;
  }, []);
  return T$1("oneOf", { type: n2.length > 0 ? n2 : void 0, validator: function(n3) {
    var r2 = e2.indexOf(n3) !== -1;
    return r2 || y$1(t2), r2;
  } });
}
function B$1(e2) {
  if (!b$1(e2))
    throw new TypeError("[VueTypes error]: You must provide an array as argument");
  for (var t2 = false, n2 = [], r2 = 0; r2 < e2.length; r2 += 1) {
    var i2 = e2[r2];
    if (m$1(i2)) {
      if (g$1(i2) && i2._vueTypes_name === "oneOf") {
        n2 = n2.concat(i2.type);
        continue;
      }
      if (O$1(i2.validator) && (t2 = true), i2.type !== true && i2.type) {
        n2 = n2.concat(i2.type);
        continue;
      }
    }
    n2.push(i2);
  }
  return n2 = n2.filter(function(e3, t3) {
    return n2.indexOf(e3) === t3;
  }), T$1("oneOfType", t2 ? { type: n2, validator: function(t3) {
    var n3 = [], r3 = e2.some(function(e3) {
      var r4 = _$1(g$1(e3) && e3._vueTypes_name === "oneOf" ? e3.type || null : e3, t3, true);
      return typeof r4 == "string" && n3.push(r4), r4 === true;
    });
    return r3 || y$1("oneOfType - provided value does not match any of the " + n3.length + " passed-in validators:\n" + P$1(n3.join("\n"))), r3;
  } } : { type: n2 });
}
function I$1(e2) {
  return T$1("arrayOf", { type: Array, validator: function(t2) {
    var n2, r2 = t2.every(function(t3) {
      return (n2 = _$1(e2, t3, true)) === true;
    });
    return r2 || y$1("arrayOf - value validation error:\n" + P$1(n2)), r2;
  } });
}
function J$1(e2) {
  return T$1("instanceOf", { type: e2 });
}
function M$1(e2) {
  return T$1("objectOf", { type: Object, validator: function(t2) {
    var n2, r2 = Object.keys(t2).every(function(r3) {
      return (n2 = _$1(e2, t2[r3], true)) === true;
    });
    return r2 || y$1("objectOf - value validation error:\n" + P$1(n2)), r2;
  } });
}
function R$1(e2) {
  var t2 = Object.keys(e2), n2 = t2.filter(function(t3) {
    var n3;
    return !!((n3 = e2[t3]) === null || n3 === void 0 ? void 0 : n3.required);
  }), r2 = T$1("shape", { type: Object, validator: function(r3) {
    var i2 = this;
    if (!s$1(r3))
      return false;
    var o2 = Object.keys(r3);
    if (n2.length > 0 && n2.some(function(e3) {
      return o2.indexOf(e3) === -1;
    })) {
      var u2 = n2.filter(function(e3) {
        return o2.indexOf(e3) === -1;
      });
      return y$1(u2.length === 1 ? 'shape - required property "' + u2[0] + '" is not defined.' : 'shape - required properties "' + u2.join('", "') + '" are not defined.'), false;
    }
    return o2.every(function(n3) {
      if (t2.indexOf(n3) === -1)
        return i2._vueTypes_isLoose === true || (y$1('shape - shape definition does not include a "' + n3 + '" property. Allowed keys: "' + t2.join('", "') + '".'), false);
      var o3 = _$1(e2[n3], r3[n3], true);
      return typeof o3 == "string" && y$1('shape - "' + n3 + '" property validation error:\n ' + P$1(o3)), o3 === true;
    });
  } });
  return Object.defineProperty(r2, "_vueTypes_isLoose", { writable: true, value: false }), Object.defineProperty(r2, "loose", { get: function() {
    return this._vueTypes_isLoose = true, this;
  } }), r2;
}
var $$1 = function() {
  function e2() {
  }
  return e2.extend = function(e3) {
    var t2 = this;
    if (b$1(e3))
      return e3.forEach(function(e4) {
        return t2.extend(e4);
      }), this;
    var n2 = e3.name, r2 = e3.validate, o2 = r2 !== void 0 && r2, u2 = e3.getter, a2 = u2 !== void 0 && u2, f2 = i$1(e3, ["name", "validate", "getter"]);
    if (d$1(this, n2))
      throw new TypeError('[VueTypes error]: Type "' + n2 + '" already defined');
    var c2, l2 = f2.type;
    return g$1(l2) ? (delete f2.type, Object.defineProperty(this, n2, a2 ? { get: function() {
      return k$1(n2, l2, f2);
    } } : { value: function() {
      var e4, t3 = k$1(n2, l2, f2);
      return t3.validator && (t3.validator = (e4 = t3.validator).bind.apply(e4, [t3].concat([].slice.call(arguments)))), t3;
    } })) : (c2 = a2 ? { get: function() {
      var e4 = Object.assign({}, f2);
      return o2 ? w$1(n2, e4) : T$1(n2, e4);
    }, enumerable: true } : { value: function() {
      var e4, t3, r3 = Object.assign({}, f2);
      return e4 = o2 ? w$1(n2, r3) : T$1(n2, r3), r3.validator && (e4.validator = (t3 = r3.validator).bind.apply(t3, [e4].concat([].slice.call(arguments)))), e4;
    }, enumerable: true }, Object.defineProperty(this, n2, c2));
  }, t$2(e2, null, [{ key: "any", get: function() {
    return x$1();
  } }, { key: "func", get: function() {
    return A$1().def(this.defaults.func);
  } }, { key: "bool", get: function() {
    return E$1().def(this.defaults.bool);
  } }, { key: "string", get: function() {
    return N$1().def(this.defaults.string);
  } }, { key: "number", get: function() {
    return q$1().def(this.defaults.number);
  } }, { key: "array", get: function() {
    return S$1().def(this.defaults.array);
  } }, { key: "object", get: function() {
    return V$1().def(this.defaults.object);
  } }, { key: "integer", get: function() {
    return F$1().def(this.defaults.integer);
  } }, { key: "symbol", get: function() {
    return D$1();
  } }]), e2;
}();
function z$1(e2) {
  var i2;
  return e2 === void 0 && (e2 = { func: function() {
  }, bool: true, string: "", number: 0, array: function() {
    return [];
  }, object: function() {
    return {};
  }, integer: 0 }), (i2 = function(i3) {
    function o2() {
      return i3.apply(this, arguments) || this;
    }
    return r$2(o2, i3), t$2(o2, null, [{ key: "sensibleDefaults", get: function() {
      return n$2({}, this.defaults);
    }, set: function(t2) {
      this.defaults = t2 !== false ? n$2({}, t2 !== true ? t2 : e2) : {};
    } }]), o2;
  }($$1)).defaults = n$2({}, e2), i2;
}
$$1.defaults = {}, $$1.custom = L$1, $$1.oneOf = Y$1, $$1.instanceOf = J$1, $$1.oneOfType = B$1, $$1.arrayOf = I$1, $$1.objectOf = M$1, $$1.shape = R$1, $$1.utils = { validate: function(e2, t2) {
  return _$1(t2, e2, true) === true;
}, toType: function(e2, t2, n2) {
  return n2 === void 0 && (n2 = false), n2 ? w$1(e2, t2) : T$1(e2, t2);
} };
(function(e2) {
  function t2() {
    return e2.apply(this, arguments) || this;
  }
  return r$2(t2, e2), t2;
})(z$1());
var PropTypes = z$1({
  func: void 0,
  bool: void 0,
  string: void 0,
  number: void 0,
  array: void 0,
  object: void 0,
  integer: void 0
});
PropTypes.extend([{
  name: "looseBool",
  getter: true,
  type: Boolean,
  default: void 0
}, {
  name: "style",
  getter: true,
  type: [String, Object],
  default: void 0
}, {
  name: "VueNode",
  getter: true,
  type: null
}]);
function withUndefined(type4) {
  type4.default = void 0;
  return type4;
}
var PropTypes$1 = PropTypes;
var __rest$M = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var defaultEmptyImg = createVNode(DefaultEmptyImg, null, null);
var simpleEmptyImg = createVNode(SimpleEmptyImg, null, null);
var Empty$1 = function Empty2(props2, _ref) {
  var _ref$slots = _ref.slots, slots = _ref$slots === void 0 ? {} : _ref$slots, attrs = _ref.attrs;
  var _a2;
  var _useConfigInject = useConfigInject("empty", props2), direction2 = _useConfigInject.direction, prefixClsRef = _useConfigInject.prefixCls;
  var prefixCls2 = prefixClsRef.value;
  var _b = _extends$2(_extends$2({}, props2), attrs), _b$image = _b.image, image = _b$image === void 0 ? defaultEmptyImg : _b$image, _b$description = _b.description, description = _b$description === void 0 ? ((_a2 = slots.description) === null || _a2 === void 0 ? void 0 : _a2.call(slots)) || void 0 : _b$description, imageStyle = _b.imageStyle, _b$class = _b.class, className = _b$class === void 0 ? "" : _b$class, restProps = __rest$M(_b, ["image", "description", "imageStyle", "class"]);
  return createVNode(LocaleReceiver, {
    "componentName": "Empty",
    "children": function children(locale2) {
      var _classNames;
      var des = typeof description !== "undefined" ? description : locale2.description;
      var alt = typeof des === "string" ? des : "empty";
      var imageNode = null;
      if (typeof image === "string") {
        imageNode = createVNode("img", {
          "alt": alt,
          "src": image
        }, null);
      } else {
        imageNode = image;
      }
      return createVNode("div", _objectSpread2$2({
        "class": classNames(prefixCls2, className, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-normal"), image === simpleEmptyImg), _defineProperty$R(_classNames, "".concat(prefixCls2, "-rtl"), direction2.value === "rtl"), _classNames))
      }, restProps), [createVNode("div", {
        "class": "".concat(prefixCls2, "-image"),
        "style": imageStyle
      }, [imageNode]), des && createVNode("p", {
        "class": "".concat(prefixCls2, "-description")
      }, [des]), slots.default && createVNode("div", {
        "class": "".concat(prefixCls2, "-footer")
      }, [filterEmpty(slots.default())])]);
    }
  }, null);
};
Empty$1.displayName = "AEmpty";
Empty$1.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty$1.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
Empty$1.inheritAttrs = false;
Empty$1.props = {
  prefixCls: String,
  image: PropTypes$1.any,
  description: PropTypes$1.any,
  imageStyle: {
    type: Object,
    default: void 0
  }
};
var Empty$2 = withInstall$2(Empty$1);
var RenderEmpty = function RenderEmpty2(props2) {
  var _useConfigInject = useConfigInject("empty", props2), prefixCls2 = _useConfigInject.prefixCls;
  var renderHtml = function renderHtml2(componentName) {
    switch (componentName) {
      case "Table":
      case "List":
        return createVNode(Empty$2, {
          "image": Empty$2.PRESENTED_IMAGE_SIMPLE
        }, null);
      case "Select":
      case "TreeSelect":
      case "Cascader":
      case "Transfer":
      case "Mentions":
        return createVNode(Empty$2, {
          "image": Empty$2.PRESENTED_IMAGE_SIMPLE,
          "class": "".concat(prefixCls2.value, "-small")
        }, null);
      default:
        return createVNode(Empty$2, null, null);
    }
  };
  return renderHtml(props2.componentName);
};
function renderEmpty(componentName) {
  return createVNode(RenderEmpty, {
    "componentName": componentName
  }, null);
}
var warned = {};
function warning$3(valid, message) {
}
function note(valid, message) {
}
function call(method4, valid, message) {
  if (!valid && !warned[message]) {
    method4(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning$3, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
var warning$2 = function(valid, component) {
  var message = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  warningOnce(valid, "[antdv: ".concat(component, "] ").concat(message));
};
var ANT_MARK = "internalMark";
var LocaleProvider = defineComponent({
  name: "ALocaleProvider",
  props: {
    locale: {
      type: Object
    },
    ANT_MARK__: String
  },
  setup: function setup3(props2, _ref) {
    var slots = _ref.slots;
    warning$2(props2.ANT_MARK__ === ANT_MARK, "LocaleProvider", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead");
    var state = reactive({
      antLocale: _extends$2(_extends$2({}, props2.locale), {
        exist: true
      }),
      ANT_MARK__: ANT_MARK
    });
    provide("localeData", state);
    watch(function() {
      return props2.locale;
    }, function() {
      state.antLocale = _extends$2(_extends$2({}, props2.locale), {
        exist: true
      });
    }, {
      immediate: true
    });
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
LocaleProvider.install = function(app) {
  app.component(LocaleProvider.name, LocaleProvider);
  return app;
};
var LocaleProvider$1 = withInstall$2(LocaleProvider);
globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
tuple$1("bottomLeft", "bottomRight", "topLeft", "topRight");
var getTransitionDirection = function getTransitionDirection2(placement) {
  if (placement !== void 0 && (placement === "topLeft" || placement === "topRight")) {
    return "slide-down";
  }
  return "slide-up";
};
var getTransitionProps = function getTransitionProps2(transitionName2) {
  var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var transitionProps = transitionName2 ? _extends$2({
    name: transitionName2,
    appear: true,
    enterFromClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-enter-prepare"),
    enterActiveClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-enter-prepare"),
    enterToClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-enter-active"),
    leaveFromClass: " ".concat(transitionName2, "-leave"),
    leaveActiveClass: "".concat(transitionName2, "-leave"),
    leaveToClass: "".concat(transitionName2, "-leave ").concat(transitionName2, "-leave-active")
  }, opt) : _extends$2({
    css: false
  }, opt);
  return transitionProps;
};
var getTransitionGroupProps = function getTransitionGroupProps2(transitionName2) {
  var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var transitionProps = transitionName2 ? _extends$2({
    name: transitionName2,
    appear: true,
    appearActiveClass: "".concat(transitionName2),
    appearToClass: "".concat(transitionName2, "-appear ").concat(transitionName2, "-appear-active"),
    enterFromClass: "".concat(transitionName2, "-appear ").concat(transitionName2, "-enter ").concat(transitionName2, "-appear-prepare ").concat(transitionName2, "-enter-prepare"),
    enterActiveClass: "".concat(transitionName2),
    enterToClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-appear ").concat(transitionName2, "-appear-active ").concat(transitionName2, "-enter-active"),
    leaveActiveClass: "".concat(transitionName2, " ").concat(transitionName2, "-leave"),
    leaveToClass: "".concat(transitionName2, "-leave-active")
  }, opt) : _extends$2({
    css: false
  }, opt);
  return transitionProps;
};
var Transition = Transition$2;
var TransitionGroup = TransitionGroup$1;
var getTransitionName$2 = function getTransitionName(rootPrefixCls, motion, transitionName2) {
  if (transitionName2 !== void 0) {
    return transitionName2;
  }
  return "".concat(rootPrefixCls, "-").concat(motion);
};
var Transition$1 = Transition;
var Notice = defineComponent({
  name: "Notice",
  inheritAttrs: false,
  props: ["prefixCls", "duration", "updateMark", "noticeKey", "closeIcon", "closable", "props", "onClick", "onClose", "holder", "visible"],
  setup: function setup4(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var closeTimer;
    var duration = computed(function() {
      return props2.duration === void 0 ? 1.5 : props2.duration;
    });
    var startCloseTimer = function startCloseTimer2() {
      if (duration.value) {
        closeTimer = setTimeout(function() {
          close3();
        }, duration.value * 1e3);
      }
    };
    var clearCloseTimer = function clearCloseTimer2() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };
    var close3 = function close4(e2) {
      if (e2) {
        e2.stopPropagation();
      }
      clearCloseTimer();
      var onClose = props2.onClose, noticeKey = props2.noticeKey;
      if (onClose) {
        onClose(noticeKey);
      }
    };
    var restartCloseTimer = function restartCloseTimer2() {
      clearCloseTimer();
      startCloseTimer();
    };
    onMounted(function() {
      startCloseTimer();
    });
    onUnmounted(function() {
      clearCloseTimer();
    });
    watch([duration, function() {
      return props2.updateMark;
    }, function() {
      return props2.visible;
    }], function(_ref2, _ref3) {
      var _ref4 = _slicedToArray$2(_ref2, 3), preDuration = _ref4[0], preUpdateMark = _ref4[1], preVisible = _ref4[2];
      var _ref5 = _slicedToArray$2(_ref3, 3), newDuration = _ref5[0], newUpdateMark = _ref5[1], newVisible = _ref5[2];
      if (preDuration !== newDuration || preUpdateMark !== newUpdateMark || preVisible !== newVisible && newVisible) {
        restartCloseTimer();
      }
    }, {
      flush: "post"
    });
    return function() {
      var _a2, _b;
      var prefixCls2 = props2.prefixCls, closable = props2.closable, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_a2 = slots.closeIcon) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$closeIcon, onClick2 = props2.onClick, holder = props2.holder;
      var className = attrs.class, style2 = attrs.style;
      var componentClass = "".concat(prefixCls2, "-notice");
      var dataOrAriaAttributeProps = Object.keys(attrs).reduce(function(acc, key2) {
        if (key2.substr(0, 5) === "data-" || key2.substr(0, 5) === "aria-" || key2 === "role") {
          acc[key2] = attrs[key2];
        }
        return acc;
      }, {});
      var node = createVNode("div", _objectSpread2$2({
        "class": classNames(componentClass, className, _defineProperty$R({}, "".concat(componentClass, "-closable"), closable)),
        "style": style2,
        "onMouseenter": clearCloseTimer,
        "onMouseleave": startCloseTimer,
        "onClick": onClick2
      }, dataOrAriaAttributeProps), [createVNode("div", {
        "class": "".concat(componentClass, "-content")
      }, [(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)]), closable ? createVNode("a", {
        "tabindex": 0,
        "onClick": close3,
        "class": "".concat(componentClass, "-close")
      }, [closeIcon || createVNode("span", {
        "class": "".concat(componentClass, "-close-x")
      }, null)]) : null]);
      if (holder) {
        return createVNode(Teleport, {
          "to": holder
        }, {
          default: function _default7() {
            return node;
          }
        });
      }
      return node;
    };
  }
});
var __rest$L = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var seed = 0;
var now$3 = Date.now();
function getUuid() {
  var id = seed;
  seed += 1;
  return "rcNotification_".concat(now$3, "_").concat(id);
}
var Notification = defineComponent({
  name: "Notification",
  inheritAttrs: false,
  props: ["prefixCls", "transitionName", "animation", "maxCount", "closeIcon"],
  setup: function setup5(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var hookRefs = new Map();
    var notices = ref([]);
    var transitionProps = computed(function() {
      var prefixCls2 = props2.prefixCls, _props$animation = props2.animation, animation = _props$animation === void 0 ? "fade" : _props$animation;
      var name2 = props2.transitionName;
      if (!name2 && animation) {
        name2 = "".concat(prefixCls2, "-").concat(animation);
      }
      return getTransitionGroupProps(name2);
    });
    var add2 = function add3(originNotice, holderCallback) {
      var key2 = originNotice.key || getUuid();
      var notice2 = _extends$2(_extends$2({}, originNotice), {
        key: key2
      });
      var maxCount2 = props2.maxCount;
      var noticeIndex = notices.value.map(function(v2) {
        return v2.notice.key;
      }).indexOf(key2);
      var updatedNotices = notices.value.concat();
      if (noticeIndex !== -1) {
        updatedNotices.splice(noticeIndex, 1, {
          notice: notice2,
          holderCallback
        });
      } else {
        if (maxCount2 && notices.value.length >= maxCount2) {
          notice2.key = updatedNotices[0].notice.key;
          notice2.updateMark = getUuid();
          notice2.userPassKey = key2;
          updatedNotices.shift();
        }
        updatedNotices.push({
          notice: notice2,
          holderCallback
        });
      }
      notices.value = updatedNotices;
    };
    var remove = function remove2(removeKey) {
      notices.value = notices.value.filter(function(_ref2) {
        var _ref2$notice = _ref2.notice, key2 = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
        var mergedKey = userPassKey || key2;
        return mergedKey !== removeKey;
      });
    };
    expose({
      add: add2,
      remove,
      notices
    });
    return function() {
      var _className;
      var _a2;
      var prefixCls2 = props2.prefixCls, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_a2 = slots.closeIcon) === null || _a2 === void 0 ? void 0 : _a2.call(slots, {
        prefixCls: prefixCls2
      }) : _props$closeIcon;
      var noticeNodes = notices.value.map(function(_ref3, index2) {
        var notice2 = _ref3.notice, holderCallback = _ref3.holderCallback;
        var updateMark = index2 === notices.value.length - 1 ? notice2.updateMark : void 0;
        var key2 = notice2.key, userPassKey = notice2.userPassKey;
        var content = notice2.content;
        var noticeProps = _extends$2(_extends$2(_extends$2({
          prefixCls: prefixCls2,
          closeIcon: typeof closeIcon === "function" ? closeIcon({
            prefixCls: prefixCls2
          }) : closeIcon
        }, notice2), notice2.props), {
          key: key2,
          noticeKey: userPassKey || key2,
          updateMark,
          onClose: function onClose(noticeKey) {
            var _a3;
            remove(noticeKey);
            (_a3 = notice2.onClose) === null || _a3 === void 0 ? void 0 : _a3.call(notice2);
          },
          onClick: notice2.onClick
        });
        if (holderCallback) {
          return createVNode("div", {
            "key": key2,
            "class": "".concat(prefixCls2, "-hook-holder"),
            "ref": function ref2(div) {
              if (typeof key2 === "undefined") {
                return;
              }
              if (div) {
                hookRefs.set(key2, div);
                holderCallback(div, noticeProps);
              } else {
                hookRefs.delete(key2);
              }
            }
          }, null);
        }
        return createVNode(Notice, noticeProps, {
          default: function _default7() {
            return [typeof content === "function" ? content({
              prefixCls: prefixCls2
            }) : content];
          }
        });
      });
      var className = (_className = {}, _defineProperty$R(_className, prefixCls2, 1), _defineProperty$R(_className, attrs.class, !!attrs.class), _className);
      return createVNode("div", {
        "class": className,
        "style": attrs.style || {
          top: "65px",
          left: "50%"
        }
      }, [createVNode(TransitionGroup$1, _objectSpread2$2({
        "tag": "div"
      }, transitionProps.value), {
        default: function _default7() {
          return [noticeNodes];
        }
      })]);
    };
  }
});
Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _a2 = properties || {}, _a$name = _a2.name, name2 = _a$name === void 0 ? "notification" : _a$name, getContainer4 = _a2.getContainer, appContext = _a2.appContext, customizePrefixCls = _a2.prefixCls, customRootPrefixCls = _a2.rootPrefixCls, customTransitionName = _a2.transitionName, hasTransitionName2 = _a2.hasTransitionName, props2 = __rest$L(_a2, ["name", "getContainer", "appContext", "prefixCls", "rootPrefixCls", "transitionName", "hasTransitionName"]);
  var div = document.createElement("div");
  if (getContainer4) {
    var root2 = getContainer4();
    root2.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var Wrapper = defineComponent({
    name: "NotificationWrapper",
    setup: function setup162(_props, _ref4) {
      var attrs = _ref4.attrs;
      var notiRef = ref();
      onMounted(function() {
        callback({
          notice: function notice2(noticeProps) {
            var _a3;
            (_a3 = notiRef.value) === null || _a3 === void 0 ? void 0 : _a3.add(noticeProps);
          },
          removeNotice: function removeNotice(key2) {
            var _a3;
            (_a3 = notiRef.value) === null || _a3 === void 0 ? void 0 : _a3.remove(key2);
          },
          destroy: function destroy4() {
            render(null, div);
            if (div.parentNode) {
              div.parentNode.removeChild(div);
            }
          },
          component: notiRef
        });
      });
      return function() {
        var global2 = globalConfigForApi;
        var prefixCls2 = global2.getPrefixCls(name2, customizePrefixCls);
        var rootPrefixCls = global2.getRootPrefixCls(customRootPrefixCls, prefixCls2);
        var transitionName2 = hasTransitionName2 ? customTransitionName : "".concat(rootPrefixCls, "-").concat(customTransitionName);
        return createVNode(ConfigProvider$1, _objectSpread2$2(_objectSpread2$2({}, global2), {}, {
          "notUpdateGlobalConfig": true,
          "prefixCls": rootPrefixCls
        }), {
          default: function _default7() {
            return [createVNode(Notification, _objectSpread2$2(_objectSpread2$2({
              "ref": notiRef
            }, attrs), {}, {
              "prefixCls": prefixCls2,
              "transitionName": transitionName2
            }), null)];
          }
        });
      };
    }
  });
  var vm = createVNode(Wrapper, props2);
  vm.appContext = appContext || vm.appContext;
  render(vm, div);
};
var Notification$1 = Notification;
var LoadingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
var LoadingOutlinedSvg = LoadingOutlined$2;
function bound01(n2, max4) {
  if (isOnePointZero(n2)) {
    n2 = "100%";
  }
  var isPercent = isPercentage(n2);
  n2 = max4 === 360 ? n2 : Math.min(max4, Math.max(0, parseFloat(n2)));
  if (isPercent) {
    n2 = parseInt(String(n2 * max4), 10) / 100;
  }
  if (Math.abs(n2 - max4) < 1e-6) {
    return 1;
  }
  if (max4 === 360) {
    n2 = (n2 < 0 ? n2 % max4 + max4 : n2 % max4) / parseFloat(String(max4));
  } else {
    n2 = n2 % max4 / parseFloat(String(max4));
  }
  return n2;
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function isOnePointZero(n2) {
  return typeof n2 === "string" && n2.indexOf(".") !== -1 && parseFloat(n2) === 1;
}
function isPercentage(n2) {
  return typeof n2 === "string" && n2.indexOf("%") !== -1;
}
function boundAlpha(a2) {
  a2 = parseFloat(a2);
  if (isNaN(a2) || a2 < 0 || a2 > 1) {
    a2 = 1;
  }
  return a2;
}
function convertToPercentage(n2) {
  if (n2 <= 1) {
    return "".concat(Number(n2) * 100, "%");
  }
  return n2;
}
function pad2(c2) {
  return c2.length === 1 ? "0" + c2 : String(c2);
}
function rgbToRgb(r2, g2, b2) {
  return {
    r: bound01(r2, 255) * 255,
    g: bound01(g2, 255) * 255,
    b: bound01(b2, 255) * 255
  };
}
function rgbToHsl(r2, g2, b2) {
  r2 = bound01(r2, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max4 = Math.max(r2, g2, b2);
  var min4 = Math.min(r2, g2, b2);
  var h2 = 0;
  var s2 = 0;
  var l2 = (max4 + min4) / 2;
  if (max4 === min4) {
    s2 = 0;
    h2 = 0;
  } else {
    var d2 = max4 - min4;
    s2 = l2 > 0.5 ? d2 / (2 - max4 - min4) : d2 / (max4 + min4);
    switch (max4) {
      case r2:
        h2 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h2 = (b2 - r2) / d2 + 2;
        break;
      case b2:
        h2 = (r2 - g2) / d2 + 4;
        break;
    }
    h2 /= 6;
  }
  return { h: h2, s: s2, l: l2 };
}
function hue2rgb(p2, q2, t2) {
  if (t2 < 0) {
    t2 += 1;
  }
  if (t2 > 1) {
    t2 -= 1;
  }
  if (t2 < 1 / 6) {
    return p2 + (q2 - p2) * (6 * t2);
  }
  if (t2 < 1 / 2) {
    return q2;
  }
  if (t2 < 2 / 3) {
    return p2 + (q2 - p2) * (2 / 3 - t2) * 6;
  }
  return p2;
}
function hslToRgb(h2, s2, l2) {
  var r2;
  var g2;
  var b2;
  h2 = bound01(h2, 360);
  s2 = bound01(s2, 100);
  l2 = bound01(l2, 100);
  if (s2 === 0) {
    g2 = l2;
    b2 = l2;
    r2 = l2;
  } else {
    var q2 = l2 < 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
    var p2 = 2 * l2 - q2;
    r2 = hue2rgb(p2, q2, h2 + 1 / 3);
    g2 = hue2rgb(p2, q2, h2);
    b2 = hue2rgb(p2, q2, h2 - 1 / 3);
  }
  return { r: r2 * 255, g: g2 * 255, b: b2 * 255 };
}
function rgbToHsv(r2, g2, b2) {
  r2 = bound01(r2, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max4 = Math.max(r2, g2, b2);
  var min4 = Math.min(r2, g2, b2);
  var h2 = 0;
  var v2 = max4;
  var d2 = max4 - min4;
  var s2 = max4 === 0 ? 0 : d2 / max4;
  if (max4 === min4) {
    h2 = 0;
  } else {
    switch (max4) {
      case r2:
        h2 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h2 = (b2 - r2) / d2 + 2;
        break;
      case b2:
        h2 = (r2 - g2) / d2 + 4;
        break;
    }
    h2 /= 6;
  }
  return { h: h2, s: s2, v: v2 };
}
function hsvToRgb(h2, s2, v2) {
  h2 = bound01(h2, 360) * 6;
  s2 = bound01(s2, 100);
  v2 = bound01(v2, 100);
  var i2 = Math.floor(h2);
  var f2 = h2 - i2;
  var p2 = v2 * (1 - s2);
  var q2 = v2 * (1 - f2 * s2);
  var t2 = v2 * (1 - (1 - f2) * s2);
  var mod = i2 % 6;
  var r2 = [v2, q2, p2, p2, t2, v2][mod];
  var g2 = [t2, v2, v2, q2, p2, p2][mod];
  var b2 = [p2, p2, t2, v2, v2, q2][mod];
  return { r: r2 * 255, g: g2 * 255, b: b2 * 255 };
}
function rgbToHex(r2, g2, b2, allow3Char) {
  var hex2 = [
    pad2(Math.round(r2).toString(16)),
    pad2(Math.round(g2).toString(16)),
    pad2(Math.round(b2).toString(16))
  ];
  if (allow3Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1))) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
  }
  return hex2.join("");
}
function rgbaToHex(r2, g2, b2, a2, allow4Char) {
  var hex2 = [
    pad2(Math.round(r2).toString(16)),
    pad2(Math.round(g2).toString(16)),
    pad2(Math.round(b2).toString(16)),
    pad2(convertDecimalToHex(a2))
  ];
  if (allow4Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1)) && hex2[3].startsWith(hex2[3].charAt(1))) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0) + hex2[3].charAt(0);
  }
  return hex2.join("");
}
function convertDecimalToHex(d2) {
  return Math.round(parseFloat(d2) * 255).toString(16);
}
function convertHexToDecimal(h2) {
  return parseIntFromHex(h2) / 255;
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function numberInputToObject(color) {
  return {
    r: color >> 16,
    g: (color & 65280) >> 8,
    b: color & 255
  };
}
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function inputToRGB(color) {
  var rgb = { r: 0, g: 0, b: 0 };
  var a2 = 1;
  var s2 = null;
  var v2 = null;
  var l2 = null;
  var ok = false;
  var format3 = false;
  if (typeof color === "string") {
    color = stringInputToObject(color);
  }
  if (typeof color === "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format3 = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s2 = convertToPercentage(color.s);
      v2 = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s2, v2);
      ok = true;
      format3 = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s2 = convertToPercentage(color.s);
      l2 = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s2, l2);
      ok = true;
      format3 = "hsl";
    }
    if (Object.prototype.hasOwnProperty.call(color, "a")) {
      a2 = color.a;
    }
  }
  a2 = boundAlpha(a2);
  return {
    ok,
    format: color.format || format3,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a2
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?";
var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(color) {
  color = color.trim().toLowerCase();
  if (color.length === 0) {
    return false;
  }
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color === "transparent") {
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  }
  var match2 = matchers.rgb.exec(color);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3] };
  }
  match2 = matchers.rgba.exec(color);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3], a: match2[4] };
  }
  match2 = matchers.hsl.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3] };
  }
  match2 = matchers.hsla.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3], a: match2[4] };
  }
  match2 = matchers.hsv.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3] };
  }
  match2 = matchers.hsva.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3], a: match2[4] };
  }
  match2 = matchers.hex8.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      a: convertHexToDecimal(match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex6.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      format: named ? "name" : "hex"
    };
  }
  match2 = matchers.hex4.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      a: convertHexToDecimal(match2[4] + match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex3.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function isValidCSSUnit(color) {
  return Boolean(matchers.CSS_UNIT.exec(String(color)));
}
var TinyColor = function() {
  function TinyColor2(color, opts) {
    if (color === void 0) {
      color = "";
    }
    if (opts === void 0) {
      opts = {};
    }
    var _a2;
    if (color instanceof TinyColor2) {
      return color;
    }
    if (typeof color === "number") {
      color = numberInputToObject(color);
    }
    this.originalInput = color;
    var rgb = inputToRGB(color);
    this.originalInput = color;
    this.r = rgb.r;
    this.g = rgb.g;
    this.b = rgb.b;
    this.a = rgb.a;
    this.roundA = Math.round(100 * this.a) / 100;
    this.format = (_a2 = opts.format) !== null && _a2 !== void 0 ? _a2 : rgb.format;
    this.gradientType = opts.gradientType;
    if (this.r < 1) {
      this.r = Math.round(this.r);
    }
    if (this.g < 1) {
      this.g = Math.round(this.g);
    }
    if (this.b < 1) {
      this.b = Math.round(this.b);
    }
    this.isValid = rgb.ok;
  }
  TinyColor2.prototype.isDark = function() {
    return this.getBrightness() < 128;
  };
  TinyColor2.prototype.isLight = function() {
    return !this.isDark();
  };
  TinyColor2.prototype.getBrightness = function() {
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
  };
  TinyColor2.prototype.getLuminance = function() {
    var rgb = this.toRgb();
    var R2;
    var G;
    var B2;
    var RsRGB = rgb.r / 255;
    var GsRGB = rgb.g / 255;
    var BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) {
      R2 = RsRGB / 12.92;
    } else {
      R2 = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    }
    if (GsRGB <= 0.03928) {
      G = GsRGB / 12.92;
    } else {
      G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    }
    if (BsRGB <= 0.03928) {
      B2 = BsRGB / 12.92;
    } else {
      B2 = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * R2 + 0.7152 * G + 0.0722 * B2;
  };
  TinyColor2.prototype.getAlpha = function() {
    return this.a;
  };
  TinyColor2.prototype.setAlpha = function(alpha) {
    this.a = boundAlpha(alpha);
    this.roundA = Math.round(100 * this.a) / 100;
    return this;
  };
  TinyColor2.prototype.isMonochrome = function() {
    var s2 = this.toHsl().s;
    return s2 === 0;
  };
  TinyColor2.prototype.toHsv = function() {
    var hsv = rgbToHsv(this.r, this.g, this.b);
    return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
  };
  TinyColor2.prototype.toHsvString = function() {
    var hsv = rgbToHsv(this.r, this.g, this.b);
    var h2 = Math.round(hsv.h * 360);
    var s2 = Math.round(hsv.s * 100);
    var v2 = Math.round(hsv.v * 100);
    return this.a === 1 ? "hsv(".concat(h2, ", ").concat(s2, "%, ").concat(v2, "%)") : "hsva(".concat(h2, ", ").concat(s2, "%, ").concat(v2, "%, ").concat(this.roundA, ")");
  };
  TinyColor2.prototype.toHsl = function() {
    var hsl = rgbToHsl(this.r, this.g, this.b);
    return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
  };
  TinyColor2.prototype.toHslString = function() {
    var hsl = rgbToHsl(this.r, this.g, this.b);
    var h2 = Math.round(hsl.h * 360);
    var s2 = Math.round(hsl.s * 100);
    var l2 = Math.round(hsl.l * 100);
    return this.a === 1 ? "hsl(".concat(h2, ", ").concat(s2, "%, ").concat(l2, "%)") : "hsla(".concat(h2, ", ").concat(s2, "%, ").concat(l2, "%, ").concat(this.roundA, ")");
  };
  TinyColor2.prototype.toHex = function(allow3Char) {
    if (allow3Char === void 0) {
      allow3Char = false;
    }
    return rgbToHex(this.r, this.g, this.b, allow3Char);
  };
  TinyColor2.prototype.toHexString = function(allow3Char) {
    if (allow3Char === void 0) {
      allow3Char = false;
    }
    return "#" + this.toHex(allow3Char);
  };
  TinyColor2.prototype.toHex8 = function(allow4Char) {
    if (allow4Char === void 0) {
      allow4Char = false;
    }
    return rgbaToHex(this.r, this.g, this.b, this.a, allow4Char);
  };
  TinyColor2.prototype.toHex8String = function(allow4Char) {
    if (allow4Char === void 0) {
      allow4Char = false;
    }
    return "#" + this.toHex8(allow4Char);
  };
  TinyColor2.prototype.toHexShortString = function(allowShortChar) {
    if (allowShortChar === void 0) {
      allowShortChar = false;
    }
    return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
  };
  TinyColor2.prototype.toRgb = function() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  };
  TinyColor2.prototype.toRgbString = function() {
    var r2 = Math.round(this.r);
    var g2 = Math.round(this.g);
    var b2 = Math.round(this.b);
    return this.a === 1 ? "rgb(".concat(r2, ", ").concat(g2, ", ").concat(b2, ")") : "rgba(".concat(r2, ", ").concat(g2, ", ").concat(b2, ", ").concat(this.roundA, ")");
  };
  TinyColor2.prototype.toPercentageRgb = function() {
    var fmt = function(x2) {
      return "".concat(Math.round(bound01(x2, 255) * 100), "%");
    };
    return {
      r: fmt(this.r),
      g: fmt(this.g),
      b: fmt(this.b),
      a: this.a
    };
  };
  TinyColor2.prototype.toPercentageRgbString = function() {
    var rnd = function(x2) {
      return Math.round(bound01(x2, 255) * 100);
    };
    return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
  };
  TinyColor2.prototype.toName = function() {
    if (this.a === 0) {
      return "transparent";
    }
    if (this.a < 1) {
      return false;
    }
    var hex2 = "#" + rgbToHex(this.r, this.g, this.b, false);
    for (var _i = 0, _a2 = Object.entries(names); _i < _a2.length; _i++) {
      var _b = _a2[_i], key2 = _b[0], value = _b[1];
      if (hex2 === value) {
        return key2;
      }
    }
    return false;
  };
  TinyColor2.prototype.toString = function(format3) {
    var formatSet = Boolean(format3);
    format3 = format3 !== null && format3 !== void 0 ? format3 : this.format;
    var formattedString = false;
    var hasAlpha = this.a < 1 && this.a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format3.startsWith("hex") || format3 === "name");
    if (needsAlphaFormat) {
      if (format3 === "name" && this.a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format3 === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format3 === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format3 === "hex" || format3 === "hex6") {
      formattedString = this.toHexString();
    }
    if (format3 === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format3 === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format3 === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format3 === "name") {
      formattedString = this.toName();
    }
    if (format3 === "hsl") {
      formattedString = this.toHslString();
    }
    if (format3 === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  };
  TinyColor2.prototype.toNumber = function() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  };
  TinyColor2.prototype.clone = function() {
    return new TinyColor2(this.toString());
  };
  TinyColor2.prototype.lighten = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.brighten = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var rgb = this.toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return new TinyColor2(rgb);
  };
  TinyColor2.prototype.darken = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.tint = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return this.mix("white", amount);
  };
  TinyColor2.prototype.shade = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return this.mix("black", amount);
  };
  TinyColor2.prototype.desaturate = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.saturate = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.greyscale = function() {
    return this.desaturate(100);
  };
  TinyColor2.prototype.spin = function(amount) {
    var hsl = this.toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.mix = function(color, amount) {
    if (amount === void 0) {
      amount = 50;
    }
    var rgb1 = this.toRgb();
    var rgb2 = new TinyColor2(color).toRgb();
    var p2 = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p2 + rgb1.r,
      g: (rgb2.g - rgb1.g) * p2 + rgb1.g,
      b: (rgb2.b - rgb1.b) * p2 + rgb1.b,
      a: (rgb2.a - rgb1.a) * p2 + rgb1.a
    };
    return new TinyColor2(rgba);
  };
  TinyColor2.prototype.analogous = function(results, slices) {
    if (results === void 0) {
      results = 6;
    }
    if (slices === void 0) {
      slices = 30;
    }
    var hsl = this.toHsl();
    var part = 360 / slices;
    var ret = [this];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(new TinyColor2(hsl));
    }
    return ret;
  };
  TinyColor2.prototype.complement = function() {
    var hsl = this.toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.monochromatic = function(results) {
    if (results === void 0) {
      results = 6;
    }
    var hsv = this.toHsv();
    var h2 = hsv.h;
    var s2 = hsv.s;
    var v2 = hsv.v;
    var res = [];
    var modification = 1 / results;
    while (results--) {
      res.push(new TinyColor2({ h: h2, s: s2, v: v2 }));
      v2 = (v2 + modification) % 1;
    }
    return res;
  };
  TinyColor2.prototype.splitcomplement = function() {
    var hsl = this.toHsl();
    var h2 = hsl.h;
    return [
      this,
      new TinyColor2({ h: (h2 + 72) % 360, s: hsl.s, l: hsl.l }),
      new TinyColor2({ h: (h2 + 216) % 360, s: hsl.s, l: hsl.l })
    ];
  };
  TinyColor2.prototype.onBackground = function(background) {
    var fg = this.toRgb();
    var bg = new TinyColor2(background).toRgb();
    var alpha = fg.a + bg.a * (1 - fg.a);
    return new TinyColor2({
      r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
      g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
      b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
      a: alpha
    });
  };
  TinyColor2.prototype.triad = function() {
    return this.polyad(3);
  };
  TinyColor2.prototype.tetrad = function() {
    return this.polyad(4);
  };
  TinyColor2.prototype.polyad = function(n2) {
    var hsl = this.toHsl();
    var h2 = hsl.h;
    var result = [this];
    var increment = 360 / n2;
    for (var i2 = 1; i2 < n2; i2++) {
      result.push(new TinyColor2({ h: (h2 + i2 * increment) % 360, s: hsl.s, l: hsl.l }));
    }
    return result;
  };
  TinyColor2.prototype.equals = function(color) {
    return this.toRgbString() === new TinyColor2(color).toRgbString();
  };
  return TinyColor2;
}();
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv(_ref) {
  var r2 = _ref.r, g2 = _ref.g, b2 = _ref.b;
  var hsv = rgbToHsv(r2, g2, b2);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
}
function toHex(_ref2) {
  var r2 = _ref2.r, g2 = _ref2.g, b2 = _ref2.b;
  return "#".concat(rgbToHex(r2, g2, b2, false));
}
function mix$1(rgb1, rgb2, amount) {
  var p2 = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p2 + rgb1.r,
    g: (rgb2.g - rgb1.g) * p2 + rgb1.g,
    b: (rgb2.b - rgb1.b) * p2 + rgb1.b
  };
  return rgb;
}
function getHue(hsv, i2, light) {
  var hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i2 : Math.round(hsv.h) + hueStep * i2;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i2 : Math.round(hsv.h) - hueStep * i2;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i2, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i2;
  } else if (i2 === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i2;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i2 === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Number(saturation.toFixed(2));
}
function getValue$4(hsv, i2, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i2;
  } else {
    value = hsv.v - brightnessStep2 * i2;
  }
  if (value > 1) {
    value = 1;
  }
  return Number(value.toFixed(2));
}
function generate$1(color) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);
  for (var i2 = lightColorCount; i2 > 0; i2 -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i2, true),
      s: getSaturation(hsv, i2, true),
      v: getValue$4(hsv, i2, true)
    }));
    patterns.push(colorString);
  }
  patterns.push(toHex(pColor));
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);
    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue$4(_hsv, _i)
    }));
    patterns.push(_colorString);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(function(_ref3) {
      var index2 = _ref3.index, opacity = _ref3.opacity;
      var darkColorString = toHex(mix$1(inputToRGB(opts.backgroundColor || "#141414"), inputToRGB(patterns[index2]), opacity * 100));
      return darkColorString;
    });
  }
  return patterns;
}
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function(key2) {
  presetPalettes[key2] = generate$1(presetPrimaryColors[key2]);
  presetPalettes[key2].primary = presetPalettes[key2][5];
  presetDarkPalettes[key2] = generate$1(presetPrimaryColors[key2], {
    theme: "dark",
    backgroundColor: "#141414"
  });
  presetDarkPalettes[key2].primary = presetDarkPalettes[key2][5];
});
presetPalettes.red;
presetPalettes.volcano;
presetPalettes.gold;
presetPalettes.orange;
presetPalettes.yellow;
presetPalettes.lime;
presetPalettes.green;
presetPalettes.cyan;
presetPalettes.blue;
presetPalettes.geekblue;
presetPalettes.purple;
presetPalettes.magenta;
presetPalettes.grey;
var containers = [];
var styleElements = [];
var usage = "insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).";
function createStyleElement() {
  var styleElement = document.createElement("style");
  styleElement.setAttribute("type", "text/css");
  return styleElement;
}
function insertCss(css2, options) {
  options = options || {};
  if (css2 === void 0) {
    throw new Error(usage);
  }
  var position2 = options.prepend === true ? "prepend" : "append";
  var container = options.container !== void 0 ? options.container : document.querySelector("head");
  var containerId = containers.indexOf(container);
  if (containerId === -1) {
    containerId = containers.push(container) - 1;
    styleElements[containerId] = {};
  }
  var styleElement;
  if (styleElements[containerId] !== void 0 && styleElements[containerId][position2] !== void 0) {
    styleElement = styleElements[containerId][position2];
  } else {
    styleElement = styleElements[containerId][position2] = createStyleElement();
    if (position2 === "prepend") {
      container.insertBefore(styleElement, container.childNodes[0]);
    } else {
      container.appendChild(styleElement);
    }
  }
  if (css2.charCodeAt(0) === 65279) {
    css2 = css2.substr(1, css2.length);
  }
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText += css2;
  } else {
    styleElement.textContent += css2;
  }
  return styleElement;
}
function _objectSpread$O(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$Q(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$Q(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function warning$1(valid, message) {
}
function isIconDefinition(target) {
  return typeof target === "object" && typeof target.name === "string" && typeof target.theme === "string" && (typeof target.icon === "object" || typeof target.icon === "function");
}
function generate(node, key2, rootProps) {
  if (!rootProps) {
    return h$2(node.tag, _objectSpread$O({
      key: key2
    }, node.attrs), (node.children || []).map(function(child, index2) {
      return generate(child, "".concat(key2, "-").concat(node.tag, "-").concat(index2));
    }));
  }
  return h$2(node.tag, _objectSpread$O({
    key: key2
  }, rootProps, node.attrs), (node.children || []).map(function(child, index2) {
    return generate(child, "".concat(key2, "-").concat(node.tag, "-").concat(index2));
  }));
}
function getSecondaryColor(primaryColor) {
  return generate$1(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var cssInjectedFlag = false;
var useInsertStyles = function useInsertStyles2() {
  var styleStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iconStyles;
  nextTick(function() {
    if (!cssInjectedFlag) {
      if (typeof window !== "undefined" && window.document && window.document.documentElement) {
        insertCss(styleStr, {
          prepend: true
        });
      }
      cssInjectedFlag = true;
    }
  });
};
var _excluded$2 = ["icon", "primaryColor", "secondaryColor"];
function _objectWithoutProperties$2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key2, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key2 = sourceSymbolKeys[i2];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key2 = sourceKeys[i2];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectSpread$N(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$P(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$P(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return _objectSpread$N({}, twoToneColorPalette);
}
var IconBase = function IconBase2(props2, context2) {
  var _props$context$attrs = _objectSpread$N({}, props2, context2.attrs), icon = _props$context$attrs.icon, primaryColor = _props$context$attrs.primaryColor, secondaryColor = _props$context$attrs.secondaryColor, restProps = _objectWithoutProperties$2(_props$context$attrs, _excluded$2);
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles();
  warning$1(isIconDefinition(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === "function") {
    target = _objectSpread$N({}, target, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return generate(target.icon, "svg-".concat(target.name), _objectSpread$N({}, restProps, {
    "data-icon": target.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }));
};
IconBase.props = {
  icon: Object,
  primaryColor: String,
  secondaryColor: String,
  focusable: String
};
IconBase.inheritAttrs = false;
IconBase.displayName = "IconBase";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var VueIcon = IconBase;
function _slicedToArray$1(arr, i2) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i2) || _unsupportedIterableToArray$1(arr, i2) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray$1(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return VueIcon.setTwoToneColors({
    primaryColor,
    secondaryColor
  });
}
function getTwoToneColor() {
  var colors = VueIcon.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}
var _excluded$1 = ["class", "icon", "spin", "rotate", "tabindex", "twoToneColor", "onClick"];
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectSpread$M(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$O(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$O(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key2, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key2 = sourceSymbolKeys[i2];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key2 = sourceKeys[i2];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
setTwoToneColor("#1890ff");
var Icon$1 = function Icon(props2, context2) {
  var _classObj;
  var _props$context$attrs = _objectSpread$M({}, props2, context2.attrs), cls = _props$context$attrs["class"], icon = _props$context$attrs.icon, spin = _props$context$attrs.spin, rotate = _props$context$attrs.rotate, tabindex = _props$context$attrs.tabindex, twoToneColor = _props$context$attrs.twoToneColor, onClick2 = _props$context$attrs.onClick, restProps = _objectWithoutProperties$1(_props$context$attrs, _excluded$1);
  var classObj = (_classObj = {
    anticon: true
  }, _defineProperty$O(_classObj, "anticon-".concat(icon.name), Boolean(icon.name)), _defineProperty$O(_classObj, cls, cls), _classObj);
  var svgClassString = spin === "" || !!spin || icon.name === "loading" ? "anticon-spin" : "";
  var iconTabIndex = tabindex;
  if (iconTabIndex === void 0 && onClick2) {
    iconTabIndex = -1;
    restProps.tabindex = iconTabIndex;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : void 0;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return createVNode("span", _objectSpread$M({
    "role": "img",
    "aria-label": icon.name
  }, restProps, {
    "onClick": onClick2,
    "class": classObj
  }), [createVNode(VueIcon, {
    "class": svgClassString,
    "icon": icon,
    "primaryColor": primaryColor,
    "secondaryColor": secondaryColor,
    "style": svgStyle
  }, null)]);
};
Icon$1.props = {
  spin: Boolean,
  rotate: Number,
  icon: Object,
  twoToneColor: String
};
Icon$1.displayName = "AntdIcon";
Icon$1.inheritAttrs = false;
Icon$1.getTwoToneColor = getTwoToneColor;
Icon$1.setTwoToneColor = setTwoToneColor;
var AntdIcon = Icon$1;
function _objectSpread$L(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$N(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$N(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var LoadingOutlined = function LoadingOutlined2(props2, context2) {
  var p2 = _objectSpread$L({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$L({}, p2, {
    "icon": LoadingOutlinedSvg
  }), null);
};
LoadingOutlined.displayName = "LoadingOutlined";
LoadingOutlined.inheritAttrs = false;
var LoadingOutlined$1 = LoadingOutlined;
var ExclamationCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
var ExclamationCircleFilledSvg = ExclamationCircleFilled$2;
function _objectSpread$K(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$M(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$M(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ExclamationCircleFilled = function ExclamationCircleFilled2(props2, context2) {
  var p2 = _objectSpread$K({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$K({}, p2, {
    "icon": ExclamationCircleFilledSvg
  }), null);
};
ExclamationCircleFilled.displayName = "ExclamationCircleFilled";
ExclamationCircleFilled.inheritAttrs = false;
var ExclamationCircleFilled$1 = ExclamationCircleFilled;
var CloseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };
var CloseCircleFilledSvg = CloseCircleFilled$2;
function _objectSpread$J(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$L(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$L(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CloseCircleFilled = function CloseCircleFilled2(props2, context2) {
  var p2 = _objectSpread$J({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$J({}, p2, {
    "icon": CloseCircleFilledSvg
  }), null);
};
CloseCircleFilled.displayName = "CloseCircleFilled";
CloseCircleFilled.inheritAttrs = false;
var CloseCircleFilled$1 = CloseCircleFilled;
var CheckCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
var CheckCircleFilledSvg = CheckCircleFilled$2;
function _objectSpread$I(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$K(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$K(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CheckCircleFilled = function CheckCircleFilled2(props2, context2) {
  var p2 = _objectSpread$I({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$I({}, p2, {
    "icon": CheckCircleFilledSvg
  }), null);
};
CheckCircleFilled.displayName = "CheckCircleFilled";
CheckCircleFilled.inheritAttrs = false;
var CheckCircleFilled$1 = CheckCircleFilled;
var InfoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
var InfoCircleFilledSvg = InfoCircleFilled$2;
function _objectSpread$H(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$J(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$J(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var InfoCircleFilled = function InfoCircleFilled2(props2, context2) {
  var p2 = _objectSpread$H({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$H({}, p2, {
    "icon": InfoCircleFilledSvg
  }), null);
};
InfoCircleFilled.displayName = "InfoCircleFilled";
InfoCircleFilled.inheritAttrs = false;
var InfoCircleFilled$1 = InfoCircleFilled;
var defaultDuration$1 = 3;
var defaultTop$1;
var messageInstance;
var key$5 = 1;
var localPrefixCls = "";
var transitionName = "move-up";
var hasTransitionName = false;
var getContainer$1 = function getContainer() {
  return document.body;
};
var maxCount$1;
var rtl$1 = false;
function getKeyThenIncreaseKey() {
  return key$5++;
}
function setMessageConfig(options) {
  if (options.top !== void 0) {
    defaultTop$1 = options.top;
    messageInstance = null;
  }
  if (options.duration !== void 0) {
    defaultDuration$1 = options.duration;
  }
  if (options.prefixCls !== void 0) {
    localPrefixCls = options.prefixCls;
  }
  if (options.getContainer !== void 0) {
    getContainer$1 = options.getContainer;
    messageInstance = null;
  }
  if (options.transitionName !== void 0) {
    transitionName = options.transitionName;
    messageInstance = null;
    hasTransitionName = true;
  }
  if (options.maxCount !== void 0) {
    maxCount$1 = options.maxCount;
    messageInstance = null;
  }
  if (options.rtl !== void 0) {
    rtl$1 = options.rtl;
  }
}
function getMessageInstance(args, callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }
  Notification$1.newInstance({
    appContext: args.appContext,
    prefixCls: args.prefixCls || localPrefixCls,
    rootPrefixCls: args.rootPrefixCls,
    transitionName,
    hasTransitionName,
    style: {
      top: defaultTop$1
    },
    getContainer: getContainer$1 || args.getPopupContainer,
    maxCount: maxCount$1,
    name: "message"
  }, function(instance2) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }
    messageInstance = instance2;
    callback(instance2);
  });
}
var typeToIcon$1 = {
  info: InfoCircleFilled$1,
  success: CheckCircleFilled$1,
  error: CloseCircleFilled$1,
  warning: ExclamationCircleFilled$1,
  loading: LoadingOutlined$1
};
function notice$1(args) {
  var duration = args.duration !== void 0 ? args.duration : defaultDuration$1;
  var target = args.key || getKeyThenIncreaseKey();
  var closePromise = new Promise(function(resolve) {
    var callback = function callback2() {
      if (typeof args.onClose === "function") {
        args.onClose();
      }
      return resolve(true);
    };
    getMessageInstance(args, function(instance2) {
      instance2.notice({
        key: target,
        duration,
        style: args.style || {},
        class: args.class,
        content: function content(_ref) {
          var _classNames;
          var prefixCls2 = _ref.prefixCls;
          var Icon3 = typeToIcon$1[args.type];
          var iconNode = Icon3 ? createVNode(Icon3, null, null) : "";
          var messageClass = classNames("".concat(prefixCls2, "-custom-content"), (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-").concat(args.type), args.type), _defineProperty$R(_classNames, "".concat(prefixCls2, "-rtl"), rtl$1 === true), _classNames));
          return createVNode("div", {
            "class": messageClass
          }, [typeof args.icon === "function" ? args.icon() : args.icon || iconNode, createVNode("span", null, [typeof args.content === "function" ? args.content() : args.content])]);
        },
        onClose: callback,
        onClick: args.onClick
      });
    });
  });
  var result = function result2() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };
  result.then = function(filled, rejected) {
    return closePromise.then(filled, rejected);
  };
  result.promise = closePromise;
  return result;
}
function isArgsProps(content) {
  return Object.prototype.toString.call(content) === "[object Object]" && !!content.content;
}
var api$1 = {
  open: notice$1,
  config: setMessageConfig,
  destroy: function destroy(messageKey) {
    if (messageInstance) {
      if (messageKey) {
        var _messageInstance = messageInstance, removeNotice = _messageInstance.removeNotice;
        removeNotice(messageKey);
      } else {
        var _messageInstance2 = messageInstance, destroy4 = _messageInstance2.destroy;
        destroy4();
        messageInstance = null;
      }
    }
  }
};
function attachTypeApi(originalApi, type4) {
  originalApi[type4] = function(content, duration, onClose) {
    if (isArgsProps(content)) {
      return originalApi.open(_extends$2(_extends$2({}, content), {
        type: type4
      }));
    }
    if (typeof duration === "function") {
      onClose = duration;
      duration = void 0;
    }
    return originalApi.open({
      content,
      duration,
      type: type4,
      onClose
    });
  };
}
["success", "info", "warning", "error", "loading"].forEach(function(type4) {
  return attachTypeApi(api$1, type4);
});
api$1.warn = api$1.warning;
var AntMessage = api$1;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var runtime = { exports: {} };
(function(module2) {
  var runtime2 = function(exports2) {
    var Op = Object.prototype;
    var hasOwn3 = Op.hasOwnProperty;
    var undefined$1;
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key2, value) {
      Object.defineProperty(obj, key2, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key2];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function(obj, key2, value) {
        return obj[key2] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context2 = new Context(tryLocsList || []);
      generator._invoke = makeInvokeMethod(innerFn, self2, context2);
      return generator;
    }
    exports2.wrap = wrap;
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    var ContinueSentinel = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn3.call(NativeIteratorPrototype, iteratorSymbol)) {
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method4) {
        define(prototype, method4, function(arg) {
          return this._invoke(method4, arg);
        });
      });
    }
    exports2.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports2.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
    exports2.awrap = function(arg) {
      return { __await: arg };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method4, arg, resolve, reject) {
        var record = tryCatch(generator[method4], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn3.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function(value2) {
              invoke("next", value2, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function(unwrapped) {
            result.value = unwrapped;
            resolve(result);
          }, function(error) {
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method4, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function(resolve, reject) {
            invoke(method4, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
      return this;
    });
    exports2.AsyncIterator = AsyncIterator;
    exports2.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0)
        PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports2.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self2, context2) {
      var state = GenStateSuspendedStart;
      return function invoke(method4, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method4 === "throw") {
            throw arg;
          }
          return doneResult();
        }
        context2.method = method4;
        context2.arg = arg;
        while (true) {
          var delegate = context2.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context2);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if (context2.method === "next") {
            context2.sent = context2._sent = context2.arg;
          } else if (context2.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context2.arg;
            }
            context2.dispatchException(context2.arg);
          } else if (context2.method === "return") {
            context2.abrupt("return", context2.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self2, context2);
          if (record.type === "normal") {
            state = context2.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context2.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            context2.method = "throw";
            context2.arg = record.arg;
          }
        }
      };
    }
    function maybeInvokeDelegate(delegate, context2) {
      var method4 = delegate.iterator[context2.method];
      if (method4 === undefined$1) {
        context2.delegate = null;
        if (context2.method === "throw") {
          if (delegate.iterator["return"]) {
            context2.method = "return";
            context2.arg = undefined$1;
            maybeInvokeDelegate(delegate, context2);
            if (context2.method === "throw") {
              return ContinueSentinel;
            }
          }
          context2.method = "throw";
          context2.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method4, delegate.iterator, context2.arg);
      if (record.type === "throw") {
        context2.method = "throw";
        context2.arg = record.arg;
        context2.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context2.method = "throw";
        context2.arg = new TypeError("iterator result is not an object");
        context2.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        context2[delegate.resultName] = info.value;
        context2.next = delegate.nextLoc;
        if (context2.method !== "return") {
          context2.method = "next";
          context2.arg = undefined$1;
        }
      } else {
        return info;
      }
      context2.delegate = null;
      return ContinueSentinel;
    }
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    define(Gp, iteratorSymbol, function() {
      return this;
    });
    define(Gp, "toString", function() {
      return "[object Generator]";
    });
    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports2.keys = function(object4) {
      var keys2 = [];
      for (var key2 in object4) {
        keys2.push(key2);
      }
      keys2.reverse();
      return function next2() {
        while (keys2.length) {
          var key3 = keys2.pop();
          if (key3 in object4) {
            next2.value = key3;
            next2.done = false;
            return next2;
          }
        }
        next2.done = true;
        return next2;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i2 = -1, next2 = function next3() {
            while (++i2 < iterable.length) {
              if (hasOwn3.call(iterable, i2)) {
                next3.value = iterable[i2];
                next3.done = false;
                return next3;
              }
            }
            next3.value = undefined$1;
            next3.done = true;
            return next3;
          };
          return next2.next = next2;
        }
      }
      return { next: doneResult };
    }
    exports2.values = values;
    function doneResult() {
      return { value: undefined$1, done: true };
    }
    Context.prototype = {
      constructor: Context,
      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name2 in this) {
            if (name2.charAt(0) === "t" && hasOwn3.call(this, name2) && !isNaN(+name2.slice(1))) {
              this[name2] = undefined$1;
            }
          }
        }
      },
      stop: function() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }
        var context2 = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context2.next = loc;
          if (caught) {
            context2.method = "next";
            context2.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn3.call(entry, "catchLoc");
            var hasFinally = hasOwn3.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function(type4, arg) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.tryLoc <= this.prev && hasOwn3.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type4 === "break" || type4 === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type4;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function(finallyLoc) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function(tryLoc) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName,
          nextLoc
        };
        if (this.method === "next") {
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };
    return exports2;
  }(module2.exports);
  try {
    regeneratorRuntime = runtime2;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime2;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime2);
    }
  }
})(runtime);
var regenerator = runtime.exports;
var CheckCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };
var CheckCircleOutlinedSvg = CheckCircleOutlined$2;
function _objectSpread$G(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$I(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$I(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CheckCircleOutlined = function CheckCircleOutlined2(props2, context2) {
  var p2 = _objectSpread$G({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$G({}, p2, {
    "icon": CheckCircleOutlinedSvg
  }), null);
};
CheckCircleOutlined.displayName = "CheckCircleOutlined";
CheckCircleOutlined.inheritAttrs = false;
var CheckCircleOutlined$1 = CheckCircleOutlined;
var InfoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };
var InfoCircleOutlinedSvg = InfoCircleOutlined$2;
function _objectSpread$F(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$H(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$H(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var InfoCircleOutlined = function InfoCircleOutlined2(props2, context2) {
  var p2 = _objectSpread$F({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$F({}, p2, {
    "icon": InfoCircleOutlinedSvg
  }), null);
};
InfoCircleOutlined.displayName = "InfoCircleOutlined";
InfoCircleOutlined.inheritAttrs = false;
var InfoCircleOutlined$1 = InfoCircleOutlined;
var CloseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "close-circle", "theme": "outlined" };
var CloseCircleOutlinedSvg = CloseCircleOutlined$2;
function _objectSpread$E(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$G(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$G(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CloseCircleOutlined = function CloseCircleOutlined2(props2, context2) {
  var p2 = _objectSpread$E({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$E({}, p2, {
    "icon": CloseCircleOutlinedSvg
  }), null);
};
CloseCircleOutlined.displayName = "CloseCircleOutlined";
CloseCircleOutlined.inheritAttrs = false;
var CloseCircleOutlined$1 = CloseCircleOutlined;
var ExclamationCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };
var ExclamationCircleOutlinedSvg = ExclamationCircleOutlined$2;
function _objectSpread$D(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$F(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$F(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ExclamationCircleOutlined = function ExclamationCircleOutlined2(props2, context2) {
  var p2 = _objectSpread$D({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$D({}, p2, {
    "icon": ExclamationCircleOutlinedSvg
  }), null);
};
ExclamationCircleOutlined.displayName = "ExclamationCircleOutlined";
ExclamationCircleOutlined.inheritAttrs = false;
var ExclamationCircleOutlined$1 = ExclamationCircleOutlined;
var CloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlinedSvg = CloseOutlined$2;
function _objectSpread$C(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$E(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$E(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CloseOutlined = function CloseOutlined2(props2, context2) {
  var p2 = _objectSpread$C({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$C({}, p2, {
    "icon": CloseOutlinedSvg
  }), null);
};
CloseOutlined.displayName = "CloseOutlined";
CloseOutlined.inheritAttrs = false;
var CloseOutlined$1 = CloseOutlined;
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var notificationInstance = {};
var defaultDuration = 4.5;
var defaultTop = "24px";
var defaultBottom = "24px";
var defaultPrefixCls$1 = "";
var defaultPlacement = "topRight";
var defaultGetContainer = function defaultGetContainer2() {
  return document.body;
};
var defaultCloseIcon = null;
var rtl = false;
var maxCount;
function setNotificationConfig(options) {
  var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer4 = options.getContainer, closeIcon = options.closeIcon, prefixCls2 = options.prefixCls;
  if (prefixCls2 !== void 0) {
    defaultPrefixCls$1 = prefixCls2;
  }
  if (duration !== void 0) {
    defaultDuration = duration;
  }
  if (placement !== void 0) {
    defaultPlacement = placement;
  }
  if (bottom !== void 0) {
    defaultBottom = typeof bottom === "number" ? "".concat(bottom, "px") : bottom;
  }
  if (top !== void 0) {
    defaultTop = typeof top === "number" ? "".concat(top, "px") : top;
  }
  if (getContainer4 !== void 0) {
    defaultGetContainer = getContainer4;
  }
  if (closeIcon !== void 0) {
    defaultCloseIcon = closeIcon;
  }
  if (options.rtl !== void 0) {
    rtl = options.rtl;
  }
  if (options.maxCount !== void 0) {
    maxCount = options.maxCount;
  }
}
function getPlacementStyle(placement) {
  var top = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultTop;
  var bottom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultBottom;
  var style2;
  switch (placement) {
    case "topLeft":
      style2 = {
        left: "0px",
        top,
        bottom: "auto"
      };
      break;
    case "topRight":
      style2 = {
        right: "0px",
        top,
        bottom: "auto"
      };
      break;
    case "bottomLeft":
      style2 = {
        left: "0px",
        top: "auto",
        bottom
      };
      break;
    default:
      style2 = {
        right: "0px",
        top: "auto",
        bottom
      };
      break;
  }
  return style2;
}
function getNotificationInstance(_ref, callback) {
  var customizePrefixCls = _ref.prefixCls, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement, _ref$getContainer = _ref.getContainer, getContainer4 = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer, top = _ref.top, bottom = _ref.bottom, _ref$closeIcon = _ref.closeIcon, _closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon, appContext = _ref.appContext;
  var _globalConfig = globalConfig(), getPrefixCls2 = _globalConfig.getPrefixCls;
  var prefixCls2 = getPrefixCls2("notification", customizePrefixCls || defaultPrefixCls$1);
  var cacheKey = "".concat(prefixCls2, "-").concat(placement, "-").concat(rtl);
  var cacheInstance = notificationInstance[cacheKey];
  if (cacheInstance) {
    Promise.resolve(cacheInstance).then(function(instance2) {
      callback(instance2);
    });
    return;
  }
  var notificationClass = classNames("".concat(prefixCls2, "-").concat(placement), _defineProperty$R({}, "".concat(prefixCls2, "-rtl"), rtl === true));
  Notification$1.newInstance({
    name: "notification",
    prefixCls: customizePrefixCls || defaultPrefixCls$1,
    class: notificationClass,
    style: getPlacementStyle(placement, top, bottom),
    appContext,
    getContainer: getContainer4,
    closeIcon: function closeIcon(_ref2) {
      var prefixCls3 = _ref2.prefixCls;
      var closeIconToRender = createVNode("span", {
        "class": "".concat(prefixCls3, "-close-x")
      }, [renderHelper(_closeIcon, {}, createVNode(CloseOutlined$1, {
        "class": "".concat(prefixCls3, "-close-icon")
      }, null))]);
      return closeIconToRender;
    },
    maxCount,
    hasTransitionName: true
  }, function(notification) {
    notificationInstance[cacheKey] = notification;
    callback(notification);
  });
}
var typeToIcon = {
  success: CheckCircleOutlined$1,
  info: InfoCircleOutlined$1,
  error: CloseCircleOutlined$1,
  warning: ExclamationCircleOutlined$1
};
function notice(args) {
  var icon = args.icon, type4 = args.type, description = args.description, message = args.message, btn = args.btn;
  var duration = args.duration === void 0 ? defaultDuration : args.duration;
  getNotificationInstance(args, function(notification) {
    notification.notice({
      content: function content(_ref3) {
        var outerPrefixCls = _ref3.prefixCls;
        var prefixCls2 = "".concat(outerPrefixCls, "-notice");
        var iconNode = null;
        if (icon) {
          iconNode = function iconNode2() {
            return createVNode("span", {
              "class": "".concat(prefixCls2, "-icon")
            }, [renderHelper(icon)]);
          };
        } else if (type4) {
          var Icon3 = typeToIcon[type4];
          iconNode = function iconNode2() {
            return createVNode(Icon3, {
              "class": "".concat(prefixCls2, "-icon ").concat(prefixCls2, "-icon-").concat(type4)
            }, null);
          };
        }
        return createVNode("div", {
          "class": iconNode ? "".concat(prefixCls2, "-with-icon") : ""
        }, [iconNode && iconNode(), createVNode("div", {
          "class": "".concat(prefixCls2, "-message")
        }, [!description && iconNode ? createVNode("span", {
          "class": "".concat(prefixCls2, "-message-single-line-auto-margin")
        }, null) : null, renderHelper(message)]), createVNode("div", {
          "class": "".concat(prefixCls2, "-description")
        }, [renderHelper(description)]), btn ? createVNode("span", {
          "class": "".concat(prefixCls2, "-btn")
        }, [renderHelper(btn)]) : null]);
      },
      duration,
      closable: true,
      onClose: args.onClose,
      onClick: args.onClick,
      key: args.key,
      style: args.style || {},
      class: args.class
    });
  });
}
var api = {
  open: notice,
  close: function close(key2) {
    Object.keys(notificationInstance).forEach(function(cacheKey) {
      return Promise.resolve(notificationInstance[cacheKey]).then(function(instance2) {
        instance2.removeNotice(key2);
      });
    });
  },
  config: setNotificationConfig,
  destroy: function destroy2() {
    Object.keys(notificationInstance).forEach(function(cacheKey) {
      Promise.resolve(notificationInstance[cacheKey]).then(function(instance2) {
        instance2.destroy();
      });
      delete notificationInstance[cacheKey];
    });
  }
};
var iconTypes = ["success", "info", "warning", "error"];
iconTypes.forEach(function(type4) {
  api[type4] = function(args) {
    return api.open(_extends$2(_extends$2({}, args), {
      type: type4
    }));
  };
});
api.warn = api.warning;
var AntNotification = api;
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var MARK_KEY = "vc-util-key";
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
  if (mark) {
    return mark.startsWith("data-") ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer2(option2) {
  if (option2.attachTo) {
    return option2.attachTo;
  }
  var head = document.querySelector("head");
  return head || document.body;
}
function injectCSS(css2) {
  var option2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _a2, _b;
  if (!canUseDom()) {
    return null;
  }
  var styleNode = document.createElement("style");
  if ((_a2 = option2.csp) === null || _a2 === void 0 ? void 0 : _a2.nonce) {
    styleNode.nonce = (_b = option2.csp) === null || _b === void 0 ? void 0 : _b.nonce;
  }
  styleNode.innerHTML = css2;
  var container = getContainer2(option2);
  var firstChild = container.firstChild;
  if (option2.prepend && container.prepend) {
    container.prepend(styleNode);
  } else if (option2.prepend && firstChild) {
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
var containerCache = new Map();
function findExistNode(key2) {
  var option2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var container = getContainer2(option2);
  return Array.from(containerCache.get(container).children).find(function(node) {
    return node.tagName === "STYLE" && node.getAttribute(getMark(option2)) === key2;
  });
}
function updateCSS(css2, key2) {
  var option2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _a2, _b, _c;
  var container = getContainer2(option2);
  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS("", option2);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }
  var existNode = findExistNode(key2, option2);
  if (existNode) {
    if (((_a2 = option2.csp) === null || _a2 === void 0 ? void 0 : _a2.nonce) && existNode.nonce !== ((_b = option2.csp) === null || _b === void 0 ? void 0 : _b.nonce)) {
      existNode.nonce = (_c = option2.csp) === null || _c === void 0 ? void 0 : _c.nonce;
    }
    if (existNode.innerHTML !== css2) {
      existNode.innerHTML = css2;
    }
    return existNode;
  }
  var newNode = injectCSS(css2, option2);
  newNode.setAttribute(getMark(option2), key2);
  return newNode;
}
var devWarning = function(valid, component, message) {
  warningOnce(valid, "[ant-design-vue: ".concat(component, "] ").concat(message));
};
var dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function registerTheme(globalPrefixCls, theme) {
  var variables = {};
  var formatColor = function formatColor2(color, updater) {
    var clone3 = color.clone();
    clone3 = (updater === null || updater === void 0 ? void 0 : updater(clone3)) || clone3;
    return clone3.toRgbString();
  };
  var fillColor = function fillColor2(colorVal, type4) {
    var baseColor = new TinyColor(colorVal);
    var colorPalettes = generate$1(baseColor.toRgbString());
    variables["".concat(type4, "-color")] = formatColor(baseColor);
    variables["".concat(type4, "-color-disabled")] = colorPalettes[1];
    variables["".concat(type4, "-color-hover")] = colorPalettes[4];
    variables["".concat(type4, "-color-active")] = colorPalettes[7];
    variables["".concat(type4, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
    variables["".concat(type4, "-color-deprecated-bg")] = colorPalettes[1];
    variables["".concat(type4, "-color-deprecated-border")] = colorPalettes[3];
  };
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, "primary");
    var primaryColor = new TinyColor(theme.primaryColor);
    var primaryColors = generate$1(primaryColor.toRgbString());
    primaryColors.forEach(function(color, index2) {
      variables["primary-".concat(index2 + 1)] = color;
    });
    variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, function(c2) {
      return c2.lighten(35);
    });
    variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, function(c2) {
      return c2.lighten(20);
    });
    variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, function(c2) {
      return c2.tint(20);
    });
    variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, function(c2) {
      return c2.tint(50);
    });
    variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, function(c2) {
      return c2.setAlpha(c2.getAlpha() * 0.12);
    });
    var primaryActiveColor = new TinyColor(primaryColors[0]);
    variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, function(c2) {
      return c2.setAlpha(c2.getAlpha() * 0.3);
    });
    variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, function(c2) {
      return c2.darken(2);
    });
  }
  if (theme.successColor) {
    fillColor(theme.successColor, "success");
  }
  if (theme.warningColor) {
    fillColor(theme.warningColor, "warning");
  }
  if (theme.errorColor) {
    fillColor(theme.errorColor, "error");
  }
  if (theme.infoColor) {
    fillColor(theme.infoColor, "info");
  }
  var cssList = Object.keys(variables).map(function(key2) {
    return "--".concat(globalPrefixCls, "-").concat(key2, ": ").concat(variables[key2], ";");
  });
  if (canUseDom()) {
    updateCSS("\n  :root {\n    ".concat(cssList.join("\n"), "\n  }\n  "), "".concat(dynamicStyleMark, "-dynamic-theme"));
  } else {
    devWarning(false, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
  }
}
var GlobalFormContextKey = Symbol("GlobalFormContextKey");
var useProvideGlobalForm = function useProvideGlobalForm2(state) {
  provide(GlobalFormContextKey, state);
};
var configProviderProps = function configProviderProps2() {
  return {
    getTargetContainer: {
      type: Function
    },
    getPopupContainer: {
      type: Function
    },
    prefixCls: String,
    getPrefixCls: {
      type: Function
    },
    renderEmpty: {
      type: Function
    },
    transformCellText: {
      type: Function
    },
    csp: {
      type: Object,
      default: void 0
    },
    input: {
      type: Object
    },
    autoInsertSpaceInButton: {
      type: Boolean,
      default: void 0
    },
    locale: {
      type: Object,
      default: void 0
    },
    pageHeader: {
      type: Object
    },
    componentSize: {
      type: String
    },
    direction: {
      type: String
    },
    space: {
      type: Object
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    dropdownMatchSelectWidth: {
      type: [Number, Boolean],
      default: true
    },
    form: {
      type: Object,
      default: void 0
    },
    notUpdateGlobalConfig: Boolean
  };
};
var defaultPrefixCls = "ant";
function getGlobalPrefixCls() {
  return globalConfigForApi.prefixCls || defaultPrefixCls;
}
var globalConfigByCom = reactive({});
var globalConfigBySet = reactive({});
var globalConfigForApi = reactive({});
watchEffect(function() {
  _extends$2(globalConfigForApi, globalConfigByCom, globalConfigBySet);
  globalConfigForApi.prefixCls = getGlobalPrefixCls();
  globalConfigForApi.getPrefixCls = function(suffixCls, customizePrefixCls) {
    if (customizePrefixCls)
      return customizePrefixCls;
    return suffixCls ? "".concat(globalConfigForApi.prefixCls, "-").concat(suffixCls) : globalConfigForApi.prefixCls;
  };
  globalConfigForApi.getRootPrefixCls = function(rootPrefixCls, customizePrefixCls) {
    if (rootPrefixCls) {
      return rootPrefixCls;
    }
    if (globalConfigForApi.prefixCls) {
      return globalConfigForApi.prefixCls;
    }
    if (customizePrefixCls && customizePrefixCls.includes("-")) {
      return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
    }
    return getGlobalPrefixCls();
  };
});
var stopWatchEffect;
var setGlobalConfig = function setGlobalConfig2(params) {
  if (stopWatchEffect) {
    stopWatchEffect();
  }
  stopWatchEffect = watchEffect(function() {
    _extends$2(globalConfigBySet, reactive(params));
  });
  if (params.theme) {
    registerTheme(getGlobalPrefixCls(), params.theme);
  }
};
var globalConfig = function globalConfig2() {
  return {
    getPrefixCls: function getPrefixCls2(suffixCls, customizePrefixCls) {
      if (customizePrefixCls)
        return customizePrefixCls;
      return suffixCls ? "".concat(getGlobalPrefixCls(), "-").concat(suffixCls) : getGlobalPrefixCls();
    },
    getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
      if (rootPrefixCls) {
        return rootPrefixCls;
      }
      if (globalConfigForApi.prefixCls) {
        return globalConfigForApi.prefixCls;
      }
      if (customizePrefixCls && customizePrefixCls.includes("-")) {
        return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
      }
      return getGlobalPrefixCls();
    }
  };
};
var ConfigProvider = defineComponent({
  name: "AConfigProvider",
  inheritAttrs: false,
  props: configProviderProps(),
  setup: function setup6(props2, _ref) {
    var slots = _ref.slots;
    var getPrefixCls2 = function getPrefixCls3(suffixCls, customizePrefixCls) {
      var _props$prefixCls = props2.prefixCls, prefixCls2 = _props$prefixCls === void 0 ? "ant" : _props$prefixCls;
      if (customizePrefixCls)
        return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls2, "-").concat(suffixCls) : prefixCls2;
    };
    var renderEmptyComponent = function renderEmptyComponent2(name2) {
      var renderEmpty$1 = props2.renderEmpty || slots.renderEmpty || renderEmpty;
      return renderEmpty$1(name2);
    };
    var getPrefixClsWrapper = function getPrefixClsWrapper2(suffixCls, customizePrefixCls) {
      var prefixCls2 = props2.prefixCls;
      if (customizePrefixCls)
        return customizePrefixCls;
      var mergedPrefixCls = prefixCls2 || getPrefixCls2("");
      return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    };
    var configProvider = reactive(_extends$2(_extends$2({}, props2), {
      getPrefixCls: getPrefixClsWrapper,
      renderEmpty: renderEmptyComponent
    }));
    Object.keys(props2).forEach(function(key2) {
      watch(function() {
        return props2[key2];
      }, function() {
        configProvider[key2] = props2[key2];
      });
    });
    if (!props2.notUpdateGlobalConfig) {
      _extends$2(globalConfigByCom, configProvider);
      watch(configProvider, function() {
        _extends$2(globalConfigByCom, configProvider);
      });
    }
    var validateMessagesRef = computed(function() {
      var _a2, _b;
      var validateMessages = {};
      if (props2.locale) {
        validateMessages = ((_a2 = props2.locale.Form) === null || _a2 === void 0 ? void 0 : _a2.defaultValidateMessages) || ((_b = defaultLocale.Form) === null || _b === void 0 ? void 0 : _b.defaultValidateMessages) || {};
      }
      if (props2.form && props2.form.validateMessages) {
        validateMessages = _extends$2(_extends$2({}, validateMessages), props2.form.validateMessages);
      }
      return validateMessages;
    });
    useProvideGlobalForm({
      validateMessages: validateMessagesRef
    });
    provide("configProvider", configProvider);
    var renderProvider = function renderProvider2(legacyLocale) {
      var _a2;
      return createVNode(LocaleProvider$1, {
        "locale": props2.locale || legacyLocale,
        "ANT_MARK__": ANT_MARK
      }, {
        default: function _default7() {
          return [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)];
        }
      });
    };
    watchEffect(function() {
      if (props2.direction) {
        AntMessage.config({
          rtl: props2.direction === "rtl"
        });
        AntNotification.config({
          rtl: props2.direction === "rtl"
        });
      }
    });
    return function() {
      return createVNode(LocaleReceiver, {
        "children": function children(_2, __, legacyLocale) {
          return renderProvider(legacyLocale);
        }
      }, null);
    };
  }
});
var defaultConfigProvider = reactive({
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls)
      return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : "ant";
  },
  renderEmpty,
  direction: "ltr"
});
ConfigProvider.config = setGlobalConfig;
ConfigProvider.install = function(app) {
  app.component(ConfigProvider.name, ConfigProvider);
};
var ConfigProvider$1 = ConfigProvider;
var useConfigInject = function(name2, props2) {
  var configProvider = inject("configProvider", defaultConfigProvider);
  var prefixCls2 = computed(function() {
    return configProvider.getPrefixCls(name2, props2.prefixCls);
  });
  var direction2 = computed(function() {
    var _a2;
    return (_a2 = props2.direction) !== null && _a2 !== void 0 ? _a2 : configProvider.direction;
  });
  var rootPrefixCls = computed(function() {
    return configProvider.getPrefixCls();
  });
  var autoInsertSpaceInButton = computed(function() {
    return configProvider.autoInsertSpaceInButton;
  });
  var renderEmpty2 = computed(function() {
    return configProvider.renderEmpty;
  });
  var space = computed(function() {
    return configProvider.space;
  });
  var pageHeader = computed(function() {
    return configProvider.pageHeader;
  });
  var form = computed(function() {
    return configProvider.form;
  });
  var getTargetContainer = computed(function() {
    return props2.getTargetContainer || configProvider.getTargetContainer;
  });
  var getPopupContainer = computed(function() {
    return props2.getPopupContainer || configProvider.getPopupContainer;
  });
  var dropdownMatchSelectWidth = computed(function() {
    var _a2;
    return (_a2 = props2.dropdownMatchSelectWidth) !== null && _a2 !== void 0 ? _a2 : configProvider.dropdownMatchSelectWidth;
  });
  var virtual = computed(function() {
    return (props2.virtual === void 0 ? configProvider.virtual !== false : props2.virtual !== false) && dropdownMatchSelectWidth.value !== false;
  });
  var size = computed(function() {
    return props2.size || configProvider.componentSize;
  });
  var autocomplete = computed(function() {
    var _a2;
    return props2.autocomplete || ((_a2 = configProvider.input) === null || _a2 === void 0 ? void 0 : _a2.autocomplete);
  });
  var csp = computed(function() {
    return configProvider.csp;
  });
  return {
    configProvider,
    prefixCls: prefixCls2,
    direction: direction2,
    size,
    getTargetContainer,
    getPopupContainer,
    space,
    pageHeader,
    form,
    autoInsertSpaceInButton,
    renderEmpty: renderEmpty2,
    virtual,
    dropdownMatchSelectWidth,
    rootPrefixCls,
    getPrefixCls: configProvider.getPrefixCls,
    autocomplete,
    csp
  };
};
function omit$3(obj, fields) {
  var shallowCopy = _extends$2({}, obj);
  for (var i2 = 0; i2 < fields.length; i2 += 1) {
    var key2 = fields[i2];
    delete shallowCopy[key2];
  }
  return shallowCopy;
}
function isWindow$1(obj) {
  return obj !== null && obj !== void 0 && obj === obj.window;
}
function getScroll$3(target, top) {
  var _a2;
  if (typeof window === "undefined") {
    return 0;
  }
  var method4 = top ? "scrollTop" : "scrollLeft";
  var result = 0;
  if (isWindow$1(target)) {
    result = target[top ? "pageYOffset" : "pageXOffset"];
  } else if (target instanceof Document) {
    result = target.documentElement[method4];
  } else if (target) {
    result = target[method4];
  }
  if (target && !isWindow$1(target) && typeof result !== "number") {
    result = (_a2 = (target.ownerDocument || target).documentElement) === null || _a2 === void 0 ? void 0 : _a2[method4];
  }
  return result;
}
function easeInOutCubic(t2, b2, c2, d2) {
  var cc = c2 - b2;
  t2 /= d2 / 2;
  if (t2 < 1) {
    return cc / 2 * t2 * t2 * t2 + b2;
  }
  return cc / 2 * ((t2 -= 2) * t2 * t2 + 2) + b2;
}
function scrollTo$2(y2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$getContainer = options.getContainer, getContainer4 = _options$getContainer === void 0 ? function() {
    return window;
  } : _options$getContainer, callback = options.callback, _options$duration = options.duration, duration = _options$duration === void 0 ? 450 : _options$duration;
  var container = getContainer4();
  var scrollTop = getScroll$3(container, true);
  var startTime = Date.now();
  var frameFunc = function frameFunc2() {
    var timestamp = Date.now();
    var time = timestamp - startTime;
    var nextScrollTop = easeInOutCubic(time > duration ? duration : time, scrollTop, y2, duration);
    if (isWindow$1(container)) {
      container.scrollTo(window.pageXOffset, nextScrollTop);
    } else if (container instanceof HTMLDocument || container.constructor.name === "HTMLDocument") {
      container.documentElement.scrollTop = nextScrollTop;
    } else {
      container.scrollTop = nextScrollTop;
    }
    if (time < duration) {
      wrapperRaf(frameFunc2);
    } else if (typeof callback === "function") {
      callback();
    }
  };
  wrapperRaf(frameFunc);
}
function _toArray(arr) {
  return _arrayWithHoles$2(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableRest$2();
}
function getKey$3(data6, index2) {
  var key2 = data6.key;
  var value;
  if ("value" in data6) {
    value = data6.value;
  }
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  if (value !== void 0) {
    return value;
  }
  return "rc-index-key-".concat(index2);
}
function fillFieldNames$3(fieldNames, childrenAsData) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options;
  return {
    label: label || (childrenAsData ? "children" : "label"),
    value: value || "value",
    options: options || "options"
  };
}
function flattenOptions(options) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
  var flattenList = [];
  var _fillFieldNames = fillFieldNames$3(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options;
  function dig(list, isGroupOption) {
    list.forEach(function(data6) {
      var label = data6[fieldLabel];
      if (isGroupOption || !(fieldOptions in data6)) {
        var value = data6[fieldValue];
        flattenList.push({
          key: getKey$3(data6, flattenList.length),
          groupOption: isGroupOption,
          data: data6,
          label,
          value
        });
      } else {
        var grpLabel = label;
        if (grpLabel === void 0 && childrenAsData) {
          grpLabel = data6.label;
        }
        flattenList.push({
          key: getKey$3(data6, flattenList.length),
          group: true,
          data: data6,
          label: grpLabel
        });
        dig(data6[fieldOptions], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}
function injectPropsWithOption(option2) {
  var newOption = _extends$2({}, option2);
  if (!("props" in newOption)) {
    Object.defineProperty(newOption, "props", {
      get: function get2() {
        return newOption;
      }
    });
  }
  return newOption;
}
function getSeparatedContent(text, tokens) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match2 = false;
  function separate(str, _ref3) {
    var _ref4 = _toArray(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
    if (!token) {
      return [str];
    }
    var list2 = str.split(token);
    match2 = match2 || list2.length > 1;
    return list2.reduce(function(prevList, unitStr) {
      return [].concat(_toConsumableArray(prevList), _toConsumableArray(separate(unitStr, restTokens)));
    }, []).filter(function(unit) {
      return unit;
    });
  }
  var list = separate(text, tokens);
  return match2 ? list : null;
}
function contains(root2, n2) {
  if (!root2) {
    return false;
  }
  return root2.contains(n2);
}
var availablePrefixs = ["moz", "ms", "webkit"];
function requestAnimationFramePolyfill() {
  var lastTime = 0;
  return function(callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function() {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
}
function getRequestAnimationFrame() {
  if (typeof window === "undefined") {
    return function() {
    };
  }
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame.bind(window);
  }
  var prefix = availablePrefixs.filter(function(key2) {
    return "".concat(key2, "RequestAnimationFrame") in window;
  })[0];
  return prefix ? window["".concat(prefix, "RequestAnimationFrame")] : requestAnimationFramePolyfill();
}
function cancelRequestAnimationFrame(id) {
  if (typeof window === "undefined") {
    return null;
  }
  if (window.cancelAnimationFrame) {
    return window.cancelAnimationFrame(id);
  }
  var prefix = availablePrefixs.filter(function(key2) {
    return "".concat(key2, "CancelAnimationFrame") in window || "".concat(key2, "CancelRequestAnimationFrame") in window;
  })[0];
  return prefix ? (window["".concat(prefix, "CancelAnimationFrame")] || window["".concat(prefix, "CancelRequestAnimationFrame")]).call(this, id) : clearTimeout(id);
}
var raf2 = getRequestAnimationFrame();
var cancelAnimationTimeout = function cancelAnimationTimeout2(frame) {
  return cancelRequestAnimationFrame(frame.id);
};
var requestAnimationTimeout = function requestAnimationTimeout2(callback) {
  var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var start2 = Date.now();
  function timeout() {
    if (Date.now() - start2 >= delay) {
      callback.call();
    } else {
      frame.id = raf2(timeout);
    }
  }
  var frame = {
    id: raf2(timeout)
  };
  return frame;
};
var innerProps = {
  visible: Boolean,
  prefixCls: String,
  zIndex: Number,
  destroyPopupOnHide: Boolean,
  forceRender: Boolean,
  animation: [String, Object],
  transitionName: String,
  stretch: {
    type: String
  },
  align: {
    type: Object
  },
  point: {
    type: Object
  },
  getRootDomNode: {
    type: Function
  },
  getClassNameFromAlign: {
    type: Function
  },
  onMouseenter: {
    type: Function
  },
  onMouseleave: {
    type: Function
  },
  onMousedown: {
    type: Function
  },
  onTouchstart: {
    type: Function
  }
};
var mobileProps = _extends$2(_extends$2({}, innerProps), {
  mobile: {
    type: Object
  }
});
var popupProps = _extends$2(_extends$2({}, innerProps), {
  mask: Boolean,
  mobile: {
    type: Object
  },
  maskAnimation: String,
  maskTransitionName: String
});
function getMotion(_ref) {
  var prefixCls2 = _ref.prefixCls, animation = _ref.animation, transitionName2 = _ref.transitionName;
  if (animation) {
    return {
      name: "".concat(prefixCls2, "-").concat(animation)
    };
  }
  if (transitionName2) {
    return {
      name: transitionName2
    };
  }
  return {};
}
function Mask$1(props2) {
  var prefixCls2 = props2.prefixCls, visible = props2.visible, zIndex = props2.zIndex, mask = props2.mask, maskAnimation = props2.maskAnimation, maskTransitionName = props2.maskTransitionName;
  if (!mask) {
    return null;
  }
  var motion = {};
  if (maskTransitionName || maskAnimation) {
    motion = getMotion({
      prefixCls: prefixCls2,
      transitionName: maskTransitionName,
      animation: maskAnimation
    });
  }
  return createVNode(Transition$2, _objectSpread2$2({
    "appear": true
  }, motion), {
    default: function _default7() {
      return [withDirectives(createVNode("div", {
        "style": {
          zIndex
        },
        "class": "".concat(prefixCls2, "-mask")
      }, null), [[resolveDirective("if"), visible]])];
    }
  });
}
Mask$1.displayName = "Mask";
var MobilePopupInner = defineComponent({
  name: "MobilePopupInner",
  inheritAttrs: false,
  props: mobileProps,
  emits: ["mouseenter", "mouseleave", "mousedown", "touchstart", "align"],
  setup: function setup7(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var elementRef = ref();
    expose({
      forceAlign: function forceAlign() {
      },
      getElement: function getElement2() {
        return elementRef.value;
      }
    });
    return function() {
      var _a2;
      var zIndex = props2.zIndex, visible = props2.visible, prefixCls2 = props2.prefixCls, _props$mobile = props2.mobile;
      _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
      var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender;
      var mergedStyle = _extends$2({
        zIndex
      }, popupStyle);
      var childNode = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      if (childNode.length > 1) {
        childNode = createVNode("div", {
          "class": "".concat(prefixCls2, "-content")
        }, [childNode]);
      }
      if (popupRender) {
        childNode = popupRender(childNode);
      }
      var mergedClassName = classNames(prefixCls2, popupClassName);
      return createVNode(Transition$2, _objectSpread2$2({
        "ref": elementRef
      }, popupMotion), {
        default: function _default7() {
          return [visible ? createVNode("div", {
            "class": mergedClassName,
            "style": mergedStyle
          }, [childNode]) : null];
        }
      });
    };
  }
});
var __awaiter$3 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var StatusQueue = ["measure", "align", null, "motion"];
var useVisibleStatus = function(visible, doMeasure) {
  var status = ref(null);
  var rafRef = ref();
  var destroyRef = ref(false);
  function setStatus(nextStatus) {
    if (!destroyRef.value) {
      status.value = nextStatus;
    }
  }
  function cancelRaf() {
    wrapperRaf.cancel(rafRef.value);
  }
  function goNextStatus(callback) {
    cancelRaf();
    rafRef.value = wrapperRaf(function() {
      var newStatus = status.value;
      switch (status.value) {
        case "align":
          newStatus = "motion";
          break;
        case "motion":
          newStatus = "stable";
          break;
      }
      setStatus(newStatus);
      callback === null || callback === void 0 ? void 0 : callback();
    });
  }
  watch(visible, function() {
    setStatus("measure");
  }, {
    immediate: true,
    flush: "post"
  });
  onMounted(function() {
    watch(status, function() {
      switch (status.value) {
        case "measure":
          doMeasure();
          break;
      }
      if (status.value) {
        rafRef.value = wrapperRaf(function() {
          return __awaiter$3(void 0, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee() {
            var index2, nextStatus;
            return regenerator.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    index2 = StatusQueue.indexOf(status.value);
                    nextStatus = StatusQueue[index2 + 1];
                    if (nextStatus && index2 !== -1) {
                      setStatus(nextStatus);
                    }
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        });
      }
    }, {
      immediate: true,
      flush: "post"
    });
  });
  onBeforeUnmount(function() {
    destroyRef.value = true;
    cancelRaf();
  });
  return [status, goNextStatus];
};
var useStretchStyle = function(stretch) {
  var targetSize = ref({
    width: 0,
    height: 0
  });
  function measureStretch(element) {
    targetSize.value = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
  }
  var style2 = computed(function() {
    var sizeStyle = {};
    if (stretch.value) {
      var _targetSize$value = targetSize.value, width = _targetSize$value.width, height = _targetSize$value.height;
      if (stretch.value.indexOf("height") !== -1 && height) {
        sizeStyle.height = "".concat(height, "px");
      } else if (stretch.value.indexOf("minHeight") !== -1 && height) {
        sizeStyle.minHeight = "".concat(height, "px");
      }
      if (stretch.value.indexOf("width") !== -1 && width) {
        sizeStyle.width = "".concat(width, "px");
      } else if (stretch.value.indexOf("minWidth") !== -1 && width) {
        sizeStyle.minWidth = "".concat(width, "px");
      }
    }
    return sizeStyle;
  });
  return [style2, measureStretch];
};
function ownKeys$1(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$1(Object(source), true).forEach(function(key2) {
        _defineProperty$D(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _defineProperty$D(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var vendorPrefix;
var jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0) {
    return vendorPrefix;
  }
  vendorPrefix = "";
  var style2 = document.createElement("p").style;
  var testProp = "Transform";
  for (var key2 in jsCssMap) {
    if (key2 + testProp in style2) {
      vendorPrefix = key2;
    }
  }
  return vendorPrefix;
}
function getTransitionName$1() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(node, value) {
  var name2 = getTransitionName$1();
  if (name2) {
    node.style[name2] = value;
    if (name2 !== "transitionProperty") {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name2 = getTransformName();
  if (name2) {
    node.style[name2] = value;
    if (name2 !== "transform") {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName$1()];
}
function getTransformXY(node) {
  var style2 = window.getComputedStyle(node, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var matrix2 = transform.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(matrix2[12] || matrix2[4], 0),
      y: parseFloat(matrix2[13] || matrix2[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style2 = window.getComputedStyle(node, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(",").map(function(item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(","), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(",").map(function(item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = "none";
  elem.offsetHeight;
  elem.style.display = originalStyle;
}
function css$2(el, name2, v2) {
  var value = v2;
  if (_typeof$1(name2) === "object") {
    for (var i2 in name2) {
      if (name2.hasOwnProperty(i2)) {
        css$2(el, i2, name2[i2]);
      }
    }
    return void 0;
  }
  if (typeof value !== "undefined") {
    if (typeof value === "number") {
      value = "".concat(value, "px");
    }
    el.style[name2] = value;
    return void 0;
  }
  return getComputedStyleX(el, name2);
}
function getClientPosition$1(elem) {
  var box;
  var x2;
  var y2;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x2 = Math.floor(box.left);
  y2 = Math.floor(box.top);
  x2 -= docElem.clientLeft || body.clientLeft || 0;
  y2 -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x2,
    top: y2
  };
}
function getScroll$2(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method4 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d2 = w2.document;
    ret = d2.documentElement[method4];
    if (typeof ret !== "number") {
      ret = d2.body[method4];
    }
  }
  return ret;
}
function getScrollLeft(w2) {
  return getScroll$2(w2);
}
function getScrollTop(w2) {
  return getScroll$2(w2, true);
}
function getOffset$3(el) {
  var pos = getClientPosition$1(el);
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w2);
  pos.top += getScrollTop(w2);
  return pos;
}
function isWindow(obj) {
  return obj !== null && obj !== void 0 && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name2, cs) {
  var computedStyle = cs;
  var val = "";
  var d2 = getDocument(elem);
  computedStyle = computedStyle || d2.defaultView.getComputedStyle(elem, null);
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name2) || computedStyle[name2];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i");
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = "currentStyle";
var RUNTIME_STYLE = "runtimeStyle";
var LEFT = "left";
var PX = "px";
function _getComputedStyleIE(elem, name2) {
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name2];
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name2)) {
    var style2 = elem.style;
    var left = style2[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
    style2[LEFT] = name2 === "fontSize" ? "1em" : ret || 0;
    ret = style2.pixelLeft + PX;
    style2[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option2) {
  if (dir === "left") {
    return option2.useCssRight ? "right" : dir;
  }
  return option2.useCssBottom ? "bottom" : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === "left") {
    return "right";
  } else if (dir === "right") {
    return "left";
  } else if (dir === "top") {
    return "bottom";
  } else if (dir === "bottom") {
    return "top";
  }
}
function setLeftTop(elem, offset3, option2) {
  if (css$2(elem, "position") === "static") {
    elem.style.position = "relative";
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection("left", option2);
  var verticalProperty = getOffsetDirection("top", option2);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== "left") {
    presetH = 999;
  }
  if (verticalProperty !== "top") {
    presetV = 999;
  }
  var originalTransition = "";
  var originalOffset = getOffset$3(elem);
  if ("left" in offset3 || "top" in offset3) {
    originalTransition = getTransitionProperty(elem) || "";
    setTransitionProperty(elem, "none");
  }
  if ("left" in offset3) {
    elem.style[oppositeHorizontalProperty] = "";
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ("top" in offset3) {
    elem.style[oppositeVerticalProperty] = "";
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  forceRelayout(elem);
  var old = getOffset$3(elem);
  var originalStyle = {};
  for (var key2 in offset3) {
    if (offset3.hasOwnProperty(key2)) {
      var dir = getOffsetDirection(key2, option2);
      var preset = key2 === "left" ? presetH : presetV;
      var off2 = originalOffset[key2] - old[key2];
      if (dir === key2) {
        originalStyle[dir] = preset + off2;
      } else {
        originalStyle[dir] = preset - off2;
      }
    }
  }
  css$2(elem, originalStyle);
  forceRelayout(elem);
  if ("left" in offset3 || "top" in offset3) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset3) {
    if (offset3.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option2);
      var _off = offset3[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css$2(elem, ret);
}
function setTransform$1(elem, offset3) {
  var originalOffset = getOffset$3(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ("left" in offset3) {
    resultXY.x = originalXY.x + offset3.left - originalOffset.left;
  }
  if ("top" in offset3) {
    resultXY.y = originalXY.y + offset3.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset3, option2) {
  if (option2.ignoreShake) {
    var oriOffset = getOffset$3(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset3.left.toFixed(0);
    var tTop = offset3.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option2.useCssRight || option2.useCssBottom) {
    setLeftTop(elem, offset3, option2);
  } else if (option2.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset3);
  } else {
    setLeftTop(elem, offset3, option2);
  }
}
function each(arr, fn) {
  for (var i2 = 0; i2 < arr.length; i2++) {
    fn(arr[i2]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style2 = elem.style;
  var name2;
  for (name2 in options) {
    if (options.hasOwnProperty(name2)) {
      old[name2] = style2[name2];
      style2[name2] = options[name2];
    }
  }
  callback.call(elem);
  for (name2 in options) {
    if (options.hasOwnProperty(name2)) {
      style2[name2] = old[name2];
    }
  }
}
function getPBMWidth(elem, props2, which) {
  var value = 0;
  var prop;
  var j2;
  var i2;
  for (j2 = 0; j2 < props2.length; j2++) {
    prop = props2[j2];
    if (prop) {
      for (i2 = 0; i2 < which.length; i2++) {
        var cssProp = void 0;
        if (prop === "border") {
          cssProp = "".concat(prop).concat(which[i2], "Width");
        } else {
          cssProp = prop + which[i2];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent2 = element;
    do {
      if (parent2.nodeType === 11 && parent2.host) {
        parent2 = parent2.host;
      } else {
        parent2 = parent2.parentNode;
      }
    } while (parent2 && parent2.nodeType !== 1 && parent2.nodeType !== 9);
    return parent2;
  }
};
each(["Width", "Height"], function(name2) {
  domUtils["doc".concat(name2)] = function(refWin) {
    var d2 = refWin.document;
    return Math.max(d2.documentElement["scroll".concat(name2)], d2.body["scroll".concat(name2)], domUtils["viewport".concat(name2)](d2));
  };
  domUtils["viewport".concat(name2)] = function(win) {
    var prop = "client".concat(name2);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
  };
});
function getWH(elem, name2, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name2 === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name2 === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name2 === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  var borderBoxValue = name2 === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === void 0 || borderBoxValue <= 0) {
    borderBoxValue = void 0;
    cssBoxValue = getComputedStyleX(elem, name2);
    if (cssBoxValue === null || cssBoxValue === void 0 || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name2] || 0;
    }
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === void 0) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== void 0 || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ["border", "padding"], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ["border"], which) : getPBMWidth(elem, ["margin"], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(void 0, args);
  } else {
    swap(elem, cssShow, function() {
      val = getWH.apply(void 0, args);
    });
  }
  return val;
}
each(["width", "height"], function(name2) {
  var first = name2.charAt(0).toUpperCase() + name2.slice(1);
  domUtils["outer".concat(first)] = function(el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name2, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name2 === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[name2] = function(elem, v2) {
    var val = v2;
    if (val !== void 0) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ["padding", "border"], which);
        }
        return css$2(elem, name2, val);
      }
      return void 0;
    }
    return elem && getWHIgnoreDisplay(elem, name2, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i2 in from) {
    if (from.hasOwnProperty(i2)) {
      to[i2] = from[i2];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument,
  offset: function offset(el, value, option2) {
    if (typeof value !== "undefined") {
      setOffset(el, value, option2 || {});
    } else {
      return getOffset$3(el);
    }
  },
  isWindow,
  each,
  css: css$2,
  clone: function clone(obj) {
    var i2;
    var ret = {};
    for (i2 in obj) {
      if (obj.hasOwnProperty(i2)) {
        ret[i2] = obj[i2];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i2 in obj) {
        if (obj.hasOwnProperty(i2)) {
          ret.overflow[i2] = obj.overflow[i2];
        }
      }
    }
    return ret;
  },
  mix,
  getWindowScrollLeft: function getWindowScrollLeft(w2) {
    return getScrollLeft(w2);
  },
  getWindowScrollTop: function getWindowScrollTop(w2) {
    return getScrollTop(w2);
  },
  merge: function merge() {
    var ret = {};
    for (var i2 = 0; i2 < arguments.length; i2++) {
      utils.mix(ret, i2 < 0 || arguments.length <= i2 ? void 0 : arguments[i2]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);
var getParent$1 = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent2;
  var positionStyle = utils.css(element, "position");
  var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === "html" ? null : getParent$1(element);
  }
  for (parent2 = getParent$1(element); parent2 && parent2 !== body && parent2.nodeType !== 9; parent2 = getParent$1(parent2)) {
    positionStyle = utils.css(parent2, "position");
    if (positionStyle !== "static") {
      return parent2;
    }
  }
  return null;
}
var getParent$1$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent2 = null;
  for (parent2 = getParent$1$1(element); parent2 && parent2 !== body && parent2 !== doc; parent2 = getParent$1$1(parent2)) {
    var positionStyle = utils.css(parent2, "position");
    if (positionStyle === "fixed") {
      return true;
    }
  }
  return false;
}
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;
  while (el) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && el !== body && el !== documentElement && utils.css(el, "overflow") !== "visible") {
      var pos = utils.offset(el);
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position2 = utils.css(element, "position");
    if (position2 === "absolute") {
      element.style.position = "fixed";
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === "hidden") {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === "hidden") {
    documentHeight = win.innerHeight;
  }
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}
function getRegion(node) {
  var offset3;
  var w2;
  var h2;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset3 = utils.offset(node);
    w2 = utils.outerWidth(node);
    h2 = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset3 = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w2 = utils.viewportWidth(win);
    h2 = utils.viewportHeight(win);
  }
  offset3.width = w2;
  offset3.height = h2;
  return offset3;
}
function getAlignOffset(region, align) {
  var V2 = align.charAt(0);
  var H = align.charAt(1);
  var w2 = region.width;
  var h2 = region.height;
  var x2 = region.left;
  var y2 = region.top;
  if (V2 === "c") {
    y2 += h2 / 2;
  } else if (V2 === "b") {
    y2 += h2;
  }
  if (H === "c") {
    x2 += w2 / 2;
  } else if (H === "r") {
    x2 += w2;
  }
  return {
    left: x2,
    top: y2
  };
}
function getElFuturePos(elRegion, refNodeRegion, points, offset3, targetOffset2) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset3[0] - targetOffset2[0]),
    top: Math.round(elRegion.top - diff[1] + offset3[1] - targetOffset2[1])
  };
}
function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function(p2) {
    ret.push(p2.replace(reg, function(m2) {
      return map[m2];
    }));
  });
  return ret;
}
function flipOffset(offset3, index2) {
  offset3[index2] = -offset3[index2];
  return offset3;
}
function convertOffset(str, offsetLen) {
  var n2;
  if (/%$/.test(str)) {
    n2 = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n2 = parseInt(str, 10);
  }
  return n2 || 0;
}
function normalizeOffset(offset3, el) {
  offset3[0] = convertOffset(offset3[0], el.width);
  offset3[1] = convertOffset(offset3[1], el.height);
}
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset3 = align.offset || [0, 0];
  var targetOffset2 = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset3 = [].concat(offset3);
  targetOffset2 = [].concat(targetOffset2);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  var elRegion = getRegion(source);
  normalizeOffset(offset3, elRegion);
  normalizeOffset(targetOffset2, tgtRegion);
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
  var newElRegion = utils.merge(elRegion, elFuturePos);
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        var newPoints = flip(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
        var newOffset = flipOffset(offset3, 0);
        var newTargetOffset = flipOffset(targetOffset2, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset3 = newOffset;
          targetOffset2 = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        var _newPoints = flip(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
        var _newOffset = flipOffset(offset3, 1);
        var _newTargetOffset = flipOffset(targetOffset2, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset3 = _newOffset;
          targetOffset2 = _newTargetOffset;
        }
      }
    }
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
      }
      points = _newPoints2;
      offset3 = align.offset || [0, 0];
      targetOffset2 = align.targetOffset || [0, 0];
    }
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, "width", utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, "height", utils.height(source) + newElRegion.height - elRegion.height);
  }
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points,
    offset: offset3,
    targetOffset: targetOffset2,
    overflow: newOverflowCfg
  };
}
function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ("pageX" in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ("pageY" in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
  var points = [align.points[0], "cc"];
  return doAlign(el, tgtRegion, _objectSpread2$1(_objectSpread2$1({}, align), {}, {
    points
  }), pointInView);
}
function cloneElement(vnode) {
  var nodeProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var mergeRef = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var ele = vnode;
  if (Array.isArray(vnode)) {
    ele = filterEmpty(vnode)[0];
  }
  if (!ele) {
    return null;
  }
  var node = cloneVNode(ele, nodeProps, mergeRef);
  node.props = override ? _extends$2(_extends$2({}, node.props), nodeProps) : node.props;
  warning$2(_typeof$2(node.props.class) !== "object", "class must be string");
  return node;
}
function cloneVNodes(vnodes) {
  var nodeProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  return vnodes.map(function(vnode) {
    return cloneElement(vnode, nodeProps, override);
  });
}
var isVisible = function(element) {
  if (!element) {
    return false;
  }
  if (element.offsetParent) {
    return true;
  }
  if (element.getBBox) {
    var box = element.getBBox();
    if (box.width || box.height) {
      return true;
    }
  }
  if (element.getBoundingClientRect) {
    var _box = element.getBoundingClientRect();
    if (_box.width || _box.height) {
      return true;
    }
  }
  return false;
};
function isSamePoint(prev2, next2) {
  if (prev2 === next2)
    return true;
  if (!prev2 || !next2)
    return false;
  if ("pageX" in next2 && "pageY" in next2) {
    return prev2.pageX === next2.pageX && prev2.pageY === next2.pageY;
  }
  if ("clientX" in next2 && "clientY" in next2) {
    return prev2.clientX === next2.clientX && prev2.clientY === next2.clientY;
  }
  return false;
}
function restoreFocus(activeElement, container) {
  if (activeElement !== document.activeElement && contains(container, activeElement) && typeof activeElement.focus === "function") {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;
  function onResize(_ref) {
    var _ref2 = _slicedToArray$2(_ref, 1), target = _ref2[0].target;
    if (!document.documentElement.contains(target))
      return;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      Promise.resolve().then(function() {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }
    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }
  var resizeObserver = new index$b(onResize);
  if (element) {
    resizeObserver.observe(element);
  }
  return function() {
    resizeObserver.disconnect();
  };
}
var useBuffer = function(callback, buffer) {
  var called = false;
  var timeout = null;
  function cancelTrigger() {
    clearTimeout(timeout);
  }
  function trigger2(force) {
    if (!called || force === true) {
      if (callback() === false) {
        return;
      }
      called = true;
      cancelTrigger();
      timeout = setTimeout(function() {
        called = false;
      }, buffer.value);
    } else {
      cancelTrigger();
      timeout = setTimeout(function() {
        called = false;
        trigger2();
      }, buffer.value);
    }
  }
  return [trigger2, function() {
    called = false;
    cancelTrigger();
  }];
};
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function assocIndexOf(array4, key2) {
  var length = array4.length;
  while (length--) {
    if (eq(array4[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key2) {
  var data6 = this.__data__, index2 = assocIndexOf(data6, key2);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data6.length - 1;
  if (index2 == lastIndex) {
    data6.pop();
  } else {
    splice.call(data6, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key2) {
  var data6 = this.__data__, index2 = assocIndexOf(data6, key2);
  return index2 < 0 ? void 0 : data6[index2][1];
}
function listCacheHas(key2) {
  return assocIndexOf(this.__data__, key2) > -1;
}
function listCacheSet(key2, value) {
  var data6 = this.__data__, index2 = assocIndexOf(data6, key2);
  if (index2 < 0) {
    ++this.size;
    data6.push([key2, value]);
  } else {
    data6[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key2) {
  var data6 = this.__data__, result = data6["delete"](key2);
  this.size = data6.size;
  return result;
}
function stackGet(key2) {
  return this.__data__.get(key2);
}
function stackHas(key2) {
  return this.__data__.has(key2);
}
function isObject$4(value) {
  var type4 = typeof value;
  return value != null && (type4 == "object" || type4 == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$4(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
var coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid2 = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$c = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$b = objectProto$c.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$b).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value) {
  if (!isObject$4(value) || isMasked(value)) {
    return false;
  }
  var pattern4 = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern4.test(toSource(value));
}
function getValue$3(object4, key2) {
  return object4 == null ? void 0 : object4[key2];
}
function getNative(object4, key2) {
  var value = getValue$3(object4, key2);
  return baseIsNative(value) ? value : void 0;
}
var Map$1 = getNative(root$1, "Map");
var Map$2 = Map$1;
var nativeCreate = getNative(Object, "create");
var nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key2) {
  var result = this.has(key2) && delete this.__data__[key2];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$b = Object.prototype;
var hasOwnProperty$a = objectProto$b.hasOwnProperty;
function hashGet(key2) {
  var data6 = this.__data__;
  if (nativeCreate$1) {
    var result = data6[key2];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$a.call(data6, key2) ? data6[key2] : void 0;
}
var objectProto$a = Object.prototype;
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
function hashHas(key2) {
  var data6 = this.__data__;
  return nativeCreate$1 ? data6[key2] !== void 0 : hasOwnProperty$9.call(data6, key2);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key2, value) {
  var data6 = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data6[key2] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type4 = typeof value;
  return type4 == "string" || type4 == "number" || type4 == "symbol" || type4 == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key2) {
  var data6 = map.__data__;
  return isKeyable(key2) ? data6[typeof key2 == "string" ? "string" : "hash"] : data6.map;
}
function mapCacheDelete(key2) {
  var result = getMapData(this, key2)["delete"](key2);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key2) {
  return getMapData(this, key2).get(key2);
}
function mapCacheHas(key2) {
  return getMapData(this, key2).has(key2);
}
function mapCacheSet(key2, value) {
  var data6 = getMapData(this, key2), size = data6.size;
  data6.set(key2, value);
  this.size += data6.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet(key2, value) {
  var data6 = this.__data__;
  if (data6 instanceof ListCache) {
    var pairs = data6.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key2, value]);
      this.size = ++data6.size;
      return this;
    }
    data6 = this.__data__ = new MapCache(pairs);
  }
  data6.set(key2, value);
  this.size = data6.size;
  return this;
}
function Stack(entries) {
  var data6 = this.__data__ = new ListCache(entries);
  this.size = data6.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array4, predicate) {
  var index2 = -1, length = array4 == null ? 0 : array4.length;
  while (++index2 < length) {
    if (predicate(array4[index2], index2, array4)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key2) {
  return cache2.has(key2);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array4, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array4.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array4);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array4;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array4, other);
  stack.set(other, array4);
  while (++index2 < arrLength) {
    var arrValue = array4[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array4, stack) : customizer(arrValue, othValue, index2, array4, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array4);
  stack["delete"](other);
  return result;
}
var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;
function mapToArray(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key2) {
    result[++index2] = [key2, value];
  });
  return result;
}
function setToArray(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", mapTag$5 = "[object Map]", numberTag$4 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$3 = "[object Symbol]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]";
var symbolProto$2 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag(object4, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if (object4.byteLength != other.byteLength || object4.byteOffset != other.byteOffset) {
        return false;
      }
      object4 = object4.buffer;
      other = other.buffer;
    case arrayBufferTag$3:
      if (object4.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object4), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag$3:
    case dateTag$3:
    case numberTag$4:
      return eq(+object4, +other);
    case errorTag$2:
      return object4.name == other.name && object4.message == other.message;
    case regexpTag$3:
    case stringTag$3:
      return object4 == other + "";
    case mapTag$5:
      var convert = mapToArray;
    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object4.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object4);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object4, other);
      var result = equalArrays(convert(object4), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object4);
      return result;
    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object4) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
function arrayPush(array4, values) {
  var index2 = -1, length = values.length, offset3 = array4.length;
  while (++index2 < length) {
    array4[offset3 + index2] = values[index2];
  }
  return array4;
}
var isArray$2 = Array.isArray;
var isArray$3 = isArray$2;
function baseGetAllKeys(object4, keysFunc, symbolsFunc) {
  var result = keysFunc(object4);
  return isArray$3(object4) ? result : arrayPush(result, symbolsFunc(object4));
}
function arrayFilter(array4, predicate) {
  var index2 = -1, length = array4 == null ? 0 : array4.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array4[index2];
    if (predicate(value, index2, array4)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$9 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object4) {
  if (object4 == null) {
    return [];
  }
  object4 = Object(object4);
  return arrayFilter(nativeGetSymbols$1(object4), function(symbol) {
    return propertyIsEnumerable$1.call(object4, symbol);
  });
};
var getSymbols$1 = getSymbols;
function baseTimes(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}
var objectProto$8 = Object.prototype;
var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
var propertyIsEnumerable = objectProto$8.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$8.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments$1 = isArguments;
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type4 = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type4 == "number" || type4 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", funcTag$1 = "[object Function]", mapTag$4 = "[object Map]", numberTag$3 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$2 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e2) {
  }
}();
var nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
var objectProto$7 = Object.prototype;
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$3(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key2 in value) {
    if ((inherited || hasOwnProperty$7.call(value, key2)) && !(skipIndexes && (key2 == "length" || isBuff && (key2 == "offset" || key2 == "parent") || isType && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || isIndex(key2, length)))) {
      result.push(key2);
    }
  }
  return result;
}
var objectProto$6 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$6;
  return value === proto;
}
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
var objectProto$5 = Object.prototype;
var hasOwnProperty$6 = objectProto$5.hasOwnProperty;
function baseKeys(object4) {
  if (!isPrototype(object4)) {
    return nativeKeys$1(object4);
  }
  var result = [];
  for (var key2 in Object(object4)) {
    if (hasOwnProperty$6.call(object4, key2) && key2 != "constructor") {
      result.push(key2);
    }
  }
  return result;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$2(value);
}
function keys(object4) {
  return isArrayLike(object4) ? arrayLikeKeys(object4) : baseKeys(object4);
}
function getAllKeys$1(object4) {
  return baseGetAllKeys(object4, keys, getSymbols$1);
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$5 = objectProto$4.hasOwnProperty;
function equalObjects(object4, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys$1(object4), objLength = objProps.length, othProps = getAllKeys$1(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key2 = objProps[index2];
    if (!(isPartial ? key2 in other : hasOwnProperty$5.call(other, key2))) {
      return false;
    }
  }
  var objStacked = stack.get(object4);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object4;
  }
  var result = true;
  stack.set(object4, other);
  stack.set(other, object4);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key2 = objProps[index2];
    var objValue = object4[key2], othValue = other[key2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key2, other, object4, stack) : customizer(objValue, othValue, key2, object4, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key2 == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object4.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object4 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object4);
  stack["delete"](other);
  return result;
}
var DataView = getNative(root$1, "DataView");
var DataView$1 = DataView;
var Promise$1 = getNative(root$1, "Promise");
var Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
var Set$2 = Set$1;
var WeakMap$1 = getNative(root$1, "WeakMap");
var WeakMap$2 = WeakMap$1;
var mapTag$3 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$3 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", objectTag$1 = "[object Object]";
var objectProto$3 = Object.prototype;
var hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function baseIsEqualDeep(object4, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$3(object4), othIsArr = isArray$3(other), objTag = objIsArr ? arrayTag$1 : getTag$1(object4), othTag = othIsArr ? arrayTag$1 : getTag$1(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object4)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object4) ? equalArrays(object4, other, bitmask, customizer, equalFunc, stack) : equalByTag(object4, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$4.call(object4, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$4.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object4.value() : object4, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object4, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
function isEqual$2(value, other) {
  return baseIsEqual(value, other);
}
var alignProps = {
  align: Object,
  target: [Object, Function],
  onAlign: Function,
  monitorBufferTime: Number,
  monitorWindowResize: Boolean,
  disabled: Boolean
};
function getElement(func) {
  if (typeof func !== "function")
    return null;
  return func();
}
function getPoint(point) {
  if (_typeof$2(point) !== "object" || !point)
    return null;
  return point;
}
var Align = defineComponent({
  name: "Align",
  props: alignProps,
  emits: ["align"],
  setup: function setup8(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var cacheRef = ref({});
    var nodeRef = ref();
    var _useBuffer = useBuffer(function() {
      var latestDisabled = props2.disabled, latestTarget = props2.target, latestAlign = props2.align, latestOnAlign = props2.onAlign;
      if (!latestDisabled && latestTarget && nodeRef.value) {
        var source = nodeRef.value;
        var result;
        var element = getElement(latestTarget);
        var point = getPoint(latestTarget);
        cacheRef.value.element = element;
        cacheRef.value.point = point;
        cacheRef.value.align = latestAlign;
        var _document = document, activeElement = _document.activeElement;
        if (element && isVisible(element)) {
          result = alignElement(source, element, latestAlign);
        } else if (point) {
          result = alignPoint(source, point, latestAlign);
        }
        restoreFocus(activeElement, source);
        if (latestOnAlign && result) {
          latestOnAlign(source, result);
        }
        return true;
      }
      return false;
    }, computed(function() {
      return props2.monitorBufferTime;
    })), _useBuffer2 = _slicedToArray$2(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1];
    var resizeMonitor = ref({
      cancel: function cancel() {
      }
    });
    var sourceResizeMonitor = ref({
      cancel: function cancel() {
      }
    });
    var goAlign = function goAlign2() {
      var target = props2.target;
      var element = getElement(target);
      var point = getPoint(target);
      if (nodeRef.value !== sourceResizeMonitor.value.element) {
        sourceResizeMonitor.value.cancel();
        sourceResizeMonitor.value.element = nodeRef.value;
        sourceResizeMonitor.value.cancel = monitorResize(nodeRef.value, _forceAlign);
      }
      if (cacheRef.value.element !== element || !isSamePoint(cacheRef.value.point, point) || !isEqual$2(cacheRef.value.align, props2.align)) {
        _forceAlign();
        if (resizeMonitor.value.element !== element) {
          resizeMonitor.value.cancel();
          resizeMonitor.value.element = element;
          resizeMonitor.value.cancel = monitorResize(element, _forceAlign);
        }
      }
    };
    onMounted(function() {
      nextTick(function() {
        goAlign();
      });
    });
    onUpdated(function() {
      nextTick(function() {
        goAlign();
      });
    });
    watch(function() {
      return props2.disabled;
    }, function(disabled) {
      if (!disabled) {
        _forceAlign();
      } else {
        cancelForceAlign();
      }
    }, {
      immediate: true,
      flush: "post"
    });
    var winResizeRef = ref(null);
    watch(function() {
      return props2.monitorWindowResize;
    }, function(monitorWindowResize) {
      if (monitorWindowResize) {
        if (!winResizeRef.value) {
          winResizeRef.value = addEventListenerWrap(window, "resize", _forceAlign);
        }
      } else if (winResizeRef.value) {
        winResizeRef.value.remove();
        winResizeRef.value = null;
      }
    }, {
      flush: "post"
    });
    onUnmounted(function() {
      resizeMonitor.value.cancel();
      sourceResizeMonitor.value.cancel();
      if (winResizeRef.value)
        winResizeRef.value.remove();
      cancelForceAlign();
    });
    expose({
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    });
    return function() {
      var child = slots === null || slots === void 0 ? void 0 : slots.default();
      if (child) {
        return cloneElement(child[0], {
          ref: nodeRef
        }, true, true);
      }
      return null;
    };
  }
});
var PopupInner = defineComponent({
  name: "PopupInner",
  inheritAttrs: false,
  props: innerProps,
  emits: ["mouseenter", "mouseleave", "mousedown", "touchstart", "align"],
  setup: function setup9(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs, slots = _ref.slots;
    var alignRef = ref();
    var elementRef = ref();
    var alignedClassName = ref();
    var _useStretchStyle = useStretchStyle(toRef(props2, "stretch")), _useStretchStyle2 = _slicedToArray$2(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    var doMeasure = function doMeasure2() {
      if (props2.stretch) {
        measureStretchStyle(props2.getRootDomNode());
      }
    };
    var visible = ref(false);
    var timeoutId;
    watch(function() {
      return props2.visible;
    }, function(val) {
      clearTimeout(timeoutId);
      if (val) {
        timeoutId = setTimeout(function() {
          visible.value = props2.visible;
        });
      } else {
        visible.value = false;
      }
    }, {
      immediate: true
    });
    var _useVisibleStatus = useVisibleStatus(visible, doMeasure), _useVisibleStatus2 = _slicedToArray$2(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1];
    var prepareResolveRef = ref();
    var getAlignTarget = function getAlignTarget2() {
      if (props2.point) {
        return props2.point;
      }
      return props2.getRootDomNode;
    };
    var forceAlign = function forceAlign2() {
      var _a2;
      (_a2 = alignRef.value) === null || _a2 === void 0 ? void 0 : _a2.forceAlign();
    };
    var onInternalAlign = function onInternalAlign2(popupDomNode, matchAlign) {
      var _a2;
      var nextAlignedClassName = props2.getClassNameFromAlign(matchAlign);
      var preAlignedClassName = alignedClassName.value;
      if (alignedClassName.value !== nextAlignedClassName) {
        alignedClassName.value = nextAlignedClassName;
      }
      if (status.value === "align") {
        if (preAlignedClassName !== nextAlignedClassName) {
          Promise.resolve().then(function() {
            forceAlign();
          });
        } else {
          goNextStatus(function() {
            var _a3;
            (_a3 = prepareResolveRef.value) === null || _a3 === void 0 ? void 0 : _a3.call(prepareResolveRef);
          });
        }
        (_a2 = props2.onAlign) === null || _a2 === void 0 ? void 0 : _a2.call(props2, popupDomNode, matchAlign);
      }
    };
    var motion = computed(function() {
      var m2 = _typeof$2(props2.animation) === "object" ? props2.animation : getMotion(props2);
      ["onAfterEnter", "onAfterLeave"].forEach(function(eventName) {
        var originFn = m2[eventName];
        m2[eventName] = function(node) {
          goNextStatus();
          status.value = "stable";
          originFn === null || originFn === void 0 ? void 0 : originFn(node);
        };
      });
      return m2;
    });
    var onShowPrepare = function onShowPrepare2() {
      return new Promise(function(resolve) {
        prepareResolveRef.value = resolve;
      });
    };
    watch([motion, status], function() {
      if (!motion.value && status.value === "motion") {
        goNextStatus();
      }
    }, {
      immediate: true
    });
    expose({
      forceAlign,
      getElement: function getElement2() {
        return elementRef.value.$el || elementRef.value;
      }
    });
    var alignDisabled = computed(function() {
      var _a2;
      if (((_a2 = props2.align) === null || _a2 === void 0 ? void 0 : _a2.points) && (status.value === "align" || status.value === "stable")) {
        return false;
      }
      return true;
    });
    return function() {
      var _a2;
      var zIndex = props2.zIndex, align = props2.align, prefixCls2 = props2.prefixCls, destroyPopupOnHide = props2.destroyPopupOnHide, onMouseenter2 = props2.onMouseenter, onMouseleave2 = props2.onMouseleave, _props$onTouchstart = props2.onTouchstart, onTouchstart2 = _props$onTouchstart === void 0 ? function() {
      } : _props$onTouchstart, onMousedown2 = props2.onMousedown;
      var statusValue = status.value;
      var mergedStyle = [_extends$2(_extends$2({}, stretchStyle.value), {
        zIndex,
        opacity: statusValue === "motion" || statusValue === "stable" || !visible.value ? null : 0,
        pointerEvents: statusValue === "stable" ? null : "none"
      }), attrs.style];
      var childNode = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots, {
        visible: props2.visible
      }));
      if (childNode.length > 1) {
        childNode = createVNode("div", {
          "class": "".concat(prefixCls2, "-content")
        }, [childNode]);
      }
      var mergedClassName = classNames(prefixCls2, attrs.class, alignedClassName.value);
      var hasAnimate = visible.value || !props2.visible;
      var transitionProps = hasAnimate ? getTransitionProps(motion.value.name, motion.value) : {};
      return createVNode(Transition$2, _objectSpread2$2(_objectSpread2$2({
        "ref": elementRef
      }, transitionProps), {}, {
        "onBeforeEnter": onShowPrepare
      }), {
        default: function _default7() {
          return !destroyPopupOnHide || props2.visible ? withDirectives(createVNode(Align, {
            "target": getAlignTarget(),
            "key": "popup",
            "ref": alignRef,
            "monitorWindowResize": true,
            "disabled": alignDisabled.value,
            "align": align,
            "onAlign": onInternalAlign
          }, {
            default: function _default8() {
              return createVNode("div", _objectSpread2$2(_objectSpread2$2({
                "class": mergedClassName,
                "onMouseenter": onMouseenter2,
                "onMouseleave": onMouseleave2,
                "onMousedown": withModifiers(onMousedown2, ["capture"])
              }, _defineProperty$R({}, supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart", withModifiers(onTouchstart2, ["capture"]))), {}, {
                "style": mergedStyle
              }), [childNode]);
            }
          }), [[vShow, visible.value]]) : null;
        }
      });
    };
  }
});
var Popup = defineComponent({
  name: "Popup",
  inheritAttrs: false,
  props: popupProps,
  setup: function setup10(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose;
    var innerVisible = ref(false);
    var inMobile = ref(false);
    var popupRef = ref();
    watch([function() {
      return props2.visible;
    }, function() {
      return props2.mobile;
    }], function() {
      innerVisible.value = props2.visible;
      if (props2.visible && props2.mobile) {
        inMobile.value = true;
      }
    }, {
      immediate: true,
      flush: "post"
    });
    expose({
      forceAlign: function forceAlign() {
        var _a2;
        (_a2 = popupRef.value) === null || _a2 === void 0 ? void 0 : _a2.forceAlign();
      },
      getElement: function getElement2() {
        var _a2;
        return (_a2 = popupRef.value) === null || _a2 === void 0 ? void 0 : _a2.getElement();
      }
    });
    return function() {
      var cloneProps = _extends$2(_extends$2(_extends$2({}, props2), attrs), {
        visible: innerVisible.value
      });
      var popupNode = inMobile.value ? createVNode(MobilePopupInner, _objectSpread2$2(_objectSpread2$2({}, cloneProps), {}, {
        "mobile": props2.mobile,
        "ref": popupRef
      }), {
        default: slots.default
      }) : createVNode(PopupInner, _objectSpread2$2(_objectSpread2$2({}, cloneProps), {}, {
        "ref": popupRef
      }), {
        default: slots.default
      });
      return createVNode("div", null, [createVNode(Mask$1, cloneProps, null), popupNode]);
    };
  }
});
function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return _extends$2(_extends$2({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls2, align, isAlignPoint) {
  var points = align.points;
  var placements2 = Object.keys(builtinPlacements);
  for (var i2 = 0; i2 < placements2.length; i2 += 1) {
    var placement = placements2[i2];
    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls2, "-placement-").concat(placement);
    }
  }
  return "";
}
var BaseMixin = {
  methods: {
    setState: function setState() {
      var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : void 0;
      var newState = typeof state === "function" ? state(this.$data, this.$props) : state;
      if (this.getDerivedStateFromProps) {
        var s2 = this.getDerivedStateFromProps(getOptionProps(this), _extends$2(_extends$2({}, this.$data), newState));
        if (s2 === null) {
          return;
        } else {
          newState = _extends$2(_extends$2({}, newState), s2 || {});
        }
      }
      _extends$2(this.$data, newState);
      if (this._.isMounted) {
        this.$forceUpdate();
      }
      nextTick(function() {
        callback && callback();
      });
    },
    __emit: function __emit() {
      var args = [].slice.call(arguments, 0);
      var eventName = args[0];
      eventName = "on".concat(eventName[0].toUpperCase()).concat(eventName.substring(1));
      var event = this.$props[eventName] || this.$attrs[eventName];
      if (args.length && event) {
        if (Array.isArray(event)) {
          for (var i2 = 0, l2 = event.length; i2 < l2; i2++) {
            event[i2].apply(event, _toConsumableArray(args.slice(1)));
          }
        } else {
          event.apply(void 0, _toConsumableArray(args.slice(1)));
        }
      }
    }
  }
};
var TriggerContextKey = Symbol("TriggerContextKey");
var useProviderTrigger = function useProviderTrigger2() {
  var portal = null;
  provide(TriggerContextKey, {
    setPortal: function setPortal(val) {
      portal = val;
    },
    popPortal: true
  });
  return function() {
    return portal;
  };
};
var useInjectTrigger = function useInjectTrigger2() {
  return inject(TriggerContextKey, {
    setPortal: function setPortal() {
    },
    popPortal: false
  });
};
var PortalContextKey = Symbol("PortalContextKey");
var useProvidePortal = function useProvidePortal2(instance2) {
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inTriggerContext: true
  };
  provide(PortalContextKey, {
    inTriggerContext: config.inTriggerContext,
    shouldRender: computed(function() {
      var _ref = instance2 || {}, sPopupVisible = _ref.sPopupVisible, popupRef = _ref.popupRef, forceRender = _ref.forceRender, autoDestroy = _ref.autoDestroy;
      var shouldRender = false;
      if (sPopupVisible || popupRef || forceRender) {
        shouldRender = true;
      }
      if (!sPopupVisible && autoDestroy) {
        shouldRender = false;
      }
      return shouldRender;
    })
  });
};
var useInjectPortal = function useInjectPortal2() {
  useProvidePortal({}, {
    inTriggerContext: false
  });
  var portalContext = inject(PortalContextKey, {
    shouldRender: computed(function() {
      return false;
    }),
    inTriggerContext: false
  });
  return {
    shouldRender: computed(function() {
      return portalContext.shouldRender.value || portalContext.inTriggerContext === false;
    })
  };
};
var Portal$1 = defineComponent({
  name: "Portal",
  inheritAttrs: false,
  props: {
    getContainer: PropTypes$1.func.isRequired,
    didUpdate: Function
  },
  setup: function setup11(props2, _ref) {
    var slots = _ref.slots;
    var isSSR = true;
    var container;
    var _useInjectPortal = useInjectPortal(), shouldRender = _useInjectPortal.shouldRender;
    onBeforeMount(function() {
      isSSR = false;
      if (shouldRender.value) {
        container = props2.getContainer();
      }
    });
    var stopWatch = watch(shouldRender, function() {
      if (shouldRender.value && !container) {
        container = props2.getContainer();
      }
      if (container) {
        stopWatch();
      }
    });
    onUpdated(function() {
      nextTick(function() {
        var _a2;
        if (shouldRender.value) {
          (_a2 = props2.didUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(props2, props2);
        }
      });
    });
    onBeforeUnmount(function() {
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    });
    return function() {
      var _a2;
      if (!shouldRender.value)
        return null;
      if (isSSR) {
        return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      }
      return container ? createVNode(Teleport, {
        "to": container
      }, slots) : null;
    };
  }
});
function noop$4() {
}
function returnEmptyString() {
  return "";
}
function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }
  return window.document;
}
var ALL_HANDLERS = ["onClick", "onMousedown", "onTouchstart", "onMouseenter", "onMouseleave", "onFocus", "onBlur", "onContextmenu"];
var Trigger = defineComponent({
  name: "Trigger",
  mixins: [BaseMixin],
  inheritAttrs: false,
  props: {
    action: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]).def([]),
    showAction: PropTypes$1.any.def([]),
    hideAction: PropTypes$1.any.def([]),
    getPopupClassNameFromAlign: PropTypes$1.any.def(returnEmptyString),
    onPopupVisibleChange: Function,
    afterPopupVisibleChange: PropTypes$1.func.def(noop$4),
    popup: PropTypes$1.any,
    popupStyle: {
      type: Object,
      default: void 0
    },
    prefixCls: PropTypes$1.string.def("rc-trigger-popup"),
    popupClassName: PropTypes$1.string.def(""),
    popupPlacement: String,
    builtinPlacements: PropTypes$1.object,
    popupTransitionName: String,
    popupAnimation: PropTypes$1.any,
    mouseEnterDelay: PropTypes$1.number.def(0),
    mouseLeaveDelay: PropTypes$1.number.def(0.1),
    zIndex: Number,
    focusDelay: PropTypes$1.number.def(0),
    blurDelay: PropTypes$1.number.def(0.15),
    getPopupContainer: Function,
    getDocument: PropTypes$1.func.def(returnDocument),
    forceRender: {
      type: Boolean,
      default: void 0
    },
    destroyPopupOnHide: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    popupAlign: PropTypes$1.object.def(function() {
      return {};
    }),
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    defaultPopupVisible: {
      type: Boolean,
      default: false
    },
    maskTransitionName: String,
    maskAnimation: String,
    stretch: String,
    alignPoint: {
      type: Boolean,
      default: void 0
    },
    autoDestroy: {
      type: Boolean,
      default: false
    },
    mobile: Object,
    getTriggerDOMNode: Function
  },
  setup: function setup12(props2) {
    var align = computed(function() {
      var popupPlacement = props2.popupPlacement, popupAlign = props2.popupAlign, builtinPlacements = props2.builtinPlacements;
      if (popupPlacement && builtinPlacements) {
        return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
      }
      return popupAlign;
    });
    var _useInjectTrigger = useInjectTrigger(), setPortal = _useInjectTrigger.setPortal, popPortal = _useInjectTrigger.popPortal;
    var popupRef = ref(null);
    var setPopupRef = function setPopupRef2(val) {
      popupRef.value = val;
    };
    return {
      popPortal,
      setPortal,
      vcTriggerContext: inject("vcTriggerContext", {}),
      popupRef,
      setPopupRef,
      triggerRef: ref(null),
      align,
      focusTime: null,
      clickOutsideHandler: null,
      contextmenuOutsideHandler1: null,
      contextmenuOutsideHandler2: null,
      touchOutsideHandler: null,
      attachId: null,
      delayTimer: null,
      hasPopupMouseDown: false,
      preClickTime: null,
      preTouchTime: null,
      mouseDownTimeout: null,
      childOriginEvents: {}
    };
  },
  data: function data() {
    var _this = this;
    var _a2, _b;
    var props2 = this.$props;
    var popupVisible2;
    if (this.popupVisible !== void 0) {
      popupVisible2 = !!props2.popupVisible;
    } else {
      popupVisible2 = !!props2.defaultPopupVisible;
    }
    ALL_HANDLERS.forEach(function(h2) {
      _this["fire".concat(h2)] = function(e2) {
        _this.fireEvents(h2, e2);
      };
    });
    (_b = (_a2 = this).setPortal) === null || _b === void 0 ? void 0 : _b.call(_a2, createVNode(Portal$1, {
      "key": "portal",
      "getContainer": this.getContainer,
      "didUpdate": this.handlePortalUpdate
    }, {
      default: this.getComponent
    }));
    return {
      prevPopupVisible: popupVisible2,
      sPopupVisible: popupVisible2,
      point: null
    };
  },
  watch: {
    popupVisible: function popupVisible(val) {
      if (val !== void 0) {
        this.prevPopupVisible = this.sPopupVisible;
        this.sPopupVisible = val;
      }
    }
  },
  created: function created() {
    provide("vcTriggerContext", {
      onPopupMouseDown: this.onPopupMouseDown
    });
    useProvidePortal(this);
  },
  deactivated: function deactivated() {
    this.setPopupVisible(false);
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function() {
      _this2.updatedCal();
    });
  },
  updated: function updated() {
    var _this3 = this;
    this.$nextTick(function() {
      _this3.updatedCal();
    });
  },
  beforeUnmount: function beforeUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
    wrapperRaf.cancel(this.attachId);
  },
  methods: {
    updatedCal: function updatedCal() {
      var props2 = this.$props;
      var state = this.$data;
      if (state.sPopupVisible) {
        var currentDocument;
        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextmenuToShow())) {
          currentDocument = props2.getDocument(this.getRootDomNode());
          this.clickOutsideHandler = addEventListenerWrap(currentDocument, "mousedown", this.onDocumentClick);
        }
        if (!this.touchOutsideHandler) {
          currentDocument = currentDocument || props2.getDocument(this.getRootDomNode());
          this.touchOutsideHandler = addEventListenerWrap(currentDocument, "touchstart", this.onDocumentClick, supportsPassive$1 ? {
            passive: false
          } : false);
        }
        if (!this.contextmenuOutsideHandler1 && this.isContextmenuToShow()) {
          currentDocument = currentDocument || props2.getDocument(this.getRootDomNode());
          this.contextmenuOutsideHandler1 = addEventListenerWrap(currentDocument, "scroll", this.onContextmenuClose);
        }
        if (!this.contextmenuOutsideHandler2 && this.isContextmenuToShow()) {
          this.contextmenuOutsideHandler2 = addEventListenerWrap(window, "blur", this.onContextmenuClose);
        }
      } else {
        this.clearOutsideHandler();
      }
    },
    onMouseenter: function onMouseenter(e2) {
      var mouseEnterDelay = this.$props.mouseEnterDelay;
      this.fireEvents("onMouseenter", e2);
      this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e2);
    },
    onMouseMove: function onMouseMove(e2) {
      this.fireEvents("onMousemove", e2);
      this.setPoint(e2);
    },
    onMouseleave: function onMouseleave(e2) {
      this.fireEvents("onMouseleave", e2);
      this.delaySetPopupVisible(false, this.$props.mouseLeaveDelay);
    },
    onPopupMouseenter: function onPopupMouseenter() {
      this.clearDelayTimer();
    },
    onPopupMouseleave: function onPopupMouseleave(e2) {
      var _a2;
      if (e2 && e2.relatedTarget && !e2.relatedTarget.setTimeout && contains((_a2 = this.popupRef) === null || _a2 === void 0 ? void 0 : _a2.getElement(), e2.relatedTarget)) {
        return;
      }
      this.delaySetPopupVisible(false, this.$props.mouseLeaveDelay);
    },
    onFocus: function onFocus(e2) {
      this.fireEvents("onFocus", e2);
      this.clearDelayTimer();
      if (this.isFocusToShow()) {
        this.focusTime = Date.now();
        this.delaySetPopupVisible(true, this.$props.focusDelay);
      }
    },
    onMousedown: function onMousedown(e2) {
      this.fireEvents("onMousedown", e2);
      this.preClickTime = Date.now();
    },
    onTouchstart: function onTouchstart(e2) {
      this.fireEvents("onTouchstart", e2);
      this.preTouchTime = Date.now();
    },
    onBlur: function onBlur(e2) {
      if (!contains(e2.target, e2.relatedTarget || document.activeElement)) {
        this.fireEvents("onBlur", e2);
        this.clearDelayTimer();
        if (this.isBlurToHide()) {
          this.delaySetPopupVisible(false, this.$props.blurDelay);
        }
      }
    },
    onContextmenu: function onContextmenu(e2) {
      e2.preventDefault();
      this.fireEvents("onContextmenu", e2);
      this.setPopupVisible(true, e2);
    },
    onContextmenuClose: function onContextmenuClose() {
      if (this.isContextmenuToShow()) {
        this.close();
      }
    },
    onClick: function onClick(event) {
      this.fireEvents("onClick", event);
      if (this.focusTime) {
        var preTime;
        if (this.preClickTime && this.preTouchTime) {
          preTime = Math.min(this.preClickTime, this.preTouchTime);
        } else if (this.preClickTime) {
          preTime = this.preClickTime;
        } else if (this.preTouchTime) {
          preTime = this.preTouchTime;
        }
        if (Math.abs(preTime - this.focusTime) < 20) {
          return;
        }
        this.focusTime = 0;
      }
      this.preClickTime = 0;
      this.preTouchTime = 0;
      if (this.isClickToShow() && (this.isClickToHide() || this.isBlurToHide()) && event && event.preventDefault) {
        event.preventDefault();
      }
      if (event && event.domEvent) {
        event.domEvent.preventDefault();
      }
      var nextVisible = !this.$data.sPopupVisible;
      if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
        this.setPopupVisible(!this.$data.sPopupVisible, event);
      }
    },
    onPopupMouseDown: function onPopupMouseDown() {
      var _this4 = this;
      var _this$vcTriggerContex = this.vcTriggerContext, vcTriggerContext = _this$vcTriggerContex === void 0 ? {} : _this$vcTriggerContex;
      this.hasPopupMouseDown = true;
      clearTimeout(this.mouseDownTimeout);
      this.mouseDownTimeout = setTimeout(function() {
        _this4.hasPopupMouseDown = false;
      }, 0);
      if (vcTriggerContext.onPopupMouseDown) {
        vcTriggerContext.onPopupMouseDown.apply(vcTriggerContext, arguments);
      }
    },
    onDocumentClick: function onDocumentClick(event) {
      if (this.$props.mask && !this.$props.maskClosable) {
        return;
      }
      var target = event.target;
      var root2 = this.getRootDomNode();
      var popupNode = this.getPopupDomNode();
      if ((!contains(root2, target) || this.isContextMenuOnly()) && !contains(popupNode, target) && !this.hasPopupMouseDown) {
        this.delaySetPopupVisible(false, 0.1);
      }
    },
    getPopupDomNode: function getPopupDomNode() {
      var _a2;
      return ((_a2 = this.popupRef) === null || _a2 === void 0 ? void 0 : _a2.getElement()) || null;
    },
    getRootDomNode: function getRootDomNode() {
      var getTriggerDOMNode = this.$props.getTriggerDOMNode;
      if (getTriggerDOMNode) {
        return getTriggerDOMNode(this.triggerRef);
      }
      try {
        var domNode = findDOMNode(this.triggerRef);
        if (domNode) {
          return domNode;
        }
      } catch (err) {
      }
      return findDOMNode(this);
    },
    handleGetPopupClassFromAlign: function handleGetPopupClassFromAlign(align) {
      var className = [];
      var props2 = this.$props;
      var popupPlacement = props2.popupPlacement, builtinPlacements = props2.builtinPlacements, prefixCls2 = props2.prefixCls, alignPoint2 = props2.alignPoint, getPopupClassNameFromAlign = props2.getPopupClassNameFromAlign;
      if (popupPlacement && builtinPlacements) {
        className.push(getAlignPopupClassName(builtinPlacements, prefixCls2, align, alignPoint2));
      }
      if (getPopupClassNameFromAlign) {
        className.push(getPopupClassNameFromAlign(align));
      }
      return className.join(" ");
    },
    getPopupAlign: function getPopupAlign() {
      var props2 = this.$props;
      var popupPlacement = props2.popupPlacement, popupAlign = props2.popupAlign, builtinPlacements = props2.builtinPlacements;
      if (popupPlacement && builtinPlacements) {
        return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
      }
      return popupAlign;
    },
    getComponent: function getComponent$1() {
      var _this5 = this;
      var mouseProps = {};
      if (this.isMouseEnterToShow()) {
        mouseProps.onMouseenter = this.onPopupMouseenter;
      }
      if (this.isMouseLeaveToHide()) {
        mouseProps.onMouseleave = this.onPopupMouseleave;
      }
      mouseProps.onMousedown = this.onPopupMouseDown;
      mouseProps[supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart"] = this.onPopupMouseDown;
      var handleGetPopupClassFromAlign2 = this.handleGetPopupClassFromAlign, getRootDomNode2 = this.getRootDomNode, getContainer4 = this.getContainer, $attrs = this.$attrs;
      var _this$$props = this.$props, prefixCls2 = _this$$props.prefixCls, destroyPopupOnHide = _this$$props.destroyPopupOnHide, popupClassName = _this$$props.popupClassName, popupAnimation = _this$$props.popupAnimation, popupTransitionName = _this$$props.popupTransitionName, popupStyle = _this$$props.popupStyle, mask = _this$$props.mask, maskAnimation = _this$$props.maskAnimation, maskTransitionName = _this$$props.maskTransitionName, zIndex = _this$$props.zIndex, stretch = _this$$props.stretch, alignPoint2 = _this$$props.alignPoint, mobile = _this$$props.mobile, forceRender = _this$$props.forceRender;
      var _this$$data = this.$data, sPopupVisible = _this$$data.sPopupVisible, point = _this$$data.point;
      var popupProps2 = _extends$2(_extends$2({
        prefixCls: prefixCls2,
        destroyPopupOnHide,
        visible: sPopupVisible,
        point: alignPoint2 ? point : null,
        align: this.align,
        animation: popupAnimation,
        getClassNameFromAlign: handleGetPopupClassFromAlign2,
        stretch,
        getRootDomNode: getRootDomNode2,
        mask,
        zIndex,
        transitionName: popupTransitionName,
        maskAnimation,
        maskTransitionName,
        getContainer: getContainer4,
        class: popupClassName,
        style: popupStyle,
        onAlign: $attrs.onPopupAlign || noop$4
      }, mouseProps), {
        ref: this.setPopupRef,
        mobile,
        forceRender
      });
      return createVNode(Popup, popupProps2, {
        default: this.$slots.popup || function() {
          return getComponent(_this5, "popup");
        }
      });
    },
    attachParent: function attachParent(popupContainer) {
      var _this6 = this;
      wrapperRaf.cancel(this.attachId);
      var _this$$props2 = this.$props, getPopupContainer = _this$$props2.getPopupContainer, getDocument2 = _this$$props2.getDocument;
      var domNode = this.getRootDomNode();
      var mountNode;
      if (!getPopupContainer) {
        mountNode = getDocument2(this.getRootDomNode()).body;
      } else if (domNode || getPopupContainer.length === 0) {
        mountNode = getPopupContainer(domNode);
      }
      if (mountNode) {
        mountNode.appendChild(popupContainer);
      } else {
        this.attachId = wrapperRaf(function() {
          _this6.attachParent(popupContainer);
        });
      }
    },
    getContainer: function getContainer3() {
      var props2 = this.$props;
      var getDocument2 = props2.getDocument;
      var popupContainer = getDocument2(this.getRootDomNode()).createElement("div");
      popupContainer.style.position = "absolute";
      popupContainer.style.top = "0";
      popupContainer.style.left = "0";
      popupContainer.style.width = "100%";
      this.attachParent(popupContainer);
      return popupContainer;
    },
    setPopupVisible: function setPopupVisible(sPopupVisible, event) {
      var alignPoint2 = this.alignPoint, prevPopupVisible = this.sPopupVisible, onPopupVisibleChange = this.onPopupVisibleChange;
      this.clearDelayTimer();
      if (prevPopupVisible !== sPopupVisible) {
        if (!hasProp(this, "popupVisible")) {
          this.setState({
            sPopupVisible,
            prevPopupVisible
          });
        }
        onPopupVisibleChange && onPopupVisibleChange(sPopupVisible);
      }
      if (alignPoint2 && event && sPopupVisible) {
        this.setPoint(event);
      }
    },
    setPoint: function setPoint(point) {
      var alignPoint2 = this.$props.alignPoint;
      if (!alignPoint2 || !point)
        return;
      this.setState({
        point: {
          pageX: point.pageX,
          pageY: point.pageY
        }
      });
    },
    handlePortalUpdate: function handlePortalUpdate() {
      if (this.prevPopupVisible !== this.sPopupVisible) {
        this.afterPopupVisibleChange(this.sPopupVisible);
      }
    },
    delaySetPopupVisible: function delaySetPopupVisible(visible, delayS, event) {
      var _this7 = this;
      var delay = delayS * 1e3;
      this.clearDelayTimer();
      if (delay) {
        var point = event ? {
          pageX: event.pageX,
          pageY: event.pageY
        } : null;
        this.delayTimer = requestAnimationTimeout(function() {
          _this7.setPopupVisible(visible, point);
          _this7.clearDelayTimer();
        }, delay);
      } else {
        this.setPopupVisible(visible, event);
      }
    },
    clearDelayTimer: function clearDelayTimer() {
      if (this.delayTimer) {
        cancelAnimationTimeout(this.delayTimer);
        this.delayTimer = null;
      }
    },
    clearOutsideHandler: function clearOutsideHandler() {
      if (this.clickOutsideHandler) {
        this.clickOutsideHandler.remove();
        this.clickOutsideHandler = null;
      }
      if (this.contextmenuOutsideHandler1) {
        this.contextmenuOutsideHandler1.remove();
        this.contextmenuOutsideHandler1 = null;
      }
      if (this.contextmenuOutsideHandler2) {
        this.contextmenuOutsideHandler2.remove();
        this.contextmenuOutsideHandler2 = null;
      }
      if (this.touchOutsideHandler) {
        this.touchOutsideHandler.remove();
        this.touchOutsideHandler = null;
      }
    },
    createTwoChains: function createTwoChains(event) {
      var fn = function fn2() {
      };
      var events2 = getEvents(this);
      if (this.childOriginEvents[event] && events2[event]) {
        return this["fire".concat(event)];
      }
      fn = this.childOriginEvents[event] || events2[event] || fn;
      return fn;
    },
    isClickToShow: function isClickToShow() {
      var _this$$props3 = this.$props, action = _this$$props3.action, showAction = _this$$props3.showAction;
      return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
    },
    isContextMenuOnly: function isContextMenuOnly() {
      var action = this.$props.action;
      return action === "contextmenu" || action.length === 1 && action[0] === "contextmenu";
    },
    isContextmenuToShow: function isContextmenuToShow() {
      var _this$$props4 = this.$props, action = _this$$props4.action, showAction = _this$$props4.showAction;
      return action.indexOf("contextmenu") !== -1 || showAction.indexOf("contextmenu") !== -1;
    },
    isClickToHide: function isClickToHide() {
      var _this$$props5 = this.$props, action = _this$$props5.action, hideAction = _this$$props5.hideAction;
      return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
    },
    isMouseEnterToShow: function isMouseEnterToShow() {
      var _this$$props6 = this.$props, action = _this$$props6.action, showAction = _this$$props6.showAction;
      return action.indexOf("hover") !== -1 || showAction.indexOf("mouseenter") !== -1;
    },
    isMouseLeaveToHide: function isMouseLeaveToHide() {
      var _this$$props7 = this.$props, action = _this$$props7.action, hideAction = _this$$props7.hideAction;
      return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseleave") !== -1;
    },
    isFocusToShow: function isFocusToShow() {
      var _this$$props8 = this.$props, action = _this$$props8.action, showAction = _this$$props8.showAction;
      return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
    },
    isBlurToHide: function isBlurToHide() {
      var _this$$props9 = this.$props, action = _this$$props9.action, hideAction = _this$$props9.hideAction;
      return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
    },
    forcePopupAlign: function forcePopupAlign() {
      var _a2;
      if (this.$data.sPopupVisible) {
        (_a2 = this.popupRef) === null || _a2 === void 0 ? void 0 : _a2.forceAlign();
      }
    },
    fireEvents: function fireEvents(type4, e2) {
      if (this.childOriginEvents[type4]) {
        this.childOriginEvents[type4](e2);
      }
      var event = this.$props[type4] || this.$attrs[type4];
      if (event) {
        event(e2);
      }
    },
    close: function close2() {
      this.setPopupVisible(false);
    }
  },
  render: function render2() {
    var _this8 = this;
    var $attrs = this.$attrs;
    var children = filterEmpty(getSlot$1(this));
    var alignPoint2 = this.$props.alignPoint;
    var child = children[0];
    this.childOriginEvents = getEvents(child);
    var newChildProps = {
      key: "trigger"
    };
    if (this.isContextmenuToShow()) {
      newChildProps.onContextmenu = this.onContextmenu;
    } else {
      newChildProps.onContextmenu = this.createTwoChains("onContextmenu");
    }
    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMousedown = this.onMousedown;
      newChildProps[supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart"] = this.onTouchstart;
    } else {
      newChildProps.onClick = this.createTwoChains("onClick");
      newChildProps.onMousedown = this.createTwoChains("onMousedown");
      newChildProps[supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart"] = this.createTwoChains("onTouchstart");
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseenter = this.onMouseenter;
      if (alignPoint2) {
        newChildProps.onMousemove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseenter = this.createTwoChains("onMouseenter");
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseleave = this.onMouseleave;
    } else {
      newChildProps.onMouseleave = this.createTwoChains("onMouseleave");
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains("onFocus");
      newChildProps.onBlur = function(e2) {
        if (e2 && (!e2.relatedTarget || !contains(e2.target, e2.relatedTarget))) {
          _this8.createTwoChains("onBlur")(e2);
        }
      };
    }
    var childrenClassName = classNames(child && child.props && child.props.class, $attrs.class);
    if (childrenClassName) {
      newChildProps.class = childrenClassName;
    }
    var trigger2 = cloneElement(child, _extends$2(_extends$2({}, newChildProps), {
      ref: "triggerRef"
    }), true, true);
    if (this.popPortal) {
      return trigger2;
    } else {
      var portal = createVNode(Portal$1, {
        "key": "portal",
        "getContainer": this.getContainer,
        "didUpdate": this.handlePortalUpdate
      }, {
        default: this.getComponent
      });
      return createVNode(Fragment, null, [portal, trigger2]);
    }
  }
});
var __rest$K = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var getBuiltInPlacements = function getBuiltInPlacements2(dropdownMatchSelectWidth) {
  var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    }
  };
};
var SelectTrigger = defineComponent({
  name: "SelectTrigger",
  inheritAttrs: false,
  props: {
    dropdownAlign: Object,
    visible: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    dropdownClassName: String,
    dropdownStyle: PropTypes$1.object,
    placement: String,
    empty: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    popupClassName: String,
    animation: String,
    transitionName: String,
    getPopupContainer: Function,
    dropdownRender: Function,
    containerWidth: Number,
    dropdownMatchSelectWidth: PropTypes$1.oneOfType([Number, Boolean]).def(true),
    popupElement: PropTypes$1.any,
    direction: String,
    getTriggerDOMNode: Function,
    onPopupVisibleChange: Function,
    onPopupMouseEnter: Function
  },
  setup: function setup13(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var builtInPlacements = computed(function() {
      var dropdownMatchSelectWidth = props2.dropdownMatchSelectWidth;
      return getBuiltInPlacements(dropdownMatchSelectWidth);
    });
    var popupRef = ref();
    expose({
      getPopupElement: function getPopupElement() {
        return popupRef.value;
      }
    });
    return function() {
      var _a2 = _extends$2(_extends$2({}, props2), attrs), _a$empty = _a2.empty, empty2 = _a$empty === void 0 ? false : _a$empty, restProps = __rest$K(_a2, ["empty"]);
      var visible = restProps.visible, dropdownAlign = restProps.dropdownAlign, prefixCls2 = restProps.prefixCls, popupElement = restProps.popupElement, dropdownClassName = restProps.dropdownClassName, dropdownStyle = restProps.dropdownStyle, _restProps$direction = restProps.direction, direction2 = _restProps$direction === void 0 ? "ltr" : _restProps$direction, placement = restProps.placement, dropdownMatchSelectWidth = restProps.dropdownMatchSelectWidth, containerWidth = restProps.containerWidth, dropdownRender = restProps.dropdownRender, animation = restProps.animation, transitionName2 = restProps.transitionName, getPopupContainer = restProps.getPopupContainer, getTriggerDOMNode = restProps.getTriggerDOMNode, onPopupVisibleChange = restProps.onPopupVisibleChange, onPopupMouseEnter = restProps.onPopupMouseEnter;
      var dropdownPrefixCls = "".concat(prefixCls2, "-dropdown");
      var popupNode = popupElement;
      if (dropdownRender) {
        popupNode = dropdownRender({
          menuNode: popupElement,
          props: props2
        });
      }
      var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName2;
      var popupStyle = _extends$2({
        minWidth: "".concat(containerWidth, "px")
      }, dropdownStyle);
      if (typeof dropdownMatchSelectWidth === "number") {
        popupStyle.width = "".concat(dropdownMatchSelectWidth, "px");
      } else if (dropdownMatchSelectWidth) {
        popupStyle.width = "".concat(containerWidth, "px");
      }
      return createVNode(Trigger, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
        "showAction": onPopupVisibleChange ? ["click"] : [],
        "hideAction": onPopupVisibleChange ? ["click"] : [],
        "popupPlacement": placement || (direction2 === "rtl" ? "bottomRight" : "bottomLeft"),
        "builtinPlacements": builtInPlacements.value,
        "prefixCls": dropdownPrefixCls,
        "popupTransitionName": mergedTransitionName,
        "popupAlign": dropdownAlign,
        "popupVisible": visible,
        "getPopupContainer": getPopupContainer,
        "popupClassName": classNames(dropdownClassName, _defineProperty$R({}, "".concat(dropdownPrefixCls, "-empty"), empty2)),
        "popupStyle": popupStyle,
        "getTriggerDOMNode": getTriggerDOMNode,
        "onPopupVisibleChange": onPopupVisibleChange
      }), {
        default: slots.default,
        popup: function popup() {
          return createVNode("div", {
            "ref": popupRef,
            "onMouseenter": onPopupMouseEnter
          }, [popupNode]);
        }
      });
    };
  }
});
var SelectTrigger$1 = SelectTrigger;
var KeyCode = {
  MAC_ENTER: 3,
  BACKSPACE: 8,
  TAB: 9,
  NUM_CENTER: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  QUESTION_MARK: 63,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  META: 91,
  WIN_KEY_RIGHT: 92,
  CONTEXT_MENU: 93,
  NUM_ZERO: 96,
  NUM_ONE: 97,
  NUM_TWO: 98,
  NUM_THREE: 99,
  NUM_FOUR: 100,
  NUM_FIVE: 101,
  NUM_SIX: 102,
  NUM_SEVEN: 103,
  NUM_EIGHT: 104,
  NUM_NINE: 105,
  NUM_MULTIPLY: 106,
  NUM_PLUS: 107,
  NUM_MINUS: 109,
  NUM_PERIOD: 110,
  NUM_DIVISION: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUMLOCK: 144,
  SEMICOLON: 186,
  DASH: 189,
  EQUALS: 187,
  COMMA: 188,
  PERIOD: 190,
  SLASH: 191,
  APOSTROPHE: 192,
  SINGLE_QUOTE: 222,
  OPEN_SQUARE_BRACKET: 219,
  BACKSLASH: 220,
  CLOSE_SQUARE_BRACKET: 221,
  WIN_KEY: 224,
  MAC_FF_META: 224,
  WIN_IME: 229,
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e2) {
    var keyCode = e2.keyCode;
    if (e2.altKey && !e2.ctrlKey || e2.metaKey || keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var KeyCode$1 = KeyCode;
var TransBtn = function TransBtn2(props2, _ref) {
  var slots = _ref.slots;
  var _a2;
  var className = props2.class, customizeIcon = props2.customizeIcon, customizeIconProps = props2.customizeIconProps, _onMousedown = props2.onMousedown, onClick2 = props2.onClick;
  var icon;
  if (typeof customizeIcon === "function") {
    icon = customizeIcon(customizeIconProps);
  } else {
    icon = customizeIcon;
  }
  return createVNode("span", {
    "class": className,
    "onMousedown": function onMousedown2(event) {
      event.preventDefault();
      if (_onMousedown) {
        _onMousedown(event);
      }
    },
    "style": {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    "unselectable": "on",
    "onClick": onClick2,
    "aria-hidden": true
  }, [icon !== void 0 ? icon : createVNode("span", {
    "class": className.split(/\s+/).map(function(cls) {
      return "".concat(cls, "-icon");
    })
  }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)])]);
};
TransBtn.inheritAttrs = false;
TransBtn.displayName = "TransBtn";
TransBtn.props = {
  class: String,
  customizeIcon: PropTypes$1.any,
  customizeIconProps: PropTypes$1.any,
  onMousedown: Function,
  onClick: Function
};
var TransBtn$1 = TransBtn;
function onCompositionStart(e2) {
  e2.target.composing = true;
}
function onCompositionEnd(e2) {
  if (!e2.target.composing)
    return;
  e2.target.composing = false;
  trigger(e2.target, "input");
}
function trigger(el, type4) {
  var e2 = document.createEvent("HTMLEvents");
  e2.initEvent(type4, true, true);
  el.dispatchEvent(e2);
}
function addEventListener$1(el, event, handler4, options) {
  el.addEventListener(event, handler4, options);
}
var antInput = {
  created: function created2(el, binding) {
    if (!binding.modifiers || !binding.modifiers.lazy) {
      addEventListener$1(el, "compositionstart", onCompositionStart);
      addEventListener$1(el, "compositionend", onCompositionEnd);
      addEventListener$1(el, "change", onCompositionEnd);
    }
  }
};
var antInputDirective = antInput;
var inputProps$2 = {
  inputRef: PropTypes$1.any,
  prefixCls: String,
  id: String,
  inputElement: PropTypes$1.VueNode,
  disabled: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  editable: {
    type: Boolean,
    default: void 0
  },
  activeDescendantId: String,
  value: String,
  open: {
    type: Boolean,
    default: void 0
  },
  tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  attrs: PropTypes$1.object,
  onKeydown: {
    type: Function
  },
  onMousedown: {
    type: Function
  },
  onChange: {
    type: Function
  },
  onPaste: {
    type: Function
  },
  onCompositionstart: {
    type: Function
  },
  onCompositionend: {
    type: Function
  },
  onFocus: {
    type: Function
  },
  onBlur: {
    type: Function
  }
};
var Input$1 = defineComponent({
  name: "Input",
  inheritAttrs: false,
  props: inputProps$2,
  setup: function setup14(props2) {
    var blurTimeout = null;
    var VCSelectContainerEvent = inject("VCSelectContainerEvent");
    return function() {
      var _a2;
      var prefixCls2 = props2.prefixCls, id = props2.id, inputElement = props2.inputElement, disabled = props2.disabled, tabindex = props2.tabindex, autofocus = props2.autofocus, autocomplete = props2.autocomplete, editable = props2.editable, activeDescendantId = props2.activeDescendantId, value = props2.value, _onKeydown = props2.onKeydown, _onMousedown = props2.onMousedown, onChange3 = props2.onChange, onPaste = props2.onPaste, _onCompositionstart = props2.onCompositionstart, _onCompositionend = props2.onCompositionend, _onFocus = props2.onFocus, _onBlur = props2.onBlur, open2 = props2.open, inputRef = props2.inputRef, attrs = props2.attrs;
      var inputNode = inputElement || withDirectives(createVNode("input", null, null), [[antInputDirective]]);
      var inputProps3 = inputNode.props || {};
      var onOriginKeyDown = inputProps3.onKeydown, onOriginInput = inputProps3.onInput, onOriginFocus = inputProps3.onFocus, onOriginBlur = inputProps3.onBlur, onOriginMouseDown = inputProps3.onMousedown, onOriginCompositionStart = inputProps3.onCompositionstart, onOriginCompositionEnd = inputProps3.onCompositionend, style2 = inputProps3.style;
      inputNode = cloneElement(inputNode, _extends$2(_extends$2(_extends$2(_extends$2(_extends$2({
        type: "search"
      }, inputProps3), {
        id,
        ref: inputRef,
        disabled,
        tabindex,
        autocomplete: autocomplete || "off",
        autofocus,
        class: classNames("".concat(prefixCls2, "-selection-search-input"), (_a2 = inputNode === null || inputNode === void 0 ? void 0 : inputNode.props) === null || _a2 === void 0 ? void 0 : _a2.class),
        role: "combobox",
        "aria-expanded": open2,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(id, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(id, "_list"),
        "aria-activedescendant": activeDescendantId
      }), attrs), {
        value: editable ? value : "",
        readonly: !editable,
        unselectable: !editable ? "on" : null,
        style: _extends$2(_extends$2({}, style2), {
          opacity: editable ? null : 0
        }),
        onKeydown: function onKeydown(event) {
          _onKeydown(event);
          if (onOriginKeyDown) {
            onOriginKeyDown(event);
          }
        },
        onMousedown: function onMousedown2(event) {
          _onMousedown(event);
          if (onOriginMouseDown) {
            onOriginMouseDown(event);
          }
        },
        onInput: function onInput(event) {
          onChange3(event);
          if (onOriginInput) {
            onOriginInput(event);
          }
        },
        onCompositionstart: function onCompositionstart(event) {
          _onCompositionstart(event);
          if (onOriginCompositionStart) {
            onOriginCompositionStart(event);
          }
        },
        onCompositionend: function onCompositionend(event) {
          _onCompositionend(event);
          if (onOriginCompositionEnd) {
            onOriginCompositionEnd(event);
          }
        },
        onPaste,
        onFocus: function onFocus2() {
          clearTimeout(blurTimeout);
          onOriginFocus && onOriginFocus(arguments.length <= 0 ? void 0 : arguments[0]);
          _onFocus && _onFocus(arguments.length <= 0 ? void 0 : arguments[0]);
          VCSelectContainerEvent === null || VCSelectContainerEvent === void 0 ? void 0 : VCSelectContainerEvent.focus(arguments.length <= 0 ? void 0 : arguments[0]);
        },
        onBlur: function onBlur2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          blurTimeout = setTimeout(function() {
            onOriginBlur && onOriginBlur(args[0]);
            _onBlur && _onBlur(args[0]);
            VCSelectContainerEvent === null || VCSelectContainerEvent === void 0 ? void 0 : VCSelectContainerEvent.blur(args[0]);
          }, 100);
        }
      }), inputNode.type === "textarea" ? {} : {
        type: "search"
      }), true, true);
      return inputNode;
    };
  }
});
var Input$2 = Input$1;
var attributes = "accept acceptcharset accesskey action allowfullscreen allowtransparency\nalt async autocomplete autofocus autoplay capture cellpadding cellspacing challenge\ncharset checked classid classname colspan cols content contenteditable contextmenu\ncontrols coords crossorigin data datetime default defer dir disabled download draggable\nenctype form formaction formenctype formmethod formnovalidate formtarget frameborder\nheaders height hidden high href hreflang htmlfor for httpequiv icon id inputmode integrity\nis keyparams keytype kind label lang list loop low manifest marginheight marginwidth max maxlength media\nmediagroup method min minlength multiple muted name novalidate nonce open\noptimum pattern placeholder poster preload radiogroup readonly rel required\nreversed role rowspan rows sandbox scope scoped scrolling seamless selected\nshape size sizes span spellcheck src srcdoc srclang srcset start step style\nsummary tabindex target title type usemap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionend onCompositionstart onCompositionupdate onKeydown\n    onKeypress onKeyup onFocus onBlur onChange onInput onSubmit onClick onContextmenu onDoubleclick onDblclick\n    onDrag onDragend onDragenter onDragexit onDragleave onDragover onDragstart onDrop onMousedown\n    onMouseenter onMouseleave onMousemove onMouseout onMouseover onMouseup onSelect onTouchcancel\n    onTouchend onTouchmove onTouchstart onTouchstartPassive onTouchmovePassive onScroll onWheel onAbort onCanplay onCanplaythrough\n    onDurationchange onEmptied onEncrypted onEnded onError onLoadeddata onLoadedmetadata\n    onLoadstart onPause onPlay onPlaying onProgress onRatechange onSeeked onSeeking onStalled onSuspend onTimeupdate onVolumechange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
var ariaPrefix = "aria-";
var dataPrefix = "data-";
function match$1(key2, prefix) {
  return key2.indexOf(prefix) === 0;
}
function pickAttrs(props2) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _extends$2({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props2).forEach(function(key2) {
    if (mergedConfig.aria && (key2 === "role" || match$1(key2, ariaPrefix)) || mergedConfig.data && match$1(key2, dataPrefix) || mergedConfig.attr && (propList.includes(key2) || propList.includes(key2.toLowerCase()))) {
      attrs[key2] = props2[key2];
    }
  });
  return attrs;
}
var OverflowContextProviderKey = Symbol("OverflowContextProviderKey");
var OverflowContextProvider = defineComponent({
  name: "OverflowContextProvider",
  inheritAttrs: false,
  props: {
    value: {
      type: Object
    }
  },
  setup: function setup15(props2, _ref) {
    var slots = _ref.slots;
    provide(OverflowContextProviderKey, computed(function() {
      return props2.value;
    }));
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var useInjectOverflowContext = function useInjectOverflowContext2() {
  return inject(OverflowContextProviderKey, computed(function() {
    return null;
  }));
};
var __rest$J = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var UNDEFINED = void 0;
var Item$2 = defineComponent({
  name: "Item",
  props: {
    prefixCls: String,
    item: PropTypes$1.any,
    renderItem: Function,
    responsive: Boolean,
    itemKey: {
      type: [String, Number]
    },
    registerSize: Function,
    display: Boolean,
    order: Number,
    component: PropTypes$1.any,
    invalidate: Boolean
  },
  setup: function setup16(props2, _ref) {
    var slots = _ref.slots, expose = _ref.expose;
    var mergedHidden = computed(function() {
      return props2.responsive && !props2.display;
    });
    var itemNodeRef = ref();
    expose({
      itemNodeRef
    });
    function internalRegisterSize(width) {
      props2.registerSize(props2.itemKey, width);
    }
    onUnmounted(function() {
      internalRegisterSize(null);
    });
    return function() {
      var _a2;
      var prefixCls2 = props2.prefixCls, invalidate = props2.invalidate, item = props2.item, renderItem = props2.renderItem, responsive = props2.responsive;
      props2.registerSize;
      props2.itemKey;
      props2.display;
      var order = props2.order, _props$component = props2.component, Component = _props$component === void 0 ? "div" : _props$component, restProps = __rest$J(props2, ["prefixCls", "invalidate", "item", "renderItem", "responsive", "registerSize", "itemKey", "display", "order", "component"]);
      var children = (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      var childNode = renderItem && item !== UNDEFINED ? renderItem(item) : children;
      var overflowStyle;
      if (!invalidate) {
        overflowStyle = {
          opacity: mergedHidden.value ? 0 : 1,
          height: mergedHidden.value ? 0 : UNDEFINED,
          overflowY: mergedHidden.value ? "hidden" : UNDEFINED,
          order: responsive ? order : UNDEFINED,
          pointerEvents: mergedHidden.value ? "none" : UNDEFINED,
          position: mergedHidden.value ? "absolute" : UNDEFINED
        };
      }
      var overflowProps3 = {};
      if (mergedHidden.value) {
        overflowProps3["aria-hidden"] = true;
      }
      return createVNode(ResizeObserver$1, {
        "disabled": !responsive,
        "onResize": function onResize(_ref2) {
          var offsetWidth = _ref2.offsetWidth;
          internalRegisterSize(offsetWidth);
        }
      }, {
        default: function _default7() {
          return createVNode(Component, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
            "class": classNames(!invalidate && prefixCls2),
            "style": overflowStyle
          }, overflowProps3), restProps), {}, {
            "ref": itemNodeRef
          }), {
            default: function _default8() {
              return [childNode];
            }
          });
        }
      });
    };
  }
});
var __rest$I = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var RawItem = defineComponent({
  name: "RawItem",
  inheritAttrs: false,
  props: {
    component: PropTypes$1.any,
    title: PropTypes$1.any,
    id: String,
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onKeydown: {
      type: Function
    },
    onFocus: {
      type: Function
    }
  },
  setup: function setup17(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var context2 = useInjectOverflowContext();
    return function() {
      var _a2;
      if (!context2.value) {
        var _props$component = props2.component, Component = _props$component === void 0 ? "div" : _props$component, _restProps = __rest$I(props2, ["component"]);
        return createVNode(Component, _objectSpread2$2(_objectSpread2$2({}, _restProps), attrs), {
          default: function _default7() {
            return [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)];
          }
        });
      }
      var _b = context2.value, contextClassName = _b.className, restContext = __rest$I(_b, ["className"]);
      var className = attrs.class, restProps = __rest$I(attrs, ["class"]);
      return createVNode(OverflowContextProvider, {
        "value": null
      }, {
        default: function _default7() {
          return [createVNode(Item$2, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
            "class": classNames(contextClassName, className)
          }, restContext), restProps), props2), slots)];
        }
      });
    };
  }
});
var __rest$H = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var RESPONSIVE = "responsive";
var INVALIDATE = "invalidate";
function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
var overflowProps = function overflowProps2() {
  return {
    id: String,
    prefixCls: String,
    data: Array,
    itemKey: [String, Number, Function],
    itemWidth: {
      type: Number,
      default: 10
    },
    renderItem: Function,
    renderRawItem: Function,
    maxCount: [Number, String],
    renderRest: Function,
    renderRawRest: Function,
    suffix: PropTypes$1.any,
    component: String,
    itemComponent: PropTypes$1.any,
    onVisibleChange: Function,
    ssr: String,
    onMousedown: Function
  };
};
var Overflow = defineComponent({
  name: "Overflow",
  inheritAttrs: false,
  props: overflowProps(),
  emits: ["visibleChange"],
  setup: function setup18(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit;
    var fullySSR = computed(function() {
      return props2.ssr === "full";
    });
    var containerWidth = ref(null);
    var mergedContainerWidth = computed(function() {
      return containerWidth.value || 0;
    });
    var itemWidths = ref(new Map());
    var prevRestWidth = ref(0);
    var restWidth = ref(0);
    var suffixWidth = ref(0);
    var suffixFixedStart = ref(null);
    var displayCount = ref(null);
    var mergedDisplayCount = computed(function() {
      if (displayCount.value === null && fullySSR.value) {
        return Number.MAX_SAFE_INTEGER;
      }
      return displayCount.value || 0;
    });
    var restReady = ref(false);
    var itemPrefixCls = computed(function() {
      return "".concat(props2.prefixCls, "-item");
    });
    var mergedRestWidth = computed(function() {
      return Math.max(prevRestWidth.value, restWidth.value);
    });
    var isResponsive = computed(function() {
      return !!(props2.data.length && props2.maxCount === RESPONSIVE);
    });
    var invalidate = computed(function() {
      return props2.maxCount === INVALIDATE;
    });
    var showRest = computed(function() {
      return isResponsive.value || typeof props2.maxCount === "number" && props2.data.length > props2.maxCount;
    });
    var mergedData = computed(function() {
      var items = props2.data;
      if (isResponsive.value) {
        if (containerWidth.value === null && fullySSR.value) {
          items = props2.data;
        } else {
          items = props2.data.slice(0, Math.min(props2.data.length, mergedContainerWidth.value / props2.itemWidth));
        }
      } else if (typeof props2.maxCount === "number") {
        items = props2.data.slice(0, props2.maxCount);
      }
      return items;
    });
    var omittedItems = computed(function() {
      if (isResponsive.value) {
        return props2.data.slice(mergedDisplayCount.value + 1);
      }
      return props2.data.slice(mergedData.value.length);
    });
    var getKey2 = function getKey3(item, index2) {
      var _a2, _b;
      if (typeof props2.itemKey === "function") {
        return props2.itemKey(item);
      }
      return (_b = props2.itemKey && ((_a2 = item) === null || _a2 === void 0 ? void 0 : _a2[props2.itemKey])) !== null && _b !== void 0 ? _b : index2;
    };
    var mergedRenderItem = computed(function() {
      return props2.renderItem || function(item) {
        return item;
      };
    });
    var updateDisplayCount = function updateDisplayCount2(count, notReady) {
      displayCount.value = count;
      if (!notReady) {
        restReady.value = count < props2.data.length - 1;
        emit("visibleChange", count);
      }
    };
    var onOverflowResize = function onOverflowResize2(_2, element) {
      containerWidth.value = element.clientWidth;
    };
    var registerSize = function registerSize2(key2, width) {
      var clone3 = new Map(itemWidths.value);
      if (width === null) {
        clone3.delete(key2);
      } else {
        clone3.set(key2, width);
      }
      itemWidths.value = clone3;
    };
    var registerOverflowSize = function registerOverflowSize2(_2, width) {
      prevRestWidth.value = restWidth.value;
      restWidth.value = width;
    };
    var registerSuffixSize = function registerSuffixSize2(_2, width) {
      suffixWidth.value = width;
    };
    var getItemWidth = function getItemWidth2(index2) {
      return itemWidths.value.get(getKey2(mergedData.value[index2], index2));
    };
    watch([mergedContainerWidth, itemWidths, restWidth, suffixWidth, function() {
      return props2.itemKey;
    }, mergedData], function() {
      if (mergedContainerWidth.value && mergedRestWidth.value && mergedData.value) {
        var totalWidth = suffixWidth.value;
        var len = mergedData.value.length;
        var lastIndex = len - 1;
        if (!len) {
          updateDisplayCount(0);
          suffixFixedStart.value = null;
          return;
        }
        for (var i2 = 0; i2 < len; i2 += 1) {
          var currentItemWidth = getItemWidth(i2);
          if (currentItemWidth === void 0) {
            updateDisplayCount(i2 - 1, true);
            break;
          }
          totalWidth += currentItemWidth;
          if (lastIndex === 0 && totalWidth <= mergedContainerWidth.value || i2 === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth.value) {
            updateDisplayCount(lastIndex);
            suffixFixedStart.value = null;
            break;
          } else if (totalWidth + mergedRestWidth.value > mergedContainerWidth.value) {
            updateDisplayCount(i2 - 1);
            suffixFixedStart.value = totalWidth - currentItemWidth - suffixWidth.value + restWidth.value;
            break;
          }
        }
        if (props2.suffix && getItemWidth(0) + suffixWidth.value > mergedContainerWidth.value) {
          suffixFixedStart.value = null;
        }
      }
    });
    return function() {
      var displayRest = restReady.value && !!omittedItems.value.length;
      var itemComponent = props2.itemComponent, renderRawItem = props2.renderRawItem, renderRawRest = props2.renderRawRest, renderRest = props2.renderRest, _props$prefixCls = props2.prefixCls, prefixCls2 = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, suffix = props2.suffix, _props$component = props2.component, Component = _props$component === void 0 ? "div" : _props$component, id = props2.id, onMousedown2 = props2.onMousedown;
      var className = attrs.class, style2 = attrs.style, restAttrs = __rest$H(attrs, ["class", "style"]);
      var suffixStyle = {};
      if (suffixFixedStart.value !== null && isResponsive.value) {
        suffixStyle = {
          position: "absolute",
          left: "".concat(suffixFixedStart.value, "px"),
          top: 0
        };
      }
      var itemSharedProps = {
        prefixCls: itemPrefixCls.value,
        responsive: isResponsive.value,
        component: itemComponent,
        invalidate: invalidate.value
      };
      var internalRenderItemNode = renderRawItem ? function(item, index2) {
        var key2 = getKey2(item, index2);
        return createVNode(OverflowContextProvider, {
          "key": key2,
          "value": _extends$2(_extends$2({}, itemSharedProps), {
            order: index2,
            item,
            itemKey: key2,
            registerSize,
            display: index2 <= mergedDisplayCount.value
          })
        }, {
          default: function _default7() {
            return [renderRawItem(item, index2)];
          }
        });
      } : function(item, index2) {
        var key2 = getKey2(item, index2);
        return createVNode(Item$2, _objectSpread2$2(_objectSpread2$2({}, itemSharedProps), {}, {
          "order": index2,
          "key": key2,
          "item": item,
          "renderItem": mergedRenderItem.value,
          "itemKey": key2,
          "registerSize": registerSize,
          "display": index2 <= mergedDisplayCount.value
        }), null);
      };
      var restNode = function restNode2() {
        return null;
      };
      var restContextProps = {
        order: displayRest ? mergedDisplayCount.value : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls.value, " ").concat(itemPrefixCls.value, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
      };
      if (!renderRawRest) {
        var mergedRenderRest = renderRest || defaultRenderRest;
        restNode = function restNode2() {
          return createVNode(Item$2, _objectSpread2$2(_objectSpread2$2({}, itemSharedProps), restContextProps), {
            default: function _default7() {
              return typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems.value) : mergedRenderRest;
            }
          });
        };
      } else if (renderRawRest) {
        restNode = function restNode2() {
          return createVNode(OverflowContextProvider, {
            "value": _extends$2(_extends$2({}, itemSharedProps), restContextProps)
          }, {
            default: function _default7() {
              return [renderRawRest(omittedItems.value)];
            }
          });
        };
      }
      var overflowNode = function overflowNode2() {
        return createVNode(Component, _objectSpread2$2({
          "id": id,
          "class": classNames(!invalidate.value && prefixCls2, className),
          "style": style2,
          "onMousedown": onMousedown2
        }, restAttrs), {
          default: function _default7() {
            return [mergedData.value.map(internalRenderItemNode), showRest.value ? restNode() : null, suffix && createVNode(Item$2, _objectSpread2$2(_objectSpread2$2({}, itemSharedProps), {}, {
              "order": mergedDisplayCount.value,
              "class": "".concat(itemPrefixCls.value, "-suffix"),
              "registerSize": registerSuffixSize,
              "display": true,
              "style": suffixStyle
            }), {
              default: function _default8() {
                return suffix;
              }
            })];
          }
        });
      };
      return createVNode(ResizeObserver$1, {
        "disabled": !isResponsive.value,
        "onResize": onOverflowResize
      }, {
        default: overflowNode
      });
    };
  }
});
Overflow.Item = RawItem;
Overflow.RESPONSIVE = RESPONSIVE;
Overflow.INVALIDATE = INVALIDATE;
var Overflow$1 = Overflow;
var TreeSelectLegacyContextPropsKey = Symbol("TreeSelectLegacyContextPropsKey");
function useProvideLegacySelectContext(props2) {
  return provide(TreeSelectLegacyContextPropsKey, props2);
}
function useInjectLegacySelectContext() {
  return inject(TreeSelectLegacyContextPropsKey, {});
}
var props$1 = {
  id: String,
  prefixCls: String,
  values: PropTypes$1.array,
  open: {
    type: Boolean,
    default: void 0
  },
  searchValue: String,
  inputRef: PropTypes$1.any,
  placeholder: PropTypes$1.any,
  disabled: {
    type: Boolean,
    default: void 0
  },
  mode: String,
  showSearch: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  activeDescendantId: String,
  tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  removeIcon: PropTypes$1.any,
  choiceTransitionName: String,
  maxTagCount: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  maxTagTextLength: Number,
  maxTagPlaceholder: PropTypes$1.any.def(function() {
    return function(omittedValues) {
      return "+ ".concat(omittedValues.length, " ...");
    };
  }),
  tagRender: Function,
  onToggleOpen: {
    type: Function
  },
  onRemove: Function,
  onInputChange: Function,
  onInputPaste: Function,
  onInputKeyDown: Function,
  onInputMouseDown: Function,
  onInputCompositionStart: Function,
  onInputCompositionEnd: Function
};
var onPreventMouseDown = function onPreventMouseDown2(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = defineComponent({
  name: "MultipleSelectSelector",
  inheritAttrs: false,
  props: props$1,
  setup: function setup19(props2) {
    var measureRef = ref();
    var inputWidth = ref(0);
    var focused = ref(false);
    var legacyTreeSelectContext = useInjectLegacySelectContext();
    var selectionPrefixCls = computed(function() {
      return "".concat(props2.prefixCls, "-selection");
    });
    var inputValue = computed(function() {
      return props2.open || props2.mode === "tags" ? props2.searchValue : "";
    });
    var inputEditable = computed(function() {
      return props2.mode === "tags" || props2.showSearch && (props2.open || focused.value);
    });
    onMounted(function() {
      watch(inputValue, function() {
        inputWidth.value = measureRef.value.scrollWidth;
      }, {
        flush: "post",
        immediate: true
      });
    });
    function defaultRenderSelector(title, content, itemDisabled, closable, onClose) {
      return createVNode("span", {
        "class": classNames("".concat(selectionPrefixCls.value, "-item"), _defineProperty$R({}, "".concat(selectionPrefixCls.value, "-item-disabled"), itemDisabled)),
        "title": typeof title === "string" || typeof title === "number" ? title.toString() : void 0
      }, [createVNode("span", {
        "class": "".concat(selectionPrefixCls.value, "-item-content")
      }, [content]), closable && createVNode(TransBtn$1, {
        "class": "".concat(selectionPrefixCls.value, "-item-remove"),
        "onMousedown": onPreventMouseDown,
        "onClick": onClose,
        "customizeIcon": props2.removeIcon
      }, {
        default: function _default7() {
          return [createTextVNode("\xD7")];
        }
      })]);
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose, option2) {
      var _a2;
      var onMouseDown2 = function onMouseDown3(e2) {
        onPreventMouseDown(e2);
        props2.onToggleOpen(!open);
      };
      var originData = option2;
      if (legacyTreeSelectContext.keyEntities) {
        originData = ((_a2 = legacyTreeSelectContext.keyEntities[value]) === null || _a2 === void 0 ? void 0 : _a2.node) || {};
      }
      return createVNode("span", {
        "key": value,
        "onMousedown": onMouseDown2
      }, [props2.tagRender({
        label: content,
        value,
        disabled: itemDisabled,
        closable,
        onClose,
        option: originData
      })]);
    }
    function renderItem(valueItem) {
      var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value, option2 = valueItem.option;
      var closable = !props2.disabled && !itemDisabled;
      var displayLabel = label;
      if (typeof props2.maxTagTextLength === "number") {
        if (typeof label === "string" || typeof label === "number") {
          var strLabel = String(displayLabel);
          if (strLabel.length > props2.maxTagTextLength) {
            displayLabel = "".concat(strLabel.slice(0, props2.maxTagTextLength), "...");
          }
        }
      }
      var onClose = function onClose2(event) {
        var _a2;
        if (event)
          event.stopPropagation();
        (_a2 = props2.onRemove) === null || _a2 === void 0 ? void 0 : _a2.call(props2, valueItem);
      };
      return typeof props2.tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, option2) : defaultRenderSelector(label, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
      var _props$maxTagPlacehol = props2.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues2) {
        return "+ ".concat(omittedValues2.length, " ...");
      } : _props$maxTagPlacehol;
      var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
      return defaultRenderSelector(content, content, false);
    }
    return function() {
      var id = props2.id, prefixCls2 = props2.prefixCls, values = props2.values, open2 = props2.open, inputRef = props2.inputRef, placeholder = props2.placeholder, disabled = props2.disabled, autofocus = props2.autofocus, autocomplete = props2.autocomplete, activeDescendantId = props2.activeDescendantId, tabindex = props2.tabindex, onInputChange = props2.onInputChange, onInputPaste = props2.onInputPaste, onInputKeyDown = props2.onInputKeyDown, onInputMouseDown = props2.onInputMouseDown, onInputCompositionStart = props2.onInputCompositionStart, onInputCompositionEnd = props2.onInputCompositionEnd;
      var inputNode = createVNode("div", {
        "class": "".concat(selectionPrefixCls.value, "-search"),
        "style": {
          width: inputWidth.value + "px"
        },
        "key": "input"
      }, [createVNode(Input$2, {
        "inputRef": inputRef,
        "open": open2,
        "prefixCls": prefixCls2,
        "id": id,
        "inputElement": null,
        "disabled": disabled,
        "autofocus": autofocus,
        "autocomplete": autocomplete,
        "editable": inputEditable.value,
        "activeDescendantId": activeDescendantId,
        "value": inputValue.value,
        "onKeydown": onInputKeyDown,
        "onMousedown": onInputMouseDown,
        "onChange": onInputChange,
        "onPaste": onInputPaste,
        "onCompositionstart": onInputCompositionStart,
        "onCompositionend": onInputCompositionEnd,
        "tabindex": tabindex,
        "attrs": pickAttrs(props2, true),
        "onFocus": function onFocus2() {
          return focused.value = true;
        },
        "onBlur": function onBlur2() {
          return focused.value = false;
        }
      }, null), createVNode("span", {
        "ref": measureRef,
        "class": "".concat(selectionPrefixCls.value, "-search-mirror"),
        "aria-hidden": true
      }, [inputValue.value, createTextVNode("\xA0")])]);
      var selectionNode = createVNode(Overflow$1, {
        "prefixCls": "".concat(selectionPrefixCls.value, "-overflow"),
        "data": values,
        "renderItem": renderItem,
        "renderRest": renderRest,
        "suffix": inputNode,
        "itemKey": "key",
        "maxCount": props2.maxTagCount,
        "key": "overflow"
      }, null);
      return createVNode(Fragment, null, [selectionNode, !values.length && !inputValue.value && createVNode("span", {
        "class": "".concat(selectionPrefixCls.value, "-placeholder")
      }, [placeholder])]);
    };
  }
});
var MultipleSelector = SelectSelector;
var props = {
  inputElement: PropTypes$1.any,
  id: String,
  prefixCls: String,
  values: PropTypes$1.array,
  open: {
    type: Boolean,
    default: void 0
  },
  searchValue: String,
  inputRef: PropTypes$1.any,
  placeholder: PropTypes$1.any,
  disabled: {
    type: Boolean,
    default: void 0
  },
  mode: String,
  showSearch: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  activeDescendantId: String,
  tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  activeValue: String,
  backfill: {
    type: Boolean,
    default: void 0
  },
  optionLabelRender: Function,
  onInputChange: Function,
  onInputPaste: Function,
  onInputKeyDown: Function,
  onInputMouseDown: Function,
  onInputCompositionStart: Function,
  onInputCompositionEnd: Function
};
var SingleSelector = defineComponent({
  name: "SingleSelector",
  setup: function setup20(props2) {
    var inputChanged = ref(false);
    var combobox = computed(function() {
      return props2.mode === "combobox";
    });
    var inputEditable = computed(function() {
      return combobox.value || props2.showSearch;
    });
    var inputValue = computed(function() {
      var inputValue2 = props2.searchValue || "";
      if (combobox.value && props2.activeValue && !inputChanged.value) {
        inputValue2 = props2.activeValue;
      }
      return inputValue2;
    });
    var legacyTreeSelectContext = useInjectLegacySelectContext();
    watch([combobox, function() {
      return props2.activeValue;
    }], function() {
      if (combobox.value) {
        inputChanged.value = false;
      }
    }, {
      immediate: true
    });
    var hasTextInput = computed(function() {
      return props2.mode !== "combobox" && !props2.open && !props2.showSearch ? false : !!inputValue.value;
    });
    var title = computed(function() {
      var item = props2.values[0];
      return item && (typeof item.label === "string" || typeof item.label === "number") ? item.label.toString() : void 0;
    });
    var renderPlaceholder = function renderPlaceholder2() {
      if (props2.values[0]) {
        return null;
      }
      var hiddenStyle = hasTextInput.value ? {
        visibility: "hidden"
      } : void 0;
      return createVNode("span", {
        "class": "".concat(props2.prefixCls, "-selection-placeholder"),
        "style": hiddenStyle
      }, [props2.placeholder]);
    };
    return function() {
      var _a2, _b, _c, _d;
      var inputElement = props2.inputElement, prefixCls2 = props2.prefixCls, id = props2.id, values = props2.values, inputRef = props2.inputRef, disabled = props2.disabled, autofocus = props2.autofocus, autocomplete = props2.autocomplete, activeDescendantId = props2.activeDescendantId, open2 = props2.open, tabindex = props2.tabindex, optionLabelRender = props2.optionLabelRender, onInputKeyDown = props2.onInputKeyDown, onInputMouseDown = props2.onInputMouseDown, onInputChange = props2.onInputChange, onInputPaste = props2.onInputPaste, onInputCompositionStart = props2.onInputCompositionStart, onInputCompositionEnd = props2.onInputCompositionEnd;
      var item = values[0];
      var titleNode = null;
      if (item && legacyTreeSelectContext.customSlots) {
        var key2 = (_a2 = item.key) !== null && _a2 !== void 0 ? _a2 : item.value;
        var originData = ((_b = legacyTreeSelectContext.keyEntities[key2]) === null || _b === void 0 ? void 0 : _b.node) || {};
        titleNode = legacyTreeSelectContext.customSlots[(_c = originData.slots) === null || _c === void 0 ? void 0 : _c.title] || legacyTreeSelectContext.customSlots.title || item.label;
        if (typeof titleNode === "function") {
          titleNode = titleNode(originData);
        }
      } else {
        titleNode = optionLabelRender && item ? optionLabelRender(item.option) : item === null || item === void 0 ? void 0 : item.label;
      }
      return createVNode(Fragment, null, [createVNode("span", {
        "class": "".concat(prefixCls2, "-selection-search")
      }, [createVNode(Input$2, {
        "inputRef": inputRef,
        "prefixCls": prefixCls2,
        "id": id,
        "open": open2,
        "inputElement": inputElement,
        "disabled": disabled,
        "autofocus": autofocus,
        "autocomplete": autocomplete,
        "editable": inputEditable.value,
        "activeDescendantId": activeDescendantId,
        "value": inputValue.value,
        "onKeydown": onInputKeyDown,
        "onMousedown": onInputMouseDown,
        "onChange": function onChange3(e2) {
          inputChanged.value = true;
          onInputChange(e2);
        },
        "onPaste": onInputPaste,
        "onCompositionstart": onInputCompositionStart,
        "onCompositionend": onInputCompositionEnd,
        "tabindex": tabindex,
        "attrs": pickAttrs(props2, true)
      }, null)]), !combobox.value && item && !hasTextInput.value && createVNode("span", {
        "class": "".concat(prefixCls2, "-selection-item"),
        "title": title.value
      }, [createVNode(Fragment, {
        "key": (_d = item.key) !== null && _d !== void 0 ? _d : item.value
      }, [titleNode])]), renderPlaceholder()]);
    };
  }
});
SingleSelector.props = props;
SingleSelector.inheritAttrs = false;
var SingleSelector$1 = SingleSelector;
function isValidateOpenKey(currentKeyCode) {
  return ![
    KeyCode$1.ESC,
    KeyCode$1.SHIFT,
    KeyCode$1.BACKSPACE,
    KeyCode$1.TAB,
    KeyCode$1.WIN_KEY,
    KeyCode$1.ALT,
    KeyCode$1.META,
    KeyCode$1.WIN_KEY_RIGHT,
    KeyCode$1.CTRL,
    KeyCode$1.SEMICOLON,
    KeyCode$1.EQUALS,
    KeyCode$1.CAPS_LOCK,
    KeyCode$1.CONTEXT_MENU,
    KeyCode$1.F1,
    KeyCode$1.F2,
    KeyCode$1.F3,
    KeyCode$1.F4,
    KeyCode$1.F5,
    KeyCode$1.F6,
    KeyCode$1.F7,
    KeyCode$1.F8,
    KeyCode$1.F9,
    KeyCode$1.F10,
    KeyCode$1.F11,
    KeyCode$1.F12
  ].includes(currentKeyCode);
}
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250;
  var lock = null;
  var timeout;
  onBeforeUnmount(function() {
    clearTimeout(timeout);
  });
  function doLock(locked) {
    if (locked || lock === null) {
      lock = locked;
    }
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      lock = null;
    }, duration);
  }
  return [function() {
    return lock;
  }, doLock];
}
function createRef() {
  var func = function func2(node) {
    func2.current = node;
  };
  return func;
}
var Selector = defineComponent({
  name: "Selector",
  inheritAttrs: false,
  props: {
    id: String,
    prefixCls: String,
    showSearch: {
      type: Boolean,
      default: void 0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    values: PropTypes$1.array,
    multiple: {
      type: Boolean,
      default: void 0
    },
    mode: String,
    searchValue: String,
    activeValue: String,
    inputElement: PropTypes$1.any,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    activeDescendantId: String,
    tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    disabled: {
      type: Boolean,
      default: void 0
    },
    placeholder: PropTypes$1.any,
    removeIcon: PropTypes$1.any,
    maxTagCount: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    maxTagTextLength: Number,
    maxTagPlaceholder: PropTypes$1.any,
    tagRender: Function,
    optionLabelRender: Function,
    tokenWithEnter: {
      type: Boolean,
      default: void 0
    },
    choiceTransitionName: String,
    onToggleOpen: {
      type: Function
    },
    onSearch: Function,
    onSearchSubmit: Function,
    onRemove: Function,
    onInputKeyDown: {
      type: Function
    },
    domRef: Function
  },
  setup: function setup21(props2, _ref) {
    var expose = _ref.expose;
    var inputRef = createRef();
    var compositionStatus = false;
    var _useLock = useLock(0), _useLock2 = _slicedToArray$2(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown2(event) {
      var which = event.which;
      if (which === KeyCode$1.UP || which === KeyCode$1.DOWN) {
        event.preventDefault();
      }
      if (props2.onInputKeyDown) {
        props2.onInputKeyDown(event);
      }
      if (which === KeyCode$1.ENTER && props2.mode === "tags" && !compositionStatus && !props2.open) {
        props2.onSearchSubmit(event.target.value);
      }
      if (isValidateOpenKey(which)) {
        props2.onToggleOpen(true);
      }
    };
    var onInternalInputMouseDown = function onInternalInputMouseDown2() {
      setInputMouseDown(true);
    };
    var pastedText = null;
    var triggerOnSearch = function triggerOnSearch2(value) {
      if (props2.onSearch(value, true, compositionStatus) !== false) {
        props2.onToggleOpen(true);
      }
    };
    var onInputCompositionStart = function onInputCompositionStart2() {
      compositionStatus = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd2(e2) {
      compositionStatus = false;
      if (props2.mode !== "combobox") {
        triggerOnSearch(e2.target.value);
      }
    };
    var onInputChange = function onInputChange2(event) {
      var value = event.target.value;
      if (props2.tokenWithEnter && pastedText && /[\r\n]/.test(pastedText)) {
        var replacedText = pastedText.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
        value = value.replace(replacedText, pastedText);
      }
      pastedText = null;
      triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste2(e2) {
      var clipboardData = e2.clipboardData;
      var value = clipboardData.getData("text");
      pastedText = value;
    };
    var onClick2 = function onClick3(_ref2) {
      var target = _ref2.target;
      if (target !== inputRef.current) {
        var isIE = document.body.style.msTouchAction !== void 0;
        if (isIE) {
          setTimeout(function() {
            inputRef.current.focus();
          });
        } else {
          inputRef.current.focus();
        }
      }
    };
    var onMousedown2 = function onMousedown3(event) {
      var inputMouseDown = getInputMouseDown();
      if (event.target !== inputRef.current && !inputMouseDown) {
        event.preventDefault();
      }
      if (props2.mode !== "combobox" && (!props2.showSearch || !inputMouseDown) || !props2.open) {
        if (props2.open) {
          props2.onSearch("", true, false);
        }
        props2.onToggleOpen();
      }
    };
    expose({
      focus: function focus2() {
        inputRef.current.focus();
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    });
    return function() {
      var prefixCls2 = props2.prefixCls, domRef = props2.domRef, mode = props2.mode;
      var sharedProps = {
        inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange,
        onInputPaste,
        onInputCompositionStart,
        onInputCompositionEnd
      };
      var selectNode = mode === "multiple" || mode === "tags" ? createVNode(MultipleSelector, _objectSpread2$2(_objectSpread2$2({}, props2), sharedProps), null) : createVNode(SingleSelector$1, _objectSpread2$2(_objectSpread2$2({}, props2), sharedProps), null);
      return createVNode("div", {
        "ref": domRef,
        "class": "".concat(prefixCls2, "-selector"),
        "onClick": onClick2,
        "onMousedown": onMousedown2
      }, [selectNode]);
    };
  }
});
var Selector$1 = Selector;
function useSelectTriggerControl(refs, open2, triggerOpen) {
  function onGlobalMouseDown(event) {
    var _a2, _b, _c;
    var target = event.target;
    if (target.shadowRoot && event.composed) {
      target = event.composedPath()[0] || target;
    }
    var elements = [(_a2 = refs[0]) === null || _a2 === void 0 ? void 0 : _a2.value, (_c = (_b = refs[1]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.getPopupElement()];
    if (open2.value && elements.every(function(element) {
      return element && !element.contains(target) && element !== target;
    })) {
      triggerOpen(false);
    }
  }
  onMounted(function() {
    window.addEventListener("mousedown", onGlobalMouseDown);
  });
  onBeforeUnmount(function() {
    window.removeEventListener("mousedown", onGlobalMouseDown);
  });
}
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
  var bool = ref(false);
  var delay;
  var cancelLatest = function cancelLatest2() {
    clearTimeout(delay);
  };
  onMounted(function() {
    cancelLatest();
  });
  var delaySetBool = function delaySetBool2(value, callback) {
    cancelLatest();
    delay = setTimeout(function() {
      bool.value = value;
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}
var BaseSelectContextKey = Symbol("BaseSelectContextKey");
function useProvideBaseSelectProps(props2) {
  return provide(BaseSelectContextKey, props2);
}
function useBaseProps() {
  return inject(BaseSelectContextKey, {});
}
var isMobile$2 = function() {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4))) {
    return true;
  }
  return false;
};
function toReactive(objectRef) {
  if (!isRef(objectRef))
    return reactive(objectRef);
  var proxy = new Proxy({}, {
    get: function get2(_2, p2, receiver) {
      return Reflect.get(objectRef.value, p2, receiver);
    },
    set: function set2(_2, p2, value) {
      objectRef.value[p2] = value;
      return true;
    },
    deleteProperty: function deleteProperty(_2, p2) {
      return Reflect.deleteProperty(objectRef.value, p2);
    },
    has: function has(_2, p2) {
      return Reflect.has(objectRef.value, p2);
    },
    ownKeys: function ownKeys2() {
      return Object.keys(objectRef.value);
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor() {
      return {
        enumerable: true,
        configurable: true
      };
    }
  });
  return reactive(proxy);
}
var __rest$G = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autofocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabindex", "OptionList", "notFoundContent"];
var baseSelectPrivateProps = function baseSelectPrivateProps2() {
  return {
    prefixCls: String,
    id: String,
    omitDomProps: Array,
    displayValues: Array,
    onDisplayValuesChange: Function,
    activeValue: String,
    activeDescendantId: String,
    onActiveValueChange: Function,
    searchValue: String,
    onSearch: Function,
    onSearchSplit: Function,
    maxLength: Number,
    OptionList: PropTypes$1.any,
    emptyOptions: Boolean
  };
};
var baseSelectPropsWithoutPrivate = function baseSelectPropsWithoutPrivate2() {
  return {
    showSearch: {
      type: Boolean,
      default: void 0
    },
    tagRender: {
      type: Function
    },
    optionLabelRender: {
      type: Function
    },
    direction: {
      type: String
    },
    tabindex: Number,
    autofocus: Boolean,
    notFoundContent: PropTypes$1.any,
    placeholder: PropTypes$1.any,
    onClear: Function,
    choiceTransitionName: String,
    mode: String,
    disabled: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    defaultOpen: {
      type: Boolean,
      default: void 0
    },
    onDropdownVisibleChange: {
      type: Function
    },
    getInputElement: {
      type: Function
    },
    getRawInputElement: {
      type: Function
    },
    maxTagTextLength: Number,
    maxTagCount: {
      type: [String, Number]
    },
    maxTagPlaceholder: PropTypes$1.any,
    tokenSeparators: {
      type: Array
    },
    allowClear: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    inputIcon: PropTypes$1.any,
    clearIcon: PropTypes$1.any,
    removeIcon: PropTypes$1.any,
    animation: String,
    transitionName: String,
    dropdownStyle: {
      type: Object
    },
    dropdownClassName: String,
    dropdownMatchSelectWidth: {
      type: [Boolean, Number],
      default: void 0
    },
    dropdownRender: {
      type: Function
    },
    dropdownAlign: Object,
    placement: {
      type: String
    },
    getPopupContainer: {
      type: Function
    },
    showAction: {
      type: Array
    },
    onBlur: {
      type: Function
    },
    onFocus: {
      type: Function
    },
    onKeyup: Function,
    onKeydown: Function,
    onMousedown: Function,
    onPopupScroll: Function,
    onInputKeyDown: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onClick: Function
  };
};
var baseSelectProps = function baseSelectProps2() {
  return _extends$2(_extends$2({}, baseSelectPrivateProps()), baseSelectPropsWithoutPrivate());
};
function isMultiple(mode) {
  return mode === "tags" || mode === "multiple";
}
var BaseSelect = defineComponent({
  name: "BaseSelect",
  inheritAttrs: false,
  props: initDefaultProps$1(baseSelectProps(), {
    showAction: [],
    notFoundContent: "Not Found"
  }),
  setup: function setup22(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var multiple = computed(function() {
      return isMultiple(props2.mode);
    });
    var mergedShowSearch = computed(function() {
      return props2.showSearch !== void 0 ? props2.showSearch : multiple.value || props2.mode === "combobox";
    });
    var mobile = ref(false);
    onMounted(function() {
      mobile.value = isMobile$2();
    });
    var legacyTreeSelectContext = useInjectLegacySelectContext();
    var containerRef = ref(null);
    var selectorDomRef = createRef();
    var triggerRef = ref(null);
    var selectorRef = ref(null);
    var listRef = ref(null);
    var _useDelayReset = useDelayReset(), _useDelayReset2 = _slicedToArray$2(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    var focus2 = function focus3() {
      var _a2;
      (_a2 = selectorRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = selectorRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur,
      scrollTo: function scrollTo2(arg) {
        var _a2;
        return (_a2 = listRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg);
      }
    });
    var mergedSearchValue = computed(function() {
      var _a2;
      if (props2.mode !== "combobox") {
        return props2.searchValue;
      }
      var val = (_a2 = props2.displayValues[0]) === null || _a2 === void 0 ? void 0 : _a2.value;
      return typeof val === "string" || typeof val === "number" ? String(val) : "";
    });
    var initOpen = props2.open !== void 0 ? props2.open : props2.defaultOpen;
    var innerOpen = ref(initOpen);
    var mergedOpen = ref(initOpen);
    var setInnerOpen = function setInnerOpen2(val) {
      innerOpen.value = props2.open !== void 0 ? props2.open : val;
      mergedOpen.value = innerOpen.value;
    };
    watch(function() {
      return props2.open;
    }, function() {
      setInnerOpen(props2.open);
    });
    var emptyListContent = computed(function() {
      return !props2.notFoundContent && props2.emptyOptions;
    });
    watchEffect(function() {
      mergedOpen.value = innerOpen.value;
      if (props2.disabled || emptyListContent.value && mergedOpen.value && props2.mode === "combobox") {
        mergedOpen.value = false;
      }
    });
    var triggerOpen = computed(function() {
      return emptyListContent.value ? false : mergedOpen.value;
    });
    var onToggleOpen = function onToggleOpen2(newOpen) {
      var nextOpen = newOpen !== void 0 ? newOpen : !mergedOpen.value;
      if (innerOpen.value !== nextOpen && !props2.disabled) {
        setInnerOpen(nextOpen);
        if (props2.onDropdownVisibleChange) {
          props2.onDropdownVisibleChange(nextOpen);
        }
      }
    };
    var tokenWithEnter = computed(function() {
      return (props2.tokenSeparators || []).some(function(tokenSeparator) {
        return ["\n", "\r\n"].includes(tokenSeparator);
      });
    });
    var onInternalSearch = function onInternalSearch2(searchText, fromTyping, isCompositing) {
      var _a2, _b;
      var ret = true;
      var newSearchText = searchText;
      (_a2 = props2.onActiveValueChange) === null || _a2 === void 0 ? void 0 : _a2.call(props2, null);
      var patchLabels = isCompositing ? null : getSeparatedContent(searchText, props2.tokenSeparators);
      if (props2.mode !== "combobox" && patchLabels) {
        newSearchText = "";
        (_b = props2.onSearchSplit) === null || _b === void 0 ? void 0 : _b.call(props2, patchLabels);
        onToggleOpen(false);
        ret = false;
      }
      if (props2.onSearch && mergedSearchValue.value !== newSearchText) {
        props2.onSearch(newSearchText, {
          source: fromTyping ? "typing" : "effect"
        });
      }
      return ret;
    };
    var onInternalSearchSubmit = function onInternalSearchSubmit2(searchText) {
      var _a2;
      if (!searchText || !searchText.trim()) {
        return;
      }
      (_a2 = props2.onSearch) === null || _a2 === void 0 ? void 0 : _a2.call(props2, searchText, {
        source: "submit"
      });
    };
    watch(mergedOpen, function() {
      if (!mergedOpen.value && !multiple.value && props2.mode !== "combobox") {
        onInternalSearch("", false, false);
      }
    }, {
      immediate: true,
      flush: "post"
    });
    watch(function() {
      return props2.disabled;
    }, function() {
      if (innerOpen.value && !!props2.disabled) {
        setInnerOpen(false);
      }
    }, {
      immediate: true
    });
    var _useLock = useLock(), _useLock2 = _slicedToArray$2(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    var onInternalKeyDown = function onInternalKeyDown2(event) {
      var _a2;
      var _a3;
      var clearLock = getClearLock();
      var which = event.which;
      if (which === KeyCode$1.ENTER) {
        if (props2.mode !== "combobox") {
          event.preventDefault();
        }
        if (!mergedOpen.value) {
          onToggleOpen(true);
        }
      }
      setClearLock(!!mergedSearchValue.value);
      if (which === KeyCode$1.BACKSPACE && !clearLock && multiple.value && !mergedSearchValue.value && props2.displayValues.length) {
        var cloneDisplayValues = _toConsumableArray(props2.displayValues);
        var removedDisplayValue = null;
        for (var i2 = cloneDisplayValues.length - 1; i2 >= 0; i2 -= 1) {
          var current2 = cloneDisplayValues[i2];
          if (!current2.disabled) {
            cloneDisplayValues.splice(i2, 1);
            removedDisplayValue = current2;
            break;
          }
        }
        if (removedDisplayValue) {
          props2.onDisplayValuesChange(cloneDisplayValues, {
            type: "remove",
            values: [removedDisplayValue]
          });
        }
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (mergedOpen.value && listRef.value) {
        var _listRef$value;
        (_listRef$value = listRef.value).onKeydown.apply(_listRef$value, [event].concat(rest));
      }
      (_a3 = props2.onKeydown) === null || _a3 === void 0 ? void 0 : (_a2 = _a3).call.apply(_a2, [props2, event].concat(rest));
    };
    var onInternalKeyUp = function onInternalKeyUp2(event) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      if (mergedOpen.value && listRef.value) {
        var _listRef$value2;
        (_listRef$value2 = listRef.value).onKeyup.apply(_listRef$value2, [event].concat(rest));
      }
      if (props2.onKeyup) {
        props2.onKeyup.apply(props2, [event].concat(rest));
      }
    };
    var onSelectorRemove = function onSelectorRemove2(val) {
      var newValues = props2.displayValues.filter(function(i2) {
        return i2 !== val;
      });
      props2.onDisplayValuesChange(newValues, {
        type: "remove",
        values: [val]
      });
    };
    var focusRef = ref(false);
    var onContainerFocus = function onContainerFocus2() {
      setMockFocused(true);
      if (!props2.disabled) {
        if (props2.onFocus && !focusRef.value) {
          props2.onFocus.apply(props2, arguments);
        }
        if (props2.showAction && props2.showAction.includes("focus")) {
          onToggleOpen(true);
        }
      }
      focusRef.value = true;
    };
    var onContainerBlur = function onContainerBlur2() {
      setMockFocused(false, function() {
        focusRef.value = false;
        onToggleOpen(false);
      });
      if (props2.disabled) {
        return;
      }
      var searchVal = mergedSearchValue.value;
      if (searchVal) {
        if (props2.mode === "tags") {
          props2.onSearch(searchVal, {
            source: "submit"
          });
        } else if (props2.mode === "multiple") {
          props2.onSearch("", {
            source: "blur"
          });
        }
      }
      if (props2.onBlur) {
        props2.onBlur.apply(props2, arguments);
      }
    };
    provide("VCSelectContainerEvent", {
      focus: onContainerFocus,
      blur: onContainerBlur
    });
    var activeTimeoutIds = [];
    onMounted(function() {
      activeTimeoutIds.forEach(function(timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    });
    onBeforeUnmount(function() {
      activeTimeoutIds.forEach(function(timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    });
    var onInternalMouseDown = function onInternalMouseDown2(event) {
      var _b2;
      var _a2, _b;
      var target = event.target;
      var popupElement = (_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.getPopupElement();
      if (popupElement && popupElement.contains(target)) {
        var timeoutId = setTimeout(function() {
          var _a3;
          var index2 = activeTimeoutIds.indexOf(timeoutId);
          if (index2 !== -1) {
            activeTimeoutIds.splice(index2, 1);
          }
          cancelSetMockFocused();
          if (!mobile.value && !popupElement.contains(document.activeElement)) {
            (_a3 = selectorRef.value) === null || _a3 === void 0 ? void 0 : _a3.focus();
          }
        });
        activeTimeoutIds.push(timeoutId);
      }
      for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        restArgs[_key3 - 1] = arguments[_key3];
      }
      (_b = props2.onMousedown) === null || _b === void 0 ? void 0 : (_b2 = _b).call.apply(_b2, [props2, event].concat(restArgs));
    };
    var containerWidth = ref(null);
    var instance2 = getCurrentInstance();
    var onPopupMouseEnter = function onPopupMouseEnter2() {
      instance2.update();
    };
    onMounted(function() {
      watch(triggerOpen, function() {
        var _a2;
        if (triggerOpen.value) {
          var newWidth = Math.ceil((_a2 = containerRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetWidth);
          if (containerWidth.value !== newWidth && !Number.isNaN(newWidth)) {
            containerWidth.value = newWidth;
          }
        }
      }, {
        immediate: true,
        flush: "post"
      });
    });
    useSelectTriggerControl([containerRef, triggerRef], triggerOpen, onToggleOpen);
    useProvideBaseSelectProps(toReactive(_extends$2(_extends$2({}, toRefs(props2)), {
      open: mergedOpen,
      triggerOpen,
      showSearch: mergedShowSearch,
      multiple,
      toggleOpen: onToggleOpen
    })));
    return function() {
      var _classNames2;
      var _a2 = _extends$2(_extends$2({}, props2), attrs), prefixCls2 = _a2.prefixCls, id = _a2.id;
      _a2.open;
      _a2.defaultOpen;
      var mode = _a2.mode;
      _a2.showSearch;
      _a2.searchValue;
      _a2.onSearch;
      var allowClear = _a2.allowClear, clearIcon = _a2.clearIcon, showArrow = _a2.showArrow, inputIcon = _a2.inputIcon, disabled = _a2.disabled, loading = _a2.loading, getInputElement = _a2.getInputElement, getPopupContainer = _a2.getPopupContainer, placement = _a2.placement, animation = _a2.animation, transitionName2 = _a2.transitionName, dropdownStyle = _a2.dropdownStyle, dropdownClassName = _a2.dropdownClassName, dropdownMatchSelectWidth = _a2.dropdownMatchSelectWidth, dropdownRender = _a2.dropdownRender, dropdownAlign = _a2.dropdownAlign;
      _a2.showAction;
      var direction2 = _a2.direction;
      _a2.tokenSeparators;
      var tagRender = _a2.tagRender, optionLabelRender = _a2.optionLabelRender;
      _a2.onPopupScroll;
      _a2.onDropdownVisibleChange;
      _a2.onFocus;
      _a2.onBlur;
      _a2.onKeyup;
      _a2.onKeydown;
      _a2.onMousedown;
      var onClear = _a2.onClear, omitDomProps = _a2.omitDomProps, getRawInputElement = _a2.getRawInputElement, displayValues = _a2.displayValues, onDisplayValuesChange = _a2.onDisplayValuesChange, emptyOptions = _a2.emptyOptions, activeDescendantId = _a2.activeDescendantId, activeValue = _a2.activeValue, OptionList2 = _a2.OptionList, restProps = __rest$G(_a2, ["prefixCls", "id", "open", "defaultOpen", "mode", "showSearch", "searchValue", "onSearch", "allowClear", "clearIcon", "showArrow", "inputIcon", "disabled", "loading", "getInputElement", "getPopupContainer", "placement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "showAction", "direction", "tokenSeparators", "tagRender", "optionLabelRender", "onPopupScroll", "onDropdownVisibleChange", "onFocus", "onBlur", "onKeyup", "onKeydown", "onMousedown", "onClear", "omitDomProps", "getRawInputElement", "displayValues", "onDisplayValuesChange", "emptyOptions", "activeDescendantId", "activeValue", "OptionList"]);
      var customizeInputElement = mode === "combobox" && getInputElement && getInputElement() || null;
      var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
      var domProps = _extends$2({}, restProps);
      var onTriggerVisibleChange;
      if (customizeRawInputElement) {
        onTriggerVisibleChange = function onTriggerVisibleChange2(newOpen) {
          onToggleOpen(newOpen);
        };
      }
      DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
      });
      omitDomProps === null || omitDomProps === void 0 ? void 0 : omitDomProps.forEach(function(propName) {
        delete domProps[propName];
      });
      var mergedShowArrow = showArrow !== void 0 ? showArrow : loading || !multiple.value && mode !== "combobox";
      var arrowNode;
      if (mergedShowArrow) {
        arrowNode = createVNode(TransBtn$1, {
          "class": classNames("".concat(prefixCls2, "-arrow"), _defineProperty$R({}, "".concat(prefixCls2, "-arrow-loading"), loading)),
          "customizeIcon": inputIcon,
          "customizeIconProps": {
            loading,
            searchValue: mergedSearchValue.value,
            open: mergedOpen.value,
            focused: mockFocused.value,
            showSearch: mergedShowSearch.value
          }
        }, null);
      }
      var clearNode;
      var onClearMouseDown = function onClearMouseDown2() {
        onClear === null || onClear === void 0 ? void 0 : onClear();
        onDisplayValuesChange([], {
          type: "clear",
          values: displayValues
        });
        onInternalSearch("", false, false);
      };
      if (!disabled && allowClear && (displayValues.length || mergedSearchValue.value)) {
        clearNode = createVNode(TransBtn$1, {
          "class": "".concat(prefixCls2, "-clear"),
          "onMousedown": onClearMouseDown,
          "customizeIcon": clearIcon
        }, {
          default: function _default7() {
            return [createTextVNode("\xD7")];
          }
        });
      }
      var optionList = createVNode(OptionList2, {
        "ref": listRef
      }, _extends$2(_extends$2({}, legacyTreeSelectContext.customSlots), {
        option: slots.option
      }));
      var mergedClassName = classNames(prefixCls2, attrs.class, (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2, "-focused"), mockFocused.value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-multiple"), multiple.value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-single"), !multiple.value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-allow-clear"), allowClear), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-show-arrow"), mergedShowArrow), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-disabled"), disabled), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-loading"), loading), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-open"), mergedOpen.value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-customize-input"), customizeInputElement), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-show-search"), mergedShowSearch.value), _classNames2));
      var selectorNode = createVNode(SelectTrigger$1, {
        "ref": triggerRef,
        "disabled": disabled,
        "prefixCls": prefixCls2,
        "visible": triggerOpen.value,
        "popupElement": optionList,
        "containerWidth": containerWidth.value,
        "animation": animation,
        "transitionName": transitionName2,
        "dropdownStyle": dropdownStyle,
        "dropdownClassName": dropdownClassName,
        "direction": direction2,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth,
        "dropdownRender": dropdownRender,
        "dropdownAlign": dropdownAlign,
        "placement": placement,
        "getPopupContainer": getPopupContainer,
        "empty": emptyOptions,
        "getTriggerDOMNode": function getTriggerDOMNode() {
          return selectorDomRef.current;
        },
        "onPopupVisibleChange": onTriggerVisibleChange,
        "onPopupMouseEnter": onPopupMouseEnter
      }, {
        default: function _default7() {
          return customizeRawInputElement ? isValidElement(customizeRawInputElement) && cloneElement(customizeRawInputElement, {
            ref: selectorDomRef
          }, false, true) : createVNode(Selector$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
            "domRef": selectorDomRef,
            "prefixCls": prefixCls2,
            "inputElement": customizeInputElement,
            "ref": selectorRef,
            "id": id,
            "showSearch": mergedShowSearch.value,
            "mode": mode,
            "activeDescendantId": activeDescendantId,
            "tagRender": tagRender,
            "optionLabelRender": optionLabelRender,
            "values": displayValues,
            "open": mergedOpen.value,
            "onToggleOpen": onToggleOpen,
            "activeValue": activeValue,
            "searchValue": mergedSearchValue.value,
            "onSearch": onInternalSearch,
            "onSearchSubmit": onInternalSearchSubmit,
            "onRemove": onSelectorRemove,
            "tokenWithEnter": tokenWithEnter.value
          }), null);
        }
      });
      var renderNode;
      if (customizeRawInputElement) {
        renderNode = selectorNode;
      } else {
        renderNode = createVNode("div", _objectSpread2$2(_objectSpread2$2({}, domProps), {}, {
          "class": mergedClassName,
          "ref": containerRef,
          "onMousedown": onInternalMouseDown,
          "onKeydown": onInternalKeyDown,
          "onKeyup": onInternalKeyUp
        }), [mockFocused.value && !mergedOpen.value && createVNode("span", {
          "style": {
            width: 0,
            height: 0,
            display: "flex",
            overflow: "hidden",
            opacity: 0
          },
          "aria-live": "polite"
        }, ["".concat(displayValues.map(function(_ref2) {
          var label = _ref2.label, value = _ref2.value;
          return ["number", "string"].includes(_typeof$2(label)) ? label : value;
        }).join(", "))]), selectorNode, arrowNode, clearNode]);
      }
      return renderNode;
    };
  }
});
var Filter = function Filter2(_ref, _ref2) {
  var height = _ref.height, offset3 = _ref.offset, prefixCls2 = _ref.prefixCls, onInnerResize = _ref.onInnerResize;
  var slots = _ref2.slots;
  var _a2;
  var outerStyle = {};
  var innerStyle = {
    display: "flex",
    flexDirection: "column"
  };
  if (offset3 !== void 0) {
    outerStyle = {
      height: "".concat(height, "px"),
      position: "relative",
      overflow: "hidden"
    };
    innerStyle = _extends$2(_extends$2({}, innerStyle), {
      transform: "translateY(".concat(offset3, "px)"),
      position: "absolute",
      left: 0,
      right: 0,
      top: 0
    });
  }
  return createVNode("div", {
    "style": outerStyle
  }, [createVNode(ResizeObserver$1, {
    "onResize": function onResize(_ref3) {
      var offsetHeight = _ref3.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, {
    default: function _default7() {
      return [createVNode("div", {
        "style": innerStyle,
        "class": classNames(_defineProperty$R({}, "".concat(prefixCls2, "-holder-inner"), prefixCls2))
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)])];
    }
  })]);
};
Filter.displayName = "Filter";
Filter.inheritAttrs = false;
Filter.props = {
  prefixCls: String,
  height: Number,
  offset: Number,
  onInnerResize: Function
};
var Filler = Filter;
var Item = function Item2(_ref, _ref2) {
  var setRef = _ref.setRef;
  var slots = _ref2.slots;
  var _a2;
  var children = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
  return children && children.length ? cloneVNode(children[0], {
    ref: setRef
  }) : children;
};
Item.props = {
  setRef: {
    type: Function,
    default: function _default2() {
    }
  }
};
var Item$1 = Item;
var MIN_SIZE = 20;
function getPageY(e2) {
  return "touches" in e2 ? e2.touches[0].pageY : e2.pageY;
}
var ScrollBar$1 = defineComponent({
  name: "ScrollBar",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    scrollTop: Number,
    scrollHeight: Number,
    height: Number,
    count: Number,
    onScroll: {
      type: Function
    },
    onStartMove: {
      type: Function
    },
    onStopMove: {
      type: Function
    }
  },
  setup: function setup23() {
    return {
      moveRaf: null,
      scrollbarRef: createRef(),
      thumbRef: createRef(),
      visibleTimeout: null,
      state: reactive({
        dragging: false,
        pageY: null,
        startTop: null,
        visible: false
      })
    };
  },
  watch: {
    scrollTop: {
      handler: function handler() {
        this.delayHidden();
      },
      flush: "post"
    }
  },
  mounted: function mounted2() {
    var _a2, _b;
    (_a2 = this.scrollbarRef.current) === null || _a2 === void 0 ? void 0 : _a2.addEventListener("touchstart", this.onScrollbarTouchStart, supportsPassive$1 ? {
      passive: false
    } : false);
    (_b = this.thumbRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener("touchstart", this.onMouseDown, supportsPassive$1 ? {
      passive: false
    } : false);
  },
  beforeUnmount: function beforeUnmount2() {
    this.removeEvents();
    clearTimeout(this.visibleTimeout);
  },
  methods: {
    delayHidden: function delayHidden() {
      var _this = this;
      clearTimeout(this.visibleTimeout);
      this.state.visible = true;
      this.visibleTimeout = setTimeout(function() {
        _this.state.visible = false;
      }, 2e3);
    },
    onScrollbarTouchStart: function onScrollbarTouchStart(e2) {
      e2.preventDefault();
    },
    onContainerMouseDown: function onContainerMouseDown(e2) {
      e2.stopPropagation();
      e2.preventDefault();
    },
    patchEvents: function patchEvents() {
      window.addEventListener("mousemove", this.onMouseMove);
      window.addEventListener("mouseup", this.onMouseUp);
      this.thumbRef.current.addEventListener("touchmove", this.onMouseMove, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.addEventListener("touchend", this.onMouseUp);
    },
    removeEvents: function removeEvents() {
      window.removeEventListener("mousemove", this.onMouseMove);
      window.removeEventListener("mouseup", this.onMouseUp);
      this.scrollbarRef.current.removeEventListener("touchstart", this.onScrollbarTouchStart, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.removeEventListener("touchstart", this.onMouseDown, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.removeEventListener("touchmove", this.onMouseMove, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.removeEventListener("touchend", this.onMouseUp);
      wrapperRaf.cancel(this.moveRaf);
    },
    onMouseDown: function onMouseDown(e2) {
      var onStartMove = this.$props.onStartMove;
      _extends$2(this.state, {
        dragging: true,
        pageY: getPageY(e2),
        startTop: this.getTop()
      });
      onStartMove();
      this.patchEvents();
      e2.stopPropagation();
      e2.preventDefault();
    },
    onMouseMove: function onMouseMove2(e2) {
      var _this$state = this.state, dragging = _this$state.dragging, pageY = _this$state.pageY, startTop = _this$state.startTop;
      var onScroll = this.$props.onScroll;
      wrapperRaf.cancel(this.moveRaf);
      if (dragging) {
        var offsetY = getPageY(e2) - pageY;
        var newTop = startTop + offsetY;
        var enableScrollRange = this.getEnableScrollRange();
        var enableHeightRange = this.getEnableHeightRange();
        var ptg = enableHeightRange ? newTop / enableHeightRange : 0;
        var newScrollTop = Math.ceil(ptg * enableScrollRange);
        this.moveRaf = wrapperRaf(function() {
          onScroll(newScrollTop);
        });
      }
    },
    onMouseUp: function onMouseUp() {
      var onStopMove = this.$props.onStopMove;
      this.state.dragging = false;
      onStopMove();
      this.removeEvents();
    },
    getSpinHeight: function getSpinHeight() {
      var _this$$props = this.$props, height = _this$$props.height, count = _this$$props.count;
      var baseHeight = height / count * 10;
      baseHeight = Math.max(baseHeight, MIN_SIZE);
      baseHeight = Math.min(baseHeight, height / 2);
      return Math.floor(baseHeight);
    },
    getEnableScrollRange: function getEnableScrollRange() {
      var _this$$props2 = this.$props, scrollHeight = _this$$props2.scrollHeight, height = _this$$props2.height;
      return scrollHeight - height || 0;
    },
    getEnableHeightRange: function getEnableHeightRange() {
      var height = this.$props.height;
      var spinHeight = this.getSpinHeight();
      return height - spinHeight || 0;
    },
    getTop: function getTop() {
      var scrollTop = this.$props.scrollTop;
      var enableScrollRange = this.getEnableScrollRange();
      var enableHeightRange = this.getEnableHeightRange();
      if (scrollTop === 0 || enableScrollRange === 0) {
        return 0;
      }
      var ptg = scrollTop / enableScrollRange;
      return ptg * enableHeightRange;
    },
    showScroll: function showScroll() {
      var _this$$props3 = this.$props, height = _this$$props3.height, scrollHeight = _this$$props3.scrollHeight;
      return scrollHeight > height;
    }
  },
  render: function render3() {
    var _this$state2 = this.state, dragging = _this$state2.dragging, visible = _this$state2.visible;
    var prefixCls2 = this.$props.prefixCls;
    var spinHeight = this.getSpinHeight() + "px";
    var top = this.getTop() + "px";
    var canScroll = this.showScroll();
    var mergedVisible = canScroll && visible;
    return createVNode("div", {
      "ref": this.scrollbarRef,
      "class": classNames("".concat(prefixCls2, "-scrollbar"), _defineProperty$R({}, "".concat(prefixCls2, "-scrollbar-show"), canScroll)),
      "style": {
        width: "8px",
        top: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: mergedVisible ? void 0 : "none"
      },
      "onMousedown": this.onContainerMouseDown,
      "onMousemove": this.delayHidden
    }, [createVNode("div", {
      "ref": this.thumbRef,
      "class": classNames("".concat(prefixCls2, "-scrollbar-thumb"), _defineProperty$R({}, "".concat(prefixCls2, "-scrollbar-thumb-moving"), dragging)),
      "style": {
        width: "100%",
        height: spinHeight,
        top,
        left: 0,
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: "99px",
        cursor: "pointer",
        userSelect: "none"
      },
      "onMousedown": this.onMouseDown
    }, null)]);
  }
});
function useHeights(mergedData, getKey2, onItemAdd, onItemRemove) {
  var instance2 = new Map();
  var heights = new Map();
  var updatedMark = ref(Symbol("update"));
  watch(mergedData, function() {
    updatedMark.value = Symbol("update");
  });
  var heightUpdateId = 0;
  function collectHeight() {
    heightUpdateId += 1;
    var currentId = heightUpdateId;
    Promise.resolve().then(function() {
      if (currentId !== heightUpdateId)
        return;
      instance2.forEach(function(element, key2) {
        if (element && element.offsetParent) {
          var offsetHeight = element.offsetHeight;
          if (heights.get(key2) !== offsetHeight) {
            updatedMark.value = Symbol("update");
            heights.set(key2, element.offsetHeight);
          }
        }
      });
    });
  }
  function setInstance(item, ins) {
    var key2 = getKey2(item);
    var origin = instance2.get(key2);
    if (ins) {
      instance2.set(key2, ins.$el || ins);
      collectHeight();
    } else {
      instance2.delete(key2);
    }
    if (!origin !== !ins) {
      if (ins) {
        onItemAdd === null || onItemAdd === void 0 ? void 0 : onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(item);
      }
    }
  }
  return [setInstance, collectHeight, heights, updatedMark];
}
function useScrollTo(containerRef, mergedData, heights, props2, getKey2, collectHeight, syncScrollTop, triggerFlash) {
  var scroll;
  return function(arg) {
    if (arg === null || arg === void 0) {
      triggerFlash();
      return;
    }
    wrapperRaf.cancel(scroll);
    var data6 = mergedData.value;
    var itemHeight = props2.itemHeight;
    if (typeof arg === "number") {
      syncScrollTop(arg);
    } else if (arg && _typeof$2(arg) === "object") {
      var index2;
      var align = arg.align;
      if ("index" in arg) {
        index2 = arg.index;
      } else {
        index2 = data6.findIndex(function(item) {
          return getKey2(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset, offset3 = _arg$offset === void 0 ? 0 : _arg$offset;
      var syncScroll = function syncScroll2(times, targetAlign) {
        if (times < 0 || !containerRef.value)
          return;
        var height = containerRef.value.clientHeight;
        var needCollectHeight = false;
        var newTargetAlign = targetAlign;
        if (height) {
          var mergedAlign = targetAlign || align;
          var stackTop = 0;
          var itemTop = 0;
          var itemBottom = 0;
          var maxLen = Math.min(data6.length, index2);
          for (var i2 = 0; i2 <= maxLen; i2 += 1) {
            var key2 = getKey2(data6[i2]);
            itemTop = stackTop;
            var cacheHeight = heights.get(key2);
            itemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
            stackTop = itemBottom;
            if (i2 === index2 && cacheHeight === void 0) {
              needCollectHeight = true;
            }
          }
          var scrollTop = containerRef.value.scrollTop;
          var targetTop = null;
          switch (mergedAlign) {
            case "top":
              targetTop = itemTop - offset3;
              break;
            case "bottom":
              targetTop = itemBottom - height + offset3;
              break;
            default: {
              var scrollBottom = scrollTop + height;
              if (itemTop < scrollTop) {
                newTargetAlign = "top";
              } else if (itemBottom > scrollBottom) {
                newTargetAlign = "bottom";
              }
            }
          }
          if (targetTop !== null && targetTop !== scrollTop) {
            syncScrollTop(targetTop);
          }
        }
        scroll = wrapperRaf(function() {
          if (needCollectHeight) {
            collectHeight();
          }
          syncScroll2(times - 1, newTargetAlign);
        });
      };
      syncScroll(3);
    }
  };
}
var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof$2(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var isFF$1 = isFF;
var useOriginScroll = function(isScrollAtTop, isScrollAtBottom) {
  var lock = false;
  var lockTimeout = null;
  function lockScroll() {
    clearTimeout(lockTimeout);
    lock = true;
    lockTimeout = setTimeout(function() {
      lock = false;
    }, 50);
  }
  return function(deltaY) {
    var smoothOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var originScroll = deltaY < 0 && isScrollAtTop.value || deltaY > 0 && isScrollAtBottom.value;
    if (smoothOffset && originScroll) {
      clearTimeout(lockTimeout);
      lock = false;
    } else if (!originScroll || lock) {
      lockScroll();
    }
    return !lock && originScroll;
  };
};
function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, onWheelDelta) {
  var offsetRef = 0;
  var nextFrame = null;
  var wheelValue = null;
  var isMouseScroll = false;
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);
  function onWheel(event) {
    if (!inVirtual.value)
      return;
    wrapperRaf.cancel(nextFrame);
    var deltaY = event.deltaY;
    offsetRef += deltaY;
    wheelValue = deltaY;
    if (originScroll(deltaY))
      return;
    if (!isFF$1) {
      event.preventDefault();
    }
    nextFrame = wrapperRaf(function() {
      var patchMultiple = isMouseScroll ? 10 : 1;
      onWheelDelta(offsetRef * patchMultiple);
      offsetRef = 0;
    });
  }
  function onFireFoxScroll(event) {
    if (!inVirtual.value)
      return;
    isMouseScroll = event.detail === wheelValue;
  }
  return [onWheel, onFireFoxScroll];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touched = false;
  var touchY = 0;
  var element = null;
  var interval = null;
  var cleanUpEvents = function cleanUpEvents2() {
    if (element) {
      element.removeEventListener("touchmove", onTouchMove);
      element.removeEventListener("touchend", onTouchEnd);
    }
  };
  var onTouchMove = function onTouchMove2(e2) {
    if (touched) {
      var currentY = Math.ceil(e2.touches[0].pageY);
      var offsetY = touchY - currentY;
      touchY = currentY;
      if (callback(offsetY)) {
        e2.preventDefault();
      }
      clearInterval(interval);
      interval = setInterval(function() {
        offsetY *= SMOOTH_PTG;
        if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) {
          clearInterval(interval);
        }
      }, 16);
    }
  };
  var onTouchEnd = function onTouchEnd2() {
    touched = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart2(e2) {
    cleanUpEvents();
    if (e2.touches.length === 1 && !touched) {
      touched = true;
      touchY = Math.ceil(e2.touches[0].pageY);
      element = e2.target;
      element.addEventListener("touchmove", onTouchMove, {
        passive: false
      });
      element.addEventListener("touchend", onTouchEnd);
    }
  };
  var noop3 = function noop4() {
  };
  onMounted(function() {
    document.addEventListener("touchmove", noop3, {
      passive: false
    });
    watch(inVirtual, function(val) {
      listRef.value.removeEventListener("touchstart", onTouchStart);
      cleanUpEvents();
      clearInterval(interval);
      if (val) {
        listRef.value.addEventListener("touchstart", onTouchStart, {
          passive: false
        });
      }
    }, {
      immediate: true
    });
  });
  onBeforeUnmount(function() {
    document.removeEventListener("touchmove", noop3);
  });
}
var __rest$F = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var EMPTY_DATA$1 = [];
var ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function renderChildren(list, startIndex, endIndex, setNodeRef, renderFunc, _ref) {
  var getKey2 = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function(item, index2) {
    var eleIndex = startIndex + index2;
    var node = renderFunc(item, eleIndex, {});
    var key2 = getKey2(item);
    return createVNode(Item$1, {
      "key": key2,
      "setRef": function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, {
      default: function _default7() {
        return [node];
      }
    });
  });
}
var List = defineComponent({
  name: "List",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    data: PropTypes$1.array,
    height: Number,
    itemHeight: Number,
    fullHeight: {
      type: Boolean,
      default: void 0
    },
    itemKey: {
      type: [String, Number, Function],
      required: true
    },
    component: {
      type: [String, Object]
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    children: Function,
    onScroll: Function,
    onMousedown: Function,
    onMouseenter: Function,
    onVisibleChange: Function
  },
  setup: function setup24(props2, _ref2) {
    var expose = _ref2.expose;
    var useVirtual2 = computed(function() {
      var height = props2.height, itemHeight = props2.itemHeight, virtual = props2.virtual;
      return !!(virtual !== false && height && itemHeight);
    });
    var inVirtual = computed(function() {
      var height = props2.height, itemHeight = props2.itemHeight, data7 = props2.data;
      return useVirtual2.value && data7 && itemHeight * data7.length > height;
    });
    var state = reactive({
      scrollTop: 0,
      scrollMoving: false
    });
    var data6 = computed(function() {
      return props2.data || EMPTY_DATA$1;
    });
    var mergedData = shallowRef([]);
    watch(data6, function() {
      mergedData.value = toRaw(data6.value).slice();
    }, {
      immediate: true
    });
    var itemKey2 = shallowRef(function(_item) {
      return void 0;
    });
    watch(function() {
      return props2.itemKey;
    }, function(val) {
      if (typeof val === "function") {
        itemKey2.value = val;
      } else {
        itemKey2.value = function(item) {
          return item === null || item === void 0 ? void 0 : item[val];
        };
      }
    }, {
      immediate: true
    });
    var componentRef = ref();
    var fillerInnerRef = ref();
    var scrollBarRef = ref();
    var getKey2 = function getKey3(item) {
      return itemKey2.value(item);
    };
    var sharedConfig = {
      getKey: getKey2
    };
    function syncScrollTop(newTop) {
      var value;
      if (typeof newTop === "function") {
        value = newTop(state.scrollTop);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      if (componentRef.value) {
        componentRef.value.scrollTop = alignedTop;
      }
      state.scrollTop = alignedTop;
    }
    var _useHeights = useHeights(mergedData, getKey2, null, null), _useHeights2 = _slicedToArray$2(_useHeights, 4), setInstance = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], updatedMark = _useHeights2[3];
    var calRes = reactive({
      scrollHeight: void 0,
      start: 0,
      end: 0,
      offset: void 0
    });
    var offsetHeight = ref(0);
    onMounted(function() {
      nextTick(function() {
        var _a2;
        offsetHeight.value = ((_a2 = fillerInnerRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetHeight) || 0;
      });
    });
    onUpdated(function() {
      nextTick(function() {
        var _a2;
        offsetHeight.value = ((_a2 = fillerInnerRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetHeight) || 0;
      });
    });
    watch([useVirtual2, mergedData], function() {
      if (!useVirtual2.value) {
        _extends$2(calRes, {
          scrollHeight: void 0,
          start: 0,
          end: mergedData.value.length - 1,
          offset: void 0
        });
      }
    }, {
      immediate: true
    });
    watch([useVirtual2, mergedData, offsetHeight, inVirtual], function() {
      if (useVirtual2.value && !inVirtual.value) {
        _extends$2(calRes, {
          scrollHeight: offsetHeight.value,
          start: 0,
          end: mergedData.value.length - 1,
          offset: void 0
        });
      }
    }, {
      immediate: true
    });
    watch([inVirtual, useVirtual2, function() {
      return state.scrollTop;
    }, mergedData, updatedMark, function() {
      return props2.height;
    }, offsetHeight], function() {
      if (!useVirtual2.value || !inVirtual.value) {
        return;
      }
      var itemTop = 0;
      var startIndex;
      var startOffset;
      var endIndex;
      var dataLen = mergedData.value.length;
      var data7 = mergedData.value;
      var scrollTop = state.scrollTop;
      var itemHeight = props2.itemHeight, height = props2.height;
      var scrollTopHeight = scrollTop + height;
      for (var i2 = 0; i2 < dataLen; i2 += 1) {
        var item = data7[i2];
        var key2 = getKey2(item);
        var cacheHeight = heights.get(key2);
        if (cacheHeight === void 0) {
          cacheHeight = itemHeight;
        }
        var currentItemBottom = itemTop + cacheHeight;
        if (startIndex === void 0 && currentItemBottom >= scrollTop) {
          startIndex = i2;
          startOffset = itemTop;
        }
        if (endIndex === void 0 && currentItemBottom > scrollTopHeight) {
          endIndex = i2;
        }
        itemTop = currentItemBottom;
      }
      if (startIndex === void 0) {
        startIndex = 0;
        startOffset = 0;
      }
      if (endIndex === void 0) {
        endIndex = dataLen - 1;
      }
      endIndex = Math.min(endIndex + 1, dataLen);
      _extends$2(calRes, {
        scrollHeight: itemTop,
        start: startIndex,
        end: endIndex,
        offset: startOffset
      });
    }, {
      immediate: true
    });
    var maxScrollHeight = computed(function() {
      return calRes.scrollHeight - props2.height;
    });
    function keepInRange(newScrollTop) {
      var newTop = newScrollTop;
      if (!Number.isNaN(maxScrollHeight.value)) {
        newTop = Math.min(newTop, maxScrollHeight.value);
      }
      newTop = Math.max(newTop, 0);
      return newTop;
    }
    var isScrollAtTop = computed(function() {
      return state.scrollTop <= 0;
    });
    var isScrollAtBottom = computed(function() {
      return state.scrollTop >= maxScrollHeight.value;
    });
    var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);
    function onScrollBar(newScrollTop) {
      var newTop = newScrollTop;
      syncScrollTop(newTop);
    }
    function onFallbackScroll(e2) {
      var _a2;
      var newScrollTop = e2.currentTarget.scrollTop;
      if (Math.abs(newScrollTop - state.scrollTop) >= 1) {
        syncScrollTop(newScrollTop);
      }
      (_a2 = props2.onScroll) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
    }
    var _useFrameWheel = useFrameWheel(useVirtual2, isScrollAtTop, isScrollAtBottom, function(offsetY) {
      syncScrollTop(function(top) {
        var newTop = top + offsetY;
        return newTop;
      });
    }), _useFrameWheel2 = _slicedToArray$2(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    useMobileTouchMove(useVirtual2, componentRef, function(deltaY, smoothOffset) {
      if (originScroll(deltaY, smoothOffset)) {
        return false;
      }
      onRawWheel({
        preventDefault: function preventDefault() {
        },
        deltaY
      });
      return true;
    });
    function onMozMousePixelScroll(e2) {
      if (useVirtual2.value) {
        e2.preventDefault();
      }
    }
    var removeEventListener2 = function removeEventListener3() {
      if (componentRef.value) {
        componentRef.value.removeEventListener("wheel", onRawWheel, supportsPassive$1 ? {
          passive: false
        } : false);
        componentRef.value.removeEventListener("DOMMouseScroll", onFireFoxScroll);
        componentRef.value.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
      }
    };
    watchEffect(function() {
      nextTick(function() {
        if (componentRef.value) {
          removeEventListener2();
          componentRef.value.addEventListener("wheel", onRawWheel, supportsPassive$1 ? {
            passive: false
          } : false);
          componentRef.value.addEventListener("DOMMouseScroll", onFireFoxScroll);
          componentRef.value.addEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        }
      });
    });
    onBeforeUnmount(function() {
      removeEventListener2();
    });
    var scrollTo2 = useScrollTo(componentRef, mergedData, heights, props2, getKey2, collectHeight, syncScrollTop, function() {
      var _a2;
      (_a2 = scrollBarRef.value) === null || _a2 === void 0 ? void 0 : _a2.delayHidden();
    });
    expose({
      scrollTo: scrollTo2
    });
    var componentStyle = computed(function() {
      var cs = null;
      if (props2.height) {
        cs = _extends$2(_defineProperty$R({}, props2.fullHeight ? "height" : "maxHeight", props2.height + "px"), ScrollStyle);
        if (useVirtual2.value) {
          cs.overflowY = "hidden";
          if (state.scrollMoving) {
            cs.pointerEvents = "none";
          }
        }
      }
      return cs;
    });
    watch([function() {
      return calRes.start;
    }, function() {
      return calRes.end;
    }, mergedData], function() {
      if (props2.onVisibleChange) {
        var renderList2 = mergedData.value.slice(calRes.start, calRes.end + 1);
        props2.onVisibleChange(renderList2, mergedData.value);
      }
    }, {
      flush: "post"
    });
    return {
      state,
      mergedData,
      componentStyle,
      onFallbackScroll,
      onScrollBar,
      componentRef,
      useVirtual: useVirtual2,
      calRes,
      collectHeight,
      setInstance,
      sharedConfig,
      scrollBarRef,
      fillerInnerRef
    };
  },
  render: function render4() {
    var _this = this;
    var _a2 = _extends$2(_extends$2({}, this.$props), this.$attrs), _a$prefixCls = _a2.prefixCls, prefixCls2 = _a$prefixCls === void 0 ? "rc-virtual-list" : _a$prefixCls, height = _a2.height;
    _a2.itemHeight;
    _a2.fullHeight;
    _a2.data;
    _a2.itemKey;
    _a2.virtual;
    var _a$component = _a2.component, Component = _a$component === void 0 ? "div" : _a$component;
    _a2.onScroll;
    var _a$children = _a2.children, children = _a$children === void 0 ? this.$slots.default : _a$children, style2 = _a2.style, className = _a2.class, restProps = __rest$F(_a2, ["prefixCls", "height", "itemHeight", "fullHeight", "data", "itemKey", "virtual", "component", "onScroll", "children", "style", "class"]);
    var mergedClassName = classNames(prefixCls2, className);
    var scrollTop = this.state.scrollTop;
    var _this$calRes = this.calRes, scrollHeight = _this$calRes.scrollHeight, offset3 = _this$calRes.offset, start2 = _this$calRes.start, end = _this$calRes.end;
    var componentStyle = this.componentStyle, onFallbackScroll = this.onFallbackScroll, onScrollBar = this.onScrollBar, useVirtual2 = this.useVirtual, collectHeight = this.collectHeight, sharedConfig = this.sharedConfig, setInstance = this.setInstance, mergedData = this.mergedData;
    return createVNode("div", _objectSpread2$2({
      "style": _extends$2(_extends$2({}, style2), {
        position: "relative"
      }),
      "class": mergedClassName
    }, restProps), [createVNode(Component, {
      "class": "".concat(prefixCls2, "-holder"),
      "style": componentStyle,
      "ref": "componentRef",
      "onScroll": onFallbackScroll
    }, {
      default: function _default7() {
        return [createVNode(Filler, {
          "prefixCls": prefixCls2,
          "height": scrollHeight,
          "offset": offset3,
          "onInnerResize": collectHeight,
          "ref": "fillerInnerRef"
        }, {
          default: function _default8() {
            return renderChildren(mergedData, start2, end, setInstance, children, sharedConfig);
          }
        })];
      }
    }), useVirtual2 && createVNode(ScrollBar$1, {
      "ref": "scrollBarRef",
      "prefixCls": prefixCls2,
      "scrollTop": scrollTop,
      "height": height,
      "scrollHeight": scrollHeight,
      "count": mergedData.length,
      "onScroll": onScrollBar,
      "onStartMove": function onStartMove() {
        _this.state.scrollMoving = true;
      },
      "onStopMove": function onStopMove() {
        _this.state.scrollMoving = false;
      }
    }, null)]);
  }
});
var List$1 = List;
function useMemo(getValue2, condition, shouldUpdate) {
  var cacheRef = ref(getValue2());
  watch(condition, function(next2, pre) {
    if (shouldUpdate) {
      if (shouldUpdate(next2, pre)) {
        cacheRef.value = getValue2();
      }
    } else {
      cacheRef.value = getValue2();
    }
  });
  return cacheRef;
}
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var SelectContextKey = Symbol("SelectContextKey");
function useProvideSelectProps(props2) {
  return provide(SelectContextKey, props2);
}
function useSelectProps() {
  return inject(SelectContextKey, {});
}
var __rest$E = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function isTitleType(content) {
  return typeof content === "string" || typeof content === "number";
}
var OptionList$2 = defineComponent({
  name: "OptionList",
  inheritAttrs: false,
  slots: ["option"],
  setup: function setup25(_2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var baseProps2 = useBaseProps();
    var props2 = useSelectProps();
    var itemPrefixCls = computed(function() {
      return "".concat(baseProps2.prefixCls, "-item");
    });
    var memoFlattenOptions = useMemo(function() {
      return props2.flattenOptions;
    }, [function() {
      return baseProps2.open;
    }, function() {
      return props2.flattenOptions;
    }], function(next2) {
      return next2[0];
    });
    var listRef = createRef();
    var onListMouseDown = function onListMouseDown2(event) {
      event.preventDefault();
    };
    var scrollIntoView2 = function scrollIntoView3(args) {
      if (listRef.current) {
        listRef.current.scrollTo(typeof args === "number" ? {
          index: args
        } : args);
      }
    };
    var getEnabledActiveIndex = function getEnabledActiveIndex2(index2) {
      var offset3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      var len = memoFlattenOptions.value.length;
      for (var i2 = 0; i2 < len; i2 += 1) {
        var current2 = (index2 + i2 * offset3 + len) % len;
        var _memoFlattenOptions$v = memoFlattenOptions.value[current2], group = _memoFlattenOptions$v.group, data6 = _memoFlattenOptions$v.data;
        if (!group && !data6.disabled) {
          return current2;
        }
      }
      return -1;
    };
    var state = reactive({
      activeIndex: getEnabledActiveIndex(0)
    });
    var setActive = function setActive2(index2) {
      var fromKeyboard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      state.activeIndex = index2;
      var info = {
        source: fromKeyboard ? "keyboard" : "mouse"
      };
      var flattenItem = memoFlattenOptions.value[index2];
      if (!flattenItem) {
        props2.onActiveValue(null, -1, info);
        return;
      }
      props2.onActiveValue(flattenItem.value, index2, info);
    };
    watch([function() {
      return memoFlattenOptions.value.length;
    }, function() {
      return baseProps2.searchValue;
    }], function() {
      setActive(props2.defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, {
      immediate: true
    });
    var isSelected = function isSelected2(value) {
      return props2.rawValues.has(value) && baseProps2.mode !== "combobox";
    };
    watch([function() {
      return baseProps2.open;
    }, function() {
      return baseProps2.searchValue;
    }], function() {
      if (!baseProps2.multiple && baseProps2.open && props2.rawValues.size === 1) {
        var value = Array.from(props2.rawValues)[0];
        var index2 = toRaw(memoFlattenOptions.value).findIndex(function(_ref2) {
          var data6 = _ref2.data;
          return data6.value === value;
        });
        if (index2 !== -1) {
          setActive(index2);
          nextTick(function() {
            scrollIntoView2(index2);
          });
        }
      }
      if (baseProps2.open) {
        nextTick(function() {
          var _a2;
          (_a2 = listRef.current) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(void 0);
        });
      }
    }, {
      immediate: true,
      flush: "post"
    });
    var onSelectValue = function onSelectValue2(value) {
      if (value !== void 0) {
        props2.onSelect(value, {
          selected: !props2.rawValues.has(value)
        });
      }
      if (!baseProps2.multiple) {
        baseProps2.toggleOpen(false);
      }
    };
    var getLabel = function getLabel2(item) {
      return typeof item.label === "function" ? item.label() : item.label;
    };
    function renderItem(index2) {
      var item = memoFlattenOptions.value[index2];
      if (!item)
        return null;
      var itemData = item.data || {};
      var value = itemData.value;
      var group = item.group;
      var attrs = pickAttrs(itemData, true);
      var mergedLabel = getLabel(item);
      return item ? createVNode("div", _objectSpread2$2(_objectSpread2$2({
        "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
      }, attrs), {}, {
        "key": index2,
        "role": group ? "presentation" : "option",
        "id": "".concat(baseProps2.id, "_list_").concat(index2),
        "aria-selected": isSelected(value)
      }), [value]) : null;
    }
    var onKeydown = function onKeydown2(event) {
      var which = event.which, ctrlKey = event.ctrlKey;
      switch (which) {
        case KeyCode$1.N:
        case KeyCode$1.P:
        case KeyCode$1.UP:
        case KeyCode$1.DOWN: {
          var offset3 = 0;
          if (which === KeyCode$1.UP) {
            offset3 = -1;
          } else if (which === KeyCode$1.DOWN) {
            offset3 = 1;
          } else if (isPlatformMac() && ctrlKey) {
            if (which === KeyCode$1.N) {
              offset3 = 1;
            } else if (which === KeyCode$1.P) {
              offset3 = -1;
            }
          }
          if (offset3 !== 0) {
            var nextActiveIndex = getEnabledActiveIndex(state.activeIndex + offset3, offset3);
            scrollIntoView2(nextActiveIndex);
            setActive(nextActiveIndex, true);
          }
          break;
        }
        case KeyCode$1.ENTER: {
          var item = memoFlattenOptions.value[state.activeIndex];
          if (item && !item.data.disabled) {
            onSelectValue(item.value);
          } else {
            onSelectValue(void 0);
          }
          if (baseProps2.open) {
            event.preventDefault();
          }
          break;
        }
        case KeyCode$1.ESC: {
          baseProps2.toggleOpen(false);
          if (baseProps2.open) {
            event.stopPropagation();
          }
        }
      }
    };
    var onKeyup = function onKeyup2() {
    };
    var scrollTo2 = function scrollTo3(index2) {
      scrollIntoView2(index2);
    };
    expose({
      onKeydown,
      onKeyup,
      scrollTo: scrollTo2
    });
    return function() {
      var id = baseProps2.id, notFoundContent = baseProps2.notFoundContent, onPopupScroll = baseProps2.onPopupScroll;
      var menuItemSelectedIcon = props2.menuItemSelectedIcon, fieldNames = props2.fieldNames, virtual = props2.virtual, listHeight = props2.listHeight, listItemHeight = props2.listItemHeight;
      var renderOption = slots.option;
      var activeIndex = state.activeIndex;
      var omitFieldNameList = Object.keys(fieldNames).map(function(key2) {
        return fieldNames[key2];
      });
      if (memoFlattenOptions.value.length === 0) {
        return createVNode("div", {
          "role": "listbox",
          "id": "".concat(id, "_list"),
          "class": "".concat(itemPrefixCls.value, "-empty"),
          "onMousedown": onListMouseDown
        }, [notFoundContent]);
      }
      return createVNode(Fragment, null, [createVNode("div", {
        "role": "listbox",
        "id": "".concat(id, "_list"),
        "style": {
          height: 0,
          width: 0,
          overflow: "hidden"
        }
      }, [renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)]), createVNode(List$1, {
        "itemKey": "key",
        "ref": listRef,
        "data": memoFlattenOptions.value,
        "height": listHeight,
        "itemHeight": listItemHeight,
        "fullHeight": false,
        "onMousedown": onListMouseDown,
        "onScroll": onPopupScroll,
        "virtual": virtual
      }, {
        default: function _default7(item, itemIndex) {
          var _classNames;
          var _a2;
          var group = item.group, groupOption = item.groupOption, data6 = item.data, value = item.value;
          var key2 = data6.key;
          var label = typeof item.label === "function" ? item.label() : item.label;
          if (group) {
            var groupTitle = (_a2 = data6.title) !== null && _a2 !== void 0 ? _a2 : isTitleType(label) && label;
            return createVNode("div", {
              "class": classNames(itemPrefixCls.value, "".concat(itemPrefixCls.value, "-group")),
              "title": groupTitle
            }, [renderOption ? renderOption(data6) : label !== void 0 ? label : key2]);
          }
          var disabled = data6.disabled, title = data6.title;
          data6.children;
          var style2 = data6.style, cls = data6.class, className = data6.className, otherProps = __rest$E(data6, ["disabled", "title", "children", "style", "class", "className"]);
          var passedProps = omit$3(otherProps, omitFieldNameList);
          var selected = isSelected(value);
          var optionPrefixCls = "".concat(itemPrefixCls.value, "-option");
          var optionClassName = classNames(itemPrefixCls.value, optionPrefixCls, cls, className, (_classNames = {}, _defineProperty$R(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), _defineProperty$R(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), _defineProperty$R(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), _defineProperty$R(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
          var mergedLabel = getLabel(item);
          var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
          var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
          var optionTitle = isTitleType(content) ? content.toString() : void 0;
          if (title !== void 0) {
            optionTitle = title;
          }
          return createVNode("div", _objectSpread2$2(_objectSpread2$2({}, passedProps), {}, {
            "aria-selected": selected,
            "class": optionClassName,
            "title": optionTitle,
            "onMousemove": function onMousemove(e2) {
              if (otherProps.onMousemove) {
                otherProps.onMousemove(e2);
              }
              if (activeIndex === itemIndex || disabled) {
                return;
              }
              setActive(itemIndex);
            },
            "onClick": function onClick2(e2) {
              if (!disabled) {
                onSelectValue(value);
              }
              if (otherProps.onClick) {
                otherProps.onClick(e2);
              }
            },
            "style": style2
          }), [createVNode("div", {
            "class": "".concat(optionPrefixCls, "-content")
          }, [renderOption ? renderOption(data6) : content]), isValidElement(menuItemSelectedIcon) || selected, iconVisible && createVNode(TransBtn$1, {
            "class": "".concat(itemPrefixCls.value, "-option-state"),
            "customizeIcon": menuItemSelectedIcon,
            "customizeIconProps": {
              isSelected: selected
            }
          }, {
            default: function _default8() {
              return [selected ? "\u2713" : null];
            }
          })]);
        }
      })]);
    };
  }
});
var OptionList$3 = OptionList$2;
var __rest$D = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function convertNodeToOption(node) {
  var _a2 = node, key2 = _a2.key, children = _a2.children, _b = _a2.props, value = _b.value, disabled = _b.disabled, restProps = __rest$D(_b, ["value", "disabled"]);
  var child = children === null || children === void 0 ? void 0 : children.default;
  return _extends$2({
    key: key2,
    value: value !== void 0 ? value : key2,
    children: child,
    disabled: disabled || disabled === ""
  }, restProps);
}
function convertChildrenToData$1(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var dd = flattenChildren(nodes).map(function(node, index2) {
    var _a2;
    if (!isValidElement(node) || !node.type) {
      return null;
    }
    var isSelectOptGroup = node.type.isSelectOptGroup, key2 = node.key, children = node.children, props2 = node.props;
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }
    var child = children && children.default ? children.default() : void 0;
    var label = (props2 === null || props2 === void 0 ? void 0 : props2.label) || ((_a2 = children.label) === null || _a2 === void 0 ? void 0 : _a2.call(children)) || key2;
    return _extends$2(_extends$2({
      key: "__RC_SELECT_GRP__".concat(key2 === null ? index2 : String(key2), "__")
    }, props2), {
      label,
      options: convertChildrenToData$1(child || [])
    });
  }).filter(function(data6) {
    return data6;
  });
  return dd;
}
function useOptions(options, children, fieldNames) {
  var mergedOptions = shallowRef();
  var valueOptions = shallowRef();
  var labelOptions = shallowRef();
  var tempMergedOptions = shallowRef([]);
  watch([options, children], function() {
    if (options.value) {
      tempMergedOptions.value = toRaw(options.value).slice();
    } else {
      tempMergedOptions.value = convertChildrenToData$1(children.value);
    }
  }, {
    immediate: true,
    deep: true
  });
  watchEffect(function() {
    var newOptions = tempMergedOptions.value;
    var newValueOptions = new Map();
    var newLabelOptions = new Map();
    var fieldNamesValue = fieldNames.value;
    function dig(optionList) {
      var isChildren = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      for (var i2 = 0; i2 < optionList.length; i2 += 1) {
        var option2 = optionList[i2];
        if (!option2[fieldNamesValue.options] || isChildren) {
          newValueOptions.set(option2[fieldNamesValue.value], option2);
          newLabelOptions.set(option2[fieldNamesValue.label], option2);
        } else {
          dig(option2[fieldNamesValue.options], true);
        }
      }
    }
    dig(newOptions);
    mergedOptions.value = newOptions;
    valueOptions.value = newValueOptions;
    labelOptions.value = newLabelOptions;
  });
  return {
    options: mergedOptions,
    valueOptions,
    labelOptions
  };
}
var uuid$5 = 0;
var isBrowserClient = canUseDom();
function getUUID$1() {
  var retId;
  if (isBrowserClient) {
    retId = uuid$5;
    uuid$5 += 1;
  } else {
    retId = "TEST_OR_SSR";
  }
  return retId;
}
function useId$1() {
  var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ref("");
  var innerId = "rc_select_".concat(getUUID$1());
  return id.value || innerId;
}
function toArray$7(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
function includes(test, search) {
  return toArray$7(test).join("").toUpperCase().includes(search);
}
var useFilterOptions = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
  return computed(function() {
    var searchValueVal = searchValue.value;
    var optionFilterPropValue = optionFilterProp === null || optionFilterProp === void 0 ? void 0 : optionFilterProp.value;
    var filterOptionValue = filterOption === null || filterOption === void 0 ? void 0 : filterOption.value;
    if (!searchValueVal || filterOptionValue === false) {
      return options.value;
    }
    var _fieldNames$value = fieldNames.value, fieldOptions = _fieldNames$value.options, fieldLabel = _fieldNames$value.label, fieldValue = _fieldNames$value.value;
    var filteredOptions = [];
    var customizeFilter = typeof filterOptionValue === "function";
    var upperSearch = searchValueVal.toUpperCase();
    var filterFunc = customizeFilter ? filterOptionValue : function(_2, option2) {
      if (optionFilterPropValue) {
        return includes(option2[optionFilterPropValue], upperSearch);
      }
      if (option2[fieldOptions]) {
        return includes(option2[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
      }
      return includes(option2[fieldValue], upperSearch);
    };
    var wrapOption = customizeFilter ? function(opt) {
      return injectPropsWithOption(opt);
    } : function(opt) {
      return opt;
    };
    options.value.forEach(function(item) {
      if (item[fieldOptions]) {
        var matchGroup = filterFunc(searchValueVal, wrapOption(item));
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          var subOptions = item[fieldOptions].filter(function(subItem) {
            return filterFunc(searchValueVal, wrapOption(subItem));
          });
          if (subOptions.length) {
            filteredOptions.push(_extends$2(_extends$2({}, item), _defineProperty$R({}, fieldOptions, subOptions)));
          }
        }
        return;
      }
      if (filterFunc(searchValueVal, wrapOption(item))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  });
};
var useCache$2 = function(labeledValues, valueOptions) {
  var cacheRef = shallowRef({
    values: new Map(),
    options: new Map()
  });
  var filledLabeledValues = computed(function() {
    var _cacheRef$value = cacheRef.value, prevValueCache = _cacheRef$value.values, prevOptionCache = _cacheRef$value.options;
    var patchedValues = labeledValues.value.map(function(item) {
      var _a2;
      if (item.label === void 0) {
        return _extends$2(_extends$2({}, item), {
          label: (_a2 = prevValueCache.get(item.value)) === null || _a2 === void 0 ? void 0 : _a2.label
        });
      }
      return item;
    });
    var valueCache = new Map();
    var optionCache = new Map();
    patchedValues.forEach(function(item) {
      valueCache.set(item.value, item);
      optionCache.set(item.value, valueOptions.value.get(item.value) || prevOptionCache.get(item.value));
    });
    cacheRef.value.values = valueCache;
    cacheRef.value.options = optionCache;
    return patchedValues;
  });
  var getOption = function getOption2(val) {
    return valueOptions.value.get(val) || cacheRef.value.options.get(val);
  };
  return [filledLabeledValues, getOption];
};
function useMergedState(defaultStateValue, option2) {
  var _ref = option2 || {}, defaultValue = _ref.defaultValue, _ref$value = _ref.value, value = _ref$value === void 0 ? ref() : _ref$value;
  var initValue = typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
  if (value.value !== void 0) {
    initValue = unref(value);
  }
  if (defaultValue !== void 0) {
    initValue = typeof defaultValue === "function" ? defaultValue() : defaultValue;
  }
  var innerValue = ref(initValue);
  var mergedValue = ref(initValue);
  watchEffect(function() {
    var val = value.value !== void 0 ? value.value : innerValue.value;
    if (option2.postState) {
      val = option2.postState(val);
    }
    mergedValue.value = val;
  });
  function triggerChange(newValue) {
    var preVal = mergedValue.value;
    innerValue.value = newValue;
    if (toRaw(mergedValue.value) !== newValue && option2.onChange) {
      option2.onChange(newValue, preVal);
    }
  }
  watch(value, function() {
    innerValue.value = value.value;
  });
  return [mergedValue, triggerChange];
}
function useState(defaultStateValue) {
  var initValue = typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
  var innerValue = ref(initValue);
  function triggerChange(newValue) {
    innerValue.value = newValue;
  }
  return [innerValue, triggerChange];
}
var OMIT_DOM_PROPS = ["inputValue"];
function selectProps$1() {
  return _extends$2(_extends$2({}, baseSelectPropsWithoutPrivate()), {
    prefixCls: String,
    id: String,
    backfill: {
      type: Boolean,
      default: void 0
    },
    fieldNames: Object,
    inputValue: String,
    searchValue: String,
    onSearch: Function,
    autoClearSearchValue: {
      type: Boolean,
      default: void 0
    },
    onSelect: Function,
    onDeselect: Function,
    filterOption: {
      type: [Boolean, Function],
      default: void 0
    },
    filterSort: Function,
    optionFilterProp: String,
    optionLabelProp: String,
    options: Array,
    defaultActiveFirstOption: {
      type: Boolean,
      default: void 0
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    listHeight: Number,
    listItemHeight: Number,
    menuItemSelectedIcon: PropTypes$1.any,
    mode: String,
    labelInValue: {
      type: Boolean,
      default: void 0
    },
    value: PropTypes$1.any,
    defaultValue: PropTypes$1.any,
    onChange: Function,
    children: Array
  });
}
function isRawValue$1(value) {
  return !value || _typeof$2(value) !== "object";
}
var Select$2 = defineComponent({
  name: "Select",
  inheritAttrs: false,
  props: initDefaultProps$1(selectProps$1(), {
    prefixCls: "vc-select",
    autoClearSearchValue: true,
    listHeight: 200,
    listItemHeight: 20,
    dropdownMatchSelectWidth: true
  }),
  setup: function setup26(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs, slots = _ref.slots;
    var mergedId = useId$1(toRef(props2, "id"));
    var multiple = computed(function() {
      return isMultiple(props2.mode);
    });
    var childrenAsData = computed(function() {
      return !!(!props2.options && props2.children);
    });
    var mergedFilterOption = computed(function() {
      if (props2.filterOption === void 0 && props2.mode === "combobox") {
        return false;
      }
      return props2.filterOption;
    });
    var mergedFieldNames = computed(function() {
      return fillFieldNames$3(props2.fieldNames, childrenAsData.value);
    });
    var _useMergedState = useMergedState("", {
      value: computed(function() {
        return props2.searchValue !== void 0 ? props2.searchValue : props2.inputValue;
      }),
      postState: function postState(search) {
        return search || "";
      }
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    var parsedOptions = useOptions(toRef(props2, "options"), toRef(props2, "children"), mergedFieldNames);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    var convert2LabelValues = function convert2LabelValues2(draftValues) {
      var valueList = toArray$7(draftValues);
      return valueList.map(function(val) {
        var _a2, _b;
        var rawValue;
        var rawLabel;
        var rawKey;
        var rawDisabled;
        if (isRawValue$1(val)) {
          rawValue = val;
        } else {
          rawKey = val.key;
          rawLabel = val.label;
          rawValue = (_a2 = val.value) !== null && _a2 !== void 0 ? _a2 : rawKey;
        }
        var option2 = valueOptions.value.get(rawValue);
        if (option2) {
          if (rawLabel === void 0)
            rawLabel = option2 === null || option2 === void 0 ? void 0 : option2[props2.optionLabelProp || mergedFieldNames.value.label];
          if (rawKey === void 0)
            rawKey = (_b = option2 === null || option2 === void 0 ? void 0 : option2.key) !== null && _b !== void 0 ? _b : rawValue;
          rawDisabled = option2 === null || option2 === void 0 ? void 0 : option2.disabled;
        }
        return {
          label: rawLabel,
          value: rawValue,
          key: rawKey,
          disabled: rawDisabled,
          option: option2
        };
      });
    };
    var _useMergedState3 = useMergedState(props2.defaultValue, {
      value: toRef(props2, "value")
    }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    var rawLabeledValues = computed(function() {
      var _a2;
      var values = convert2LabelValues(internalValue.value);
      if (props2.mode === "combobox" && !((_a2 = values[0]) === null || _a2 === void 0 ? void 0 : _a2.value)) {
        return [];
      }
      return values;
    });
    var _useCache = useCache$2(rawLabeledValues, valueOptions), _useCache2 = _slicedToArray$2(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = computed(function() {
      if (!props2.mode && mergedValues.value.length === 1) {
        var firstValue = mergedValues.value[0];
        if (firstValue.value === null && (firstValue.label === null || firstValue.label === void 0)) {
          return [];
        }
      }
      return mergedValues.value.map(function(item) {
        var _a2;
        return _extends$2(_extends$2({}, item), {
          label: (_a2 = typeof item.label === "function" ? item.label() : item.label) !== null && _a2 !== void 0 ? _a2 : item.value
        });
      });
    });
    var rawValues = computed(function() {
      return new Set(mergedValues.value.map(function(val) {
        return val.value;
      }));
    });
    watchEffect(function() {
      var _a2;
      if (props2.mode === "combobox") {
        var strValue = (_a2 = mergedValues.value[0]) === null || _a2 === void 0 ? void 0 : _a2.value;
        if (strValue !== void 0 && strValue !== null) {
          setSearchValue(String(strValue));
        }
      }
    }, {
      flush: "post"
    });
    var createTagOption = function createTagOption2(val, label) {
      var _ref2;
      var mergedLabel = label !== null && label !== void 0 ? label : val;
      return _ref2 = {}, _defineProperty$R(_ref2, mergedFieldNames.value.value, val), _defineProperty$R(_ref2, mergedFieldNames.value.label, mergedLabel), _ref2;
    };
    var filledTagOptions = shallowRef();
    watchEffect(function() {
      if (props2.mode !== "tags") {
        filledTagOptions.value = mergedOptions.value;
        return;
      }
      var cloneOptions = mergedOptions.value.slice();
      var existOptions = function existOptions2(val) {
        return valueOptions.value.has(val);
      };
      _toConsumableArray(mergedValues.value).sort(function(a2, b2) {
        return a2.value < b2.value ? -1 : 1;
      }).forEach(function(item) {
        var val = item.value;
        if (!existOptions(val)) {
          cloneOptions.push(createTagOption(val, item.label));
        }
      });
      filledTagOptions.value = cloneOptions;
    });
    var filteredOptions = useFilterOptions(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, toRef(props2, "optionFilterProp"));
    var filledSearchOptions = computed(function() {
      if (props2.mode !== "tags" || !mergedSearchValue.value || filteredOptions.value.some(function(item) {
        return item[props2.optionFilterProp || "value"] === mergedSearchValue.value;
      })) {
        return filteredOptions.value;
      }
      return [createTagOption(mergedSearchValue.value)].concat(_toConsumableArray(filteredOptions.value));
    });
    var orderedFilteredOptions = computed(function() {
      if (!props2.filterSort) {
        return filledSearchOptions.value;
      }
      return _toConsumableArray(filledSearchOptions.value).sort(function(a2, b2) {
        return props2.filterSort(a2, b2);
      });
    });
    var displayOptions = computed(function() {
      return flattenOptions(orderedFilteredOptions.value, {
        fieldNames: mergedFieldNames.value,
        childrenAsData: childrenAsData.value
      });
    });
    var triggerChange = function triggerChange2(values) {
      var labeledValues = convert2LabelValues(values);
      setInternalValue(labeledValues);
      if (props2.onChange && (labeledValues.length !== mergedValues.value.length || labeledValues.some(function(newVal, index2) {
        var _a2;
        return ((_a2 = mergedValues.value[index2]) === null || _a2 === void 0 ? void 0 : _a2.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
      }))) {
        var returnValues = props2.labelInValue ? labeledValues.map(function(v2) {
          return _extends$2(_extends$2({}, v2), {
            originLabel: v2.label,
            label: typeof v2.label === "function" ? v2.label() : v2.label
          });
        }) : labeledValues.map(function(v2) {
          return v2.value;
        });
        var returnOptions = labeledValues.map(function(v2) {
          return injectPropsWithOption(getMixedOption(v2.value));
        });
        props2.onChange(multiple.value ? returnValues : returnValues[0], multiple.value ? returnOptions : returnOptions[0]);
      }
    };
    var _useState = useState(null), _useState2 = _slicedToArray$2(_useState, 2), activeValue = _useState2[0], setActiveValue = _useState2[1];
    var _useState3 = useState(0), _useState4 = _slicedToArray$2(_useState3, 2), accessibilityIndex = _useState4[0], setAccessibilityIndex = _useState4[1];
    var mergedDefaultActiveFirstOption = computed(function() {
      return props2.defaultActiveFirstOption !== void 0 ? props2.defaultActiveFirstOption : props2.mode !== "combobox";
    });
    var onActiveValue = function onActiveValue2(active, index2) {
      var _ref3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? "keyboard" : _ref3$source;
      setAccessibilityIndex(index2);
      if (props2.backfill && props2.mode === "combobox" && active !== null && source === "keyboard") {
        setActiveValue(String(active));
      }
    };
    var triggerSelect = function triggerSelect2(val, selected) {
      var getSelectEnt = function getSelectEnt2() {
        var _a2;
        var option3 = getMixedOption(val);
        var originLabel = option3 === null || option3 === void 0 ? void 0 : option3[mergedFieldNames.value.label];
        return [props2.labelInValue ? {
          label: typeof originLabel === "function" ? originLabel() : originLabel,
          originLabel,
          value: val,
          key: (_a2 = option3 === null || option3 === void 0 ? void 0 : option3.key) !== null && _a2 !== void 0 ? _a2 : val
        } : val, injectPropsWithOption(option3)];
      };
      if (selected && props2.onSelect) {
        var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = _slicedToArray$2(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], option2 = _getSelectEnt2[1];
        props2.onSelect(wrappedValue, option2);
      } else if (!selected && props2.onDeselect) {
        var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = _slicedToArray$2(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option = _getSelectEnt4[1];
        props2.onDeselect(_wrappedValue, _option);
      }
    };
    var onInternalSelect = function onInternalSelect2(val, info) {
      var cloneValues;
      var mergedSelect = multiple.value ? info.selected : true;
      if (mergedSelect) {
        cloneValues = multiple.value ? [].concat(_toConsumableArray(mergedValues.value), [val]) : [val];
      } else {
        cloneValues = mergedValues.value.filter(function(v2) {
          return v2.value !== val;
        });
      }
      triggerChange(cloneValues);
      triggerSelect(val, mergedSelect);
      if (props2.mode === "combobox") {
        setActiveValue("");
      } else if (!multiple.value || props2.autoClearSearchValue) {
        setSearchValue("");
        setActiveValue("");
      }
    };
    var onDisplayValuesChange = function onDisplayValuesChange2(nextValues, info) {
      triggerChange(nextValues);
      if (info.type === "remove" || info.type === "clear") {
        info.values.forEach(function(item) {
          triggerSelect(item.value, false);
        });
      }
    };
    var onInternalSearch = function onInternalSearch2(searchText, info) {
      var _a2;
      setSearchValue(searchText);
      setActiveValue(null);
      if (info.source === "submit") {
        var formatted = (searchText || "").trim();
        if (formatted) {
          var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues.value), [formatted])));
          triggerChange(newRawValues);
          triggerSelect(formatted, true);
          setSearchValue("");
        }
        return;
      }
      if (info.source !== "blur") {
        if (props2.mode === "combobox") {
          triggerChange(searchText);
        }
        (_a2 = props2.onSearch) === null || _a2 === void 0 ? void 0 : _a2.call(props2, searchText);
      }
    };
    var onInternalSearchSplit = function onInternalSearchSplit2(words) {
      var patchValues = words;
      if (props2.mode !== "tags") {
        patchValues = words.map(function(word) {
          var opt = labelOptions.value.get(word);
          return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
          return val !== void 0;
        });
      }
      var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues.value), _toConsumableArray(patchValues))));
      triggerChange(newRawValues);
      newRawValues.forEach(function(newRawValue) {
        triggerSelect(newRawValue, true);
      });
    };
    var realVirtual = computed(function() {
      return props2.virtual !== false && props2.dropdownMatchSelectWidth !== false;
    });
    useProvideSelectProps(toReactive(_extends$2(_extends$2({}, parsedOptions), {
      flattenOptions: displayOptions,
      onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      onSelect: onInternalSelect,
      menuItemSelectedIcon: toRef(props2, "menuItemSelectedIcon"),
      rawValues,
      fieldNames: mergedFieldNames,
      virtual: realVirtual,
      listHeight: toRef(props2, "listHeight"),
      listItemHeight: toRef(props2, "listItemHeight"),
      childrenAsData
    })));
    var selectRef = ref();
    expose({
      focus: function focus2() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      },
      scrollTo: function scrollTo2(arg) {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg);
      }
    });
    var pickProps = computed(function() {
      return omit$3(props2, [
        "id",
        "mode",
        "prefixCls",
        "backfill",
        "fieldNames",
        "inputValue",
        "searchValue",
        "onSearch",
        "autoClearSearchValue",
        "onSelect",
        "onDeselect",
        "dropdownMatchSelectWidth",
        "filterOption",
        "filterSort",
        "optionFilterProp",
        "optionLabelProp",
        "options",
        "children",
        "defaultActiveFirstOption",
        "menuItemSelectedIcon",
        "virtual",
        "listHeight",
        "listItemHeight",
        "value",
        "defaultValue",
        "labelInValue",
        "onChange"
      ]);
    });
    return function() {
      return createVNode(BaseSelect, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, pickProps.value), attrs), {}, {
        "id": mergedId,
        "prefixCls": props2.prefixCls,
        "ref": selectRef,
        "omitDomProps": OMIT_DOM_PROPS,
        "mode": props2.mode,
        "displayValues": displayValues.value,
        "onDisplayValuesChange": onDisplayValuesChange,
        "searchValue": mergedSearchValue.value,
        "onSearch": onInternalSearch,
        "onSearchSplit": onInternalSearchSplit,
        "dropdownMatchSelectWidth": props2.dropdownMatchSelectWidth,
        "OptionList": OptionList$3,
        "emptyOptions": !displayOptions.value.length,
        "activeValue": activeValue.value,
        "activeDescendantId": "".concat(mergedId, "_list_").concat(accessibilityIndex.value)
      }), slots);
    };
  }
});
var Option$2 = function Option() {
  return null;
};
Option$2.isSelectOption = true;
Option$2.displayName = "ASelectOption";
var Option$3 = Option$2;
var OptGroup$2 = function OptGroup() {
  return null;
};
OptGroup$2.isSelectOptGroup = true;
OptGroup$2.displayName = "ASelectOptGroup";
var OptGroup$3 = OptGroup$2;
var DownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
var DownOutlinedSvg = DownOutlined$2;
function _objectSpread$B(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$C(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$C(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DownOutlined = function DownOutlined2(props2, context2) {
  var p2 = _objectSpread$B({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$B({}, p2, {
    "icon": DownOutlinedSvg
  }), null);
};
DownOutlined.displayName = "DownOutlined";
DownOutlined.inheritAttrs = false;
var DownOutlined$1 = DownOutlined;
var CheckOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlinedSvg = CheckOutlined$2;
function _objectSpread$A(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$B(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$B(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CheckOutlined = function CheckOutlined2(props2, context2) {
  var p2 = _objectSpread$A({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$A({}, p2, {
    "icon": CheckOutlinedSvg
  }), null);
};
CheckOutlined.displayName = "CheckOutlined";
CheckOutlined.inheritAttrs = false;
var CheckOutlined$1 = CheckOutlined;
var SearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
var SearchOutlinedSvg = SearchOutlined$2;
function _objectSpread$z(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$A(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$A(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var SearchOutlined = function SearchOutlined2(props2, context2) {
  var p2 = _objectSpread$z({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$z({}, p2, {
    "icon": SearchOutlinedSvg
  }), null);
};
SearchOutlined.displayName = "SearchOutlined";
SearchOutlined.inheritAttrs = false;
var SearchOutlined$1 = SearchOutlined;
function getIcons(props2) {
  var slots = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var loading = props2.loading, multiple = props2.multiple, prefixCls2 = props2.prefixCls;
  var suffixIcon = props2.suffixIcon || slots.suffixIcon && slots.suffixIcon();
  var clearIcon = props2.clearIcon || slots.clearIcon && slots.clearIcon();
  var menuItemSelectedIcon = props2.menuItemSelectedIcon || slots.menuItemSelectedIcon && slots.menuItemSelectedIcon();
  var removeIcon = props2.removeIcon || slots.removeIcon && slots.removeIcon();
  var mergedClearIcon = clearIcon;
  if (!clearIcon) {
    mergedClearIcon = createVNode(CloseCircleFilled$1, null, null);
  }
  var mergedSuffixIcon = null;
  if (suffixIcon !== void 0) {
    mergedSuffixIcon = suffixIcon;
  } else if (loading) {
    mergedSuffixIcon = createVNode(LoadingOutlined$1, {
      "spin": true
    }, null);
  } else {
    var iconCls = "".concat(prefixCls2, "-suffix");
    mergedSuffixIcon = function mergedSuffixIcon2(_ref) {
      var open2 = _ref.open, showSearch = _ref.showSearch;
      if (open2 && showSearch) {
        return createVNode(SearchOutlined$1, {
          "class": iconCls
        }, null);
      }
      return createVNode(DownOutlined$1, {
        "class": iconCls
      }, null);
    };
  }
  var mergedItemIcon = null;
  if (menuItemSelectedIcon !== void 0) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = createVNode(CheckOutlined$1, null, null);
  } else {
    mergedItemIcon = null;
  }
  var mergedRemoveIcon = null;
  if (removeIcon !== void 0) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = createVNode(CloseOutlined$1, null, null);
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}
var ContextKey$1 = Symbol("ContextProps");
var InternalContextKey = Symbol("InternalContextProps");
var useProvideFormItemContext = function useProvideFormItemContext2(props2) {
  var useValidation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : computed(function() {
    return true;
  });
  var formItemFields = ref(new Map());
  var addFormItemField2 = function addFormItemField3(key2, type4) {
    formItemFields.value.set(key2, type4);
    formItemFields.value = new Map(formItemFields.value);
  };
  var removeFormItemField2 = function removeFormItemField3(key2) {
    formItemFields.value.delete(key2);
    formItemFields.value = new Map(formItemFields.value);
  };
  getCurrentInstance();
  watch([useValidation, formItemFields], function() {
  });
  provide(ContextKey$1, props2);
  provide(InternalContextKey, {
    addFormItemField: addFormItemField2,
    removeFormItemField: removeFormItemField2
  });
};
var defaultContext = {
  id: computed(function() {
    return void 0;
  }),
  onFieldBlur: function onFieldBlur() {
  },
  onFieldChange: function onFieldChange() {
  },
  clearValidate: function clearValidate() {
  }
};
var defaultInternalContext = {
  addFormItemField: function addFormItemField() {
  },
  removeFormItemField: function removeFormItemField() {
  }
};
var useInjectFormItemContext = function useInjectFormItemContext2() {
  var internalContext = inject(InternalContextKey, defaultInternalContext);
  var formItemFieldKey = Symbol("FormItemFieldKey");
  var instance2 = getCurrentInstance();
  internalContext.addFormItemField(formItemFieldKey, instance2.type);
  onBeforeUnmount(function() {
    internalContext.removeFormItemField(formItemFieldKey);
  });
  provide(InternalContextKey, defaultInternalContext);
  provide(ContextKey$1, defaultContext);
  return inject(ContextKey$1, defaultContext);
};
var FormItemRest = defineComponent({
  name: "AFormItemRest",
  setup: function setup27(_2, _ref) {
    var slots = _ref.slots;
    provide(InternalContextKey, defaultInternalContext);
    provide(ContextKey$1, defaultContext);
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var selectProps = function selectProps2() {
  return _extends$2(_extends$2({}, omit$3(selectProps$1(), ["inputIcon", "mode", "getInputElement", "getRawInputElement", "backfill"])), {
    value: {
      type: [Array, Object, String, Number]
    },
    defaultValue: {
      type: [Array, Object, String, Number]
    },
    notFoundContent: PropTypes$1.any,
    suffixIcon: PropTypes$1.any,
    itemIcon: PropTypes$1.any,
    size: String,
    mode: String,
    bordered: {
      type: Boolean,
      default: true
    },
    transitionName: String,
    choiceTransitionName: {
      type: String,
      default: ""
    },
    "onUpdate:value": Function
  });
};
var SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var Select = defineComponent({
  name: "ASelect",
  Option: Option$3,
  OptGroup: OptGroup$3,
  inheritAttrs: false,
  props: initDefaultProps$1(selectProps(), {
    listHeight: 256,
    listItemHeight: 24
  }),
  SECRET_COMBOBOX_MODE_DO_NOT_USE,
  slots: [
    "notFoundContent",
    "suffixIcon",
    "itemIcon",
    "removeIcon",
    "clearIcon",
    "dropdownRender",
    "option",
    "placeholder",
    "tagRender",
    "maxTagPlaceholder",
    "optionLabel"
  ],
  setup: function setup28(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots, expose = _ref.expose;
    var selectRef = ref();
    var formItemContext = useInjectFormItemContext();
    var focus2 = function focus3() {
      var _a2;
      (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    var scrollTo2 = function scrollTo3(arg) {
      var _a2;
      (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg);
    };
    var mode = computed(function() {
      var mode2 = props2.mode;
      if (mode2 === "combobox") {
        return void 0;
      }
      if (mode2 === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
        return "combobox";
      }
      return mode2;
    });
    var _useConfigInject = useConfigInject("select", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, configProvider = _useConfigInject.configProvider, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var rootPrefixCls = computed(function() {
      return getPrefixCls2();
    });
    var transitionName2 = computed(function() {
      return getTransitionName$2(rootPrefixCls.value, "slide-up", props2.transitionName);
    });
    var mergedClassName = computed(function() {
      var _classNames;
      return classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-lg"), props2.size === "large"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-sm"), props2.size === "small"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-borderless"), !props2.bordered), _classNames));
    });
    var triggerChange = function triggerChange2() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      emit("update:value", args[0]);
      emit.apply(void 0, ["change"].concat(args));
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2(e2) {
      emit("blur", e2);
      formItemContext.onFieldBlur();
    };
    expose({
      blur,
      focus: focus2,
      scrollTo: scrollTo2
    });
    var isMultiple2 = computed(function() {
      return mode.value === "multiple" || mode.value === "tags";
    });
    return function() {
      var _a2, _b;
      var notFoundContent = props2.notFoundContent, _props$listHeight = props2.listHeight, listHeight = _props$listHeight === void 0 ? 256 : _props$listHeight, _props$listItemHeight = props2.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 24 : _props$listItemHeight, getPopupContainer = props2.getPopupContainer, dropdownClassName = props2.dropdownClassName, virtual = props2.virtual, dropdownMatchSelectWidth = props2.dropdownMatchSelectWidth, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, _props$placeholder = props2.placeholder, placeholder = _props$placeholder === void 0 ? (_a2 = slots.placeholder) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$placeholder;
      var renderEmpty2 = configProvider.renderEmpty, getContextPopupContainer = configProvider.getPopupContainer;
      var mergedNotFound;
      if (notFoundContent !== void 0) {
        mergedNotFound = notFoundContent;
      } else if (slots.notFoundContent) {
        mergedNotFound = slots.notFoundContent();
      } else if (mode.value === "combobox") {
        mergedNotFound = null;
      } else {
        mergedNotFound = renderEmpty2("Select");
      }
      var _getIcons = getIcons(_extends$2(_extends$2({}, props2), {
        multiple: isMultiple2.value,
        prefixCls: prefixCls2.value
      }), slots), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
      var selectProps3 = omit$3(props2, ["prefixCls", "suffixIcon", "itemIcon", "removeIcon", "clearIcon", "size", "bordered"]);
      var rcSelectRtlDropDownClassName = classNames(dropdownClassName, _defineProperty$R({}, "".concat(prefixCls2.value, "-dropdown-").concat(direction2.value), direction2.value === "rtl"));
      return createVNode(Select$2, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
        "ref": selectRef,
        "virtual": virtual,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth
      }, selectProps3), attrs), {}, {
        "placeholder": placeholder,
        "listHeight": listHeight,
        "listItemHeight": listItemHeight,
        "mode": mode.value,
        "prefixCls": prefixCls2.value,
        "direction": direction2.value,
        "inputIcon": suffixIcon,
        "menuItemSelectedIcon": itemIcon,
        "removeIcon": removeIcon,
        "clearIcon": clearIcon,
        "notFoundContent": mergedNotFound,
        "class": [mergedClassName.value, attrs.class],
        "getPopupContainer": getPopupContainer || getContextPopupContainer,
        "dropdownClassName": rcSelectRtlDropDownClassName,
        "onChange": triggerChange,
        "onBlur": handleBlur,
        "id": id,
        "dropdownRender": selectProps3.dropdownRender || slots.dropdownRender,
        "transitionName": transitionName2.value,
        "children": (_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots),
        "tagRender": props2.tagRender || slots.tagRender,
        "optionLabelRender": slots.optionLabel,
        "maxTagPlaceholder": props2.maxTagPlaceholder || slots.maxTagPlaceholder
      }), {
        option: slots.option
      });
    };
  }
});
Select.install = function(app) {
  app.component(Select.name, Select);
  app.component(Select.Option.displayName, Select.Option);
  app.component(Select.OptGroup.displayName, Select.OptGroup);
  return app;
};
var SelectOption = Select.Option;
Select.OptGroup;
var Select$1 = Select;
var Option2 = function Option3() {
  return null;
};
Option2.isSelectOption = true;
Option2.displayName = "AAutoCompleteOption";
var Option$1 = Option2;
var OptGroup2 = function OptGroup3() {
  return null;
};
OptGroup2.isSelectOptGroup = true;
OptGroup2.displayName = "AAutoCompleteOptGroup";
var OptGroup$1 = OptGroup2;
function isSelectOptionOrSelectOptGroup(child) {
  var _a2, _b;
  return ((_a2 = child === null || child === void 0 ? void 0 : child.type) === null || _a2 === void 0 ? void 0 : _a2.isSelectOption) || ((_b = child === null || child === void 0 ? void 0 : child.type) === null || _b === void 0 ? void 0 : _b.isSelectOptGroup);
}
var autoCompleteProps = function autoCompleteProps2() {
  return _extends$2(_extends$2({}, omit$3(selectProps(), ["loading", "mode", "optionLabelProp", "labelInValue"])), {
    dataSource: Array,
    dropdownMenuStyle: {
      type: Object,
      default: void 0
    },
    dropdownMatchSelectWidth: {
      type: [Number, Boolean],
      default: true
    },
    prefixCls: String,
    showSearch: {
      type: Boolean,
      default: void 0
    },
    transitionName: String,
    choiceTransitionName: {
      type: String,
      default: "zoom"
    },
    autofocus: {
      type: Boolean,
      default: void 0
    },
    backfill: {
      type: Boolean,
      default: void 0
    },
    filterOption: {
      type: [Boolean, Function],
      default: false
    },
    defaultActiveFirstOption: {
      type: Boolean,
      default: true
    }
  });
};
var AutoComplete = defineComponent({
  name: "AAutoComplete",
  inheritAttrs: false,
  props: autoCompleteProps(),
  slots: ["option"],
  setup: function setup29(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    warning$2(!("dataSource" in slots), "AutoComplete", "`dataSource` slot is deprecated, please use props `options` instead.");
    warning$2(!("options" in slots), "AutoComplete", "`options` slot is deprecated, please use props `options` instead.");
    var selectRef = ref();
    var getInputElement = function getInputElement2() {
      var _a2;
      var children = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      var element = children.length ? children[0] : void 0;
      return element;
    };
    var focus2 = function focus3() {
      var _a2;
      (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    var _useConfigInject = useConfigInject("select", props2), prefixCls2 = _useConfigInject.prefixCls;
    return function() {
      var _cls;
      var _a2, _b, _c;
      var size = props2.size, dataSource = props2.dataSource, _props$notFoundConten = props2.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? (_a2 = slots.notFoundContent) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$notFoundConten;
      var optionChildren;
      var className = attrs.class;
      var cls = (_cls = {}, _defineProperty$R(_cls, className, !!className), _defineProperty$R(_cls, "".concat(prefixCls2.value, "-lg"), size === "large"), _defineProperty$R(_cls, "".concat(prefixCls2.value, "-sm"), size === "small"), _defineProperty$R(_cls, "".concat(prefixCls2.value, "-show-search"), true), _defineProperty$R(_cls, "".concat(prefixCls2.value, "-auto-complete"), true), _cls);
      if (props2.options === void 0) {
        var childArray = ((_b = slots.dataSource) === null || _b === void 0 ? void 0 : _b.call(slots)) || ((_c = slots.options) === null || _c === void 0 ? void 0 : _c.call(slots)) || [];
        if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
          optionChildren = childArray;
        } else {
          optionChildren = dataSource ? dataSource.map(function(item) {
            if (isValidElement(item)) {
              return item;
            }
            switch (_typeof$2(item)) {
              case "string":
                return createVNode(Option$1, {
                  "key": item,
                  "value": item
                }, {
                  default: function _default7() {
                    return [item];
                  }
                });
              case "object":
                return createVNode(Option$1, {
                  "key": item.value,
                  "value": item.value
                }, {
                  default: function _default7() {
                    return [item.text];
                  }
                });
              default:
                throw new Error("AutoComplete[dataSource] only supports type `string[] | Object[]`.");
            }
          }) : [];
        }
      }
      var selectProps3 = omit$3(_extends$2(_extends$2(_extends$2({}, props2), attrs), {
        mode: Select$1.SECRET_COMBOBOX_MODE_DO_NOT_USE,
        getInputElement,
        notFoundContent,
        class: cls,
        ref: selectRef
      }), ["dataSource", "loading"]);
      return createVNode(Select$1, selectProps3, _objectSpread2$2({
        default: function _default7() {
          return [optionChildren];
        }
      }, omit$3(slots, ["default", "dataSource", "options"])));
    };
  }
});
var AutoComplete$1 = _extends$2(AutoComplete, {
  Option: Option$1,
  OptGroup: OptGroup$1,
  install: function install(app) {
    app.component(AutoComplete.name, AutoComplete);
    app.component(Option$1.displayName, Option$1);
    app.component(OptGroup$1.displayName, OptGroup$1);
    return app;
  }
});
var responsiveArray = ["xxxl", "xxl", "xl", "lg", "md", "sm", "xs"];
var responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 992px)",
  xl: "(min-width: 1200px)",
  xxl: "(min-width: 1600px)",
  xxxl: "(min-width: 2000px)"
};
var subscribers = new Map();
var subUid = -1;
var screens = {};
var responsiveObserve = {
  matchHandlers: {},
  dispatch: function dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach(function(func) {
      return func(screens);
    });
    return subscribers.size >= 1;
  },
  subscribe: function subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister: function unregister() {
    var _this = this;
    Object.keys(responsiveMap).forEach(function(screen) {
      var matchMediaQuery = responsiveMap[screen];
      var handler4 = _this.matchHandlers[matchMediaQuery];
      handler4 === null || handler4 === void 0 ? void 0 : handler4.mql.removeListener(handler4 === null || handler4 === void 0 ? void 0 : handler4.listener);
    });
    subscribers.clear();
  },
  register: function register() {
    var _this2 = this;
    Object.keys(responsiveMap).forEach(function(screen) {
      var matchMediaQuery = responsiveMap[screen];
      var listener = function listener2(_ref) {
        var matches2 = _ref.matches;
        _this2.dispatch(_extends$2(_extends$2({}, screens), _defineProperty$R({}, screen, matches2)));
      };
      var mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      _this2.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;
function useBreakpoint() {
  var screens2 = ref({});
  var token = null;
  onMounted(function() {
    token = ResponsiveObserve.subscribe(function(supportScreens) {
      screens2.value = supportScreens;
    });
  });
  onUnmounted(function() {
    ResponsiveObserve.unsubscribe(token);
  });
  return screens2;
}
var sizeProvider = Symbol("SizeProvider");
var useInjectSize = function useInjectSize2(props2) {
  var size = props2 ? computed(function() {
    return props2.size;
  }) : inject(sizeProvider, computed(function() {
    return "default";
  }));
  return size;
};
function eagerComputed(fn) {
  var result = shallowRef();
  watchEffect(function() {
    result.value = fn();
  }, {
    flush: "sync"
  });
  return result;
}
var autoAdjustOverflow$2 = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset$2 = [0, 0];
var placements$3 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  }
};
var tooltipContentProps = {
  prefixCls: String,
  id: String,
  overlayInnerStyle: PropTypes$1.any
};
var Content$1 = defineComponent({
  name: "Content",
  props: tooltipContentProps,
  slots: ["overlay"],
  setup: function setup30(props2, _ref) {
    var slots = _ref.slots;
    return function() {
      var _a2;
      return createVNode("div", {
        "class": "".concat(props2.prefixCls, "-inner"),
        "id": props2.id,
        "role": "tooltip",
        "style": props2.overlayInnerStyle
      }, [(_a2 = slots.overlay) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var __rest$C = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function noop$3() {
}
var Tooltip$1 = defineComponent({
  name: "Tooltip",
  inheritAttrs: false,
  props: {
    trigger: PropTypes$1.any.def(["hover"]),
    defaultVisible: {
      type: Boolean,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    placement: PropTypes$1.string.def("right"),
    transitionName: String,
    animation: PropTypes$1.any,
    afterVisibleChange: PropTypes$1.func.def(function() {
    }),
    overlayStyle: {
      type: Object,
      default: void 0
    },
    overlayClassName: String,
    prefixCls: PropTypes$1.string.def("rc-tooltip"),
    mouseEnterDelay: PropTypes$1.number.def(0.1),
    mouseLeaveDelay: PropTypes$1.number.def(0.1),
    getTooltipContainer: Function,
    destroyTooltipOnHide: {
      type: Boolean,
      default: false
    },
    align: PropTypes$1.object.def(function() {
      return {};
    }),
    arrowContent: PropTypes$1.any.def(null),
    tipId: String,
    builtinPlacements: PropTypes$1.object,
    overlayInnerStyle: {
      type: Object,
      default: void 0
    },
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    onVisibleChange: Function,
    onPopupAlign: Function
  },
  slots: ["arrowContent", "overlay"],
  setup: function setup31(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var triggerDOM = ref();
    var getPopupElement = function getPopupElement2() {
      var prefixCls2 = props2.prefixCls, tipId = props2.tipId, overlayInnerStyle = props2.overlayInnerStyle;
      return [createVNode("div", {
        "class": "".concat(prefixCls2, "-arrow"),
        "key": "arrow"
      }, [getPropsSlot(slots, props2, "arrowContent")]), createVNode(Content$1, {
        "key": "content",
        "prefixCls": prefixCls2,
        "id": tipId,
        "overlayInnerStyle": overlayInnerStyle
      }, {
        overlay: slots.overlay
      })];
    };
    var getPopupDomNode2 = function getPopupDomNode3() {
      return triggerDOM.value.getPopupDomNode();
    };
    expose({
      getPopupDomNode: getPopupDomNode2,
      triggerDOM,
      forcePopupAlign: function forcePopupAlign2() {
        var _a2;
        return (_a2 = triggerDOM.value) === null || _a2 === void 0 ? void 0 : _a2.forcePopupAlign();
      }
    });
    var destroyTooltip = ref(false);
    var autoDestroy = ref(false);
    watchEffect(function() {
      var destroyTooltipOnHide = props2.destroyTooltipOnHide;
      if (typeof destroyTooltipOnHide === "boolean") {
        destroyTooltip.value = destroyTooltipOnHide;
      } else if (destroyTooltipOnHide && _typeof$2(destroyTooltipOnHide) === "object") {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip.value = keepParent === true;
        autoDestroy.value = keepParent === false;
      }
    });
    return function() {
      var overlayClassName = props2.overlayClassName, trigger2 = props2.trigger, mouseEnterDelay = props2.mouseEnterDelay, mouseLeaveDelay = props2.mouseLeaveDelay, overlayStyle = props2.overlayStyle, prefixCls2 = props2.prefixCls, afterVisibleChange = props2.afterVisibleChange, transitionName2 = props2.transitionName, animation = props2.animation, placement = props2.placement, align = props2.align;
      props2.destroyTooltipOnHide;
      var defaultVisible = props2.defaultVisible, getTooltipContainer = props2.getTooltipContainer, restProps = __rest$C(props2, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer"]);
      var extraProps = _extends$2({}, restProps);
      if (props2.visible !== void 0) {
        extraProps.popupVisible = props2.visible;
      }
      var triggerProps = _extends$2(_extends$2(_extends$2({
        popupClassName: overlayClassName,
        prefixCls: prefixCls2,
        action: trigger2,
        builtinPlacements: placements$3,
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName2,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip.value,
        autoDestroy: autoDestroy.value,
        mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay
      }, extraProps), attrs), {
        onPopupVisibleChange: props2.onVisibleChange || noop$3,
        onPopupAlign: props2.onPopupAlign || noop$3,
        ref: triggerDOM,
        popup: getPopupElement()
      });
      return createVNode(Trigger, triggerProps, {
        default: slots.default
      });
    };
  }
});
var PresetStatusColorTypes = tuple$1("success", "processing", "error", "default", "warning");
var PresetColorTypes = tuple$1("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime");
var abstractTooltipProps = function() {
  return {
    trigger: [String, Array],
    visible: {
      type: Boolean,
      default: void 0
    },
    defaultVisible: {
      type: Boolean,
      default: void 0
    },
    placement: String,
    color: String,
    transitionName: String,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    overlayClassName: String,
    openClassName: String,
    prefixCls: String,
    mouseEnterDelay: Number,
    mouseLeaveDelay: Number,
    getPopupContainer: Function,
    arrowPointAtCenter: {
      type: Boolean,
      default: void 0
    },
    autoAdjustOverflow: {
      type: [Boolean, Object],
      default: void 0
    },
    destroyTooltipOnHide: {
      type: Boolean,
      default: void 0
    },
    align: {
      type: Object,
      default: void 0
    },
    builtinPlacements: {
      type: Object,
      default: void 0
    },
    children: Array,
    onVisibleChange: Function,
    "onUpdate:visible": Function
  };
};
var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset$1 = [0, 0];
function getOverflowOptions(autoAdjustOverflow2) {
  if (typeof autoAdjustOverflow2 === "boolean") {
    return autoAdjustOverflow2 ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }
  return _extends$2(_extends$2({}, autoAdjustOverflowDisabled), autoAdjustOverflow2);
}
function getPlacements(config) {
  var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 4 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow2 = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter;
  var placementMap = {
    left: {
      points: ["cr", "cl"],
      offset: [-4, 0]
    },
    right: {
      points: ["cl", "cr"],
      offset: [4, 0]
    },
    top: {
      points: ["bc", "tc"],
      offset: [0, -4]
    },
    bottom: {
      points: ["tc", "bc"],
      offset: [0, 4]
    },
    topLeft: {
      points: ["bl", "tc"],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ["tr", "cl"],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ["br", "tc"],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ["tl", "cr"],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ["tr", "bc"],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ["bl", "cr"],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ["tl", "bc"],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ["br", "cl"],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function(key2) {
    placementMap[key2] = arrowPointAtCenter ? _extends$2(_extends$2({}, placementMap[key2]), {
      overflow: getOverflowOptions(autoAdjustOverflow2),
      targetOffset: targetOffset$1
    }) : _extends$2(_extends$2({}, placements$3[key2]), {
      overflow: getOverflowOptions(autoAdjustOverflow2)
    });
    placementMap[key2].ignoreShake = true;
  });
  return placementMap;
}
function firstNotUndefined() {
  var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    if (arr[i2] !== void 0) {
      return arr[i2];
    }
  }
  return void 0;
}
var splitObject = function splitObject2(obj, keys2) {
  var picked = {};
  var omitted = _extends$2({}, obj);
  keys2.forEach(function(key2) {
    if (obj && key2 in obj) {
      picked[key2] = obj[key2];
      delete omitted[key2];
    }
  });
  return {
    picked,
    omitted
  };
};
var PresetColorRegex$1 = new RegExp("^(".concat(PresetColorTypes.join("|"), ")(-inverse)?$"));
var tooltipProps = function tooltipProps2() {
  return _extends$2(_extends$2({}, abstractTooltipProps()), {
    title: PropTypes$1.any
  });
};
var tooltipDefaultProps = function tooltipDefaultProps2() {
  return {
    trigger: "hover",
    transitionName: "zoom-big-fast",
    align: {},
    placement: "top",
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    arrowPointAtCenter: false,
    autoAdjustOverflow: true
  };
};
var ToolTip = defineComponent({
  name: "ATooltip",
  inheritAttrs: false,
  props: initDefaultProps$1(tooltipProps(), {
    trigger: "hover",
    transitionName: "zoom-big-fast",
    align: {},
    placement: "top",
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    arrowPointAtCenter: false,
    autoAdjustOverflow: true
  }),
  slots: ["title"],
  setup: function setup32(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs, expose = _ref.expose;
    var _useConfigInject = useConfigInject("tooltip", props2), prefixCls2 = _useConfigInject.prefixCls, getTargetContainer = _useConfigInject.getTargetContainer;
    var visible = ref(firstNotUndefined([props2.visible, props2.defaultVisible]));
    var tooltip = ref();
    onMounted(function() {
      warning$2(props2.defaultVisible === void 0, "Tooltip", "'defaultVisible' is deprecated, please use 'v-model:visible'");
    });
    var rafId;
    watch(function() {
      return props2.visible;
    }, function(val) {
      wrapperRaf.cancel(rafId);
      rafId = wrapperRaf(function() {
        visible.value = !!val;
      });
    });
    var isNoTitle = function isNoTitle2() {
      var _a2;
      var title = (_a2 = props2.title) !== null && _a2 !== void 0 ? _a2 : slots.title;
      return !title && title !== 0;
    };
    var handleVisibleChange = function handleVisibleChange2(val) {
      var noTitle = isNoTitle();
      if (props2.visible === void 0) {
        visible.value = noTitle ? false : val;
      }
      if (!noTitle) {
        emit("update:visible", val);
        emit("visibleChange", val);
      }
    };
    var getPopupDomNode2 = function getPopupDomNode3() {
      return tooltip.value.getPopupDomNode();
    };
    expose({
      getPopupDomNode: getPopupDomNode2,
      visible,
      forcePopupAlign: function forcePopupAlign2() {
        var _a2;
        return (_a2 = tooltip.value) === null || _a2 === void 0 ? void 0 : _a2.forcePopupAlign();
      }
    });
    var tooltipPlacements = computed(function() {
      var builtinPlacements = props2.builtinPlacements, arrowPointAtCenter = props2.arrowPointAtCenter, autoAdjustOverflow2 = props2.autoAdjustOverflow;
      return builtinPlacements || getPlacements({
        arrowPointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow2
      });
    });
    var isTrueProps = function isTrueProps2(val) {
      return val || val === "";
    };
    var getDisabledCompatibleChildren = function getDisabledCompatibleChildren2(ele) {
      var elementType = ele.type;
      if (_typeof$2(elementType) === "object" && ele.props) {
        if ((elementType.__ANT_BUTTON === true || elementType === "button") && isTrueProps(ele.props.disabled) || elementType.__ANT_SWITCH === true && (isTrueProps(ele.props.disabled) || isTrueProps(ele.props.loading))) {
          var _splitObject = splitObject(getStyle(ele), ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]), picked = _splitObject.picked, omitted = _splitObject.omitted;
          var spanStyle = _extends$2(_extends$2({
            display: "inline-block"
          }, picked), {
            cursor: "not-allowed",
            width: ele.props && ele.props.block ? "100%" : null
          });
          var buttonStyle = _extends$2(_extends$2({}, omitted), {
            pointerEvents: "none"
          });
          var child = cloneElement(ele, {
            style: buttonStyle
          }, true);
          return createVNode("span", {
            "style": spanStyle,
            "class": "".concat(prefixCls2, "-disabled-compatible-wrapper")
          }, [child]);
        }
      }
      return ele;
    };
    var getOverlay = function getOverlay2() {
      var _a2, _b;
      return (_a2 = props2.title) !== null && _a2 !== void 0 ? _a2 : (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots);
    };
    var onPopupAlign = function onPopupAlign2(domNode, align) {
      var placements2 = tooltipPlacements.value;
      var placement = Object.keys(placements2).filter(function(key2) {
        return placements2[key2].points[0] === align.points[0] && placements2[key2].points[1] === align.points[1];
      })[0];
      if (!placement) {
        return;
      }
      var rect = domNode.getBoundingClientRect();
      var transformOrigin = {
        top: "50%",
        left: "50%"
      };
      if (placement.indexOf("top") >= 0 || placement.indexOf("Bottom") >= 0) {
        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
      } else if (placement.indexOf("Top") >= 0 || placement.indexOf("bottom") >= 0) {
        transformOrigin.top = "".concat(-align.offset[1], "px");
      }
      if (placement.indexOf("left") >= 0 || placement.indexOf("Right") >= 0) {
        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
      } else if (placement.indexOf("right") >= 0 || placement.indexOf("Left") >= 0) {
        transformOrigin.left = "".concat(-align.offset[0], "px");
      }
      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };
    return function() {
      var _classNames;
      var _a2, _b;
      var openClassName = props2.openClassName, getPopupContainer = props2.getPopupContainer, color = props2.color, overlayClassName = props2.overlayClassName;
      var children = (_b = filterEmpty((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots))) !== null && _b !== void 0 ? _b : null;
      children = children.length === 1 ? children[0] : children;
      var tempVisible = visible.value;
      if (props2.visible === void 0 && isNoTitle()) {
        tempVisible = false;
      }
      if (!children) {
        return null;
      }
      var child = getDisabledCompatibleChildren(isValidElement(children) ? children : createVNode("span", null, [children]));
      var childCls = classNames((_classNames = {}, _defineProperty$R(_classNames, openClassName || "".concat(prefixCls2.value, "-open"), true), _defineProperty$R(_classNames, child.props && child.props.class, child.props && child.props.class), _classNames));
      var customOverlayClassName = classNames(overlayClassName, _defineProperty$R({}, "".concat(prefixCls2.value, "-").concat(color), color && PresetColorRegex$1.test(color)));
      var formattedOverlayInnerStyle;
      var arrowContentStyle;
      if (color && !PresetColorRegex$1.test(color)) {
        formattedOverlayInnerStyle = {
          backgroundColor: color
        };
        arrowContentStyle = {
          backgroundColor: color
        };
      }
      var vcTooltipProps = _extends$2(_extends$2(_extends$2({}, attrs), props2), {
        prefixCls: prefixCls2.value,
        getTooltipContainer: getPopupContainer || getTargetContainer.value,
        builtinPlacements: tooltipPlacements.value,
        visible: tempVisible,
        ref: tooltip,
        overlayClassName: customOverlayClassName,
        overlayInnerStyle: formattedOverlayInnerStyle,
        onVisibleChange: handleVisibleChange,
        onPopupAlign
      });
      return createVNode(Tooltip$1, vcTooltipProps, {
        default: function _default7() {
          return [visible.value ? cloneElement(child, {
            class: childCls
          }) : child];
        },
        arrowContent: function arrowContent() {
          return createVNode("span", {
            "class": "".concat(prefixCls2.value, "-arrow-content"),
            "style": arrowContentStyle
          }, null);
        },
        overlay: getOverlay
      });
    };
  }
});
var Tooltip = withInstall$2(ToolTip);
var popoverProps = function popoverProps2() {
  return _extends$2(_extends$2({}, abstractTooltipProps()), {
    content: PropTypes$1.any,
    title: PropTypes$1.any
  });
};
var Popover = defineComponent({
  name: "APopover",
  props: initDefaultProps$1(popoverProps(), _extends$2(_extends$2({}, tooltipDefaultProps()), {
    trigger: "hover",
    transitionName: "zoom-big",
    placement: "top",
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1
  })),
  setup: function setup33(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var tooltipRef = ref();
    expose({
      getPopupDomNode: function getPopupDomNode2() {
        var _a2, _b;
        return (_b = (_a2 = tooltipRef.value) === null || _a2 === void 0 ? void 0 : _a2.getPopupDomNode) === null || _b === void 0 ? void 0 : _b.call(_a2);
      }
    });
    var _useConfigInject = useConfigInject("popover", props2), prefixCls2 = _useConfigInject.prefixCls, configProvider = _useConfigInject.configProvider;
    var rootPrefixCls = computed(function() {
      return configProvider.getPrefixCls();
    });
    var getOverlay = function getOverlay2() {
      var _a2, _b;
      var _props$title = props2.title, title = _props$title === void 0 ? filterEmpty((_a2 = slots.title) === null || _a2 === void 0 ? void 0 : _a2.call(slots)) : _props$title, _props$content = props2.content, content = _props$content === void 0 ? filterEmpty((_b = slots.content) === null || _b === void 0 ? void 0 : _b.call(slots)) : _props$content;
      var hasTitle = !!(Array.isArray(title) ? title.length : title);
      var hasContent = !!(Array.isArray(content) ? content.length : title);
      if (!hasTitle && !hasContent)
        return void 0;
      return createVNode(Fragment, null, [hasTitle && createVNode("div", {
        "class": "".concat(prefixCls2.value, "-title")
      }, [title]), createVNode("div", {
        "class": "".concat(prefixCls2.value, "-inner-content")
      }, [content])]);
    };
    return function() {
      return createVNode(Tooltip, _objectSpread2$2(_objectSpread2$2({}, omit$3(props2, ["title", "content"])), {}, {
        "prefixCls": prefixCls2.value,
        "ref": tooltipRef,
        "transitionName": getTransitionName$2(rootPrefixCls.value, "zoom-big", props2.transitionName)
      }), {
        title: getOverlay,
        default: slots.default
      });
    };
  }
});
var Popover$1 = withInstall$2(Popover);
function UnitNumber(_ref) {
  var prefixCls2 = _ref.prefixCls, value = _ref.value, current2 = _ref.current, _ref$offset = _ref.offset, offset3 = _ref$offset === void 0 ? 0 : _ref$offset;
  var style2;
  if (offset3) {
    style2 = {
      position: "absolute",
      top: "".concat(offset3, "00%"),
      left: 0
    };
  }
  return createVNode("p", {
    "style": style2,
    "class": classNames("".concat(prefixCls2, "-only-unit"), {
      current: current2
    })
  }, [value]);
}
function getOffset$2(start2, end, unit) {
  var index2 = start2;
  var offset3 = 0;
  while ((index2 + 10) % 10 !== end) {
    index2 += unit;
    offset3 += unit;
  }
  return offset3;
}
var SingleNumber = defineComponent({
  name: "SingleNumber",
  props: {
    prefixCls: String,
    value: String,
    count: Number
  },
  setup: function setup34(props2) {
    var originValue = computed(function() {
      return Number(props2.value);
    });
    var originCount = computed(function() {
      return Math.abs(props2.count);
    });
    var state = reactive({
      prevValue: originValue.value,
      prevCount: originCount.value
    });
    var onTransitionEnd = function onTransitionEnd2() {
      state.prevValue = originValue.value;
      state.prevCount = originCount.value;
    };
    var timeout = ref();
    watch(originValue, function() {
      clearTimeout(timeout.value);
      timeout.value = setTimeout(function() {
        onTransitionEnd();
      }, 1e3);
    }, {
      flush: "post"
    });
    onUnmounted(function() {
      clearTimeout(timeout.value);
    });
    return function() {
      var unitNodes;
      var offsetStyle = {};
      var value = originValue.value;
      if (state.prevValue === value || Number.isNaN(value) || Number.isNaN(state.prevValue)) {
        unitNodes = [UnitNumber(_extends$2(_extends$2({}, props2), {
          current: true
        }))];
        offsetStyle = {
          transition: "none"
        };
      } else {
        unitNodes = [];
        var end = value + 10;
        var unitNumberList = [];
        for (var index2 = value; index2 <= end; index2 += 1) {
          unitNumberList.push(index2);
        }
        var prevIndex = unitNumberList.findIndex(function(n2) {
          return n2 % 10 === state.prevValue;
        });
        unitNodes = unitNumberList.map(function(n2, index3) {
          var singleUnit = n2 % 10;
          return UnitNumber(_extends$2(_extends$2({}, props2), {
            value: singleUnit,
            offset: index3 - prevIndex,
            current: index3 === prevIndex
          }));
        });
        var unit = state.prevCount < originCount.value ? 1 : -1;
        offsetStyle = {
          transform: "translateY(".concat(-getOffset$2(state.prevValue, value, unit), "00%)")
        };
      }
      return createVNode("span", {
        "class": "".concat(props2.prefixCls, "-only"),
        "style": offsetStyle,
        "onTransitionend": function onTransitionend() {
          return onTransitionEnd();
        }
      }, [unitNodes]);
    };
  }
});
var __rest$B = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var scrollNumberProps = {
  prefixCls: String,
  count: PropTypes$1.any,
  component: String,
  title: PropTypes$1.any,
  show: Boolean
};
var ScrollNumber = defineComponent({
  name: "ScrollNumber",
  inheritAttrs: false,
  props: scrollNumberProps,
  setup: function setup35(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var _useConfigInject = useConfigInject("scroll-number", props2), prefixCls2 = _useConfigInject.prefixCls;
    return function() {
      var _a2;
      var _b = _extends$2(_extends$2({}, props2), attrs);
      _b.prefixCls;
      var count = _b.count, title = _b.title;
      _b.show;
      var _b$component = _b.component, Tag2 = _b$component === void 0 ? "sup" : _b$component, className = _b.class, style2 = _b.style, restProps = __rest$B(_b, ["prefixCls", "count", "title", "show", "component", "class", "style"]);
      var newProps = _extends$2(_extends$2({}, restProps), {
        style: style2,
        "data-show": props2.show,
        class: classNames(prefixCls2.value, className),
        title
      });
      var numberNodes = count;
      if (count && Number(count) % 1 === 0) {
        var numberList = String(count).split("");
        numberNodes = numberList.map(function(num, i2) {
          return createVNode(SingleNumber, {
            "prefixCls": prefixCls2.value,
            "count": Number(count),
            "value": num,
            "key": numberList.length - i2
          }, null);
        });
      }
      if (style2 && style2.borderColor) {
        newProps.style = _extends$2(_extends$2({}, style2), {
          boxShadow: "0 0 0 1px ".concat(style2.borderColor, " inset")
        });
      }
      var children = filterEmpty((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      if (children && children.length) {
        return cloneElement(children, {
          class: classNames("".concat(prefixCls2.value, "-custom-component"))
        }, false);
      }
      return createVNode(Tag2, newProps, {
        default: function _default7() {
          return [numberNodes];
        }
      });
    };
  }
});
function isPresetColor(color) {
  return PresetColorTypes.indexOf(color) !== -1;
}
var __rest$A = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var ribbonProps = function ribbonProps2() {
  return {
    prefix: String,
    color: {
      type: String
    },
    text: PropTypes$1.any,
    placement: {
      type: String,
      default: "end"
    }
  };
};
var Ribbon = defineComponent({
  name: "ABadgeRibbon",
  inheritAttrs: false,
  props: ribbonProps(),
  slots: ["text"],
  setup: function setup36(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var _useConfigInject = useConfigInject("ribbon", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var colorInPreset = computed(function() {
      return isPresetColor(props2.color);
    });
    var ribbonCls = computed(function() {
      var _ref2;
      return [prefixCls2.value, "".concat(prefixCls2.value, "-placement-").concat(props2.placement), (_ref2 = {}, _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-color-").concat(props2.color), colorInPreset.value), _ref2)];
    });
    return function() {
      var _a2, _b;
      var className = attrs.class, style2 = attrs.style, restAttrs = __rest$A(attrs, ["class", "style"]);
      var colorStyle = {};
      var cornerColorStyle = {};
      if (props2.color && !colorInPreset.value) {
        colorStyle.background = props2.color;
        cornerColorStyle.color = props2.color;
      }
      return createVNode("div", _objectSpread2$2({
        "class": "".concat(prefixCls2.value, "-wrapper")
      }, restAttrs), [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots), createVNode("div", {
        "class": [ribbonCls.value, className],
        "style": _extends$2(_extends$2({}, colorStyle), style2)
      }, [createVNode("span", {
        "class": "".concat(prefixCls2.value, "-text")
      }, [props2.text || ((_b = slots.text) === null || _b === void 0 ? void 0 : _b.call(slots))]), createVNode("div", {
        "class": "".concat(prefixCls2.value, "-corner"),
        "style": cornerColorStyle
      }, null)])]);
    };
  }
});
var isNumeric = function isNumeric2(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
var isNumeric$1 = isNumeric;
var badgeProps = function badgeProps2() {
  return {
    count: PropTypes$1.any,
    showZero: {
      type: Boolean,
      default: void 0
    },
    overflowCount: {
      type: Number,
      default: 99
    },
    dot: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    scrollNumberPrefixCls: String,
    status: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    color: String,
    text: PropTypes$1.any,
    offset: Array,
    numberStyle: {
      type: Object,
      default: void 0
    },
    title: String
  };
};
var Badge = defineComponent({
  name: "ABadge",
  Ribbon,
  inheritAttrs: false,
  props: badgeProps(),
  slots: ["text", "count"],
  setup: function setup37(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("badge", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var numberedDisplayCount = computed(function() {
      return props2.count > props2.overflowCount ? "".concat(props2.overflowCount, "+") : props2.count;
    });
    var hasStatus = computed(function() {
      return props2.status !== null && props2.status !== void 0 || props2.color !== null && props2.color !== void 0;
    });
    var isZero = computed(function() {
      return numberedDisplayCount.value === "0" || numberedDisplayCount.value === 0;
    });
    var showAsDot = computed(function() {
      return props2.dot && !isZero.value;
    });
    var mergedCount = computed(function() {
      return showAsDot.value ? "" : numberedDisplayCount.value;
    });
    var isHidden2 = computed(function() {
      var isEmpty = mergedCount.value === null || mergedCount.value === void 0 || mergedCount.value === "";
      return (isEmpty || isZero.value && !props2.showZero) && !showAsDot.value;
    });
    var livingCount = ref(props2.count);
    var displayCount = ref(mergedCount.value);
    var isDotRef = ref(showAsDot.value);
    watch([function() {
      return props2.count;
    }, mergedCount, showAsDot], function() {
      if (!isHidden2.value) {
        livingCount.value = props2.count;
        displayCount.value = mergedCount.value;
        isDotRef.value = showAsDot.value;
      }
    }, {
      immediate: true
    });
    var statusCls = computed(function() {
      var _ref2;
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-status-dot"), hasStatus.value), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-status-").concat(props2.status), !!props2.status), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-status-").concat(props2.color), isPresetColor(props2.color)), _ref2;
    });
    var statusStyle = computed(function() {
      if (props2.color && !isPresetColor(props2.color)) {
        return {
          background: props2.color
        };
      } else {
        return {};
      }
    });
    var scrollNumberCls = computed(function() {
      var _ref3;
      return _ref3 = {}, _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-dot"), isDotRef.value), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-count"), !isDotRef.value), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-count-sm"), props2.size === "small"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-multiple-words"), !isDotRef.value && displayCount.value && displayCount.value.toString().length > 1), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-status-").concat(props2.status), !!props2.status), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-status-").concat(props2.color), isPresetColor(props2.color)), _ref3;
    });
    return function() {
      var _classNames;
      var _a2, _b;
      var offset3 = props2.offset, title = props2.title, color = props2.color;
      var style2 = attrs.style;
      var text = getPropsSlot(slots, props2, "text");
      var pre = prefixCls2.value;
      var count = livingCount.value;
      var children = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      children = children.length ? children : null;
      var visible = !!(!isHidden2.value || slots.count);
      var mergedStyle = function() {
        if (!offset3) {
          return _extends$2({}, style2);
        }
        var offsetStyle = {
          marginTop: isNumeric$1(offset3[1]) ? "".concat(offset3[1], "px") : offset3[1]
        };
        if (direction2.value === "rtl") {
          offsetStyle.left = "".concat(parseInt(offset3[0], 10), "px");
        } else {
          offsetStyle.right = "".concat(-parseInt(offset3[0], 10), "px");
        }
        return _extends$2(_extends$2({}, offsetStyle), style2);
      }();
      var titleNode = title !== null && title !== void 0 ? title : typeof count === "string" || typeof count === "number" ? count : void 0;
      var statusTextNode = visible || !text ? null : createVNode("span", {
        "class": "".concat(pre, "-status-text")
      }, [text]);
      var displayNode = _typeof$2(count) === "object" || count === void 0 && slots.count ? cloneElement(count !== null && count !== void 0 ? count : (_b = slots.count) === null || _b === void 0 ? void 0 : _b.call(slots), {
        style: mergedStyle
      }, false) : null;
      var badgeClassName = classNames(pre, (_classNames = {}, _defineProperty$R(_classNames, "".concat(pre, "-status"), hasStatus.value), _defineProperty$R(_classNames, "".concat(pre, "-not-a-wrapper"), !children), _defineProperty$R(_classNames, "".concat(pre, "-rtl"), direction2.value === "rtl"), _classNames), attrs.class);
      if (!children && hasStatus.value) {
        var statusTextColor = mergedStyle.color;
        return createVNode("span", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
          "class": badgeClassName,
          "style": mergedStyle
        }), [createVNode("span", {
          "class": statusCls.value,
          "style": statusStyle.value
        }, null), createVNode("span", {
          "style": {
            color: statusTextColor
          },
          "class": "".concat(pre, "-status-text")
        }, [text])]);
      }
      var transitionProps = getTransitionProps(children ? "".concat(pre, "-zoom") : "", {
        appear: false
      });
      var scrollNumberStyle = _extends$2(_extends$2({}, mergedStyle), props2.numberStyle);
      if (color && !isPresetColor(color)) {
        scrollNumberStyle = scrollNumberStyle || {};
        scrollNumberStyle.background = color;
      }
      return createVNode("span", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "class": badgeClassName
      }), [children, createVNode(Transition, transitionProps, {
        default: function _default7() {
          return [withDirectives(createVNode(ScrollNumber, {
            "prefixCls": props2.scrollNumberPrefixCls,
            "show": visible,
            "class": scrollNumberCls.value,
            "count": displayCount.value,
            "title": titleNode,
            "style": scrollNumberStyle,
            "key": "scrollNumber"
          }, {
            default: function _default8() {
              return [displayNode];
            }
          }), [[vShow, visible]])];
        }
      }), statusTextNode]);
    };
  }
});
Badge.install = function(app) {
  app.component(Badge.name, Badge);
  app.component(Ribbon.name, Ribbon);
  return app;
};
var autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements$1 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topCenter: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomCenter: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  }
};
var placements$2 = placements$1;
var __rest$z = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var Dropdown$3 = defineComponent({
  props: {
    minOverlayWidthMatchTrigger: {
      type: Boolean,
      default: void 0
    },
    arrow: {
      type: Boolean,
      default: false
    },
    prefixCls: PropTypes$1.string.def("rc-dropdown"),
    transitionName: String,
    overlayClassName: PropTypes$1.string.def(""),
    openClassName: String,
    animation: PropTypes$1.any,
    align: PropTypes$1.object,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    placement: PropTypes$1.string.def("bottomLeft"),
    overlay: PropTypes$1.any,
    trigger: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]).def("hover"),
    alignPoint: {
      type: Boolean,
      default: void 0
    },
    showAction: PropTypes$1.array,
    hideAction: PropTypes$1.array,
    getPopupContainer: Function,
    visible: {
      type: Boolean,
      default: void 0
    },
    defaultVisible: {
      type: Boolean,
      default: false
    },
    mouseEnterDelay: PropTypes$1.number.def(0.15),
    mouseLeaveDelay: PropTypes$1.number.def(0.1)
  },
  emits: ["visibleChange", "overlayClick"],
  slots: ["overlay"],
  setup: function setup38(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    var triggerVisible = ref(!!props2.visible);
    watch(function() {
      return props2.visible;
    }, function(val) {
      if (val !== void 0) {
        triggerVisible.value = val;
      }
    });
    var triggerRef = ref();
    expose({
      triggerRef
    });
    var onClick2 = function onClick3(e2) {
      if (props2.visible === void 0) {
        triggerVisible.value = false;
      }
      emit("overlayClick", e2);
    };
    var onVisibleChange = function onVisibleChange2(visible) {
      if (props2.visible === void 0) {
        triggerVisible.value = visible;
      }
      emit("visibleChange", visible);
    };
    var getMenuElement = function getMenuElement2() {
      var _a2;
      var overlayElement = (_a2 = slots.overlay) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      var extraOverlayProps = {
        prefixCls: "".concat(props2.prefixCls, "-menu"),
        onClick: onClick2,
        getPopupContainer: function getPopupContainer() {
          return triggerRef.value.getPopupDomNode();
        }
      };
      return createVNode(Fragment, null, [props2.arrow && createVNode("div", {
        "class": "".concat(props2.prefixCls, "-arrow")
      }, null), cloneElement(overlayElement, extraOverlayProps, false)]);
    };
    var minOverlayWidthMatchTrigger = computed(function() {
      var _props$minOverlayWidt = props2.minOverlayWidthMatchTrigger, matchTrigger = _props$minOverlayWidt === void 0 ? !props2.alignPoint : _props$minOverlayWidt;
      return matchTrigger;
    });
    var renderChildren2 = function renderChildren3() {
      var _a2;
      var children = (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      return triggerVisible.value && children ? cloneElement(children[0], {
        class: props2.openClassName || "".concat(props2.prefixCls, "-open")
      }, false) : children;
    };
    var triggerHideAction = computed(function() {
      if (!props2.hideAction && props2.trigger.indexOf("contextmenu") !== -1) {
        return ["click"];
      }
      return props2.hideAction;
    });
    return function() {
      var prefixCls2 = props2.prefixCls, arrow = props2.arrow, showAction = props2.showAction, overlayStyle = props2.overlayStyle, trigger2 = props2.trigger, placement = props2.placement, align = props2.align, getPopupContainer = props2.getPopupContainer, transitionName2 = props2.transitionName, animation = props2.animation, overlayClassName = props2.overlayClassName, otherProps = __rest$z(props2, ["prefixCls", "arrow", "showAction", "overlayStyle", "trigger", "placement", "align", "getPopupContainer", "transitionName", "animation", "overlayClassName"]);
      return createVNode(Trigger, _objectSpread2$2(_objectSpread2$2({}, otherProps), {}, {
        "prefixCls": prefixCls2,
        "ref": triggerRef,
        "popupClassName": classNames(overlayClassName, _defineProperty$R({}, "".concat(prefixCls2, "-show-arrow"), arrow)),
        "popupStyle": overlayStyle,
        "builtinPlacements": placements$2,
        "action": trigger2,
        "showAction": showAction,
        "hideAction": triggerHideAction.value || [],
        "popupPlacement": placement,
        "popupAlign": align,
        "popupTransitionName": transitionName2,
        "popupAnimation": animation,
        "popupVisible": triggerVisible.value,
        "stretch": minOverlayWidthMatchTrigger.value ? "minWidth" : "",
        "onPopupVisibleChange": onVisibleChange,
        "getPopupContainer": getPopupContainer
      }), {
        popup: getMenuElement,
        default: renderChildren2
      });
    };
  }
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: "transitionstart",
    WebkitTransition: "webkitTransitionStart",
    MozTransition: "mozTransitionStart",
    OTransition: "oTransitionStart",
    msTransition: "MSTransitionStart"
  },
  animationstart: {
    animation: "animationstart",
    WebkitAnimation: "webkitAnimationStart",
    MozAnimation: "mozAnimationStart",
    OAnimation: "oAnimationStart",
    msAnimation: "MSAnimationStart"
  }
};
var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: "transitionend",
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "mozTransitionEnd",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd"
  },
  animationend: {
    animation: "animationend",
    WebkitAnimation: "webkitAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    OAnimation: "oAnimationEnd",
    msAnimation: "MSAnimationEnd"
  }
};
var startEvents = [];
var endEvents = [];
function detectEvents() {
  var testEl = document.createElement("div");
  var style2 = testEl.style;
  if (!("AnimationEvent" in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }
  if (!("TransitionEvent" in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }
  function process2(EVENT_NAME_MAP, events2) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style2) {
            events2.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }
  process2(START_EVENT_NAME_MAP, startEvents);
  process2(END_EVENT_NAME_MAP, endEvents);
}
if (typeof window !== "undefined" && typeof document !== "undefined") {
  detectEvents();
}
function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}
function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}
var TransitionEvents = {
  startEvents,
  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function(startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function(startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },
  endEvents,
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function(endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function(endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};
var TransitionEvents$1 = TransitionEvents;
var styleForPesudo;
function isHidden(element) {
  return !element || element.offsetParent === null;
}
function isNotGrey(color) {
  var match2 = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
  if (match2 && match2[1] && match2[2] && match2[3]) {
    return !(match2[1] === match2[2] && match2[2] === match2[3]);
  }
  return true;
}
var Wave = defineComponent({
  name: "Wave",
  props: {
    insertExtraNode: Boolean,
    disabled: Boolean
  },
  setup: function setup39(props2, _ref) {
    var slots = _ref.slots, expose = _ref.expose;
    var instance2 = getCurrentInstance();
    var _useConfigInject = useConfigInject("", props2), csp = _useConfigInject.csp, prefixCls2 = _useConfigInject.prefixCls;
    expose({
      csp
    });
    var eventIns = null;
    var clickWaveTimeoutId = null;
    var animationStartId = null;
    var animationStart = false;
    var extraNode = null;
    var isUnmounted = false;
    var onTransitionStart = function onTransitionStart2(e2) {
      if (isUnmounted)
        return;
      var node = findDOMNode(instance2);
      if (!e2 || e2.target !== node) {
        return;
      }
      if (!animationStart) {
        resetEffect(node);
      }
    };
    var onTransitionEnd = function onTransitionEnd2(e2) {
      if (!e2 || e2.animationName !== "fadeEffect") {
        return;
      }
      resetEffect(e2.target);
    };
    var getAttributeName = function getAttributeName2() {
      var insertExtraNode = props2.insertExtraNode;
      return insertExtraNode ? "".concat(prefixCls2.value, "-click-animating") : "".concat(prefixCls2.value, "-click-animating-without-extra-node");
    };
    var onClick2 = function onClick3(node, waveColor) {
      var _a2;
      var insertExtraNode = props2.insertExtraNode, disabled = props2.disabled;
      if (disabled || !node || isHidden(node) || node.className.indexOf("-leave") >= 0) {
        return;
      }
      extraNode = document.createElement("div");
      extraNode.className = "".concat(prefixCls2.value, "-click-animating-node");
      var attributeName = getAttributeName();
      node.removeAttribute(attributeName);
      node.setAttribute(attributeName, "true");
      styleForPesudo = styleForPesudo || document.createElement("style");
      if (waveColor && waveColor !== "#ffffff" && waveColor !== "rgb(255, 255, 255)" && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && waveColor !== "transparent") {
        if ((_a2 = csp.value) === null || _a2 === void 0 ? void 0 : _a2.nonce) {
          styleForPesudo.nonce = csp.value.nonce;
        }
        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "\n        [".concat(prefixCls2.value, "-click-animating-without-extra-node='true']::after, .").concat(prefixCls2.value, "-click-animating-node {\n          --antd-wave-shadow-color: ").concat(waveColor, ";\n        }");
        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }
      if (insertExtraNode) {
        node.appendChild(extraNode);
      }
      TransitionEvents$1.addStartEventListener(node, onTransitionStart);
      TransitionEvents$1.addEndEventListener(node, onTransitionEnd);
    };
    var resetEffect = function resetEffect2(node) {
      if (!node || node === extraNode || !(node instanceof Element)) {
        return;
      }
      var insertExtraNode = props2.insertExtraNode;
      var attributeName = getAttributeName();
      node.setAttribute(attributeName, "false");
      if (styleForPesudo) {
        styleForPesudo.innerHTML = "";
      }
      if (insertExtraNode && extraNode && node.contains(extraNode)) {
        node.removeChild(extraNode);
      }
      TransitionEvents$1.removeStartEventListener(node, onTransitionStart);
      TransitionEvents$1.removeEndEventListener(node, onTransitionEnd);
    };
    var bindAnimationEvent = function bindAnimationEvent2(node) {
      if (!node || !node.getAttribute || node.getAttribute("disabled") || node.className.indexOf("disabled") >= 0) {
        return;
      }
      var newClick = function newClick2(e2) {
        if (e2.target.tagName === "INPUT" || isHidden(e2.target)) {
          return;
        }
        resetEffect(node);
        var waveColor = getComputedStyle(node).getPropertyValue("border-top-color") || getComputedStyle(node).getPropertyValue("border-color") || getComputedStyle(node).getPropertyValue("background-color");
        clickWaveTimeoutId = setTimeout(function() {
          return onClick2(node, waveColor);
        }, 0);
        wrapperRaf.cancel(animationStartId);
        animationStart = true;
        animationStartId = wrapperRaf(function() {
          animationStart = false;
        }, 10);
      };
      node.addEventListener("click", newClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener("click", newClick, true);
        }
      };
    };
    onMounted(function() {
      nextTick(function() {
        var node = findDOMNode(instance2);
        if (node.nodeType !== 1) {
          return;
        }
        eventIns = bindAnimationEvent(node);
      });
    });
    onBeforeUnmount(function() {
      if (eventIns) {
        eventIns.cancel();
      }
      clearTimeout(clickWaveTimeoutId);
      isUnmounted = true;
    });
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)[0];
    };
  }
});
function convertLegacyProps(type4) {
  if (type4 === "danger") {
    return {
      danger: true
    };
  }
  return {
    type: type4
  };
}
var buttonProps = function buttonProps2() {
  return {
    prefixCls: String,
    type: String,
    htmlType: {
      type: String,
      default: "button"
    },
    shape: {
      type: String
    },
    size: {
      type: String
    },
    loading: {
      type: [Boolean, Object],
      default: function _default7() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    ghost: {
      type: Boolean,
      default: void 0
    },
    block: {
      type: Boolean,
      default: void 0
    },
    danger: {
      type: Boolean,
      default: void 0
    },
    icon: PropTypes$1.any,
    href: String,
    target: String,
    title: String,
    onClick: {
      type: Function
    },
    onMousedown: {
      type: Function
    }
  };
};
var buttonTypes = buttonProps;
var getCollapsedWidth = function getCollapsedWidth2(node) {
  if (node) {
    node.style.width = "0px";
    node.style.opacity = "0";
    node.style.transform = "scale(0)";
  }
};
var getRealWidth = function getRealWidth2(node) {
  nextTick(function() {
    if (node) {
      node.style.width = "".concat(node.scrollWidth, "px");
      node.style.opacity = "1";
      node.style.transform = "scale(1)";
    }
  });
};
var resetStyle = function resetStyle2(node) {
  if (node && node.style) {
    node.style.width = null;
    node.style.opacity = null;
    node.style.transform = null;
  }
};
var LoadingIcon = defineComponent({
  name: "LoadingIcon",
  props: {
    prefixCls: String,
    loading: [Boolean, Object],
    existIcon: Boolean
  },
  setup: function setup40(props2) {
    return function() {
      var existIcon = props2.existIcon, prefixCls2 = props2.prefixCls, loading = props2.loading;
      if (existIcon) {
        return createVNode("span", {
          "class": "".concat(prefixCls2, "-loading-icon")
        }, [createVNode(LoadingOutlined$1, null, null)]);
      }
      var visible = !!loading;
      return createVNode(Transition$1, {
        "name": "".concat(prefixCls2, "-loading-icon-motion"),
        "onBeforeEnter": getCollapsedWidth,
        "onEnter": getRealWidth,
        "onAfterEnter": resetStyle,
        "onBeforeLeave": getRealWidth,
        "onLeave": function onLeave(node) {
          setTimeout(function() {
            getCollapsedWidth(node);
          });
        },
        "onAfterLeave": resetStyle
      }, {
        default: function _default7() {
          return [visible ? createVNode("span", {
            "class": "".concat(prefixCls2, "-loading-icon")
          }, [createVNode(LoadingOutlined$1, null, null)]) : null];
        }
      });
    };
  }
});
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isUnborderedButtonType(type4) {
  return type4 === "text" || type4 === "link";
}
var Button$2 = defineComponent({
  name: "AButton",
  inheritAttrs: false,
  __ANT_BUTTON: true,
  props: initDefaultProps$1(buttonTypes(), {
    type: "default"
  }),
  slots: ["icon"],
  setup: function setup41(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var _useConfigInject = useConfigInject("btn", props2), prefixCls2 = _useConfigInject.prefixCls, autoInsertSpaceInButton = _useConfigInject.autoInsertSpaceInButton, direction2 = _useConfigInject.direction, size = _useConfigInject.size;
    var buttonNodeRef = ref(null);
    var delayTimeoutRef = ref(void 0);
    var isNeedInserted = false;
    var innerLoading = ref(false);
    var hasTwoCNChar = ref(false);
    var autoInsertSpace = computed(function() {
      return autoInsertSpaceInButton.value !== false;
    });
    var loadingOrDelay = computed(function() {
      return _typeof$2(props2.loading) === "object" && props2.loading.delay ? props2.loading.delay || true : !!props2.loading;
    });
    watch(loadingOrDelay, function(val) {
      clearTimeout(delayTimeoutRef.value);
      if (typeof loadingOrDelay.value === "number") {
        delayTimeoutRef.value = setTimeout(function() {
          innerLoading.value = val;
        }, loadingOrDelay.value);
      } else {
        innerLoading.value = val;
      }
    }, {
      immediate: true
    });
    var classes = computed(function() {
      var _ref2;
      var type4 = props2.type, _props$shape = props2.shape, shape = _props$shape === void 0 ? "default" : _props$shape, ghost = props2.ghost, block = props2.block, danger = props2.danger;
      var pre = prefixCls2.value;
      var sizeClassNameMap = {
        large: "lg",
        small: "sm",
        middle: void 0
      };
      var sizeFullname = size.value;
      var sizeCls = sizeFullname ? sizeClassNameMap[sizeFullname] || "" : "";
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(pre), true), _defineProperty$R(_ref2, "".concat(pre, "-").concat(type4), type4), _defineProperty$R(_ref2, "".concat(pre, "-").concat(shape), shape !== "default" && shape), _defineProperty$R(_ref2, "".concat(pre, "-").concat(sizeCls), sizeCls), _defineProperty$R(_ref2, "".concat(pre, "-loading"), innerLoading.value), _defineProperty$R(_ref2, "".concat(pre, "-background-ghost"), ghost && !isUnborderedButtonType(type4)), _defineProperty$R(_ref2, "".concat(pre, "-two-chinese-chars"), hasTwoCNChar.value && autoInsertSpace.value), _defineProperty$R(_ref2, "".concat(pre, "-block"), block), _defineProperty$R(_ref2, "".concat(pre, "-dangerous"), !!danger), _defineProperty$R(_ref2, "".concat(pre, "-rtl"), direction2.value === "rtl"), _ref2;
    });
    var fixTwoCNChar = function fixTwoCNChar2() {
      var node = buttonNodeRef.value;
      if (!node || autoInsertSpaceInButton.value === false) {
        return;
      }
      var buttonText = node.textContent;
      if (isNeedInserted && isTwoCNChar(buttonText)) {
        if (!hasTwoCNChar.value) {
          hasTwoCNChar.value = true;
        }
      } else if (hasTwoCNChar.value) {
        hasTwoCNChar.value = false;
      }
    };
    var handleClick = function handleClick2(event) {
      if (innerLoading.value || props2.disabled) {
        event.preventDefault();
        return;
      }
      emit("click", event);
    };
    var insertSpace = function insertSpace2(child, needInserted) {
      var SPACE = needInserted ? " " : "";
      if (child.type === Text) {
        var text = child.children.trim();
        if (isTwoCNChar(text)) {
          text = text.split("").join(SPACE);
        }
        return createVNode("span", null, [text]);
      }
      return child;
    };
    watchEffect(function() {
      devWarning(!(props2.ghost && isUnborderedButtonType(props2.type)), "Button", "`link` or `text` button can't be a `ghost` button.");
    });
    onMounted(fixTwoCNChar);
    onUpdated(fixTwoCNChar);
    onBeforeUnmount(function() {
      delayTimeoutRef.value && clearTimeout(delayTimeoutRef.value);
    });
    return function() {
      var _a2, _b;
      var _props$icon = props2.icon, icon = _props$icon === void 0 ? (_a2 = slots.icon) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$icon;
      var children = flattenChildren((_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots));
      isNeedInserted = children.length === 1 && !icon && !isUnborderedButtonType(props2.type);
      var type4 = props2.type, htmlType = props2.htmlType, disabled = props2.disabled, href = props2.href, title = props2.title, target = props2.target, onMousedown2 = props2.onMousedown;
      var iconType = innerLoading.value ? "loading" : icon;
      var buttonProps3 = _extends$2(_extends$2({}, attrs), {
        title,
        disabled,
        class: [classes.value, attrs.class, _defineProperty$R({}, "".concat(prefixCls2.value, "-icon-only"), children.length === 0 && !!iconType)],
        onClick: handleClick,
        onMousedown: onMousedown2
      });
      if (!disabled) {
        delete buttonProps3.disabled;
      }
      var iconNode = icon && !innerLoading.value ? icon : createVNode(LoadingIcon, {
        "existIcon": !!icon,
        "prefixCls": prefixCls2.value,
        "loading": !!innerLoading.value
      }, null);
      var kids = children.map(function(child) {
        return insertSpace(child, isNeedInserted && autoInsertSpace.value);
      });
      if (href !== void 0) {
        return createVNode("a", _objectSpread2$2(_objectSpread2$2({}, buttonProps3), {}, {
          "href": href,
          "target": target,
          "ref": buttonNodeRef
        }), [iconNode, kids]);
      }
      var buttonNode = createVNode("button", _objectSpread2$2(_objectSpread2$2({}, buttonProps3), {}, {
        "ref": buttonNodeRef,
        "type": htmlType
      }), [iconNode, kids]);
      if (isUnborderedButtonType(type4)) {
        return buttonNode;
      }
      return createVNode(Wave, {
        "ref": "wave",
        "disabled": !!innerLoading.value
      }, {
        default: function _default7() {
          return [buttonNode];
        }
      });
    };
  }
});
function _defineProperties(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var UnreachableException = /* @__PURE__ */ _createClass(function UnreachableException2(value) {
  _classCallCheck(this, UnreachableException2);
  this.error = new Error("unreachable case: ".concat(JSON.stringify(value)));
});
var buttonGroupProps = function buttonGroupProps2() {
  return {
    prefixCls: String,
    size: {
      type: String
    }
  };
};
var ButtonGroup$1 = defineComponent({
  name: "AButtonGroup",
  props: buttonGroupProps(),
  setup: function setup42(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("btn-group", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var classes = computed(function() {
      var _ref2;
      var size = props2.size;
      var sizeCls = "";
      switch (size) {
        case "large":
          sizeCls = "lg";
          break;
        case "small":
          sizeCls = "sm";
          break;
        case "middle":
        case void 0:
          break;
        default:
          console.warn(new UnreachableException(size).error);
      }
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(prefixCls2.value), true), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-").concat(sizeCls), sizeCls), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _ref2;
    });
    return function() {
      var _a2;
      return createVNode("div", {
        "class": classes.value
      }, [flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots))]);
    };
  }
});
Button$2.Group = ButtonGroup$1;
Button$2.install = function(app) {
  app.component(Button$2.name, Button$2);
  app.component(ButtonGroup$1.name, ButtonGroup$1);
  return app;
};
var dropdownProps = function dropdownProps2() {
  return {
    arrow: {
      type: [Boolean, Object],
      default: void 0
    },
    trigger: {
      type: [Array, String]
    },
    overlay: PropTypes$1.any,
    visible: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    align: {
      type: Object
    },
    getPopupContainer: Function,
    prefixCls: String,
    transitionName: String,
    placement: String,
    overlayClassName: String,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    forceRender: {
      type: Boolean,
      default: void 0
    },
    mouseEnterDelay: Number,
    mouseLeaveDelay: Number,
    openClassName: String,
    minOverlayWidthMatchTrigger: {
      type: Boolean,
      default: void 0
    },
    destroyPopupOnHide: {
      type: Boolean,
      default: void 0
    },
    onVisibleChange: {
      type: Function
    },
    "onUpdate:visible": {
      type: Function
    }
  };
};
var buttonTypesProps = buttonTypes();
var dropdownButtonProps = function dropdownButtonProps2() {
  return _extends$2(_extends$2({}, dropdownProps()), {
    type: buttonTypesProps.type,
    size: String,
    htmlType: buttonTypesProps.htmlType,
    href: String,
    disabled: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    icon: PropTypes$1.any,
    title: String,
    loading: buttonTypesProps.loading,
    onClick: {
      type: Function
    }
  });
};
var EllipsisOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };
var EllipsisOutlinedSvg = EllipsisOutlined$2;
function _objectSpread$y(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$z(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$z(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var EllipsisOutlined = function EllipsisOutlined2(props2, context2) {
  var p2 = _objectSpread$y({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$y({}, p2, {
    "icon": EllipsisOutlinedSvg
  }), null);
};
EllipsisOutlined.displayName = "EllipsisOutlined";
EllipsisOutlined.inheritAttrs = false;
var EllipsisOutlined$1 = EllipsisOutlined;
var __rest$y = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var ButtonGroup = Button$2.Group;
var DropdownButton = defineComponent({
  name: "ADropdownButton",
  inheritAttrs: false,
  __ANT_BUTTON: true,
  props: initDefaultProps$1(dropdownButtonProps(), {
    trigger: "hover",
    placement: "bottomRight",
    type: "default"
  }),
  slots: ["icon", "leftButton", "rightButton", "overlay"],
  setup: function setup43(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var handleVisibleChange = function handleVisibleChange2(val) {
      emit("update:visible", val);
      emit("visibleChange", val);
    };
    var _useConfigInject = useConfigInject("dropdown-button", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer;
    return function() {
      var _a2, _b;
      var _c = _extends$2(_extends$2({}, props2), attrs), _c$type = _c.type, type4 = _c$type === void 0 ? "default" : _c$type, disabled = _c.disabled, loading = _c.loading, htmlType = _c.htmlType, _c$class = _c.class, className = _c$class === void 0 ? "" : _c$class, _c$overlay = _c.overlay, _overlay = _c$overlay === void 0 ? (_a2 = slots.overlay) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _c$overlay, trigger2 = _c.trigger, align = _c.align, visible = _c.visible;
      _c.onVisibleChange;
      var _c$placement = _c.placement, placement = _c$placement === void 0 ? direction2.value === "rtl" ? "bottomLeft" : "bottomRight" : _c$placement, href = _c.href, title = _c.title, _c$icon = _c.icon, icon = _c$icon === void 0 ? ((_b = slots.icon) === null || _b === void 0 ? void 0 : _b.call(slots)) || createVNode(EllipsisOutlined$1, null, null) : _c$icon, mouseEnterDelay = _c.mouseEnterDelay, mouseLeaveDelay = _c.mouseLeaveDelay, overlayClassName = _c.overlayClassName, overlayStyle = _c.overlayStyle, destroyPopupOnHide = _c.destroyPopupOnHide, onClick2 = _c.onClick;
      _c["onUpdate:visible"];
      var restProps = __rest$y(_c, ["type", "disabled", "loading", "htmlType", "class", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "href", "title", "icon", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "onClick", "onUpdate:visible"]);
      var dropdownProps3 = {
        align,
        disabled,
        trigger: disabled ? [] : trigger2,
        placement,
        getPopupContainer: getPopupContainer.value,
        onVisibleChange: handleVisibleChange,
        mouseEnterDelay,
        mouseLeaveDelay,
        visible,
        overlayClassName,
        overlayStyle,
        destroyPopupOnHide
      };
      var leftButton = createVNode(Button$2, {
        "type": type4,
        "disabled": disabled,
        "loading": loading,
        "onClick": onClick2,
        "htmlType": htmlType,
        "href": href,
        "title": title
      }, {
        default: slots.default
      });
      var rightButton = createVNode(Button$2, {
        "type": type4,
        "icon": icon
      }, null);
      return createVNode(ButtonGroup, _objectSpread2$2(_objectSpread2$2({}, restProps), {}, {
        "class": classNames(prefixCls2.value, className)
      }), {
        default: function _default7() {
          return [slots.leftButton ? slots.leftButton({
            button: leftButton
          }) : leftButton, createVNode(Dropdown$2, dropdownProps3, {
            default: function _default8() {
              return [slots.rightButton ? slots.rightButton({
                button: rightButton
              }) : rightButton];
            },
            overlay: function overlay() {
              return _overlay;
            }
          })];
        }
      });
    };
  }
});
var RightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlinedSvg = RightOutlined$2;
function _objectSpread$x(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$y(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$y(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var RightOutlined = function RightOutlined2(props2, context2) {
  var p2 = _objectSpread$x({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$x({}, p2, {
    "icon": RightOutlinedSvg
  }), null);
};
RightOutlined.displayName = "RightOutlined";
RightOutlined.inheritAttrs = false;
var RightOutlined$1 = RightOutlined;
var Dropdown$1 = defineComponent({
  name: "ADropdown",
  inheritAttrs: false,
  props: initDefaultProps$1(dropdownProps(), {
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
    placement: "bottomLeft",
    trigger: "hover"
  }),
  slots: ["overlay"],
  setup: function setup44(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var _useConfigInject = useConfigInject("dropdown", props2), prefixCls2 = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer;
    var transitionName2 = computed(function() {
      var _props$placement = props2.placement, placement2 = _props$placement === void 0 ? "" : _props$placement, transitionName3 = props2.transitionName;
      if (transitionName3 !== void 0) {
        return transitionName3;
      }
      if (placement2.indexOf("top") >= 0) {
        return "".concat(rootPrefixCls.value, "-slide-down");
      }
      return "".concat(rootPrefixCls.value, "-slide-up");
    });
    var renderOverlay = function renderOverlay2() {
      var _a2, _b, _c;
      var overlay = props2.overlay || ((_a2 = slots.overlay) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      var overlayNode = Array.isArray(overlay) ? overlay[0] : overlay;
      if (!overlayNode)
        return null;
      var overlayProps = overlayNode.props || {};
      devWarning(!overlayProps.mode || overlayProps.mode === "vertical", "Dropdown", 'mode="'.concat(overlayProps.mode, `" is not supported for Dropdown's Menu.`));
      var _overlayProps$selecta = overlayProps.selectable, selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta, _overlayProps$expandI = overlayProps.expandIcon, expandIcon = _overlayProps$expandI === void 0 ? (_c = (_b = overlayNode.children) === null || _b === void 0 ? void 0 : _b.expandIcon) === null || _c === void 0 ? void 0 : _c.call(_b) : _overlayProps$expandI;
      var overlayNodeExpandIcon = typeof expandIcon !== "undefined" && isValidElement(expandIcon) ? expandIcon : createVNode("span", {
        "class": "".concat(prefixCls2.value, "-menu-submenu-arrow")
      }, [createVNode(RightOutlined$1, {
        "class": "".concat(prefixCls2.value, "-menu-submenu-arrow-icon")
      }, null)]);
      var fixedModeOverlay = isValidElement(overlayNode) ? cloneElement(overlayNode, {
        mode: "vertical",
        selectable,
        expandIcon: function expandIcon2() {
          return overlayNodeExpandIcon;
        }
      }) : overlayNode;
      return fixedModeOverlay;
    };
    var placement = computed(function() {
      var placement2 = props2.placement;
      if (!placement2) {
        return direction2.value === "rtl" ? "bottomRight" : "bottomLeft";
      }
      if (placement2.includes("Center")) {
        var newPlacement = placement2.slice(0, placement2.indexOf("Center"));
        devWarning(!placement2.includes("Center"), "Dropdown", "You are using '".concat(placement2, "' placement in Dropdown, which is deprecated. Try to use '").concat(newPlacement, "' instead."));
        return newPlacement;
      }
      return placement2;
    });
    var handleVisibleChange = function handleVisibleChange2(val) {
      emit("update:visible", val);
      emit("visibleChange", val);
    };
    return function() {
      var _a2, _b;
      var arrow = props2.arrow, trigger2 = props2.trigger, disabled = props2.disabled, overlayClassName = props2.overlayClassName;
      var child = (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)[0];
      var dropdownTrigger = cloneElement(child, _extends$2({
        class: classNames((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.class, _defineProperty$R({}, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), "".concat(prefixCls2.value, "-trigger"))
      }, disabled ? {
        disabled
      } : {}));
      var overlayClassNameCustomized = classNames(overlayClassName, _defineProperty$R({}, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"));
      var triggerActions = disabled ? [] : trigger2;
      var alignPoint2;
      if (triggerActions && triggerActions.indexOf("contextmenu") !== -1) {
        alignPoint2 = true;
      }
      var builtinPlacements = getPlacements({
        arrowPointAtCenter: _typeof$2(arrow) === "object" && arrow.pointAtCenter,
        autoAdjustOverflow: true
      });
      var dropdownProps3 = omit$3(_extends$2(_extends$2(_extends$2({}, props2), attrs), {
        builtinPlacements,
        overlayClassName: overlayClassNameCustomized,
        arrow,
        alignPoint: alignPoint2,
        prefixCls: prefixCls2.value,
        getPopupContainer: getPopupContainer.value,
        transitionName: transitionName2.value,
        trigger: triggerActions,
        onVisibleChange: handleVisibleChange,
        placement: placement.value
      }), ["overlay", "onUpdate:visible"]);
      return createVNode(Dropdown$3, dropdownProps3, {
        default: function _default7() {
          return [dropdownTrigger];
        },
        overlay: renderOverlay
      });
    };
  }
});
Dropdown$1.Button = DropdownButton;
var Dropdown$2 = Dropdown$1;
function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
  if (ret !== void 0) {
    return !!ret;
  }
  if (objA === objB) {
    return true;
  }
  if (_typeof$2(objA) !== "object" || !objA || _typeof$2(objB) !== "object" || !objB) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var idx = 0; idx < keysA.length; idx++) {
    var key2 = keysA[idx];
    if (!bHasOwnProperty(key2)) {
      return false;
    }
    var valueA = objA[key2];
    var valueB = objB[key2];
    ret = compare ? compare.call(compareContext, valueA, valueB, key2) : void 0;
    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }
  return true;
}
function shallowequal(value, other, customizer, thisArg) {
  return shallowEqual(toRaw(value), toRaw(other), customizer, thisArg);
}
var MenuContextKey = Symbol("menuContextKey");
var useProvideMenu = function useProvideMenu2(props2) {
  provide(MenuContextKey, props2);
};
var useInjectMenu = function useInjectMenu2() {
  return inject(MenuContextKey);
};
var ForceRenderKey = Symbol("ForceRenderKey");
var useProvideForceRender = function useProvideForceRender2(forceRender) {
  provide(ForceRenderKey, forceRender);
};
var useInjectForceRender = function useInjectForceRender2() {
  return inject(ForceRenderKey, false);
};
var MenuFirstLevelContextKey = Symbol("menuFirstLevelContextKey");
var useProvideFirstLevel = function useProvideFirstLevel2(firstLevel) {
  provide(MenuFirstLevelContextKey, firstLevel);
};
var useInjectFirstLevel = function useInjectFirstLevel2() {
  return inject(MenuFirstLevelContextKey, true);
};
var MenuContextProvider = defineComponent({
  name: "MenuContextProvider",
  inheritAttrs: false,
  props: {
    mode: {
      type: String,
      default: void 0
    },
    overflowDisabled: {
      type: Boolean,
      default: void 0
    },
    isRootMenu: {
      type: Boolean,
      default: void 0
    }
  },
  setup: function setup45(props2, _ref) {
    var slots = _ref.slots;
    var menuContext = useInjectMenu();
    var newContext = _extends$2({}, menuContext);
    if (props2.mode !== void 0) {
      newContext.mode = toRef(props2, "mode");
    }
    if (props2.isRootMenu !== void 0) {
      newContext.isRootMenu = toRef(props2, "isRootMenu");
    }
    if (props2.overflowDisabled !== void 0) {
      newContext.overflowDisabled = toRef(props2, "overflowDisabled");
    }
    useProvideMenu(newContext);
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var useProvideMenu$1 = useProvideMenu;
function baseFindIndex(array4, predicate, fromIndex, fromRight) {
  var length = array4.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length) {
    if (predicate(array4[index2], index2, array4)) {
      return index2;
    }
  }
  return -1;
}
function baseIsNaN(value) {
  return value !== value;
}
function strictIndexOf(array4, value, fromIndex) {
  var index2 = fromIndex - 1, length = array4.length;
  while (++index2 < length) {
    if (array4[index2] === value) {
      return index2;
    }
  }
  return -1;
}
function baseIndexOf(array4, value, fromIndex) {
  return value === value ? strictIndexOf(array4, value, fromIndex) : baseFindIndex(array4, baseIsNaN, fromIndex);
}
function arrayIncludes(array4, value) {
  var length = array4 == null ? 0 : array4.length;
  return !!length && baseIndexOf(array4, value, 0) > -1;
}
function arrayIncludesWith(array4, value, comparator) {
  var index2 = -1, length = array4 == null ? 0 : array4.length;
  while (++index2 < length) {
    if (comparator(value, array4[index2])) {
      return true;
    }
  }
  return false;
}
function noop$2() {
}
var INFINITY$3 = 1 / 0;
var createSet = !(Set$2 && 1 / setToArray(new Set$2([, -0]))[1] == INFINITY$3) ? noop$2 : function(values) {
  return new Set$2(values);
};
var createSet$1 = createSet;
var LARGE_ARRAY_SIZE = 200;
function baseUniq(array4, iteratee, comparator) {
  var index2 = -1, includes2 = arrayIncludes, length = array4.length, isCommon = true, result = [], seen = result;
  if (comparator) {
    isCommon = false;
    includes2 = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set2 = iteratee ? null : createSet$1(array4);
    if (set2) {
      return setToArray(set2);
    }
    isCommon = false;
    includes2 = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length) {
      var value = array4[index2], computed2 = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed2) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed2);
        }
        result.push(value);
      } else if (!includes2(seen, computed2, comparator)) {
        if (seen !== result) {
          seen.push(computed2);
        }
        result.push(value);
      }
    }
  return result;
}
function uniq(array4) {
  return array4 && array4.length ? baseUniq(array4) : [];
}
var SiderCollapsedKey = Symbol("siderCollapsed");
var OVERFLOW_KEY = "$$__vc-menu-more__key";
var KeyPathContext = Symbol("KeyPathContext");
var useInjectKeyPath = function useInjectKeyPath2() {
  return inject(KeyPathContext, {
    parentEventKeys: computed(function() {
      return [];
    }),
    parentKeys: computed(function() {
      return [];
    }),
    parentInfo: {}
  });
};
var useProvideKeyPath = function useProvideKeyPath2(eventKey, key2, menuInfo) {
  var _useInjectKeyPath = useInjectKeyPath(), parentEventKeys = _useInjectKeyPath.parentEventKeys, parentKeys = _useInjectKeyPath.parentKeys;
  var eventKeys = computed(function() {
    return [].concat(_toConsumableArray(parentEventKeys.value), [eventKey]);
  });
  var keys2 = computed(function() {
    return [].concat(_toConsumableArray(parentKeys.value), [key2]);
  });
  provide(KeyPathContext, {
    parentEventKeys: eventKeys,
    parentKeys: keys2,
    parentInfo: menuInfo
  });
  return keys2;
};
var measure = Symbol("measure");
var PathContext = defineComponent({
  setup: function setup46(_props, _ref) {
    var slots = _ref.slots;
    provide(measure, true);
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var useMeasure = function useMeasure2() {
  return inject(measure, false);
};
var useProvideKeyPath$1 = useProvideKeyPath;
function useDirectionStyle(level) {
  var _useInjectMenu = useInjectMenu(), mode = _useInjectMenu.mode, rtl2 = _useInjectMenu.rtl, inlineIndent = _useInjectMenu.inlineIndent;
  return computed(function() {
    return mode.value !== "inline" ? null : rtl2.value ? {
      paddingRight: "".concat(level.value * inlineIndent.value, "px")
    } : {
      paddingLeft: "".concat(level.value * inlineIndent.value, "px")
    };
  });
}
var indexGuid$3 = 0;
var menuItemProps = function menuItemProps2() {
  return {
    id: String,
    role: String,
    disabled: Boolean,
    danger: Boolean,
    title: {
      type: [String, Boolean],
      default: void 0
    },
    icon: PropTypes$1.any,
    onMouseenter: Function,
    onMouseleave: Function,
    onClick: Function,
    onKeydown: Function,
    onFocus: Function
  };
};
var MenuItem$1 = defineComponent({
  name: "AMenuItem",
  inheritAttrs: false,
  props: menuItemProps(),
  slots: ["icon", "title"],
  setup: function setup47(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs;
    var instance2 = getCurrentInstance();
    var isMeasure = useMeasure();
    var key2 = _typeof$2(instance2.vnode.key) === "symbol" ? String(instance2.vnode.key) : instance2.vnode.key;
    devWarning(_typeof$2(instance2.vnode.key) !== "symbol", "MenuItem", 'MenuItem `:key="'.concat(String(key2), '"` not support Symbol type'));
    var eventKey = "menu_item_".concat(++indexGuid$3, "_$$_").concat(key2);
    var _useInjectKeyPath = useInjectKeyPath(), parentEventKeys = _useInjectKeyPath.parentEventKeys, parentKeys = _useInjectKeyPath.parentKeys;
    var _useInjectMenu = useInjectMenu(), prefixCls2 = _useInjectMenu.prefixCls, activeKeys = _useInjectMenu.activeKeys, disabled = _useInjectMenu.disabled, changeActiveKeys = _useInjectMenu.changeActiveKeys, rtl2 = _useInjectMenu.rtl, inlineCollapsed = _useInjectMenu.inlineCollapsed, siderCollapsed = _useInjectMenu.siderCollapsed, onItemClick = _useInjectMenu.onItemClick, selectedKeys = _useInjectMenu.selectedKeys, registerMenuInfo = _useInjectMenu.registerMenuInfo, unRegisterMenuInfo = _useInjectMenu.unRegisterMenuInfo;
    var firstLevel = useInjectFirstLevel();
    var isActive = ref(false);
    var keysPath = computed(function() {
      return [].concat(_toConsumableArray(parentKeys.value), [key2]);
    });
    var menuInfo = {
      eventKey,
      key: key2,
      parentEventKeys,
      parentKeys,
      isLeaf: true
    };
    registerMenuInfo(eventKey, menuInfo);
    onBeforeUnmount(function() {
      unRegisterMenuInfo(eventKey);
    });
    watch(activeKeys, function() {
      isActive.value = !!activeKeys.value.find(function(val) {
        return val === key2;
      });
    }, {
      immediate: true
    });
    var mergedDisabled = computed(function() {
      return disabled.value || props2.disabled;
    });
    var selected = computed(function() {
      return selectedKeys.value.includes(key2);
    });
    var classNames2 = computed(function() {
      var _ref2;
      var itemCls = "".concat(prefixCls2.value, "-item");
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(itemCls), true), _defineProperty$R(_ref2, "".concat(itemCls, "-danger"), props2.danger), _defineProperty$R(_ref2, "".concat(itemCls, "-active"), isActive.value), _defineProperty$R(_ref2, "".concat(itemCls, "-selected"), selected.value), _defineProperty$R(_ref2, "".concat(itemCls, "-disabled"), mergedDisabled.value), _ref2;
    });
    var getEventInfo = function getEventInfo2(e2) {
      return {
        key: key2,
        eventKey,
        keyPath: keysPath.value,
        eventKeyPath: [].concat(_toConsumableArray(parentEventKeys.value), [eventKey]),
        domEvent: e2,
        item: _extends$2(_extends$2({}, props2), attrs)
      };
    };
    var onInternalClick = function onInternalClick2(e2) {
      if (mergedDisabled.value) {
        return;
      }
      var info = getEventInfo(e2);
      emit("click", e2);
      onItemClick(info);
    };
    var onMouseEnter = function onMouseEnter2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys(keysPath.value);
        emit("mouseenter", event);
      }
    };
    var onMouseLeave = function onMouseLeave2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys([]);
        emit("mouseleave", event);
      }
    };
    var onInternalKeyDown = function onInternalKeyDown2(e2) {
      emit("keydown", e2);
      if (e2.which === KeyCode$1.ENTER) {
        var info = getEventInfo(e2);
        emit("click", e2);
        onItemClick(info);
      }
    };
    var onInternalFocus = function onInternalFocus2(e2) {
      changeActiveKeys(keysPath.value);
      emit("focus", e2);
    };
    var renderItemChildren = function renderItemChildren2(icon, children) {
      var wrapNode = createVNode("span", {
        "class": "".concat(prefixCls2.value, "-title-content")
      }, [children]);
      if (!icon || isValidElement(children) && children.type === "span") {
        if (children && inlineCollapsed.value && firstLevel && typeof children === "string") {
          return createVNode("div", {
            "class": "".concat(prefixCls2.value, "-inline-collapsed-noicon")
          }, [children.charAt(0)]);
        }
      }
      return wrapNode;
    };
    var directionStyle = useDirectionStyle(computed(function() {
      return keysPath.value.length;
    }));
    return function() {
      var _ref3;
      var _a2, _b, _c;
      if (isMeasure)
        return null;
      var title = (_a2 = props2.title) !== null && _a2 !== void 0 ? _a2 : (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots);
      var children = flattenChildren((_c = slots.default) === null || _c === void 0 ? void 0 : _c.call(slots));
      var childrenLength = children.length;
      var tooltipTitle = title;
      if (typeof title === "undefined") {
        tooltipTitle = firstLevel && childrenLength ? children : "";
      } else if (title === false) {
        tooltipTitle = "";
      }
      var tooltipProps3 = {
        title: tooltipTitle
      };
      if (!siderCollapsed.value && !inlineCollapsed.value) {
        tooltipProps3.title = null;
        tooltipProps3.visible = false;
      }
      var optionRoleProps = {};
      if (props2.role === "option") {
        optionRoleProps["aria-selected"] = selected.value;
      }
      var icon = getPropsSlot(slots, props2, "icon");
      return createVNode(Tooltip, _objectSpread2$2(_objectSpread2$2({}, tooltipProps3), {}, {
        "placement": rtl2.value ? "left" : "right",
        "overlayClassName": "".concat(prefixCls2.value, "-inline-collapsed-tooltip")
      }), {
        default: function _default7() {
          return [createVNode(Overflow$1.Item, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
            "component": "li"
          }, attrs), {}, {
            "id": props2.id,
            "style": _extends$2(_extends$2({}, attrs.style || {}), directionStyle.value),
            "class": [classNames2.value, (_ref3 = {}, _defineProperty$R(_ref3, "".concat(attrs.class), !!attrs.class), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _ref3)],
            "role": props2.role || "menuitem",
            "tabindex": props2.disabled ? null : -1,
            "data-menu-id": key2,
            "aria-disabled": props2.disabled
          }, optionRoleProps), {}, {
            "onMouseenter": onMouseEnter,
            "onMouseleave": onMouseLeave,
            "onClick": onInternalClick,
            "onKeydown": onInternalKeyDown,
            "onFocus": onInternalFocus,
            "title": typeof title === "string" ? title : void 0
          }), {
            default: function _default8() {
              return [cloneElement(icon, {
                class: "".concat(prefixCls2.value, "-item-icon")
              }, false), renderItemChildren(icon, children)];
            }
          })];
        }
      });
    };
  }
});
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
var PopupTrigger = defineComponent({
  name: "PopupTrigger",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    mode: String,
    visible: Boolean,
    popupClassName: String,
    popupOffset: Array,
    disabled: Boolean,
    onVisibleChange: Function
  },
  slots: ["popup"],
  emits: ["visibleChange"],
  setup: function setup48(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var innerVisible = ref(false);
    var _useInjectMenu = useInjectMenu(), getPopupContainer = _useInjectMenu.getPopupContainer, rtl2 = _useInjectMenu.rtl, subMenuOpenDelay = _useInjectMenu.subMenuOpenDelay, subMenuCloseDelay = _useInjectMenu.subMenuCloseDelay, builtinPlacements = _useInjectMenu.builtinPlacements, triggerSubMenuAction = _useInjectMenu.triggerSubMenuAction, isRootMenu = _useInjectMenu.isRootMenu, forceSubMenuRender = _useInjectMenu.forceSubMenuRender, motion = _useInjectMenu.motion, defaultMotions = _useInjectMenu.defaultMotions;
    var forceRender = useInjectForceRender();
    var placement = computed(function() {
      return rtl2.value ? _extends$2(_extends$2({}, placementsRtl), builtinPlacements.value) : _extends$2(_extends$2({}, placements), builtinPlacements.value);
    });
    var popupPlacement = computed(function() {
      return popupPlacementMap[props2.mode];
    });
    var visibleRef = ref();
    watch(function() {
      return props2.visible;
    }, function(visible) {
      wrapperRaf.cancel(visibleRef.value);
      visibleRef.value = wrapperRaf(function() {
        innerVisible.value = visible;
      });
    }, {
      immediate: true
    });
    onBeforeUnmount(function() {
      wrapperRaf.cancel(visibleRef.value);
    });
    var onVisibleChange = function onVisibleChange2(visible) {
      emit("visibleChange", visible);
    };
    var mergedMotion = computed(function() {
      var _a2, _b;
      var m2 = motion.value || ((_a2 = defaultMotions.value) === null || _a2 === void 0 ? void 0 : _a2[props2.mode]) || ((_b = defaultMotions.value) === null || _b === void 0 ? void 0 : _b.other);
      var res = typeof m2 === "function" ? m2() : m2;
      return res ? getTransitionProps(res.name, {
        css: true
      }) : void 0;
    });
    return function() {
      var prefixCls2 = props2.prefixCls, popupClassName = props2.popupClassName, mode = props2.mode, popupOffset = props2.popupOffset, disabled = props2.disabled;
      return createVNode(Trigger, {
        "prefixCls": prefixCls2,
        "popupClassName": classNames("".concat(prefixCls2, "-popup"), _defineProperty$R({}, "".concat(prefixCls2, "-rtl"), rtl2.value), popupClassName),
        "stretch": mode === "horizontal" ? "minWidth" : null,
        "getPopupContainer": isRootMenu.value ? getPopupContainer.value : function(triggerNode) {
          return triggerNode.parentNode;
        },
        "builtinPlacements": placement.value,
        "popupPlacement": popupPlacement.value,
        "popupVisible": innerVisible.value,
        "popupAlign": popupOffset && {
          offset: popupOffset
        },
        "action": disabled ? [] : [triggerSubMenuAction.value],
        "mouseEnterDelay": subMenuOpenDelay.value,
        "mouseLeaveDelay": subMenuCloseDelay.value,
        "onPopupVisibleChange": onVisibleChange,
        "forceRender": forceRender || forceSubMenuRender.value,
        "popupAnimation": mergedMotion.value
      }, {
        popup: slots.popup,
        default: slots.default
      });
    };
  }
});
var InternalSubMenuList = function InternalSubMenuList2(_props, _ref) {
  var slots = _ref.slots, attrs = _ref.attrs;
  var _a2;
  var _useInjectMenu = useInjectMenu(), prefixCls2 = _useInjectMenu.prefixCls, mode = _useInjectMenu.mode;
  return createVNode("ul", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
    "class": classNames(prefixCls2.value, "".concat(prefixCls2.value, "-sub"), "".concat(prefixCls2.value, "-").concat(mode.value === "inline" ? "inline" : "vertical")),
    "data-menu-list": true
  }), [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
};
InternalSubMenuList.displayName = "SubMenuList";
var SubMenuList = InternalSubMenuList;
var InlineSubMenuList = defineComponent({
  name: "InlineSubMenuList",
  inheritAttrs: false,
  props: {
    id: String,
    open: Boolean,
    keyPath: Array
  },
  setup: function setup49(props2, _ref) {
    var slots = _ref.slots;
    var fixedMode = computed(function() {
      return "inline";
    });
    var _useInjectMenu = useInjectMenu(), motion = _useInjectMenu.motion, mode = _useInjectMenu.mode, defaultMotions = _useInjectMenu.defaultMotions;
    var sameModeRef = computed(function() {
      return mode.value === fixedMode.value;
    });
    var destroy4 = ref(!sameModeRef.value);
    var mergedOpen = computed(function() {
      return sameModeRef.value ? props2.open : false;
    });
    watch(mode, function() {
      if (sameModeRef.value) {
        destroy4.value = false;
      }
    }, {
      flush: "post"
    });
    var mergedMotion = computed(function() {
      var _a2, _b;
      var m2 = motion.value || ((_a2 = defaultMotions.value) === null || _a2 === void 0 ? void 0 : _a2[fixedMode.value]) || ((_b = defaultMotions.value) === null || _b === void 0 ? void 0 : _b.other);
      var res = typeof m2 === "function" ? m2() : m2;
      return _extends$2(_extends$2({}, res), {
        appear: props2.keyPath.length <= 1
      });
    });
    return function() {
      var _a2;
      if (destroy4.value) {
        return null;
      }
      return createVNode(MenuContextProvider, {
        "mode": fixedMode.value
      }, {
        default: function _default7() {
          return [createVNode(Transition$1, mergedMotion.value, {
            default: function _default8() {
              return [withDirectives(createVNode(SubMenuList, {
                "id": props2.id
              }, {
                default: function _default9() {
                  return [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)];
                }
              }), [[vShow, mergedOpen.value]])];
            }
          })];
        }
      });
    };
  }
});
var indexGuid$2 = 0;
var subMenuProps = function subMenuProps2() {
  return {
    icon: PropTypes$1.any,
    title: PropTypes$1.any,
    disabled: Boolean,
    level: Number,
    popupClassName: String,
    popupOffset: Array,
    internalPopupClose: Boolean,
    eventKey: String,
    expandIcon: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onTitleClick: Function
  };
};
var SubMenu$1 = defineComponent({
  name: "ASubMenu",
  inheritAttrs: false,
  props: subMenuProps(),
  slots: ["icon", "title", "expandIcon"],
  setup: function setup50(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var _a2, _b;
    useProvideFirstLevel(false);
    var isMeasure = useMeasure();
    var instance2 = getCurrentInstance();
    var vnodeKey = _typeof$2(instance2.vnode.key) === "symbol" ? String(instance2.vnode.key) : instance2.vnode.key;
    devWarning(_typeof$2(instance2.vnode.key) !== "symbol", "SubMenu", 'SubMenu `:key="'.concat(String(vnodeKey), '"` not support Symbol type'));
    var key2 = isValid$2(vnodeKey) ? vnodeKey : "sub_menu_".concat(++indexGuid$2, "_$$_not_set_key");
    var eventKey = (_a2 = props2.eventKey) !== null && _a2 !== void 0 ? _a2 : isValid$2(vnodeKey) ? "sub_menu_".concat(++indexGuid$2, "_$$_").concat(vnodeKey) : key2;
    var _useInjectKeyPath = useInjectKeyPath(), parentEventKeys = _useInjectKeyPath.parentEventKeys, parentInfo = _useInjectKeyPath.parentInfo, parentKeys = _useInjectKeyPath.parentKeys;
    var keysPath = computed(function() {
      return [].concat(_toConsumableArray(parentKeys.value), [key2]);
    });
    var childrenEventKeys = ref([]);
    var menuInfo = {
      eventKey,
      key: key2,
      parentEventKeys,
      childrenEventKeys,
      parentKeys
    };
    (_b = parentInfo.childrenEventKeys) === null || _b === void 0 ? void 0 : _b.value.push(eventKey);
    onBeforeUnmount(function() {
      var _a3;
      if (parentInfo.childrenEventKeys) {
        parentInfo.childrenEventKeys.value = (_a3 = parentInfo.childrenEventKeys) === null || _a3 === void 0 ? void 0 : _a3.value.filter(function(k2) {
          return k2 != eventKey;
        });
      }
    });
    useProvideKeyPath$1(eventKey, key2, menuInfo);
    var _useInjectMenu = useInjectMenu(), prefixCls2 = _useInjectMenu.prefixCls, activeKeys = _useInjectMenu.activeKeys, contextDisabled = _useInjectMenu.disabled, changeActiveKeys = _useInjectMenu.changeActiveKeys, mode = _useInjectMenu.mode, inlineCollapsed = _useInjectMenu.inlineCollapsed, antdMenuTheme = _useInjectMenu.antdMenuTheme, openKeys = _useInjectMenu.openKeys, overflowDisabled = _useInjectMenu.overflowDisabled, onOpenChange = _useInjectMenu.onOpenChange, registerMenuInfo = _useInjectMenu.registerMenuInfo, unRegisterMenuInfo = _useInjectMenu.unRegisterMenuInfo, selectedSubMenuKeys = _useInjectMenu.selectedSubMenuKeys, menuExpandIcon = _useInjectMenu.expandIcon;
    var hasKey = vnodeKey !== void 0 && vnodeKey !== null;
    var forceRender = !isMeasure && (useInjectForceRender() || !hasKey);
    useProvideForceRender(forceRender);
    if (isMeasure && hasKey || !isMeasure && !hasKey || forceRender) {
      registerMenuInfo(eventKey, menuInfo);
      onBeforeUnmount(function() {
        unRegisterMenuInfo(eventKey);
      });
    }
    var subMenuPrefixCls = computed(function() {
      return "".concat(prefixCls2.value, "-submenu");
    });
    var mergedDisabled = computed(function() {
      return contextDisabled.value || props2.disabled;
    });
    var elementRef = ref();
    var popupRef = ref();
    var originOpen = computed(function() {
      return openKeys.value.includes(key2);
    });
    var open2 = computed(function() {
      return !overflowDisabled.value && originOpen.value;
    });
    var childrenSelected = computed(function() {
      return selectedSubMenuKeys.value.includes(key2);
    });
    var isActive = ref(false);
    watch(activeKeys, function() {
      isActive.value = !!activeKeys.value.find(function(val) {
        return val === key2;
      });
    }, {
      immediate: true
    });
    var onInternalTitleClick = function onInternalTitleClick2(e2) {
      if (mergedDisabled.value) {
        return;
      }
      emit("titleClick", e2, key2);
      if (mode.value === "inline") {
        onOpenChange(key2, !originOpen.value);
      }
    };
    var onMouseEnter = function onMouseEnter2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys(keysPath.value);
        emit("mouseenter", event);
      }
    };
    var onMouseLeave = function onMouseLeave2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys([]);
        emit("mouseleave", event);
      }
    };
    var directionStyle = useDirectionStyle(computed(function() {
      return keysPath.value.length;
    }));
    var onPopupVisibleChange = function onPopupVisibleChange2(newVisible) {
      if (mode.value !== "inline") {
        onOpenChange(key2, newVisible);
      }
    };
    var onInternalFocus = function onInternalFocus2() {
      changeActiveKeys(keysPath.value);
    };
    var popupId = eventKey && "".concat(eventKey, "-popup");
    var popupClassName = computed(function() {
      return classNames(prefixCls2.value, "".concat(prefixCls2.value, "-").concat(antdMenuTheme.value), props2.popupClassName);
    });
    var renderTitle = function renderTitle2(title, icon) {
      if (!icon) {
        return inlineCollapsed.value && !parentKeys.value.length && title && typeof title === "string" ? createVNode("div", {
          "class": "".concat(prefixCls2.value, "-inline-collapsed-noicon")
        }, [title.charAt(0)]) : createVNode("span", {
          "class": "".concat(prefixCls2.value, "-title-content")
        }, [title]);
      }
      var titleIsSpan = isValidElement(title) && title.type === "span";
      return createVNode(Fragment, null, [cloneElement(icon, {
        class: "".concat(prefixCls2.value, "-item-icon")
      }, false), titleIsSpan ? title : createVNode("span", {
        "class": "".concat(prefixCls2.value, "-title-content")
      }, [title])]);
    };
    var triggerModeRef = computed(function() {
      return mode.value !== "inline" && keysPath.value.length > 1 ? "vertical" : mode.value;
    });
    var renderMode = computed(function() {
      return mode.value === "horizontal" ? "vertical" : mode.value;
    });
    var subMenuTriggerModeRef = computed(function() {
      return triggerModeRef.value === "horizontal" ? "vertical" : triggerModeRef.value;
    });
    var baseTitleNode = function baseTitleNode2() {
      var subMenuPrefixClsValue = subMenuPrefixCls.value;
      var icon = getPropsSlot(slots, props2, "icon");
      var expandIcon = props2.expandIcon || slots.expandIcon || menuExpandIcon.value;
      var title = renderTitle(getPropsSlot(slots, props2, "title"), icon);
      return createVNode("div", {
        "style": directionStyle.value,
        "class": "".concat(subMenuPrefixClsValue, "-title"),
        "tabindex": mergedDisabled.value ? null : -1,
        "ref": elementRef,
        "title": typeof title === "string" ? title : null,
        "data-menu-id": key2,
        "aria-expanded": open2.value,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled.value,
        "onClick": onInternalTitleClick,
        "onFocus": onInternalFocus
      }, [title, mode.value !== "horizontal" && expandIcon ? expandIcon(_extends$2(_extends$2({}, props2), {
        isOpen: open2.value
      })) : createVNode("i", {
        "class": "".concat(subMenuPrefixClsValue, "-arrow")
      }, null)]);
    };
    return function() {
      var _classNames;
      var _a3;
      if (isMeasure) {
        if (!hasKey) {
          return null;
        }
        return (_a3 = slots.default) === null || _a3 === void 0 ? void 0 : _a3.call(slots);
      }
      var subMenuPrefixClsValue = subMenuPrefixCls.value;
      var titleNode = function titleNode2() {
        return null;
      };
      if (!overflowDisabled.value && mode.value !== "inline") {
        titleNode = function titleNode2() {
          return createVNode(PopupTrigger, {
            "mode": triggerModeRef.value,
            "prefixCls": subMenuPrefixClsValue,
            "visible": !props2.internalPopupClose && open2.value,
            "popupClassName": popupClassName.value,
            "popupOffset": props2.popupOffset,
            "disabled": mergedDisabled.value,
            "onVisibleChange": onPopupVisibleChange
          }, {
            default: function _default7() {
              return [baseTitleNode()];
            },
            popup: function popup() {
              return createVNode(MenuContextProvider, {
                "mode": subMenuTriggerModeRef.value,
                "isRootMenu": false
              }, {
                default: function _default7() {
                  return [createVNode(SubMenuList, {
                    "id": popupId,
                    "ref": popupRef
                  }, {
                    default: slots.default
                  })];
                }
              });
            }
          });
        };
      } else {
        titleNode = function titleNode2() {
          return createVNode(PopupTrigger, null, {
            default: baseTitleNode
          });
        };
      }
      return createVNode(MenuContextProvider, {
        "mode": renderMode.value
      }, {
        default: function _default7() {
          return [createVNode(Overflow$1.Item, _objectSpread2$2(_objectSpread2$2({
            "component": "li"
          }, attrs), {}, {
            "role": "none",
            "class": classNames(subMenuPrefixClsValue, "".concat(subMenuPrefixClsValue, "-").concat(mode.value), attrs.class, (_classNames = {}, _defineProperty$R(_classNames, "".concat(subMenuPrefixClsValue, "-open"), open2.value), _defineProperty$R(_classNames, "".concat(subMenuPrefixClsValue, "-active"), isActive.value), _defineProperty$R(_classNames, "".concat(subMenuPrefixClsValue, "-selected"), childrenSelected.value), _defineProperty$R(_classNames, "".concat(subMenuPrefixClsValue, "-disabled"), mergedDisabled.value), _classNames)),
            "onMouseenter": onMouseEnter,
            "onMouseleave": onMouseLeave,
            "data-submenu-id": key2
          }), {
            default: function _default8() {
              return createVNode(Fragment, null, [titleNode(), !overflowDisabled.value && createVNode(InlineSubMenuList, {
                "id": popupId,
                "open": open2.value,
                "keyPath": keysPath.value
              }, {
                default: slots.default
              })]);
            }
          })];
        }
      });
    };
  }
});
function hasClass(node, className) {
  if (node.classList) {
    return node.classList.contains(className);
  }
  var originClass = node.className;
  return " ".concat(originClass, " ").indexOf(" ".concat(className, " ")) > -1;
}
function addClass(node, className) {
  if (node.classList) {
    node.classList.add(className);
  } else {
    if (!hasClass(node, className)) {
      node.className = "".concat(node.className, " ").concat(className);
    }
  }
}
function removeClass(node, className) {
  if (node.classList) {
    node.classList.remove(className);
  } else {
    if (hasClass(node, className)) {
      var originClass = node.className;
      node.className = " ".concat(originClass, " ").replace(" ".concat(className, " "), " ");
    }
  }
}
var collapseMotion = function collapseMotion2() {
  var name2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant-motion-collapse";
  var appear = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return {
    name: name2,
    appear,
    css: true,
    onBeforeEnter: function onBeforeEnter(node) {
      node.style.height = "0px";
      node.style.opacity = "0";
      addClass(node, name2);
    },
    onEnter: function onEnter(node) {
      nextTick(function() {
        node.style.height = "".concat(node.scrollHeight, "px");
        node.style.opacity = "1";
      });
    },
    onAfterEnter: function onAfterEnter(node) {
      if (node) {
        removeClass(node, name2);
        node.style.height = null;
        node.style.opacity = null;
      }
    },
    onBeforeLeave: function onBeforeLeave(node) {
      addClass(node, name2);
      node.style.height = "".concat(node.offsetHeight, "px");
      node.style.opacity = null;
    },
    onLeave: function onLeave(node) {
      setTimeout(function() {
        node.style.height = "0px";
        node.style.opacity = "0";
      });
    },
    onAfterLeave: function onAfterLeave(node) {
      if (node) {
        removeClass(node, name2);
        if (node.style) {
          node.style.height = null;
          node.style.opacity = null;
        }
      }
    }
  };
};
var collapseMotion$1 = collapseMotion;
var menuProps = function menuProps2() {
  return {
    id: String,
    prefixCls: String,
    disabled: Boolean,
    inlineCollapsed: Boolean,
    disabledOverflow: Boolean,
    forceSubMenuRender: Boolean,
    openKeys: Array,
    selectedKeys: Array,
    activeKey: String,
    selectable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    motion: Object,
    theme: {
      type: String,
      default: "light"
    },
    mode: {
      type: String,
      default: "vertical"
    },
    inlineIndent: {
      type: Number,
      default: 24
    },
    subMenuOpenDelay: {
      type: Number,
      default: 0.1
    },
    subMenuCloseDelay: {
      type: Number,
      default: 0.1
    },
    builtinPlacements: {
      type: Object
    },
    triggerSubMenuAction: {
      type: String,
      default: "hover"
    },
    getPopupContainer: Function,
    expandIcon: Function,
    onOpenChange: Function,
    onSelect: Function,
    onDeselect: Function,
    onClick: [Function, Array],
    onFocus: Function,
    onBlur: Function,
    onMousedown: Function,
    "onUpdate:openKeys": Function,
    "onUpdate:selectedKeys": Function,
    "onUpdate:activeKey": Function
  };
};
var EMPTY_LIST$2 = [];
var Menu = defineComponent({
  name: "AMenu",
  inheritAttrs: false,
  props: menuProps(),
  slots: ["expandIcon", "overflowedIndicator"],
  setup: function setup51(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("menu", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var store = ref({});
    var siderCollapsed = inject(SiderCollapsedKey, ref(void 0));
    var inlineCollapsed = computed(function() {
      if (siderCollapsed.value !== void 0) {
        return siderCollapsed.value;
      }
      return props2.inlineCollapsed;
    });
    var isMounted = ref(false);
    onMounted(function() {
      isMounted.value = true;
    });
    watchEffect(function() {
      devWarning(!(props2.inlineCollapsed === true && props2.mode !== "inline"), "Menu", "`inlineCollapsed` should only be used when `mode` is inline.");
      devWarning(!(siderCollapsed.value !== void 0 && props2.inlineCollapsed === true), "Menu", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.");
    });
    var activeKeys = ref([]);
    var mergedSelectedKeys = ref([]);
    var keyMapStore = ref({});
    watch(store, function() {
      var newKeyMapStore = {};
      for (var _i = 0, _Object$values = Object.values(store.value); _i < _Object$values.length; _i++) {
        var menuInfo = _Object$values[_i];
        newKeyMapStore[menuInfo.key] = menuInfo;
      }
      keyMapStore.value = newKeyMapStore;
    }, {
      flush: "post"
    });
    watchEffect(function() {
      if (props2.activeKey !== void 0) {
        var keys2 = [];
        var menuInfo = props2.activeKey ? keyMapStore.value[props2.activeKey] : void 0;
        if (menuInfo && props2.activeKey !== void 0) {
          keys2 = uniq([].concat(unref(menuInfo.parentKeys), props2.activeKey));
        } else {
          keys2 = [];
        }
        if (!shallowequal(activeKeys.value, keys2)) {
          activeKeys.value = keys2;
        }
      }
    });
    watch(function() {
      return props2.selectedKeys;
    }, function(selectedKeys) {
      if (selectedKeys) {
        mergedSelectedKeys.value = selectedKeys.slice();
      }
    }, {
      immediate: true,
      deep: true
    });
    var selectedSubMenuKeys = ref([]);
    watch([keyMapStore, mergedSelectedKeys], function() {
      var subMenuParentKeys = [];
      mergedSelectedKeys.value.forEach(function(key2) {
        var menuInfo = keyMapStore.value[key2];
        if (menuInfo) {
          subMenuParentKeys = subMenuParentKeys.concat(unref(menuInfo.parentKeys));
        }
      });
      subMenuParentKeys = uniq(subMenuParentKeys);
      if (!shallowequal(selectedSubMenuKeys.value, subMenuParentKeys)) {
        selectedSubMenuKeys.value = subMenuParentKeys;
      }
    }, {
      immediate: true
    });
    var triggerSelection = function triggerSelection2(info) {
      if (!props2.selectable) {
        return;
      }
      var targetKey = info.key;
      var exist = mergedSelectedKeys.value.includes(targetKey);
      var newSelectedKeys;
      if (props2.multiple) {
        if (exist) {
          newSelectedKeys = mergedSelectedKeys.value.filter(function(key2) {
            return key2 !== targetKey;
          });
        } else {
          newSelectedKeys = [].concat(_toConsumableArray(mergedSelectedKeys.value), [targetKey]);
        }
      } else {
        newSelectedKeys = [targetKey];
      }
      var selectInfo = _extends$2(_extends$2({}, info), {
        selectedKeys: newSelectedKeys
      });
      if (!shallowequal(newSelectedKeys, mergedSelectedKeys.value)) {
        if (props2.selectedKeys === void 0) {
          mergedSelectedKeys.value = newSelectedKeys;
        }
        emit("update:selectedKeys", newSelectedKeys);
        if (exist && props2.multiple) {
          emit("deselect", selectInfo);
        } else {
          emit("select", selectInfo);
        }
      }
      if (mergedMode.value !== "inline" && !props2.multiple && mergedOpenKeys.value.length) {
        triggerOpenKeys(EMPTY_LIST$2);
      }
    };
    var mergedOpenKeys = ref([]);
    watch(function() {
      return props2.openKeys;
    }, function() {
      var openKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : mergedOpenKeys.value;
      if (!shallowequal(mergedOpenKeys.value, openKeys)) {
        mergedOpenKeys.value = openKeys.slice();
      }
    }, {
      immediate: true,
      deep: true
    });
    var timeout;
    var changeActiveKeys = function changeActiveKeys2(keys2) {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        if (props2.activeKey === void 0) {
          activeKeys.value = keys2;
        }
        emit("update:activeKey", keys2[keys2.length - 1]);
      });
    };
    var disabled = computed(function() {
      return !!props2.disabled;
    });
    var isRtl = computed(function() {
      return direction2.value === "rtl";
    });
    var mergedMode = ref("vertical");
    var mergedInlineCollapsed = ref(false);
    watchEffect(function() {
      if ((props2.mode === "inline" || props2.mode === "vertical") && inlineCollapsed.value) {
        mergedMode.value = "vertical";
        mergedInlineCollapsed.value = inlineCollapsed.value;
      } else {
        mergedMode.value = props2.mode;
        mergedInlineCollapsed.value = false;
      }
    });
    var isInlineMode = computed(function() {
      return mergedMode.value === "inline";
    });
    var triggerOpenKeys = function triggerOpenKeys2(keys2) {
      mergedOpenKeys.value = keys2;
      emit("update:openKeys", keys2);
      emit("openChange", keys2);
    };
    var inlineCacheOpenKeys = ref(mergedOpenKeys.value);
    var mountRef = ref(false);
    watch(mergedOpenKeys, function() {
      if (isInlineMode.value) {
        inlineCacheOpenKeys.value = mergedOpenKeys.value;
      }
    }, {
      immediate: true
    });
    watch(isInlineMode, function() {
      if (!mountRef.value) {
        mountRef.value = true;
        return;
      }
      if (isInlineMode.value) {
        mergedOpenKeys.value = inlineCacheOpenKeys.value;
      } else {
        triggerOpenKeys(EMPTY_LIST$2);
      }
    }, {
      immediate: true
    });
    var className = computed(function() {
      var _ref2;
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(prefixCls2.value), true), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-root"), true), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-").concat(mergedMode.value), true), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-inline-collapsed"), mergedInlineCollapsed.value), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-rtl"), isRtl.value), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-").concat(props2.theme), true), _ref2;
    });
    var rootPrefixCls = computed(function() {
      return getPrefixCls2();
    });
    var defaultMotions = computed(function() {
      return {
        horizontal: {
          name: "".concat(rootPrefixCls.value, "-slide-up")
        },
        inline: collapseMotion$1,
        other: {
          name: "".concat(rootPrefixCls.value, "-zoom-big")
        }
      };
    });
    useProvideFirstLevel(true);
    var getChildrenKeys = function getChildrenKeys2() {
      var eventKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var keys2 = [];
      var storeValue = store.value;
      eventKeys.forEach(function(eventKey) {
        var _storeValue$eventKey = storeValue[eventKey], key2 = _storeValue$eventKey.key, childrenEventKeys = _storeValue$eventKey.childrenEventKeys;
        keys2.push.apply(keys2, [key2].concat(_toConsumableArray(getChildrenKeys2(childrenEventKeys))));
      });
      return keys2;
    };
    var onInternalClick = function onInternalClick2(info) {
      emit("click", info);
      triggerSelection(info);
    };
    var onInternalOpenChange = function onInternalOpenChange2(key2, open2) {
      var childrenEventKeys = keyMapStore.value[key2].childrenEventKeys;
      var newOpenKeys = mergedOpenKeys.value.filter(function(k2) {
        return k2 !== key2;
      });
      if (open2) {
        newOpenKeys.push(key2);
      } else if (mergedMode.value !== "inline") {
        var subPathKeys = getChildrenKeys(childrenEventKeys);
        newOpenKeys = uniq(newOpenKeys.filter(function(k2) {
          return !subPathKeys.includes(k2);
        }));
      }
      if (!shallowequal(mergedOpenKeys, newOpenKeys)) {
        triggerOpenKeys(newOpenKeys);
      }
    };
    var registerMenuInfo = function registerMenuInfo2(key2, info) {
      store.value = _extends$2(_extends$2({}, store.value), _defineProperty$R({}, key2, info));
    };
    var unRegisterMenuInfo = function unRegisterMenuInfo2(key2) {
      delete store.value[key2];
      store.value = _extends$2({}, store.value);
    };
    var lastVisibleIndex = ref(0);
    var expandIcon = computed(function() {
      return props2.expandIcon || slots.expandIcon ? function(opt) {
        var icon = props2.expandIcon || slots.expandIcon;
        icon = typeof icon === "function" ? icon(opt) : icon;
        return cloneElement(icon, {
          class: "".concat(prefixCls2.value, "-submenu-expand-icon")
        }, false);
      } : null;
    });
    useProvideMenu$1({
      store,
      prefixCls: prefixCls2,
      activeKeys,
      openKeys: mergedOpenKeys,
      selectedKeys: mergedSelectedKeys,
      changeActiveKeys,
      disabled,
      rtl: isRtl,
      mode: mergedMode,
      inlineIndent: computed(function() {
        return props2.inlineIndent;
      }),
      subMenuCloseDelay: computed(function() {
        return props2.subMenuCloseDelay;
      }),
      subMenuOpenDelay: computed(function() {
        return props2.subMenuOpenDelay;
      }),
      builtinPlacements: computed(function() {
        return props2.builtinPlacements;
      }),
      triggerSubMenuAction: computed(function() {
        return props2.triggerSubMenuAction;
      }),
      getPopupContainer: computed(function() {
        return props2.getPopupContainer;
      }),
      inlineCollapsed: mergedInlineCollapsed,
      antdMenuTheme: computed(function() {
        return props2.theme;
      }),
      siderCollapsed,
      defaultMotions: computed(function() {
        return isMounted.value ? defaultMotions.value : null;
      }),
      motion: computed(function() {
        return isMounted.value ? props2.motion : null;
      }),
      overflowDisabled: ref(void 0),
      onOpenChange: onInternalOpenChange,
      onItemClick: onInternalClick,
      registerMenuInfo,
      unRegisterMenuInfo,
      selectedSubMenuKeys,
      isRootMenu: ref(true),
      expandIcon,
      forceSubMenuRender: computed(function() {
        return props2.forceSubMenuRender;
      })
    });
    return function() {
      var _a2, _b;
      var childList = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      var allVisible = lastVisibleIndex.value >= childList.length - 1 || mergedMode.value !== "horizontal" || props2.disabledOverflow;
      var wrappedChildList = mergedMode.value !== "horizontal" || props2.disabledOverflow ? childList : childList.map(function(child, index2) {
        return createVNode(MenuContextProvider, {
          "key": child.key,
          "overflowDisabled": index2 > lastVisibleIndex.value
        }, {
          default: function _default7() {
            return child;
          }
        });
      });
      var overflowedIndicator = ((_b = slots.overflowedIndicator) === null || _b === void 0 ? void 0 : _b.call(slots)) || createVNode(EllipsisOutlined$1, null, null);
      return createVNode(Fragment, null, [createVNode(Overflow$1, _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "onMousedown": props2.onMousedown,
        "prefixCls": "".concat(prefixCls2.value, "-overflow"),
        "component": "ul",
        "itemComponent": MenuItem$1,
        "class": [className.value, attrs.class],
        "role": "menu",
        "id": props2.id,
        "data": wrappedChildList,
        "renderRawItem": function renderRawItem(node) {
          return node;
        },
        "renderRawRest": function renderRawRest(omitItems) {
          var len = omitItems.length;
          var originOmitItems = len ? childList.slice(-len) : null;
          return createVNode(Fragment, null, [createVNode(SubMenu$1, {
            "eventKey": OVERFLOW_KEY,
            "key": OVERFLOW_KEY,
            "title": overflowedIndicator,
            "disabled": allVisible,
            "internalPopupClose": len === 0
          }, {
            default: function _default7() {
              return originOmitItems;
            }
          }), createVNode(PathContext, null, {
            default: function _default7() {
              return [createVNode(SubMenu$1, {
                "eventKey": OVERFLOW_KEY,
                "key": OVERFLOW_KEY,
                "title": overflowedIndicator,
                "disabled": allVisible,
                "internalPopupClose": len === 0
              }, {
                default: function _default8() {
                  return originOmitItems;
                }
              })];
            }
          })]);
        },
        "maxCount": mergedMode.value !== "horizontal" || props2.disabledOverflow ? Overflow$1.INVALIDATE : Overflow$1.RESPONSIVE,
        "ssr": "full",
        "data-menu-list": true,
        "onVisibleChange": function onVisibleChange(newLastIndex) {
          lastVisibleIndex.value = newLastIndex;
        }
      }), null), createVNode("div", {
        "style": {
          display: "none"
        },
        "aria-hidden": true
      }, [createVNode(PathContext, null, {
        default: function _default7() {
          return [wrappedChildList];
        }
      })])]);
    };
  }
});
var menuItemGroupProps = function menuItemGroupProps2() {
  return {
    title: PropTypes$1.any
  };
};
var ItemGroup = defineComponent({
  name: "AMenuItemGroup",
  inheritAttrs: false,
  props: menuItemGroupProps(),
  slots: ["title"],
  setup: function setup52(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var _useInjectMenu = useInjectMenu(), prefixCls2 = _useInjectMenu.prefixCls;
    var groupPrefixCls = computed(function() {
      return "".concat(prefixCls2.value, "-item-group");
    });
    var isMeasure = useMeasure();
    return function() {
      var _a2, _b;
      if (isMeasure)
        return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      return createVNode("li", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "onClick": function onClick2(e2) {
          return e2.stopPropagation();
        },
        "class": groupPrefixCls.value
      }), [createVNode("div", {
        "title": typeof props2.title === "string" ? props2.title : void 0,
        "class": "".concat(groupPrefixCls.value, "-title")
      }, [getPropsSlot(slots, props2, "title")]), createVNode("ul", {
        "class": "".concat(groupPrefixCls.value, "-list")
      }, [(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)])]);
    };
  }
});
var menuDividerProps = function menuDividerProps2() {
  return {
    prefixCls: String,
    dashed: Boolean
  };
};
var Divider$2 = defineComponent({
  name: "AMenuDivider",
  props: menuDividerProps(),
  setup: function setup53(props2) {
    var _useConfigInject = useConfigInject("menu", props2), prefixCls2 = _useConfigInject.prefixCls;
    var cls = computed(function() {
      var _ref;
      return _ref = {}, _defineProperty$R(_ref, "".concat(prefixCls2.value, "-item-divider"), true), _defineProperty$R(_ref, "".concat(prefixCls2.value, "-item-divider-dashed"), !!props2.dashed), _ref;
    });
    return function() {
      return createVNode("li", {
        "class": cls.value
      }, null);
    };
  }
});
Menu.install = function(app) {
  app.component(Menu.name, Menu);
  app.component(MenuItem$1.name, MenuItem$1);
  app.component(SubMenu$1.name, SubMenu$1);
  app.component(Divider$2.name, Divider$2);
  app.component(ItemGroup.name, ItemGroup);
  return app;
};
Menu.Item = MenuItem$1;
Menu.Divider = Divider$2;
Menu.SubMenu = SubMenu$1;
Menu.ItemGroup = ItemGroup;
var dayjs_min = { exports: {} };
(function(module2, exports2) {
  !function(t2, e2) {
    module2.exports = e2();
  }(commonjsGlobal, function() {
    var t2 = 1e3, e2 = 6e4, n2 = 36e5, r2 = "millisecond", i2 = "second", s2 = "minute", u2 = "hour", a2 = "day", o2 = "week", f2 = "month", h2 = "quarter", c2 = "year", d2 = "date", $2 = "Invalid Date", l2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M2 = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m2 = function(t3, e3, n3) {
      var r3 = String(t3);
      return !r3 || r3.length >= e3 ? t3 : "" + Array(e3 + 1 - r3.length).join(n3) + t3;
    }, g2 = { s: m2, z: function(t3) {
      var e3 = -t3.utcOffset(), n3 = Math.abs(e3), r3 = Math.floor(n3 / 60), i3 = n3 % 60;
      return (e3 <= 0 ? "+" : "-") + m2(r3, 2, "0") + ":" + m2(i3, 2, "0");
    }, m: function t3(e3, n3) {
      if (e3.date() < n3.date())
        return -t3(n3, e3);
      var r3 = 12 * (n3.year() - e3.year()) + (n3.month() - e3.month()), i3 = e3.clone().add(r3, f2), s3 = n3 - i3 < 0, u3 = e3.clone().add(r3 + (s3 ? -1 : 1), f2);
      return +(-(r3 + (n3 - i3) / (s3 ? i3 - u3 : u3 - i3)) || 0);
    }, a: function(t3) {
      return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
    }, p: function(t3) {
      return { M: f2, y: c2, w: o2, d: a2, D: d2, h: u2, m: s2, s: i2, ms: r2, Q: h2 }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t3) {
      return t3 === void 0;
    } }, v2 = "en", D2 = {};
    D2[v2] = M2;
    var p2 = function(t3) {
      return t3 instanceof _2;
    }, S2 = function t3(e3, n3, r3) {
      var i3;
      if (!e3)
        return v2;
      if (typeof e3 == "string") {
        var s3 = e3.toLowerCase();
        D2[s3] && (i3 = s3), n3 && (D2[s3] = n3, i3 = s3);
        var u3 = e3.split("-");
        if (!i3 && u3.length > 1)
          return t3(u3[0]);
      } else {
        var a3 = e3.name;
        D2[a3] = e3, i3 = a3;
      }
      return !r3 && i3 && (v2 = i3), i3 || !r3 && v2;
    }, w2 = function(t3, e3) {
      if (p2(t3))
        return t3.clone();
      var n3 = typeof e3 == "object" ? e3 : {};
      return n3.date = t3, n3.args = arguments, new _2(n3);
    }, O2 = g2;
    O2.l = S2, O2.i = p2, O2.w = function(t3, e3) {
      return w2(t3, { locale: e3.$L, utc: e3.$u, x: e3.$x, $offset: e3.$offset });
    };
    var _2 = function() {
      function M3(t3) {
        this.$L = S2(t3.locale, null, true), this.parse(t3);
      }
      var m3 = M3.prototype;
      return m3.parse = function(t3) {
        this.$d = function(t4) {
          var e3 = t4.date, n3 = t4.utc;
          if (e3 === null)
            return new Date(NaN);
          if (O2.u(e3))
            return new Date();
          if (e3 instanceof Date)
            return new Date(e3);
          if (typeof e3 == "string" && !/Z$/i.test(e3)) {
            var r3 = e3.match(l2);
            if (r3) {
              var i3 = r3[2] - 1 || 0, s3 = (r3[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r3[1], i3, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s3)) : new Date(r3[1], i3, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s3);
            }
          }
          return new Date(e3);
        }(t3), this.$x = t3.x || {}, this.init();
      }, m3.init = function() {
        var t3 = this.$d;
        this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
      }, m3.$utils = function() {
        return O2;
      }, m3.isValid = function() {
        return !(this.$d.toString() === $2);
      }, m3.isSame = function(t3, e3) {
        var n3 = w2(t3);
        return this.startOf(e3) <= n3 && n3 <= this.endOf(e3);
      }, m3.isAfter = function(t3, e3) {
        return w2(t3) < this.startOf(e3);
      }, m3.isBefore = function(t3, e3) {
        return this.endOf(e3) < w2(t3);
      }, m3.$g = function(t3, e3, n3) {
        return O2.u(t3) ? this[e3] : this.set(n3, t3);
      }, m3.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m3.valueOf = function() {
        return this.$d.getTime();
      }, m3.startOf = function(t3, e3) {
        var n3 = this, r3 = !!O2.u(e3) || e3, h3 = O2.p(t3), $3 = function(t4, e4) {
          var i3 = O2.w(n3.$u ? Date.UTC(n3.$y, e4, t4) : new Date(n3.$y, e4, t4), n3);
          return r3 ? i3 : i3.endOf(a2);
        }, l3 = function(t4, e4) {
          return O2.w(n3.toDate()[t4].apply(n3.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e4)), n3);
        }, y3 = this.$W, M4 = this.$M, m4 = this.$D, g3 = "set" + (this.$u ? "UTC" : "");
        switch (h3) {
          case c2:
            return r3 ? $3(1, 0) : $3(31, 11);
          case f2:
            return r3 ? $3(1, M4) : $3(0, M4 + 1);
          case o2:
            var v3 = this.$locale().weekStart || 0, D3 = (y3 < v3 ? y3 + 7 : y3) - v3;
            return $3(r3 ? m4 - D3 : m4 + (6 - D3), M4);
          case a2:
          case d2:
            return l3(g3 + "Hours", 0);
          case u2:
            return l3(g3 + "Minutes", 1);
          case s2:
            return l3(g3 + "Seconds", 2);
          case i2:
            return l3(g3 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m3.endOf = function(t3) {
        return this.startOf(t3, false);
      }, m3.$set = function(t3, e3) {
        var n3, o3 = O2.p(t3), h3 = "set" + (this.$u ? "UTC" : ""), $3 = (n3 = {}, n3[a2] = h3 + "Date", n3[d2] = h3 + "Date", n3[f2] = h3 + "Month", n3[c2] = h3 + "FullYear", n3[u2] = h3 + "Hours", n3[s2] = h3 + "Minutes", n3[i2] = h3 + "Seconds", n3[r2] = h3 + "Milliseconds", n3)[o3], l3 = o3 === a2 ? this.$D + (e3 - this.$W) : e3;
        if (o3 === f2 || o3 === c2) {
          var y3 = this.clone().set(d2, 1);
          y3.$d[$3](l3), y3.init(), this.$d = y3.set(d2, Math.min(this.$D, y3.daysInMonth())).$d;
        } else
          $3 && this.$d[$3](l3);
        return this.init(), this;
      }, m3.set = function(t3, e3) {
        return this.clone().$set(t3, e3);
      }, m3.get = function(t3) {
        return this[O2.p(t3)]();
      }, m3.add = function(r3, h3) {
        var d3, $3 = this;
        r3 = Number(r3);
        var l3 = O2.p(h3), y3 = function(t3) {
          var e3 = w2($3);
          return O2.w(e3.date(e3.date() + Math.round(t3 * r3)), $3);
        };
        if (l3 === f2)
          return this.set(f2, this.$M + r3);
        if (l3 === c2)
          return this.set(c2, this.$y + r3);
        if (l3 === a2)
          return y3(1);
        if (l3 === o2)
          return y3(7);
        var M4 = (d3 = {}, d3[s2] = e2, d3[u2] = n2, d3[i2] = t2, d3)[l3] || 1, m4 = this.$d.getTime() + r3 * M4;
        return O2.w(m4, this);
      }, m3.subtract = function(t3, e3) {
        return this.add(-1 * t3, e3);
      }, m3.format = function(t3) {
        var e3 = this, n3 = this.$locale();
        if (!this.isValid())
          return n3.invalidDate || $2;
        var r3 = t3 || "YYYY-MM-DDTHH:mm:ssZ", i3 = O2.z(this), s3 = this.$H, u3 = this.$m, a3 = this.$M, o3 = n3.weekdays, f3 = n3.months, h3 = function(t4, n4, i4, s4) {
          return t4 && (t4[n4] || t4(e3, r3)) || i4[n4].slice(0, s4);
        }, c3 = function(t4) {
          return O2.s(s3 % 12 || 12, t4, "0");
        }, d3 = n3.meridiem || function(t4, e4, n4) {
          var r4 = t4 < 12 ? "AM" : "PM";
          return n4 ? r4.toLowerCase() : r4;
        }, l3 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a3 + 1, MM: O2.s(a3 + 1, 2, "0"), MMM: h3(n3.monthsShort, a3, f3, 3), MMMM: h3(f3, a3), D: this.$D, DD: O2.s(this.$D, 2, "0"), d: String(this.$W), dd: h3(n3.weekdaysMin, this.$W, o3, 2), ddd: h3(n3.weekdaysShort, this.$W, o3, 3), dddd: o3[this.$W], H: String(s3), HH: O2.s(s3, 2, "0"), h: c3(1), hh: c3(2), a: d3(s3, u3, true), A: d3(s3, u3, false), m: String(u3), mm: O2.s(u3, 2, "0"), s: String(this.$s), ss: O2.s(this.$s, 2, "0"), SSS: O2.s(this.$ms, 3, "0"), Z: i3 };
        return r3.replace(y2, function(t4, e4) {
          return e4 || l3[t4] || i3.replace(":", "");
        });
      }, m3.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m3.diff = function(r3, d3, $3) {
        var l3, y3 = O2.p(d3), M4 = w2(r3), m4 = (M4.utcOffset() - this.utcOffset()) * e2, g3 = this - M4, v3 = O2.m(this, M4);
        return v3 = (l3 = {}, l3[c2] = v3 / 12, l3[f2] = v3, l3[h2] = v3 / 3, l3[o2] = (g3 - m4) / 6048e5, l3[a2] = (g3 - m4) / 864e5, l3[u2] = g3 / n2, l3[s2] = g3 / e2, l3[i2] = g3 / t2, l3)[y3] || g3, $3 ? v3 : O2.a(v3);
      }, m3.daysInMonth = function() {
        return this.endOf(f2).$D;
      }, m3.$locale = function() {
        return D2[this.$L];
      }, m3.locale = function(t3, e3) {
        if (!t3)
          return this.$L;
        var n3 = this.clone(), r3 = S2(t3, e3, true);
        return r3 && (n3.$L = r3), n3;
      }, m3.clone = function() {
        return O2.w(this.$d, this);
      }, m3.toDate = function() {
        return new Date(this.valueOf());
      }, m3.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m3.toISOString = function() {
        return this.$d.toISOString();
      }, m3.toString = function() {
        return this.$d.toUTCString();
      }, M3;
    }(), T2 = _2.prototype;
    return w2.prototype = T2, [["$ms", r2], ["$s", i2], ["$m", s2], ["$H", u2], ["$W", a2], ["$M", f2], ["$y", c2], ["$D", d2]].forEach(function(t3) {
      T2[t3[1]] = function(e3) {
        return this.$g(e3, t3[0], t3[1]);
      };
    }), w2.extend = function(t3, e3) {
      return t3.$i || (t3(e3, _2, w2), t3.$i = true), w2;
    }, w2.locale = S2, w2.isDayjs = p2, w2.unix = function(t3) {
      return w2(1e3 * t3);
    }, w2.en = D2[v2], w2.Ls = D2, w2.p = {}, w2;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var weekday$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(commonjsGlobal, function() {
    return function(e2, t2) {
      t2.prototype.weekday = function(e3) {
        var t3 = this.$locale().weekStart || 0, i2 = this.$W, n2 = (i2 < t3 ? i2 + 7 : i2) - t3;
        return this.$utils().u(e3) ? n2 : this.subtract(n2, "day").add(e3, "day");
      };
    };
  });
})(weekday$1);
var weekday = weekday$1.exports;
var localeData$1 = { exports: {} };
(function(module2, exports2) {
  !function(n2, e2) {
    module2.exports = e2();
  }(commonjsGlobal, function() {
    return function(n2, e2, t2) {
      var r2 = e2.prototype, o2 = function(n3) {
        return n3 && (n3.indexOf ? n3 : n3.s);
      }, u2 = function(n3, e3, t3, r3, u3) {
        var i3 = n3.name ? n3 : n3.$locale(), a3 = o2(i3[e3]), s3 = o2(i3[t3]), f2 = a3 || s3.map(function(n4) {
          return n4.slice(0, r3);
        });
        if (!u3)
          return f2;
        var d2 = i3.weekStart;
        return f2.map(function(n4, e4) {
          return f2[(e4 + (d2 || 0)) % 7];
        });
      }, i2 = function() {
        return t2.Ls[t2.locale()];
      }, a2 = function(n3, e3) {
        return n3.formats[e3] || function(n4) {
          return n4.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n5, e4, t3) {
            return e4 || t3.slice(1);
          });
        }(n3.formats[e3.toUpperCase()]);
      }, s2 = function() {
        var n3 = this;
        return { months: function(e3) {
          return e3 ? e3.format("MMMM") : u2(n3, "months");
        }, monthsShort: function(e3) {
          return e3 ? e3.format("MMM") : u2(n3, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return n3.$locale().weekStart || 0;
        }, weekdays: function(e3) {
          return e3 ? e3.format("dddd") : u2(n3, "weekdays");
        }, weekdaysMin: function(e3) {
          return e3 ? e3.format("dd") : u2(n3, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(e3) {
          return e3 ? e3.format("ddd") : u2(n3, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(e3) {
          return a2(n3.$locale(), e3);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      r2.localeData = function() {
        return s2.bind(this)();
      }, t2.localeData = function() {
        var n3 = i2();
        return { firstDayOfWeek: function() {
          return n3.weekStart || 0;
        }, weekdays: function() {
          return t2.weekdays();
        }, weekdaysShort: function() {
          return t2.weekdaysShort();
        }, weekdaysMin: function() {
          return t2.weekdaysMin();
        }, months: function() {
          return t2.months();
        }, monthsShort: function() {
          return t2.monthsShort();
        }, longDateFormat: function(e3) {
          return a2(n3, e3);
        }, meridiem: n3.meridiem, ordinal: n3.ordinal };
      }, t2.months = function() {
        return u2(i2(), "months");
      }, t2.monthsShort = function() {
        return u2(i2(), "monthsShort", "months", 3);
      }, t2.weekdays = function(n3) {
        return u2(i2(), "weekdays", null, null, n3);
      }, t2.weekdaysShort = function(n3) {
        return u2(i2(), "weekdaysShort", "weekdays", 3, n3);
      }, t2.weekdaysMin = function(n3) {
        return u2(i2(), "weekdaysMin", "weekdays", 2, n3);
      };
    };
  });
})(localeData$1);
var localeData = localeData$1.exports;
var weekOfYear$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(commonjsGlobal, function() {
    var e2 = "week", t2 = "year";
    return function(i2, n2, r2) {
      var f2 = n2.prototype;
      f2.week = function(i3) {
        if (i3 === void 0 && (i3 = null), i3 !== null)
          return this.add(7 * (i3 - this.week()), "day");
        var n3 = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var f3 = r2(this).startOf(t2).add(1, t2).date(n3), s2 = r2(this).endOf(e2);
          if (f3.isBefore(s2))
            return 1;
        }
        var a2 = r2(this).startOf(t2).date(n3).startOf(e2).subtract(1, "millisecond"), o2 = this.diff(a2, e2, true);
        return o2 < 0 ? r2(this).startOf("week").week() : Math.ceil(o2);
      }, f2.weeks = function(e3) {
        return e3 === void 0 && (e3 = null), this.week(e3);
      };
    };
  });
})(weekOfYear$1);
var weekOfYear = weekOfYear$1.exports;
var weekYear$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(commonjsGlobal, function() {
    return function(e2, t2) {
      t2.prototype.weekYear = function() {
        var e3 = this.month(), t3 = this.week(), n2 = this.year();
        return t3 === 1 && e3 === 11 ? n2 + 1 : e3 === 0 && t3 >= 52 ? n2 - 1 : n2;
      };
    };
  });
})(weekYear$1);
var weekYear = weekYear$1.exports;
var advancedFormat$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(commonjsGlobal, function() {
    return function(e2, t2, r2) {
      var n2 = t2.prototype, s2 = n2.format;
      r2.en.ordinal = function(e3) {
        var t3 = ["th", "st", "nd", "rd"], r3 = e3 % 100;
        return "[" + e3 + (t3[(r3 - 20) % 10] || t3[r3] || t3[0]) + "]";
      }, n2.format = function(e3) {
        var t3 = this, r3 = this.$locale();
        if (!this.isValid())
          return s2.bind(this)(e3);
        var n3 = this.$utils(), a2 = (e3 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e4) {
          switch (e4) {
            case "Q":
              return Math.ceil((t3.$M + 1) / 3);
            case "Do":
              return r3.ordinal(t3.$D);
            case "gggg":
              return t3.weekYear();
            case "GGGG":
              return t3.isoWeekYear();
            case "wo":
              return r3.ordinal(t3.week(), "W");
            case "w":
            case "ww":
              return n3.s(t3.week(), e4 === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return n3.s(t3.isoWeek(), e4 === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return n3.s(String(t3.$H === 0 ? 24 : t3.$H), e4 === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(t3.$d.getTime() / 1e3);
            case "x":
              return t3.$d.getTime();
            case "z":
              return "[" + t3.offsetName() + "]";
            case "zzz":
              return "[" + t3.offsetName("long") + "]";
            default:
              return e4;
          }
        });
        return s2.bind(this)(a2);
      };
    };
  });
})(advancedFormat$1);
var advancedFormat = advancedFormat$1.exports;
var customParseFormat$1 = { exports: {} };
(function(module2, exports2) {
  !function(e2, t2) {
    module2.exports = t2();
  }(commonjsGlobal, function() {
    var e2 = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t2 = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n2 = /\d\d/, r2 = /\d\d?/, i2 = /\d*[^-_:/,()\s\d]+/, o2 = {}, s2 = function(e3) {
      return (e3 = +e3) + (e3 > 68 ? 1900 : 2e3);
    };
    var a2 = function(e3) {
      return function(t3) {
        this[e3] = +t3;
      };
    }, f2 = [/[+-]\d\d:?(\d\d)?|Z/, function(e3) {
      (this.zone || (this.zone = {})).offset = function(e4) {
        if (!e4)
          return 0;
        if (e4 === "Z")
          return 0;
        var t3 = e4.match(/([+-]|\d\d)/g), n3 = 60 * t3[1] + (+t3[2] || 0);
        return n3 === 0 ? 0 : t3[0] === "+" ? -n3 : n3;
      }(e3);
    }], h2 = function(e3) {
      var t3 = o2[e3];
      return t3 && (t3.indexOf ? t3 : t3.s.concat(t3.f));
    }, u2 = function(e3, t3) {
      var n3, r3 = o2.meridiem;
      if (r3) {
        for (var i3 = 1; i3 <= 24; i3 += 1)
          if (e3.indexOf(r3(i3, 0, t3)) > -1) {
            n3 = i3 > 12;
            break;
          }
      } else
        n3 = e3 === (t3 ? "pm" : "PM");
      return n3;
    }, d2 = { A: [i2, function(e3) {
      this.afternoon = u2(e3, false);
    }], a: [i2, function(e3) {
      this.afternoon = u2(e3, true);
    }], S: [/\d/, function(e3) {
      this.milliseconds = 100 * +e3;
    }], SS: [n2, function(e3) {
      this.milliseconds = 10 * +e3;
    }], SSS: [/\d{3}/, function(e3) {
      this.milliseconds = +e3;
    }], s: [r2, a2("seconds")], ss: [r2, a2("seconds")], m: [r2, a2("minutes")], mm: [r2, a2("minutes")], H: [r2, a2("hours")], h: [r2, a2("hours")], HH: [r2, a2("hours")], hh: [r2, a2("hours")], D: [r2, a2("day")], DD: [n2, a2("day")], Do: [i2, function(e3) {
      var t3 = o2.ordinal, n3 = e3.match(/\d+/);
      if (this.day = n3[0], t3)
        for (var r3 = 1; r3 <= 31; r3 += 1)
          t3(r3).replace(/\[|\]/g, "") === e3 && (this.day = r3);
    }], M: [r2, a2("month")], MM: [n2, a2("month")], MMM: [i2, function(e3) {
      var t3 = h2("months"), n3 = (h2("monthsShort") || t3.map(function(e4) {
        return e4.slice(0, 3);
      })).indexOf(e3) + 1;
      if (n3 < 1)
        throw new Error();
      this.month = n3 % 12 || n3;
    }], MMMM: [i2, function(e3) {
      var t3 = h2("months").indexOf(e3) + 1;
      if (t3 < 1)
        throw new Error();
      this.month = t3 % 12 || t3;
    }], Y: [/[+-]?\d+/, a2("year")], YY: [n2, function(e3) {
      this.year = s2(e3);
    }], YYYY: [/\d{4}/, a2("year")], Z: f2, ZZ: f2 };
    function c2(n3) {
      var r3, i3;
      r3 = n3, i3 = o2 && o2.formats;
      for (var s3 = (n3 = r3.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t3, n4, r4) {
        var o3 = r4 && r4.toUpperCase();
        return n4 || i3[r4] || e2[r4] || i3[o3].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e3, t4, n5) {
          return t4 || n5.slice(1);
        });
      })).match(t2), a3 = s3.length, f3 = 0; f3 < a3; f3 += 1) {
        var h3 = s3[f3], u3 = d2[h3], c3 = u3 && u3[0], l2 = u3 && u3[1];
        s3[f3] = l2 ? { regex: c3, parser: l2 } : h3.replace(/^\[|\]$/g, "");
      }
      return function(e3) {
        for (var t3 = {}, n4 = 0, r4 = 0; n4 < a3; n4 += 1) {
          var i4 = s3[n4];
          if (typeof i4 == "string")
            r4 += i4.length;
          else {
            var o3 = i4.regex, f4 = i4.parser, h4 = e3.slice(r4), u4 = o3.exec(h4)[0];
            f4.call(t3, u4), e3 = e3.replace(u4, "");
          }
        }
        return function(e4) {
          var t4 = e4.afternoon;
          if (t4 !== void 0) {
            var n5 = e4.hours;
            t4 ? n5 < 12 && (e4.hours += 12) : n5 === 12 && (e4.hours = 0), delete e4.afternoon;
          }
        }(t3), t3;
      };
    }
    return function(e3, t3, n3) {
      n3.p.customParseFormat = true, e3 && e3.parseTwoDigitYear && (s2 = e3.parseTwoDigitYear);
      var r3 = t3.prototype, i3 = r3.parse;
      r3.parse = function(e4) {
        var t4 = e4.date, r4 = e4.utc, s3 = e4.args;
        this.$u = r4;
        var a3 = s3[1];
        if (typeof a3 == "string") {
          var f3 = s3[2] === true, h3 = s3[3] === true, u3 = f3 || h3, d3 = s3[2];
          h3 && (d3 = s3[2]), o2 = this.$locale(), !f3 && d3 && (o2 = n3.Ls[d3]), this.$d = function(e5, t5, n4) {
            try {
              if (["x", "X"].indexOf(t5) > -1)
                return new Date((t5 === "X" ? 1e3 : 1) * e5);
              var r5 = c2(t5)(e5), i4 = r5.year, o3 = r5.month, s4 = r5.day, a4 = r5.hours, f4 = r5.minutes, h4 = r5.seconds, u4 = r5.milliseconds, d4 = r5.zone, l3 = new Date(), m3 = s4 || (i4 || o3 ? 1 : l3.getDate()), M3 = i4 || l3.getFullYear(), Y2 = 0;
              i4 && !o3 || (Y2 = o3 > 0 ? o3 - 1 : l3.getMonth());
              var p2 = a4 || 0, v2 = f4 || 0, D2 = h4 || 0, g2 = u4 || 0;
              return d4 ? new Date(Date.UTC(M3, Y2, m3, p2, v2, D2, g2 + 60 * d4.offset * 1e3)) : n4 ? new Date(Date.UTC(M3, Y2, m3, p2, v2, D2, g2)) : new Date(M3, Y2, m3, p2, v2, D2, g2);
            } catch (e6) {
              return new Date("");
            }
          }(t4, a3, r4), this.init(), d3 && d3 !== true && (this.$L = this.locale(d3).$L), u3 && t4 != this.format(a3) && (this.$d = new Date("")), o2 = {};
        } else if (a3 instanceof Array)
          for (var l2 = a3.length, m2 = 1; m2 <= l2; m2 += 1) {
            s3[1] = a3[m2 - 1];
            var M2 = n3.apply(this, s3);
            if (M2.isValid()) {
              this.$d = M2.$d, this.$L = M2.$L, this.init();
              break;
            }
            m2 === l2 && (this.$d = new Date(""));
          }
        else
          i3.call(this, e4);
      };
    };
  });
})(customParseFormat$1);
var customParseFormat = customParseFormat$1.exports;
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(function(_o, c2) {
  var proto = c2.prototype;
  var oldFormat = proto.format;
  proto.format = function f2(formatStr) {
    var str = (formatStr || "").replace("Wo", "wo");
    return oldFormat.bind(this)(str);
  };
});
var localeMap = {
  bn_BD: "bn-bd",
  by_BY: "be",
  en_GB: "en-gb",
  en_US: "en",
  fr_BE: "fr",
  fr_CA: "fr-ca",
  hy_AM: "hy-am",
  kmr_IQ: "ku",
  nl_BE: "nl-be",
  pt_BR: "pt-br",
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
};
var parseLocale = function parseLocale2(locale2) {
  var mapLocale = localeMap[locale2];
  return mapLocale || locale2.split("_")[0];
};
var parseNoMatchNotice = function parseNoMatchNotice2() {
  noteOnce(false, "Not match any format. Please help to fire a issue about this.");
};
var generateConfig = {
  getNow: function getNow() {
    return dayjs();
  },
  getFixedDate: function getFixedDate(string3) {
    return dayjs(string3, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function getEndDate(date4) {
    return date4.endOf("month");
  },
  getWeekDay: function getWeekDay(date4) {
    var clone3 = date4.locale("en");
    return clone3.weekday() + clone3.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date4) {
    return date4.year();
  },
  getMonth: function getMonth(date4) {
    return date4.month();
  },
  getDate: function getDate(date4) {
    return date4.date();
  },
  getHour: function getHour(date4) {
    return date4.hour();
  },
  getMinute: function getMinute(date4) {
    return date4.minute();
  },
  getSecond: function getSecond(date4) {
    return date4.second();
  },
  addYear: function addYear(date4, diff) {
    return date4.add(diff, "year");
  },
  addMonth: function addMonth(date4, diff) {
    return date4.add(diff, "month");
  },
  addDate: function addDate(date4, diff) {
    return date4.add(diff, "day");
  },
  setYear: function setYear(date4, year) {
    return date4.year(year);
  },
  setMonth: function setMonth(date4, month) {
    return date4.month(month);
  },
  setDate: function setDate(date4, num) {
    return date4.date(num);
  },
  setHour: function setHour(date4, hour) {
    return date4.hour(hour);
  },
  setMinute: function setMinute(date4, minute) {
    return date4.minute(minute);
  },
  setSecond: function setSecond(date4, second) {
    return date4.second(second);
  },
  isAfter: function isAfter(date1, date22) {
    return date1.isAfter(date22);
  },
  isValidate: function isValidate(date4) {
    return date4.isValid();
  },
  locale: {
    getWeekFirstDay: function getWeekFirstDay(locale2) {
      return dayjs().locale(parseLocale(locale2)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function getWeekFirstDate(locale2, date4) {
      return date4.locale(parseLocale(locale2)).weekday(0);
    },
    getWeek: function getWeek(locale2, date4) {
      return date4.locale(parseLocale(locale2)).week();
    },
    getShortWeekDays: function getShortWeekDays(locale2) {
      return dayjs().locale(parseLocale(locale2)).localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale2) {
      return dayjs().locale(parseLocale(locale2)).localeData().monthsShort();
    },
    format: function format(locale2, date4, _format) {
      return date4.locale(parseLocale(locale2)).format(_format);
    },
    parse: function parse(locale2, text, formats) {
      var localeStr = parseLocale(locale2);
      for (var i2 = 0; i2 < formats.length; i2 += 1) {
        var format3 = formats[i2];
        var formatText = text;
        if (format3.includes("wo") || format3.includes("Wo")) {
          var year = formatText.split("-")[0];
          var weekStr = formatText.split("-")[1];
          var firstWeek = dayjs(year, "YYYY").startOf("year").locale(localeStr);
          for (var j2 = 0; j2 <= 52; j2 += 1) {
            var nextWeek = firstWeek.add(j2, "week");
            if (nextWeek.format("Wo") === weekStr) {
              return nextWeek;
            }
          }
          parseNoMatchNotice();
          return null;
        }
        var date4 = dayjs(formatText, format3, true).locale(localeStr);
        if (date4.isValid()) {
          return date4;
        }
      }
      if (!text) {
        parseNoMatchNotice();
      }
      return null;
    }
  },
  toDate: function toDate(value, valueFormat) {
    if (Array.isArray(value)) {
      return value.map(function(val) {
        return typeof val === "string" && val ? dayjs(val, valueFormat) : val || null;
      });
    } else {
      return typeof value === "string" && value ? dayjs(value, valueFormat) : value || null;
    }
  },
  toString: function toString(value, valueFormat) {
    if (Array.isArray(value)) {
      return value.map(function(val) {
        return dayjs.isDayjs(val) ? val.format(valueFormat) : val;
      });
    } else {
      return dayjs.isDayjs(value) ? value.format(valueFormat) : value;
    }
  }
};
var dayjsGenerateConfig = generateConfig;
function arrayMap(array4, iteratee) {
  var index2 = -1, length = array4 == null ? 0 : array4.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array4[index2], index2, array4);
  }
  return result;
}
var symbolTag$2 = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$2;
}
var INFINITY$2 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$3(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
function baseSlice(array4, start2, end) {
  var index2 = -1, length = array4.length;
  if (start2 < 0) {
    start2 = -start2 > length ? 0 : length + start2;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start2 > end ? 0 : end - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length);
  while (++index2 < length) {
    result[index2] = array4[index2 + start2];
  }
  return result;
}
function baseProperty(key2) {
  return function(object4) {
    return object4 == null ? void 0 : object4[key2];
  };
}
var reWhitespace = /\s/;
function trimmedEndIndex(string3) {
  var index2 = string3.length;
  while (index2-- && reWhitespace.test(string3.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string3) {
  return string3 ? string3.slice(0, trimmedEndIndex(string3) + 1).replace(reTrimStart, "") : string3;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$4(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$4(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var INFINITY$1 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
function toInteger(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
function toString$2(value) {
  return value == null ? "" : baseToString(value);
}
function useMergeProps(props2) {
  var attrs = useAttrs();
  return _extends$2(_extends$2({}, props2), attrs);
}
var PanelContextKey = Symbol("PanelContextProps");
var useProvidePanel = function useProvidePanel2(props2) {
  provide(PanelContextKey, props2);
};
var useInjectPanel = function useInjectPanel2() {
  return inject(PanelContextKey, {});
};
var HIDDEN_STYLE$2 = {
  visibility: "hidden"
};
function Header$1(_props, _ref) {
  var slots = _ref.slots;
  var _a2;
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, _props$prevIcon = props2.prevIcon, prevIcon = _props$prevIcon === void 0 ? "\u2039" : _props$prevIcon, _props$nextIcon = props2.nextIcon, nextIcon = _props$nextIcon === void 0 ? "\u203A" : _props$nextIcon, _props$superPrevIcon = props2.superPrevIcon, superPrevIcon = _props$superPrevIcon === void 0 ? "\xAB" : _props$superPrevIcon, _props$superNextIcon = props2.superNextIcon, superNextIcon = _props$superNextIcon === void 0 ? "\xBB" : _props$superNextIcon, onSuperPrev = props2.onSuperPrev, onSuperNext = props2.onSuperNext, onPrev = props2.onPrev, onNext = props2.onNext;
  var _useInjectPanel = useInjectPanel(), hideNextBtn = _useInjectPanel.hideNextBtn, hidePrevBtn = _useInjectPanel.hidePrevBtn;
  return createVNode("div", {
    "class": prefixCls2
  }, [onSuperPrev && createVNode("button", {
    "type": "button",
    "onClick": onSuperPrev,
    "tabindex": -1,
    "class": "".concat(prefixCls2, "-super-prev-btn"),
    "style": hidePrevBtn.value ? HIDDEN_STYLE$2 : {}
  }, [superPrevIcon]), onPrev && createVNode("button", {
    "type": "button",
    "onClick": onPrev,
    "tabindex": -1,
    "class": "".concat(prefixCls2, "-prev-btn"),
    "style": hidePrevBtn.value ? HIDDEN_STYLE$2 : {}
  }, [prevIcon]), createVNode("div", {
    "class": "".concat(prefixCls2, "-view")
  }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]), onNext && createVNode("button", {
    "type": "button",
    "onClick": onNext,
    "tabindex": -1,
    "class": "".concat(prefixCls2, "-next-btn"),
    "style": hideNextBtn.value ? HIDDEN_STYLE$2 : {}
  }, [nextIcon]), onSuperNext && createVNode("button", {
    "type": "button",
    "onClick": onSuperNext,
    "tabindex": -1,
    "class": "".concat(prefixCls2, "-super-next-btn"),
    "style": hideNextBtn.value ? HIDDEN_STYLE$2 : {}
  }, [superNextIcon])]);
}
Header$1.displayName = "Header";
Header$1.inheritAttrs = false;
function DecadeHeader(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, viewDate = props2.viewDate, onPrevDecades = props2.onPrevDecades, onNextDecades = props2.onNextDecades;
  var _useInjectPanel = useInjectPanel(), hideHeader = _useInjectPanel.hideHeader;
  if (hideHeader) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls2, "-header");
  var yearNumber = generateConfig2.getYear(viewDate);
  var startYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
  var endYear = startYear + DECADE_DISTANCE_COUNT - 1;
  return createVNode(Header$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": headerPrefixCls,
    "onSuperPrev": onPrevDecades,
    "onSuperNext": onNextDecades
  }), {
    default: function _default7() {
      return [startYear, createTextVNode("-"), endYear];
    }
  });
}
DecadeHeader.displayName = "DecadeHeader";
DecadeHeader.inheritAttrs = false;
function setTime(generateConfig2, date4, hour, minute, second) {
  var nextTime = generateConfig2.setHour(date4, hour);
  nextTime = generateConfig2.setMinute(nextTime, minute);
  nextTime = generateConfig2.setSecond(nextTime, second);
  return nextTime;
}
function setDateTime(generateConfig2, date4, defaultDate) {
  if (!defaultDate) {
    return date4;
  }
  var newDate = date4;
  newDate = generateConfig2.setHour(newDate, generateConfig2.getHour(defaultDate));
  newDate = generateConfig2.setMinute(newDate, generateConfig2.getMinute(defaultDate));
  newDate = generateConfig2.setSecond(newDate, generateConfig2.getSecond(defaultDate));
  return newDate;
}
function getLowerBoundTime(hour, minute, second, hourStep, minuteStep, secondStep) {
  var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;
  if (lowerBoundHour < hour) {
    return [lowerBoundHour, 60 - minuteStep, 60 - secondStep];
  }
  var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;
  if (lowerBoundMinute < minute) {
    return [lowerBoundHour, lowerBoundMinute, 60 - secondStep];
  }
  var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
  return [lowerBoundHour, lowerBoundMinute, lowerBoundSecond];
}
function getLastDay(generateConfig2, date4) {
  var year = generateConfig2.getYear(date4);
  var month = generateConfig2.getMonth(date4) + 1;
  var endDate = generateConfig2.getEndDate(generateConfig2.getFixedDate("".concat(year, "-").concat(month, "-01")));
  var lastDay = generateConfig2.getDate(endDate);
  var monthShow = month < 10 ? "0".concat(month) : "".concat(month);
  return "".concat(year, "-").concat(monthShow, "-").concat(lastDay);
}
function PanelBody(_props) {
  var _useMergeProps = useMergeProps(_props), prefixCls2 = _useMergeProps.prefixCls, disabledDate = _useMergeProps.disabledDate, onSelect = _useMergeProps.onSelect, picker = _useMergeProps.picker, rowNum = _useMergeProps.rowNum, colNum = _useMergeProps.colNum, prefixColumn = _useMergeProps.prefixColumn, rowClassName = _useMergeProps.rowClassName, baseDate = _useMergeProps.baseDate, getCellClassName = _useMergeProps.getCellClassName, getCellText = _useMergeProps.getCellText, getCellNode = _useMergeProps.getCellNode, getCellDate = _useMergeProps.getCellDate, generateConfig2 = _useMergeProps.generateConfig, titleCell = _useMergeProps.titleCell, headerCells = _useMergeProps.headerCells;
  var _useInjectPanel = useInjectPanel(), onDateMouseenter = _useInjectPanel.onDateMouseenter, onDateMouseleave = _useInjectPanel.onDateMouseleave, mode = _useInjectPanel.mode;
  var cellPrefixCls = "".concat(prefixCls2, "-cell");
  var rows = [];
  for (var i2 = 0; i2 < rowNum; i2 += 1) {
    var row = [];
    var rowStartDate = void 0;
    var _loop = function _loop2(j3) {
      var _extends2;
      var offset3 = i2 * colNum + j3;
      var currentDate = getCellDate(baseDate, offset3);
      var disabled = getCellDateDisabled({
        cellDate: currentDate,
        mode: mode.value,
        disabledDate,
        generateConfig: generateConfig2
      });
      if (j3 === 0) {
        rowStartDate = currentDate;
        if (prefixColumn) {
          row.push(prefixColumn(rowStartDate));
        }
      }
      var title = titleCell && titleCell(currentDate);
      row.push(createVNode("td", {
        "key": j3,
        "title": title,
        "class": classNames(cellPrefixCls, _extends$2((_extends2 = {}, _defineProperty$R(_extends2, "".concat(cellPrefixCls, "-disabled"), disabled), _defineProperty$R(_extends2, "".concat(cellPrefixCls, "-start"), getCellText(currentDate) === 1 || picker === "year" && Number(title) % 10 === 0), _defineProperty$R(_extends2, "".concat(cellPrefixCls, "-end"), title === getLastDay(generateConfig2, currentDate) || picker === "year" && Number(title) % 10 === 9), _extends2), getCellClassName(currentDate))),
        "onClick": function onClick2() {
          if (!disabled) {
            onSelect(currentDate);
          }
        },
        "onMouseenter": function onMouseenter2() {
          if (!disabled && onDateMouseenter) {
            onDateMouseenter(currentDate);
          }
        },
        "onMouseleave": function onMouseleave2() {
          if (!disabled && onDateMouseleave) {
            onDateMouseleave(currentDate);
          }
        }
      }, [getCellNode ? getCellNode(currentDate) : createVNode("div", {
        "class": "".concat(cellPrefixCls, "-inner")
      }, [getCellText(currentDate)])]));
    };
    for (var j2 = 0; j2 < colNum; j2 += 1) {
      _loop(j2);
    }
    rows.push(createVNode("tr", {
      "key": i2,
      "class": rowClassName && rowClassName(rowStartDate)
    }, [row]));
  }
  return createVNode("div", {
    "class": "".concat(prefixCls2, "-body")
  }, [createVNode("table", {
    "class": "".concat(prefixCls2, "-content")
  }, [headerCells && createVNode("thead", null, [createVNode("tr", null, [headerCells])]), createVNode("tbody", null, [rows])])]);
}
PanelBody.displayName = "PanelBody";
PanelBody.inheritAttrs = false;
var DECADE_COL_COUNT = 3;
var DECADE_ROW_COUNT = 4;
function DecadeBody(_props) {
  var props2 = useMergeProps(_props);
  var DECADE_UNIT_DIFF_DES = DECADE_UNIT_DIFF - 1;
  var prefixCls2 = props2.prefixCls, viewDate = props2.viewDate, generateConfig2 = props2.generateConfig;
  var cellPrefixCls = "".concat(prefixCls2, "-cell");
  var yearNumber = generateConfig2.getYear(viewDate);
  var decadeYearNumber = Math.floor(yearNumber / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
  var startDecadeYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
  var endDecadeYear = startDecadeYear + DECADE_DISTANCE_COUNT - 1;
  var baseDecadeYear = generateConfig2.setYear(viewDate, startDecadeYear - Math.ceil((DECADE_COL_COUNT * DECADE_ROW_COUNT * DECADE_UNIT_DIFF - DECADE_DISTANCE_COUNT) / 2));
  var getCellClassName = function getCellClassName2(date4) {
    var _ref;
    var startDecadeNumber = generateConfig2.getYear(date4);
    var endDecadeNumber = startDecadeNumber + DECADE_UNIT_DIFF_DES;
    return _ref = {}, _defineProperty$R(_ref, "".concat(cellPrefixCls, "-in-view"), startDecadeYear <= startDecadeNumber && endDecadeNumber <= endDecadeYear), _defineProperty$R(_ref, "".concat(cellPrefixCls, "-selected"), startDecadeNumber === decadeYearNumber), _ref;
  };
  return createVNode(PanelBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "rowNum": DECADE_ROW_COUNT,
    "colNum": DECADE_COL_COUNT,
    "baseDate": baseDecadeYear,
    "getCellText": function getCellText(date4) {
      var startDecadeNumber = generateConfig2.getYear(date4);
      return "".concat(startDecadeNumber, "-").concat(startDecadeNumber + DECADE_UNIT_DIFF_DES);
    },
    "getCellClassName": getCellClassName,
    "getCellDate": function getCellDate(date4, offset3) {
      return generateConfig2.addYear(date4, offset3 * DECADE_UNIT_DIFF);
    }
  }), null);
}
DecadeBody.displayName = "DecadeBody";
DecadeBody.inheritAttrs = false;
var scrollIds = new Map();
function waitElementReady(element, callback) {
  var id;
  function tryOrNextFrame() {
    if (isVisible(element)) {
      callback();
    } else {
      id = wrapperRaf(function() {
        tryOrNextFrame();
      });
    }
  }
  tryOrNextFrame();
  return function() {
    wrapperRaf.cancel(id);
  };
}
function scrollTo$1(element, to, duration) {
  if (scrollIds.get(element)) {
    wrapperRaf.cancel(scrollIds.get(element));
  }
  if (duration <= 0) {
    scrollIds.set(element, wrapperRaf(function() {
      element.scrollTop = to;
    }));
    return;
  }
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  scrollIds.set(element, wrapperRaf(function() {
    element.scrollTop += perTick;
    if (element.scrollTop !== to) {
      scrollTo$1(element, to, duration - 10);
    }
  }));
}
function createKeydownHandler(event, _ref) {
  var onLeftRight = _ref.onLeftRight, onCtrlLeftRight = _ref.onCtrlLeftRight, onUpDown = _ref.onUpDown, onPageUpDown = _ref.onPageUpDown, onEnter = _ref.onEnter;
  var which = event.which, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
  switch (which) {
    case KeyCode$1.LEFT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(-1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(-1);
        return true;
      }
      break;
    case KeyCode$1.RIGHT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(1);
        return true;
      }
      break;
    case KeyCode$1.UP:
      if (onUpDown) {
        onUpDown(-1);
        return true;
      }
      break;
    case KeyCode$1.DOWN:
      if (onUpDown) {
        onUpDown(1);
        return true;
      }
      break;
    case KeyCode$1.PAGE_UP:
      if (onPageUpDown) {
        onPageUpDown(-1);
        return true;
      }
      break;
    case KeyCode$1.PAGE_DOWN:
      if (onPageUpDown) {
        onPageUpDown(1);
        return true;
      }
      break;
    case KeyCode$1.ENTER:
      if (onEnter) {
        onEnter();
        return true;
      }
      break;
  }
  return false;
}
function getDefaultFormat(format3, picker, showTime, use12Hours) {
  var mergedFormat = format3;
  if (!mergedFormat) {
    switch (picker) {
      case "time":
        mergedFormat = use12Hours ? "hh:mm:ss a" : "HH:mm:ss";
        break;
      case "week":
        mergedFormat = "gggg-wo";
        break;
      case "month":
        mergedFormat = "YYYY-MM";
        break;
      case "quarter":
        mergedFormat = "YYYY-[Q]Q";
        break;
      case "year":
        mergedFormat = "YYYY";
        break;
      default:
        mergedFormat = showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    }
  }
  return mergedFormat;
}
function getInputSize(picker, format3, generateConfig2) {
  var defaultSize = picker === "time" ? 8 : 10;
  var length = typeof format3 === "function" ? format3(generateConfig2.getNow()).length : format3.length;
  return Math.max(defaultSize, length) + 2;
}
var globalClickFunc = null;
var clickCallbacks = new Set();
function addGlobalMousedownEvent(callback) {
  if (!globalClickFunc && typeof window !== "undefined" && window.addEventListener) {
    globalClickFunc = function globalClickFunc2(e2) {
      _toConsumableArray(clickCallbacks).forEach(function(queueFunc) {
        queueFunc(e2);
      });
    };
    window.addEventListener("mousedown", globalClickFunc);
  }
  clickCallbacks.add(callback);
  return function() {
    clickCallbacks.delete(callback);
    if (clickCallbacks.size === 0) {
      window.removeEventListener("mousedown", globalClickFunc);
      globalClickFunc = null;
    }
  };
}
function getTargetFromEvent(e2) {
  var _a2;
  var target = e2.target;
  if (e2.composed && target.shadowRoot) {
    return ((_a2 = e2.composedPath) === null || _a2 === void 0 ? void 0 : _a2.call(e2)[0]) || target;
  }
  return target;
}
var getYearNextMode = function getYearNextMode2(next2) {
  if (next2 === "month" || next2 === "date") {
    return "year";
  }
  return next2;
};
var getMonthNextMode = function getMonthNextMode2(next2) {
  if (next2 === "date") {
    return "month";
  }
  return next2;
};
var getQuarterNextMode = function getQuarterNextMode2(next2) {
  if (next2 === "month" || next2 === "date") {
    return "quarter";
  }
  return next2;
};
var getWeekNextMode = function getWeekNextMode2(next2) {
  if (next2 === "date") {
    return "week";
  }
  return next2;
};
var PickerModeMap = {
  year: getYearNextMode,
  month: getMonthNextMode,
  quarter: getQuarterNextMode,
  week: getWeekNextMode,
  time: null,
  date: null
};
function elementsContains(elements, target) {
  return elements.some(function(ele) {
    return ele && ele.contains(target);
  });
}
var DECADE_UNIT_DIFF = 10;
var DECADE_DISTANCE_COUNT = DECADE_UNIT_DIFF * 10;
function DecadePanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, onViewDateChange = props2.onViewDateChange, generateConfig2 = props2.generateConfig, viewDate = props2.viewDate, operationRef = props2.operationRef, onSelect = props2.onSelect, onPanelChange = props2.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls2, "-decade-panel");
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      return createKeydownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          onSelect(generateConfig2.addYear(viewDate, diff * DECADE_UNIT_DIFF), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          onSelect(generateConfig2.addYear(viewDate, diff * DECADE_DISTANCE_COUNT), "key");
        },
        onUpDown: function onUpDown(diff) {
          onSelect(generateConfig2.addYear(viewDate, diff * DECADE_UNIT_DIFF * DECADE_COL_COUNT), "key");
        },
        onEnter: function onEnter() {
          onPanelChange("year", viewDate);
        }
      });
    }
  };
  var onDecadesChange = function onDecadesChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff * DECADE_DISTANCE_COUNT);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  var onInternalSelect = function onInternalSelect2(date4) {
    onSelect(date4, "mouse");
    onPanelChange("year", date4);
  };
  return createVNode("div", {
    "class": panelPrefixCls
  }, [createVNode(DecadeHeader, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onPrevDecades": function onPrevDecades() {
      onDecadesChange(-1);
    },
    "onNextDecades": function onNextDecades() {
      onDecadesChange(1);
    }
  }), null), createVNode(DecadeBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onSelect": onInternalSelect
  }), null)]);
}
DecadePanel.displayName = "DecadePanel";
DecadePanel.inheritAttrs = false;
var WEEK_DAY_COUNT = 7;
function isNullEqual(value1, value2) {
  if (!value1 && !value2) {
    return true;
  }
  if (!value1 || !value2) {
    return false;
  }
  return void 0;
}
function isSameDecade(generateConfig2, decade1, decade2) {
  var equal = isNullEqual(decade1, decade2);
  if (typeof equal === "boolean") {
    return equal;
  }
  var num1 = Math.floor(generateConfig2.getYear(decade1) / 10);
  var num2 = Math.floor(generateConfig2.getYear(decade2) / 10);
  return num1 === num2;
}
function isSameYear(generateConfig2, year1, year2) {
  var equal = isNullEqual(year1, year2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.getYear(year1) === generateConfig2.getYear(year2);
}
function getQuarter(generateConfig2, date4) {
  var quota = Math.floor(generateConfig2.getMonth(date4) / 3);
  return quota + 1;
}
function isSameQuarter(generateConfig2, quarter1, quarter2) {
  var equal = isNullEqual(quarter1, quarter2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return isSameYear(generateConfig2, quarter1, quarter2) && getQuarter(generateConfig2, quarter1) === getQuarter(generateConfig2, quarter2);
}
function isSameMonth(generateConfig2, month1, month2) {
  var equal = isNullEqual(month1, month2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return isSameYear(generateConfig2, month1, month2) && generateConfig2.getMonth(month1) === generateConfig2.getMonth(month2);
}
function isSameDate(generateConfig2, date1, date22) {
  var equal = isNullEqual(date1, date22);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.getYear(date1) === generateConfig2.getYear(date22) && generateConfig2.getMonth(date1) === generateConfig2.getMonth(date22) && generateConfig2.getDate(date1) === generateConfig2.getDate(date22);
}
function isSameTime(generateConfig2, time1, time2) {
  var equal = isNullEqual(time1, time2);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.getHour(time1) === generateConfig2.getHour(time2) && generateConfig2.getMinute(time1) === generateConfig2.getMinute(time2) && generateConfig2.getSecond(time1) === generateConfig2.getSecond(time2);
}
function isSameWeek(generateConfig2, locale2, date1, date22) {
  var equal = isNullEqual(date1, date22);
  if (typeof equal === "boolean") {
    return equal;
  }
  return generateConfig2.locale.getWeek(locale2, date1) === generateConfig2.locale.getWeek(locale2, date22);
}
function isEqual$1(generateConfig2, value1, value2) {
  return isSameDate(generateConfig2, value1, value2) && isSameTime(generateConfig2, value1, value2);
}
function isInRange(generateConfig2, startDate, endDate, current2) {
  if (!startDate || !endDate || !current2) {
    return false;
  }
  return !isSameDate(generateConfig2, startDate, current2) && !isSameDate(generateConfig2, endDate, current2) && generateConfig2.isAfter(current2, startDate) && generateConfig2.isAfter(endDate, current2);
}
function getWeekStartDate(locale2, generateConfig2, value) {
  var weekFirstDay = generateConfig2.locale.getWeekFirstDay(locale2);
  var monthStartDate = generateConfig2.setDate(value, 1);
  var startDateWeekDay = generateConfig2.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig2.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
  if (generateConfig2.getMonth(alignStartDate) === generateConfig2.getMonth(value) && generateConfig2.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig2.addDate(alignStartDate, -7);
  }
  return alignStartDate;
}
function getClosingViewDate(viewDate, picker, generateConfig2) {
  var offset3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  switch (picker) {
    case "year":
      return generateConfig2.addYear(viewDate, offset3 * 10);
    case "quarter":
    case "month":
      return generateConfig2.addYear(viewDate, offset3);
    default:
      return generateConfig2.addMonth(viewDate, offset3);
  }
}
function formatValue(value, _ref) {
  var generateConfig2 = _ref.generateConfig, locale2 = _ref.locale, format3 = _ref.format;
  return typeof format3 === "function" ? format3(value) : generateConfig2.locale.format(locale2.locale, value, format3);
}
function parseValue(value, _ref2) {
  var generateConfig2 = _ref2.generateConfig, locale2 = _ref2.locale, formatList = _ref2.formatList;
  if (!value || typeof formatList[0] === "function") {
    return null;
  }
  return generateConfig2.locale.parse(locale2.locale, value, formatList);
}
function getCellDateDisabled(_ref3) {
  var cellDate = _ref3.cellDate, mode = _ref3.mode, disabledDate = _ref3.disabledDate, generateConfig2 = _ref3.generateConfig;
  if (!disabledDate)
    return false;
  var getDisabledFromRange = function getDisabledFromRange2(currentMode, start2, end) {
    var current2 = start2;
    while (current2 <= end) {
      var date4 = void 0;
      switch (currentMode) {
        case "date": {
          date4 = generateConfig2.setDate(cellDate, current2);
          if (!disabledDate(date4)) {
            return false;
          }
          break;
        }
        case "month": {
          date4 = generateConfig2.setMonth(cellDate, current2);
          if (!getCellDateDisabled({
            cellDate: date4,
            mode: "month",
            generateConfig: generateConfig2,
            disabledDate
          })) {
            return false;
          }
          break;
        }
        case "year": {
          date4 = generateConfig2.setYear(cellDate, current2);
          if (!getCellDateDisabled({
            cellDate: date4,
            mode: "year",
            generateConfig: generateConfig2,
            disabledDate
          })) {
            return false;
          }
          break;
        }
      }
      current2 += 1;
    }
    return true;
  };
  switch (mode) {
    case "date":
    case "week": {
      return disabledDate(cellDate);
    }
    case "month": {
      var startDate = 1;
      var endDate = generateConfig2.getDate(generateConfig2.getEndDate(cellDate));
      return getDisabledFromRange("date", startDate, endDate);
    }
    case "quarter": {
      var startMonth = Math.floor(generateConfig2.getMonth(cellDate) / 3) * 3;
      var endMonth = startMonth + 2;
      return getDisabledFromRange("month", startMonth, endMonth);
    }
    case "year": {
      return getDisabledFromRange("month", 0, 11);
    }
    case "decade": {
      var year = generateConfig2.getYear(cellDate);
      var startYear = Math.floor(year / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
      var endYear = startYear + DECADE_UNIT_DIFF - 1;
      return getDisabledFromRange("year", startYear, endYear);
    }
  }
}
function TimeHeader(_props) {
  var props2 = useMergeProps(_props);
  var _useInjectPanel = useInjectPanel(), hideHeader = _useInjectPanel.hideHeader;
  if (hideHeader.value) {
    return null;
  }
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, locale2 = props2.locale, value = props2.value, format3 = props2.format;
  var headerPrefixCls = "".concat(prefixCls2, "-header");
  return createVNode(Header$1, {
    "prefixCls": headerPrefixCls
  }, {
    default: function _default7() {
      return [value ? formatValue(value, {
        locale: locale2,
        format: format3,
        generateConfig: generateConfig2
      }) : "\xA0"];
    }
  });
}
TimeHeader.displayName = "TimeHeader";
TimeHeader.inheritAttrs = false;
var TimeUnitColumn = defineComponent({
  name: "TimeUnitColumn",
  props: ["prefixCls", "units", "onSelect", "value", "active", "hideDisabledOptions"],
  setup: function setup54(props2) {
    var _useInjectPanel = useInjectPanel(), open2 = _useInjectPanel.open;
    var ulRef = ref(null);
    var liRefs = ref(new Map());
    var scrollRef = ref();
    watch(function() {
      return props2.value;
    }, function() {
      var li = liRefs.value.get(props2.value);
      if (li && open2.value !== false) {
        scrollTo$1(ulRef.value, li.offsetTop, 120);
      }
    });
    onBeforeUnmount(function() {
      var _a2;
      (_a2 = scrollRef.value) === null || _a2 === void 0 ? void 0 : _a2.call(scrollRef);
    });
    watch(open2, function() {
      var _a2;
      (_a2 = scrollRef.value) === null || _a2 === void 0 ? void 0 : _a2.call(scrollRef);
      nextTick(function() {
        if (open2.value) {
          var li = liRefs.value.get(props2.value);
          if (li) {
            scrollRef.value = waitElementReady(li, function() {
              scrollTo$1(ulRef.value, li.offsetTop, 0);
            });
          }
        }
      });
    }, {
      immediate: true,
      flush: "post"
    });
    return function() {
      var prefixCls2 = props2.prefixCls, units = props2.units, onSelect = props2.onSelect, value = props2.value, active = props2.active, hideDisabledOptions = props2.hideDisabledOptions;
      var cellPrefixCls = "".concat(prefixCls2, "-cell");
      return createVNode("ul", {
        "class": classNames("".concat(prefixCls2, "-column"), _defineProperty$R({}, "".concat(prefixCls2, "-column-active"), active)),
        "ref": ulRef,
        "style": {
          position: "relative"
        }
      }, [units.map(function(unit) {
        var _classNames2;
        if (hideDisabledOptions && unit.disabled) {
          return null;
        }
        return createVNode("li", {
          "key": unit.value,
          "ref": function ref2(element) {
            liRefs.value.set(unit.value, element);
          },
          "class": classNames(cellPrefixCls, (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(cellPrefixCls, "-disabled"), unit.disabled), _defineProperty$R(_classNames2, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames2)),
          "onClick": function onClick2() {
            if (unit.disabled) {
              return;
            }
            onSelect(unit.value);
          }
        }, [createVNode("div", {
          "class": "".concat(cellPrefixCls, "-inner")
        }, [unit.label])]);
      })]);
    };
  }
});
function leftPad(str, length) {
  var fill = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  var current2 = String(str);
  while (current2.length < length) {
    current2 = "".concat(fill).concat(str);
  }
  return current2;
}
var tuple2 = function tuple3() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
function toArray$6(val) {
  if (val === null || val === void 0) {
    return [];
  }
  return Array.isArray(val) ? val : [val];
}
function getDataOrAriaProps(props2) {
  var retProps = {};
  Object.keys(props2).forEach(function(key2) {
    if ((key2.substr(0, 5) === "data-" || key2.substr(0, 5) === "aria-" || key2 === "role" || key2 === "name") && key2.substr(0, 7) !== "data-__") {
      retProps[key2] = props2[key2];
    }
  });
  return retProps;
}
function getValue$2(values, index2) {
  return values ? values[index2] : null;
}
function updateValues(values, value, index2) {
  var newValues = [getValue$2(values, 0), getValue$2(values, 1)];
  newValues[index2] = typeof value === "function" ? value(newValues[index2]) : value;
  if (!newValues[0] && !newValues[1]) {
    return null;
  }
  return newValues;
}
function generateUnits(start2, end, step, disabledUnits) {
  var units = [];
  for (var i2 = start2; i2 <= end; i2 += step) {
    units.push({
      label: leftPad(i2, 2),
      value: i2,
      disabled: (disabledUnits || []).includes(i2)
    });
  }
  return units;
}
var TimeBody = defineComponent({
  name: "TimeBody",
  inheritAttrs: false,
  props: ["generateConfig", "prefixCls", "operationRef", "activeColumnIndex", "value", "showHour", "showMinute", "showSecond", "use12Hours", "hourStep", "minuteStep", "secondStep", "disabledHours", "disabledMinutes", "disabledSeconds", "disabledTime", "hideDisabledOptions", "onSelect"],
  setup: function setup55(props2) {
    var originHour = computed(function() {
      return props2.value ? props2.generateConfig.getHour(props2.value) : -1;
    });
    var isPM = computed(function() {
      if (props2.use12Hours) {
        return originHour.value >= 12;
      } else {
        return false;
      }
    });
    var hour = computed(function() {
      if (props2.use12Hours) {
        return originHour.value % 12;
      } else {
        return originHour.value;
      }
    });
    var minute = computed(function() {
      return props2.value ? props2.generateConfig.getMinute(props2.value) : -1;
    });
    var second = computed(function() {
      return props2.value ? props2.generateConfig.getSecond(props2.value) : -1;
    });
    var now2 = ref(props2.generateConfig.getNow());
    var mergedDisabledHours = ref();
    var mergedDisabledMinutes = ref();
    var mergedDisabledSeconds = ref();
    onBeforeUpdate(function() {
      now2.value = props2.generateConfig.getNow();
    });
    watchEffect(function() {
      if (props2.disabledTime) {
        var disabledConfig = props2.disabledTime(now2);
        var _ref = [disabledConfig.disabledHours, disabledConfig.disabledMinutes, disabledConfig.disabledSeconds];
        mergedDisabledHours.value = _ref[0];
        mergedDisabledMinutes.value = _ref[1];
        mergedDisabledSeconds.value = _ref[2];
      } else {
        var _ref2 = [props2.disabledHours, props2.disabledMinutes, props2.disabledSeconds];
        mergedDisabledHours.value = _ref2[0];
        mergedDisabledMinutes.value = _ref2[1];
        mergedDisabledSeconds.value = _ref2[2];
      }
    });
    var setTime$1 = function setTime$12(isNewPM, newHour, newMinute, newSecond) {
      var newDate = props2.value || props2.generateConfig.getNow();
      var mergedHour = Math.max(0, newHour);
      var mergedMinute = Math.max(0, newMinute);
      var mergedSecond = Math.max(0, newSecond);
      newDate = setTime(props2.generateConfig, newDate, !props2.use12Hours || !isNewPM ? mergedHour : mergedHour + 12, mergedMinute, mergedSecond);
      return newDate;
    };
    var rawHours = computed(function() {
      var _a2;
      return generateUnits(0, 23, (_a2 = props2.hourStep) !== null && _a2 !== void 0 ? _a2 : 1, mergedDisabledHours.value && mergedDisabledHours.value());
    });
    var AMPMDisabled = computed(function() {
      if (!props2.use12Hours) {
        return [false, false];
      }
      var AMPMDisabled2 = [true, true];
      rawHours.value.forEach(function(_ref3) {
        var disabled = _ref3.disabled, hourValue = _ref3.value;
        if (disabled)
          return;
        if (hourValue >= 12) {
          AMPMDisabled2[1] = false;
        } else {
          AMPMDisabled2[0] = false;
        }
      });
      return AMPMDisabled2;
    });
    var hours = computed(function() {
      if (!props2.use12Hours)
        return rawHours.value;
      return rawHours.value.filter(isPM.value ? function(hourMeta) {
        return hourMeta.value >= 12;
      } : function(hourMeta) {
        return hourMeta.value < 12;
      }).map(function(hourMeta) {
        var hourValue = hourMeta.value % 12;
        var hourLabel = hourValue === 0 ? "12" : leftPad(hourValue, 2);
        return _extends$2(_extends$2({}, hourMeta), {
          label: hourLabel,
          value: hourValue
        });
      });
    });
    var minutes = computed(function() {
      var _a2;
      return generateUnits(0, 59, (_a2 = props2.minuteStep) !== null && _a2 !== void 0 ? _a2 : 1, mergedDisabledMinutes.value && mergedDisabledMinutes.value(originHour.value));
    });
    var seconds = computed(function() {
      var _a2;
      return generateUnits(0, 59, (_a2 = props2.secondStep) !== null && _a2 !== void 0 ? _a2 : 1, mergedDisabledSeconds.value && mergedDisabledSeconds.value(originHour.value, minute));
    });
    return function() {
      var prefixCls2 = props2.prefixCls, operationRef = props2.operationRef, activeColumnIndex = props2.activeColumnIndex, showHour = props2.showHour, showMinute = props2.showMinute, showSecond = props2.showSecond, use12Hours = props2.use12Hours, hideDisabledOptions = props2.hideDisabledOptions, onSelect = props2.onSelect;
      var columns2 = [];
      var contentPrefixCls = "".concat(prefixCls2, "-content");
      var columnPrefixCls = "".concat(prefixCls2, "-time-panel");
      operationRef.value = {
        onUpDown: function onUpDown(diff) {
          var column = columns2[activeColumnIndex];
          if (column) {
            var valueIndex = column.units.findIndex(function(unit) {
              return unit.value === column.value;
            });
            var unitLen = column.units.length;
            for (var i2 = 1; i2 < unitLen; i2 += 1) {
              var nextUnit = column.units[(valueIndex + diff * i2 + unitLen) % unitLen];
              if (nextUnit.disabled !== true) {
                column.onSelect(nextUnit.value);
                break;
              }
            }
          }
        }
      };
      function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
        if (condition !== false) {
          columns2.push({
            node: cloneElement(node, {
              prefixCls: columnPrefixCls,
              value: columnValue,
              active: activeColumnIndex === columns2.length,
              onSelect: onColumnSelect,
              units,
              hideDisabledOptions
            }),
            onSelect: onColumnSelect,
            value: columnValue,
            units
          });
        }
      }
      addColumnNode(showHour, createVNode(TimeUnitColumn, {
        "key": "hour"
      }, null), hour.value, hours.value, function(num) {
        onSelect(setTime$1(isPM.value, num, minute.value, second.value), "mouse");
      });
      addColumnNode(showMinute, createVNode(TimeUnitColumn, {
        "key": "minute"
      }, null), minute.value, minutes.value, function(num) {
        onSelect(setTime$1(isPM.value, hour.value, num, second.value), "mouse");
      });
      addColumnNode(showSecond, createVNode(TimeUnitColumn, {
        "key": "second"
      }, null), second.value, seconds.value, function(num) {
        onSelect(setTime$1(isPM.value, hour.value, minute.value, num), "mouse");
      });
      var PMIndex = -1;
      if (typeof isPM.value === "boolean") {
        PMIndex = isPM.value ? 1 : 0;
      }
      addColumnNode(use12Hours === true, createVNode(TimeUnitColumn, {
        "key": "12hours"
      }, null), PMIndex, [{
        label: "AM",
        value: 0,
        disabled: AMPMDisabled.value[0]
      }, {
        label: "PM",
        value: 1,
        disabled: AMPMDisabled.value[1]
      }], function(num) {
        onSelect(setTime$1(!!num, hour.value, minute.value, second.value), "mouse");
      });
      return createVNode("div", {
        "class": contentPrefixCls
      }, [columns2.map(function(_ref4) {
        var node = _ref4.node;
        return node;
      })]);
    };
  }
});
var TimeBody$1 = TimeBody;
var countBoolean = function countBoolean2(boolList) {
  return boolList.filter(function(bool) {
    return bool !== false;
  }).length;
};
function TimePanel(_props) {
  var props2 = useMergeProps(_props);
  var generateConfig2 = props2.generateConfig, _props$format = props2.format, format3 = _props$format === void 0 ? "HH:mm:ss" : _props$format, prefixCls2 = props2.prefixCls, active = props2.active, operationRef = props2.operationRef, showHour = props2.showHour, showMinute = props2.showMinute, showSecond = props2.showSecond, _props$use12Hours = props2.use12Hours, use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours, onSelect = props2.onSelect, value = props2.value;
  var panelPrefixCls = "".concat(prefixCls2, "-time-panel");
  var bodyOperationRef = ref();
  var activeColumnIndex = ref(-1);
  var columnsCount = countBoolean([showHour, showMinute, showSecond, use12Hours]);
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      return createKeydownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          activeColumnIndex.value = (activeColumnIndex.value + diff + columnsCount) % columnsCount;
        },
        onUpDown: function onUpDown(diff) {
          if (activeColumnIndex.value === -1) {
            activeColumnIndex.value = 0;
          } else if (bodyOperationRef.value) {
            bodyOperationRef.value.onUpDown(diff);
          }
        },
        onEnter: function onEnter() {
          onSelect(value || generateConfig2.getNow(), "key");
          activeColumnIndex.value = -1;
        }
      });
    },
    onBlur: function onBlur2() {
      activeColumnIndex.value = -1;
    }
  };
  return createVNode("div", {
    "class": classNames(panelPrefixCls, _defineProperty$R({}, "".concat(panelPrefixCls, "-active"), active))
  }, [createVNode(TimeHeader, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "format": format3,
    "prefixCls": prefixCls2
  }), null), createVNode(TimeBody$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "activeColumnIndex": activeColumnIndex.value,
    "operationRef": bodyOperationRef
  }), null)]);
}
TimePanel.displayName = "TimePanel";
TimePanel.inheritAttrs = false;
function useCellClassName(_ref) {
  var cellPrefixCls = _ref.cellPrefixCls, generateConfig2 = _ref.generateConfig, rangedValue = _ref.rangedValue, hoverRangedValue = _ref.hoverRangedValue, isInView = _ref.isInView, isSameCell = _ref.isSameCell, offsetCell = _ref.offsetCell, today = _ref.today, value = _ref.value;
  function getClassName(currentDate) {
    var _ref2;
    var prevDate = offsetCell(currentDate, -1);
    var nextDate = offsetCell(currentDate, 1);
    var rangeStart = getValue$2(rangedValue, 0);
    var rangeEnd = getValue$2(rangedValue, 1);
    var hoverStart = getValue$2(hoverRangedValue, 0);
    var hoverEnd = getValue$2(hoverRangedValue, 1);
    var isRangeHovered = isInRange(generateConfig2, hoverStart, hoverEnd, currentDate);
    function isRangeStart(date4) {
      return isSameCell(rangeStart, date4);
    }
    function isRangeEnd(date4) {
      return isSameCell(rangeEnd, date4);
    }
    var isHoverStart = isSameCell(hoverStart, currentDate);
    var isHoverEnd = isSameCell(hoverEnd, currentDate);
    var isHoverEdgeStart = (isRangeHovered || isHoverEnd) && (!isInView(prevDate) || isRangeEnd(prevDate));
    var isHoverEdgeEnd = (isRangeHovered || isHoverStart) && (!isInView(nextDate) || isRangeStart(nextDate));
    return _ref2 = {}, _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-in-view"), isInView(currentDate)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-in-range"), isInRange(generateConfig2, rangeStart, rangeEnd, currentDate)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-start"), isRangeStart(currentDate)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-end"), isRangeEnd(currentDate)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-start-single"), isRangeStart(currentDate) && !rangeEnd), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-end-single"), isRangeEnd(currentDate) && !rangeStart), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-start-near-hover"), isRangeStart(currentDate) && (isSameCell(prevDate, hoverStart) || isInRange(generateConfig2, hoverStart, hoverEnd, prevDate))), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-end-near-hover"), isRangeEnd(currentDate) && (isSameCell(nextDate, hoverEnd) || isInRange(generateConfig2, hoverStart, hoverEnd, nextDate))), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover"), isRangeHovered), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover-start"), isHoverStart), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover-end"), isHoverEnd), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start"), isHoverEdgeStart), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end"), isHoverEdgeEnd), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start-near-range"), isHoverEdgeStart && isSameCell(prevDate, rangeEnd)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end-near-range"), isHoverEdgeEnd && isSameCell(nextDate, rangeStart)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-today"), isSameCell(today, currentDate)), _defineProperty$R(_ref2, "".concat(cellPrefixCls, "-selected"), isSameCell(value, currentDate)), _ref2;
  }
  return getClassName;
}
var RangeContextKey = Symbol("RangeContextProps");
var useProvideRange = function useProvideRange2(props2) {
  provide(RangeContextKey, props2);
};
var useInjectRange = function useInjectRange2() {
  return inject(RangeContextKey, {
    rangedValue: ref(),
    hoverRangedValue: ref(),
    inRange: ref(),
    panelPosition: ref()
  });
};
var RangeContextProvider = defineComponent({
  name: "PanelContextProvider",
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: function _default3() {
        return {};
      }
    }
  },
  setup: function setup56(props2, _ref) {
    var slots = _ref.slots;
    var value = {
      rangedValue: ref(props2.value.rangedValue),
      hoverRangedValue: ref(props2.value.hoverRangedValue),
      inRange: ref(props2.value.inRange),
      panelPosition: ref(props2.value.panelPosition)
    };
    useProvideRange(value);
    watch(function() {
      return props2.value;
    }, function() {
      Object.keys(props2.value).forEach(function(key2) {
        if (value[key2]) {
          value[key2].value = props2.value[key2];
        }
      });
    });
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
function DateBody(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, prefixColumn = props2.prefixColumn, locale2 = props2.locale, rowCount = props2.rowCount, viewDate = props2.viewDate, value = props2.value, dateRender = props2.dateRender;
  var _useInjectRange = useInjectRange(), rangedValue = _useInjectRange.rangedValue, hoverRangedValue = _useInjectRange.hoverRangedValue;
  var baseDate = getWeekStartDate(locale2.locale, generateConfig2, viewDate);
  var cellPrefixCls = "".concat(prefixCls2, "-cell");
  var weekFirstDay = generateConfig2.locale.getWeekFirstDay(locale2.locale);
  var today = generateConfig2.getNow();
  var headerCells = [];
  var weekDaysLocale = locale2.shortWeekDays || (generateConfig2.locale.getShortWeekDays ? generateConfig2.locale.getShortWeekDays(locale2.locale) : []);
  if (prefixColumn) {
    headerCells.push(createVNode("th", {
      "key": "empty",
      "aria-label": "empty cell"
    }, null));
  }
  for (var i2 = 0; i2 < WEEK_DAY_COUNT; i2 += 1) {
    headerCells.push(createVNode("th", {
      "key": i2
    }, [weekDaysLocale[(i2 + weekFirstDay) % WEEK_DAY_COUNT]]));
  }
  var getCellClassName = useCellClassName({
    cellPrefixCls,
    today,
    value,
    generateConfig: generateConfig2,
    rangedValue: prefixColumn ? null : rangedValue.value,
    hoverRangedValue: prefixColumn ? null : hoverRangedValue.value,
    isSameCell: function isSameCell(current2, target) {
      return isSameDate(generateConfig2, current2, target);
    },
    isInView: function isInView(date4) {
      return isSameMonth(generateConfig2, date4, viewDate);
    },
    offsetCell: function offsetCell(date4, offset3) {
      return generateConfig2.addDate(date4, offset3);
    }
  });
  var getCellNode = dateRender ? function(date4) {
    return dateRender({
      current: date4,
      today
    });
  } : void 0;
  return createVNode(PanelBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "rowNum": rowCount,
    "colNum": WEEK_DAY_COUNT,
    "baseDate": baseDate,
    "getCellNode": getCellNode,
    "getCellText": generateConfig2.getDate,
    "getCellClassName": getCellClassName,
    "getCellDate": generateConfig2.addDate,
    "titleCell": function titleCell(date4) {
      return formatValue(date4, {
        locale: locale2,
        format: "YYYY-MM-DD",
        generateConfig: generateConfig2
      });
    },
    "headerCells": headerCells
  }), null);
}
DateBody.displayName = "DateBody";
DateBody.inheritAttrs = false;
DateBody.props = [
  "prefixCls",
  "generateConfig",
  "value?",
  "viewDate",
  "locale",
  "rowCount",
  "onSelect",
  "dateRender?",
  "disabledDate?",
  "prefixColumn?",
  "rowClassName?"
];
function DateHeader(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, locale2 = props2.locale, viewDate = props2.viewDate, onNextMonth = props2.onNextMonth, onPrevMonth = props2.onPrevMonth, onNextYear = props2.onNextYear, onPrevYear = props2.onPrevYear, onYearClick = props2.onYearClick, onMonthClick = props2.onMonthClick;
  var _useInjectPanel = useInjectPanel(), hideHeader = _useInjectPanel.hideHeader;
  if (hideHeader.value) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls2, "-header");
  var monthsLocale = locale2.shortMonths || (generateConfig2.locale.getShortMonths ? generateConfig2.locale.getShortMonths(locale2.locale) : []);
  var month = generateConfig2.getMonth(viewDate);
  var yearNode = createVNode("button", {
    "type": "button",
    "key": "year",
    "onClick": onYearClick,
    "tabindex": -1,
    "class": "".concat(prefixCls2, "-year-btn")
  }, [formatValue(viewDate, {
    locale: locale2,
    format: locale2.yearFormat,
    generateConfig: generateConfig2
  })]);
  var monthNode = createVNode("button", {
    "type": "button",
    "key": "month",
    "onClick": onMonthClick,
    "tabindex": -1,
    "class": "".concat(prefixCls2, "-month-btn")
  }, [locale2.monthFormat ? formatValue(viewDate, {
    locale: locale2,
    format: locale2.monthFormat,
    generateConfig: generateConfig2
  }) : monthsLocale[month]]);
  var monthYearNodes = locale2.monthBeforeYear ? [monthNode, yearNode] : [yearNode, monthNode];
  return createVNode(Header$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": headerPrefixCls,
    "onSuperPrev": onPrevYear,
    "onPrev": onPrevMonth,
    "onNext": onNextMonth,
    "onSuperNext": onNextYear
  }), {
    default: function _default7() {
      return [monthYearNodes];
    }
  });
}
DateHeader.displayName = "DateHeader";
DateHeader.inheritAttrs = false;
var DATE_ROW_COUNT = 6;
function DatePanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, _props$panelName = props2.panelName, panelName = _props$panelName === void 0 ? "date" : _props$panelName, keyboardConfig = props2.keyboardConfig, active = props2.active, operationRef = props2.operationRef, generateConfig2 = props2.generateConfig, value = props2.value, viewDate = props2.viewDate, onViewDateChange = props2.onViewDateChange, onPanelChange = props2.onPanelChange, _onSelect = props2.onSelect;
  var panelPrefixCls = "".concat(prefixCls2, "-").concat(panelName, "-panel");
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      return createKeydownHandler(event, _extends$2({
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addDate(value || viewDate, diff), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addDate(value || viewDate, diff * WEEK_DAY_COUNT), "key");
        },
        onPageUpDown: function onPageUpDown(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff), "key");
        }
      }, keyboardConfig));
    }
  };
  var onYearChange = function onYearChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  var onMonthChange = function onMonthChange2(diff) {
    var newDate = generateConfig2.addMonth(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return createVNode("div", {
    "class": classNames(panelPrefixCls, _defineProperty$R({}, "".concat(panelPrefixCls, "-active"), active))
  }, [createVNode(DateHeader, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "value": value,
    "viewDate": viewDate,
    "onPrevYear": function onPrevYear() {
      onYearChange(-1);
    },
    "onNextYear": function onNextYear() {
      onYearChange(1);
    },
    "onPrevMonth": function onPrevMonth() {
      onMonthChange(-1);
    },
    "onNextMonth": function onNextMonth() {
      onMonthChange(1);
    },
    "onMonthClick": function onMonthClick() {
      onPanelChange("month", viewDate);
    },
    "onYearClick": function onYearClick() {
      onPanelChange("year", viewDate);
    }
  }), null), createVNode(DateBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "onSelect": function onSelect(date4) {
      return _onSelect(date4, "mouse");
    },
    "prefixCls": prefixCls2,
    "value": value,
    "viewDate": viewDate,
    "rowCount": DATE_ROW_COUNT
  }), null)]);
}
DatePanel.displayName = "DatePanel";
DatePanel.inheritAttrs = false;
var ACTIVE_PANEL = tuple2("date", "time");
function DatetimePanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, operationRef = props2.operationRef, generateConfig2 = props2.generateConfig, value = props2.value, defaultValue = props2.defaultValue, disabledTime = props2.disabledTime, showTime = props2.showTime, onSelect = props2.onSelect;
  var panelPrefixCls = "".concat(prefixCls2, "-datetime-panel");
  var activePanel = ref(null);
  var dateOperationRef = ref({});
  var timeOperationRef = ref({});
  var timeProps = _typeof$2(showTime) === "object" ? _extends$2({}, showTime) : {};
  function getNextActive(offset3) {
    var activeIndex = ACTIVE_PANEL.indexOf(activePanel.value) + offset3;
    var nextActivePanel = ACTIVE_PANEL[activeIndex] || null;
    return nextActivePanel;
  }
  var onBlur2 = function onBlur3(e2) {
    if (timeOperationRef.value.onBlur) {
      timeOperationRef.value.onBlur(e2);
    }
    activePanel.value = null;
  };
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      if (event.which === KeyCode$1.TAB) {
        var nextActivePanel = getNextActive(event.shiftKey ? -1 : 1);
        activePanel.value = nextActivePanel;
        if (nextActivePanel) {
          event.preventDefault();
        }
        return true;
      }
      if (activePanel.value) {
        var _ref = activePanel.value === "date" ? dateOperationRef : timeOperationRef;
        if (_ref.value && _ref.value.onKeydown) {
          _ref.value.onKeydown(event);
        }
        return true;
      }
      if ([KeyCode$1.LEFT, KeyCode$1.RIGHT, KeyCode$1.UP, KeyCode$1.DOWN].includes(event.which)) {
        activePanel.value = "date";
        return true;
      }
      return false;
    },
    onBlur: onBlur2,
    onClose: onBlur2
  };
  var onInternalSelect = function onInternalSelect2(date4, source) {
    var selectedDate = date4;
    if (source === "date" && !value && timeProps.defaultValue) {
      selectedDate = generateConfig2.setHour(selectedDate, generateConfig2.getHour(timeProps.defaultValue));
      selectedDate = generateConfig2.setMinute(selectedDate, generateConfig2.getMinute(timeProps.defaultValue));
      selectedDate = generateConfig2.setSecond(selectedDate, generateConfig2.getSecond(timeProps.defaultValue));
    } else if (source === "time" && !value && defaultValue) {
      selectedDate = generateConfig2.setYear(selectedDate, generateConfig2.getYear(defaultValue));
      selectedDate = generateConfig2.setMonth(selectedDate, generateConfig2.getMonth(defaultValue));
      selectedDate = generateConfig2.setDate(selectedDate, generateConfig2.getDate(defaultValue));
    }
    if (onSelect) {
      onSelect(selectedDate, "mouse");
    }
  };
  var disabledTimes = disabledTime ? disabledTime(value || null) : {};
  return createVNode("div", {
    "class": classNames(panelPrefixCls, _defineProperty$R({}, "".concat(panelPrefixCls, "-active"), activePanel.value))
  }, [createVNode(DatePanel, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "operationRef": dateOperationRef,
    "active": activePanel.value === "date",
    "onSelect": function onSelect2(date4) {
      onInternalSelect(setDateTime(generateConfig2, date4, !value && _typeof$2(showTime) === "object" ? showTime.defaultValue : null), "date");
    }
  }), null), createVNode(TimePanel, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "format": void 0
  }, timeProps), disabledTimes), {}, {
    "disabledTime": null,
    "defaultValue": void 0,
    "operationRef": timeOperationRef,
    "active": activePanel.value === "time",
    "onSelect": function onSelect2(date4) {
      onInternalSelect(date4, "time");
    }
  }), null)]);
}
DatetimePanel.displayName = "DatetimePanel";
DatetimePanel.inheritAttrs = false;
function WeekPanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, locale2 = props2.locale, value = props2.value;
  var cellPrefixCls = "".concat(prefixCls2, "-cell");
  var prefixColumn = function prefixColumn2(date4) {
    return createVNode("td", {
      "key": "week",
      "class": classNames(cellPrefixCls, "".concat(cellPrefixCls, "-week"))
    }, [generateConfig2.locale.getWeek(locale2.locale, date4)]);
  };
  var rowPrefixCls = "".concat(prefixCls2, "-week-panel-row");
  var rowClassName = function rowClassName2(date4) {
    return classNames(rowPrefixCls, _defineProperty$R({}, "".concat(rowPrefixCls, "-selected"), isSameWeek(generateConfig2, locale2.locale, value, date4)));
  };
  return createVNode(DatePanel, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "panelName": "week",
    "prefixColumn": prefixColumn,
    "rowClassName": rowClassName,
    "keyboardConfig": {
      onLeftRight: null
    }
  }), null);
}
WeekPanel.displayName = "WeekPanel";
WeekPanel.inheritAttrs = false;
function MonthHeader(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, locale2 = props2.locale, viewDate = props2.viewDate, onNextYear = props2.onNextYear, onPrevYear = props2.onPrevYear, onYearClick = props2.onYearClick;
  var _useInjectPanel = useInjectPanel(), hideHeader = _useInjectPanel.hideHeader;
  if (hideHeader.value) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls2, "-header");
  return createVNode(Header$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": headerPrefixCls,
    "onSuperPrev": onPrevYear,
    "onSuperNext": onNextYear
  }), {
    default: function _default7() {
      return [createVNode("button", {
        "type": "button",
        "onClick": onYearClick,
        "class": "".concat(prefixCls2, "-year-btn")
      }, [formatValue(viewDate, {
        locale: locale2,
        format: locale2.yearFormat,
        generateConfig: generateConfig2
      })])];
    }
  });
}
MonthHeader.displayName = "MonthHeader";
MonthHeader.inheritAttrs = false;
var MONTH_COL_COUNT = 3;
var MONTH_ROW_COUNT = 4;
function MonthBody(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, locale2 = props2.locale, value = props2.value, viewDate = props2.viewDate, generateConfig2 = props2.generateConfig, monthCellRender = props2.monthCellRender;
  var _useInjectRange = useInjectRange(), rangedValue = _useInjectRange.rangedValue, hoverRangedValue = _useInjectRange.hoverRangedValue;
  var cellPrefixCls = "".concat(prefixCls2, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls,
    value,
    generateConfig: generateConfig2,
    rangedValue: rangedValue.value,
    hoverRangedValue: hoverRangedValue.value,
    isSameCell: function isSameCell(current2, target) {
      return isSameMonth(generateConfig2, current2, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date4, offset3) {
      return generateConfig2.addMonth(date4, offset3);
    }
  });
  var monthsLocale = locale2.shortMonths || (generateConfig2.locale.getShortMonths ? generateConfig2.locale.getShortMonths(locale2.locale) : []);
  var baseMonth = generateConfig2.setMonth(viewDate, 0);
  var getCellNode = monthCellRender ? function(date4) {
    return monthCellRender({
      current: date4,
      locale: locale2
    });
  } : void 0;
  return createVNode(PanelBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "rowNum": MONTH_ROW_COUNT,
    "colNum": MONTH_COL_COUNT,
    "baseDate": baseMonth,
    "getCellNode": getCellNode,
    "getCellText": function getCellText(date4) {
      return locale2.monthFormat ? formatValue(date4, {
        locale: locale2,
        format: locale2.monthFormat,
        generateConfig: generateConfig2
      }) : monthsLocale[generateConfig2.getMonth(date4)];
    },
    "getCellClassName": getCellClassName,
    "getCellDate": generateConfig2.addMonth,
    "titleCell": function titleCell(date4) {
      return formatValue(date4, {
        locale: locale2,
        format: "YYYY-MM",
        generateConfig: generateConfig2
      });
    }
  }), null);
}
MonthBody.displayName = "MonthBody";
MonthBody.inheritAttrs = false;
function MonthPanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, operationRef = props2.operationRef, onViewDateChange = props2.onViewDateChange, generateConfig2 = props2.generateConfig, value = props2.value, viewDate = props2.viewDate, onPanelChange = props2.onPanelChange, _onSelect = props2.onSelect;
  var panelPrefixCls = "".concat(prefixCls2, "-month-panel");
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      return createKeydownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff * MONTH_COL_COUNT), "key");
        },
        onEnter: function onEnter() {
          onPanelChange("date", value || viewDate);
        }
      });
    }
  };
  var onYearChange = function onYearChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return createVNode("div", {
    "class": panelPrefixCls
  }, [createVNode(MonthHeader, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onPrevYear": function onPrevYear() {
      onYearChange(-1);
    },
    "onNextYear": function onNextYear() {
      onYearChange(1);
    },
    "onYearClick": function onYearClick() {
      onPanelChange("year", viewDate);
    }
  }), null), createVNode(MonthBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onSelect": function onSelect(date4) {
      _onSelect(date4, "mouse");
      onPanelChange("date", date4);
    }
  }), null)]);
}
MonthPanel.displayName = "MonthPanel";
MonthPanel.inheritAttrs = false;
function QuarterHeader(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, locale2 = props2.locale, viewDate = props2.viewDate, onNextYear = props2.onNextYear, onPrevYear = props2.onPrevYear, onYearClick = props2.onYearClick;
  var _useInjectPanel = useInjectPanel(), hideHeader = _useInjectPanel.hideHeader;
  if (hideHeader.value) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls2, "-header");
  return createVNode(Header$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": headerPrefixCls,
    "onSuperPrev": onPrevYear,
    "onSuperNext": onNextYear
  }), {
    default: function _default7() {
      return [createVNode("button", {
        "type": "button",
        "onClick": onYearClick,
        "class": "".concat(prefixCls2, "-year-btn")
      }, [formatValue(viewDate, {
        locale: locale2,
        format: locale2.yearFormat,
        generateConfig: generateConfig2
      })])];
    }
  });
}
QuarterHeader.displayName = "QuarterHeader";
QuarterHeader.inheritAttrs = false;
var QUARTER_COL_COUNT = 4;
var QUARTER_ROW_COUNT = 1;
function QuarterBody(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, locale2 = props2.locale, value = props2.value, viewDate = props2.viewDate, generateConfig2 = props2.generateConfig;
  var _useInjectRange = useInjectRange(), rangedValue = _useInjectRange.rangedValue, hoverRangedValue = _useInjectRange.hoverRangedValue;
  var cellPrefixCls = "".concat(prefixCls2, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls,
    value,
    generateConfig: generateConfig2,
    rangedValue: rangedValue.value,
    hoverRangedValue: hoverRangedValue.value,
    isSameCell: function isSameCell(current2, target) {
      return isSameQuarter(generateConfig2, current2, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date4, offset3) {
      return generateConfig2.addMonth(date4, offset3 * 3);
    }
  });
  var baseQuarter = generateConfig2.setDate(generateConfig2.setMonth(viewDate, 0), 1);
  return createVNode(PanelBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "rowNum": QUARTER_ROW_COUNT,
    "colNum": QUARTER_COL_COUNT,
    "baseDate": baseQuarter,
    "getCellText": function getCellText(date4) {
      return formatValue(date4, {
        locale: locale2,
        format: locale2.quarterFormat || "[Q]Q",
        generateConfig: generateConfig2
      });
    },
    "getCellClassName": getCellClassName,
    "getCellDate": function getCellDate(date4, offset3) {
      return generateConfig2.addMonth(date4, offset3 * 3);
    },
    "titleCell": function titleCell(date4) {
      return formatValue(date4, {
        locale: locale2,
        format: "YYYY-[Q]Q",
        generateConfig: generateConfig2
      });
    }
  }), null);
}
QuarterBody.displayName = "QuarterBody";
QuarterBody.inheritAttrs = false;
function QuarterPanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, operationRef = props2.operationRef, onViewDateChange = props2.onViewDateChange, generateConfig2 = props2.generateConfig, value = props2.value, viewDate = props2.viewDate, onPanelChange = props2.onPanelChange, _onSelect = props2.onSelect;
  var panelPrefixCls = "".concat(prefixCls2, "-quarter-panel");
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      return createKeydownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addMonth(value || viewDate, diff * 3), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        }
      });
    }
  };
  var onYearChange = function onYearChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return createVNode("div", {
    "class": panelPrefixCls
  }, [createVNode(QuarterHeader, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onPrevYear": function onPrevYear() {
      onYearChange(-1);
    },
    "onNextYear": function onNextYear() {
      onYearChange(1);
    },
    "onYearClick": function onYearClick() {
      onPanelChange("year", viewDate);
    }
  }), null), createVNode(QuarterBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onSelect": function onSelect(date4) {
      _onSelect(date4, "mouse");
    }
  }), null)]);
}
QuarterPanel.displayName = "QuarterPanel";
QuarterPanel.inheritAttrs = false;
function YearHeader(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, generateConfig2 = props2.generateConfig, viewDate = props2.viewDate, onPrevDecade = props2.onPrevDecade, onNextDecade = props2.onNextDecade, onDecadeClick = props2.onDecadeClick;
  var _useInjectPanel = useInjectPanel(), hideHeader = _useInjectPanel.hideHeader;
  if (hideHeader.value) {
    return null;
  }
  var headerPrefixCls = "".concat(prefixCls2, "-header");
  var yearNumber = generateConfig2.getYear(viewDate);
  var startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
  var endYear = startYear + YEAR_DECADE_COUNT - 1;
  return createVNode(Header$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": headerPrefixCls,
    "onSuperPrev": onPrevDecade,
    "onSuperNext": onNextDecade
  }), {
    default: function _default7() {
      return [createVNode("button", {
        "type": "button",
        "onClick": onDecadeClick,
        "class": "".concat(prefixCls2, "-decade-btn")
      }, [startYear, createTextVNode("-"), endYear])];
    }
  });
}
YearHeader.displayName = "YearHeader";
YearHeader.inheritAttrs = false;
var YEAR_COL_COUNT = 3;
var YEAR_ROW_COUNT = 4;
function YearBody(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, value = props2.value, viewDate = props2.viewDate, locale2 = props2.locale, generateConfig2 = props2.generateConfig;
  var _useInjectRange = useInjectRange(), rangedValue = _useInjectRange.rangedValue, hoverRangedValue = _useInjectRange.hoverRangedValue;
  var yearPrefixCls = "".concat(prefixCls2, "-cell");
  var yearNumber = generateConfig2.getYear(viewDate);
  var startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
  var endYear = startYear + YEAR_DECADE_COUNT - 1;
  var baseYear = generateConfig2.setYear(viewDate, startYear - Math.ceil((YEAR_COL_COUNT * YEAR_ROW_COUNT - YEAR_DECADE_COUNT) / 2));
  var isInView = function isInView2(date4) {
    var currentYearNumber = generateConfig2.getYear(date4);
    return startYear <= currentYearNumber && currentYearNumber <= endYear;
  };
  var getCellClassName = useCellClassName({
    cellPrefixCls: yearPrefixCls,
    value,
    generateConfig: generateConfig2,
    rangedValue: rangedValue.value,
    hoverRangedValue: hoverRangedValue.value,
    isSameCell: function isSameCell(current2, target) {
      return isSameYear(generateConfig2, current2, target);
    },
    isInView,
    offsetCell: function offsetCell(date4, offset3) {
      return generateConfig2.addYear(date4, offset3);
    }
  });
  return createVNode(PanelBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "rowNum": YEAR_ROW_COUNT,
    "colNum": YEAR_COL_COUNT,
    "baseDate": baseYear,
    "getCellText": generateConfig2.getYear,
    "getCellClassName": getCellClassName,
    "getCellDate": generateConfig2.addYear,
    "titleCell": function titleCell(date4) {
      return formatValue(date4, {
        locale: locale2,
        format: "YYYY",
        generateConfig: generateConfig2
      });
    }
  }), null);
}
YearBody.displayName = "YearBody";
YearBody.inheritAttrs = false;
var YEAR_DECADE_COUNT = 10;
function YearPanel(_props) {
  var props2 = useMergeProps(_props);
  var prefixCls2 = props2.prefixCls, operationRef = props2.operationRef, onViewDateChange = props2.onViewDateChange, generateConfig2 = props2.generateConfig, value = props2.value, viewDate = props2.viewDate, sourceMode = props2.sourceMode, _onSelect = props2.onSelect, onPanelChange = props2.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls2, "-year-panel");
  operationRef.value = {
    onKeydown: function onKeydown(event) {
      return createKeydownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff), "key");
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff * YEAR_DECADE_COUNT), "key");
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig2.addYear(value || viewDate, diff * YEAR_COL_COUNT), "key");
        },
        onEnter: function onEnter() {
          onPanelChange(sourceMode === "date" ? "date" : "month", value || viewDate);
        }
      });
    }
  };
  var onDecadeChange = function onDecadeChange2(diff) {
    var newDate = generateConfig2.addYear(viewDate, diff * 10);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };
  return createVNode("div", {
    "class": panelPrefixCls
  }, [createVNode(YearHeader, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onPrevDecade": function onPrevDecade() {
      onDecadeChange(-1);
    },
    "onNextDecade": function onNextDecade() {
      onDecadeChange(1);
    },
    "onDecadeClick": function onDecadeClick() {
      onPanelChange("decade", viewDate);
    }
  }), null), createVNode(YearBody, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
    "prefixCls": prefixCls2,
    "onSelect": function onSelect(date4) {
      onPanelChange(sourceMode === "date" ? "date" : "month", date4);
      _onSelect(date4, "mouse");
    }
  }), null)]);
}
YearPanel.displayName = "YearPanel";
YearPanel.inheritAttrs = false;
function getExtraFooter(prefixCls2, mode, renderExtraFooter) {
  if (!renderExtraFooter) {
    return null;
  }
  return createVNode("div", {
    "class": "".concat(prefixCls2, "-footer-extra")
  }, [renderExtraFooter(mode)]);
}
function getRanges(_ref) {
  var prefixCls2 = _ref.prefixCls, _ref$rangeList = _ref.rangeList, rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList, _ref$components = _ref.components, components2 = _ref$components === void 0 ? {} : _ref$components, needConfirmButton = _ref.needConfirmButton, onNow = _ref.onNow, onOk = _ref.onOk, okDisabled = _ref.okDisabled, showNow = _ref.showNow, locale2 = _ref.locale;
  var presetNode;
  var okNode;
  if (rangeList.length) {
    var Item3 = components2.rangeItem || "span";
    presetNode = createVNode(Fragment, null, [rangeList.map(function(_ref2) {
      var label = _ref2.label, onClick2 = _ref2.onClick, onMouseenter2 = _ref2.onMouseenter, onMouseleave2 = _ref2.onMouseleave;
      return createVNode("li", {
        "key": label,
        "class": "".concat(prefixCls2, "-preset")
      }, [createVNode(Item3, {
        "onClick": onClick2,
        "onMouseenter": onMouseenter2,
        "onMouseleave": onMouseleave2
      }, {
        default: function _default7() {
          return [label];
        }
      })]);
    })]);
  }
  if (needConfirmButton) {
    var Button2 = components2.button || "button";
    if (onNow && !presetNode && showNow !== false) {
      presetNode = createVNode("li", {
        "class": "".concat(prefixCls2, "-now")
      }, [createVNode("a", {
        "class": "".concat(prefixCls2, "-now-btn"),
        "onClick": onNow
      }, [locale2.now])]);
    }
    okNode = needConfirmButton && createVNode("li", {
      "class": "".concat(prefixCls2, "-ok")
    }, [createVNode(Button2, {
      "disabled": okDisabled,
      "onClick": onOk
    }, {
      default: function _default7() {
        return [locale2.ok];
      }
    })]);
  }
  if (!presetNode && !okNode) {
    return null;
  }
  return createVNode("ul", {
    "class": "".concat(prefixCls2, "-ranges")
  }, [presetNode, okNode]);
}
function PickerPanel() {
  return defineComponent({
    name: "PickerPanel",
    inheritAttrs: false,
    props: {
      prefixCls: String,
      locale: Object,
      generateConfig: Object,
      value: Object,
      defaultValue: Object,
      pickerValue: Object,
      defaultPickerValue: Object,
      disabledDate: Function,
      mode: String,
      picker: {
        type: String,
        default: "date"
      },
      tabindex: {
        type: [Number, String],
        default: 0
      },
      showNow: {
        type: Boolean,
        default: void 0
      },
      showTime: [Boolean, Object],
      showToday: Boolean,
      renderExtraFooter: Function,
      dateRender: Function,
      hideHeader: {
        type: Boolean,
        default: void 0
      },
      onSelect: Function,
      onChange: Function,
      onPanelChange: Function,
      onMousedown: Function,
      onPickerValueChange: Function,
      onOk: Function,
      components: Object,
      direction: String,
      hourStep: {
        type: Number,
        default: 1
      },
      minuteStep: {
        type: Number,
        default: 1
      },
      secondStep: {
        type: Number,
        default: 1
      }
    },
    setup: function setup162(props2, _ref) {
      var attrs = _ref.attrs;
      var needConfirmButton = computed(function() {
        return props2.picker === "date" && !!props2.showTime || props2.picker === "time";
      });
      var isHourStepValid = computed(function() {
        return 24 % props2.hourStep === 0;
      });
      var isMinuteStepValid = computed(function() {
        return 60 % props2.minuteStep === 0;
      });
      var isSecondStepValid = computed(function() {
        return 60 % props2.secondStep === 0;
      });
      var panelContext = useInjectPanel();
      var operationRef = panelContext.operationRef, panelDivRef = panelContext.panelRef, onContextSelect = panelContext.onSelect, hideRanges = panelContext.hideRanges, defaultOpenValue = panelContext.defaultOpenValue;
      var _useInjectRange = useInjectRange(), inRange = _useInjectRange.inRange, panelPosition = _useInjectRange.panelPosition, rangedValue = _useInjectRange.rangedValue, hoverRangedValue = _useInjectRange.hoverRangedValue;
      var panelRef = ref({});
      var _useMergedState = useMergedState(null, {
        value: toRef(props2, "value"),
        defaultValue: props2.defaultValue,
        postState: function postState(val) {
          if (!val && (defaultOpenValue === null || defaultOpenValue === void 0 ? void 0 : defaultOpenValue.value) && props2.picker === "time") {
            return defaultOpenValue.value;
          }
          return val;
        }
      }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
      var _useMergedState3 = useMergedState(null, {
        value: toRef(props2, "pickerValue"),
        defaultValue: props2.defaultPickerValue || mergedValue.value,
        postState: function postState(date4) {
          var generateConfig2 = props2.generateConfig, showTime = props2.showTime, defaultValue = props2.defaultValue;
          var now2 = generateConfig2.getNow();
          if (!date4)
            return now2;
          if (!mergedValue.value && props2.showTime) {
            if (_typeof$2(showTime) === "object") {
              return setDateTime(generateConfig2, Array.isArray(date4) ? date4[0] : date4, showTime.defaultValue || now2);
            }
            if (defaultValue) {
              return setDateTime(generateConfig2, Array.isArray(date4) ? date4[0] : date4, defaultValue);
            }
            return setDateTime(generateConfig2, Array.isArray(date4) ? date4[0] : date4, now2);
          }
          return date4;
        }
      }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), viewDate = _useMergedState4[0], setInnerViewDate = _useMergedState4[1];
      var setViewDate = function setViewDate2(date4) {
        setInnerViewDate(date4);
        if (props2.onPickerValueChange) {
          props2.onPickerValueChange(date4);
        }
      };
      var getInternalNextMode = function getInternalNextMode2(nextMode) {
        var getNextMode = PickerModeMap[props2.picker];
        if (getNextMode) {
          return getNextMode(nextMode);
        }
        return nextMode;
      };
      var _useMergedState5 = useMergedState(function() {
        if (props2.picker === "time") {
          return "time";
        }
        return getInternalNextMode("date");
      }, {
        value: toRef(props2, "mode")
      }), _useMergedState6 = _slicedToArray$2(_useMergedState5, 2), mergedMode = _useMergedState6[0], setInnerMode = _useMergedState6[1];
      watch(function() {
        return props2.picker;
      }, function() {
        setInnerMode(props2.picker);
      });
      var sourceMode = ref(mergedMode.value);
      var setSourceMode = function setSourceMode2(val) {
        sourceMode.value = val;
      };
      var onInternalPanelChange = function onInternalPanelChange2(newMode, viewValue) {
        var onPanelChange = props2.onPanelChange, generateConfig2 = props2.generateConfig;
        var nextMode = getInternalNextMode(newMode || mergedMode.value);
        setSourceMode(mergedMode.value);
        setInnerMode(nextMode);
        if (onPanelChange && (mergedMode.value !== nextMode || isEqual$1(generateConfig2, viewDate.value, viewDate.value))) {
          onPanelChange(viewValue, nextMode);
        }
      };
      var triggerSelect = function triggerSelect2(date4, type4) {
        var forceTriggerSelect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var picker = props2.picker, generateConfig2 = props2.generateConfig, onSelect = props2.onSelect, onChange3 = props2.onChange, disabledDate = props2.disabledDate;
        if (mergedMode.value === picker || forceTriggerSelect) {
          setInnerValue(date4);
          if (onSelect) {
            onSelect(date4);
          }
          if (onContextSelect) {
            onContextSelect(date4, type4);
          }
          if (onChange3 && !isEqual$1(generateConfig2, date4, mergedValue.value) && !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date4))) {
            onChange3(date4);
          }
        }
      };
      var onInternalKeydown = function onInternalKeydown2(e2) {
        if (panelRef.value && panelRef.value.onKeydown) {
          if ([KeyCode$1.LEFT, KeyCode$1.RIGHT, KeyCode$1.UP, KeyCode$1.DOWN, KeyCode$1.PAGE_UP, KeyCode$1.PAGE_DOWN, KeyCode$1.ENTER].includes(e2.which)) {
            e2.preventDefault();
          }
          return panelRef.value.onKeydown(e2);
        }
        {
          return false;
        }
      };
      var onInternalBlur = function onInternalBlur2(e2) {
        if (panelRef.value && panelRef.value.onBlur) {
          panelRef.value.onBlur(e2);
        }
      };
      var onNow = function onNow2() {
        var generateConfig2 = props2.generateConfig, hourStep = props2.hourStep, minuteStep = props2.minuteStep, secondStep = props2.secondStep;
        var now2 = generateConfig2.getNow();
        var lowerBoundTime = getLowerBoundTime(generateConfig2.getHour(now2), generateConfig2.getMinute(now2), generateConfig2.getSecond(now2), isHourStepValid.value ? hourStep : 1, isMinuteStepValid.value ? minuteStep : 1, isSecondStepValid.value ? secondStep : 1);
        var adjustedNow = setTime(generateConfig2, now2, lowerBoundTime[0], lowerBoundTime[1], lowerBoundTime[2]);
        triggerSelect(adjustedNow, "submit");
      };
      var classString = computed(function() {
        var _classNames;
        var prefixCls2 = props2.prefixCls, direction2 = props2.direction;
        return classNames("".concat(prefixCls2, "-panel"), (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-panel-has-range"), rangedValue && rangedValue.value && rangedValue.value[0] && rangedValue.value[1]), _defineProperty$R(_classNames, "".concat(prefixCls2, "-panel-has-range-hover"), hoverRangedValue && hoverRangedValue.value && hoverRangedValue.value[0] && hoverRangedValue.value[1]), _defineProperty$R(_classNames, "".concat(prefixCls2, "-panel-rtl"), direction2 === "rtl"), _classNames));
      });
      useProvidePanel(_extends$2(_extends$2({}, panelContext), {
        mode: mergedMode,
        hideHeader: computed(function() {
          var _a2;
          return props2.hideHeader !== void 0 ? props2.hideHeader : (_a2 = panelContext.hideHeader) === null || _a2 === void 0 ? void 0 : _a2.value;
        }),
        hidePrevBtn: computed(function() {
          return inRange.value && panelPosition.value === "right";
        }),
        hideNextBtn: computed(function() {
          return inRange.value && panelPosition.value === "left";
        })
      }));
      watch(function() {
        return props2.value;
      }, function() {
        if (props2.value) {
          setInnerViewDate(props2.value);
        }
      });
      return function() {
        var _props$prefixCls = props2.prefixCls, prefixCls2 = _props$prefixCls === void 0 ? "ant-picker" : _props$prefixCls, locale2 = props2.locale, generateConfig2 = props2.generateConfig, disabledDate = props2.disabledDate, _props$picker = props2.picker, picker = _props$picker === void 0 ? "date" : _props$picker, _props$tabindex = props2.tabindex, tabindex = _props$tabindex === void 0 ? 0 : _props$tabindex, showNow = props2.showNow, showTime = props2.showTime, showToday = props2.showToday, renderExtraFooter = props2.renderExtraFooter, onMousedown2 = props2.onMousedown, _onOk = props2.onOk, components2 = props2.components;
        if (operationRef && panelPosition.value !== "right") {
          operationRef.value = {
            onKeydown: onInternalKeydown,
            onClose: function onClose() {
              if (panelRef.value && panelRef.value.onClose) {
                panelRef.value.onClose();
              }
            }
          };
        }
        var panelNode;
        var pickerProps = _extends$2(_extends$2(_extends$2({}, attrs), props2), {
          operationRef: panelRef,
          prefixCls: prefixCls2,
          viewDate: viewDate.value,
          value: mergedValue.value,
          onViewDateChange: setViewDate,
          sourceMode: sourceMode.value,
          onPanelChange: onInternalPanelChange,
          disabledDate
        });
        delete pickerProps.onChange;
        delete pickerProps.onSelect;
        switch (mergedMode.value) {
          case "decade":
            panelNode = createVNode(DecadePanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
              "onSelect": function onSelect(date4, type4) {
                setViewDate(date4);
                triggerSelect(date4, type4);
              }
            }), null);
            break;
          case "year":
            panelNode = createVNode(YearPanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
              "onSelect": function onSelect(date4, type4) {
                setViewDate(date4);
                triggerSelect(date4, type4);
              }
            }), null);
            break;
          case "month":
            panelNode = createVNode(MonthPanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
              "onSelect": function onSelect(date4, type4) {
                setViewDate(date4);
                triggerSelect(date4, type4);
              }
            }), null);
            break;
          case "quarter":
            panelNode = createVNode(QuarterPanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
              "onSelect": function onSelect(date4, type4) {
                setViewDate(date4);
                triggerSelect(date4, type4);
              }
            }), null);
            break;
          case "week":
            panelNode = createVNode(WeekPanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
              "onSelect": function onSelect(date4, type4) {
                setViewDate(date4);
                triggerSelect(date4, type4);
              }
            }), null);
            break;
          case "time":
            delete pickerProps.showTime;
            panelNode = createVNode(TimePanel, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, pickerProps), _typeof$2(showTime) === "object" ? showTime : null), {}, {
              "onSelect": function onSelect(date4, type4) {
                setViewDate(date4);
                triggerSelect(date4, type4);
              }
            }), null);
            break;
          default:
            if (showTime) {
              panelNode = createVNode(DatetimePanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
                "onSelect": function onSelect(date4, type4) {
                  setViewDate(date4);
                  triggerSelect(date4, type4);
                }
              }), null);
            } else {
              panelNode = createVNode(DatePanel, _objectSpread2$2(_objectSpread2$2({}, pickerProps), {}, {
                "onSelect": function onSelect(date4, type4) {
                  setViewDate(date4);
                  triggerSelect(date4, type4);
                }
              }), null);
            }
        }
        var extraFooter;
        var rangesNode;
        if (!(hideRanges === null || hideRanges === void 0 ? void 0 : hideRanges.value)) {
          extraFooter = getExtraFooter(prefixCls2, mergedMode.value, renderExtraFooter);
          rangesNode = getRanges({
            prefixCls: prefixCls2,
            components: components2,
            needConfirmButton: needConfirmButton.value,
            okDisabled: !mergedValue.value || disabledDate && disabledDate(mergedValue.value),
            locale: locale2,
            showNow,
            onNow: needConfirmButton.value && onNow,
            onOk: function onOk() {
              if (mergedValue.value) {
                triggerSelect(mergedValue.value, "submit", true);
                if (_onOk) {
                  _onOk(mergedValue.value);
                }
              }
            }
          });
        }
        var todayNode;
        if (showToday && mergedMode.value === "date" && picker === "date" && !showTime) {
          var now2 = generateConfig2.getNow();
          var todayCls = "".concat(prefixCls2, "-today-btn");
          var disabled = disabledDate && disabledDate(now2);
          todayNode = createVNode("a", {
            "class": classNames(todayCls, disabled && "".concat(todayCls, "-disabled")),
            "aria-disabled": disabled,
            "onClick": function onClick2() {
              if (!disabled) {
                triggerSelect(now2, "mouse", true);
              }
            }
          }, [locale2.today]);
        }
        return createVNode("div", {
          "tabindex": tabindex,
          "class": classNames(classString.value, attrs.class),
          "style": attrs.style,
          "onKeydown": onInternalKeydown,
          "onBlur": onInternalBlur,
          "onMousedown": onMousedown2,
          "ref": panelDivRef
        }, [panelNode, extraFooter || rangesNode || todayNode ? createVNode("div", {
          "class": "".concat(prefixCls2, "-footer")
        }, [extraFooter, rangesNode, todayNode]) : null]);
      };
    }
  });
}
var InterPickerPanel = PickerPanel();
var PickerPanel$1 = function(props2) {
  return createVNode(InterPickerPanel, props2);
};
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function PickerTrigger(props2, _ref) {
  var _classNames;
  var slots = _ref.slots;
  var _useMergeProps = useMergeProps(props2), prefixCls2 = _useMergeProps.prefixCls, popupStyle = _useMergeProps.popupStyle, visible = _useMergeProps.visible, dropdownClassName = _useMergeProps.dropdownClassName, dropdownAlign = _useMergeProps.dropdownAlign, transitionName2 = _useMergeProps.transitionName, getPopupContainer = _useMergeProps.getPopupContainer, range3 = _useMergeProps.range, popupPlacement = _useMergeProps.popupPlacement, direction2 = _useMergeProps.direction;
  var dropdownPrefixCls = "".concat(prefixCls2, "-dropdown");
  var getPopupPlacement = function getPopupPlacement2() {
    if (popupPlacement !== void 0) {
      return popupPlacement;
    }
    return direction2 === "rtl" ? "bottomRight" : "bottomLeft";
  };
  return createVNode(Trigger, {
    "showAction": [],
    "hideAction": [],
    "popupPlacement": getPopupPlacement(),
    "builtinPlacements": BUILT_IN_PLACEMENTS,
    "prefixCls": dropdownPrefixCls,
    "popupTransitionName": transitionName2,
    "popupAlign": dropdownAlign,
    "popupVisible": visible,
    "popupClassName": classNames(dropdownClassName, (_classNames = {}, _defineProperty$R(_classNames, "".concat(dropdownPrefixCls, "-range"), range3), _defineProperty$R(_classNames, "".concat(dropdownPrefixCls, "-rtl"), direction2 === "rtl"), _classNames)),
    "popupStyle": popupStyle,
    "getPopupContainer": getPopupContainer
  }, {
    default: slots.default,
    popup: slots.popupElement
  });
}
function usePickerInput(_ref) {
  var open2 = _ref.open, value = _ref.value, isClickOutside = _ref.isClickOutside, triggerOpen = _ref.triggerOpen, forwardKeydown = _ref.forwardKeydown, _onKeydown = _ref.onKeydown, blurToCancel = _ref.blurToCancel, onSubmit = _ref.onSubmit, onCancel = _ref.onCancel, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur;
  var typing = ref(false);
  var focused = ref(false);
  var preventBlurRef = ref(false);
  var valueChangedRef = ref(false);
  var preventDefaultRef = ref(false);
  var inputProps3 = computed(function() {
    return {
      onMousedown: function onMousedown2() {
        typing.value = true;
        triggerOpen(true);
      },
      onKeydown: function onKeydown(e2) {
        var preventDefault = function preventDefault2() {
          preventDefaultRef.value = true;
        };
        _onKeydown(e2, preventDefault);
        if (preventDefaultRef.value)
          return;
        switch (e2.which) {
          case KeyCode$1.ENTER: {
            if (!open2.value) {
              triggerOpen(true);
            } else if (onSubmit() !== false) {
              typing.value = true;
            }
            e2.preventDefault();
            return;
          }
          case KeyCode$1.TAB: {
            if (typing.value && open2.value && !e2.shiftKey) {
              typing.value = false;
              e2.preventDefault();
            } else if (!typing.value && open2.value) {
              if (!forwardKeydown(e2) && e2.shiftKey) {
                typing.value = true;
                e2.preventDefault();
              }
            }
            return;
          }
          case KeyCode$1.ESC: {
            typing.value = true;
            onCancel();
            return;
          }
        }
        if (!open2.value && ![KeyCode$1.SHIFT].includes(e2.which)) {
          triggerOpen(true);
        } else if (!typing.value) {
          forwardKeydown(e2);
        }
      },
      onFocus: function onFocus2(e2) {
        typing.value = true;
        focused.value = true;
        if (_onFocus) {
          _onFocus(e2);
        }
      },
      onBlur: function onBlur2(e2) {
        if (preventBlurRef.value || !isClickOutside(document.activeElement)) {
          preventBlurRef.value = false;
          return;
        }
        if (blurToCancel.value) {
          setTimeout(function() {
            var _document = document, activeElement = _document.activeElement;
            while (activeElement && activeElement.shadowRoot) {
              activeElement = activeElement.shadowRoot.activeElement;
            }
            if (isClickOutside(activeElement)) {
              onCancel();
            }
          }, 0);
        } else if (open2.value) {
          triggerOpen(false);
          if (valueChangedRef.value) {
            onSubmit();
          }
        }
        focused.value = false;
        if (_onBlur) {
          _onBlur(e2);
        }
      }
    };
  });
  watch(open2, function() {
    valueChangedRef.value = false;
  });
  watch(value, function() {
    valueChangedRef.value = true;
  });
  var globalMousedownEvent = ref();
  watchEffect(function() {
    return globalMousedownEvent.value && globalMousedownEvent.value()(globalMousedownEvent.value = addGlobalMousedownEvent(function(e2) {
      var target = getTargetFromEvent(e2);
      if (open2) {
        var clickedOutside = isClickOutside(target);
        if (!clickedOutside) {
          preventBlurRef.value = true;
          wrapperRaf(function() {
            preventBlurRef.value = false;
          });
        } else if (!focused.value || clickedOutside) {
          triggerOpen(false);
        }
      }
    }));
  });
  onBeforeUnmount(function() {
    globalMousedownEvent.value && globalMousedownEvent.value();
  });
  return [inputProps3, {
    focused,
    typing
  }];
}
function useTextValueMapping(_ref) {
  var valueTexts = _ref.valueTexts, onTextChange = _ref.onTextChange;
  var text = ref("");
  function triggerTextChange(value) {
    text.value = value;
    onTextChange(value);
  }
  function resetText() {
    text.value = valueTexts.value[0];
  }
  watch(function() {
    return _toConsumableArray(valueTexts.value);
  }, function(cur) {
    var pre = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (cur.join("||") !== pre.join("||") && valueTexts.value.every(function(valText) {
      return valText !== text.value;
    })) {
      resetText();
    }
  }, {
    immediate: true
  });
  return [text, triggerTextChange, resetText];
}
function useValueTexts(value, _ref) {
  var formatList = _ref.formatList, generateConfig2 = _ref.generateConfig, locale2 = _ref.locale;
  var texts = useMemo(function() {
    if (!value.value) {
      return [[""], ""];
    }
    var firstValueText2 = "";
    var fullValueTexts2 = [];
    for (var i2 = 0; i2 < formatList.value.length; i2 += 1) {
      var format3 = formatList.value[i2];
      var formatStr = formatValue(value.value, {
        generateConfig: generateConfig2.value,
        locale: locale2.value,
        format: format3
      });
      fullValueTexts2.push(formatStr);
      if (i2 === 0) {
        firstValueText2 = formatStr;
      }
    }
    return [fullValueTexts2, firstValueText2];
  }, [value, formatList], function(next2, prev2) {
    return prev2[0] !== next2[0] || !shallowequal(prev2[1], next2[1]);
  });
  var fullValueTexts = computed(function() {
    return texts.value[0];
  });
  var firstValueText = computed(function() {
    return texts.value[1];
  });
  return [fullValueTexts, firstValueText];
}
function useHoverValue(valueText, _ref) {
  var formatList = _ref.formatList, generateConfig2 = _ref.generateConfig, locale2 = _ref.locale;
  var innerValue = ref(null);
  var rafId;
  function setValue2(val) {
    var immediately = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    wrapperRaf.cancel(rafId);
    if (immediately) {
      innerValue.value = val;
      return;
    }
    rafId = wrapperRaf(function() {
      innerValue.value = val;
    });
  }
  var _useValueTexts = useValueTexts(innerValue, {
    formatList,
    generateConfig: generateConfig2,
    locale: locale2
  }), _useValueTexts2 = _slicedToArray$2(_useValueTexts, 2), firstText = _useValueTexts2[1];
  function onEnter(date4) {
    setValue2(date4);
  }
  function onLeave() {
    var immediately = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    setValue2(null, immediately);
  }
  watch(valueText, function() {
    onLeave(true);
  });
  onBeforeUnmount(function() {
    wrapperRaf.cancel(rafId);
  });
  return [firstText, onEnter, onLeave];
}
function Picker() {
  return defineComponent({
    name: "Picker",
    inheritAttrs: false,
    props: ["prefixCls", "id", "tabindex", "dropdownClassName", "dropdownAlign", "popupStyle", "transitionName", "generateConfig", "locale", "inputReadOnly", "allowClear", "autofocus", "showTime", "showNow", "showHour", "showMinute", "showSecond", "picker", "format", "use12Hours", "value", "defaultValue", "open", "defaultOpen", "defaultOpenValue", "suffixIcon", "clearIcon", "disabled", "disabledDate", "placeholder", "getPopupContainer", "panelRender", "inputRender", "onChange", "onOpenChange", "onFocus", "onBlur", "onMousedown", "onMouseup", "onMouseenter", "onMouseleave", "onContextmenu", "onClick", "onKeydown", "onSelect", "direction", "autocomplete", "showToday", "renderExtraFooter", "dateRender"],
    setup: function setup162(props2, _ref) {
      var attrs = _ref.attrs, expose = _ref.expose;
      var inputRef = ref(null);
      var picker = computed(function() {
        var _a2;
        return (_a2 = props2.picker) !== null && _a2 !== void 0 ? _a2 : "date";
      });
      var needConfirmButton = computed(function() {
        return picker.value === "date" && !!props2.showTime || picker.value === "time";
      });
      var formatList = computed(function() {
        return toArray$6(getDefaultFormat(props2.format, picker.value, props2.showTime, props2.use12Hours));
      });
      var panelDivRef = ref(null);
      var inputDivRef = ref(null);
      var containerRef = ref(null);
      var _useMergedState = useMergedState(null, {
        value: toRef(props2, "value"),
        defaultValue: props2.defaultValue
      }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
      var selectedValue = ref(mergedValue.value);
      var setSelectedValue = function setSelectedValue2(val) {
        selectedValue.value = val;
      };
      var operationRef = ref(null);
      var _useMergedState3 = useMergedState(false, {
        value: toRef(props2, "open"),
        defaultValue: props2.defaultOpen,
        postState: function postState(postOpen) {
          return props2.disabled ? false : postOpen;
        },
        onChange: function onChange3(newOpen) {
          if (props2.onOpenChange) {
            props2.onOpenChange(newOpen);
          }
          if (!newOpen && operationRef.value && operationRef.value.onClose) {
            operationRef.value.onClose();
          }
        }
      }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), mergedOpen = _useMergedState4[0], triggerInnerOpen = _useMergedState4[1];
      var _useValueTexts = useValueTexts(selectedValue, {
        formatList,
        generateConfig: toRef(props2, "generateConfig"),
        locale: toRef(props2, "locale")
      }), _useValueTexts2 = _slicedToArray$2(_useValueTexts, 2), valueTexts = _useValueTexts2[0], firstValueText = _useValueTexts2[1];
      var _useTextValueMapping = useTextValueMapping({
        valueTexts,
        onTextChange: function onTextChange(newText) {
          var inputDate = parseValue(newText, {
            locale: props2.locale,
            formatList: formatList.value,
            generateConfig: props2.generateConfig
          });
          if (inputDate && (!props2.disabledDate || !props2.disabledDate(inputDate))) {
            setSelectedValue(inputDate);
          }
        }
      }), _useTextValueMapping2 = _slicedToArray$2(_useTextValueMapping, 3), text = _useTextValueMapping2[0], triggerTextChange = _useTextValueMapping2[1], resetText = _useTextValueMapping2[2];
      var triggerChange = function triggerChange2(newValue) {
        var onChange3 = props2.onChange, generateConfig2 = props2.generateConfig, locale2 = props2.locale;
        setSelectedValue(newValue);
        setInnerValue(newValue);
        if (onChange3 && !isEqual$1(generateConfig2, mergedValue.value, newValue)) {
          onChange3(newValue, newValue ? formatValue(newValue, {
            generateConfig: generateConfig2,
            locale: locale2,
            format: formatList.value[0]
          }) : "");
        }
      };
      var triggerOpen = function triggerOpen2(newOpen) {
        if (props2.disabled && newOpen) {
          return;
        }
        triggerInnerOpen(newOpen);
      };
      var forwardKeydown = function forwardKeydown2(e2) {
        if (mergedOpen.value && operationRef.value && operationRef.value.onKeydown) {
          return operationRef.value.onKeydown(e2);
        }
        {
          return false;
        }
      };
      var onInternalMouseup = function onInternalMouseup2() {
        if (props2.onMouseup) {
          props2.onMouseup.apply(props2, arguments);
        }
        if (inputRef.value) {
          inputRef.value.focus();
          triggerOpen(true);
        }
      };
      var _usePickerInput = usePickerInput({
        blurToCancel: needConfirmButton,
        open: mergedOpen,
        value: text,
        triggerOpen,
        forwardKeydown,
        isClickOutside: function isClickOutside(target) {
          return !elementsContains([panelDivRef.value, inputDivRef.value, containerRef.value], target);
        },
        onSubmit: function onSubmit() {
          if (!selectedValue.value || props2.disabledDate && props2.disabledDate(selectedValue.value)) {
            return false;
          }
          triggerChange(selectedValue.value);
          triggerOpen(false);
          resetText();
          return true;
        },
        onCancel: function onCancel() {
          triggerOpen(false);
          setSelectedValue(mergedValue.value);
          resetText();
        },
        onKeydown: function onKeydown(e2, preventDefault) {
          var _a2;
          (_a2 = props2.onKeydown) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2, preventDefault);
        },
        onFocus: function onFocus2(e2) {
          var _a2;
          (_a2 = props2.onFocus) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
        },
        onBlur: function onBlur2(e2) {
          var _a2;
          (_a2 = props2.onBlur) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
        }
      }), _usePickerInput2 = _slicedToArray$2(_usePickerInput, 2), inputProps3 = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], focused = _usePickerInput2$.focused, typing = _usePickerInput2$.typing;
      watch([mergedOpen, valueTexts], function() {
        if (!mergedOpen.value) {
          setSelectedValue(mergedValue.value);
          if (!valueTexts.value.length || valueTexts.value[0] === "") {
            triggerTextChange("");
          } else if (firstValueText.value !== text.value) {
            resetText();
          }
        }
      });
      watch(picker, function() {
        if (!mergedOpen.value) {
          resetText();
        }
      });
      watch(mergedValue, function() {
        setSelectedValue(mergedValue.value);
      });
      var _useHoverValue = useHoverValue(text, {
        formatList,
        generateConfig: toRef(props2, "generateConfig"),
        locale: toRef(props2, "locale")
      }), _useHoverValue2 = _slicedToArray$2(_useHoverValue, 3), hoverValue = _useHoverValue2[0], onEnter = _useHoverValue2[1], onLeave = _useHoverValue2[2];
      var onContextSelect = function onContextSelect2(date4, type4) {
        if (type4 === "submit" || type4 !== "key" && !needConfirmButton.value) {
          triggerChange(date4);
          triggerOpen(false);
        }
      };
      useProvidePanel({
        operationRef,
        hideHeader: computed(function() {
          return picker.value === "time";
        }),
        panelRef: panelDivRef,
        onSelect: onContextSelect,
        open: mergedOpen,
        defaultOpenValue: toRef(props2, "defaultOpenValue"),
        onDateMouseenter: onEnter,
        onDateMouseleave: onLeave
      });
      expose({
        focus: function focus2() {
          if (inputRef.value) {
            inputRef.value.focus();
          }
        },
        blur: function blur() {
          if (inputRef.value) {
            inputRef.value.blur();
          }
        }
      });
      var getPortal = useProviderTrigger();
      return function() {
        var _classNames2;
        var _props$prefixCls = props2.prefixCls, prefixCls2 = _props$prefixCls === void 0 ? "rc-picker" : _props$prefixCls, id = props2.id, tabindex = props2.tabindex, dropdownClassName = props2.dropdownClassName, dropdownAlign = props2.dropdownAlign, popupStyle = props2.popupStyle, transitionName2 = props2.transitionName, generateConfig2 = props2.generateConfig, locale2 = props2.locale, inputReadOnly = props2.inputReadOnly, allowClear = props2.allowClear, autofocus = props2.autofocus, _props$picker = props2.picker, picker2 = _props$picker === void 0 ? "date" : _props$picker;
        props2.defaultOpenValue;
        var suffixIcon = props2.suffixIcon, clearIcon = props2.clearIcon, disabled = props2.disabled, placeholder = props2.placeholder, getPopupContainer = props2.getPopupContainer, panelRender = props2.panelRender, onMousedown2 = props2.onMousedown, onMouseenter2 = props2.onMouseenter, onMouseleave2 = props2.onMouseleave, onContextmenu2 = props2.onContextmenu, onClick2 = props2.onClick, _onSelect = props2.onSelect, direction2 = props2.direction, _props$autocomplete = props2.autocomplete, autocomplete = _props$autocomplete === void 0 ? "off" : _props$autocomplete;
        var panelProps = _extends$2(_extends$2(_extends$2({}, props2), attrs), {
          class: classNames(_defineProperty$R({}, "".concat(prefixCls2, "-panel-focused"), !typing.value)),
          style: void 0,
          pickerValue: void 0,
          onPickerValueChange: void 0,
          onChange: null
        });
        var panelNode = createVNode(PickerPanel$1, _objectSpread2$2(_objectSpread2$2({}, panelProps), {}, {
          "generateConfig": generateConfig2,
          "value": selectedValue.value,
          "locale": locale2,
          "tabindex": -1,
          "onSelect": function onSelect(date4) {
            _onSelect === null || _onSelect === void 0 ? void 0 : _onSelect(date4);
            setSelectedValue(date4);
          },
          "direction": direction2,
          "onPanelChange": function onPanelChange(viewDate, mode) {
            var onPanelChange2 = props2.onPanelChange;
            onLeave(true);
            onPanelChange2 === null || onPanelChange2 === void 0 ? void 0 : onPanelChange2(viewDate, mode);
          }
        }), null);
        if (panelRender) {
          panelNode = panelRender(panelNode);
        }
        var panel = createVNode("div", {
          "class": "".concat(prefixCls2, "-panel-container"),
          "onMousedown": function onMousedown3(e2) {
            e2.preventDefault();
          }
        }, [panelNode]);
        var suffixNode;
        if (suffixIcon) {
          suffixNode = createVNode("span", {
            "class": "".concat(prefixCls2, "-suffix")
          }, [suffixIcon]);
        }
        var clearNode;
        if (allowClear && mergedValue.value && !disabled) {
          clearNode = createVNode("span", {
            "onMousedown": function onMousedown3(e2) {
              e2.preventDefault();
              e2.stopPropagation();
            },
            "onMouseup": function onMouseup(e2) {
              e2.preventDefault();
              e2.stopPropagation();
              triggerChange(null);
              triggerOpen(false);
            },
            "class": "".concat(prefixCls2, "-clear"),
            "role": "button"
          }, [clearIcon || createVNode("span", {
            "class": "".concat(prefixCls2, "-clear-btn")
          }, null)]);
        }
        var mergedInputProps = _extends$2(_extends$2(_extends$2(_extends$2({
          id,
          tabindex,
          disabled,
          readonly: inputReadOnly || typeof formatList.value[0] === "function" || !typing.value,
          value: hoverValue.value || text.value,
          onInput: function onInput(e2) {
            triggerTextChange(e2.target.value);
          },
          autofocus,
          placeholder,
          ref: inputRef,
          title: text.value
        }, inputProps3.value), {
          size: getInputSize(picker2, formatList.value[0], generateConfig2)
        }), getDataOrAriaProps(props2)), {
          autocomplete
        });
        var inputNode = props2.inputRender ? props2.inputRender(mergedInputProps) : createVNode("input", mergedInputProps, null);
        var popupPlacement = direction2 === "rtl" ? "bottomRight" : "bottomLeft";
        return createVNode(PickerTrigger, {
          "visible": mergedOpen.value,
          "popupStyle": popupStyle,
          "prefixCls": prefixCls2,
          "dropdownClassName": dropdownClassName,
          "dropdownAlign": dropdownAlign,
          "getPopupContainer": getPopupContainer,
          "transitionName": transitionName2,
          "popupPlacement": popupPlacement,
          "direction": direction2
        }, {
          default: function _default7() {
            return [createVNode("div", {
              "ref": containerRef,
              "class": classNames(prefixCls2, attrs.class, (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2, "-disabled"), disabled), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-focused"), focused.value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-rtl"), direction2 === "rtl"), _classNames2)),
              "style": attrs.style,
              "onMousedown": onMousedown2,
              "onMouseup": onInternalMouseup,
              "onMouseenter": onMouseenter2,
              "onMouseleave": onMouseleave2,
              "onContextmenu": onContextmenu2,
              "onClick": onClick2
            }, [createVNode("div", {
              "class": classNames("".concat(prefixCls2, "-input"), _defineProperty$R({}, "".concat(prefixCls2, "-input-placeholder"), !!hoverValue.value)),
              "ref": inputDivRef
            }, [inputNode, suffixNode, clearNode]), getPortal()])];
          },
          popupElement: function popupElement() {
            return panel;
          }
        });
      };
    }
  });
}
var Picker$1 = Picker();
function useRangeDisabled(_ref, openRecordsRef) {
  var picker = _ref.picker, locale2 = _ref.locale, selectedValue = _ref.selectedValue, disabledDate = _ref.disabledDate, disabled = _ref.disabled, generateConfig2 = _ref.generateConfig;
  var startDate = computed(function() {
    return getValue$2(selectedValue.value, 0);
  });
  var endDate = computed(function() {
    return getValue$2(selectedValue.value, 1);
  });
  function weekFirstDate(date4) {
    return generateConfig2.value.locale.getWeekFirstDate(locale2.value.locale, date4);
  }
  function monthNumber(date4) {
    var year = generateConfig2.value.getYear(date4);
    var month = generateConfig2.value.getMonth(date4);
    return year * 100 + month;
  }
  function quarterNumber(date4) {
    var year = generateConfig2.value.getYear(date4);
    var quarter = getQuarter(generateConfig2.value, date4);
    return year * 10 + quarter;
  }
  var disabledStartDate = function disabledStartDate2(date4) {
    var _a2;
    if (disabledDate && ((_a2 = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate.value) === null || _a2 === void 0 ? void 0 : _a2.call(disabledDate, date4))) {
      return true;
    }
    if (disabled[1] && endDate) {
      return !isSameDate(generateConfig2.value, date4, endDate.value) && generateConfig2.value.isAfter(date4, endDate.value);
    }
    if (openRecordsRef.value[1] && endDate.value) {
      switch (picker.value) {
        case "quarter":
          return quarterNumber(date4) > quarterNumber(endDate.value);
        case "month":
          return monthNumber(date4) > monthNumber(endDate.value);
        case "week":
          return weekFirstDate(date4) > weekFirstDate(endDate.value);
        default:
          return !isSameDate(generateConfig2.value, date4, endDate.value) && generateConfig2.value.isAfter(date4, endDate.value);
      }
    }
    return false;
  };
  var disabledEndDate = function disabledEndDate2(date4) {
    var _a2;
    if ((_a2 = disabledDate.value) === null || _a2 === void 0 ? void 0 : _a2.call(disabledDate, date4)) {
      return true;
    }
    if (disabled[0] && startDate) {
      return !isSameDate(generateConfig2.value, date4, endDate.value) && generateConfig2.value.isAfter(startDate.value, date4);
    }
    if (openRecordsRef.value[0] && startDate.value) {
      switch (picker.value) {
        case "quarter":
          return quarterNumber(date4) < quarterNumber(startDate.value);
        case "month":
          return monthNumber(date4) < monthNumber(startDate.value);
        case "week":
          return weekFirstDate(date4) < weekFirstDate(startDate.value);
        default:
          return !isSameDate(generateConfig2.value, date4, startDate.value) && generateConfig2.value.isAfter(startDate.value, date4);
      }
    }
    return false;
  };
  return [disabledStartDate, disabledEndDate];
}
function getStartEndDistance(startDate, endDate, picker, generateConfig2) {
  var startNext = getClosingViewDate(startDate, picker, generateConfig2, 1);
  function getDistance(compareFunc) {
    if (compareFunc(startDate, endDate)) {
      return "same";
    }
    if (compareFunc(startNext, endDate)) {
      return "closing";
    }
    return "far";
  }
  switch (picker) {
    case "year":
      return getDistance(function(start2, end) {
        return isSameDecade(generateConfig2, start2, end);
      });
    case "quarter":
    case "month":
      return getDistance(function(start2, end) {
        return isSameYear(generateConfig2, start2, end);
      });
    default:
      return getDistance(function(start2, end) {
        return isSameMonth(generateConfig2, start2, end);
      });
  }
}
function getRangeViewDate(values, index2, picker, generateConfig2) {
  var startDate = getValue$2(values, 0);
  var endDate = getValue$2(values, 1);
  if (index2 === 0) {
    return startDate;
  }
  if (startDate && endDate) {
    var distance = getStartEndDistance(startDate, endDate, picker, generateConfig2);
    switch (distance) {
      case "same":
        return startDate;
      case "closing":
        return startDate;
      default:
        return getClosingViewDate(endDate, picker, generateConfig2, -1);
    }
  }
  return startDate;
}
function useRangeViewDates(_ref) {
  var values = _ref.values, picker = _ref.picker, defaultDates = _ref.defaultDates, generateConfig2 = _ref.generateConfig;
  var defaultViewDates = ref([getValue$2(defaultDates, 0), getValue$2(defaultDates, 1)]);
  var viewDates = ref(null);
  var startDate = computed(function() {
    return getValue$2(values.value, 0);
  });
  var endDate = computed(function() {
    return getValue$2(values.value, 1);
  });
  var getViewDate = function getViewDate2(index2) {
    if (defaultViewDates.value[index2]) {
      return defaultViewDates.value[index2];
    }
    return getValue$2(viewDates.value, index2) || getRangeViewDate(values.value, index2, picker.value, generateConfig2.value) || startDate.value || endDate.value || generateConfig2.value.getNow();
  };
  var startViewDate = ref(null);
  var endViewDate = ref(null);
  watchEffect(function() {
    startViewDate.value = getViewDate(0);
    endViewDate.value = getViewDate(1);
  });
  function setViewDate(viewDate, index2) {
    if (viewDate) {
      var newViewDates = updateValues(viewDates.value, viewDate, index2);
      defaultViewDates.value = updateValues(defaultViewDates.value, null, index2) || [null, null];
      var anotherIndex = (index2 + 1) % 2;
      if (!getValue$2(values.value, anotherIndex)) {
        newViewDates = updateValues(newViewDates, viewDate, anotherIndex);
      }
      viewDates.value = newViewDates;
    } else if (startDate.value || endDate.value) {
      viewDates.value = null;
    }
  }
  return [startViewDate, endViewDate, setViewDate];
}
function reorderValues(values, generateConfig2) {
  if (values && values[0] && values[1] && generateConfig2.isAfter(values[0], values[1])) {
    return [values[1], values[0]];
  }
  return values;
}
function canValueTrigger(value, index2, disabled, allowEmpty) {
  if (value) {
    return true;
  }
  if (allowEmpty && allowEmpty[index2]) {
    return true;
  }
  if (disabled[(index2 + 1) % 2]) {
    return true;
  }
  return false;
}
function RangerPicker() {
  return defineComponent({
    name: "RangerPicker",
    inheritAttrs: false,
    props: ["prefixCls", "id", "popupStyle", "dropdownClassName", "transitionName", "dropdownAlign", "getPopupContainer", "generateConfig", "locale", "placeholder", "autofocus", "disabled", "format", "picker", "showTime", "showNow", "showHour", "showMinute", "showSecond", "use12Hours", "separator", "value", "defaultValue", "defaultPickerValue", "open", "defaultOpen", "disabledDate", "disabledTime", "dateRender", "panelRender", "ranges", "allowEmpty", "allowClear", "suffixIcon", "clearIcon", "pickerRef", "inputReadOnly", "mode", "renderExtraFooter", "onChange", "onOpenChange", "onPanelChange", "onCalendarChange", "onFocus", "onBlur", "onMousedown", "onMouseup", "onMouseenter", "onMouseleave", "onClick", "onOk", "onKeydown", "components", "order", "direction", "activePickerIndex", "autocomplete"],
    setup: function setup162(props2, _ref) {
      var attrs = _ref.attrs, expose = _ref.expose;
      var needConfirmButton = computed(function() {
        return props2.picker === "date" && !!props2.showTime || props2.picker === "time";
      });
      var getPortal = useProviderTrigger();
      var openRecordsRef = ref({});
      var containerRef = ref(null);
      var panelDivRef = ref(null);
      var startInputDivRef = ref(null);
      var endInputDivRef = ref(null);
      var separatorRef = ref(null);
      var startInputRef = ref(null);
      var endInputRef = ref(null);
      var arrowRef = ref(null);
      var formatList = computed(function() {
        return toArray$6(getDefaultFormat(props2.format, props2.picker, props2.showTime, props2.use12Hours));
      });
      var _useMergedState = useMergedState(0, {
        value: toRef(props2, "activePickerIndex")
      }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedActivePickerIndex = _useMergedState2[0], setMergedActivePickerIndex = _useMergedState2[1];
      var operationRef = ref(null);
      var mergedDisabled = computed(function() {
        var disabled = props2.disabled;
        if (Array.isArray(disabled)) {
          return disabled;
        }
        return [disabled || false, disabled || false];
      });
      var _useMergedState3 = useMergedState(null, {
        value: toRef(props2, "value"),
        defaultValue: props2.defaultValue,
        postState: function postState(values) {
          return props2.picker === "time" && !props2.order ? values : reorderValues(values, props2.generateConfig);
        }
      }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), mergedValue = _useMergedState4[0], setInnerValue = _useMergedState4[1];
      var _useRangeViewDates = useRangeViewDates({
        values: mergedValue,
        picker: toRef(props2, "picker"),
        defaultDates: props2.defaultPickerValue,
        generateConfig: toRef(props2, "generateConfig")
      }), _useRangeViewDates2 = _slicedToArray$2(_useRangeViewDates, 3), startViewDate = _useRangeViewDates2[0], endViewDate = _useRangeViewDates2[1], setViewDate = _useRangeViewDates2[2];
      var _useMergedState5 = useMergedState(mergedValue.value, {
        postState: function postState(values) {
          var postValues = values;
          if (mergedDisabled.value[0] && mergedDisabled.value[1]) {
            return postValues;
          }
          for (var i2 = 0; i2 < 2; i2 += 1) {
            if (mergedDisabled[i2] && !getValue$2(postValues, i2) && !getValue$2(props2.allowEmpty, i2)) {
              postValues = updateValues(postValues, props2.generateConfig.getNow(), i2);
            }
          }
          return postValues;
        }
      }), _useMergedState6 = _slicedToArray$2(_useMergedState5, 2), selectedValue = _useMergedState6[0], setSelectedValue = _useMergedState6[1];
      var _useMergedState7 = useMergedState([props2.picker, props2.picker], {
        value: toRef(props2, "mode")
      }), _useMergedState8 = _slicedToArray$2(_useMergedState7, 2), mergedModes = _useMergedState8[0], setInnerModes = _useMergedState8[1];
      watch(function() {
        return props2.picker;
      }, function() {
        setInnerModes([props2.picker, props2.picker]);
      });
      var triggerModesChange = function triggerModesChange2(modes, values) {
        var _a2;
        setInnerModes(modes);
        (_a2 = props2.onPanelChange) === null || _a2 === void 0 ? void 0 : _a2.call(props2, values, modes);
      };
      var _useRangeDisabled = useRangeDisabled({
        picker: toRef(props2, "picker"),
        selectedValue,
        locale: toRef(props2, "locale"),
        disabled: mergedDisabled,
        disabledDate: toRef(props2, "disabledDate"),
        generateConfig: toRef(props2, "generateConfig")
      }, openRecordsRef), _useRangeDisabled2 = _slicedToArray$2(_useRangeDisabled, 2), disabledStartDate = _useRangeDisabled2[0], disabledEndDate = _useRangeDisabled2[1];
      var _useMergedState9 = useMergedState(false, {
        value: toRef(props2, "open"),
        defaultValue: props2.defaultOpen,
        postState: function postState(postOpen) {
          return mergedDisabled.value[mergedActivePickerIndex.value] ? false : postOpen;
        },
        onChange: function onChange3(newOpen) {
          var _a2;
          (_a2 = props2.onOpenChange) === null || _a2 === void 0 ? void 0 : _a2.call(props2, newOpen);
          if (!newOpen && operationRef.value && operationRef.value.onClose) {
            operationRef.value.onClose();
          }
        }
      }), _useMergedState10 = _slicedToArray$2(_useMergedState9, 2), mergedOpen = _useMergedState10[0], triggerInnerOpen = _useMergedState10[1];
      var startOpen = computed(function() {
        return mergedOpen.value && mergedActivePickerIndex.value === 0;
      });
      var endOpen = computed(function() {
        return mergedOpen.value && mergedActivePickerIndex.value === 1;
      });
      var popupMinWidth = ref(0);
      watch(mergedOpen, function() {
        if (!mergedOpen.value && containerRef.value) {
          popupMinWidth.value = containerRef.value.offsetWidth;
        }
      });
      var triggerRef = ref();
      function _triggerOpen(newOpen, index2) {
        if (newOpen) {
          clearTimeout(triggerRef.value);
          openRecordsRef.value[index2] = true;
          setMergedActivePickerIndex(index2);
          triggerInnerOpen(newOpen);
          if (!mergedOpen.value) {
            setViewDate(null, index2);
          }
        } else if (mergedActivePickerIndex.value === index2) {
          triggerInnerOpen(newOpen);
          var openRecords = openRecordsRef.value;
          triggerRef.value = setTimeout(function() {
            if (openRecords === openRecordsRef.value) {
              openRecordsRef.value = {};
            }
          });
        }
      }
      function triggerOpenAndFocus(index2) {
        _triggerOpen(true, index2);
        setTimeout(function() {
          var inputRef = [startInputRef, endInputRef][index2];
          if (inputRef.value) {
            inputRef.value.focus();
          }
        }, 0);
      }
      function triggerChange(newValue, sourceIndex) {
        var values = newValue;
        var startValue = getValue$2(values, 0);
        var endValue = getValue$2(values, 1);
        var generateConfig2 = props2.generateConfig, locale2 = props2.locale, picker = props2.picker, order = props2.order, onCalendarChange = props2.onCalendarChange, allowEmpty = props2.allowEmpty, onChange3 = props2.onChange, showTime = props2.showTime;
        if (startValue && endValue && generateConfig2.isAfter(startValue, endValue)) {
          if (picker === "week" && !isSameWeek(generateConfig2, locale2.locale, startValue, endValue) || picker === "quarter" && !isSameQuarter(generateConfig2, startValue, endValue) || picker !== "week" && picker !== "quarter" && picker !== "time" && !(showTime ? isEqual$1(generateConfig2, startValue, endValue) : isSameDate(generateConfig2, startValue, endValue))) {
            if (sourceIndex === 0) {
              values = [startValue, null];
              endValue = null;
            } else {
              startValue = null;
              values = [null, endValue];
            }
            openRecordsRef.value = _defineProperty$R({}, sourceIndex, true);
          } else if (picker !== "time" || order !== false) {
            values = reorderValues(values, generateConfig2);
          }
        }
        setSelectedValue(values);
        var startStr2 = values && values[0] ? formatValue(values[0], {
          generateConfig: generateConfig2,
          locale: locale2,
          format: formatList.value[0]
        }) : "";
        var endStr2 = values && values[1] ? formatValue(values[1], {
          generateConfig: generateConfig2,
          locale: locale2,
          format: formatList.value[0]
        }) : "";
        if (onCalendarChange) {
          var info = {
            range: sourceIndex === 0 ? "start" : "end"
          };
          onCalendarChange(values, [startStr2, endStr2], info);
        }
        var canStartValueTrigger = canValueTrigger(startValue, 0, mergedDisabled.value, allowEmpty);
        var canEndValueTrigger = canValueTrigger(endValue, 1, mergedDisabled.value, allowEmpty);
        var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;
        if (canTrigger) {
          setInnerValue(values);
          if (onChange3 && (!isEqual$1(generateConfig2, getValue$2(mergedValue.value, 0), startValue) || !isEqual$1(generateConfig2, getValue$2(mergedValue.value, 1), endValue))) {
            onChange3(values, [startStr2, endStr2]);
          }
        }
        var nextOpenIndex = null;
        if (sourceIndex === 0 && !mergedDisabled.value[1]) {
          nextOpenIndex = 1;
        } else if (sourceIndex === 1 && !mergedDisabled.value[0]) {
          nextOpenIndex = 0;
        }
        if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex.value && (!openRecordsRef.value[nextOpenIndex] || !getValue$2(values, nextOpenIndex)) && getValue$2(values, sourceIndex)) {
          triggerOpenAndFocus(nextOpenIndex);
        } else {
          _triggerOpen(false, sourceIndex);
        }
      }
      var forwardKeydown = function forwardKeydown2(e2) {
        if (mergedOpen && operationRef.value && operationRef.value.onKeydown) {
          return operationRef.value.onKeydown(e2);
        }
        {
          return false;
        }
      };
      var sharedTextHooksProps = {
        formatList,
        generateConfig: toRef(props2, "generateConfig"),
        locale: toRef(props2, "locale")
      };
      var _useValueTexts = useValueTexts(computed(function() {
        return getValue$2(selectedValue.value, 0);
      }), sharedTextHooksProps), _useValueTexts2 = _slicedToArray$2(_useValueTexts, 2), startValueTexts = _useValueTexts2[0], firstStartValueText = _useValueTexts2[1];
      var _useValueTexts3 = useValueTexts(computed(function() {
        return getValue$2(selectedValue.value, 1);
      }), sharedTextHooksProps), _useValueTexts4 = _slicedToArray$2(_useValueTexts3, 2), endValueTexts = _useValueTexts4[0], firstEndValueText = _useValueTexts4[1];
      var _onTextChange = function onTextChange(newText, index2) {
        var inputDate = parseValue(newText, {
          locale: props2.locale,
          formatList: formatList.value,
          generateConfig: props2.generateConfig
        });
        var disabledFunc = index2 === 0 ? disabledStartDate : disabledEndDate;
        if (inputDate && !disabledFunc(inputDate)) {
          setSelectedValue(updateValues(selectedValue.value, inputDate, index2));
          setViewDate(inputDate, index2);
        }
      };
      var _useTextValueMapping = useTextValueMapping({
        valueTexts: startValueTexts,
        onTextChange: function onTextChange(newText) {
          return _onTextChange(newText, 0);
        }
      }), _useTextValueMapping2 = _slicedToArray$2(_useTextValueMapping, 3), startText = _useTextValueMapping2[0], triggerStartTextChange = _useTextValueMapping2[1], resetStartText = _useTextValueMapping2[2];
      var _useTextValueMapping3 = useTextValueMapping({
        valueTexts: endValueTexts,
        onTextChange: function onTextChange(newText) {
          return _onTextChange(newText, 1);
        }
      }), _useTextValueMapping4 = _slicedToArray$2(_useTextValueMapping3, 3), endText = _useTextValueMapping4[0], triggerEndTextChange = _useTextValueMapping4[1], resetEndText = _useTextValueMapping4[2];
      var _useState = useState(null), _useState2 = _slicedToArray$2(_useState, 2), rangeHoverValue = _useState2[0], setRangeHoverValue = _useState2[1];
      var _useState3 = useState(null), _useState4 = _slicedToArray$2(_useState3, 2), hoverRangedValue = _useState4[0], setHoverRangedValue = _useState4[1];
      var _useHoverValue = useHoverValue(startText, sharedTextHooksProps), _useHoverValue2 = _slicedToArray$2(_useHoverValue, 3), startHoverValue = _useHoverValue2[0], onStartEnter = _useHoverValue2[1], onStartLeave = _useHoverValue2[2];
      var _useHoverValue3 = useHoverValue(endText, sharedTextHooksProps), _useHoverValue4 = _slicedToArray$2(_useHoverValue3, 3), endHoverValue = _useHoverValue4[0], onEndEnter = _useHoverValue4[1], onEndLeave = _useHoverValue4[2];
      var onDateMouseenter = function onDateMouseenter2(date4) {
        setHoverRangedValue(updateValues(selectedValue.value, date4, mergedActivePickerIndex.value));
        if (mergedActivePickerIndex.value === 0) {
          onStartEnter(date4);
        } else {
          onEndEnter(date4);
        }
      };
      var onDateMouseleave = function onDateMouseleave2() {
        setHoverRangedValue(updateValues(selectedValue.value, null, mergedActivePickerIndex.value));
        if (mergedActivePickerIndex.value === 0) {
          onStartLeave();
        } else {
          onEndLeave();
        }
      };
      var getSharedInputHookProps = function getSharedInputHookProps2(index2, resetText) {
        return {
          forwardKeydown,
          onBlur: function onBlur2(e2) {
            var _a2;
            (_a2 = props2.onBlur) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
          },
          isClickOutside: function isClickOutside(target) {
            return !elementsContains([panelDivRef.value, startInputDivRef.value, endInputDivRef.value, containerRef.value], target);
          },
          onFocus: function onFocus2(e2) {
            var _a2;
            setMergedActivePickerIndex(index2);
            (_a2 = props2.onFocus) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
          },
          triggerOpen: function triggerOpen(newOpen) {
            _triggerOpen(newOpen, index2);
          },
          onSubmit: function onSubmit() {
            if (!selectedValue.value || props2.disabledDate && props2.disabledDate(selectedValue.value[index2])) {
              return false;
            }
            triggerChange(selectedValue.value, index2);
            resetText();
          },
          onCancel: function onCancel() {
            _triggerOpen(false, index2);
            setSelectedValue(mergedValue.value);
            resetText();
          }
        };
      };
      var _usePickerInput = usePickerInput(_extends$2(_extends$2({}, getSharedInputHookProps(0, resetStartText)), {
        blurToCancel: needConfirmButton,
        open: startOpen,
        value: startText,
        onKeydown: function onKeydown(e2, preventDefault) {
          var _a2;
          (_a2 = props2.onKeydown) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2, preventDefault);
        }
      })), _usePickerInput2 = _slicedToArray$2(_usePickerInput, 2), startInputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], startFocused = _usePickerInput2$.focused, startTyping = _usePickerInput2$.typing;
      var _usePickerInput3 = usePickerInput(_extends$2(_extends$2({}, getSharedInputHookProps(1, resetEndText)), {
        blurToCancel: needConfirmButton,
        open: endOpen,
        value: endText,
        onKeydown: function onKeydown(e2, preventDefault) {
          var _a2;
          (_a2 = props2.onKeydown) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2, preventDefault);
        }
      })), _usePickerInput4 = _slicedToArray$2(_usePickerInput3, 2), endInputProps = _usePickerInput4[0], _usePickerInput4$ = _usePickerInput4[1], endFocused = _usePickerInput4$.focused, endTyping = _usePickerInput4$.typing;
      var onPickerClick = function onPickerClick2(e2) {
        var _a2;
        (_a2 = props2.onClick) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
        if (!mergedOpen.value && !startInputRef.value.contains(e2.target) && !endInputRef.value.contains(e2.target)) {
          if (!mergedDisabled.value[0]) {
            triggerOpenAndFocus(0);
          } else if (!mergedDisabled.value[1]) {
            triggerOpenAndFocus(1);
          }
        }
      };
      var onPickerMousedown = function onPickerMousedown2(e2) {
        var _a2;
        (_a2 = props2.onMousedown) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
        if (mergedOpen.value && (startFocused.value || endFocused.value) && !startInputRef.value.contains(e2.target) && !endInputRef.value.contains(e2.target)) {
          e2.preventDefault();
        }
      };
      var startStr = computed(function() {
        var _a2;
        return ((_a2 = mergedValue.value) === null || _a2 === void 0 ? void 0 : _a2[0]) ? formatValue(mergedValue.value[0], {
          locale: props2.locale,
          format: "YYYYMMDDHHmmss",
          generateConfig: props2.generateConfig
        }) : "";
      });
      var endStr = computed(function() {
        var _a2;
        return ((_a2 = mergedValue.value) === null || _a2 === void 0 ? void 0 : _a2[1]) ? formatValue(mergedValue.value[1], {
          locale: props2.locale,
          format: "YYYYMMDDHHmmss",
          generateConfig: props2.generateConfig
        }) : "";
      });
      watch([mergedOpen, startValueTexts, endValueTexts], function() {
        if (!mergedOpen.value) {
          setSelectedValue(mergedValue.value);
          if (!startValueTexts.value.length || startValueTexts.value[0] === "") {
            triggerStartTextChange("");
          } else if (firstStartValueText.value !== startText.value) {
            resetStartText();
          }
          if (!endValueTexts.value.length || endValueTexts.value[0] === "") {
            triggerEndTextChange("");
          } else if (firstEndValueText.value !== endText.value) {
            resetEndText();
          }
        }
      });
      watch([startStr, endStr], function() {
        setSelectedValue(mergedValue.value);
      });
      expose({
        focus: function focus2() {
          if (startInputRef.value) {
            startInputRef.value.focus();
          }
        },
        blur: function blur() {
          if (startInputRef.value) {
            startInputRef.value.blur();
          }
          if (endInputRef.value) {
            endInputRef.value.blur();
          }
        }
      });
      var rangeList = computed(function() {
        return Object.keys(props2.ranges || {}).map(function(label) {
          var range3 = props2.ranges[label];
          var newValues = typeof range3 === "function" ? range3() : range3;
          return {
            label,
            onClick: function onClick2() {
              triggerChange(newValues, null);
              _triggerOpen(false, mergedActivePickerIndex.value);
            },
            onMouseenter: function onMouseenter2() {
              setRangeHoverValue(newValues);
            },
            onMouseleave: function onMouseleave2() {
              setRangeHoverValue(null);
            }
          };
        });
      });
      var panelHoverRangedValue = computed(function() {
        if (mergedOpen.value && hoverRangedValue.value && hoverRangedValue.value[0] && hoverRangedValue.value[1] && props2.generateConfig.isAfter(hoverRangedValue.value[1], hoverRangedValue.value[0])) {
          return hoverRangedValue.value;
        } else {
          return null;
        }
      });
      function renderPanel() {
        var panelPosition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var panelProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var generateConfig2 = props2.generateConfig, showTime = props2.showTime, dateRender = props2.dateRender, direction2 = props2.direction, _disabledTime = props2.disabledTime, prefixCls2 = props2.prefixCls, locale2 = props2.locale;
        var panelShowTime = showTime;
        if (showTime && _typeof$2(showTime) === "object" && showTime.defaultValue) {
          var timeDefaultValues = showTime.defaultValue;
          panelShowTime = _extends$2(_extends$2({}, showTime), {
            defaultValue: getValue$2(timeDefaultValues, mergedActivePickerIndex.value) || void 0
          });
        }
        var panelDateRender = null;
        if (dateRender) {
          panelDateRender = function panelDateRender2(_ref2) {
            var date4 = _ref2.current, today = _ref2.today;
            return dateRender({
              current: date4,
              today,
              info: {
                range: mergedActivePickerIndex.value ? "end" : "start"
              }
            });
          };
        }
        return createVNode(RangeContextProvider, {
          "value": {
            inRange: true,
            panelPosition,
            rangedValue: rangeHoverValue.value || selectedValue.value,
            hoverRangedValue: panelHoverRangedValue.value
          }
        }, {
          default: function _default7() {
            return [createVNode(PickerPanel$1, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, props2), panelProps), {}, {
              "dateRender": panelDateRender,
              "showTime": panelShowTime,
              "mode": mergedModes.value[mergedActivePickerIndex.value],
              "generateConfig": generateConfig2,
              "style": void 0,
              "direction": direction2,
              "disabledDate": mergedActivePickerIndex.value === 0 ? disabledStartDate : disabledEndDate,
              "disabledTime": function disabledTime(date4) {
                if (_disabledTime) {
                  return _disabledTime(date4, mergedActivePickerIndex.value === 0 ? "start" : "end");
                }
                return false;
              },
              "class": classNames(_defineProperty$R({}, "".concat(prefixCls2, "-panel-focused"), mergedActivePickerIndex.value === 0 ? !startTyping.value : !endTyping.value)),
              "value": getValue$2(selectedValue.value, mergedActivePickerIndex.value),
              "locale": locale2,
              "tabIndex": -1,
              "onPanelChange": function onPanelChange(date4, newMode) {
                if (mergedActivePickerIndex.value === 0) {
                  onStartLeave(true);
                }
                if (mergedActivePickerIndex.value === 1) {
                  onEndLeave(true);
                }
                triggerModesChange(updateValues(mergedModes.value, newMode, mergedActivePickerIndex.value), updateValues(selectedValue.value, date4, mergedActivePickerIndex.value));
                var viewDate = date4;
                if (panelPosition === "right" && mergedModes.value[mergedActivePickerIndex.value] === newMode) {
                  viewDate = getClosingViewDate(viewDate, newMode, generateConfig2, -1);
                }
                setViewDate(viewDate, mergedActivePickerIndex.value);
              },
              "onOk": null,
              "onSelect": void 0,
              "onChange": void 0,
              "defaultValue": mergedActivePickerIndex.value === 0 ? getValue$2(selectedValue.value, 1) : getValue$2(selectedValue.value, 0)
            }), null)];
          }
        });
      }
      var onContextSelect = function onContextSelect2(date4, type4) {
        var values = updateValues(selectedValue.value, date4, mergedActivePickerIndex.value);
        if (type4 === "submit" || type4 !== "key" && !needConfirmButton.value) {
          triggerChange(values, mergedActivePickerIndex.value);
          if (mergedActivePickerIndex.value === 0) {
            onStartLeave();
          } else {
            onEndLeave();
          }
        } else {
          setSelectedValue(values);
        }
      };
      useProvidePanel({
        operationRef,
        hideHeader: computed(function() {
          return props2.picker === "time";
        }),
        onDateMouseenter,
        onDateMouseleave,
        hideRanges: computed(function() {
          return true;
        }),
        onSelect: onContextSelect,
        open: mergedOpen
      });
      return function() {
        var _classNames2, _classNames3, _classNames4;
        var _props$prefixCls = props2.prefixCls, prefixCls2 = _props$prefixCls === void 0 ? "rc-picker" : _props$prefixCls, id = props2.id, popupStyle = props2.popupStyle, dropdownClassName = props2.dropdownClassName, transitionName2 = props2.transitionName, dropdownAlign = props2.dropdownAlign, getPopupContainer = props2.getPopupContainer, generateConfig2 = props2.generateConfig, locale2 = props2.locale, placeholder = props2.placeholder, autofocus = props2.autofocus, _props$picker = props2.picker, picker = _props$picker === void 0 ? "date" : _props$picker, showTime = props2.showTime, _props$separator = props2.separator, separator = _props$separator === void 0 ? "~" : _props$separator, disabledDate = props2.disabledDate, panelRender = props2.panelRender, allowClear = props2.allowClear, suffixIcon = props2.suffixIcon, clearIcon = props2.clearIcon, inputReadOnly = props2.inputReadOnly, renderExtraFooter = props2.renderExtraFooter, onMouseenter2 = props2.onMouseenter, onMouseleave2 = props2.onMouseleave, onMouseup = props2.onMouseup, _onOk = props2.onOk, components2 = props2.components, direction2 = props2.direction, _props$autocomplete = props2.autocomplete, autocomplete = _props$autocomplete === void 0 ? "off" : _props$autocomplete;
        var arrowLeft = 0;
        var panelLeft = 0;
        if (mergedActivePickerIndex.value && startInputDivRef.value && separatorRef.value && panelDivRef.value) {
          arrowLeft = startInputDivRef.value.offsetWidth + separatorRef.value.offsetWidth;
          if (panelDivRef.value.offsetWidth && arrowRef.value.offsetWidth && arrowLeft > panelDivRef.value.offsetWidth - arrowRef.value.offsetWidth - (direction2 === "rtl" || arrowRef.value.offsetLeft > arrowLeft ? 0 : arrowRef.value.offsetLeft)) {
            panelLeft = arrowLeft;
          }
        }
        var arrowPositionStyle = direction2 === "rtl" ? {
          right: arrowLeft
        } : {
          left: arrowLeft
        };
        function renderPanels() {
          var panels;
          var extraNode = getExtraFooter(prefixCls2, mergedModes.value[mergedActivePickerIndex.value], renderExtraFooter);
          var rangesNode = getRanges({
            prefixCls: prefixCls2,
            components: components2,
            needConfirmButton: needConfirmButton.value,
            okDisabled: !getValue$2(selectedValue.value, mergedActivePickerIndex.value) || disabledDate && disabledDate(selectedValue.value[mergedActivePickerIndex.value]),
            locale: locale2,
            rangeList: rangeList.value,
            onOk: function onOk() {
              if (getValue$2(selectedValue.value, mergedActivePickerIndex.value)) {
                triggerChange(selectedValue.value, mergedActivePickerIndex.value);
                if (_onOk) {
                  _onOk(selectedValue.value);
                }
              }
            }
          });
          if (picker !== "time" && !showTime) {
            var viewDate = mergedActivePickerIndex.value === 0 ? startViewDate.value : endViewDate.value;
            var nextViewDate = getClosingViewDate(viewDate, picker, generateConfig2);
            var currentMode = mergedModes.value[mergedActivePickerIndex.value];
            var showDoublePanel = currentMode === picker;
            var leftPanel = renderPanel(showDoublePanel ? "left" : false, {
              pickerValue: viewDate,
              onPickerValueChange: function onPickerValueChange(newViewDate) {
                setViewDate(newViewDate, mergedActivePickerIndex.value);
              }
            });
            var rightPanel = renderPanel("right", {
              pickerValue: nextViewDate,
              onPickerValueChange: function onPickerValueChange(newViewDate) {
                setViewDate(getClosingViewDate(newViewDate, picker, generateConfig2, -1), mergedActivePickerIndex.value);
              }
            });
            if (direction2 === "rtl") {
              panels = createVNode(Fragment, null, [rightPanel, showDoublePanel && leftPanel]);
            } else {
              panels = createVNode(Fragment, null, [leftPanel, showDoublePanel && rightPanel]);
            }
          } else {
            panels = renderPanel();
          }
          var mergedNodes = createVNode(Fragment, null, [createVNode("div", {
            "class": "".concat(prefixCls2, "-panels")
          }, [panels]), (extraNode || rangesNode) && createVNode("div", {
            "class": "".concat(prefixCls2, "-footer")
          }, [extraNode, rangesNode])]);
          if (panelRender) {
            mergedNodes = panelRender(mergedNodes);
          }
          return createVNode("div", {
            "class": "".concat(prefixCls2, "-panel-container"),
            "style": {
              marginLeft: panelLeft
            },
            "ref": panelDivRef,
            "onMousedown": function onMousedown2(e2) {
              e2.preventDefault();
            }
          }, [mergedNodes]);
        }
        var rangePanel = createVNode("div", {
          "class": classNames("".concat(prefixCls2, "-range-wrapper"), "".concat(prefixCls2, "-").concat(picker, "-range-wrapper")),
          "style": {
            minWidth: "".concat(popupMinWidth.value, "px")
          }
        }, [createVNode("div", {
          "ref": arrowRef,
          "class": "".concat(prefixCls2, "-range-arrow"),
          "style": arrowPositionStyle
        }, null), renderPanels()]);
        var suffixNode;
        if (suffixIcon) {
          suffixNode = createVNode("span", {
            "class": "".concat(prefixCls2, "-suffix")
          }, [suffixIcon]);
        }
        var clearNode;
        if (allowClear && (getValue$2(mergedValue.value, 0) && !mergedDisabled.value[0] || getValue$2(mergedValue.value, 1) && !mergedDisabled.value[1])) {
          clearNode = createVNode("span", {
            "onMousedown": function onMousedown2(e2) {
              e2.preventDefault();
              e2.stopPropagation();
            },
            "onMouseup": function onMouseup2(e2) {
              e2.preventDefault();
              e2.stopPropagation();
              var values = mergedValue.value;
              if (!mergedDisabled.value[0]) {
                values = updateValues(values, null, 0);
              }
              if (!mergedDisabled.value[1]) {
                values = updateValues(values, null, 1);
              }
              triggerChange(values, null);
              _triggerOpen(false, mergedActivePickerIndex.value);
            },
            "class": "".concat(prefixCls2, "-clear")
          }, [clearIcon || createVNode("span", {
            "class": "".concat(prefixCls2, "-clear-btn")
          }, null)]);
        }
        var inputSharedProps = {
          size: getInputSize(picker, formatList.value[0], generateConfig2)
        };
        var activeBarLeft = 0;
        var activeBarWidth = 0;
        if (startInputDivRef.value && endInputDivRef.value && separatorRef.value) {
          if (mergedActivePickerIndex.value === 0) {
            activeBarWidth = startInputDivRef.value.offsetWidth;
          } else {
            activeBarLeft = arrowLeft;
            activeBarWidth = endInputDivRef.value.offsetWidth;
          }
        }
        var activeBarPositionStyle = direction2 === "rtl" ? {
          right: "".concat(activeBarLeft, "px")
        } : {
          left: "".concat(activeBarLeft, "px")
        };
        return createVNode(PickerTrigger, {
          "visible": mergedOpen.value,
          "popupStyle": popupStyle,
          "prefixCls": prefixCls2,
          "dropdownClassName": dropdownClassName,
          "dropdownAlign": dropdownAlign,
          "getPopupContainer": getPopupContainer,
          "transitionName": transitionName2,
          "range": true,
          "direction": direction2
        }, {
          default: function _default7() {
            return [createVNode("div", _objectSpread2$2({
              "ref": containerRef,
              "class": classNames(prefixCls2, "".concat(prefixCls2, "-range"), attrs.class, (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2, "-disabled"), mergedDisabled.value[0] && mergedDisabled.value[1]), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-focused"), mergedActivePickerIndex.value === 0 ? startFocused.value : endFocused.value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-rtl"), direction2 === "rtl"), _classNames2)),
              "style": attrs.style,
              "onClick": onPickerClick,
              "onMouseenter": onMouseenter2,
              "onMouseleave": onMouseleave2,
              "onMousedown": onPickerMousedown,
              "onMouseup": onMouseup
            }, getDataOrAriaProps(props2)), [createVNode("div", {
              "class": classNames("".concat(prefixCls2, "-input"), (_classNames3 = {}, _defineProperty$R(_classNames3, "".concat(prefixCls2, "-input-active"), mergedActivePickerIndex.value === 0), _defineProperty$R(_classNames3, "".concat(prefixCls2, "-input-placeholder"), !!startHoverValue.value), _classNames3)),
              "ref": startInputDivRef
            }, [createVNode("input", _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
              "id": id,
              "disabled": mergedDisabled.value[0],
              "readonly": inputReadOnly || typeof formatList.value[0] === "function" || !startTyping.value,
              "value": startHoverValue.value || startText.value,
              "onInput": function onInput(e2) {
                triggerStartTextChange(e2.target.value);
              },
              "autofocus": autofocus,
              "placeholder": getValue$2(placeholder, 0) || "",
              "ref": startInputRef
            }, startInputProps.value), inputSharedProps), {}, {
              "autocomplete": autocomplete
            }), null)]), createVNode("div", {
              "class": "".concat(prefixCls2, "-range-separator"),
              "ref": separatorRef
            }, [separator]), createVNode("div", {
              "class": classNames("".concat(prefixCls2, "-input"), (_classNames4 = {}, _defineProperty$R(_classNames4, "".concat(prefixCls2, "-input-active"), mergedActivePickerIndex.value === 1), _defineProperty$R(_classNames4, "".concat(prefixCls2, "-input-placeholder"), !!endHoverValue.value), _classNames4)),
              "ref": endInputDivRef
            }, [createVNode("input", _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
              "disabled": mergedDisabled.value[1],
              "readonly": inputReadOnly || typeof formatList.value[0] === "function" || !endTyping.value,
              "value": endHoverValue.value || endText.value,
              "onInput": function onInput(e2) {
                triggerEndTextChange(e2.target.value);
              },
              "placeholder": getValue$2(placeholder, 1) || "",
              "ref": endInputRef
            }, endInputProps.value), inputSharedProps), {}, {
              "autocomplete": autocomplete
            }), null)]), createVNode("div", {
              "class": "".concat(prefixCls2, "-active-bar"),
              "style": _extends$2(_extends$2({}, activeBarPositionStyle), {
                width: "".concat(activeBarWidth, "px"),
                position: "absolute"
              })
            }, null), suffixNode, clearNode, getPortal()])];
          },
          popupElement: function popupElement() {
            return rangePanel;
          }
        });
      };
    }
  });
}
var InterRangerPicker = RangerPicker();
var VCRangePicker = InterRangerPicker;
var __rest$x = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var checkboxProps$1 = {
  prefixCls: String,
  name: String,
  id: String,
  type: String,
  defaultChecked: {
    type: [Boolean, Number],
    default: void 0
  },
  checked: {
    type: [Boolean, Number],
    default: void 0
  },
  disabled: Boolean,
  tabindex: {
    type: [Number, String]
  },
  readonly: Boolean,
  autofocus: Boolean,
  value: PropTypes$1.any,
  required: Boolean
};
var VcCheckbox = defineComponent({
  name: "Checkbox",
  inheritAttrs: false,
  props: initDefaultProps$1(checkboxProps$1, {
    prefixCls: "rc-checkbox",
    type: "checkbox",
    defaultChecked: false
  }),
  emits: ["click", "change"],
  setup: function setup57(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit, expose = _ref.expose;
    var checked = ref(props2.checked === void 0 ? props2.defaultChecked : props2.checked);
    var inputRef = ref();
    watch(function() {
      return props2.checked;
    }, function() {
      checked.value = props2.checked;
    });
    onMounted(function() {
      nextTick(function() {
      });
    });
    expose({
      focus: function focus2() {
        var _a2;
        (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _a2;
        (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    });
    var eventShiftKey = ref();
    var handleChange2 = function handleChange3(e2) {
      if (props2.disabled) {
        return;
      }
      if (props2.checked === void 0) {
        checked.value = e2.target.checked;
      }
      e2.shiftKey = eventShiftKey.value;
      var eventObj = {
        target: _extends$2(_extends$2({}, props2), {
          checked: e2.target.checked
        }),
        stopPropagation: function stopPropagation() {
          e2.stopPropagation();
        },
        preventDefault: function preventDefault() {
          e2.preventDefault();
        },
        nativeEvent: e2
      };
      if (props2.checked !== void 0) {
        inputRef.value.checked = !!props2.checked;
      }
      emit("change", eventObj);
      eventShiftKey.value = false;
    };
    var onClick2 = function onClick3(e2) {
      emit("click", e2);
      eventShiftKey.value = e2.shiftKey;
    };
    return function() {
      var _classNames;
      var prefixCls2 = props2.prefixCls, name2 = props2.name, id = props2.id, type4 = props2.type, disabled = props2.disabled, readonly2 = props2.readonly, tabindex = props2.tabindex, autofocus = props2.autofocus, value = props2.value, required4 = props2.required, others = __rest$x(props2, ["prefixCls", "name", "id", "type", "disabled", "readonly", "tabindex", "autofocus", "value", "required"]);
      var className = attrs.class, onFocus2 = attrs.onFocus, onBlur2 = attrs.onBlur, onKeydown = attrs.onKeydown, onKeypress = attrs.onKeypress, onKeyup = attrs.onKeyup;
      var globalProps = Object.keys(_extends$2(_extends$2({}, others), attrs)).reduce(function(prev2, key2) {
        if (key2.substr(0, 5) === "aria-" || key2.substr(0, 5) === "data-" || key2 === "role") {
          prev2[key2] = others[key2];
        }
        return prev2;
      }, {});
      var classString = classNames(prefixCls2, className, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-checked"), checked.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-disabled"), disabled), _classNames));
      var inputProps3 = _extends$2(_extends$2({
        name: name2,
        id,
        type: type4,
        readonly: readonly2,
        disabled,
        tabindex,
        class: "".concat(prefixCls2, "-input"),
        checked: !!checked.value,
        autofocus,
        value
      }, globalProps), {
        onChange: handleChange2,
        onClick: onClick2,
        onFocus: onFocus2,
        onBlur: onBlur2,
        onKeydown,
        onKeypress,
        onKeyup,
        required: required4
      });
      return createVNode("span", {
        "class": classString
      }, [createVNode("input", _objectSpread2$2({
        "ref": inputRef
      }, inputProps3), null), createVNode("span", {
        "class": "".concat(prefixCls2, "-inner")
      }, null)]);
    };
  }
});
var __rest$w = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var radioProps = function radioProps2() {
  return {
    prefixCls: String,
    checked: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    isGroup: {
      type: Boolean,
      default: void 0
    },
    value: PropTypes$1.any,
    name: String,
    id: String,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    onChange: Function,
    onFocus: Function,
    onBlur: Function,
    onClick: Function,
    "onUpdate:checked": Function,
    "onUpdate:value": Function
  };
};
var Radio = defineComponent({
  name: "ARadio",
  props: radioProps(),
  setup: function setup58(props2, _ref) {
    var emit = _ref.emit, expose = _ref.expose, slots = _ref.slots;
    var formItemContext = useInjectFormItemContext();
    var vcCheckbox = ref();
    var radioGroupContext = inject("radioGroupContext", void 0);
    var _useConfigInject = useConfigInject("radio", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var focus2 = function focus3() {
      vcCheckbox.value.focus();
    };
    var blur = function blur2() {
      vcCheckbox.value.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    var handleChange2 = function handleChange3(event) {
      var targetChecked = event.target.checked;
      emit("update:checked", targetChecked);
      emit("update:value", targetChecked);
      emit("change", event);
      formItemContext.onFieldChange();
    };
    var onChange3 = function onChange4(e2) {
      emit("change", e2);
      if (radioGroupContext && radioGroupContext.onRadioChange) {
        radioGroupContext.onRadioChange(e2);
      }
    };
    return function() {
      var _classNames;
      var radioGroup2 = radioGroupContext;
      props2.prefixCls;
      var _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, restProps = __rest$w(props2, ["prefixCls", "id"]);
      var rProps = _extends$2({
        prefixCls: prefixCls2.value,
        id
      }, omit$3(restProps, ["onUpdate:checked", "onUpdate:value"]));
      if (radioGroup2) {
        rProps.name = radioGroup2.props.name;
        rProps.onChange = onChange3;
        rProps.checked = props2.value === radioGroup2.stateValue.value;
        rProps.disabled = props2.disabled || radioGroup2.props.disabled;
      } else {
        rProps.onChange = handleChange2;
      }
      var wrapperClassString = classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper"), true), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper-checked"), rProps.checked), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper-disabled"), rProps.disabled), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper-rtl"), direction2.value === "rtl"), _classNames));
      return createVNode("label", {
        "class": wrapperClassString
      }, [createVNode(VcCheckbox, _objectSpread2$2(_objectSpread2$2({}, rProps), {}, {
        "type": "radio",
        "ref": vcCheckbox
      }), null), slots.default && createVNode("span", null, [slots.default()])]);
    };
  }
});
var RadioGroupSizeTypes = tuple$1("large", "default", "small");
var radioGroupProps = function radioGroupProps2() {
  return {
    prefixCls: String,
    value: PropTypes$1.any,
    size: PropTypes$1.oneOf(RadioGroupSizeTypes).def("default"),
    options: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    name: String,
    buttonStyle: {
      type: String,
      default: "outline"
    },
    id: String,
    optionType: {
      type: String,
      default: "default"
    },
    onChange: Function,
    "onUpdate:value": Function
  };
};
var RadioGroup$1 = defineComponent({
  name: "ARadioGroup",
  props: radioGroupProps(),
  setup: function setup59(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("radio", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, size = _useConfigInject.size;
    var stateValue = ref(props2.value);
    var updatingValue = ref(false);
    watch(function() {
      return props2.value;
    }, function(val) {
      stateValue.value = val;
      updatingValue.value = false;
    });
    var onRadioChange = function onRadioChange2(ev) {
      var lastValue = stateValue.value;
      var value = ev.target.value;
      if (!("value" in props2)) {
        stateValue.value = value;
      }
      if (!updatingValue.value && value !== lastValue) {
        updatingValue.value = true;
        emit("update:value", value);
        emit("change", ev);
        formItemContext.onFieldChange();
      }
      nextTick(function() {
        updatingValue.value = false;
      });
    };
    provide("radioGroupContext", {
      onRadioChange,
      stateValue,
      props: props2
    });
    return function() {
      var _classNames;
      var _a2;
      var options = props2.options, optionType = props2.optionType, buttonStyle = props2.buttonStyle, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id;
      var groupPrefixCls = "".concat(prefixCls2.value, "-group");
      var classString = classNames(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (_classNames = {}, _defineProperty$R(_classNames, "".concat(groupPrefixCls, "-").concat(size.value), size.value), _defineProperty$R(_classNames, "".concat(groupPrefixCls, "-rtl"), direction2.value === "rtl"), _classNames));
      var children = null;
      if (options && options.length > 0) {
        var optionsPrefixCls = optionType === "button" ? "".concat(prefixCls2.value, "-button") : prefixCls2.value;
        children = options.map(function(option2) {
          if (typeof option2 === "string" || typeof option2 === "number") {
            return createVNode(Radio, {
              "key": option2,
              "prefixCls": optionsPrefixCls,
              "disabled": props2.disabled,
              "value": option2,
              "checked": stateValue.value === option2
            }, {
              default: function _default7() {
                return [option2];
              }
            });
          }
          var value = option2.value, disabled = option2.disabled, label = option2.label;
          return createVNode(Radio, {
            "key": "radio-group-value-options-".concat(value),
            "prefixCls": optionsPrefixCls,
            "disabled": disabled || props2.disabled,
            "value": value,
            "checked": stateValue.value === value
          }, {
            default: function _default7() {
              return [label];
            }
          });
        });
      } else {
        children = (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      }
      return createVNode("div", {
        "class": classString,
        "id": id
      }, [children]);
    };
  }
});
var Button$1 = defineComponent({
  name: "ARadioButton",
  props: radioProps(),
  setup: function setup60(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("radio-button", props2), prefixCls2 = _useConfigInject.prefixCls;
    var radioGroupContext = inject("radioGroupContext", void 0);
    return function() {
      var _a2;
      var rProps = _extends$2(_extends$2({}, props2), {
        prefixCls: prefixCls2.value
      });
      if (radioGroupContext) {
        rProps.onChange = radioGroupContext.onRadioChange;
        rProps.checked = rProps.value === radioGroupContext.stateValue.value;
        rProps.disabled = rProps.disabled || radioGroupContext.props.disabled;
      }
      return createVNode(Radio, rProps, {
        default: function _default7() {
          return [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)];
        }
      });
    };
  }
});
Radio.Group = RadioGroup$1;
Radio.Button = Button$1;
Radio.install = function(app) {
  app.component(Radio.name, Radio);
  app.component(Radio.Group.name, Radio.Group);
  app.component(Radio.Button.name, Radio.Button);
  return app;
};
function useRaf(callback) {
  var rafRef = ref();
  var removedRef = ref(false);
  function trigger2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!removedRef.value) {
      wrapperRaf.cancel(rafRef.value);
      rafRef.value = wrapperRaf(function() {
        callback.apply(void 0, args);
      });
    }
  }
  onBeforeUnmount(function() {
    removedRef.value = true;
    wrapperRaf.cancel(rafRef.value);
  });
  return trigger2;
}
function useRafState(defaultState) {
  var batchRef = ref([]);
  var state = ref(typeof defaultState === "function" ? defaultState() : defaultState);
  var flushUpdate = useRaf(function() {
    var value = state.value;
    batchRef.value.forEach(function(callback) {
      value = callback(value);
    });
    batchRef.value = [];
    state.value = value;
  });
  function updater(callback) {
    batchRef.value.push(callback);
    flushUpdate();
  }
  return [state, updater];
}
var TabNode = defineComponent({
  name: "TabNode",
  props: {
    id: {
      type: String
    },
    prefixCls: {
      type: String
    },
    tab: {
      type: Object
    },
    active: {
      type: Boolean
    },
    closable: {
      type: Boolean
    },
    editable: {
      type: Object
    },
    onClick: {
      type: Function
    },
    onResize: {
      type: Function
    },
    renderWrapper: {
      type: Function
    },
    removeAriaLabel: {
      type: String
    },
    onFocus: {
      type: Function
    }
  },
  emits: ["click", "resize", "remove", "focus"],
  setup: function setup61(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs;
    var domRef = ref();
    function onInternalClick(e2) {
      var _a2;
      if ((_a2 = props2.tab) === null || _a2 === void 0 ? void 0 : _a2.disabled) {
        return;
      }
      props2.onClick(e2);
    }
    expose({
      domRef
    });
    function onRemoveTab(event) {
      var _a2;
      event.preventDefault();
      event.stopPropagation();
      props2.editable.onEdit("remove", {
        key: (_a2 = props2.tab) === null || _a2 === void 0 ? void 0 : _a2.key,
        event
      });
    }
    var removable = computed(function() {
      var _a2;
      return props2.editable && props2.closable !== false && !((_a2 = props2.tab) === null || _a2 === void 0 ? void 0 : _a2.disabled);
    });
    return function() {
      var _classNames;
      var _a2;
      var prefixCls2 = props2.prefixCls, id = props2.id, active = props2.active, _props$tab = props2.tab, key2 = _props$tab.key, tab = _props$tab.tab, disabled = _props$tab.disabled, closeIcon = _props$tab.closeIcon, renderWrapper = props2.renderWrapper, removeAriaLabel = props2.removeAriaLabel, editable = props2.editable, onFocus2 = props2.onFocus;
      var tabPrefix = "".concat(prefixCls2, "-tab");
      var node = createVNode("div", {
        "key": key2,
        "ref": domRef,
        "class": classNames(tabPrefix, (_classNames = {}, _defineProperty$R(_classNames, "".concat(tabPrefix, "-with-remove"), removable.value), _defineProperty$R(_classNames, "".concat(tabPrefix, "-active"), active), _defineProperty$R(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
        "style": attrs.style,
        "onClick": onInternalClick
      }, [createVNode("div", {
        "role": "tab",
        "aria-selected": active,
        "id": id && "".concat(id, "-tab-").concat(key2),
        "class": "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key2),
        "aria-disabled": disabled,
        "tabindex": disabled ? null : 0,
        "onClick": function onClick2(e2) {
          e2.stopPropagation();
          onInternalClick(e2);
        },
        "onKeydown": function onKeydown(e2) {
          if ([KeyCode$1.SPACE, KeyCode$1.ENTER].includes(e2.which)) {
            e2.preventDefault();
            onInternalClick(e2);
          }
        },
        "onFocus": onFocus2
      }, [typeof tab === "function" ? tab() : tab]), removable.value && createVNode("button", {
        "type": "button",
        "aria-label": removeAriaLabel || "remove",
        "tabindex": 0,
        "class": "".concat(tabPrefix, "-remove"),
        "onClick": function onClick2(e2) {
          e2.stopPropagation();
          onRemoveTab(e2);
        }
      }, [(closeIcon === null || closeIcon === void 0 ? void 0 : closeIcon()) || ((_a2 = editable.removeIcon) === null || _a2 === void 0 ? void 0 : _a2.call(editable)) || "\xD7"])]);
      return renderWrapper ? renderWrapper(node) : node;
    };
  }
});
var DEFAULT_SIZE$3 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(tabs, tabSizes) {
  var offsetMap = ref(new Map());
  watchEffect(function() {
    var _a2, _b;
    var map = new Map();
    var tabsValue = tabs.value;
    var lastOffset = tabSizes.value.get((_a2 = tabsValue[0]) === null || _a2 === void 0 ? void 0 : _a2.key) || DEFAULT_SIZE$3;
    var rightOffset = lastOffset.left + lastOffset.width;
    for (var i2 = 0; i2 < tabsValue.length; i2 += 1) {
      var key2 = tabsValue[i2].key;
      var data6 = tabSizes.value.get(key2);
      if (!data6) {
        data6 = tabSizes.value.get((_b = tabsValue[i2 - 1]) === null || _b === void 0 ? void 0 : _b.key) || DEFAULT_SIZE$3;
      }
      var entity = map.get(key2) || _extends$2({}, data6);
      entity.right = rightOffset - entity.left - entity.width;
      map.set(key2, entity);
    }
    offsetMap.value = new Map(map);
  });
  return offsetMap;
}
var AddButton = defineComponent({
  name: "AddButton",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    editable: {
      type: Object
    },
    locale: {
      type: Object,
      default: void 0
    }
  },
  setup: function setup62(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs;
    var domRef = ref();
    expose({
      domRef
    });
    return function() {
      var prefixCls2 = props2.prefixCls, editable = props2.editable, locale2 = props2.locale;
      if (!editable || editable.showAdd === false) {
        return null;
      }
      return createVNode("button", {
        "ref": domRef,
        "type": "button",
        "class": "".concat(prefixCls2, "-nav-add"),
        "style": attrs.style,
        "aria-label": (locale2 === null || locale2 === void 0 ? void 0 : locale2.addAriaLabel) || "Add tab",
        "onClick": function onClick2(event) {
          editable.onEdit("add", {
            event
          });
        }
      }, [editable.addIcon ? editable.addIcon() : "+"]);
    };
  }
});
var CalendarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };
var CalendarOutlinedSvg = CalendarOutlined$2;
function _objectSpread$w(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$x(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$x(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CalendarOutlined = function CalendarOutlined2(props2, context2) {
  var p2 = _objectSpread$w({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$w({}, p2, {
    "icon": CalendarOutlinedSvg
  }), null);
};
CalendarOutlined.displayName = "CalendarOutlined";
CalendarOutlined.inheritAttrs = false;
var CalendarOutlined$1 = CalendarOutlined;
var CaretDownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };
var CaretDownFilledSvg = CaretDownFilled$2;
function _objectSpread$v(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$w(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$w(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CaretDownFilled = function CaretDownFilled2(props2, context2) {
  var p2 = _objectSpread$v({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$v({}, p2, {
    "icon": CaretDownFilledSvg
  }), null);
};
CaretDownFilled.displayName = "CaretDownFilled";
CaretDownFilled.inheritAttrs = false;
var CaretDownFilled$1 = CaretDownFilled;
var CaretDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };
var CaretDownOutlinedSvg = CaretDownOutlined$2;
function _objectSpread$u(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$v(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$v(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CaretDownOutlined = function CaretDownOutlined2(props2, context2) {
  var p2 = _objectSpread$u({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$u({}, p2, {
    "icon": CaretDownOutlinedSvg
  }), null);
};
CaretDownOutlined.displayName = "CaretDownOutlined";
CaretDownOutlined.inheritAttrs = false;
var CaretDownOutlined$1 = CaretDownOutlined;
var CaretUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };
var CaretUpOutlinedSvg = CaretUpOutlined$2;
function _objectSpread$t(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$u(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$u(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CaretUpOutlined = function CaretUpOutlined2(props2, context2) {
  var p2 = _objectSpread$t({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$t({}, p2, {
    "icon": CaretUpOutlinedSvg
  }), null);
};
CaretUpOutlined.displayName = "CaretUpOutlined";
CaretUpOutlined.inheritAttrs = false;
var CaretUpOutlined$1 = CaretUpOutlined;
var ClockCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };
var ClockCircleOutlinedSvg = ClockCircleOutlined$2;
function _objectSpread$s(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$t(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$t(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ClockCircleOutlined = function ClockCircleOutlined2(props2, context2) {
  var p2 = _objectSpread$s({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$s({}, p2, {
    "icon": ClockCircleOutlinedSvg
  }), null);
};
ClockCircleOutlined.displayName = "ClockCircleOutlined";
ClockCircleOutlined.inheritAttrs = false;
var ClockCircleOutlined$1 = ClockCircleOutlined;
var DeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };
var DeleteOutlinedSvg = DeleteOutlined$2;
function _objectSpread$r(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$s(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$s(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DeleteOutlined = function DeleteOutlined2(props2, context2) {
  var p2 = _objectSpread$r({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$r({}, p2, {
    "icon": DeleteOutlinedSvg
  }), null);
};
DeleteOutlined.displayName = "DeleteOutlined";
DeleteOutlined.inheritAttrs = false;
var DeleteOutlined$1 = DeleteOutlined;
var DoubleLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
var DoubleLeftOutlinedSvg = DoubleLeftOutlined$2;
function _objectSpread$q(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$r(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$r(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DoubleLeftOutlined = function DoubleLeftOutlined2(props2, context2) {
  var p2 = _objectSpread$q({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$q({}, p2, {
    "icon": DoubleLeftOutlinedSvg
  }), null);
};
DoubleLeftOutlined.displayName = "DoubleLeftOutlined";
DoubleLeftOutlined.inheritAttrs = false;
var DoubleLeftOutlined$1 = DoubleLeftOutlined;
var DoubleRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
var DoubleRightOutlinedSvg = DoubleRightOutlined$2;
function _objectSpread$p(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$q(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$q(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DoubleRightOutlined = function DoubleRightOutlined2(props2, context2) {
  var p2 = _objectSpread$p({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$p({}, p2, {
    "icon": DoubleRightOutlinedSvg
  }), null);
};
DoubleRightOutlined.displayName = "DoubleRightOutlined";
DoubleRightOutlined.inheritAttrs = false;
var DoubleRightOutlined$1 = DoubleRightOutlined;
var DownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };
var DownloadOutlinedSvg = DownloadOutlined$2;
function _objectSpread$o(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$p(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$p(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DownloadOutlined = function DownloadOutlined2(props2, context2) {
  var p2 = _objectSpread$o({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$o({}, p2, {
    "icon": DownloadOutlinedSvg
  }), null);
};
DownloadOutlined.displayName = "DownloadOutlined";
DownloadOutlined.inheritAttrs = false;
var DownloadOutlined$1 = DownloadOutlined;
var EyeInvisibleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
var EyeInvisibleOutlinedSvg = EyeInvisibleOutlined$2;
function _objectSpread$n(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$o(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$o(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var EyeInvisibleOutlined = function EyeInvisibleOutlined2(props2, context2) {
  var p2 = _objectSpread$n({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$n({}, p2, {
    "icon": EyeInvisibleOutlinedSvg
  }), null);
};
EyeInvisibleOutlined.displayName = "EyeInvisibleOutlined";
EyeInvisibleOutlined.inheritAttrs = false;
var EyeInvisibleOutlined$1 = EyeInvisibleOutlined;
var EyeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
var EyeOutlinedSvg = EyeOutlined$2;
function _objectSpread$m(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$n(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$n(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var EyeOutlined = function EyeOutlined2(props2, context2) {
  var p2 = _objectSpread$m({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$m({}, p2, {
    "icon": EyeOutlinedSvg
  }), null);
};
EyeOutlined.displayName = "EyeOutlined";
EyeOutlined.inheritAttrs = false;
var EyeOutlined$1 = EyeOutlined;
var FileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };
var FileOutlinedSvg = FileOutlined$2;
function _objectSpread$l(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$m(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$m(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var FileOutlined = function FileOutlined2(props2, context2) {
  var p2 = _objectSpread$l({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$l({}, p2, {
    "icon": FileOutlinedSvg
  }), null);
};
FileOutlined.displayName = "FileOutlined";
FileOutlined.inheritAttrs = false;
var FileOutlined$1 = FileOutlined;
var FileTwoTone$2 = { "icon": function render5(primaryColor, secondaryColor) {
  return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] };
}, "name": "file", "theme": "twotone" };
var FileTwoToneSvg = FileTwoTone$2;
function _objectSpread$k(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$l(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$l(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var FileTwoTone = function FileTwoTone2(props2, context2) {
  var p2 = _objectSpread$k({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$k({}, p2, {
    "icon": FileTwoToneSvg
  }), null);
};
FileTwoTone.displayName = "FileTwoTone";
FileTwoTone.inheritAttrs = false;
var FileTwoTone$1 = FileTwoTone;
var FilterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };
var FilterFilledSvg = FilterFilled$2;
function _objectSpread$j(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$k(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$k(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var FilterFilled = function FilterFilled2(props2, context2) {
  var p2 = _objectSpread$j({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$j({}, p2, {
    "icon": FilterFilledSvg
  }), null);
};
FilterFilled.displayName = "FilterFilled";
FilterFilled.inheritAttrs = false;
var FilterFilled$1 = FilterFilled;
var FolderOpenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };
var FolderOpenOutlinedSvg = FolderOpenOutlined$2;
function _objectSpread$i(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$j(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$j(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var FolderOpenOutlined = function FolderOpenOutlined2(props2, context2) {
  var p2 = _objectSpread$i({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$i({}, p2, {
    "icon": FolderOpenOutlinedSvg
  }), null);
};
FolderOpenOutlined.displayName = "FolderOpenOutlined";
FolderOpenOutlined.inheritAttrs = false;
var FolderOpenOutlined$1 = FolderOpenOutlined;
var FolderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };
var FolderOutlinedSvg = FolderOutlined$2;
function _objectSpread$h(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$i(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$i(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var FolderOutlined = function FolderOutlined2(props2, context2) {
  var p2 = _objectSpread$h({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$h({}, p2, {
    "icon": FolderOutlinedSvg
  }), null);
};
FolderOutlined.displayName = "FolderOutlined";
FolderOutlined.inheritAttrs = false;
var FolderOutlined$1 = FolderOutlined;
var FormOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z" } }] }, "name": "form", "theme": "outlined" };
var FormOutlinedSvg = FormOutlined$2;
function _objectSpread$g(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$h(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$h(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var FormOutlined = function FormOutlined2(props2, context2) {
  var p2 = _objectSpread$g({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$g({}, p2, {
    "icon": FormOutlinedSvg
  }), null);
};
FormOutlined.displayName = "FormOutlined";
FormOutlined.inheritAttrs = false;
var FormOutlined$1 = FormOutlined;
var LeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlinedSvg = LeftOutlined$2;
function _objectSpread$f(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$g(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$g(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var LeftOutlined = function LeftOutlined2(props2, context2) {
  var p2 = _objectSpread$f({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$f({}, p2, {
    "icon": LeftOutlinedSvg
  }), null);
};
LeftOutlined.displayName = "LeftOutlined";
LeftOutlined.inheritAttrs = false;
var LeftOutlined$1 = LeftOutlined;
var MinusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };
var MinusSquareOutlinedSvg = MinusSquareOutlined$2;
function _objectSpread$e(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$f(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$f(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var MinusSquareOutlined = function MinusSquareOutlined2(props2, context2) {
  var p2 = _objectSpread$e({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$e({}, p2, {
    "icon": MinusSquareOutlinedSvg
  }), null);
};
MinusSquareOutlined.displayName = "MinusSquareOutlined";
MinusSquareOutlined.inheritAttrs = false;
var MinusSquareOutlined$1 = MinusSquareOutlined;
var PaperClipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };
var PaperClipOutlinedSvg = PaperClipOutlined$2;
function _objectSpread$d(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$e(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$e(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var PaperClipOutlined = function PaperClipOutlined2(props2, context2) {
  var p2 = _objectSpread$d({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$d({}, p2, {
    "icon": PaperClipOutlinedSvg
  }), null);
};
PaperClipOutlined.displayName = "PaperClipOutlined";
PaperClipOutlined.inheritAttrs = false;
var PaperClipOutlined$1 = PaperClipOutlined;
var PictureTwoTone$2 = { "icon": function render6(primaryColor, secondaryColor) {
  return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] };
}, "name": "picture", "theme": "twotone" };
var PictureTwoToneSvg = PictureTwoTone$2;
function _objectSpread$c(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$d(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$d(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var PictureTwoTone = function PictureTwoTone2(props2, context2) {
  var p2 = _objectSpread$c({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$c({}, p2, {
    "icon": PictureTwoToneSvg
  }), null);
};
PictureTwoTone.displayName = "PictureTwoTone";
PictureTwoTone.inheritAttrs = false;
var PictureTwoTone$1 = PictureTwoTone;
var PlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };
var PlusOutlinedSvg = PlusOutlined$2;
function _objectSpread$b(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$c(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$c(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var PlusOutlined = function PlusOutlined2(props2, context2) {
  var p2 = _objectSpread$b({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$b({}, p2, {
    "icon": PlusOutlinedSvg
  }), null);
};
PlusOutlined.displayName = "PlusOutlined";
PlusOutlined.inheritAttrs = false;
var PlusOutlined$1 = PlusOutlined;
var PlusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };
var PlusSquareOutlinedSvg = PlusSquareOutlined$2;
function _objectSpread$a(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$b(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$b(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var PlusSquareOutlined = function PlusSquareOutlined2(props2, context2) {
  var p2 = _objectSpread$a({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$a({}, p2, {
    "icon": PlusSquareOutlinedSvg
  }), null);
};
PlusSquareOutlined.displayName = "PlusSquareOutlined";
PlusSquareOutlined.inheritAttrs = false;
var PlusSquareOutlined$1 = PlusSquareOutlined;
var QuestionCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };
var QuestionCircleOutlinedSvg = QuestionCircleOutlined$2;
function _objectSpread$9(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$a(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$a(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var QuestionCircleOutlined = function QuestionCircleOutlined2(props2, context2) {
  var p2 = _objectSpread$9({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$9({}, p2, {
    "icon": QuestionCircleOutlinedSvg
  }), null);
};
QuestionCircleOutlined.displayName = "QuestionCircleOutlined";
QuestionCircleOutlined.inheritAttrs = false;
var QuestionCircleOutlined$1 = QuestionCircleOutlined;
var RedoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };
var RedoOutlinedSvg = RedoOutlined$2;
function _objectSpread$8(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$9(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$9(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var RedoOutlined = function RedoOutlined2(props2, context2) {
  var p2 = _objectSpread$8({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$8({}, p2, {
    "icon": RedoOutlinedSvg
  }), null);
};
RedoOutlined.displayName = "RedoOutlined";
RedoOutlined.inheritAttrs = false;
var RedoOutlined$1 = RedoOutlined;
var RotateLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };
var RotateLeftOutlinedSvg = RotateLeftOutlined$2;
function _objectSpread$7(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$8(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$8(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var RotateLeftOutlined = function RotateLeftOutlined2(props2, context2) {
  var p2 = _objectSpread$7({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$7({}, p2, {
    "icon": RotateLeftOutlinedSvg
  }), null);
};
RotateLeftOutlined.displayName = "RotateLeftOutlined";
RotateLeftOutlined.inheritAttrs = false;
var RotateLeftOutlined$1 = RotateLeftOutlined;
var RotateRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };
var RotateRightOutlinedSvg = RotateRightOutlined$2;
function _objectSpread$6(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$7(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$7(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var RotateRightOutlined = function RotateRightOutlined2(props2, context2) {
  var p2 = _objectSpread$6({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$6({}, p2, {
    "icon": RotateRightOutlinedSvg
  }), null);
};
RotateRightOutlined.displayName = "RotateRightOutlined";
RotateRightOutlined.inheritAttrs = false;
var RotateRightOutlined$1 = RotateRightOutlined;
var StarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };
var StarFilledSvg = StarFilled$2;
function _objectSpread$5(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$6(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$6(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var StarFilled = function StarFilled2(props2, context2) {
  var p2 = _objectSpread$5({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$5({}, p2, {
    "icon": StarFilledSvg
  }), null);
};
StarFilled.displayName = "StarFilled";
StarFilled.inheritAttrs = false;
var StarFilled$1 = StarFilled;
var SwapRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };
var SwapRightOutlinedSvg = SwapRightOutlined$2;
function _objectSpread$4(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$5(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$5(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var SwapRightOutlined = function SwapRightOutlined2(props2, context2) {
  var p2 = _objectSpread$4({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$4({}, p2, {
    "icon": SwapRightOutlinedSvg
  }), null);
};
SwapRightOutlined.displayName = "SwapRightOutlined";
SwapRightOutlined.inheritAttrs = false;
var SwapRightOutlined$1 = SwapRightOutlined;
var UpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
var UpOutlinedSvg = UpOutlined$2;
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$4(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$4(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var UpOutlined = function UpOutlined2(props2, context2) {
  var p2 = _objectSpread$3({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$3({}, p2, {
    "icon": UpOutlinedSvg
  }), null);
};
UpOutlined.displayName = "UpOutlined";
UpOutlined.inheritAttrs = false;
var UpOutlined$1 = UpOutlined;
var WarningFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };
var WarningFilledSvg = WarningFilled$2;
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$3(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$3(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var WarningFilled = function WarningFilled2(props2, context2) {
  var p2 = _objectSpread$2({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$2({}, p2, {
    "icon": WarningFilledSvg
  }), null);
};
WarningFilled.displayName = "WarningFilled";
WarningFilled.inheritAttrs = false;
var WarningFilled$1 = WarningFilled;
var ZoomInOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };
var ZoomInOutlinedSvg = ZoomInOutlined$2;
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$2(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$2(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ZoomInOutlined = function ZoomInOutlined2(props2, context2) {
  var p2 = _objectSpread$1({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread$1({}, p2, {
    "icon": ZoomInOutlinedSvg
  }), null);
};
ZoomInOutlined.displayName = "ZoomInOutlined";
ZoomInOutlined.inheritAttrs = false;
var ZoomInOutlined$1 = ZoomInOutlined;
var ZoomOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };
var ZoomOutOutlinedSvg = ZoomOutOutlined$2;
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$1(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$1(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ZoomOutOutlined = function ZoomOutOutlined2(props2, context2) {
  var p2 = _objectSpread({}, props2, context2.attrs);
  return createVNode(AntdIcon, _objectSpread({}, p2, {
    "icon": ZoomOutOutlinedSvg
  }), null);
};
ZoomOutOutlined.displayName = "ZoomOutOutlined";
ZoomOutOutlined.inheritAttrs = false;
var ZoomOutOutlined$1 = ZoomOutOutlined;
var operationNodeProps = {
  prefixCls: {
    type: String
  },
  id: {
    type: String
  },
  tabs: {
    type: Object
  },
  rtl: {
    type: Boolean
  },
  tabBarGutter: {
    type: Number
  },
  activeKey: {
    type: [String, Number]
  },
  mobile: {
    type: Boolean
  },
  moreIcon: PropTypes$1.any,
  moreTransitionName: {
    type: String
  },
  editable: {
    type: Object
  },
  locale: {
    type: Object,
    default: void 0
  },
  removeAriaLabel: String,
  onTabClick: {
    type: Function
  }
};
var OperationNode = defineComponent({
  name: "OperationNode",
  inheritAttrs: false,
  props: operationNodeProps,
  emits: ["tabClick"],
  slots: ["moreIcon"],
  setup: function setup63(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var _useState = useState(false), _useState2 = _slicedToArray$2(_useState, 2), open2 = _useState2[0], setOpen = _useState2[1];
    var _useState3 = useState(null), _useState4 = _slicedToArray$2(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var selectOffset = function selectOffset2(offset3) {
      var enabledTabs = props2.tabs.filter(function(tab2) {
        return !tab2.disabled;
      });
      var selectedIndex = enabledTabs.findIndex(function(tab2) {
        return tab2.key === selectedKey.value;
      }) || 0;
      var len = enabledTabs.length;
      for (var i2 = 0; i2 < len; i2 += 1) {
        selectedIndex = (selectedIndex + offset3 + len) % len;
        var tab = enabledTabs[selectedIndex];
        if (!tab.disabled) {
          setSelectedKey(tab.key);
          return;
        }
      }
    };
    var onKeyDown = function onKeyDown2(e2) {
      var which = e2.which;
      if (!open2.value) {
        if ([KeyCode$1.DOWN, KeyCode$1.SPACE, KeyCode$1.ENTER].includes(which)) {
          setOpen(true);
          e2.preventDefault();
        }
        return;
      }
      switch (which) {
        case KeyCode$1.UP:
          selectOffset(-1);
          e2.preventDefault();
          break;
        case KeyCode$1.DOWN:
          selectOffset(1);
          e2.preventDefault();
          break;
        case KeyCode$1.ESC:
          setOpen(false);
          break;
        case KeyCode$1.SPACE:
        case KeyCode$1.ENTER:
          if (selectedKey.value !== null)
            props2.onTabClick(selectedKey.value, e2);
          break;
      }
    };
    var popupId = computed(function() {
      return "".concat(props2.id, "-more-popup");
    });
    var selectedItemId = computed(function() {
      return selectedKey.value !== null ? "".concat(popupId.value, "-").concat(selectedKey.value) : null;
    });
    var onRemoveTab = function onRemoveTab2(event, key2) {
      event.preventDefault();
      event.stopPropagation();
      props2.editable.onEdit("remove", {
        key: key2,
        event
      });
    };
    onMounted(function() {
      watch(selectedKey, function() {
        var ele = document.getElementById(selectedItemId.value);
        if (ele && ele.scrollIntoView) {
          ele.scrollIntoView(false);
        }
      }, {
        flush: "post",
        immediate: true
      });
    });
    watch(open2, function() {
      if (!open2.value) {
        setSelectedKey(null);
      }
    });
    return function() {
      var _a2;
      var prefixCls2 = props2.prefixCls, id = props2.id, tabs = props2.tabs, locale2 = props2.locale, mobile = props2.mobile, _props$moreIcon = props2.moreIcon, moreIcon = _props$moreIcon === void 0 ? ((_a2 = slots.moreIcon) === null || _a2 === void 0 ? void 0 : _a2.call(slots)) || createVNode(EllipsisOutlined$1, null, null) : _props$moreIcon, moreTransitionName = props2.moreTransitionName, editable = props2.editable, tabBarGutter = props2.tabBarGutter, rtl2 = props2.rtl, onTabClick = props2.onTabClick;
      var dropdownPrefix = "".concat(prefixCls2, "-dropdown");
      var dropdownAriaLabel = locale2 === null || locale2 === void 0 ? void 0 : locale2.dropdownAriaLabel;
      var moreStyle = _defineProperty$R({}, rtl2 ? "marginRight" : "marginLeft", tabBarGutter);
      if (!tabs.length) {
        moreStyle.visibility = "hidden";
        moreStyle.order = 1;
      }
      var overlayClassName = classNames(_defineProperty$R({}, "".concat(dropdownPrefix, "-rtl"), rtl2));
      var moreNode = mobile ? null : createVNode(Dropdown$3, {
        "prefixCls": dropdownPrefix,
        "trigger": ["hover"],
        "visible": open2.value,
        "transitionName": moreTransitionName,
        "onVisibleChange": setOpen,
        "overlayClassName": overlayClassName,
        "mouseEnterDelay": 0.1,
        "mouseLeaveDelay": 0.1
      }, {
        overlay: function overlay() {
          return createVNode(Menu, {
            "onClick": function onClick2(_ref2) {
              var key2 = _ref2.key, domEvent = _ref2.domEvent;
              onTabClick(key2, domEvent);
              setOpen(false);
            },
            "id": popupId.value,
            "tabindex": -1,
            "role": "listbox",
            "aria-activedescendant": selectedItemId.value,
            "selectedKeys": [selectedKey.value],
            "aria-label": dropdownAriaLabel !== void 0 ? dropdownAriaLabel : "expanded dropdown"
          }, {
            default: function _default7() {
              return [tabs.map(function(tab) {
                var _a3, _b;
                var removable = editable && tab.closable !== false && !tab.disabled;
                return createVNode(MenuItem$1, {
                  "key": tab.key,
                  "id": "".concat(popupId.value, "-").concat(tab.key),
                  "role": "option",
                  "aria-controls": id && "".concat(id, "-panel-").concat(tab.key),
                  "disabled": tab.disabled
                }, {
                  default: function _default8() {
                    return [createVNode("span", null, [typeof tab.tab === "function" ? tab.tab() : tab.tab]), removable && createVNode("button", {
                      "type": "button",
                      "aria-label": props2.removeAriaLabel || "remove",
                      "tabindex": 0,
                      "class": "".concat(dropdownPrefix, "-menu-item-remove"),
                      "onClick": function onClick2(e2) {
                        e2.stopPropagation();
                        onRemoveTab(e2, tab.key);
                      }
                    }, [((_a3 = tab.closeIcon) === null || _a3 === void 0 ? void 0 : _a3.call(tab)) || ((_b = editable.removeIcon) === null || _b === void 0 ? void 0 : _b.call(editable)) || "\xD7"])];
                  }
                });
              })];
            }
          });
        },
        default: function _default7() {
          return createVNode("button", {
            "type": "button",
            "class": "".concat(prefixCls2, "-nav-more"),
            "style": moreStyle,
            "tabindex": -1,
            "aria-hidden": "true",
            "aria-haspopup": "listbox",
            "aria-controls": popupId.value,
            "id": "".concat(id, "-more"),
            "aria-expanded": open2.value,
            "onKeydown": onKeyDown
          }, [moreIcon]);
        }
      });
      return createVNode("div", {
        "class": classNames("".concat(prefixCls2, "-nav-operations"), attrs.class),
        "style": attrs.style
      }, [moreNode, createVNode(AddButton, {
        "prefixCls": prefixCls2,
        "locale": locale2,
        "editable": editable
      }, null)]);
    };
  }
});
var TabsContextKey = Symbol("tabsContextKey");
var useProvideTabs = function useProvideTabs2(props2) {
  provide(TabsContextKey, props2);
};
var useInjectTabs = function useInjectTabs2() {
  return inject(TabsContextKey, {
    tabs: ref([]),
    prefixCls: ref()
  });
};
defineComponent({
  name: "TabsContextProvider",
  inheritAttrs: false,
  props: {
    tabs: {
      type: Object,
      default: void 0
    },
    prefixCls: {
      type: String,
      default: void 0
    }
  },
  setup: function setup64(props2, _ref) {
    var slots = _ref.slots;
    useProvideTabs(toRefs(props2));
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var MIN_SWIPE_DISTANCE = 0.1;
var STOP_SWIPE_DISTANCE = 0.01;
var REFRESH_INTERVAL = 20;
var SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL);
function useTouchMove(domRef, onOffset) {
  var _useState = useState(), _useState2 = _slicedToArray$2(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
  var _useState3 = useState(0), _useState4 = _slicedToArray$2(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
  var _useState5 = useState(0), _useState6 = _slicedToArray$2(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
  var _useState7 = useState(), _useState8 = _slicedToArray$2(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
  var motionInterval = ref();
  function onTouchStart(e2) {
    var _e$touches$ = e2.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    clearInterval(motionInterval.value);
  }
  function onTouchMove(e2) {
    if (!touchPosition.value)
      return;
    e2.preventDefault();
    var _e$touches$2 = e2.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
    var offsetX = screenX - touchPosition.value.x;
    var offsetY = screenY - touchPosition.value.y;
    onOffset(offsetX, offsetY);
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    var now2 = Date.now();
    setLastTimeDiff(now2 - lastTimestamp.value);
    setLastTimestamp(now2);
    setLastOffset({
      x: offsetX,
      y: offsetY
    });
  }
  function onTouchEnd() {
    if (!touchPosition.value)
      return;
    var lastOffsetValue = lastOffset.value;
    setTouchPosition(null);
    setLastOffset(null);
    if (lastOffsetValue) {
      var distanceX = lastOffsetValue.x / lastTimeDiff.value;
      var distanceY = lastOffsetValue.y / lastTimeDiff.value;
      var absX = Math.abs(distanceX);
      var absY = Math.abs(distanceY);
      if (Math.max(absX, absY) < MIN_SWIPE_DISTANCE)
        return;
      var currentX = distanceX;
      var currentY = distanceY;
      motionInterval.value = setInterval(function() {
        if (Math.abs(currentX) < STOP_SWIPE_DISTANCE && Math.abs(currentY) < STOP_SWIPE_DISTANCE) {
          clearInterval(motionInterval.value);
          return;
        }
        currentX *= SPEED_OFF_MULTIPLE;
        currentY *= SPEED_OFF_MULTIPLE;
        onOffset(currentX * REFRESH_INTERVAL, currentY * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  }
  var lastWheelDirectionRef = ref();
  function onWheel(e2) {
    var deltaX = e2.deltaX, deltaY = e2.deltaY;
    var mixed = 0;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);
    if (absX === absY) {
      mixed = lastWheelDirectionRef.value === "x" ? deltaX : deltaY;
    } else if (absX > absY) {
      mixed = deltaX;
      lastWheelDirectionRef.value = "x";
    } else {
      mixed = deltaY;
      lastWheelDirectionRef.value = "y";
    }
    if (onOffset(-mixed, -mixed)) {
      e2.preventDefault();
    }
  }
  var touchEventsRef = ref({
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onWheel
  });
  function onProxyTouchStart(e2) {
    touchEventsRef.value.onTouchStart(e2);
  }
  function onProxyTouchMove(e2) {
    touchEventsRef.value.onTouchMove(e2);
  }
  function onProxyTouchEnd(e2) {
    touchEventsRef.value.onTouchEnd(e2);
  }
  function onProxyWheel(e2) {
    touchEventsRef.value.onWheel(e2);
  }
  onMounted(function() {
    var _a2, _b;
    document.addEventListener("touchmove", onProxyTouchMove, {
      passive: false
    });
    document.addEventListener("touchend", onProxyTouchEnd, {
      passive: false
    });
    (_a2 = domRef.value) === null || _a2 === void 0 ? void 0 : _a2.addEventListener("touchstart", onProxyTouchStart, {
      passive: false
    });
    (_b = domRef.value) === null || _b === void 0 ? void 0 : _b.addEventListener("wheel", onProxyWheel, {
      passive: false
    });
  });
  onBeforeUnmount(function() {
    document.removeEventListener("touchmove", onProxyTouchMove);
    document.removeEventListener("touchend", onProxyTouchEnd);
  });
}
function useSyncState(defaultState, onChange3) {
  var stateRef = ref(defaultState);
  function setState2(updater) {
    var newValue = typeof updater === "function" ? updater(stateRef.value) : updater;
    if (newValue !== stateRef.value) {
      onChange3(newValue, stateRef.value);
    }
    stateRef.value = newValue;
  }
  return [stateRef, setState2];
}
var useRefs = function useRefs2() {
  var refs = ref(new Map());
  var setRef = function setRef2(key2) {
    return function(el) {
      refs.value.set(key2, el);
    };
  };
  onBeforeUpdate(function() {
    refs.value = new Map();
  });
  return [setRef, refs];
};
var useRefs$1 = useRefs;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object4) {
  if (isArray$3(value)) {
    return false;
  }
  var type4 = typeof value;
  if (type4 == "number" || type4 == "symbol" || type4 == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object4 != null && value in Object(object4);
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key2)) {
      return cache2.get(key2);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key2, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key2) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key2;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string3) {
  var result = [];
  if (string3.charCodeAt(0) === 46) {
    result.push("");
  }
  string3.replace(rePropName, function(match2, number4, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number4 || match2);
  });
  return result;
});
var stringToPath$1 = stringToPath;
function castPath(value, object4) {
  if (isArray$3(value)) {
    return value;
  }
  return isKey(value, object4) ? [value] : stringToPath$1(toString$2(value));
}
var INFINITY = 1 / 0;
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function baseGet(object4, path) {
  path = castPath(path, object4);
  var index2 = 0, length = path.length;
  while (object4 != null && index2 < length) {
    object4 = object4[toKey(path[index2++])];
  }
  return index2 && index2 == length ? object4 : void 0;
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {
  }
}();
var defineProperty$1 = defineProperty;
function baseAssignValue(object4, key2, value) {
  if (key2 == "__proto__" && defineProperty$1) {
    defineProperty$1(object4, key2, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object4[key2] = value;
  }
}
var objectProto$2 = Object.prototype;
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function assignValue(object4, key2, value) {
  var objValue = object4[key2];
  if (!(hasOwnProperty$3.call(object4, key2) && eq(objValue, value)) || value === void 0 && !(key2 in object4)) {
    baseAssignValue(object4, key2, value);
  }
}
function baseSet(object4, path, value, customizer) {
  if (!isObject$4(object4)) {
    return object4;
  }
  path = castPath(path, object4);
  var index2 = -1, length = path.length, lastIndex = length - 1, nested = object4;
  while (nested != null && ++index2 < length) {
    var key2 = toKey(path[index2]), newValue = value;
    if (key2 === "__proto__" || key2 === "constructor" || key2 === "prototype") {
      return object4;
    }
    if (index2 != lastIndex) {
      var objValue = nested[key2];
      newValue = customizer ? customizer(objValue, key2, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject$4(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
      }
    }
    assignValue(nested, key2, newValue);
    nested = nested[key2];
  }
  return object4;
}
function basePickBy(object4, paths, predicate) {
  var index2 = -1, length = paths.length, result = {};
  while (++index2 < length) {
    var path = paths[index2], value = baseGet(object4, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object4), value);
    }
  }
  return result;
}
function baseHasIn(object4, key2) {
  return object4 != null && key2 in Object(object4);
}
function hasPath(object4, path, hasFunc) {
  path = castPath(path, object4);
  var index2 = -1, length = path.length, result = false;
  while (++index2 < length) {
    var key2 = toKey(path[index2]);
    if (!(result = object4 != null && hasFunc(object4, key2))) {
      break;
    }
    object4 = object4[key2];
  }
  if (result || ++index2 != length) {
    return result;
  }
  length = object4 == null ? 0 : object4.length;
  return !!length && isLength(length) && isIndex(key2, length) && (isArray$3(object4) || isArguments$1(object4));
}
function hasIn(object4, path) {
  return object4 != null && hasPath(object4, path, baseHasIn);
}
function basePick(object4, paths) {
  return basePickBy(object4, paths, function(value, path) {
    return hasIn(object4, path);
  });
}
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : void 0;
function isFlattenable(value) {
  return isArray$3(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function baseFlatten(array4, depth, predicate, isStrict, result) {
  var index2 = -1, length = array4.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length) {
    var value = array4[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
function flatten(array4) {
  var length = array4 == null ? 0 : array4.length;
  return length ? baseFlatten(array4, 1) : [];
}
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var nativeMax$2 = Math.max;
function overRest(func, start2, transform) {
  start2 = nativeMax$2(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax$2(args.length - start2, 0), array4 = Array(length);
    while (++index2 < length) {
      array4[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform(array4);
    return apply(func, this, otherArgs);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
function identity$1(value) {
  return value;
}
var baseSetToString = !defineProperty$1 ? identity$1 : function(func, string3) {
  return defineProperty$1(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string3),
    "writable": true
  });
};
var baseSetToString$1 = baseSetToString;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;
function flatRest(func) {
  return setToString$1(overRest(func, void 0, flatten), func + "");
}
var pick = flatRest(function(object4, paths) {
  return object4 == null ? {} : basePick(object4, paths);
});
var pick$1 = pick;
var DEFAULT_SIZE$2 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
var tabNavListProps = function tabNavListProps2() {
  return {
    id: {
      type: String
    },
    tabPosition: {
      type: String
    },
    activeKey: {
      type: [String, Number]
    },
    rtl: {
      type: Boolean
    },
    animated: {
      type: Object,
      default: void 0
    },
    editable: {
      type: Object
    },
    moreIcon: PropTypes$1.any,
    moreTransitionName: {
      type: String
    },
    mobile: {
      type: Boolean
    },
    tabBarGutter: {
      type: Number
    },
    renderTabBar: {
      type: Function
    },
    locale: {
      type: Object,
      default: void 0
    },
    onTabClick: {
      type: Function
    },
    onTabScroll: {
      type: Function
    }
  };
};
var TabNavList = defineComponent({
  name: "TabNavList",
  inheritAttrs: false,
  props: tabNavListProps(),
  slots: ["moreIcon", "leftExtra", "rightExtra", "tabBarExtraContent"],
  emits: ["tabClick", "tabScroll"],
  setup: function setup65(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var _useInjectTabs = useInjectTabs(), tabs = _useInjectTabs.tabs, prefixCls2 = _useInjectTabs.prefixCls;
    var tabsWrapperRef = ref();
    var tabListRef = ref();
    var operationsRef = ref();
    var innerAddButtonRef = ref();
    var _useRefs = useRefs$1(), _useRefs2 = _slicedToArray$2(_useRefs, 2), setRef = _useRefs2[0], btnRefs = _useRefs2[1];
    var tabPositionTopOrBottom = computed(function() {
      return props2.tabPosition === "top" || props2.tabPosition === "bottom";
    });
    var _useSyncState = useSyncState(0, function(next2, prev2) {
      if (tabPositionTopOrBottom.value && props2.onTabScroll) {
        props2.onTabScroll({
          direction: next2 > prev2 ? "left" : "right"
        });
      }
    }), _useSyncState2 = _slicedToArray$2(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = useSyncState(0, function(next2, prev2) {
      if (!tabPositionTopOrBottom.value && props2.onTabScroll) {
        props2.onTabScroll({
          direction: next2 > prev2 ? "top" : "bottom"
        });
      }
    }), _useSyncState4 = _slicedToArray$2(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = useState(0), _useState2 = _slicedToArray$2(_useState, 2), wrapperScrollWidth = _useState2[0], setWrapperScrollWidth = _useState2[1];
    var _useState3 = useState(0), _useState4 = _slicedToArray$2(_useState3, 2), wrapperScrollHeight = _useState4[0], setWrapperScrollHeight = _useState4[1];
    var _useState5 = useState(null), _useState6 = _slicedToArray$2(_useState5, 2), wrapperWidth = _useState6[0], setWrapperWidth = _useState6[1];
    var _useState7 = useState(null), _useState8 = _slicedToArray$2(_useState7, 2), wrapperHeight = _useState8[0], setWrapperHeight = _useState8[1];
    var _useState9 = useState(0), _useState10 = _slicedToArray$2(_useState9, 2), addWidth = _useState10[0], setAddWidth = _useState10[1];
    var _useState11 = useState(0), _useState12 = _slicedToArray$2(_useState11, 2), addHeight = _useState12[0], setAddHeight = _useState12[1];
    var _useRafState = useRafState(new Map()), _useRafState2 = _slicedToArray$2(_useRafState, 2), tabSizes = _useRafState2[0], setTabSizes = _useRafState2[1];
    var tabOffsets = useOffsets(tabs, tabSizes);
    var operationsHiddenClassName = computed(function() {
      return "".concat(prefixCls2.value, "-nav-operations-hidden");
    });
    var transformMin = ref(0);
    var transformMax = ref(0);
    watchEffect(function() {
      if (!tabPositionTopOrBottom.value) {
        transformMin.value = Math.min(0, wrapperHeight.value - wrapperScrollHeight.value);
        transformMax.value = 0;
      } else if (props2.rtl) {
        transformMin.value = 0;
        transformMax.value = Math.max(0, wrapperScrollWidth.value - wrapperWidth.value);
      } else {
        transformMin.value = Math.min(0, wrapperWidth.value - wrapperScrollWidth.value);
        transformMax.value = 0;
      }
    });
    var alignInRange = function alignInRange2(value) {
      if (value < transformMin.value) {
        return transformMin.value;
      }
      if (value > transformMax.value) {
        return transformMax.value;
      }
      return value;
    };
    var touchMovingRef = ref();
    var _useState13 = useState(), _useState14 = _slicedToArray$2(_useState13, 2), lockAnimation = _useState14[0], setLockAnimation = _useState14[1];
    var doLockAnimation = function doLockAnimation2() {
      setLockAnimation(Date.now());
    };
    var clearTouchMoving = function clearTouchMoving2() {
      clearTimeout(touchMovingRef.value);
    };
    var doMove = function doMove2(setState2, offset3) {
      setState2(function(value) {
        var newValue = alignInRange(value + offset3);
        return newValue;
      });
    };
    useTouchMove(tabsWrapperRef, function(offsetX, offsetY) {
      if (tabPositionTopOrBottom.value) {
        if (wrapperWidth.value >= wrapperScrollWidth.value) {
          return false;
        }
        doMove(setTransformLeft, offsetX);
      } else {
        if (wrapperHeight.value >= wrapperScrollHeight.value) {
          return false;
        }
        doMove(setTransformTop, offsetY);
      }
      clearTouchMoving();
      doLockAnimation();
      return true;
    });
    watch(lockAnimation, function() {
      clearTouchMoving();
      if (lockAnimation.value) {
        touchMovingRef.value = setTimeout(function() {
          setLockAnimation(0);
        }, 100);
      }
    });
    var scrollToTab = function scrollToTab2() {
      var key2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : props2.activeKey;
      var tabOffset = tabOffsets.value.get(key2) || {
        width: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0
      };
      if (tabPositionTopOrBottom.value) {
        var newTransform = transformLeft.value;
        if (props2.rtl) {
          if (tabOffset.right < transformLeft.value) {
            newTransform = tabOffset.right;
          } else if (tabOffset.right + tabOffset.width > transformLeft.value + wrapperWidth.value) {
            newTransform = tabOffset.right + tabOffset.width - wrapperWidth.value;
          }
        } else if (tabOffset.left < -transformLeft.value) {
          newTransform = -tabOffset.left;
        } else if (tabOffset.left + tabOffset.width > -transformLeft.value + wrapperWidth.value) {
          newTransform = -(tabOffset.left + tabOffset.width - wrapperWidth.value);
        }
        setTransformTop(0);
        setTransformLeft(alignInRange(newTransform));
      } else {
        var _newTransform = transformTop.value;
        if (tabOffset.top < -transformTop.value) {
          _newTransform = -tabOffset.top;
        } else if (tabOffset.top + tabOffset.height > -transformTop.value + wrapperHeight.value) {
          _newTransform = -(tabOffset.top + tabOffset.height - wrapperHeight.value);
        }
        setTransformLeft(0);
        setTransformTop(alignInRange(_newTransform));
      }
    };
    var visibleStart = ref(0);
    var visibleEnd = ref(0);
    watchEffect(function() {
      var _ref3;
      var unit;
      var position2;
      var transformSize;
      var basicSize;
      var tabContentSize;
      var addSize;
      var tabOffsetsValue = tabOffsets.value;
      if (["top", "bottom"].includes(props2.tabPosition)) {
        unit = "width";
        basicSize = wrapperWidth.value;
        tabContentSize = wrapperScrollWidth.value;
        addSize = addWidth.value;
        position2 = props2.rtl ? "right" : "left";
        transformSize = Math.abs(transformLeft.value);
      } else {
        unit = "height";
        basicSize = wrapperHeight.value;
        tabContentSize = wrapperScrollWidth.value;
        addSize = addHeight.value;
        position2 = "top";
        transformSize = -transformTop.value;
      }
      var mergedBasicSize = basicSize;
      if (tabContentSize + addSize > basicSize && tabContentSize < basicSize) {
        mergedBasicSize = basicSize - addSize;
      }
      var tabsVal = tabs.value;
      if (!tabsVal.length) {
        var _ref2;
        return _ref2 = [0, 0], visibleStart.value = _ref2[0], visibleEnd.value = _ref2[1], _ref2;
      }
      var len = tabsVal.length;
      var endIndex = len;
      for (var i2 = 0; i2 < len; i2 += 1) {
        var offset3 = tabOffsetsValue.get(tabsVal[i2].key) || DEFAULT_SIZE$2;
        if (offset3[position2] + offset3[unit] > transformSize + mergedBasicSize) {
          endIndex = i2 - 1;
          break;
        }
      }
      var startIndex = 0;
      for (var _i = len - 1; _i >= 0; _i -= 1) {
        var _offset = tabOffsetsValue.get(tabsVal[_i].key) || DEFAULT_SIZE$2;
        if (_offset[position2] < transformSize) {
          startIndex = _i + 1;
          break;
        }
      }
      return _ref3 = [startIndex, endIndex], visibleStart.value = _ref3[0], visibleEnd.value = _ref3[1], _ref3;
    });
    var onListHolderResize = function onListHolderResize2() {
      var _a2, _b, _c, _d, _e;
      var offsetWidth = ((_a2 = tabsWrapperRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetWidth) || 0;
      var offsetHeight = ((_b = tabsWrapperRef.value) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
      var addDom = ((_c = innerAddButtonRef.value) === null || _c === void 0 ? void 0 : _c.$el) || {};
      var newAddWidth = addDom.offsetWidth || 0;
      var newAddHeight = addDom.offsetHeight || 0;
      setWrapperWidth(offsetWidth);
      setWrapperHeight(offsetHeight);
      setAddWidth(newAddWidth);
      setAddHeight(newAddHeight);
      var newWrapperScrollWidth = (((_d = tabListRef.value) === null || _d === void 0 ? void 0 : _d.offsetWidth) || 0) - newAddWidth;
      var newWrapperScrollHeight = (((_e = tabListRef.value) === null || _e === void 0 ? void 0 : _e.offsetHeight) || 0) - newAddHeight;
      setWrapperScrollWidth(newWrapperScrollWidth);
      setWrapperScrollHeight(newWrapperScrollHeight);
      setTabSizes(function() {
        var newSizes = new Map();
        tabs.value.forEach(function(_ref4) {
          var key2 = _ref4.key;
          var _a3;
          var btnRef = btnRefs.value.get(key2);
          var btnNode = ((_a3 = btnRef) === null || _a3 === void 0 ? void 0 : _a3.$el) || btnRef;
          if (btnNode) {
            newSizes.set(key2, {
              width: btnNode.offsetWidth,
              height: btnNode.offsetHeight,
              left: btnNode.offsetLeft,
              top: btnNode.offsetTop
            });
          }
        });
        return newSizes;
      });
    };
    var hiddenTabs = computed(function() {
      return [].concat(_toConsumableArray(tabs.value.slice(0, visibleStart.value)), _toConsumableArray(tabs.value.slice(visibleEnd.value + 1)));
    });
    var _useState15 = useState(), _useState16 = _slicedToArray$2(_useState15, 2), inkStyle = _useState16[0], setInkStyle = _useState16[1];
    var activeTabOffset = computed(function() {
      return tabOffsets.value.get(props2.activeKey);
    });
    var inkBarRafRef = ref();
    var cleanInkBarRaf = function cleanInkBarRaf2() {
      wrapperRaf.cancel(inkBarRafRef.value);
    };
    watch([activeTabOffset, tabPositionTopOrBottom, function() {
      return props2.rtl;
    }], function() {
      var newInkStyle = {};
      if (activeTabOffset.value) {
        if (tabPositionTopOrBottom.value) {
          if (props2.rtl) {
            newInkStyle.right = toPx(activeTabOffset.value.right);
          } else {
            newInkStyle.left = toPx(activeTabOffset.value.left);
          }
          newInkStyle.width = toPx(activeTabOffset.value.width);
        } else {
          newInkStyle.top = toPx(activeTabOffset.value.top);
          newInkStyle.height = toPx(activeTabOffset.value.height);
        }
      }
      cleanInkBarRaf();
      inkBarRafRef.value = wrapperRaf(function() {
        setInkStyle(newInkStyle);
      });
    });
    watch([function() {
      return props2.activeKey;
    }, activeTabOffset, tabOffsets, tabPositionTopOrBottom], function() {
      scrollToTab();
    }, {
      flush: "post"
    });
    watch([function() {
      return props2.rtl;
    }, function() {
      return props2.tabBarGutter;
    }, function() {
      return props2.activeKey;
    }, function() {
      return tabs.value;
    }], function() {
      onListHolderResize();
    }, {
      flush: "post"
    });
    var ExtraContent = function ExtraContent2(_ref5) {
      var position2 = _ref5.position, prefixCls3 = _ref5.prefixCls, extra = _ref5.extra;
      if (!extra)
        return null;
      var content = extra === null || extra === void 0 ? void 0 : extra({
        position: position2
      });
      return content ? createVNode("div", {
        "class": "".concat(prefixCls3, "-extra-content")
      }, [content]) : null;
    };
    onBeforeUnmount(function() {
      clearTouchMoving();
      cleanInkBarRaf();
    });
    return function() {
      var _classNames;
      var id = props2.id, animated = props2.animated, activeKey = props2.activeKey, rtl2 = props2.rtl, editable = props2.editable, locale2 = props2.locale, tabPosition = props2.tabPosition, tabBarGutter = props2.tabBarGutter, onTabClick = props2.onTabClick;
      var className = attrs.class, style2 = attrs.style;
      var pre = prefixCls2.value;
      var hasDropdown = !!hiddenTabs.value.length;
      var wrapPrefix = "".concat(pre, "-nav-wrap");
      var pingLeft;
      var pingRight;
      var pingTop;
      var pingBottom;
      if (tabPositionTopOrBottom.value) {
        if (rtl2) {
          pingRight = transformLeft.value > 0;
          pingLeft = transformLeft.value + wrapperWidth.value < wrapperScrollWidth.value;
        } else {
          pingLeft = transformLeft.value < 0;
          pingRight = -transformLeft.value + wrapperWidth.value < wrapperScrollWidth.value;
        }
      } else {
        pingTop = transformTop.value < 0;
        pingBottom = -transformTop.value + wrapperHeight.value < wrapperScrollHeight.value;
      }
      var tabNodeStyle = {};
      if (tabPosition === "top" || tabPosition === "bottom") {
        tabNodeStyle[rtl2 ? "marginRight" : "marginLeft"] = typeof tabBarGutter === "number" ? "".concat(tabBarGutter, "px") : tabBarGutter;
      } else {
        tabNodeStyle.marginTop = typeof tabBarGutter === "number" ? "".concat(tabBarGutter, "px") : tabBarGutter;
      }
      var tabNodes = tabs.value.map(function(tab, i2) {
        var key2 = tab.key;
        return createVNode(TabNode, {
          "id": id,
          "prefixCls": pre,
          "key": key2,
          "tab": tab,
          "style": i2 === 0 ? void 0 : tabNodeStyle,
          "closable": tab.closable,
          "editable": editable,
          "active": key2 === activeKey,
          "removeAriaLabel": locale2 === null || locale2 === void 0 ? void 0 : locale2.removeAriaLabel,
          "ref": setRef(key2),
          "onClick": function onClick2(e2) {
            onTabClick(key2, e2);
          },
          "onFocus": function onFocus2() {
            scrollToTab(key2);
            doLockAnimation();
            if (!tabsWrapperRef.value) {
              return;
            }
            if (!rtl2) {
              tabsWrapperRef.value.scrollLeft = 0;
            }
            tabsWrapperRef.value.scrollTop = 0;
          }
        }, slots);
      });
      return createVNode("div", {
        "role": "tablist",
        "class": classNames("".concat(pre, "-nav"), className),
        "style": style2,
        "onKeydown": function onKeydown() {
          doLockAnimation();
        }
      }, [createVNode(ExtraContent, {
        "position": "left",
        "prefixCls": pre,
        "extra": slots.leftExtra
      }, null), createVNode(ResizeObserver$1, {
        "onResize": onListHolderResize
      }, {
        default: function _default7() {
          return [createVNode("div", {
            "class": classNames(wrapPrefix, (_classNames = {}, _defineProperty$R(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), _defineProperty$R(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), _defineProperty$R(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), _defineProperty$R(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
            "ref": tabsWrapperRef
          }, [createVNode(ResizeObserver$1, {
            "onResize": onListHolderResize
          }, {
            default: function _default8() {
              return [createVNode("div", {
                "ref": tabListRef,
                "class": "".concat(pre, "-nav-list"),
                "style": {
                  transform: "translate(".concat(transformLeft.value, "px, ").concat(transformTop.value, "px)"),
                  transition: lockAnimation.value ? "none" : void 0
                }
              }, [tabNodes, createVNode(AddButton, {
                "ref": innerAddButtonRef,
                "prefixCls": pre,
                "locale": locale2,
                "editable": editable,
                "style": _extends$2(_extends$2({}, tabNodes.length === 0 ? void 0 : tabNodeStyle), {
                  visibility: hasDropdown ? "hidden" : null
                })
              }, null), createVNode("div", {
                "class": classNames("".concat(pre, "-ink-bar"), _defineProperty$R({}, "".concat(pre, "-ink-bar-animated"), animated.inkBar)),
                "style": inkStyle.value
              }, null)])];
            }
          })])];
        }
      }), createVNode(OperationNode, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
        "removeAriaLabel": locale2 === null || locale2 === void 0 ? void 0 : locale2.removeAriaLabel,
        "ref": operationsRef,
        "prefixCls": pre,
        "tabs": hiddenTabs.value,
        "class": !hasDropdown && operationsHiddenClassName.value
      }), pick$1(slots, ["moreIcon"])), createVNode(ExtraContent, {
        "position": "right",
        "prefixCls": pre,
        "extra": slots.rightExtra
      }, null), createVNode(ExtraContent, {
        "position": "right",
        "prefixCls": pre,
        "extra": slots.tabBarExtraContent
      }, null)]);
    };
  }
});
var TabPanelList = defineComponent({
  name: "TabPanelList",
  inheritAttrs: false,
  props: {
    activeKey: {
      type: [String, Number]
    },
    id: {
      type: String
    },
    rtl: {
      type: Boolean
    },
    animated: {
      type: Object,
      default: void 0
    },
    tabPosition: {
      type: String
    },
    destroyInactiveTabPane: {
      type: Boolean
    }
  },
  setup: function setup66(props2) {
    var _useInjectTabs = useInjectTabs(), tabs = _useInjectTabs.tabs, prefixCls2 = _useInjectTabs.prefixCls;
    return function() {
      var id = props2.id, activeKey = props2.activeKey, animated = props2.animated, tabPosition = props2.tabPosition, rtl2 = props2.rtl, destroyInactiveTabPane = props2.destroyInactiveTabPane;
      var tabPaneAnimated = animated.tabPane;
      var pre = prefixCls2.value;
      var activeIndex = tabs.value.findIndex(function(tab) {
        return tab.key === activeKey;
      });
      return createVNode("div", {
        "class": "".concat(pre, "-content-holder")
      }, [createVNode("div", {
        "class": ["".concat(pre, "-content"), "".concat(pre, "-content-").concat(tabPosition), _defineProperty$R({}, "".concat(pre, "-content-animated"), tabPaneAnimated)],
        "style": activeIndex && tabPaneAnimated ? _defineProperty$R({}, rtl2 ? "marginRight" : "marginLeft", "-".concat(activeIndex, "00%")) : null
      }, [tabs.value.map(function(tab) {
        return cloneElement(tab.node, {
          key: tab.key,
          prefixCls: pre,
          tabKey: tab.key,
          id,
          animated: tabPaneAnimated,
          active: tab.key === activeKey,
          destroyInactiveTabPane
        });
      })])]);
    };
  }
});
var uuid$4 = 0;
var tabsProps = function tabsProps2() {
  return {
    prefixCls: {
      type: String
    },
    id: {
      type: String
    },
    activeKey: {
      type: [String, Number]
    },
    defaultActiveKey: {
      type: [String, Number]
    },
    direction: {
      type: String
    },
    animated: {
      type: [Boolean, Object]
    },
    renderTabBar: {
      type: Function
    },
    tabBarGutter: {
      type: Number
    },
    tabBarStyle: {
      type: Object
    },
    tabPosition: {
      type: String
    },
    destroyInactiveTabPane: {
      type: Boolean
    },
    hideAdd: Boolean,
    type: {
      type: String
    },
    size: {
      type: String
    },
    centered: Boolean,
    onEdit: {
      type: Function
    },
    onChange: {
      type: Function
    },
    onTabClick: {
      type: Function
    },
    onTabScroll: {
      type: Function
    },
    "onUpdate:activeKey": {
      type: Function
    },
    locale: {
      type: Object,
      default: void 0
    },
    onPrevClick: Function,
    onNextClick: Function,
    tabBarExtraContent: PropTypes$1.any
  };
};
function parseTabList(children) {
  return children.map(function(node) {
    if (isValidElement(node)) {
      var props2 = _extends$2({}, node.props || {});
      for (var _i = 0, _Object$entries = Object.entries(props2); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2), k2 = _Object$entries$_i[0], v2 = _Object$entries$_i[1];
        delete props2[k2];
        props2[camelize$1(k2)] = v2;
      }
      var slots = node.children || {};
      var key2 = node.key !== void 0 ? node.key : void 0;
      var _props$tab = props2.tab, tab = _props$tab === void 0 ? slots.tab : _props$tab, disabled = props2.disabled, forceRender = props2.forceRender, closable = props2.closable, animated = props2.animated, active = props2.active, destroyInactiveTabPane = props2.destroyInactiveTabPane;
      return _extends$2(_extends$2({
        key: key2
      }, props2), {
        node,
        closeIcon: slots.closeIcon,
        tab,
        disabled: disabled === "" || disabled,
        forceRender: forceRender === "" || forceRender,
        closable: closable === "" || closable,
        animated: animated === "" || animated,
        active: active === "" || active,
        destroyInactiveTabPane: destroyInactiveTabPane === "" || destroyInactiveTabPane
      });
    }
    return null;
  }).filter(function(tab) {
    return tab;
  });
}
var InternalTabs = defineComponent({
  name: "InternalTabs",
  inheritAttrs: false,
  props: _extends$2(_extends$2({}, initDefaultProps$1(tabsProps(), {
    tabPosition: "top",
    animated: {
      inkBar: true,
      tabPane: false
    }
  })), {
    tabs: {
      type: Array
    }
  }),
  slots: ["tabBarExtraContent", "leftExtra", "rightExtra", "moreIcon", "addIcon", "removeIcon", "renderTabBar"],
  setup: function setup67(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    devWarning(!(props2.onPrevClick !== void 0) && !(props2.onNextClick !== void 0), "Tabs", "`onPrevClick / @prevClick` and `onNextClick / @nextClick` has been removed. Please use `onTabScroll / @tabScroll` instead.");
    devWarning(!(props2.tabBarExtraContent !== void 0), "Tabs", "`tabBarExtraContent` prop has been removed. Please use `rightExtra` slot instead.");
    devWarning(!(slots.tabBarExtraContent !== void 0), "Tabs", "`tabBarExtraContent` slot is deprecated. Please use `rightExtra` slot instead.");
    var _useConfigInject = useConfigInject("tabs", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, size = _useConfigInject.size, rootPrefixCls = _useConfigInject.rootPrefixCls;
    var rtl2 = computed(function() {
      return direction2.value === "rtl";
    });
    var mergedAnimated = computed(function() {
      var animated = props2.animated, tabPosition = props2.tabPosition;
      if (animated === false || ["left", "right"].includes(tabPosition)) {
        return {
          inkBar: false,
          tabPane: false
        };
      } else if (animated === true) {
        return {
          inkBar: true,
          tabPane: true
        };
      } else {
        return _extends$2({
          inkBar: true,
          tabPane: false
        }, _typeof$2(animated) === "object" ? animated : {});
      }
    });
    var _useState = useState(false), _useState2 = _slicedToArray$2(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    onMounted(function() {
      setMobile(isMobile$2());
    });
    var _useMergedState = useMergedState(function() {
      var _a2;
      return (_a2 = props2.tabs[0]) === null || _a2 === void 0 ? void 0 : _a2.key;
    }, {
      value: computed(function() {
        return props2.activeKey;
      }),
      defaultValue: props2.defaultActiveKey
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = useState(function() {
      return props2.tabs.findIndex(function(tab) {
        return tab.key === mergedActiveKey.value;
      });
    }), _useState4 = _slicedToArray$2(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    watchEffect(function() {
      var _a2;
      var newActiveIndex = props2.tabs.findIndex(function(tab) {
        return tab.key === mergedActiveKey.value;
      });
      if (newActiveIndex === -1) {
        newActiveIndex = Math.max(0, Math.min(activeIndex.value, props2.tabs.length - 1));
        setMergedActiveKey((_a2 = props2.tabs[newActiveIndex]) === null || _a2 === void 0 ? void 0 : _a2.key);
      }
      setActiveIndex(newActiveIndex);
    });
    var _useMergedState3 = useMergedState(null, {
      value: computed(function() {
        return props2.id;
      })
    }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    var mergedTabPosition = computed(function() {
      if (mobile.value && !["left", "right"].includes(props2.tabPosition)) {
        return "top";
      } else {
        return props2.tabPosition;
      }
    });
    onMounted(function() {
      if (!props2.id) {
        setMergedId("rc-tabs-".concat(uuid$4));
        uuid$4 += 1;
      }
    });
    var onInternalTabClick = function onInternalTabClick2(key2, e2) {
      var _a2, _b;
      (_a2 = props2.onTabClick) === null || _a2 === void 0 ? void 0 : _a2.call(props2, key2, e2);
      var isActiveChanged = key2 !== mergedActiveKey.value;
      setMergedActiveKey(key2);
      if (isActiveChanged) {
        (_b = props2.onChange) === null || _b === void 0 ? void 0 : _b.call(props2, key2);
      }
    };
    useProvideTabs({
      tabs: computed(function() {
        return props2.tabs;
      }),
      prefixCls: prefixCls2
    });
    return function() {
      var _classNames;
      var id = props2.id, type4 = props2.type, tabBarGutter = props2.tabBarGutter, tabBarStyle = props2.tabBarStyle, locale2 = props2.locale, destroyInactiveTabPane = props2.destroyInactiveTabPane, _props$renderTabBar = props2.renderTabBar, renderTabBar = _props$renderTabBar === void 0 ? slots.renderTabBar : _props$renderTabBar, onTabScroll = props2.onTabScroll, hideAdd = props2.hideAdd, centered = props2.centered;
      var sharedProps = {
        id: mergedId.value,
        activeKey: mergedActiveKey.value,
        animated: mergedAnimated.value,
        tabPosition: mergedTabPosition.value,
        rtl: rtl2.value,
        mobile: mobile.value
      };
      var editable;
      if (type4 === "editable-card") {
        editable = {
          onEdit: function onEdit(editType, _ref2) {
            var key2 = _ref2.key, event = _ref2.event;
            var _a2;
            (_a2 = props2.onEdit) === null || _a2 === void 0 ? void 0 : _a2.call(props2, editType === "add" ? event : key2, editType);
          },
          removeIcon: function removeIcon() {
            return createVNode(CloseOutlined$1, null, null);
          },
          addIcon: slots.addIcon ? slots.addIcon : function() {
            return createVNode(PlusOutlined$1, null, null);
          },
          showAdd: hideAdd !== true
        };
      }
      var tabNavBar;
      var tabNavBarProps = _extends$2(_extends$2({}, sharedProps), {
        moreTransitionName: "".concat(rootPrefixCls.value, "-slide-up"),
        editable,
        locale: locale2,
        tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll,
        style: tabBarStyle
      });
      if (renderTabBar) {
        tabNavBar = renderTabBar(_extends$2(_extends$2({}, tabNavBarProps), {
          DefaultTabBar: TabNavList
        }));
      } else {
        tabNavBar = createVNode(TabNavList, tabNavBarProps, pick$1(slots, ["moreIcon", "leftExtra", "rightExtra", "tabBarExtraContent"]));
      }
      var pre = prefixCls2.value;
      return createVNode("div", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "id": id,
        "class": classNames(pre, "".concat(pre, "-").concat(mergedTabPosition.value), (_classNames = {}, _defineProperty$R(_classNames, "".concat(pre, "-").concat(size.value), size.value), _defineProperty$R(_classNames, "".concat(pre, "-card"), ["card", "editable-card"].includes(type4)), _defineProperty$R(_classNames, "".concat(pre, "-editable-card"), type4 === "editable-card"), _defineProperty$R(_classNames, "".concat(pre, "-centered"), centered), _defineProperty$R(_classNames, "".concat(pre, "-mobile"), mobile.value), _defineProperty$R(_classNames, "".concat(pre, "-editable"), type4 === "editable-card"), _defineProperty$R(_classNames, "".concat(pre, "-rtl"), rtl2.value), _classNames), attrs.class)
      }), [tabNavBar, createVNode(TabPanelList, _objectSpread2$2(_objectSpread2$2({
        "destroyInactiveTabPane": destroyInactiveTabPane
      }, sharedProps), {}, {
        "animated": mergedAnimated.value
      }), null)]);
    };
  }
});
var Tabs = defineComponent({
  name: "ATabs",
  inheritAttrs: false,
  props: initDefaultProps$1(tabsProps(), {
    tabPosition: "top",
    animated: {
      inkBar: true,
      tabPane: false
    }
  }),
  slots: ["tabBarExtraContent", "leftExtra", "rightExtra", "moreIcon", "addIcon", "removeIcon", "renderTabBar"],
  setup: function setup68(props2, _ref3) {
    var attrs = _ref3.attrs, slots = _ref3.slots, emit = _ref3.emit;
    var handleChange2 = function handleChange3(key2) {
      emit("update:activeKey", key2);
      emit("change", key2);
    };
    return function() {
      var _a2;
      var tabs = parseTabList(flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)));
      return createVNode(InternalTabs, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, omit$3(props2, ["onUpdate:activeKey"])), attrs), {}, {
        "onChange": handleChange2,
        "tabs": tabs
      }), slots);
    };
  }
});
var tabPaneProps = function tabPaneProps2() {
  return {
    tab: PropTypes$1.any,
    disabled: {
      type: Boolean
    },
    forceRender: {
      type: Boolean
    },
    closable: {
      type: Boolean
    },
    animated: {
      type: Boolean
    },
    active: {
      type: Boolean
    },
    destroyInactiveTabPane: {
      type: Boolean
    },
    prefixCls: {
      type: String
    },
    tabKey: {
      type: [String, Number]
    },
    id: {
      type: String
    }
  };
};
var TabPane = defineComponent({
  name: "ATabPane",
  inheritAttrs: false,
  __ANT_TAB_PANE: true,
  props: tabPaneProps(),
  slots: ["closeIcon", "tab"],
  setup: function setup69(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var visited = ref(props2.forceRender);
    watch([function() {
      return props2.active;
    }, function() {
      return props2.destroyInactiveTabPane;
    }], function() {
      if (props2.active) {
        visited.value = true;
      } else if (props2.destroyInactiveTabPane) {
        visited.value = false;
      }
    }, {
      immediate: true
    });
    var mergedStyle = computed(function() {
      if (!props2.active) {
        if (props2.animated) {
          return {
            visibility: "hidden",
            height: 0,
            overflowY: "hidden"
          };
        } else {
          return {
            display: "none"
          };
        }
      }
      return {};
    });
    return function() {
      var _a2;
      var prefixCls2 = props2.prefixCls, forceRender = props2.forceRender, id = props2.id, active = props2.active, tabKey = props2.tabKey;
      return createVNode("div", {
        "id": id && "".concat(id, "-panel-").concat(tabKey),
        "role": "tabpanel",
        "tabindex": active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        "style": [mergedStyle.value, attrs.style],
        "class": ["".concat(prefixCls2, "-tabpane"), active && "".concat(prefixCls2, "-tabpane-active"), attrs.class]
      }, [(active || visited.value || forceRender) && ((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots))]);
    };
  }
});
Tabs.TabPane = TabPane;
Tabs.install = function(app) {
  app.component(Tabs.name, Tabs);
  app.component(TabPane.name, TabPane);
  return app;
};
var canUseDocElement = function canUseDocElement2() {
  return canUseDom() && window.document.documentElement;
};
var isStyleNameSupport = function isStyleNameSupport2(styleName) {
  if (canUseDom() && window.document.documentElement) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function(name2) {
      return name2 in documentElement.style;
    });
  }
  return false;
};
var isStyleValueSupport = function isStyleValueSupport2(styleName, value) {
  if (!isStyleNameSupport(styleName)) {
    return false;
  }
  var ele = document.createElement("div");
  var origin = ele.style[styleName];
  ele.style[styleName] = value;
  return ele.style[styleName] !== origin;
};
function isStyleSupport(styleName, styleValue) {
  if (!Array.isArray(styleName) && styleValue !== void 0) {
    return isStyleValueSupport(styleName, styleValue);
  }
  return isStyleNameSupport(styleName);
}
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported2() {
  if (!canUseDocElement()) {
    return false;
  }
  if (flexGapSupported !== void 0) {
    return flexGapSupported;
  }
  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));
  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1;
  document.body.removeChild(flex);
  return flexGapSupported;
};
var useFlexGapSupport = function() {
  var flexible = ref(false);
  onMounted(function() {
    flexible.value = detectFlexGapSupported();
  });
  return flexible;
};
var RowContextKey = Symbol("rowContextKey");
var useProvideRow = function useProvideRow2(state) {
  provide(RowContextKey, state);
};
var useInjectRow = function useInjectRow2() {
  return inject(RowContextKey, {
    gutter: computed(function() {
      return void 0;
    }),
    wrap: computed(function() {
      return void 0;
    }),
    supportFlexGap: computed(function() {
      return void 0;
    })
  });
};
tuple$1("top", "middle", "bottom", "stretch");
tuple$1("start", "end", "center", "space-around", "space-between");
var rowProps = function rowProps2() {
  return {
    align: String,
    justify: String,
    prefixCls: String,
    gutter: {
      type: [Number, Array],
      default: 0
    },
    wrap: {
      type: Boolean,
      default: void 0
    }
  };
};
var ARow = defineComponent({
  name: "ARow",
  props: rowProps(),
  setup: function setup70(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("row", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var token;
    var screens2 = ref({
      xs: true,
      sm: true,
      md: true,
      lg: true,
      xl: true,
      xxl: true,
      xxxl: true
    });
    var supportFlexGap = useFlexGapSupport();
    onMounted(function() {
      token = ResponsiveObserve.subscribe(function(screen) {
        var currentGutter = props2.gutter || 0;
        if (!Array.isArray(currentGutter) && _typeof$2(currentGutter) === "object" || Array.isArray(currentGutter) && (_typeof$2(currentGutter[0]) === "object" || _typeof$2(currentGutter[1]) === "object")) {
          screens2.value = screen;
        }
      });
    });
    onBeforeUnmount(function() {
      ResponsiveObserve.unsubscribe(token);
    });
    var gutter = computed(function() {
      var results = [0, 0];
      var _props$gutter = props2.gutter, gutter2 = _props$gutter === void 0 ? 0 : _props$gutter;
      var normalizedGutter = Array.isArray(gutter2) ? gutter2 : [gutter2, 0];
      normalizedGutter.forEach(function(g2, index2) {
        if (_typeof$2(g2) === "object") {
          for (var i2 = 0; i2 < responsiveArray.length; i2++) {
            var breakpoint = responsiveArray[i2];
            if (screens2.value[breakpoint] && g2[breakpoint] !== void 0) {
              results[index2] = g2[breakpoint];
              break;
            }
          }
        } else {
          results[index2] = g2 || 0;
        }
      });
      return results;
    });
    useProvideRow({
      gutter,
      supportFlexGap,
      wrap: computed(function() {
        return props2.wrap;
      })
    });
    var classes = computed(function() {
      var _classNames;
      return classNames(prefixCls2.value, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-no-wrap"), props2.wrap === false), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-").concat(props2.justify), props2.justify), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-").concat(props2.align), props2.align), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _classNames));
    });
    var rowStyle = computed(function() {
      var gt = gutter.value;
      var style2 = {};
      var horizontalGutter = gt[0] > 0 ? "".concat(gt[0] / -2, "px") : void 0;
      var verticalGutter = gt[1] > 0 ? "".concat(gt[1] / -2, "px") : void 0;
      if (horizontalGutter) {
        style2.marginLeft = horizontalGutter;
        style2.marginRight = horizontalGutter;
      }
      if (supportFlexGap.value) {
        style2.rowGap = "".concat(gt[1], "px");
      } else if (verticalGutter) {
        style2.marginTop = verticalGutter;
        style2.marginBottom = verticalGutter;
      }
      return style2;
    });
    return function() {
      var _a2;
      return createVNode("div", {
        "class": classes.value,
        "style": rowStyle.value
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var Row$3 = ARow;
function parseFlex(flex) {
  if (typeof flex === "number") {
    return "".concat(flex, " ").concat(flex, " auto");
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return "0 0 ".concat(flex);
  }
  return flex;
}
var colProps = function colProps2() {
  return {
    span: [String, Number],
    order: [String, Number],
    offset: [String, Number],
    push: [String, Number],
    pull: [String, Number],
    xs: {
      type: [String, Number, Object],
      default: void 0
    },
    sm: {
      type: [String, Number, Object],
      default: void 0
    },
    md: {
      type: [String, Number, Object],
      default: void 0
    },
    lg: {
      type: [String, Number, Object],
      default: void 0
    },
    xl: {
      type: [String, Number, Object],
      default: void 0
    },
    xxl: {
      type: [String, Number, Object],
      default: void 0
    },
    xxxl: {
      type: [String, Number, Object],
      default: void 0
    },
    prefixCls: String,
    flex: [String, Number]
  };
};
var Col$1 = defineComponent({
  name: "ACol",
  props: colProps(),
  setup: function setup71(props2, _ref) {
    var slots = _ref.slots;
    var _useInjectRow = useInjectRow(), gutter = _useInjectRow.gutter, supportFlexGap = _useInjectRow.supportFlexGap, wrap = _useInjectRow.wrap;
    var _useConfigInject = useConfigInject("col", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var classes = computed(function() {
      var _classNames;
      var span = props2.span, order = props2.order, offset3 = props2.offset, push = props2.push, pull = props2.pull;
      var pre = prefixCls2.value;
      var sizeClassObj = {};
      ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"].forEach(function(size) {
        var _extends2;
        var sizeProps = {};
        var propSize = props2[size];
        if (typeof propSize === "number") {
          sizeProps.span = propSize;
        } else if (_typeof$2(propSize) === "object") {
          sizeProps = propSize || {};
        }
        sizeClassObj = _extends$2(_extends$2({}, sizeClassObj), (_extends2 = {}, _defineProperty$R(_extends2, "".concat(pre, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== void 0), _defineProperty$R(_extends2, "".concat(pre, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty$R(_extends2, "".concat(pre, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty$R(_extends2, "".concat(pre, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty$R(_extends2, "".concat(pre, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _defineProperty$R(_extends2, "".concat(pre, "-rtl"), direction2.value === "rtl"), _extends2));
      });
      return classNames(pre, (_classNames = {}, _defineProperty$R(_classNames, "".concat(pre, "-").concat(span), span !== void 0), _defineProperty$R(_classNames, "".concat(pre, "-order-").concat(order), order), _defineProperty$R(_classNames, "".concat(pre, "-offset-").concat(offset3), offset3), _defineProperty$R(_classNames, "".concat(pre, "-push-").concat(push), push), _defineProperty$R(_classNames, "".concat(pre, "-pull-").concat(pull), pull), _classNames), sizeClassObj);
    });
    var mergedStyle = computed(function() {
      var flex = props2.flex;
      var gutterVal = gutter.value;
      var style2 = {};
      if (gutterVal && gutterVal[0] > 0) {
        var horizontalGutter = "".concat(gutterVal[0] / 2, "px");
        style2.paddingLeft = horizontalGutter;
        style2.paddingRight = horizontalGutter;
      }
      if (gutterVal && gutterVal[1] > 0 && !supportFlexGap.value) {
        var verticalGutter = "".concat(gutterVal[1] / 2, "px");
        style2.paddingTop = verticalGutter;
        style2.paddingBottom = verticalGutter;
      }
      if (flex) {
        style2.flex = parseFlex(flex);
        if (wrap.value === false && !style2.minWidth) {
          style2.minWidth = 0;
        }
      }
      return style2;
    });
    return function() {
      var _a2;
      return createVNode("div", {
        "class": classes.value,
        "style": mergedStyle.value
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var Row$2 = withInstall$2(Row$3);
var Col = withInstall$2(Col$1);
var now$1 = function() {
  return root$1.Date.now();
};
var now$2 = now$1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax$1 = Math.max, nativeMin$1 = Math.min;
function debounce$1(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$4(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax$1(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$2());
  }
  function debounced() {
    var time = now$2(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var VALUE_SPLIT = "__RC_CASCADER_SPLIT__";
var SHOW_PARENT$1 = "SHOW_PARENT";
var SHOW_CHILD$1 = "SHOW_CHILD";
function toPathKey(value) {
  return value.join(VALUE_SPLIT);
}
function toPathKeys(value) {
  return value.map(toPathKey);
}
function toPathValueStr(pathKey) {
  return pathKey.split(VALUE_SPLIT);
}
function fillFieldNames$2(fieldNames) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, children = _ref.children;
  var val = value || "value";
  return {
    label: label || "label",
    value: val,
    key: val,
    children: children || "children"
  };
}
function isLeaf(option2, fieldNames) {
  var _a2, _b;
  return (_a2 = option2.isLeaf) !== null && _a2 !== void 0 ? _a2 : !((_b = option2[fieldNames.children]) === null || _b === void 0 ? void 0 : _b.length);
}
function scrollIntoParentView(element) {
  var parent2 = element.parentElement;
  if (!parent2) {
    return;
  }
  var elementToParent = element.offsetTop - parent2.offsetTop;
  if (elementToParent - parent2.scrollTop < 0) {
    parent2.scrollTo({
      top: elementToParent
    });
  } else if (elementToParent + element.offsetHeight - parent2.scrollTop > parent2.offsetHeight) {
    parent2.scrollTo({
      top: elementToParent + element.offsetHeight - parent2.offsetHeight
    });
  }
}
var TreeContextKey = Symbol("TreeContextKey");
var TreeContext = defineComponent({
  name: "TreeContext",
  props: {
    value: {
      type: Object
    }
  },
  setup: function setup72(props2, _ref) {
    var slots = _ref.slots;
    provide(TreeContextKey, computed(function() {
      return props2.value;
    }));
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var useInjectTreeContext = function useInjectTreeContext2() {
  return inject(TreeContextKey, computed(function() {
    return {};
  }));
};
var KeysStateKey = Symbol("KeysStateKey");
var useProvideKeysState = function useProvideKeysState2(state) {
  provide(KeysStateKey, state);
};
var useInjectKeysState = function useInjectKeysState2() {
  return inject(KeysStateKey, {
    expandedKeys: shallowRef([]),
    selectedKeys: shallowRef([]),
    loadedKeys: shallowRef([]),
    loadingKeys: shallowRef([]),
    checkedKeys: shallowRef([]),
    halfCheckedKeys: shallowRef([]),
    expandedKeysSet: computed(function() {
      return new Set();
    }),
    selectedKeysSet: computed(function() {
      return new Set();
    }),
    loadedKeysSet: computed(function() {
      return new Set();
    }),
    loadingKeysSet: computed(function() {
      return new Set();
    }),
    checkedKeysSet: computed(function() {
      return new Set();
    }),
    halfCheckedKeysSet: computed(function() {
      return new Set();
    }),
    flattenNodes: shallowRef([])
  });
};
var Indent = function Indent2(_ref) {
  var prefixCls2 = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
  var baseClassName = "".concat(prefixCls2, "-indent-unit");
  var list = [];
  for (var i2 = 0; i2 < level; i2 += 1) {
    var _ref2;
    list.push(createVNode("span", {
      "key": i2,
      "class": (_ref2 = {}, _defineProperty$R(_ref2, baseClassName, true), _defineProperty$R(_ref2, "".concat(baseClassName, "-start"), isStart[i2]), _defineProperty$R(_ref2, "".concat(baseClassName, "-end"), isEnd[i2]), _ref2)
    }, null));
  }
  return createVNode("span", {
    "aria-hidden": "true",
    "class": "".concat(prefixCls2, "-indent")
  }, [list]);
};
var Indent$1 = Indent;
var treeNodeProps = {
  eventKey: [String, Number],
  prefixCls: String,
  title: PropTypes$1.any,
  data: {
    type: Object,
    default: void 0
  },
  parent: {
    type: Object,
    default: void 0
  },
  isStart: {
    type: Array
  },
  isEnd: {
    type: Array
  },
  active: {
    type: Boolean,
    default: void 0
  },
  onMousemove: {
    type: Function
  },
  isLeaf: {
    type: Boolean,
    default: void 0
  },
  checkable: {
    type: Boolean,
    default: void 0
  },
  selectable: {
    type: Boolean,
    default: void 0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  disableCheckbox: {
    type: Boolean,
    default: void 0
  },
  icon: PropTypes$1.any,
  switcherIcon: PropTypes$1.any,
  domRef: {
    type: Function
  }
};
var nodeListProps = {
  prefixCls: {
    type: String
  },
  motion: {
    type: Object
  },
  focusable: {
    type: Boolean
  },
  activeItem: {
    type: Object
  },
  focused: {
    type: Boolean
  },
  tabindex: {
    type: Number
  },
  checkable: {
    type: Boolean
  },
  selectable: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  },
  height: {
    type: Number
  },
  itemHeight: {
    type: Number
  },
  virtual: {
    type: Boolean
  },
  onScroll: {
    type: Function
  },
  onKeydown: {
    type: Function
  },
  onFocus: {
    type: Function
  },
  onBlur: {
    type: Function
  },
  onActiveChange: {
    type: Function
  },
  onContextmenu: {
    type: Function
  },
  onListChangeStart: {
    type: Function
  },
  onListChangeEnd: {
    type: Function
  }
};
var treeProps$1 = function treeProps() {
  return {
    prefixCls: String,
    focusable: {
      type: Boolean,
      default: void 0
    },
    activeKey: [Number, String],
    tabindex: Number,
    children: PropTypes$1.any,
    treeData: {
      type: Array
    },
    fieldNames: {
      type: Object
    },
    showLine: {
      type: [Boolean, Object],
      default: void 0
    },
    showIcon: {
      type: Boolean,
      default: void 0
    },
    icon: PropTypes$1.any,
    selectable: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    checkable: {
      type: Boolean,
      default: void 0
    },
    checkStrictly: {
      type: Boolean,
      default: void 0
    },
    draggable: {
      type: [Function, Boolean]
    },
    defaultExpandParent: {
      type: Boolean,
      default: void 0
    },
    autoExpandParent: {
      type: Boolean,
      default: void 0
    },
    defaultExpandAll: {
      type: Boolean,
      default: void 0
    },
    defaultExpandedKeys: {
      type: Array
    },
    expandedKeys: {
      type: Array
    },
    defaultCheckedKeys: {
      type: Array
    },
    checkedKeys: {
      type: [Object, Array]
    },
    defaultSelectedKeys: {
      type: Array
    },
    selectedKeys: {
      type: Array
    },
    allowDrop: {
      type: Function
    },
    dropIndicatorRender: {
      type: Function
    },
    onFocus: {
      type: Function
    },
    onBlur: {
      type: Function
    },
    onKeydown: {
      type: Function
    },
    onContextmenu: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onDblclick: {
      type: Function
    },
    onScroll: {
      type: Function
    },
    onExpand: {
      type: Function
    },
    onCheck: {
      type: Function
    },
    onSelect: {
      type: Function
    },
    onLoad: {
      type: Function
    },
    loadData: {
      type: Function
    },
    loadedKeys: {
      type: Array
    },
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onRightClick: {
      type: Function
    },
    onDragstart: {
      type: Function
    },
    onDragenter: {
      type: Function
    },
    onDragover: {
      type: Function
    },
    onDragleave: {
      type: Function
    },
    onDragend: {
      type: Function
    },
    onDrop: {
      type: Function
    },
    onActiveChange: {
      type: Function
    },
    filterTreeNode: {
      type: Function
    },
    motion: PropTypes$1.any,
    switcherIcon: PropTypes$1.any,
    height: Number,
    itemHeight: Number,
    virtual: {
      type: Boolean,
      default: void 0
    },
    direction: {
      type: String
    }
  };
};
var __rest$v = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var ICON_OPEN = "open";
var ICON_CLOSE = "close";
var defaultTitle = "---";
var VcTreeNode = defineComponent({
  name: "TreeNode",
  inheritAttrs: false,
  props: treeNodeProps,
  isTreeNode: 1,
  slots: ["title", "icon", "switcherIcon"],
  setup: function setup73(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose;
    warning$3(!("slots" in props2.data), "treeData slots is deprecated, please use ".concat(Object.keys(props2.data.slots || {}).map(function(key2) {
      return "`v-slot:" + key2 + "` ";
    }), "instead"));
    var dragNodeHighlight = ref(false);
    var context2 = useInjectTreeContext();
    var _useInjectKeysState = useInjectKeysState(), expandedKeysSet = _useInjectKeysState.expandedKeysSet, selectedKeysSet = _useInjectKeysState.selectedKeysSet, loadedKeysSet = _useInjectKeysState.loadedKeysSet, loadingKeysSet = _useInjectKeysState.loadingKeysSet, checkedKeysSet = _useInjectKeysState.checkedKeysSet, halfCheckedKeysSet = _useInjectKeysState.halfCheckedKeysSet;
    var _context$value = context2.value, dragOverNodeKey = _context$value.dragOverNodeKey, dropPosition = _context$value.dropPosition, keyEntities = _context$value.keyEntities;
    var mergedTreeNodeProps = computed(function() {
      return getTreeNodeProps(props2.eventKey, {
        expandedKeysSet: expandedKeysSet.value,
        selectedKeysSet: selectedKeysSet.value,
        loadedKeysSet: loadedKeysSet.value,
        loadingKeysSet: loadingKeysSet.value,
        checkedKeysSet: checkedKeysSet.value,
        halfCheckedKeysSet: halfCheckedKeysSet.value,
        dragOverNodeKey,
        dropPosition,
        keyEntities
      });
    });
    var expanded = eagerComputed(function() {
      return mergedTreeNodeProps.value.expanded;
    });
    var selected = eagerComputed(function() {
      return mergedTreeNodeProps.value.selected;
    });
    var checked = eagerComputed(function() {
      return mergedTreeNodeProps.value.checked;
    });
    var loaded = eagerComputed(function() {
      return mergedTreeNodeProps.value.loaded;
    });
    var loading = eagerComputed(function() {
      return mergedTreeNodeProps.value.loading;
    });
    var halfChecked = eagerComputed(function() {
      return mergedTreeNodeProps.value.halfChecked;
    });
    var dragOver = eagerComputed(function() {
      return mergedTreeNodeProps.value.dragOver;
    });
    var dragOverGapTop = eagerComputed(function() {
      return mergedTreeNodeProps.value.dragOverGapTop;
    });
    var dragOverGapBottom = eagerComputed(function() {
      return mergedTreeNodeProps.value.dragOverGapBottom;
    });
    var pos = eagerComputed(function() {
      return mergedTreeNodeProps.value.pos;
    });
    var selectHandle = ref();
    var hasChildren = computed(function() {
      var eventKey = props2.eventKey;
      var keyEntities2 = context2.value.keyEntities;
      var _ref2 = keyEntities2[eventKey] || {}, children = _ref2.children;
      return !!(children || []).length;
    });
    var isLeaf2 = computed(function() {
      var isLeaf3 = props2.isLeaf;
      var loadData = context2.value.loadData;
      var has = hasChildren.value;
      if (isLeaf3 === false) {
        return false;
      }
      return isLeaf3 || !loadData && !has || loadData && loaded.value && !has;
    });
    var nodeState = computed(function() {
      if (isLeaf2.value) {
        return null;
      }
      return expanded.value ? ICON_OPEN : ICON_CLOSE;
    });
    var isDisabled = computed(function() {
      var disabled = props2.disabled;
      var treeDisabled = context2.value.disabled;
      return !!(treeDisabled || disabled);
    });
    var isCheckable = computed(function() {
      var checkable = props2.checkable;
      var treeCheckable = context2.value.checkable;
      if (!treeCheckable || checkable === false)
        return false;
      return treeCheckable;
    });
    var isSelectable = computed(function() {
      var selectable = props2.selectable;
      var treeSelectable = context2.value.selectable;
      if (typeof selectable === "boolean") {
        return selectable;
      }
      return treeSelectable;
    });
    var renderArgsData = computed(function() {
      var data6 = props2.data, active = props2.active, checkable = props2.checkable, disableCheckbox = props2.disableCheckbox, disabled = props2.disabled, selectable = props2.selectable;
      return _extends$2(_extends$2({
        active,
        checkable,
        disableCheckbox,
        disabled,
        selectable
      }, data6), {
        dataRef: data6,
        data: data6,
        isLeaf: isLeaf2.value,
        checked: checked.value,
        expanded: expanded.value,
        loading: loading.value,
        selected: selected.value,
        halfChecked: halfChecked.value
      });
    });
    var instance2 = getCurrentInstance();
    var eventData = computed(function() {
      var eventKey = props2.eventKey;
      var keyEntities2 = context2.value.keyEntities;
      var _ref3 = keyEntities2[eventKey] || {}, parent2 = _ref3.parent;
      return _extends$2(_extends$2({}, convertNodePropsToEventData(_extends$2({}, props2, mergedTreeNodeProps.value))), {
        parent: parent2
      });
    });
    var dragNodeEvent = reactive({
      eventData,
      eventKey: computed(function() {
        return props2.eventKey;
      }),
      selectHandle,
      pos,
      key: instance2.vnode.key
    });
    expose(dragNodeEvent);
    var onSelectorDoubleClick = function onSelectorDoubleClick2(e2) {
      var onNodeDoubleClick = context2.value.onNodeDoubleClick;
      onNodeDoubleClick(e2, eventData.value);
    };
    var onSelect = function onSelect2(e2) {
      if (isDisabled.value)
        return;
      var onNodeSelect = context2.value.onNodeSelect;
      e2.preventDefault();
      onNodeSelect(e2, eventData.value);
    };
    var onCheck = function onCheck2(e2) {
      if (isDisabled.value)
        return;
      var disableCheckbox = props2.disableCheckbox;
      var onNodeCheck = context2.value.onNodeCheck;
      if (!isCheckable.value || disableCheckbox)
        return;
      e2.preventDefault();
      var targetChecked = !checked.value;
      onNodeCheck(e2, eventData.value, targetChecked);
    };
    var onSelectorClick = function onSelectorClick2(e2) {
      var onNodeClick = context2.value.onNodeClick;
      onNodeClick(e2, eventData.value);
      if (isSelectable.value) {
        onSelect(e2);
      } else {
        onCheck(e2);
      }
    };
    var onMouseEnter = function onMouseEnter2(e2) {
      var onNodeMouseEnter = context2.value.onNodeMouseEnter;
      onNodeMouseEnter(e2, eventData.value);
    };
    var onMouseLeave = function onMouseLeave2(e2) {
      var onNodeMouseLeave = context2.value.onNodeMouseLeave;
      onNodeMouseLeave(e2, eventData.value);
    };
    var onContextmenu2 = function onContextmenu3(e2) {
      var onNodeContextMenu = context2.value.onNodeContextMenu;
      onNodeContextMenu(e2, eventData.value);
    };
    var onDragStart = function onDragStart2(e2) {
      var onNodeDragStart = context2.value.onNodeDragStart;
      e2.stopPropagation();
      dragNodeHighlight.value = true;
      onNodeDragStart(e2, dragNodeEvent);
      try {
        e2.dataTransfer.setData("text/plain", "");
      } catch (error) {
      }
    };
    var onDragEnter = function onDragEnter2(e2) {
      var onNodeDragEnter = context2.value.onNodeDragEnter;
      e2.preventDefault();
      e2.stopPropagation();
      onNodeDragEnter(e2, dragNodeEvent);
    };
    var onDragOver = function onDragOver2(e2) {
      var onNodeDragOver = context2.value.onNodeDragOver;
      e2.preventDefault();
      e2.stopPropagation();
      onNodeDragOver(e2, dragNodeEvent);
    };
    var onDragLeave = function onDragLeave2(e2) {
      var onNodeDragLeave = context2.value.onNodeDragLeave;
      e2.stopPropagation();
      onNodeDragLeave(e2, dragNodeEvent);
    };
    var onDragEnd = function onDragEnd2(e2) {
      var onNodeDragEnd = context2.value.onNodeDragEnd;
      e2.stopPropagation();
      dragNodeHighlight.value = false;
      onNodeDragEnd(e2, dragNodeEvent);
    };
    var onDrop = function onDrop2(e2) {
      var onNodeDrop = context2.value.onNodeDrop;
      e2.preventDefault();
      e2.stopPropagation();
      dragNodeHighlight.value = false;
      onNodeDrop(e2, dragNodeEvent);
    };
    var onExpand = function onExpand2(e2) {
      var onNodeExpand = context2.value.onNodeExpand;
      if (loading.value)
        return;
      onNodeExpand(e2, eventData.value);
    };
    var isDraggable = function isDraggable2() {
      var data6 = props2.data;
      var draggable2 = context2.value.draggable;
      return !!(draggable2 && (!draggable2.nodeDraggable || draggable2.nodeDraggable(data6)));
    };
    var renderDragHandler = function renderDragHandler2() {
      var _context$value2 = context2.value, draggable2 = _context$value2.draggable, prefixCls2 = _context$value2.prefixCls;
      return (draggable2 === null || draggable2 === void 0 ? void 0 : draggable2.icon) ? createVNode("span", {
        "class": "".concat(prefixCls2, "-draggable-icon")
      }, [draggable2.icon]) : null;
    };
    var renderSwitcherIconDom = function renderSwitcherIconDom2() {
      var _a2, _b, _c;
      var _props$switcherIcon = props2.switcherIcon, switcherIconFromProps = _props$switcherIcon === void 0 ? slots.switcherIcon || ((_a2 = context2.value.slots) === null || _a2 === void 0 ? void 0 : _a2[(_c = (_b = props2.data) === null || _b === void 0 ? void 0 : _b.slots) === null || _c === void 0 ? void 0 : _c.switcherIcon]) : _props$switcherIcon;
      var switcherIconFromCtx = context2.value.switcherIcon;
      var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
      if (typeof switcherIcon === "function") {
        return switcherIcon(renderArgsData.value);
      }
      return switcherIcon;
    };
    var syncLoadData = function syncLoadData2() {
      var _context$value3 = context2.value, loadData = _context$value3.loadData, onNodeLoad = _context$value3.onNodeLoad;
      if (loading.value) {
        return;
      }
      if (loadData && expanded.value && !isLeaf2.value) {
        if (!hasChildren.value && !loaded.value) {
          onNodeLoad(eventData.value);
        }
      }
    };
    onMounted(function() {
      syncLoadData();
    });
    onUpdated(function() {
      syncLoadData();
    });
    var renderSwitcher = function renderSwitcher2() {
      var prefixCls2 = context2.value.prefixCls;
      var switcherIconDom = renderSwitcherIconDom();
      if (isLeaf2.value) {
        return switcherIconDom !== false ? createVNode("span", {
          "class": classNames("".concat(prefixCls2, "-switcher"), "".concat(prefixCls2, "-switcher-noop"))
        }, [switcherIconDom]) : null;
      }
      var switcherCls = classNames("".concat(prefixCls2, "-switcher"), "".concat(prefixCls2, "-switcher_").concat(expanded.value ? ICON_OPEN : ICON_CLOSE));
      return switcherIconDom !== false ? createVNode("span", {
        "onClick": onExpand,
        "class": switcherCls
      }, [switcherIconDom]) : null;
    };
    var renderCheckbox = function renderCheckbox2() {
      var _a2, _b;
      var disableCheckbox = props2.disableCheckbox;
      var prefixCls2 = context2.value.prefixCls;
      var disabled = isDisabled.value;
      var checkable = isCheckable.value;
      if (!checkable)
        return null;
      return createVNode("span", {
        "class": classNames("".concat(prefixCls2, "-checkbox"), checked.value && "".concat(prefixCls2, "-checkbox-checked"), !checked.value && halfChecked.value && "".concat(prefixCls2, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls2, "-checkbox-disabled")),
        "onClick": onCheck
      }, [(_b = (_a2 = context2.value).customCheckable) === null || _b === void 0 ? void 0 : _b.call(_a2)]);
    };
    var renderIcon3 = function renderIcon4() {
      var prefixCls2 = context2.value.prefixCls;
      return createVNode("span", {
        "class": classNames("".concat(prefixCls2, "-iconEle"), "".concat(prefixCls2, "-icon__").concat(nodeState.value || "docu"), loading.value && "".concat(prefixCls2, "-icon_loading"))
      }, null);
    };
    var renderDropIndicator = function renderDropIndicator2() {
      var disabled = props2.disabled, eventKey = props2.eventKey;
      var _context$value4 = context2.value, draggable2 = _context$value4.draggable, dropLevelOffset = _context$value4.dropLevelOffset, dropPosition2 = _context$value4.dropPosition, prefixCls2 = _context$value4.prefixCls, indent = _context$value4.indent, dropIndicatorRender2 = _context$value4.dropIndicatorRender, dragOverNodeKey2 = _context$value4.dragOverNodeKey, direction2 = _context$value4.direction;
      var rootDraggable = draggable2 !== false;
      var showIndicator = !disabled && rootDraggable && dragOverNodeKey2 === eventKey;
      return showIndicator ? dropIndicatorRender2({
        dropPosition: dropPosition2,
        dropLevelOffset,
        indent,
        prefixCls: prefixCls2,
        direction: direction2
      }) : null;
    };
    var renderSelector = function renderSelector2() {
      var _a2, _b, _c, _d, _e, _f;
      var _props$icon = props2.icon, icon = _props$icon === void 0 ? slots.icon : _props$icon, data6 = props2.data;
      var title = slots.title || ((_a2 = context2.value.slots) === null || _a2 === void 0 ? void 0 : _a2[(_c = (_b = props2.data) === null || _b === void 0 ? void 0 : _b.slots) === null || _c === void 0 ? void 0 : _c.title]) || ((_d = context2.value.slots) === null || _d === void 0 ? void 0 : _d.title) || props2.title;
      var _context$value5 = context2.value, prefixCls2 = _context$value5.prefixCls, showIcon = _context$value5.showIcon, treeIcon = _context$value5.icon, loadData = _context$value5.loadData;
      var disabled = isDisabled.value;
      var wrapClass = "".concat(prefixCls2, "-node-content-wrapper");
      var $icon;
      if (showIcon) {
        var currentIcon = icon || ((_e = context2.value.slots) === null || _e === void 0 ? void 0 : _e[(_f = data6 === null || data6 === void 0 ? void 0 : data6.slots) === null || _f === void 0 ? void 0 : _f.icon]) || treeIcon;
        $icon = currentIcon ? createVNode("span", {
          "class": classNames("".concat(prefixCls2, "-iconEle"), "".concat(prefixCls2, "-icon__customize"))
        }, [typeof currentIcon === "function" ? currentIcon(renderArgsData.value) : currentIcon]) : renderIcon3();
      } else if (loadData && loading.value) {
        $icon = renderIcon3();
      }
      var titleNode;
      if (typeof title === "function") {
        titleNode = title(renderArgsData.value);
      } else {
        titleNode = title;
      }
      titleNode = titleNode === void 0 ? defaultTitle : titleNode;
      var $title = createVNode("span", {
        "class": "".concat(prefixCls2, "-title")
      }, [titleNode]);
      return createVNode("span", {
        "ref": selectHandle,
        "title": typeof title === "string" ? title : "",
        "class": classNames("".concat(wrapClass), "".concat(wrapClass, "-").concat(nodeState.value || "normal"), !disabled && (selected.value || dragNodeHighlight.value) && "".concat(prefixCls2, "-node-selected")),
        "onMouseenter": onMouseEnter,
        "onMouseleave": onMouseLeave,
        "onContextmenu": onContextmenu2,
        "onClick": onSelectorClick,
        "onDblclick": onSelectorDoubleClick
      }, [$icon, $title, renderDropIndicator()]);
    };
    return function() {
      var _classNames;
      var _a2 = _extends$2(_extends$2({}, props2), attrs), eventKey = _a2.eventKey, isLeaf3 = _a2.isLeaf, isStart = _a2.isStart, isEnd = _a2.isEnd, domRef = _a2.domRef, active = _a2.active;
      _a2.data;
      var onMousemove = _a2.onMousemove, selectable = _a2.selectable, otherProps = __rest$v(_a2, ["eventKey", "isLeaf", "isStart", "isEnd", "domRef", "active", "data", "onMousemove", "selectable"]);
      var _context$value6 = context2.value, prefixCls2 = _context$value6.prefixCls, filterTreeNode = _context$value6.filterTreeNode, keyEntities2 = _context$value6.keyEntities, dropContainerKey = _context$value6.dropContainerKey, dropTargetKey = _context$value6.dropTargetKey, draggingNodeKey = _context$value6.draggingNodeKey;
      var disabled = isDisabled.value;
      var dataOrAriaAttributeProps = pickAttrs(otherProps, {
        aria: true,
        data: true
      });
      var _ref4 = keyEntities2[eventKey] || {}, level = _ref4.level;
      var isEndNode = isEnd[isEnd.length - 1];
      var mergedDraggable = isDraggable();
      var draggableWithoutDisabled = !disabled && mergedDraggable;
      var dragging = draggingNodeKey === eventKey;
      var ariaSelected = selectable !== void 0 ? {
        "aria-selected": !!selectable
      } : void 0;
      return createVNode("div", _objectSpread2$2(_objectSpread2$2({
        "ref": domRef,
        "class": classNames(attrs.class, "".concat(prefixCls2, "-treenode"), (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-disabled"), disabled), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-switcher-").concat(expanded.value ? "open" : "close"), !isLeaf3), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-checkbox-checked"), checked.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-checkbox-indeterminate"), halfChecked.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-selected"), selected.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-loading"), loading.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-active"), active), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-leaf-last"), isEndNode), _defineProperty$R(_classNames, "".concat(prefixCls2, "-treenode-draggable"), draggableWithoutDisabled), _defineProperty$R(_classNames, "dragging", dragging), _defineProperty$R(_classNames, "drop-target", dropTargetKey === eventKey), _defineProperty$R(_classNames, "drop-container", dropContainerKey === eventKey), _defineProperty$R(_classNames, "drag-over", !disabled && dragOver.value), _defineProperty$R(_classNames, "drag-over-gap-top", !disabled && dragOverGapTop.value), _defineProperty$R(_classNames, "drag-over-gap-bottom", !disabled && dragOverGapBottom.value), _defineProperty$R(_classNames, "filter-node", filterTreeNode && filterTreeNode(eventData.value)), _classNames)),
        "style": attrs.style,
        "draggable": draggableWithoutDisabled,
        "aria-grabbed": dragging,
        "onDragstart": draggableWithoutDisabled ? onDragStart : void 0,
        "onDragenter": mergedDraggable ? onDragEnter : void 0,
        "onDragover": mergedDraggable ? onDragOver : void 0,
        "onDragleave": mergedDraggable ? onDragLeave : void 0,
        "onDrop": mergedDraggable ? onDrop : void 0,
        "onDragend": mergedDraggable ? onDragEnd : void 0,
        "onMousemove": onMousemove
      }, ariaSelected), dataOrAriaAttributeProps), [createVNode(Indent$1, {
        "prefixCls": prefixCls2,
        "level": level,
        "isStart": isStart,
        "isEnd": isEnd
      }, null), renderDragHandler(), renderSwitcher(), renderCheckbox(), renderSelector()]);
    };
  }
});
globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function arrDel(list, value) {
  if (!list)
    return [];
  var clone3 = list.slice();
  var index2 = clone3.indexOf(value);
  if (index2 >= 0) {
    clone3.splice(index2, 1);
  }
  return clone3;
}
function arrAdd(list, value) {
  var clone3 = (list || []).slice();
  if (clone3.indexOf(value) === -1) {
    clone3.push(value);
  }
  return clone3;
}
function posToArr(pos) {
  return pos.split("-");
}
function getPosition(level, index2) {
  return "".concat(level, "-").concat(index2);
}
function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}
function getDragChildrenKeys(dragNodeKey, keyEntities) {
  var dragChildrenKeys = [];
  var entity = keyEntities[dragNodeKey];
  function dig() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    list.forEach(function(_ref) {
      var key2 = _ref.key, children = _ref.children;
      dragChildrenKeys.push(key2);
      dig(children);
    });
  }
  dig(entity.children);
  return dragChildrenKeys;
}
function isLastChild(treeNodeEntity) {
  if (treeNodeEntity.parent) {
    var posArr = posToArr(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
  }
  return false;
}
function isFirstChild(treeNodeEntity) {
  var posArr = posToArr(treeNodeEntity.pos);
  return Number(posArr[posArr.length - 1]) === 0;
}
function calcDropPosition(event, dragNode, targetNode, indent, startMousePosition, allowDrop2, flattenedNodes, keyEntities, expandKeysSet, direction2) {
  var _a2;
  var clientX = event.clientX, clientY = event.clientY;
  var _event$target$getBoun = event.target.getBoundingClientRect(), top = _event$target$getBoun.top, height = _event$target$getBoun.height;
  var horizontalMouseOffset = (direction2 === "rtl" ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
  var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
  var abstractDropNodeEntity = keyEntities[targetNode.eventKey];
  if (clientY < top + height / 2) {
    var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
      return flattenedNode.key === abstractDropNodeEntity.key;
    });
    var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
    var prevNodeKey = flattenedNodes[prevNodeIndex].key;
    abstractDropNodeEntity = keyEntities[prevNodeKey];
  }
  var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
  var abstractDragOverEntity = abstractDropNodeEntity;
  var dragOverNodeKey = abstractDropNodeEntity.key;
  var dropPosition = 0;
  var dropLevelOffset = 0;
  if (!expandKeysSet.has(initialAbstractDropNodeKey)) {
    for (var i2 = 0; i2 < rawDropLevelOffset; i2 += 1) {
      if (isLastChild(abstractDropNodeEntity)) {
        abstractDropNodeEntity = abstractDropNodeEntity.parent;
        dropLevelOffset += 1;
      } else {
        break;
      }
    }
  }
  var abstractDragDataNode = dragNode.eventData;
  var abstractDropDataNode = abstractDropNodeEntity.node;
  var dropAllowed = true;
  if (isFirstChild(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop2({
    dragNode: abstractDragDataNode,
    dropNode: abstractDropDataNode,
    dropPosition: -1
  }) && abstractDropNodeEntity.key === targetNode.eventKey) {
    dropPosition = -1;
  } else if ((abstractDragOverEntity.children || []).length && expandKeysSet.has(dragOverNodeKey)) {
    if (allowDrop2({
      dragNode: abstractDragDataNode,
      dropNode: abstractDropDataNode,
      dropPosition: 0
    })) {
      dropPosition = 0;
    } else {
      dropAllowed = false;
    }
  } else if (dropLevelOffset === 0) {
    if (rawDropLevelOffset > -1.5) {
      if (allowDrop2({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    } else {
      if (allowDrop2({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 0
      })) {
        dropPosition = 0;
      } else if (allowDrop2({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    }
  } else {
    if (allowDrop2({
      dragNode: abstractDragDataNode,
      dropNode: abstractDropDataNode,
      dropPosition: 1
    })) {
      dropPosition = 1;
    } else {
      dropAllowed = false;
    }
  }
  return {
    dropPosition,
    dropLevelOffset,
    dropTargetKey: abstractDropNodeEntity.key,
    dropTargetPos: abstractDropNodeEntity.pos,
    dragOverNodeKey,
    dropContainerKey: dropPosition === 0 ? null : ((_a2 = abstractDropNodeEntity.parent) === null || _a2 === void 0 ? void 0 : _a2.key) || null,
    dropAllowed
  };
}
function calcSelectedKeys(selectedKeys, props2) {
  if (!selectedKeys)
    return void 0;
  var multiple = props2.multiple;
  if (multiple) {
    return selectedKeys.slice();
  }
  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }
  return selectedKeys;
}
function parseCheckedKeys(keys2) {
  if (!keys2) {
    return null;
  }
  var keyProps;
  if (Array.isArray(keys2)) {
    keyProps = {
      checkedKeys: keys2,
      halfCheckedKeys: void 0
    };
  } else if (_typeof$2(keys2) === "object") {
    keyProps = {
      checkedKeys: keys2.checked || void 0,
      halfCheckedKeys: keys2.halfChecked || void 0
    };
  } else {
    return null;
  }
  return keyProps;
}
function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = new Set();
  function conductUp(key2) {
    if (expandedKeys.has(key2))
      return;
    var entity = keyEntities[key2];
    if (!entity)
      return;
    expandedKeys.add(key2);
    var parent2 = entity.parent, node = entity.node;
    if (node.disabled)
      return;
    if (parent2) {
      conductUp(parent2.key);
    }
  }
  (keyList || []).forEach(function(key2) {
    conductUp(key2);
  });
  return _toConsumableArray(expandedKeys);
}
var __rest$u = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function getKey$2(key2, pos) {
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  return pos;
}
function fillFieldNames$1(fieldNames) {
  var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key2 = _ref.key, children = _ref.children;
  var mergedTitle = title || "title";
  return {
    title: mergedTitle,
    _title: _title || [mergedTitle],
    key: key2 || "key",
    children: children || "children"
  };
}
function convertTreeToData(rootNodes) {
  function dig() {
    var node = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var treeNodes = filterEmpty(node);
    return treeNodes.map(function(treeNode) {
      var _a2, _b, _c, _d;
      if (!isTreeNode(treeNode)) {
        return null;
      }
      var slots = treeNode.children || {};
      var key2 = treeNode.key;
      var props2 = {};
      for (var _i = 0, _Object$entries = Object.entries(treeNode.props); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2), k2 = _Object$entries$_i[0], v2 = _Object$entries$_i[1];
        props2[camelize$1(k2)] = v2;
      }
      var isLeaf2 = props2.isLeaf, checkable = props2.checkable, selectable = props2.selectable, disabled = props2.disabled, disableCheckbox = props2.disableCheckbox;
      var newProps = {
        isLeaf: isLeaf2 || isLeaf2 === "" || void 0,
        checkable: checkable || checkable === "" || void 0,
        selectable: selectable || selectable === "" || void 0,
        disabled: disabled || disabled === "" || void 0,
        disableCheckbox: disableCheckbox || disableCheckbox === "" || void 0
      };
      var slotsProps = _extends$2(_extends$2({}, props2), newProps);
      var _props$title = props2.title, title = _props$title === void 0 ? (_a2 = slots.title) === null || _a2 === void 0 ? void 0 : _a2.call(slots, slotsProps) : _props$title, _props$icon = props2.icon, icon = _props$icon === void 0 ? (_b = slots.icon) === null || _b === void 0 ? void 0 : _b.call(slots, slotsProps) : _props$icon, _props$switcherIcon = props2.switcherIcon, switcherIcon = _props$switcherIcon === void 0 ? (_c = slots.switcherIcon) === null || _c === void 0 ? void 0 : _c.call(slots, slotsProps) : _props$switcherIcon, rest = __rest$u(props2, ["title", "icon", "switcherIcon"]);
      var children = (_d = slots.default) === null || _d === void 0 ? void 0 : _d.call(slots);
      var dataNode = _extends$2(_extends$2(_extends$2({}, rest), {
        title,
        icon,
        switcherIcon,
        key: key2,
        isLeaf: isLeaf2
      }), newProps);
      var parsedChildren = dig(children);
      if (parsedChildren.length) {
        dataNode.children = parsedChildren;
      }
      return dataNode;
    });
  }
  return dig(rootNodes);
}
function flattenTreeData(treeNodeList, expandedKeys, fieldNames) {
  var _fillFieldNames = fillFieldNames$1(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
  var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
  var flattenList = [];
  function dig(list) {
    var parent2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return list.map(function(treeNode, index2) {
      var pos = getPosition(parent2 ? parent2.pos : "0", index2);
      var mergedKey = getKey$2(treeNode[fieldKey], pos);
      var mergedTitle;
      for (var i2 = 0; i2 < fieldTitles.length; i2 += 1) {
        var fieldTitle = fieldTitles[i2];
        if (treeNode[fieldTitle] !== void 0) {
          mergedTitle = treeNode[fieldTitle];
          break;
        }
      }
      var flattenNode = _extends$2(_extends$2({}, omit$3(treeNode, [].concat(_toConsumableArray(fieldTitles), [fieldKey, fieldChildren]))), {
        title: mergedTitle,
        key: mergedKey,
        parent: parent2,
        pos,
        children: null,
        data: treeNode,
        isStart: [].concat(_toConsumableArray(parent2 ? parent2.isStart : []), [index2 === 0]),
        isEnd: [].concat(_toConsumableArray(parent2 ? parent2.isEnd : []), [index2 === list.length - 1])
      });
      flattenList.push(flattenNode);
      if (expandedKeys === true || expandedKeySet.has(mergedKey)) {
        flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
      } else {
        flattenNode.children = [];
      }
      return flattenNode;
    });
  }
  dig(treeNodeList);
  return flattenList;
}
function traverseDataNodes(dataNodes, callback, config) {
  var mergedConfig = {};
  if (_typeof$2(config) === "object") {
    mergedConfig = config;
  } else {
    mergedConfig = {
      externalGetKey: config
    };
  }
  mergedConfig = mergedConfig || {};
  var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
  var _fillFieldNames2 = fillFieldNames$1(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
  var mergeChildrenPropName = childrenPropName || fieldChildren;
  var syntheticGetKey;
  if (externalGetKey) {
    if (typeof externalGetKey === "string") {
      syntheticGetKey = function syntheticGetKey2(node) {
        return node[externalGetKey];
      };
    } else if (typeof externalGetKey === "function") {
      syntheticGetKey = function syntheticGetKey2(node) {
        return externalGetKey(node);
      };
    }
  } else {
    syntheticGetKey = function syntheticGetKey2(node, pos) {
      return getKey$2(node[fieldKey], pos);
    };
  }
  function processNode(node, index2, parent2, pathNodes) {
    var children = node ? node[mergeChildrenPropName] : dataNodes;
    var pos = node ? getPosition(parent2.pos, index2) : "0";
    var connectNodes = node ? [].concat(_toConsumableArray(pathNodes), [node]) : [];
    if (node) {
      var key2 = syntheticGetKey(node, pos);
      var data6 = {
        node,
        index: index2,
        pos,
        key: key2,
        parentPos: parent2.node ? parent2.pos : null,
        level: parent2.level + 1,
        nodes: connectNodes
      };
      callback(data6);
    }
    if (children) {
      children.forEach(function(subNode, subIndex) {
        processNode(subNode, subIndex, {
          node,
          pos,
          level: parent2 ? parent2.level + 1 : -1
        }, connectNodes);
      });
    }
  }
  processNode(null);
}
function convertDataToEntities(dataNodes) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
  var legacyExternalGetKey = arguments.length > 2 ? arguments[2] : void 0;
  var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities,
    keyEntities
  };
  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }
  traverseDataNodes(dataNodes, function(item) {
    var node = item.node, index2 = item.index, pos = item.pos, key2 = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
    var entity = {
      node,
      nodes,
      index: index2,
      key: key2,
      pos,
      level
    };
    var mergedKey = getKey$2(key2, pos);
    posEntities[pos] = entity;
    keyEntities[mergedKey] = entity;
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
    if (processEntity) {
      processEntity(entity, wrapper);
    }
  }, {
    externalGetKey: mergedExternalGetKey,
    childrenPropName,
    fieldNames
  });
  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }
  return wrapper;
}
function getTreeNodeProps(key2, _ref3) {
  var expandedKeysSet = _ref3.expandedKeysSet, selectedKeysSet = _ref3.selectedKeysSet, loadedKeysSet = _ref3.loadedKeysSet, loadingKeysSet = _ref3.loadingKeysSet, checkedKeysSet = _ref3.checkedKeysSet, halfCheckedKeysSet = _ref3.halfCheckedKeysSet, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
  var entity = keyEntities[key2];
  var treeNodeProps2 = {
    eventKey: key2,
    expanded: expandedKeysSet.has(key2),
    selected: selectedKeysSet.has(key2),
    loaded: loadedKeysSet.has(key2),
    loading: loadingKeysSet.has(key2),
    checked: checkedKeysSet.has(key2),
    halfChecked: halfCheckedKeysSet.has(key2),
    pos: String(entity ? entity.pos : ""),
    parent: entity.parent,
    dragOver: dragOverNodeKey === key2 && dropPosition === 0,
    dragOverGapTop: dragOverNodeKey === key2 && dropPosition === -1,
    dragOverGapBottom: dragOverNodeKey === key2 && dropPosition === 1
  };
  return treeNodeProps2;
}
function convertNodePropsToEventData(props2) {
  var data6 = props2.data, expanded = props2.expanded, selected = props2.selected, checked = props2.checked, loaded = props2.loaded, loading = props2.loading, halfChecked = props2.halfChecked, dragOver = props2.dragOver, dragOverGapTop = props2.dragOverGapTop, dragOverGapBottom = props2.dragOverGapBottom, pos = props2.pos, active = props2.active, eventKey = props2.eventKey;
  var eventData = _extends$2(_extends$2({
    dataRef: data6
  }, data6), {
    expanded,
    selected,
    checked,
    loaded,
    loading,
    halfChecked,
    dragOver,
    dragOverGapTop,
    dragOverGapBottom,
    pos,
    active,
    eventKey,
    key: eventKey
  });
  if (!("props" in eventData)) {
    Object.defineProperty(eventData, "props", {
      get: function get2() {
        return props2;
      }
    });
  }
  return eventData;
}
var useEntities = function(options, fieldNames) {
  var entities = computed(function() {
    return convertDataToEntities(options.value, {
      fieldNames: fieldNames.value,
      initWrapper: function initWrapper(wrapper) {
        return _extends$2(_extends$2({}, wrapper), {
          pathKeyEntities: {}
        });
      },
      processEntity: function processEntity(entity, wrapper) {
        var pathKey = entity.nodes.map(function(node) {
          return node[fieldNames.value.value];
        }).join(VALUE_SPLIT);
        wrapper.pathKeyEntities[pathKey] = entity;
        entity.key = pathKey;
      }
    }).pathKeyEntities;
  });
  return entities;
};
function useSearchConfig(showSearch) {
  var mergedShowSearch = ref(false);
  var mergedSearchConfig = ref({});
  watchEffect(function() {
    if (!showSearch.value) {
      mergedShowSearch.value = false;
      mergedSearchConfig.value = {};
      return;
    }
    var searchConfig = {
      matchInputWidth: true,
      limit: 50
    };
    if (showSearch.value && _typeof$2(showSearch.value) === "object") {
      searchConfig = _extends$2(_extends$2({}, searchConfig), showSearch.value);
    }
    if (searchConfig.limit <= 0) {
      delete searchConfig.limit;
    }
    mergedShowSearch.value = true;
    mergedSearchConfig.value = searchConfig;
    return;
  });
  return {
    showSearch: mergedShowSearch,
    searchConfig: mergedSearchConfig
  };
}
var SEARCH_MARK = "__rc_cascader_search_mark__";
var defaultFilter = function defaultFilter2(search, options, _ref) {
  var label = _ref.label;
  return options.some(function(opt) {
    return String(opt[label]).toLowerCase().includes(search.toLowerCase());
  });
};
var defaultRender = function defaultRender2(_ref2) {
  var path = _ref2.path, fieldNames = _ref2.fieldNames;
  return path.map(function(opt) {
    return opt[fieldNames.label];
  }).join(" / ");
};
var useSearchOptions = function(search, options, fieldNames, prefixCls2, config, changeOnSelect) {
  return computed(function() {
    var _config$value = config.value, _config$value$filter = _config$value.filter, filter = _config$value$filter === void 0 ? defaultFilter : _config$value$filter, _config$value$render = _config$value.render, render11 = _config$value$render === void 0 ? defaultRender : _config$value$render, _config$value$limit = _config$value.limit, limit = _config$value$limit === void 0 ? 50 : _config$value$limit, sort2 = _config$value.sort;
    var filteredOptions = [];
    if (!search.value) {
      return [];
    }
    function dig(list, pathOptions) {
      list.forEach(function(option2) {
        if (!sort2 && limit > 0 && filteredOptions.length >= limit) {
          return;
        }
        var connectedPathOptions = [].concat(_toConsumableArray(pathOptions), [option2]);
        var children = option2[fieldNames.value.children];
        if (!children || children.length === 0 || changeOnSelect.value) {
          if (filter(search.value, connectedPathOptions, {
            label: fieldNames.value.label
          })) {
            var _extends2;
            filteredOptions.push(_extends$2(_extends$2({}, option2), (_extends2 = {}, _defineProperty$R(_extends2, fieldNames.value.label, render11({
              inputValue: search.value,
              path: connectedPathOptions,
              prefixCls: prefixCls2.value,
              fieldNames: fieldNames.value
            })), _defineProperty$R(_extends2, SEARCH_MARK, connectedPathOptions), _extends2)));
          }
        }
        if (children) {
          dig(option2[fieldNames.value.children], connectedPathOptions);
        }
      });
    }
    dig(options.value, []);
    if (sort2) {
      filteredOptions.sort(function(a2, b2) {
        return sort2(a2[SEARCH_MARK], b2[SEARCH_MARK], search.value, fieldNames.value);
      });
    }
    return limit > 0 ? filteredOptions.slice(0, limit) : filteredOptions;
  });
};
function formatStrategyValues$1(pathKeys, keyPathEntities, showCheckedStrategy) {
  var valueSet = new Set(pathKeys);
  return pathKeys.filter(function(key2) {
    var entity = keyPathEntities[key2];
    var parent2 = entity ? entity.parent : null;
    var children = entity ? entity.children : null;
    return showCheckedStrategy === SHOW_CHILD$1 ? !(children && children.some(function(child) {
      return child.key && valueSet.has(child.key);
    })) : !(parent2 && !parent2.node.disabled && valueSet.has(parent2.key));
  });
}
function toPathOptions(valueCells, options, fieldNames) {
  var stringMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var _a2;
  var currentList = options;
  var valueOptions = [];
  var _loop = function _loop2(i3) {
    var valueCell = valueCells[i3];
    var foundIndex = currentList === null || currentList === void 0 ? void 0 : currentList.findIndex(function(option2) {
      var val = option2[fieldNames.value];
      return stringMode ? String(val) === String(valueCell) : val === valueCell;
    });
    var foundOption = foundIndex !== -1 ? currentList === null || currentList === void 0 ? void 0 : currentList[foundIndex] : null;
    valueOptions.push({
      value: (_a2 = foundOption === null || foundOption === void 0 ? void 0 : foundOption[fieldNames.value]) !== null && _a2 !== void 0 ? _a2 : valueCell,
      index: foundIndex,
      option: foundOption
    });
    currentList = foundOption === null || foundOption === void 0 ? void 0 : foundOption[fieldNames.children];
  };
  for (var i2 = 0; i2 < valueCells.length; i2 += 1) {
    _loop(i2);
  }
  return valueOptions;
}
var useMissingValues = function(options, fieldNames, rawValues) {
  return computed(function() {
    var missingValues = [];
    var existsValues = [];
    rawValues.value.forEach(function(valueCell) {
      var pathOptions = toPathOptions(valueCell, options.value, fieldNames.value);
      if (pathOptions.every(function(opt) {
        return opt.option;
      })) {
        existsValues.push(valueCell);
      } else {
        missingValues.push(valueCell);
      }
    });
    return [existsValues, missingValues];
  });
};
function removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
  var filteredKeys = new Set();
  halfCheckedKeys.forEach(function(key2) {
    if (!checkedKeys.has(key2)) {
      filteredKeys.add(key2);
    }
  });
  return filteredKeys;
}
function isCheckDisabled$1(node) {
  var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
  return !!(disabled || disableCheckbox) || checkable === false;
}
function fillConductCheck(keys2, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys2);
  var halfCheckedKeys = new Set();
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
      if (checkedKeys.has(key2) && !syntheticGetCheckDisabled(node)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.add(childEntity.key);
        });
      }
    });
  }
  var visitedKeys = new Set();
  for (var _level = maxLevel; _level >= 0; _level -= 1) {
    var _entities = levelEntities.get(_level) || new Set();
    _entities.forEach(function(entity) {
      var parent2 = entity.parent, node = entity.node;
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent2.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent2.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref2) {
        var key2 = _ref2.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (allChecked) {
        checkedKeys.add(parent2.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent2.key);
      }
      visitedKeys.add(parent2.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function cleanConductCheck(keys2, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys2);
  var halfCheckedKeys = new Set(halfKeys);
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
      if (!checkedKeys.has(key2) && !halfCheckedKeys.has(key2) && !syntheticGetCheckDisabled(node)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.delete(childEntity.key);
        });
      }
    });
  }
  halfCheckedKeys = new Set();
  var visitedKeys = new Set();
  for (var _level2 = maxLevel; _level2 >= 0; _level2 -= 1) {
    var _entities2 = levelEntities.get(_level2) || new Set();
    _entities2.forEach(function(entity) {
      var parent2 = entity.parent, node = entity.node;
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent2.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent2.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref3) {
        var key2 = _ref3.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (!allChecked) {
        checkedKeys.delete(parent2.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent2.key);
      }
      visitedKeys.add(parent2.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function conductCheck(keyList, checked, keyEntities, maxLevel, levelEntities, getCheckDisabled) {
  var syntheticGetCheckDisabled;
  if (getCheckDisabled) {
    syntheticGetCheckDisabled = getCheckDisabled;
  } else {
    syntheticGetCheckDisabled = isCheckDisabled$1;
  }
  var keys2 = new Set(keyList.filter(function(key2) {
    var hasEntity = !!keyEntities[key2];
    return hasEntity;
  }));
  var result;
  if (checked === true) {
    result = fillConductCheck(keys2, levelEntities, maxLevel, syntheticGetCheckDisabled);
  } else {
    result = cleanConductCheck(keys2, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  }
  return result;
}
var useDisplayValues = function(rawValues, options, fieldNames, multiple, displayRender) {
  return computed(function() {
    var mergedDisplayRender = displayRender.value || function(_ref) {
      var labels = _ref.labels;
      var mergedLabels = multiple.value ? labels.slice(-1) : labels;
      var SPLIT = " / ";
      if (mergedLabels.every(function(label) {
        return ["string", "number"].includes(_typeof$2(label));
      })) {
        return mergedLabels.join(SPLIT);
      }
      return mergedLabels.reduce(function(list, label, index2) {
        var keyedLabel = isValidElement(label) ? cloneElement(label, {
          key: index2
        }) : label;
        if (index2 === 0) {
          return [keyedLabel];
        }
        return [].concat(_toConsumableArray(list), [SPLIT, keyedLabel]);
      }, []);
    };
    return rawValues.value.map(function(valueCells) {
      var valueOptions = toPathOptions(valueCells, options.value, fieldNames.value);
      var label = mergedDisplayRender({
        labels: valueOptions.map(function(_ref2) {
          var option2 = _ref2.option, value2 = _ref2.value;
          var _a2;
          return (_a2 = option2 === null || option2 === void 0 ? void 0 : option2[fieldNames.value.label]) !== null && _a2 !== void 0 ? _a2 : value2;
        }),
        selectedOptions: valueOptions.map(function(_ref3) {
          var option2 = _ref3.option;
          return option2;
        })
      });
      var value = toPathKey(valueCells);
      return {
        label,
        value,
        key: value,
        valueCells
      };
    });
  });
};
var CascaderContextKey = Symbol("CascaderContextKey");
var useProvideCascader = function useProvideCascader2(props2) {
  provide(CascaderContextKey, props2);
};
var useInjectCascader = function useInjectCascader2() {
  return inject(CascaderContextKey);
};
var useActive = function() {
  var baseProps2 = useBaseProps();
  var _useInjectCascader = useInjectCascader(), values = _useInjectCascader.values;
  var _useState = useState([]), _useState2 = _slicedToArray$2(_useState, 2), activeValueCells = _useState2[0], setActiveValueCells = _useState2[1];
  watch(function() {
    return baseProps2.open;
  }, function() {
    if (baseProps2.open && !baseProps2.multiple) {
      var firstValueCells = values.value[0];
      setActiveValueCells(firstValueCells || []);
    }
  }, {
    immediate: true
  });
  return [activeValueCells, setActiveValueCells];
};
var useKeyboard = function(context2, options, fieldNames, activeValueCells, setActiveValueCells, onKeyBoardSelect) {
  var baseProps2 = useBaseProps();
  var rtl2 = computed(function() {
    return baseProps2.direction === "rtl";
  });
  var _ref = [ref([]), ref(), ref([])], validActiveValueCells = _ref[0], lastActiveIndex = _ref[1], lastActiveOptions = _ref[2];
  watchEffect(function() {
    var activeIndex = -1;
    var currentOptions = options.value;
    var mergedActiveIndexes = [];
    var mergedActiveValueCells = [];
    var len = activeValueCells.value.length;
    var _loop = function _loop2(i3) {
      var nextActiveIndex = currentOptions.findIndex(function(option2) {
        return option2[fieldNames.value.value] === activeValueCells.value[i3];
      });
      if (nextActiveIndex === -1) {
        return "break";
      }
      activeIndex = nextActiveIndex;
      mergedActiveIndexes.push(activeIndex);
      mergedActiveValueCells.push(activeValueCells.value[i3]);
      currentOptions = currentOptions[activeIndex][fieldNames.value.children];
    };
    for (var i2 = 0; i2 < len && currentOptions; i2 += 1) {
      var _ret = _loop(i2);
      if (_ret === "break")
        break;
    }
    var activeOptions = options.value;
    for (var _i = 0; _i < mergedActiveIndexes.length - 1; _i += 1) {
      activeOptions = activeOptions[mergedActiveIndexes[_i]][fieldNames.value.children];
    }
    var _ref2 = [mergedActiveValueCells, activeIndex, activeOptions];
    validActiveValueCells.value = _ref2[0];
    lastActiveIndex.value = _ref2[1];
    lastActiveOptions.value = _ref2[2];
  });
  var internalSetActiveValueCells = function internalSetActiveValueCells2(next2) {
    setActiveValueCells(next2);
  };
  var offsetActiveOption = function offsetActiveOption2(offset3) {
    var len = lastActiveOptions.value.length;
    var currentIndex = lastActiveIndex.value;
    if (currentIndex === -1 && offset3 < 0) {
      currentIndex = len;
    }
    for (var i2 = 0; i2 < len; i2 += 1) {
      currentIndex = (currentIndex + offset3 + len) % len;
      var option2 = lastActiveOptions.value[currentIndex];
      if (option2 && !option2.disabled) {
        var value = option2[fieldNames.value.value];
        var nextActiveCells = validActiveValueCells.value.slice(0, -1).concat(value);
        internalSetActiveValueCells(nextActiveCells);
        return;
      }
    }
  };
  var prevColumn = function prevColumn2() {
    if (validActiveValueCells.value.length > 1) {
      var nextActiveCells = validActiveValueCells.value.slice(0, -1);
      internalSetActiveValueCells(nextActiveCells);
    } else {
      baseProps2.toggleOpen(false);
    }
  };
  var nextColumn = function nextColumn2() {
    var _a2;
    var nextOptions = ((_a2 = lastActiveOptions.value[lastActiveIndex.value]) === null || _a2 === void 0 ? void 0 : _a2[fieldNames.value.children]) || [];
    var nextOption = nextOptions.find(function(option2) {
      return !option2.disabled;
    });
    if (nextOption) {
      var nextActiveCells = [].concat(_toConsumableArray(validActiveValueCells.value), [nextOption[fieldNames.value.value]]);
      internalSetActiveValueCells(nextActiveCells);
    }
  };
  context2.expose({
    onKeydown: function onKeydown(event) {
      var which = event.which;
      switch (which) {
        case KeyCode$1.UP:
        case KeyCode$1.DOWN: {
          var offset3 = 0;
          if (which === KeyCode$1.UP) {
            offset3 = -1;
          } else if (which === KeyCode$1.DOWN) {
            offset3 = 1;
          }
          if (offset3 !== 0) {
            offsetActiveOption(offset3);
          }
          break;
        }
        case KeyCode$1.LEFT: {
          if (rtl2.value) {
            nextColumn();
          } else {
            prevColumn();
          }
          break;
        }
        case KeyCode$1.RIGHT: {
          if (rtl2.value) {
            prevColumn();
          } else {
            nextColumn();
          }
          break;
        }
        case KeyCode$1.BACKSPACE: {
          if (!baseProps2.searchValue) {
            prevColumn();
          }
          break;
        }
        case KeyCode$1.ENTER: {
          if (validActiveValueCells.value.length) {
            var option2 = lastActiveOptions.value[lastActiveIndex.value];
            var originOptions = (option2 === null || option2 === void 0 ? void 0 : option2[SEARCH_MARK]) || [];
            if (originOptions.length) {
              onKeyBoardSelect(originOptions.map(function(opt) {
                return opt[fieldNames.value.value];
              }), originOptions[originOptions.length - 1]);
            } else {
              onKeyBoardSelect(validActiveValueCells.value, option2);
            }
          }
          break;
        }
        case KeyCode$1.ESC: {
          baseProps2.toggleOpen(false);
          if (open) {
            event.stopPropagation();
          }
        }
      }
    },
    onKeyup: function onKeyup() {
    }
  });
};
function Checkbox$1(_ref) {
  var _ref2;
  var prefixCls2 = _ref.prefixCls, checked = _ref.checked, halfChecked = _ref.halfChecked, disabled = _ref.disabled, onClick2 = _ref.onClick;
  var _useInjectCascader = useInjectCascader(), customSlots = _useInjectCascader.customSlots, checkable = _useInjectCascader.checkable;
  var mergedCheckable = checkable.value !== false ? customSlots.value.checkable : checkable.value;
  var customCheckbox = typeof mergedCheckable === "function" ? mergedCheckable() : typeof mergedCheckable === "boolean" ? null : mergedCheckable;
  return createVNode("span", {
    "class": (_ref2 = {}, _defineProperty$R(_ref2, prefixCls2, true), _defineProperty$R(_ref2, "".concat(prefixCls2, "-checked"), checked), _defineProperty$R(_ref2, "".concat(prefixCls2, "-indeterminate"), !checked && halfChecked), _defineProperty$R(_ref2, "".concat(prefixCls2, "-disabled"), disabled), _ref2),
    "onClick": onClick2
  }, [customCheckbox]);
}
Checkbox$1.props = ["prefixCls", "checked", "halfChecked", "disabled", "onClick"];
Checkbox$1.displayName = "Checkbox";
Checkbox$1.inheritAttrs = false;
var FIX_LABEL = "__cascader_fix_label__";
function Column$1(_ref) {
  var prefixCls2 = _ref.prefixCls, multiple = _ref.multiple, options = _ref.options, activeValue = _ref.activeValue, prevValuePath = _ref.prevValuePath, onToggleOpen = _ref.onToggleOpen, onSelect = _ref.onSelect, onActive = _ref.onActive, checkedSet = _ref.checkedSet, halfCheckedSet = _ref.halfCheckedSet, loadingKeys = _ref.loadingKeys, isSelectable = _ref.isSelectable;
  var _a2, _b, _c, _d, _e, _f;
  var menuPrefixCls = "".concat(prefixCls2, "-menu");
  var menuItemPrefixCls = "".concat(prefixCls2, "-menu-item");
  var _useInjectCascader = useInjectCascader(), fieldNames = _useInjectCascader.fieldNames, changeOnSelect = _useInjectCascader.changeOnSelect, expandTrigger = _useInjectCascader.expandTrigger, expandIconRef = _useInjectCascader.expandIcon, loadingIconRef = _useInjectCascader.loadingIcon, dropdownMenuColumnStyle = _useInjectCascader.dropdownMenuColumnStyle, customSlots = _useInjectCascader.customSlots;
  var expandIcon = (_a2 = expandIconRef.value) !== null && _a2 !== void 0 ? _a2 : (_c = (_b = customSlots.value).expandIcon) === null || _c === void 0 ? void 0 : _c.call(_b);
  var loadingIcon = (_d = loadingIconRef.value) !== null && _d !== void 0 ? _d : (_f = (_e = customSlots.value).loadingIcon) === null || _f === void 0 ? void 0 : _f.call(_e);
  var hoverOpen = expandTrigger.value === "hover";
  return createVNode("ul", {
    "class": menuPrefixCls,
    "role": "menu"
  }, [options.map(function(option2) {
    var _ref2;
    var _a3;
    var disabled = option2.disabled;
    var searchOptions = option2[SEARCH_MARK];
    var label = (_a3 = option2[FIX_LABEL]) !== null && _a3 !== void 0 ? _a3 : option2[fieldNames.value.label];
    var value = option2[fieldNames.value.value];
    var isMergedLeaf = isLeaf(option2, fieldNames.value);
    var fullPath = searchOptions ? searchOptions.map(function(opt) {
      return opt[fieldNames.value.value];
    }) : [].concat(_toConsumableArray(prevValuePath), [value]);
    var fullPathKey = toPathKey(fullPath);
    var isLoading = loadingKeys.includes(fullPathKey);
    var checked = checkedSet.has(fullPathKey);
    var halfChecked = halfCheckedSet.has(fullPathKey);
    var triggerOpenPath = function triggerOpenPath2() {
      if (!disabled && (!hoverOpen || !isMergedLeaf)) {
        onActive(fullPath);
      }
    };
    var triggerSelect = function triggerSelect2() {
      if (isSelectable(option2)) {
        onSelect(fullPath, isMergedLeaf);
      }
    };
    var title;
    if (typeof option2.title === "string") {
      title = option2.title;
    } else if (typeof label === "string") {
      title = label;
    }
    return createVNode("li", {
      "key": fullPathKey,
      "class": [menuItemPrefixCls, (_ref2 = {}, _defineProperty$R(_ref2, "".concat(menuItemPrefixCls, "-expand"), !isMergedLeaf), _defineProperty$R(_ref2, "".concat(menuItemPrefixCls, "-active"), activeValue === value), _defineProperty$R(_ref2, "".concat(menuItemPrefixCls, "-disabled"), disabled), _defineProperty$R(_ref2, "".concat(menuItemPrefixCls, "-loading"), isLoading), _ref2)],
      "style": dropdownMenuColumnStyle.value,
      "role": "menuitemcheckbox",
      "title": title,
      "aria-checked": checked,
      "data-path-key": fullPathKey,
      "onClick": function onClick2() {
        triggerOpenPath();
        if (!multiple || isMergedLeaf) {
          triggerSelect();
        }
      },
      "onDblclick": function onDblclick() {
        if (changeOnSelect.value) {
          onToggleOpen(false);
        }
      },
      "onMouseenter": function onMouseenter2() {
        if (hoverOpen) {
          triggerOpenPath();
        }
      },
      "onMousedown": function onMousedown2(e2) {
        e2.preventDefault();
      }
    }, [multiple && createVNode(Checkbox$1, {
      "prefixCls": "".concat(prefixCls2, "-checkbox"),
      "checked": checked,
      "halfChecked": halfChecked,
      "disabled": disabled,
      "onClick": function onClick2(e2) {
        e2.stopPropagation();
        triggerSelect();
      }
    }, null), createVNode("div", {
      "class": "".concat(menuItemPrefixCls, "-content")
    }, [label]), !isLoading && expandIcon && !isMergedLeaf && createVNode("div", {
      "class": "".concat(menuItemPrefixCls, "-expand-icon")
    }, [expandIcon]), isLoading && loadingIcon && createVNode("div", {
      "class": "".concat(menuItemPrefixCls, "-loading-icon")
    }, [loadingIcon])]);
  })]);
}
Column$1.props = ["prefixCls", "multiple", "options", "activeValue", "prevValuePath", "onToggleOpen", "onSelect", "onActive", "checkedSet", "halfCheckedSet", "loadingKeys", "isSelectable"];
Column$1.displayName = "Column";
Column$1.inheritAttrs = false;
var OptionList$1 = defineComponent({
  name: "OptionList",
  inheritAttrs: false,
  setup: function setup74(_props, context2) {
    var attrs = context2.attrs, slots = context2.slots;
    var baseProps2 = useBaseProps();
    var containerRef = ref();
    var rtl2 = computed(function() {
      return baseProps2.direction === "rtl";
    });
    var _useInjectCascader = useInjectCascader(), options = _useInjectCascader.options, values = _useInjectCascader.values, halfValues = _useInjectCascader.halfValues, fieldNames = _useInjectCascader.fieldNames, changeOnSelect = _useInjectCascader.changeOnSelect, onSelect = _useInjectCascader.onSelect, searchOptions = _useInjectCascader.searchOptions, dropdownPrefixCls = _useInjectCascader.dropdownPrefixCls, loadData = _useInjectCascader.loadData, expandTrigger = _useInjectCascader.expandTrigger, customSlots = _useInjectCascader.customSlots;
    var mergedPrefixCls = computed(function() {
      return dropdownPrefixCls.value || baseProps2.prefixCls;
    });
    var loadingKeys = shallowRef([]);
    var internalLoadData = function internalLoadData2(valueCells) {
      if (!loadData.value || baseProps2.searchValue) {
        return;
      }
      var optionList = toPathOptions(valueCells, options.value, fieldNames.value);
      var rawOptions = optionList.map(function(_ref) {
        var option2 = _ref.option;
        return option2;
      });
      var lastOption = rawOptions[rawOptions.length - 1];
      if (lastOption && !isLeaf(lastOption, fieldNames.value)) {
        var pathKey = toPathKey(valueCells);
        loadingKeys.value = [].concat(_toConsumableArray(loadingKeys.value), [pathKey]);
        loadData.value(rawOptions);
      }
    };
    watchEffect(function() {
      if (loadingKeys.value.length) {
        loadingKeys.value.forEach(function(loadingKey) {
          var valueStrCells = toPathValueStr(loadingKey);
          var optionList = toPathOptions(valueStrCells, options.value, fieldNames.value, true).map(function(_ref2) {
            var option2 = _ref2.option;
            return option2;
          });
          var lastOption = optionList[optionList.length - 1];
          if (!lastOption || lastOption[fieldNames.value.children] || isLeaf(lastOption, fieldNames.value)) {
            loadingKeys.value = loadingKeys.value.filter(function(key2) {
              return key2 !== loadingKey;
            });
          }
        });
      }
    });
    var checkedSet = computed(function() {
      return new Set(toPathKeys(values.value));
    });
    var halfCheckedSet = computed(function() {
      return new Set(toPathKeys(halfValues.value));
    });
    var _useActive = useActive(), _useActive2 = _slicedToArray$2(_useActive, 2), activeValueCells = _useActive2[0], setActiveValueCells = _useActive2[1];
    var onPathOpen = function onPathOpen2(nextValueCells) {
      setActiveValueCells(nextValueCells);
      internalLoadData(nextValueCells);
    };
    var isSelectable = function isSelectable2(option2) {
      var disabled = option2.disabled;
      var isMergedLeaf = isLeaf(option2, fieldNames.value);
      return !disabled && (isMergedLeaf || changeOnSelect.value || baseProps2.multiple);
    };
    var onPathSelect = function onPathSelect2(valuePath, leaf) {
      var fromKeyboard = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      onSelect(valuePath);
      if (!baseProps2.multiple && (leaf || changeOnSelect.value && (expandTrigger.value === "hover" || fromKeyboard))) {
        baseProps2.toggleOpen(false);
      }
    };
    var mergedOptions = computed(function() {
      if (baseProps2.searchValue) {
        return searchOptions.value;
      }
      return options.value;
    });
    var optionColumns = computed(function() {
      var optionList = [{
        options: mergedOptions.value
      }];
      var currentList = mergedOptions.value;
      var _loop = function _loop2(i3) {
        var activeValueCell = activeValueCells.value[i3];
        var currentOption = currentList.find(function(option2) {
          return option2[fieldNames.value.value] === activeValueCell;
        });
        var subOptions = currentOption === null || currentOption === void 0 ? void 0 : currentOption[fieldNames.value.children];
        if (!(subOptions === null || subOptions === void 0 ? void 0 : subOptions.length)) {
          return "break";
        }
        currentList = subOptions;
        optionList.push({
          options: subOptions
        });
      };
      for (var i2 = 0; i2 < activeValueCells.value.length; i2 += 1) {
        var _ret = _loop(i2);
        if (_ret === "break")
          break;
      }
      return optionList;
    });
    var onKeyboardSelect = function onKeyboardSelect2(selectValueCells, option2) {
      if (isSelectable(option2)) {
        onPathSelect(selectValueCells, isLeaf(option2, fieldNames.value), true);
      }
    };
    useKeyboard(context2, mergedOptions, fieldNames, activeValueCells, onPathOpen, onKeyboardSelect);
    var onListMouseDown = function onListMouseDown2(event) {
      event.preventDefault();
    };
    onMounted(function() {
      watch(activeValueCells, function(cells) {
        var _a2;
        for (var i2 = 0; i2 < cells.length; i2 += 1) {
          var cellPath = cells.slice(0, i2 + 1);
          var cellKeyPath = toPathKey(cellPath);
          var ele = (_a2 = containerRef.value) === null || _a2 === void 0 ? void 0 : _a2.querySelector('li[data-path-key="'.concat(cellKeyPath.replace(/\\{0,2}"/g, '\\"'), '"]'));
          if (ele) {
            scrollIntoParentView(ele);
          }
        }
      }, {
        flush: "post",
        immediate: true
      });
    });
    return function() {
      var _ref3, _ref4;
      var _a2, _b, _c, _d, _e;
      var _baseProps$notFoundCo = baseProps2.notFoundContent, notFoundContent = _baseProps$notFoundCo === void 0 ? ((_a2 = slots.notFoundContent) === null || _a2 === void 0 ? void 0 : _a2.call(slots)) || ((_c = (_b = customSlots.value).notFoundContent) === null || _c === void 0 ? void 0 : _c.call(_b)) : _baseProps$notFoundCo, multiple = baseProps2.multiple, toggleOpen = baseProps2.toggleOpen;
      var isEmpty = !((_e = (_d = optionColumns.value[0]) === null || _d === void 0 ? void 0 : _d.options) === null || _e === void 0 ? void 0 : _e.length);
      var emptyList = [(_ref3 = {}, _defineProperty$R(_ref3, fieldNames.value.value, "__EMPTY__"), _defineProperty$R(_ref3, FIX_LABEL, notFoundContent), _defineProperty$R(_ref3, "disabled", true), _ref3)];
      var columnProps = _extends$2(_extends$2({}, attrs), {
        multiple: !isEmpty && multiple,
        onSelect: onPathSelect,
        onActive: onPathOpen,
        onToggleOpen: toggleOpen,
        checkedSet: checkedSet.value,
        halfCheckedSet: halfCheckedSet.value,
        loadingKeys: loadingKeys.value,
        isSelectable
      });
      var mergedOptionColumns = isEmpty ? [{
        options: emptyList
      }] : optionColumns.value;
      var columnNodes = mergedOptionColumns.map(function(col, index2) {
        var prevValuePath = activeValueCells.value.slice(0, index2);
        var activeValue = activeValueCells.value[index2];
        return createVNode(Column$1, _objectSpread2$2(_objectSpread2$2({
          "key": index2
        }, columnProps), {}, {
          "prefixCls": mergedPrefixCls.value,
          "options": col.options,
          "prevValuePath": prevValuePath,
          "activeValue": activeValue
        }), null);
      });
      return createVNode("div", {
        "class": ["".concat(mergedPrefixCls.value, "-menus"), (_ref4 = {}, _defineProperty$R(_ref4, "".concat(mergedPrefixCls.value, "-menu-empty"), isEmpty), _defineProperty$R(_ref4, "".concat(mergedPrefixCls.value, "-rtl"), rtl2.value), _ref4)],
        "onMousedown": onListMouseDown,
        "ref": containerRef
      }, [columnNodes]);
    };
  }
});
function useMaxLevel(keyEntities) {
  var maxLevel = ref(0);
  var levelEntities = shallowRef();
  watchEffect(function() {
    var newLevelEntities = new Map();
    var newMaxLevel = 0;
    var keyEntitiesValue = keyEntities.value || {};
    for (var key2 in keyEntitiesValue) {
      if (Object.prototype.hasOwnProperty.call(keyEntitiesValue, key2)) {
        var entity = keyEntitiesValue[key2];
        var level = entity.level;
        var levelSet = newLevelEntities.get(level);
        if (!levelSet) {
          levelSet = new Set();
          newLevelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        newMaxLevel = Math.max(newMaxLevel, level);
      }
    }
    maxLevel.value = newMaxLevel;
    levelEntities.value = newLevelEntities;
  });
  return {
    maxLevel,
    levelEntities
  };
}
function baseCascaderProps() {
  return _extends$2(_extends$2({}, omit$3(baseSelectPropsWithoutPrivate(), ["tokenSeparators", "mode", "showSearch"])), {
    id: String,
    prefixCls: String,
    fieldNames: Object,
    children: Array,
    value: {
      type: [String, Number, Array]
    },
    defaultValue: {
      type: [String, Number, Array]
    },
    changeOnSelect: {
      type: Boolean,
      default: void 0
    },
    displayRender: Function,
    checkable: {
      type: Boolean,
      default: void 0
    },
    showCheckedStrategy: {
      type: String,
      default: SHOW_PARENT$1
    },
    showSearch: {
      type: [Boolean, Object],
      default: void 0
    },
    searchValue: String,
    onSearch: Function,
    expandTrigger: String,
    options: Array,
    dropdownPrefixCls: String,
    loadData: Function,
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    popupClassName: String,
    dropdownClassName: String,
    dropdownMenuColumnStyle: {
      type: Object,
      default: void 0
    },
    popupStyle: {
      type: Object,
      default: void 0
    },
    dropdownStyle: {
      type: Object,
      default: void 0
    },
    popupPlacement: String,
    placement: String,
    onPopupVisibleChange: Function,
    onDropdownVisibleChange: Function,
    expandIcon: PropTypes$1.any,
    loadingIcon: PropTypes$1.any
  });
}
function internalCascaderProps() {
  return _extends$2(_extends$2({}, baseCascaderProps()), {
    onChange: Function,
    customSlots: Object
  });
}
function isMultipleValue(value) {
  return Array.isArray(value) && Array.isArray(value[0]);
}
function toRawValues(value) {
  if (!value) {
    return [];
  }
  if (isMultipleValue(value)) {
    return value;
  }
  return (value.length === 0 ? [] : [value]).map(function(val) {
    return Array.isArray(val) ? val : [val];
  });
}
var Cascader$2 = defineComponent({
  name: "Cascader",
  inheritAttrs: false,
  props: initDefaultProps$1(internalCascaderProps(), {}),
  setup: function setup75(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var mergedId = useId$1(toRef(props2, "id"));
    var multiple = computed(function() {
      return !!props2.checkable;
    });
    var _useMergedState = useMergedState(props2.defaultValue, {
      value: computed(function() {
        return props2.value;
      }),
      postState: toRawValues
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), rawValues = _useMergedState2[0], setRawValues = _useMergedState2[1];
    var mergedFieldNames = computed(function() {
      return fillFieldNames$2(props2.fieldNames);
    });
    var mergedOptions = computed(function() {
      return props2.options || [];
    });
    var pathKeyEntities = useEntities(mergedOptions, mergedFieldNames);
    var getValueByKeyPath = function getValueByKeyPath2(pathKeys) {
      var keyPathEntities = pathKeyEntities.value;
      return pathKeys.map(function(pathKey) {
        var nodes = keyPathEntities[pathKey].nodes;
        return nodes.map(function(node) {
          return node[mergedFieldNames.value.value];
        });
      });
    };
    var _useMergedState3 = useMergedState("", {
      value: computed(function() {
        return props2.searchValue;
      }),
      postState: function postState(search) {
        return search || "";
      }
    }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), mergedSearchValue = _useMergedState4[0], setSearchValue = _useMergedState4[1];
    var onInternalSearch = function onInternalSearch2(searchText, info) {
      setSearchValue(searchText);
      if (info.source !== "blur" && props2.onSearch) {
        props2.onSearch(searchText);
      }
    };
    var _useSearchConfig = useSearchConfig(toRef(props2, "showSearch")), mergedShowSearch = _useSearchConfig.showSearch, mergedSearchConfig = _useSearchConfig.searchConfig;
    var searchOptions = useSearchOptions(mergedSearchValue, mergedOptions, mergedFieldNames, computed(function() {
      return props2.dropdownPrefixCls || props2.prefixCls;
    }), mergedSearchConfig, toRef(props2, "changeOnSelect"));
    var missingValuesInfo = useMissingValues(mergedOptions, mergedFieldNames, rawValues);
    var _ref2 = [ref([]), ref([]), ref([])], checkedValues = _ref2[0], halfCheckedValues = _ref2[1], missingCheckedValues = _ref2[2];
    var _useMaxLevel = useMaxLevel(pathKeyEntities), maxLevel = _useMaxLevel.maxLevel, levelEntities = _useMaxLevel.levelEntities;
    watchEffect(function() {
      var _missingValuesInfo$va = _slicedToArray$2(missingValuesInfo.value, 2), existValues = _missingValuesInfo$va[0], missingValues = _missingValuesInfo$va[1];
      if (!multiple.value || !rawValues.value.length) {
        var _ref3 = [existValues, [], missingValues];
        checkedValues.value = _ref3[0];
        halfCheckedValues.value = _ref3[1];
        missingCheckedValues.value = _ref3[2];
        return;
      }
      var keyPathValues = toPathKeys(existValues);
      var keyPathEntities = pathKeyEntities.value;
      var _conductCheck = conductCheck(keyPathValues, true, keyPathEntities, maxLevel.value, levelEntities.value), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
      var _ref4 = [getValueByKeyPath(checkedKeys), getValueByKeyPath(halfCheckedKeys), missingValues];
      checkedValues.value = _ref4[0];
      halfCheckedValues.value = _ref4[1];
      missingCheckedValues.value = _ref4[2];
    });
    var deDuplicatedValues = computed(function() {
      var checkedKeys = toPathKeys(checkedValues.value);
      var deduplicateKeys = formatStrategyValues$1(checkedKeys, pathKeyEntities.value, props2.showCheckedStrategy);
      return [].concat(_toConsumableArray(missingCheckedValues.value), _toConsumableArray(getValueByKeyPath(deduplicateKeys)));
    });
    var displayValues = useDisplayValues(deDuplicatedValues, mergedOptions, mergedFieldNames, multiple, toRef(props2, "displayRender"));
    var triggerChange = function triggerChange2(nextValues) {
      setRawValues(nextValues);
      if (props2.onChange) {
        var nextRawValues = toRawValues(nextValues);
        var valueOptions = nextRawValues.map(function(valueCells) {
          return toPathOptions(valueCells, mergedOptions.value, mergedFieldNames.value).map(function(valueOpt) {
            return valueOpt.option;
          });
        });
        var triggerValues = multiple.value ? nextRawValues : nextRawValues[0];
        var triggerOptions = multiple.value ? valueOptions : valueOptions[0];
        props2.onChange(triggerValues, triggerOptions);
      }
    };
    var onInternalSelect = function onInternalSelect2(valuePath) {
      setSearchValue("");
      if (!multiple.value) {
        triggerChange(valuePath);
      } else {
        var pathKey = toPathKey(valuePath);
        var checkedPathKeys = toPathKeys(checkedValues.value);
        var halfCheckedPathKeys = toPathKeys(halfCheckedValues.value);
        var existInChecked = checkedPathKeys.includes(pathKey);
        var existInMissing = missingCheckedValues.value.some(function(valueCells) {
          return toPathKey(valueCells) === pathKey;
        });
        var nextCheckedValues = checkedValues.value;
        var nextMissingValues = missingCheckedValues.value;
        if (existInMissing && !existInChecked) {
          nextMissingValues = missingCheckedValues.value.filter(function(valueCells) {
            return toPathKey(valueCells) !== pathKey;
          });
        } else {
          var nextRawCheckedKeys = existInChecked ? checkedPathKeys.filter(function(key2) {
            return key2 !== pathKey;
          }) : [].concat(_toConsumableArray(checkedPathKeys), [pathKey]);
          var checkedKeys;
          if (existInChecked) {
            var _conductCheck2 = conductCheck(nextRawCheckedKeys, {
              checked: false,
              halfCheckedKeys: halfCheckedPathKeys
            }, pathKeyEntities.value, maxLevel.value, levelEntities.value);
            checkedKeys = _conductCheck2.checkedKeys;
          } else {
            var _conductCheck3 = conductCheck(nextRawCheckedKeys, true, pathKeyEntities.value, maxLevel.value, levelEntities.value);
            checkedKeys = _conductCheck3.checkedKeys;
          }
          var deDuplicatedKeys = formatStrategyValues$1(checkedKeys, pathKeyEntities.value, props2.showCheckedStrategy);
          nextCheckedValues = getValueByKeyPath(deDuplicatedKeys);
        }
        triggerChange([].concat(_toConsumableArray(nextMissingValues), _toConsumableArray(nextCheckedValues)));
      }
    };
    var onDisplayValuesChange = function onDisplayValuesChange2(_2, info) {
      if (info.type === "clear") {
        triggerChange([]);
        return;
      }
      var valueCells = info.values[0].valueCells;
      onInternalSelect(valueCells);
    };
    var mergedOpen = computed(function() {
      return props2.open !== void 0 ? props2.open : props2.popupVisible;
    });
    var mergedDropdownClassName = computed(function() {
      return props2.dropdownClassName || props2.popupClassName;
    });
    var mergedDropdownStyle = computed(function() {
      return props2.dropdownStyle || props2.popupStyle || {};
    });
    var mergedPlacement = computed(function() {
      return props2.placement || props2.popupPlacement;
    });
    var onInternalDropdownVisibleChange = function onInternalDropdownVisibleChange2(nextVisible) {
      var _a2, _b;
      (_a2 = props2.onDropdownVisibleChange) === null || _a2 === void 0 ? void 0 : _a2.call(props2, nextVisible);
      (_b = props2.onPopupVisibleChange) === null || _b === void 0 ? void 0 : _b.call(props2, nextVisible);
    };
    var _toRefs = toRefs(props2), changeOnSelect = _toRefs.changeOnSelect, checkable = _toRefs.checkable, dropdownPrefixCls = _toRefs.dropdownPrefixCls, loadData = _toRefs.loadData, expandTrigger = _toRefs.expandTrigger, expandIcon = _toRefs.expandIcon, loadingIcon = _toRefs.loadingIcon, dropdownMenuColumnStyle = _toRefs.dropdownMenuColumnStyle, customSlots = _toRefs.customSlots;
    useProvideCascader({
      options: mergedOptions,
      fieldNames: mergedFieldNames,
      values: checkedValues,
      halfValues: halfCheckedValues,
      changeOnSelect,
      onSelect: onInternalSelect,
      checkable,
      searchOptions,
      dropdownPrefixCls,
      loadData,
      expandTrigger,
      expandIcon,
      loadingIcon,
      dropdownMenuColumnStyle,
      customSlots
    });
    var selectRef = ref();
    expose({
      focus: function focus2() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      },
      scrollTo: function scrollTo2(arg) {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg);
      }
    });
    var pickProps = computed(function() {
      return omit$3(props2, [
        "id",
        "prefixCls",
        "fieldNames",
        "defaultValue",
        "value",
        "changeOnSelect",
        "onChange",
        "displayRender",
        "checkable",
        "searchValue",
        "onSearch",
        "showSearch",
        "expandTrigger",
        "options",
        "dropdownPrefixCls",
        "loadData",
        "popupVisible",
        "open",
        "popupClassName",
        "dropdownClassName",
        "dropdownMenuColumnStyle",
        "popupPlacement",
        "placement",
        "onDropdownVisibleChange",
        "onPopupVisibleChange",
        "expandIcon",
        "loadingIcon",
        "customSlots",
        "showCheckedStrategy",
        "children"
      ]);
    });
    return function() {
      var emptyOptions = !(mergedSearchValue.value ? searchOptions.value : mergedOptions.value).length;
      var _props$dropdownMatchS = props2.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? false : _props$dropdownMatchS;
      var dropdownStyle = mergedSearchValue.value && mergedSearchConfig.value.matchInputWidth || emptyOptions ? {} : {
        minWidth: "auto"
      };
      return createVNode(BaseSelect, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, pickProps.value), attrs), {}, {
        "ref": selectRef,
        "id": mergedId,
        "prefixCls": props2.prefixCls,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth,
        "dropdownStyle": _extends$2(_extends$2({}, mergedDropdownStyle.value), dropdownStyle),
        "displayValues": displayValues.value,
        "onDisplayValuesChange": onDisplayValuesChange,
        "mode": multiple.value ? "multiple" : void 0,
        "searchValue": mergedSearchValue.value,
        "onSearch": onInternalSearch,
        "showSearch": mergedShowSearch.value,
        "OptionList": OptionList$1,
        "emptyOptions": emptyOptions,
        "open": mergedOpen.value,
        "dropdownClassName": mergedDropdownClassName.value,
        "placement": mergedPlacement.value,
        "onDropdownVisibleChange": onInternalDropdownVisibleChange,
        "getRawInputElement": function getRawInputElement() {
          var _a2;
          return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
        }
      }), slots);
    };
  }
});
function arrayEach(array4, iteratee) {
  var index2 = -1, length = array4 == null ? 0 : array4.length;
  while (++index2 < length) {
    if (iteratee(array4[index2], index2, array4) === false) {
      break;
    }
  }
  return array4;
}
function copyObject(source, props2, object4, customizer) {
  var isNew = !object4;
  object4 || (object4 = {});
  var index2 = -1, length = props2.length;
  while (++index2 < length) {
    var key2 = props2[index2];
    var newValue = customizer ? customizer(object4[key2], source[key2], key2, object4, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key2];
    }
    if (isNew) {
      baseAssignValue(object4, key2, newValue);
    } else {
      assignValue(object4, key2, newValue);
    }
  }
  return object4;
}
function baseAssign(object4, source) {
  return object4 && copyObject(source, keys(source), object4);
}
function nativeKeysIn(object4) {
  var result = [];
  if (object4 != null) {
    for (var key2 in Object(object4)) {
      result.push(key2);
    }
  }
  return result;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function baseKeysIn(object4) {
  if (!isObject$4(object4)) {
    return nativeKeysIn(object4);
  }
  var isProto = isPrototype(object4), result = [];
  for (var key2 in object4) {
    if (!(key2 == "constructor" && (isProto || !hasOwnProperty$2.call(object4, key2)))) {
      result.push(key2);
    }
  }
  return result;
}
function keysIn(object4) {
  return isArrayLike(object4) ? arrayLikeKeys(object4, true) : baseKeysIn(object4);
}
function baseAssignIn(object4, source) {
  return object4 && copyObject(source, keysIn(source), object4);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer2 = moduleExports ? root$1.Buffer : void 0, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}
function copyArray(source, array4) {
  var index2 = -1, length = source.length;
  array4 || (array4 = Array(length));
  while (++index2 < length) {
    array4[index2] = source[index2];
  }
  return array4;
}
function copySymbols(source, object4) {
  return copyObject(source, getSymbols$1(source), object4);
}
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object4) {
  var result = [];
  while (object4) {
    arrayPush(result, getSymbols$1(object4));
    object4 = getPrototype$1(object4);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;
function copySymbolsIn(source, object4) {
  return copyObject(source, getSymbolsIn$1(source), object4);
}
function getAllKeysIn(object4) {
  return baseGetAllKeys(object4, keysIn, getSymbolsIn$1);
}
var objectProto = Object.prototype;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
function initCloneArray(array4) {
  var length = array4.length, result = new array4.constructor(length);
  if (length && typeof array4[0] == "string" && hasOwnProperty$1.call(array4, "index")) {
    result.index = array4.index;
    result.input = array4.input;
  }
  return result;
}
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp4) {
  var result = new regexp4.constructor(regexp4.source, reFlags.exec(regexp4));
  result.lastIndex = regexp4.lastIndex;
  return result;
}
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object4, tag, isDeep) {
  var Ctor = object4.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object4);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object4);
    case dataViewTag$1:
      return cloneDataView(object4, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object4, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$2:
    case stringTag$1:
      return new Ctor(object4);
    case regexpTag$1:
      return cloneRegExp(object4);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object4);
  }
}
var objectCreate = Object.create;
var baseCreate = function() {
  function object4() {
  }
  return function(proto) {
    if (!isObject$4(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object4.prototype = proto;
    var result = new object4();
    object4.prototype = void 0;
    return result;
  };
}();
var baseCreate$1 = baseCreate;
function initCloneObject(object4) {
  return typeof object4.constructor == "function" && !isPrototype(object4) ? baseCreate$1(getPrototype$1(object4)) : {};
}
var mapTag$1 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;
var setTag$1 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag$1 = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag$1] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value, bitmask, customizer, key2, object4, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer) {
    result = object4 ? customizer(value, key2, object4, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$4(value)) {
    return value;
  }
  var isArr = isArray$3(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object4) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object4 ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function(subValue, key3) {
      result.set(key3, baseClone(subValue, bitmask, customizer, key3, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$1 : isFlat ? keysIn : keys;
  var props2 = isArr ? void 0 : keysFunc(value);
  arrayEach(props2 || value, function(subValue, key3) {
    if (props2) {
      key3 = subValue;
      subValue = value[key3];
    }
    assignValue(result, key3, baseClone(subValue, bitmask, customizer, key3, value, stack));
  });
  return result;
}
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep$1(value) {
  return baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance2 = new Constructor();
      if (Class2)
        _setPrototypeOf(instance2, Class2.prototype);
      return instance2;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
var formatRegExp = /%[sdj%]/g;
var warning = function warning2() {
};
if (typeof process !== "undefined" && process.env && false) {
  warning = function warning3(type4, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e2) {
        return typeof e2 === "string";
      })) {
        console.warn(type4, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length)
    return null;
  var fields = {};
  errors.forEach(function(error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format2(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i2 = 0;
  var len = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x2) {
      if (x2 === "%%") {
        return "%";
      }
      if (i2 >= len) {
        return x2;
      }
      switch (x2) {
        case "%s":
          return String(args[i2++]);
        case "%d":
          return Number(args[i2++]);
        case "%j":
          try {
            return JSON.stringify(args[i2++]);
          } catch (_2) {
            return "[Circular]";
          }
          break;
        default:
          return x2;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type4) {
  return type4 === "string" || type4 === "url" || type4 === "hex" || type4 === "email" || type4 === "date" || type4 === "pattern";
}
function isEmptyValue(value, type4) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type4 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type4) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total3 = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, errors || []);
    total3++;
    if (total3 === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a2) {
    func(a2, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next2(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next2);
    } else {
      callback([]);
    }
  }
  next2([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k2) {
    ret.push.apply(ret, objArr[k2] || []);
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(AsyncValidationError2, _Error);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _this = _Error.call(this, "Async Validation Error") || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return AsyncValidationError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option2, func, callback, source) {
  if (option2.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next2 = function next3(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next2);
    });
    _pending["catch"](function(e2) {
      return e2;
    });
    return _pending;
  }
  var firstFields = option2.firstFields === true ? Object.keys(objArr) : option2.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total3 = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next2 = function next3(errors) {
      results.push.apply(results, errors);
      total3++;
      if (total3 === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key2) {
      var arr = objArr[key2];
      if (firstFields.indexOf(key2) !== -1) {
        asyncSerialArray(arr, func, next2);
      } else {
        asyncParallelArray(arr, func, next2);
      }
    });
  });
  pending["catch"](function(e2) {
    return e2;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue$1(value, path) {
  var v2 = value;
  for (var i2 = 0; i2 < path.length; i2++) {
    if (v2 == void 0) {
      return v2;
    }
    v2 = v2[path[i2]];
  }
  return v2;
}
function complementError(rule, source) {
  return function(oe) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue$1(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }
    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }
    return {
      message: typeof oe === "function" ? oe() : oe,
      fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s2 in source) {
      if (source.hasOwnProperty(s2)) {
        var value = source[s2];
        if (typeof value === "object" && typeof target[s2] === "object") {
          target[s2] = _extends$1({}, target[s2], value);
        } else {
          target[s2] = value;
        }
      }
    }
  }
  return target;
}
var required$1 = function required(rule, value, source, errors, options, type4) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type4 || rule.type))) {
    errors.push(format2(options.messages.required, rule.fullField));
  }
};
var whitespace = function whitespace2(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format2(options.messages.whitespace, rule.fullField));
  }
};
var urlReg;
var getUrlRegex = function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b2 = function b3(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
  };
  var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
  var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v4 + "$");
  var v6exact = new RegExp("^" + v6 + "$");
  var ip = function ip2(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b2(options) + v4 + b2(options) + ")|(?:" + b2(options) + v6 + b2(options) + ")", "g");
  };
  ip.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("" + b2(options) + v4 + b2(options), "g");
  };
  ip.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("" + b2(options) + v6 + b2(options), "g");
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
  urlReg = new RegExp("(?:^" + regex + "$)", "i");
  return urlReg;
};
var pattern$2 = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e2) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return typeof value === "object" && !types.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && value.length <= 320 && !!value.match(pattern$2.email);
  },
  url: function url(value) {
    return typeof value === "string" && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern$2.hex);
  }
};
var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required$1(rule, value, source, errors, options);
    return;
  }
  var custom = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format2(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format2(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var range = function range2(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min4 = typeof rule.min === "number";
  var max4 = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key2 = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key2 = "number";
  } else if (str) {
    key2 = "string";
  } else if (arr) {
    key2 = "array";
  }
  if (!key2) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format2(options.messages[key2].len, rule.fullField, rule.len));
    }
  } else if (min4 && !max4 && val < rule.min) {
    errors.push(format2(options.messages[key2].min, rule.fullField, rule.min));
  } else if (max4 && !min4 && val > rule.max) {
    errors.push(format2(options.messages[key2].max, rule.fullField, rule.max));
  } else if (min4 && max4 && (val < rule.min || val > rule.max)) {
    errors.push(format2(options.messages[key2].range, rule.fullField, rule.min, rule.max));
  }
};
var ENUM$1 = "enum";
var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];
  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format2(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(", ")));
  }
};
var pattern$1 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format2(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format2(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
var rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  "enum": enumerable$1,
  pattern: pattern$1
};
var string = function string2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
var method2 = function method3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var number2 = function number3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var _boolean = function _boolean2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var regexp2 = function regexp3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var integer2 = function integer3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var floatFn = function floatFn2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var array2 = function array3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var object2 = function object3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var ENUM = "enum";
var enumerable2 = function enumerable3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var pattern2 = function pattern3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rules.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var date2 = function date3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var required2 = function required3(rule, value, callback, source, options) {
  var errors = [];
  var type4 = Array.isArray(value) ? "array" : typeof value;
  rules.required(rule, value, source, errors, options, type4);
  callback(errors);
};
var type2 = function type3(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var any = function any2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
  }
  callback(errors);
};
var validators = {
  string,
  method: method2,
  number: number2,
  "boolean": _boolean,
  regexp: regexp2,
  integer: integer2,
  "float": floatFn,
  array: array2,
  object: object2,
  "enum": enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
function newMessages() {
  return {
    "default": "Validation error on field %s",
    required: "%s is required",
    "enum": "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      "boolean": "%s is not a %s",
      integer: "%s is not an %s",
      "float": "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone3() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
var Schema = /* @__PURE__ */ function() {
  function Schema2(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }
  var _proto = Schema2.prototype;
  _proto.define = function define(rules2) {
    var _this = this;
    if (!rules2) {
      throw new Error("Cannot configure a schema with no rules");
    }
    if (typeof rules2 !== "object" || Array.isArray(rules2)) {
      throw new Error("Rules must be an object");
    }
    this.rules = {};
    Object.keys(rules2).forEach(function(name2) {
      var item = rules2[name2];
      _this.rules[name2] = Array.isArray(item) ? item : [item];
    });
  };
  _proto.messages = function messages2(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }
    return this._messages;
  };
  _proto.validate = function validate(source_, o2, oc) {
    var _this2 = this;
    if (o2 === void 0) {
      o2 = {};
    }
    if (oc === void 0) {
      oc = function oc2() {
      };
    }
    var source = source_;
    var options = o2;
    var callback = oc;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }
      return Promise.resolve(source);
    }
    function complete(results) {
      var errors = [];
      var fields = {};
      function add2(e2) {
        if (Array.isArray(e2)) {
          var _errors;
          errors = (_errors = errors).concat.apply(_errors, e2);
        } else {
          errors.push(e2);
        }
      }
      for (var i2 = 0; i2 < results.length; i2++) {
        add2(results[i2]);
      }
      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }
    if (options.messages) {
      var messages$1 = this.messages();
      if (messages$1 === messages) {
        messages$1 = newMessages();
      }
      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }
    var series = {};
    var keys2 = options.keys || Object.keys(this.rules);
    keys2.forEach(function(z2) {
      var arr = _this2.rules[z2];
      var value = source[z2];
      arr.forEach(function(r2) {
        var rule = r2;
        if (typeof rule.transform === "function") {
          if (source === source_) {
            source = _extends$1({}, source);
          }
          value = source[z2] = rule.transform(value);
        }
        if (typeof rule === "function") {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends$1({}, rule);
        }
        rule.validator = _this2.getValidationMethod(rule);
        if (!rule.validator) {
          return;
        }
        rule.field = z2;
        rule.fullField = rule.fullField || z2;
        rule.type = _this2.getType(rule);
        series[z2] = series[z2] || [];
        series[z2].push({
          rule,
          value,
          source,
          field: z2
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function(data6, doIt) {
      var rule = data6.rule;
      var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
      deep = deep && (rule.required || !rule.required && data6.value);
      rule.field = data6.field;
      function addFullField(key2, schema) {
        return _extends$1({}, schema, {
          fullField: rule.fullField + "." + key2,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key2]) : [key2]
        });
      }
      function cb(e2) {
        if (e2 === void 0) {
          e2 = [];
        }
        var errorList = Array.isArray(e2) ? e2 : [e2];
        if (!options.suppressWarning && errorList.length) {
          Schema2.warning("async-validator:", errorList);
        }
        if (errorList.length && rule.message !== void 0) {
          errorList = [].concat(rule.message);
        }
        var filledErrors = errorList.map(complementError(rule, source));
        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }
        if (!deep) {
          doIt(filledErrors);
        } else {
          if (rule.required && !data6.value) {
            if (rule.message !== void 0) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format2(options.messages.required, rule.field))];
            }
            return doIt(filledErrors);
          }
          var fieldsSchema = {};
          if (rule.defaultField) {
            Object.keys(data6.value).map(function(key2) {
              fieldsSchema[key2] = rule.defaultField;
            });
          }
          fieldsSchema = _extends$1({}, fieldsSchema, data6.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function(field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema2(paredFieldsSchema);
          schema.messages(options.messages);
          if (data6.rule.options) {
            data6.rule.options.messages = options.messages;
            data6.rule.options.error = options.error;
          }
          schema.validate(data6.value, data6.rule.options || options, function(errs) {
            var finalErrors = [];
            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }
      var res;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data6.value, cb, data6.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data6.value, cb, data6.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error);
          if (!options.suppressValidatorError) {
            setTimeout(function() {
              throw error;
            }, 0);
          }
          cb(error.message);
        }
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function() {
          return cb();
        }, function(e2) {
          return cb(e2);
        });
      }
    }, function(results) {
      complete(results);
    }, source);
  };
  _proto.getType = function getType(rule) {
    if (rule.type === void 0 && rule.pattern instanceof RegExp) {
      rule.type = "pattern";
    }
    if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format2("Unknown rule type %s", rule.type));
    }
    return rule.type || "string";
  };
  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === "function") {
      return rule.validator;
    }
    var keys2 = Object.keys(rule);
    var messageIndex = keys2.indexOf("message");
    if (messageIndex !== -1) {
      keys2.splice(messageIndex, 1);
    }
    if (keys2.length === 1 && keys2[0] === "required") {
      return validators.required;
    }
    return validators[this.getType(rule)] || void 0;
  };
  return Schema2;
}();
Schema.register = function register2(type4, validator) {
  if (typeof validator !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type4] = validator;
};
Schema.warning = warning;
Schema.messages = messages;
Schema.validators = validators;
function toArray$5(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function get$2(entity, path) {
  var current2 = entity;
  for (var i2 = 0; i2 < path.length; i2 += 1) {
    if (current2 === null || current2 === void 0) {
      return void 0;
    }
    current2 = current2[path[i2]];
  }
  return current2;
}
function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = _toArray(paths), path = _paths[0], restPath = _paths.slice(1);
  var clone3;
  if (!entity && typeof path === "number") {
    clone3 = [];
  } else if (Array.isArray(entity)) {
    clone3 = _toConsumableArray(entity);
  } else {
    clone3 = _extends$2({}, entity);
  }
  if (removeIfUndefined && value === void 0 && restPath.length === 1) {
    delete clone3[path][restPath[0]];
  } else {
    clone3[path] = internalSet(clone3[path], restPath, value, removeIfUndefined);
  }
  return clone3;
}
function set$1(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (paths.length && removeIfUndefined && value === void 0 && !get$2(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function getNamePath(path) {
  return toArray$5(path);
}
function getValue(store, namePath) {
  var value = get$2(store, namePath);
  return value;
}
function setValue(store, namePath, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var newStore = set$1(store, namePath, value, removeIfUndefined);
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  return namePathList && namePathList.some(function(path) {
    return matchNamePath(path, namePath);
  });
}
function isObject$3(obj) {
  return _typeof$2(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function internalSetValues(store, values) {
  var newStore = Array.isArray(store) ? _toConsumableArray(store) : _extends$2({}, store);
  if (!values) {
    return newStore;
  }
  Object.keys(values).forEach(function(key2) {
    var prevValue = newStore[key2];
    var value = values[key2];
    var recursive = isObject$3(prevValue) && isObject$3(value);
    newStore[key2] = recursive ? internalSetValues(prevValue, value || {}) : value;
  });
  return newStore;
}
function setValues(store) {
  for (var _len = arguments.length, restValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restValues[_key - 1] = arguments[_key];
  }
  return restValues.reduce(function(current2, newStore) {
    return internalSetValues(current2, newStore);
  }, store);
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function(namePath) {
    var value = getValue(store, namePath);
    newStore = setValue(newStore, namePath, value);
  });
  return newStore;
}
function matchNamePath(namePath, changedNamePath) {
  if (!namePath || !changedNamePath || namePath.length !== changedNamePath.length) {
    return false;
  }
  return namePath.every(function(nameUnit, i2) {
    return changedNamePath[i2] === nameUnit;
  });
}
var typeTemplate = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var AsyncValidator = Schema;
function replaceMessage(template, kv) {
  return template.replace(/\$\{\w+\}/g, function(str) {
    var key2 = str.slice(2, -1);
    return kv[key2];
  });
}
function validateRule(name2, value, rule, options, messageVariables) {
  return __awaiter$2(this, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee() {
    var cloneRule, subRuleField, validator, messages2, result, subResults, kv, fillVariableResult;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cloneRule = _extends$2({}, rule);
            delete cloneRule.ruleIndex;
            delete cloneRule.trigger;
            subRuleField = null;
            if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
              subRuleField = cloneRule.defaultField;
              delete cloneRule.defaultField;
            }
            validator = new AsyncValidator(_defineProperty$R({}, name2, [cloneRule]));
            messages2 = setValues({}, defaultValidateMessages, options.validateMessages);
            validator.messages(messages2);
            result = [];
            _context.prev = 9;
            _context.next = 12;
            return Promise.resolve(validator.validate(_defineProperty$R({}, name2, value), _extends$2({}, options)));
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](9);
            if (_context.t0.errors) {
              result = _context.t0.errors.map(function(_ref, index2) {
                var message = _ref.message;
                return isValidElement(message) ? cloneVNode(message, {
                  key: "error_".concat(index2)
                }) : message;
              });
            } else {
              console.error(_context.t0);
              result = [messages2.default()];
            }
          case 17:
            if (!(!result.length && subRuleField)) {
              _context.next = 22;
              break;
            }
            _context.next = 20;
            return Promise.all(value.map(function(subValue, i2) {
              return validateRule("".concat(name2, ".").concat(i2), subValue, subRuleField, options, messageVariables);
            }));
          case 20:
            subResults = _context.sent;
            return _context.abrupt("return", subResults.reduce(function(prev2, errors) {
              return [].concat(_toConsumableArray(prev2), _toConsumableArray(errors));
            }, []));
          case 22:
            kv = _extends$2(_extends$2(_extends$2({}, rule), {
              name: name2,
              enum: (rule.enum || []).join(", ")
            }), messageVariables);
            fillVariableResult = result.map(function(error) {
              if (typeof error === "string") {
                return replaceMessage(error, kv);
              }
              return error;
            });
            return _context.abrupt("return", fillVariableResult);
          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 14]]);
  }));
}
function validateRules(namePath, value, rules2, options, validateFirst, messageVariables) {
  var _this = this;
  var name2 = namePath.join(".");
  var filledRules = rules2.map(function(currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;
    var cloneRule = _extends$2(_extends$2({}, currentRule), {
      ruleIndex
    });
    if (originValidatorFunc) {
      cloneRule.validator = function(rule, val, callback) {
        var hasPromise = false;
        var wrappedCallback = function wrappedCallback2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          Promise.resolve().then(function() {
            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        };
        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
        if (hasPromise) {
          promise.then(function() {
            callback();
          }).catch(function(err) {
            callback(err || " ");
          });
        }
      };
    }
    return cloneRule;
  }).sort(function(_ref2, _ref3) {
    var w1 = _ref2.warningOnly, i1 = _ref2.ruleIndex;
    var w2 = _ref3.warningOnly, i2 = _ref3.ruleIndex;
    if (!!w1 === !!w2) {
      return i1 - i2;
    }
    if (w1) {
      return 1;
    }
    return -1;
  });
  var summaryPromise;
  if (validateFirst === true) {
    summaryPromise = new Promise(function(resolve, reject) {
      return __awaiter$2(_this, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee2() {
        var i2, rule, errors;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                i2 = 0;
              case 1:
                if (!(i2 < filledRules.length)) {
                  _context2.next = 12;
                  break;
                }
                rule = filledRules[i2];
                _context2.next = 5;
                return validateRule(name2, value, rule, options, messageVariables);
              case 5:
                errors = _context2.sent;
                if (!errors.length) {
                  _context2.next = 9;
                  break;
                }
                reject([{
                  errors,
                  rule
                }]);
                return _context2.abrupt("return");
              case 9:
                i2 += 1;
                _context2.next = 1;
                break;
              case 12:
                resolve([]);
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    });
  } else {
    var rulePromises = filledRules.map(function(rule) {
      return validateRule(name2, value, rule, options, messageVariables).then(function(errors) {
        return {
          errors,
          rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function(errors) {
      return Promise.reject(errors);
    });
  }
  summaryPromise.catch(function(e2) {
    return e2;
  });
  return summaryPromise;
}
function finishOnAllFailed(rulePromises) {
  return __awaiter$2(this, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee3() {
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
              var _ref4;
              var errors = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(errorsList));
              return errors;
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}
function finishOnFirstFailed(rulePromises) {
  return __awaiter$2(this, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee4() {
    var count;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            count = 0;
            return _context4.abrupt("return", new Promise(function(resolve) {
              rulePromises.forEach(function(promise) {
                promise.then(function(ruleError) {
                  if (ruleError.errors.length) {
                    resolve([ruleError]);
                  }
                  count += 1;
                  if (count === rulePromises.length) {
                    resolve([]);
                  }
                });
              });
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object4, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object4 == null) {
    return !length;
  }
  object4 = Object(object4);
  while (index2--) {
    var data6 = matchData[index2];
    if (noCustomizer && data6[2] ? data6[1] !== object4[data6[0]] : !(data6[0] in object4)) {
      return false;
    }
  }
  while (++index2 < length) {
    data6 = matchData[index2];
    var key2 = data6[0], objValue = object4[key2], srcValue = data6[1];
    if (noCustomizer && data6[2]) {
      if (objValue === void 0 && !(key2 in object4)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key2, object4, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject$4(value);
}
function getMatchData(object4) {
  var result = keys(object4), length = result.length;
  while (length--) {
    var key2 = result[length], value = object4[key2];
    result[length] = [key2, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key2, srcValue) {
  return function(object4) {
    if (object4 == null) {
      return false;
    }
    return object4[key2] === srcValue && (srcValue !== void 0 || key2 in Object(object4));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object4) {
    return object4 === source || baseIsMatch(object4, source, matchData);
  };
}
function get$1(object4, path, defaultValue) {
  var result = object4 == null ? void 0 : baseGet(object4, path);
  return result === void 0 ? defaultValue : result;
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object4) {
    var objValue = get$1(object4, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object4, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function basePropertyDeep(path) {
  return function(object4) {
    return baseGet(object4, path);
  };
}
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == "object") {
    return isArray$3(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate);
      collection = keys(collection);
      predicate = function(key2) {
        return iteratee(iterable[key2], key2, iterable);
      };
    }
    var index2 = findIndexFunc(collection, predicate, fromIndex);
    return index2 > -1 ? iterable[iteratee ? collection[index2] : index2] : void 0;
  };
}
var nativeMax = Math.max;
function findIndex(array4, predicate, fromIndex) {
  var length = array4 == null ? 0 : array4.length;
  if (!length) {
    return -1;
  }
  var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index2 < 0) {
    index2 = nativeMax(length + index2, 0);
  }
  return baseFindIndex(array4, baseIteratee(predicate), index2);
}
var find$1 = createFind(findIndex);
var find$2 = find$1;
var FormContextKey = Symbol("formContextKey");
var useProvideForm = function useProvideForm2(state) {
  provide(FormContextKey, state);
};
var useInjectForm = function useInjectForm2() {
  return inject(FormContextKey, {
    name: computed(function() {
      return void 0;
    }),
    labelAlign: computed(function() {
      return "right";
    }),
    vertical: computed(function() {
      return false;
    }),
    addField: function addField(_eventKey, _field) {
    },
    removeField: function removeField(_eventKey) {
    },
    model: computed(function() {
      return void 0;
    }),
    rules: computed(function() {
      return void 0;
    }),
    colon: computed(function() {
      return void 0;
    }),
    labelWrap: computed(function() {
      return void 0;
    }),
    labelCol: computed(function() {
      return void 0;
    }),
    requiredMark: computed(function() {
      return false;
    }),
    validateTrigger: computed(function() {
      return void 0;
    }),
    onValidate: function onValidate() {
    },
    validateMessages: computed(function() {
      return defaultValidateMessages;
    })
  });
};
var FormItemPrefixContextKey = Symbol("formItemPrefixContextKey");
var useProvideFormItemPrefix = function useProvideFormItemPrefix2(state) {
  provide(FormItemPrefixContextKey, state);
};
var useInjectFormItemPrefix = function useInjectFormItemPrefix2() {
  return inject(FormItemPrefixContextKey, {
    prefixCls: computed(function() {
      return "";
    })
  });
};
var FormItemLabel = function FormItemLabel2(props2, _ref) {
  var _classNames2;
  var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs;
  var _a2, _b, _c, _d, _e;
  var _Object$assign = _extends$2(_extends$2({}, props2), attrs), prefixCls2 = _Object$assign.prefixCls, htmlFor = _Object$assign.htmlFor, labelCol = _Object$assign.labelCol, labelAlign = _Object$assign.labelAlign, colon = _Object$assign.colon, required4 = _Object$assign.required, requiredMark = _Object$assign.requiredMark;
  var _useLocaleReceiver = useLocaleReceiver("Form"), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), formLocale = _useLocaleReceiver2[0];
  var label = (_a2 = props2.label) !== null && _a2 !== void 0 ? _a2 : (_b = slots.label) === null || _b === void 0 ? void 0 : _b.call(slots);
  if (!label)
    return null;
  var _useInjectForm = useInjectForm(), vertical = _useInjectForm.vertical, contextLabelAlign = _useInjectForm.labelAlign, contextLabelCol = _useInjectForm.labelCol, labelWrap = _useInjectForm.labelWrap, contextColon = _useInjectForm.colon;
  var mergedLabelCol = labelCol || (contextLabelCol === null || contextLabelCol === void 0 ? void 0 : contextLabelCol.value) || {};
  var mergedLabelAlign = labelAlign || (contextLabelAlign === null || contextLabelAlign === void 0 ? void 0 : contextLabelAlign.value);
  var labelClsBasic = "".concat(prefixCls2, "-item-label");
  var labelColClassName = classNames(labelClsBasic, mergedLabelAlign === "left" && "".concat(labelClsBasic, "-left"), mergedLabelCol.class, _defineProperty$R({}, "".concat(labelClsBasic, "-wrap"), !!labelWrap.value));
  var labelChildren = label;
  var computedColon = colon === true || (contextColon === null || contextColon === void 0 ? void 0 : contextColon.value) !== false && colon !== false;
  var haveColon = computedColon && !vertical.value;
  if (haveColon && typeof label === "string" && label.trim() !== "") {
    labelChildren = label.replace(/[:|：]\s*$/, "");
  }
  labelChildren = createVNode(Fragment, null, [labelChildren, (_c = slots.tooltip) === null || _c === void 0 ? void 0 : _c.call(slots, {
    class: "".concat(prefixCls2, "-item-tooltip")
  })]);
  if (requiredMark === "optional" && !required4) {
    labelChildren = createVNode(Fragment, null, [labelChildren, createVNode("span", {
      "class": "".concat(prefixCls2, "-item-optional")
    }, [((_d = formLocale.value) === null || _d === void 0 ? void 0 : _d.optional) || ((_e = defaultLocale.Form) === null || _e === void 0 ? void 0 : _e.optional)])]);
  }
  var labelClassName = classNames((_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2, "-item-required"), required4), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-item-required-mark-optional"), requiredMark === "optional"), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-item-no-colon"), !computedColon), _classNames2));
  return createVNode(Col$1, _objectSpread2$2(_objectSpread2$2({}, mergedLabelCol), {}, {
    "class": labelColClassName
  }), {
    default: function _default7() {
      return [createVNode("label", {
        "for": htmlFor,
        "class": labelClassName,
        "title": typeof label === "string" ? label : "",
        "onClick": function onClick2(e2) {
          return emit("click", e2);
        }
      }, [labelChildren])];
    }
  });
};
FormItemLabel.displayName = "FormItemLabel";
FormItemLabel.inheritAttrs = false;
var FormItemLabel$1 = FormItemLabel;
var ErrorList = defineComponent({
  name: "ErrorList",
  props: ["errors", "help", "onDomErrorVisibleChange", "helpStatus", "warnings"],
  setup: function setup76(props2) {
    var _useConfigInject = useConfigInject("", props2), rootPrefixCls = _useConfigInject.prefixCls;
    var _useInjectFormItemPre = useInjectFormItemPrefix(), prefixCls2 = _useInjectFormItemPre.prefixCls, status = _useInjectFormItemPre.status;
    var baseClassName = computed(function() {
      return "".concat(prefixCls2.value, "-item-explain");
    });
    var visible = computed(function() {
      return !!(props2.errors && props2.errors.length);
    });
    var innerStatus = ref(status.value);
    watch([visible, status], function() {
      if (visible.value) {
        innerStatus.value = status.value;
      }
    });
    return function() {
      var _a2, _b;
      var colMItem = collapseMotion$1("".concat(rootPrefixCls.value, "-show-help-item"));
      var transitionGroupProps = getTransitionGroupProps("".concat(rootPrefixCls.value, "-show-help-item"), colMItem);
      transitionGroupProps.class = baseClassName.value;
      return ((_a2 = props2.errors) === null || _a2 === void 0 ? void 0 : _a2.length) ? createVNode(TransitionGroup, _objectSpread2$2(_objectSpread2$2({}, transitionGroupProps), {}, {
        "tag": "div"
      }), {
        default: function _default7() {
          return [(_b = props2.errors) === null || _b === void 0 ? void 0 : _b.map(function(error, index2) {
            return createVNode("div", {
              "key": index2,
              "role": "alert",
              "class": innerStatus.value ? "".concat(baseClassName.value, "-").concat(innerStatus.value) : ""
            }, [error]);
          })];
        }
      }) : null;
    };
  }
});
var iconMap = {
  success: CheckCircleFilled$1,
  warning: ExclamationCircleFilled$1,
  error: CloseCircleFilled$1,
  validating: LoadingOutlined$1
};
var FormItemInput = defineComponent({
  slots: ["help", "extra", "errors"],
  inheritAttrs: false,
  props: ["prefixCls", "errors", "hasFeedback", "onDomErrorVisibleChange", "wrapperCol", "help", "extra", "status"],
  setup: function setup77(props2, _ref) {
    var slots = _ref.slots;
    var formContext = useInjectForm();
    var contextWrapperCol = formContext.wrapperCol;
    var subFormContext = _extends$2({}, formContext);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    useProvideForm(subFormContext);
    useProvideFormItemPrefix({
      prefixCls: computed(function() {
        return props2.prefixCls;
      }),
      status: computed(function() {
        return props2.status;
      })
    });
    return function() {
      var _a2, _b, _c;
      var prefixCls2 = props2.prefixCls, wrapperCol = props2.wrapperCol, _props$help = props2.help, help = _props$help === void 0 ? (_a2 = slots.help) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$help, _props$errors = props2.errors, errors = _props$errors === void 0 ? (_b = slots.errors) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$errors, hasFeedback = props2.hasFeedback, status = props2.status, _props$extra = props2.extra, extra = _props$extra === void 0 ? (_c = slots.extra) === null || _c === void 0 ? void 0 : _c.call(slots) : _props$extra;
      var baseClassName = "".concat(prefixCls2, "-item");
      var mergedWrapperCol = wrapperCol || (contextWrapperCol === null || contextWrapperCol === void 0 ? void 0 : contextWrapperCol.value) || {};
      var className = classNames("".concat(baseClassName, "-control"), mergedWrapperCol.class);
      var IconNode = status && iconMap[status];
      return createVNode(Col$1, _objectSpread2$2(_objectSpread2$2({}, mergedWrapperCol), {}, {
        "class": className
      }), {
        default: function _default7() {
          var _a3;
          return createVNode(Fragment, null, [createVNode("div", {
            "class": "".concat(baseClassName, "-control-input")
          }, [createVNode("div", {
            "class": "".concat(baseClassName, "-control-input-content")
          }, [(_a3 = slots.default) === null || _a3 === void 0 ? void 0 : _a3.call(slots)]), hasFeedback && IconNode ? createVNode("span", {
            "class": "".concat(baseClassName, "-children-icon")
          }, [createVNode(IconNode, null, null)]) : null]), createVNode(ErrorList, {
            "errors": errors,
            "help": help,
            "class": "".concat(baseClassName, "-explain-connected")
          }, null), extra ? createVNode("div", {
            "class": "".concat(baseClassName, "-extra")
          }, [extra]) : null]);
        }
      });
    };
  }
});
var FormItemInput$1 = FormItemInput;
function useDebounce(value) {
  var cacheValue = shallowRef(value.value.slice());
  var timeout = null;
  watchEffect(function() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      cacheValue.value = value.value;
    }, value.value.length ? 0 : 10);
  });
  return cacheValue;
}
tuple$1("success", "warning", "error", "validating", "");
function getPropByPath$1(obj, namePathList, strict) {
  var tempObj = obj;
  var keyArr = namePathList;
  var i2 = 0;
  try {
    for (var len = keyArr.length; i2 < len - 1; ++i2) {
      if (!tempObj && !strict)
        break;
      var key2 = keyArr[i2];
      if (key2 in tempObj) {
        tempObj = tempObj[key2];
      } else {
        if (strict) {
          throw Error("please transfer a valid name path to form item!");
        }
        break;
      }
    }
    if (strict && !tempObj) {
      throw Error("please transfer a valid name path to form item!");
    }
  } catch (error) {
    console.error("please transfer a valid name path to form item!");
  }
  return {
    o: tempObj,
    k: keyArr[i2],
    v: tempObj ? tempObj[keyArr[i2]] : void 0
  };
}
var formItemProps = function formItemProps2() {
  return {
    htmlFor: String,
    prefixCls: String,
    label: PropTypes$1.any,
    help: PropTypes$1.any,
    extra: PropTypes$1.any,
    labelCol: {
      type: Object
    },
    wrapperCol: {
      type: Object
    },
    hasFeedback: {
      type: Boolean,
      default: false
    },
    colon: {
      type: Boolean,
      default: void 0
    },
    labelAlign: PropTypes$1.oneOf(tuple$1("left", "right")),
    prop: {
      type: [String, Number, Array]
    },
    name: {
      type: [String, Number, Array]
    },
    rules: [Array, Object],
    autoLink: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: void 0
    },
    validateFirst: {
      type: Boolean,
      default: void 0
    },
    validateStatus: PropTypes$1.oneOf(tuple$1("", "success", "warning", "error", "validating")),
    validateTrigger: {
      type: [String, Array]
    },
    messageVariables: {
      type: Object
    },
    hidden: Boolean,
    noStyle: Boolean
  };
};
var indexGuid$1 = 0;
var defaultItemNamePrefixCls = "form_item";
var FormItem = defineComponent({
  name: "AFormItem",
  inheritAttrs: false,
  __ANT_NEW_FORM_ITEM: true,
  props: formItemProps(),
  slots: ["help", "label", "extra"],
  setup: function setup78(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    warning$3(props2.prop === void 0);
    var eventKey = "form-item-".concat(++indexGuid$1);
    var _useConfigInject = useConfigInject("form", props2), prefixCls2 = _useConfigInject.prefixCls;
    var formContext = useInjectForm();
    var fieldName = computed(function() {
      return props2.name || props2.prop;
    });
    var errors = ref([]);
    var validateDisabled = ref(false);
    var inputRef = ref();
    var namePath = computed(function() {
      var val = fieldName.value;
      return getNamePath(val);
    });
    var fieldId = computed(function() {
      if (!namePath.value.length) {
        return void 0;
      } else {
        var formName = formContext.name.value;
        var mergedId = namePath.value.join("_");
        return formName ? "".concat(formName, "_").concat(mergedId) : "".concat(defaultItemNamePrefixCls, "_").concat(mergedId);
      }
    });
    var getNewFieldValue = function getNewFieldValue2() {
      var model = formContext.model.value;
      if (!model || !fieldName.value) {
        return;
      } else {
        return getPropByPath$1(model, namePath.value, true).v;
      }
    };
    var fieldValue = computed(function() {
      return getNewFieldValue();
    });
    var initialValue = ref(cloneDeep$1(fieldValue.value));
    var mergedValidateTrigger = computed(function() {
      var validateTrigger = props2.validateTrigger !== void 0 ? props2.validateTrigger : formContext.validateTrigger.value;
      validateTrigger = validateTrigger === void 0 ? "change" : validateTrigger;
      return toArray$5(validateTrigger);
    });
    var rulesRef = computed(function() {
      var formRules = formContext.rules.value;
      var selfRules = props2.rules;
      var requiredRule = props2.required !== void 0 ? {
        required: !!props2.required,
        trigger: mergedValidateTrigger.value
      } : [];
      var prop = getPropByPath$1(formRules, namePath.value);
      formRules = formRules ? prop.o[prop.k] || prop.v : [];
      var rules2 = [].concat(selfRules || formRules || []);
      if (find$2(rules2, function(rule) {
        return rule.required;
      })) {
        return rules2;
      } else {
        return rules2.concat(requiredRule);
      }
    });
    var isRequired2 = computed(function() {
      var rules2 = rulesRef.value;
      var isRequired3 = false;
      if (rules2 && rules2.length) {
        rules2.every(function(rule) {
          if (rule.required) {
            isRequired3 = true;
            return false;
          }
          return true;
        });
      }
      return isRequired3 || props2.required;
    });
    var validateState = ref();
    watchEffect(function() {
      validateState.value = props2.validateStatus;
    });
    var messageVariables = computed(function() {
      var variables = {};
      if (typeof props2.label === "string") {
        variables.label = props2.label;
      } else if (props2.name) {
        variables.label = String(name);
      }
      if (props2.messageVariables) {
        variables = _extends$2(_extends$2({}, variables), props2.messageVariables);
      }
      return variables;
    });
    var validateRules$1 = function validateRules$12(options) {
      if (namePath.value.length === 0) {
        return;
      }
      var _props$validateFirst = props2.validateFirst, validateFirst = _props$validateFirst === void 0 ? false : _props$validateFirst;
      var _ref2 = options || {}, triggerName = _ref2.triggerName;
      var filteredRules = rulesRef.value;
      if (triggerName) {
        filteredRules = filteredRules.filter(function(rule) {
          var trigger2 = rule.trigger;
          if (!trigger2 && !mergedValidateTrigger.value.length) {
            return true;
          }
          var triggerList = toArray$5(trigger2 || mergedValidateTrigger.value);
          return triggerList.includes(triggerName);
        });
      }
      if (!filteredRules.length) {
        return Promise.resolve();
      }
      var promise = validateRules(namePath.value, fieldValue.value, filteredRules, _extends$2({
        validateMessages: formContext.validateMessages.value
      }, options), validateFirst, messageVariables.value);
      validateState.value = "validating";
      errors.value = [];
      promise.catch(function(e2) {
        return e2;
      }).then(function() {
        var results = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (validateState.value === "validating") {
          var res = results.filter(function(result) {
            return result && result.errors.length;
          });
          validateState.value = res.length ? "error" : "success";
          errors.value = res.map(function(r2) {
            return r2.errors;
          });
          formContext.onValidate(fieldName.value, !errors.value.length, errors.value.length ? toRaw(errors.value[0]) : null);
        }
      });
      return promise;
    };
    var _onFieldBlur = function onFieldBlur2() {
      validateRules$1({
        triggerName: "blur"
      });
    };
    var _onFieldChange = function onFieldChange2() {
      if (validateDisabled.value) {
        validateDisabled.value = false;
        return;
      }
      validateRules$1({
        triggerName: "change"
      });
    };
    var clearValidate2 = function clearValidate3() {
      validateState.value = props2.validateStatus;
      validateDisabled.value = false;
      errors.value = [];
    };
    var resetField = function resetField2() {
      validateState.value = props2.validateStatus;
      validateDisabled.value = true;
      errors.value = [];
      var model = formContext.model.value || {};
      var value = fieldValue.value;
      var prop = getPropByPath$1(model, namePath.value, true);
      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(initialValue.value);
      } else {
        prop.o[prop.k] = initialValue.value;
      }
      nextTick(function() {
        validateDisabled.value = false;
      });
    };
    var htmlFor = computed(function() {
      return props2.htmlFor === void 0 ? fieldId.value : props2.htmlFor;
    });
    var onLabelClick = function onLabelClick2() {
      var id = htmlFor.value;
      if (!id || !inputRef.value) {
        return;
      }
      var control = inputRef.value.$el.querySelector('[id="'.concat(id, '"]'));
      if (control && control.focus) {
        control.focus();
      }
    };
    expose({
      onFieldBlur: _onFieldBlur,
      onFieldChange: _onFieldChange,
      clearValidate: clearValidate2,
      resetField
    });
    useProvideFormItemContext({
      id: fieldId,
      onFieldBlur: function onFieldBlur2() {
        if (props2.autoLink) {
          _onFieldBlur();
        }
      },
      onFieldChange: function onFieldChange2() {
        if (props2.autoLink) {
          _onFieldChange();
        }
      },
      clearValidate: clearValidate2
    }, computed(function() {
      return !!(props2.autoLink && formContext.model.value && fieldName.value);
    }));
    var registered = false;
    watch(fieldName, function(val) {
      if (val) {
        if (!registered) {
          registered = true;
          formContext.addField(eventKey, {
            fieldValue,
            fieldId,
            fieldName,
            resetField,
            clearValidate: clearValidate2,
            namePath,
            validateRules: validateRules$1,
            rules: rulesRef
          });
        }
      } else {
        registered = false;
        formContext.removeField(eventKey);
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(function() {
      formContext.removeField(eventKey);
    });
    var debounceErrors = useDebounce(errors);
    var mergedValidateStatus = computed(function() {
      if (props2.validateStatus !== void 0) {
        return props2.validateStatus;
      } else if (debounceErrors.value.length) {
        return "error";
      }
      return validateState.value;
    });
    var itemClassName = computed(function() {
      var _ref3;
      return _ref3 = {}, _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item"), true), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-has-feedback"), mergedValidateStatus.value && props2.hasFeedback), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-has-success"), mergedValidateStatus.value === "success"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-has-warning"), mergedValidateStatus.value === "warning"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-has-error"), mergedValidateStatus.value === "error"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-is-validating"), mergedValidateStatus.value === "validating"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-item-hidden"), props2.hidden), _ref3;
    });
    return function() {
      var _a2, _b;
      if (props2.noStyle)
        return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      var help = (_b = props2.help) !== null && _b !== void 0 ? _b : slots.help ? filterEmpty(slots.help()) : null;
      return createVNode(Row$3, _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "class": [itemClassName.value, help !== void 0 && help !== null || debounceErrors.value.length ? "".concat(prefixCls2.value, "-item-with-help") : "", attrs.class],
        "key": "row"
      }), {
        default: function _default7() {
          var _a3, _b2, _c, _d;
          return createVNode(Fragment, null, [createVNode(FormItemLabel$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
            "htmlFor": htmlFor.value,
            "required": isRequired2.value,
            "requiredMark": formContext.requiredMark.value,
            "prefixCls": prefixCls2.value,
            "onClick": onLabelClick,
            "label": (_a3 = props2.label) !== null && _a3 !== void 0 ? _a3 : (_b2 = slots.label) === null || _b2 === void 0 ? void 0 : _b2.call(slots)
          }), null), createVNode(FormItemInput$1, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
            "errors": help !== void 0 && help !== null ? toArray$5(help) : debounceErrors.value,
            "prefixCls": prefixCls2.value,
            "status": mergedValidateStatus.value,
            "ref": inputRef,
            "help": help,
            "extra": (_c = props2.extra) !== null && _c !== void 0 ? _c : (_d = slots.extra) === null || _d === void 0 ? void 0 : _d.call(slots)
          }), {
            default: slots.default
          })]);
        }
      });
    };
  }
});
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];
  if (!promiseList.length) {
    return Promise.resolve([]);
  }
  return new Promise(function(resolve, reject) {
    promiseList.forEach(function(promise, index2) {
      promise.catch(function(e2) {
        hasError = true;
        return e2;
      }).then(function(result) {
        count -= 1;
        results[index2] = result;
        if (count > 0) {
          return;
        }
        if (hasError) {
          reject(results);
        }
        resolve(results);
      });
    });
  });
}
function t$1(t2) {
  return typeof t2 == "object" && t2 != null && t2.nodeType === 1;
}
function e(t2, e2) {
  return (!e2 || t2 !== "hidden") && t2 !== "visible" && t2 !== "clip";
}
function n$1(t2, n2) {
  if (t2.clientHeight < t2.scrollHeight || t2.clientWidth < t2.scrollWidth) {
    var r2 = getComputedStyle(t2, null);
    return e(r2.overflowY, n2) || e(r2.overflowX, n2) || function(t3) {
      var e2 = function(t4) {
        if (!t4.ownerDocument || !t4.ownerDocument.defaultView)
          return null;
        try {
          return t4.ownerDocument.defaultView.frameElement;
        } catch (t5) {
          return null;
        }
      }(t3);
      return !!e2 && (e2.clientHeight < t3.scrollHeight || e2.clientWidth < t3.scrollWidth);
    }(t2);
  }
  return false;
}
function r$1(t2, e2, n2, r2, i2, o2, l2, d2) {
  return o2 < t2 && l2 > e2 || o2 > t2 && l2 < e2 ? 0 : o2 <= t2 && d2 <= n2 || l2 >= e2 && d2 >= n2 ? o2 - t2 - r2 : l2 > e2 && d2 < n2 || o2 < t2 && d2 > n2 ? l2 - e2 + i2 : 0;
}
function compute(e2, i2) {
  var o2 = window, l2 = i2.scrollMode, d2 = i2.block, u2 = i2.inline, h2 = i2.boundary, a2 = i2.skipOverflowHiddenElements, c2 = typeof h2 == "function" ? h2 : function(t2) {
    return t2 !== h2;
  };
  if (!t$1(e2))
    throw new TypeError("Invalid target");
  for (var f2 = document.scrollingElement || document.documentElement, s2 = [], p2 = e2; t$1(p2) && c2(p2); ) {
    if ((p2 = p2.parentElement) === f2) {
      s2.push(p2);
      break;
    }
    p2 != null && p2 === document.body && n$1(p2) && !n$1(document.documentElement) || p2 != null && n$1(p2, a2) && s2.push(p2);
  }
  for (var m2 = o2.visualViewport ? o2.visualViewport.width : innerWidth, g2 = o2.visualViewport ? o2.visualViewport.height : innerHeight, w2 = window.scrollX || pageXOffset, v2 = window.scrollY || pageYOffset, W = e2.getBoundingClientRect(), b2 = W.height, H = W.width, y2 = W.top, E2 = W.right, M2 = W.bottom, V2 = W.left, x2 = d2 === "start" || d2 === "nearest" ? y2 : d2 === "end" ? M2 : y2 + b2 / 2, I2 = u2 === "center" ? V2 + H / 2 : u2 === "end" ? E2 : V2, C = [], T2 = 0; T2 < s2.length; T2++) {
    var k2 = s2[T2], B2 = k2.getBoundingClientRect(), D2 = B2.height, O2 = B2.width, R2 = B2.top, X = B2.right, Y2 = B2.bottom, L2 = B2.left;
    if (l2 === "if-needed" && y2 >= 0 && V2 >= 0 && M2 <= g2 && E2 <= m2 && y2 >= R2 && M2 <= Y2 && V2 >= L2 && E2 <= X)
      return C;
    var S2 = getComputedStyle(k2), j2 = parseInt(S2.borderLeftWidth, 10), q2 = parseInt(S2.borderTopWidth, 10), z2 = parseInt(S2.borderRightWidth, 10), A2 = parseInt(S2.borderBottomWidth, 10), F2 = 0, G = 0, J2 = "offsetWidth" in k2 ? k2.offsetWidth - k2.clientWidth - j2 - z2 : 0, K = "offsetHeight" in k2 ? k2.offsetHeight - k2.clientHeight - q2 - A2 : 0;
    if (f2 === k2)
      F2 = d2 === "start" ? x2 : d2 === "end" ? x2 - g2 : d2 === "nearest" ? r$1(v2, v2 + g2, g2, q2, A2, v2 + x2, v2 + x2 + b2, b2) : x2 - g2 / 2, G = u2 === "start" ? I2 : u2 === "center" ? I2 - m2 / 2 : u2 === "end" ? I2 - m2 : r$1(w2, w2 + m2, m2, j2, z2, w2 + I2, w2 + I2 + H, H), F2 = Math.max(0, F2 + v2), G = Math.max(0, G + w2);
    else {
      F2 = d2 === "start" ? x2 - R2 - q2 : d2 === "end" ? x2 - Y2 + A2 + K : d2 === "nearest" ? r$1(R2, Y2, D2, q2, A2 + K, x2, x2 + b2, b2) : x2 - (R2 + D2 / 2) + K / 2, G = u2 === "start" ? I2 - L2 - j2 : u2 === "center" ? I2 - (L2 + O2 / 2) + J2 / 2 : u2 === "end" ? I2 - X + z2 + J2 : r$1(L2, X, O2, j2, z2 + J2, I2, I2 + H, H);
      var N2 = k2.scrollLeft, P2 = k2.scrollTop;
      x2 += P2 - (F2 = Math.max(0, Math.min(P2 + F2, k2.scrollHeight - D2 + K))), I2 += N2 - (G = Math.max(0, Math.min(N2 + G, k2.scrollWidth - O2 + J2)));
    }
    C.push({ el: k2, top: F2, left: G });
  }
  return C;
}
function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}
function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = "auto";
  }
  var canSmoothScroll = "scrollBehavior" in document.body.style;
  actions.forEach(function(_ref) {
    var el = _ref.el, top = _ref.top, left = _ref.left;
    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top,
        left,
        behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}
function getOptions(options) {
  if (options === false) {
    return {
      block: "end",
      inline: "nearest"
    };
  }
  if (isOptionsObject(options)) {
    return options;
  }
  return {
    block: "start",
    inline: "nearest"
  };
}
function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
  if (isOptionsObject(options) && typeof options.behavior === "function") {
    return options.behavior(isTargetAttached ? compute(target, options) : []);
  }
  if (!isTargetAttached) {
    return;
  }
  var computeOptions = getOptions(options);
  return defaultBehavior(compute(target, computeOptions), computeOptions.behavior);
}
var nativeMin = Math.min;
function baseIntersection(arrays, iteratee, comparator) {
  var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
  while (othIndex--) {
    var array4 = arrays[othIndex];
    if (othIndex && iteratee) {
      array4 = arrayMap(array4, baseUnary(iteratee));
    }
    maxLength = nativeMin(array4.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array4.length >= 120) ? new SetCache(othIndex && array4) : void 0;
  }
  array4 = arrays[0];
  var index2 = -1, seen = caches[0];
  outer:
    while (++index2 < length && result.length < maxLength) {
      var value = array4[index2], computed2 = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (!(seen ? cacheHas(seen, computed2) : includes2(result, computed2, comparator))) {
        othIndex = othLength;
        while (--othIndex) {
          var cache2 = caches[othIndex];
          if (!(cache2 ? cacheHas(cache2, computed2) : includes2(arrays[othIndex], computed2, comparator))) {
            continue outer;
          }
        }
        if (seen) {
          seen.push(computed2);
        }
        result.push(value);
      }
    }
  return result;
}
function baseRest(func, start2) {
  return setToString$1(overRest(func, start2, identity$1), func + "");
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
var intersection$1 = intersection;
function last(array4) {
  var length = array4 == null ? 0 : array4.length;
  return length ? array4[length - 1] : void 0;
}
function parent(object4, path) {
  return path.length < 2 ? object4 : baseGet(object4, baseSlice(path, 0, -1));
}
function baseUnset(object4, path) {
  path = castPath(path, object4);
  object4 = parent(object4, path);
  return object4 == null || delete object4[toKey(last(path))];
}
function customOmitClone(value) {
  return isPlainObject$2(value) ? void 0 : value;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
var omit$1 = flatRest(function(object4, paths) {
  var result = {};
  if (object4 == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object4);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object4, getAllKeysIn(object4), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});
var omit$2 = omit$1;
function isRequired(rules2) {
  var isRequired2 = false;
  if (rules2 && rules2.length) {
    rules2.every(function(rule) {
      if (rule.required) {
        isRequired2 = true;
        return false;
      }
      return true;
    });
  }
  return isRequired2;
}
function toArray$4(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, ".$1");
  path = path.replace(/^\./, "");
  var keyArr = path.split(".");
  var i2 = 0;
  for (var len = keyArr.length; i2 < len - 1; ++i2) {
    if (!tempObj && !strict)
      break;
    var key2 = keyArr[i2];
    if (key2 in tempObj) {
      tempObj = tempObj[key2];
    } else {
      if (strict) {
        throw new Error("please transfer a valid name path to validate!");
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i2],
    v: tempObj ? tempObj[keyArr[i2]] : null,
    isValid: tempObj && keyArr[i2] in tempObj
  };
}
function useForm$1(modelRef) {
  var rulesRef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ref({});
  var options = arguments.length > 2 ? arguments[2] : void 0;
  var initialModel = cloneDeep$1(unref(modelRef));
  var validateInfos = reactive({});
  var rulesKeys = shallowRef([]);
  var resetFields = function resetFields2(newValues) {
    _extends$2(unref(modelRef), _extends$2(_extends$2({}, cloneDeep$1(initialModel)), newValues));
    nextTick(function() {
      Object.keys(validateInfos).forEach(function(key2) {
        validateInfos[key2] = {
          autoLink: false,
          required: isRequired(unref(rulesRef)[key2])
        };
      });
    });
  };
  var filterRules = function filterRules2() {
    var rules2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var trigger2 = arguments.length > 1 ? arguments[1] : void 0;
    if (!trigger2.length) {
      return rules2;
    } else {
      return rules2.filter(function(rule) {
        var triggerList = toArray$4(rule.trigger || "change");
        return intersection$1(triggerList, trigger2).length;
      });
    }
  };
  var lastValidatePromise = null;
  var validateFields = function validateFields2(names2) {
    var option2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var strict = arguments.length > 2 ? arguments[2] : void 0;
    var promiseList = [];
    var values = {};
    var _loop = function _loop2(i3) {
      var name2 = names2[i3];
      var prop = getPropByPath(unref(modelRef), name2, strict);
      if (!prop.isValid)
        return "continue";
      values[name2] = prop.v;
      var rules2 = filterRules(unref(rulesRef)[name2], toArray$4(option2 && option2.trigger));
      if (rules2.length) {
        promiseList.push(validateField(name2, prop.v, rules2, option2 || {}).then(function() {
          return {
            name: name2,
            errors: [],
            warnings: []
          };
        }).catch(function(ruleErrors) {
          var mergedErrors = [];
          var mergedWarnings = [];
          ruleErrors.forEach(function(_ref) {
            var warningOnly = _ref.rule.warningOnly, errors = _ref.errors;
            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, _toConsumableArray(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, _toConsumableArray(errors));
            }
          });
          if (mergedErrors.length) {
            return Promise.reject({
              name: name2,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }
          return {
            name: name2,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    };
    for (var i2 = 0; i2 < names2.length; i2++) {
      var _ret = _loop(i2);
      if (_ret === "continue")
        continue;
    }
    var summaryPromise = allPromiseFinish(promiseList);
    lastValidatePromise = summaryPromise;
    var returnPromise = summaryPromise.then(function() {
      if (lastValidatePromise === summaryPromise) {
        return Promise.resolve(values);
      }
      return Promise.reject([]);
    }).catch(function(results) {
      var errorList = results.filter(function(result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values,
        errorFields: errorList,
        outOfDate: lastValidatePromise !== summaryPromise
      });
    });
    returnPromise.catch(function(e2) {
      return e2;
    });
    return returnPromise;
  };
  var validateField = function validateField2(name2, value, rules2) {
    var option2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var promise = validateRules([name2], value, rules2, _extends$2({
      validateMessages: defaultValidateMessages
    }, option2), !!option2.validateFirst);
    if (!validateInfos[name2]) {
      return promise.catch(function(e2) {
        return e2;
      });
    }
    validateInfos[name2].validateStatus = "validating";
    promise.catch(function(e2) {
      return e2;
    }).then(function() {
      var results = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var _a2;
      if (validateInfos[name2].validateStatus === "validating") {
        var res = results.filter(function(result) {
          return result && result.errors.length;
        });
        validateInfos[name2].validateStatus = res.length ? "error" : "success";
        validateInfos[name2].help = res.length ? res.map(function(r2) {
          return r2.errors;
        }) : "";
        (_a2 = options === null || options === void 0 ? void 0 : options.onValidate) === null || _a2 === void 0 ? void 0 : _a2.call(options, name2, !res.length, res.length ? toRaw(validateInfos[name2].help[0]) : null);
      }
    });
    return promise;
  };
  var validate = function validate2(names2, option2) {
    var keys2 = [];
    var strict = true;
    if (!names2) {
      strict = false;
      keys2 = rulesKeys.value;
    } else if (Array.isArray(names2)) {
      keys2 = names2;
    } else {
      keys2 = [names2];
    }
    var promises = validateFields(keys2, option2 || {}, strict);
    promises.catch(function(e2) {
      return e2;
    });
    return promises;
  };
  var clearValidate2 = function clearValidate3(names2) {
    var keys2 = [];
    if (!names2) {
      keys2 = rulesKeys.value;
    } else if (Array.isArray(names2)) {
      keys2 = names2;
    } else {
      keys2 = [names2];
    }
    keys2.forEach(function(key2) {
      validateInfos[key2] && _extends$2(validateInfos[key2], {
        validateStatus: "",
        help: ""
      });
    });
  };
  var mergeValidateInfo = function mergeValidateInfo2(items) {
    var info = {
      autoLink: false
    };
    var help = [];
    var infos = Array.isArray(items) ? items : [items];
    for (var i2 = 0; i2 < infos.length; i2++) {
      var arg = infos[i2];
      if ((arg === null || arg === void 0 ? void 0 : arg.validateStatus) === "error") {
        info.validateStatus = "error";
        arg.help && help.push(arg.help);
      }
      info.required = info.required || (arg === null || arg === void 0 ? void 0 : arg.required);
    }
    info.help = help;
    return info;
  };
  var oldModel = initialModel;
  var isFirstTime = true;
  var modelFn = function modelFn2(model) {
    var names2 = [];
    rulesKeys.value.forEach(function(key2) {
      var prop = getPropByPath(model, key2, false);
      var oldProp = getPropByPath(oldModel, key2, false);
      var isFirstValidation = isFirstTime && (options === null || options === void 0 ? void 0 : options.immediate) && prop.isValid;
      if (isFirstValidation || !isEqual$2(prop.v, oldProp.v)) {
        names2.push(key2);
      }
    });
    validate(names2, {
      trigger: "change"
    });
    isFirstTime = false;
    oldModel = cloneDeep$1(toRaw(model));
  };
  var debounceOptions = options === null || options === void 0 ? void 0 : options.debounce;
  var first = true;
  watch(rulesRef, function() {
    rulesKeys.value = rulesRef ? Object.keys(unref(rulesRef)) : [];
    if (!first && options && options.validateOnRuleChange) {
      validate();
    }
    first = false;
  }, {
    deep: true,
    immediate: true
  });
  watch(rulesKeys, function() {
    var newValidateInfos = {};
    rulesKeys.value.forEach(function(key3) {
      newValidateInfos[key3] = _extends$2({}, validateInfos[key3], {
        autoLink: false,
        required: isRequired(unref(rulesRef)[key3])
      });
      delete validateInfos[key3];
    });
    for (var key2 in validateInfos) {
      if (Object.prototype.hasOwnProperty.call(validateInfos, key2)) {
        delete validateInfos[key2];
      }
    }
    _extends$2(validateInfos, newValidateInfos);
  }, {
    immediate: true
  });
  watch(modelRef, debounceOptions && debounceOptions.wait ? debounce$1(modelFn, debounceOptions.wait, omit$2(debounceOptions, ["wait"])) : modelFn, {
    immediate: options && !!options.immediate,
    deep: true
  });
  return {
    modelRef,
    rulesRef,
    initialModel,
    validateInfos,
    resetFields,
    validate,
    validateField,
    mergeValidateInfo,
    clearValidate: clearValidate2
  };
}
var formProps = function formProps2() {
  return {
    layout: PropTypes$1.oneOf(tuple$1("horizontal", "inline", "vertical")),
    labelCol: {
      type: Object
    },
    wrapperCol: {
      type: Object
    },
    colon: {
      type: Boolean,
      default: void 0
    },
    labelAlign: PropTypes$1.oneOf(tuple$1("left", "right")),
    labelWrap: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    requiredMark: {
      type: [String, Boolean],
      default: void 0
    },
    hideRequiredMark: {
      type: Boolean,
      default: void 0
    },
    model: PropTypes$1.object,
    rules: {
      type: Object
    },
    validateMessages: {
      type: Object,
      default: void 0
    },
    validateOnRuleChange: {
      type: Boolean,
      default: void 0
    },
    scrollToFirstError: {
      type: [Boolean, Object]
    },
    onSubmit: Function,
    name: String,
    validateTrigger: {
      type: [String, Array]
    },
    size: {
      type: String
    },
    onValuesChange: {
      type: Function
    },
    onFieldsChange: {
      type: Function
    },
    onFinish: {
      type: Function
    },
    onFinishFailed: {
      type: Function
    },
    onValidate: {
      type: Function
    }
  };
};
function isEqualName(name1, name2) {
  return isEqual$2(toArray$5(name1), toArray$5(name2));
}
var Form = defineComponent({
  name: "AForm",
  inheritAttrs: false,
  props: initDefaultProps$1(formProps(), {
    layout: "horizontal",
    hideRequiredMark: false,
    colon: true
  }),
  Item: FormItem,
  useForm: useForm$1,
  setup: function setup79(props2, _ref) {
    var emit = _ref.emit, slots = _ref.slots, expose = _ref.expose, attrs = _ref.attrs;
    var size = useInjectSize(props2);
    var _useConfigInject = useConfigInject("form", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, contextForm = _useConfigInject.form;
    var requiredMark = computed(function() {
      return props2.requiredMark === "" || props2.requiredMark;
    });
    var mergedRequiredMark = computed(function() {
      var _a2;
      if (requiredMark.value !== void 0) {
        return requiredMark.value;
      }
      if (contextForm && ((_a2 = contextForm.value) === null || _a2 === void 0 ? void 0 : _a2.requiredMark) !== void 0) {
        return contextForm.value.requiredMark;
      }
      if (props2.hideRequiredMark) {
        return false;
      }
      return true;
    });
    var mergedColon = computed(function() {
      var _a2, _b;
      return (_a2 = props2.colon) !== null && _a2 !== void 0 ? _a2 : (_b = contextForm.value) === null || _b === void 0 ? void 0 : _b.colon;
    });
    var validateMessages = computed(function() {
      return _extends$2(_extends$2({}, defaultValidateMessages), props2.validateMessages);
    });
    var formClassName = computed(function() {
      var _classNames;
      return classNames(prefixCls2.value, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-").concat(props2.layout), true), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-hide-required-mark"), mergedRequiredMark.value === false), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-").concat(size.value), size.value), _classNames));
    });
    var lastValidatePromise = ref();
    var fields = {};
    var addField = function addField2(eventKey, field) {
      fields[eventKey] = field;
    };
    var removeField = function removeField2(eventKey) {
      delete fields[eventKey];
    };
    var getFieldsByNameList = function getFieldsByNameList2(nameList) {
      var provideNameList = !!nameList;
      var namePathList = provideNameList ? toArray$5(nameList).map(getNamePath) : [];
      if (!provideNameList) {
        return Object.values(fields);
      } else {
        return Object.values(fields).filter(function(field) {
          return namePathList.findIndex(function(namePath) {
            return isEqualName(namePath, field.fieldName.value);
          }) > -1;
        });
      }
    };
    var resetFields = function resetFields2(name2) {
      if (!props2.model) {
        warning$2(false, "Form", "model is required for resetFields to work.");
        return;
      }
      getFieldsByNameList(name2 ? [name2] : void 0).forEach(function(field) {
        field.resetField();
      });
    };
    var clearValidate2 = function clearValidate3(name2) {
      getFieldsByNameList(name2 ? [name2] : void 0).forEach(function(field) {
        field.clearValidate();
      });
    };
    var handleFinishFailed = function handleFinishFailed2(errorInfo) {
      var scrollToFirstError = props2.scrollToFirstError;
      emit("finishFailed", errorInfo);
      if (scrollToFirstError && errorInfo.errorFields.length) {
        var scrollToFieldOptions = {};
        if (_typeof$2(scrollToFirstError) === "object") {
          scrollToFieldOptions = scrollToFirstError;
        }
        scrollToField(errorInfo.errorFields[0].name, scrollToFieldOptions);
      }
    };
    var validate = function validate2() {
      return validateField.apply(void 0, arguments);
    };
    var scrollToField = function scrollToField2(name2) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var fields2 = getFieldsByNameList(name2 ? [name2] : void 0);
      if (fields2.length) {
        var fieldId = fields2[0].fieldId.value;
        var node = fieldId ? document.getElementById(fieldId) : null;
        if (node) {
          scrollIntoView(node, _extends$2({
            scrollMode: "if-needed",
            block: "nearest"
          }, options));
        }
      }
    };
    var getFieldsValue = function getFieldsValue2() {
      var nameList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (nameList === true) {
        var allNameList = [];
        Object.values(fields).forEach(function(_ref2) {
          var namePath = _ref2.namePath;
          allNameList.push(namePath.value);
        });
        return cloneByNamePathList(props2.model, allNameList);
      } else {
        return cloneByNamePathList(props2.model, nameList);
      }
    };
    var validateFields = function validateFields2(nameList, options) {
      warning$2(!(nameList instanceof Function), "Form", "validateFields/validateField/validate not support callback, please use promise instead");
      if (!props2.model) {
        warning$2(false, "Form", "model is required for validateFields to work.");
        return Promise.reject("Form `model` is required for validateFields to work.");
      }
      var provideNameList = !!nameList;
      var namePathList = provideNameList ? toArray$5(nameList).map(getNamePath) : [];
      var promiseList = [];
      Object.values(fields).forEach(function(field) {
        var _a2;
        if (!provideNameList) {
          namePathList.push(field.namePath.value);
        }
        if (!((_a2 = field.rules) === null || _a2 === void 0 ? void 0 : _a2.value.length)) {
          return;
        }
        var fieldNamePath = field.namePath.value;
        if (!provideNameList || containsNamePath(namePathList, fieldNamePath)) {
          var promise = field.validateRules(_extends$2({
            validateMessages: validateMessages.value
          }, options));
          promiseList.push(promise.then(function() {
            return {
              name: fieldNamePath,
              errors: [],
              warnings: []
            };
          }).catch(function(ruleErrors) {
            var mergedErrors = [];
            var mergedWarnings = [];
            ruleErrors.forEach(function(_ref3) {
              var warningOnly = _ref3.rule.warningOnly, errors = _ref3.errors;
              if (warningOnly) {
                mergedWarnings.push.apply(mergedWarnings, _toConsumableArray(errors));
              } else {
                mergedErrors.push.apply(mergedErrors, _toConsumableArray(errors));
              }
            });
            if (mergedErrors.length) {
              return Promise.reject({
                name: fieldNamePath,
                errors: mergedErrors,
                warnings: mergedWarnings
              });
            }
            return {
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            };
          }));
        }
      });
      var summaryPromise = allPromiseFinish(promiseList);
      lastValidatePromise.value = summaryPromise;
      var returnPromise = summaryPromise.then(function() {
        if (lastValidatePromise.value === summaryPromise) {
          return Promise.resolve(getFieldsValue(namePathList));
        }
        return Promise.reject([]);
      }).catch(function(results) {
        var errorList = results.filter(function(result) {
          return result && result.errors.length;
        });
        return Promise.reject({
          values: getFieldsValue(namePathList),
          errorFields: errorList,
          outOfDate: lastValidatePromise.value !== summaryPromise
        });
      });
      returnPromise.catch(function(e2) {
        return e2;
      });
      return returnPromise;
    };
    var validateField = function validateField2() {
      return validateFields.apply(void 0, arguments);
    };
    var handleSubmit = function handleSubmit2(e2) {
      e2.preventDefault();
      e2.stopPropagation();
      emit("submit", e2);
      if (props2.model) {
        var res = validateFields();
        res.then(function(values) {
          emit("finish", values);
        }).catch(function(errors) {
          handleFinishFailed(errors);
        });
      }
    };
    expose({
      resetFields,
      clearValidate: clearValidate2,
      validateFields,
      getFieldsValue,
      validate,
      scrollToField
    });
    useProvideForm({
      model: computed(function() {
        return props2.model;
      }),
      name: computed(function() {
        return props2.name;
      }),
      labelAlign: computed(function() {
        return props2.labelAlign;
      }),
      labelCol: computed(function() {
        return props2.labelCol;
      }),
      labelWrap: computed(function() {
        return props2.labelWrap;
      }),
      wrapperCol: computed(function() {
        return props2.wrapperCol;
      }),
      vertical: computed(function() {
        return props2.layout === "vertical";
      }),
      colon: mergedColon,
      requiredMark: mergedRequiredMark,
      validateTrigger: computed(function() {
        return props2.validateTrigger;
      }),
      rules: computed(function() {
        return props2.rules;
      }),
      addField,
      removeField,
      onValidate: function onValidate(name2, status, errors) {
        emit("validate", name2, status, errors);
      },
      validateMessages
    });
    watch(function() {
      return props2.rules;
    }, function() {
      if (props2.validateOnRuleChange) {
        validateFields();
      }
    });
    return function() {
      var _a2;
      return createVNode("form", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "onSubmit": handleSubmit,
        "class": [formClassName.value, attrs.class]
      }), [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var Form$1 = Form;
Form$1.useInjectFormItemContext = useInjectFormItemContext;
Form$1.ItemRest = FormItemRest;
Form$1.install = function(app) {
  app.component(Form$1.name, Form$1);
  app.component(Form$1.Item.name, Form$1.Item);
  app.component(FormItemRest.name, FormItemRest);
  return app;
};
var __rest$t = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function highlightKeyword(str, lowerKeyword, prefixCls2) {
  var cells = str.toLowerCase().split(lowerKeyword).reduce(function(list, cur, index2) {
    return index2 === 0 ? [cur] : [].concat(_toConsumableArray(list), [lowerKeyword, cur]);
  }, []);
  var fillCells = [];
  var start2 = 0;
  cells.forEach(function(cell, index2) {
    var end = start2 + cell.length;
    var originWorld = str.slice(start2, end);
    start2 = end;
    if (index2 % 2 === 1) {
      originWorld = createVNode("span", {
        "class": "".concat(prefixCls2, "-menu-item-keyword"),
        "key": "seperator"
      }, [originWorld]);
    }
    fillCells.push(originWorld);
  });
  return fillCells;
}
var defaultSearchRender = function defaultSearchRender2(_ref) {
  var inputValue = _ref.inputValue, path = _ref.path, prefixCls2 = _ref.prefixCls, fieldNames = _ref.fieldNames;
  var optionList = [];
  var lower = inputValue.toLowerCase();
  path.forEach(function(node, index2) {
    if (index2 !== 0) {
      optionList.push(" / ");
    }
    var label = node[fieldNames.label];
    var type4 = _typeof$2(label);
    if (type4 === "string" || type4 === "number") {
      label = highlightKeyword(String(label), lower, prefixCls2);
    }
    optionList.push(label);
  });
  return optionList;
};
function cascaderProps() {
  return _extends$2(_extends$2({}, omit$3(internalCascaderProps(), ["customSlots", "checkable", "options"])), {
    multiple: {
      type: Boolean,
      default: void 0
    },
    size: String,
    bordered: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String
    },
    suffixIcon: PropTypes$1.any,
    options: Array,
    "onUpdate:value": Function
  });
}
var Cascader = defineComponent({
  name: "ACascader",
  inheritAttrs: false,
  props: initDefaultProps$1(cascaderProps(), {
    bordered: true,
    choiceTransitionName: "",
    allowClear: true
  }),
  setup: function setup80(props2, _ref2) {
    var attrs = _ref2.attrs, expose = _ref2.expose, slots = _ref2.slots, emit = _ref2.emit;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("cascader", props2), cascaderPrefixCls = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, getPrefixCls2 = _useConfigInject.getPrefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer, renderEmpty2 = _useConfigInject.renderEmpty, size = _useConfigInject.size;
    var prefixCls2 = computed(function() {
      return getPrefixCls2("select", props2.prefixCls);
    });
    var isRtl = computed(function() {
      return direction2.value === "rtl";
    });
    var mergedShowSearch = computed(function() {
      if (!props2.showSearch) {
        return props2.showSearch;
      }
      var searchConfig = {
        render: defaultSearchRender
      };
      if (_typeof$2(props2.showSearch) === "object") {
        searchConfig = _extends$2(_extends$2({}, searchConfig), props2.showSearch);
      }
      return searchConfig;
    });
    var mergedDropdownClassName = computed(function() {
      return classNames(props2.dropdownClassName || props2.popupClassName, "".concat(cascaderPrefixCls.value, "-dropdown"), _defineProperty$R({}, "".concat(cascaderPrefixCls.value, "-dropdown-rtl"), isRtl.value));
    });
    var selectRef = ref();
    expose({
      focus: function focus2() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    });
    var handleChange2 = function handleChange3() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      emit("update:value", args[0]);
      emit.apply(void 0, ["change"].concat(args));
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      emit.apply(void 0, ["blur"].concat(args));
      formItemContext.onFieldBlur();
    };
    var mergedShowArrow = computed(function() {
      return props2.showArrow !== void 0 ? props2.showArrow : props2.loading || !props2.multiple;
    });
    var placement = computed(function() {
      if (props2.placement !== void 0) {
        return props2.placement;
      }
      return direction2.value === "rtl" ? "bottomRight" : "bottomLeft";
    });
    return function() {
      var _ref3;
      var _a2, _b;
      var _props$notFoundConten = props2.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? (_a2 = slots.notFoundContent) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$notFoundConten, _props$expandIcon = props2.expandIcon, expandIcon = _props$expandIcon === void 0 ? (_b = slots.expandIcon) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$expandIcon, multiple = props2.multiple, bordered = props2.bordered, allowClear = props2.allowClear, choiceTransitionName = props2.choiceTransitionName, transitionName2 = props2.transitionName, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, restProps = __rest$t(props2, ["notFoundContent", "expandIcon", "multiple", "bordered", "allowClear", "choiceTransitionName", "transitionName", "id"]);
      var mergedNotFoundContent = notFoundContent || renderEmpty2.value("Cascader");
      var mergedExpandIcon = expandIcon;
      if (!expandIcon) {
        mergedExpandIcon = isRtl.value ? createVNode(LeftOutlined$1, null, null) : createVNode(RightOutlined$1, null, null);
      }
      var loadingIcon = createVNode("span", {
        "class": "".concat(prefixCls2.value, "-menu-item-loading-icon")
      }, [createVNode(LoadingOutlined$1, {
        "spin": true
      }, null)]);
      var _getIcons = getIcons(_extends$2(_extends$2({}, props2), {
        multiple,
        prefixCls: prefixCls2.value,
        showArrow: mergedShowArrow.value
      }), slots), suffixIcon = _getIcons.suffixIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
      return createVNode(Cascader$2, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, restProps), attrs), {}, {
        "id": id,
        "prefixCls": prefixCls2.value,
        "class": [cascaderPrefixCls.value, (_ref3 = {}, _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-lg"), size.value === "large"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-sm"), size.value === "small"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-rtl"), isRtl.value), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-borderless"), !bordered), _ref3), attrs.class],
        "direction": direction2.value,
        "placement": placement.value,
        "notFoundContent": mergedNotFoundContent,
        "allowClear": allowClear,
        "showSearch": mergedShowSearch.value,
        "expandIcon": mergedExpandIcon,
        "inputIcon": suffixIcon,
        "removeIcon": removeIcon,
        "clearIcon": clearIcon,
        "loadingIcon": loadingIcon,
        "checkable": !!multiple,
        "dropdownClassName": mergedDropdownClassName.value,
        "dropdownPrefixCls": cascaderPrefixCls.value,
        "choiceTransitionName": getTransitionName$2(rootPrefixCls.value, "", choiceTransitionName),
        "transitionName": getTransitionName$2(rootPrefixCls.value, getTransitionDirection(placement.value), transitionName2),
        "getPopupContainer": getPopupContainer.value,
        "customSlots": _extends$2(_extends$2({}, slots), {
          checkable: function checkable() {
            return createVNode("span", {
              "class": "".concat(cascaderPrefixCls.value, "-checkbox-inner")
            }, null);
          }
        }),
        "displayRender": props2.displayRender || slots.displayRender,
        "maxTagPlaceholder": props2.maxTagPlaceholder || slots.maxTagPlaceholder,
        "showArrow": props2.showArrow,
        "onChange": handleChange2,
        "onBlur": handleBlur,
        "ref": selectRef
      }), slots);
    };
  }
});
var Cascader$1 = withInstall$2(Cascader);
var abstractCheckboxGroupProps = function abstractCheckboxGroupProps2() {
  return {
    name: String,
    prefixCls: String,
    options: {
      type: Array,
      default: function _default7() {
        return [];
      }
    },
    disabled: Boolean,
    id: String
  };
};
var checkboxGroupProps = function checkboxGroupProps2() {
  return _extends$2(_extends$2({}, abstractCheckboxGroupProps()), {
    defaultValue: {
      type: Array
    },
    value: {
      type: Array
    },
    onChange: {
      type: Function
    },
    "onUpdate:value": {
      type: Function
    }
  });
};
var abstractCheckboxProps = function abstractCheckboxProps2() {
  return {
    prefixCls: String,
    defaultChecked: {
      type: Boolean,
      default: void 0
    },
    checked: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    isGroup: {
      type: Boolean,
      default: void 0
    },
    value: PropTypes$1.any,
    name: String,
    id: String,
    indeterminate: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "checkbox"
    },
    autofocus: {
      type: Boolean,
      default: void 0
    },
    onChange: Function,
    "onUpdate:checked": Function,
    onClick: Function,
    skipGroup: {
      type: Boolean,
      default: false
    }
  };
};
var checkboxProps = function checkboxProps2() {
  return _extends$2(_extends$2({}, abstractCheckboxProps()), {
    indeterminate: {
      type: Boolean,
      default: false
    }
  });
};
var CheckboxGroupContextKey = Symbol("CheckboxGroupContext");
var __rest$s = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var Checkbox = defineComponent({
  name: "ACheckbox",
  inheritAttrs: false,
  __ANT_CHECKBOX: true,
  props: checkboxProps(),
  setup: function setup81(props2, _ref) {
    var emit = _ref.emit, attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("checkbox", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var checkboxGroup = inject(CheckboxGroupContextKey, void 0);
    var uniId = Symbol("checkboxUniId");
    watchEffect(function() {
      if (!props2.skipGroup && checkboxGroup) {
        checkboxGroup.registerValue(uniId, props2.value);
      }
    });
    onBeforeUnmount(function() {
      if (checkboxGroup) {
        checkboxGroup.cancelValue(uniId);
      }
    });
    onMounted(function() {
      warning$2(props2.checked !== void 0 || checkboxGroup || props2.value === void 0, "Checkbox", "`value` is not validate prop, do you mean `checked`?");
    });
    var handleChange2 = function handleChange3(event) {
      var targetChecked = event.target.checked;
      emit("update:checked", targetChecked);
      emit("change", event);
    };
    var checkboxRef = ref();
    var focus2 = function focus3() {
      var _a2;
      (_a2 = checkboxRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = checkboxRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    return function() {
      var _classNames;
      var _a2;
      var children = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      var indeterminate = props2.indeterminate, skipGroup = props2.skipGroup, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, restProps = __rest$s(props2, ["indeterminate", "skipGroup", "id"]);
      var onMouseenter2 = attrs.onMouseenter, onMouseleave2 = attrs.onMouseleave;
      attrs.onInput;
      var className = attrs.class, style2 = attrs.style, restAttrs = __rest$s(attrs, ["onMouseenter", "onMouseleave", "onInput", "class", "style"]);
      var checkboxProps3 = _extends$2(_extends$2(_extends$2({}, restProps), {
        id,
        prefixCls: prefixCls2.value
      }), restAttrs);
      if (checkboxGroup && !skipGroup) {
        checkboxProps3.onChange = function() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          emit.apply(void 0, ["change"].concat(args));
          checkboxGroup.toggleOption({
            label: children,
            value: props2.value
          });
        };
        checkboxProps3.name = checkboxGroup.name.value;
        checkboxProps3.checked = checkboxGroup.mergedValue.value.indexOf(props2.value) !== -1;
        checkboxProps3.disabled = props2.disabled || checkboxGroup.disabled.value;
        checkboxProps3.indeterminate = indeterminate;
      } else {
        checkboxProps3.onChange = handleChange2;
      }
      var classString = classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper"), true), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper-checked"), checkboxProps3.checked), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrapper-disabled"), checkboxProps3.disabled), _classNames), className);
      var checkboxClass = classNames(_defineProperty$R({}, "".concat(prefixCls2.value, "-indeterminate"), indeterminate));
      return createVNode("label", {
        "class": classString,
        "style": style2,
        "onMouseenter": onMouseenter2,
        "onMouseleave": onMouseleave2
      }, [createVNode(VcCheckbox, _objectSpread2$2(_objectSpread2$2({}, checkboxProps3), {}, {
        "class": checkboxClass,
        "ref": checkboxRef
      }), null), children.length ? createVNode("span", null, [children]) : null]);
    };
  }
});
function _createForOfIteratorHelper(o2, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (!it) {
    if (Array.isArray(o2) || (it = _unsupportedIterableToArray$2(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
      if (it)
        o2 = it;
      var i2 = 0;
      var F2 = function F3() {
      };
      return {
        s: F2,
        n: function n2() {
          if (i2 >= o2.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o2[i2++]
          };
        },
        e: function e2(_e) {
          throw _e;
        },
        f: F2
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s2() {
      it = it.call(o2);
    },
    n: function n2() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e2(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f2() {
      try {
        if (!normalCompletion && it["return"] != null)
          it["return"]();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
var CheckboxGroup = defineComponent({
  name: "ACheckboxGroup",
  props: checkboxGroupProps(),
  setup: function setup82(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("checkbox", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var mergedValue = ref((props2.value === void 0 ? props2.defaultValue : props2.value) || []);
    watch(function() {
      return props2.value;
    }, function() {
      mergedValue.value = props2.value || [];
    });
    var options = computed(function() {
      return props2.options.map(function(option2) {
        if (typeof option2 === "string" || typeof option2 === "number") {
          return {
            label: option2,
            value: option2
          };
        }
        return option2;
      });
    });
    var triggerUpdate = ref(Symbol());
    var registeredValuesMap = ref(new Map());
    var cancelValue = function cancelValue2(id) {
      registeredValuesMap.value.delete(id);
      triggerUpdate.value = Symbol();
    };
    var registerValue = function registerValue2(id, value) {
      registeredValuesMap.value.set(id, value);
      triggerUpdate.value = Symbol();
    };
    var registeredValues = ref(new Map());
    watch(triggerUpdate, function() {
      var valuseMap = new Map();
      var _iterator = _createForOfIteratorHelper(registeredValuesMap.value.values()), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var value = _step.value;
          valuseMap.set(value, true);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      registeredValues.value = valuseMap;
    });
    var toggleOption = function toggleOption2(option2) {
      var optionIndex = mergedValue.value.indexOf(option2.value);
      var value = _toConsumableArray(mergedValue.value);
      if (optionIndex === -1) {
        value.push(option2.value);
      } else {
        value.splice(optionIndex, 1);
      }
      if (props2.value === void 0) {
        mergedValue.value = value;
      }
      var val = value.filter(function(val2) {
        return registeredValues.value.has(val2);
      }).sort(function(a2, b2) {
        var indexA = options.value.findIndex(function(opt) {
          return opt.value === a2;
        });
        var indexB = options.value.findIndex(function(opt) {
          return opt.value === b2;
        });
        return indexA - indexB;
      });
      emit("update:value", val);
      emit("change", val);
      formItemContext.onFieldChange();
    };
    provide(CheckboxGroupContextKey, {
      cancelValue,
      registerValue,
      toggleOption,
      mergedValue,
      name: computed(function() {
        return props2.name;
      }),
      disabled: computed(function() {
        return props2.disabled;
      })
    });
    expose({
      mergedValue
    });
    return function() {
      var _a2;
      var _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id;
      var children = null;
      var groupPrefixCls = "".concat(prefixCls2.value, "-group");
      if (options.value && options.value.length > 0) {
        children = options.value.map(function(option2) {
          var _a3;
          return createVNode(Checkbox, {
            "prefixCls": prefixCls2.value,
            "key": option2.value.toString(),
            "disabled": "disabled" in option2 ? option2.disabled : props2.disabled,
            "indeterminate": option2.indeterminate,
            "value": option2.value,
            "checked": mergedValue.value.indexOf(option2.value) !== -1,
            "onChange": option2.onChange,
            "class": "".concat(groupPrefixCls, "-item")
          }, {
            default: function _default7() {
              return [option2.label === void 0 ? (_a3 = slots.label) === null || _a3 === void 0 ? void 0 : _a3.call(slots, option2) : option2.label];
            }
          });
        });
      }
      return createVNode("div", {
        "class": [groupPrefixCls, _defineProperty$R({}, "".concat(groupPrefixCls, "-rtl"), direction2.value === "rtl")],
        "id": id
      }, [children || ((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots))]);
    };
  }
});
Checkbox.Group = CheckboxGroup;
Checkbox.install = function(app) {
  app.component(Checkbox.name, Checkbox);
  app.component(CheckboxGroup.name, CheckboxGroup);
  return app;
};
var PickerButton = function PickerButton2(props2, _ref) {
  var attrs = _ref.attrs, slots = _ref.slots;
  return createVNode(Button$2, _objectSpread2$2(_objectSpread2$2({
    "size": "small",
    "type": "primary"
  }, props2), attrs), slots);
};
var PickerButton$1 = PickerButton;
var checkableTagProps = function checkableTagProps2() {
  return {
    prefixCls: String,
    checked: {
      type: Boolean,
      default: void 0
    },
    onChange: {
      type: Function
    },
    onClick: {
      type: Function
    },
    "onUpdate:checked": Function
  };
};
var CheckableTag = defineComponent({
  name: "ACheckableTag",
  props: checkableTagProps(),
  setup: function setup83(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var _useConfigInject = useConfigInject("tag", props2), prefixCls2 = _useConfigInject.prefixCls;
    var handleClick = function handleClick2(e2) {
      var checked = props2.checked;
      emit("update:checked", !checked);
      emit("change", !checked);
      emit("click", e2);
    };
    var cls = computed(function() {
      var _classNames;
      return classNames(prefixCls2.value, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-checkable"), true), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-checkable-checked"), props2.checked), _classNames));
    });
    return function() {
      var _a2;
      return createVNode("span", {
        "class": cls.value,
        "onClick": handleClick
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var CheckableTag$1 = CheckableTag;
var PresetColorRegex = new RegExp("^(".concat(PresetColorTypes.join("|"), ")(-inverse)?$"));
var PresetStatusColorRegex = new RegExp("^(".concat(PresetStatusColorTypes.join("|"), ")$"));
var tagProps = function tagProps2() {
  return {
    prefixCls: String,
    color: {
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    closeIcon: PropTypes$1.any,
    visible: {
      type: Boolean,
      default: void 0
    },
    onClose: {
      type: Function
    },
    "onUpdate:visible": Function,
    icon: PropTypes$1.any
  };
};
var Tag = defineComponent({
  name: "ATag",
  props: tagProps(),
  slots: ["closeIcon", "icon"],
  setup: function setup84(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("tag", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var visible = ref(true);
    watchEffect(function() {
      if (props2.visible !== void 0) {
        visible.value = props2.visible;
      }
    });
    var handleCloseClick = function handleCloseClick2(e2) {
      e2.stopPropagation();
      emit("update:visible", false);
      emit("close", e2);
      if (e2.defaultPrevented) {
        return;
      }
      if (props2.visible === void 0) {
        visible.value = false;
      }
    };
    var isPresetColor2 = computed(function() {
      var color = props2.color;
      if (!color) {
        return false;
      }
      return PresetColorRegex.test(color) || PresetStatusColorRegex.test(color);
    });
    var tagClassName = computed(function() {
      var _classNames;
      return classNames(prefixCls2.value, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-").concat(props2.color), isPresetColor2.value), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-has-color"), props2.color && !isPresetColor2.value), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-hidden"), !visible.value), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _classNames));
    });
    return function() {
      var _a2, _b, _c;
      var _props$icon = props2.icon, icon = _props$icon === void 0 ? (_a2 = slots.icon) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$icon, color = props2.color, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_b = slots.closeIcon) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$closeIcon, _props$closable = props2.closable, closable = _props$closable === void 0 ? false : _props$closable;
      var renderCloseIcon = function renderCloseIcon2() {
        if (closable) {
          return closeIcon ? createVNode("div", {
            "class": "".concat(prefixCls2.value, "-close-icon"),
            "onClick": handleCloseClick
          }, [closeIcon]) : createVNode(CloseOutlined$1, {
            "class": "".concat(prefixCls2.value, "-close-icon"),
            "onClick": handleCloseClick
          }, null);
        }
        return null;
      };
      var tagStyle = {
        backgroundColor: color && !isPresetColor2.value ? color : void 0
      };
      var iconNode = icon || null;
      var children = (_c = slots.default) === null || _c === void 0 ? void 0 : _c.call(slots);
      var kids = iconNode ? createVNode(Fragment, null, [iconNode, createVNode("span", null, [children])]) : children;
      var isNeedWave = "onClick" in attrs;
      var tagNode = createVNode("span", {
        "class": tagClassName.value,
        "style": tagStyle
      }, [kids, renderCloseIcon()]);
      return isNeedWave ? createVNode(Wave, null, {
        default: function _default7() {
          return [tagNode];
        }
      }) : tagNode;
    };
  }
});
Tag.CheckableTag = CheckableTag$1;
Tag.install = function(app) {
  app.component(Tag.name, Tag);
  app.component(CheckableTag$1.name, CheckableTag$1);
  return app;
};
var Tag$1 = Tag;
function PickerTag(props2, _ref) {
  var slots = _ref.slots, attrs = _ref.attrs;
  return createVNode(Tag$1, _objectSpread2$2(_objectSpread2$2({
    "color": "blue"
  }, props2), attrs), slots);
}
function getPlaceholder(picker, locale2, customizePlaceholder) {
  if (customizePlaceholder !== void 0) {
    return customizePlaceholder;
  }
  if (picker === "year" && locale2.lang.yearPlaceholder) {
    return locale2.lang.yearPlaceholder;
  }
  if (picker === "quarter" && locale2.lang.quarterPlaceholder) {
    return locale2.lang.quarterPlaceholder;
  }
  if (picker === "month" && locale2.lang.monthPlaceholder) {
    return locale2.lang.monthPlaceholder;
  }
  if (picker === "week" && locale2.lang.weekPlaceholder) {
    return locale2.lang.weekPlaceholder;
  }
  if (picker === "time" && locale2.timePickerLocale.placeholder) {
    return locale2.timePickerLocale.placeholder;
  }
  return locale2.lang.placeholder;
}
function getRangePlaceholder(picker, locale2, customizePlaceholder) {
  if (customizePlaceholder !== void 0) {
    return customizePlaceholder;
  }
  if (picker === "year" && locale2.lang.yearPlaceholder) {
    return locale2.lang.rangeYearPlaceholder;
  }
  if (picker === "month" && locale2.lang.monthPlaceholder) {
    return locale2.lang.rangeMonthPlaceholder;
  }
  if (picker === "week" && locale2.lang.weekPlaceholder) {
    return locale2.lang.rangeWeekPlaceholder;
  }
  if (picker === "time" && locale2.timePickerLocale.placeholder) {
    return locale2.timePickerLocale.rangePlaceholder;
  }
  return locale2.lang.rangePlaceholder;
}
function commonProps() {
  return {
    id: String,
    dropdownClassName: String,
    dropdownAlign: {
      type: Object
    },
    popupStyle: {
      type: Object
    },
    transitionName: String,
    placeholder: String,
    allowClear: {
      type: Boolean,
      default: void 0
    },
    autofocus: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    tabindex: Number,
    open: {
      type: Boolean,
      default: void 0
    },
    defaultOpen: {
      type: Boolean,
      default: void 0
    },
    inputReadOnly: {
      type: Boolean,
      default: void 0
    },
    getPopupContainer: {
      type: Function
    },
    panelRender: {
      type: Function
    },
    onChange: {
      type: Function
    },
    "onUpdate:value": {
      type: Function
    },
    onOk: {
      type: Function
    },
    onOpenChange: {
      type: Function
    },
    "onUpdate:open": {
      type: Function
    },
    onFocus: {
      type: Function
    },
    onBlur: {
      type: Function
    },
    onMousedown: {
      type: Function
    },
    onMouseup: {
      type: Function
    },
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onContextmenu: {
      type: Function
    },
    onKeydown: {
      type: Function
    },
    role: String,
    name: String,
    autocomplete: String,
    direction: {
      type: String
    },
    showToday: {
      type: Boolean,
      default: void 0
    },
    showTime: {
      type: [Boolean, Object],
      default: void 0
    },
    locale: {
      type: Object
    },
    size: {
      type: String
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    dateRender: {
      type: Function
    },
    disabledDate: {
      type: Function
    },
    mode: {
      type: String
    },
    picker: {
      type: String
    },
    valueFormat: String
  };
}
function datePickerProps() {
  return {
    defaultPickerValue: {
      type: [String, Object]
    },
    defaultValue: {
      type: [String, Object]
    },
    value: {
      type: [String, Object]
    },
    disabledTime: {
      type: Function
    },
    format: {
      type: [String, Function, Array]
    },
    renderExtraFooter: {
      type: Function
    },
    showNow: {
      type: Boolean,
      default: void 0
    },
    monthCellRender: {
      type: Function
    },
    monthCellContentRender: {
      type: Function
    }
  };
}
function rangePickerProps() {
  return {
    allowEmpty: {
      type: Array
    },
    dateRender: {
      type: Function
    },
    defaultPickerValue: {
      type: Array
    },
    defaultValue: {
      type: Array
    },
    value: {
      type: Array
    },
    disabledTime: {
      type: Function
    },
    disabled: {
      type: [Boolean, Array]
    },
    format: String,
    renderExtraFooter: {
      type: Function
    },
    separator: {
      type: String
    },
    ranges: {
      type: Object
    },
    placeholder: Array,
    mode: {
      type: Array
    },
    onChange: {
      type: Function
    },
    "onUpdate:value": {
      type: Function
    },
    onCalendarChange: {
      type: Function
    },
    onPanelChange: {
      type: Function
    },
    onOk: {
      type: Function
    }
  };
}
var __rest$r = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function generateSinglePicker(generateConfig2, extraProps) {
  function getPicker(picker, displayName) {
    var comProps = _extends$2(_extends$2(_extends$2({}, commonProps()), datePickerProps()), extraProps);
    return defineComponent({
      name: displayName,
      inheritAttrs: false,
      props: comProps,
      slots: [
        "suffixIcon",
        "prevIcon",
        "nextIcon",
        "superPrevIcon",
        "superNextIcon",
        "dateRender",
        "renderExtraFooter",
        "monthCellRender"
      ],
      setup: function setup162(_props, _ref) {
        var slots = _ref.slots, expose = _ref.expose, attrs = _ref.attrs, emit = _ref.emit;
        var props2 = _props;
        var formItemContext = useInjectFormItemContext();
        devWarning(!(props2.monthCellContentRender || slots.monthCellContentRender), "DatePicker", '`monthCellContentRender` is deprecated. Please use `monthCellRender"` instead.');
        devWarning(!attrs.getCalendarContainer, "DatePicker", '`getCalendarContainer` is deprecated. Please use `getPopupContainer"` instead.');
        var _useConfigInject = useConfigInject("picker", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer, size = _useConfigInject.size, rootPrefixCls = _useConfigInject.rootPrefixCls;
        var pickerRef = ref();
        onMounted(function() {
          nextTick(function() {
          });
        });
        expose({
          focus: function focus2() {
            var _a2;
            (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
          },
          blur: function blur() {
            var _a2;
            (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
          }
        });
        var maybeToString = function maybeToString2(date4) {
          return props2.valueFormat ? generateConfig2.toString(date4, props2.valueFormat) : date4;
        };
        var onChange3 = function onChange4(date4, dateString) {
          var value2 = maybeToString(date4);
          emit("update:value", value2);
          emit("change", value2, dateString);
          formItemContext.onFieldChange();
        };
        var onOpenChange = function onOpenChange2(open2) {
          emit("update:open", open2);
          emit("openChange", open2);
        };
        var onFocus2 = function onFocus3(e2) {
          emit("focus", e2);
        };
        var onBlur2 = function onBlur3(e2) {
          emit("blur", e2);
          formItemContext.onFieldBlur();
        };
        var onPanelChange = function onPanelChange2(date4, mode) {
          var value2 = maybeToString(date4);
          emit("panelChange", value2, mode);
        };
        var onOk = function onOk2(date4) {
          var value2 = maybeToString(date4);
          emit("ok", value2);
        };
        var _useLocaleReceiver = useLocaleReceiver("DatePicker", enUS), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), contextLocale = _useLocaleReceiver2[0];
        var value = computed(function() {
          if (props2.value) {
            return props2.valueFormat ? generateConfig2.toDate(props2.value, props2.valueFormat) : props2.value;
          }
          return props2.value === "" ? void 0 : props2.value;
        });
        var defaultValue = computed(function() {
          if (props2.defaultValue) {
            return props2.valueFormat ? generateConfig2.toDate(props2.defaultValue, props2.valueFormat) : props2.defaultValue;
          }
          return props2.defaultValue === "" ? void 0 : props2.defaultValue;
        });
        var defaultPickerValue = computed(function() {
          if (props2.defaultPickerValue) {
            return props2.valueFormat ? generateConfig2.toDate(props2.defaultPickerValue, props2.valueFormat) : props2.defaultPickerValue;
          }
          return props2.defaultPickerValue === "" ? void 0 : props2.defaultPickerValue;
        });
        return function() {
          var _classNames;
          var _a2, _b, _c, _d, _e, _f;
          var locale2 = _extends$2(_extends$2({}, contextLocale.value), props2.locale);
          var p2 = _extends$2(_extends$2({}, props2), attrs);
          var _p$bordered = p2.bordered, bordered = _p$bordered === void 0 ? true : _p$bordered, placeholder = p2.placeholder, _p$suffixIcon = p2.suffixIcon, suffixIcon = _p$suffixIcon === void 0 ? (_a2 = slots.suffixIcon) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _p$suffixIcon, _p$showToday = p2.showToday, showToday = _p$showToday === void 0 ? true : _p$showToday, transitionName2 = p2.transitionName, _p$allowClear = p2.allowClear, allowClear = _p$allowClear === void 0 ? true : _p$allowClear, _p$dateRender = p2.dateRender, dateRender = _p$dateRender === void 0 ? slots.dateRender : _p$dateRender, _p$renderExtraFooter = p2.renderExtraFooter, renderExtraFooter = _p$renderExtraFooter === void 0 ? slots.renderExtraFooter : _p$renderExtraFooter, _p$monthCellRender = p2.monthCellRender, monthCellRender = _p$monthCellRender === void 0 ? slots.monthCellRender || props2.monthCellContentRender || slots.monthCellContentRender : _p$monthCellRender, _p$clearIcon = p2.clearIcon, clearIcon = _p$clearIcon === void 0 ? (_b = slots.clearIcon) === null || _b === void 0 ? void 0 : _b.call(slots) : _p$clearIcon, _p$id = p2.id, id = _p$id === void 0 ? formItemContext.id.value : _p$id, restProps = __rest$r(p2, ["bordered", "placeholder", "suffixIcon", "showToday", "transitionName", "allowClear", "dateRender", "renderExtraFooter", "monthCellRender", "clearIcon", "id"]);
          var showTime = p2.showTime === "" ? true : p2.showTime;
          var format3 = p2.format;
          var additionalOverrideProps = {};
          if (picker) {
            additionalOverrideProps.picker = picker;
          }
          var mergedPicker = picker || p2.picker || "date";
          additionalOverrideProps = _extends$2(_extends$2(_extends$2({}, additionalOverrideProps), showTime ? getTimeProps(_extends$2({
            format: format3,
            picker: mergedPicker
          }, _typeof$2(showTime) === "object" ? showTime : {})) : {}), mergedPicker === "time" ? getTimeProps(_extends$2(_extends$2({
            format: format3
          }, restProps), {
            picker: mergedPicker
          })) : {});
          var pre = prefixCls2.value;
          return createVNode(Picker$1, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
            "monthCellRender": monthCellRender,
            "dateRender": dateRender,
            "renderExtraFooter": renderExtraFooter,
            "ref": pickerRef,
            "placeholder": getPlaceholder(mergedPicker, locale2, placeholder),
            "suffixIcon": suffixIcon || (mergedPicker === "time" ? createVNode(ClockCircleOutlined$1, null, null) : createVNode(CalendarOutlined$1, null, null)),
            "clearIcon": clearIcon || createVNode(CloseCircleFilled$1, null, null),
            "allowClear": allowClear,
            "transitionName": transitionName2 || "".concat(rootPrefixCls.value, "-slide-up")
          }, restProps), additionalOverrideProps), {}, {
            "id": id,
            "picker": mergedPicker,
            "value": value.value,
            "defaultValue": defaultValue.value,
            "defaultPickerValue": defaultPickerValue.value,
            "showToday": showToday,
            "locale": locale2.lang,
            "class": classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(pre, "-").concat(size.value), size.value), _defineProperty$R(_classNames, "".concat(pre, "-borderless"), !bordered), _classNames), attrs.class),
            "prefixCls": pre,
            "getPopupContainer": attrs.getCalendarContainer || getPopupContainer.value,
            "generateConfig": generateConfig2,
            "prevIcon": ((_c = slots.prevIcon) === null || _c === void 0 ? void 0 : _c.call(slots)) || createVNode("span", {
              "class": "".concat(pre, "-prev-icon")
            }, null),
            "nextIcon": ((_d = slots.nextIcon) === null || _d === void 0 ? void 0 : _d.call(slots)) || createVNode("span", {
              "class": "".concat(pre, "-next-icon")
            }, null),
            "superPrevIcon": ((_e = slots.superPrevIcon) === null || _e === void 0 ? void 0 : _e.call(slots)) || createVNode("span", {
              "class": "".concat(pre, "-super-prev-icon")
            }, null),
            "superNextIcon": ((_f = slots.superNextIcon) === null || _f === void 0 ? void 0 : _f.call(slots)) || createVNode("span", {
              "class": "".concat(pre, "-super-next-icon")
            }, null),
            "components": Components,
            "direction": direction2.value,
            "onChange": onChange3,
            "onOpenChange": onOpenChange,
            "onFocus": onFocus2,
            "onBlur": onBlur2,
            "onPanelChange": onPanelChange,
            "onOk": onOk
          }), null);
        };
      }
    });
  }
  var DatePicker2 = getPicker(void 0, "ADatePicker");
  var WeekPicker2 = getPicker("week", "AWeekPicker");
  var MonthPicker2 = getPicker("month", "AMonthPicker");
  var YearPicker2 = getPicker("year", "AYearPicker");
  var TimePicker2 = getPicker("time", "TimePicker");
  var QuarterPicker2 = getPicker("quarter", "AQuarterPicker");
  return {
    DatePicker: DatePicker2,
    WeekPicker: WeekPicker2,
    MonthPicker: MonthPicker2,
    YearPicker: YearPicker2,
    TimePicker: TimePicker2,
    QuarterPicker: QuarterPicker2
  };
}
var __rest$q = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function generateRangePicker(generateConfig2, extraProps) {
  var RangePicker2 = defineComponent({
    name: "ARangePicker",
    inheritAttrs: false,
    props: _extends$2(_extends$2(_extends$2({}, commonProps()), rangePickerProps()), extraProps),
    slots: [
      "suffixIcon",
      "prevIcon",
      "nextIcon",
      "superPrevIcon",
      "superNextIcon",
      "dateRender",
      "renderExtraFooter"
    ],
    setup: function setup162(_props, _ref) {
      var expose = _ref.expose, slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
      var props2 = _props;
      var formItemContext = useInjectFormItemContext();
      devWarning(!attrs.getCalendarContainer, "DatePicker", '`getCalendarContainer` is deprecated. Please use `getPopupContainer"` instead.');
      var _useConfigInject = useConfigInject("picker", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer, size = _useConfigInject.size, rootPrefixCls = _useConfigInject.rootPrefixCls;
      var pickerRef = ref();
      onMounted(function() {
        nextTick(function() {
        });
      });
      expose({
        focus: function focus2() {
          var _a2;
          (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        },
        blur: function blur() {
          var _a2;
          (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
        }
      });
      var maybeToStrings = function maybeToStrings2(dates) {
        return props2.valueFormat ? generateConfig2.toString(dates, props2.valueFormat) : dates;
      };
      var onChange3 = function onChange4(dates, dateStrings) {
        var values = maybeToStrings(dates);
        emit("update:value", values);
        emit("change", values, dateStrings);
        formItemContext.onFieldChange();
      };
      var onOpenChange = function onOpenChange2(open2) {
        emit("update:open", open2);
        emit("openChange", open2);
      };
      var onFocus2 = function onFocus3(e2) {
        emit("focus", e2);
      };
      var onBlur2 = function onBlur3(e2) {
        emit("blur", e2);
        formItemContext.onFieldBlur();
      };
      var onPanelChange = function onPanelChange2(dates, modes) {
        var values = maybeToStrings(dates);
        emit("panelChange", values, modes);
      };
      var onOk = function onOk2(dates) {
        var value2 = maybeToStrings(dates);
        emit("ok", value2);
      };
      var onCalendarChange = function onCalendarChange2(dates, dateStrings, info) {
        var values = maybeToStrings(dates);
        emit("calendarChange", values, dateStrings, info);
      };
      var _useLocaleReceiver = useLocaleReceiver("DatePicker", enUS), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), contextLocale = _useLocaleReceiver2[0];
      var value = computed(function() {
        if (props2.value) {
          return props2.valueFormat ? generateConfig2.toDate(props2.value, props2.valueFormat) : props2.value;
        }
        return props2.value;
      });
      var defaultValue = computed(function() {
        if (props2.defaultValue) {
          return props2.valueFormat ? generateConfig2.toDate(props2.defaultValue, props2.valueFormat) : props2.defaultValue;
        }
        return props2.defaultValue;
      });
      var defaultPickerValue = computed(function() {
        if (props2.defaultPickerValue) {
          return props2.valueFormat ? generateConfig2.toDate(props2.defaultPickerValue, props2.valueFormat) : props2.defaultPickerValue;
        }
        return props2.defaultPickerValue;
      });
      return function() {
        var _classNames;
        var _a2, _b, _c, _d, _e, _f, _g;
        var locale2 = _extends$2(_extends$2({}, contextLocale.value), props2.locale);
        var p2 = _extends$2(_extends$2({}, props2), attrs);
        p2.prefixCls;
        var _p$bordered = p2.bordered, bordered = _p$bordered === void 0 ? true : _p$bordered, placeholder = p2.placeholder, _p$suffixIcon = p2.suffixIcon, suffixIcon = _p$suffixIcon === void 0 ? (_a2 = slots.suffixIcon) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _p$suffixIcon, _p$picker = p2.picker, picker = _p$picker === void 0 ? "date" : _p$picker, transitionName2 = p2.transitionName, _p$allowClear = p2.allowClear, allowClear = _p$allowClear === void 0 ? true : _p$allowClear, _p$dateRender = p2.dateRender, dateRender = _p$dateRender === void 0 ? slots.dateRender : _p$dateRender, _p$renderExtraFooter = p2.renderExtraFooter, renderExtraFooter = _p$renderExtraFooter === void 0 ? slots.renderExtraFooter : _p$renderExtraFooter, _p$separator = p2.separator, separator = _p$separator === void 0 ? (_b = slots.separator) === null || _b === void 0 ? void 0 : _b.call(slots) : _p$separator, _p$clearIcon = p2.clearIcon, clearIcon = _p$clearIcon === void 0 ? (_c = slots.clearIcon) === null || _c === void 0 ? void 0 : _c.call(slots) : _p$clearIcon, _p$id = p2.id, id = _p$id === void 0 ? formItemContext.id.value : _p$id, restProps = __rest$q(p2, ["prefixCls", "bordered", "placeholder", "suffixIcon", "picker", "transitionName", "allowClear", "dateRender", "renderExtraFooter", "separator", "clearIcon", "id"]);
        delete restProps["onUpdate:value"];
        delete restProps["onUpdate:open"];
        var format3 = p2.format, showTime = p2.showTime;
        var additionalOverrideProps = {};
        additionalOverrideProps = _extends$2(_extends$2(_extends$2({}, additionalOverrideProps), showTime ? getTimeProps(_extends$2({
          format: format3,
          picker
        }, showTime)) : {}), picker === "time" ? getTimeProps(_extends$2(_extends$2({
          format: format3
        }, omit$3(restProps, ["disabledTime"])), {
          picker
        })) : {});
        var pre = prefixCls2.value;
        return createVNode(VCRangePicker, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
          "dateRender": dateRender,
          "renderExtraFooter": renderExtraFooter,
          "separator": separator || createVNode("span", {
            "aria-label": "to",
            "class": "".concat(pre, "-separator")
          }, [createVNode(SwapRightOutlined$1, null, null)]),
          "ref": pickerRef,
          "placeholder": getRangePlaceholder(picker, locale2, placeholder),
          "suffixIcon": suffixIcon || (picker === "time" ? createVNode(ClockCircleOutlined$1, null, null) : createVNode(CalendarOutlined$1, null, null)),
          "clearIcon": clearIcon || createVNode(CloseCircleFilled$1, null, null),
          "allowClear": allowClear,
          "transitionName": transitionName2 || "".concat(rootPrefixCls.value, "-slide-up")
        }, restProps), additionalOverrideProps), {}, {
          "id": id,
          "value": value.value,
          "defaultValue": defaultValue.value,
          "defaultPickerValue": defaultPickerValue.value,
          "picker": picker,
          "class": classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(pre, "-").concat(size.value), size.value), _defineProperty$R(_classNames, "".concat(pre, "-borderless"), !bordered), _classNames), attrs.class),
          "locale": locale2.lang,
          "prefixCls": pre,
          "getPopupContainer": attrs.getCalendarContainer || getPopupContainer.value,
          "generateConfig": generateConfig2,
          "prevIcon": ((_d = slots.prevIcon) === null || _d === void 0 ? void 0 : _d.call(slots)) || createVNode("span", {
            "class": "".concat(pre, "-prev-icon")
          }, null),
          "nextIcon": ((_e = slots.nextIcon) === null || _e === void 0 ? void 0 : _e.call(slots)) || createVNode("span", {
            "class": "".concat(pre, "-next-icon")
          }, null),
          "superPrevIcon": ((_f = slots.superPrevIcon) === null || _f === void 0 ? void 0 : _f.call(slots)) || createVNode("span", {
            "class": "".concat(pre, "-super-prev-icon")
          }, null),
          "superNextIcon": ((_g = slots.superNextIcon) === null || _g === void 0 ? void 0 : _g.call(slots)) || createVNode("span", {
            "class": "".concat(pre, "-super-next-icon")
          }, null),
          "components": Components,
          "direction": direction2.value,
          "onChange": onChange3,
          "onOpenChange": onOpenChange,
          "onFocus": onFocus2,
          "onBlur": onBlur2,
          "onPanelChange": onPanelChange,
          "onOk": onOk,
          "onCalendarChange": onCalendarChange
        }), null);
      };
    }
  });
  return RangePicker2;
}
var Components = {
  button: PickerButton$1,
  rangeItem: PickerTag
};
function toArray$3(list) {
  if (!list) {
    return [];
  }
  return Array.isArray(list) ? list : [list];
}
function getTimeProps(props2) {
  var format3 = props2.format, picker = props2.picker, showHour = props2.showHour, showMinute = props2.showMinute, showSecond = props2.showSecond, use12Hours = props2.use12Hours;
  var firstFormat = toArray$3(format3)[0];
  var showTimeObj = _extends$2({}, props2);
  if (firstFormat && typeof firstFormat === "string") {
    if (!firstFormat.includes("s") && showSecond === void 0) {
      showTimeObj.showSecond = false;
    }
    if (!firstFormat.includes("m") && showMinute === void 0) {
      showTimeObj.showMinute = false;
    }
    if (!firstFormat.includes("H") && !firstFormat.includes("h") && showHour === void 0) {
      showTimeObj.showHour = false;
    }
    if ((firstFormat.includes("a") || firstFormat.includes("A")) && use12Hours === void 0) {
      showTimeObj.use12Hours = true;
    }
  }
  if (picker === "time") {
    return showTimeObj;
  }
  if (typeof firstFormat === "function") {
    delete showTimeObj.format;
  }
  return {
    showTime: showTimeObj
  };
}
function generatePicker(generateConfig2, extraProps) {
  var _generateSinglePicker = generateSinglePicker(generateConfig2, extraProps), DatePicker2 = _generateSinglePicker.DatePicker, WeekPicker2 = _generateSinglePicker.WeekPicker, MonthPicker2 = _generateSinglePicker.MonthPicker, YearPicker2 = _generateSinglePicker.YearPicker, TimePicker2 = _generateSinglePicker.TimePicker, QuarterPicker2 = _generateSinglePicker.QuarterPicker;
  var RangePicker2 = generateRangePicker(generateConfig2, extraProps);
  return {
    DatePicker: DatePicker2,
    WeekPicker: WeekPicker2,
    MonthPicker: MonthPicker2,
    YearPicker: YearPicker2,
    TimePicker: TimePicker2,
    QuarterPicker: QuarterPicker2,
    RangePicker: RangePicker2
  };
}
var _generatePicker = generatePicker(dayjsGenerateConfig), DatePicker = _generatePicker.DatePicker, WeekPicker = _generatePicker.WeekPicker, MonthPicker = _generatePicker.MonthPicker, YearPicker = _generatePicker.YearPicker, TimePicker$2 = _generatePicker.TimePicker, QuarterPicker = _generatePicker.QuarterPicker, RangePicker = _generatePicker.RangePicker;
var DatePicker$1 = _extends$2(DatePicker, {
  WeekPicker,
  MonthPicker,
  YearPicker,
  RangePicker,
  TimePicker: TimePicker$2,
  QuarterPicker,
  install: function install2(app) {
    app.component(DatePicker.name, DatePicker);
    app.component(RangePicker.name, RangePicker);
    app.component(MonthPicker.name, MonthPicker);
    app.component(WeekPicker.name, WeekPicker);
    app.component(QuarterPicker.name, QuarterPicker);
    return app;
  }
});
function notEmpty(val) {
  return val !== void 0 && val !== null;
}
var Cell$1 = function Cell(props2) {
  var itemPrefixCls = props2.itemPrefixCls, component = props2.component, span = props2.span, labelStyle = props2.labelStyle, contentStyle = props2.contentStyle, bordered = props2.bordered, label = props2.label, content = props2.content, colon = props2.colon;
  var Component = component;
  if (bordered) {
    var _ref;
    return createVNode(Component, {
      "class": [(_ref = {}, _defineProperty$R(_ref, "".concat(itemPrefixCls, "-item-label"), notEmpty(label)), _defineProperty$R(_ref, "".concat(itemPrefixCls, "-item-content"), notEmpty(content)), _ref)],
      "colSpan": span
    }, {
      default: function _default7() {
        return [notEmpty(label) && createVNode("span", {
          "style": labelStyle
        }, [label]), notEmpty(content) && createVNode("span", {
          "style": contentStyle
        }, [content])];
      }
    });
  }
  return createVNode(Component, {
    "class": ["".concat(itemPrefixCls, "-item")],
    "colSpan": span
  }, {
    default: function _default7() {
      return [createVNode("div", {
        "class": "".concat(itemPrefixCls, "-item-container")
      }, [label && createVNode("span", {
        "class": ["".concat(itemPrefixCls, "-item-label"), _defineProperty$R({}, "".concat(itemPrefixCls, "-item-no-colon"), !colon)],
        "style": labelStyle
      }, [label]), content && createVNode("span", {
        "class": "".concat(itemPrefixCls, "-item-content"),
        "style": contentStyle
      }, [content])])];
    }
  });
};
var Cell$2 = Cell$1;
var Row = function Row2(props2) {
  var renderCells = function renderCells2(items, _ref, _ref2) {
    var colon = _ref.colon, prefixCls3 = _ref.prefixCls, bordered2 = _ref.bordered;
    var component = _ref2.component, type4 = _ref2.type, showLabel = _ref2.showLabel, showContent = _ref2.showContent, rootLabelStyle = _ref2.labelStyle, rootContentStyle = _ref2.contentStyle;
    return items.map(function(item, index3) {
      var _a2, _b;
      var _ref3 = item.props || {}, _ref3$prefixCls = _ref3.prefixCls, itemPrefixCls = _ref3$prefixCls === void 0 ? prefixCls3 : _ref3$prefixCls, _ref3$span = _ref3.span, span = _ref3$span === void 0 ? 1 : _ref3$span, labelStyle2 = _ref3.labelStyle, contentStyle2 = _ref3.contentStyle, _ref3$label = _ref3.label, label = _ref3$label === void 0 ? (_b = (_a2 = item.children) === null || _a2 === void 0 ? void 0 : _a2.label) === null || _b === void 0 ? void 0 : _b.call(_a2) : _ref3$label;
      var children = getSlot$1(item);
      var className = getClass(item);
      var style2 = getStyle(item);
      var key2 = item.key;
      if (typeof component === "string") {
        return createVNode(Cell$2, {
          "key": "".concat(type4, "-").concat(String(key2) || index3),
          "class": className,
          "style": style2,
          "labelStyle": _extends$2(_extends$2({}, rootLabelStyle.value), labelStyle2),
          "contentStyle": _extends$2(_extends$2({}, rootContentStyle.value), contentStyle2),
          "span": span,
          "colon": colon,
          "component": component,
          "itemPrefixCls": itemPrefixCls,
          "bordered": bordered2,
          "label": showLabel ? label : null,
          "content": showContent ? children : null
        }, null);
      }
      return [createVNode(Cell$2, {
        "key": "label-".concat(String(key2) || index3),
        "class": className,
        "style": _extends$2(_extends$2(_extends$2({}, rootLabelStyle.value), style2), labelStyle2),
        "span": 1,
        "colon": colon,
        "component": component[0],
        "itemPrefixCls": itemPrefixCls,
        "bordered": bordered2,
        "label": label
      }, null), createVNode(Cell$2, {
        "key": "content-".concat(String(key2) || index3),
        "class": className,
        "style": _extends$2(_extends$2(_extends$2({}, rootContentStyle.value), style2), contentStyle2),
        "span": span * 2 - 1,
        "component": component[1],
        "itemPrefixCls": itemPrefixCls,
        "bordered": bordered2,
        "content": children
      }, null)];
    });
  };
  var prefixCls2 = props2.prefixCls, vertical = props2.vertical, row = props2.row, index2 = props2.index, bordered = props2.bordered;
  var _inject = inject(descriptionsContext, {
    labelStyle: ref({}),
    contentStyle: ref({})
  }), labelStyle = _inject.labelStyle, contentStyle = _inject.contentStyle;
  if (vertical) {
    return createVNode(Fragment, null, [createVNode("tr", {
      "key": "label-".concat(index2),
      "class": "".concat(prefixCls2, "-row")
    }, [renderCells(row, props2, {
      component: "th",
      type: "label",
      showLabel: true,
      labelStyle,
      contentStyle
    })]), createVNode("tr", {
      "key": "content-".concat(index2),
      "class": "".concat(prefixCls2, "-row")
    }, [renderCells(row, props2, {
      component: "td",
      type: "content",
      showContent: true,
      labelStyle,
      contentStyle
    })])]);
  }
  return createVNode("tr", {
    "key": index2,
    "class": "".concat(prefixCls2, "-row")
  }, [renderCells(row, props2, {
    component: bordered ? ["th", "td"] : "td",
    type: "item",
    showLabel: true,
    showContent: true,
    labelStyle,
    contentStyle
  })]);
};
var Row$1 = Row;
({
  prefixCls: String,
  label: PropTypes$1.any,
  span: Number
});
var descriptionsItemProp = function descriptionsItemProp2() {
  return {
    prefixCls: String,
    label: PropTypes$1.any,
    labelStyle: {
      type: Object,
      default: void 0
    },
    contentStyle: {
      type: Object,
      default: void 0
    },
    span: {
      type: Number,
      default: 1
    }
  };
};
var DescriptionsItem = defineComponent({
  name: "ADescriptionsItem",
  props: descriptionsItemProp(),
  slots: ["label"],
  setup: function setup85(_2, _ref) {
    var slots = _ref.slots;
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var DEFAULT_COLUMN_MAP = {
  xxxl: 3,
  xxl: 3,
  xl: 3,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1
};
function getColumn(column, screens2) {
  if (typeof column === "number") {
    return column;
  }
  if (_typeof$2(column) === "object") {
    for (var i2 = 0; i2 < responsiveArray.length; i2++) {
      var breakpoint = responsiveArray[i2];
      if (screens2[breakpoint] && column[breakpoint] !== void 0) {
        return column[breakpoint] || DEFAULT_COLUMN_MAP[breakpoint];
      }
    }
  }
  return 3;
}
function getFilledItem(node, span, rowRestCol) {
  var clone3 = node;
  if (span === void 0 || span > rowRestCol) {
    clone3 = cloneElement(node, {
      span: rowRestCol
    });
    warning$2(span === void 0, "Descriptions", "Sum of column `span` in a line not match `column` of Descriptions.");
  }
  return clone3;
}
function getRows(children, column) {
  var childNodes = flattenChildren(children);
  var rows = [];
  var tmpRow = [];
  var rowRestCol = column;
  childNodes.forEach(function(node, index2) {
    var _a2;
    var span = (_a2 = node.props) === null || _a2 === void 0 ? void 0 : _a2.span;
    var mergedSpan = span || 1;
    if (index2 === childNodes.length - 1) {
      tmpRow.push(getFilledItem(node, span, rowRestCol));
      rows.push(tmpRow);
      return;
    }
    if (mergedSpan < rowRestCol) {
      rowRestCol -= mergedSpan;
      tmpRow.push(node);
    } else {
      tmpRow.push(getFilledItem(node, mergedSpan, rowRestCol));
      rows.push(tmpRow);
      rowRestCol = column;
      tmpRow = [];
    }
  });
  return rows;
}
var descriptionsProps = function descriptionsProps2() {
  return {
    prefixCls: String,
    bordered: {
      type: Boolean,
      default: void 0
    },
    size: {
      type: String,
      default: "default"
    },
    title: PropTypes$1.any,
    extra: PropTypes$1.any,
    column: {
      type: [Number, Object],
      default: function _default7() {
        return DEFAULT_COLUMN_MAP;
      }
    },
    layout: String,
    colon: {
      type: Boolean,
      default: void 0
    },
    labelStyle: {
      type: Object,
      default: void 0
    },
    contentStyle: {
      type: Object,
      default: void 0
    }
  };
};
var descriptionsContext = Symbol("descriptionsContext");
var Descriptions = defineComponent({
  name: "ADescriptions",
  props: descriptionsProps(),
  slots: ["title", "extra"],
  Item: DescriptionsItem,
  setup: function setup86(props2, _ref2) {
    var slots = _ref2.slots;
    var _useConfigInject = useConfigInject("descriptions", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var token;
    var screens2 = ref({});
    onBeforeMount(function() {
      token = ResponsiveObserve.subscribe(function(screen) {
        if (_typeof$2(props2.column) !== "object") {
          return;
        }
        screens2.value = screen;
      });
    });
    onBeforeUnmount(function() {
      ResponsiveObserve.unsubscribe(token);
    });
    provide(descriptionsContext, {
      labelStyle: toRef(props2, "labelStyle"),
      contentStyle: toRef(props2, "contentStyle")
    });
    var mergeColumn = computed(function() {
      return getColumn(props2.column, screens2.value);
    });
    return function() {
      var _ref3;
      var _a2, _b, _c;
      var size = props2.size, _props$bordered = props2.bordered, bordered = _props$bordered === void 0 ? false : _props$bordered, _props$layout = props2.layout, layout2 = _props$layout === void 0 ? "horizontal" : _props$layout, _props$colon = props2.colon, colon = _props$colon === void 0 ? true : _props$colon, _props$title = props2.title, title = _props$title === void 0 ? (_a2 = slots.title) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$title, _props$extra = props2.extra, extra = _props$extra === void 0 ? (_b = slots.extra) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$extra;
      var children = (_c = slots.default) === null || _c === void 0 ? void 0 : _c.call(slots);
      var rows = getRows(children, mergeColumn.value);
      return createVNode("div", {
        "class": [prefixCls2.value, (_ref3 = {}, _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-").concat(size), size !== "default"), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-bordered"), !!bordered), _defineProperty$R(_ref3, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _ref3)]
      }, [(title || extra) && createVNode("div", {
        "class": "".concat(prefixCls2.value, "-header")
      }, [title && createVNode("div", {
        "class": "".concat(prefixCls2.value, "-title")
      }, [title]), extra && createVNode("div", {
        "class": "".concat(prefixCls2.value, "-extra")
      }, [extra])]), createVNode("div", {
        "class": "".concat(prefixCls2.value, "-view")
      }, [createVNode("table", null, [createVNode("tbody", null, [rows.map(function(row, index2) {
        return createVNode(Row$1, {
          "key": index2,
          "index": index2,
          "colon": colon,
          "prefixCls": prefixCls2.value,
          "vertical": layout2 === "vertical",
          "bordered": bordered,
          "row": row
        }, null);
      })])])])]);
    };
  }
});
Descriptions.install = function(app) {
  app.component(Descriptions.name, Descriptions);
  app.component(Descriptions.Item.name, Descriptions.Item);
  return app;
};
var Descriptions$1 = Descriptions;
var dividerProps = function dividerProps2() {
  return {
    prefixCls: String,
    type: {
      type: String,
      default: "horizontal"
    },
    dashed: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      default: "center"
    },
    plain: {
      type: Boolean,
      default: false
    },
    orientationMargin: [String, Number]
  };
};
var Divider = defineComponent({
  name: "ADivider",
  props: dividerProps(),
  setup: function setup87(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("divider", props2), prefixClsRef = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var hasCustomMarginLeft = computed(function() {
      return props2.orientation === "left" && props2.orientationMargin != null;
    });
    var hasCustomMarginRight = computed(function() {
      return props2.orientation === "right" && props2.orientationMargin != null;
    });
    var classString = computed(function() {
      var _ref2;
      var type4 = props2.type, dashed = props2.dashed, plain = props2.plain;
      var prefixCls2 = prefixClsRef.value;
      return _ref2 = {}, _defineProperty$R(_ref2, prefixCls2, true), _defineProperty$R(_ref2, "".concat(prefixCls2, "-").concat(type4), true), _defineProperty$R(_ref2, "".concat(prefixCls2, "-dashed"), !!dashed), _defineProperty$R(_ref2, "".concat(prefixCls2, "-plain"), !!plain), _defineProperty$R(_ref2, "".concat(prefixCls2, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_ref2, "".concat(prefixCls2, "-no-default-orientation-margin-left"), hasCustomMarginLeft.value), _defineProperty$R(_ref2, "".concat(prefixCls2, "-no-default-orientation-margin-right"), hasCustomMarginRight.value), _ref2;
    });
    var innerStyle = computed(function() {
      var marginValue = typeof props2.orientationMargin === "number" ? "".concat(props2.orientationMargin, "px") : props2.orientationMargin;
      return _extends$2(_extends$2({}, hasCustomMarginLeft.value && {
        marginLeft: marginValue
      }), hasCustomMarginRight.value && {
        marginRight: marginValue
      });
    });
    var orientationPrefix = computed(function() {
      return props2.orientation.length > 0 ? "-" + props2.orientation : props2.orientation;
    });
    return function() {
      var _a2;
      var children = flattenChildren((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      return createVNode("div", {
        "class": [classString.value, children.length ? "".concat(prefixClsRef.value, "-with-text ").concat(prefixClsRef.value, "-with-text").concat(orientationPrefix.value) : ""],
        "role": "separator"
      }, [children.length ? createVNode("span", {
        "class": "".concat(prefixClsRef.value, "-inner-text"),
        "style": innerStyle.value
      }, [children]) : null]);
    };
  }
});
var Divider$1 = withInstall$2(Divider);
Dropdown$2.Button = DropdownButton;
Dropdown$2.install = function(app) {
  app.component(Dropdown$2.name, Dropdown$2);
  app.component(DropdownButton.name, DropdownButton);
  return app;
};
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === "undefined") {
    return 0;
  }
  if (fresh || cached === void 0) {
    var inner = document.createElement("div");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    var outerStyle = outer.style;
    outerStyle.position = "absolute";
    outerStyle.top = "0";
    outerStyle.left = "0";
    outerStyle.pointerEvents = "none";
    outerStyle.visibility = "hidden";
    outerStyle.width = "200px";
    outerStyle.height = "150px";
    outerStyle.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
function ensureSize(str) {
  var match2 = str.match(/^(.*)px$/);
  var value = Number(match2 === null || match2 === void 0 ? void 0 : match2[1]);
  return Number.isNaN(value) ? getScrollBarSize() : value;
}
function getTargetScrollBarSize(target) {
  if (typeof document === "undefined" || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  var _getComputedStyle2 = getComputedStyle(target, "::-webkit-scrollbar"), width = _getComputedStyle2.width, height = _getComputedStyle2.height;
  return {
    width: ensureSize(width),
    height: ensureSize(height)
  };
}
function setStyle(style2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$element = options.element, element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style2);
  styleKeys.forEach(function(key2) {
    oldStyle[key2] = element.style[key2];
  });
  styleKeys.forEach(function(key2) {
    element.style[key2] = style2[key2];
  });
  return oldStyle;
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var cacheStyle$1 = {};
var switchScrollingEffect = function(close3) {
  if (!isBodyOverflowing() && !close3) {
    return;
  }
  var scrollingEffectClassName2 = "ant-scrolling-effect";
  var scrollingEffectClassNameReg2 = new RegExp("".concat(scrollingEffectClassName2), "g");
  var bodyClassName = document.body.className;
  if (close3) {
    if (!scrollingEffectClassNameReg2.test(bodyClassName))
      return;
    setStyle(cacheStyle$1);
    cacheStyle$1 = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg2, "").trim();
    return;
  }
  var scrollBarSize = getScrollBarSize();
  if (scrollBarSize) {
    cacheStyle$1 = setStyle({
      position: "relative",
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });
    if (!scrollingEffectClassNameReg2.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName2);
      document.body.className = addClassName.trim();
    }
  }
};
var locks = [];
var scrollingEffectClassName = "ant-scrolling-effect";
var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), "g");
var uuid$3 = 0;
var cacheStyle = new Map();
var ScrollLocker = /* @__PURE__ */ _createClass(function ScrollLocker2(options) {
  var _this = this;
  _classCallCheck(this, ScrollLocker2);
  this.getContainer = function() {
    var _a2;
    return (_a2 = _this.options) === null || _a2 === void 0 ? void 0 : _a2.container;
  };
  this.reLock = function(options2) {
    var findLock = locks.find(function(_ref) {
      var target = _ref.target;
      return target === _this.lockTarget;
    });
    if (findLock) {
      _this.unLock();
    }
    _this.options = options2;
    if (findLock) {
      findLock.options = options2;
      _this.lock();
    }
  };
  this.lock = function() {
    var _a2;
    if (locks.some(function(_ref2) {
      var target = _ref2.target;
      return target === _this.lockTarget;
    })) {
      return;
    }
    if (locks.some(function(_ref3) {
      var options2 = _ref3.options;
      var _a3;
      return (options2 === null || options2 === void 0 ? void 0 : options2.container) === ((_a3 = _this.options) === null || _a3 === void 0 ? void 0 : _a3.container);
    })) {
      locks = [].concat(_toConsumableArray(locks), [{
        target: _this.lockTarget,
        options: _this.options
      }]);
      return;
    }
    var scrollBarSize = 0;
    var container = ((_a2 = _this.options) === null || _a2 === void 0 ? void 0 : _a2.container) || document.body;
    if (container === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || container.scrollHeight > container.clientHeight) {
      scrollBarSize = getScrollBarSize();
    }
    var containerClassName = container.className;
    if (locks.filter(function(_ref4) {
      var options2 = _ref4.options;
      var _a3;
      return (options2 === null || options2 === void 0 ? void 0 : options2.container) === ((_a3 = _this.options) === null || _a3 === void 0 ? void 0 : _a3.container);
    }).length === 0) {
      cacheStyle.set(container, setStyle({
        width: scrollBarSize !== 0 ? "calc(100% - ".concat(scrollBarSize, "px)") : void 0,
        overflow: "hidden",
        overflowX: "hidden",
        overflowY: "hidden"
      }, {
        element: container
      }));
    }
    if (!scrollingEffectClassNameReg.test(containerClassName)) {
      var addClassName = "".concat(containerClassName, " ").concat(scrollingEffectClassName);
      container.className = addClassName.trim();
    }
    locks = [].concat(_toConsumableArray(locks), [{
      target: _this.lockTarget,
      options: _this.options
    }]);
  };
  this.unLock = function() {
    var _a2;
    var findLock = locks.find(function(_ref5) {
      var target = _ref5.target;
      return target === _this.lockTarget;
    });
    locks = locks.filter(function(_ref6) {
      var target = _ref6.target;
      return target !== _this.lockTarget;
    });
    if (!findLock || locks.some(function(_ref7) {
      var options2 = _ref7.options;
      var _a3;
      return (options2 === null || options2 === void 0 ? void 0 : options2.container) === ((_a3 = findLock.options) === null || _a3 === void 0 ? void 0 : _a3.container);
    })) {
      return;
    }
    var container = ((_a2 = _this.options) === null || _a2 === void 0 ? void 0 : _a2.container) || document.body;
    var containerClassName = container.className;
    if (!scrollingEffectClassNameReg.test(containerClassName))
      return;
    setStyle(cacheStyle.get(container), {
      element: container
    });
    cacheStyle.delete(container);
    container.className = container.className.replace(scrollingEffectClassNameReg, "").trim();
  };
  this.lockTarget = uuid$3++;
  this.options = options;
});
var openCount = 0;
var supportDom = canUseDom();
var cacheOverflow = {};
var getParent2 = function getParent3(getContainer4) {
  if (!supportDom) {
    return null;
  }
  if (getContainer4) {
    if (typeof getContainer4 === "string") {
      return document.querySelectorAll(getContainer4)[0];
    }
    if (typeof getContainer4 === "function") {
      return getContainer4();
    }
    if (_typeof$2(getContainer4) === "object" && getContainer4 instanceof window.HTMLElement) {
      return getContainer4;
    }
  }
  return document.body;
};
var Portal = defineComponent({
  name: "PortalWrapper",
  inheritAttrs: false,
  props: {
    wrapperClassName: String,
    forceRender: {
      type: Boolean,
      default: void 0
    },
    getContainer: PropTypes$1.any,
    visible: {
      type: Boolean,
      default: void 0
    }
  },
  setup: function setup88(props2, _ref) {
    var slots = _ref.slots;
    var container = ref();
    var componentRef = ref();
    var rafId = ref();
    var scrollLocker = new ScrollLocker({
      container: getParent2(props2.getContainer)
    });
    var removeCurrentContainer = function removeCurrentContainer2() {
      var _a2, _b;
      (_b = (_a2 = container.value) === null || _a2 === void 0 ? void 0 : _a2.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(container.value);
    };
    var attachToParent = function attachToParent2() {
      var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      if (force || container.value && !container.value.parentNode) {
        var parent2 = getParent2(props2.getContainer);
        if (parent2) {
          parent2.appendChild(container.value);
          return true;
        }
        return false;
      }
      return true;
    };
    var getContainer4 = function getContainer5() {
      if (!supportDom) {
        return null;
      }
      if (!container.value) {
        container.value = document.createElement("div");
        attachToParent(true);
      }
      setWrapperClassName();
      return container.value;
    };
    var setWrapperClassName = function setWrapperClassName2() {
      var wrapperClassName = props2.wrapperClassName;
      if (container.value && wrapperClassName && wrapperClassName !== container.value.className) {
        container.value.className = wrapperClassName;
      }
    };
    onUpdated(function() {
      setWrapperClassName();
      attachToParent();
    });
    var switchScrolling = function switchScrolling2() {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        switchScrollingEffect();
        cacheOverflow = setStyle({
          overflow: "hidden",
          overflowX: "hidden",
          overflowY: "hidden"
        });
      } else if (!openCount) {
        setStyle(cacheOverflow);
        cacheOverflow = {};
        switchScrollingEffect(true);
      }
    };
    var instance2 = getCurrentInstance();
    onMounted(function() {
      var init = false;
      watch([function() {
        return props2.visible;
      }, function() {
        return props2.getContainer;
      }], function(_ref2, _ref3) {
        var _ref4 = _slicedToArray$2(_ref2, 2), visible = _ref4[0], getContainer5 = _ref4[1];
        var _ref5 = _slicedToArray$2(_ref3, 2), prevVisible = _ref5[0], prevGetContainer = _ref5[1];
        if (supportDom && getParent2(props2.getContainer) === document.body) {
          if (visible && !prevVisible) {
            openCount += 1;
          } else if (init) {
            openCount -= 1;
          }
        }
        if (init) {
          var getContainerIsFunc = typeof getContainer5 === "function" && typeof prevGetContainer === "function";
          if (getContainerIsFunc ? getContainer5.toString() !== prevGetContainer.toString() : getContainer5 !== prevGetContainer) {
            removeCurrentContainer();
          }
          if (visible && visible !== prevVisible && supportDom && getParent2(getContainer5) !== scrollLocker.getContainer()) {
            scrollLocker.reLock({
              container: getParent2(getContainer5)
            });
          }
        }
        init = true;
      }, {
        immediate: true,
        flush: "post"
      });
      nextTick(function() {
        if (!attachToParent()) {
          rafId.value = wrapperRaf(function() {
            instance2.update();
          });
        }
      });
    });
    onBeforeUnmount(function() {
      var visible = props2.visible, getContainer5 = props2.getContainer;
      if (supportDom && getParent2(getContainer5) === document.body) {
        openCount = visible && openCount ? openCount - 1 : openCount;
      }
      removeCurrentContainer();
      wrapperRaf.cancel(rafId.value);
    });
    return function() {
      var forceRender = props2.forceRender, visible = props2.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount2() {
          return openCount;
        },
        getContainer: getContainer4,
        switchScrollingEffect: switchScrolling,
        scrollLocker
      };
      if (forceRender || visible || componentRef.value) {
        portal = createVNode(Portal$1, {
          "getContainer": getContainer4,
          "ref": componentRef
        }, {
          default: function _default7() {
            var _a2;
            return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots, childProps);
          }
        });
      }
      return portal;
    };
  }
});
var inputProps = function inputProps2() {
  return {
    id: String,
    prefixCls: String,
    inputPrefixCls: String,
    defaultValue: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
    value: {
      type: [String, Number, Symbol],
      default: void 0
    },
    placeholder: {
      type: [String, Number]
    },
    autocomplete: String,
    type: {
      type: String,
      default: "text"
    },
    name: String,
    size: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    readonly: {
      type: Boolean,
      default: void 0
    },
    addonBefore: PropTypes$1.any,
    addonAfter: PropTypes$1.any,
    prefix: PropTypes$1.any,
    suffix: PropTypes$1.any,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    allowClear: {
      type: Boolean,
      default: void 0
    },
    lazy: {
      type: Boolean,
      default: true
    },
    maxlength: Number,
    loading: {
      type: Boolean,
      default: void 0
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    showCount: {
      type: [Boolean, Object]
    },
    htmlSize: Number,
    onPressEnter: Function,
    onKeydown: Function,
    onKeyup: Function,
    onFocus: Function,
    onBlur: Function,
    onChange: Function,
    onInput: Function,
    "onUpdate:value": Function,
    valueModifiers: Object,
    hidden: Boolean
  };
};
var inputProps$1 = inputProps;
var textAreaProps = function textAreaProps2() {
  return _extends$2(_extends$2({}, omit$3(inputProps(), ["prefix", "addonBefore", "addonAfter", "suffix"])), {
    rows: Number,
    autosize: {
      type: [Boolean, Object],
      default: void 0
    },
    autoSize: {
      type: [Boolean, Object],
      default: void 0
    },
    onResize: {
      type: Function
    },
    onCompositionstart: Function,
    onCompositionend: Function,
    valueModifiers: Object
  });
};
function getInputClassName(prefixCls2, bordered, size, disabled, direction2) {
  var _classNames;
  return classNames(prefixCls2, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-sm"), size === "small"), _defineProperty$R(_classNames, "".concat(prefixCls2, "-lg"), size === "large"), _defineProperty$R(_classNames, "".concat(prefixCls2, "-disabled"), disabled), _defineProperty$R(_classNames, "".concat(prefixCls2, "-rtl"), direction2 === "rtl"), _defineProperty$R(_classNames, "".concat(prefixCls2, "-borderless"), !bordered), _classNames));
}
var isValid2 = function isValid3(value) {
  return value !== void 0 && value !== null && (Array.isArray(value) ? filterEmpty(value).length : true);
};
function hasPrefixSuffix(propsAndSlots) {
  return isValid2(propsAndSlots.prefix) || isValid2(propsAndSlots.suffix) || isValid2(propsAndSlots.allowClear);
}
function hasAddon(propsAndSlots) {
  return isValid2(propsAndSlots.addonBefore) || isValid2(propsAndSlots.addonAfter);
}
var ClearableInputType = ["text", "input"];
var ClearableLabeledInput = defineComponent({
  name: "ClearableLabeledInput",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    inputType: PropTypes$1.oneOf(tuple$1("text", "input")),
    value: PropTypes$1.any,
    defaultValue: PropTypes$1.any,
    allowClear: {
      type: Boolean,
      default: void 0
    },
    element: PropTypes$1.any,
    handleReset: Function,
    disabled: {
      type: Boolean,
      default: void 0
    },
    direction: {
      type: String
    },
    size: {
      type: String
    },
    suffix: PropTypes$1.any,
    prefix: PropTypes$1.any,
    addonBefore: PropTypes$1.any,
    addonAfter: PropTypes$1.any,
    readonly: {
      type: Boolean,
      default: void 0
    },
    focused: {
      type: Boolean,
      default: void 0
    },
    bordered: {
      type: Boolean,
      default: true
    },
    triggerFocus: {
      type: Function
    },
    hidden: Boolean
  },
  setup: function setup89(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var containerRef = ref();
    var onInputMouseUp = function onInputMouseUp2(e2) {
      var _a2;
      if ((_a2 = containerRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(e2.target)) {
        var triggerFocus2 = props2.triggerFocus;
        triggerFocus2 === null || triggerFocus2 === void 0 ? void 0 : triggerFocus2();
      }
    };
    var renderClearIcon = function renderClearIcon2(prefixCls2) {
      var _classNames;
      var allowClear = props2.allowClear, value = props2.value, disabled = props2.disabled, readonly2 = props2.readonly, handleReset = props2.handleReset, _props$suffix = props2.suffix, suffix = _props$suffix === void 0 ? slots.suffix : _props$suffix;
      if (!allowClear) {
        return null;
      }
      var needClear = !disabled && !readonly2 && value;
      var className = "".concat(prefixCls2, "-clear-icon");
      return createVNode(CloseCircleFilled$1, {
        "onClick": handleReset,
        "onMousedown": function onMousedown2(e2) {
          return e2.preventDefault();
        },
        "class": classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(className, "-hidden"), !needClear), _defineProperty$R(_classNames, "".concat(className, "-has-suffix"), !!suffix), _classNames), className),
        "role": "button"
      }, null);
    };
    var renderSuffix = function renderSuffix2(prefixCls2) {
      var _a2;
      var _props$suffix2 = props2.suffix, suffix = _props$suffix2 === void 0 ? (_a2 = slots.suffix) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$suffix2, allowClear = props2.allowClear;
      if (suffix || allowClear) {
        return createVNode("span", {
          "class": "".concat(prefixCls2, "-suffix")
        }, [renderClearIcon(prefixCls2), suffix]);
      }
      return null;
    };
    var renderLabeledIcon = function renderLabeledIcon2(prefixCls2, element) {
      var _classNames2;
      var _a2, _b;
      var focused = props2.focused, value = props2.value, _props$prefix = props2.prefix, prefix = _props$prefix === void 0 ? (_a2 = slots.prefix) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$prefix, size = props2.size, _props$suffix3 = props2.suffix, suffix = _props$suffix3 === void 0 ? (_b = slots.suffix) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$suffix3, disabled = props2.disabled, allowClear = props2.allowClear, direction2 = props2.direction, readonly2 = props2.readonly, bordered = props2.bordered, hidden = props2.hidden, _props$addonAfter = props2.addonAfter, addonAfter = _props$addonAfter === void 0 ? slots.addonAfter : _props$addonAfter, _props$addonBefore = props2.addonBefore, addonBefore = _props$addonBefore === void 0 ? slots.addonBefore : _props$addonBefore;
      var suffixNode = renderSuffix(prefixCls2);
      if (!hasPrefixSuffix({
        prefix,
        suffix,
        allowClear
      })) {
        return cloneElement(element, {
          value
        });
      }
      var prefixNode = prefix ? createVNode("span", {
        "class": "".concat(prefixCls2, "-prefix")
      }, [prefix]) : null;
      var affixWrapperCls = classNames("".concat(prefixCls2, "-affix-wrapper"), (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-focused"), focused), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-disabled"), disabled), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-sm"), size === "small"), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-lg"), size === "large"), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-input-with-clear-btn"), suffix && allowClear && value), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-rtl"), direction2 === "rtl"), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-readonly"), readonly2), _defineProperty$R(_classNames2, "".concat(prefixCls2, "-affix-wrapper-borderless"), !bordered), _defineProperty$R(_classNames2, "".concat(attrs.class), !hasAddon({
        addonAfter,
        addonBefore
      }) && attrs.class), _classNames2));
      return createVNode("span", {
        "ref": containerRef,
        "class": affixWrapperCls,
        "style": attrs.style,
        "onMouseup": onInputMouseUp,
        "hidden": hidden
      }, [prefixNode, cloneElement(element, {
        style: null,
        value,
        class: getInputClassName(prefixCls2, bordered, size, disabled)
      }), suffixNode]);
    };
    var renderInputWithLabel = function renderInputWithLabel2(prefixCls2, labeledElement) {
      var _classNames4;
      var _a2, _b;
      var _props$addonBefore2 = props2.addonBefore, addonBefore = _props$addonBefore2 === void 0 ? (_a2 = slots.addonBefore) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$addonBefore2, _props$addonAfter2 = props2.addonAfter, addonAfter = _props$addonAfter2 === void 0 ? (_b = slots.addonAfter) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$addonAfter2, size = props2.size, direction2 = props2.direction, hidden = props2.hidden;
      if (!hasAddon({
        addonBefore,
        addonAfter
      })) {
        return labeledElement;
      }
      var wrapperClassName = "".concat(prefixCls2, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBeforeNode = addonBefore ? createVNode("span", {
        "class": addonClassName
      }, [addonBefore]) : null;
      var addonAfterNode = addonAfter ? createVNode("span", {
        "class": addonClassName
      }, [addonAfter]) : null;
      var mergedWrapperClassName = classNames("".concat(prefixCls2, "-wrapper"), wrapperClassName, _defineProperty$R({}, "".concat(wrapperClassName, "-rtl"), direction2 === "rtl"));
      var mergedGroupClassName = classNames("".concat(prefixCls2, "-group-wrapper"), (_classNames4 = {}, _defineProperty$R(_classNames4, "".concat(prefixCls2, "-group-wrapper-sm"), size === "small"), _defineProperty$R(_classNames4, "".concat(prefixCls2, "-group-wrapper-lg"), size === "large"), _defineProperty$R(_classNames4, "".concat(prefixCls2, "-group-wrapper-rtl"), direction2 === "rtl"), _classNames4), attrs.class);
      return createVNode("span", {
        "class": mergedGroupClassName,
        "style": attrs.style,
        "hidden": hidden
      }, [createVNode("span", {
        "class": mergedWrapperClassName
      }, [addonBeforeNode, cloneElement(labeledElement, {
        style: null
      }), addonAfterNode])]);
    };
    var renderTextAreaWithClearIcon = function renderTextAreaWithClearIcon2(prefixCls2, element) {
      var _classNames5;
      var value = props2.value, allowClear = props2.allowClear, direction2 = props2.direction, bordered = props2.bordered, hidden = props2.hidden, _props$addonAfter3 = props2.addonAfter, addonAfter = _props$addonAfter3 === void 0 ? slots.addonAfter : _props$addonAfter3, _props$addonBefore3 = props2.addonBefore, addonBefore = _props$addonBefore3 === void 0 ? slots.addonBefore : _props$addonBefore3;
      if (!allowClear) {
        return cloneElement(element, {
          value
        });
      }
      var affixWrapperCls = classNames("".concat(prefixCls2, "-affix-wrapper"), "".concat(prefixCls2, "-affix-wrapper-textarea-with-clear-btn"), (_classNames5 = {}, _defineProperty$R(_classNames5, "".concat(prefixCls2, "-affix-wrapper-rtl"), direction2 === "rtl"), _defineProperty$R(_classNames5, "".concat(prefixCls2, "-affix-wrapper-borderless"), !bordered), _defineProperty$R(_classNames5, "".concat(attrs.class), !hasAddon({
        addonAfter,
        addonBefore
      }) && attrs.class), _classNames5));
      return createVNode("span", {
        "class": affixWrapperCls,
        "style": attrs.style,
        "hidden": hidden
      }, [cloneElement(element, {
        style: null,
        value
      }), renderClearIcon(prefixCls2)]);
    };
    return function() {
      var _a2;
      var prefixCls2 = props2.prefixCls, inputType = props2.inputType, _props$element = props2.element, element = _props$element === void 0 ? (_a2 = slots.element) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$element;
      if (inputType === ClearableInputType[0]) {
        return renderTextAreaWithClearIcon(prefixCls2, element);
      }
      return renderInputWithLabel(prefixCls2, renderLabeledIcon(prefixCls2, element));
    };
  }
});
function fixControlledValue(value) {
  if (typeof value === "undefined" || value === null) {
    return "";
  }
  return String(value);
}
function resolveOnChange(target, e2, onChange3, targetValue) {
  if (!onChange3) {
    return;
  }
  var event = e2;
  if (e2.type === "click") {
    Object.defineProperty(event, "target", {
      writable: true
    });
    Object.defineProperty(event, "currentTarget", {
      writable: true
    });
    var currentTarget = target.cloneNode(true);
    event.target = currentTarget;
    event.currentTarget = currentTarget;
    currentTarget.value = "";
    onChange3(event);
    return;
  }
  if (targetValue !== void 0) {
    Object.defineProperty(event, "target", {
      writable: true
    });
    Object.defineProperty(event, "currentTarget", {
      writable: true
    });
    event.target = target;
    event.currentTarget = target;
    target.value = targetValue;
    onChange3(event);
    return;
  }
  onChange3(event);
}
function triggerFocus(element, option2) {
  if (!element)
    return;
  element.focus(option2);
  var _ref = option2 || {}, cursor = _ref.cursor;
  if (cursor) {
    var len = element.value.length;
    switch (cursor) {
      case "start":
        element.setSelectionRange(0, 0);
        break;
      case "end":
        element.setSelectionRange(len, len);
        break;
      default:
        element.setSelectionRange(0, len);
    }
  }
}
var Input = defineComponent({
  name: "AInput",
  inheritAttrs: false,
  props: inputProps$1(),
  setup: function setup90(props2, _ref2) {
    var slots = _ref2.slots, attrs = _ref2.attrs, expose = _ref2.expose, emit = _ref2.emit;
    var inputRef = ref();
    var clearableInputRef = ref();
    var removePasswordTimeout;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("input", props2), direction2 = _useConfigInject.direction, prefixCls2 = _useConfigInject.prefixCls, size = _useConfigInject.size, autocomplete = _useConfigInject.autocomplete;
    var stateValue = ref(props2.value === void 0 ? props2.defaultValue : props2.value);
    var focused = ref(false);
    watch(function() {
      return props2.value;
    }, function() {
      stateValue.value = props2.value;
    });
    watch(function() {
      return props2.disabled;
    }, function() {
      if (props2.value !== void 0) {
        stateValue.value = props2.value;
      }
      if (props2.disabled) {
        focused.value = false;
      }
    });
    var clearPasswordValueAttribute = function clearPasswordValueAttribute2() {
      removePasswordTimeout = setTimeout(function() {
        var _a2;
        if (((_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.getAttribute("type")) === "password" && inputRef.value.hasAttribute("value")) {
          inputRef.value.removeAttribute("value");
        }
      });
    };
    var focus2 = function focus3(option2) {
      triggerFocus(inputRef.value, option2);
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    var setSelectionRange = function setSelectionRange2(start2, end, direction3) {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.setSelectionRange(start2, end, direction3);
    };
    var select = function select2() {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.select();
    };
    expose({
      focus: focus2,
      blur,
      input: inputRef,
      stateValue,
      setSelectionRange,
      select
    });
    var onFocus2 = function onFocus3(e2) {
      var onFocus4 = props2.onFocus;
      focused.value = true;
      onFocus4 === null || onFocus4 === void 0 ? void 0 : onFocus4(e2);
      nextTick(function() {
        clearPasswordValueAttribute();
      });
    };
    var onBlur2 = function onBlur3(e2) {
      var onBlur4 = props2.onBlur;
      focused.value = false;
      onBlur4 === null || onBlur4 === void 0 ? void 0 : onBlur4(e2);
      formItemContext.onFieldBlur();
      nextTick(function() {
        clearPasswordValueAttribute();
      });
    };
    var triggerChange = function triggerChange2(e2) {
      emit("update:value", e2.target.value);
      emit("change", e2);
      emit("input", e2);
      formItemContext.onFieldChange();
    };
    var instance2 = getCurrentInstance();
    var setValue2 = function setValue3(value, callback) {
      if (stateValue.value === value) {
        return;
      }
      if (props2.value === void 0) {
        stateValue.value = value;
      } else {
        nextTick(function() {
          if (inputRef.value.value !== stateValue.value) {
            instance2.update();
          }
        });
      }
      nextTick(function() {
        callback && callback();
      });
    };
    var handleReset = function handleReset2(e2) {
      resolveOnChange(inputRef.value, e2, triggerChange);
      setValue2("", function() {
        focus2();
      });
    };
    var handleChange2 = function handleChange3(e2) {
      var _e$target = e2.target, value = _e$target.value, composing = _e$target.composing;
      if ((e2.isComposing || composing) && props2.lazy || stateValue.value === value)
        return;
      var newVal = e2.target.value;
      resolveOnChange(inputRef.value, e2, triggerChange);
      setValue2(newVal, function() {
        clearPasswordValueAttribute();
      });
    };
    var handleKeyDown2 = function handleKeyDown3(e2) {
      if (e2.keyCode === 13) {
        emit("pressEnter", e2);
      }
      emit("keydown", e2);
    };
    onMounted(function() {
      clearPasswordValueAttribute();
    });
    onBeforeUnmount(function() {
      clearTimeout(removePasswordTimeout);
    });
    var renderInput = function renderInput2() {
      var _a2;
      var _props$addonBefore = props2.addonBefore, addonBefore = _props$addonBefore === void 0 ? slots.addonBefore : _props$addonBefore, _props$addonAfter = props2.addonAfter, addonAfter = _props$addonAfter === void 0 ? slots.addonAfter : _props$addonAfter, disabled = props2.disabled, _props$bordered = props2.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, _props$valueModifiers = props2.valueModifiers, valueModifiers = _props$valueModifiers === void 0 ? {} : _props$valueModifiers, htmlSize = props2.htmlSize;
      var otherProps = omit$3(props2, [
        "prefixCls",
        "onPressEnter",
        "addonBefore",
        "addonAfter",
        "prefix",
        "suffix",
        "allowClear",
        "defaultValue",
        "size",
        "bordered",
        "htmlSize",
        "lazy",
        "showCount",
        "valueModifiers"
      ]);
      var inputProps3 = _extends$2(_extends$2(_extends$2({}, otherProps), attrs), {
        autocomplete: autocomplete.value,
        onChange: handleChange2,
        onInput: handleChange2,
        onFocus: onFocus2,
        onBlur: onBlur2,
        onKeydown: handleKeyDown2,
        class: classNames(getInputClassName(prefixCls2.value, bordered, size.value, disabled, direction2.value), _defineProperty$R({}, attrs.class, attrs.class && !addonBefore && !addonAfter)),
        ref: inputRef,
        key: "ant-input",
        size: htmlSize,
        id: (_a2 = otherProps.id) !== null && _a2 !== void 0 ? _a2 : formItemContext.id.value
      });
      if (valueModifiers.lazy) {
        delete inputProps3.onInput;
      }
      if (!inputProps3.autofocus) {
        delete inputProps3.autofocus;
      }
      var inputNode = createVNode("input", omit$3(inputProps3, ["size"]), null);
      return withDirectives(inputNode, [[antInputDirective]]);
    };
    var renderShowCountSuffix = function renderShowCountSuffix2() {
      var _a2;
      var value = stateValue.value;
      var maxlength = props2.maxlength, _props$suffix = props2.suffix, suffix = _props$suffix === void 0 ? (_a2 = slots.suffix) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$suffix, showCount = props2.showCount;
      var hasMaxLength = Number(maxlength) > 0;
      if (suffix || showCount) {
        var valueLength = _toConsumableArray(fixControlledValue(value)).length;
        var dataCount = null;
        if (_typeof$2(showCount) === "object") {
          dataCount = showCount.formatter({
            count: valueLength,
            maxlength
          });
        } else {
          dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxlength) : "");
        }
        return createVNode(Fragment, null, [!!showCount && createVNode("span", {
          "class": classNames("".concat(prefixCls2.value, "-show-count-suffix"), _defineProperty$R({}, "".concat(prefixCls2.value, "-show-count-has-suffix"), !!suffix))
        }, [dataCount]), suffix]);
      }
      return null;
    };
    return function() {
      var inputProps3 = _extends$2(_extends$2(_extends$2({}, attrs), props2), {
        prefixCls: prefixCls2.value,
        inputType: "input",
        value: fixControlledValue(stateValue.value),
        handleReset,
        focused: focused.value && !props2.disabled
      });
      return createVNode(ClearableLabeledInput, _objectSpread2$2(_objectSpread2$2({}, omit$3(inputProps3, ["element", "valueModifiers", "suffix", "showCount"])), {}, {
        "ref": clearableInputRef
      }), _extends$2(_extends$2({}, slots), {
        element: renderInput,
        suffix: renderShowCountSuffix
      }));
    };
  }
});
var Group$1 = defineComponent({
  name: "AInputGroup",
  props: {
    prefixCls: String,
    size: {
      type: String
    },
    compact: {
      type: Boolean,
      default: void 0
    },
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onFocus: {
      type: Function
    },
    onBlur: {
      type: Function
    }
  },
  setup: function setup91(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("input-group", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var cls = computed(function() {
      var _ref2;
      var pre = prefixCls2.value;
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(pre), true), _defineProperty$R(_ref2, "".concat(pre, "-lg"), props2.size === "large"), _defineProperty$R(_ref2, "".concat(pre, "-sm"), props2.size === "small"), _defineProperty$R(_ref2, "".concat(pre, "-compact"), props2.compact), _defineProperty$R(_ref2, "".concat(pre, "-rtl"), direction2.value === "rtl"), _ref2;
    });
    return function() {
      var _a2;
      return createVNode("span", {
        "class": cls.value,
        "onMouseenter": props2.onMouseEnter,
        "onMouseleave": props2.onMouseLeave,
        "onFocus": props2.onFocus,
        "onBlur": props2.onBlur
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i;
var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i;
function match(regex, userAgent2) {
  return regex.test(userAgent2);
}
function isMobile(userAgent2) {
  var ua = userAgent2 || (typeof navigator !== "undefined" ? navigator.userAgent : "");
  var tmp = ua.split("[FBAN");
  if (typeof tmp[1] !== "undefined") {
    var _tmp = tmp;
    var _tmp2 = _slicedToArray$2(_tmp, 1);
    ua = _tmp2[0];
  }
  tmp = ua.split("Twitter");
  if (typeof tmp[1] !== "undefined") {
    var _tmp3 = tmp;
    var _tmp4 = _slicedToArray$2(_tmp3, 1);
    ua = _tmp4[0];
  }
  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}
var defaultResult = _extends$2(_extends$2({}, isMobile()), {
  isMobile
});
var isMobile$1 = defaultResult;
var __rest$p = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var Search = defineComponent({
  name: "AInputSearch",
  inheritAttrs: false,
  props: _extends$2(_extends$2({}, inputProps$1()), {
    inputPrefixCls: String,
    enterButton: PropTypes$1.any,
    onSearch: {
      type: Function
    }
  }),
  setup: function setup92(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose, emit = _ref.emit;
    var inputRef = ref();
    var focus2 = function focus3() {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    var onChange3 = function onChange4(e2) {
      emit("update:value", e2.target.value);
      if (e2 && e2.target && e2.type === "click") {
        emit("search", e2.target.value, e2);
      }
      emit("change", e2);
    };
    var onMousedown2 = function onMousedown3(e2) {
      var _a2;
      if (document.activeElement === ((_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.input)) {
        e2.preventDefault();
      }
    };
    var onSearch = function onSearch2(e2) {
      var _a2;
      emit("search", (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.stateValue, e2);
      if (!isMobile$1.tablet) {
        inputRef.value.focus();
      }
    };
    var _useConfigInject = useConfigInject("input-search", props2), prefixCls2 = _useConfigInject.prefixCls, getPrefixCls2 = _useConfigInject.getPrefixCls, direction2 = _useConfigInject.direction, size = _useConfigInject.size;
    var inputPrefixCls = computed(function() {
      return getPrefixCls2("input", props2.inputPrefixCls);
    });
    return function() {
      var _classNames;
      var _a2, _b, _c, _d;
      var disabled = props2.disabled, loading = props2.loading, _props$addonAfter = props2.addonAfter, addonAfter = _props$addonAfter === void 0 ? (_a2 = slots.addonAfter) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$addonAfter, _props$suffix = props2.suffix, suffix = _props$suffix === void 0 ? (_b = slots.suffix) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$suffix, restProps = __rest$p(props2, ["disabled", "loading", "addonAfter", "suffix"]);
      var _props$enterButton = props2.enterButton, enterButton = _props$enterButton === void 0 ? (_d = (_c = slots.enterButton) === null || _c === void 0 ? void 0 : _c.call(slots)) !== null && _d !== void 0 ? _d : false : _props$enterButton;
      enterButton = enterButton || enterButton === "";
      var searchIcon2 = typeof enterButton === "boolean" ? createVNode(SearchOutlined$1, null, null) : null;
      var btnClassName = "".concat(prefixCls2.value, "-button");
      var enterButtonAsElement = Array.isArray(enterButton) ? enterButton[0] : enterButton;
      var button;
      var isAntdButton = enterButtonAsElement.type && isPlainObject$2(enterButtonAsElement.type) && enterButtonAsElement.type.__ANT_BUTTON;
      if (isAntdButton || enterButtonAsElement.tagName === "button") {
        button = cloneElement(enterButtonAsElement, _extends$2({
          onMousedown: onMousedown2,
          onClick: onSearch,
          key: "enterButton"
        }, isAntdButton ? {
          class: btnClassName,
          size: size.value
        } : {}), false);
      } else {
        var iconOnly = searchIcon2 && !enterButton;
        button = createVNode(Button$2, {
          "class": btnClassName,
          "type": enterButton ? "primary" : void 0,
          "size": size.value,
          "disabled": disabled,
          "key": "enterButton",
          "onMousedown": onMousedown2,
          "onClick": onSearch,
          "loading": loading,
          "icon": iconOnly ? searchIcon2 : null
        }, {
          default: function _default7() {
            return [iconOnly ? null : searchIcon2 || enterButton];
          }
        });
      }
      if (addonAfter) {
        button = [button, addonAfter];
      }
      var cls = classNames(prefixCls2.value, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-").concat(size.value), !!size.value), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-with-button"), !!enterButton), _classNames), attrs.class);
      return createVNode(Input, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
        "ref": inputRef
      }, omit$3(restProps, ["onUpdate:value", "onSearch", "enterButton"])), attrs), {}, {
        "onPressEnter": onSearch,
        "size": size.value,
        "prefixCls": inputPrefixCls.value,
        "addonAfter": button,
        "suffix": suffix,
        "onChange": onChange3,
        "class": cls,
        "disabled": disabled
      }), slots);
    };
  }
});
var HIDDEN_TEXTAREA_STYLE = "\n min-height:0 !important;\n max-height:none !important;\n height:0 !important;\n visibility:hidden !important;\n overflow:hidden !important;\n position:absolute !important;\n z-index:-1000 !important;\n top:0 !important;\n right:0 !important\n";
var SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break"];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node) {
  var useCache2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
  if (useCache2 && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }
  var style2 = window.getComputedStyle(node);
  var boxSizing = style2.getPropertyValue("box-sizing") || style2.getPropertyValue("-moz-box-sizing") || style2.getPropertyValue("-webkit-box-sizing");
  var paddingSize = parseFloat(style2.getPropertyValue("padding-bottom")) + parseFloat(style2.getPropertyValue("padding-top"));
  var borderSize = parseFloat(style2.getPropertyValue("border-bottom-width")) + parseFloat(style2.getPropertyValue("border-top-width"));
  var sizingStyle = SIZING_STYLE.map(function(name2) {
    return "".concat(name2, ":").concat(style2.getPropertyValue(name2));
  }).join(";");
  var nodeInfo = {
    sizingStyle,
    paddingSize,
    borderSize,
    boxSizing
  };
  if (useCache2 && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }
  return nodeInfo;
}
function calculateNodeHeight(uiTextNode) {
  var useCache2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement("textarea");
    hiddenTextarea.setAttribute("tab-index", "-1");
    hiddenTextarea.setAttribute("aria-hidden", "true");
    document.body.appendChild(hiddenTextarea);
  }
  if (uiTextNode.getAttribute("wrap")) {
    hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
  } else {
    hiddenTextarea.removeAttribute("wrap");
  }
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache2), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;
  if (boxSizing === "border-box") {
    height += borderSize;
  } else if (boxSizing === "content-box") {
    height -= paddingSize;
  }
  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = " ";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? "" : "hidden";
      height = Math.min(maxHeight, height);
    }
  }
  return {
    height: "".concat(height, "px"),
    minHeight: "".concat(minHeight, "px"),
    maxHeight: "".concat(maxHeight, "px"),
    overflowY,
    resize: "none"
  };
}
var RESIZE_STATUS_NONE = 0;
var RESIZE_STATUS_RESIZING = 1;
var RESIZE_STATUS_RESIZED = 2;
var ResizableTextArea = defineComponent({
  name: "ResizableTextArea",
  inheritAttrs: false,
  props: textAreaProps(),
  setup: function setup93(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit, expose = _ref.expose;
    var nextFrameActionId;
    var resizeFrameId;
    var textAreaRef = ref();
    var textareaStyles = ref({});
    var resizeStatus = ref(RESIZE_STATUS_NONE);
    onBeforeUnmount(function() {
      wrapperRaf.cancel(nextFrameActionId);
      wrapperRaf.cancel(resizeFrameId);
    });
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll2() {
      try {
        if (document.activeElement === textAreaRef.value) {
          var currentStart = textAreaRef.value.selectionStart;
          var currentEnd = textAreaRef.value.selectionEnd;
          textAreaRef.value.setSelectionRange(currentStart, currentEnd);
        }
      } catch (e2) {
      }
    };
    var resizeTextarea = function resizeTextarea2() {
      var autoSize = props2.autoSize || props2.autosize;
      if (!autoSize || !textAreaRef.value) {
        return;
      }
      var minRows = autoSize.minRows, maxRows = autoSize.maxRows;
      textareaStyles.value = calculateNodeHeight(textAreaRef.value, false, minRows, maxRows);
      resizeStatus.value = RESIZE_STATUS_RESIZING;
      wrapperRaf.cancel(resizeFrameId);
      resizeFrameId = wrapperRaf(function() {
        resizeStatus.value = RESIZE_STATUS_RESIZED;
        resizeFrameId = wrapperRaf(function() {
          resizeStatus.value = RESIZE_STATUS_NONE;
          fixFirefoxAutoScroll();
        });
      });
    };
    var resizeOnNextFrame = function resizeOnNextFrame2() {
      wrapperRaf.cancel(nextFrameActionId);
      nextFrameActionId = wrapperRaf(resizeTextarea);
    };
    var handleResize = function handleResize2(size) {
      if (resizeStatus.value !== RESIZE_STATUS_NONE) {
        return;
      }
      emit("resize", size);
      var autoSize = props2.autoSize || props2.autosize;
      if (autoSize) {
        resizeOnNextFrame();
      }
    };
    warning$2(props2.autosize === void 0, "Input.TextArea", "autosize is deprecated, please use autoSize instead.");
    var renderTextArea = function renderTextArea2() {
      var prefixCls2 = props2.prefixCls, autoSize = props2.autoSize, autosize = props2.autosize, disabled = props2.disabled;
      var otherProps = omit$3(props2, ["prefixCls", "onPressEnter", "autoSize", "autosize", "defaultValue", "allowClear", "type", "lazy", "maxlength", "valueModifiers"]);
      var cls = classNames(prefixCls2, attrs.class, _defineProperty$R({}, "".concat(prefixCls2, "-disabled"), disabled));
      var style2 = [attrs.style, textareaStyles.value, resizeStatus.value === RESIZE_STATUS_RESIZING ? {
        overflowX: "hidden",
        overflowY: "hidden"
      } : null];
      var textareaProps = _extends$2(_extends$2(_extends$2({}, otherProps), attrs), {
        style: style2,
        class: cls
      });
      if (!textareaProps.autofocus) {
        delete textareaProps.autofocus;
      }
      return createVNode(ResizeObserver$1, {
        "onResize": handleResize,
        "disabled": !(autoSize || autosize)
      }, {
        default: function _default7() {
          return [withDirectives(createVNode("textarea", _objectSpread2$2(_objectSpread2$2({}, textareaProps), {}, {
            "ref": textAreaRef
          }), null), [[antInputDirective]])];
        }
      });
    };
    watch(function() {
      return props2.value;
    }, function() {
      nextTick(function() {
        resizeTextarea();
      });
    });
    onMounted(function() {
      nextTick(function() {
        resizeTextarea();
      });
    });
    var instance2 = getCurrentInstance();
    expose({
      resizeTextarea,
      textArea: textAreaRef,
      instance: instance2
    });
    return function() {
      return renderTextArea();
    };
  }
});
var ResizableTextArea$1 = ResizableTextArea;
function fixEmojiLength(value, maxLength) {
  return _toConsumableArray(value || "").slice(0, maxLength).join("");
}
function setTriggerValue(isCursorInEnd, preValue, triggerValue, maxLength) {
  var newTriggerValue = triggerValue;
  if (isCursorInEnd) {
    newTriggerValue = fixEmojiLength(triggerValue, maxLength);
  } else if (_toConsumableArray(preValue || "").length < triggerValue.length && _toConsumableArray(triggerValue || "").length > maxLength) {
    newTriggerValue = preValue;
  }
  return newTriggerValue;
}
var TextArea = defineComponent({
  name: "ATextarea",
  inheritAttrs: false,
  props: textAreaProps(),
  setup: function setup94(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, emit = _ref.emit;
    var formItemContext = useInjectFormItemContext();
    var stateValue = ref(props2.value === void 0 ? props2.defaultValue : props2.value);
    var resizableTextArea = ref();
    var mergedValue = ref("");
    var _useConfigInject = useConfigInject("input", props2), prefixCls2 = _useConfigInject.prefixCls, size = _useConfigInject.size, direction2 = _useConfigInject.direction;
    var showCount = computed(function() {
      return props2.showCount === "" || props2.showCount || false;
    });
    var hasMaxLength = computed(function() {
      return Number(props2.maxlength) > 0;
    });
    var compositing = ref(false);
    var oldCompositionValueRef = ref();
    var oldSelectionStartRef = ref(0);
    var onInternalCompositionStart = function onInternalCompositionStart2(e2) {
      compositing.value = true;
      oldCompositionValueRef.value = mergedValue.value;
      oldSelectionStartRef.value = e2.currentTarget.selectionStart;
      emit("compositionstart", e2);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd2(e2) {
      var _a2;
      compositing.value = false;
      var triggerValue = e2.currentTarget.value;
      if (hasMaxLength.value) {
        var isCursorInEnd = oldSelectionStartRef.value >= props2.maxlength + 1 || oldSelectionStartRef.value === ((_a2 = oldCompositionValueRef.value) === null || _a2 === void 0 ? void 0 : _a2.length);
        triggerValue = setTriggerValue(isCursorInEnd, oldCompositionValueRef.value, triggerValue, props2.maxlength);
      }
      if (triggerValue !== mergedValue.value) {
        setValue2(triggerValue);
        resolveOnChange(e2.currentTarget, e2, triggerChange, triggerValue);
      }
      emit("compositionend", e2);
    };
    var instance2 = getCurrentInstance();
    watch(function() {
      return props2.value;
    }, function() {
      var _a2;
      if ("value" in instance2.vnode.props || {}) {
        stateValue.value = (_a2 = props2.value) !== null && _a2 !== void 0 ? _a2 : "";
      }
    });
    var focus2 = function focus3(option2) {
      var _a2;
      triggerFocus((_a2 = resizableTextArea.value) === null || _a2 === void 0 ? void 0 : _a2.textArea, option2);
    };
    var blur = function blur2() {
      var _a2, _b;
      (_b = (_a2 = resizableTextArea.value) === null || _a2 === void 0 ? void 0 : _a2.textArea) === null || _b === void 0 ? void 0 : _b.blur();
    };
    var setValue2 = function setValue3(value, callback) {
      if (stateValue.value === value) {
        return;
      }
      if (props2.value === void 0) {
        stateValue.value = value;
      } else {
        nextTick(function() {
          var _a2, _b, _c;
          if (resizableTextArea.value.textArea.value !== mergedValue.value) {
            (_c = (_a2 = resizableTextArea.value) === null || _a2 === void 0 ? void 0 : (_b = _a2.instance).update) === null || _c === void 0 ? void 0 : _c.call(_b);
          }
        });
      }
      nextTick(function() {
        callback && callback();
      });
    };
    var handleKeyDown2 = function handleKeyDown3(e2) {
      if (e2.keyCode === 13) {
        emit("pressEnter", e2);
      }
      emit("keydown", e2);
    };
    var onBlur2 = function onBlur3(e2) {
      var onBlur4 = props2.onBlur;
      onBlur4 === null || onBlur4 === void 0 ? void 0 : onBlur4(e2);
      formItemContext.onFieldBlur();
    };
    var triggerChange = function triggerChange2(e2) {
      emit("update:value", e2.target.value);
      emit("change", e2);
      emit("input", e2);
      formItemContext.onFieldChange();
    };
    var handleReset = function handleReset2(e2) {
      resolveOnChange(resizableTextArea.value.textArea, e2, triggerChange);
      setValue2("", function() {
        focus2();
      });
    };
    var handleChange2 = function handleChange3(e2) {
      var composing = e2.target.composing;
      var triggerValue = e2.target.value;
      compositing.value = !!(e2.isComposing || composing);
      if (compositing.value && props2.lazy || stateValue.value === triggerValue)
        return;
      if (hasMaxLength.value) {
        var target = e2.target;
        var isCursorInEnd = target.selectionStart >= props2.maxlength + 1 || target.selectionStart === triggerValue.length || !target.selectionStart;
        triggerValue = setTriggerValue(isCursorInEnd, mergedValue.value, triggerValue, props2.maxlength);
      }
      resolveOnChange(e2.currentTarget, e2, triggerChange, triggerValue);
      setValue2(triggerValue);
    };
    var renderTextArea = function renderTextArea2() {
      var _class;
      var _a2, _b;
      var style2 = attrs.style, customClass = attrs.class;
      var _props$bordered = props2.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered;
      var resizeProps = _extends$2(_extends$2(_extends$2({}, omit$3(props2, ["allowClear"])), attrs), {
        style: showCount.value ? {} : style2,
        class: (_class = {}, _defineProperty$R(_class, "".concat(prefixCls2.value, "-borderless"), !bordered), _defineProperty$R(_class, "".concat(customClass), customClass && !showCount.value), _defineProperty$R(_class, "".concat(prefixCls2.value, "-sm"), size.value === "small"), _defineProperty$R(_class, "".concat(prefixCls2.value, "-lg"), size.value === "large"), _class),
        showCount: null,
        prefixCls: prefixCls2.value,
        onInput: handleChange2,
        onChange: handleChange2,
        onBlur: onBlur2,
        onKeydown: handleKeyDown2,
        onCompositionstart: onInternalCompositionStart,
        onCompositionend: onInternalCompositionEnd
      });
      if ((_a2 = props2.valueModifiers) === null || _a2 === void 0 ? void 0 : _a2.lazy) {
        delete resizeProps.onInput;
      }
      return createVNode(ResizableTextArea$1, _objectSpread2$2(_objectSpread2$2({}, resizeProps), {}, {
        "id": (_b = resizeProps.id) !== null && _b !== void 0 ? _b : formItemContext.id.value,
        "ref": resizableTextArea,
        "maxlength": props2.maxlength
      }), null);
    };
    onMounted(function() {
    });
    expose({
      focus: focus2,
      blur,
      resizableTextArea
    });
    watchEffect(function() {
      var val = fixControlledValue(stateValue.value);
      if (!compositing.value && hasMaxLength.value && (props2.value === null || props2.value === void 0)) {
        val = fixEmojiLength(val, props2.maxlength);
      }
      mergedValue.value = val;
    });
    return function() {
      var maxlength = props2.maxlength, _props$bordered2 = props2.bordered, bordered = _props$bordered2 === void 0 ? true : _props$bordered2, hidden = props2.hidden;
      var style2 = attrs.style, customClass = attrs.class;
      var inputProps3 = _extends$2(_extends$2(_extends$2({}, props2), attrs), {
        prefixCls: prefixCls2.value,
        inputType: "text",
        handleReset,
        direction: direction2.value,
        bordered,
        style: showCount.value ? void 0 : style2
      });
      var textareaNode = createVNode(ClearableLabeledInput, _objectSpread2$2(_objectSpread2$2({}, inputProps3), {}, {
        "value": mergedValue.value
      }), {
        element: renderTextArea
      });
      if (showCount.value) {
        var valueLength = _toConsumableArray(mergedValue.value).length;
        var dataCount = "";
        if (_typeof$2(showCount.value) === "object") {
          dataCount = showCount.value.formatter({
            count: valueLength,
            maxlength
          });
        } else {
          dataCount = "".concat(valueLength).concat(hasMaxLength.value ? " / ".concat(maxlength) : "");
        }
        textareaNode = createVNode("div", {
          "hidden": hidden,
          "class": classNames("".concat(prefixCls2.value, "-textarea"), _defineProperty$R({}, "".concat(prefixCls2.value, "-textarea-rtl"), direction2.value === "rtl"), "".concat(prefixCls2.value, "-textarea-show-count"), customClass),
          "style": style2,
          "data-count": _typeof$2(dataCount) !== "object" ? dataCount : void 0
        }, [textareaNode]);
      }
      return textareaNode;
    };
  }
});
var __rest$o = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var ActionMap = {
  click: "onClick",
  hover: "onMouseover"
};
var defaultIconRender = function defaultIconRender2(visible) {
  return visible ? createVNode(EyeOutlined$1, null, null) : createVNode(EyeInvisibleOutlined$1, null, null);
};
var Password = defineComponent({
  name: "AInputPassword",
  inheritAttrs: false,
  props: _extends$2(_extends$2({}, inputProps$1()), {
    prefixCls: String,
    inputPrefixCls: String,
    action: {
      type: String,
      default: "click"
    },
    visibilityToggle: {
      type: Boolean,
      default: true
    },
    iconRender: Function
  }),
  setup: function setup95(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var visible = ref(false);
    var onVisibleChange = function onVisibleChange2() {
      var disabled = props2.disabled;
      if (disabled) {
        return;
      }
      visible.value = !visible.value;
    };
    var inputRef = ref();
    var focus2 = function focus3() {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    var getIcon2 = function getIcon3(prefixCls3) {
      var _iconProps;
      var action = props2.action, _props$iconRender = props2.iconRender, iconRender = _props$iconRender === void 0 ? slots.iconRender || defaultIconRender : _props$iconRender;
      var iconTrigger = ActionMap[action] || "";
      var icon = iconRender(visible.value);
      var iconProps2 = (_iconProps = {}, _defineProperty$R(_iconProps, iconTrigger, onVisibleChange), _defineProperty$R(_iconProps, "class", "".concat(prefixCls3, "-icon")), _defineProperty$R(_iconProps, "key", "passwordIcon"), _defineProperty$R(_iconProps, "onMousedown", function onMousedown2(e2) {
        e2.preventDefault();
      }), _defineProperty$R(_iconProps, "onMouseup", function onMouseup(e2) {
        e2.preventDefault();
      }), _iconProps);
      return cloneElement(isValidElement(icon) ? icon : createVNode("span", null, [icon]), iconProps2);
    };
    var _useConfigInject = useConfigInject("input-password", props2), prefixCls2 = _useConfigInject.prefixCls, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var inputPrefixCls = computed(function() {
      return getPrefixCls2("input", props2.inputPrefixCls);
    });
    var renderPassword = function renderPassword2() {
      var size = props2.size, visibilityToggle = props2.visibilityToggle, restProps = __rest$o(props2, ["size", "visibilityToggle"]);
      var suffixIcon = visibilityToggle && getIcon2(prefixCls2.value);
      var inputClassName = classNames(prefixCls2.value, attrs.class, _defineProperty$R({}, "".concat(prefixCls2.value, "-").concat(size), !!size));
      var omittedProps = _extends$2(_extends$2(_extends$2({}, omit$3(restProps, ["suffix", "iconRender", "action"])), attrs), {
        type: visible.value ? "text" : "password",
        class: inputClassName,
        prefixCls: inputPrefixCls.value,
        suffix: suffixIcon
      });
      if (size) {
        omittedProps.size = size;
      }
      return createVNode(Input, _objectSpread2$2({
        "ref": inputRef
      }, omittedProps), slots);
    };
    return function() {
      return renderPassword();
    };
  }
});
Input.Group = Group$1;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
Input.install = function(app) {
  app.component(Input.name, Input);
  app.component(Input.Group.name, Input.Group);
  app.component(Input.Search.name, Input.Search);
  app.component(Input.TextArea.name, Input.TextArea);
  app.component(Input.Password.name, Input.Password);
  return app;
};
var numberTag = "[object Number]";
function isNumber$2(value) {
  return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
function getClientSize() {
  var width = document.documentElement.clientWidth;
  var height = window.innerHeight || document.documentElement.clientHeight;
  return {
    width,
    height
  };
}
function getOffset$1(node) {
  var box = node.getBoundingClientRect();
  var docElem = document.documentElement;
  return {
    left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}
function dialogPropTypes() {
  return {
    keyboard: {
      type: Boolean,
      default: void 0
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    afterClose: Function,
    closable: {
      type: Boolean,
      default: void 0
    },
    maskClosable: {
      type: Boolean,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    destroyOnClose: {
      type: Boolean,
      default: void 0
    },
    mousePosition: PropTypes$1.shape({
      x: Number,
      y: Number
    }).loose,
    title: PropTypes$1.any,
    footer: PropTypes$1.any,
    transitionName: String,
    maskTransitionName: String,
    animation: PropTypes$1.any,
    maskAnimation: PropTypes$1.any,
    wrapStyle: {
      type: Object,
      default: void 0
    },
    bodyStyle: {
      type: Object,
      default: void 0
    },
    maskStyle: {
      type: Object,
      default: void 0
    },
    prefixCls: String,
    wrapClassName: String,
    rootClassName: String,
    width: [String, Number],
    height: [String, Number],
    zIndex: Number,
    bodyProps: PropTypes$1.any,
    maskProps: PropTypes$1.any,
    wrapProps: PropTypes$1.any,
    getContainer: PropTypes$1.any,
    dialogStyle: {
      type: Object,
      default: void 0
    },
    dialogClass: String,
    closeIcon: PropTypes$1.any,
    forceRender: {
      type: Boolean,
      default: void 0
    },
    getOpenCount: Function,
    focusTriggerAfterClose: {
      type: Boolean,
      default: void 0
    },
    onClose: Function,
    modalRender: Function
  };
}
function getMotionName(prefixCls2, transitionName2, animationName) {
  var motionName = transitionName2;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls2, "-").concat(animationName);
  }
  return motionName;
}
var uuid$2 = -1;
function getUUID() {
  uuid$2 += 1;
  return uuid$2;
}
function getScroll$1(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method4 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d2 = w2.document;
    ret = d2.documentElement[method4];
    if (typeof ret !== "number") {
      ret = d2.body[method4];
    }
  }
  return ret;
}
function offset$1(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScroll$1(w2);
  pos.top += getScroll$1(w2, true);
  return pos;
}
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
};
var Content = defineComponent({
  name: "Content",
  inheritAttrs: false,
  props: _extends$2(_extends$2({}, dialogPropTypes()), {
    motionName: String,
    ariaId: String,
    onVisibleChanged: Function,
    onMousedown: Function,
    onMouseup: Function
  }),
  setup: function setup96(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots, attrs = _ref.attrs;
    var sentinelStartRef = ref();
    var sentinelEndRef = ref();
    var dialogRef = ref();
    expose({
      focus: function focus2() {
        var _a2;
        (_a2 = sentinelStartRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      changeActive: function changeActive(next2) {
        var _document = document, activeElement = _document.activeElement;
        if (next2 && activeElement === sentinelEndRef.value) {
          sentinelStartRef.value.focus();
        } else if (!next2 && activeElement === sentinelStartRef.value) {
          sentinelEndRef.value.focus();
        }
      }
    });
    var transformOrigin = ref();
    var contentStyleRef = computed(function() {
      var width = props2.width, height = props2.height;
      var contentStyle = {};
      if (width !== void 0) {
        contentStyle.width = typeof width === "number" ? "".concat(width, "px") : width;
      }
      if (height !== void 0) {
        contentStyle.height = typeof height === "number" ? "".concat(height, "px") : height;
      }
      if (transformOrigin.value) {
        contentStyle.transformOrigin = transformOrigin.value;
      }
      return contentStyle;
    });
    var onPrepare = function onPrepare2() {
      nextTick(function() {
        if (dialogRef.value) {
          var elementOffset = offset$1(dialogRef.value);
          transformOrigin.value = props2.mousePosition ? "".concat(props2.mousePosition.x - elementOffset.left, "px ").concat(props2.mousePosition.y - elementOffset.top, "px") : "";
        }
      });
    };
    var onVisibleChanged = function onVisibleChanged2(visible) {
      props2.onVisibleChanged(visible);
    };
    return function() {
      var _a2, _b, _c, _d;
      var prefixCls2 = props2.prefixCls, _props$footer = props2.footer, footer = _props$footer === void 0 ? (_a2 = slots.footer) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$footer, _props$title = props2.title, title = _props$title === void 0 ? (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$title, ariaId = props2.ariaId, closable = props2.closable, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_c = slots.closeIcon) === null || _c === void 0 ? void 0 : _c.call(slots) : _props$closeIcon, onClose = props2.onClose, bodyStyle = props2.bodyStyle, bodyProps = props2.bodyProps, onMousedown2 = props2.onMousedown, onMouseup = props2.onMouseup, visible = props2.visible, _props$modalRender = props2.modalRender, modalRender = _props$modalRender === void 0 ? slots.modalRender : _props$modalRender, destroyOnClose = props2.destroyOnClose, motionName = props2.motionName;
      var footerNode;
      if (footer) {
        footerNode = createVNode("div", {
          "class": "".concat(prefixCls2, "-footer")
        }, [footer]);
      }
      var headerNode;
      if (title) {
        headerNode = createVNode("div", {
          "class": "".concat(prefixCls2, "-header")
        }, [createVNode("div", {
          "class": "".concat(prefixCls2, "-title"),
          "id": ariaId
        }, [title])]);
      }
      var closer;
      if (closable) {
        closer = createVNode("button", {
          "type": "button",
          "onClick": onClose,
          "aria-label": "Close",
          "class": "".concat(prefixCls2, "-close")
        }, [closeIcon || createVNode("span", {
          "class": "".concat(prefixCls2, "-close-x")
        }, null)]);
      }
      var content = createVNode("div", {
        "class": "".concat(prefixCls2, "-content")
      }, [closer, headerNode, createVNode("div", _objectSpread2$2({
        "class": "".concat(prefixCls2, "-body"),
        "style": bodyStyle
      }, bodyProps), [(_d = slots.default) === null || _d === void 0 ? void 0 : _d.call(slots)]), footerNode]);
      var transitionProps = getTransitionProps(motionName);
      return createVNode(Transition$1, _objectSpread2$2(_objectSpread2$2({}, transitionProps), {}, {
        "onBeforeEnter": onPrepare,
        "onAfterEnter": function onAfterEnter() {
          return onVisibleChanged(true);
        },
        "onAfterLeave": function onAfterLeave() {
          return onVisibleChanged(false);
        }
      }), {
        default: function _default7() {
          return [visible || !destroyOnClose ? withDirectives(createVNode("div", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
            "ref": dialogRef,
            "key": "dialog-element",
            "role": "document",
            "style": [contentStyleRef.value, attrs.style],
            "class": [prefixCls2, attrs.class],
            "onMousedown": onMousedown2,
            "onMouseup": onMouseup
          }), [createVNode("div", {
            "tabindex": 0,
            "ref": sentinelStartRef,
            "style": sentinelStyle,
            "aria-hidden": "true"
          }, null), modalRender ? modalRender({
            originVNode: content
          }) : content, createVNode("div", {
            "tabindex": 0,
            "ref": sentinelEndRef,
            "style": sentinelStyle,
            "aria-hidden": "true"
          }, null)]), [[vShow, visible]]) : null];
        }
      });
    };
  }
});
function _objectDestructuringEmpty(obj) {
  if (obj == null)
    throw new TypeError("Cannot destructure undefined");
}
var Mask = defineComponent({
  name: "Mask",
  props: {
    prefixCls: String,
    visible: Boolean,
    motionName: String,
    maskProps: Object
  },
  setup: function setup97(props2, _ref) {
    _objectDestructuringEmpty(_ref);
    return function() {
      var prefixCls2 = props2.prefixCls, visible = props2.visible, maskProps = props2.maskProps, motionName = props2.motionName;
      var transitionProps = getTransitionProps(motionName);
      return createVNode(Transition$1, transitionProps, {
        default: function _default7() {
          return [withDirectives(createVNode("div", _objectSpread2$2({
            "class": "".concat(prefixCls2, "-mask")
          }, maskProps), null), [[vShow, visible]])];
        }
      });
    };
  }
});
var Dialog = defineComponent({
  name: "Dialog",
  inheritAttrs: false,
  props: initDefaultProps$1(_extends$2(_extends$2({}, dialogPropTypes()), {
    getOpenCount: Function,
    scrollLocker: Object
  }), {
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: "rc-dialog",
    getOpenCount: function getOpenCount() {
      return null;
    },
    focusTriggerAfterClose: true
  }),
  setup: function setup98(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var lastOutSideActiveElementRef = ref();
    var wrapperRef = ref();
    var contentRef = ref();
    var animatedVisible = ref(props2.visible);
    var ariaIdRef = ref("vcDialogTitle".concat(getUUID()));
    var onDialogVisibleChanged = function onDialogVisibleChanged2(newVisible) {
      var _a2, _b;
      if (newVisible) {
        if (!contains(wrapperRef.value, document.activeElement)) {
          lastOutSideActiveElementRef.value = document.activeElement;
          (_a2 = contentRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        }
      } else {
        var preAnimatedVisible = animatedVisible.value;
        animatedVisible.value = false;
        if (props2.mask && lastOutSideActiveElementRef.value && props2.focusTriggerAfterClose) {
          try {
            lastOutSideActiveElementRef.value.focus({
              preventScroll: true
            });
          } catch (e2) {
          }
          lastOutSideActiveElementRef.value = null;
        }
        if (preAnimatedVisible) {
          (_b = props2.afterClose) === null || _b === void 0 ? void 0 : _b.call(props2);
        }
      }
    };
    var onInternalClose = function onInternalClose2(e2) {
      var _a2;
      (_a2 = props2.onClose) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
    };
    var contentClickRef = ref(false);
    var contentTimeoutRef = ref();
    var onContentMouseDown = function onContentMouseDown2() {
      clearTimeout(contentTimeoutRef.value);
      contentClickRef.value = true;
    };
    var onContentMouseUp = function onContentMouseUp2() {
      contentTimeoutRef.value = setTimeout(function() {
        contentClickRef.value = false;
      });
    };
    var onWrapperClick = function onWrapperClick2(e2) {
      if (!props2.maskClosable)
        return null;
      if (contentClickRef.value) {
        contentClickRef.value = false;
      } else if (wrapperRef.value === e2.target) {
        onInternalClose(e2);
      }
    };
    var onWrapperKeyDown = function onWrapperKeyDown2(e2) {
      if (props2.keyboard && e2.keyCode === KeyCode$1.ESC) {
        e2.stopPropagation();
        onInternalClose(e2);
        return;
      }
      if (props2.visible) {
        if (e2.keyCode === KeyCode$1.TAB) {
          contentRef.value.changeActive(!e2.shiftKey);
        }
      }
    };
    watch(function() {
      return props2.visible;
    }, function() {
      if (props2.visible) {
        animatedVisible.value = true;
      }
    }, {
      flush: "post"
    });
    onBeforeUnmount(function() {
      var _a2;
      clearTimeout(contentTimeoutRef.value);
      (_a2 = props2.scrollLocker) === null || _a2 === void 0 ? void 0 : _a2.unLock();
    });
    watchEffect(function() {
      var _a2, _b;
      (_a2 = props2.scrollLocker) === null || _a2 === void 0 ? void 0 : _a2.unLock();
      if (animatedVisible.value) {
        (_b = props2.scrollLocker) === null || _b === void 0 ? void 0 : _b.lock();
      }
    });
    return function() {
      var prefixCls2 = props2.prefixCls, mask = props2.mask, visible = props2.visible, maskTransitionName = props2.maskTransitionName, maskAnimation = props2.maskAnimation, zIndex = props2.zIndex, wrapClassName = props2.wrapClassName, rootClassName = props2.rootClassName, wrapStyle = props2.wrapStyle, closable = props2.closable, maskProps = props2.maskProps, maskStyle = props2.maskStyle, transitionName2 = props2.transitionName, animation = props2.animation, wrapProps = props2.wrapProps, _props$title = props2.title, title = _props$title === void 0 ? slots.title : _props$title;
      var style2 = attrs.style, className = attrs.class;
      return createVNode("div", _objectSpread2$2({
        "class": ["".concat(prefixCls2, "-root"), rootClassName]
      }, pickAttrs(props2, {
        data: true
      })), [createVNode(Mask, {
        "prefixCls": prefixCls2,
        "visible": mask && visible,
        "motionName": getMotionName(prefixCls2, maskTransitionName, maskAnimation),
        "style": _extends$2({
          zIndex
        }, maskStyle),
        "maskProps": maskProps
      }, null), createVNode("div", _objectSpread2$2({
        "tabIndex": -1,
        "onKeydown": onWrapperKeyDown,
        "class": classNames("".concat(prefixCls2, "-wrap"), wrapClassName),
        "ref": wrapperRef,
        "onClick": onWrapperClick,
        "role": "dialog",
        "aria-labelledby": title ? ariaIdRef.value : null,
        "style": _extends$2(_extends$2({
          zIndex
        }, wrapStyle), {
          display: !animatedVisible.value ? "none" : null
        })
      }, wrapProps), [createVNode(Content, _objectSpread2$2(_objectSpread2$2({}, omit$3(props2, ["scrollLocker"])), {}, {
        "style": style2,
        "class": className,
        "onMousedown": onContentMouseDown,
        "onMouseup": onContentMouseUp,
        "ref": contentRef,
        "closable": closable,
        "ariaId": ariaIdRef.value,
        "prefixCls": prefixCls2,
        "visible": visible,
        "onClose": onInternalClose,
        "onVisibleChanged": onDialogVisibleChanged,
        "motionName": getMotionName(prefixCls2, transitionName2, animation)
      }), slots)])]);
    };
  }
});
var IDialogPropTypes = dialogPropTypes();
var DialogWrap = defineComponent({
  name: "DialogWrap",
  inheritAttrs: false,
  props: initDefaultProps$1(IDialogPropTypes, {
    visible: false
  }),
  setup: function setup99(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var animatedVisible = ref(props2.visible);
    useProvidePortal({}, {
      inTriggerContext: false
    });
    watch(function() {
      return props2.visible;
    }, function() {
      if (props2.visible) {
        animatedVisible.value = true;
      }
    }, {
      flush: "post"
    });
    return function() {
      var visible = props2.visible, getContainer4 = props2.getContainer, forceRender = props2.forceRender, _props$destroyOnClose = props2.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props2.afterClose;
      var dialogProps = _extends$2(_extends$2(_extends$2({}, props2), attrs), {
        ref: "_component",
        key: "dialog"
      });
      if (getContainer4 === false) {
        return createVNode(Dialog, _objectSpread2$2(_objectSpread2$2({}, dialogProps), {}, {
          "getOpenCount": function getOpenCount2() {
            return 2;
          }
        }), slots);
      }
      if (!forceRender && destroyOnClose && !animatedVisible.value) {
        return null;
      }
      return createVNode(Portal, {
        "visible": visible,
        "forceRender": forceRender,
        "getContainer": getContainer4
      }, {
        default: function _default7(childProps) {
          dialogProps = _extends$2(_extends$2(_extends$2({}, dialogProps), childProps), {
            afterClose: function afterClose() {
              _afterClose === null || _afterClose === void 0 ? void 0 : _afterClose();
              animatedVisible.value = false;
            }
          });
          return createVNode(Dialog, dialogProps, slots);
        }
      });
    };
  }
});
var DialogWrap$1 = DialogWrap;
function useFrameSetState(initial) {
  var frame = ref(null);
  var state = reactive(_extends$2({}, initial));
  var queue = ref([]);
  var setFrameState = function setFrameState2(newState) {
    if (frame.value === null) {
      queue.value = [];
      frame.value = wrapperRaf(function() {
        var memoState;
        queue.value.forEach(function(queueState) {
          memoState = _extends$2(_extends$2({}, memoState), queueState);
        });
        _extends$2(state, memoState);
        frame.value = null;
      });
    }
    queue.value.push(newState);
  };
  onMounted(function() {
    frame.value && wrapperRaf.cancel(frame.value);
  });
  return [state, setFrameState];
}
function fixPoint(key2, start2, width, clientWidth) {
  var startAddWidth = start2 + width;
  var offsetStart = (width - clientWidth) / 2;
  if (width > clientWidth) {
    if (start2 > 0) {
      return _defineProperty$R({}, key2, offsetStart);
    }
    if (start2 < 0 && startAddWidth < clientWidth) {
      return _defineProperty$R({}, key2, -offsetStart);
    }
  } else if (start2 < 0 || startAddWidth > clientWidth) {
    return _defineProperty$R({}, key2, start2 < 0 ? offsetStart : -offsetStart);
  }
  return {};
}
function getFixScaleEleTransPosition(width, height, left, top) {
  var _getClientSize = getClientSize(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
  var fixPos = null;
  if (width <= clientWidth && height <= clientHeight) {
    fixPos = {
      x: 0,
      y: 0
    };
  } else if (width > clientWidth || height > clientHeight) {
    fixPos = _extends$2(_extends$2({}, fixPoint("x", left, width, clientWidth)), fixPoint("y", top, height, clientHeight));
  }
  return fixPos;
}
var __rest$n = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var previewGroupContext = Symbol("previewGroupContext");
var context = {
  provide: function provide$1(val) {
    provide(previewGroupContext, val);
  },
  inject: function inject$1() {
    return inject(previewGroupContext, {
      isPreviewGroup: ref(false),
      previewUrls: computed(function() {
        return new Map();
      }),
      setPreviewUrls: function setPreviewUrls() {
      },
      current: ref(null),
      setCurrent: function setCurrent() {
      },
      setShowPreview: function setShowPreview() {
      },
      setMousePosition: function setMousePosition() {
      },
      registerImage: null,
      rootClassName: ""
    });
  }
};
var Group = defineComponent({
  name: "PreviewGroup",
  inheritAttrs: false,
  props: {
    previewPrefixCls: String,
    preview: {
      type: [Boolean, Object],
      default: true
    },
    icons: {
      type: Object,
      default: function _default4() {
        return {};
      }
    }
  },
  setup: function setup100(props2, _ref) {
    var slots = _ref.slots;
    var preview = computed(function() {
      var defaultValues = {
        visible: void 0,
        onVisibleChange: function onVisibleChange() {
        },
        getContainer: void 0,
        current: 0
      };
      return _typeof$2(props2.preview) === "object" ? mergeDefaultValue(props2.preview, defaultValues) : defaultValues;
    });
    var previewUrls = reactive(new Map());
    var current2 = ref();
    var previewVisible = computed(function() {
      return preview.value.visible;
    });
    var getPreviewContainer = computed(function() {
      return preview.value.getContainer;
    });
    var onPreviewVisibleChange = function onPreviewVisibleChange2(val, preval) {
      var _a2, _b;
      (_b = (_a2 = preview.value).onVisibleChange) === null || _b === void 0 ? void 0 : _b.call(_a2, val, preval);
    };
    var _useMergedState = useMergedState(!!previewVisible.value, {
      value: previewVisible,
      onChange: onPreviewVisibleChange
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    var mousePosition2 = ref(null);
    var isControlled = computed(function() {
      return previewVisible.value !== void 0;
    });
    var previewUrlsKeys = computed(function() {
      return Array.from(previewUrls.keys());
    });
    var currentControlledKey = computed(function() {
      return previewUrlsKeys.value[preview.value.current];
    });
    var canPreviewUrls = computed(function() {
      return new Map(Array.from(previewUrls).filter(function(_ref2) {
        var _ref3 = _slicedToArray$2(_ref2, 2), canPreview = _ref3[1].canPreview;
        return !!canPreview;
      }).map(function(_ref4) {
        var _ref5 = _slicedToArray$2(_ref4, 2), id = _ref5[0], url2 = _ref5[1].url;
        return [id, url2];
      }));
    });
    var setPreviewUrls = function setPreviewUrls2(id, url2) {
      var canPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
      previewUrls.set(id, {
        url: url2,
        canPreview
      });
    };
    var setCurrent = function setCurrent2(val) {
      current2.value = val;
    };
    var setMousePosition = function setMousePosition2(val) {
      mousePosition2.value = val;
    };
    var registerImage = function registerImage2(id, url2) {
      var canPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
      var unRegister = function unRegister2() {
        previewUrls.delete(id);
      };
      previewUrls.set(id, {
        url: url2,
        canPreview
      });
      return unRegister;
    };
    var onPreviewClose = function onPreviewClose2(e2) {
      e2 === null || e2 === void 0 ? void 0 : e2.stopPropagation();
      setShowPreview(false);
      setMousePosition(null);
    };
    watch(currentControlledKey, function(val) {
      setCurrent(val);
    }, {
      immediate: true,
      flush: "post"
    });
    watchEffect(function() {
      if (!isShowPreview.value && isControlled.value) {
        setCurrent(currentControlledKey.value);
      }
    }, {
      flush: "post"
    });
    context.provide({
      isPreviewGroup: ref(true),
      previewUrls: canPreviewUrls,
      setPreviewUrls,
      current: current2,
      setCurrent,
      setShowPreview,
      setMousePosition,
      registerImage
    });
    return function() {
      var dialogProps = __rest$n(preview.value, []);
      return createVNode(Fragment, null, [slots.default && slots.default(), createVNode(Preview$1, _objectSpread2$2(_objectSpread2$2({}, dialogProps), {}, {
        "ria-hidden": !isShowPreview.value,
        "visible": isShowPreview.value,
        "prefixCls": props2.previewPrefixCls,
        "onClose": onPreviewClose,
        "mousePosition": mousePosition2.value,
        "src": canPreviewUrls.value.get(current2.value),
        "icons": props2.icons,
        "getContainer": getPreviewContainer.value
      }), null)]);
    };
  }
});
var PreviewGroup$1 = Group;
var initialPosition = {
  x: 0,
  y: 0
};
var previewProps = _extends$2(_extends$2({}, dialogPropTypes()), {
  src: String,
  alt: String,
  rootClassName: String,
  icons: {
    type: Object,
    default: function _default5() {
      return {};
    }
  }
});
var Preview = defineComponent({
  name: "Preview",
  inheritAttrs: false,
  props: previewProps,
  emits: ["close", "afterClose"],
  setup: function setup101(props2, _ref) {
    var emit = _ref.emit, attrs = _ref.attrs;
    var _reactive = reactive(props2.icons), rotateLeft = _reactive.rotateLeft, rotateRight = _reactive.rotateRight, zoomIn = _reactive.zoomIn, zoomOut = _reactive.zoomOut, close3 = _reactive.close, left = _reactive.left, right = _reactive.right;
    var scale = ref(1);
    var rotate = ref(0);
    var _useFrameSetState = useFrameSetState(initialPosition), _useFrameSetState2 = _slicedToArray$2(_useFrameSetState, 2), position2 = _useFrameSetState2[0], setPosition = _useFrameSetState2[1];
    var onClose = function onClose2() {
      return emit("close");
    };
    var imgRef = ref();
    var originPositionRef = reactive({
      originX: 0,
      originY: 0,
      deltaX: 0,
      deltaY: 0
    });
    var isMoving = ref(false);
    var groupContext = context.inject();
    var previewUrls = groupContext.previewUrls, current2 = groupContext.current, isPreviewGroup = groupContext.isPreviewGroup, setCurrent = groupContext.setCurrent;
    var previewGroupCount = computed(function() {
      return previewUrls.value.size;
    });
    var previewUrlsKeys = computed(function() {
      return Array.from(previewUrls.value.keys());
    });
    var currentPreviewIndex = computed(function() {
      return previewUrlsKeys.value.indexOf(current2.value);
    });
    var combinationSrc = computed(function() {
      return isPreviewGroup.value ? previewUrls.value.get(current2.value) : props2.src;
    });
    var showLeftOrRightSwitches = computed(function() {
      return isPreviewGroup.value && previewGroupCount.value > 1;
    });
    var lastWheelZoomDirection = ref({
      wheelDirection: 0
    });
    var onAfterClose = function onAfterClose2() {
      scale.value = 1;
      rotate.value = 0;
      setPosition(initialPosition);
      emit("afterClose");
    };
    var onZoomIn = function onZoomIn2() {
      scale.value++;
      setPosition(initialPosition);
    };
    var onZoomOut = function onZoomOut2() {
      if (scale.value > 1) {
        scale.value--;
      }
      setPosition(initialPosition);
    };
    var onRotateRight = function onRotateRight2() {
      rotate.value += 90;
    };
    var onRotateLeft = function onRotateLeft2() {
      rotate.value -= 90;
    };
    var onSwitchLeft = function onSwitchLeft2(event) {
      event.preventDefault();
      event.stopPropagation();
      if (currentPreviewIndex.value > 0) {
        setCurrent(previewUrlsKeys.value[currentPreviewIndex.value - 1]);
      }
    };
    var onSwitchRight = function onSwitchRight2(event) {
      event.preventDefault();
      event.stopPropagation();
      if (currentPreviewIndex.value < previewGroupCount.value - 1) {
        setCurrent(previewUrlsKeys.value[currentPreviewIndex.value + 1]);
      }
    };
    var wrapClassName = classNames(_defineProperty$R({}, "".concat(props2.prefixCls, "-moving"), isMoving.value));
    var toolClassName = "".concat(props2.prefixCls, "-operations-operation");
    var iconClassName = "".concat(props2.prefixCls, "-operations-icon");
    var tools = [{
      icon: close3,
      onClick: onClose,
      type: "close"
    }, {
      icon: zoomIn,
      onClick: onZoomIn,
      type: "zoomIn"
    }, {
      icon: zoomOut,
      onClick: onZoomOut,
      type: "zoomOut",
      disabled: computed(function() {
        return scale.value === 1;
      })
    }, {
      icon: rotateRight,
      onClick: onRotateRight,
      type: "rotateRight"
    }, {
      icon: rotateLeft,
      onClick: onRotateLeft,
      type: "rotateLeft"
    }];
    var onMouseUp2 = function onMouseUp3() {
      if (props2.visible && isMoving.value) {
        var width = imgRef.value.offsetWidth * scale.value;
        var height = imgRef.value.offsetHeight * scale.value;
        var _getOffset = getOffset$1(imgRef.value), _left = _getOffset.left, top = _getOffset.top;
        var isRotate = rotate.value % 180 !== 0;
        isMoving.value = false;
        var fixState = getFixScaleEleTransPosition(isRotate ? height : width, isRotate ? width : height, _left, top);
        if (fixState) {
          setPosition(_extends$2({}, fixState));
        }
      }
    };
    var onMouseDown2 = function onMouseDown3(event) {
      if (event.button !== 0)
        return;
      event.preventDefault();
      event.stopPropagation();
      originPositionRef.deltaX = event.pageX - position2.x;
      originPositionRef.deltaY = event.pageY - position2.y;
      originPositionRef.originX = position2.x;
      originPositionRef.originY = position2.y;
      isMoving.value = true;
    };
    var onMouseMove3 = function onMouseMove4(event) {
      if (props2.visible && isMoving.value) {
        setPosition({
          x: event.pageX - originPositionRef.deltaX,
          y: event.pageY - originPositionRef.deltaY
        });
      }
    };
    var onWheelMove = function onWheelMove2(event) {
      if (!props2.visible)
        return;
      event.preventDefault();
      var wheelDirection = event.deltaY;
      lastWheelZoomDirection.value = {
        wheelDirection
      };
    };
    var removeListeners = function removeListeners2() {
    };
    onMounted(function() {
      watch([function() {
        return props2.visible;
      }, isMoving], function() {
        removeListeners();
        var onTopMouseUpListener;
        var onTopMouseMoveListener;
        var onMouseUpListener = addEventListenerWrap(window, "mouseup", onMouseUp2, false);
        var onMouseMoveListener = addEventListenerWrap(window, "mousemove", onMouseMove3, false);
        var onScrollWheelListener = addEventListenerWrap(window, "wheel", onWheelMove, {
          passive: false
        });
        try {
          if (window.top !== window.self) {
            onTopMouseUpListener = addEventListenerWrap(window.top, "mouseup", onMouseUp2, false);
            onTopMouseMoveListener = addEventListenerWrap(window.top, "mousemove", onMouseMove3, false);
          }
        } catch (error) {
        }
        removeListeners = function removeListeners2() {
          onMouseUpListener.remove();
          onMouseMoveListener.remove();
          onScrollWheelListener.remove();
          if (onTopMouseUpListener)
            onTopMouseUpListener.remove();
          if (onTopMouseMoveListener)
            onTopMouseMoveListener.remove();
        };
      }, {
        flush: "post",
        immediate: true
      });
    });
    onUnmounted(function() {
      removeListeners();
    });
    return function() {
      var visible = props2.visible, prefixCls2 = props2.prefixCls, rootClassName = props2.rootClassName;
      return createVNode(DialogWrap$1, _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "transitionName": "zoom",
        "maskTransitionName": "fade",
        "closable": false,
        "keyboard": true,
        "prefixCls": prefixCls2,
        "onClose": onClose,
        "afterClose": onAfterClose,
        "visible": visible,
        "wrapClassName": wrapClassName,
        "rootClassName": rootClassName,
        "getContainer": props2.getContainer
      }), {
        default: function _default7() {
          return [createVNode("ul", {
            "class": "".concat(props2.prefixCls, "-operations")
          }, [tools.map(function(_ref2) {
            var IconType = _ref2.icon, onClick2 = _ref2.onClick, type4 = _ref2.type, disabled = _ref2.disabled;
            return createVNode("li", {
              "class": classNames(toolClassName, _defineProperty$R({}, "".concat(props2.prefixCls, "-operations-operation-disabled"), disabled && (disabled === null || disabled === void 0 ? void 0 : disabled.value))),
              "onClick": onClick2,
              "key": type4
            }, [cloneVNode(IconType, {
              class: iconClassName
            })]);
          })]), createVNode("div", {
            "class": "".concat(props2.prefixCls, "-img-wrapper"),
            "style": {
              transform: "translate3d(".concat(position2.x, "px, ").concat(position2.y, "px, 0)")
            }
          }, [createVNode("img", {
            "onMousedown": onMouseDown2,
            "ref": imgRef,
            "class": "".concat(props2.prefixCls, "-img"),
            "src": combinationSrc.value,
            "alt": props2.alt,
            "style": {
              transform: "scale3d(".concat(scale.value, ", ").concat(scale.value, ", 1) rotate(").concat(rotate.value, "deg)")
            }
          }, null)]), showLeftOrRightSwitches.value && createVNode("div", {
            "class": classNames("".concat(props2.prefixCls, "-switch-left"), _defineProperty$R({}, "".concat(props2.prefixCls, "-switch-left-disabled"), currentPreviewIndex.value <= 0)),
            "onClick": onSwitchLeft
          }, [left]), showLeftOrRightSwitches.value && createVNode("div", {
            "class": classNames("".concat(props2.prefixCls, "-switch-right"), _defineProperty$R({}, "".concat(props2.prefixCls, "-switch-right-disabled"), currentPreviewIndex.value >= previewGroupCount.value - 1)),
            "onClick": onSwitchRight
          }, [right])];
        }
      });
    };
  }
});
var Preview$1 = Preview;
var __rest$m = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var imageProps = function imageProps2() {
  return {
    src: String,
    wrapperClassName: String,
    wrapperStyle: {
      type: Object,
      default: void 0
    },
    rootClassName: String,
    prefixCls: String,
    previewPrefixCls: String,
    previewMask: {
      type: [Boolean, Function],
      default: void 0
    },
    placeholder: PropTypes$1.any,
    fallback: String,
    preview: {
      type: [Boolean, Object],
      default: true
    },
    onClick: {
      type: Function
    },
    onError: {
      type: Function
    }
  };
};
var mergeDefaultValue = function mergeDefaultValue2(obj, defaultValues) {
  var res = _extends$2({}, obj);
  Object.keys(defaultValues).forEach(function(key2) {
    if (obj[key2] === void 0) {
      res[key2] = defaultValues[key2];
    }
  });
  return res;
};
var uuid$1 = 0;
var ImageInternal = defineComponent({
  name: "Image",
  inheritAttrs: false,
  props: imageProps(),
  emits: ["click", "error"],
  setup: function setup102(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit;
    var prefixCls2 = computed(function() {
      return props2.prefixCls;
    });
    var previewPrefixCls = computed(function() {
      return "".concat(prefixCls2.value, "-preview");
    });
    var preview = computed(function() {
      var defaultValues = {
        visible: void 0,
        onVisibleChange: function onVisibleChange() {
        },
        getContainer: void 0
      };
      return _typeof$2(props2.preview) === "object" ? mergeDefaultValue(props2.preview, defaultValues) : defaultValues;
    });
    var isCustomPlaceholder = computed(function() {
      return props2.placeholder && props2.placeholder !== true || slots.placeholder;
    });
    var previewVisible = computed(function() {
      return preview.value.visible;
    });
    var getPreviewContainer = computed(function() {
      return preview.value.getContainer;
    });
    var isControlled = computed(function() {
      return previewVisible.value !== void 0;
    });
    var onPreviewVisibleChange = function onPreviewVisibleChange2(val, preval) {
      var _a2, _b;
      (_b = (_a2 = preview.value).onVisibleChange) === null || _b === void 0 ? void 0 : _b.call(_a2, val, preval);
    };
    var _useMergedState = useMergedState(!!previewVisible.value, {
      value: previewVisible,
      onChange: onPreviewVisibleChange
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    watch(isShowPreview, function(val, preVal) {
      onPreviewVisibleChange(val, preVal);
    });
    var status = ref(isCustomPlaceholder.value ? "loading" : "normal");
    watch(function() {
      return props2.src;
    }, function() {
      status.value = isCustomPlaceholder.value ? "loading" : "normal";
    });
    var mousePosition2 = ref(null);
    var isError = computed(function() {
      return status.value === "error";
    });
    var groupContext = context.inject();
    var isPreviewGroup = groupContext.isPreviewGroup, setCurrent = groupContext.setCurrent, setGroupShowPreview = groupContext.setShowPreview, setGroupMousePosition = groupContext.setMousePosition, registerImage = groupContext.registerImage;
    var currentId = ref(uuid$1++);
    var canPreview = computed(function() {
      return props2.preview && !isError.value;
    });
    var onLoad = function onLoad2() {
      status.value = "normal";
    };
    var onError = function onError2(e2) {
      status.value = "error";
      emit("error", e2);
    };
    var onPreview = function onPreview2(e2) {
      if (!isControlled.value) {
        var _getOffset = getOffset$1(e2.target), left = _getOffset.left, top = _getOffset.top;
        if (isPreviewGroup.value) {
          setCurrent(currentId.value);
          setGroupMousePosition({
            x: left,
            y: top
          });
        } else {
          mousePosition2.value = {
            x: left,
            y: top
          };
        }
      }
      if (isPreviewGroup.value) {
        setGroupShowPreview(true);
      } else {
        setShowPreview(true);
      }
      emit("click", e2);
    };
    var onPreviewClose = function onPreviewClose2() {
      setShowPreview(false);
      if (!isControlled.value) {
        mousePosition2.value = null;
      }
    };
    var img = ref(null);
    watch(function() {
      return img;
    }, function() {
      if (status.value !== "loading")
        return;
      if (img.value.complete && (img.value.naturalWidth || img.value.naturalHeight)) {
        onLoad();
      }
    });
    var unRegister = function unRegister2() {
    };
    onMounted(function() {
      watch([function() {
        return props2.src;
      }, canPreview], function() {
        unRegister();
        if (!isPreviewGroup.value) {
          return function() {
          };
        }
        unRegister = registerImage(currentId.value, props2.src, canPreview.value);
        if (!canPreview.value) {
          unRegister();
        }
      }, {
        flush: "post",
        immediate: true
      });
    });
    onUnmounted(unRegister);
    var toSizePx = function toSizePx2(l2) {
      if (isNumber$2(l2))
        return l2 + "px";
      return l2;
    };
    return function() {
      var prefixCls3 = props2.prefixCls, wrapperClassName = props2.wrapperClassName, fallback = props2.fallback, imgSrc = props2.src, placeholder = props2.placeholder, wrapperStyle = props2.wrapperStyle, rootClassName = props2.rootClassName;
      var width = attrs.width, height = attrs.height, crossorigin = attrs.crossorigin, decoding = attrs.decoding, alt = attrs.alt, sizes = attrs.sizes, srcset = attrs.srcset, usemap = attrs.usemap, cls = attrs.class, style2 = attrs.style;
      var _a2 = preview.value, icons2 = _a2.icons, maskClassName = _a2.maskClassName, previewSrc = _a2.src, dialogProps = __rest$m(_a2, ["icons", "maskClassName", "src"]);
      var wrappperClass = classNames(prefixCls3, wrapperClassName, rootClassName, _defineProperty$R({}, "".concat(prefixCls3, "-error"), isError.value));
      var mergedSrc = isError.value && fallback ? fallback : previewSrc !== null && previewSrc !== void 0 ? previewSrc : imgSrc;
      var imgCommonProps = {
        crossorigin,
        decoding,
        alt,
        sizes,
        srcset,
        usemap,
        class: classNames("".concat(prefixCls3, "-img"), _defineProperty$R({}, "".concat(prefixCls3, "-img-placeholder"), placeholder === true), cls),
        style: _extends$2({
          height
        }, style2)
      };
      return createVNode(Fragment, null, [createVNode("div", {
        "class": wrappperClass,
        "onClick": canPreview.value ? onPreview : function(e2) {
          emit("click", e2);
        },
        "style": _extends$2({
          width: toSizePx(width),
          height: toSizePx(height)
        }, wrapperStyle)
      }, [createVNode("img", _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, imgCommonProps), isError.value && fallback ? {
        src: fallback
      } : {
        onLoad,
        onError,
        src: imgSrc
      }), {}, {
        "ref": img
      }), null), status.value === "loading" && createVNode("div", {
        "aria-hidden": "true",
        "class": "".concat(prefixCls3, "-placeholder")
      }, [placeholder || slots.placeholder && slots.placeholder()]), slots.previewMask && canPreview.value && createVNode("div", {
        "class": ["".concat(prefixCls3, "-mask"), maskClassName]
      }, [slots.previewMask()])]), !isPreviewGroup.value && canPreview.value && createVNode(Preview$1, _objectSpread2$2(_objectSpread2$2({}, dialogProps), {}, {
        "aria-hidden": !isShowPreview.value,
        "visible": isShowPreview.value,
        "prefixCls": previewPrefixCls.value,
        "onClose": onPreviewClose,
        "mousePosition": mousePosition2.value,
        "src": mergedSrc,
        "alt": alt,
        "getContainer": getPreviewContainer.value,
        "icons": icons2,
        "rootClassName": rootClassName
      }), null)]);
    };
  }
});
ImageInternal.PreviewGroup = PreviewGroup$1;
var Image$3 = ImageInternal;
var icons = {
  rotateLeft: createVNode(RotateLeftOutlined$1, null, null),
  rotateRight: createVNode(RotateRightOutlined$1, null, null),
  zoomIn: createVNode(ZoomInOutlined$1, null, null),
  zoomOut: createVNode(ZoomOutOutlined$1, null, null),
  close: createVNode(CloseOutlined$1, null, null),
  left: createVNode(LeftOutlined$1, null, null),
  right: createVNode(RightOutlined$1, null, null)
};
var InternalPreviewGroup = defineComponent({
  name: "AImagePreviewGroup",
  inheritAttrs: false,
  props: {
    previewPrefixCls: String
  },
  setup: function setup103(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var _useConfigInject = useConfigInject("image", props2), getPrefixCls2 = _useConfigInject.getPrefixCls;
    var prefixCls2 = computed(function() {
      return getPrefixCls2("image-preview", props2.previewPrefixCls);
    });
    return function() {
      return createVNode(PreviewGroup$1, _objectSpread2$2(_objectSpread2$2({}, _extends$2(_extends$2({}, attrs), props2)), {}, {
        "icons": icons,
        "previewPrefixCls": prefixCls2.value
      }), slots);
    };
  }
});
var PreviewGroup = InternalPreviewGroup;
var Image$1 = defineComponent({
  name: "AImage",
  inheritAttrs: false,
  props: imageProps(),
  setup: function setup104(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("image", props2), prefixCls2 = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, configProvider = _useConfigInject.configProvider;
    var mergedPreview = computed(function() {
      var preview = props2.preview;
      if (preview === false) {
        return preview;
      }
      var _preview = _typeof$2(preview) === "object" ? preview : {};
      return _extends$2(_extends$2({
        icons
      }, _preview), {
        transitionName: getTransitionName$2(rootPrefixCls.value, "zoom", _preview.transitionName),
        maskTransitionName: getTransitionName$2(rootPrefixCls.value, "fade", _preview.maskTransitionName)
      });
    });
    return function() {
      var _a2;
      var imageLocale = ((_a2 = configProvider.locale) === null || _a2 === void 0 ? void 0 : _a2.Image) || defaultLocale.Image;
      var defaultPreviewMask = function defaultPreviewMask2() {
        return createVNode("div", {
          "class": "".concat(prefixCls2.value, "-mask-info")
        }, [createVNode(EyeOutlined$1, null, null), imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview]);
      };
      var _props$previewMask = props2.previewMask, previewMask = _props$previewMask === void 0 ? slots.previewMask || defaultPreviewMask : _props$previewMask;
      return createVNode(Image$3, _objectSpread2$2(_objectSpread2$2({}, _extends$2(_extends$2(_extends$2({}, attrs), props2), {
        prefixCls: prefixCls2.value
      })), {}, {
        "preview": mergedPreview.value
      }), _extends$2(_extends$2({}, slots), {
        previewMask: typeof previewMask === "function" ? previewMask : null
      }));
    };
  }
});
Image$1.PreviewGroup = PreviewGroup;
Image$1.install = function(app) {
  app.component(Image$1.name, Image$1);
  app.component(Image$1.PreviewGroup.name, Image$1.PreviewGroup);
  return app;
};
var Image$2 = Image$1;
function supportBigInt() {
  return typeof BigInt === "function";
}
function trimNumber(numStr) {
  var str = numStr.trim();
  var negative = str.startsWith("-");
  if (negative) {
    str = str.slice(1);
  }
  str = str.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, "");
  if (str.startsWith(".")) {
    str = "0".concat(str);
  }
  var trimStr = str || "0";
  var splitNumber = trimStr.split(".");
  var integerStr = splitNumber[0] || "0";
  var decimalStr = splitNumber[1] || "0";
  if (integerStr === "0" && decimalStr === "0") {
    negative = false;
  }
  var negativeStr = negative ? "-" : "";
  return {
    negative,
    negativeStr,
    trimStr,
    integerStr,
    decimalStr,
    fullStr: "".concat(negativeStr).concat(trimStr)
  };
}
function isE(number4) {
  var str = String(number4);
  return !Number.isNaN(Number(str)) && str.includes("e");
}
function getNumberPrecision(number4) {
  var numStr = String(number4);
  if (isE(number4)) {
    var precision = Number(numStr.slice(numStr.indexOf("e-") + 2));
    var decimalMatch = numStr.match(/\.(\d+)/);
    if (decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[1]) {
      precision += decimalMatch[1].length;
    }
    return precision;
  }
  return numStr.includes(".") && validateNumber(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function num2str(number4) {
  var numStr = String(number4);
  if (isE(number4)) {
    if (number4 > Number.MAX_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number4).toString() : Number.MAX_SAFE_INTEGER);
    }
    if (number4 < Number.MIN_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number4).toString() : Number.MIN_SAFE_INTEGER);
    }
    numStr = number4.toFixed(getNumberPrecision(numStr));
  }
  return trimNumber(numStr).fullStr;
}
function validateNumber(num) {
  if (typeof num === "number") {
    return !Number.isNaN(num);
  }
  if (!num) {
    return false;
  }
  return /^\s*-?\d+(\.\d+)?\s*$/.test(num) || /^\s*-?\d+\.\s*$/.test(num) || /^\s*-?\.\d+\s*$/.test(num);
}
var NumberDecimal = /* @__PURE__ */ function() {
  function NumberDecimal2(value) {
    _classCallCheck(this, NumberDecimal2);
    this.origin = "";
    if (!value && value !== 0 || !String(value).trim()) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    this.number = Number(value);
  }
  _createClass(NumberDecimal2, [{
    key: "negate",
    value: function negate() {
      return new NumberDecimal2(-this.toNumber());
    }
  }, {
    key: "add",
    value: function add2(value) {
      if (this.isInvalidate()) {
        return new NumberDecimal2(value);
      }
      var target = Number(value);
      if (Number.isNaN(target)) {
        return this;
      }
      var number4 = this.number + target;
      if (number4 > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MAX_SAFE_INTEGER);
      }
      if (number4 < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal2(Number.MIN_SAFE_INTEGER);
      }
      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal2(number4.toFixed(maxPrecision));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber2() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function toString3() {
      var safe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (!safe) {
        return this.origin;
      }
      if (this.isInvalidate()) {
        return "";
      }
      return num2str(this.number);
    }
  }]);
  return NumberDecimal2;
}();
var BigIntDecimal = /* @__PURE__ */ function() {
  function BigIntDecimal2(value) {
    _classCallCheck(this, BigIntDecimal2);
    this.origin = "";
    if (!value && value !== 0 || !String(value).trim()) {
      this.empty = true;
      return;
    }
    this.origin = String(value);
    if (value === "-") {
      this.nan = true;
      return;
    }
    var mergedValue = value;
    if (isE(mergedValue)) {
      mergedValue = Number(mergedValue);
    }
    mergedValue = typeof mergedValue === "string" ? mergedValue : num2str(mergedValue);
    if (validateNumber(mergedValue)) {
      var trimRet = trimNumber(mergedValue);
      this.negative = trimRet.negative;
      var numbers = trimRet.trimStr.split(".");
      this.integer = BigInt(numbers[0]);
      var decimalStr = numbers[1] || "0";
      this.decimal = BigInt(decimalStr);
      this.decimalLen = decimalStr.length;
    } else {
      this.nan = true;
    }
  }
  _createClass(BigIntDecimal2, [{
    key: "getMark",
    value: function getMark2() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function getIntegerStr() {
      return this.integer.toString();
    }
  }, {
    key: "getDecimalStr",
    value: function getDecimalStr() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
  }, {
    key: "alignDecimal",
    value: function alignDecimal(decimalLength) {
      var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
      return BigInt(str);
    }
  }, {
    key: "negate",
    value: function negate() {
      var clone3 = new BigIntDecimal2(this.toString());
      clone3.negative = !clone3.negative;
      return clone3;
    }
  }, {
    key: "add",
    value: function add2(value) {
      if (this.isInvalidate()) {
        return new BigIntDecimal2(value);
      }
      var offset3 = new BigIntDecimal2(value);
      if (offset3.isInvalidate()) {
        return this;
      }
      var maxDecimalLength = Math.max(this.getDecimalStr().length, offset3.getDecimalStr().length);
      var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
      var offsetAlignedDecimal = offset3.alignDecimal(maxDecimalLength);
      var valueStr = (myAlignedDecimal + offsetAlignedDecimal).toString();
      var _trimNumber = trimNumber(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
      var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(maxDecimalLength + 1, "0"));
      return new BigIntDecimal2("".concat(hydrateValueStr.slice(0, -maxDecimalLength), ".").concat(hydrateValueStr.slice(-maxDecimalLength)));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN2() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber2() {
      if (this.isNaN()) {
        return NaN;
      }
      return Number(this.toString());
    }
  }, {
    key: "toString",
    value: function toString3() {
      var safe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
      if (!safe) {
        return this.origin;
      }
      if (this.isInvalidate()) {
        return "";
      }
      return trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
    }
  }]);
  return BigIntDecimal2;
}();
function getMiniDecimal(value) {
  if (supportBigInt()) {
    return new BigIntDecimal(value);
  }
  return new NumberDecimal(value);
}
function toFixed(numStr, separatorStr, precision) {
  if (numStr === "") {
    return "";
  }
  var _trimNumber4 = trimNumber(numStr), negativeStr = _trimNumber4.negativeStr, integerStr = _trimNumber4.integerStr, decimalStr = _trimNumber4.decimalStr;
  var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
  var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
  if (precision >= 0) {
    var advancedNum = Number(decimalStr[precision]);
    if (advancedNum >= 5) {
      var advancedDecimal = getMiniDecimal(numStr).add("".concat(negativeStr, "0.").concat("0".repeat(precision)).concat(10 - advancedNum));
      return toFixed(advancedDecimal.toString(), separatorStr, precision);
    }
    if (precision === 0) {
      return numberWithoutDecimal;
    }
    return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
  }
  if (precisionDecimalStr === ".0") {
    return numberWithoutDecimal;
  }
  return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}
var STEP_INTERVAL = 200;
var STEP_DELAY = 600;
var StepHandler = defineComponent({
  name: "StepHandler",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    upDisabled: Boolean,
    downDisabled: Boolean,
    onStep: {
      type: Function
    }
  },
  slots: ["upNode", "downNode"],
  setup: function setup105(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var stepTimeoutRef = ref();
    var onStepMouseDown = function onStepMouseDown2(e2, up) {
      e2.preventDefault();
      emit("step", up);
      function loopStep() {
        emit("step", up);
        stepTimeoutRef.value = setTimeout(loopStep, STEP_INTERVAL);
      }
      stepTimeoutRef.value = setTimeout(loopStep, STEP_DELAY);
    };
    var onStopStep = function onStopStep2() {
      clearTimeout(stepTimeoutRef.value);
    };
    onBeforeUnmount(function() {
      onStopStep();
    });
    return function() {
      if (isMobile$2()) {
        return null;
      }
      var prefixCls2 = props2.prefixCls, upDisabled = props2.upDisabled, downDisabled = props2.downDisabled;
      var handlerClassName = "".concat(prefixCls2, "-handler");
      var upClassName = classNames(handlerClassName, "".concat(handlerClassName, "-up"), _defineProperty$R({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
      var downClassName = classNames(handlerClassName, "".concat(handlerClassName, "-down"), _defineProperty$R({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
      var sharedHandlerProps = {
        unselectable: "on",
        role: "button",
        onMouseup: onStopStep,
        onMouseleave: onStopStep
      };
      var upNode = slots.upNode, downNode = slots.downNode;
      return createVNode("div", {
        "class": "".concat(handlerClassName, "-wrap")
      }, [createVNode("span", _objectSpread2$2(_objectSpread2$2({}, sharedHandlerProps), {}, {
        "onMousedown": function onMousedown2(e2) {
          onStepMouseDown(e2, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        "class": upClassName
      }), [(upNode === null || upNode === void 0 ? void 0 : upNode()) || createVNode("span", {
        "unselectable": "on",
        "class": "".concat(prefixCls2, "-handler-up-inner")
      }, null)]), createVNode("span", _objectSpread2$2(_objectSpread2$2({}, sharedHandlerProps), {}, {
        "onMousedown": function onMousedown2(e2) {
          onStepMouseDown(e2, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        "class": downClassName
      }), [(downNode === null || downNode === void 0 ? void 0 : downNode()) || createVNode("span", {
        "unselectable": "on",
        "class": "".concat(prefixCls2, "-handler-down-inner")
      }, null)])]);
    };
  }
});
function useCursor(inputRef, focused) {
  var selectionRef = ref(null);
  function recordCursor() {
    try {
      var _inputRef$value = inputRef.value, start2 = _inputRef$value.selectionStart, end = _inputRef$value.selectionEnd, value = _inputRef$value.value;
      var beforeTxt = value.substring(0, start2);
      var afterTxt = value.substring(end);
      selectionRef.value = {
        start: start2,
        end,
        value,
        beforeTxt,
        afterTxt
      };
    } catch (e2) {
    }
  }
  function restoreCursor() {
    if (inputRef.value && selectionRef.value && focused.value) {
      try {
        var value = inputRef.value.value;
        var _selectionRef$value = selectionRef.value, beforeTxt = _selectionRef$value.beforeTxt, afterTxt = _selectionRef$value.afterTxt, start2 = _selectionRef$value.start;
        var startPos = value.length;
        if (value.endsWith(afterTxt)) {
          startPos = value.length - selectionRef.value.afterTxt.length;
        } else if (value.startsWith(beforeTxt)) {
          startPos = beforeTxt.length;
        } else {
          var beforeLastChar = beforeTxt[start2 - 1];
          var newIndex2 = value.indexOf(beforeLastChar, start2 - 1);
          if (newIndex2 !== -1) {
            startPos = newIndex2 + 1;
          }
        }
        inputRef.value.setSelectionRange(startPos, startPos);
      } catch (e2) {
        warning$3(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e2.message));
      }
    }
  }
  return [recordCursor, restoreCursor];
}
var useFrame = function() {
  var idRef = ref(0);
  var cleanUp = function cleanUp2() {
    wrapperRaf.cancel(idRef.value);
  };
  onBeforeUnmount(function() {
    cleanUp();
  });
  return function(callback) {
    cleanUp();
    idRef.value = wrapperRaf(function() {
      callback();
    });
  };
};
var __rest$l = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var getDecimalValue = function getDecimalValue2(stringMode, decimalValue) {
  if (stringMode || decimalValue.isEmpty()) {
    return decimalValue.toString();
  }
  return decimalValue.toNumber();
};
var getDecimalIfValidate = function getDecimalIfValidate2(value) {
  var decimal = getMiniDecimal(value);
  return decimal.isInvalidate() ? null : decimal;
};
var inputNumberProps$1 = function inputNumberProps() {
  return {
    stringMode: {
      type: Boolean
    },
    defaultValue: {
      type: [String, Number]
    },
    value: {
      type: [String, Number]
    },
    prefixCls: {
      type: String
    },
    min: {
      type: [String, Number]
    },
    max: {
      type: [String, Number]
    },
    step: {
      type: [String, Number],
      default: 1
    },
    tabindex: {
      type: Number
    },
    controls: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    autofocus: {
      type: Boolean
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    parser: {
      type: Function
    },
    formatter: {
      type: Function
    },
    precision: {
      type: Number
    },
    decimalSeparator: {
      type: String
    },
    onInput: {
      type: Function
    },
    onChange: {
      type: Function
    },
    onPressEnter: {
      type: Function
    },
    onStep: {
      type: Function
    },
    onBlur: {
      type: Function
    },
    onFocus: {
      type: Function
    }
  };
};
var VcInputNumber = defineComponent({
  name: "InnerInputNumber",
  inheritAttrs: false,
  props: _extends$2(_extends$2({}, inputNumberProps$1()), {
    lazy: Boolean
  }),
  slots: ["upHandler", "downHandler"],
  setup: function setup106(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    var inputRef = ref();
    var focus2 = ref(false);
    var userTypingRef = ref(false);
    var compositionRef = ref(false);
    var decimalValue = ref(getMiniDecimal(props2.value));
    function setUncontrolledDecimalValue(newDecimal) {
      if (props2.value === void 0) {
        decimalValue.value = newDecimal;
      }
    }
    var getPrecision2 = function getPrecision3(numStr, userTyping) {
      if (userTyping) {
        return void 0;
      }
      if (props2.precision >= 0) {
        return props2.precision;
      }
      return Math.max(getNumberPrecision(numStr), getNumberPrecision(props2.step));
    };
    var mergedParser = function mergedParser2(num) {
      var numStr = String(num);
      if (props2.parser) {
        return props2.parser(numStr);
      }
      var parsedStr = numStr;
      if (props2.decimalSeparator) {
        parsedStr = parsedStr.replace(props2.decimalSeparator, ".");
      }
      return parsedStr.replace(/[^\w.-]+/g, "");
    };
    var inputValue = ref("");
    var mergedFormatter = function mergedFormatter2(number4, userTyping) {
      if (props2.formatter) {
        return props2.formatter(number4, {
          userTyping,
          input: String(inputValue.value)
        });
      }
      var str = typeof number4 === "number" ? num2str(number4) : number4;
      if (!userTyping) {
        var mergedPrecision = getPrecision2(str, userTyping);
        if (validateNumber(str) && (props2.decimalSeparator || mergedPrecision >= 0)) {
          var separatorStr = props2.decimalSeparator || ".";
          str = toFixed(str, separatorStr, mergedPrecision);
        }
      }
      return str;
    };
    var initValue = function() {
      var initValue2 = props2.value;
      if (decimalValue.value.isInvalidate() && ["string", "number"].includes(_typeof$2(initValue2))) {
        return Number.isNaN(initValue2) ? "" : initValue2;
      }
      return mergedFormatter(decimalValue.value.toString(), false);
    }();
    inputValue.value = initValue;
    function setInputValue(newValue, userTyping) {
      inputValue.value = mergedFormatter(newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping);
    }
    var maxDecimal = computed(function() {
      return getDecimalIfValidate(props2.max);
    });
    var minDecimal = computed(function() {
      return getDecimalIfValidate(props2.min);
    });
    var upDisabled = computed(function() {
      if (!maxDecimal.value || !decimalValue.value || decimalValue.value.isInvalidate()) {
        return false;
      }
      return maxDecimal.value.lessEquals(decimalValue.value);
    });
    var downDisabled = computed(function() {
      if (!minDecimal.value || !decimalValue.value || decimalValue.value.isInvalidate()) {
        return false;
      }
      return decimalValue.value.lessEquals(minDecimal.value);
    });
    var _useCursor = useCursor(inputRef, focus2), _useCursor2 = _slicedToArray$2(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    var getRangeValue = function getRangeValue2(target) {
      if (maxDecimal.value && !target.lessEquals(maxDecimal.value)) {
        return maxDecimal.value;
      }
      if (minDecimal.value && !minDecimal.value.lessEquals(target)) {
        return minDecimal.value;
      }
      return null;
    };
    var isInRange2 = function isInRange3(target) {
      return !getRangeValue(target);
    };
    var triggerValueUpdate = function triggerValueUpdate2(newValue, userTyping) {
      var _a2;
      var updateValue = newValue;
      var isRangeValidate = isInRange2(updateValue) || updateValue.isEmpty();
      if (!updateValue.isEmpty() && !userTyping) {
        updateValue = getRangeValue(updateValue) || updateValue;
        isRangeValidate = true;
      }
      if (!props2.readonly && !props2.disabled && isRangeValidate) {
        var numStr = updateValue.toString();
        var mergedPrecision = getPrecision2(numStr, userTyping);
        if (mergedPrecision >= 0) {
          updateValue = getMiniDecimal(toFixed(numStr, ".", mergedPrecision));
        }
        if (!updateValue.equals(decimalValue.value)) {
          setUncontrolledDecimalValue(updateValue);
          (_a2 = props2.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(props2, updateValue.isEmpty() ? null : getDecimalValue(props2.stringMode, updateValue));
          if (props2.value === void 0) {
            setInputValue(updateValue, userTyping);
          }
        }
        return updateValue;
      }
      return decimalValue.value;
    };
    var onNextPromise = useFrame();
    var collectInputValue = function collectInputValue2(inputStr) {
      var _a2;
      recordCursor();
      inputValue.value = inputStr;
      if (!compositionRef.value) {
        var finalValue = mergedParser(inputStr);
        var finalDecimal = getMiniDecimal(finalValue);
        if (!finalDecimal.isNaN()) {
          triggerValueUpdate(finalDecimal, true);
        }
      }
      (_a2 = props2.onInput) === null || _a2 === void 0 ? void 0 : _a2.call(props2, inputStr);
      onNextPromise(function() {
        var nextInputStr = inputStr;
        if (!props2.parser) {
          nextInputStr = inputStr.replace(/。/g, ".");
        }
        if (nextInputStr !== inputStr) {
          collectInputValue2(nextInputStr);
        }
      });
    };
    var onCompositionStart2 = function onCompositionStart3() {
      compositionRef.value = true;
    };
    var onCompositionEnd2 = function onCompositionEnd3() {
      compositionRef.value = false;
      collectInputValue(inputRef.value.value);
    };
    var onInternalInput = function onInternalInput2(e2) {
      collectInputValue(e2.target.value);
    };
    var onInternalStep = function onInternalStep2(up) {
      var _a2, _b;
      if (up && upDisabled.value || !up && downDisabled.value) {
        return;
      }
      userTypingRef.value = false;
      var stepDecimal = getMiniDecimal(props2.step);
      if (!up) {
        stepDecimal = stepDecimal.negate();
      }
      var target = (decimalValue.value || getMiniDecimal(0)).add(stepDecimal.toString());
      var updatedValue = triggerValueUpdate(target, false);
      (_a2 = props2.onStep) === null || _a2 === void 0 ? void 0 : _a2.call(props2, getDecimalValue(props2.stringMode, updatedValue), {
        offset: props2.step,
        type: up ? "up" : "down"
      });
      (_b = inputRef.value) === null || _b === void 0 ? void 0 : _b.focus();
    };
    var flushInputValue = function flushInputValue2(userTyping) {
      var parsedValue = getMiniDecimal(mergedParser(inputValue.value));
      var formatValue2 = parsedValue;
      if (!parsedValue.isNaN()) {
        formatValue2 = triggerValueUpdate(parsedValue, userTyping);
      } else {
        formatValue2 = decimalValue.value;
      }
      if (props2.value !== void 0) {
        setInputValue(decimalValue.value, false);
      } else if (!formatValue2.isNaN()) {
        setInputValue(formatValue2, false);
      }
    };
    var onKeyDown = function onKeyDown2(event) {
      var _a2;
      var which = event.which;
      userTypingRef.value = true;
      if (which === KeyCode$1.ENTER) {
        if (!compositionRef.value) {
          userTypingRef.value = false;
        }
        flushInputValue(false);
        (_a2 = props2.onPressEnter) === null || _a2 === void 0 ? void 0 : _a2.call(props2, event);
      }
      if (props2.keyboard === false) {
        return;
      }
      if (!compositionRef.value && [KeyCode$1.UP, KeyCode$1.DOWN].includes(which)) {
        onInternalStep(KeyCode$1.UP === which);
        event.preventDefault();
      }
    };
    var onKeyUp = function onKeyUp2() {
      userTypingRef.value = false;
    };
    var onBlur2 = function onBlur3(e2) {
      flushInputValue(false);
      focus2.value = false;
      userTypingRef.value = false;
      emit("blur", e2);
    };
    watch(function() {
      return props2.precision;
    }, function() {
      if (!decimalValue.value.isInvalidate()) {
        setInputValue(decimalValue.value, false);
      }
    }, {
      flush: "post"
    });
    watch(function() {
      return props2.value;
    }, function() {
      var newValue = getMiniDecimal(props2.value);
      decimalValue.value = newValue;
      var currentParsedValue = getMiniDecimal(mergedParser(inputValue.value));
      if (!newValue.equals(currentParsedValue) || !userTypingRef.value || props2.formatter) {
        setInputValue(newValue, userTypingRef.value);
      }
    }, {
      flush: "post"
    });
    watch(inputValue, function() {
      if (props2.formatter) {
        restoreCursor();
      }
    }, {
      flush: "post"
    });
    watch(function() {
      return props2.disabled;
    }, function(val) {
      if (val) {
        focus2.value = false;
      }
    });
    expose({
      focus: function focus3() {
        var _a2;
        (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _a2;
        (_a2 = inputRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    });
    return function() {
      var _classNames;
      var _a2 = _extends$2(_extends$2({}, attrs), props2), _a$prefixCls = _a2.prefixCls, prefixCls2 = _a$prefixCls === void 0 ? "rc-input-number" : _a$prefixCls, min4 = _a2.min, max4 = _a2.max, _a$step = _a2.step, step = _a$step === void 0 ? 1 : _a$step;
      _a2.defaultValue;
      _a2.value;
      var disabled = _a2.disabled, readonly2 = _a2.readonly;
      _a2.keyboard;
      var _a$controls = _a2.controls, controls = _a$controls === void 0 ? true : _a$controls, autofocus = _a2.autofocus;
      _a2.stringMode;
      _a2.parser;
      _a2.formatter;
      _a2.precision;
      _a2.decimalSeparator;
      _a2.onChange;
      _a2.onInput;
      _a2.onPressEnter;
      _a2.onStep;
      var lazy = _a2.lazy, className = _a2.class, style2 = _a2.style, inputProps3 = __rest$l(_a2, ["prefixCls", "min", "max", "step", "defaultValue", "value", "disabled", "readonly", "keyboard", "controls", "autofocus", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "lazy", "class", "style"]);
      var upHandler = slots.upHandler, downHandler = slots.downHandler;
      var inputClassName = "".concat(prefixCls2, "-input");
      var eventProps = {};
      if (lazy) {
        eventProps.onChange = onInternalInput;
      } else {
        eventProps.onInput = onInternalInput;
      }
      return createVNode("div", {
        "class": classNames(prefixCls2, className, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-focused"), focus2.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-disabled"), disabled), _defineProperty$R(_classNames, "".concat(prefixCls2, "-readonly"), readonly2), _defineProperty$R(_classNames, "".concat(prefixCls2, "-not-a-number"), decimalValue.value.isNaN()), _defineProperty$R(_classNames, "".concat(prefixCls2, "-out-of-range"), !decimalValue.value.isInvalidate() && !isInRange2(decimalValue.value)), _classNames)),
        "style": style2,
        "onKeydown": onKeyDown,
        "onKeyup": onKeyUp
      }, [controls && createVNode(StepHandler, {
        "prefixCls": prefixCls2,
        "upDisabled": upDisabled.value,
        "downDisabled": downDisabled.value,
        "onStep": onInternalStep
      }, {
        upNode: upHandler,
        downNode: downHandler
      }), createVNode("div", {
        "class": "".concat(inputClassName, "-wrap")
      }, [createVNode("input", _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
        "autofocus": autofocus,
        "autocomplete": "off",
        "role": "spinbutton",
        "aria-valuemin": min4,
        "aria-valuemax": max4,
        "aria-valuenow": decimalValue.value.isInvalidate() ? null : decimalValue.value.toString(),
        "step": step
      }, inputProps3), {}, {
        "ref": inputRef,
        "class": inputClassName,
        "value": inputValue.value,
        "disabled": disabled,
        "readonly": readonly2,
        "onFocus": function onFocus2(e2) {
          focus2.value = true;
          emit("focus", e2);
        }
      }, eventProps), {}, {
        "onBlur": onBlur2,
        "onCompositionstart": onCompositionStart2,
        "onCompositionend": onCompositionEnd2
      }), null)])]);
    };
  }
});
function isValidValue(val) {
  return val !== void 0 && val !== null;
}
var __rest$k = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var baseProps = inputNumberProps$1();
var inputNumberProps2 = function inputNumberProps3() {
  return _extends$2(_extends$2({}, baseProps), {
    size: {
      type: String
    },
    bordered: {
      type: Boolean,
      default: true
    },
    placeholder: String,
    name: String,
    id: String,
    type: String,
    addonBefore: PropTypes$1.any,
    addonAfter: PropTypes$1.any,
    prefix: PropTypes$1.any,
    "update:value": baseProps.onChange,
    valueModifiers: Object
  });
};
var InputNumber = defineComponent({
  name: "AInputNumber",
  inheritAttrs: false,
  props: inputNumberProps2(),
  slots: ["addonBefore", "addonAfter", "prefix"],
  setup: function setup107(props2, _ref) {
    var emit = _ref.emit, expose = _ref.expose, attrs = _ref.attrs, slots = _ref.slots;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("input-number", props2), prefixCls2 = _useConfigInject.prefixCls, size = _useConfigInject.size, direction2 = _useConfigInject.direction;
    var mergedValue = ref(props2.value === void 0 ? props2.defaultValue : props2.value);
    var focused = ref(false);
    watch(function() {
      return props2.value;
    }, function() {
      mergedValue.value = props2.value;
    });
    var inputNumberRef = ref(null);
    var focus2 = function focus3() {
      var _a2;
      (_a2 = inputNumberRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = inputNumberRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    var handleChange2 = function handleChange3(val) {
      if (props2.value === void 0) {
        mergedValue.value = val;
      }
      emit("update:value", val);
      emit("change", val);
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2(e2) {
      focused.value = false;
      emit("blur", e2);
      formItemContext.onFieldBlur();
    };
    var handleFocus = function handleFocus2(e2) {
      focused.value = true;
      emit("focus", e2);
    };
    onMounted(function() {
      nextTick(function() {
      });
    });
    return function() {
      var _classNames;
      var _a2, _b, _c;
      var _d = _extends$2(_extends$2({}, attrs), props2), className = _d.class, bordered = _d.bordered, readonly2 = _d.readonly, style2 = _d.style, _d$addonBefore = _d.addonBefore, addonBefore = _d$addonBefore === void 0 ? (_a2 = slots.addonBefore) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _d$addonBefore, _d$addonAfter = _d.addonAfter, addonAfter = _d$addonAfter === void 0 ? (_b = slots.addonAfter) === null || _b === void 0 ? void 0 : _b.call(slots) : _d$addonAfter, _d$prefix = _d.prefix, prefix = _d$prefix === void 0 ? (_c = slots.prefix) === null || _c === void 0 ? void 0 : _c.call(slots) : _d$prefix, _d$valueModifiers = _d.valueModifiers, valueModifiers = _d$valueModifiers === void 0 ? {} : _d$valueModifiers, others = __rest$k(_d, ["class", "bordered", "readonly", "style", "addonBefore", "addonAfter", "prefix", "valueModifiers"]);
      var preCls = prefixCls2.value;
      var mergeSize = size.value;
      var inputNumberClass = classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(preCls, "-lg"), mergeSize === "large"), _defineProperty$R(_classNames, "".concat(preCls, "-sm"), mergeSize === "small"), _defineProperty$R(_classNames, "".concat(preCls, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames, "".concat(preCls, "-readonly"), readonly2), _defineProperty$R(_classNames, "".concat(preCls, "-borderless"), !bordered), _classNames), className);
      var element = createVNode(VcInputNumber, _objectSpread2$2(_objectSpread2$2({}, omit$3(others, ["size", "defaultValue"])), {}, {
        "ref": inputNumberRef,
        "lazy": !!valueModifiers.lazy,
        "value": mergedValue.value,
        "class": inputNumberClass,
        "prefixCls": preCls,
        "readonly": readonly2,
        "onChange": handleChange2,
        "onBlur": handleBlur,
        "onFocus": handleFocus
      }), {
        upHandler: function upHandler() {
          return createVNode(UpOutlined$1, {
            "class": "".concat(preCls, "-handler-up-inner")
          }, null);
        },
        downHandler: function downHandler() {
          return createVNode(DownOutlined$1, {
            "class": "".concat(preCls, "-handler-down-inner")
          }, null);
        }
      });
      var hasAddon2 = isValidValue(addonBefore) || isValidValue(addonAfter);
      if (isValidValue(prefix)) {
        var _classNames2;
        var affixWrapperCls = classNames("".concat(preCls, "-affix-wrapper"), (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-focused"), focused.value), _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-disabled"), props2.disabled), _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-sm"), size.value === "small"), _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-lg"), size.value === "large"), _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-readonly"), readonly2), _defineProperty$R(_classNames2, "".concat(preCls, "-affix-wrapper-borderless"), !bordered), _defineProperty$R(_classNames2, "".concat(className), !hasAddon2 && className), _classNames2));
        element = createVNode("div", {
          "class": affixWrapperCls,
          "style": style2,
          "onMouseup": function onMouseup() {
            return inputNumberRef.value.focus();
          }
        }, [createVNode("span", {
          "class": "".concat(preCls, "-prefix")
        }, [prefix]), element]);
      }
      if (hasAddon2) {
        var _classNames4;
        var wrapperClassName = "".concat(preCls, "-group");
        var addonClassName = "".concat(wrapperClassName, "-addon");
        var addonBeforeNode = addonBefore ? createVNode("div", {
          "class": addonClassName
        }, [addonBefore]) : null;
        var addonAfterNode = addonAfter ? createVNode("div", {
          "class": addonClassName
        }, [addonAfter]) : null;
        var mergedWrapperClassName = classNames("".concat(preCls, "-wrapper"), wrapperClassName, _defineProperty$R({}, "".concat(wrapperClassName, "-rtl"), direction2.value === "rtl"));
        var mergedGroupClassName = classNames("".concat(preCls, "-group-wrapper"), (_classNames4 = {}, _defineProperty$R(_classNames4, "".concat(preCls, "-group-wrapper-sm"), mergeSize === "small"), _defineProperty$R(_classNames4, "".concat(preCls, "-group-wrapper-lg"), mergeSize === "large"), _defineProperty$R(_classNames4, "".concat(preCls, "-group-wrapper-rtl"), direction2.value === "rtl"), _classNames4), className);
        element = createVNode("div", {
          "class": mergedGroupClassName,
          "style": style2
        }, [createVNode("div", {
          "class": mergedWrapperClassName
        }, [addonBeforeNode, element, addonAfterNode])]);
      }
      return cloneElement(element, {
        style: style2
      });
    };
  }
});
var InputNumber$1 = _extends$2(InputNumber, {
  install: function install3(app) {
    app.component(InputNumber.name, InputNumber);
    return app;
  }
});
var __rest$j = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var spinProps = function spinProps2() {
  return {
    prefixCls: String,
    spinning: {
      type: Boolean,
      default: void 0
    },
    size: String,
    wrapperClassName: String,
    tip: PropTypes$1.any,
    delay: Number,
    indicator: PropTypes$1.any
  };
};
var defaultIndicator = null;
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
function setDefaultIndicator(Content2) {
  var Indicator = Content2.indicator;
  defaultIndicator = typeof Indicator === "function" ? Indicator : function() {
    return createVNode(Indicator, null, null);
  };
}
var Spin = defineComponent({
  name: "ASpin",
  inheritAttrs: false,
  props: initDefaultProps$1(spinProps(), {
    size: "default",
    spinning: true,
    wrapperClassName: ""
  }),
  setup: function setup108() {
    return {
      originalUpdateSpinning: null,
      configProvider: inject("configProvider", defaultConfigProvider)
    };
  },
  data: function data2() {
    var spinning = this.spinning, delay = this.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    return {
      sSpinning: spinning && !shouldBeDelayed
    };
  },
  created: function created3() {
    this.originalUpdateSpinning = this.updateSpinning;
    this.debouncifyUpdateSpinning(this.$props);
  },
  mounted: function mounted3() {
    this.updateSpinning();
  },
  updated: function updated2() {
    var _this = this;
    nextTick(function() {
      _this.debouncifyUpdateSpinning();
      _this.updateSpinning();
    });
  },
  beforeUnmount: function beforeUnmount3() {
    this.cancelExistingSpin();
  },
  methods: {
    debouncifyUpdateSpinning: function debouncifyUpdateSpinning(props2) {
      var _ref = props2 || this.$props, delay = _ref.delay;
      if (delay) {
        this.cancelExistingSpin();
        this.updateSpinning = debounce$1(this.originalUpdateSpinning, delay);
      }
    },
    updateSpinning: function updateSpinning() {
      var spinning = this.spinning, sSpinning = this.sSpinning;
      if (sSpinning !== spinning) {
        this.sSpinning = spinning;
      }
    },
    cancelExistingSpin: function cancelExistingSpin() {
      var updateSpinning2 = this.updateSpinning;
      if (updateSpinning2 && updateSpinning2.cancel) {
        updateSpinning2.cancel();
      }
    },
    renderIndicator: function renderIndicator(prefixCls2) {
      var dotClassName = "".concat(prefixCls2, "-dot");
      var indicator = getComponent(this, "indicator");
      if (indicator === null) {
        return null;
      }
      if (Array.isArray(indicator)) {
        indicator = indicator.length === 1 ? indicator[0] : indicator;
      }
      if (isVNode(indicator)) {
        return cloneVNode(indicator, {
          class: dotClassName
        });
      }
      if (defaultIndicator && isVNode(defaultIndicator())) {
        return cloneVNode(defaultIndicator(), {
          class: dotClassName
        });
      }
      return createVNode("span", {
        "class": "".concat(dotClassName, " ").concat(prefixCls2, "-dot-spin")
      }, [createVNode("i", {
        "class": "".concat(prefixCls2, "-dot-item")
      }, null), createVNode("i", {
        "class": "".concat(prefixCls2, "-dot-item")
      }, null), createVNode("i", {
        "class": "".concat(prefixCls2, "-dot-item")
      }, null), createVNode("i", {
        "class": "".concat(prefixCls2, "-dot-item")
      }, null)]);
    }
  },
  render: function render7() {
    var _spinClassName;
    var _a2, _b;
    var _this$$props = this.$props, size = _this$$props.size, customizePrefixCls = _this$$props.prefixCls, _this$$props$tip = _this$$props.tip, tip = _this$$props$tip === void 0 ? (_b = (_a2 = this.$slots).tip) === null || _b === void 0 ? void 0 : _b.call(_a2) : _this$$props$tip, wrapperClassName = _this$$props.wrapperClassName;
    var _c = this.$attrs, cls = _c.class, style2 = _c.style, divProps = __rest$j(_c, ["class", "style"]);
    var _this$configProvider = this.configProvider, getPrefixCls2 = _this$configProvider.getPrefixCls, direction2 = _this$configProvider.direction;
    var prefixCls2 = getPrefixCls2("spin", customizePrefixCls);
    var sSpinning = this.sSpinning;
    var spinClassName = (_spinClassName = {}, _defineProperty$R(_spinClassName, prefixCls2, true), _defineProperty$R(_spinClassName, "".concat(prefixCls2, "-sm"), size === "small"), _defineProperty$R(_spinClassName, "".concat(prefixCls2, "-lg"), size === "large"), _defineProperty$R(_spinClassName, "".concat(prefixCls2, "-spinning"), sSpinning), _defineProperty$R(_spinClassName, "".concat(prefixCls2, "-show-text"), !!tip), _defineProperty$R(_spinClassName, "".concat(prefixCls2, "-rtl"), direction2 === "rtl"), _defineProperty$R(_spinClassName, cls, !!cls), _spinClassName);
    var spinElement = createVNode("div", _objectSpread2$2(_objectSpread2$2({}, divProps), {}, {
      "style": style2,
      "class": spinClassName
    }), [this.renderIndicator(prefixCls2), tip ? createVNode("div", {
      "class": "".concat(prefixCls2, "-text")
    }, [tip]) : null]);
    var children = getSlot$1(this);
    if (children && children.length) {
      var _containerClassName;
      var containerClassName = (_containerClassName = {}, _defineProperty$R(_containerClassName, "".concat(prefixCls2, "-container"), true), _defineProperty$R(_containerClassName, "".concat(prefixCls2, "-blur"), sSpinning), _containerClassName);
      return createVNode("div", {
        "class": ["".concat(prefixCls2, "-nested-loading"), wrapperClassName]
      }, [sSpinning && createVNode("div", {
        "key": "loading"
      }, [spinElement]), createVNode("div", {
        "class": containerClassName,
        "key": "container"
      }, [children])]);
    }
    return spinElement;
  }
});
Spin.setDefaultIndicator = setDefaultIndicator;
Spin.install = function(app) {
  app.component(Spin.name, Spin);
  return app;
};
var MiniSelect = defineComponent({
  inheritAttrs: false,
  props: selectProps(),
  Option: Select$1.Option,
  setup: function setup109(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    return function() {
      var selelctProps = _extends$2(_extends$2(_extends$2({}, props2), {
        size: "small"
      }), attrs);
      return createVNode(Select$1, selelctProps, slots);
    };
  }
});
var Pager = defineComponent({
  name: "Pager",
  inheritAttrs: false,
  props: {
    rootPrefixCls: String,
    page: Number,
    active: {
      type: Boolean,
      default: void 0
    },
    last: {
      type: Boolean,
      default: void 0
    },
    locale: PropTypes$1.object,
    showTitle: {
      type: Boolean,
      default: void 0
    },
    itemRender: {
      type: Function,
      default: function _default6() {
      }
    },
    onClick: {
      type: Function
    },
    onKeypress: {
      type: Function
    }
  },
  eimt: ["click", "keypress"],
  setup: function setup110(props2, _ref) {
    var emit = _ref.emit, attrs = _ref.attrs;
    var handleClick = function handleClick2() {
      emit("click", props2.page);
    };
    var handleKeyPress = function handleKeyPress2(event) {
      emit("keypress", event, handleClick, props2.page);
    };
    return function() {
      var _classNames;
      var showTitle = props2.showTitle, page = props2.page, itemRender2 = props2.itemRender;
      var _cls = attrs.class, style2 = attrs.style;
      var prefixCls2 = "".concat(props2.rootPrefixCls, "-item");
      var cls = classNames(prefixCls2, "".concat(prefixCls2, "-").concat(props2.page), (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-active"), props2.active), _defineProperty$R(_classNames, "".concat(prefixCls2, "-disabled"), !props2.page), _classNames), _cls);
      return createVNode("li", {
        "onClick": handleClick,
        "onKeypress": handleKeyPress,
        "title": showTitle ? String(page) : null,
        "tabindex": "0",
        "class": cls,
        "style": style2
      }, [itemRender2({
        page,
        type: "page",
        originalElement: createVNode("a", {
          "rel": "nofollow"
        }, [page])
      })]);
    };
  }
});
var KEYCODE = {
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};
var Options = defineComponent({
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    changeSize: Function,
    quickGo: Function,
    selectComponentClass: PropTypes$1.any,
    current: Number,
    pageSizeOptions: PropTypes$1.array.def(["10", "20", "50", "100"]),
    pageSize: Number,
    buildOptionText: Function,
    locale: PropTypes$1.object,
    rootPrefixCls: String,
    selectPrefixCls: String,
    goButton: PropTypes$1.any
  },
  setup: function setup111(props2) {
    var goInputText = ref("");
    var validValue = computed(function() {
      return !goInputText.value || isNaN(goInputText.value) ? void 0 : Number(goInputText.value);
    });
    var defaultBuildOptionText = function defaultBuildOptionText2(opt) {
      return "".concat(opt.value, " ").concat(props2.locale.items_per_page);
    };
    var handleChange2 = function handleChange3(e2) {
      var _e$target = e2.target, value = _e$target.value, composing = _e$target.composing;
      if (e2.isComposing || composing || goInputText.value === value)
        return;
      goInputText.value = value;
    };
    var handleBlur = function handleBlur2(e2) {
      var goButton = props2.goButton, quickGo = props2.quickGo, rootPrefixCls = props2.rootPrefixCls;
      if (goButton || goInputText.value === "") {
        return;
      }
      if (e2.relatedTarget && (e2.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e2.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
        goInputText.value = "";
        return;
      } else {
        quickGo(validValue.value);
        goInputText.value = "";
      }
    };
    var go = function go2(e2) {
      if (goInputText.value === "") {
        return;
      }
      if (e2.keyCode === KEYCODE.ENTER || e2.type === "click") {
        props2.quickGo(validValue.value);
        goInputText.value = "";
      }
    };
    var pageSizeOptions = computed(function() {
      var pageSize2 = props2.pageSize, pageSizeOptions2 = props2.pageSizeOptions;
      if (pageSizeOptions2.some(function(option2) {
        return option2.toString() === pageSize2.toString();
      })) {
        return pageSizeOptions2;
      }
      return pageSizeOptions2.concat([pageSize2.toString()]).sort(function(a2, b2) {
        var numberA = isNaN(Number(a2)) ? 0 : Number(a2);
        var numberB = isNaN(Number(b2)) ? 0 : Number(b2);
        return numberA - numberB;
      });
    });
    return function() {
      var rootPrefixCls = props2.rootPrefixCls, locale2 = props2.locale, changeSize = props2.changeSize, quickGo = props2.quickGo, goButton = props2.goButton, Select2 = props2.selectComponentClass, selectPrefixCls = props2.selectPrefixCls, pageSize2 = props2.pageSize, disabled = props2.disabled;
      var prefixCls2 = "".concat(rootPrefixCls, "-options");
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;
      if (!changeSize && !quickGo) {
        return null;
      }
      if (changeSize && Select2) {
        var buildOptionText = props2.buildOptionText || defaultBuildOptionText;
        var options = pageSizeOptions.value.map(function(opt, i2) {
          return createVNode(Select2.Option, {
            "key": i2,
            "value": opt
          }, {
            default: function _default7() {
              return [buildOptionText({
                value: opt
              })];
            }
          });
        });
        changeSelect = createVNode(Select2, {
          "disabled": disabled,
          "prefixCls": selectPrefixCls,
          "showSearch": false,
          "class": "".concat(prefixCls2, "-size-changer"),
          "optionLabelProp": "children",
          "value": (pageSize2 || pageSizeOptions.value[0]).toString(),
          "onChange": function onChange3(value) {
            return changeSize(Number(value));
          },
          "getPopupContainer": function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          }
        }, {
          default: function _default7() {
            return [options];
          }
        });
      }
      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === "boolean" ? createVNode("button", {
            "type": "button",
            "onClick": go,
            "onKeyup": go,
            "disabled": disabled,
            "class": "".concat(prefixCls2, "-quick-jumper-button")
          }, [locale2.jump_to_confirm]) : createVNode("span", {
            "onClick": go,
            "onKeyup": go
          }, [goButton]);
        }
        goInput = createVNode("div", {
          "class": "".concat(prefixCls2, "-quick-jumper")
        }, [locale2.jump_to, withDirectives(createVNode("input", {
          "disabled": disabled,
          "type": "text",
          "value": goInputText.value,
          "onInput": handleChange2,
          "onChange": handleChange2,
          "onKeyup": go,
          "onBlur": handleBlur
        }, null), [[antInputDirective]]), locale2.page, gotoButton]);
      }
      return createVNode("li", {
        "class": "".concat(prefixCls2)
      }, [changeSelect, goInput]);
    };
  }
});
var LOCALE = {
  items_per_page: "\u6761/\u9875",
  jump_to: "\u8DF3\u81F3",
  jump_to_confirm: "\u786E\u5B9A",
  page: "\u9875",
  prev_page: "\u4E0A\u4E00\u9875",
  next_page: "\u4E0B\u4E00\u9875",
  prev_5: "\u5411\u524D 5 \u9875",
  next_5: "\u5411\u540E 5 \u9875",
  prev_3: "\u5411\u524D 3 \u9875",
  next_3: "\u5411\u540E 3 \u9875"
};
var __rest$i = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function isInteger(value) {
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function defaultItemRender(_ref) {
  var originalElement = _ref.originalElement;
  return originalElement;
}
function calculatePage(p2, state, props2) {
  var pageSize2 = typeof p2 === "undefined" ? state.statePageSize : p2;
  return Math.floor((props2.total - 1) / pageSize2) + 1;
}
var VcPagination = defineComponent({
  name: "Pagination",
  mixins: [BaseMixin],
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    prefixCls: PropTypes$1.string.def("rc-pagination"),
    selectPrefixCls: PropTypes$1.string.def("rc-select"),
    current: Number,
    defaultCurrent: PropTypes$1.number.def(1),
    total: PropTypes$1.number.def(0),
    pageSize: Number,
    defaultPageSize: PropTypes$1.number.def(10),
    hideOnSinglePage: {
      type: Boolean,
      default: false
    },
    showSizeChanger: {
      type: Boolean,
      default: void 0
    },
    showLessItems: {
      type: Boolean,
      default: false
    },
    selectComponentClass: PropTypes$1.any,
    showPrevNextJumpers: {
      type: Boolean,
      default: true
    },
    showQuickJumper: PropTypes$1.oneOfType([PropTypes$1.looseBool, PropTypes$1.object]).def(false),
    showTitle: {
      type: Boolean,
      default: true
    },
    pageSizeOptions: PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])),
    buildOptionText: Function,
    showTotal: Function,
    simple: {
      type: Boolean,
      default: void 0
    },
    locale: PropTypes$1.object.def(LOCALE),
    itemRender: PropTypes$1.func.def(defaultItemRender),
    prevIcon: PropTypes$1.any,
    nextIcon: PropTypes$1.any,
    jumpPrevIcon: PropTypes$1.any,
    jumpNextIcon: PropTypes$1.any,
    totalBoundaryShowSizeChanger: PropTypes$1.number.def(50)
  },
  data: function data3() {
    var props2 = this.$props;
    var current2 = firstNotUndefined([this.current, this.defaultCurrent]);
    var pageSize2 = firstNotUndefined([this.pageSize, this.defaultPageSize]);
    current2 = Math.min(current2, calculatePage(pageSize2, void 0, props2));
    return {
      stateCurrent: current2,
      stateCurrentInputValue: current2,
      statePageSize: pageSize2
    };
  },
  watch: {
    current: function current(val) {
      this.setState({
        stateCurrent: val,
        stateCurrentInputValue: val
      });
    },
    pageSize: function pageSize(val) {
      var newState = {};
      var current2 = this.stateCurrent;
      var newCurrent = calculatePage(val, this.$data, this.$props);
      current2 = current2 > newCurrent ? newCurrent : current2;
      if (!hasProp(this, "current")) {
        newState.stateCurrent = current2;
        newState.stateCurrentInputValue = current2;
      }
      newState.statePageSize = val;
      this.setState(newState);
    },
    stateCurrent: function stateCurrent(_val, oldValue) {
      var _this = this;
      this.$nextTick(function() {
        if (_this.$refs.paginationNode) {
          var lastCurrentNode = _this.$refs.paginationNode.querySelector(".".concat(_this.prefixCls, "-item-").concat(oldValue));
          if (lastCurrentNode && document.activeElement === lastCurrentNode) {
            lastCurrentNode.blur();
          }
        }
      });
    },
    total: function total() {
      var newState = {};
      var newCurrent = calculatePage(this.pageSize, this.$data, this.$props);
      if (hasProp(this, "current")) {
        var current2 = Math.min(this.current, newCurrent);
        newState.stateCurrent = current2;
        newState.stateCurrentInputValue = current2;
      } else {
        var _current = this.stateCurrent;
        if (_current === 0 && newCurrent > 0) {
          _current = 1;
        } else {
          _current = Math.min(this.stateCurrent, newCurrent);
        }
        newState.stateCurrent = _current;
      }
      this.setState(newState);
    }
  },
  methods: {
    getJumpPrevPage: function getJumpPrevPage() {
      return Math.max(1, this.stateCurrent - (this.showLessItems ? 3 : 5));
    },
    getJumpNextPage: function getJumpNextPage() {
      return Math.min(calculatePage(void 0, this.$data, this.$props), this.stateCurrent + (this.showLessItems ? 3 : 5));
    },
    getItemIcon: function getItemIcon(icon, label) {
      var prefixCls2 = this.$props.prefixCls;
      var iconNode = getComponent(this, icon, this.$props) || createVNode("button", {
        "type": "button",
        "aria-label": label,
        "class": "".concat(prefixCls2, "-item-link")
      }, null);
      return iconNode;
    },
    getValidValue: function getValidValue(e2) {
      var inputValue = e2.target.value;
      var allPages = calculatePage(void 0, this.$data, this.$props);
      var stateCurrentInputValue = this.$data.stateCurrentInputValue;
      var value;
      if (inputValue === "") {
        value = inputValue;
      } else if (isNaN(Number(inputValue))) {
        value = stateCurrentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }
      return value;
    },
    isValid: function isValid4(page) {
      return isInteger(page) && page !== this.stateCurrent;
    },
    shouldDisplayQuickJumper: function shouldDisplayQuickJumper() {
      var _this$$props = this.$props, showQuickJumper = _this$$props.showQuickJumper, pageSize2 = _this$$props.pageSize, total3 = _this$$props.total;
      if (total3 <= pageSize2) {
        return false;
      }
      return showQuickJumper;
    },
    handleKeyDown: function handleKeyDown(event) {
      if (event.keyCode === KEYCODE.ARROW_UP || event.keyCode === KEYCODE.ARROW_DOWN) {
        event.preventDefault();
      }
    },
    handleKeyUp: function handleKeyUp(e2) {
      if (e2.isComposing || e2.target.composing)
        return;
      var value = this.getValidValue(e2);
      var stateCurrentInputValue = this.stateCurrentInputValue;
      if (value !== stateCurrentInputValue) {
        this.setState({
          stateCurrentInputValue: value
        });
      }
      if (e2.keyCode === KEYCODE.ENTER) {
        this.handleChange(value);
      } else if (e2.keyCode === KEYCODE.ARROW_UP) {
        this.handleChange(value - 1);
      } else if (e2.keyCode === KEYCODE.ARROW_DOWN) {
        this.handleChange(value + 1);
      }
    },
    changePageSize: function changePageSize(size) {
      var current2 = this.stateCurrent;
      var preCurrent = current2;
      var newCurrent = calculatePage(size, this.$data, this.$props);
      current2 = current2 > newCurrent ? newCurrent : current2;
      if (newCurrent === 0) {
        current2 = this.stateCurrent;
      }
      if (typeof size === "number") {
        if (!hasProp(this, "pageSize")) {
          this.setState({
            statePageSize: size
          });
        }
        if (!hasProp(this, "current")) {
          this.setState({
            stateCurrent: current2,
            stateCurrentInputValue: current2
          });
        }
      }
      this.__emit("update:pageSize", size);
      if (current2 !== preCurrent) {
        this.__emit("update:current", current2);
      }
      this.__emit("showSizeChange", current2, size);
      this.__emit("change", current2, size);
    },
    handleChange: function handleChange(p2) {
      var disabled = this.$props.disabled;
      var page = p2;
      if (this.isValid(page) && !disabled) {
        var currentPage = calculatePage(void 0, this.$data, this.$props);
        if (page > currentPage) {
          page = currentPage;
        } else if (page < 1) {
          page = 1;
        }
        if (!hasProp(this, "current")) {
          this.setState({
            stateCurrent: page,
            stateCurrentInputValue: page
          });
        }
        this.__emit("update:current", page);
        this.__emit("change", page, this.statePageSize);
        return page;
      }
      return this.stateCurrent;
    },
    prev: function prev() {
      if (this.hasPrev()) {
        this.handleChange(this.stateCurrent - 1);
      }
    },
    next: function next() {
      if (this.hasNext()) {
        this.handleChange(this.stateCurrent + 1);
      }
    },
    jumpPrev: function jumpPrev() {
      this.handleChange(this.getJumpPrevPage());
    },
    jumpNext: function jumpNext() {
      this.handleChange(this.getJumpNextPage());
    },
    hasPrev: function hasPrev() {
      return this.stateCurrent > 1;
    },
    hasNext: function hasNext() {
      return this.stateCurrent < calculatePage(void 0, this.$data, this.$props);
    },
    getShowSizeChanger: function getShowSizeChanger() {
      var _this$$props2 = this.$props, showSizeChanger = _this$$props2.showSizeChanger, total3 = _this$$props2.total, totalBoundaryShowSizeChanger = _this$$props2.totalBoundaryShowSizeChanger;
      if (typeof showSizeChanger !== "undefined") {
        return showSizeChanger;
      }
      return total3 > totalBoundaryShowSizeChanger;
    },
    runIfEnter: function runIfEnter(event, callback) {
      if (event.key === "Enter" || event.charCode === 13) {
        for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          restParams[_key - 2] = arguments[_key];
        }
        callback.apply(void 0, restParams);
      }
    },
    runIfEnterPrev: function runIfEnterPrev(event) {
      this.runIfEnter(event, this.prev);
    },
    runIfEnterNext: function runIfEnterNext(event) {
      this.runIfEnter(event, this.next);
    },
    runIfEnterJumpPrev: function runIfEnterJumpPrev(event) {
      this.runIfEnter(event, this.jumpPrev);
    },
    runIfEnterJumpNext: function runIfEnterJumpNext(event) {
      this.runIfEnter(event, this.jumpNext);
    },
    handleGoTO: function handleGoTO(event) {
      if (event.keyCode === KEYCODE.ENTER || event.type === "click") {
        this.handleChange(this.stateCurrentInputValue);
      }
    },
    renderPrev: function renderPrev(prevPage) {
      var itemRender2 = this.$props.itemRender;
      var prevButton = itemRender2({
        page: prevPage,
        type: "prev",
        originalElement: this.getItemIcon("prevIcon", "prev page")
      });
      var disabled = !this.hasPrev();
      return isValidElement(prevButton) ? cloneElement(prevButton, disabled ? {
        disabled
      } : {}) : prevButton;
    },
    renderNext: function renderNext(nextPage) {
      var itemRender2 = this.$props.itemRender;
      var nextButton = itemRender2({
        page: nextPage,
        type: "next",
        originalElement: this.getItemIcon("nextIcon", "next page")
      });
      var disabled = !this.hasNext();
      return isValidElement(nextButton) ? cloneElement(nextButton, disabled ? {
        disabled
      } : {}) : nextButton;
    }
  },
  render: function render8() {
    var _classNames6;
    var _this$$props3 = this.$props, prefixCls2 = _this$$props3.prefixCls, disabled = _this$$props3.disabled, hideOnSinglePage = _this$$props3.hideOnSinglePage, total3 = _this$$props3.total, locale2 = _this$$props3.locale, showQuickJumper = _this$$props3.showQuickJumper, showLessItems = _this$$props3.showLessItems, showTitle = _this$$props3.showTitle, showTotal = _this$$props3.showTotal, simple = _this$$props3.simple, itemRender2 = _this$$props3.itemRender, showPrevNextJumpers = _this$$props3.showPrevNextJumpers, jumpPrevIcon = _this$$props3.jumpPrevIcon, jumpNextIcon = _this$$props3.jumpNextIcon, selectComponentClass = _this$$props3.selectComponentClass, selectPrefixCls = _this$$props3.selectPrefixCls, pageSizeOptions = _this$$props3.pageSizeOptions;
    var stateCurrent2 = this.stateCurrent, statePageSize = this.statePageSize;
    var _a2 = splitAttrs(this.$attrs).extraAttrs, className = _a2.class, restAttrs = __rest$i(_a2, ["class"]);
    if (hideOnSinglePage === true && this.total <= statePageSize) {
      return null;
    }
    var allPages = calculatePage(void 0, this.$data, this.$props);
    var pagerList = [];
    var jumpPrev2 = null;
    var jumpNext2 = null;
    var firstPager = null;
    var lastPager = null;
    var gotoButton = null;
    var goButton = showQuickJumper && showQuickJumper.goButton;
    var pageBufferSize = showLessItems ? 1 : 2;
    var prevPage = stateCurrent2 - 1 > 0 ? stateCurrent2 - 1 : 0;
    var nextPage = stateCurrent2 + 1 < allPages ? stateCurrent2 + 1 : allPages;
    var hasPrev2 = this.hasPrev();
    var hasNext2 = this.hasNext();
    if (simple) {
      if (goButton) {
        if (typeof goButton === "boolean") {
          gotoButton = createVNode("button", {
            "type": "button",
            "onClick": this.handleGoTO,
            "onKeyup": this.handleGoTO
          }, [locale2.jump_to_confirm]);
        } else {
          gotoButton = createVNode("span", {
            "onClick": this.handleGoTO,
            "onKeyup": this.handleGoTO
          }, [goButton]);
        }
        gotoButton = createVNode("li", {
          "title": showTitle ? "".concat(locale2.jump_to).concat(stateCurrent2, "/").concat(allPages) : null,
          "class": "".concat(prefixCls2, "-simple-pager")
        }, [gotoButton]);
      }
      return createVNode("ul", _objectSpread2$2({
        "class": classNames("".concat(prefixCls2, " ").concat(prefixCls2, "-simple"), _defineProperty$R({}, "".concat(prefixCls2, "-disabled"), disabled), className)
      }, restAttrs), [createVNode("li", {
        "title": showTitle ? locale2.prev_page : null,
        "onClick": this.prev,
        "tabindex": hasPrev2 ? 0 : null,
        "onKeypress": this.runIfEnterPrev,
        "class": classNames("".concat(prefixCls2, "-prev"), _defineProperty$R({}, "".concat(prefixCls2, "-disabled"), !hasPrev2)),
        "aria-disabled": !hasPrev2
      }, [this.renderPrev(prevPage)]), createVNode("li", {
        "title": showTitle ? "".concat(stateCurrent2, "/").concat(allPages) : null,
        "class": "".concat(prefixCls2, "-simple-pager")
      }, [withDirectives(createVNode("input", {
        "type": "text",
        "value": this.stateCurrentInputValue,
        "disabled": disabled,
        "onKeydown": this.handleKeyDown,
        "onKeyup": this.handleKeyUp,
        "onInput": this.handleKeyUp,
        "onChange": this.handleKeyUp,
        "size": "3"
      }, null), [[antInputDirective]]), createVNode("span", {
        "class": "".concat(prefixCls2, "-slash")
      }, [createTextVNode("\uFF0F")]), allPages]), createVNode("li", {
        "title": showTitle ? locale2.next_page : null,
        "onClick": this.next,
        "tabindex": hasNext2 ? 0 : null,
        "onKeypress": this.runIfEnterNext,
        "class": classNames("".concat(prefixCls2, "-next"), _defineProperty$R({}, "".concat(prefixCls2, "-disabled"), !hasNext2)),
        "aria-disabled": !hasNext2
      }, [this.renderNext(nextPage)]), gotoButton]);
    }
    if (allPages <= 3 + pageBufferSize * 2) {
      var pagerProps = {
        locale: locale2,
        rootPrefixCls: prefixCls2,
        showTitle,
        itemRender: itemRender2,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter
      };
      if (!allPages) {
        pagerList.push(createVNode(Pager, _objectSpread2$2(_objectSpread2$2({}, pagerProps), {}, {
          "key": "noPager",
          "page": 1,
          "class": "".concat(prefixCls2, "-item-disabled")
        }), null));
      }
      for (var i2 = 1; i2 <= allPages; i2 += 1) {
        var active = stateCurrent2 === i2;
        pagerList.push(createVNode(Pager, _objectSpread2$2(_objectSpread2$2({}, pagerProps), {}, {
          "key": i2,
          "page": i2,
          "active": active
        }), null));
      }
    } else {
      var prevItemTitle = showLessItems ? locale2.prev_3 : locale2.prev_5;
      var nextItemTitle = showLessItems ? locale2.next_3 : locale2.next_5;
      if (showPrevNextJumpers) {
        jumpPrev2 = createVNode("li", {
          "title": this.showTitle ? prevItemTitle : null,
          "key": "prev",
          "onClick": this.jumpPrev,
          "tabindex": "0",
          "onKeypress": this.runIfEnterJumpPrev,
          "class": classNames("".concat(prefixCls2, "-jump-prev"), _defineProperty$R({}, "".concat(prefixCls2, "-jump-prev-custom-icon"), !!jumpPrevIcon))
        }, [itemRender2({
          page: this.getJumpPrevPage(),
          type: "jump-prev",
          originalElement: this.getItemIcon("jumpPrevIcon", "prev page")
        })]);
        jumpNext2 = createVNode("li", {
          "title": this.showTitle ? nextItemTitle : null,
          "key": "next",
          "tabindex": "0",
          "onClick": this.jumpNext,
          "onKeypress": this.runIfEnterJumpNext,
          "class": classNames("".concat(prefixCls2, "-jump-next"), _defineProperty$R({}, "".concat(prefixCls2, "-jump-next-custom-icon"), !!jumpNextIcon))
        }, [itemRender2({
          page: this.getJumpNextPage(),
          type: "jump-next",
          originalElement: this.getItemIcon("jumpNextIcon", "next page")
        })]);
      }
      lastPager = createVNode(Pager, {
        "locale": locale2,
        "last": true,
        "rootPrefixCls": prefixCls2,
        "onClick": this.handleChange,
        "onKeypress": this.runIfEnter,
        "key": allPages,
        "page": allPages,
        "active": false,
        "showTitle": showTitle,
        "itemRender": itemRender2
      }, null);
      firstPager = createVNode(Pager, {
        "locale": locale2,
        "rootPrefixCls": prefixCls2,
        "onClick": this.handleChange,
        "onKeypress": this.runIfEnter,
        "key": 1,
        "page": 1,
        "active": false,
        "showTitle": showTitle,
        "itemRender": itemRender2
      }, null);
      var left = Math.max(1, stateCurrent2 - pageBufferSize);
      var right = Math.min(stateCurrent2 + pageBufferSize, allPages);
      if (stateCurrent2 - 1 <= pageBufferSize) {
        right = 1 + pageBufferSize * 2;
      }
      if (allPages - stateCurrent2 <= pageBufferSize) {
        left = allPages - pageBufferSize * 2;
      }
      for (var _i = left; _i <= right; _i += 1) {
        var _active = stateCurrent2 === _i;
        pagerList.push(createVNode(Pager, {
          "locale": locale2,
          "rootPrefixCls": prefixCls2,
          "onClick": this.handleChange,
          "onKeypress": this.runIfEnter,
          "key": _i,
          "page": _i,
          "active": _active,
          "showTitle": showTitle,
          "itemRender": itemRender2
        }, null));
      }
      if (stateCurrent2 - 1 >= pageBufferSize * 2 && stateCurrent2 !== 1 + 2) {
        pagerList[0] = createVNode(Pager, {
          "locale": locale2,
          "rootPrefixCls": prefixCls2,
          "onClick": this.handleChange,
          "onKeypress": this.runIfEnter,
          "key": left,
          "page": left,
          "class": "".concat(prefixCls2, "-item-after-jump-prev"),
          "active": false,
          "showTitle": this.showTitle,
          "itemRender": itemRender2
        }, null);
        pagerList.unshift(jumpPrev2);
      }
      if (allPages - stateCurrent2 >= pageBufferSize * 2 && stateCurrent2 !== allPages - 2) {
        pagerList[pagerList.length - 1] = createVNode(Pager, {
          "locale": locale2,
          "rootPrefixCls": prefixCls2,
          "onClick": this.handleChange,
          "onKeypress": this.runIfEnter,
          "key": right,
          "page": right,
          "class": "".concat(prefixCls2, "-item-before-jump-next"),
          "active": false,
          "showTitle": this.showTitle,
          "itemRender": itemRender2
        }, null);
        pagerList.push(jumpNext2);
      }
      if (left !== 1) {
        pagerList.unshift(firstPager);
      }
      if (right !== allPages) {
        pagerList.push(lastPager);
      }
    }
    var totalText = null;
    if (showTotal) {
      totalText = createVNode("li", {
        "class": "".concat(prefixCls2, "-total-text")
      }, [showTotal(total3, [total3 === 0 ? 0 : (stateCurrent2 - 1) * statePageSize + 1, stateCurrent2 * statePageSize > total3 ? total3 : stateCurrent2 * statePageSize])]);
    }
    var prevDisabled = !hasPrev2 || !allPages;
    var nextDisabled = !hasNext2 || !allPages;
    var buildOptionText = this.buildOptionText || this.$slots.buildOptionText;
    return createVNode("ul", _objectSpread2$2(_objectSpread2$2({
      "unselectable": "on",
      "ref": "paginationNode"
    }, restAttrs), {}, {
      "class": classNames((_classNames6 = {}, _defineProperty$R(_classNames6, "".concat(prefixCls2), true), _defineProperty$R(_classNames6, "".concat(prefixCls2, "-disabled"), disabled), _classNames6), className)
    }), [totalText, createVNode("li", {
      "title": showTitle ? locale2.prev_page : null,
      "onClick": this.prev,
      "tabindex": prevDisabled ? null : 0,
      "onKeypress": this.runIfEnterPrev,
      "class": classNames("".concat(prefixCls2, "-prev"), _defineProperty$R({}, "".concat(prefixCls2, "-disabled"), prevDisabled)),
      "aria-disabled": prevDisabled
    }, [this.renderPrev(prevPage)]), pagerList, createVNode("li", {
      "title": showTitle ? locale2.next_page : null,
      "onClick": this.next,
      "tabindex": nextDisabled ? null : 0,
      "onKeypress": this.runIfEnterNext,
      "class": classNames("".concat(prefixCls2, "-next"), _defineProperty$R({}, "".concat(prefixCls2, "-disabled"), nextDisabled)),
      "aria-disabled": nextDisabled
    }, [this.renderNext(nextPage)]), createVNode(Options, {
      "disabled": disabled,
      "locale": locale2,
      "rootPrefixCls": prefixCls2,
      "selectComponentClass": selectComponentClass,
      "selectPrefixCls": selectPrefixCls,
      "changeSize": this.getShowSizeChanger() ? this.changePageSize : null,
      "current": stateCurrent2,
      "pageSize": statePageSize,
      "pageSizeOptions": pageSizeOptions,
      "buildOptionText": buildOptionText || null,
      "quickGo": this.shouldDisplayQuickJumper() ? this.handleChange : null,
      "goButton": goButton
    }, null)]);
  }
});
var __rest$h = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var paginationProps = function paginationProps2() {
  return {
    total: Number,
    defaultCurrent: Number,
    disabled: {
      type: Boolean,
      default: void 0
    },
    current: Number,
    defaultPageSize: Number,
    pageSize: Number,
    hideOnSinglePage: {
      type: Boolean,
      default: void 0
    },
    showSizeChanger: {
      type: Boolean,
      default: void 0
    },
    pageSizeOptions: Array,
    buildOptionText: Function,
    showQuickJumper: {
      type: [Boolean, Object],
      default: void 0
    },
    showTotal: Function,
    size: String,
    simple: {
      type: Boolean,
      default: void 0
    },
    locale: Object,
    prefixCls: String,
    selectPrefixCls: String,
    totalBoundaryShowSizeChanger: Number,
    selectComponentClass: String,
    itemRender: Function,
    role: String,
    responsive: Boolean,
    showLessItems: {
      type: Boolean,
      default: void 0
    },
    onChange: Function,
    onShowSizeChange: Function,
    "onUpdate:current": Function,
    "onUpdate:pageSize": Function
  };
};
var Pagination$2 = defineComponent({
  name: "APagination",
  inheritAttrs: false,
  props: paginationProps(),
  setup: function setup112(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("pagination", props2), prefixCls2 = _useConfigInject.prefixCls, configProvider = _useConfigInject.configProvider, direction2 = _useConfigInject.direction;
    var selectPrefixCls = computed(function() {
      return configProvider.getPrefixCls("select", props2.selectPrefixCls);
    });
    var breakpoint = useBreakpoint();
    var _useLocaleReceiver = useLocaleReceiver("Pagination", enUS$1, toRef(props2, "locale")), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    var getIconsProps = function getIconsProps2(pre) {
      var ellipsis = createVNode("span", {
        "class": "".concat(pre, "-item-ellipsis")
      }, [createTextVNode("\u2022\u2022\u2022")]);
      var prevIcon = createVNode("button", {
        "class": "".concat(pre, "-item-link"),
        "type": "button",
        "tabindex": -1
      }, [createVNode(LeftOutlined$1, null, null)]);
      var nextIcon = createVNode("button", {
        "class": "".concat(pre, "-item-link"),
        "type": "button",
        "tabindex": -1
      }, [createVNode(RightOutlined$1, null, null)]);
      var jumpPrevIcon = createVNode("a", {
        "rel": "nofollow",
        "class": "".concat(pre, "-item-link")
      }, [createVNode("div", {
        "class": "".concat(pre, "-item-container")
      }, [createVNode(DoubleLeftOutlined$1, {
        "class": "".concat(pre, "-item-link-icon")
      }, null), ellipsis])]);
      var jumpNextIcon = createVNode("a", {
        "rel": "nofollow",
        "class": "".concat(pre, "-item-link")
      }, [createVNode("div", {
        "class": "".concat(pre, "-item-container")
      }, [createVNode(DoubleRightOutlined$1, {
        "class": "".concat(pre, "-item-link-icon")
      }, null), ellipsis])]);
      if (direction2.value === "rtl") {
        var _ref2 = [nextIcon, prevIcon];
        prevIcon = _ref2[0];
        nextIcon = _ref2[1];
        var _ref3 = [jumpNextIcon, jumpPrevIcon];
        jumpPrevIcon = _ref3[0];
        jumpNextIcon = _ref3[1];
      }
      return {
        prevIcon,
        nextIcon,
        jumpPrevIcon,
        jumpNextIcon
      };
    };
    return function() {
      var _a2;
      var size = props2.size, _props$itemRender = props2.itemRender, itemRender2 = _props$itemRender === void 0 ? slots.itemRender : _props$itemRender, _props$buildOptionTex = props2.buildOptionText, buildOptionText = _props$buildOptionTex === void 0 ? slots.buildOptionText : _props$buildOptionTex, selectComponentClass = props2.selectComponentClass, responsive = props2.responsive, restProps = __rest$h(props2, ["size", "itemRender", "buildOptionText", "selectComponentClass", "responsive"]);
      var isSmall = size === "small" || !!(((_a2 = breakpoint.value) === null || _a2 === void 0 ? void 0 : _a2.xs) && !size && responsive);
      var paginationProps3 = _extends$2(_extends$2(_extends$2(_extends$2(_extends$2({}, restProps), getIconsProps(prefixCls2.value)), {
        prefixCls: prefixCls2.value,
        selectPrefixCls: selectPrefixCls.value,
        selectComponentClass: selectComponentClass || (isSmall ? MiniSelect : Select$1),
        locale: locale2.value,
        buildOptionText
      }), attrs), {
        class: classNames(_defineProperty$R({
          mini: isSmall
        }, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), attrs.class),
        itemRender: itemRender2
      });
      return createVNode(VcPagination, paginationProps3, null);
    };
  }
});
var Pagination$1 = withInstall$2(Pagination$2);
var __rest$g = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var mousePosition = null;
var getClickPosition = function getClickPosition2(e2) {
  mousePosition = {
    x: e2.pageX,
    y: e2.pageY
  };
  setTimeout(function() {
    return mousePosition = null;
  }, 100);
};
if (canUseDocElement()) {
  addEventListenerWrap(document.documentElement, "click", getClickPosition, true);
}
var modalProps = function modalProps2() {
  return {
    prefixCls: String,
    visible: {
      type: Boolean,
      default: void 0
    },
    confirmLoading: {
      type: Boolean,
      default: void 0
    },
    title: PropTypes$1.any,
    closable: {
      type: Boolean,
      default: void 0
    },
    closeIcon: PropTypes$1.any,
    onOk: Function,
    onCancel: Function,
    "onUpdate:visible": Function,
    onChange: Function,
    afterClose: Function,
    centered: {
      type: Boolean,
      default: void 0
    },
    width: [String, Number],
    footer: PropTypes$1.any,
    okText: PropTypes$1.any,
    okType: String,
    cancelText: PropTypes$1.any,
    icon: PropTypes$1.any,
    maskClosable: {
      type: Boolean,
      default: void 0
    },
    forceRender: {
      type: Boolean,
      default: void 0
    },
    okButtonProps: Object,
    cancelButtonProps: Object,
    destroyOnClose: {
      type: Boolean,
      default: void 0
    },
    wrapClassName: String,
    maskTransitionName: String,
    transitionName: String,
    getContainer: {
      type: [String, Function, Boolean, Object],
      default: void 0
    },
    zIndex: Number,
    bodyStyle: {
      type: Object,
      default: void 0
    },
    maskStyle: {
      type: Object,
      default: void 0
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    keyboard: {
      type: Boolean,
      default: void 0
    },
    wrapProps: Object,
    focusTriggerAfterClose: {
      type: Boolean,
      default: void 0
    },
    modalRender: Function
  };
};
var destroyFns = [];
var Modal$1 = defineComponent({
  name: "AModal",
  inheritAttrs: false,
  props: initDefaultProps$1(modalProps(), {
    width: 520,
    transitionName: "zoom",
    maskTransitionName: "fade",
    confirmLoading: false,
    visible: false,
    okType: "primary"
  }),
  setup: function setup113(props2, _ref) {
    var emit = _ref.emit, slots = _ref.slots, attrs = _ref.attrs;
    var _useLocaleReceiver = useLocaleReceiver("Modal"), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    var _useConfigInject = useConfigInject("modal", props2), prefixCls2 = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer;
    var handleCancel = function handleCancel2(e2) {
      emit("update:visible", false);
      emit("cancel", e2);
      emit("change", false);
    };
    var handleOk = function handleOk2(e2) {
      emit("ok", e2);
    };
    var renderFooter = function renderFooter2() {
      var _a2, _b;
      var _props$okText = props2.okText, okText = _props$okText === void 0 ? (_a2 = slots.okText) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$okText, okType = props2.okType, _props$cancelText = props2.cancelText, cancelText = _props$cancelText === void 0 ? (_b = slots.cancelText) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$cancelText, confirmLoading = props2.confirmLoading;
      return createVNode(Fragment, null, [createVNode(Button$2, _objectSpread2$2({
        "onClick": handleCancel
      }, props2.cancelButtonProps), {
        default: function _default7() {
          return [cancelText || locale2.value.cancelText];
        }
      }), createVNode(Button$2, _objectSpread2$2(_objectSpread2$2({}, convertLegacyProps(okType)), {}, {
        "loading": confirmLoading,
        "onClick": handleOk
      }, props2.okButtonProps), {
        default: function _default7() {
          return [okText || locale2.value.okText];
        }
      })]);
    };
    return function() {
      var _classNames;
      var _a2;
      props2.prefixCls;
      var visible = props2.visible, wrapClassName = props2.wrapClassName, centered = props2.centered, getContainer4 = props2.getContainer, _props$closeIcon = props2.closeIcon, _closeIcon = _props$closeIcon === void 0 ? (_a2 = slots.closeIcon) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$closeIcon, _props$focusTriggerAf = props2.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, restProps = __rest$g(props2, ["prefixCls", "visible", "wrapClassName", "centered", "getContainer", "closeIcon", "focusTriggerAfterClose"]);
      var wrapClassNameExtended = classNames(wrapClassName, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-centered"), !!centered), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-wrap-rtl"), direction2.value === "rtl"), _classNames));
      return createVNode(DialogWrap$1, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, restProps), attrs), {}, {
        "getContainer": getContainer4 || getPopupContainer.value,
        "prefixCls": prefixCls2.value,
        "wrapClassName": wrapClassNameExtended,
        "visible": visible,
        "mousePosition": mousePosition,
        "onClose": handleCancel,
        "focusTriggerAfterClose": focusTriggerAfterClose,
        "transitionName": getTransitionName$2(rootPrefixCls.value, "zoom", props2.transitionName),
        "maskTransitionName": getTransitionName$2(rootPrefixCls.value, "fade", props2.maskTransitionName)
      }), _extends$2(_extends$2({}, slots), {
        footer: slots.footer || renderFooter,
        closeIcon: function closeIcon() {
          return createVNode("span", {
            "class": "".concat(prefixCls2.value, "-close-x")
          }, [_closeIcon || createVNode(CloseOutlined$1, {
            "class": "".concat(prefixCls2.value, "-close-icon")
          }, null)]);
        }
      }));
    };
  }
});
var useDestroyed = function useDestroyed2() {
  var destroyed = ref(false);
  onBeforeUnmount(function() {
    destroyed.value = true;
  });
  return destroyed;
};
var useDestroyed$1 = useDestroyed;
var actionButtonProps = {
  type: {
    type: String
  },
  actionFn: Function,
  close: Function,
  autofocus: Boolean,
  prefixCls: String,
  buttonProps: Object,
  emitEvent: Boolean,
  quitOnNullishReturnValue: Boolean
};
function isThenable(thing) {
  return !!(thing && !!thing.then);
}
var ActionButton = defineComponent({
  name: "ActionButton",
  props: actionButtonProps,
  setup: function setup114(props2, _ref) {
    var slots = _ref.slots;
    var clickedRef = ref(false);
    var buttonRef = ref();
    var loading = ref(false);
    var timeoutId;
    var isDestroyed = useDestroyed$1();
    onMounted(function() {
      if (props2.autofocus) {
        timeoutId = setTimeout(function() {
          var _a2;
          return (_a2 = buttonRef.value.$el) === null || _a2 === void 0 ? void 0 : _a2.focus();
        });
      }
    });
    onBeforeUnmount(function() {
      clearTimeout(timeoutId);
    });
    var handlePromiseOnOk = function handlePromiseOnOk2(returnValueOfOnOk) {
      var close3 = props2.close;
      if (!isThenable(returnValueOfOnOk)) {
        return;
      }
      loading.value = true;
      returnValueOfOnOk.then(function() {
        if (!isDestroyed.value) {
          loading.value = false;
        }
        close3.apply(void 0, arguments);
        clickedRef.value = false;
      }, function(e2) {
        console.error(e2);
        if (!isDestroyed.value) {
          loading.value = false;
        }
        clickedRef.value = false;
      });
    };
    var onClick2 = function onClick3(e2) {
      var actionFn = props2.actionFn, _props$close = props2.close, close3 = _props$close === void 0 ? function() {
      } : _props$close;
      if (clickedRef.value) {
        return;
      }
      clickedRef.value = true;
      if (!actionFn) {
        close3();
        return;
      }
      var returnValueOfOnOk;
      if (props2.emitEvent) {
        returnValueOfOnOk = actionFn(e2);
        if (props2.quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
          clickedRef.value = false;
          close3(e2);
          return;
        }
      } else if (actionFn.length) {
        returnValueOfOnOk = actionFn(close3);
        clickedRef.value = false;
      } else {
        returnValueOfOnOk = actionFn();
        if (!returnValueOfOnOk) {
          close3();
          return;
        }
      }
      handlePromiseOnOk(returnValueOfOnOk);
    };
    return function() {
      var type4 = props2.type, prefixCls2 = props2.prefixCls, buttonProps3 = props2.buttonProps;
      return createVNode(Button$2, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, convertLegacyProps(type4)), {}, {
        "onClick": onClick2,
        "loading": loading.value,
        "prefixCls": prefixCls2
      }, buttonProps3), {}, {
        "ref": buttonRef
      }), slots);
    };
  }
});
function renderSomeContent(someContent) {
  if (typeof someContent === "function") {
    return someContent();
  }
  return someContent;
}
var ConfirmDialog = defineComponent({
  name: "ConfirmDialog",
  inheritAttrs: false,
  props: ["icon", "onCancel", "onOk", "close", "closable", "zIndex", "afterClose", "visible", "keyboard", "centered", "getContainer", "maskStyle", "okButtonProps", "cancelButtonProps", "okType", "prefixCls", "okCancel", "width", "mask", "maskClosable", "okText", "cancelText", "autoFocusButton", "transitionName", "maskTransitionName", "type", "title", "content", "direction", "rootPrefixCls", "bodyStyle", "closeIcon", "modalRender", "focusTriggerAfterClose", "wrapClassName"],
  setup: function setup115(props2, _ref) {
    var attrs = _ref.attrs;
    var _useLocaleReceiver = useLocaleReceiver("Modal"), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    return function() {
      var icon = props2.icon, onCancel = props2.onCancel, onOk = props2.onOk, close3 = props2.close, _props$closable = props2.closable, closable = _props$closable === void 0 ? false : _props$closable, zIndex = props2.zIndex, afterClose = props2.afterClose, visible = props2.visible, keyboard = props2.keyboard, centered = props2.centered, getContainer4 = props2.getContainer, maskStyle = props2.maskStyle, okButtonProps = props2.okButtonProps, cancelButtonProps = props2.cancelButtonProps, _props$okCancel = props2.okCancel, okCancel = _props$okCancel === void 0 ? true : _props$okCancel, _props$width = props2.width, width = _props$width === void 0 ? 416 : _props$width, _props$mask = props2.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$maskClosable = props2.maskClosable, maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable, type4 = props2.type, title = props2.title, content = props2.content, direction2 = props2.direction, closeIcon = props2.closeIcon, modalRender = props2.modalRender, focusTriggerAfterClose = props2.focusTriggerAfterClose, rootPrefixCls = props2.rootPrefixCls, bodyStyle = props2.bodyStyle, wrapClassName = props2.wrapClassName;
      var okType = props2.okType || "primary";
      var prefixCls2 = props2.prefixCls || "ant-modal";
      var contentPrefixCls = "".concat(prefixCls2, "-confirm");
      var style2 = attrs.style || {};
      var okText = renderSomeContent(props2.okText) || (okCancel ? locale2.value.okText : locale2.value.justOkText);
      var cancelText = renderSomeContent(props2.cancelText) || locale2.value.cancelText;
      var autoFocusButton = props2.autoFocusButton === null ? false : props2.autoFocusButton || "ok";
      var classString = classNames(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(type4), "".concat(prefixCls2, "-").concat(type4), _defineProperty$R({}, "".concat(contentPrefixCls, "-rtl"), direction2 === "rtl"), attrs.class);
      var cancelButton = okCancel && createVNode(ActionButton, {
        "actionFn": onCancel,
        "close": close3,
        "autofocus": autoFocusButton === "cancel",
        "buttonProps": cancelButtonProps,
        "prefixCls": "".concat(rootPrefixCls, "-btn")
      }, {
        default: function _default7() {
          return [cancelText];
        }
      });
      return createVNode(Modal$1, {
        "prefixCls": prefixCls2,
        "class": classString,
        "wrapClassName": classNames(_defineProperty$R({}, "".concat(contentPrefixCls, "-centered"), !!centered), wrapClassName),
        "onCancel": function onCancel2(e2) {
          return close3({
            triggerCancel: true
          }, e2);
        },
        "visible": visible,
        "title": "",
        "footer": "",
        "transitionName": getTransitionName$2(rootPrefixCls, "zoom", props2.transitionName),
        "maskTransitionName": getTransitionName$2(rootPrefixCls, "fade", props2.maskTransitionName),
        "mask": mask,
        "maskClosable": maskClosable,
        "maskStyle": maskStyle,
        "style": style2,
        "bodyStyle": bodyStyle,
        "width": width,
        "zIndex": zIndex,
        "afterClose": afterClose,
        "keyboard": keyboard,
        "centered": centered,
        "getContainer": getContainer4,
        "closable": closable,
        "closeIcon": closeIcon,
        "modalRender": modalRender,
        "focusTriggerAfterClose": focusTriggerAfterClose
      }, {
        default: function _default7() {
          return [createVNode("div", {
            "class": "".concat(contentPrefixCls, "-body-wrapper")
          }, [createVNode("div", {
            "class": "".concat(contentPrefixCls, "-body")
          }, [renderSomeContent(icon), title === void 0 ? null : createVNode("span", {
            "class": "".concat(contentPrefixCls, "-title")
          }, [renderSomeContent(title)]), createVNode("div", {
            "class": "".concat(contentPrefixCls, "-content")
          }, [renderSomeContent(content)])]), createVNode("div", {
            "class": "".concat(contentPrefixCls, "-btns")
          }, [cancelButton, createVNode(ActionButton, {
            "type": okType,
            "actionFn": onOk,
            "close": close3,
            "autofocus": autoFocusButton === "ok",
            "buttonProps": okButtonProps,
            "prefixCls": "".concat(rootPrefixCls, "-btn")
          }, {
            default: function _default8() {
              return [okText];
            }
          })])])];
        }
      });
    };
  }
});
var confirm = function confirm2(config) {
  var container = document.createDocumentFragment();
  var currentConfig = _extends$2(_extends$2({}, omit$3(config, ["parentContext", "appContext"])), {
    close: close3,
    visible: true
  });
  var confirmDialogInstance = null;
  function destroy4() {
    if (confirmDialogInstance) {
      render(null, container);
      confirmDialogInstance.component.update();
      confirmDialogInstance = null;
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var triggerCancel = args.some(function(param) {
      return param && param.triggerCancel;
    });
    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }
    for (var i2 = 0; i2 < destroyFns.length; i2++) {
      var fn = destroyFns[i2];
      if (fn === close3) {
        destroyFns.splice(i2, 1);
        break;
      }
    }
  }
  function close3() {
    var _this = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    currentConfig = _extends$2(_extends$2({}, currentConfig), {
      visible: false,
      afterClose: function afterClose() {
        if (typeof config.afterClose === "function") {
          config.afterClose();
        }
        destroy4.apply(_this, args);
      }
    });
    update(currentConfig);
  }
  function update(configUpdate) {
    if (typeof configUpdate === "function") {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = _extends$2(_extends$2({}, currentConfig), configUpdate);
    }
    if (confirmDialogInstance) {
      _extends$2(confirmDialogInstance.component.props, currentConfig);
      confirmDialogInstance.component.update();
    }
  }
  var Wrapper = function Wrapper2(p2) {
    var global2 = globalConfigForApi;
    var rootPrefixCls = global2.prefixCls;
    var prefixCls2 = p2.prefixCls || "".concat(rootPrefixCls, "-modal");
    return createVNode(ConfigProvider$1, _objectSpread2$2(_objectSpread2$2({}, global2), {}, {
      "notUpdateGlobalConfig": true,
      "prefixCls": rootPrefixCls
    }), {
      default: function _default7() {
        return [createVNode(ConfirmDialog, _objectSpread2$2(_objectSpread2$2({}, p2), {}, {
          "rootPrefixCls": rootPrefixCls,
          "prefixCls": prefixCls2
        }), null)];
      }
    });
  };
  function render$1(props2) {
    var vm = createVNode(Wrapper, _extends$2({}, props2));
    vm.appContext = config.parentContext || config.appContext || vm.appContext;
    render(vm, container);
    return vm;
  }
  confirmDialogInstance = render$1(currentConfig);
  destroyFns.push(close3);
  return {
    destroy: close3,
    update
  };
};
var confirm$1 = confirm;
function withWarn(props2) {
  return _extends$2(_extends$2({
    icon: function icon() {
      return createVNode(ExclamationCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "warning"
  });
}
function withInfo(props2) {
  return _extends$2(_extends$2({
    icon: function icon() {
      return createVNode(InfoCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "info"
  });
}
function withSuccess(props2) {
  return _extends$2(_extends$2({
    icon: function icon() {
      return createVNode(CheckCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "success"
  });
}
function withError(props2) {
  return _extends$2(_extends$2({
    icon: function icon() {
      return createVNode(CloseCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "error"
  });
}
function withConfirm(props2) {
  return _extends$2(_extends$2({
    icon: function icon() {
      return createVNode(ExclamationCircleOutlined$1, null, null);
    },
    okCancel: true
  }, props2), {
    type: "confirm"
  });
}
function modalWarn(props2) {
  return confirm$1(withWarn(props2));
}
Modal$1.info = function infoFn(props2) {
  return confirm$1(withInfo(props2));
};
Modal$1.success = function successFn(props2) {
  return confirm$1(withSuccess(props2));
};
Modal$1.error = function errorFn(props2) {
  return confirm$1(withError(props2));
};
Modal$1.warning = modalWarn;
Modal$1.warn = modalWarn;
Modal$1.confirm = function confirmFn(props2) {
  return confirm$1(withConfirm(props2));
};
Modal$1.destroyAll = function destroyAllFn() {
  while (destroyFns.length) {
    var close3 = destroyFns.pop();
    if (close3) {
      close3();
    }
  }
};
Modal$1.install = function(app) {
  app.component(Modal$1.name, Modal$1);
  return app;
};
var __rest$f = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var popconfirmProps = function popconfirmProps2() {
  return _extends$2(_extends$2({}, abstractTooltipProps()), {
    prefixCls: String,
    content: PropTypes$1.any,
    title: PropTypes$1.any,
    okType: {
      type: String,
      default: "primary"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    okText: PropTypes$1.any,
    cancelText: PropTypes$1.any,
    icon: PropTypes$1.any,
    okButtonProps: {
      type: Object,
      default: void 0
    },
    cancelButtonProps: {
      type: Object,
      default: void 0
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    onConfirm: Function,
    onCancel: Function
  });
};
var Popconfirm = defineComponent({
  name: "APopconfirm",
  props: initDefaultProps$1(popconfirmProps(), _extends$2(_extends$2({}, tooltipDefaultProps()), {
    trigger: "click",
    transitionName: "zoom-big",
    placement: "top",
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    arrowPointAtCenter: false,
    autoAdjustOverflow: true,
    okType: "primary",
    disabled: false
  })),
  slots: ["title", "content", "okText", "icon", "cancelText", "cancelButton", "okButton"],
  emits: ["update:visible", "visibleChange"],
  setup: function setup116(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    onMounted(function() {
      devWarning(props2.defaultVisible === void 0, "Popconfirm", "'defaultVisible' is deprecated, please use 'v-model:visible'");
    });
    var tooltipRef = ref();
    expose({
      getPopupDomNode: function getPopupDomNode2() {
        var _a2, _b;
        return (_b = (_a2 = tooltipRef.value) === null || _a2 === void 0 ? void 0 : _a2.getPopupDomNode) === null || _b === void 0 ? void 0 : _b.call(_a2);
      }
    });
    var _useMergedState = useMergedState(false, {
      value: toRef(props2, "visible"),
      defaultValue: props2.defaultVisible
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), visible = _useMergedState2[0], setVisible = _useMergedState2[1];
    var settingVisible = function settingVisible2(value, e2) {
      if (props2.visible === void 0) {
        setVisible(value);
      }
      emit("update:visible", value);
      emit("visibleChange", value, e2);
    };
    var close3 = function close4(e2) {
      settingVisible(false, e2);
    };
    var onConfirm = function onConfirm2(e2) {
      var _a2;
      return (_a2 = props2.onConfirm) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
    };
    var onCancel = function onCancel2(e2) {
      var _a2;
      settingVisible(false, e2);
      (_a2 = props2.onCancel) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
    };
    var onKeyDown = function onKeyDown2(e2) {
      if (e2.keyCode === KeyCode$1.ESC && visible) {
        settingVisible(false, e2);
      }
    };
    var onVisibleChange = function onVisibleChange2(value) {
      var disabled = props2.disabled;
      if (disabled) {
        return;
      }
      settingVisible(value);
    };
    var _useConfigInject = useConfigInject("popconfirm", props2), prefixClsConfirm = _useConfigInject.prefixCls, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var rootPrefixCls = computed(function() {
      return getPrefixCls2();
    });
    var popoverPrefixCls = computed(function() {
      return getPrefixCls2("popover");
    });
    var btnPrefixCls = computed(function() {
      return getPrefixCls2("btn");
    });
    var _useLocaleReceiver = useLocaleReceiver("Popconfirm", defaultLocale.Popconfirm), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), popconfirmLocale = _useLocaleReceiver2[0];
    var renderOverlay = function renderOverlay2() {
      var _a2, _b, _c, _d;
      var okButtonProps = props2.okButtonProps, cancelButtonProps = props2.cancelButtonProps, _props$title = props2.title, title = _props$title === void 0 ? (_a2 = slots.title) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$title, _props$cancelText = props2.cancelText, cancelText = _props$cancelText === void 0 ? (_b = slots.cancel) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$cancelText, _props$okText = props2.okText, okText = _props$okText === void 0 ? (_c = slots.okText) === null || _c === void 0 ? void 0 : _c.call(slots) : _props$okText, okType = props2.okType, _props$icon = props2.icon, icon = _props$icon === void 0 ? (_d = slots.icon) === null || _d === void 0 ? void 0 : _d.call(slots) : _props$icon, _props$showCancel = props2.showCancel, showCancel = _props$showCancel === void 0 ? true : _props$showCancel;
      var cancelButton = slots.cancelButton, okButton = slots.okButton;
      var cancelProps = _extends$2({
        onClick: onCancel,
        size: "small"
      }, cancelButtonProps);
      var okProps = _extends$2(_extends$2(_extends$2({
        onClick: onConfirm
      }, convertLegacyProps(okType)), {
        size: "small"
      }), okButtonProps);
      return createVNode("div", {
        "class": "".concat(popoverPrefixCls.value, "-inner-content")
      }, [createVNode("div", {
        "class": "".concat(popoverPrefixCls.value, "-message")
      }, [icon || createVNode(ExclamationCircleFilled$1, null, null), createVNode("div", {
        "class": "".concat(popoverPrefixCls.value, "-message-title")
      }, [title])]), createVNode("div", {
        "class": "".concat(popoverPrefixCls.value, "-buttons")
      }, [showCancel ? cancelButton ? cancelButton(cancelProps) : createVNode(Button$2, cancelProps, {
        default: function _default7() {
          return [cancelText || popconfirmLocale.value.cancelText];
        }
      }) : null, okButton ? okButton(okProps) : createVNode(ActionButton, {
        "buttonProps": _extends$2(_extends$2({
          size: "small"
        }, convertLegacyProps(okType)), okButtonProps),
        "actionFn": onConfirm,
        "close": close3,
        "prefixCls": btnPrefixCls.value,
        "quitOnNullishReturnValue": true,
        "emitEvent": true
      }, {
        default: function _default7() {
          return [okText || popconfirmLocale.value.okText];
        }
      })])]);
    };
    return function() {
      var _a2;
      var placement = props2.placement, overlayClassName = props2.overlayClassName, restProps = __rest$f(props2, ["placement", "overlayClassName"]);
      var otherProps = omit$3(restProps, ["title", "content", "cancelText", "okText", "onUpdate:visible", "onConfirm", "onCancel"]);
      var overlayClassNames = classNames(prefixClsConfirm.value, overlayClassName);
      return createVNode(Tooltip, _objectSpread2$2(_objectSpread2$2({}, otherProps), {}, {
        "prefixCls": popoverPrefixCls.value,
        "placement": placement,
        "onVisibleChange": onVisibleChange,
        "visible": visible.value,
        "overlayClassName": overlayClassNames,
        "transitionName": getTransitionName$2(rootPrefixCls.value, "zoom-big", props2.transitionName),
        "ref": tooltipRef
      }), {
        default: function _default7() {
          return [cloneVNodes(((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)) || [], {
            onKeydown: function onKeydown(e2) {
              onKeyDown(e2);
            }
          }, false)];
        },
        title: renderOverlay
      });
    };
  }
});
var Popconfirm$1 = withInstall$2(Popconfirm);
var progressStatuses = tuple$1("normal", "exception", "active", "success");
var ProgressType = tuple$1("line", "circle", "dashboard");
var ProgressSize = tuple$1("default", "small");
var progressProps = function progressProps2() {
  return {
    prefixCls: String,
    type: PropTypes$1.oneOf(ProgressType),
    percent: Number,
    format: {
      type: Function
    },
    status: PropTypes$1.oneOf(progressStatuses),
    showInfo: {
      type: Boolean,
      default: void 0
    },
    strokeWidth: Number,
    strokeLinecap: String,
    strokeColor: {
      type: [String, Object],
      default: void 0
    },
    trailColor: String,
    width: Number,
    success: {
      type: Object,
      default: function _default7() {
        return {};
      }
    },
    gapDegree: Number,
    gapPosition: String,
    size: PropTypes$1.oneOf(ProgressSize),
    steps: Number,
    successPercent: Number,
    title: String
  };
};
function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}
function getSuccessPercent(_ref) {
  var success = _ref.success, successPercent = _ref.successPercent;
  var percent = successPercent;
  if (success && "progress" in success) {
    devWarning(false, "Progress", "`success.progress` is deprecated. Please use `success.percent` instead.");
    percent = success.progress;
  }
  if (success && "percent" in success) {
    percent = success.percent;
  }
  return percent;
}
var __rest$e = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var lineProps = function lineProps2() {
  return _extends$2(_extends$2({}, progressProps()), {
    prefixCls: String,
    direction: {
      type: String
    }
  });
};
var sortGradient = function sortGradient2(gradients) {
  var tempArr = [];
  Object.keys(gradients).forEach(function(key2) {
    var formattedKey = parseFloat(key2.replace(/%/g, ""));
    if (!isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key2]
      });
    }
  });
  tempArr = tempArr.sort(function(a2, b2) {
    return a2.key - b2.key;
  });
  return tempArr.map(function(_ref) {
    var key2 = _ref.key, value = _ref.value;
    return "".concat(value, " ").concat(key2, "%");
  }).join(", ");
};
var handleGradient = function handleGradient2(strokeColor, directionConfig) {
  var _strokeColor$from = strokeColor.from, from = _strokeColor$from === void 0 ? presetPrimaryColors.blue : _strokeColor$from, _strokeColor$to = strokeColor.to, to = _strokeColor$to === void 0 ? presetPrimaryColors.blue : _strokeColor$to, _strokeColor$directio = strokeColor.direction, direction2 = _strokeColor$directio === void 0 ? directionConfig === "rtl" ? "to left" : "to right" : _strokeColor$directio, rest = __rest$e(strokeColor, ["from", "to", "direction"]);
  if (Object.keys(rest).length !== 0) {
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: "linear-gradient(".concat(direction2, ", ").concat(sortedGradients, ")")
    };
  }
  return {
    backgroundImage: "linear-gradient(".concat(direction2, ", ").concat(from, ", ").concat(to, ")")
  };
};
var Line = defineComponent({
  name: "Line",
  props: lineProps(),
  setup: function setup117(props2, _ref2) {
    var slots = _ref2.slots;
    var backgroundProps = computed(function() {
      var strokeColor = props2.strokeColor, direction2 = props2.direction;
      return strokeColor && typeof strokeColor !== "string" ? handleGradient(strokeColor, direction2) : {
        background: strokeColor
      };
    });
    var trailStyle = computed(function() {
      return props2.trailColor ? {
        backgroundColor: props2.trailColor
      } : void 0;
    });
    var percentStyle = computed(function() {
      var percent = props2.percent, strokeWidth = props2.strokeWidth, strokeLinecap = props2.strokeLinecap, size = props2.size;
      return _extends$2({
        width: "".concat(validProgress(percent), "%"),
        height: "".concat(strokeWidth || (size === "small" ? 6 : 8), "px"),
        borderRadius: strokeLinecap === "square" ? 0 : ""
      }, backgroundProps.value);
    });
    var successPercent = computed(function() {
      return getSuccessPercent(props2);
    });
    var successPercentStyle = computed(function() {
      var strokeWidth = props2.strokeWidth, size = props2.size, strokeLinecap = props2.strokeLinecap, success = props2.success;
      return {
        width: "".concat(validProgress(successPercent.value), "%"),
        height: "".concat(strokeWidth || (size === "small" ? 6 : 8), "px"),
        borderRadius: strokeLinecap === "square" ? 0 : "",
        backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
      };
    });
    return function() {
      var _a2;
      return createVNode(Fragment, null, [createVNode("div", {
        "class": "".concat(props2.prefixCls, "-outer")
      }, [createVNode("div", {
        "class": "".concat(props2.prefixCls, "-inner"),
        "style": trailStyle.value
      }, [createVNode("div", {
        "class": "".concat(props2.prefixCls, "-bg"),
        "style": percentStyle.value
      }, null), successPercent.value !== void 0 ? createVNode("div", {
        "class": "".concat(props2.prefixCls, "-success-bg"),
        "style": successPercentStyle.value
      }, null) : null])]), (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var defaultProps = {
  percent: 0,
  prefixCls: "vc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1
};
var useTransitionDuration = function useTransitionDuration2(paths) {
  var prevTimeStamp = ref(null);
  onUpdated(function() {
    var now2 = Date.now();
    var updated3 = false;
    paths.value.forEach(function(val) {
      var _a2;
      var path = ((_a2 = val) === null || _a2 === void 0 ? void 0 : _a2.$el) || val;
      if (!path) {
        return;
      }
      updated3 = true;
      var pathStyle = path.style;
      pathStyle.transitionDuration = ".3s, .3s, .3s, .06s";
      if (prevTimeStamp.value && now2 - prevTimeStamp.value < 100) {
        pathStyle.transitionDuration = "0s, 0s";
      }
    });
    if (updated3) {
      prevTimeStamp.value = Date.now();
    }
  });
  return paths;
};
var propTypes = {
  gapDegree: Number,
  gapPosition: {
    type: String
  },
  percent: {
    type: [Array, Number]
  },
  prefixCls: String,
  strokeColor: {
    type: [Object, String, Array]
  },
  strokeLinecap: {
    type: String
  },
  strokeWidth: Number,
  trailColor: String,
  trailWidth: Number,
  transition: String
};
var __rest$d = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var gradientSeed = 0;
function stripPercentToNumber(percent) {
  return +percent.replace("%", "");
}
function toArray$2(value) {
  return Array.isArray(value) ? value : [value];
}
function getPathStyles(offset3, percent, strokeColor, strokeWidth) {
  var gapDegree = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  var gapPosition = arguments.length > 5 ? arguments[5] : void 0;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;
  switch (gapPosition) {
    case "left":
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;
    case "right":
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;
    case "bottom":
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;
  }
  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;
  var pathStyle = {
    stroke: strokeColor,
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
    strokeDashoffset: "-".concat(gapDegree / 2 + offset3 / 100 * (len - gapDegree), "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s"
  };
  return {
    pathString,
    pathStyle
  };
}
var VCCircle = defineComponent({
  name: "VCCircle",
  props: initDefaultProps$1(propTypes, defaultProps),
  setup: function setup118(props2) {
    gradientSeed += 1;
    var gradientId = ref(gradientSeed);
    var percentList = computed(function() {
      return toArray$2(props2.percent);
    });
    var strokeColorList = computed(function() {
      return toArray$2(props2.strokeColor);
    });
    var _useRefs = useRefs$1(), _useRefs2 = _slicedToArray$2(_useRefs, 2), setRef = _useRefs2[0], paths = _useRefs2[1];
    useTransitionDuration(paths);
    var getStokeList = function getStokeList2() {
      var prefixCls2 = props2.prefixCls, strokeWidth = props2.strokeWidth, strokeLinecap = props2.strokeLinecap, gapDegree = props2.gapDegree, gapPosition = props2.gapPosition;
      var stackPtg = 0;
      return percentList.value.map(function(ptg, index2) {
        var color = strokeColorList.value[index2] || strokeColorList.value[strokeColorList.value.length - 1];
        var stroke = Object.prototype.toString.call(color) === "[object Object]" ? "url(#".concat(prefixCls2, "-gradient-").concat(gradientId.value, ")") : "";
        var _getPathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition), pathString = _getPathStyles.pathString, pathStyle = _getPathStyles.pathStyle;
        stackPtg += ptg;
        var pathProps = {
          key: index2,
          d: pathString,
          stroke,
          "stroke-linecap": strokeLinecap,
          "stroke-width": strokeWidth,
          opacity: ptg === 0 ? 0 : 1,
          "fill-opacity": "0",
          class: "".concat(prefixCls2, "-circle-path"),
          style: pathStyle
        };
        return createVNode("path", _objectSpread2$2({
          "ref": setRef(index2)
        }, pathProps), null);
      });
    };
    return function() {
      var prefixCls2 = props2.prefixCls, strokeWidth = props2.strokeWidth, trailWidth = props2.trailWidth, gapDegree = props2.gapDegree, gapPosition = props2.gapPosition, trailColor = props2.trailColor, strokeLinecap = props2.strokeLinecap;
      props2.strokeColor;
      var restProps = __rest$d(props2, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "strokeColor"]);
      var _getPathStyles2 = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition), pathString = _getPathStyles2.pathString, pathStyle = _getPathStyles2.pathStyle;
      delete restProps.percent;
      var gradient = strokeColorList.value.find(function(color) {
        return Object.prototype.toString.call(color) === "[object Object]";
      });
      var pathFirst = {
        d: pathString,
        stroke: trailColor,
        "stroke-linecap": strokeLinecap,
        "stroke-width": trailWidth || strokeWidth,
        "fill-opacity": "0",
        class: "".concat(prefixCls2, "-circle-trail"),
        style: pathStyle
      };
      return createVNode("svg", _objectSpread2$2({
        "class": "".concat(prefixCls2, "-circle"),
        "viewBox": "0 0 100 100"
      }, restProps), [gradient && createVNode("defs", null, [createVNode("linearGradient", {
        "id": "".concat(prefixCls2, "-gradient-").concat(gradientId.value),
        "x1": "100%",
        "y1": "0%",
        "x2": "0%",
        "y2": "0%"
      }, [Object.keys(gradient).sort(function(a2, b2) {
        return stripPercentToNumber(a2) - stripPercentToNumber(b2);
      }).map(function(key2, index2) {
        return createVNode("stop", {
          "key": index2,
          "offset": key2,
          "stop-color": gradient[key2]
        }, null);
      })])]), createVNode("path", pathFirst, null), getStokeList().reverse()]);
    };
  }
});
function getPercentage(_ref) {
  var percent = _ref.percent, success = _ref.success, successPercent = _ref.successPercent;
  var realSuccessPercent = validProgress(getSuccessPercent({
    success,
    successPercent
  }));
  return [realSuccessPercent, validProgress(validProgress(percent) - realSuccessPercent)];
}
function getStrokeColor(_ref2) {
  var _ref2$success = _ref2.success, success = _ref2$success === void 0 ? {} : _ref2$success, strokeColor = _ref2.strokeColor;
  var successColor = success.strokeColor;
  return [successColor || presetPrimaryColors.green, strokeColor || null];
}
var Circle = defineComponent({
  name: "Circle",
  inheritAttrs: false,
  props: progressProps(),
  setup: function setup119(props2, _ref3) {
    var slots = _ref3.slots;
    var gapDeg = computed(function() {
      if (props2.gapDegree || props2.gapDegree === 0) {
        return props2.gapDegree;
      }
      if (props2.type === "dashboard") {
        return 75;
      }
      return void 0;
    });
    var circleStyle = computed(function() {
      var circleSize = props2.width || 120;
      return {
        width: typeof circleSize === "number" ? "".concat(circleSize, "px") : circleSize,
        height: typeof circleSize === "number" ? "".concat(circleSize, "px") : circleSize,
        fontSize: "".concat(circleSize * 0.15 + 6, "px")
      };
    });
    var circleWidth = computed(function() {
      return props2.strokeWidth || 6;
    });
    var gapPos = computed(function() {
      return props2.gapPosition || props2.type === "dashboard" && "bottom" || "top";
    });
    var percent = computed(function() {
      return getPercentage(props2);
    });
    var isGradient = computed(function() {
      return Object.prototype.toString.call(props2.strokeColor) === "[object Object]";
    });
    var strokeColor = computed(function() {
      return getStrokeColor({
        success: props2.success,
        strokeColor: props2.strokeColor
      });
    });
    var wrapperClassName = computed(function() {
      var _ref4;
      return _ref4 = {}, _defineProperty$R(_ref4, "".concat(props2.prefixCls, "-inner"), true), _defineProperty$R(_ref4, "".concat(props2.prefixCls, "-circle-gradient"), isGradient.value), _ref4;
    });
    return function() {
      var _a2;
      return createVNode("div", {
        "class": wrapperClassName.value,
        "style": circleStyle.value
      }, [createVNode(VCCircle, {
        "percent": percent.value,
        "strokeWidth": circleWidth.value,
        "trailWidth": circleWidth.value,
        "strokeColor": strokeColor.value,
        "strokeLinecap": props2.strokeLinecap,
        "trailColor": props2.trailColor,
        "prefixCls": props2.prefixCls,
        "gapDegree": gapDeg.value,
        "gapPosition": gapPos.value
      }, null), (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var stepsProps = function stepsProps2() {
  return _extends$2(_extends$2({}, progressProps()), {
    steps: Number,
    size: {
      type: String
    },
    strokeColor: String,
    trailColor: String
  });
};
var Steps$2 = defineComponent({
  name: "Steps",
  props: stepsProps(),
  setup: function setup120(props2, _ref) {
    var slots = _ref.slots;
    var current2 = computed(function() {
      return Math.round(props2.steps * ((props2.percent || 0) / 100));
    });
    var stepWidth = computed(function() {
      return props2.size === "small" ? 2 : 14;
    });
    var styledSteps = computed(function() {
      var steps = props2.steps, _props$strokeWidth = props2.strokeWidth, strokeWidth = _props$strokeWidth === void 0 ? 8 : _props$strokeWidth, strokeColor = props2.strokeColor, trailColor = props2.trailColor, prefixCls2 = props2.prefixCls;
      var temp = [];
      for (var i2 = 0; i2 < steps; i2 += 1) {
        var _cls;
        var cls = (_cls = {}, _defineProperty$R(_cls, "".concat(prefixCls2, "-steps-item"), true), _defineProperty$R(_cls, "".concat(prefixCls2, "-steps-item-active"), i2 <= current2.value - 1), _cls);
        temp.push(createVNode("div", {
          "key": i2,
          "class": cls,
          "style": {
            backgroundColor: i2 <= current2.value - 1 ? strokeColor : trailColor,
            width: "".concat(stepWidth.value, "px"),
            height: "".concat(strokeWidth, "px")
          }
        }, null));
      }
      return temp;
    });
    return function() {
      var _a2;
      return createVNode("div", {
        "class": "".concat(props2.prefixCls, "-steps-outer")
      }, [styledSteps.value, (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var Progress$1 = defineComponent({
  name: "AProgress",
  props: initDefaultProps$1(progressProps(), {
    type: "line",
    percent: 0,
    showInfo: true,
    trailColor: null,
    size: "default",
    strokeLinecap: "round"
  }),
  slots: ["format"],
  setup: function setup121(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("progress", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    devWarning(props2.successPercent == void 0, "Progress", "`successPercent` is deprecated. Please use `success.percent` instead.");
    var classString = computed(function() {
      var _ref2;
      var type4 = props2.type, showInfo = props2.showInfo, size = props2.size;
      var pre = prefixCls2.value;
      return _ref2 = {}, _defineProperty$R(_ref2, pre, true), _defineProperty$R(_ref2, "".concat(pre, "-").concat(type4 === "dashboard" && "circle" || type4), true), _defineProperty$R(_ref2, "".concat(pre, "-show-info"), showInfo), _defineProperty$R(_ref2, "".concat(pre, "-").concat(size), size), _defineProperty$R(_ref2, "".concat(pre, "-rtl"), direction2.value === "rtl"), _ref2;
    });
    var percentNumber = computed(function() {
      var _props$percent = props2.percent, percent = _props$percent === void 0 ? 0 : _props$percent;
      var successPercent = getSuccessPercent(props2);
      return parseInt(successPercent !== void 0 ? successPercent.toString() : percent.toString(), 10);
    });
    var progressStatus = computed(function() {
      var status = props2.status;
      if (progressStatuses.indexOf(status) < 0 && percentNumber.value >= 100) {
        return "success";
      }
      return status || "normal";
    });
    var renderProcessInfo = function renderProcessInfo2() {
      var showInfo = props2.showInfo, format3 = props2.format, type4 = props2.type, percent = props2.percent, title = props2.title;
      var successPercent = getSuccessPercent(props2);
      if (!showInfo)
        return null;
      var text;
      var textFormatter = format3 || (slots === null || slots === void 0 ? void 0 : slots.format) || function(val) {
        return "".concat(val, "%");
      };
      var isLineType = type4 === "line";
      if (format3 || (slots === null || slots === void 0 ? void 0 : slots.format) || progressStatus.value !== "exception" && progressStatus.value !== "success") {
        text = textFormatter(validProgress(percent), validProgress(successPercent));
      } else if (progressStatus.value === "exception") {
        text = isLineType ? createVNode(CloseCircleFilled$1, null, null) : createVNode(CloseOutlined$1, null, null);
      } else if (progressStatus.value === "success") {
        text = isLineType ? createVNode(CheckCircleFilled$1, null, null) : createVNode(CheckOutlined$1, null, null);
      }
      return createVNode("span", {
        "class": "".concat(prefixCls2.value, "-text"),
        "title": title === void 0 && typeof text === "string" ? text : void 0
      }, [text]);
    };
    return function() {
      var type4 = props2.type, steps = props2.steps, strokeColor = props2.strokeColor, title = props2.title;
      var progressInfo = renderProcessInfo();
      var progress;
      if (type4 === "line") {
        progress = steps ? createVNode(Steps$2, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
          "strokeColor": typeof strokeColor === "string" ? strokeColor : void 0,
          "prefixCls": prefixCls2.value,
          "steps": steps
        }), {
          default: function _default7() {
            return [progressInfo];
          }
        }) : createVNode(Line, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
          "prefixCls": prefixCls2.value
        }), {
          default: function _default7() {
            return [progressInfo];
          }
        });
      } else if (type4 === "circle" || type4 === "dashboard") {
        progress = createVNode(Circle, _objectSpread2$2(_objectSpread2$2({}, props2), {}, {
          "prefixCls": prefixCls2.value
        }), {
          default: function _default7() {
            return [progressInfo];
          }
        });
      }
      var classNames2 = _extends$2(_extends$2({}, classString.value), _defineProperty$R({}, "".concat(prefixCls2.value, "-status-").concat(progressStatus.value), true));
      return createVNode("div", {
        "class": classNames2,
        "title": title
      }, [progress]);
    };
  }
});
var Progress = withInstall$2(Progress$1);
function getScroll(w2) {
  var ret = w2.pageXOffset;
  var method4 = "scrollLeft";
  if (typeof ret !== "number") {
    var d2 = w2.document;
    ret = d2.documentElement[method4];
    if (typeof ret !== "number") {
      ret = d2.body[method4];
    }
  }
  return ret;
}
function getClientPosition(elem) {
  var x2;
  var y2;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  var box = elem.getBoundingClientRect();
  x2 = box.left;
  y2 = box.top;
  x2 -= docElem.clientLeft || body.clientLeft || 0;
  y2 -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x2,
    top: y2
  };
}
function getOffsetLeft(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w2);
  return pos.left;
}
var starProps = {
  value: Number,
  index: Number,
  prefixCls: String,
  allowHalf: {
    type: Boolean,
    default: void 0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  character: PropTypes$1.any,
  characterRender: Function,
  focused: {
    type: Boolean,
    default: void 0
  },
  count: Number,
  onClick: Function,
  onHover: Function
};
var Star = defineComponent({
  name: "Star",
  inheritAttrs: false,
  props: starProps,
  emits: ["hover", "click"],
  setup: function setup122(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var onHover = function onHover2(e2) {
      var index2 = props2.index;
      emit("hover", e2, index2);
    };
    var onClick2 = function onClick3(e2) {
      var index2 = props2.index;
      emit("click", e2, index2);
    };
    var onKeyDown = function onKeyDown2(e2) {
      var index2 = props2.index;
      if (e2.keyCode === 13) {
        emit("click", e2, index2);
      }
    };
    var cls = computed(function() {
      var prefixCls2 = props2.prefixCls, index2 = props2.index, value = props2.value, allowHalf = props2.allowHalf, focused = props2.focused;
      var starValue = index2 + 1;
      var className = prefixCls2;
      if (value === 0 && index2 === 0 && focused) {
        className += " ".concat(prefixCls2, "-focused");
      } else if (allowHalf && value + 0.5 >= starValue && value < starValue) {
        className += " ".concat(prefixCls2, "-half ").concat(prefixCls2, "-active");
        if (focused) {
          className += " ".concat(prefixCls2, "-focused");
        }
      } else {
        className += starValue <= value ? " ".concat(prefixCls2, "-full") : " ".concat(prefixCls2, "-zero");
        if (starValue === value && focused) {
          className += " ".concat(prefixCls2, "-focused");
        }
      }
      return className;
    });
    return function() {
      var disabled = props2.disabled, prefixCls2 = props2.prefixCls, characterRender = props2.characterRender, index2 = props2.index, count = props2.count, value = props2.value;
      var character = getPropsSlot(slots, props2, "character");
      var star = createVNode("li", {
        "class": cls.value
      }, [createVNode("div", {
        "onClick": disabled ? null : onClick2,
        "onKeydown": disabled ? null : onKeyDown,
        "onMousemove": disabled ? null : onHover,
        "role": "radio",
        "aria-checked": value > index2 ? "true" : "false",
        "aria-posinset": index2 + 1,
        "aria-setsize": count,
        "tabindex": disabled ? -1 : 0
      }, [createVNode("div", {
        "class": "".concat(prefixCls2, "-first")
      }, [character]), createVNode("div", {
        "class": "".concat(prefixCls2, "-second")
      }, [character])])]);
      if (characterRender) {
        star = characterRender(star, props2);
      }
      return star;
    };
  }
});
var rateProps = function rateProps2() {
  return {
    prefixCls: String,
    count: Number,
    value: Number,
    allowHalf: {
      type: Boolean,
      default: void 0
    },
    allowClear: {
      type: Boolean,
      default: void 0
    },
    tooltips: Array,
    disabled: {
      type: Boolean,
      default: void 0
    },
    character: PropTypes$1.any,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    direction: String,
    id: String,
    onChange: Function,
    onHoverChange: Function,
    "onUpdate:value": Function,
    onFocus: Function,
    onBlur: Function,
    onKeydown: Function
  };
};
var Rate = defineComponent({
  name: "ARate",
  inheritAttrs: false,
  props: initDefaultProps$1(rateProps(), {
    value: 0,
    count: 5,
    allowHalf: false,
    allowClear: true,
    tabindex: 0,
    direction: "ltr"
  }),
  setup: function setup123(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit, expose = _ref.expose;
    var _useConfigInject = useConfigInject("rate", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var formItemContext = useInjectFormItemContext();
    var rateRef = ref();
    var _useRefs = useRefs$1(), _useRefs2 = _slicedToArray$2(_useRefs, 2), setRef = _useRefs2[0], starRefs = _useRefs2[1];
    var state = reactive({
      value: props2.value,
      focused: false,
      cleanedValue: null,
      hoverValue: void 0
    });
    watch(function() {
      return props2.value;
    }, function() {
      state.value = props2.value;
    });
    var getStarDOM = function getStarDOM2(index2) {
      return findDOMNode(starRefs.value.get(index2));
    };
    var getStarValue = function getStarValue2(index2, x2) {
      var reverse = direction2.value === "rtl";
      var value = index2 + 1;
      if (props2.allowHalf) {
        var starEle = getStarDOM(index2);
        var leftDis = getOffsetLeft(starEle);
        var width = starEle.clientWidth;
        if (reverse && x2 - leftDis > width / 2) {
          value -= 0.5;
        } else if (!reverse && x2 - leftDis < width / 2) {
          value -= 0.5;
        }
      }
      return value;
    };
    var changeValue = function changeValue2(value) {
      if (props2.value === void 0) {
        state.value = value;
      }
      emit("update:value", value);
      emit("change", value);
      formItemContext.onFieldChange();
    };
    var onHover = function onHover2(e2, index2) {
      var hoverValue = getStarValue(index2, e2.pageX);
      if (hoverValue !== state.cleanedValue) {
        state.hoverValue = hoverValue;
        state.cleanedValue = null;
      }
      emit("hoverChange", hoverValue);
    };
    var onMouseLeave = function onMouseLeave2() {
      state.hoverValue = void 0;
      state.cleanedValue = null;
      emit("hoverChange", void 0);
    };
    var onClick2 = function onClick3(event, index2) {
      var allowClear = props2.allowClear;
      var newValue = getStarValue(index2, event.pageX);
      var isReset = false;
      if (allowClear) {
        isReset = newValue === state.value;
      }
      onMouseLeave();
      changeValue(isReset ? 0 : newValue);
      state.cleanedValue = isReset ? newValue : null;
    };
    var onFocus2 = function onFocus3(e2) {
      state.focused = true;
      emit("focus", e2);
    };
    var onBlur2 = function onBlur3(e2) {
      state.focused = false;
      emit("blur", e2);
      formItemContext.onFieldBlur();
    };
    var onKeyDown = function onKeyDown2(event) {
      var keyCode = event.keyCode;
      var count = props2.count, allowHalf = props2.allowHalf;
      var reverse = direction2.value === "rtl";
      if (keyCode === KeyCode$1.RIGHT && state.value < count && !reverse) {
        if (allowHalf) {
          state.value += 0.5;
        } else {
          state.value += 1;
        }
        changeValue(state.value);
        event.preventDefault();
      } else if (keyCode === KeyCode$1.LEFT && state.value > 0 && !reverse) {
        if (allowHalf) {
          state.value -= 0.5;
        } else {
          state.value -= 1;
        }
        changeValue(state.value);
        event.preventDefault();
      } else if (keyCode === KeyCode$1.RIGHT && state.value > 0 && reverse) {
        if (allowHalf) {
          state.value -= 0.5;
        } else {
          state.value -= 1;
        }
        changeValue(state.value);
        event.preventDefault();
      } else if (keyCode === KeyCode$1.LEFT && state.value < count && reverse) {
        if (allowHalf) {
          state.value += 0.5;
        } else {
          state.value += 1;
        }
        changeValue(state.value);
        event.preventDefault();
      }
      emit("keydown", event);
    };
    var focus2 = function focus3() {
      if (!props2.disabled) {
        rateRef.value.focus();
      }
    };
    var blur = function blur2() {
      if (!props2.disabled) {
        rateRef.value.blur();
      }
    };
    expose({
      focus: focus2,
      blur
    });
    onMounted(function() {
      var autofocus = props2.autofocus, disabled = props2.disabled;
      if (autofocus && !disabled) {
        focus2();
      }
    });
    var characterRender = function characterRender2(node, _ref2) {
      var index2 = _ref2.index;
      var tooltips = props2.tooltips;
      if (!tooltips)
        return node;
      return createVNode(Tooltip, {
        "title": tooltips[index2]
      }, {
        default: function _default7() {
          return [node];
        }
      });
    };
    var character = getPropsSlot(slots, props2, "character") || createVNode(StarFilled$1, null, null);
    return function() {
      var count = props2.count, allowHalf = props2.allowHalf, disabled = props2.disabled, tabindex = props2.tabindex, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id;
      var className = attrs.class, style2 = attrs.style;
      var stars = [];
      var disabledClass = disabled ? "".concat(prefixCls2.value, "-disabled") : "";
      for (var index2 = 0; index2 < count; index2++) {
        stars.push(createVNode(Star, {
          "ref": setRef(index2),
          "key": index2,
          "index": index2,
          "count": count,
          "disabled": disabled,
          "prefixCls": "".concat(prefixCls2.value, "-star"),
          "allowHalf": allowHalf,
          "value": state.hoverValue === void 0 ? state.value : state.hoverValue,
          "onClick": onClick2,
          "onHover": onHover,
          "character": character,
          "characterRender": characterRender,
          "focused": state.focused
        }, null));
      }
      var rateClassName = classNames(prefixCls2.value, disabledClass, className, _defineProperty$R({}, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"));
      return createVNode("ul", _objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "id": id,
        "class": rateClassName,
        "style": style2,
        "onMouseleave": disabled ? null : onMouseLeave,
        "tabindex": disabled ? -1 : tabindex,
        "onFocus": disabled ? null : onFocus2,
        "onBlur": disabled ? null : onBlur2,
        "onKeydown": disabled ? null : onKeyDown,
        "ref": rateRef,
        "role": "radiogroup"
      }), [stars]);
    };
  }
});
var Rate$1 = withInstall$2(Rate);
var NoFound = function NoFound2() {
  return createVNode("svg", {
    "width": "252",
    "height": "294"
  }, [createVNode("defs", null, [createVNode("path", {
    "d": "M0 .387h251.772v251.772H0z"
  }, null)]), createVNode("g", {
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("g", {
    "transform": "translate(0 .012)"
  }, [createVNode("mask", {
    "fill": "#fff"
  }, null), createVNode("path", {
    "d": "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
    "fill": "#E4EBF7",
    "mask": "url(#b)"
  }, null)]), createVNode("path", {
    "d": "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "d": "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "d": "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "stroke": "#FFF",
    "stroke-width": "2",
    "d": "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
  }, null), createVNode("path", {
    "d": "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
    "fill": "#1890FF"
  }, null), createVNode("path", {
    "d": "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
    "fill": "#FFB594"
  }, null), createVNode("path", {
    "d": "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
    "fill": "#CBD1D1"
  }, null), createVNode("path", {
    "d": "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
    "fill": "#2B0849"
  }, null), createVNode("path", {
    "d": "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
    "fill": "#A4AABA"
  }, null), createVNode("path", {
    "d": "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
    "fill": "#CBD1D1"
  }, null), createVNode("path", {
    "d": "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
    "fill": "#2B0849"
  }, null), createVNode("path", {
    "d": "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
    "fill": "#A4AABA"
  }, null), createVNode("path", {
    "d": "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
    "fill": "#7BB2F9"
  }, null), createVNode("path", {
    "d": "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M107.275 222.1s2.773-1.11 6.102-3.884",
    "stroke": "#648BD8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
    "fill": "#192064"
  }, null), createVNode("path", {
    "d": "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
    "fill": "#192064"
  }, null), createVNode("path", {
    "d": "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
    "fill": "#520038"
  }, null), createVNode("path", {
    "d": "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
    "fill": "#552950"
  }, null), createVNode("path", {
    "stroke": "#DB836E",
    "stroke-width": "1.118",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "d": "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
  }, null), createVNode("path", {
    "d": "M110.846 74.481s1.79-.716 2.506.537",
    "stroke": "#5C2552",
    "stroke-width": "1.118",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
    "stroke": "#DB836E",
    "stroke-width": "1.118",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M103.287 72.93s1.83 1.113 4.137.954",
    "stroke": "#5C2552",
    "stroke-width": "1.118",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
    "stroke": "#DB836E",
    "stroke-width": "1.118",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
    "stroke": "#E4EBF7",
    "stroke-width": "1.101",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M129.405 122.865s-5.272 7.403-9.422 10.768",
    "stroke": "#E4EBF7",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M119.306 107.329s.452 4.366-2.127 32.062",
    "stroke": "#E4EBF7",
    "stroke-width": "1.101",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
    "fill": "#F2D7AD"
  }, null), createVNode("path", {
    "d": "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
    "fill": "#F4D19D"
  }, null), createVNode("path", {
    "d": "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
    "fill": "#F2D7AD"
  }, null), createVNode("path", {
    "fill": "#CC9B6E",
    "d": "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
  }, null), createVNode("path", {
    "d": "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
    "fill": "#F4D19D"
  }, null), createVNode("path", {
    "fill": "#CC9B6E",
    "d": "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
  }, null), createVNode("path", {
    "fill": "#CC9B6E",
    "d": "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
  }, null), createVNode("path", {
    "d": "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
    "stroke": "#DB836E",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
    "stroke": "#DB836E",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
    "stroke": "#DB836E",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
    "fill": "#5BA02E"
  }, null), createVNode("path", {
    "d": "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
    "fill": "#92C110"
  }, null), createVNode("path", {
    "d": "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
    "fill": "#F2D7AD"
  }, null), createVNode("path", {
    "d": "M88.979 89.48s7.776 5.384 16.6 2.842",
    "stroke": "#E4EBF7",
    "stroke-width": "1.101",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null)])]);
};
var noFound = NoFound;
var ServerError = function ServerError2() {
  return createVNode("svg", {
    "width": "254",
    "height": "294"
  }, [createVNode("defs", null, [createVNode("path", {
    "d": "M0 .335h253.49v253.49H0z"
  }, null), createVNode("path", {
    "d": "M0 293.665h253.49V.401H0z"
  }, null)]), createVNode("g", {
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("g", {
    "transform": "translate(0 .067)"
  }, [createVNode("mask", {
    "fill": "#fff"
  }, null), createVNode("path", {
    "d": "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
    "fill": "#E4EBF7",
    "mask": "url(#b)"
  }, null)]), createVNode("path", {
    "d": "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "d": "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
    "fill": "#FF603B"
  }, null), createVNode("path", {
    "d": "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
    "fill": "#FFB594"
  }, null), createVNode("path", {
    "d": "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
    "fill": "#FFB594"
  }, null), createVNode("path", {
    "d": "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
    "fill": "#520038"
  }, null), createVNode("path", {
    "d": "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
    "fill": "#552950"
  }, null), createVNode("path", {
    "stroke": "#DB836E",
    "stroke-width": "1.063",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "d": "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
  }, null), createVNode("path", {
    "d": "M99.926 73.284s1.8-.72 2.52.54",
    "stroke": "#5C2552",
    "stroke-width": "1.117",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
    "stroke": "#DB836E",
    "stroke-width": "1.117",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M92.326 71.724s1.84 1.12 4.16.96",
    "stroke": "#5C2552",
    "stroke-width": "1.117",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
    "stroke": "#DB836E",
    "stroke-width": "1.063",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
    "stroke": "#E4EBF7",
    "stroke-width": "1.136",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
    "stroke": "#E4EBF7",
    "stroke-width": "1.085",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
    "fill": "#CBD1D1"
  }, null), createVNode("path", {
    "d": "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
    "fill": "#2B0849"
  }, null), createVNode("path", {
    "d": "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
    "fill": "#A4AABA"
  }, null), createVNode("path", {
    "d": "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
    "fill": "#CBD1D1"
  }, null), createVNode("path", {
    "d": "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
    "fill": "#2B0849"
  }, null), createVNode("path", {
    "d": "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
    "fill": "#A4AABA"
  }, null), createVNode("path", {
    "d": "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
    "fill": "#7BB2F9"
  }, null), createVNode("path", {
    "d": "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
    "stroke": "#648BD8",
    "stroke-width": "1.085",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M96.973 219.373s2.882-1.153 6.34-4.034",
    "stroke": "#648BD8",
    "stroke-width": "1.032",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
    "stroke": "#648BD8",
    "stroke-width": "1.085",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
    "fill": "#192064"
  }, null), createVNode("path", {
    "d": "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
    "fill": "#192064"
  }, null), createVNode("path", {
    "d": "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
    "stroke": "#648BD8",
    "stroke-width": "1.085",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
    "stroke": "#E4EBF7",
    "stroke-width": "1.085",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
    "stroke": "#DB836E",
    "stroke-width": ".774",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
    "stroke": "#E59788",
    "stroke-width": ".774",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
    "stroke": "#E59788",
    "stroke-width": ".774",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M109.278 112.533s3.38-3.613 7.575-4.662",
    "stroke": "#E4EBF7",
    "stroke-width": "1.085",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M107.375 123.006s9.697-2.745 11.445-.88",
    "stroke": "#E59788",
    "stroke-width": ".774",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
    "stroke": "#BFCDDD",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
    "fill": "#A3B4C6"
  }, null), createVNode("path", {
    "d": "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
    "fill": "#A3B4C6"
  }, null), createVNode("mask", {
    "fill": "#fff"
  }, null), createVNode("path", {
    "fill": "#A3B4C6",
    "mask": "url(#d)",
    "d": "M154.098 190.096h70.513v-84.617h-70.513z"
  }, null), createVNode("path", {
    "d": "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
    "fill": "#BFCDDD",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
    "fill": "#FFF",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
    "fill": "#BFCDDD",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
    "stroke": "#7C90A5",
    "stroke-width": "1.124",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
    "fill": "#FFF",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
    "fill": "#BFCDDD",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M177.259 207.217v11.52M201.05 207.217v11.52",
    "stroke": "#A3B4C6",
    "stroke-width": "1.124",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
    "fill": "#5BA02E",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
    "fill": "#92C110",
    "mask": "url(#d)"
  }, null), createVNode("path", {
    "d": "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
    "fill": "#F2D7AD",
    "mask": "url(#d)"
  }, null)])]);
};
var serverError = ServerError;
var Unauthorized = function Unauthorized2() {
  return createVNode("svg", {
    "width": "251",
    "height": "294"
  }, [createVNode("g", {
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("path", {
    "d": "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
    "fill": "#E4EBF7"
  }, null), createVNode("path", {
    "d": "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "d": "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "d": "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
    "stroke": "#FFF",
    "stroke-width": "2"
  }, null), createVNode("path", {
    "stroke": "#FFF",
    "stroke-width": "2",
    "d": "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
  }, null), createVNode("path", {
    "d": "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
    "fill": "#A26EF4"
  }, null), createVNode("path", {
    "d": "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
    "fill": "#5BA02E"
  }, null), createVNode("path", {
    "d": "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
    "fill": "#92C110"
  }, null), createVNode("path", {
    "d": "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
    "fill": "#F2D7AD"
  }, null), createVNode("path", {
    "d": "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
    "fill": "#FFB594"
  }, null), createVNode("path", {
    "d": "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M78.18 94.656s.911 7.41-4.914 13.078",
    "stroke": "#E4EBF7",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
    "stroke": "#E4EBF7",
    "stroke-width": ".932",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
    "fill": "#FFB594"
  }, null), createVNode("path", {
    "d": "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
    "fill": "#5C2552"
  }, null), createVNode("path", {
    "d": "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "stroke": "#DB836E",
    "stroke-width": "1.145",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "d": "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
  }, null), createVNode("path", {
    "d": "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
    "fill": "#552950"
  }, null), createVNode("path", {
    "d": "M91.132 86.786s5.269 4.957 12.679 2.327",
    "stroke": "#DB836E",
    "stroke-width": "1.145",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
    "fill": "#DB836E"
  }, null), createVNode("path", {
    "d": "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
    "stroke": "#5C2552",
    "stroke-width": "1.526",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
    "stroke": "#DB836E",
    "stroke-width": "1.145",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
    "stroke": "#E4EBF7",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M66.508 86.763s-1.598 8.83-6.697 14.078",
    "stroke": "#E4EBF7",
    "stroke-width": "1.114",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M128.31 87.934s3.013 4.121 4.06 11.785",
    "stroke": "#E4EBF7",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M64.09 84.816s-6.03 9.912-13.607 9.903",
    "stroke": "#DB836E",
    "stroke-width": ".795",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
    "fill": "#FFC6A0"
  }, null), createVNode("path", {
    "d": "M130.532 85.488s4.588 5.757 11.619 6.214",
    "stroke": "#DB836E",
    "stroke-width": ".75",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M121.708 105.73s-.393 8.564-1.34 13.612",
    "stroke": "#E4EBF7",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M115.784 161.512s-3.57-1.488-2.678-7.14",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
    "fill": "#CBD1D1"
  }, null), createVNode("path", {
    "d": "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
    "fill": "#2B0849"
  }, null), createVNode("path", {
    "d": "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
    "fill": "#A4AABA"
  }, null), createVNode("path", {
    "d": "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
    "fill": "#CBD1D1"
  }, null), createVNode("path", {
    "d": "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
    "fill": "#2B0849"
  }, null), createVNode("path", {
    "d": "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
    "fill": "#A4AABA"
  }, null), createVNode("path", {
    "d": "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
    "fill": "#7BB2F9"
  }, null), createVNode("path", {
    "d": "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M108.459 220.905s2.759-1.104 6.07-3.863",
    "stroke": "#648BD8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null), createVNode("path", {
    "d": "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
    "fill": "#192064"
  }, null), createVNode("path", {
    "d": "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
    "fill": "#FFF"
  }, null), createVNode("path", {
    "d": "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
    "fill": "#192064"
  }, null), createVNode("path", {
    "d": "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
    "stroke": "#648BD8",
    "stroke-width": "1.051",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null)])]);
};
var unauthorized = Unauthorized;
var IconMap = {
  success: CheckCircleFilled$1,
  error: CloseCircleFilled$1,
  info: ExclamationCircleFilled$1,
  warning: WarningFilled$1
};
var ExceptionMap = {
  "404": noFound,
  "500": serverError,
  "403": unauthorized
};
var ExceptionStatus = Object.keys(ExceptionMap);
var resultProps = function resultProps2() {
  return {
    prefixCls: String,
    icon: PropTypes$1.any,
    status: {
      type: [Number, String],
      default: "info"
    },
    title: PropTypes$1.any,
    subTitle: PropTypes$1.any,
    extra: PropTypes$1.any
  };
};
var renderIcon = function renderIcon2(prefixCls2, _ref) {
  var status = _ref.status, icon = _ref.icon;
  if (ExceptionStatus.includes("".concat(status))) {
    var SVGComponent = ExceptionMap[status];
    return createVNode("div", {
      "class": "".concat(prefixCls2, "-icon ").concat(prefixCls2, "-image")
    }, [createVNode(SVGComponent, null, null)]);
  }
  var IconComponent = IconMap[status];
  var iconNode = icon || createVNode(IconComponent, null, null);
  return createVNode("div", {
    "class": "".concat(prefixCls2, "-icon")
  }, [iconNode]);
};
var renderExtra = function renderExtra2(prefixCls2, extra) {
  return extra && createVNode("div", {
    "class": "".concat(prefixCls2, "-extra")
  }, [extra]);
};
var Result = defineComponent({
  name: "AResult",
  props: resultProps(),
  slots: ["title", "subTitle", "icon", "extra"],
  setup: function setup124(props2, _ref2) {
    var slots = _ref2.slots;
    var _useConfigInject = useConfigInject("result", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var className = computed(function() {
      return classNames(prefixCls2.value, "".concat(prefixCls2.value, "-").concat(props2.status), _defineProperty$R({}, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"));
    });
    return function() {
      var _a2, _b, _c, _d, _e, _f, _g, _h;
      var title = (_a2 = props2.title) !== null && _a2 !== void 0 ? _a2 : (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots);
      var subTitle = (_c = props2.subTitle) !== null && _c !== void 0 ? _c : (_d = slots.subTitle) === null || _d === void 0 ? void 0 : _d.call(slots);
      var icon = (_e = props2.icon) !== null && _e !== void 0 ? _e : (_f = slots.icon) === null || _f === void 0 ? void 0 : _f.call(slots);
      var extra = (_g = props2.extra) !== null && _g !== void 0 ? _g : (_h = slots.extra) === null || _h === void 0 ? void 0 : _h.call(slots);
      var pre = prefixCls2.value;
      return createVNode("div", {
        "class": className.value
      }, [renderIcon(pre, {
        status: props2.status,
        icon
      }), createVNode("div", {
        "class": "".concat(pre, "-title")
      }, [title]), subTitle && createVNode("div", {
        "class": "".concat(pre, "-subtitle")
      }, [subTitle]), renderExtra(pre, extra), slots.default && createVNode("div", {
        "class": "".concat(pre, "-content")
      }, [slots.default()])]);
    };
  }
});
Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
Result.install = function(app) {
  app.component(Result.name, Result);
  return app;
};
var Result$1 = Result;
var Track = function Track2(_2, _ref) {
  var _ref2, _ref3;
  var attrs = _ref.attrs;
  var included = attrs.included, vertical = attrs.vertical, style2 = attrs.style, className = attrs.class;
  var length = attrs.length, offset3 = attrs.offset, reverse = attrs.reverse;
  if (length < 0) {
    reverse = !reverse;
    length = Math.abs(length);
    offset3 = 100 - offset3;
  }
  var positonStyle = vertical ? (_ref2 = {}, _defineProperty$R(_ref2, reverse ? "top" : "bottom", "".concat(offset3, "%")), _defineProperty$R(_ref2, reverse ? "bottom" : "top", "auto"), _defineProperty$R(_ref2, "height", "".concat(length, "%")), _ref2) : (_ref3 = {}, _defineProperty$R(_ref3, reverse ? "right" : "left", "".concat(offset3, "%")), _defineProperty$R(_ref3, reverse ? "left" : "right", "auto"), _defineProperty$R(_ref3, "width", "".concat(length, "%")), _ref3);
  var elStyle = _extends$2(_extends$2({}, style2), positonStyle);
  return included ? createVNode("div", {
    "class": className,
    "style": elStyle
  }, null) : null;
};
Track.inheritAttrs = false;
var Track$1 = Track;
var calcPoints = function calcPoints2(_vertical, marks, dots, step, min4, max4) {
  warning$2(dots ? step > 0 : true, "Slider", "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
  var points = Object.keys(marks).map(parseFloat).sort(function(a2, b2) {
    return a2 - b2;
  });
  if (dots && step) {
    for (var i2 = min4; i2 <= max4; i2 += step) {
      if (points.indexOf(i2) === -1) {
        points.push(i2);
      }
    }
  }
  return points;
};
var Steps = function Steps2(_2, _ref) {
  var attrs = _ref.attrs;
  var prefixCls2 = attrs.prefixCls, vertical = attrs.vertical, reverse = attrs.reverse, marks = attrs.marks, dots = attrs.dots, step = attrs.step, included = attrs.included, lowerBound = attrs.lowerBound, upperBound = attrs.upperBound, max4 = attrs.max, min4 = attrs.min, dotStyle = attrs.dotStyle, activeDotStyle = attrs.activeDotStyle;
  var range3 = max4 - min4;
  var elements = calcPoints(vertical, marks, dots, step, min4, max4).map(function(point) {
    var _classNames;
    var offset3 = "".concat(Math.abs(point - min4) / range3 * 100, "%");
    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style2 = vertical ? _extends$2(_extends$2({}, dotStyle), _defineProperty$R({}, reverse ? "top" : "bottom", offset3)) : _extends$2(_extends$2({}, dotStyle), _defineProperty$R({}, reverse ? "right" : "left", offset3));
    if (isActived) {
      style2 = _extends$2(_extends$2({}, style2), activeDotStyle);
    }
    var pointClassName = classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-dot"), true), _defineProperty$R(_classNames, "".concat(prefixCls2, "-dot-active"), isActived), _defineProperty$R(_classNames, "".concat(prefixCls2, "-dot-reverse"), reverse), _classNames));
    return createVNode("span", {
      "class": pointClassName,
      "style": style2,
      "key": point
    }, null);
  });
  return createVNode("div", {
    "class": "".concat(prefixCls2, "-step")
  }, [elements]);
};
Steps.inheritAttrs = false;
var Steps$1 = Steps;
var Marks = function Marks2(_2, _ref) {
  var attrs = _ref.attrs, slots = _ref.slots;
  var className = attrs.class, vertical = attrs.vertical, reverse = attrs.reverse, marks = attrs.marks, included = attrs.included, upperBound = attrs.upperBound, lowerBound = attrs.lowerBound, max4 = attrs.max, min4 = attrs.min, onClickLabel = attrs.onClickLabel;
  var marksKeys = Object.keys(marks);
  var customMark = slots.mark;
  var range3 = max4 - min4;
  var elements = marksKeys.map(parseFloat).sort(function(a2, b2) {
    return a2 - b2;
  }).map(function(point) {
    var _classNames;
    var markPoint = typeof marks[point] === "function" ? marks[point]() : marks[point];
    var markPointIsObject = _typeof$2(markPoint) === "object" && !isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }
    if (customMark) {
      markLabel = customMark({
        point,
        label: markLabel
      });
    }
    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(className, "-text"), true), _defineProperty$R(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
    var bottomStyle = _defineProperty$R({
      marginBottom: "-50%"
    }, reverse ? "top" : "bottom", "".concat((point - min4) / range3 * 100, "%"));
    var leftStyle = _defineProperty$R({
      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
    }, reverse ? "right" : "left", "".concat((point - min4) / range3 * 100, "%"));
    var style2 = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? _extends$2(_extends$2({}, style2), markPoint.style) : style2;
    var touchEvents = _defineProperty$R({}, supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart", function(e2) {
      return onClickLabel(e2, point);
    });
    return createVNode("span", _objectSpread2$2({
      "class": markClassName,
      "style": markStyle,
      "key": point,
      "onMousedown": function onMousedown2(e2) {
        return onClickLabel(e2, point);
      }
    }, touchEvents), [markLabel]);
  });
  return createVNode("div", {
    "class": className
  }, [elements]);
};
Marks.inheritAttrs = false;
var Marks$1 = Marks;
var VcHandle = defineComponent({
  name: "Handle",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    vertical: {
      type: Boolean,
      default: void 0
    },
    offset: Number,
    disabled: {
      type: Boolean,
      default: void 0
    },
    min: Number,
    max: Number,
    value: Number,
    tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    reverse: {
      type: Boolean,
      default: void 0
    },
    ariaLabel: String,
    ariaLabelledBy: String,
    ariaValueTextFormatter: Function,
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onMousedown: {
      type: Function
    }
  },
  setup: function setup125(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit, expose = _ref.expose;
    var clickFocused = ref(false);
    var handle = ref();
    var handleMouseUp = function handleMouseUp2() {
      if (document.activeElement === handle.value) {
        clickFocused.value = true;
      }
    };
    var handleBlur = function handleBlur2(e2) {
      clickFocused.value = false;
      emit("blur", e2);
    };
    var handleKeyDown2 = function handleKeyDown3() {
      clickFocused.value = false;
    };
    var focus2 = function focus3() {
      var _a2;
      (_a2 = handle.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = handle.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    var clickFocus = function clickFocus2() {
      clickFocused.value = true;
      focus2();
    };
    var handleMousedown = function handleMousedown2(e2) {
      e2.preventDefault();
      focus2();
      emit("mousedown", e2);
    };
    expose({
      focus: focus2,
      blur,
      clickFocus,
      ref: handle
    });
    var onMouseUpListener = null;
    onMounted(function() {
      onMouseUpListener = addEventListenerWrap(document, "mouseup", handleMouseUp);
    });
    onBeforeUnmount(function() {
      onMouseUpListener === null || onMouseUpListener === void 0 ? void 0 : onMouseUpListener.remove();
    });
    var positionStyle = computed(function() {
      var _ref2, _ref3;
      var vertical = props2.vertical, offset3 = props2.offset, reverse = props2.reverse;
      return vertical ? (_ref2 = {}, _defineProperty$R(_ref2, reverse ? "top" : "bottom", "".concat(offset3, "%")), _defineProperty$R(_ref2, reverse ? "bottom" : "top", "auto"), _defineProperty$R(_ref2, "transform", reverse ? null : "translateY(+50%)"), _ref2) : (_ref3 = {}, _defineProperty$R(_ref3, reverse ? "right" : "left", "".concat(offset3, "%")), _defineProperty$R(_ref3, reverse ? "left" : "right", "auto"), _defineProperty$R(_ref3, "transform", "translateX(".concat(reverse ? "+" : "-", "50%)")), _ref3);
    });
    return function() {
      var prefixCls2 = props2.prefixCls, disabled = props2.disabled, min4 = props2.min, max4 = props2.max, value = props2.value, tabindex = props2.tabindex, ariaLabel = props2.ariaLabel, ariaLabelledBy = props2.ariaLabelledBy, ariaValueTextFormatter = props2.ariaValueTextFormatter, onMouseenter2 = props2.onMouseenter, onMouseleave2 = props2.onMouseleave;
      var className = classNames(attrs.class, _defineProperty$R({}, "".concat(prefixCls2, "-handle-click-focused"), clickFocused.value));
      var ariaProps = {
        "aria-valuemin": min4,
        "aria-valuemax": max4,
        "aria-valuenow": value,
        "aria-disabled": !!disabled
      };
      var elStyle = [attrs.style, positionStyle.value];
      var mergedTabIndex = tabindex || 0;
      if (disabled || tabindex === null) {
        mergedTabIndex = null;
      }
      var ariaValueText;
      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value);
      }
      var handleProps = _extends$2(_extends$2(_extends$2(_extends$2({}, attrs), {
        role: "slider",
        tabindex: mergedTabIndex
      }), ariaProps), {
        class: className,
        onBlur: handleBlur,
        onKeydown: handleKeyDown2,
        onMousedown: handleMousedown,
        onMouseenter: onMouseenter2,
        onMouseleave: onMouseleave2,
        ref: handle,
        style: elStyle
      });
      return createVNode("div", _objectSpread2$2(_objectSpread2$2({}, handleProps), {}, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
      }), null);
    };
  }
});
function isEventFromHandle(e2, handles) {
  try {
    return Object.keys(handles).some(function(key2) {
      return e2.target === handles[key2].ref;
    });
  } catch (error) {
    return false;
  }
}
function isValueOutOfRange(value, _ref) {
  var min4 = _ref.min, max4 = _ref.max;
  return value < min4 || value > max4;
}
function isNotTouchEvent(e2) {
  return e2.touches.length > 1 || e2.type.toLowerCase() === "touchend" && e2.touches.length > 0;
}
function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks, step = _ref2.step, min4 = _ref2.min, max4 = _ref2.max;
  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var baseNum = Math.pow(10, getPrecision(step));
    var maxSteps = Math.floor((max4 * baseNum - min4 * baseNum) / (step * baseNum));
    var steps = Math.min((val - min4) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min4;
    points.push(closestStep);
  }
  var diffs = points.map(function(point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, _toConsumableArray(diffs)))];
}
function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf(".") >= 0) {
    precision = stepString.length - stepString.indexOf(".") - 1;
  }
  return precision;
}
function getMousePosition(vertical, e2) {
  var zoom = 1;
  if (window.visualViewport) {
    zoom = +(window.visualViewport.width / document.body.getBoundingClientRect().width).toFixed(2);
  }
  return (vertical ? e2.clientY : e2.pageX) / zoom;
}
function getTouchPosition(vertical, e2) {
  var zoom = 1;
  if (window.visualViewport) {
    zoom = +(window.visualViewport.width / document.body.getBoundingClientRect().width).toFixed(2);
  }
  return (vertical ? e2.touches[0].clientY : e2.touches[0].pageX) / zoom;
}
function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
  var max4 = _ref3.max, min4 = _ref3.min;
  if (val <= min4) {
    return min4;
  }
  if (val >= max4) {
    return max4;
  }
  return val;
}
function ensureValuePrecision(val, props2) {
  var step = props2.step;
  var closestPoint = isFinite(getClosestPoint(val, props2)) ? getClosestPoint(val, props2) : 0;
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e2) {
  e2.stopPropagation();
  e2.preventDefault();
}
function calculateNextValue(func, value, props2) {
  var operations = {
    increase: function increase(a2, b2) {
      return a2 + b2;
    },
    decrease: function decrease(a2, b2) {
      return a2 - b2;
    }
  };
  var indexToGet = operations[func](Object.keys(props2.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props2.marks)[indexToGet];
  if (props2.step) {
    return operations[func](value, props2.step);
  }
  if (!!Object.keys(props2.marks).length && !!props2.marks[keyToGet]) {
    return props2.marks[keyToGet];
  }
  return value;
}
function getKeyboardValueMutator(e2, vertical, reverse) {
  var increase = "increase";
  var decrease = "decrease";
  var method4 = increase;
  switch (e2.keyCode) {
    case KeyCode$1.UP:
      method4 = vertical && reverse ? decrease : increase;
      break;
    case KeyCode$1.RIGHT:
      method4 = !vertical && reverse ? decrease : increase;
      break;
    case KeyCode$1.DOWN:
      method4 = vertical && reverse ? increase : decrease;
      break;
    case KeyCode$1.LEFT:
      method4 = !vertical && reverse ? increase : decrease;
      break;
    case KeyCode$1.END:
      return function(_value, props2) {
        return props2.max;
      };
    case KeyCode$1.HOME:
      return function(_value, props2) {
        return props2.min;
      };
    case KeyCode$1.PAGE_UP:
      return function(value, props2) {
        return value + props2.step * 2;
      };
    case KeyCode$1.PAGE_DOWN:
      return function(value, props2) {
        return value - props2.step * 2;
      };
    default:
      return void 0;
  }
  return function(value, props2) {
    return calculateNextValue(method4, value, props2);
  };
}
var __rest$c = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function noop$1() {
}
function createSlider(Component) {
  var propTypes2 = {
    id: String,
    min: Number,
    max: Number,
    step: Number,
    marks: PropTypes$1.object,
    included: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    disabled: {
      type: Boolean,
      default: void 0
    },
    handle: Function,
    dots: {
      type: Boolean,
      default: void 0
    },
    vertical: {
      type: Boolean,
      default: void 0
    },
    reverse: {
      type: Boolean,
      default: void 0
    },
    minimumTrackStyle: PropTypes$1.object,
    maximumTrackStyle: PropTypes$1.object,
    handleStyle: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.arrayOf(PropTypes$1.object)]),
    trackStyle: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.arrayOf(PropTypes$1.object)]),
    railStyle: PropTypes$1.object,
    dotStyle: PropTypes$1.object,
    activeDotStyle: PropTypes$1.object,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    draggableTrack: {
      type: Boolean,
      default: void 0
    }
  };
  return defineComponent({
    name: "CreateSlider",
    mixins: [BaseMixin, Component],
    inheritAttrs: false,
    slots: ["mark"],
    props: initDefaultProps$1(propTypes2, {
      prefixCls: "rc-slider",
      min: 0,
      max: 100,
      step: 1,
      marks: {},
      included: true,
      disabled: false,
      dots: false,
      vertical: false,
      reverse: false,
      trackStyle: [{}],
      handleStyle: [{}],
      railStyle: {},
      dotStyle: {},
      activeDotStyle: {}
    }),
    emits: ["change", "blur", "focus"],
    data: function data6() {
      var step = this.step, max4 = this.max, min4 = this.min;
      var isPointDiffEven = isFinite(max4 - min4) ? (max4 - min4) % step === 0 : true;
      warning$2(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max4 - min4, ") should be a multiple of Slider[step] (").concat(step, ")"));
      this.handlesRefs = {};
      return {};
    },
    mounted: function mounted4() {
      var _this = this;
      this.$nextTick(function() {
        _this.document = _this.sliderRef && _this.sliderRef.ownerDocument;
        var autofocus = _this.autofocus, disabled = _this.disabled;
        if (autofocus && !disabled) {
          _this.focus();
        }
      });
    },
    beforeUnmount: function beforeUnmount4() {
      var _this2 = this;
      this.$nextTick(function() {
        _this2.removeDocumentEvents();
      });
    },
    methods: {
      defaultHandle: function defaultHandle(_a2) {
        var index2 = _a2.index;
        _a2.directives;
        var className = _a2.className, style2 = _a2.style, restProps = __rest$c(_a2, ["index", "directives", "className", "style"]);
        delete restProps.dragging;
        if (restProps.value === null) {
          return null;
        }
        var handleProps = _extends$2(_extends$2({}, restProps), {
          class: className,
          style: style2,
          key: index2
        });
        return createVNode(VcHandle, handleProps, null);
      },
      onDown: function onDown(e2, position2) {
        var p2 = position2;
        var _this$$props = this.$props, draggableTrack = _this$$props.draggableTrack, isVertical = _this$$props.vertical;
        var bounds = this.$data.bounds;
        var value = draggableTrack && this.positionGetValue ? this.positionGetValue(p2) || [] : [];
        var inPoint = isEventFromHandle(e2, this.handlesRefs);
        this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n2, i2) {
          var v2 = !i2 ? n2 >= bounds[i2] : true;
          return i2 === value.length - 1 ? n2 <= bounds[i2] : v2;
        }).some(function(c2) {
          return !c2;
        });
        if (this.dragTrack) {
          this.dragOffset = p2;
          this.startBounds = _toConsumableArray(bounds);
        } else {
          if (!inPoint) {
            this.dragOffset = 0;
          } else {
            var handlePosition = getHandleCenterPosition(isVertical, e2.target);
            this.dragOffset = p2 - handlePosition;
            p2 = handlePosition;
          }
          this.onStart(p2);
        }
      },
      onMouseDown: function onMouseDown2(e2) {
        if (e2.button !== 0) {
          return;
        }
        this.removeDocumentEvents();
        var isVertical = this.$props.vertical;
        var position2 = getMousePosition(isVertical, e2);
        this.onDown(e2, position2);
        this.addDocumentMouseEvents();
      },
      onTouchStart: function onTouchStart(e2) {
        if (isNotTouchEvent(e2))
          return;
        var isVertical = this.vertical;
        var position2 = getTouchPosition(isVertical, e2);
        this.onDown(e2, position2);
        this.addDocumentTouchEvents();
        pauseEvent(e2);
      },
      onFocus: function onFocus2(e2) {
        var vertical = this.vertical;
        if (isEventFromHandle(e2, this.handlesRefs) && !this.dragTrack) {
          var handlePosition = getHandleCenterPosition(vertical, e2.target);
          this.dragOffset = 0;
          this.onStart(handlePosition);
          pauseEvent(e2);
          this.$emit("focus", e2);
        }
      },
      onBlur: function onBlur2(e2) {
        if (!this.dragTrack) {
          this.onEnd();
        }
        this.$emit("blur", e2);
      },
      onMouseUp: function onMouseUp2() {
        if (this.handlesRefs[this.prevMovedHandleIndex]) {
          this.handlesRefs[this.prevMovedHandleIndex].clickFocus();
        }
      },
      onMouseMove: function onMouseMove3(e2) {
        if (!this.sliderRef) {
          this.onEnd();
          return;
        }
        var position2 = getMousePosition(this.vertical, e2);
        this.onMove(e2, position2 - this.dragOffset, this.dragTrack, this.startBounds);
      },
      onTouchMove: function onTouchMove(e2) {
        if (isNotTouchEvent(e2) || !this.sliderRef) {
          this.onEnd();
          return;
        }
        var position2 = getTouchPosition(this.vertical, e2);
        this.onMove(e2, position2 - this.dragOffset, this.dragTrack, this.startBounds);
      },
      onKeyDown: function onKeyDown(e2) {
        if (this.sliderRef && isEventFromHandle(e2, this.handlesRefs)) {
          this.onKeyboard(e2);
        }
      },
      onClickMarkLabel: function onClickMarkLabel(e2, value) {
        var _this3 = this;
        e2.stopPropagation();
        this.onChange({
          sValue: value
        });
        this.setState({
          sValue: value
        }, function() {
          return _this3.onEnd(true);
        });
      },
      getSliderStart: function getSliderStart() {
        var slider = this.sliderRef;
        var vertical = this.vertical, reverse = this.reverse;
        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      },
      getSliderLength: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }
        var coords = slider.getBoundingClientRect();
        return this.vertical ? coords.height : coords.width;
      },
      addDocumentTouchEvents: function addDocumentTouchEvents() {
        this.onTouchMoveListener = addEventListenerWrap(this.document, "touchmove", this.onTouchMove);
        this.onTouchUpListener = addEventListenerWrap(this.document, "touchend", this.onEnd);
      },
      addDocumentMouseEvents: function addDocumentMouseEvents() {
        this.onMouseMoveListener = addEventListenerWrap(this.document, "mousemove", this.onMouseMove);
        this.onMouseUpListener = addEventListenerWrap(this.document, "mouseup", this.onEnd);
      },
      removeDocumentEvents: function removeDocumentEvents() {
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
      },
      focus: function focus2() {
        var _a2;
        if (this.$props.disabled) {
          return;
        }
        (_a2 = this.handlesRefs[0]) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _this4 = this;
        if (this.$props.disabled) {
          return;
        }
        Object.keys(this.handlesRefs).forEach(function(key2) {
          var _a2, _b;
          (_b = (_a2 = _this4.handlesRefs[key2]) === null || _a2 === void 0 ? void 0 : _a2.blur) === null || _b === void 0 ? void 0 : _b.call(_a2);
        });
      },
      calcValue: function calcValue(offset3) {
        var vertical = this.vertical, min4 = this.min, max4 = this.max;
        var ratio = Math.abs(Math.max(offset3, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max4 - min4) + min4 : ratio * (max4 - min4) + min4;
        return value;
      },
      calcValueByPos: function calcValueByPos(position2) {
        var sign = this.reverse ? -1 : 1;
        var pixelOffset = sign * (position2 - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      },
      calcOffset: function calcOffset(value) {
        var min4 = this.min, max4 = this.max;
        var ratio = (value - min4) / (max4 - min4);
        return Math.max(0, ratio * 100);
      },
      saveSlider: function saveSlider(slider) {
        this.sliderRef = slider;
      },
      saveHandle: function saveHandle(index2, handle) {
        this.handlesRefs[index2] = handle;
      }
    },
    render: function render11() {
      var _classNames;
      var prefixCls2 = this.prefixCls, marks = this.marks, dots = this.dots, step = this.step, included = this.included, disabled = this.disabled, vertical = this.vertical, reverse = this.reverse, min4 = this.min, max4 = this.max, maximumTrackStyle = this.maximumTrackStyle, railStyle = this.railStyle, dotStyle = this.dotStyle, activeDotStyle = this.activeDotStyle, id = this.id;
      var _this$$attrs = this.$attrs, className = _this$$attrs.class, style2 = _this$$attrs.style;
      var _this$renderSlider = this.renderSlider(), tracks = _this$renderSlider.tracks, handles = _this$renderSlider.handles;
      var sliderClassName = classNames(prefixCls2, className, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-with-marks"), Object.keys(marks).length), _defineProperty$R(_classNames, "".concat(prefixCls2, "-disabled"), disabled), _defineProperty$R(_classNames, "".concat(prefixCls2, "-vertical"), vertical), _classNames));
      var markProps = {
        vertical,
        marks,
        included,
        lowerBound: this.getLowerBound(),
        upperBound: this.getUpperBound(),
        max: max4,
        min: min4,
        reverse,
        class: "".concat(prefixCls2, "-mark"),
        onClickLabel: disabled ? noop$1 : this.onClickMarkLabel
      };
      var touchEvents = _defineProperty$R({}, supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart", disabled ? noop$1 : this.onTouchStart);
      return createVNode("div", _objectSpread2$2(_objectSpread2$2({
        "id": id,
        "ref": this.saveSlider,
        "tabindex": "-1",
        "class": sliderClassName
      }, touchEvents), {}, {
        "onMousedown": disabled ? noop$1 : this.onMouseDown,
        "onMouseup": disabled ? noop$1 : this.onMouseUp,
        "onKeydown": disabled ? noop$1 : this.onKeyDown,
        "onFocus": disabled ? noop$1 : this.onFocus,
        "onBlur": disabled ? noop$1 : this.onBlur,
        "style": style2
      }), [createVNode("div", {
        "class": "".concat(prefixCls2, "-rail"),
        "style": _extends$2(_extends$2({}, maximumTrackStyle), railStyle)
      }, null), tracks, createVNode(Steps$1, {
        "prefixCls": prefixCls2,
        "vertical": vertical,
        "reverse": reverse,
        "marks": marks,
        "dots": dots,
        "step": step,
        "included": included,
        "lowerBound": this.getLowerBound(),
        "upperBound": this.getUpperBound(),
        "max": max4,
        "min": min4,
        "dotStyle": dotStyle,
        "activeDotStyle": activeDotStyle
      }, null), handles, createVNode(Marks$1, markProps, {
        mark: this.$slots.mark
      }), getSlot$1(this)]);
    }
  });
}
var Slider$2 = defineComponent({
  name: "Slider",
  mixins: [BaseMixin],
  inheritAttrs: false,
  props: {
    defaultValue: Number,
    value: Number,
    disabled: {
      type: Boolean,
      default: void 0
    },
    autofocus: {
      type: Boolean,
      default: void 0
    },
    tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    reverse: {
      type: Boolean,
      default: void 0
    },
    min: Number,
    max: Number,
    ariaLabelForHandle: String,
    ariaLabelledByForHandle: String,
    ariaValueTextFormatterForHandle: String,
    startPoint: Number
  },
  emits: ["beforeChange", "afterChange", "change"],
  data: function data4() {
    var defaultValue = this.defaultValue !== void 0 ? this.defaultValue : this.min;
    var value = this.value !== void 0 ? this.value : defaultValue;
    return {
      sValue: this.trimAlignValue(value),
      dragging: false
    };
  },
  watch: {
    value: {
      handler: function handler2(val) {
        this.setChangeValue(val);
      },
      deep: true
    },
    min: function min() {
      var sValue = this.sValue;
      this.setChangeValue(sValue);
    },
    max: function max() {
      var sValue = this.sValue;
      this.setChangeValue(sValue);
    }
  },
  methods: {
    setChangeValue: function setChangeValue(value) {
      var newValue = value !== void 0 ? value : this.sValue;
      var nextValue = this.trimAlignValue(newValue, this.$props);
      if (nextValue === this.sValue)
        return;
      this.setState({
        sValue: nextValue
      });
      if (isValueOutOfRange(newValue, this.$props)) {
        this.$emit("change", nextValue);
      }
    },
    onChange: function onChange(state) {
      var isNotControlled = !hasProp(this, "value");
      var nextState = state.sValue > this.max ? _extends$2(_extends$2({}, state), {
        sValue: this.max
      }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }
      var changedValue = nextState.sValue;
      this.$emit("change", changedValue);
    },
    onStart: function onStart(position2) {
      this.setState({
        dragging: true
      });
      var sValue = this.sValue;
      this.$emit("beforeChange", sValue);
      var value = this.calcValueByPos(position2);
      this.startValue = value;
      this.startPosition = position2;
      if (value === sValue)
        return;
      this.prevMovedHandleIndex = 0;
      this.onChange({
        sValue: value
      });
    },
    onEnd: function onEnd(force) {
      var dragging = this.dragging;
      this.removeDocumentEvents();
      if (dragging || force) {
        this.$emit("afterChange", this.sValue);
      }
      this.setState({
        dragging: false
      });
    },
    onMove: function onMove(e2, position2) {
      pauseEvent(e2);
      var sValue = this.sValue;
      var value = this.calcValueByPos(position2);
      if (value === sValue)
        return;
      this.onChange({
        sValue: value
      });
    },
    onKeyboard: function onKeyboard(e2) {
      var _this$$props = this.$props, reverse = _this$$props.reverse, vertical = _this$$props.vertical;
      var valueMutator = getKeyboardValueMutator(e2, vertical, reverse);
      if (valueMutator) {
        pauseEvent(e2);
        var sValue = this.sValue;
        var mutatedValue = valueMutator(sValue, this.$props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === sValue)
          return;
        this.onChange({
          sValue: value
        });
        this.$emit("afterChange", value);
        this.onEnd();
      }
    },
    getLowerBound: function getLowerBound() {
      var minPoint = this.$props.startPoint || this.$props.min;
      return this.$data.sValue > minPoint ? minPoint : this.$data.sValue;
    },
    getUpperBound: function getUpperBound() {
      if (this.$data.sValue < this.$props.startPoint) {
        return this.$props.startPoint;
      }
      return this.$data.sValue;
    },
    trimAlignValue: function trimAlignValue(v2) {
      var nextProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (v2 === null) {
        return null;
      }
      var mergedProps = _extends$2(_extends$2({}, this.$props), nextProps);
      var val = ensureValueInRange(v2, mergedProps);
      return ensureValuePrecision(val, mergedProps);
    },
    getTrack: function getTrack(_ref) {
      var prefixCls2 = _ref.prefixCls, reverse = _ref.reverse, vertical = _ref.vertical, included = _ref.included, minimumTrackStyle = _ref.minimumTrackStyle, mergedTrackStyle = _ref.mergedTrackStyle, length = _ref.length, offset3 = _ref.offset;
      return createVNode(Track$1, {
        "class": "".concat(prefixCls2, "-track"),
        "vertical": vertical,
        "included": included,
        "offset": offset3,
        "reverse": reverse,
        "length": length,
        "style": _extends$2(_extends$2({}, minimumTrackStyle), mergedTrackStyle)
      }, null);
    },
    renderSlider: function renderSlider() {
      var _this = this;
      var prefixCls2 = this.prefixCls, vertical = this.vertical, included = this.included, disabled = this.disabled, minimumTrackStyle = this.minimumTrackStyle, trackStyle = this.trackStyle, handleStyle = this.handleStyle, tabindex = this.tabindex, ariaLabelForHandle = this.ariaLabelForHandle, ariaLabelledByForHandle = this.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = this.ariaValueTextFormatterForHandle, min4 = this.min, max4 = this.max, startPoint = this.startPoint, reverse = this.reverse, handle = this.handle, defaultHandle = this.defaultHandle;
      var handleGenerator = handle || defaultHandle;
      var sValue = this.sValue, dragging = this.dragging;
      var offset3 = this.calcOffset(sValue);
      var handles = handleGenerator({
        class: "".concat(prefixCls2, "-handle"),
        prefixCls: prefixCls2,
        vertical,
        offset: offset3,
        value: sValue,
        dragging,
        disabled,
        min: min4,
        max: max4,
        reverse,
        index: 0,
        tabindex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref2(h2) {
          return _this.saveHandle(0, h2);
        },
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });
      var trackOffset = startPoint !== void 0 ? this.calcOffset(startPoint) : 0;
      var mergedTrackStyle = trackStyle[0] || trackStyle;
      return {
        tracks: this.getTrack({
          prefixCls: prefixCls2,
          reverse,
          vertical,
          included,
          offset: trackOffset,
          minimumTrackStyle,
          mergedTrackStyle,
          length: offset3 - trackOffset
        }),
        handles
      };
    }
  }
});
var VcSlider = createSlider(Slider$2);
var _trimAlignValue = function trimAlignValue2(_ref) {
  var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props2 = _ref.props;
  var allowCross = props2.allowCross, pushable = props2.pushable;
  var thershold = Number(pushable);
  var valInRange = ensureValueInRange(value, props2);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== void 0) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return ensureValuePrecision(valNotConflict, props2);
};
var rangeProps = {
  defaultValue: PropTypes$1.arrayOf(PropTypes$1.number),
  value: PropTypes$1.arrayOf(PropTypes$1.number),
  count: Number,
  pushable: withUndefined(PropTypes$1.oneOfType([PropTypes$1.looseBool, PropTypes$1.number])),
  allowCross: {
    type: Boolean,
    default: void 0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  reverse: {
    type: Boolean,
    default: void 0
  },
  tabindex: PropTypes$1.arrayOf(PropTypes$1.number),
  prefixCls: String,
  min: Number,
  max: Number,
  autofocus: {
    type: Boolean,
    default: void 0
  },
  ariaLabelGroupForHandles: Array,
  ariaLabelledByGroupForHandles: Array,
  ariaValueTextFormatterGroupForHandles: Array,
  draggableTrack: {
    type: Boolean,
    default: void 0
  }
};
var Range = defineComponent({
  name: "Range",
  mixins: [BaseMixin],
  inheritAttrs: false,
  props: initDefaultProps$1(rangeProps, {
    count: 1,
    allowCross: true,
    pushable: false,
    tabindex: [],
    draggableTrack: false,
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
  }),
  emits: ["beforeChange", "afterChange", "change"],
  displayName: "Range",
  data: function data5() {
    var _this = this;
    var count = this.count, min4 = this.min, max4 = this.max;
    var initialValue = Array.apply(void 0, _toConsumableArray(Array(count + 1))).map(function() {
      return min4;
    });
    var defaultValue = hasProp(this, "defaultValue") ? this.defaultValue : initialValue;
    var value = this.value;
    if (value === void 0) {
      value = defaultValue;
    }
    var bounds = value.map(function(v2, i2) {
      return _trimAlignValue({
        value: v2,
        handle: i2,
        props: _this.$props
      });
    });
    var recent = bounds[0] === max4 ? 0 : bounds.length - 1;
    return {
      sHandle: null,
      recent,
      bounds
    };
  },
  watch: {
    value: {
      handler: function handler3(val) {
        var bounds = this.bounds;
        this.setChangeValue(val || bounds);
      },
      deep: true
    },
    min: function min2() {
      var value = this.value;
      this.setChangeValue(value || this.bounds);
    },
    max: function max2() {
      var value = this.value;
      this.setChangeValue(value || this.bounds);
    }
  },
  methods: {
    setChangeValue: function setChangeValue2(value) {
      var _this2 = this;
      var bounds = this.bounds;
      var nextBounds = value.map(function(v2, i2) {
        return _trimAlignValue({
          value: v2,
          handle: i2,
          bounds,
          props: _this2.$props
        });
      });
      if (bounds.length === nextBounds.length) {
        if (nextBounds.every(function(v2, i2) {
          return v2 === bounds[i2];
        })) {
          return null;
        }
      } else {
        nextBounds = value.map(function(v2, i2) {
          return _trimAlignValue({
            value: v2,
            handle: i2,
            props: _this2.$props
          });
        });
      }
      this.setState({
        bounds: nextBounds
      });
      if (value.some(function(v2) {
        return isValueOutOfRange(v2, _this2.$props);
      })) {
        var newValues = value.map(function(v2) {
          return ensureValueInRange(v2, _this2.$props);
        });
        this.$emit("change", newValues);
      }
    },
    onChange: function onChange2(state) {
      var isNotControlled = !hasProp(this, "value");
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};
        ["sHandle", "recent"].forEach(function(item) {
          if (state[item] !== void 0) {
            controlledState[item] = state[item];
          }
        });
        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }
      var data6 = _extends$2(_extends$2({}, this.$data), state);
      var changedValue = data6.bounds;
      this.$emit("change", changedValue);
    },
    positionGetValue: function positionGetValue(position2) {
      var bounds = this.getValue();
      var value = this.calcValueByPos(position2);
      var closestBound = this.getClosestBound(value);
      var index2 = this.getBoundNeedMoving(value, closestBound);
      var prevValue = bounds[index2];
      if (value === prevValue)
        return null;
      var nextBounds = _toConsumableArray(bounds);
      nextBounds[index2] = value;
      return nextBounds;
    },
    onStart: function onStart2(position2) {
      var bounds = this.bounds;
      this.$emit("beforeChange", bounds);
      var value = this.calcValueByPos(position2);
      this.startValue = value;
      this.startPosition = position2;
      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
      this.setState({
        sHandle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });
      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue)
        return;
      var nextBounds = _toConsumableArray(bounds);
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({
        bounds: nextBounds
      });
    },
    onEnd: function onEnd2(force) {
      var sHandle = this.sHandle;
      this.removeDocumentEvents();
      if (!sHandle) {
        this.dragTrack = false;
      }
      if (sHandle !== null || force) {
        this.$emit("afterChange", this.bounds);
      }
      this.setState({
        sHandle: null
      });
    },
    onMove: function onMove2(e2, position2, dragTrack, startBounds) {
      pauseEvent(e2);
      var state = this.$data, props2 = this.$props;
      var maxValue = props2.max || 100;
      var minValue = props2.min || 0;
      if (dragTrack) {
        var pos = props2.vertical ? -position2 : position2;
        pos = props2.reverse ? -pos : pos;
        var max4 = maxValue - Math.max.apply(Math, _toConsumableArray(startBounds));
        var min4 = minValue - Math.min.apply(Math, _toConsumableArray(startBounds));
        var ratio = Math.min(Math.max(pos / (this.getSliderLength() / 100), min4), max4);
        var nextBounds = startBounds.map(function(v2) {
          return Math.floor(Math.max(Math.min(v2 + ratio, maxValue), minValue));
        });
        if (state.bounds.map(function(c2, i2) {
          return c2 === nextBounds[i2];
        }).some(function(c2) {
          return !c2;
        })) {
          this.onChange({
            bounds: nextBounds
          });
        }
        return;
      }
      var bounds = this.bounds, sHandle = this.sHandle;
      var value = this.calcValueByPos(position2);
      var oldValue = bounds[sHandle];
      if (value === oldValue)
        return;
      this.moveTo(value);
    },
    onKeyboard: function onKeyboard2(e2) {
      var _this$$props = this.$props, reverse = _this$$props.reverse, vertical = _this$$props.vertical;
      var valueMutator = getKeyboardValueMutator(e2, vertical, reverse);
      if (valueMutator) {
        pauseEvent(e2);
        var bounds = this.bounds, sHandle = this.sHandle;
        var oldValue = bounds[sHandle === null ? this.recent : sHandle];
        var mutatedValue = valueMutator(oldValue, this.$props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle: sHandle,
          bounds,
          props: this.$props
        });
        if (value === oldValue)
          return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    },
    getClosestBound: function getClosestBound(value) {
      var bounds = this.bounds;
      var closestBound = 0;
      for (var i2 = 1; i2 < bounds.length - 1; i2 += 1) {
        if (value >= bounds[i2]) {
          closestBound = i2;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    },
    getBoundNeedMoving: function getBoundNeedMoving(value, closestBound) {
      var bounds = this.bounds, recent = this.recent;
      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }
      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    },
    getLowerBound: function getLowerBound2() {
      return this.bounds[0];
    },
    getUpperBound: function getUpperBound2() {
      var bounds = this.bounds;
      return bounds[bounds.length - 1];
    },
    getPoints: function getPoints() {
      var marks = this.marks, step = this.step, min4 = this.min, max4 = this.max;
      var cache2 = this.internalPointsCache;
      if (!cache2 || cache2.marks !== marks || cache2.step !== step) {
        var pointsObject = _extends$2({}, marks);
        if (step !== null) {
          for (var point = min4; point <= max4; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function(a2, b2) {
          return a2 - b2;
        });
        this.internalPointsCache = {
          marks,
          step,
          points
        };
      }
      return this.internalPointsCache.points;
    },
    moveTo: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;
      var nextBounds = _toConsumableArray(this.bounds);
      var sHandle = this.sHandle, recent = this.recent;
      var handle = sHandle === null ? recent : sHandle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (this.$props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (this.$props.allowCross) {
        nextBounds.sort(function(a2, b2) {
          return a2 - b2;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        sHandle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        this.$emit("afterChange", nextBounds);
        this.setState({}, function() {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    },
    pushSurroundingHandles: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var pushable = this.pushable;
      var threshold = Number(pushable);
      var direction2 = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction2 = 1;
      }
      if (value - bounds[handle - 1] < threshold) {
        direction2 = -1;
      }
      if (direction2 === 0) {
        return;
      }
      var nextHandle = handle + direction2;
      var diffToNext = direction2 * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction2, threshold - diffToNext)) {
        bounds[handle] = bounds[nextHandle] - direction2 * threshold;
      }
    },
    pushHandle: function pushHandle(bounds, handle, direction2, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction2 * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction2)) {
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      return true;
    },
    pushHandleOnePoint: function pushHandleOnePoint(bounds, handle, direction2) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction2;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        return false;
      }
      var nextHandle = handle + direction2;
      var nextValue = points[nextPointIndex];
      var pushable = this.pushable;
      var threshold = Number(pushable);
      var diffToNext = direction2 * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction2, threshold - diffToNext)) {
        return false;
      }
      bounds[handle] = nextValue;
      return true;
    },
    trimAlignValue: function trimAlignValue3(value) {
      var sHandle = this.sHandle, bounds = this.bounds;
      return _trimAlignValue({
        value,
        handle: sHandle,
        bounds,
        props: this.$props
      });
    },
    ensureValueNotConflict: function ensureValueNotConflict(handle, val, _ref2) {
      var allowCross = _ref2.allowCross, thershold = _ref2.pushable;
      var state = this.$data || {};
      var bounds = state.bounds;
      handle = handle === void 0 ? state.sHandle : handle;
      thershold = Number(thershold);
      if (!allowCross && handle != null && bounds !== void 0) {
        if (handle > 0 && val <= bounds[handle - 1] + thershold) {
          return bounds[handle - 1] + thershold;
        }
        if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
          return bounds[handle + 1] - thershold;
        }
      }
      return val;
    },
    getTrack: function getTrack2(_ref3) {
      var bounds = _ref3.bounds, prefixCls2 = _ref3.prefixCls, reverse = _ref3.reverse, vertical = _ref3.vertical, included = _ref3.included, offsets = _ref3.offsets, trackStyle = _ref3.trackStyle;
      return bounds.slice(0, -1).map(function(_2, index2) {
        var _classNames;
        var i2 = index2 + 1;
        var trackClassName = classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-track"), true), _defineProperty$R(_classNames, "".concat(prefixCls2, "-track-").concat(i2), true), _classNames));
        return createVNode(Track$1, {
          "class": trackClassName,
          "vertical": vertical,
          "reverse": reverse,
          "included": included,
          "offset": offsets[i2 - 1],
          "length": offsets[i2] - offsets[i2 - 1],
          "style": trackStyle[index2],
          "key": i2
        }, null);
      });
    },
    renderSlider: function renderSlider2() {
      var _this4 = this;
      var sHandle = this.sHandle, bounds = this.bounds, prefixCls2 = this.prefixCls, vertical = this.vertical, included = this.included, disabled = this.disabled, min4 = this.min, max4 = this.max, reverse = this.reverse, handle = this.handle, defaultHandle = this.defaultHandle, trackStyle = this.trackStyle, handleStyle = this.handleStyle, tabindex = this.tabindex, ariaLabelGroupForHandles = this.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = this.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = this.ariaValueTextFormatterGroupForHandles;
      var handleGenerator = handle || defaultHandle;
      var offsets = bounds.map(function(v2) {
        return _this4.calcOffset(v2);
      });
      var handleClassName = "".concat(prefixCls2, "-handle");
      var handles = bounds.map(function(v2, i2) {
        var _classNames2;
        var mergedTabIndex = tabindex[i2] || 0;
        if (disabled || tabindex[i2] === null) {
          mergedTabIndex = null;
        }
        var dragging = sHandle === i2;
        return handleGenerator({
          class: classNames((_classNames2 = {}, _defineProperty$R(_classNames2, handleClassName, true), _defineProperty$R(_classNames2, "".concat(handleClassName, "-").concat(i2 + 1), true), _defineProperty$R(_classNames2, "".concat(handleClassName, "-dragging"), dragging), _classNames2)),
          prefixCls: prefixCls2,
          vertical,
          dragging,
          offset: offsets[i2],
          value: v2,
          index: i2,
          tabindex: mergedTabIndex,
          min: min4,
          max: max4,
          reverse,
          disabled,
          style: handleStyle[i2],
          ref: function ref2(h2) {
            return _this4.saveHandle(i2, h2);
          },
          onFocus: _this4.onFocus,
          onBlur: _this4.onBlur,
          ariaLabel: ariaLabelGroupForHandles[i2],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i2],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i2]
        });
      });
      return {
        tracks: this.getTrack({
          bounds,
          prefixCls: prefixCls2,
          reverse,
          vertical,
          included,
          offsets,
          trackStyle
        }),
        handles
      };
    }
  }
});
var VcRange = createSlider(Range);
var SliderTooltip = defineComponent({
  name: "SliderTooltip",
  inheritAttrs: false,
  props: tooltipProps(),
  setup: function setup126(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var innerRef = ref(null);
    var rafRef = ref(null);
    function cancelKeepAlign() {
      wrapperRaf.cancel(rafRef.value);
      rafRef.value = null;
    }
    function keepAlign() {
      rafRef.value = wrapperRaf(function() {
        var _a2;
        (_a2 = innerRef.value) === null || _a2 === void 0 ? void 0 : _a2.forcePopupAlign();
        rafRef.value = null;
      });
    }
    var align = function align2() {
      cancelKeepAlign();
      if (props2.visible) {
        keepAlign();
      }
    };
    watch([function() {
      return props2.visible;
    }, function() {
      return props2.title;
    }], function() {
      align();
    }, {
      flush: "post",
      immediate: true
    });
    onActivated(function() {
      align();
    });
    onBeforeUnmount(function() {
      cancelKeepAlign();
    });
    return function() {
      return createVNode(Tooltip, _objectSpread2$2(_objectSpread2$2({
        "ref": innerRef
      }, props2), attrs), slots);
    };
  }
});
var __rest$b = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var defaultTipFormatter = function defaultTipFormatter2(value) {
  return typeof value === "number" ? value.toString() : "";
};
var sliderProps = function sliderProps2() {
  return {
    id: String,
    prefixCls: String,
    tooltipPrefixCls: String,
    range: {
      type: [Boolean, Object],
      default: void 0
    },
    reverse: {
      type: Boolean,
      default: void 0
    },
    min: Number,
    max: Number,
    step: {
      type: [Number, Object]
    },
    marks: {
      type: Object
    },
    dots: {
      type: Boolean,
      default: void 0
    },
    value: {
      type: [Number, Array]
    },
    defaultValue: {
      type: [Number, Array]
    },
    included: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    vertical: {
      type: Boolean,
      default: void 0
    },
    tipFormatter: {
      type: [Function, Object],
      default: function _default7() {
        return defaultTipFormatter;
      }
    },
    tooltipVisible: {
      type: Boolean,
      default: void 0
    },
    tooltipPlacement: {
      type: String
    },
    getTooltipPopupContainer: {
      type: Function
    },
    autofocus: {
      type: Boolean,
      default: void 0
    },
    handleStyle: {
      type: [Object, Array]
    },
    trackStyle: {
      type: [Object, Array]
    },
    onChange: {
      type: Function
    },
    onAfterChange: {
      type: Function
    },
    onFocus: {
      type: Function
    },
    onBlur: {
      type: Function
    },
    "onUpdate:value": {
      type: Function
    }
  };
};
var Slider = defineComponent({
  name: "ASlider",
  inheritAttrs: false,
  props: sliderProps(),
  slots: ["mark"],
  setup: function setup127(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    var _useConfigInject = useConfigInject("slider", props2), prefixCls2 = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, direction2 = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer, configProvider = _useConfigInject.configProvider;
    var formItemContext = useInjectFormItemContext();
    var sliderRef = ref();
    var visibles = ref({});
    var toggleTooltipVisible = function toggleTooltipVisible2(index2, visible) {
      visibles.value[index2] = visible;
    };
    var tooltipPlacement = computed(function() {
      if (props2.tooltipPlacement) {
        return props2.tooltipPlacement;
      }
      if (!props2.vertical) {
        return "top";
      }
      return direction2.value === "rtl" ? "left" : "right";
    });
    var focus2 = function focus3() {
      var _a2;
      (_a2 = sliderRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = sliderRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    var handleChange2 = function handleChange3(val) {
      emit("update:value", val);
      emit("change", val);
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2(e2) {
      emit("blur", e2);
    };
    expose({
      focus: focus2,
      blur
    });
    var handleWithTooltip = function handleWithTooltip2(_a2) {
      var tooltipPrefixCls = _a2.tooltipPrefixCls, _b = _a2.info, value = _b.value, dragging = _b.dragging, index2 = _b.index, restProps = __rest$b(_b, ["value", "dragging", "index"]);
      var tipFormatter = props2.tipFormatter, tooltipVisible = props2.tooltipVisible, getTooltipPopupContainer = props2.getTooltipPopupContainer;
      var isTipFormatter = tipFormatter ? visibles.value[index2] || dragging : false;
      var visible = tooltipVisible || tooltipVisible === void 0 && isTipFormatter;
      return createVNode(SliderTooltip, {
        "prefixCls": tooltipPrefixCls,
        "title": tipFormatter ? tipFormatter(value) : "",
        "visible": visible,
        "placement": tooltipPlacement.value,
        "transitionName": "".concat(rootPrefixCls.value, "-zoom-down"),
        "key": index2,
        "overlayClassName": "".concat(prefixCls2.value, "-tooltip"),
        "getPopupContainer": getTooltipPopupContainer || getPopupContainer.value
      }, {
        default: function _default7() {
          return [createVNode(VcHandle, _objectSpread2$2(_objectSpread2$2({}, restProps), {}, {
            "value": value,
            "onMouseenter": function onMouseenter2() {
              return toggleTooltipVisible(index2, true);
            },
            "onMouseleave": function onMouseleave2() {
              return toggleTooltipVisible(index2, false);
            }
          }), null)];
        }
      });
    };
    return function() {
      var customizeTooltipPrefixCls = props2.tooltipPrefixCls, range3 = props2.range, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, restProps = __rest$b(props2, ["tooltipPrefixCls", "range", "id"]);
      var tooltipPrefixCls = configProvider.getPrefixCls("tooltip", customizeTooltipPrefixCls);
      var cls = classNames(attrs.class, _defineProperty$R({}, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"));
      if (direction2.value === "rtl" && !restProps.vertical) {
        restProps.reverse = !restProps.reverse;
      }
      var draggableTrack;
      if (_typeof$2(range3) === "object") {
        draggableTrack = range3.draggableTrack;
      }
      if (range3) {
        return createVNode(VcRange, _objectSpread2$2(_objectSpread2$2({}, restProps), {}, {
          "step": restProps.step,
          "draggableTrack": draggableTrack,
          "class": cls,
          "ref": sliderRef,
          "handle": function handle(info) {
            return handleWithTooltip({
              tooltipPrefixCls,
              prefixCls: prefixCls2.value,
              info
            });
          },
          "prefixCls": prefixCls2.value,
          "onChange": handleChange2,
          "onBlur": handleBlur
        }), {
          mark: slots.mark
        });
      }
      return createVNode(VcSlider, _objectSpread2$2(_objectSpread2$2({}, restProps), {}, {
        "id": id,
        "step": restProps.step,
        "class": cls,
        "ref": sliderRef,
        "handle": function handle(info) {
          return handleWithTooltip({
            tooltipPrefixCls,
            prefixCls: prefixCls2.value,
            info
          });
        },
        "prefixCls": prefixCls2.value,
        "onChange": handleChange2,
        "onBlur": handleBlur
      }), {
        mark: slots.mark
      });
    };
  }
});
var Slider$1 = withInstall$2(Slider);
var SwitchSizes = tuple$1("small", "default");
var switchProps = function switchProps2() {
  return {
    id: String,
    prefixCls: String,
    size: PropTypes$1.oneOf(SwitchSizes),
    disabled: {
      type: Boolean,
      default: void 0
    },
    checkedChildren: PropTypes$1.any,
    unCheckedChildren: PropTypes$1.any,
    tabindex: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
    autofocus: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    checked: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.looseBool]),
    checkedValue: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.looseBool]).def(true),
    unCheckedValue: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.looseBool]).def(false),
    onChange: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onKeydown: {
      type: Function
    },
    onMouseup: {
      type: Function
    },
    "onUpdate:checked": {
      type: Function
    },
    onBlur: Function,
    onFocus: Function
  };
};
var Switch = defineComponent({
  name: "ASwitch",
  __ANT_SWITCH: true,
  inheritAttrs: false,
  props: switchProps(),
  slots: ["checkedChildren", "unCheckedChildren"],
  setup: function setup128(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose, emit = _ref.emit;
    var formItemContext = useInjectFormItemContext();
    onBeforeMount(function() {
      warning$2(!("defaultChecked" in attrs), "Switch", "'defaultChecked' is deprecated, please use 'v-model:checked'");
      warning$2(!("value" in attrs), "Switch", "`value` is not validate prop, do you mean `checked`?");
    });
    var checked = ref(props2.checked !== void 0 ? props2.checked : attrs.defaultChecked);
    var checkedStatus = computed(function() {
      return checked.value === props2.checkedValue;
    });
    watch(function() {
      return props2.checked;
    }, function() {
      checked.value = props2.checked;
    });
    var _useConfigInject = useConfigInject("switch", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, size = _useConfigInject.size;
    var refSwitchNode = ref();
    var focus2 = function focus3() {
      var _a2;
      (_a2 = refSwitchNode.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    var blur = function blur2() {
      var _a2;
      (_a2 = refSwitchNode.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
    };
    expose({
      focus: focus2,
      blur
    });
    onMounted(function() {
      nextTick(function() {
        if (props2.autofocus && !props2.disabled) {
          refSwitchNode.value.focus();
        }
      });
    });
    var setChecked = function setChecked2(check, e2) {
      if (props2.disabled) {
        return;
      }
      emit("update:checked", check);
      emit("change", check, e2);
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2(e2) {
      emit("blur", e2);
    };
    var handleClick = function handleClick2(e2) {
      focus2();
      var newChecked = checkedStatus.value ? props2.unCheckedValue : props2.checkedValue;
      setChecked(newChecked, e2);
      emit("click", newChecked, e2);
    };
    var handleKeyDown2 = function handleKeyDown3(e2) {
      if (e2.keyCode === KeyCode$1.LEFT) {
        setChecked(props2.unCheckedValue, e2);
      } else if (e2.keyCode === KeyCode$1.RIGHT) {
        setChecked(props2.checkedValue, e2);
      }
      emit("keydown", e2);
    };
    var handleMouseUp = function handleMouseUp2(e2) {
      var _a2;
      (_a2 = refSwitchNode.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      emit("mouseup", e2);
    };
    var classNames2 = computed(function() {
      var _ref2;
      return _ref2 = {}, _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-small"), size.value === "small"), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-loading"), props2.loading), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-checked"), checkedStatus.value), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-disabled"), props2.disabled), _defineProperty$R(_ref2, prefixCls2.value, true), _defineProperty$R(_ref2, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _ref2;
    });
    return function() {
      var _a2;
      return createVNode(Wave, {
        "insertExtraNode": true
      }, {
        default: function _default7() {
          return [createVNode("button", _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, omit$3(props2, ["prefixCls", "checkedChildren", "unCheckedChildren", "checked", "autofocus", "checkedValue", "unCheckedValue", "id", "onChange", "onUpdate:checked"])), attrs), {}, {
            "id": (_a2 = props2.id) !== null && _a2 !== void 0 ? _a2 : formItemContext.id.value,
            "onKeydown": handleKeyDown2,
            "onClick": handleClick,
            "onBlur": handleBlur,
            "onMouseup": handleMouseUp,
            "type": "button",
            "role": "switch",
            "aria-checked": checked.value,
            "disabled": props2.disabled || props2.loading,
            "class": [attrs.class, classNames2.value],
            "ref": refSwitchNode
          }), [createVNode("div", {
            "class": "".concat(prefixCls2.value, "-handle")
          }, [props2.loading ? createVNode(LoadingOutlined$1, {
            "class": "".concat(prefixCls2.value, "-loading-icon")
          }, null) : null]), createVNode("span", {
            "class": "".concat(prefixCls2.value, "-inner")
          }, [checkedStatus.value ? getPropsSlot(slots, props2, "checkedChildren") : getPropsSlot(slots, props2, "unCheckedChildren")])])];
        }
      });
    };
  }
});
var Switch$1 = withInstall$2(Switch);
var TableContextKey = Symbol("TableContextProps");
var useProvideTable = function useProvideTable2(props2) {
  provide(TableContextKey, props2);
};
var useInjectTable = function useInjectTable2() {
  return inject(TableContextKey, {});
};
var INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function toArray$1(arr) {
  if (arr === void 0 || arr === null) {
    return [];
  }
  return Array.isArray(arr) ? arr : [arr];
}
function getPathValue(record, path) {
  if (!path && typeof path !== "number") {
    return record;
  }
  var pathList = toArray$1(path);
  var current2 = record;
  for (var i2 = 0; i2 < pathList.length; i2 += 1) {
    if (!current2) {
      return null;
    }
    var prop = pathList[i2];
    current2 = current2[prop];
  }
  return current2;
}
function getColumnsKey(columns2) {
  var columnKeys = [];
  var keys2 = {};
  columns2.forEach(function(column) {
    var _ref = column || {}, key2 = _ref.key, dataIndex = _ref.dataIndex;
    var mergedKey = key2 || toArray$1(dataIndex).join("-") || INTERNAL_KEY_PREFIX;
    while (keys2[mergedKey]) {
      mergedKey = "".concat(mergedKey, "_next");
    }
    keys2[mergedKey] = true;
    columnKeys.push(mergedKey);
  });
  return columnKeys;
}
function mergeObject() {
  var merged = {};
  function fillProps(obj, clone3) {
    if (clone3) {
      Object.keys(clone3).forEach(function(key2) {
        var value = clone3[key2];
        if (value && _typeof$2(value) === "object") {
          obj[key2] = obj[key2] || {};
          fillProps(obj[key2], value);
        } else {
          obj[key2] = value;
        }
      });
    }
  }
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  objects.forEach(function(clone3) {
    fillProps(merged, clone3);
  });
  return merged;
}
function validateValue(val) {
  return val !== null && val !== void 0;
}
var SlotsContextKey = Symbol("SlotsContextProps");
var useProvideSlots = function useProvideSlots2(props2) {
  provide(SlotsContextKey, props2);
};
var useInjectSlots = function useInjectSlots2() {
  return inject(SlotsContextKey, computed(function() {
    return {};
  }));
};
var ContextKey = Symbol("ContextProps");
var useProvideTableContext = function useProvideTableContext2(props2) {
  provide(ContextKey, props2);
};
var useInjectTableContext = function useInjectTableContext2() {
  return inject(ContextKey, {
    onResizeColumn: function onResizeColumn() {
    }
  });
};
globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var INTERNAL_COL_DEFINE = "RC_TABLE_INTERNAL_COL_DEFINE";
var HoverContextKey = Symbol("HoverContextProps");
var useProvideHover = function useProvideHover2(props2) {
  provide(HoverContextKey, props2);
};
var useInjectHover = function useInjectHover2() {
  return inject(HoverContextKey, {
    startRow: ref(-1),
    endRow: ref(-1),
    onHover: function onHover() {
    }
  });
};
var supportSticky = ref(false);
var useProvideSticky = function useProvideSticky2() {
  onMounted(function() {
    supportSticky.value = supportSticky.value || isStyleSupport("position", "sticky");
  });
};
var useInjectSticky = function useInjectSticky2() {
  return supportSticky;
};
var __rest$a = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
  var cellEndRow = cellStartRow + cellRowSpan - 1;
  return cellStartRow <= endRow && cellEndRow >= startRow;
}
function isRenderCell(data6) {
  return data6 && _typeof$2(data6) === "object" && !Array.isArray(data6) && !isVNode(data6);
}
var Cell2 = defineComponent({
  name: "Cell",
  props: ["prefixCls", "record", "index", "renderIndex", "dataIndex", "customRender", "component", "colSpan", "rowSpan", "fixLeft", "fixRight", "firstFixLeft", "lastFixLeft", "firstFixRight", "lastFixRight", "appendNode", "additionalProps", "ellipsis", "align", "rowType", "isSticky", "column", "cellType", "transformCellText"],
  slots: ["appendNode"],
  setup: function setup129(props2, _ref) {
    var slots = _ref.slots;
    var contextSlots = useInjectSlots();
    var _useInjectHover = useInjectHover(), onHover = _useInjectHover.onHover, startRow = _useInjectHover.startRow, endRow = _useInjectHover.endRow;
    var colSpan = computed(function() {
      var _a2, _b, _c, _d;
      return (_c = (_a2 = props2.colSpan) !== null && _a2 !== void 0 ? _a2 : (_b = props2.additionalProps) === null || _b === void 0 ? void 0 : _b.colSpan) !== null && _c !== void 0 ? _c : (_d = props2.additionalProps) === null || _d === void 0 ? void 0 : _d.colspan;
    });
    var rowSpan = computed(function() {
      var _a2, _b, _c, _d;
      return (_c = (_a2 = props2.rowSpan) !== null && _a2 !== void 0 ? _a2 : (_b = props2.additionalProps) === null || _b === void 0 ? void 0 : _b.rowSpan) !== null && _c !== void 0 ? _c : (_d = props2.additionalProps) === null || _d === void 0 ? void 0 : _d.rowspan;
    });
    var hovering = eagerComputed(function() {
      var index2 = props2.index;
      return inHoverRange(index2, rowSpan.value || 1, startRow.value, endRow.value);
    });
    var supportSticky2 = useInjectSticky();
    var _onMouseenter = function onMouseenter2(event, mergedRowSpan) {
      var _a2;
      var record = props2.record, index2 = props2.index, additionalProps = props2.additionalProps;
      if (record) {
        onHover(index2, index2 + mergedRowSpan - 1);
      }
      (_a2 = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.onMouseenter) === null || _a2 === void 0 ? void 0 : _a2.call(additionalProps, event);
    };
    var onMouseleave2 = function onMouseleave3(event) {
      var _a2;
      var record = props2.record, additionalProps = props2.additionalProps;
      if (record) {
        onHover(-1, -1);
      }
      (_a2 = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.onMouseleave) === null || _a2 === void 0 ? void 0 : _a2.call(additionalProps, event);
    };
    return function() {
      var _classNames;
      var _a2, _b, _c, _d, _e, _f;
      var prefixCls2 = props2.prefixCls, record = props2.record, index2 = props2.index, renderIndex = props2.renderIndex, dataIndex = props2.dataIndex, customRender = props2.customRender, _props$component = props2.component, Component = _props$component === void 0 ? "td" : _props$component, fixLeft = props2.fixLeft, fixRight = props2.fixRight, firstFixLeft = props2.firstFixLeft, lastFixLeft = props2.lastFixLeft, firstFixRight = props2.firstFixRight, lastFixRight = props2.lastFixRight, _props$appendNode = props2.appendNode, appendNode = _props$appendNode === void 0 ? (_a2 = slots.appendNode) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$appendNode, _props$additionalProp = props2.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, ellipsis = props2.ellipsis, align = props2.align, rowType = props2.rowType, isSticky = props2.isSticky, _props$column = props2.column, column = _props$column === void 0 ? {} : _props$column, cellType = props2.cellType;
      var cellPrefixCls = "".concat(prefixCls2, "-cell");
      var cellProps;
      var childNode;
      var children = (_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots);
      if (validateValue(children) || cellType === "header") {
        childNode = children;
      } else {
        var value = getPathValue(record, dataIndex);
        childNode = value;
        if (customRender) {
          var renderData = customRender({
            text: value,
            value,
            record,
            index: index2,
            renderIndex,
            column: column.__originColumn__
          });
          if (isRenderCell(renderData)) {
            childNode = renderData.children;
            cellProps = renderData.props;
          } else {
            childNode = renderData;
          }
        }
        if (!(INTERNAL_COL_DEFINE in column) && cellType === "body" && contextSlots.value.bodyCell && !((_c = column.slots) === null || _c === void 0 ? void 0 : _c.customRender)) {
          var child = renderSlot(contextSlots.value, "bodyCell", {
            text: value,
            value,
            record,
            index: index2,
            column: column.__originColumn__
          }, function() {
            var fallback = childNode === void 0 ? value : childNode;
            return [_typeof$2(fallback) === "object" && isValidElement(fallback) || _typeof$2(fallback) !== "object" ? fallback : null];
          });
          childNode = flattenChildren(child);
        }
        if (props2.transformCellText) {
          childNode = props2.transformCellText({
            text: childNode,
            record,
            index: index2,
            column: column.__originColumn__
          });
        }
      }
      if (_typeof$2(childNode) === "object" && !Array.isArray(childNode) && !isVNode(childNode)) {
        childNode = null;
      }
      if (ellipsis && (lastFixLeft || firstFixRight)) {
        childNode = createVNode("span", {
          "class": "".concat(cellPrefixCls, "-content")
        }, [childNode]);
      }
      if (Array.isArray(childNode) && childNode.length === 1) {
        childNode = childNode[0];
      }
      var _g = cellProps || {}, cellColSpan = _g.colSpan, cellRowSpan = _g.rowSpan, cellStyle = _g.style, cellClassName = _g.class, restCellProps = __rest$a(_g, ["colSpan", "rowSpan", "style", "class"]);
      var mergedColSpan = (_d = cellColSpan !== void 0 ? cellColSpan : colSpan.value) !== null && _d !== void 0 ? _d : 1;
      var mergedRowSpan = (_e = cellRowSpan !== void 0 ? cellRowSpan : rowSpan.value) !== null && _e !== void 0 ? _e : 1;
      if (mergedColSpan === 0 || mergedRowSpan === 0) {
        return null;
      }
      var fixedStyle = {};
      var isFixLeft = typeof fixLeft === "number" && supportSticky2.value;
      var isFixRight = typeof fixRight === "number" && supportSticky2.value;
      if (isFixLeft) {
        fixedStyle.position = "sticky";
        fixedStyle.left = "".concat(fixLeft, "px");
      }
      if (isFixRight) {
        fixedStyle.position = "sticky";
        fixedStyle.right = "".concat(fixRight, "px");
      }
      var alignStyle = {};
      if (align) {
        alignStyle.textAlign = align;
      }
      var title;
      var ellipsisConfig = ellipsis === true ? {
        showTitle: true
      } : ellipsis;
      if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === "header")) {
        if (typeof childNode === "string" || typeof childNode === "number") {
          title = childNode.toString();
        } else if (isVNode(childNode) && typeof childNode.children === "string") {
          title = childNode.children;
        }
      }
      var componentProps = _extends$2(_extends$2(_extends$2({
        title
      }, restCellProps), additionalProps), {
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null,
        class: classNames(cellPrefixCls, (_classNames = {}, _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky2.value), _defineProperty$R(_classNames, "".concat(cellPrefixCls, "-row-hover"), !cellProps && hovering.value), _classNames), additionalProps.class, cellClassName),
        onMouseenter: function onMouseenter2(e2) {
          _onMouseenter(e2, mergedRowSpan);
        },
        onMouseleave: onMouseleave2,
        style: _extends$2(_extends$2(_extends$2(_extends$2({}, parseStyleText(additionalProps.style)), alignStyle), fixedStyle), cellStyle)
      });
      return createVNode(Component, componentProps, {
        default: function _default7() {
          return [appendNode, childNode, (_f = slots.dragHandle) === null || _f === void 0 ? void 0 : _f.call(slots)];
        }
      });
    };
  }
});
function getCellFixedInfo(colStart, colEnd, columns2, stickyOffsets, direction2) {
  var startColumn = columns2[colStart] || {};
  var endColumn = columns2[colEnd] || {};
  var fixLeft;
  var fixRight;
  if (startColumn.fixed === "left") {
    fixLeft = stickyOffsets.left[colStart];
  } else if (endColumn.fixed === "right") {
    fixRight = stickyOffsets.right[colEnd];
  }
  var lastFixLeft = false;
  var firstFixRight = false;
  var lastFixRight = false;
  var firstFixLeft = false;
  var nextColumn = columns2[colEnd + 1];
  var prevColumn = columns2[colStart - 1];
  if (direction2 === "rtl") {
    if (fixLeft !== void 0) {
      var prevFixLeft = prevColumn && prevColumn.fixed === "left";
      firstFixLeft = !prevFixLeft;
    } else if (fixRight !== void 0) {
      var nextFixRight = nextColumn && nextColumn.fixed === "right";
      lastFixRight = !nextFixRight;
    }
  } else if (fixLeft !== void 0) {
    var nextFixLeft = nextColumn && nextColumn.fixed === "left";
    lastFixLeft = !nextFixLeft;
  } else if (fixRight !== void 0) {
    var prevFixRight = prevColumn && prevColumn.fixed === "right";
    firstFixRight = !prevFixRight;
  }
  return {
    fixLeft,
    fixRight,
    lastFixLeft,
    firstFixRight,
    lastFixRight,
    firstFixLeft,
    isSticky: stickyOffsets.isSticky
  };
}
var events = {
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  },
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  }
};
var defaultMinWidth = 50;
var DragHandleVue = defineComponent({
  name: "DragHandle",
  props: {
    prefixCls: String,
    width: {
      type: Number,
      required: true
    },
    minWidth: {
      type: Number,
      default: defaultMinWidth
    },
    maxWidth: {
      type: Number,
      default: Infinity
    },
    column: {
      type: Object,
      default: void 0
    }
  },
  setup: function setup130(props2) {
    var startX = 0;
    var moveEvent = {
      remove: function remove() {
      }
    };
    var stopEvent = {
      remove: function remove() {
      }
    };
    var removeEvents2 = function removeEvents3() {
      moveEvent.remove();
      stopEvent.remove();
    };
    onUnmounted(function() {
      removeEvents2();
    });
    watchEffect(function() {
      devWarning(!isNaN(props2.width), "Table", "width must be a number when use resizable");
    });
    var _useInjectTableContex = useInjectTableContext(), onResizeColumn = _useInjectTableContex.onResizeColumn;
    var minWidth = computed(function() {
      return typeof props2.minWidth === "number" && !isNaN(props2.minWidth) ? props2.minWidth : defaultMinWidth;
    });
    var maxWidth = computed(function() {
      return typeof props2.maxWidth === "number" && !isNaN(props2.maxWidth) ? props2.maxWidth : Infinity;
    });
    var instance2 = getCurrentInstance();
    var baseWidth = 0;
    var dragging = ref(false);
    var rafId;
    var updateWidth = function updateWidth2(e2) {
      var pageX = 0;
      if (e2.touches) {
        if (e2.touches.length) {
          pageX = e2.touches[0].pageX;
        } else {
          pageX = e2.changedTouches[0].pageX;
        }
      } else {
        pageX = e2.pageX;
      }
      var tmpDeltaX = startX - pageX;
      var w2 = Math.max(baseWidth - tmpDeltaX, minWidth.value);
      w2 = Math.min(w2, maxWidth.value);
      wrapperRaf.cancel(rafId);
      rafId = wrapperRaf(function() {
        onResizeColumn(w2, props2.column.__originColumn__);
      });
    };
    var handleMove = function handleMove2(e2) {
      updateWidth(e2);
    };
    var handleStop = function handleStop2(e2) {
      dragging.value = false;
      updateWidth(e2);
      removeEvents2();
    };
    var handleStart = function handleStart2(e2, eventsFor) {
      dragging.value = true;
      removeEvents2();
      baseWidth = instance2.vnode.el.parentNode.getBoundingClientRect().width;
      if (e2 instanceof MouseEvent && e2.which !== 1) {
        return;
      }
      if (e2.stopPropagation)
        e2.stopPropagation();
      startX = e2.touches ? e2.touches[0].pageX : e2.pageX;
      moveEvent = addEventListenerWrap(document.documentElement, eventsFor.move, handleMove);
      stopEvent = addEventListenerWrap(document.documentElement, eventsFor.stop, handleStop);
    };
    var handleDown = function handleDown2(e2) {
      e2.stopPropagation();
      e2.preventDefault();
      handleStart(e2, events.mouse);
    };
    var handleTouchDown = function handleTouchDown2(e2) {
      e2.stopPropagation();
      e2.preventDefault();
      handleStart(e2, events.touch);
    };
    var handleClick = function handleClick2(e2) {
      e2.stopPropagation();
      e2.preventDefault();
    };
    return function() {
      var prefixCls2 = props2.prefixCls;
      var touchEvents = _defineProperty$R({}, supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart", function(e2) {
        return handleTouchDown(e2);
      });
      return createVNode("div", _objectSpread2$2(_objectSpread2$2({
        "class": "".concat(prefixCls2, "-resize-handle ").concat(dragging.value ? "dragging" : ""),
        "onMousedown": handleDown
      }, touchEvents), {}, {
        "onClick": handleClick
      }), [createVNode("div", {
        "class": "".concat(prefixCls2, "-resize-handle-line")
      }, null)]);
    };
  }
});
var HeaderRow = defineComponent({
  name: "HeaderRow",
  props: ["cells", "stickyOffsets", "flattenColumns", "rowComponent", "cellComponent", "index", "customHeaderRow"],
  setup: function setup131(props2) {
    var tableContext = useInjectTable();
    return function() {
      var prefixCls2 = tableContext.prefixCls, direction2 = tableContext.direction;
      var cells = props2.cells, stickyOffsets = props2.stickyOffsets, flattenColumns = props2.flattenColumns, RowComponent = props2.rowComponent, CellComponent2 = props2.cellComponent, customHeaderRow = props2.customHeaderRow, index2 = props2.index;
      var rowProps3;
      if (customHeaderRow) {
        rowProps3 = customHeaderRow(cells.map(function(cell) {
          return cell.column;
        }), index2);
      }
      var columnsKey = getColumnsKey(cells.map(function(cell) {
        return cell.column;
      }));
      return createVNode(RowComponent, rowProps3, {
        default: function _default7() {
          return [cells.map(function(cell, cellIndex) {
            var column = cell.column;
            var fixedInfo = getCellFixedInfo(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction2);
            var additionalProps;
            if (column && column.customHeaderCell) {
              additionalProps = cell.column.customHeaderCell(column);
            }
            var col = column;
            return createVNode(Cell2, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, cell), {}, {
              "cellType": "header",
              "ellipsis": column.ellipsis,
              "align": column.align,
              "component": CellComponent2,
              "prefixCls": prefixCls2,
              "key": columnsKey[cellIndex]
            }, fixedInfo), {}, {
              "additionalProps": additionalProps,
              "rowType": "header",
              "column": column
            }), {
              default: function _default8() {
                return column.title;
              },
              dragHandle: function dragHandle() {
                return col.resizable ? createVNode(DragHandleVue, {
                  "prefixCls": prefixCls2,
                  "width": col.width,
                  "minWidth": col.minWidth,
                  "maxWidth": col.maxWidth,
                  "column": col
                }, null) : null;
              }
            });
          })];
        }
      });
    };
  }
});
function parseHeaderRows(rootColumns) {
  var rows = [];
  function fillRowCells(columns2, colIndex) {
    var rowIndex2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    rows[rowIndex2] = rows[rowIndex2] || [];
    var currentColIndex = colIndex;
    var colSpans = columns2.filter(Boolean).map(function(column) {
      var cell = {
        key: column.key,
        class: classNames(column.className, column.class),
        column,
        colStart: currentColIndex
      };
      var colSpan = 1;
      var subColumns = column.children;
      if (subColumns && subColumns.length > 0) {
        colSpan = fillRowCells(subColumns, currentColIndex, rowIndex2 + 1).reduce(function(total3, count) {
          return total3 + count;
        }, 0);
        cell.hasSubColumns = true;
      }
      if ("colSpan" in column) {
        colSpan = column.colSpan;
      }
      if ("rowSpan" in column) {
        cell.rowSpan = column.rowSpan;
      }
      cell.colSpan = colSpan;
      cell.colEnd = cell.colStart + colSpan - 1;
      rows[rowIndex2].push(cell);
      currentColIndex += colSpan;
      return colSpan;
    });
    return colSpans;
  }
  fillRowCells(rootColumns, 0);
  var rowCount = rows.length;
  var _loop = function _loop2(rowIndex2) {
    rows[rowIndex2].forEach(function(cell) {
      if (!("rowSpan" in cell) && !cell.hasSubColumns) {
        cell.rowSpan = rowCount - rowIndex2;
      }
    });
  };
  for (var rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    _loop(rowIndex);
  }
  return rows;
}
var Header = defineComponent({
  name: "Header",
  inheritAttrs: false,
  props: ["columns", "flattenColumns", "stickyOffsets", "customHeaderRow"],
  setup: function setup132(props2) {
    var tableContext = useInjectTable();
    var rows = computed(function() {
      return parseHeaderRows(props2.columns);
    });
    return function() {
      var prefixCls2 = tableContext.prefixCls, getComponent3 = tableContext.getComponent;
      var stickyOffsets = props2.stickyOffsets, flattenColumns = props2.flattenColumns, customHeaderRow = props2.customHeaderRow;
      var WrapperComponent = getComponent3(["header", "wrapper"], "thead");
      var trComponent = getComponent3(["header", "row"], "tr");
      var thComponent = getComponent3(["header", "cell"], "th");
      return createVNode(WrapperComponent, {
        "class": "".concat(prefixCls2, "-thead")
      }, {
        default: function _default7() {
          return [rows.value.map(function(row, rowIndex) {
            var rowNode = createVNode(HeaderRow, {
              "key": rowIndex,
              "flattenColumns": flattenColumns,
              "cells": row,
              "stickyOffsets": stickyOffsets,
              "rowComponent": trComponent,
              "cellComponent": thComponent,
              "customHeaderRow": customHeaderRow,
              "index": rowIndex
            }, null);
            return rowNode;
          })];
        }
      });
    };
  }
});
var ExpandedRowContextKey = Symbol("ExpandedRowProps");
var useProvideExpandedRow = function useProvideExpandedRow2(props2) {
  provide(ExpandedRowContextKey, props2);
};
var useInjectExpandedRow = function useInjectExpandedRow2() {
  return inject(ExpandedRowContextKey, {});
};
var ExpandedRow = defineComponent({
  name: "ExpandedRow",
  inheritAttrs: false,
  props: ["prefixCls", "component", "cellComponent", "expanded", "colSpan", "isEmpty"],
  setup: function setup133(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var tableContext = useInjectTable();
    var expandedRowContext = useInjectExpandedRow();
    var fixHeader = expandedRowContext.fixHeader, fixColumn = expandedRowContext.fixColumn, componentWidth = expandedRowContext.componentWidth, horizonScroll = expandedRowContext.horizonScroll;
    return function() {
      var prefixCls2 = props2.prefixCls, Component = props2.component, cellComponent = props2.cellComponent, expanded = props2.expanded, colSpan = props2.colSpan, isEmpty = props2.isEmpty;
      return createVNode(Component, {
        "class": attrs.class,
        "style": {
          display: expanded ? null : "none"
        }
      }, {
        default: function _default7() {
          return [createVNode(Cell2, {
            "component": cellComponent,
            "prefixCls": prefixCls2,
            "colSpan": colSpan
          }, {
            default: function _default8() {
              var _a2;
              var contentNode = (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
              if (isEmpty ? horizonScroll.value : fixColumn.value) {
                contentNode = createVNode("div", {
                  "style": {
                    width: "".concat(componentWidth.value - (fixHeader.value ? tableContext.scrollbarSize : 0), "px"),
                    position: "sticky",
                    left: 0,
                    overflow: "hidden"
                  },
                  "class": "".concat(prefixCls2, "-expanded-row-fixed")
                }, [contentNode]);
              }
              return contentNode;
            }
          })];
        }
      });
    };
  }
});
var MeasureCell = defineComponent({
  name: "MeasureCell",
  props: ["columnKey"],
  setup: function setup134(props2, _ref) {
    var emit = _ref.emit;
    var tdRef = ref();
    onMounted(function() {
      if (tdRef.value) {
        emit("columnResize", props2.columnKey, tdRef.value.offsetWidth);
      }
    });
    return function() {
      return createVNode(ResizeObserver$1, {
        "onResize": function onResize(_ref2) {
          var offsetWidth = _ref2.offsetWidth;
          emit("columnResize", props2.columnKey, offsetWidth);
        }
      }, {
        default: function _default7() {
          return [createVNode("td", {
            "ref": tdRef,
            "style": {
              padding: 0,
              border: 0,
              height: 0
            }
          }, [createVNode("div", {
            "style": {
              height: 0,
              overflow: "hidden"
            }
          }, [createTextVNode("\xA0")])])];
        }
      });
    };
  }
});
var BodyContextKey = Symbol("BodyContextProps");
var useProvideBody = function useProvideBody2(props2) {
  provide(BodyContextKey, props2);
};
var useInjectBody = function useInjectBody2() {
  return inject(BodyContextKey, {});
};
var BodyRow = defineComponent({
  name: "BodyRow",
  inheritAttrs: false,
  props: ["record", "index", "renderIndex", "recordKey", "expandedKeys", "rowComponent", "cellComponent", "customRow", "rowExpandable", "indent", "rowKey", "getRowKey", "childrenColumnName"],
  setup: function setup135(props2, _ref) {
    var attrs = _ref.attrs;
    var tableContext = useInjectTable();
    var bodyContext = useInjectBody();
    var expandRended = ref(false);
    var expanded = computed(function() {
      return props2.expandedKeys && props2.expandedKeys.has(props2.recordKey);
    });
    watchEffect(function() {
      if (expanded.value) {
        expandRended.value = true;
      }
    });
    var rowSupportExpand = computed(function() {
      return bodyContext.expandableType === "row" && (!props2.rowExpandable || props2.rowExpandable(props2.record));
    });
    var nestExpandable = computed(function() {
      return bodyContext.expandableType === "nest";
    });
    var hasNestChildren = computed(function() {
      return props2.childrenColumnName && props2.record && props2.record[props2.childrenColumnName];
    });
    var mergedExpandable = computed(function() {
      return rowSupportExpand.value || nestExpandable.value;
    });
    var onInternalTriggerExpand = function onInternalTriggerExpand2(record, event) {
      bodyContext.onTriggerExpand(record, event);
    };
    var additionalProps = computed(function() {
      var _a2;
      return ((_a2 = props2.customRow) === null || _a2 === void 0 ? void 0 : _a2.call(props2, props2.record, props2.index)) || {};
    });
    var onClick2 = function onClick3(event) {
      var _b2;
      var _a2, _b;
      if (bodyContext.expandRowByClick && mergedExpandable.value) {
        onInternalTriggerExpand(props2.record, event);
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (_b = (_a2 = additionalProps.value) === null || _a2 === void 0 ? void 0 : _a2.onClick) === null || _b === void 0 ? void 0 : (_b2 = _b).call.apply(_b2, [_a2, event].concat(args));
    };
    var computeRowClassName = computed(function() {
      var record = props2.record, index2 = props2.index, indent = props2.indent;
      var rowClassName = bodyContext.rowClassName;
      if (typeof rowClassName === "string") {
        return rowClassName;
      } else if (typeof rowClassName === "function") {
        return rowClassName(record, index2, indent);
      }
      return "";
    });
    var columnsKey = computed(function() {
      return getColumnsKey(bodyContext.flattenColumns);
    });
    return function() {
      var className = attrs.class, style2 = attrs.style;
      var record = props2.record, index2 = props2.index, rowKey2 = props2.rowKey, _props$indent = props2.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props2.rowComponent, cellComponent = props2.cellComponent;
      var prefixCls2 = tableContext.prefixCls, fixedInfoList = tableContext.fixedInfoList, transformCellText = tableContext.transformCellText;
      var flattenColumns = bodyContext.flattenColumns, expandedRowClassName = bodyContext.expandedRowClassName, indentSize = bodyContext.indentSize, expandIcon = bodyContext.expandIcon, expandedRowRender = bodyContext.expandedRowRender, expandIconColumnIndex = bodyContext.expandIconColumnIndex;
      var baseRowNode = createVNode(RowComponent, _objectSpread2$2(_objectSpread2$2({}, additionalProps.value), {}, {
        "data-row-key": rowKey2,
        "class": classNames(className, "".concat(prefixCls2, "-row"), "".concat(prefixCls2, "-row-level-").concat(indent), computeRowClassName.value, additionalProps.value.class),
        "style": _extends$2(_extends$2({}, style2), parseStyleText(additionalProps.value.style)),
        "onClick": onClick2
      }), {
        default: function _default7() {
          return [flattenColumns.map(function(column, colIndex) {
            var customRender = column.customRender, dataIndex = column.dataIndex, columnClassName = column.className;
            var key2 = columnsKey[colIndex];
            var fixedInfo = fixedInfoList[colIndex];
            var additionalCellProps;
            if (column.customCell) {
              additionalCellProps = column.customCell(record, index2, column);
            }
            var appendNode = colIndex === (expandIconColumnIndex || 0) && nestExpandable.value ? createVNode(Fragment, null, [createVNode("span", {
              "style": {
                paddingLeft: "".concat(indentSize * indent, "px")
              },
              "class": "".concat(prefixCls2, "-row-indent indent-level-").concat(indent)
            }, null), expandIcon({
              prefixCls: prefixCls2,
              expanded: expanded.value,
              expandable: hasNestChildren.value,
              record,
              onExpand: onInternalTriggerExpand
            })]) : null;
            return createVNode(Cell2, _objectSpread2$2(_objectSpread2$2({
              "cellType": "body",
              "class": columnClassName,
              "ellipsis": column.ellipsis,
              "align": column.align,
              "component": cellComponent,
              "prefixCls": prefixCls2,
              "key": key2,
              "record": record,
              "index": index2,
              "renderIndex": props2.renderIndex,
              "dataIndex": dataIndex,
              "customRender": customRender
            }, fixedInfo), {}, {
              "additionalProps": additionalCellProps,
              "column": column,
              "transformCellText": transformCellText,
              "appendNode": appendNode
            }), null);
          })];
        }
      });
      var expandRowNode;
      if (rowSupportExpand.value && (expandRended.value || expanded.value)) {
        var expandContent = expandedRowRender({
          record,
          index: index2,
          indent: indent + 1,
          expanded: expanded.value
        });
        var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index2, indent);
        expandRowNode = createVNode(ExpandedRow, {
          "expanded": expanded.value,
          "class": classNames("".concat(prefixCls2, "-expanded-row"), "".concat(prefixCls2, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
          "prefixCls": prefixCls2,
          "component": RowComponent,
          "cellComponent": cellComponent,
          "colSpan": flattenColumns.length,
          "isEmpty": false
        }, {
          default: function _default7() {
            return [expandContent];
          }
        });
      }
      return createVNode(Fragment, null, [baseRowNode, expandRowNode]);
    };
  }
});
function flatRecord(record, indent, childrenColumnName, expandedKeys, getRowKey, index2) {
  var arr = [];
  arr.push({
    record,
    indent,
    index: index2
  });
  var key2 = getRowKey(record);
  var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key2);
  if (record && Array.isArray(record[childrenColumnName]) && expanded) {
    for (var i2 = 0; i2 < record[childrenColumnName].length; i2 += 1) {
      var tempArr = flatRecord(record[childrenColumnName][i2], indent + 1, childrenColumnName, expandedKeys, getRowKey, i2);
      arr.push.apply(arr, _toConsumableArray(tempArr));
    }
  }
  return arr;
}
function useFlattenRecords(dataRef, childrenColumnNameRef, expandedKeysRef, getRowKey) {
  var arr = computed(function() {
    var childrenColumnName = childrenColumnNameRef.value;
    var expandedKeys = expandedKeysRef.value;
    var data6 = dataRef.value;
    if (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.size) {
      var temp = [];
      for (var i2 = 0; i2 < (data6 === null || data6 === void 0 ? void 0 : data6.length); i2 += 1) {
        var record = data6[i2];
        temp.push.apply(temp, _toConsumableArray(flatRecord(record, 0, childrenColumnName, expandedKeys, getRowKey.value, i2)));
      }
      return temp;
    }
    return data6 === null || data6 === void 0 ? void 0 : data6.map(function(item, index2) {
      return {
        record: item,
        indent: 0,
        index: index2
      };
    });
  });
  return arr;
}
var ResizeContextKey = Symbol("ResizeContextProps");
var useProvideResize = function useProvideResize2(props2) {
  provide(ResizeContextKey, props2);
};
var useInjectResize = function useInjectResize2() {
  return inject(ResizeContextKey, {
    onColumnResize: function onColumnResize() {
    }
  });
};
var Body = defineComponent({
  name: "Body",
  props: ["data", "getRowKey", "measureColumnWidth", "expandedKeys", "customRow", "rowExpandable", "childrenColumnName"],
  slots: ["emptyNode"],
  setup: function setup136(props2, _ref) {
    var slots = _ref.slots;
    var resizeContext = useInjectResize();
    var tableContext = useInjectTable();
    var bodyContext = useInjectBody();
    var flattenData2 = useFlattenRecords(toRef(props2, "data"), toRef(props2, "childrenColumnName"), toRef(props2, "expandedKeys"), toRef(props2, "getRowKey"));
    var startRow = ref(-1);
    var endRow = ref(-1);
    var timeoutId;
    useProvideHover({
      startRow,
      endRow,
      onHover: function onHover(start2, end) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
          startRow.value = start2;
          endRow.value = end;
        }, 100);
      }
    });
    return function() {
      var _a2;
      var data6 = props2.data, getRowKey = props2.getRowKey, measureColumnWidth = props2.measureColumnWidth, expandedKeys = props2.expandedKeys, customRow = props2.customRow, rowExpandable = props2.rowExpandable, childrenColumnName = props2.childrenColumnName;
      var onColumnResize = resizeContext.onColumnResize;
      var prefixCls2 = tableContext.prefixCls, getComponent3 = tableContext.getComponent;
      var flattenColumns = bodyContext.flattenColumns;
      var WrapperComponent = getComponent3(["body", "wrapper"], "tbody");
      var trComponent = getComponent3(["body", "row"], "tr");
      var tdComponent = getComponent3(["body", "cell"], "td");
      var rows;
      if (data6.length) {
        rows = flattenData2.value.map(function(item, idx) {
          var record = item.record, indent = item.indent, renderIndex = item.index;
          var key2 = getRowKey(record, idx);
          return createVNode(BodyRow, {
            "key": key2,
            "rowKey": key2,
            "record": record,
            "recordKey": key2,
            "index": idx,
            "renderIndex": renderIndex,
            "rowComponent": trComponent,
            "cellComponent": tdComponent,
            "expandedKeys": expandedKeys,
            "customRow": customRow,
            "getRowKey": getRowKey,
            "rowExpandable": rowExpandable,
            "childrenColumnName": childrenColumnName,
            "indent": indent
          }, null);
        });
      } else {
        rows = createVNode(ExpandedRow, {
          "expanded": true,
          "class": "".concat(prefixCls2, "-placeholder"),
          "prefixCls": prefixCls2,
          "component": trComponent,
          "cellComponent": tdComponent,
          "colSpan": flattenColumns.length,
          "isEmpty": true
        }, {
          default: function _default7() {
            return [(_a2 = slots.emptyNode) === null || _a2 === void 0 ? void 0 : _a2.call(slots)];
          }
        });
      }
      var columnsKey = getColumnsKey(flattenColumns);
      return createVNode(WrapperComponent, {
        "class": "".concat(prefixCls2, "-tbody")
      }, {
        default: function _default7() {
          return [measureColumnWidth && createVNode("tr", {
            "aria-hidden": "true",
            "class": "".concat(prefixCls2, "-measure-row"),
            "style": {
              height: 0,
              fontSize: 0
            }
          }, [columnsKey.map(function(columnKey) {
            return createVNode(MeasureCell, {
              "key": columnKey,
              "columnKey": columnKey,
              "onColumnResize": onColumnResize
            }, null);
          })]), rows];
        }
      });
    };
  }
});
var EXPAND_COLUMN = {};
var __rest$9 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function flatColumns(columns2) {
  return columns2.reduce(function(list, column) {
    var fixed = column.fixed;
    var parsedFixed = fixed === true ? "left" : fixed;
    var subColumns = column.children;
    if (subColumns && subColumns.length > 0) {
      return [].concat(_toConsumableArray(list), _toConsumableArray(flatColumns(subColumns).map(function(subColum) {
        return _extends$2({
          fixed: parsedFixed
        }, subColum);
      })));
    }
    return [].concat(_toConsumableArray(list), [_extends$2(_extends$2({}, column), {
      fixed: parsedFixed
    })]);
  }, []);
}
function revertForRtl(columns2) {
  return columns2.map(function(column) {
    var fixed = column.fixed, restProps = __rest$9(column, ["fixed"]);
    var parsedFixed = fixed;
    if (fixed === "left") {
      parsedFixed = "right";
    } else if (fixed === "right") {
      parsedFixed = "left";
    }
    return _extends$2({
      fixed: parsedFixed
    }, restProps);
  });
}
function useColumns$4(_ref, transformColumns) {
  var prefixCls2 = _ref.prefixCls, baseColumns = _ref.columns, expandable = _ref.expandable, expandedKeys = _ref.expandedKeys, getRowKey = _ref.getRowKey, onTriggerExpand = _ref.onTriggerExpand, expandIcon = _ref.expandIcon, rowExpandable = _ref.rowExpandable, expandIconColumnIndex = _ref.expandIconColumnIndex, direction2 = _ref.direction, expandRowByClick = _ref.expandRowByClick, expandColumnWidth = _ref.expandColumnWidth, expandFixed = _ref.expandFixed;
  var withExpandColumns = computed(function() {
    if (expandable.value) {
      var _expandColumn;
      var cloneColumns = baseColumns.value.slice();
      if (!cloneColumns.includes(EXPAND_COLUMN)) {
        var expandColIndex = expandIconColumnIndex.value || 0;
        if (expandColIndex >= 0) {
          cloneColumns.splice(expandColIndex, 0, EXPAND_COLUMN);
        }
      }
      var expandColumnIndex = cloneColumns.indexOf(EXPAND_COLUMN);
      cloneColumns = cloneColumns.filter(function(column, index2) {
        return column !== EXPAND_COLUMN || index2 === expandColumnIndex;
      });
      var prevColumn = baseColumns.value[expandColumnIndex];
      var fixedColumn;
      if ((expandFixed.value === "left" || expandFixed.value) && !expandIconColumnIndex.value) {
        fixedColumn = "left";
      } else if ((expandFixed.value === "right" || expandFixed.value) && expandIconColumnIndex.value === baseColumns.value.length) {
        fixedColumn = "right";
      } else {
        fixedColumn = prevColumn ? prevColumn.fixed : null;
      }
      var expandedKeysValue = expandedKeys.value;
      var rowExpandableValue = rowExpandable.value;
      var expandIconValue = expandIcon.value;
      var prefixClsValue = prefixCls2.value;
      var expandRowByClickValue = expandRowByClick.value;
      var expandColumn = (_expandColumn = {}, _defineProperty$R(_expandColumn, INTERNAL_COL_DEFINE, {
        class: "".concat(prefixCls2.value, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), _defineProperty$R(_expandColumn, "title", ""), _defineProperty$R(_expandColumn, "fixed", fixedColumn), _defineProperty$R(_expandColumn, "class", "".concat(prefixCls2.value, "-row-expand-icon-cell")), _defineProperty$R(_expandColumn, "width", expandColumnWidth.value), _defineProperty$R(_expandColumn, "customRender", function customRender(_ref2) {
        var record = _ref2.record, index2 = _ref2.index;
        var rowKey2 = getRowKey.value(record, index2);
        var expanded = expandedKeysValue.has(rowKey2);
        var recordExpandable = rowExpandableValue ? rowExpandableValue(record) : true;
        var icon = expandIconValue({
          prefixCls: prefixClsValue,
          expanded,
          expandable: recordExpandable,
          record,
          onExpand: onTriggerExpand
        });
        if (expandRowByClickValue) {
          return createVNode("span", {
            "onClick": function onClick2(e2) {
              return e2.stopPropagation();
            }
          }, [icon]);
        }
        return icon;
      }), _expandColumn);
      return cloneColumns.map(function(col) {
        return col === EXPAND_COLUMN ? expandColumn : col;
      });
    }
    return baseColumns.value.filter(function(col) {
      return col !== EXPAND_COLUMN;
    });
  });
  var mergedColumns = computed(function() {
    var finalColumns = withExpandColumns.value;
    if (transformColumns.value) {
      finalColumns = transformColumns.value(finalColumns);
    }
    if (!finalColumns.length) {
      finalColumns = [{
        customRender: function customRender() {
          return null;
        }
      }];
    }
    return finalColumns;
  });
  var flattenColumns = computed(function() {
    if (direction2.value === "rtl") {
      return revertForRtl(flatColumns(mergedColumns.value));
    }
    return flatColumns(mergedColumns.value);
  });
  return [mergedColumns, flattenColumns];
}
function useLayoutState(defaultState) {
  var stateRef = shallowRef(defaultState);
  var rafId;
  var updateBatchRef = shallowRef([]);
  function setFrameState(updater) {
    updateBatchRef.value.push(updater);
    wrapperRaf.cancel(rafId);
    rafId = wrapperRaf(function() {
      var prevBatch = updateBatchRef.value;
      updateBatchRef.value = [];
      prevBatch.forEach(function(batchUpdater) {
        stateRef.value = batchUpdater(stateRef.value);
      });
    });
  }
  onBeforeUnmount(function() {
    wrapperRaf.cancel(rafId);
  });
  return [stateRef, setFrameState];
}
function useTimeoutLock(defaultState) {
  var frameRef = ref(defaultState || null);
  var timeoutRef = ref();
  function cleanUp() {
    clearTimeout(timeoutRef.value);
  }
  function setState2(newState) {
    frameRef.value = newState;
    cleanUp();
    timeoutRef.value = setTimeout(function() {
      frameRef.value = null;
      timeoutRef.value = void 0;
    }, 100);
  }
  function getState() {
    return frameRef.value;
  }
  onBeforeUnmount(function() {
    cleanUp();
  });
  return [setState2, getState];
}
function useStickyOffsets(colWidthsRef, columnCountRef, directionRef) {
  var stickyOffsets = computed(function() {
    var leftOffsets = [];
    var rightOffsets = [];
    var left = 0;
    var right = 0;
    var colWidths = colWidthsRef.value;
    var columnCount = columnCountRef.value;
    var direction2 = directionRef.value;
    for (var start2 = 0; start2 < columnCount; start2 += 1) {
      if (direction2 === "rtl") {
        rightOffsets[start2] = right;
        right += colWidths[start2] || 0;
        var end = columnCount - start2 - 1;
        leftOffsets[end] = left;
        left += colWidths[end] || 0;
      } else {
        leftOffsets[start2] = left;
        left += colWidths[start2] || 0;
        var _end = columnCount - start2 - 1;
        rightOffsets[_end] = right;
        right += colWidths[_end] || 0;
      }
    }
    return {
      left: leftOffsets,
      right: rightOffsets
    };
  });
  return stickyOffsets;
}
var __rest$8 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function ColGroup(_ref) {
  var colWidths = _ref.colWidths, columns2 = _ref.columns, columCount = _ref.columCount;
  var cols = [];
  var len = columCount || columns2.length;
  var mustInsert = false;
  for (var i2 = len - 1; i2 >= 0; i2 -= 1) {
    var width = colWidths[i2];
    var column = columns2 && columns2[i2];
    var additionalProps = column && column[INTERNAL_COL_DEFINE];
    if (width || additionalProps || mustInsert) {
      var _a2 = additionalProps || {};
      _a2.columnType;
      var restAdditionalProps = __rest$8(_a2, ["columnType"]);
      cols.unshift(createVNode("col", _objectSpread2$2({
        "key": i2,
        "style": {
          width: typeof width === "number" ? "".concat(width, "px") : width
        }
      }, restAdditionalProps), null));
      mustInsert = true;
    }
  }
  return createVNode("colgroup", null, [cols]);
}
function Panel(_2, _ref) {
  var slots = _ref.slots;
  var _a2;
  return createVNode("div", null, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
}
Panel.displayName = "Panel";
var indexGuid = 0;
var Summary = defineComponent({
  name: "Summary",
  props: ["fixed"],
  setup: function setup137(props2, _ref) {
    var slots = _ref.slots;
    var tableContext = useInjectTable();
    var uniKey = "table-summary-uni-key-".concat(++indexGuid);
    var fixed = computed(function() {
      return props2.fixed === "" || props2.fixed;
    });
    watchEffect(function() {
      tableContext.summaryCollect(uniKey, fixed.value);
    });
    onBeforeUnmount(function() {
      tableContext.summaryCollect(uniKey, false);
    });
    return function() {
      var _a2;
      return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
    };
  }
});
var Summary$1 = Summary;
var SummaryRow = defineComponent({
  name: "FooterRow",
  setup: function setup138(_props, _ref) {
    var slots = _ref.slots;
    return function() {
      var _a2;
      return createVNode("tr", null, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var SummaryContextKey = Symbol("SummaryContextProps");
var useProvideSummary = function useProvideSummary2(props2) {
  provide(SummaryContextKey, props2);
};
var useInjectSummary = function useInjectSummary2() {
  return inject(SummaryContextKey, {});
};
var SummaryCell = defineComponent({
  name: "SummaryCell",
  props: ["index", "colSpan", "rowSpan", "align"],
  setup: function setup139(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var tableContext = useInjectTable();
    var summaryContext = useInjectSummary();
    return function() {
      var index2 = props2.index, _props$colSpan = props2.colSpan, colSpan = _props$colSpan === void 0 ? 1 : _props$colSpan, rowSpan = props2.rowSpan, align = props2.align;
      var prefixCls2 = tableContext.prefixCls, direction2 = tableContext.direction;
      var scrollColumnIndex = summaryContext.scrollColumnIndex, stickyOffsets = summaryContext.stickyOffsets, flattenColumns = summaryContext.flattenColumns;
      var lastIndex = index2 + colSpan - 1;
      var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
      var fixedInfo = getCellFixedInfo(index2, index2 + mergedColSpan - 1, flattenColumns, stickyOffsets, direction2);
      return createVNode(Cell2, _objectSpread2$2({
        "class": attrs.class,
        "index": index2,
        "component": "td",
        "prefixCls": prefixCls2,
        "record": null,
        "dataIndex": null,
        "align": align,
        "colSpan": mergedColSpan,
        "rowSpan": rowSpan,
        "customRender": function customRender() {
          var _a2;
          return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
        }
      }, fixedInfo), null);
    };
  }
});
var Footer$2 = defineComponent({
  name: "Footer",
  inheritAttrs: false,
  props: ["stickyOffsets", "flattenColumns"],
  setup: function setup140(props2, _ref) {
    var slots = _ref.slots;
    var tableContext = useInjectTable();
    useProvideSummary(reactive({
      stickyOffsets: toRef(props2, "stickyOffsets"),
      flattenColumns: toRef(props2, "flattenColumns"),
      scrollColumnIndex: computed(function() {
        var lastColumnIndex = props2.flattenColumns.length - 1;
        var scrollColumn = props2.flattenColumns[lastColumnIndex];
        return (scrollColumn === null || scrollColumn === void 0 ? void 0 : scrollColumn.scrollbar) ? lastColumnIndex : null;
      })
    }));
    return function() {
      var _a2;
      var prefixCls2 = tableContext.prefixCls;
      return createVNode("tfoot", {
        "class": "".concat(prefixCls2, "-summary")
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
    };
  }
});
var FooterComponents = Summary$1;
function renderExpandIcon$1(_ref) {
  var _ref2;
  var prefixCls2 = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
  var expandClassName = "".concat(prefixCls2, "-row-expand-icon");
  if (!expandable) {
    return createVNode("span", {
      "class": [expandClassName, "".concat(prefixCls2, "-row-spaced")]
    }, null);
  }
  var onClick2 = function onClick3(event) {
    onExpand(record, event);
    event.stopPropagation();
  };
  return createVNode("span", {
    "class": (_ref2 = {}, _defineProperty$R(_ref2, expandClassName, true), _defineProperty$R(_ref2, "".concat(prefixCls2, "-row-expanded"), expanded), _defineProperty$R(_ref2, "".concat(prefixCls2, "-row-collapsed"), !expanded), _ref2),
    "onClick": onClick2
  }, null);
}
function findAllChildrenKeys(data6, getRowKey, childrenColumnName) {
  var keys2 = [];
  function dig(list) {
    (list || []).forEach(function(item, index2) {
      keys2.push(getRowKey(item, index2));
      dig(item[childrenColumnName]);
    });
  }
  dig(data6);
  return keys2;
}
var StickyScrollBar = defineComponent({
  name: "StickyScrollBar",
  inheritAttrs: false,
  props: ["offsetScroll", "container", "scrollBodyRef", "scrollBodySizeInfo"],
  emits: ["scroll"],
  setup: function setup141(props2, _ref) {
    var emit = _ref.emit, expose = _ref.expose;
    var tableContext = useInjectTable();
    var bodyScrollWidth = ref(0);
    var bodyWidth = ref(0);
    var scrollBarWidth2 = ref(0);
    watchEffect(function() {
      bodyScrollWidth.value = props2.scrollBodySizeInfo.scrollWidth || 0;
      bodyWidth.value = props2.scrollBodySizeInfo.clientWidth || 0;
      scrollBarWidth2.value = bodyScrollWidth.value && bodyWidth.value * (bodyWidth.value / bodyScrollWidth.value);
    }, {
      flush: "post"
    });
    var scrollBarRef = ref();
    var _useLayoutState = useLayoutState({
      scrollLeft: 0,
      isHiddenScrollBar: true
    }), _useLayoutState2 = _slicedToArray$2(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
    var refState = ref({
      delta: 0,
      x: 0
    });
    var isActive = ref(false);
    var onMouseUp2 = function onMouseUp3() {
      isActive.value = false;
    };
    var onMouseDown2 = function onMouseDown3(event) {
      refState.value = {
        delta: event.pageX - scrollState.value.scrollLeft,
        x: 0
      };
      isActive.value = true;
      event.preventDefault();
    };
    var onMouseMove3 = function onMouseMove4(event) {
      var _ref2 = event || (window === null || window === void 0 ? void 0 : window.event), buttons = _ref2.buttons;
      if (!isActive.value || buttons === 0) {
        if (isActive.value) {
          isActive.value = false;
        }
        return;
      }
      var left = refState.value.x + event.pageX - refState.value.x - refState.value.delta;
      if (left <= 0) {
        left = 0;
      }
      if (left + scrollBarWidth2.value >= bodyWidth.value) {
        left = bodyWidth.value - scrollBarWidth2.value;
      }
      emit("scroll", {
        scrollLeft: left / bodyWidth.value * (bodyScrollWidth.value + 2)
      });
      refState.value.x = event.pageX;
    };
    var onContainerScroll = function onContainerScroll2() {
      if (!props2.scrollBodyRef.value) {
        return;
      }
      var tableOffsetTop = getOffset$1(props2.scrollBodyRef.value).top;
      var tableBottomOffset = tableOffsetTop + props2.scrollBodyRef.value.offsetHeight;
      var currentClientOffset = props2.container === window ? document.documentElement.scrollTop + window.innerHeight : getOffset$1(props2.container).top + props2.container.clientHeight;
      if (tableBottomOffset - getScrollBarSize() <= currentClientOffset || tableOffsetTop >= currentClientOffset - props2.offsetScroll) {
        setScrollState(function(state) {
          return _extends$2(_extends$2({}, state), {
            isHiddenScrollBar: true
          });
        });
      } else {
        setScrollState(function(state) {
          return _extends$2(_extends$2({}, state), {
            isHiddenScrollBar: false
          });
        });
      }
    };
    var setScrollLeft = function setScrollLeft2(left) {
      setScrollState(function(state) {
        return _extends$2(_extends$2({}, state), {
          scrollLeft: left / bodyScrollWidth.value * bodyWidth.value || 0
        });
      });
    };
    expose({
      setScrollLeft
    });
    var onMouseUpListener = null;
    var onMouseMoveListener = null;
    var onResizeListener = null;
    var onScrollListener = null;
    onMounted(function() {
      onMouseUpListener = addEventListenerWrap(document.body, "mouseup", onMouseUp2, false);
      onMouseMoveListener = addEventListenerWrap(document.body, "mousemove", onMouseMove3, false);
      onResizeListener = addEventListenerWrap(window, "resize", onContainerScroll, false);
    });
    onActivated(function() {
      nextTick(function() {
        onContainerScroll();
      });
    });
    onMounted(function() {
      setTimeout(function() {
        watch([scrollBarWidth2, isActive], function() {
          onContainerScroll();
        }, {
          immediate: true,
          flush: "post"
        });
      });
    });
    watch(function() {
      return props2.container;
    }, function() {
      onScrollListener === null || onScrollListener === void 0 ? void 0 : onScrollListener.remove();
      onScrollListener = addEventListenerWrap(props2.container, "scroll", onContainerScroll, false);
    }, {
      immediate: true,
      flush: "post"
    });
    onBeforeUnmount(function() {
      onMouseUpListener === null || onMouseUpListener === void 0 ? void 0 : onMouseUpListener.remove();
      onMouseMoveListener === null || onMouseMoveListener === void 0 ? void 0 : onMouseMoveListener.remove();
      onScrollListener === null || onScrollListener === void 0 ? void 0 : onScrollListener.remove();
      onResizeListener === null || onResizeListener === void 0 ? void 0 : onResizeListener.remove();
    });
    watch(function() {
      return _extends$2({}, scrollState.value);
    }, function(newState, preState) {
      if (newState.isHiddenScrollBar !== (preState === null || preState === void 0 ? void 0 : preState.isHiddenScrollBar) && !newState.isHiddenScrollBar) {
        setScrollState(function(state) {
          var bodyNode = props2.scrollBodyRef.value;
          if (!bodyNode) {
            return state;
          }
          return _extends$2(_extends$2({}, state), {
            scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
          });
        });
      }
    }, {
      immediate: true
    });
    var scrollbarSize2 = getScrollBarSize();
    return function() {
      if (bodyScrollWidth.value <= bodyWidth.value || !scrollBarWidth2.value || scrollState.value.isHiddenScrollBar) {
        return null;
      }
      var prefixCls2 = tableContext.prefixCls;
      return createVNode("div", {
        "style": {
          height: "".concat(scrollbarSize2, "px"),
          width: "".concat(bodyWidth.value, "px"),
          bottom: "".concat(props2.offsetScroll, "px")
        },
        "class": "".concat(prefixCls2, "-sticky-scroll")
      }, [createVNode("div", {
        "onMousedown": onMouseDown2,
        "ref": scrollBarRef,
        "class": classNames("".concat(prefixCls2, "-sticky-scroll-bar"), _defineProperty$R({}, "".concat(prefixCls2, "-sticky-scroll-bar-active"), isActive)),
        "style": {
          width: "".concat(scrollBarWidth2.value, "px"),
          transform: "translate3d(".concat(scrollState.value.scrollLeft, "px, 0, 0)")
        }
      }, null)]);
    };
  }
});
var defaultContainer = canUseDom() ? window : null;
function useSticky(stickyRef, prefixClsRef) {
  return computed(function() {
    var _ref = _typeof$2(stickyRef.value) === "object" ? stickyRef.value : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer4 = _ref$getContainer === void 0 ? function() {
      return defaultContainer;
    } : _ref$getContainer;
    var container = getContainer4() || defaultContainer;
    var isSticky = !!stickyRef.value;
    return {
      isSticky,
      stickyClassName: isSticky ? "".concat(prefixClsRef.value, "-sticky-holder") : "",
      offsetHeader,
      offsetSummary,
      offsetScroll,
      container
    };
  });
}
function useColumnWidth(colWidthsRef, columCountRef) {
  return computed(function() {
    var cloneColumns = [];
    var colWidths = colWidthsRef.value;
    var columCount = columCountRef.value;
    for (var i2 = 0; i2 < columCount; i2 += 1) {
      var val = colWidths[i2];
      if (val !== void 0) {
        cloneColumns[i2] = val;
      } else {
        return null;
      }
    }
    return cloneColumns;
  });
}
var FixedHolder = defineComponent({
  name: "FixedHolder",
  inheritAttrs: false,
  props: ["columns", "flattenColumns", "stickyOffsets", "customHeaderRow", "noData", "maxContentScroll", "colWidths", "columCount", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName"],
  emits: ["scroll"],
  setup: function setup142(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit;
    var tableContext = useInjectTable();
    var combinationScrollBarSize = computed(function() {
      return tableContext.isSticky && !props2.fixHeader ? 0 : tableContext.scrollbarSize;
    });
    var scrollRef = ref();
    var onWheel = function onWheel2(e2) {
      var currentTarget = e2.currentTarget, deltaX = e2.deltaX;
      if (deltaX) {
        emit("scroll", {
          currentTarget,
          scrollLeft: currentTarget.scrollLeft + deltaX
        });
        e2.preventDefault();
      }
    };
    var wheelEvent = ref();
    onMounted(function() {
      nextTick(function() {
        wheelEvent.value = addEventListenerWrap(scrollRef.value, "wheel", onWheel);
      });
    });
    onBeforeUnmount(function() {
      var _a2;
      (_a2 = wheelEvent.value) === null || _a2 === void 0 ? void 0 : _a2.remove();
    });
    var allFlattenColumnsWithWidth = computed(function() {
      return props2.flattenColumns.every(function(column) {
        return column.width && column.width !== 0 && column.width !== "0px";
      });
    });
    var columnsWithScrollbar = ref([]);
    var flattenColumnsWithScrollbar = ref([]);
    watchEffect(function() {
      var lastColumn = props2.flattenColumns[props2.flattenColumns.length - 1];
      var ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        customHeaderCell: function customHeaderCell() {
          return {
            class: "".concat(tableContext.prefixCls, "-cell-scrollbar")
          };
        }
      };
      columnsWithScrollbar.value = combinationScrollBarSize.value ? [].concat(_toConsumableArray(props2.columns), [ScrollBarColumn]) : props2.columns;
      flattenColumnsWithScrollbar.value = combinationScrollBarSize.value ? [].concat(_toConsumableArray(props2.flattenColumns), [ScrollBarColumn]) : props2.flattenColumns;
    });
    var headerStickyOffsets = computed(function() {
      var stickyOffsets = props2.stickyOffsets, direction2 = props2.direction;
      var right = stickyOffsets.right, left = stickyOffsets.left;
      return _extends$2(_extends$2({}, stickyOffsets), {
        left: direction2 === "rtl" ? [].concat(_toConsumableArray(left.map(function(width) {
          return width + combinationScrollBarSize.value;
        })), [0]) : left,
        right: direction2 === "rtl" ? right : [].concat(_toConsumableArray(right.map(function(width) {
          return width + combinationScrollBarSize.value;
        })), [0]),
        isSticky: tableContext.isSticky
      });
    });
    var mergedColumnWidth = useColumnWidth(toRef(props2, "colWidths"), toRef(props2, "columCount"));
    return function() {
      var _a2;
      var noData = props2.noData, columCount = props2.columCount, stickyTopOffset = props2.stickyTopOffset, stickyBottomOffset = props2.stickyBottomOffset, stickyClassName = props2.stickyClassName, maxContentScroll = props2.maxContentScroll;
      var isSticky = tableContext.isSticky;
      return createVNode("div", {
        "style": _extends$2({
          overflow: "hidden"
        }, isSticky ? {
          top: "".concat(stickyTopOffset, "px"),
          bottom: "".concat(stickyBottomOffset, "px")
        } : {}),
        "ref": scrollRef,
        "class": classNames(attrs.class, _defineProperty$R({}, stickyClassName, !!stickyClassName))
      }, [createVNode("table", {
        "style": {
          tableLayout: "fixed",
          visibility: noData || mergedColumnWidth.value ? null : "hidden"
        }
      }, [(!noData || !maxContentScroll || allFlattenColumnsWithWidth.value) && createVNode(ColGroup, {
        "colWidths": mergedColumnWidth.value ? [].concat(_toConsumableArray(mergedColumnWidth.value), [combinationScrollBarSize.value]) : [],
        "columCount": columCount + 1,
        "columns": flattenColumnsWithScrollbar.value
      }, null), (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots, _extends$2(_extends$2({}, props2), {
        stickyOffsets: headerStickyOffsets.value,
        columns: columnsWithScrollbar.value,
        flattenColumns: flattenColumnsWithScrollbar.value
      }))])]);
    };
  }
});
function reactivePick(obj) {
  for (var _len = arguments.length, keys2 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys2[_key - 1] = arguments[_key];
  }
  return reactive(Object.fromEntries(keys2.map(function(k2) {
    return [k2, toRef(obj, k2)];
  })));
}
var EMPTY_DATA = [];
var EMPTY_SCROLL_TARGET = {};
var INTERNAL_HOOKS = "rc-table-internal-hook";
var Table$3 = defineComponent({
  name: "Table",
  inheritAttrs: false,
  props: ["prefixCls", "data", "columns", "rowKey", "tableLayout", "scroll", "rowClassName", "title", "footer", "id", "showHeader", "components", "customRow", "customHeaderRow", "direction", "expandFixed", "expandColumnWidth", "expandedRowKeys", "defaultExpandedRowKeys", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "defaultExpandAllRows", "indentSize", "expandIconColumnIndex", "expandedRowClassName", "childrenColumnName", "rowExpandable", "sticky", "transformColumns", "internalHooks", "internalRefs", "canExpandable", "onUpdateInternalRefs", "transformCellText"],
  slots: ["title", "footer", "summary", "emptyText"],
  emits: ["expand", "expandedRowsChange", "updateInternalRefs"],
  setup: function setup143(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit;
    var mergedData = computed(function() {
      return props2.data || EMPTY_DATA;
    });
    var hasData = computed(function() {
      return !!mergedData.value.length;
    });
    var mergedComponents = computed(function() {
      return mergeObject(props2.components, {});
    });
    var getComponent3 = function getComponent4(path, defaultComponent) {
      return getPathValue(mergedComponents.value, path) || defaultComponent;
    };
    var getRowKey = computed(function() {
      var rowKey2 = props2.rowKey;
      if (typeof rowKey2 === "function") {
        return rowKey2;
      }
      return function(record) {
        var key2 = record && record[rowKey2];
        return key2;
      };
    });
    var mergedExpandIcon = computed(function() {
      return props2.expandIcon || renderExpandIcon$1;
    });
    var mergedChildrenColumnName = computed(function() {
      return props2.childrenColumnName || "children";
    });
    var expandableType = computed(function() {
      if (props2.expandedRowRender) {
        return "row";
      }
      if (props2.canExpandable || mergedData.value.some(function(record) {
        return record && _typeof$2(record) === "object" && record[mergedChildrenColumnName.value];
      })) {
        return "nest";
      }
      return false;
    });
    var innerExpandedKeys = shallowRef([]);
    var stop2 = watchEffect(function() {
      if (props2.defaultExpandedRowKeys) {
        innerExpandedKeys.value = props2.defaultExpandedRowKeys;
      }
      if (props2.defaultExpandAllRows) {
        innerExpandedKeys.value = findAllChildrenKeys(mergedData.value, getRowKey.value, mergedChildrenColumnName.value);
      }
    });
    stop2();
    var mergedExpandedKeys = computed(function() {
      return new Set(props2.expandedRowKeys || innerExpandedKeys.value || []);
    });
    var onTriggerExpand = function onTriggerExpand2(record) {
      var key2 = getRowKey.value(record, mergedData.value.indexOf(record));
      var newExpandedKeys;
      var hasKey = mergedExpandedKeys.value.has(key2);
      if (hasKey) {
        mergedExpandedKeys.value.delete(key2);
        newExpandedKeys = _toConsumableArray(mergedExpandedKeys.value);
      } else {
        newExpandedKeys = [].concat(_toConsumableArray(mergedExpandedKeys.value), [key2]);
      }
      innerExpandedKeys.value = newExpandedKeys;
      emit("expand", !hasKey, record);
      emit("expandedRowsChange", newExpandedKeys);
    };
    var componentWidth = ref(0);
    var _useColumns = useColumns$4(_extends$2(_extends$2({}, toRefs(props2)), {
      expandable: computed(function() {
        return !!props2.expandedRowRender;
      }),
      expandedKeys: mergedExpandedKeys,
      getRowKey,
      onTriggerExpand,
      expandIcon: mergedExpandIcon
    }), computed(function() {
      return props2.internalHooks === INTERNAL_HOOKS ? props2.transformColumns : null;
    })), _useColumns2 = _slicedToArray$2(_useColumns, 2), columns2 = _useColumns2[0], flattenColumns = _useColumns2[1];
    var columnContext = computed(function() {
      return {
        columns: columns2.value,
        flattenColumns: flattenColumns.value
      };
    });
    var fullTableRef = ref();
    var scrollHeaderRef = ref();
    var scrollBodyRef = ref();
    var scrollBodySizeInfo = ref({
      scrollWidth: 0,
      clientWidth: 0
    });
    var scrollSummaryRef = ref();
    var _useState = useState(false), _useState2 = _slicedToArray$2(_useState, 2), pingedLeft = _useState2[0], setPingedLeft = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray$2(_useState3, 2), pingedRight = _useState4[0], setPingedRight = _useState4[1];
    var _useLayoutState = useLayoutState(new Map()), _useLayoutState2 = _slicedToArray$2(_useLayoutState, 2), colsWidths = _useLayoutState2[0], updateColsWidths = _useLayoutState2[1];
    var colsKeys = computed(function() {
      return getColumnsKey(flattenColumns.value);
    });
    var colWidths = computed(function() {
      return colsKeys.value.map(function(columnKey) {
        return colsWidths.value.get(columnKey);
      });
    });
    var columnCount = computed(function() {
      return flattenColumns.value.length;
    });
    var stickyOffsets = useStickyOffsets(colWidths, columnCount, toRef(props2, "direction"));
    var fixHeader = computed(function() {
      return props2.scroll && validateValue(props2.scroll.y);
    });
    var horizonScroll = computed(function() {
      return props2.scroll && validateValue(props2.scroll.x) || Boolean(props2.expandFixed);
    });
    var fixColumn = computed(function() {
      return horizonScroll.value && flattenColumns.value.some(function(_ref2) {
        var fixed = _ref2.fixed;
        return fixed;
      });
    });
    var stickyRef = ref();
    var stickyState = useSticky(toRef(props2, "sticky"), toRef(props2, "prefixCls"));
    var summaryFixedInfos = reactive({});
    var fixFooter = computed(function() {
      var info = Object.values(summaryFixedInfos)[0];
      return (fixHeader.value || stickyState.value.isSticky) && info;
    });
    var summaryCollect = function summaryCollect2(uniKey, fixed) {
      if (fixed) {
        summaryFixedInfos[uniKey] = fixed;
      } else {
        delete summaryFixedInfos[uniKey];
      }
    };
    var scrollXStyle = ref({});
    var scrollYStyle = ref({});
    var scrollTableStyle = ref({});
    watchEffect(function() {
      if (fixHeader.value) {
        scrollYStyle.value = {
          overflowY: "scroll",
          maxHeight: toPx(props2.scroll.y)
        };
      }
      if (horizonScroll.value) {
        scrollXStyle.value = {
          overflowX: "auto"
        };
        if (!fixHeader.value) {
          scrollYStyle.value = {
            overflowY: "hidden"
          };
        }
        scrollTableStyle.value = {
          width: props2.scroll.x === true ? "auto" : toPx(props2.scroll.x),
          minWidth: "100%"
        };
      }
    });
    var onColumnResize = function onColumnResize2(columnKey, width) {
      if (isVisible(fullTableRef.value)) {
        updateColsWidths(function(widths) {
          if (widths.get(columnKey) !== width) {
            var newWidths = new Map(widths);
            newWidths.set(columnKey, width);
            return newWidths;
          }
          return widths;
        });
      }
    };
    var _useTimeoutLock = useTimeoutLock(null), _useTimeoutLock2 = _slicedToArray$2(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
    function forceScroll(scrollLeft, target) {
      if (!target) {
        return;
      }
      if (typeof target === "function") {
        target(scrollLeft);
        return;
      }
      var domTarget = target.$el || target;
      if (domTarget.scrollLeft !== scrollLeft) {
        domTarget.scrollLeft = scrollLeft;
      }
    }
    var onScroll = function onScroll2(_ref3) {
      var currentTarget = _ref3.currentTarget, scrollLeft = _ref3.scrollLeft;
      var _a2;
      var isRTL2 = props2.direction === "rtl";
      var mergedScrollLeft = typeof scrollLeft === "number" ? scrollLeft : currentTarget.scrollLeft;
      var compareTarget = currentTarget || EMPTY_SCROLL_TARGET;
      if (!getScrollTarget() || getScrollTarget() === compareTarget) {
        setScrollTarget(compareTarget);
        forceScroll(mergedScrollLeft, scrollHeaderRef.value);
        forceScroll(mergedScrollLeft, scrollBodyRef.value);
        forceScroll(mergedScrollLeft, scrollSummaryRef.value);
        forceScroll(mergedScrollLeft, (_a2 = stickyRef.value) === null || _a2 === void 0 ? void 0 : _a2.setScrollLeft);
      }
      if (currentTarget) {
        var scrollWidth = currentTarget.scrollWidth, clientWidth = currentTarget.clientWidth;
        if (isRTL2) {
          setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
          setPingedRight(-mergedScrollLeft > 0);
        } else {
          setPingedLeft(mergedScrollLeft > 0);
          setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
        }
      }
    };
    var triggerOnScroll = function triggerOnScroll2() {
      if (horizonScroll.value && scrollBodyRef.value) {
        onScroll({
          currentTarget: scrollBodyRef.value
        });
      } else {
        setPingedLeft(false);
        setPingedRight(false);
      }
    };
    var timtout;
    var updateWidth = function updateWidth2(width) {
      if (width !== componentWidth.value) {
        triggerOnScroll();
        componentWidth.value = fullTableRef.value ? fullTableRef.value.offsetWidth : width;
      }
    };
    var onFullTableResize = function onFullTableResize2(_ref4) {
      var width = _ref4.width;
      clearTimeout(timtout);
      if (componentWidth.value === 0) {
        updateWidth(width);
        return;
      }
      timtout = setTimeout(function() {
        updateWidth(width);
      }, 100);
    };
    watch([horizonScroll, function() {
      return props2.data;
    }, function() {
      return props2.columns;
    }], function() {
      if (horizonScroll.value) {
        triggerOnScroll();
      }
    });
    var _useState5 = useState(0), _useState6 = _slicedToArray$2(_useState5, 2), scrollbarSize2 = _useState6[0], setScrollbarSize = _useState6[1];
    useProvideSticky();
    onMounted(function() {
      nextTick(function() {
        var _a2, _b;
        triggerOnScroll();
        setScrollbarSize(getTargetScrollBarSize(scrollBodyRef.value).width);
        scrollBodySizeInfo.value = {
          scrollWidth: ((_a2 = scrollBodyRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollWidth) || 0,
          clientWidth: ((_b = scrollBodyRef.value) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0
        };
      });
    });
    onUpdated(function() {
      nextTick(function() {
        var _a2, _b;
        var scrollWidth = ((_a2 = scrollBodyRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollWidth) || 0;
        var clientWidth = ((_b = scrollBodyRef.value) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0;
        if (scrollBodySizeInfo.value.scrollWidth !== scrollWidth || scrollBodySizeInfo.value.clientWidth !== clientWidth) {
          scrollBodySizeInfo.value = {
            scrollWidth,
            clientWidth
          };
        }
      });
    });
    watchEffect(function() {
      if (props2.internalHooks === INTERNAL_HOOKS && props2.internalRefs) {
        props2.onUpdateInternalRefs({
          body: scrollBodyRef.value ? scrollBodyRef.value.$el || scrollBodyRef.value : null
        });
      }
    }, {
      flush: "post"
    });
    var mergedTableLayout = computed(function() {
      if (props2.tableLayout) {
        return props2.tableLayout;
      }
      if (fixColumn.value) {
        return props2.scroll.x === "max-content" ? "auto" : "fixed";
      }
      if (fixHeader.value || stickyState.value.isSticky || flattenColumns.value.some(function(_ref5) {
        var ellipsis = _ref5.ellipsis;
        return ellipsis;
      })) {
        return "fixed";
      }
      return "auto";
    });
    var emptyNode = function emptyNode2() {
      var _a2;
      return hasData.value ? null : ((_a2 = slots.emptyText) === null || _a2 === void 0 ? void 0 : _a2.call(slots)) || "No Data";
    };
    useProvideTable(reactive(_extends$2(_extends$2({}, toRefs(reactivePick(props2, "prefixCls", "direction", "transformCellText"))), {
      getComponent: getComponent3,
      scrollbarSize: scrollbarSize2,
      fixedInfoList: computed(function() {
        return flattenColumns.value.map(function(_2, colIndex) {
          return getCellFixedInfo(colIndex, colIndex, flattenColumns.value, stickyOffsets.value, props2.direction);
        });
      }),
      isSticky: computed(function() {
        return stickyState.value.isSticky;
      }),
      summaryCollect
    })));
    useProvideBody(reactive(_extends$2(_extends$2({}, toRefs(reactivePick(props2, "rowClassName", "expandedRowClassName", "expandRowByClick", "expandedRowRender", "expandIconColumnIndex", "indentSize"))), {
      columns: columns2,
      flattenColumns,
      tableLayout: mergedTableLayout,
      expandIcon: mergedExpandIcon,
      expandableType,
      onTriggerExpand
    })));
    useProvideResize({
      onColumnResize
    });
    useProvideExpandedRow({
      componentWidth,
      fixHeader,
      fixColumn,
      horizonScroll
    });
    var bodyTable = function bodyTable2() {
      return createVNode(Body, {
        "data": mergedData.value,
        "measureColumnWidth": fixHeader.value || horizonScroll.value || stickyState.value.isSticky,
        "expandedKeys": mergedExpandedKeys.value,
        "rowExpandable": props2.rowExpandable,
        "getRowKey": getRowKey.value,
        "customRow": props2.customRow,
        "childrenColumnName": mergedChildrenColumnName.value
      }, {
        emptyNode
      });
    };
    var bodyColGroup = function bodyColGroup2() {
      return createVNode(ColGroup, {
        "colWidths": flattenColumns.value.map(function(_ref6) {
          var width = _ref6.width;
          return width;
        }),
        "columns": flattenColumns.value
      }, null);
    };
    return function() {
      var _a2;
      var prefixCls2 = props2.prefixCls, scroll = props2.scroll, tableLayout = props2.tableLayout, direction2 = props2.direction, _props$title = props2.title, title = _props$title === void 0 ? slots.title : _props$title, _props$footer = props2.footer, footer = _props$footer === void 0 ? slots.footer : _props$footer, id = props2.id, showHeader = props2.showHeader, customHeaderRow = props2.customHeaderRow;
      var _stickyState$value = stickyState.value, isSticky = _stickyState$value.isSticky, offsetHeader = _stickyState$value.offsetHeader, offsetSummary = _stickyState$value.offsetSummary, offsetScroll = _stickyState$value.offsetScroll, stickyClassName = _stickyState$value.stickyClassName, container = _stickyState$value.container;
      var TableComponent = getComponent3(["table"], "table");
      var customizeScrollBody = getComponent3(["body"]);
      var summaryNode = (_a2 = slots.summary) === null || _a2 === void 0 ? void 0 : _a2.call(slots, {
        pageData: mergedData.value
      });
      var groupTableNode = function groupTableNode2() {
        return null;
      };
      var headerProps = {
        colWidths: colWidths.value,
        columCount: flattenColumns.value.length,
        stickyOffsets: stickyOffsets.value,
        customHeaderRow,
        fixHeader: fixHeader.value,
        scroll
      };
      if (fixHeader.value || isSticky) {
        var bodyContent = function bodyContent2() {
          return null;
        };
        if (typeof customizeScrollBody === "function") {
          bodyContent = function bodyContent2() {
            return customizeScrollBody(mergedData.value, {
              scrollbarSize: scrollbarSize2.value,
              ref: scrollBodyRef,
              onScroll
            });
          };
          headerProps.colWidths = flattenColumns.value.map(function(_ref7, index2) {
            var width = _ref7.width;
            var colWidth = index2 === columns2.value.length - 1 ? width - scrollbarSize2.value : width;
            if (typeof colWidth === "number" && !Number.isNaN(colWidth)) {
              return colWidth;
            }
            return 0;
          });
        } else {
          bodyContent = function bodyContent2() {
            return createVNode("div", {
              "style": _extends$2(_extends$2({}, scrollXStyle.value), scrollYStyle.value),
              "onScroll": onScroll,
              "ref": scrollBodyRef,
              "class": classNames("".concat(prefixCls2, "-body"))
            }, [createVNode(TableComponent, {
              "style": _extends$2(_extends$2({}, scrollTableStyle.value), {
                tableLayout: mergedTableLayout.value
              })
            }, {
              default: function _default7() {
                return [bodyColGroup(), bodyTable(), !fixFooter.value && summaryNode && createVNode(Footer$2, {
                  "stickyOffsets": stickyOffsets.value,
                  "flattenColumns": flattenColumns.value
                }, {
                  default: function _default8() {
                    return [summaryNode];
                  }
                })];
              }
            })]);
          };
        }
        var fixedHolderProps = _extends$2(_extends$2(_extends$2({
          noData: !mergedData.value.length,
          maxContentScroll: horizonScroll.value && scroll.x === "max-content"
        }, headerProps), columnContext.value), {
          direction: direction2,
          stickyClassName,
          onScroll
        });
        groupTableNode = function groupTableNode2() {
          return createVNode(Fragment, null, [showHeader !== false && createVNode(FixedHolder, _objectSpread2$2(_objectSpread2$2({}, fixedHolderProps), {}, {
            "stickyTopOffset": offsetHeader,
            "class": "".concat(prefixCls2, "-header"),
            "ref": scrollHeaderRef
          }), {
            default: function _default7(fixedHolderPassProps) {
              return createVNode(Fragment, null, [createVNode(Header, fixedHolderPassProps, null), fixFooter.value === "top" && createVNode(Footer$2, fixedHolderPassProps, {
                default: function _default8() {
                  return [summaryNode];
                }
              })]);
            }
          }), bodyContent(), fixFooter.value && fixFooter.value !== "top" && createVNode(FixedHolder, _objectSpread2$2(_objectSpread2$2({}, fixedHolderProps), {}, {
            "stickyBottomOffset": offsetSummary,
            "class": "".concat(prefixCls2, "-summary"),
            "ref": scrollSummaryRef
          }), {
            default: function _default7(fixedHolderPassProps) {
              return createVNode(Footer$2, fixedHolderPassProps, {
                default: function _default8() {
                  return [summaryNode];
                }
              });
            }
          }), isSticky && scrollBodyRef.value && createVNode(StickyScrollBar, {
            "ref": stickyRef,
            "offsetScroll": offsetScroll,
            "scrollBodyRef": scrollBodyRef,
            "onScroll": onScroll,
            "container": container,
            "scrollBodySizeInfo": scrollBodySizeInfo.value
          }, null)]);
        };
      } else {
        groupTableNode = function groupTableNode2() {
          return createVNode("div", {
            "style": _extends$2(_extends$2({}, scrollXStyle.value), scrollYStyle.value),
            "class": classNames("".concat(prefixCls2, "-content")),
            "onScroll": onScroll,
            "ref": scrollBodyRef
          }, [createVNode(TableComponent, {
            "style": _extends$2(_extends$2({}, scrollTableStyle.value), {
              tableLayout: mergedTableLayout.value
            })
          }, {
            default: function _default7() {
              return [bodyColGroup(), showHeader !== false && createVNode(Header, _objectSpread2$2(_objectSpread2$2({}, headerProps), columnContext.value), null), bodyTable(), summaryNode && createVNode(Footer$2, {
                "stickyOffsets": stickyOffsets.value,
                "flattenColumns": flattenColumns.value
              }, {
                default: function _default8() {
                  return [summaryNode];
                }
              })];
            }
          })]);
        };
      }
      var ariaProps = pickAttrs(attrs, {
        aria: true,
        data: true
      });
      var fullTable = function fullTable2() {
        var _classNames;
        return createVNode("div", _objectSpread2$2(_objectSpread2$2({}, ariaProps), {}, {
          "class": classNames(prefixCls2, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-rtl"), direction2 === "rtl"), _defineProperty$R(_classNames, "".concat(prefixCls2, "-ping-left"), pingedLeft.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-ping-right"), pingedRight.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-layout-fixed"), tableLayout === "fixed"), _defineProperty$R(_classNames, "".concat(prefixCls2, "-fixed-header"), fixHeader.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-fixed-column"), fixColumn.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-scroll-horizontal"), horizonScroll.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-has-fix-left"), flattenColumns.value[0] && flattenColumns.value[0].fixed), _defineProperty$R(_classNames, "".concat(prefixCls2, "-has-fix-right"), flattenColumns.value[columnCount.value - 1] && flattenColumns.value[columnCount.value - 1].fixed === "right"), _defineProperty$R(_classNames, attrs.class, attrs.class), _classNames)),
          "style": attrs.style,
          "id": id,
          "ref": fullTableRef
        }), [title && createVNode(Panel, {
          "class": "".concat(prefixCls2, "-title")
        }, {
          default: function _default7() {
            return [title(mergedData.value)];
          }
        }), createVNode("div", {
          "class": "".concat(prefixCls2, "-container")
        }, [groupTableNode()]), footer && createVNode(Panel, {
          "class": "".concat(prefixCls2, "-footer")
        }, {
          default: function _default7() {
            return [footer(mergedData.value)];
          }
        })]);
      };
      if (horizonScroll.value) {
        return createVNode(ResizeObserver$1, {
          "onResize": onFullTableResize
        }, {
          default: fullTable
        });
      }
      return fullTable();
    };
  }
});
var DEFAULT_PAGE_SIZE = 10;
function getPaginationParam(pagination, mergedPagination) {
  var param = {
    current: mergedPagination.current,
    pageSize: mergedPagination.pageSize
  };
  var paginationObj = pagination && _typeof$2(pagination) === "object" ? pagination : {};
  Object.keys(paginationObj).forEach(function(pageProp) {
    var value = mergedPagination[pageProp];
    if (typeof value !== "function") {
      param[pageProp] = value;
    }
  });
  return param;
}
function extendsObject() {
  var result = {};
  for (var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++) {
    list[_key] = arguments[_key];
  }
  list.forEach(function(obj) {
    if (obj) {
      Object.keys(obj).forEach(function(key2) {
        var val = obj[key2];
        if (val !== void 0) {
          result[key2] = val;
        }
      });
    }
  });
  return result;
}
function usePagination$2(totalRef, paginationRef, onChange3) {
  var pagination = computed(function() {
    return paginationRef.value && _typeof$2(paginationRef.value) === "object" ? paginationRef.value : {};
  });
  var paginationTotal = computed(function() {
    return pagination.value.total || 0;
  });
  var _useState = useState(function() {
    return {
      current: "defaultCurrent" in pagination.value ? pagination.value.defaultCurrent : 1,
      pageSize: "defaultPageSize" in pagination.value ? pagination.value.defaultPageSize : DEFAULT_PAGE_SIZE
    };
  }), _useState2 = _slicedToArray$2(_useState, 2), innerPagination = _useState2[0], setInnerPagination = _useState2[1];
  var mergedPagination = computed(function() {
    var mP = extendsObject(innerPagination.value, pagination.value, {
      total: paginationTotal.value > 0 ? paginationTotal.value : totalRef.value
    });
    var maxPage = Math.ceil((paginationTotal.value || totalRef.value) / mP.pageSize);
    if (mP.current > maxPage) {
      mP.current = maxPage || 1;
    }
    return mP;
  });
  var refreshPagination = function refreshPagination2(current2, pageSize2) {
    if (pagination.value === false)
      return;
    setInnerPagination({
      current: current2 !== null && current2 !== void 0 ? current2 : 1,
      pageSize: pageSize2 || mergedPagination.value.pageSize
    });
  };
  var onInternalChange = function onInternalChange2(current2, pageSize2) {
    var _a2, _b;
    if (pagination.value) {
      (_b = (_a2 = pagination.value).onChange) === null || _b === void 0 ? void 0 : _b.call(_a2, current2, pageSize2);
    }
    refreshPagination(current2, pageSize2);
    onChange3(current2, pageSize2 || mergedPagination.value.pageSize);
  };
  return [computed(function() {
    return pagination.value === false ? {} : _extends$2(_extends$2({}, mergedPagination.value), {
      onChange: onInternalChange
    });
  }), refreshPagination];
}
function useLazyKVMap(dataRef, childrenColumnNameRef, getRowKeyRef) {
  var mapCacheRef = shallowRef({});
  watch([dataRef, childrenColumnNameRef, getRowKeyRef], function() {
    var kvMap = new Map();
    var getRowKey = getRowKeyRef.value;
    var childrenColumnName = childrenColumnNameRef.value;
    function dig(records) {
      records.forEach(function(record, index2) {
        var rowKey2 = getRowKey(record, index2);
        kvMap.set(rowKey2, record);
        if (record && _typeof$2(record) === "object" && childrenColumnName in record) {
          dig(record[childrenColumnName] || []);
        }
      });
    }
    dig(dataRef.value);
    mapCacheRef.value = {
      kvMap
    };
  }, {
    deep: true,
    immediate: true
  });
  function getRecordByKey(key2) {
    return mapCacheRef.value.kvMap.get(key2);
  }
  return [getRecordByKey];
}
var SELECTION_COLUMN = {};
var SELECTION_ALL = "SELECT_ALL";
var SELECTION_INVERT = "SELECT_INVERT";
var SELECTION_NONE = "SELECT_NONE";
var EMPTY_LIST$1 = [];
function flattenData(data6, childrenColumnName) {
  var list = [];
  (data6 || []).forEach(function(record) {
    list.push(record);
    if (record && _typeof$2(record) === "object" && childrenColumnName in record) {
      list = [].concat(_toConsumableArray(list), _toConsumableArray(flattenData(record[childrenColumnName], childrenColumnName)));
    }
  });
  return list;
}
function useSelection(rowSelectionRef, configRef) {
  var mergedRowSelection = computed(function() {
    var temp = rowSelectionRef.value || {};
    var _temp$checkStrictly = temp.checkStrictly, checkStrictly = _temp$checkStrictly === void 0 ? true : _temp$checkStrictly;
    return _extends$2(_extends$2({}, temp), {
      checkStrictly
    });
  });
  var _useMergedState = useMergedState(mergedRowSelection.value.selectedRowKeys || mergedRowSelection.value.defaultSelectedRowKeys || EMPTY_LIST$1, {
    value: computed(function() {
      return mergedRowSelection.value.selectedRowKeys;
    })
  }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedSelectedKeys = _useMergedState2[0], setMergedSelectedKeys = _useMergedState2[1];
  var preserveRecordsRef = shallowRef(new Map());
  var updatePreserveRecordsCache = function updatePreserveRecordsCache2(keys2) {
    if (mergedRowSelection.value.preserveSelectedRowKeys) {
      var newCache = new Map();
      keys2.forEach(function(key2) {
        var record = configRef.getRecordByKey(key2);
        if (!record && preserveRecordsRef.value.has(key2)) {
          record = preserveRecordsRef.value.get(key2);
        }
        newCache.set(key2, record);
      });
      preserveRecordsRef.value = newCache;
    }
  };
  watchEffect(function() {
    updatePreserveRecordsCache(mergedSelectedKeys.value);
  });
  var keyEntities = computed(function() {
    return mergedRowSelection.value.checkStrictly ? null : convertDataToEntities(configRef.data.value, {
      externalGetKey: configRef.getRowKey.value,
      childrenPropName: configRef.childrenColumnName.value
    }).keyEntities;
  });
  var flattedData = computed(function() {
    return flattenData(configRef.pageData.value, configRef.childrenColumnName.value);
  });
  var checkboxPropsMap = computed(function() {
    var map = new Map();
    var getRowKey = configRef.getRowKey.value;
    var getCheckboxProps = mergedRowSelection.value.getCheckboxProps;
    flattedData.value.forEach(function(record, index2) {
      var key2 = getRowKey(record, index2);
      var checkboxProps3 = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
      map.set(key2, checkboxProps3);
    });
    return map;
  });
  var _useMaxLevel = useMaxLevel(keyEntities), maxLevel = _useMaxLevel.maxLevel, levelEntities = _useMaxLevel.levelEntities;
  var isCheckboxDisabled = function isCheckboxDisabled2(r2) {
    var _a2;
    return !!((_a2 = checkboxPropsMap.value.get(configRef.getRowKey.value(r2))) === null || _a2 === void 0 ? void 0 : _a2.disabled);
  };
  var selectKeysState = computed(function() {
    if (mergedRowSelection.value.checkStrictly) {
      return [mergedSelectedKeys.value || [], []];
    }
    var _conductCheck = conductCheck(mergedSelectedKeys.value, true, keyEntities.value, maxLevel.value, levelEntities.value, isCheckboxDisabled), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
    return [checkedKeys || [], halfCheckedKeys];
  });
  var derivedSelectedKeys = computed(function() {
    return selectKeysState.value[0];
  });
  var derivedHalfSelectedKeys = computed(function() {
    return selectKeysState.value[1];
  });
  var derivedSelectedKeySet = computed(function() {
    var keys2 = mergedRowSelection.value.type === "radio" ? derivedSelectedKeys.value.slice(0, 1) : derivedSelectedKeys.value;
    return new Set(keys2);
  });
  var derivedHalfSelectedKeySet = computed(function() {
    return mergedRowSelection.value.type === "radio" ? new Set() : new Set(derivedHalfSelectedKeys.value);
  });
  var _useState = useState(null), _useState2 = _slicedToArray$2(_useState, 2), lastSelectedKey = _useState2[0], setLastSelectedKey = _useState2[1];
  var setSelectedKeys = function setSelectedKeys2(keys2) {
    var availableKeys;
    var records;
    updatePreserveRecordsCache(keys2);
    var _mergedRowSelection$v = mergedRowSelection.value, preserveSelectedRowKeys = _mergedRowSelection$v.preserveSelectedRowKeys, onSelectionChange = _mergedRowSelection$v.onChange;
    var getRecordByKey = configRef.getRecordByKey;
    if (preserveSelectedRowKeys) {
      availableKeys = keys2;
      records = keys2.map(function(key2) {
        return preserveRecordsRef.value.get(key2);
      });
    } else {
      availableKeys = [];
      records = [];
      keys2.forEach(function(key2) {
        var record = getRecordByKey(key2);
        if (record !== void 0) {
          availableKeys.push(key2);
          records.push(record);
        }
      });
    }
    setMergedSelectedKeys(availableKeys);
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(availableKeys, records);
  };
  var triggerSingleSelection = function triggerSingleSelection2(key2, selected, keys2, event) {
    var onSelect = mergedRowSelection.value.onSelect;
    var _ref = configRef || {}, getRecordByKey = _ref.getRecordByKey;
    if (onSelect) {
      var rows = keys2.map(function(k2) {
        return getRecordByKey(k2);
      });
      onSelect(getRecordByKey(key2), selected, rows, event);
    }
    setSelectedKeys(keys2);
  };
  var mergedSelections = computed(function() {
    var _mergedRowSelection$v2 = mergedRowSelection.value, onSelectInvert = _mergedRowSelection$v2.onSelectInvert, onSelectNone = _mergedRowSelection$v2.onSelectNone, selections = _mergedRowSelection$v2.selections, hideSelectAll = _mergedRowSelection$v2.hideSelectAll;
    var data6 = configRef.data, pageData = configRef.pageData, getRowKey = configRef.getRowKey, tableLocale = configRef.locale;
    if (!selections || hideSelectAll) {
      return null;
    }
    var selectionList = selections === true ? [SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE] : selections;
    return selectionList.map(function(selection) {
      if (selection === SELECTION_ALL) {
        return {
          key: "all",
          text: tableLocale.value.selectionAll,
          onSelect: function onSelect() {
            setSelectedKeys(data6.value.map(function(record, index2) {
              return getRowKey.value(record, index2);
            }).filter(function(key2) {
              var checkProps = checkboxPropsMap.value.get(key2);
              return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.value.has(key2);
            }));
          }
        };
      }
      if (selection === SELECTION_INVERT) {
        return {
          key: "invert",
          text: tableLocale.value.selectInvert,
          onSelect: function onSelect() {
            var keySet = new Set(derivedSelectedKeySet.value);
            pageData.value.forEach(function(record, index2) {
              var key2 = getRowKey.value(record, index2);
              var checkProps = checkboxPropsMap.value.get(key2);
              if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                if (keySet.has(key2)) {
                  keySet.delete(key2);
                } else {
                  keySet.add(key2);
                }
              }
            });
            var keys2 = Array.from(keySet);
            if (onSelectInvert) {
              devWarning(false, "Table", "`onSelectInvert` will be removed in future. Please use `onChange` instead.");
              onSelectInvert(keys2);
            }
            setSelectedKeys(keys2);
          }
        };
      }
      if (selection === SELECTION_NONE) {
        return {
          key: "none",
          text: tableLocale.value.selectNone,
          onSelect: function onSelect() {
            onSelectNone === null || onSelectNone === void 0 ? void 0 : onSelectNone();
            setSelectedKeys(Array.from(derivedSelectedKeySet.value).filter(function(key2) {
              var checkProps = checkboxPropsMap.value.get(key2);
              return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
            }));
          }
        };
      }
      return selection;
    });
  });
  var flattedDataLength = computed(function() {
    return flattedData.value.length;
  });
  var transformColumns = function transformColumns2(columns2) {
    var _a2;
    var _mergedRowSelection$v3 = mergedRowSelection.value, onSelectAll = _mergedRowSelection$v3.onSelectAll, onSelectMultiple = _mergedRowSelection$v3.onSelectMultiple, selectionColWidth = _mergedRowSelection$v3.columnWidth, selectionType = _mergedRowSelection$v3.type, fixed = _mergedRowSelection$v3.fixed, customizeRenderCell = _mergedRowSelection$v3.renderCell, hideSelectAll = _mergedRowSelection$v3.hideSelectAll, checkStrictly = _mergedRowSelection$v3.checkStrictly;
    var prefixCls2 = configRef.prefixCls, getRecordByKey = configRef.getRecordByKey, getRowKey = configRef.getRowKey, expandType = configRef.expandType, getPopupContainer = configRef.getPopupContainer;
    if (!rowSelectionRef.value) {
      return columns2.filter(function(col) {
        return col !== SELECTION_COLUMN;
      });
    }
    var cloneColumns = columns2.slice();
    var keySet = new Set(derivedSelectedKeySet.value);
    var recordKeys = flattedData.value.map(getRowKey.value).filter(function(key2) {
      return !checkboxPropsMap.value.get(key2).disabled;
    });
    var checkedCurrentAll = recordKeys.every(function(key2) {
      return keySet.has(key2);
    });
    var checkedCurrentSome = recordKeys.some(function(key2) {
      return keySet.has(key2);
    });
    var onSelectAllChange = function onSelectAllChange2() {
      var changeKeys = [];
      if (checkedCurrentAll) {
        recordKeys.forEach(function(key2) {
          keySet.delete(key2);
          changeKeys.push(key2);
        });
      } else {
        recordKeys.forEach(function(key2) {
          if (!keySet.has(key2)) {
            keySet.add(key2);
            changeKeys.push(key2);
          }
        });
      }
      var keys2 = Array.from(keySet);
      onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(!checkedCurrentAll, keys2.map(function(k2) {
        return getRecordByKey(k2);
      }), changeKeys.map(function(k2) {
        return getRecordByKey(k2);
      }));
      setSelectedKeys(keys2);
    };
    var title;
    if (selectionType !== "radio") {
      var customizeSelections;
      if (mergedSelections.value) {
        var menu = createVNode(Menu, {
          "getPopupContainer": getPopupContainer.value
        }, {
          default: function _default7() {
            return [mergedSelections.value.map(function(selection, index2) {
              var key2 = selection.key, text = selection.text, onSelectionClick = selection.onSelect;
              return createVNode(Menu.Item, {
                "key": key2 || index2,
                "onClick": function onClick2() {
                  onSelectionClick === null || onSelectionClick === void 0 ? void 0 : onSelectionClick(recordKeys);
                }
              }, {
                default: function _default8() {
                  return [text];
                }
              });
            })];
          }
        });
        customizeSelections = createVNode("div", {
          "class": "".concat(prefixCls2.value, "-selection-extra")
        }, [createVNode(Dropdown$2, {
          "overlay": menu,
          "getPopupContainer": getPopupContainer.value
        }, {
          default: function _default7() {
            return [createVNode("span", null, [createVNode(DownOutlined$1, null, null)])];
          }
        })]);
      }
      var allDisabledData = flattedData.value.map(function(record, index2) {
        var key2 = getRowKey.value(record, index2);
        var checkboxProps3 = checkboxPropsMap.value.get(key2) || {};
        return _extends$2({
          checked: keySet.has(key2)
        }, checkboxProps3);
      }).filter(function(_ref2) {
        var disabled = _ref2.disabled;
        return disabled;
      });
      var allDisabled = !!allDisabledData.length && allDisabledData.length === flattedDataLength.value;
      var allDisabledAndChecked = allDisabled && allDisabledData.every(function(_ref3) {
        var checked = _ref3.checked;
        return checked;
      });
      var allDisabledSomeChecked = allDisabled && allDisabledData.some(function(_ref4) {
        var checked = _ref4.checked;
        return checked;
      });
      title = !hideSelectAll && createVNode("div", {
        "class": "".concat(prefixCls2.value, "-selection")
      }, [createVNode(Checkbox, {
        "checked": !allDisabled ? !!flattedDataLength.value && checkedCurrentAll : allDisabledAndChecked,
        "indeterminate": !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
        "onChange": onSelectAllChange,
        "disabled": flattedDataLength.value === 0 || allDisabled,
        "skipGroup": true
      }, null), customizeSelections]);
    }
    var renderCell;
    if (selectionType === "radio") {
      renderCell = function renderCell2(_ref5) {
        var record = _ref5.record, index2 = _ref5.index;
        var key2 = getRowKey.value(record, index2);
        var checked = keySet.has(key2);
        return {
          node: createVNode(Radio, _objectSpread2$2(_objectSpread2$2({}, checkboxPropsMap.value.get(key2)), {}, {
            "checked": checked,
            "onClick": function onClick2(e2) {
              return e2.stopPropagation();
            },
            "onChange": function onChange3(event) {
              if (!keySet.has(key2)) {
                triggerSingleSelection(key2, true, [key2], event.nativeEvent);
              }
            }
          }), null),
          checked
        };
      };
    } else {
      renderCell = function renderCell2(_ref6) {
        var record = _ref6.record, index2 = _ref6.index;
        var _a3;
        var key2 = getRowKey.value(record, index2);
        var checked = keySet.has(key2);
        var indeterminate = derivedHalfSelectedKeySet.value.has(key2);
        var checkboxProps3 = checkboxPropsMap.value.get(key2);
        var mergedIndeterminate;
        if (expandType.value === "nest") {
          mergedIndeterminate = indeterminate;
          devWarning(typeof (checkboxProps3 === null || checkboxProps3 === void 0 ? void 0 : checkboxProps3.indeterminate) !== "boolean", "Table", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.");
        } else {
          mergedIndeterminate = (_a3 = checkboxProps3 === null || checkboxProps3 === void 0 ? void 0 : checkboxProps3.indeterminate) !== null && _a3 !== void 0 ? _a3 : indeterminate;
        }
        return {
          node: createVNode(Checkbox, _objectSpread2$2(_objectSpread2$2({}, checkboxProps3), {}, {
            "indeterminate": mergedIndeterminate,
            "checked": checked,
            "skipGroup": true,
            "onClick": function onClick2(e2) {
              return e2.stopPropagation();
            },
            "onChange": function onChange3(_ref7) {
              var nativeEvent = _ref7.nativeEvent;
              var shiftKey = nativeEvent.shiftKey;
              var startIndex = -1;
              var endIndex = -1;
              if (shiftKey && checkStrictly) {
                var pointKeys = new Set([lastSelectedKey.value, key2]);
                recordKeys.some(function(recordKey, recordIndex) {
                  if (pointKeys.has(recordKey)) {
                    if (startIndex === -1) {
                      startIndex = recordIndex;
                    } else {
                      endIndex = recordIndex;
                      return true;
                    }
                  }
                  return false;
                });
              }
              if (endIndex !== -1 && startIndex !== endIndex && checkStrictly) {
                var rangeKeys = recordKeys.slice(startIndex, endIndex + 1);
                var changedKeys = [];
                if (checked) {
                  rangeKeys.forEach(function(recordKey) {
                    if (keySet.has(recordKey)) {
                      changedKeys.push(recordKey);
                      keySet.delete(recordKey);
                    }
                  });
                } else {
                  rangeKeys.forEach(function(recordKey) {
                    if (!keySet.has(recordKey)) {
                      changedKeys.push(recordKey);
                      keySet.add(recordKey);
                    }
                  });
                }
                var keys2 = Array.from(keySet);
                onSelectMultiple === null || onSelectMultiple === void 0 ? void 0 : onSelectMultiple(!checked, keys2.map(function(recordKey) {
                  return getRecordByKey(recordKey);
                }), changedKeys.map(function(recordKey) {
                  return getRecordByKey(recordKey);
                }));
                setSelectedKeys(keys2);
              } else {
                var originCheckedKeys = derivedSelectedKeys.value;
                if (checkStrictly) {
                  var checkedKeys = checked ? arrDel(originCheckedKeys, key2) : arrAdd(originCheckedKeys, key2);
                  triggerSingleSelection(key2, !checked, checkedKeys, nativeEvent);
                } else {
                  var result = conductCheck([].concat(_toConsumableArray(originCheckedKeys), [key2]), true, keyEntities.value, maxLevel.value, levelEntities.value, isCheckboxDisabled);
                  var _checkedKeys = result.checkedKeys, halfCheckedKeys = result.halfCheckedKeys;
                  var nextCheckedKeys = _checkedKeys;
                  if (checked) {
                    var tempKeySet = new Set(_checkedKeys);
                    tempKeySet.delete(key2);
                    nextCheckedKeys = conductCheck(Array.from(tempKeySet), {
                      checked: false,
                      halfCheckedKeys
                    }, keyEntities.value, maxLevel.value, levelEntities.value, isCheckboxDisabled).checkedKeys;
                  }
                  triggerSingleSelection(key2, !checked, nextCheckedKeys, nativeEvent);
                }
              }
              setLastSelectedKey(key2);
            }
          }), null),
          checked
        };
      };
    }
    var renderSelectionCell = function renderSelectionCell2(_ref8) {
      var record = _ref8.record, index2 = _ref8.index;
      var _renderCell = renderCell({
        record,
        index: index2
      }), node = _renderCell.node, checked = _renderCell.checked;
      if (customizeRenderCell) {
        return customizeRenderCell(checked, record, index2, node);
      }
      return node;
    };
    if (!cloneColumns.includes(SELECTION_COLUMN)) {
      if (cloneColumns.findIndex(function(col) {
        var _a3;
        return ((_a3 = col[INTERNAL_COL_DEFINE]) === null || _a3 === void 0 ? void 0 : _a3.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        var _cloneColumns = cloneColumns, _cloneColumns2 = _toArray(_cloneColumns), expandColumn = _cloneColumns2[0], restColumns = _cloneColumns2.slice(1);
        cloneColumns = [expandColumn, SELECTION_COLUMN].concat(_toConsumableArray(restColumns));
      } else {
        cloneColumns = [SELECTION_COLUMN].concat(_toConsumableArray(cloneColumns));
      }
    }
    var selectionColumnIndex = cloneColumns.indexOf(SELECTION_COLUMN);
    cloneColumns = cloneColumns.filter(function(column, index2) {
      return column !== SELECTION_COLUMN || index2 === selectionColumnIndex;
    });
    var prevCol = cloneColumns[selectionColumnIndex - 1];
    var nextCol = cloneColumns[selectionColumnIndex + 1];
    var mergedFixed = fixed;
    if (mergedFixed === void 0) {
      if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== void 0) {
        mergedFixed = nextCol.fixed;
      } else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== void 0) {
        mergedFixed = prevCol.fixed;
      }
    }
    if (mergedFixed && prevCol && ((_a2 = prevCol[INTERNAL_COL_DEFINE]) === null || _a2 === void 0 ? void 0 : _a2.columnType) === "EXPAND_COLUMN" && prevCol.fixed === void 0) {
      prevCol.fixed = mergedFixed;
    }
    var selectionColumn = _defineProperty$R({
      fixed: mergedFixed,
      width: selectionColWidth,
      className: "".concat(prefixCls2.value, "-selection-column"),
      title: mergedRowSelection.value.columnTitle || title,
      customRender: renderSelectionCell
    }, INTERNAL_COL_DEFINE, {
      class: "".concat(prefixCls2.value, "-selection-col")
    });
    return cloneColumns.map(function(col) {
      return col === SELECTION_COLUMN ? selectionColumn : col;
    });
  };
  return [transformColumns, derivedSelectedKeySet];
}
var __rest$7 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function getColumnKey(column, defaultKey) {
  if ("key" in column && column.key !== void 0 && column.key !== null) {
    return column.key;
  }
  if (column.dataIndex) {
    return Array.isArray(column.dataIndex) ? column.dataIndex.join(".") : column.dataIndex;
  }
  return defaultKey;
}
function getColumnPos(index2, pos) {
  return pos ? "".concat(pos, "-").concat(index2) : "".concat(index2);
}
function renderColumnTitle(title, props2) {
  if (typeof title === "function") {
    return title(props2);
  }
  return title;
}
function convertChildrenToColumns() {
  var elements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var flattenElements = flattenChildren(elements);
  var columns2 = [];
  flattenElements.forEach(function(element) {
    var _a2, _b, _c, _d;
    if (!element) {
      return;
    }
    var key2 = element.key;
    var style2 = ((_a2 = element.props) === null || _a2 === void 0 ? void 0 : _a2.style) || {};
    var cls = ((_b = element.props) === null || _b === void 0 ? void 0 : _b.class) || "";
    var props2 = element.props || {};
    for (var _i = 0, _Object$entries = Object.entries(props2); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2), k2 = _Object$entries$_i[0], v2 = _Object$entries$_i[1];
      props2[camelize$1(k2)] = v2;
    }
    var _e = element.children || {}, children = _e.default, restSlots = __rest$7(_e, ["default"]);
    var column = _extends$2(_extends$2(_extends$2({}, restSlots), props2), {
      style: style2,
      class: cls
    });
    if (key2) {
      column.key = key2;
    }
    if ((_c = element.type) === null || _c === void 0 ? void 0 : _c.__ANT_TABLE_COLUMN_GROUP) {
      column.children = convertChildrenToColumns(typeof children === "function" ? children() : children);
    } else {
      var customRender = (_d = element.children) === null || _d === void 0 ? void 0 : _d.default;
      column.customRender = column.customRender || customRender;
    }
    columns2.push(column);
  });
  return columns2;
}
var ASCEND = "ascend";
var DESCEND = "descend";
function getMultiplePriority(column) {
  if (_typeof$2(column.sorter) === "object" && typeof column.sorter.multiple === "number") {
    return column.sorter.multiple;
  }
  return false;
}
function getSortFunction(sorter) {
  if (typeof sorter === "function") {
    return sorter;
  }
  if (sorter && _typeof$2(sorter) === "object" && sorter.compare) {
    return sorter.compare;
  }
  return false;
}
function nextSortDirection(sortDirections, current2) {
  if (!current2) {
    return sortDirections[0];
  }
  return sortDirections[sortDirections.indexOf(current2) + 1];
}
function collectSortStates(columns2, init, pos) {
  var sortStates = [];
  function pushState(column, columnPos) {
    sortStates.push({
      column,
      key: getColumnKey(column, columnPos),
      multiplePriority: getMultiplePriority(column),
      sortOrder: column.sortOrder
    });
  }
  (columns2 || []).forEach(function(column, index2) {
    var columnPos = getColumnPos(index2, pos);
    if (column.children) {
      if ("sortOrder" in column) {
        pushState(column, columnPos);
      }
      sortStates = [].concat(_toConsumableArray(sortStates), _toConsumableArray(collectSortStates(column.children, init, columnPos)));
    } else if (column.sorter) {
      if ("sortOrder" in column) {
        pushState(column, columnPos);
      } else if (init && column.defaultSortOrder) {
        sortStates.push({
          column,
          key: getColumnKey(column, columnPos),
          multiplePriority: getMultiplePriority(column),
          sortOrder: column.defaultSortOrder
        });
      }
    }
  });
  return sortStates;
}
function injectSorter(prefixCls2, columns2, sorterSates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) {
  return (columns2 || []).map(function(column, index2) {
    var columnPos = getColumnPos(index2, pos);
    var newColumn = column;
    if (newColumn.sorter) {
      var sortDirections = newColumn.sortDirections || defaultSortDirections;
      var showSorterTooltip = newColumn.showSorterTooltip === void 0 ? tableShowSorterTooltip : newColumn.showSorterTooltip;
      var columnKey = getColumnKey(newColumn, columnPos);
      var sorterState = sorterSates.find(function(_ref) {
        var key2 = _ref.key;
        return key2 === columnKey;
      });
      var sorterOrder = sorterState ? sorterState.sortOrder : null;
      var nextSortOrder = nextSortDirection(sortDirections, sorterOrder);
      var upNode = sortDirections.includes(ASCEND) && createVNode(CaretUpOutlined$1, {
        "class": classNames("".concat(prefixCls2, "-column-sorter-up"), {
          active: sorterOrder === ASCEND
        })
      }, null);
      var downNode = sortDirections.includes(DESCEND) && createVNode(CaretDownOutlined$1, {
        "class": classNames("".concat(prefixCls2, "-column-sorter-down"), {
          active: sorterOrder === DESCEND
        })
      }, null);
      var _ref2 = tableLocale || {}, cancelSort = _ref2.cancelSort, triggerAsc = _ref2.triggerAsc, triggerDesc = _ref2.triggerDesc;
      var sortTip = cancelSort;
      if (nextSortOrder === DESCEND) {
        sortTip = triggerDesc;
      } else if (nextSortOrder === ASCEND) {
        sortTip = triggerAsc;
      }
      var tooltipProps3 = _typeof$2(showSorterTooltip) === "object" ? showSorterTooltip : {
        title: sortTip
      };
      newColumn = _extends$2(_extends$2({}, newColumn), {
        className: classNames(newColumn.className, _defineProperty$R({}, "".concat(prefixCls2, "-column-sort"), sorterOrder)),
        title: function title(renderProps) {
          var renderSortTitle = createVNode("div", {
            "class": "".concat(prefixCls2, "-column-sorters")
          }, [createVNode("span", {
            "class": "".concat(prefixCls2, "-column-title")
          }, [renderColumnTitle(column.title, renderProps)]), createVNode("span", {
            "class": classNames("".concat(prefixCls2, "-column-sorter"), _defineProperty$R({}, "".concat(prefixCls2, "-column-sorter-full"), !!(upNode && downNode)))
          }, [createVNode("span", {
            "class": "".concat(prefixCls2, "-column-sorter-inner")
          }, [upNode, downNode])])]);
          return showSorterTooltip ? createVNode(Tooltip, tooltipProps3, {
            default: function _default7() {
              return [renderSortTitle];
            }
          }) : renderSortTitle;
        },
        customHeaderCell: function customHeaderCell(col) {
          var cell = column.customHeaderCell && column.customHeaderCell(col) || {};
          var originOnClick = cell.onClick;
          cell.onClick = function(event) {
            triggerSorter({
              column,
              key: columnKey,
              sortOrder: nextSortOrder,
              multiplePriority: getMultiplePriority(column)
            });
            if (originOnClick) {
              originOnClick(event);
            }
          };
          cell.class = classNames(cell.class, "".concat(prefixCls2, "-column-has-sorters"));
          return cell;
        }
      });
    }
    if ("children" in newColumn) {
      newColumn = _extends$2(_extends$2({}, newColumn), {
        children: injectSorter(prefixCls2, newColumn.children, sorterSates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
      });
    }
    return newColumn;
  });
}
function stateToInfo(sorterStates) {
  var column = sorterStates.column, sortOrder = sorterStates.sortOrder;
  return {
    column,
    order: sortOrder,
    field: column.dataIndex,
    columnKey: column.key
  };
}
function generateSorterInfo(sorterStates) {
  var list = sorterStates.filter(function(_ref3) {
    var sortOrder = _ref3.sortOrder;
    return sortOrder;
  }).map(stateToInfo);
  if (list.length === 0 && sorterStates.length) {
    return _extends$2(_extends$2({}, stateToInfo(sorterStates[sorterStates.length - 1])), {
      column: void 0
    });
  }
  if (list.length <= 1) {
    return list[0] || {};
  }
  return list;
}
function getSortData(data6, sortStates, childrenColumnName) {
  var innerSorterStates = sortStates.slice().sort(function(a2, b2) {
    return b2.multiplePriority - a2.multiplePriority;
  });
  var cloneData = data6.slice();
  var runningSorters = innerSorterStates.filter(function(_ref4) {
    var sorter = _ref4.column.sorter, sortOrder = _ref4.sortOrder;
    return getSortFunction(sorter) && sortOrder;
  });
  if (!runningSorters.length) {
    return cloneData;
  }
  return cloneData.sort(function(record1, record2) {
    for (var i2 = 0; i2 < runningSorters.length; i2 += 1) {
      var sorterState = runningSorters[i2];
      var sorter = sorterState.column.sorter, sortOrder = sorterState.sortOrder;
      var compareFn = getSortFunction(sorter);
      if (compareFn && sortOrder) {
        var compareResult = compareFn(record1, record2, sortOrder);
        if (compareResult !== 0) {
          return sortOrder === ASCEND ? compareResult : -compareResult;
        }
      }
    }
    return 0;
  }).map(function(record) {
    var subRecords = record[childrenColumnName];
    if (subRecords) {
      return _extends$2(_extends$2({}, record), _defineProperty$R({}, childrenColumnName, getSortData(subRecords, sortStates, childrenColumnName)));
    }
    return record;
  });
}
function useFilterSorter(_ref5) {
  var prefixCls2 = _ref5.prefixCls, mergedColumns = _ref5.mergedColumns, onSorterChange = _ref5.onSorterChange, sortDirections = _ref5.sortDirections, tableLocale = _ref5.tableLocale, showSorterTooltip = _ref5.showSorterTooltip;
  var _useState = useState(collectSortStates(mergedColumns.value, true)), _useState2 = _slicedToArray$2(_useState, 2), sortStates = _useState2[0], setSortStates = _useState2[1];
  var mergedSorterStates = computed(function() {
    var validate = true;
    var collectedStates = collectSortStates(mergedColumns.value, false);
    if (!collectedStates.length) {
      return sortStates.value;
    }
    var validateStates = [];
    function patchStates(state) {
      if (validate) {
        validateStates.push(state);
      } else {
        validateStates.push(_extends$2(_extends$2({}, state), {
          sortOrder: null
        }));
      }
    }
    var multipleMode = null;
    collectedStates.forEach(function(state) {
      if (multipleMode === null) {
        patchStates(state);
        if (state.sortOrder) {
          if (state.multiplePriority === false) {
            validate = false;
          } else {
            multipleMode = true;
          }
        }
      } else if (multipleMode && state.multiplePriority !== false) {
        patchStates(state);
      } else {
        validate = false;
        patchStates(state);
      }
    });
    return validateStates;
  });
  var columnTitleSorterProps = computed(function() {
    var sortColumns = mergedSorterStates.value.map(function(_ref6) {
      var column = _ref6.column, sortOrder = _ref6.sortOrder;
      return {
        column,
        order: sortOrder
      };
    });
    return {
      sortColumns,
      sortColumn: sortColumns[0] && sortColumns[0].column,
      sortOrder: sortColumns[0] && sortColumns[0].order
    };
  });
  function triggerSorter(sortState) {
    var newSorterStates;
    if (sortState.multiplePriority === false || !mergedSorterStates.value.length || mergedSorterStates.value[0].multiplePriority === false) {
      newSorterStates = [sortState];
    } else {
      newSorterStates = [].concat(_toConsumableArray(mergedSorterStates.value.filter(function(_ref7) {
        var key2 = _ref7.key;
        return key2 !== sortState.key;
      })), [sortState]);
    }
    setSortStates(newSorterStates);
    onSorterChange(generateSorterInfo(newSorterStates), newSorterStates);
  }
  var transformColumns = function transformColumns2(innerColumns) {
    return injectSorter(prefixCls2.value, innerColumns, mergedSorterStates.value, triggerSorter, sortDirections.value, tableLocale.value, showSorterTooltip.value);
  };
  var sorters = computed(function() {
    return generateSorterInfo(mergedSorterStates.value);
  });
  return [transformColumns, mergedSorterStates, columnTitleSorterProps, sorters];
}
var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper2(_props, _ref) {
  var slots = _ref.slots;
  var _a2;
  return createVNode("div", {
    "onClick": function onClick2(e2) {
      return e2.stopPropagation();
    }
  }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]);
};
var FilterDropdownMenuWrapper$1 = FilterDropdownMenuWrapper;
var FilterSearch = defineComponent({
  name: "FilterSearch",
  inheritAttrs: false,
  props: {
    value: String,
    onChange: Function,
    filterSearch: Boolean,
    tablePrefixCls: String,
    locale: {
      type: Object,
      default: void 0
    }
  },
  setup: function setup144(props2) {
    return function() {
      var value = props2.value, onChange3 = props2.onChange, filterSearch = props2.filterSearch, tablePrefixCls = props2.tablePrefixCls, locale2 = props2.locale;
      if (!filterSearch) {
        return null;
      }
      return createVNode("div", {
        "class": "".concat(tablePrefixCls, "-filter-dropdown-search")
      }, [createVNode(Input, {
        "placeholder": locale2.filterSearchPlaceholder,
        "onChange": onChange3,
        "value": value,
        "htmlSize": 1,
        "class": "".concat(tablePrefixCls, "-filter-dropdown-search-input")
      }, {
        prefix: function prefix() {
          return createVNode(SearchOutlined$1, null, null);
        }
      })]);
    };
  }
});
var __rest$6 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var MotionTreeNode = defineComponent({
  name: "MotionTreeNode",
  inheritAttrs: false,
  props: _extends$2(_extends$2({}, treeNodeProps), {
    active: Boolean,
    motion: Object,
    motionNodes: {
      type: Array
    },
    onMotionStart: Function,
    onMotionEnd: Function,
    motionType: String
  }),
  slots: ["title", "icon", "switcherIcon", "checkable"],
  setup: function setup145(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var visible = ref(true);
    var context2 = useInjectTreeContext();
    var motionedRef = ref(false);
    var transitionProps = computed(function() {
      if (props2.motion) {
        return props2.motion;
      } else {
        return collapseMotion$1();
      }
    });
    var onMotionEnd = function onMotionEnd2(node, type4) {
      var _a2, _b, _c, _d;
      if (type4 === "appear") {
        (_b = (_a2 = transitionProps.value) === null || _a2 === void 0 ? void 0 : _a2.onAfterEnter) === null || _b === void 0 ? void 0 : _b.call(_a2, node);
      } else if (type4 === "leave") {
        (_d = (_c = transitionProps.value) === null || _c === void 0 ? void 0 : _c.onAfterLeave) === null || _d === void 0 ? void 0 : _d.call(_c, node);
      }
      if (!motionedRef.value) {
        props2.onMotionEnd();
      }
      motionedRef.value = true;
    };
    watch(function() {
      return props2.motionNodes;
    }, function() {
      if (props2.motionNodes && props2.motionType === "hide" && visible.value) {
        nextTick(function() {
          visible.value = false;
        });
      }
    }, {
      immediate: true,
      flush: "post"
    });
    onMounted(function() {
      props2.motionNodes && props2.onMotionStart();
    });
    onBeforeUnmount(function() {
      props2.motionNodes && onMotionEnd();
    });
    return function() {
      props2.motion;
      var motionNodes = props2.motionNodes, motionType = props2.motionType, active = props2.active, eventKey = props2.eventKey, otherProps = __rest$6(props2, ["motion", "motionNodes", "motionType", "active", "eventKey"]);
      if (motionNodes) {
        return createVNode(Transition$2, _objectSpread2$2(_objectSpread2$2({}, transitionProps.value), {}, {
          "appear": motionType === "show",
          "onAfterAppear": function onAfterAppear(node) {
            return onMotionEnd(node, "appear");
          },
          "onAfterLeave": function onAfterLeave(node) {
            return onMotionEnd(node, "leave");
          }
        }), {
          default: function _default7() {
            return [withDirectives(createVNode("div", {
              "class": "".concat(context2.value.prefixCls, "-treenode-motion")
            }, [motionNodes.map(function(treeNode) {
              var restProps = __rest$6(treeNode.data, []), title = treeNode.title, key2 = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
              delete restProps.children;
              return createVNode(VcTreeNode, _objectSpread2$2(_objectSpread2$2({}, restProps), {}, {
                "title": title,
                "active": active,
                "data": treeNode.data,
                "key": key2,
                "eventKey": key2,
                "isStart": isStart,
                "isEnd": isEnd
              }), slots);
            })]), [[vShow, visible.value]])];
          }
        });
      }
      return createVNode(VcTreeNode, _objectSpread2$2(_objectSpread2$2({
        "domRef": ref,
        "class": attrs.class,
        "style": attrs.style
      }, otherProps), {}, {
        "active": active,
        "eventKey": eventKey
      }), slots);
    };
  }
});
function findExpandedKeys() {
  var prev2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var next2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var prevLen = prev2.length;
  var nextLen = next2.length;
  if (Math.abs(prevLen - nextLen) !== 1) {
    return {
      add: false,
      key: null
    };
  }
  function find2(shorter, longer) {
    var cache2 = new Map();
    shorter.forEach(function(key2) {
      cache2.set(key2, true);
    });
    var keys2 = longer.filter(function(key2) {
      return !cache2.has(key2);
    });
    return keys2.length === 1 ? keys2[0] : null;
  }
  if (prevLen < nextLen) {
    return {
      add: true,
      key: find2(prev2, next2)
    };
  }
  return {
    add: false,
    key: find2(next2, prev2)
  };
}
function getExpandRange(shorter, longer, key2) {
  var shorterStartIndex = shorter.findIndex(function(item) {
    return item.key === key2;
  });
  var shorterEndNode = shorter[shorterStartIndex + 1];
  var longerStartIndex = longer.findIndex(function(item) {
    return item.key === key2;
  });
  if (shorterEndNode) {
    var longerEndIndex = longer.findIndex(function(item) {
      return item.key === shorterEndNode.key;
    });
    return longer.slice(longerStartIndex + 1, longerEndIndex);
  }
  return longer.slice(longerStartIndex + 1);
}
var __rest$5 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var HIDDEN_STYLE$1 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var noop = function noop2() {
};
var MOTION_KEY = "RC_TREE_MOTION_".concat(Math.random());
var MotionNode = {
  key: MOTION_KEY
};
var MotionEntity = {
  key: MOTION_KEY,
  level: 0,
  index: 0,
  pos: "0",
  node: MotionNode,
  nodes: [MotionNode]
};
var MotionFlattenData = {
  parent: null,
  children: [],
  pos: MotionEntity.pos,
  data: MotionNode,
  title: null,
  key: MOTION_KEY,
  isStart: [],
  isEnd: []
};
function getMinimumRangeTransitionRange(list, virtual, height, itemHeight) {
  if (virtual === false || !height) {
    return list;
  }
  return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function itemKey(item) {
  var key2 = item.key, pos = item.pos;
  return getKey$2(key2, pos);
}
function getAccessibilityPath(item) {
  var path = String(item.key);
  var current2 = item;
  while (current2.parent) {
    current2 = current2.parent;
    path = "".concat(current2.key, " > ").concat(path);
  }
  return path;
}
var NodeList = defineComponent({
  name: "NodeList",
  inheritAttrs: false,
  props: nodeListProps,
  setup: function setup146(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs;
    var listRef = ref();
    var indentMeasurerRef = ref();
    var _useInjectKeysState = useInjectKeysState(), expandedKeys = _useInjectKeysState.expandedKeys, flattenNodes = _useInjectKeysState.flattenNodes;
    expose({
      scrollTo: function scrollTo2(scroll) {
        listRef.value.scrollTo(scroll);
      },
      getIndentWidth: function getIndentWidth() {
        return indentMeasurerRef.value.offsetWidth;
      }
    });
    var transitionData = shallowRef(flattenNodes.value);
    var transitionRange = shallowRef([]);
    var motionType = ref(null);
    function onMotionEnd() {
      transitionData.value = flattenNodes.value;
      transitionRange.value = [];
      motionType.value = null;
      props2.onListChangeEnd();
    }
    var context2 = useInjectTreeContext();
    watch([function() {
      return expandedKeys.value.slice();
    }, flattenNodes], function(_ref2, _ref3) {
      var _ref4 = _slicedToArray$2(_ref2, 2), expandedKeys2 = _ref4[0], data6 = _ref4[1];
      var _ref5 = _slicedToArray$2(_ref3, 2), prevExpandedKeys = _ref5[0], prevData = _ref5[1];
      var diffExpanded = findExpandedKeys(prevExpandedKeys, expandedKeys2);
      if (diffExpanded.key !== null) {
        var virtual = props2.virtual, height = props2.height, itemHeight = props2.itemHeight;
        if (diffExpanded.add) {
          var keyIndex = prevData.findIndex(function(_ref6) {
            var key2 = _ref6.key;
            return key2 === diffExpanded.key;
          });
          var rangeNodes = getMinimumRangeTransitionRange(getExpandRange(prevData, data6, diffExpanded.key), virtual, height, itemHeight);
          var newTransitionData = prevData.slice();
          newTransitionData.splice(keyIndex + 1, 0, MotionFlattenData);
          transitionData.value = newTransitionData;
          transitionRange.value = rangeNodes;
          motionType.value = "show";
        } else {
          var _keyIndex = data6.findIndex(function(_ref7) {
            var key2 = _ref7.key;
            return key2 === diffExpanded.key;
          });
          var _rangeNodes = getMinimumRangeTransitionRange(getExpandRange(data6, prevData, diffExpanded.key), virtual, height, itemHeight);
          var _newTransitionData = data6.slice();
          _newTransitionData.splice(_keyIndex + 1, 0, MotionFlattenData);
          transitionData.value = _newTransitionData;
          transitionRange.value = _rangeNodes;
          motionType.value = "hide";
        }
      } else if (prevData !== data6) {
        transitionData.value = data6;
      }
    });
    watch(function() {
      return context2.value.dragging;
    }, function(dragging) {
      if (!dragging) {
        onMotionEnd();
      }
    });
    var mergedData = computed(function() {
      return props2.motion === void 0 ? transitionData.value : flattenNodes.value;
    });
    var onActiveChange = function onActiveChange2() {
      props2.onActiveChange(null);
    };
    return function() {
      var _a2 = _extends$2(_extends$2({}, props2), attrs), prefixCls2 = _a2.prefixCls;
      _a2.selectable;
      _a2.checkable;
      var disabled = _a2.disabled, motion = _a2.motion, height = _a2.height, itemHeight = _a2.itemHeight, virtual = _a2.virtual, focusable = _a2.focusable, activeItem = _a2.activeItem, focused = _a2.focused, tabindex = _a2.tabindex, onKeydown = _a2.onKeydown, onFocus2 = _a2.onFocus, onBlur2 = _a2.onBlur, onListChangeStart = _a2.onListChangeStart;
      _a2.onListChangeEnd;
      var domProps = __rest$5(_a2, ["prefixCls", "selectable", "checkable", "disabled", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabindex", "onKeydown", "onFocus", "onBlur", "onListChangeStart", "onListChangeEnd"]);
      return createVNode(Fragment, null, [focused && activeItem && createVNode("span", {
        "style": HIDDEN_STYLE$1,
        "aria-live": "assertive"
      }, [getAccessibilityPath(activeItem)]), createVNode("div", null, [createVNode("input", {
        "style": HIDDEN_STYLE$1,
        "disabled": focusable === false || disabled,
        "tabindex": focusable !== false ? tabindex : null,
        "onKeydown": onKeydown,
        "onFocus": onFocus2,
        "onBlur": onBlur2,
        "value": "",
        "onChange": noop,
        "aria-label": "for screen reader"
      }, null)]), createVNode("div", {
        "class": "".concat(prefixCls2, "-treenode"),
        "aria-hidden": true,
        "style": {
          position: "absolute",
          pointerEvents: "none",
          visibility: "hidden",
          height: 0,
          overflow: "hidden"
        }
      }, [createVNode("div", {
        "class": "".concat(prefixCls2, "-indent")
      }, [createVNode("div", {
        "ref": indentMeasurerRef,
        "class": "".concat(prefixCls2, "-indent-unit")
      }, null)])]), createVNode(List$1, _objectSpread2$2(_objectSpread2$2({}, omit$3(domProps, ["onActiveChange"])), {}, {
        "data": mergedData.value,
        "itemKey": itemKey,
        "height": height,
        "fullHeight": false,
        "virtual": virtual,
        "itemHeight": itemHeight,
        "prefixCls": "".concat(prefixCls2, "-list"),
        "ref": listRef,
        "onVisibleChange": function onVisibleChange(originList, fullList) {
          var originSet = new Set(originList);
          var restList = fullList.filter(function(item) {
            return !originSet.has(item);
          });
          if (restList.some(function(item) {
            return itemKey(item) === MOTION_KEY;
          })) {
            onMotionEnd();
          }
        }
      }), {
        default: function _default7(treeNode) {
          var pos = treeNode.pos, restProps = __rest$5(treeNode.data, []), title = treeNode.title, key2 = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
          var mergedKey = getKey$2(key2, pos);
          delete restProps.key;
          delete restProps.children;
          return createVNode(MotionTreeNode, _objectSpread2$2(_objectSpread2$2({}, restProps), {}, {
            "eventKey": mergedKey,
            "title": title,
            "active": !!activeItem && key2 === activeItem.key,
            "data": treeNode.data,
            "isStart": isStart,
            "isEnd": isEnd,
            "motion": motion,
            "motionNodes": key2 === MOTION_KEY ? transitionRange.value : null,
            "motionType": motionType.value,
            "onMotionStart": onListChangeStart,
            "onMotionEnd": onMotionEnd,
            "onMousemove": onActiveChange
          }), null);
        }
      })]);
    };
  }
});
function DropIndicator(_ref) {
  var dropPosition = _ref.dropPosition, dropLevelOffset = _ref.dropLevelOffset, indent = _ref.indent;
  var style2 = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: "".concat(2, "px")
  };
  switch (dropPosition) {
    case -1:
      style2.top = 0;
      style2.left = "".concat(-dropLevelOffset * indent, "px");
      break;
    case 1:
      style2.bottom = 0;
      style2.left = "".concat(-dropLevelOffset * indent, "px");
      break;
    case 0:
      style2.bottom = 0;
      style2.left = "".concat(indent);
      break;
  }
  return createVNode("div", {
    "style": style2
  }, null);
}
var MAX_RETRY_TIMES = 10;
var Tree$2 = defineComponent({
  name: "Tree",
  inheritAttrs: false,
  slots: ["checkable", "title", "icon", "titleRender"],
  props: initDefaultProps$1(treeProps$1(), {
    prefixCls: "vc-tree",
    showLine: false,
    showIcon: true,
    selectable: true,
    multiple: false,
    checkable: false,
    disabled: false,
    checkStrictly: false,
    draggable: false,
    defaultExpandParent: true,
    autoExpandParent: false,
    defaultExpandAll: false,
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    defaultSelectedKeys: [],
    dropIndicatorRender: DropIndicator,
    allowDrop: function allowDrop() {
      return true;
    }
  }),
  setup: function setup147(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose;
    var destroyed = ref(false);
    var delayedDragEnterLogic = {};
    var indent = ref();
    var selectedKeys = shallowRef([]);
    var checkedKeys = shallowRef([]);
    var halfCheckedKeys = shallowRef([]);
    var loadedKeys = shallowRef([]);
    var loadingKeys = shallowRef([]);
    var expandedKeys = shallowRef([]);
    var loadingRetryTimes = {};
    var dragState = reactive({
      draggingNodeKey: null,
      dragChildrenKeys: [],
      dropTargetKey: null,
      dropPosition: null,
      dropContainerKey: null,
      dropLevelOffset: null,
      dropTargetPos: null,
      dropAllowed: true,
      dragOverNodeKey: null
    });
    var treeData = shallowRef([]);
    watch([function() {
      return props2.treeData;
    }, function() {
      return props2.children;
    }], function() {
      treeData.value = props2.treeData !== void 0 ? toRaw(props2.treeData).slice() : convertTreeToData(toRaw(props2.children));
    }, {
      immediate: true,
      deep: true
    });
    var keyEntities = shallowRef({});
    var focused = ref(false);
    var activeKey = ref(null);
    var listChanging = ref(false);
    var fieldNames = computed(function() {
      return fillFieldNames$1(props2.fieldNames);
    });
    var listRef = ref();
    var dragStartMousePosition = null;
    var dragNode = null;
    var currentMouseOverDroppableNodeKey = null;
    var treeNodeRequiredProps = computed(function() {
      return {
        expandedKeysSet: expandedKeysSet.value,
        selectedKeysSet: selectedKeysSet.value,
        loadedKeysSet: loadedKeysSet.value,
        loadingKeysSet: loadingKeysSet.value,
        checkedKeysSet: checkedKeysSet.value,
        halfCheckedKeysSet: halfCheckedKeysSet.value,
        dragOverNodeKey: dragState.dragOverNodeKey,
        dropPosition: dragState.dropPosition,
        keyEntities: keyEntities.value
      };
    });
    var expandedKeysSet = computed(function() {
      return new Set(expandedKeys.value);
    });
    var selectedKeysSet = computed(function() {
      return new Set(selectedKeys.value);
    });
    var loadedKeysSet = computed(function() {
      return new Set(loadedKeys.value);
    });
    var loadingKeysSet = computed(function() {
      return new Set(loadingKeys.value);
    });
    var checkedKeysSet = computed(function() {
      return new Set(checkedKeys.value);
    });
    var halfCheckedKeysSet = computed(function() {
      return new Set(halfCheckedKeys.value);
    });
    watchEffect(function() {
      if (treeData.value) {
        var entitiesMap = convertDataToEntities(treeData.value, {
          fieldNames: fieldNames.value
        });
        keyEntities.value = _extends$2(_defineProperty$R({}, MOTION_KEY, MotionEntity), entitiesMap.keyEntities);
      }
    });
    var init = false;
    watch([function() {
      return props2.expandedKeys;
    }, function() {
      return props2.autoExpandParent;
    }, keyEntities], function(_ref2, _ref3) {
      var _ref4 = _slicedToArray$2(_ref2, 2);
      _ref4[0];
      var newAutoExpandParent = _ref4[1];
      var _ref5 = _slicedToArray$2(_ref3, 2);
      _ref5[0];
      var oldAutoExpandParent = _ref5[1];
      var keys2 = expandedKeys.value;
      if (props2.expandedKeys !== void 0 || init && newAutoExpandParent !== oldAutoExpandParent) {
        keys2 = props2.autoExpandParent || !init && props2.defaultExpandParent ? conductExpandParent(props2.expandedKeys, keyEntities.value) : props2.expandedKeys;
      } else if (!init && props2.defaultExpandAll) {
        var cloneKeyEntities = _extends$2({}, keyEntities.value);
        delete cloneKeyEntities[MOTION_KEY];
        keys2 = Object.keys(cloneKeyEntities).map(function(key2) {
          return cloneKeyEntities[key2].key;
        });
      } else if (!init && props2.defaultExpandedKeys) {
        keys2 = props2.autoExpandParent || props2.defaultExpandParent ? conductExpandParent(props2.defaultExpandedKeys, keyEntities.value) : props2.defaultExpandedKeys;
      }
      if (keys2) {
        expandedKeys.value = keys2;
      }
      init = true;
    }, {
      immediate: true
    });
    var flattenNodes = shallowRef([]);
    watchEffect(function() {
      flattenNodes.value = flattenTreeData(treeData.value, expandedKeys.value, fieldNames.value);
    });
    watchEffect(function() {
      if (props2.selectable) {
        if (props2.selectedKeys !== void 0) {
          selectedKeys.value = calcSelectedKeys(props2.selectedKeys, props2);
        } else if (!init && props2.defaultSelectedKeys) {
          selectedKeys.value = calcSelectedKeys(props2.defaultSelectedKeys, props2);
        }
      }
    });
    var _useMaxLevel = useMaxLevel(keyEntities), maxLevel = _useMaxLevel.maxLevel, levelEntities = _useMaxLevel.levelEntities;
    watchEffect(function() {
      if (props2.checkable) {
        var checkedKeyEntity;
        if (props2.checkedKeys !== void 0) {
          checkedKeyEntity = parseCheckedKeys(props2.checkedKeys) || {};
        } else if (!init && props2.defaultCheckedKeys) {
          checkedKeyEntity = parseCheckedKeys(props2.defaultCheckedKeys) || {};
        } else if (treeData.value) {
          checkedKeyEntity = parseCheckedKeys(props2.checkedKeys) || {
            checkedKeys: checkedKeys.value,
            halfCheckedKeys: halfCheckedKeys.value
          };
        }
        if (checkedKeyEntity) {
          var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, newCheckedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, newHalfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
          if (!props2.checkStrictly) {
            var conductKeys = conductCheck(newCheckedKeys, true, keyEntities.value, maxLevel.value, levelEntities.value);
            newCheckedKeys = conductKeys.checkedKeys;
            newHalfCheckedKeys = conductKeys.halfCheckedKeys;
          }
          checkedKeys.value = newCheckedKeys;
          halfCheckedKeys.value = newHalfCheckedKeys;
        }
      }
    });
    watchEffect(function() {
      if (props2.loadedKeys) {
        loadedKeys.value = props2.loadedKeys;
      }
    });
    var resetDragState = function resetDragState2() {
      _extends$2(dragState, {
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: false
      });
    };
    var scrollTo2 = function scrollTo3(scroll) {
      listRef.value.scrollTo(scroll);
    };
    watch(function() {
      return props2.activeKey;
    }, function() {
      if (props2.activeKey !== void 0) {
        activeKey.value = props2.activeKey;
      }
    }, {
      immediate: true
    });
    watch(activeKey, function(val) {
      nextTick(function() {
        if (val !== null) {
          scrollTo2({
            key: val
          });
        }
      });
    }, {
      immediate: true,
      flush: "post"
    });
    var setExpandedKeys = function setExpandedKeys2(keys2) {
      if (props2.expandedKeys === void 0) {
        expandedKeys.value = keys2;
      }
    };
    var cleanDragState = function cleanDragState2() {
      if (dragState.draggingNodeKey !== null) {
        _extends$2(dragState, {
          draggingNodeKey: null,
          dropPosition: null,
          dropContainerKey: null,
          dropTargetKey: null,
          dropLevelOffset: null,
          dropAllowed: true,
          dragOverNodeKey: null
        });
      }
      dragStartMousePosition = null;
      currentMouseOverDroppableNodeKey = null;
    };
    var onNodeDragEnd = function onNodeDragEnd2(event, node) {
      var onDragend = props2.onDragend;
      dragState.dragOverNodeKey = null;
      cleanDragState();
      onDragend === null || onDragend === void 0 ? void 0 : onDragend({
        event,
        node: node.eventData
      });
      dragNode = null;
    };
    var onWindowDragEnd = function onWindowDragEnd2(event) {
      onNodeDragEnd(event, null);
      window.removeEventListener("dragend", onWindowDragEnd2);
    };
    var onNodeDragStart = function onNodeDragStart2(event, node) {
      var onDragstart = props2.onDragstart;
      var eventKey = node.eventKey, eventData = node.eventData;
      dragNode = node;
      dragStartMousePosition = {
        x: event.clientX,
        y: event.clientY
      };
      var newExpandedKeys = arrDel(expandedKeys.value, eventKey);
      dragState.draggingNodeKey = eventKey;
      dragState.dragChildrenKeys = getDragChildrenKeys(eventKey, keyEntities.value);
      indent.value = listRef.value.getIndentWidth();
      setExpandedKeys(newExpandedKeys);
      window.addEventListener("dragend", onWindowDragEnd);
      if (onDragstart) {
        onDragstart({
          event,
          node: eventData
        });
      }
    };
    var onNodeDragEnter = function onNodeDragEnter2(event, node) {
      var onDragenter = props2.onDragenter, onExpand = props2.onExpand, allowDrop2 = props2.allowDrop, direction2 = props2.direction;
      var pos = node.pos, eventKey = node.eventKey;
      if (currentMouseOverDroppableNodeKey !== eventKey) {
        currentMouseOverDroppableNodeKey = eventKey;
      }
      if (!dragNode) {
        resetDragState();
        return;
      }
      var _calcDropPosition = calcDropPosition(event, dragNode, node, indent.value, dragStartMousePosition, allowDrop2, flattenNodes.value, keyEntities.value, expandedKeysSet.value, direction2), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
      if (dragState.dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) {
        resetDragState();
        return;
      }
      if (!delayedDragEnterLogic) {
        delayedDragEnterLogic = {};
      }
      Object.keys(delayedDragEnterLogic).forEach(function(key2) {
        clearTimeout(delayedDragEnterLogic[key2]);
      });
      if (dragNode.eventKey !== node.eventKey) {
        delayedDragEnterLogic[pos] = window.setTimeout(function() {
          if (dragState.draggingNodeKey === null)
            return;
          var newExpandedKeys = expandedKeys.value.slice();
          var entity = keyEntities.value[node.eventKey];
          if (entity && (entity.children || []).length) {
            newExpandedKeys = arrAdd(expandedKeys.value, node.eventKey);
          }
          setExpandedKeys(newExpandedKeys);
          if (onExpand) {
            onExpand(newExpandedKeys, {
              node: node.eventData,
              expanded: true,
              nativeEvent: event
            });
          }
        }, 800);
      }
      if (dragNode.eventKey === dropTargetKey && dropLevelOffset === 0) {
        resetDragState();
        return;
      }
      _extends$2(dragState, {
        dragOverNodeKey,
        dropPosition,
        dropLevelOffset,
        dropTargetKey,
        dropContainerKey,
        dropTargetPos,
        dropAllowed
      });
      if (onDragenter) {
        onDragenter({
          event,
          node: node.eventData,
          expandedKeys: expandedKeys.value
        });
      }
    };
    var onNodeDragOver = function onNodeDragOver2(event, node) {
      var onDragover = props2.onDragover, allowDrop2 = props2.allowDrop, direction2 = props2.direction;
      if (!dragNode) {
        return;
      }
      var _calcDropPosition2 = calcDropPosition(event, dragNode, node, indent.value, dragStartMousePosition, allowDrop2, flattenNodes.value, keyEntities.value, expandedKeysSet.value, direction2), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropAllowed = _calcDropPosition2.dropAllowed, dropTargetPos = _calcDropPosition2.dropTargetPos, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
      if (dragState.dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) {
        return;
      }
      if (dragNode.eventKey === dropTargetKey && dropLevelOffset === 0) {
        if (!(dragState.dropPosition === null && dragState.dropLevelOffset === null && dragState.dropTargetKey === null && dragState.dropContainerKey === null && dragState.dropTargetPos === null && dragState.dropAllowed === false && dragState.dragOverNodeKey === null)) {
          resetDragState();
        }
      } else if (!(dropPosition === dragState.dropPosition && dropLevelOffset === dragState.dropLevelOffset && dropTargetKey === dragState.dropTargetKey && dropContainerKey === dragState.dropContainerKey && dropTargetPos === dragState.dropTargetPos && dropAllowed === dragState.dropAllowed && dragOverNodeKey === dragState.dragOverNodeKey)) {
        _extends$2(dragState, {
          dropPosition,
          dropLevelOffset,
          dropTargetKey,
          dropContainerKey,
          dropTargetPos,
          dropAllowed,
          dragOverNodeKey
        });
      }
      if (onDragover) {
        onDragover({
          event,
          node: node.eventData
        });
      }
    };
    var onNodeDragLeave = function onNodeDragLeave2(event, node) {
      if (currentMouseOverDroppableNodeKey === node.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
        resetDragState();
        currentMouseOverDroppableNodeKey = null;
      }
      var onDragleave = props2.onDragleave;
      if (onDragleave) {
        onDragleave({
          event,
          node: node.eventData
        });
      }
    };
    var onNodeDrop = function onNodeDrop2(event, _node) {
      var outsideTree = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var _a2;
      var dragChildrenKeys = dragState.dragChildrenKeys, dropPosition = dragState.dropPosition, dropTargetKey = dragState.dropTargetKey, dropTargetPos = dragState.dropTargetPos, dropAllowed = dragState.dropAllowed;
      if (!dropAllowed)
        return;
      var onDrop = props2.onDrop;
      dragState.dragOverNodeKey = null;
      cleanDragState();
      if (dropTargetKey === null)
        return;
      var abstractDropNodeProps = _extends$2(_extends$2({}, getTreeNodeProps(dropTargetKey, toRaw(treeNodeRequiredProps.value))), {
        active: ((_a2 = activeItem.value) === null || _a2 === void 0 ? void 0 : _a2.key) === dropTargetKey,
        data: keyEntities.value[dropTargetKey].node
      });
      dragChildrenKeys.indexOf(dropTargetKey) !== -1;
      var posArr = posToArr(dropTargetPos);
      var dropResult = {
        event,
        node: convertNodePropsToEventData(abstractDropNodeProps),
        dragNode: dragNode ? dragNode.eventData : null,
        dragNodesKeys: [dragNode.eventKey].concat(dragChildrenKeys),
        dropToGap: dropPosition !== 0,
        dropPosition: dropPosition + Number(posArr[posArr.length - 1])
      };
      if (!outsideTree) {
        onDrop === null || onDrop === void 0 ? void 0 : onDrop(dropResult);
      }
      dragNode = null;
    };
    var onNodeClick = function onNodeClick2(e2, treeNode) {
      var onClick2 = props2.onClick;
      if (onClick2) {
        onClick2(e2, treeNode);
      }
    };
    var onNodeDoubleClick = function onNodeDoubleClick2(e2, treeNode) {
      var onDblclick = props2.onDblclick;
      if (onDblclick) {
        onDblclick(e2, treeNode);
      }
    };
    var onNodeSelect = function onNodeSelect2(e2, treeNode) {
      var newSelectedKeys = selectedKeys.value;
      var onSelect = props2.onSelect, multiple = props2.multiple;
      var selected = treeNode.selected;
      var key2 = treeNode[fieldNames.value.key];
      var targetSelected = !selected;
      if (!targetSelected) {
        newSelectedKeys = arrDel(newSelectedKeys, key2);
      } else if (!multiple) {
        newSelectedKeys = [key2];
      } else {
        newSelectedKeys = arrAdd(newSelectedKeys, key2);
      }
      var keyEntitiesValue = keyEntities.value;
      var selectedNodes = newSelectedKeys.map(function(selectedKey) {
        var entity = keyEntitiesValue[selectedKey];
        if (!entity)
          return null;
        return entity.node;
      }).filter(function(node) {
        return node;
      });
      if (props2.selectedKeys === void 0) {
        selectedKeys.value = newSelectedKeys;
      }
      if (onSelect) {
        onSelect(newSelectedKeys, {
          event: "select",
          selected: targetSelected,
          node: treeNode,
          selectedNodes,
          nativeEvent: e2
        });
      }
    };
    var onNodeCheck = function onNodeCheck2(e2, treeNode, checked) {
      var checkStrictly = props2.checkStrictly, onCheck = props2.onCheck;
      var key2 = treeNode[fieldNames.value.key];
      var checkedObj;
      var eventObj = {
        event: "check",
        node: treeNode,
        checked,
        nativeEvent: e2
      };
      var keyEntitiesValue = keyEntities.value;
      if (checkStrictly) {
        var newCheckedKeys = checked ? arrAdd(checkedKeys.value, key2) : arrDel(checkedKeys.value, key2);
        var newHalfCheckedKeys = arrDel(halfCheckedKeys.value, key2);
        checkedObj = {
          checked: newCheckedKeys,
          halfChecked: newHalfCheckedKeys
        };
        eventObj.checkedNodes = newCheckedKeys.map(function(checkedKey) {
          return keyEntitiesValue[checkedKey];
        }).filter(function(entity) {
          return entity;
        }).map(function(entity) {
          return entity.node;
        });
        if (props2.checkedKeys === void 0) {
          checkedKeys.value = newCheckedKeys;
        }
      } else {
        var _conductCheck = conductCheck([].concat(_toConsumableArray(checkedKeys.value), [key2]), true, keyEntitiesValue, maxLevel.value, levelEntities.value), _newCheckedKeys = _conductCheck.checkedKeys, _newHalfCheckedKeys = _conductCheck.halfCheckedKeys;
        if (!checked) {
          var keySet = new Set(_newCheckedKeys);
          keySet.delete(key2);
          var _conductCheck2 = conductCheck(Array.from(keySet), {
            checked: false,
            halfCheckedKeys: _newHalfCheckedKeys
          }, keyEntitiesValue, maxLevel.value, levelEntities.value);
          _newCheckedKeys = _conductCheck2.checkedKeys;
          _newHalfCheckedKeys = _conductCheck2.halfCheckedKeys;
        }
        checkedObj = _newCheckedKeys;
        eventObj.checkedNodes = [];
        eventObj.checkedNodesPositions = [];
        eventObj.halfCheckedKeys = _newHalfCheckedKeys;
        _newCheckedKeys.forEach(function(checkedKey) {
          var entity = keyEntitiesValue[checkedKey];
          if (!entity)
            return;
          var node = entity.node, pos = entity.pos;
          eventObj.checkedNodes.push(node);
          eventObj.checkedNodesPositions.push({
            node,
            pos
          });
        });
        if (props2.checkedKeys === void 0) {
          checkedKeys.value = _newCheckedKeys;
          halfCheckedKeys.value = _newHalfCheckedKeys;
        }
      }
      if (onCheck) {
        onCheck(checkedObj, eventObj);
      }
    };
    var onNodeLoad = function onNodeLoad2(treeNode) {
      var key2 = treeNode[fieldNames.value.key];
      var loadPromise = new Promise(function(resolve, reject) {
        var loadData = props2.loadData, onLoad = props2.onLoad;
        if (!loadData || loadedKeysSet.value.has(key2) || loadingKeysSet.value.has(key2)) {
          return null;
        }
        var promise = loadData(treeNode);
        promise.then(function() {
          var newLoadedKeys = arrAdd(loadedKeys.value, key2);
          var newLoadingKeys = arrDel(loadingKeys.value, key2);
          if (onLoad) {
            onLoad(newLoadedKeys, {
              event: "load",
              node: treeNode
            });
          }
          if (props2.loadedKeys === void 0) {
            loadedKeys.value = newLoadedKeys;
          }
          loadingKeys.value = newLoadingKeys;
          resolve();
        }).catch(function(e2) {
          var newLoadingKeys = arrDel(loadingKeys.value, key2);
          loadingKeys.value = newLoadingKeys;
          loadingRetryTimes[key2] = (loadingRetryTimes[key2] || 0) + 1;
          if (loadingRetryTimes[key2] >= MAX_RETRY_TIMES) {
            var newLoadedKeys = arrAdd(loadedKeys.value, key2);
            if (props2.loadedKeys === void 0) {
              loadedKeys.value = newLoadedKeys;
            }
            resolve();
          }
          reject(e2);
        });
        loadingKeys.value = arrAdd(loadingKeys.value, key2);
      });
      loadPromise.catch(function() {
      });
      return loadPromise;
    };
    var onNodeMouseEnter = function onNodeMouseEnter2(event, node) {
      var onMouseenter2 = props2.onMouseenter;
      if (onMouseenter2) {
        onMouseenter2({
          event,
          node
        });
      }
    };
    var onNodeMouseLeave = function onNodeMouseLeave2(event, node) {
      var onMouseleave2 = props2.onMouseleave;
      if (onMouseleave2) {
        onMouseleave2({
          event,
          node
        });
      }
    };
    var onNodeContextMenu = function onNodeContextMenu2(event, node) {
      var onRightClick = props2.onRightClick;
      if (onRightClick) {
        event.preventDefault();
        onRightClick({
          event,
          node
        });
      }
    };
    var onFocus2 = function onFocus3(e2) {
      var onFocus4 = props2.onFocus;
      focused.value = true;
      if (onFocus4) {
        onFocus4(e2);
      }
    };
    var onBlur2 = function onBlur3(e2) {
      var onBlur4 = props2.onBlur;
      focused.value = false;
      onActiveChange(null);
      if (onBlur4) {
        onBlur4(e2);
      }
    };
    var onNodeExpand = function onNodeExpand2(e2, treeNode) {
      var newExpandedKeys = expandedKeys.value;
      var onExpand = props2.onExpand, loadData = props2.loadData;
      var expanded = treeNode.expanded;
      var key2 = treeNode[fieldNames.value.key];
      if (listChanging.value) {
        return;
      }
      newExpandedKeys.indexOf(key2);
      var targetExpanded = !expanded;
      if (targetExpanded) {
        newExpandedKeys = arrAdd(newExpandedKeys, key2);
      } else {
        newExpandedKeys = arrDel(newExpandedKeys, key2);
      }
      setExpandedKeys(newExpandedKeys);
      if (onExpand) {
        onExpand(newExpandedKeys, {
          node: treeNode,
          expanded: targetExpanded,
          nativeEvent: e2
        });
      }
      if (targetExpanded && loadData) {
        var loadPromise = onNodeLoad(treeNode);
        if (loadPromise) {
          loadPromise.then(function() {
          }).catch(function(e3) {
            var expandedKeysToRestore = arrDel(expandedKeys.value, key2);
            setExpandedKeys(expandedKeysToRestore);
            Promise.reject(e3);
          });
        }
      }
    };
    var onListChangeStart = function onListChangeStart2() {
      listChanging.value = true;
    };
    var onListChangeEnd = function onListChangeEnd2() {
      setTimeout(function() {
        listChanging.value = false;
      });
    };
    var onActiveChange = function onActiveChange2(newActiveKey) {
      var onActiveChange3 = props2.onActiveChange;
      if (activeKey.value === newActiveKey) {
        return;
      }
      if (props2.activeKey !== void 0) {
        activeKey.value = newActiveKey;
      }
      if (newActiveKey !== null) {
        scrollTo2({
          key: newActiveKey
        });
      }
      if (onActiveChange3) {
        onActiveChange3(newActiveKey);
      }
    };
    var activeItem = computed(function() {
      if (activeKey.value === null) {
        return null;
      }
      return flattenNodes.value.find(function(_ref6) {
        var key2 = _ref6.key;
        return key2 === activeKey.value;
      }) || null;
    });
    var offsetActiveKey = function offsetActiveKey2(offset3) {
      var index2 = flattenNodes.value.findIndex(function(_ref7) {
        var key3 = _ref7.key;
        return key3 === activeKey.value;
      });
      if (index2 === -1 && offset3 < 0) {
        index2 = flattenNodes.value.length;
      }
      index2 = (index2 + offset3 + flattenNodes.value.length) % flattenNodes.value.length;
      var item = flattenNodes.value[index2];
      if (item) {
        var key2 = item.key;
        onActiveChange(key2);
      } else {
        onActiveChange(null);
      }
    };
    var activeItemEventNode = computed(function() {
      return convertNodePropsToEventData(_extends$2(_extends$2({}, getTreeNodeProps(activeKey.value, treeNodeRequiredProps.value)), {
        data: activeItem.value.data,
        active: true
      }));
    });
    var onKeydown = function onKeydown2(event) {
      var onKeydown3 = props2.onKeydown, checkable = props2.checkable, selectable = props2.selectable;
      switch (event.which) {
        case KeyCode$1.UP: {
          offsetActiveKey(-1);
          event.preventDefault();
          break;
        }
        case KeyCode$1.DOWN: {
          offsetActiveKey(1);
          event.preventDefault();
          break;
        }
      }
      var item = activeItem.value;
      if (item && item.data) {
        var expandable = item.data.isLeaf === false || !!(item.data.children || []).length;
        var eventNode = activeItemEventNode.value;
        switch (event.which) {
          case KeyCode$1.LEFT: {
            if (expandable && expandedKeysSet.value.has(activeKey.value)) {
              onNodeExpand({}, eventNode);
            } else if (item.parent) {
              onActiveChange(item.parent.key);
            }
            event.preventDefault();
            break;
          }
          case KeyCode$1.RIGHT: {
            if (expandable && !expandedKeysSet.value.has(activeKey.value)) {
              onNodeExpand({}, eventNode);
            } else if (item.children && item.children.length) {
              onActiveChange(item.children[0].key);
            }
            event.preventDefault();
            break;
          }
          case KeyCode$1.ENTER:
          case KeyCode$1.SPACE: {
            if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) {
              onNodeCheck({}, eventNode, !checkedKeysSet.value.has(activeKey.value));
            } else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) {
              onNodeSelect({}, eventNode);
            }
            break;
          }
        }
      }
      if (onKeydown3) {
        onKeydown3(event);
      }
    };
    expose({
      onNodeExpand,
      scrollTo: scrollTo2,
      onKeydown,
      selectedKeys: computed(function() {
        return selectedKeys.value;
      }),
      checkedKeys: computed(function() {
        return checkedKeys.value;
      }),
      halfCheckedKeys: computed(function() {
        return halfCheckedKeys.value;
      }),
      loadedKeys: computed(function() {
        return loadedKeys.value;
      }),
      loadingKeys: computed(function() {
        return loadingKeys.value;
      }),
      expandedKeys: computed(function() {
        return expandedKeys.value;
      })
    });
    onUnmounted(function() {
      window.removeEventListener("dragend", onWindowDragEnd);
      destroyed.value = true;
    });
    useProvideKeysState({
      expandedKeys,
      selectedKeys,
      loadedKeys,
      loadingKeys,
      checkedKeys,
      halfCheckedKeys,
      expandedKeysSet,
      selectedKeysSet,
      loadedKeysSet,
      loadingKeysSet,
      checkedKeysSet,
      halfCheckedKeysSet,
      flattenNodes
    });
    return function() {
      var _classNames;
      var draggingNodeKey = dragState.draggingNodeKey, dropLevelOffset = dragState.dropLevelOffset, dropContainerKey = dragState.dropContainerKey, dropTargetKey = dragState.dropTargetKey, dropPosition = dragState.dropPosition, dragOverNodeKey = dragState.dragOverNodeKey;
      var prefixCls2 = props2.prefixCls, showLine = props2.showLine, focusable = props2.focusable, _props$tabindex = props2.tabindex, tabindex = _props$tabindex === void 0 ? 0 : _props$tabindex, selectable = props2.selectable, showIcon = props2.showIcon, _props$icon = props2.icon, icon = _props$icon === void 0 ? slots.icon : _props$icon, switcherIcon = props2.switcherIcon, draggable2 = props2.draggable, checkable = props2.checkable, checkStrictly = props2.checkStrictly, disabled = props2.disabled, motion = props2.motion, loadData = props2.loadData, filterTreeNode = props2.filterTreeNode, height = props2.height, itemHeight = props2.itemHeight, virtual = props2.virtual, dropIndicatorRender2 = props2.dropIndicatorRender, onContextmenu2 = props2.onContextmenu, onScroll = props2.onScroll, direction2 = props2.direction;
      var className = attrs.class, style2 = attrs.style;
      var domProps = pickAttrs(_extends$2(_extends$2({}, props2), attrs), {
        aria: true,
        data: true
      });
      var draggableConfig;
      if (draggable2) {
        if (_typeof$2(draggable2) === "object") {
          draggableConfig = draggable2;
        } else if (typeof draggable2 === "function") {
          draggableConfig = {
            nodeDraggable: draggable2
          };
        } else {
          draggableConfig = {};
        }
      }
      return createVNode(TreeContext, {
        "value": {
          prefixCls: prefixCls2,
          selectable,
          showIcon,
          icon,
          switcherIcon,
          draggable: draggableConfig,
          draggingNodeKey,
          checkable,
          customCheckable: slots.checkable,
          checkStrictly,
          disabled,
          keyEntities: keyEntities.value,
          dropLevelOffset,
          dropContainerKey,
          dropTargetKey,
          dropPosition,
          dragOverNodeKey,
          dragging: draggingNodeKey !== null,
          indent: indent.value,
          direction: direction2,
          dropIndicatorRender: dropIndicatorRender2,
          loadData,
          filterTreeNode,
          onNodeClick,
          onNodeDoubleClick,
          onNodeExpand,
          onNodeSelect,
          onNodeCheck,
          onNodeLoad,
          onNodeMouseEnter,
          onNodeMouseLeave,
          onNodeContextMenu,
          onNodeDragStart,
          onNodeDragEnter,
          onNodeDragOver,
          onNodeDragLeave,
          onNodeDragEnd,
          onNodeDrop,
          slots
        }
      }, {
        default: function _default7() {
          return [createVNode("div", {
            "role": "tree",
            "class": classNames(prefixCls2, className, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2, "-show-line"), showLine), _defineProperty$R(_classNames, "".concat(prefixCls2, "-focused"), focused.value), _defineProperty$R(_classNames, "".concat(prefixCls2, "-active-focused"), activeKey.value !== null), _classNames))
          }, [createVNode(NodeList, _objectSpread2$2({
            "ref": listRef,
            "prefixCls": prefixCls2,
            "style": style2,
            "disabled": disabled,
            "selectable": selectable,
            "checkable": !!checkable,
            "motion": motion,
            "height": height,
            "itemHeight": itemHeight,
            "virtual": virtual,
            "focusable": focusable,
            "focused": focused.value,
            "tabindex": tabindex,
            "activeItem": activeItem.value,
            "onFocus": onFocus2,
            "onBlur": onBlur2,
            "onKeydown": onKeydown,
            "onActiveChange": onActiveChange,
            "onListChangeStart": onListChangeStart,
            "onListChangeEnd": onListChangeEnd,
            "onContextmenu": onContextmenu2,
            "onScroll": onScroll
          }, domProps), null)])];
        }
      });
    };
  }
});
function renderSwitcherIcon(prefixCls2, switcherIcon, showLine, props2) {
  var isLeaf2 = props2.isLeaf, expanded = props2.expanded, loading = props2.loading;
  var icon = switcherIcon;
  if (loading) {
    return createVNode(LoadingOutlined$1, {
      "class": "".concat(prefixCls2, "-switcher-loading-icon")
    }, null);
  }
  var showLeafIcon;
  if (showLine && _typeof$2(showLine) === "object") {
    showLeafIcon = showLine.showLeafIcon;
  }
  var defaultIcon = null;
  var switcherCls = "".concat(prefixCls2, "-switcher-icon");
  if (isLeaf2) {
    if (showLine) {
      if (_typeof$2(showLine) === "object" && !showLeafIcon) {
        defaultIcon = createVNode("span", {
          "class": "".concat(prefixCls2, "-switcher-leaf-line")
        }, null);
      } else {
        defaultIcon = createVNode(FileOutlined$1, {
          "class": "".concat(prefixCls2, "-switcher-line-icon")
        }, null);
      }
    }
    return defaultIcon;
  } else {
    defaultIcon = createVNode(CaretDownFilled$1, {
      "class": switcherCls
    }, null);
    if (showLine) {
      defaultIcon = expanded ? createVNode(MinusSquareOutlined$1, {
        "class": "".concat(prefixCls2, "-switcher-line-icon")
      }, null) : createVNode(PlusSquareOutlined$1, {
        "class": "".concat(prefixCls2, "-switcher-line-icon")
      }, null);
    }
  }
  if (typeof switcherIcon === "function") {
    icon = switcherIcon(_extends$2(_extends$2({}, props2), {
      defaultIcon,
      switcherCls
    }));
  } else if (isValidElement(icon)) {
    icon = cloneVNode(icon, {
      class: switcherCls
    });
  }
  return icon || defaultIcon;
}
var offset2 = 4;
function dropIndicatorRender(props2) {
  var _style;
  var dropPosition = props2.dropPosition, dropLevelOffset = props2.dropLevelOffset, prefixCls2 = props2.prefixCls, indent = props2.indent, _props$direction = props2.direction, direction2 = _props$direction === void 0 ? "ltr" : _props$direction;
  var startPosition = direction2 === "ltr" ? "left" : "right";
  var endPosition = direction2 === "ltr" ? "right" : "left";
  var style2 = (_style = {}, _defineProperty$R(_style, startPosition, "".concat(-dropLevelOffset * indent + offset2, "px")), _defineProperty$R(_style, endPosition, 0), _style);
  switch (dropPosition) {
    case -1:
      style2.top = "".concat(-3, "px");
      break;
    case 1:
      style2.bottom = "".concat(-3, "px");
      break;
    default:
      style2.bottom = "".concat(-3, "px");
      style2[startPosition] = "".concat(indent + offset2, "px");
      break;
  }
  return createVNode("div", {
    "style": style2,
    "class": "".concat(prefixCls2, "-drop-indicator")
  }, null);
}
var treeProps2 = function treeProps3() {
  var baseTreeProps = treeProps$1();
  return _extends$2(_extends$2({}, baseTreeProps), {
    showLine: {
      type: [Boolean, Object],
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    autoExpandParent: {
      type: Boolean,
      default: void 0
    },
    checkStrictly: {
      type: Boolean,
      default: void 0
    },
    checkable: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    defaultExpandAll: {
      type: Boolean,
      default: void 0
    },
    defaultExpandParent: {
      type: Boolean,
      default: void 0
    },
    defaultExpandedKeys: {
      type: Array
    },
    expandedKeys: {
      type: Array
    },
    checkedKeys: {
      type: [Array, Object]
    },
    defaultCheckedKeys: {
      type: Array
    },
    selectedKeys: {
      type: Array
    },
    defaultSelectedKeys: {
      type: Array
    },
    selectable: {
      type: Boolean,
      default: void 0
    },
    loadedKeys: {
      type: Array
    },
    draggable: {
      type: Boolean,
      default: void 0
    },
    showIcon: {
      type: Boolean,
      default: void 0
    },
    icon: {
      type: Function
    },
    switcherIcon: PropTypes$1.any,
    prefixCls: String,
    replaceFields: {
      type: Object
    },
    blockNode: {
      type: Boolean,
      default: void 0
    },
    openAnimation: PropTypes$1.any,
    onDoubleclick: baseTreeProps.onDblclick,
    "onUpdate:selectedKeys": Function,
    "onUpdate:checkedKeys": Function,
    "onUpdate:expandedKeys": Function
  });
};
var Tree$1 = defineComponent({
  name: "ATree",
  inheritAttrs: false,
  props: initDefaultProps$1(treeProps2(), {
    checkable: false,
    selectable: true,
    showIcon: false,
    blockNode: false
  }),
  slots: ["icon", "title", "switcherIcon", "titleRender"],
  setup: function setup148(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, emit = _ref.emit, slots = _ref.slots;
    warning$3(!(props2.treeData === void 0 && slots.default));
    var _useConfigInject = useConfigInject("tree", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction, virtual = _useConfigInject.virtual;
    var treeRef = ref();
    expose({
      treeRef,
      onNodeExpand: function onNodeExpand() {
        var _a2;
        var _a3;
        (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : (_a2 = _a3).onNodeExpand.apply(_a2, arguments);
      },
      selectedKeys: computed(function() {
        var _a2;
        return (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.selectedKeys;
      }),
      checkedKeys: computed(function() {
        var _a2;
        return (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.checkedKeys;
      }),
      halfCheckedKeys: computed(function() {
        var _a2;
        return (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.halfCheckedKeys;
      }),
      loadedKeys: computed(function() {
        var _a2;
        return (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.loadedKeys;
      }),
      loadingKeys: computed(function() {
        var _a2;
        return (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.loadingKeys;
      }),
      expandedKeys: computed(function() {
        var _a2;
        return (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.expandedKeys;
      })
    });
    watchEffect(function() {
      devWarning(props2.replaceFields === void 0, "Tree", "`replaceFields` is deprecated, please use fieldNames instead");
    });
    var handleCheck = function handleCheck2(checkedObjOrKeys, eventObj) {
      emit("update:checkedKeys", checkedObjOrKeys);
      emit("check", checkedObjOrKeys, eventObj);
    };
    var handleExpand = function handleExpand2(expandedKeys, eventObj) {
      emit("update:expandedKeys", expandedKeys);
      emit("expand", expandedKeys, eventObj);
    };
    var handleSelect = function handleSelect2(selectedKeys, eventObj) {
      emit("update:selectedKeys", selectedKeys);
      emit("select", selectedKeys, eventObj);
    };
    return function() {
      var _classNames;
      var showIcon = props2.showIcon, showLine = props2.showLine, _props$switcherIcon = props2.switcherIcon, _switcherIcon = _props$switcherIcon === void 0 ? slots.switcherIcon : _props$switcherIcon, _props$icon = props2.icon, icon = _props$icon === void 0 ? slots.icon : _props$icon, blockNode = props2.blockNode, checkable = props2.checkable, selectable = props2.selectable, _props$fieldNames = props2.fieldNames, fieldNames = _props$fieldNames === void 0 ? props2.replaceFields : _props$fieldNames, _props$motion = props2.motion, motion = _props$motion === void 0 ? props2.openAnimation : _props$motion, _props$itemHeight = props2.itemHeight, itemHeight = _props$itemHeight === void 0 ? 28 : _props$itemHeight, onDoubleclick = props2.onDoubleclick, onDblclick = props2.onDblclick;
      var newProps = _extends$2(_extends$2(_extends$2({}, attrs), omit$3(props2, ["onUpdate:checkedKeys", "onUpdate:expandedKeys", "onUpdate:selectedKeys", "onDoubleclick"])), {
        showLine: Boolean(showLine),
        dropIndicatorRender,
        fieldNames,
        icon,
        itemHeight
      });
      var children = slots.default ? filterEmpty(slots.default()) : void 0;
      return createVNode(Tree$2, _objectSpread2$2(_objectSpread2$2({}, newProps), {}, {
        "virtual": virtual.value,
        "motion": motion,
        "ref": treeRef,
        "prefixCls": prefixCls2.value,
        "class": classNames((_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-icon-hide"), !showIcon), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-block-node"), blockNode), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-unselectable"), !selectable), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _classNames), attrs.class),
        "direction": direction2.value,
        "checkable": checkable,
        "selectable": selectable,
        "switcherIcon": function switcherIcon(nodeProps) {
          return renderSwitcherIcon(prefixCls2.value, _switcherIcon, showLine, nodeProps);
        },
        "onCheck": handleCheck,
        "onExpand": handleExpand,
        "onSelect": handleSelect,
        "onDblclick": onDblclick || onDoubleclick,
        "children": children
      }), _extends$2(_extends$2({}, slots), {
        checkable: function checkable2() {
          return createVNode("span", {
            "class": "".concat(prefixCls2.value, "-checkbox-inner")
          }, null);
        }
      }));
    };
  }
});
var Record;
(function(Record2) {
  Record2[Record2["None"] = 0] = "None";
  Record2[Record2["Start"] = 1] = "Start";
  Record2[Record2["End"] = 2] = "End";
})(Record || (Record = {}));
function traverseNodesKey(treeData, fieldNames, callback) {
  function processNode(dataNode) {
    var key2 = dataNode[fieldNames.key];
    var children = dataNode[fieldNames.children];
    if (callback(key2, dataNode) !== false) {
      traverseNodesKey(children || [], fieldNames, callback);
    }
  }
  treeData.forEach(processNode);
}
function calcRangeKeys(_ref) {
  var treeData = _ref.treeData, expandedKeys = _ref.expandedKeys, startKey = _ref.startKey, endKey = _ref.endKey, _ref$fieldNames = _ref.fieldNames, fieldNames = _ref$fieldNames === void 0 ? {
    title: "title",
    key: "key",
    children: "children"
  } : _ref$fieldNames;
  var keys2 = [];
  var record = Record.None;
  if (startKey && startKey === endKey) {
    return [startKey];
  }
  if (!startKey || !endKey) {
    return [];
  }
  function matchKey(key2) {
    return key2 === startKey || key2 === endKey;
  }
  traverseNodesKey(treeData, fieldNames, function(key2) {
    if (record === Record.End) {
      return false;
    }
    if (matchKey(key2)) {
      keys2.push(key2);
      if (record === Record.None) {
        record = Record.Start;
      } else if (record === Record.Start) {
        record = Record.End;
        return false;
      }
    } else if (record === Record.Start) {
      keys2.push(key2);
    }
    if (expandedKeys.indexOf(key2) === -1) {
      return false;
    }
    return true;
  });
  return keys2;
}
function convertDirectoryKeysToNodes(treeData, keys2, fieldNames) {
  var restKeys = _toConsumableArray(keys2);
  var nodes = [];
  traverseNodesKey(treeData, fieldNames, function(key2, node) {
    var index2 = restKeys.indexOf(key2);
    if (index2 !== -1) {
      nodes.push(node);
      restKeys.splice(index2, 1);
    }
    return !!restKeys.length;
  });
  return nodes;
}
var __rest$4 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var directoryTreeProps = function directoryTreeProps2() {
  return _extends$2(_extends$2({}, treeProps2()), {
    expandAction: {
      type: [Boolean, String]
    }
  });
};
function getIcon$1(props2) {
  var isLeaf2 = props2.isLeaf, expanded = props2.expanded;
  if (isLeaf2) {
    return createVNode(FileOutlined$1, null, null);
  }
  return expanded ? createVNode(FolderOpenOutlined$1, null, null) : createVNode(FolderOutlined$1, null, null);
}
var DirectoryTree = defineComponent({
  name: "ADirectoryTree",
  inheritAttrs: false,
  props: initDefaultProps$1(directoryTreeProps(), {
    showIcon: true,
    expandAction: "click"
  }),
  slots: ["icon", "title", "switcherIcon", "titleRender"],
  setup: function setup149(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    var _a2;
    var treeData = ref(props2.treeData || convertTreeToData(filterEmpty((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots))));
    watch(function() {
      return props2.treeData;
    }, function() {
      treeData.value = props2.treeData;
    });
    onUpdated(function() {
      nextTick(function() {
        var _a3;
        if (props2.treeData === void 0 && slots.default) {
          treeData.value = convertTreeToData(filterEmpty((_a3 = slots.default) === null || _a3 === void 0 ? void 0 : _a3.call(slots)));
        }
      });
    });
    var lastSelectedKey = ref();
    var cachedSelectedKeys = ref();
    var treeRef = ref();
    expose({
      selectedKeys: computed(function() {
        var _a3;
        return (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : _a3.selectedKeys;
      }),
      checkedKeys: computed(function() {
        var _a3;
        return (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : _a3.checkedKeys;
      }),
      halfCheckedKeys: computed(function() {
        var _a3;
        return (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : _a3.halfCheckedKeys;
      }),
      loadedKeys: computed(function() {
        var _a3;
        return (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : _a3.loadedKeys;
      }),
      loadingKeys: computed(function() {
        var _a3;
        return (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : _a3.loadingKeys;
      }),
      expandedKeys: computed(function() {
        var _a3;
        return (_a3 = treeRef.value) === null || _a3 === void 0 ? void 0 : _a3.expandedKeys;
      })
    });
    var getInitExpandedKeys = function getInitExpandedKeys2() {
      var _convertDataToEntitie = convertDataToEntities(treeData.value), keyEntities = _convertDataToEntitie.keyEntities;
      var initExpandedKeys;
      if (props2.defaultExpandAll) {
        initExpandedKeys = Object.keys(keyEntities);
      } else if (props2.defaultExpandParent) {
        initExpandedKeys = conductExpandParent(props2.expandedKeys || props2.defaultExpandedKeys || [], keyEntities);
      } else {
        initExpandedKeys = props2.expandedKeys || props2.defaultExpandedKeys;
      }
      return initExpandedKeys;
    };
    var selectedKeys = ref(props2.selectedKeys || props2.defaultSelectedKeys || []);
    var expandedKeys = ref(getInitExpandedKeys());
    watch(function() {
      return props2.selectedKeys;
    }, function() {
      if (props2.selectedKeys !== void 0) {
        selectedKeys.value = props2.selectedKeys;
      }
    }, {
      immediate: true
    });
    watch(function() {
      return props2.expandedKeys;
    }, function() {
      if (props2.expandedKeys !== void 0) {
        expandedKeys.value = props2.expandedKeys;
      }
    }, {
      immediate: true
    });
    var expandFolderNode = function expandFolderNode2(event, node) {
      var isLeaf2 = node.isLeaf;
      if (isLeaf2 || event.shiftKey || event.metaKey || event.ctrlKey) {
        return;
      }
      treeRef.value.onNodeExpand(event, node);
    };
    var onDebounceExpand = debounce$1(expandFolderNode, 200, {
      leading: true
    });
    var onExpand = function onExpand2(keys2, info) {
      if (props2.expandedKeys === void 0) {
        expandedKeys.value = keys2;
      }
      emit("update:expandedKeys", keys2);
      emit("expand", keys2, info);
    };
    var onClick2 = function onClick3(event, node) {
      var expandAction = props2.expandAction;
      if (expandAction === "click") {
        onDebounceExpand(event, node);
      }
      emit("click", event, node);
    };
    var onDoubleClick = function onDoubleClick2(event, node) {
      var expandAction = props2.expandAction;
      if (expandAction === "dblclick" || expandAction === "doubleclick") {
        onDebounceExpand(event, node);
      }
      emit("doubleclick", event, node);
      emit("dblclick", event, node);
    };
    var fieldNames = computed(function() {
      return fillFieldNames$1(props2.fieldNames);
    });
    var onSelect = function onSelect2(keys2, event) {
      var multiple = props2.multiple;
      var node = event.node, nativeEvent = event.nativeEvent;
      var key2 = node[fieldNames.value.key];
      var newEvent = _extends$2(_extends$2({}, event), {
        selected: true
      });
      var ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
      var shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
      var newSelectedKeys;
      if (multiple && ctrlPick) {
        newSelectedKeys = keys2;
        lastSelectedKey.value = key2;
        cachedSelectedKeys.value = newSelectedKeys;
        newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData.value, newSelectedKeys, fieldNames.value);
      } else if (multiple && shiftPick) {
        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(cachedSelectedKeys.value || []), _toConsumableArray(calcRangeKeys({
          treeData: treeData.value,
          expandedKeys: expandedKeys.value,
          startKey: key2,
          endKey: lastSelectedKey.value,
          fieldNames: fieldNames.value
        })))));
        newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData.value, newSelectedKeys, fieldNames.value);
      } else {
        newSelectedKeys = keys2;
        lastSelectedKey.value = key2;
        cachedSelectedKeys.value = newSelectedKeys;
        newEvent.selectedNodes = convertDirectoryKeysToNodes(treeData.value, newSelectedKeys, fieldNames.value);
      }
      emit("update:selectedKeys", newSelectedKeys);
      emit("select", newSelectedKeys, newEvent);
      if (props2.selectedKeys === void 0) {
        selectedKeys.value = newSelectedKeys;
      }
    };
    var onCheck = function onCheck2(checkedObjOrKeys, eventObj) {
      emit("update:checkedKeys", checkedObjOrKeys);
      emit("check", checkedObjOrKeys, eventObj);
    };
    var _useConfigInject = useConfigInject("tree", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    return function() {
      var connectClassName = classNames("".concat(prefixCls2.value, "-directory"), _defineProperty$R({}, "".concat(prefixCls2.value, "-directory-rtl"), direction2.value === "rtl"), attrs.class);
      var _props$icon = props2.icon, icon = _props$icon === void 0 ? slots.icon : _props$icon, _props$blockNode = props2.blockNode, blockNode = _props$blockNode === void 0 ? true : _props$blockNode, otherProps = __rest$4(props2, ["icon", "blockNode"]);
      return createVNode(Tree$1, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, attrs), {}, {
        "icon": icon || getIcon$1,
        "ref": treeRef,
        "blockNode": blockNode
      }, otherProps), {}, {
        "prefixCls": prefixCls2.value,
        "class": connectClassName,
        "expandedKeys": expandedKeys.value,
        "selectedKeys": selectedKeys.value,
        "onSelect": onSelect,
        "onClick": onClick2,
        "onDblclick": onDoubleClick,
        "onExpand": onExpand,
        "onCheck": onCheck
      }), slots);
    };
  }
});
var TreeNode$2 = defineComponent(_extends$2(_extends$2({}, VcTreeNode), {
  name: "ATreeNode",
  props: treeNodeProps
}));
var Tree = _extends$2(Tree$1, {
  DirectoryTree,
  TreeNode: TreeNode$2,
  install: function install4(app) {
    app.component(Tree$1.name, Tree$1);
    app.component(TreeNode$2.name, TreeNode$2);
    app.component(DirectoryTree.name, DirectoryTree);
    return app;
  }
});
var SubMenu = Menu.SubMenu, MenuItem = Menu.Item;
function hasSubMenu(filters) {
  return filters.some(function(_ref) {
    var children = _ref.children;
    return children && children.length > 0;
  });
}
function searchValueMatched(searchValue, text) {
  if (typeof text === "string" || typeof text === "number") {
    return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
  }
  return false;
}
function renderFilterItems(_ref2) {
  var filters = _ref2.filters, prefixCls2 = _ref2.prefixCls, filteredKeys = _ref2.filteredKeys, filterMultiple = _ref2.filterMultiple, searchValue = _ref2.searchValue, filterSearch = _ref2.filterSearch;
  return filters.map(function(filter, index2) {
    var key2 = String(filter.value);
    if (filter.children) {
      return createVNode(SubMenu, {
        "key": key2 || index2,
        "title": filter.text,
        "popupClassName": "".concat(prefixCls2, "-dropdown-submenu")
      }, {
        default: function _default7() {
          return [renderFilterItems({
            filters: filter.children,
            prefixCls: prefixCls2,
            filteredKeys,
            filterMultiple,
            searchValue,
            filterSearch
          })];
        }
      });
    }
    var Component = filterMultiple ? Checkbox : Radio;
    var item = createVNode(MenuItem, {
      "key": filter.value !== void 0 ? key2 : index2
    }, {
      default: function _default7() {
        return [createVNode(Component, {
          "checked": filteredKeys.includes(key2)
        }, null), createVNode("span", null, [filter.text])];
      }
    });
    if (searchValue.trim()) {
      if (typeof filterSearch === "function") {
        return filterSearch(searchValue, filter) ? item : void 0;
      }
      return searchValueMatched(searchValue, filter.text) ? item : void 0;
    }
    return item;
  });
}
var FilterDropdown = defineComponent({
  name: "FilterDropdown",
  props: ["tablePrefixCls", "prefixCls", "dropdownPrefixCls", "column", "filterState", "filterMultiple", "filterMode", "filterSearch", "columnKey", "triggerFilter", "locale", "getPopupContainer"],
  setup: function setup150(props2, _ref3) {
    var slots = _ref3.slots;
    var contextSlots = useInjectSlots();
    var filterMode = computed(function() {
      var _a2;
      return (_a2 = props2.filterMode) !== null && _a2 !== void 0 ? _a2 : "menu";
    });
    var filterSearch = computed(function() {
      var _a2;
      return (_a2 = props2.filterSearch) !== null && _a2 !== void 0 ? _a2 : false;
    });
    var filterDropdownVisible = computed(function() {
      return props2.column.filterDropdownVisible;
    });
    var visible = ref(false);
    var filtered = computed(function() {
      var _a2;
      return !!(props2.filterState && (((_a2 = props2.filterState.filteredKeys) === null || _a2 === void 0 ? void 0 : _a2.length) || props2.filterState.forceFiltered));
    });
    var filterFlattenKeys = computed(function() {
      var _a2;
      return flattenKeys((_a2 = props2.column) === null || _a2 === void 0 ? void 0 : _a2.filters);
    });
    var filterDropdownRef = computed(function() {
      var _props$column = props2.column, filterDropdown = _props$column.filterDropdown, _props$column$slots = _props$column.slots, slots2 = _props$column$slots === void 0 ? {} : _props$column$slots, customFilterDropdown = _props$column.customFilterDropdown;
      return filterDropdown || slots2.filterDropdown && contextSlots.value[slots2.filterDropdown] || customFilterDropdown && contextSlots.value.customFilterDropdown;
    });
    var filterIconRef = computed(function() {
      var _props$column2 = props2.column, filterIcon = _props$column2.filterIcon, _props$column2$slots = _props$column2.slots, slots2 = _props$column2$slots === void 0 ? {} : _props$column2$slots;
      return filterIcon || slots2.filterIcon && contextSlots.value[slots2.filterIcon] || contextSlots.value.customFilterIcon;
    });
    var triggerVisible = function triggerVisible2(newVisible) {
      var _a2, _b;
      visible.value = newVisible;
      (_b = (_a2 = props2.column).onFilterDropdownVisibleChange) === null || _b === void 0 ? void 0 : _b.call(_a2, newVisible);
    };
    var mergedVisible = computed(function() {
      return typeof filterDropdownVisible.value === "boolean" ? filterDropdownVisible.value : visible.value;
    });
    var propFilteredKeys = computed(function() {
      var _a2;
      return (_a2 = props2.filterState) === null || _a2 === void 0 ? void 0 : _a2.filteredKeys;
    });
    var filteredKeys = shallowRef([]);
    var onSelectKeys = function onSelectKeys2(_ref4) {
      var selectedKeys = _ref4.selectedKeys;
      filteredKeys.value = selectedKeys;
    };
    var onCheck = function onCheck2(keys2, _ref5) {
      var node = _ref5.node, checked = _ref5.checked;
      if (!props2.filterMultiple) {
        onSelectKeys({
          selectedKeys: checked && node.key ? [node.key] : []
        });
      } else {
        onSelectKeys({
          selectedKeys: keys2
        });
      }
    };
    watch(propFilteredKeys, function() {
      if (!visible.value) {
        return;
      }
      onSelectKeys({
        selectedKeys: propFilteredKeys.value || []
      });
    }, {
      immediate: true
    });
    var openKeys = shallowRef([]);
    var openRef = ref();
    var onOpenChange = function onOpenChange2(keys2) {
      openRef.value = setTimeout(function() {
        openKeys.value = keys2;
      });
    };
    var onMenuClick = function onMenuClick2() {
      clearTimeout(openRef.value);
    };
    onBeforeUnmount(function() {
      clearTimeout(openRef.value);
    });
    var searchValue = ref("");
    var onSearch = function onSearch2(e2) {
      var value = e2.target.value;
      searchValue.value = value;
    };
    watch(visible, function() {
      if (!visible.value) {
        searchValue.value = "";
      }
    });
    var internalTriggerFilter = function internalTriggerFilter2(keys2) {
      var column = props2.column, columnKey = props2.columnKey, filterState = props2.filterState;
      var mergedKeys = keys2 && keys2.length ? keys2 : null;
      if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
        return null;
      }
      if (isEqual$2(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) {
        return null;
      }
      props2.triggerFilter({
        column,
        key: columnKey,
        filteredKeys: mergedKeys
      });
    };
    var onConfirm = function onConfirm2() {
      triggerVisible(false);
      internalTriggerFilter(filteredKeys.value);
    };
    var onReset = function onReset2() {
      var _ref6 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        confirm: false,
        closeDropdown: false
      }, confirm3 = _ref6.confirm, closeDropdown = _ref6.closeDropdown;
      if (confirm3) {
        internalTriggerFilter([]);
      }
      if (closeDropdown) {
        triggerVisible(false);
      }
      searchValue.value = "";
      filteredKeys.value = [];
    };
    var doFilter = function doFilter2() {
      var _ref7 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        closeDropdown: true
      }, closeDropdown = _ref7.closeDropdown;
      if (closeDropdown) {
        triggerVisible(false);
      }
      internalTriggerFilter(filteredKeys.value);
    };
    var onVisibleChange = function onVisibleChange2(newVisible) {
      if (newVisible && propFilteredKeys.value !== void 0) {
        filteredKeys.value = propFilteredKeys.value || [];
      }
      triggerVisible(newVisible);
      if (!newVisible && !filterDropdownRef.value) {
        onConfirm();
      }
    };
    var _useConfigInject = useConfigInject("", props2), direction2 = _useConfigInject.direction;
    var onCheckAll = function onCheckAll2(e2) {
      if (e2.target.checked) {
        var allFilterKeys = filterFlattenKeys.value;
        filteredKeys.value = allFilterKeys;
      } else {
        filteredKeys.value = [];
      }
    };
    var getTreeData = function getTreeData2(_ref8) {
      var filters = _ref8.filters;
      return (filters || []).map(function(filter, index2) {
        var key2 = String(filter.value);
        var item = {
          title: filter.text,
          key: filter.value !== void 0 ? key2 : index2
        };
        if (filter.children) {
          item.children = getTreeData2({
            filters: filter.children
          });
        }
        return item;
      });
    };
    var treeData = computed(function() {
      return getTreeData({
        filters: props2.column.filters
      });
    });
    var dropdownMenuClass = computed(function() {
      return classNames(_defineProperty$R({}, "".concat(props2.dropdownPrefixCls, "-menu-without-submenu"), !hasSubMenu(props2.column.filters || [])));
    });
    var getFilterComponent = function getFilterComponent2() {
      var selectedKeys = filteredKeys.value;
      var column = props2.column, locale2 = props2.locale, tablePrefixCls = props2.tablePrefixCls, filterMultiple = props2.filterMultiple, dropdownPrefixCls = props2.dropdownPrefixCls, getPopupContainer = props2.getPopupContainer, prefixCls2 = props2.prefixCls;
      if ((column.filters || []).length === 0) {
        return createVNode(Empty$2, {
          "image": Empty$2.PRESENTED_IMAGE_SIMPLE,
          "description": locale2.filterEmptyText,
          "imageStyle": {
            height: 24
          },
          "style": {
            margin: 0,
            padding: "16px 0"
          }
        }, null);
      }
      if (filterMode.value === "tree") {
        return createVNode(Fragment, null, [createVNode(FilterSearch, {
          "filterSearch": filterSearch.value,
          "value": searchValue.value,
          "onChange": onSearch,
          "tablePrefixCls": tablePrefixCls,
          "locale": locale2
        }, null), createVNode("div", {
          "class": "".concat(tablePrefixCls, "-filter-dropdown-tree")
        }, [filterMultiple ? createVNode(Checkbox, {
          "class": "".concat(tablePrefixCls, "-filter-dropdown-checkall"),
          "onChange": onCheckAll,
          "checked": selectedKeys.length === filterFlattenKeys.value.length,
          "indeterminate": selectedKeys.length > 0 && selectedKeys.length < filterFlattenKeys.value.length
        }, {
          default: function _default7() {
            return [locale2.filterCheckall];
          }
        }) : null, createVNode(Tree, {
          "checkable": true,
          "selectable": false,
          "blockNode": true,
          "multiple": filterMultiple,
          "checkStrictly": !filterMultiple,
          "class": "".concat(dropdownPrefixCls, "-menu"),
          "onCheck": onCheck,
          "checkedKeys": selectedKeys,
          "selectedKeys": selectedKeys,
          "showIcon": false,
          "treeData": treeData.value,
          "autoExpandParent": true,
          "defaultExpandAll": true,
          "filterTreeNode": searchValue.value.trim() ? function(node) {
            return searchValueMatched(searchValue.value, node.title);
          } : void 0
        }, null)])]);
      }
      return createVNode(Fragment, null, [createVNode(FilterSearch, {
        "filterSearch": filterSearch.value,
        "value": searchValue.value,
        "onChange": onSearch,
        "tablePrefixCls": tablePrefixCls,
        "locale": locale2
      }, null), createVNode(Menu, {
        "multiple": filterMultiple,
        "prefixCls": "".concat(dropdownPrefixCls, "-menu"),
        "class": dropdownMenuClass.value,
        "onClick": onMenuClick,
        "onSelect": onSelectKeys,
        "onDeselect": onSelectKeys,
        "selectedKeys": selectedKeys,
        "getPopupContainer": getPopupContainer,
        "openKeys": openKeys.value,
        "onOpenChange": onOpenChange
      }, {
        default: function _default7() {
          return renderFilterItems({
            filters: column.filters || [],
            filterSearch: filterSearch.value,
            prefixCls: prefixCls2,
            filteredKeys: filteredKeys.value,
            filterMultiple,
            searchValue: searchValue.value
          });
        }
      })]);
    };
    return function() {
      var _a2;
      var tablePrefixCls = props2.tablePrefixCls, prefixCls2 = props2.prefixCls, column = props2.column, dropdownPrefixCls = props2.dropdownPrefixCls, locale2 = props2.locale, getPopupContainer = props2.getPopupContainer;
      var dropdownContent;
      if (typeof filterDropdownRef.value === "function") {
        dropdownContent = filterDropdownRef.value({
          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
          setSelectedKeys: function setSelectedKeys(selectedKeys2) {
            return onSelectKeys({
              selectedKeys: selectedKeys2
            });
          },
          selectedKeys: filteredKeys.value,
          confirm: doFilter,
          clearFilters: onReset,
          filters: column.filters,
          visible: mergedVisible.value,
          column: column.__originColumn__
        });
      } else if (filterDropdownRef.value) {
        dropdownContent = filterDropdownRef.value;
      } else {
        var selectedKeys = filteredKeys.value;
        dropdownContent = createVNode(Fragment, null, [getFilterComponent(), createVNode("div", {
          "class": "".concat(prefixCls2, "-dropdown-btns")
        }, [createVNode(Button$2, {
          "type": "link",
          "size": "small",
          "disabled": selectedKeys.length === 0,
          "onClick": function onClick2() {
            return onReset();
          }
        }, {
          default: function _default7() {
            return [locale2.filterReset];
          }
        }), createVNode(Button$2, {
          "type": "primary",
          "size": "small",
          "onClick": onConfirm
        }, {
          default: function _default7() {
            return [locale2.filterConfirm];
          }
        })])]);
      }
      var menu = createVNode(FilterDropdownMenuWrapper$1, {
        "class": "".concat(prefixCls2, "-dropdown")
      }, {
        default: function _default7() {
          return [dropdownContent];
        }
      });
      var filterIcon;
      if (typeof filterIconRef.value === "function") {
        filterIcon = filterIconRef.value({
          filtered: filtered.value,
          column: column.__originColumn__
        });
      } else if (filterIconRef.value) {
        filterIcon = filterIconRef.value;
      } else {
        filterIcon = createVNode(FilterFilled$1, null, null);
      }
      return createVNode("div", {
        "class": "".concat(prefixCls2, "-column")
      }, [createVNode("span", {
        "class": "".concat(tablePrefixCls, "-column-title")
      }, [(_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)]), createVNode(Dropdown$2, {
        "overlay": menu,
        "trigger": ["click"],
        "visible": mergedVisible.value,
        "onVisibleChange": onVisibleChange,
        "getPopupContainer": getPopupContainer,
        "placement": direction2.value === "rtl" ? "bottomLeft" : "bottomRight"
      }, {
        default: function _default7() {
          return [createVNode("span", {
            "role": "button",
            "tabindex": -1,
            "class": classNames("".concat(prefixCls2, "-trigger"), {
              active: filtered.value
            }),
            "onClick": function onClick2(e2) {
              e2.stopPropagation();
            }
          }, [filterIcon])];
        }
      })]);
    };
  }
});
function collectFilterStates(columns2, init, pos) {
  var filterStates = [];
  (columns2 || []).forEach(function(column, index2) {
    var _a2, _b;
    var columnPos = getColumnPos(index2, pos);
    var hasFilterDropdown = column.filterDropdown || ((_a2 = column === null || column === void 0 ? void 0 : column.slots) === null || _a2 === void 0 ? void 0 : _a2.filterDropdown) || column.customFilterDropdown;
    if (column.filters || hasFilterDropdown || "onFilter" in column) {
      if ("filteredValue" in column) {
        var filteredValues = column.filteredValue;
        if (!hasFilterDropdown) {
          filteredValues = (_b = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _b !== void 0 ? _b : filteredValues;
        }
        filterStates.push({
          column,
          key: getColumnKey(column, columnPos),
          filteredKeys: filteredValues,
          forceFiltered: column.filtered
        });
      } else {
        filterStates.push({
          column,
          key: getColumnKey(column, columnPos),
          filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : void 0,
          forceFiltered: column.filtered
        });
      }
    }
    if ("children" in column) {
      filterStates = [].concat(_toConsumableArray(filterStates), _toConsumableArray(collectFilterStates(column.children, init, columnPos)));
    }
  });
  return filterStates;
}
function injectFilter(prefixCls2, dropdownPrefixCls, columns2, filterStates, triggerFilter, getPopupContainer, locale2, pos) {
  return columns2.map(function(column, index2) {
    var _a2;
    var columnPos = getColumnPos(index2, pos);
    var _column$filterMultipl = column.filterMultiple, filterMultiple = _column$filterMultipl === void 0 ? true : _column$filterMultipl, filterMode = column.filterMode, filterSearch = column.filterSearch;
    var newColumn = column;
    var hasFilterDropdown = column.filterDropdown || ((_a2 = column === null || column === void 0 ? void 0 : column.slots) === null || _a2 === void 0 ? void 0 : _a2.filterDropdown) || column.customFilterDropdown;
    if (newColumn.filters || hasFilterDropdown) {
      var columnKey = getColumnKey(newColumn, columnPos);
      var filterState = filterStates.find(function(_ref) {
        var key2 = _ref.key;
        return columnKey === key2;
      });
      newColumn = _extends$2(_extends$2({}, newColumn), {
        title: function title(renderProps) {
          return createVNode(FilterDropdown, {
            "tablePrefixCls": prefixCls2,
            "prefixCls": "".concat(prefixCls2, "-filter"),
            "dropdownPrefixCls": dropdownPrefixCls,
            "column": newColumn,
            "columnKey": columnKey,
            "filterState": filterState,
            "filterMultiple": filterMultiple,
            "filterMode": filterMode,
            "filterSearch": filterSearch,
            "triggerFilter": triggerFilter,
            "locale": locale2,
            "getPopupContainer": getPopupContainer
          }, {
            default: function _default7() {
              return [renderColumnTitle(column.title, renderProps)];
            }
          });
        }
      });
    }
    if ("children" in newColumn) {
      newColumn = _extends$2(_extends$2({}, newColumn), {
        children: injectFilter(prefixCls2, dropdownPrefixCls, newColumn.children, filterStates, triggerFilter, getPopupContainer, locale2, columnPos)
      });
    }
    return newColumn;
  });
}
function flattenKeys(filters) {
  var keys2 = [];
  (filters || []).forEach(function(_ref2) {
    var value = _ref2.value, children = _ref2.children;
    keys2.push(value);
    if (children) {
      keys2 = [].concat(_toConsumableArray(keys2), _toConsumableArray(flattenKeys(children)));
    }
  });
  return keys2;
}
function generateFilterInfo(filterStates) {
  var currentFilters = {};
  filterStates.forEach(function(_ref3) {
    var key2 = _ref3.key, filteredKeys = _ref3.filteredKeys, column = _ref3.column;
    var _a2;
    var hasFilterDropdown = column.filterDropdown || ((_a2 = column === null || column === void 0 ? void 0 : column.slots) === null || _a2 === void 0 ? void 0 : _a2.filterDropdown) || column.customFilterDropdown;
    var filters = column.filters;
    if (hasFilterDropdown) {
      currentFilters[key2] = filteredKeys || null;
    } else if (Array.isArray(filteredKeys)) {
      var keys2 = flattenKeys(filters);
      currentFilters[key2] = keys2.filter(function(originKey) {
        return filteredKeys.includes(String(originKey));
      });
    } else {
      currentFilters[key2] = null;
    }
  });
  return currentFilters;
}
function getFilterData(data6, filterStates) {
  return filterStates.reduce(function(currentData, filterState) {
    var _filterState$column = filterState.column, onFilter = _filterState$column.onFilter, filters = _filterState$column.filters, filteredKeys = filterState.filteredKeys;
    if (onFilter && filteredKeys && filteredKeys.length) {
      return currentData.filter(function(record) {
        return filteredKeys.some(function(key2) {
          var keys2 = flattenKeys(filters);
          var keyIndex = keys2.findIndex(function(k2) {
            return String(k2) === String(key2);
          });
          var realKey = keyIndex !== -1 ? keys2[keyIndex] : key2;
          return onFilter(realKey, record);
        });
      });
    }
    return currentData;
  }, data6);
}
function useFilter(_ref4) {
  var prefixCls2 = _ref4.prefixCls, dropdownPrefixCls = _ref4.dropdownPrefixCls, mergedColumns = _ref4.mergedColumns, locale2 = _ref4.locale, onFilterChange = _ref4.onFilterChange, getPopupContainer = _ref4.getPopupContainer;
  var _useState = useState(collectFilterStates(mergedColumns.value, true)), _useState2 = _slicedToArray$2(_useState, 2), filterStates = _useState2[0], setFilterStates = _useState2[1];
  var mergedFilterStates = computed(function() {
    var collectedStates = collectFilterStates(mergedColumns.value, false);
    var filteredKeysIsNotControlled = collectedStates.every(function(_ref5) {
      var filteredKeys = _ref5.filteredKeys;
      return filteredKeys === void 0;
    });
    if (filteredKeysIsNotControlled) {
      return filterStates.value;
    }
    var filteredKeysIsAllControlled = collectedStates.every(function(_ref6) {
      var filteredKeys = _ref6.filteredKeys;
      return filteredKeys !== void 0;
    });
    devWarning(filteredKeysIsNotControlled || filteredKeysIsAllControlled, "Table", "`FilteredKeys` should all be controlled or not controlled.");
    return collectedStates;
  });
  var filters = computed(function() {
    return generateFilterInfo(mergedFilterStates.value);
  });
  var triggerFilter = function triggerFilter2(filterState) {
    var newFilterStates = mergedFilterStates.value.filter(function(_ref7) {
      var key2 = _ref7.key;
      return key2 !== filterState.key;
    });
    newFilterStates.push(filterState);
    setFilterStates(newFilterStates);
    onFilterChange(generateFilterInfo(newFilterStates), newFilterStates);
  };
  var transformColumns = function transformColumns2(innerColumns) {
    return injectFilter(prefixCls2.value, dropdownPrefixCls.value, innerColumns, mergedFilterStates.value, triggerFilter, getPopupContainer.value, locale2.value);
  };
  return [transformColumns, mergedFilterStates, filters];
}
function fillTitle(columns2, columnTitleProps) {
  return columns2.map(function(column) {
    var cloneColumn = _extends$2({}, column);
    cloneColumn.title = renderColumnTitle(cloneColumn.title, columnTitleProps);
    if ("children" in cloneColumn) {
      cloneColumn.children = fillTitle(cloneColumn.children, columnTitleProps);
    }
    return cloneColumn;
  });
}
function useTitleColumns(columnTitleProps) {
  var filledColumns = function filledColumns2(columns2) {
    return fillTitle(columns2, columnTitleProps.value);
  };
  return [filledColumns];
}
function renderExpandIcon(locale2) {
  return function expandIcon(_ref) {
    var _classNames;
    var prefixCls2 = _ref.prefixCls, onExpand = _ref.onExpand, record = _ref.record, expanded = _ref.expanded, expandable = _ref.expandable;
    var iconPrefix = "".concat(prefixCls2, "-row-expand-icon");
    return createVNode("button", {
      "type": "button",
      "onClick": function onClick2(e2) {
        onExpand(record, e2);
        e2.stopPropagation();
      },
      "class": classNames(iconPrefix, (_classNames = {}, _defineProperty$R(_classNames, "".concat(iconPrefix, "-spaced"), !expandable), _defineProperty$R(_classNames, "".concat(iconPrefix, "-expanded"), expandable && expanded), _defineProperty$R(_classNames, "".concat(iconPrefix, "-collapsed"), expandable && !expanded), _classNames)),
      "aria-label": expanded ? locale2.collapse : locale2.expand
    }, null);
  };
}
function fillSlots(columns2, contextSlots) {
  var $slots = contextSlots.value;
  return columns2.map(function(column) {
    var _a2;
    if (column === SELECTION_COLUMN || column === EXPAND_COLUMN)
      return column;
    var cloneColumn = _extends$2({}, column);
    var _cloneColumn$slots = cloneColumn.slots, slots = _cloneColumn$slots === void 0 ? {} : _cloneColumn$slots;
    cloneColumn.__originColumn__ = column;
    devWarning(!("slots" in cloneColumn), "Table", "`column.slots` is deprecated. Please use `v-slot:headerCell` `v-slot:bodyCell` instead.");
    Object.keys(slots).forEach(function(key2) {
      var name2 = slots[key2];
      if (cloneColumn[key2] === void 0 && $slots[name2]) {
        cloneColumn[key2] = $slots[name2];
      }
    });
    if (contextSlots.value.headerCell && !((_a2 = column.slots) === null || _a2 === void 0 ? void 0 : _a2.title)) {
      cloneColumn.title = renderSlot(contextSlots.value, "headerCell", {
        title: column.title,
        column
      }, function() {
        return [column.title];
      });
    }
    if ("children" in cloneColumn) {
      cloneColumn.children = fillSlots(cloneColumn.children, contextSlots);
    }
    return cloneColumn;
  });
}
function useColumns$3(contextSlots) {
  var filledColumns = function filledColumns2(columns2) {
    return fillSlots(columns2, contextSlots);
  };
  return [filledColumns];
}
var EMPTY_LIST = [];
var tableProps = function tableProps2() {
  return {
    prefixCls: {
      type: String,
      default: void 0
    },
    columns: {
      type: Array,
      default: void 0
    },
    rowKey: {
      type: [String, Function],
      default: void 0
    },
    tableLayout: {
      type: String,
      default: void 0
    },
    rowClassName: {
      type: [String, Function],
      default: void 0
    },
    title: {
      type: Function,
      default: void 0
    },
    footer: {
      type: Function,
      default: void 0
    },
    id: {
      type: String,
      default: void 0
    },
    showHeader: {
      type: Boolean,
      default: void 0
    },
    components: {
      type: Object,
      default: void 0
    },
    customRow: {
      type: Function,
      default: void 0
    },
    customHeaderRow: {
      type: Function,
      default: void 0
    },
    direction: {
      type: String,
      default: void 0
    },
    expandFixed: {
      type: [Boolean, String],
      default: void 0
    },
    expandColumnWidth: {
      type: Number,
      default: void 0
    },
    expandedRowKeys: {
      type: Array,
      default: void 0
    },
    defaultExpandedRowKeys: {
      type: Array,
      default: void 0
    },
    expandedRowRender: {
      type: Function,
      default: void 0
    },
    expandRowByClick: {
      type: Boolean,
      default: void 0
    },
    expandIcon: {
      type: Function,
      default: void 0
    },
    onExpand: {
      type: Function,
      default: void 0
    },
    onExpandedRowsChange: {
      type: Function,
      default: void 0
    },
    defaultExpandAllRows: {
      type: Boolean,
      default: void 0
    },
    indentSize: {
      type: Number,
      default: void 0
    },
    expandIconColumnIndex: {
      type: Number,
      default: void 0
    },
    showExpandColumn: {
      type: Boolean,
      default: void 0
    },
    expandedRowClassName: {
      type: Function,
      default: void 0
    },
    childrenColumnName: {
      type: String,
      default: void 0
    },
    rowExpandable: {
      type: Function,
      default: void 0
    },
    sticky: {
      type: [Boolean, Object],
      default: void 0
    },
    dropdownPrefixCls: String,
    dataSource: {
      type: Array,
      default: void 0
    },
    pagination: {
      type: [Boolean, Object],
      default: void 0
    },
    loading: {
      type: [Boolean, Object],
      default: void 0
    },
    size: {
      type: String,
      default: void 0
    },
    bordered: Boolean,
    locale: {
      type: Object,
      default: void 0
    },
    onChange: {
      type: Function,
      default: void 0
    },
    onResizeColumn: {
      type: Function,
      default: void 0
    },
    rowSelection: {
      type: Object,
      default: void 0
    },
    getPopupContainer: {
      type: Function,
      default: void 0
    },
    scroll: {
      type: Object,
      default: void 0
    },
    sortDirections: {
      type: Array,
      default: void 0
    },
    showSorterTooltip: {
      type: [Boolean, Object],
      default: true
    },
    contextSlots: {
      type: Object
    },
    transformCellText: {
      type: Function
    }
  };
};
var InteralTable = defineComponent({
  name: "InteralTable",
  inheritAttrs: false,
  props: initDefaultProps$1(tableProps(), {
    rowKey: "key"
  }),
  slots: ["emptyText", "expandIcon", "title", "footer", "summary", "expandedRowRender", "bodyCell", "headerCell", "customFilterIcon", "customFilterDropdown"],
  setup: function setup151(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose, emit = _ref.emit;
    devWarning(!(typeof props2.rowKey === "function" && props2.rowKey.length > 1), "Table", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.");
    useProvideSlots(computed(function() {
      return props2.contextSlots;
    }));
    useProvideTableContext({
      onResizeColumn: function onResizeColumn(w2, col) {
        emit("resizeColumn", w2, col);
      }
    });
    var screens2 = useBreakpoint();
    var mergedColumns = computed(function() {
      var matched = new Set(Object.keys(screens2.value).filter(function(m2) {
        return screens2.value[m2];
      }));
      return props2.columns.filter(function(c2) {
        return !c2.responsive || c2.responsive.some(function(r2) {
          return matched.has(r2);
        });
      });
    });
    var _useConfigInject = useConfigInject("table", props2), mergedSize = _useConfigInject.size, renderEmpty2 = _useConfigInject.renderEmpty, direction2 = _useConfigInject.direction, prefixCls2 = _useConfigInject.prefixCls, configProvider = _useConfigInject.configProvider;
    var transformCellText = computed(function() {
      return props2.transformCellText || configProvider.transformCellText;
    });
    var _useLocaleReceiver = useLocaleReceiver("Table", defaultLocale.Table, toRef(props2, "locale")), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), tableLocale = _useLocaleReceiver2[0];
    var rawData = computed(function() {
      return props2.dataSource || EMPTY_LIST;
    });
    var dropdownPrefixCls = computed(function() {
      return configProvider.getPrefixCls("dropdown", props2.dropdownPrefixCls);
    });
    var childrenColumnName = computed(function() {
      return props2.childrenColumnName || "children";
    });
    var expandType = computed(function() {
      if (rawData.value.some(function(item) {
        var _a2;
        return (_a2 = item) === null || _a2 === void 0 ? void 0 : _a2[childrenColumnName.value];
      })) {
        return "nest";
      }
      if (props2.expandedRowRender) {
        return "row";
      }
      return null;
    });
    var internalRefs = reactive({
      body: null
    });
    var updateInternalRefs = function updateInternalRefs2(refs) {
      _extends$2(internalRefs, refs);
    };
    var getRowKey = computed(function() {
      if (typeof props2.rowKey === "function") {
        return props2.rowKey;
      }
      return function(record) {
        var _a2;
        return (_a2 = record) === null || _a2 === void 0 ? void 0 : _a2[props2.rowKey];
      };
    });
    var _useLazyKVMap = useLazyKVMap(rawData, childrenColumnName, getRowKey), _useLazyKVMap2 = _slicedToArray$2(_useLazyKVMap, 1), getRecordByKey = _useLazyKVMap2[0];
    var changeEventInfo = {};
    var triggerOnChange = function triggerOnChange2(info, action) {
      var reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var pagination = props2.pagination, scroll = props2.scroll, onChange3 = props2.onChange;
      var changeInfo = _extends$2(_extends$2({}, changeEventInfo), info);
      if (reset) {
        changeEventInfo.resetPagination();
        if (changeInfo.pagination.current) {
          changeInfo.pagination.current = 1;
        }
        if (pagination && pagination.onChange) {
          pagination.onChange(1, changeInfo.pagination.pageSize);
        }
      }
      if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body) {
        scrollTo$2(0, {
          getContainer: function getContainer4() {
            return internalRefs.body;
          }
        });
      }
      onChange3 === null || onChange3 === void 0 ? void 0 : onChange3(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
        currentDataSource: getFilterData(getSortData(rawData.value, changeInfo.sorterStates, childrenColumnName.value), changeInfo.filterStates),
        action
      });
    };
    var onSorterChange = function onSorterChange2(sorter, sorterStates) {
      triggerOnChange({
        sorter,
        sorterStates
      }, "sort", false);
    };
    var _useSorter = useFilterSorter({
      prefixCls: prefixCls2,
      mergedColumns,
      onSorterChange,
      sortDirections: computed(function() {
        return props2.sortDirections || ["ascend", "descend"];
      }),
      tableLocale,
      showSorterTooltip: toRef(props2, "showSorterTooltip")
    }), _useSorter2 = _slicedToArray$2(_useSorter, 4), transformSorterColumns = _useSorter2[0], sortStates = _useSorter2[1], sorterTitleProps = _useSorter2[2], sorters = _useSorter2[3];
    var sortedData = computed(function() {
      return getSortData(rawData.value, sortStates.value, childrenColumnName.value);
    });
    var onFilterChange = function onFilterChange2(filters2, filterStates2) {
      triggerOnChange({
        filters: filters2,
        filterStates: filterStates2
      }, "filter", true);
    };
    var _useFilter = useFilter({
      prefixCls: prefixCls2,
      locale: tableLocale,
      dropdownPrefixCls,
      mergedColumns,
      onFilterChange,
      getPopupContainer: toRef(props2, "getPopupContainer")
    }), _useFilter2 = _slicedToArray$2(_useFilter, 3), transformFilterColumns = _useFilter2[0], filterStates = _useFilter2[1], filters = _useFilter2[2];
    var mergedData = computed(function() {
      return getFilterData(sortedData.value, filterStates.value);
    });
    var _useColumns = useColumns$3(toRef(props2, "contextSlots")), _useColumns2 = _slicedToArray$2(_useColumns, 1), transformBasicColumns = _useColumns2[0];
    var columnTitleProps = computed(function() {
      return _extends$2({}, sorterTitleProps.value);
    });
    var _useTitleColumns = useTitleColumns(columnTitleProps), _useTitleColumns2 = _slicedToArray$2(_useTitleColumns, 1), transformTitleColumns = _useTitleColumns2[0];
    var onPaginationChange = function onPaginationChange2(current2, pageSize2) {
      triggerOnChange({
        pagination: _extends$2(_extends$2({}, changeEventInfo.pagination), {
          current: current2,
          pageSize: pageSize2
        })
      }, "paginate");
    };
    var _usePagination = usePagination$2(computed(function() {
      return mergedData.value.length;
    }), toRef(props2, "pagination"), onPaginationChange), _usePagination2 = _slicedToArray$2(_usePagination, 2), mergedPagination = _usePagination2[0], resetPagination = _usePagination2[1];
    watchEffect(function() {
      changeEventInfo.sorter = sorters.value;
      changeEventInfo.sorterStates = sortStates.value;
      changeEventInfo.filters = filters.value;
      changeEventInfo.filterStates = filterStates.value;
      changeEventInfo.pagination = props2.pagination === false ? {} : getPaginationParam(props2.pagination, mergedPagination.value);
      changeEventInfo.resetPagination = resetPagination;
    });
    var pageData = computed(function() {
      if (props2.pagination === false || !mergedPagination.value.pageSize) {
        return mergedData.value;
      }
      var _mergedPagination$val = mergedPagination.value, _mergedPagination$val2 = _mergedPagination$val.current, current2 = _mergedPagination$val2 === void 0 ? 1 : _mergedPagination$val2, total3 = _mergedPagination$val.total, _mergedPagination$val3 = _mergedPagination$val.pageSize, pageSize2 = _mergedPagination$val3 === void 0 ? DEFAULT_PAGE_SIZE : _mergedPagination$val3;
      devWarning(current2 > 0, "Table", "`current` should be positive number.");
      if (mergedData.value.length < total3) {
        if (mergedData.value.length > pageSize2) {
          return mergedData.value.slice((current2 - 1) * pageSize2, current2 * pageSize2);
        }
        return mergedData.value;
      }
      return mergedData.value.slice((current2 - 1) * pageSize2, current2 * pageSize2);
    });
    watchEffect(function() {
      nextTick(function() {
        var _mergedPagination$val4 = mergedPagination.value, total3 = _mergedPagination$val4.total, _mergedPagination$val5 = _mergedPagination$val4.pageSize, pageSize2 = _mergedPagination$val5 === void 0 ? DEFAULT_PAGE_SIZE : _mergedPagination$val5;
        if (mergedData.value.length < total3) {
          if (mergedData.value.length > pageSize2) {
            devWarning(false, "Table", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode.");
          }
        }
      });
    }, {
      flush: "post"
    });
    var expandIconColumnIndex = computed(function() {
      if (props2.showExpandColumn === false)
        return -1;
      if (expandType.value === "nest" && props2.expandIconColumnIndex === void 0) {
        return props2.rowSelection ? 1 : 0;
      } else if (props2.expandIconColumnIndex > 0 && props2.rowSelection) {
        return props2.expandIconColumnIndex - 1;
      }
      return props2.expandIconColumnIndex;
    });
    var rowSelection = ref();
    watch(function() {
      return props2.rowSelection;
    }, function() {
      rowSelection.value = props2.rowSelection ? _extends$2({}, props2.rowSelection) : props2.rowSelection;
    }, {
      deep: true,
      immediate: true
    });
    var _useSelection = useSelection(rowSelection, {
      prefixCls: prefixCls2,
      data: mergedData,
      pageData,
      getRowKey,
      getRecordByKey,
      expandType,
      childrenColumnName,
      locale: tableLocale,
      getPopupContainer: computed(function() {
        return props2.getPopupContainer;
      })
    }), _useSelection2 = _slicedToArray$2(_useSelection, 2), transformSelectionColumns = _useSelection2[0], selectedKeySet = _useSelection2[1];
    var internalRowClassName = function internalRowClassName2(record, index2, indent) {
      var mergedRowClassName;
      var rowClassName = props2.rowClassName;
      if (typeof rowClassName === "function") {
        mergedRowClassName = classNames(rowClassName(record, index2, indent));
      } else {
        mergedRowClassName = classNames(rowClassName);
      }
      return classNames(_defineProperty$R({}, "".concat(prefixCls2.value, "-row-selected"), selectedKeySet.value.has(getRowKey.value(record, index2))), mergedRowClassName);
    };
    expose({
      selectedKeySet
    });
    var indentSize = computed(function() {
      return typeof props2.indentSize === "number" ? props2.indentSize : 15;
    });
    var transformColumns = function transformColumns2(innerColumns) {
      var res = transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(transformBasicColumns(innerColumns)))));
      return res;
    };
    return function() {
      var _classNames3;
      var _a2;
      var _props$expandIcon = props2.expandIcon, expandIcon = _props$expandIcon === void 0 ? slots.expandIcon || renderExpandIcon(tableLocale.value) : _props$expandIcon, pagination = props2.pagination, loading = props2.loading, bordered = props2.bordered;
      var topPaginationNode;
      var bottomPaginationNode;
      if (pagination !== false && ((_a2 = mergedPagination.value) === null || _a2 === void 0 ? void 0 : _a2.total)) {
        var paginationSize;
        if (mergedPagination.value.size) {
          paginationSize = mergedPagination.value.size;
        } else {
          paginationSize = mergedSize.value === "small" || mergedSize.value === "middle" ? "small" : void 0;
        }
        var renderPagination = function renderPagination2(position3) {
          return createVNode(Pagination$1, _objectSpread2$2(_objectSpread2$2({}, mergedPagination.value), {}, {
            "class": ["".concat(prefixCls2.value, "-pagination ").concat(prefixCls2.value, "-pagination-").concat(position3), mergedPagination.value.class],
            "size": paginationSize
          }), null);
        };
        var defaultPosition = direction2.value === "rtl" ? "left" : "right";
        var position2 = mergedPagination.value.position;
        if (position2 !== null && Array.isArray(position2)) {
          var topPos = position2.find(function(p2) {
            return p2.indexOf("top") !== -1;
          });
          var bottomPos = position2.find(function(p2) {
            return p2.indexOf("bottom") !== -1;
          });
          var isDisable = position2.every(function(p2) {
            return "".concat(p2) === "none";
          });
          if (!topPos && !bottomPos && !isDisable) {
            bottomPaginationNode = renderPagination(defaultPosition);
          }
          if (topPos) {
            topPaginationNode = renderPagination(topPos.toLowerCase().replace("top", ""));
          }
          if (bottomPos) {
            bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace("bottom", ""));
          }
        } else {
          bottomPaginationNode = renderPagination(defaultPosition);
        }
      }
      var spinProps3;
      if (typeof loading === "boolean") {
        spinProps3 = {
          spinning: loading
        };
      } else if (_typeof$2(loading) === "object") {
        spinProps3 = _extends$2({
          spinning: true
        }, loading);
      }
      var wrapperClassNames = classNames("".concat(prefixCls2.value, "-wrapper"), _defineProperty$R({}, "".concat(prefixCls2.value, "-wrapper-rtl"), direction2.value === "rtl"), attrs.class);
      var tableProps3 = omit$3(props2, ["columns"]);
      return createVNode("div", {
        "class": wrapperClassNames,
        "style": attrs.style
      }, [createVNode(Spin, _objectSpread2$2({
        "spinning": false
      }, spinProps3), {
        default: function _default7() {
          return [topPaginationNode, createVNode(Table$3, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, attrs), tableProps3), {}, {
            "expandedRowKeys": props2.expandedRowKeys,
            "defaultExpandedRowKeys": props2.defaultExpandedRowKeys,
            "expandIconColumnIndex": expandIconColumnIndex.value,
            "indentSize": indentSize.value,
            "expandIcon": expandIcon,
            "columns": mergedColumns.value,
            "direction": direction2.value,
            "prefixCls": prefixCls2.value,
            "class": classNames((_classNames3 = {}, _defineProperty$R(_classNames3, "".concat(prefixCls2.value, "-middle"), mergedSize.value === "middle"), _defineProperty$R(_classNames3, "".concat(prefixCls2.value, "-small"), mergedSize.value === "small"), _defineProperty$R(_classNames3, "".concat(prefixCls2.value, "-bordered"), bordered), _defineProperty$R(_classNames3, "".concat(prefixCls2.value, "-empty"), rawData.value.length === 0), _classNames3)),
            "data": pageData.value,
            "rowKey": getRowKey.value,
            "rowClassName": internalRowClassName,
            "internalHooks": INTERNAL_HOOKS,
            "internalRefs": internalRefs,
            "onUpdateInternalRefs": updateInternalRefs,
            "transformColumns": transformColumns,
            "transformCellText": transformCellText.value
          }), _extends$2(_extends$2({}, slots), {
            emptyText: function emptyText() {
              var _a3, _b;
              return ((_a3 = slots.emptyText) === null || _a3 === void 0 ? void 0 : _a3.call(slots)) || ((_b = props2.locale) === null || _b === void 0 ? void 0 : _b.emptyText) || renderEmpty2.value("Table");
            }
          })), bottomPaginationNode];
        }
      })]);
    };
  }
});
var Table$1 = defineComponent({
  name: "ATable",
  inheritAttrs: false,
  setup: function setup152(_props, _ref2) {
    var attrs = _ref2.attrs, slots = _ref2.slots, expose = _ref2.expose;
    var table = ref();
    expose({
      table
    });
    return function() {
      var _a2;
      var props2 = attrs;
      var columns2 = props2.columns || convertChildrenToColumns((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots));
      return createVNode(InteralTable, _objectSpread2$2(_objectSpread2$2({
        "ref": table
      }, attrs), {}, {
        "columns": columns2 || [],
        "expandedRowRender": slots.expandedRowRender,
        "contextSlots": _extends$2({}, slots)
      }), slots);
    };
  }
});
var Table$2 = Table$1;
var Column = defineComponent({
  name: "ATableColumn",
  slots: ["title", "filterIcon"],
  render: function render9() {
    return null;
  }
});
var ColumnGroup = defineComponent({
  name: "ATableColumnGroup",
  slots: ["title"],
  __ANT_TABLE_COLUMN_GROUP: true,
  render: function render10() {
    return null;
  }
});
var TableSummaryRow = defineComponent(_extends$2(_extends$2({}, SummaryRow), {
  name: "ATableSummaryRow"
}));
var TableSummaryCell = defineComponent(_extends$2(_extends$2({}, SummaryCell), {
  name: "ATableSummaryCell"
}));
var TableSummary = _extends$2(FooterComponents, {
  Cell: TableSummaryCell,
  Row: TableSummaryRow,
  name: "ATableSummary"
});
var Table = _extends$2(Table$2, {
  SELECTION_ALL,
  SELECTION_INVERT,
  SELECTION_NONE,
  SELECTION_COLUMN,
  EXPAND_COLUMN,
  Column,
  ColumnGroup,
  Summary: TableSummary,
  install: function install5(app) {
    app.component(TableSummary.name, TableSummary);
    app.component(TableSummaryCell.name, TableSummaryCell);
    app.component(TableSummaryRow.name, TableSummaryRow);
    app.component(Table$2.name, Table$2);
    app.component(Column.name, Column);
    app.component(ColumnGroup.name, ColumnGroup);
    return app;
  }
});
function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
function fillFieldNames(fieldNames) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, children = _ref.children;
  var mergedValue = value || "value";
  return {
    _title: label ? [label] : ["title", "label"],
    value: mergedValue,
    key: mergedValue,
    children: children || "children"
  };
}
function isCheckDisabled(node) {
  return node.disabled || node.disableCheckbox || node.checkable === false;
}
function getAllKeys(treeData, fieldNames) {
  var keys2 = [];
  function dig(list) {
    list.forEach(function(item) {
      keys2.push(item[fieldNames.value]);
      var children = item[fieldNames.children];
      if (children) {
        dig(children);
      }
    });
  }
  dig(treeData);
  return keys2;
}
function isNil(val) {
  return val === null || val === void 0;
}
var TreeSelectContextPropsKey = Symbol("TreeSelectContextPropsKey");
function useProvideSelectContext(props2) {
  return provide(TreeSelectContextPropsKey, props2);
}
function useInjectSelectContext() {
  return inject(TreeSelectContextPropsKey, {});
}
var HIDDEN_STYLE = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
};
var OptionList = defineComponent({
  name: "OptionList",
  inheritAttrs: false,
  slots: ["notFoundContent", "menuItemSelectedIcon"],
  setup: function setup153(_2, _ref) {
    var slots = _ref.slots, expose = _ref.expose;
    var baseProps2 = useBaseProps();
    var legacyContext = useInjectLegacySelectContext();
    var context2 = useInjectSelectContext();
    var treeRef = ref();
    var memoTreeData = useMemo(function() {
      return context2.treeData;
    }, [function() {
      return baseProps2.open;
    }, function() {
      return context2.treeData;
    }], function(next2) {
      return next2[0];
    });
    var mergedCheckedKeys = computed(function() {
      var checkable = legacyContext.checkable, halfCheckedKeys = legacyContext.halfCheckedKeys, checkedKeys = legacyContext.checkedKeys;
      if (!checkable) {
        return null;
      }
      return {
        checked: checkedKeys,
        halfChecked: halfCheckedKeys
      };
    });
    watch(function() {
      return baseProps2.open;
    }, function() {
      nextTick(function() {
        var _a2;
        if (baseProps2.open && !baseProps2.multiple && legacyContext.checkedKeys.length) {
          (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo({
            key: legacyContext.checkedKeys[0]
          });
        }
      });
    }, {
      immediate: true,
      flush: "post"
    });
    var lowerSearchValue = computed(function() {
      return String(baseProps2.searchValue).toLowerCase();
    });
    var filterTreeNode = function filterTreeNode2(treeNode) {
      if (!lowerSearchValue.value) {
        return false;
      }
      return String(treeNode[legacyContext.treeNodeFilterProp]).toLowerCase().includes(lowerSearchValue.value);
    };
    var expandedKeys = shallowRef(legacyContext.treeDefaultExpandedKeys);
    var searchExpandedKeys = shallowRef(null);
    watch(function() {
      return baseProps2.searchValue;
    }, function() {
      if (baseProps2.searchValue) {
        searchExpandedKeys.value = getAllKeys(toRaw(context2.treeData), toRaw(context2.fieldNames));
      }
    }, {
      immediate: true
    });
    var mergedExpandedKeys = computed(function() {
      if (legacyContext.treeExpandedKeys) {
        return legacyContext.treeExpandedKeys.slice();
      }
      return baseProps2.searchValue ? searchExpandedKeys.value : expandedKeys.value;
    });
    var onInternalExpand = function onInternalExpand2(keys2) {
      var _a2;
      expandedKeys.value = keys2;
      searchExpandedKeys.value = keys2;
      (_a2 = legacyContext.onTreeExpand) === null || _a2 === void 0 ? void 0 : _a2.call(legacyContext, keys2);
    };
    var onListMouseDown = function onListMouseDown2(event) {
      event.preventDefault();
    };
    var onInternalSelect = function onInternalSelect2(_3, _ref2) {
      var node = _ref2.node;
      var _a2, _b;
      var checkable = legacyContext.checkable, checkedKeys = legacyContext.checkedKeys;
      if (checkable && isCheckDisabled(node)) {
        return;
      }
      (_a2 = context2.onSelect) === null || _a2 === void 0 ? void 0 : _a2.call(context2, node.key, {
        selected: !checkedKeys.includes(node.key)
      });
      if (!baseProps2.multiple) {
        (_b = baseProps2.toggleOpen) === null || _b === void 0 ? void 0 : _b.call(baseProps2, false);
      }
    };
    var activeKey = ref(null);
    var activeEntity = computed(function() {
      return legacyContext.keyEntities[activeKey.value];
    });
    var setActiveKey = function setActiveKey2(key2) {
      activeKey.value = key2;
    };
    expose({
      scrollTo: function scrollTo2() {
        var _b2;
        var _a2, _b;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (_b = (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo) === null || _b === void 0 ? void 0 : (_b2 = _b).call.apply(_b2, [_a2].concat(args));
      },
      onKeydown: function onKeydown(event) {
        var _a2;
        var which = event.which;
        switch (which) {
          case KeyCode$1.UP:
          case KeyCode$1.DOWN:
          case KeyCode$1.LEFT:
          case KeyCode$1.RIGHT:
            (_a2 = treeRef.value) === null || _a2 === void 0 ? void 0 : _a2.onKeydown(event);
            break;
          case KeyCode$1.ENTER: {
            if (activeEntity.value) {
              var _ref3 = activeEntity.value.node || {}, selectable = _ref3.selectable, value = _ref3.value;
              if (selectable !== false) {
                onInternalSelect(null, {
                  node: {
                    key: activeKey.value
                  },
                  selected: !legacyContext.checkedKeys.includes(value)
                });
              }
            }
            break;
          }
          case KeyCode$1.ESC: {
            baseProps2.toggleOpen(false);
          }
        }
      },
      onKeyup: function onKeyup() {
      }
    });
    return function() {
      var _a2;
      var prefixCls2 = baseProps2.prefixCls, multiple = baseProps2.multiple, searchValue = baseProps2.searchValue, open2 = baseProps2.open, _baseProps$notFoundCo = baseProps2.notFoundContent, notFoundContent = _baseProps$notFoundCo === void 0 ? (_a2 = slots.notFoundContent) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _baseProps$notFoundCo;
      var listHeight = context2.listHeight, listItemHeight = context2.listItemHeight, virtual = context2.virtual;
      var checkable = legacyContext.checkable, treeDefaultExpandAll = legacyContext.treeDefaultExpandAll, treeIcon = legacyContext.treeIcon, showTreeIcon = legacyContext.showTreeIcon, switcherIcon = legacyContext.switcherIcon, treeLine = legacyContext.treeLine, loadData = legacyContext.loadData, treeLoadedKeys = legacyContext.treeLoadedKeys, treeMotion = legacyContext.treeMotion, onTreeLoad = legacyContext.onTreeLoad, checkedKeys = legacyContext.checkedKeys;
      if (memoTreeData.value.length === 0) {
        return createVNode("div", {
          "role": "listbox",
          "class": "".concat(prefixCls2, "-empty"),
          "onMousedown": onListMouseDown
        }, [notFoundContent]);
      }
      var treeProps4 = {
        fieldNames: context2.fieldNames
      };
      if (treeLoadedKeys) {
        treeProps4.loadedKeys = treeLoadedKeys;
      }
      if (mergedExpandedKeys.value) {
        treeProps4.expandedKeys = mergedExpandedKeys.value;
      }
      return createVNode("div", {
        "onMousedown": onListMouseDown
      }, [activeEntity.value && open2 && createVNode("span", {
        "style": HIDDEN_STYLE,
        "aria-live": "assertive"
      }, [activeEntity.value.node.value]), createVNode(Tree$2, _objectSpread2$2(_objectSpread2$2({
        "ref": treeRef,
        "focusable": false,
        "prefixCls": "".concat(prefixCls2, "-tree"),
        "treeData": memoTreeData.value,
        "height": listHeight,
        "itemHeight": listItemHeight,
        "virtual": virtual,
        "multiple": multiple,
        "icon": treeIcon,
        "showIcon": showTreeIcon,
        "switcherIcon": switcherIcon,
        "showLine": treeLine,
        "loadData": searchValue ? null : loadData,
        "motion": treeMotion,
        "activeKey": activeKey.value,
        "checkable": checkable,
        "checkStrictly": true,
        "checkedKeys": mergedCheckedKeys.value,
        "selectedKeys": !checkable ? checkedKeys : [],
        "defaultExpandAll": treeDefaultExpandAll
      }, treeProps4), {}, {
        "onActiveChange": setActiveKey,
        "onSelect": onInternalSelect,
        "onCheck": onInternalSelect,
        "onExpand": onInternalExpand,
        "onLoad": onTreeLoad,
        "filterTreeNode": filterTreeNode
      }), _extends$2(_extends$2({}, slots), {
        checkable: legacyContext.customSlots.treeCheckable
      }))]);
    };
  }
});
var SHOW_ALL = "SHOW_ALL";
var SHOW_PARENT = "SHOW_PARENT";
var SHOW_CHILD = "SHOW_CHILD";
function formatStrategyValues(values, strategy, keyEntities, fieldNames) {
  var valueSet = new Set(values);
  if (strategy === SHOW_CHILD) {
    return values.filter(function(key2) {
      var entity = keyEntities[key2];
      if (entity && entity.children && entity.children.some(function(_ref) {
        var node = _ref.node;
        return valueSet.has(node[fieldNames.value]);
      }) && entity.children.every(function(_ref2) {
        var node = _ref2.node;
        return isCheckDisabled(node) || valueSet.has(node[fieldNames.value]);
      })) {
        return false;
      }
      return true;
    });
  }
  if (strategy === SHOW_PARENT) {
    return values.filter(function(key2) {
      var entity = keyEntities[key2];
      var parent2 = entity ? entity.parent : null;
      if (parent2 && !isCheckDisabled(parent2.node) && valueSet.has(parent2.key)) {
        return false;
      }
      return true;
    });
  }
  return values;
}
var TreeNode = function TreeNode2() {
  return null;
};
TreeNode.inheritAttrs = false;
TreeNode.displayName = "ATreeSelectNode";
TreeNode.isTreeSelectNode = true;
var TreeNode$1 = TreeNode;
var __rest$3 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function isTreeSelectNode(node) {
  return node && node.type && node.type.isTreeSelectNode;
}
function convertChildrenToData(rootNodes) {
  function dig() {
    var treeNodes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return filterEmpty(treeNodes).map(function(treeNode) {
      var _a2, _b, _c;
      if (!isTreeSelectNode(treeNode)) {
        return null;
      }
      var slots = treeNode.children || {};
      var key2 = treeNode.key;
      var props2 = {};
      for (var _i = 0, _Object$entries = Object.entries(treeNode.props); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2), k2 = _Object$entries$_i[0], v2 = _Object$entries$_i[1];
        props2[camelize$1(k2)] = v2;
      }
      var isLeaf2 = props2.isLeaf, checkable = props2.checkable, selectable = props2.selectable, disabled = props2.disabled, disableCheckbox = props2.disableCheckbox;
      var newProps = {
        isLeaf: isLeaf2 || isLeaf2 === "" || void 0,
        checkable: checkable || checkable === "" || void 0,
        selectable: selectable || selectable === "" || void 0,
        disabled: disabled || disabled === "" || void 0,
        disableCheckbox: disableCheckbox || disableCheckbox === "" || void 0
      };
      var slotsProps = _extends$2(_extends$2({}, props2), newProps);
      var _props$title = props2.title, title = _props$title === void 0 ? (_a2 = slots.title) === null || _a2 === void 0 ? void 0 : _a2.call(slots, slotsProps) : _props$title, _props$switcherIcon = props2.switcherIcon, switcherIcon = _props$switcherIcon === void 0 ? (_b = slots.switcherIcon) === null || _b === void 0 ? void 0 : _b.call(slots, slotsProps) : _props$switcherIcon, rest = __rest$3(props2, ["title", "switcherIcon"]);
      var children = (_c = slots.default) === null || _c === void 0 ? void 0 : _c.call(slots);
      var dataNode = _extends$2(_extends$2(_extends$2({}, rest), {
        title,
        switcherIcon,
        key: key2,
        isLeaf: isLeaf2
      }), newProps);
      var parsedChildren = dig(children);
      if (parsedChildren.length) {
        dataNode.children = parsedChildren;
      }
      return dataNode;
    });
  }
  return dig(rootNodes);
}
function fillLegacyProps(dataNode) {
  if (!dataNode) {
    return dataNode;
  }
  var cloneNode = _extends$2({}, dataNode);
  if (!("props" in cloneNode)) {
    Object.defineProperty(cloneNode, "props", {
      get: function get2() {
        return cloneNode;
      }
    });
  }
  return cloneNode;
}
function fillAdditionalInfo(extra, triggerValue, checkedValues, treeData, showPosition, fieldNames) {
  var triggerNode = null;
  var nodeList = null;
  function generateMap() {
    function dig(list) {
      var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0";
      var parentIncluded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      return list.map(function(option2, index2) {
        var pos = "".concat(level, "-").concat(index2);
        var value = option2[fieldNames.value];
        var included = checkedValues.includes(value);
        var children = dig(option2[fieldNames.children] || [], pos, included);
        var node = createVNode(TreeNode$1, option2, {
          default: function _default7() {
            return [children.map(function(child) {
              return child.node;
            })];
          }
        });
        if (triggerValue === value) {
          triggerNode = node;
        }
        if (included) {
          var checkedNode = {
            pos,
            node,
            children
          };
          if (!parentIncluded) {
            nodeList.push(checkedNode);
          }
          return checkedNode;
        }
        return null;
      }).filter(function(node) {
        return node;
      });
    }
    if (!nodeList) {
      nodeList = [];
      dig(treeData);
      nodeList.sort(function(_ref, _ref2) {
        var val1 = _ref.node.props.value;
        var val2 = _ref2.node.props.value;
        var index1 = checkedValues.indexOf(val1);
        var index2 = checkedValues.indexOf(val2);
        return index1 - index2;
      });
    }
  }
  Object.defineProperty(extra, "triggerNode", {
    get: function get2() {
      generateMap();
      return triggerNode;
    }
  });
  Object.defineProperty(extra, "allCheckedNodes", {
    get: function get2() {
      generateMap();
      if (showPosition) {
        return nodeList;
      }
      return nodeList.map(function(_ref3) {
        var node = _ref3.node;
        return node;
      });
    }
  });
}
function parseSimpleTreeData(treeData, _ref) {
  var id = _ref.id, pId = _ref.pId, rootPId = _ref.rootPId;
  var keyNodes = {};
  var rootNodeList = [];
  var nodeList = treeData.map(function(node) {
    var clone3 = _extends$2({}, node);
    var key2 = clone3[id];
    keyNodes[key2] = clone3;
    clone3.key = clone3.key || key2;
    return clone3;
  });
  nodeList.forEach(function(node) {
    var parentKey = node[pId];
    var parent2 = keyNodes[parentKey];
    if (parent2) {
      parent2.children = parent2.children || [];
      parent2.children.push(node);
    }
    if (parentKey === rootPId || !parent2 && rootPId === null) {
      rootNodeList.push(node);
    }
  });
  return rootNodeList;
}
function useTreeData(treeData, children, simpleMode) {
  var mergedTreeData = shallowRef();
  watch([simpleMode, treeData, children], function() {
    var simpleModeValue = simpleMode.value;
    if (treeData.value) {
      mergedTreeData.value = simpleMode.value ? parseSimpleTreeData(toRaw(treeData.value), _extends$2({
        id: "id",
        pId: "pId",
        rootPId: null
      }, simpleModeValue !== true ? simpleModeValue : {})) : toRaw(treeData.value).slice();
    } else {
      mergedTreeData.value = convertChildrenToData(toRaw(children.value));
    }
  }, {
    immediate: true,
    deep: true
  });
  return mergedTreeData;
}
var useCache$1 = function(values) {
  var cacheRef = shallowRef({
    valueLabels: new Map()
  });
  var mergedValues = shallowRef();
  watch(values, function() {
    mergedValues.value = toRaw(values.value);
  }, {
    immediate: true
  });
  var newFilledValues = computed(function() {
    var valueLabels = cacheRef.value.valueLabels;
    var valueLabelsCache = new Map();
    var filledValues = mergedValues.value.map(function(item) {
      var _a2;
      var value = item.value;
      var mergedLabel = (_a2 = item.label) !== null && _a2 !== void 0 ? _a2 : valueLabels.get(value);
      valueLabelsCache.set(value, mergedLabel);
      return _extends$2(_extends$2({}, item), {
        label: mergedLabel
      });
    });
    cacheRef.value.valueLabels = valueLabelsCache;
    return filledValues;
  });
  return [newFilledValues];
};
var useDataEntities = function(treeData, fieldNames) {
  var valueEntities = shallowRef(new Map());
  var keyEntities = shallowRef({});
  watchEffect(function() {
    var fieldNamesValue = fieldNames.value;
    var collection = convertDataToEntities(treeData.value, {
      fieldNames: fieldNamesValue,
      initWrapper: function initWrapper(wrapper) {
        return _extends$2(_extends$2({}, wrapper), {
          valueEntities: new Map()
        });
      },
      processEntity: function processEntity(entity, wrapper) {
        var val = entity.node[fieldNamesValue.value];
        wrapper.valueEntities.set(val, entity);
      }
    });
    valueEntities.value = collection.valueEntities;
    keyEntities.value = collection.keyEntities;
  });
  return {
    valueEntities,
    keyEntities
  };
};
var useCheckedKeys = function(rawLabeledValues, rawHalfCheckedValues, treeConduction, keyEntities, maxLevel, levelEntities) {
  var newRawCheckedValues = shallowRef([]);
  var newRawHalfCheckedValues = shallowRef([]);
  watchEffect(function() {
    var checkedKeys = rawLabeledValues.value.map(function(_ref) {
      var value = _ref.value;
      return value;
    });
    var halfCheckedKeys = rawHalfCheckedValues.value.map(function(_ref2) {
      var value = _ref2.value;
      return value;
    });
    var missingValues = checkedKeys.filter(function(key2) {
      return !keyEntities.value[key2];
    });
    if (treeConduction.value) {
      var _conductCheck = conductCheck(checkedKeys, true, keyEntities.value, maxLevel.value, levelEntities.value);
      checkedKeys = _conductCheck.checkedKeys;
      halfCheckedKeys = _conductCheck.halfCheckedKeys;
    }
    newRawCheckedValues.value = Array.from(new Set([].concat(_toConsumableArray(missingValues), _toConsumableArray(checkedKeys))));
    newRawHalfCheckedValues.value = halfCheckedKeys;
  });
  return [newRawCheckedValues, newRawHalfCheckedValues];
};
var useFilterTreeData = function(treeData, searchValue, _ref) {
  var treeNodeFilterProp = _ref.treeNodeFilterProp, filterTreeNode = _ref.filterTreeNode, fieldNames = _ref.fieldNames;
  return computed(function() {
    var fieldChildren = fieldNames.value.children;
    var searchValueVal = searchValue.value;
    var treeNodeFilterPropValue = treeNodeFilterProp === null || treeNodeFilterProp === void 0 ? void 0 : treeNodeFilterProp.value;
    if (!searchValueVal || filterTreeNode.value === false) {
      return treeData.value;
    }
    var filterOptionFunc;
    if (typeof filterTreeNode.value === "function") {
      filterOptionFunc = filterTreeNode.value;
    } else {
      var upperStr = searchValueVal.toUpperCase();
      filterOptionFunc = function filterOptionFunc2(_2, dataNode) {
        var value = dataNode[treeNodeFilterPropValue];
        return String(value).toUpperCase().includes(upperStr);
      };
    }
    function dig(list) {
      var keepAll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var res = [];
      for (var index2 = 0, len = list.length; index2 < len; index2++) {
        var dataNode = list[index2];
        var children = dataNode[fieldChildren];
        var match2 = keepAll || filterOptionFunc(searchValueVal, fillLegacyProps(dataNode));
        var childList = dig(children || [], match2);
        if (match2 || childList.length) {
          res.push(_extends$2(_extends$2({}, dataNode), _defineProperty$R({}, fieldChildren, childList)));
        }
      }
      return res;
    }
    return dig(treeData.value);
  });
};
function treeSelectProps$1() {
  return _extends$2(_extends$2({}, omit$3(baseSelectPropsWithoutPrivate(), ["mode"])), {
    prefixCls: String,
    id: String,
    value: {
      type: [String, Number, Object, Array]
    },
    defaultValue: {
      type: [String, Number, Object, Array]
    },
    onChange: {
      type: Function
    },
    searchValue: String,
    inputValue: String,
    onSearch: {
      type: Function
    },
    autoClearSearchValue: {
      type: Boolean,
      default: void 0
    },
    filterTreeNode: {
      type: [Boolean, Function],
      default: void 0
    },
    treeNodeFilterProp: String,
    onSelect: Function,
    onDeselect: Function,
    showCheckedStrategy: {
      type: String
    },
    treeNodeLabelProp: String,
    fieldNames: {
      type: Object
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    treeCheckable: {
      type: Boolean,
      default: void 0
    },
    treeCheckStrictly: {
      type: Boolean,
      default: void 0
    },
    labelInValue: {
      type: Boolean,
      default: void 0
    },
    treeData: {
      type: Array
    },
    treeDataSimpleMode: {
      type: [Boolean, Object],
      default: void 0
    },
    loadData: {
      type: Function
    },
    treeLoadedKeys: {
      type: Array
    },
    onTreeLoad: {
      type: Function
    },
    treeDefaultExpandAll: {
      type: Boolean,
      default: void 0
    },
    treeExpandedKeys: {
      type: Array
    },
    treeDefaultExpandedKeys: {
      type: Array
    },
    onTreeExpand: {
      type: Function
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    listHeight: Number,
    listItemHeight: Number,
    onDropdownVisibleChange: {
      type: Function
    },
    treeLine: {
      type: [Boolean, Object],
      default: void 0
    },
    treeIcon: PropTypes$1.any,
    showTreeIcon: {
      type: Boolean,
      default: void 0
    },
    switcherIcon: PropTypes$1.any,
    treeMotion: PropTypes$1.any,
    children: Array,
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showSearch: {
      type: Boolean,
      default: void 0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    defaultOpen: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    placeholder: PropTypes$1.any,
    maxTagPlaceholder: {
      type: Function
    },
    dropdownPopupAlign: PropTypes$1.any,
    customSlots: Object
  });
}
function isRawValue(value) {
  return !value || _typeof$2(value) !== "object";
}
var TreeSelect$2 = defineComponent({
  name: "TreeSelect",
  inheritAttrs: false,
  props: initDefaultProps$1(treeSelectProps$1(), {
    treeNodeFilterProp: "value",
    autoClearSearchValue: true,
    showCheckedStrategy: SHOW_CHILD,
    listHeight: 200,
    listItemHeight: 20,
    prefixCls: "vc-tree-select"
  }),
  setup: function setup154(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var mergedId = useId$1(toRef(props2, "id"));
    var treeConduction = computed(function() {
      return props2.treeCheckable && !props2.treeCheckStrictly;
    });
    var mergedCheckable = computed(function() {
      return props2.treeCheckable || props2.treeCheckStrictly;
    });
    var mergedLabelInValue = computed(function() {
      return props2.treeCheckStrictly || props2.labelInValue;
    });
    var mergedMultiple = computed(function() {
      return mergedCheckable.value || props2.multiple;
    });
    var mergedFieldNames = computed(function() {
      return fillFieldNames(props2.fieldNames);
    });
    var _useMergedState = useMergedState("", {
      value: computed(function() {
        return props2.searchValue !== void 0 ? props2.searchValue : props2.inputValue;
      }),
      postState: function postState(search) {
        return search || "";
      }
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    var onInternalSearch = function onInternalSearch2(searchText) {
      var _a2;
      setSearchValue(searchText);
      (_a2 = props2.onSearch) === null || _a2 === void 0 ? void 0 : _a2.call(props2, searchText);
    };
    var mergedTreeData = useTreeData(toRef(props2, "treeData"), toRef(props2, "children"), toRef(props2, "treeDataSimpleMode"));
    var _useDataEntities = useDataEntities(mergedTreeData, mergedFieldNames), keyEntities = _useDataEntities.keyEntities, valueEntities = _useDataEntities.valueEntities;
    var splitRawValues = function splitRawValues2(newRawValues) {
      var missingRawValues = [];
      var existRawValues = [];
      newRawValues.forEach(function(val) {
        if (valueEntities.value.has(val)) {
          existRawValues.push(val);
        } else {
          missingRawValues.push(val);
        }
      });
      return {
        missingRawValues,
        existRawValues
      };
    };
    var filteredTreeData = useFilterTreeData(mergedTreeData, mergedSearchValue, {
      fieldNames: mergedFieldNames,
      treeNodeFilterProp: toRef(props2, "treeNodeFilterProp"),
      filterTreeNode: toRef(props2, "filterTreeNode")
    });
    var getLabel = function getLabel2(item) {
      if (item) {
        if (props2.treeNodeLabelProp) {
          return item[props2.treeNodeLabelProp];
        }
        var titleList = mergedFieldNames.value._title;
        for (var i2 = 0; i2 < titleList.length; i2 += 1) {
          var title = item[titleList[i2]];
          if (title !== void 0) {
            return title;
          }
        }
      }
    };
    var toLabeledValues = function toLabeledValues2(draftValues) {
      var values = toArray(draftValues);
      return values.map(function(val) {
        if (isRawValue(val)) {
          return {
            value: val
          };
        }
        return val;
      });
    };
    var convert2LabelValues = function convert2LabelValues2(draftValues) {
      var values = toLabeledValues(draftValues);
      return values.map(function(item) {
        var rawLabel = item.label;
        var rawValue = item.value, rawHalfChecked = item.halfChecked;
        var rawDisabled;
        var entity = valueEntities.value.get(rawValue);
        if (entity) {
          rawLabel = rawLabel !== null && rawLabel !== void 0 ? rawLabel : getLabel(entity.node);
          rawDisabled = entity.node.disabled;
        }
        return {
          label: rawLabel,
          value: rawValue,
          halfChecked: rawHalfChecked,
          disabled: rawDisabled
        };
      });
    };
    var _useMergedState3 = useMergedState(props2.defaultValue, {
      value: toRef(props2, "value")
    }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    var rawMixedLabeledValues = computed(function() {
      return toLabeledValues(internalValue.value);
    });
    var rawLabeledValues = shallowRef([]);
    var rawHalfLabeledValues = shallowRef([]);
    watchEffect(function() {
      var fullCheckValues = [];
      var halfCheckValues = [];
      rawMixedLabeledValues.value.forEach(function(item) {
        if (item.halfChecked) {
          halfCheckValues.push(item);
        } else {
          fullCheckValues.push(item);
        }
      });
      rawLabeledValues.value = fullCheckValues;
      rawHalfLabeledValues.value = halfCheckValues;
    });
    var rawValues = computed(function() {
      return rawLabeledValues.value.map(function(item) {
        return item.value;
      });
    });
    var _useMaxLevel = useMaxLevel(keyEntities), maxLevel = _useMaxLevel.maxLevel, levelEntities = _useMaxLevel.levelEntities;
    var _useCheckedKeys = useCheckedKeys(rawLabeledValues, rawHalfLabeledValues, treeConduction, keyEntities, maxLevel, levelEntities), _useCheckedKeys2 = _slicedToArray$2(_useCheckedKeys, 2), rawCheckedValues = _useCheckedKeys2[0], rawHalfCheckedValues = _useCheckedKeys2[1];
    var displayValues = computed(function() {
      var displayKeys = formatStrategyValues(rawCheckedValues.value, props2.showCheckedStrategy, keyEntities.value, mergedFieldNames.value);
      var values = displayKeys.map(function(key2) {
        var _a2, _b, _c;
        return (_c = (_b = (_a2 = keyEntities.value[key2]) === null || _a2 === void 0 ? void 0 : _a2.node) === null || _b === void 0 ? void 0 : _b[mergedFieldNames.value.value]) !== null && _c !== void 0 ? _c : key2;
      });
      var labeledValues = values.map(function(val) {
        var targetItem = rawLabeledValues.value.find(function(item) {
          return item.value === val;
        });
        return {
          value: val,
          label: targetItem === null || targetItem === void 0 ? void 0 : targetItem.label
        };
      });
      var rawDisplayValues = convert2LabelValues(labeledValues);
      var firstVal = rawDisplayValues[0];
      if (!mergedMultiple.value && firstVal && isNil(firstVal.value) && isNil(firstVal.label)) {
        return [];
      }
      return rawDisplayValues.map(function(item) {
        var _a2;
        return _extends$2(_extends$2({}, item), {
          label: (_a2 = item.label) !== null && _a2 !== void 0 ? _a2 : item.value
        });
      });
    });
    var _useCache = useCache$1(displayValues), _useCache2 = _slicedToArray$2(_useCache, 1), cachedDisplayValues = _useCache2[0];
    var triggerChange = function triggerChange2(newRawValues, extra, source) {
      var labeledValues = convert2LabelValues(newRawValues);
      setInternalValue(labeledValues);
      if (props2.autoClearSearchValue) {
        setSearchValue("");
      }
      if (props2.onChange) {
        var eventValues = newRawValues;
        if (treeConduction.value) {
          var formattedKeyList = formatStrategyValues(newRawValues, props2.showCheckedStrategy, keyEntities.value, mergedFieldNames.value);
          eventValues = formattedKeyList.map(function(key2) {
            var entity = valueEntities.value.get(key2);
            return entity ? entity.node[mergedFieldNames.value.value] : key2;
          });
        }
        var _ref2 = extra || {
          triggerValue: void 0,
          selected: void 0
        }, triggerValue = _ref2.triggerValue, selected = _ref2.selected;
        var returnRawValues = eventValues;
        if (props2.treeCheckStrictly) {
          var halfValues = rawHalfLabeledValues.value.filter(function(item) {
            return !eventValues.includes(item.value);
          });
          returnRawValues = [].concat(_toConsumableArray(returnRawValues), _toConsumableArray(halfValues));
        }
        var returnLabeledValues = convert2LabelValues(returnRawValues);
        var additionalInfo = {
          preValue: rawLabeledValues.value,
          triggerValue
        };
        var showPosition = true;
        if (props2.treeCheckStrictly || source === "selection" && !selected) {
          showPosition = false;
        }
        fillAdditionalInfo(additionalInfo, triggerValue, newRawValues, mergedTreeData.value, showPosition, mergedFieldNames.value);
        if (mergedCheckable.value) {
          additionalInfo.checked = selected;
        } else {
          additionalInfo.selected = selected;
        }
        var returnValues = mergedLabelInValue.value ? returnLabeledValues : returnLabeledValues.map(function(item) {
          return item.value;
        });
        props2.onChange(mergedMultiple.value ? returnValues : returnValues[0], mergedLabelInValue.value ? null : returnLabeledValues.map(function(item) {
          return item.label;
        }), additionalInfo);
      }
    };
    var onOptionSelect = function onOptionSelect2(selectedKey, _ref3) {
      var selected = _ref3.selected, source = _ref3.source;
      var _a2, _b, _c;
      var keyEntitiesValue = toRaw(keyEntities.value);
      var valueEntitiesValue = toRaw(valueEntities.value);
      var entity = keyEntitiesValue[selectedKey];
      var node = entity === null || entity === void 0 ? void 0 : entity.node;
      var selectedValue = (_a2 = node === null || node === void 0 ? void 0 : node[mergedFieldNames.value.value]) !== null && _a2 !== void 0 ? _a2 : selectedKey;
      if (!mergedMultiple.value) {
        triggerChange([selectedValue], {
          selected: true,
          triggerValue: selectedValue
        }, "option");
      } else {
        var newRawValues = selected ? [].concat(_toConsumableArray(rawValues.value), [selectedValue]) : rawCheckedValues.value.filter(function(v2) {
          return v2 !== selectedValue;
        });
        if (treeConduction.value) {
          var _splitRawValues = splitRawValues(newRawValues), missingRawValues = _splitRawValues.missingRawValues, existRawValues = _splitRawValues.existRawValues;
          var keyList = existRawValues.map(function(val) {
            return valueEntitiesValue.get(val).key;
          });
          var checkedKeys;
          if (selected) {
            var _conductCheck = conductCheck(keyList, true, keyEntitiesValue, maxLevel.value, levelEntities.value);
            checkedKeys = _conductCheck.checkedKeys;
          } else {
            var _conductCheck2 = conductCheck(keyList, {
              checked: false,
              halfCheckedKeys: rawHalfCheckedValues.value
            }, keyEntitiesValue, maxLevel.value, levelEntities.value);
            checkedKeys = _conductCheck2.checkedKeys;
          }
          newRawValues = [].concat(_toConsumableArray(missingRawValues), _toConsumableArray(checkedKeys.map(function(key2) {
            return keyEntitiesValue[key2].node[mergedFieldNames.value.value];
          })));
        }
        triggerChange(newRawValues, {
          selected,
          triggerValue: selectedValue
        }, source || "option");
      }
      if (selected || !mergedMultiple.value) {
        (_b = props2.onSelect) === null || _b === void 0 ? void 0 : _b.call(props2, selectedValue, fillLegacyProps(node));
      } else {
        (_c = props2.onDeselect) === null || _c === void 0 ? void 0 : _c.call(props2, selectedValue, fillLegacyProps(node));
      }
    };
    var onInternalDropdownVisibleChange = function onInternalDropdownVisibleChange2(open2) {
      if (props2.onDropdownVisibleChange) {
        var legacyParam = {};
        Object.defineProperty(legacyParam, "documentClickClose", {
          get: function get2() {
            return false;
          }
        });
        props2.onDropdownVisibleChange(open2, legacyParam);
      }
    };
    var onDisplayValuesChange = function onDisplayValuesChange2(newValues, info) {
      var newRawValues = newValues.map(function(item) {
        return item.value;
      });
      if (info.type === "clear") {
        triggerChange(newRawValues, {}, "selection");
        return;
      }
      if (info.values.length) {
        onOptionSelect(info.values[0].value, {
          selected: false,
          source: "selection"
        });
      }
    };
    var _toRefs = toRefs(props2), treeNodeFilterProp = _toRefs.treeNodeFilterProp, loadData = _toRefs.loadData, treeLoadedKeys = _toRefs.treeLoadedKeys, onTreeLoad = _toRefs.onTreeLoad, treeDefaultExpandAll = _toRefs.treeDefaultExpandAll, treeExpandedKeys = _toRefs.treeExpandedKeys, treeDefaultExpandedKeys = _toRefs.treeDefaultExpandedKeys, onTreeExpand = _toRefs.onTreeExpand, virtual = _toRefs.virtual, listHeight = _toRefs.listHeight, listItemHeight = _toRefs.listItemHeight, treeLine = _toRefs.treeLine, treeIcon = _toRefs.treeIcon, showTreeIcon = _toRefs.showTreeIcon, switcherIcon = _toRefs.switcherIcon, treeMotion = _toRefs.treeMotion, customSlots = _toRefs.customSlots;
    useProvideLegacySelectContext(toReactive({
      checkable: mergedCheckable,
      loadData,
      treeLoadedKeys,
      onTreeLoad,
      checkedKeys: rawCheckedValues,
      halfCheckedKeys: rawHalfCheckedValues,
      treeDefaultExpandAll,
      treeExpandedKeys,
      treeDefaultExpandedKeys,
      onTreeExpand,
      treeIcon,
      treeMotion,
      showTreeIcon,
      switcherIcon,
      treeLine,
      treeNodeFilterProp,
      keyEntities,
      customSlots
    }));
    useProvideSelectContext(toReactive({
      virtual,
      listHeight,
      listItemHeight,
      treeData: filteredTreeData,
      fieldNames: mergedFieldNames,
      onSelect: onOptionSelect
    }));
    var selectRef = ref();
    expose({
      focus: function focus2() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: function blur() {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      },
      scrollTo: function scrollTo2(arg) {
        var _a2;
        (_a2 = selectRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg);
      }
    });
    return function() {
      var _a2;
      var restProps = omit$3(props2, [
        "id",
        "prefixCls",
        "value",
        "defaultValue",
        "onChange",
        "onSelect",
        "onDeselect",
        "searchValue",
        "inputValue",
        "onSearch",
        "autoClearSearchValue",
        "filterTreeNode",
        "treeNodeFilterProp",
        "showCheckedStrategy",
        "treeNodeLabelProp",
        "multiple",
        "treeCheckable",
        "treeCheckStrictly",
        "labelInValue",
        "fieldNames",
        "treeDataSimpleMode",
        "treeData",
        "children",
        "loadData",
        "treeLoadedKeys",
        "onTreeLoad",
        "treeDefaultExpandAll",
        "treeExpandedKeys",
        "treeDefaultExpandedKeys",
        "onTreeExpand",
        "virtual",
        "listHeight",
        "listItemHeight",
        "onDropdownVisibleChange",
        "treeLine",
        "treeIcon",
        "showTreeIcon",
        "switcherIcon",
        "treeMotion"
      ]);
      return createVNode(BaseSelect, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
        "ref": selectRef
      }, attrs), restProps), {}, {
        "id": mergedId,
        "prefixCls": props2.prefixCls,
        "mode": mergedMultiple.value ? "multiple" : void 0,
        "displayValues": cachedDisplayValues.value,
        "onDisplayValuesChange": onDisplayValuesChange,
        "searchValue": mergedSearchValue.value,
        "onSearch": onInternalSearch,
        "OptionList": OptionList,
        "emptyOptions": !mergedTreeData.value.length,
        "onDropdownVisibleChange": onInternalDropdownVisibleChange,
        "tagRender": props2.tagRender || slots.tagRender,
        "dropdownMatchSelectWidth": (_a2 = props2.dropdownMatchSelectWidth) !== null && _a2 !== void 0 ? _a2 : true
      }), slots);
    };
  }
});
var getTransitionName2 = function getTransitionName3(rootPrefixCls, motion, transitionName2) {
  if (transitionName2 !== void 0) {
    return transitionName2;
  }
  return "".concat(rootPrefixCls, "-").concat(motion);
};
function treeSelectProps() {
  return _extends$2(_extends$2({}, omit$3(treeSelectProps$1(), ["showTreeIcon", "treeMotion", "inputIcon", "getInputElement", "treeLine", "customSlots"])), {
    suffixIcon: PropTypes$1.any,
    size: {
      type: String
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    treeLine: {
      type: [Boolean, Object],
      default: void 0
    },
    replaceFields: {
      type: Object
    },
    "onUpdate:value": {
      type: Function
    },
    "onUpdate:treeExpandedKeys": {
      type: Function
    },
    "onUpdate:searchValue": {
      type: Function
    }
  });
}
var TreeSelect = defineComponent({
  name: "ATreeSelect",
  inheritAttrs: false,
  props: initDefaultProps$1(treeSelectProps(), {
    choiceTransitionName: "",
    listHeight: 256,
    treeIcon: false,
    listItemHeight: 26,
    bordered: true
  }),
  slots: ["title", "titleRender", "placeholder", "maxTagPlaceholder", "treeIcon", "switcherIcon", "notFoundContent"],
  setup: function setup155(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose, emit = _ref.emit;
    warning$3(!(props2.treeData === void 0 && slots.default));
    watchEffect(function() {
      devWarning(props2.multiple !== false || !props2.treeCheckable, "TreeSelect", "`multiple` will always be `true` when `treeCheckable` is true");
      devWarning(props2.replaceFields === void 0, "TreeSelect", "`replaceFields` is deprecated, please use fieldNames instead");
    });
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("select", props2), prefixCls2 = _useConfigInject.prefixCls, renderEmpty2 = _useConfigInject.renderEmpty, direction2 = _useConfigInject.direction, virtual = _useConfigInject.virtual, dropdownMatchSelectWidth = _useConfigInject.dropdownMatchSelectWidth, size = _useConfigInject.size, getPopupContainer = _useConfigInject.getPopupContainer, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var rootPrefixCls = computed(function() {
      return getPrefixCls2();
    });
    var transitionName2 = computed(function() {
      return getTransitionName2(rootPrefixCls.value, "slide-up", props2.transitionName);
    });
    var choiceTransitionName = computed(function() {
      return getTransitionName2(rootPrefixCls.value, "", props2.choiceTransitionName);
    });
    var treePrefixCls = computed(function() {
      return getPrefixCls2("select-tree", props2.prefixCls);
    });
    var treeSelectPrefixCls = computed(function() {
      return getPrefixCls2("tree-select", props2.prefixCls);
    });
    var mergedDropdownClassName = computed(function() {
      return classNames(props2.dropdownClassName, "".concat(treeSelectPrefixCls.value, "-dropdown"), _defineProperty$R({}, "".concat(treeSelectPrefixCls.value, "-dropdown-rtl"), direction2.value === "rtl"));
    });
    var isMultiple2 = computed(function() {
      return !!(props2.treeCheckable || props2.multiple);
    });
    var treeSelectRef = ref();
    expose({
      focus: function focus2() {
        var _a2, _b;
        (_b = (_a2 = treeSelectRef.value).focus) === null || _b === void 0 ? void 0 : _b.call(_a2);
      },
      blur: function blur() {
        var _a2, _b;
        (_b = (_a2 = treeSelectRef.value).blur) === null || _b === void 0 ? void 0 : _b.call(_a2);
      }
    });
    var handleChange2 = function handleChange3() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      emit("update:value", args[0]);
      emit.apply(void 0, ["change"].concat(args));
      formItemContext.onFieldChange();
    };
    var handleTreeExpand = function handleTreeExpand2(keys2) {
      emit("update:treeExpandedKeys", keys2);
      emit("treeExpand", keys2);
    };
    var handleSearch = function handleSearch2(value) {
      emit("update:searchValue", value);
      emit("search", value);
    };
    var handleBlur = function handleBlur2(e2) {
      emit("blur", e2);
      formItemContext.onFieldBlur();
    };
    return function() {
      var _classNames2;
      var _a2, _b;
      var _props$notFoundConten = props2.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? (_a2 = slots.notFoundContent) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : _props$notFoundConten, customizePrefixCls = props2.prefixCls, bordered = props2.bordered, listHeight = props2.listHeight, listItemHeight = props2.listItemHeight, multiple = props2.multiple, treeIcon = props2.treeIcon, treeLine = props2.treeLine, _props$switcherIcon = props2.switcherIcon, _switcherIcon = _props$switcherIcon === void 0 ? (_b = slots.switcherIcon) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$switcherIcon, _props$fieldNames = props2.fieldNames, fieldNames = _props$fieldNames === void 0 ? props2.replaceFields : _props$fieldNames, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id;
      var _getIcons = getIcons(_extends$2(_extends$2({}, props2), {
        multiple: isMultiple2.value,
        prefixCls: prefixCls2.value
      }), slots), suffixIcon = _getIcons.suffixIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
      var mergedNotFound;
      if (notFoundContent !== void 0) {
        mergedNotFound = notFoundContent;
      } else {
        mergedNotFound = renderEmpty2.value("Select");
      }
      var selectProps3 = omit$3(props2, ["suffixIcon", "itemIcon", "removeIcon", "clearIcon", "switcherIcon", "bordered", "onUpdate:value", "onUpdate:treeExpandedKeys", "onUpdate:searchValue"]);
      var mergedClassName = classNames(!customizePrefixCls && treeSelectPrefixCls.value, (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-lg"), size.value === "large"), _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-sm"), size.value === "small"), _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-borderless"), !bordered), _classNames2), attrs.class);
      var otherProps = {};
      if (props2.treeData === void 0 && slots.default) {
        otherProps.children = flattenChildren(slots.default());
      }
      return createVNode(TreeSelect$2, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, attrs), selectProps3), {}, {
        "virtual": virtual.value,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth.value,
        "id": id,
        "fieldNames": fieldNames,
        "ref": treeSelectRef,
        "prefixCls": prefixCls2.value,
        "class": mergedClassName,
        "listHeight": listHeight,
        "listItemHeight": listItemHeight,
        "treeLine": !!treeLine,
        "inputIcon": suffixIcon,
        "multiple": multiple,
        "removeIcon": removeIcon,
        "clearIcon": clearIcon,
        "switcherIcon": function switcherIcon(nodeProps) {
          return renderSwitcherIcon(treePrefixCls.value, _switcherIcon, treeLine, nodeProps);
        },
        "showTreeIcon": treeIcon,
        "notFoundContent": mergedNotFound,
        "getPopupContainer": getPopupContainer.value,
        "treeMotion": null,
        "dropdownClassName": mergedDropdownClassName.value,
        "choiceTransitionName": choiceTransitionName.value,
        "onChange": handleChange2,
        "onBlur": handleBlur,
        "onSearch": handleSearch,
        "onTreeExpand": handleTreeExpand
      }, otherProps), {}, {
        "transitionName": transitionName2.value,
        "customSlots": _extends$2(_extends$2({}, slots), {
          treeCheckable: function treeCheckable() {
            return createVNode("span", {
              "class": "".concat(prefixCls2.value, "-tree-checkbox-inner")
            }, null);
          }
        }),
        "maxTagPlaceholder": props2.maxTagPlaceholder || slots.maxTagPlaceholder
      }), _extends$2(_extends$2({}, slots), {
        treeCheckable: function treeCheckable() {
          return createVNode("span", {
            "class": "".concat(prefixCls2.value, "-tree-checkbox-inner")
          }, null);
        }
      }));
    };
  }
});
var TreeSelectNode = TreeNode$1;
var TreeSelect$1 = _extends$2(TreeSelect, {
  TreeNode: TreeNode$1,
  SHOW_ALL,
  SHOW_PARENT,
  SHOW_CHILD,
  install: function install6(app) {
    app.component(TreeSelect.name, TreeSelect);
    app.component(TreeSelectNode.displayName, TreeSelectNode);
    return app;
  }
});
var __rest$2 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var timePickerProps = function timePickerProps2() {
  return {
    format: String,
    showNow: {
      type: Boolean,
      default: void 0
    },
    showHour: {
      type: Boolean,
      default: void 0
    },
    showMinute: {
      type: Boolean,
      default: void 0
    },
    showSecond: {
      type: Boolean,
      default: void 0
    },
    use12Hours: {
      type: Boolean,
      default: void 0
    },
    hourStep: Number,
    minuteStep: Number,
    secondStep: Number,
    hideDisabledOptions: {
      type: Boolean,
      default: void 0
    },
    popupClassName: String
  };
};
function createTimePicker(generateConfig2) {
  var DatePicker2 = generatePicker(generateConfig2, _extends$2(_extends$2({}, timePickerProps()), {
    order: {
      type: Boolean,
      default: true
    }
  }));
  var InternalTimePicker = DatePicker2.TimePicker, InternalRangePicker = DatePicker2.RangePicker;
  var TimePicker2 = defineComponent({
    name: "ATimePicker",
    inheritAttrs: false,
    props: _extends$2(_extends$2(_extends$2(_extends$2({}, commonProps()), datePickerProps()), timePickerProps()), {
      addon: {
        type: Function
      }
    }),
    slot: ["addon", "renderExtraFooter", "suffixIcon", "clearIcon"],
    setup: function setup162(props2, _ref) {
      var slots = _ref.slots, expose = _ref.expose, emit = _ref.emit, attrs = _ref.attrs;
      var formItemContext = useInjectFormItemContext();
      devWarning(!(slots.addon || props2.addon), "TimePicker", "`addon` is deprecated. Please use `v-slot:renderExtraFooter` instead.");
      var pickerRef = ref();
      expose({
        focus: function focus2() {
          var _a2;
          (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        },
        blur: function blur() {
          var _a2;
          (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
        }
      });
      var onChange3 = function onChange4(value, dateString) {
        emit("update:value", value);
        emit("change", value, dateString);
        formItemContext.onFieldChange();
      };
      var onOpenChange = function onOpenChange2(open2) {
        emit("update:open", open2);
        emit("openChange", open2);
      };
      var onFocus2 = function onFocus3(e2) {
        emit("focus", e2);
      };
      var onBlur2 = function onBlur3(e2) {
        emit("blur", e2);
        formItemContext.onFieldBlur();
      };
      var onOk = function onOk2(value) {
        emit("ok", value);
      };
      return function() {
        var _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, restProps = __rest$2(props2, ["id"]);
        return createVNode(InternalTimePicker, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, attrs), omit$3(restProps, ["onUpdate:value", "onUpdate:open"])), {}, {
          "id": id,
          "dropdownClassName": props2.popupClassName,
          "mode": void 0,
          "ref": pickerRef,
          "renderExtraFooter": props2.addon || slots.addon || props2.renderExtraFooter || slots.renderExtraFooter,
          "onChange": onChange3,
          "onOpenChange": onOpenChange,
          "onFocus": onFocus2,
          "onBlur": onBlur2,
          "onOk": onOk
        }), slots);
      };
    }
  });
  var TimeRangePicker2 = defineComponent({
    name: "ATimeRangePicker",
    inheritAttrs: false,
    props: _extends$2(_extends$2(_extends$2(_extends$2({}, commonProps()), rangePickerProps()), timePickerProps()), {
      order: {
        type: Boolean,
        default: true
      }
    }),
    slot: ["renderExtraFooter", "suffixIcon", "clearIcon"],
    setup: function setup162(props2, _ref2) {
      var slots = _ref2.slots, expose = _ref2.expose, emit = _ref2.emit, attrs = _ref2.attrs;
      var pickerRef = ref();
      var formItemContext = useInjectFormItemContext();
      expose({
        focus: function focus2() {
          var _a2;
          (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        },
        blur: function blur() {
          var _a2;
          (_a2 = pickerRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
        }
      });
      var onChange3 = function onChange4(values, dateStrings) {
        emit("update:value", values);
        emit("change", values, dateStrings);
        formItemContext.onFieldChange();
      };
      var onOpenChange = function onOpenChange2(open2) {
        emit("update:open", open2);
        emit("openChange", open2);
      };
      var onFocus2 = function onFocus3(e2) {
        emit("focus", e2);
      };
      var onBlur2 = function onBlur3(e2) {
        emit("blur", e2);
        formItemContext.onFieldBlur();
      };
      var onPanelChange = function onPanelChange2(values, modes) {
        emit("panelChange", values, modes);
      };
      var onOk = function onOk2(values) {
        emit("ok", values);
      };
      var onCalendarChange = function onCalendarChange2(values, dateStrings, info) {
        emit("calendarChange", values, dateStrings, info);
      };
      return function() {
        var _props$id2 = props2.id, id = _props$id2 === void 0 ? formItemContext.id.value : _props$id2, restProps = __rest$2(props2, ["id"]);
        return createVNode(InternalRangePicker, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, attrs), omit$3(restProps, ["onUpdate:open", "onUpdate:value"])), {}, {
          "id": id,
          "dropdownClassName": props2.popupClassName,
          "picker": "time",
          "mode": void 0,
          "ref": pickerRef,
          "onChange": onChange3,
          "onOpenChange": onOpenChange,
          "onFocus": onFocus2,
          "onBlur": onBlur2,
          "onPanelChange": onPanelChange,
          "onOk": onOk,
          "onCalendarChange": onCalendarChange
        }), slots);
      };
    }
  });
  return {
    TimePicker: TimePicker2,
    TimeRangePicker: TimeRangePicker2
  };
}
var _createTimePicker = createTimePicker(dayjsGenerateConfig), TimePicker = _createTimePicker.TimePicker, TimeRangePicker = _createTimePicker.TimeRangePicker;
var TimePicker$1 = _extends$2(TimePicker, {
  TimePicker,
  TimeRangePicker,
  install: function install7(app) {
    app.component(TimePicker.name, TimePicker);
    app.component(TimeRangePicker.name, TimeRangePicker);
    return app;
  }
});
function getError(option2, xhr) {
  var msg = "cannot ".concat(option2.method, " ").concat(option2.action, " ").concat(xhr.status, "'");
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option2.method;
  err.url = option2.action;
  return err;
}
function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }
  try {
    return JSON.parse(text);
  } catch (e2) {
    return text;
  }
}
function upload(option2) {
  var xhr = new XMLHttpRequest();
  if (option2.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e2) {
      if (e2.total > 0) {
        e2.percent = e2.loaded / e2.total * 100;
      }
      option2.onProgress(e2);
    };
  }
  var formData = new FormData();
  if (option2.data) {
    Object.keys(option2.data).forEach(function(key2) {
      var value = option2.data[key2];
      if (Array.isArray(value)) {
        value.forEach(function(item) {
          formData.append("".concat(key2, "[]"), item);
        });
        return;
      }
      formData.append(key2, value);
    });
  }
  if (option2.file instanceof Blob) {
    formData.append(option2.filename, option2.file, option2.file.name);
  } else {
    formData.append(option2.filename, option2.file);
  }
  xhr.onerror = function error(e2) {
    option2.onError(e2);
  };
  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option2.onError(getError(option2, xhr), getBody(xhr));
    }
    return option2.onSuccess(getBody(xhr), xhr);
  };
  xhr.open(option2.method, option2.action, true);
  if (option2.withCredentials && "withCredentials" in xhr) {
    xhr.withCredentials = true;
  }
  var headers = option2.headers || {};
  if (headers["X-Requested-With"] !== null) {
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  }
  Object.keys(headers).forEach(function(h2) {
    if (headers[h2] !== null) {
      xhr.setRequestHeader(h2, headers[h2]);
    }
  });
  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}
var now = +new Date();
var index$a = 0;
function uid() {
  return "vc-upload-".concat(now, "-").concat(++index$a);
}
var attrAccept = function(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    var fileName = file.name || "";
    var mimeType = file.type || "";
    var baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function(type4) {
      var validType = type4.trim();
      if (/^\*(\/\*)?$/.test(type4)) {
        return true;
      }
      if (validType.charAt(0) === ".") {
        var lowerFileName = fileName.toLowerCase();
        var lowerType = validType.toLowerCase();
        var affixList = [lowerType];
        if (lowerType === ".jpg" || lowerType === ".jpeg") {
          affixList = [".jpg", ".jpeg"];
        }
        return affixList.some(function(affix) {
          return lowerFileName.endsWith(affix);
        });
      }
      if (/\/\*$/.test(validType)) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      if (mimeType === validType) {
        return true;
      }
      if (/^\w+$/.test(validType)) {
        return true;
      }
      return false;
    });
  }
  return true;
};
function loopFiles(item, callback) {
  var dirReader = item.createReader();
  var fileList = [];
  function sequence() {
    dirReader.readEntries(function(entries) {
      var entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList);
      var isFinished = !entryList.length;
      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }
  sequence();
}
var traverseFileTree = function traverseFileTree2(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree2(item, path) {
    item.path = path || "";
    if (item.isFile) {
      item.file(function(file) {
        if (isAccepted(file)) {
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true
              }
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, "");
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false
              }
            });
          }
          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, function(entries) {
        entries.forEach(function(entryItem) {
          _traverseFileTree2(entryItem, "".concat(path).concat(item.name, "/"));
        });
      });
    }
  };
  files.forEach(function(file) {
    _traverseFileTree(file.webkitGetAsEntry());
  });
};
var traverseFileTree$1 = traverseFileTree;
var uploadProps$1 = function uploadProps() {
  return {
    capture: [Boolean, String],
    multipart: {
      type: Boolean,
      default: void 0
    },
    name: String,
    disabled: {
      type: Boolean,
      default: void 0
    },
    componentTag: String,
    action: [String, Function],
    method: String,
    directory: {
      type: Boolean,
      default: void 0
    },
    data: [Object, Function],
    headers: Object,
    accept: String,
    multiple: {
      type: Boolean,
      default: void 0
    },
    onBatchStart: Function,
    onReject: Function,
    onStart: Function,
    onError: Function,
    onSuccess: Function,
    onProgress: Function,
    beforeUpload: Function,
    customRequest: Function,
    withCredentials: {
      type: Boolean,
      default: void 0
    },
    openFileDialogOnClick: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    id: String,
    onMouseenter: Function,
    onMouseleave: Function,
    onClick: Function
  };
};
function arrayAggregator(array4, setter, iteratee, accumulator) {
  var index2 = -1, length = array4 == null ? 0 : array4.length;
  while (++index2 < length) {
    var value = array4[index2];
    setter(accumulator, value, iteratee(value), array4);
  }
  return accumulator;
}
function createBaseFor(fromRight) {
  return function(object4, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object4), props2 = keysFunc(object4), length = props2.length;
    while (length--) {
      var key2 = props2[fromRight ? length : ++index2];
      if (iteratee(iterable[key2], key2, iterable) === false) {
        break;
      }
    }
    return object4;
  };
}
var baseFor = createBaseFor();
var baseFor$1 = baseFor;
function baseForOwn(object4, iteratee) {
  return object4 && baseFor$1(object4, iteratee, keys);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
var baseEach$1 = baseEach;
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach$1(collection, function(value, key2, collection2) {
    setter(accumulator, value, iteratee(value), collection2);
  });
  return accumulator;
}
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray$3(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}
var partition = createAggregator(function(result, value, key2) {
  result[key2 ? 0 : 1].push(value);
}, function() {
  return [[], []];
});
var partition$1 = partition;
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest$1 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var AjaxUpload = defineComponent({
  name: "AjaxUploader",
  inheritAttrs: false,
  props: uploadProps$1(),
  setup: function setup156(props2, _ref) {
    var _this = this;
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var uid$1 = ref(uid());
    var reqs = {};
    var fileInput = ref();
    var isMounted = false;
    var processFile = function processFile2(file, fileList) {
      return __awaiter$1(_this, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee() {
        var beforeUpload, transformedFile, action, mergedAction, data6, mergedData, parsedData, parsedFile, mergedParsedFile;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                beforeUpload = props2.beforeUpload;
                transformedFile = file;
                if (!beforeUpload) {
                  _context.next = 14;
                  break;
                }
                _context.prev = 3;
                _context.next = 6;
                return beforeUpload(file, fileList);
              case 6:
                transformedFile = _context.sent;
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                transformedFile = false;
              case 12:
                if (!(transformedFile === false)) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", {
                  origin: file,
                  parsedFile: null,
                  action: null,
                  data: null
                });
              case 14:
                action = props2.action;
                if (!(typeof action === "function")) {
                  _context.next = 21;
                  break;
                }
                _context.next = 18;
                return action(file);
              case 18:
                mergedAction = _context.sent;
                _context.next = 22;
                break;
              case 21:
                mergedAction = action;
              case 22:
                data6 = props2.data;
                if (!(typeof data6 === "function")) {
                  _context.next = 29;
                  break;
                }
                _context.next = 26;
                return data6(file);
              case 26:
                mergedData = _context.sent;
                _context.next = 30;
                break;
              case 29:
                mergedData = data6;
              case 30:
                parsedData = (_typeof$2(transformedFile) === "object" || typeof transformedFile === "string") && transformedFile ? transformedFile : file;
                if (parsedData instanceof File) {
                  parsedFile = parsedData;
                } else {
                  parsedFile = new File([parsedData], file.name, {
                    type: file.type
                  });
                }
                mergedParsedFile = parsedFile;
                mergedParsedFile.uid = file.uid;
                return _context.abrupt("return", {
                  origin: file,
                  data: mergedData,
                  parsedFile: mergedParsedFile,
                  action: mergedAction
                });
              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 9]]);
      }));
    };
    var post = function post2(_ref2) {
      var data6 = _ref2.data, origin = _ref2.origin, action = _ref2.action, parsedFile = _ref2.parsedFile;
      if (!isMounted) {
        return;
      }
      var onStart3 = props2.onStart, customRequest = props2.customRequest, name2 = props2.name, headers = props2.headers, withCredentials = props2.withCredentials, method4 = props2.method;
      var uid2 = origin.uid;
      var request = customRequest || upload;
      var requestOption = {
        action,
        filename: name2,
        data: data6,
        file: parsedFile,
        headers,
        withCredentials,
        method: method4 || "post",
        onProgress: function onProgress(e2) {
          var onProgress2 = props2.onProgress;
          onProgress2 === null || onProgress2 === void 0 ? void 0 : onProgress2(e2, parsedFile);
        },
        onSuccess: function onSuccess(ret, xhr) {
          var onSuccess2 = props2.onSuccess;
          onSuccess2 === null || onSuccess2 === void 0 ? void 0 : onSuccess2(ret, parsedFile, xhr);
          delete reqs[uid2];
        },
        onError: function onError(err, ret) {
          var onError2 = props2.onError;
          onError2 === null || onError2 === void 0 ? void 0 : onError2(err, ret, parsedFile);
          delete reqs[uid2];
        }
      };
      onStart3(origin);
      reqs[uid2] = request(requestOption);
    };
    var reset = function reset2() {
      uid$1.value = uid();
    };
    var abort = function abort2(file) {
      if (file) {
        var _uid = file.uid ? file.uid : file;
        if (reqs[_uid] && reqs[_uid].abort) {
          reqs[_uid].abort();
        }
        delete reqs[_uid];
      } else {
        Object.keys(reqs).forEach(function(uid2) {
          if (reqs[uid2] && reqs[uid2].abort) {
            reqs[uid2].abort();
          }
          delete reqs[uid2];
        });
      }
    };
    onMounted(function() {
      isMounted = true;
    });
    onBeforeUnmount(function() {
      isMounted = false;
      abort();
    });
    var uploadFiles = function uploadFiles2(files) {
      var originFiles = _toConsumableArray(files);
      var postFiles = originFiles.map(function(file) {
        file.uid = uid();
        return processFile(file, originFiles);
      });
      Promise.all(postFiles).then(function(fileList) {
        var onBatchStart = props2.onBatchStart;
        onBatchStart === null || onBatchStart === void 0 ? void 0 : onBatchStart(fileList.map(function(_ref3) {
          var origin = _ref3.origin, parsedFile = _ref3.parsedFile;
          return {
            file: origin,
            parsedFile
          };
        }));
        fileList.filter(function(file) {
          return file.parsedFile !== null;
        }).forEach(function(file) {
          post(file);
        });
      });
    };
    var onChange3 = function onChange4(e2) {
      var accept = props2.accept, directory = props2.directory;
      var files = e2.target.files;
      var acceptedFiles = _toConsumableArray(files).filter(function(file) {
        return !directory || attrAccept(file, accept);
      });
      uploadFiles(acceptedFiles);
      reset();
    };
    var onClick2 = function onClick3(e2) {
      var el = fileInput.value;
      if (!el) {
        return;
      }
      var onClick4 = props2.onClick;
      el.click();
      if (onClick4) {
        onClick4(e2);
      }
    };
    var onKeyDown = function onKeyDown2(e2) {
      if (e2.key === "Enter") {
        onClick2(e2);
      }
    };
    var onFileDrop = function onFileDrop2(e2) {
      var multiple = props2.multiple;
      e2.preventDefault();
      if (e2.type === "dragover") {
        return;
      }
      if (props2.directory) {
        traverseFileTree$1(Array.prototype.slice.call(e2.dataTransfer.items), uploadFiles, function(_file) {
          return attrAccept(_file, props2.accept);
        });
      } else {
        var files = partition$1(Array.prototype.slice.call(e2.dataTransfer.files), function(file) {
          return attrAccept(file, props2.accept);
        });
        var successFiles = files[0];
        var errorFiles = files[1];
        if (multiple === false) {
          successFiles = successFiles.slice(0, 1);
        }
        uploadFiles(successFiles);
        if (errorFiles.length && props2.onReject)
          props2.onReject(errorFiles);
      }
    };
    expose({
      abort
    });
    return function() {
      var _cls;
      var _a2;
      var Tag2 = props2.componentTag, prefixCls2 = props2.prefixCls, disabled = props2.disabled, id = props2.id, multiple = props2.multiple, accept = props2.accept, capture = props2.capture, directory = props2.directory, openFileDialogOnClick = props2.openFileDialogOnClick, onMouseenter2 = props2.onMouseenter, onMouseleave2 = props2.onMouseleave, otherProps = __rest$1(props2, ["componentTag", "prefixCls", "disabled", "id", "multiple", "accept", "capture", "directory", "openFileDialogOnClick", "onMouseenter", "onMouseleave"]);
      var cls = (_cls = {}, _defineProperty$R(_cls, prefixCls2, true), _defineProperty$R(_cls, "".concat(prefixCls2, "-disabled"), disabled), _defineProperty$R(_cls, attrs.class, !!attrs.class), _cls);
      var dirProps = directory ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {};
      var events2 = disabled ? {} : {
        onClick: openFileDialogOnClick ? onClick2 : function() {
        },
        onKeydown: openFileDialogOnClick ? onKeyDown : function() {
        },
        onMouseenter: onMouseenter2,
        onMouseleave: onMouseleave2,
        onDrop: onFileDrop,
        onDragover: onFileDrop,
        tabindex: "0"
      };
      return createVNode(Tag2, _objectSpread2$2(_objectSpread2$2({}, events2), {}, {
        "class": cls,
        "role": "button",
        "style": attrs.style
      }), {
        default: function _default7() {
          return [createVNode("input", _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, pickAttrs(otherProps, {
            aria: true,
            data: true
          })), {}, {
            "id": id,
            "type": "file",
            "ref": fileInput,
            "onClick": function onClick3(e2) {
              return e2.stopPropagation();
            },
            "key": uid$1.value,
            "style": {
              display: "none"
            },
            "accept": accept
          }, dirProps), {}, {
            "multiple": multiple,
            "onChange": onChange3
          }, capture != null ? {
            capture
          } : {}), null), (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots)];
        }
      });
    };
  }
});
function empty() {
}
var Upload$2 = defineComponent({
  name: "Upload",
  inheritAttrs: false,
  props: initDefaultProps$1(uploadProps$1(), {
    componentTag: "span",
    prefixCls: "rc-upload",
    data: {},
    headers: {},
    name: "file",
    multipart: false,
    onStart: empty,
    onError: empty,
    onSuccess: empty,
    multiple: false,
    beforeUpload: null,
    customRequest: null,
    withCredentials: false,
    openFileDialogOnClick: true
  }),
  setup: function setup157(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var uploader = ref();
    var abort = function abort2(file) {
      var _a2;
      (_a2 = uploader.value) === null || _a2 === void 0 ? void 0 : _a2.abort(file);
    };
    expose({
      abort
    });
    return function() {
      return createVNode(AjaxUpload, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, props2), attrs), {}, {
        "ref": uploader
      }), slots);
    };
  }
});
function uploadProps2() {
  return {
    capture: [Boolean, String],
    type: String,
    name: String,
    defaultFileList: Array,
    fileList: Array,
    action: [String, Function],
    directory: {
      type: Boolean,
      default: void 0
    },
    data: [Object, Function],
    method: String,
    headers: Object,
    showUploadList: {
      type: [Boolean, Object],
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    accept: String,
    beforeUpload: Function,
    onChange: Function,
    "onUpdate:fileList": Function,
    onDrop: Function,
    listType: String,
    onPreview: Function,
    onDownload: Function,
    onReject: Function,
    onRemove: Function,
    remove: Function,
    supportServerRender: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    customRequest: Function,
    withCredentials: {
      type: Boolean,
      default: void 0
    },
    openFileDialogOnClick: {
      type: Boolean,
      default: void 0
    },
    locale: {
      type: Object,
      default: void 0
    },
    id: String,
    previewFile: Function,
    transformFile: Function,
    iconRender: Function,
    isImageUrl: Function,
    progress: Object,
    itemRender: Function,
    maxCount: Number,
    height: [Number, String],
    removeIcon: Function,
    downloadIcon: Function,
    previewIcon: Function
  };
}
function uploadListProps() {
  return {
    listType: String,
    onPreview: Function,
    onDownload: Function,
    onRemove: Function,
    items: Array,
    progress: Object,
    prefixCls: String,
    showRemoveIcon: {
      type: Boolean,
      default: void 0
    },
    showDownloadIcon: {
      type: Boolean,
      default: void 0
    },
    showPreviewIcon: {
      type: Boolean,
      default: void 0
    },
    removeIcon: Function,
    downloadIcon: Function,
    previewIcon: Function,
    locale: {
      type: Object,
      default: void 0
    },
    previewFile: Function,
    iconRender: Function,
    isImageUrl: Function,
    appendAction: Function,
    appendActionVisible: {
      type: Boolean,
      default: void 0
    },
    itemRender: Function
  };
}
function file2Obj(file) {
  return _extends$2(_extends$2({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
function updateFileList(file, fileList) {
  var nextFileList = _toConsumableArray(fileList);
  var fileIndex = nextFileList.findIndex(function(_ref) {
    var uid2 = _ref.uid;
    return uid2 === file.uid;
  });
  if (fileIndex === -1) {
    nextFileList.push(file);
  } else {
    nextFileList[fileIndex] = file;
  }
  return nextFileList;
}
function getFileItem(file, fileList) {
  var matchKey = file.uid !== void 0 ? "uid" : "name";
  return fileList.filter(function(item) {
    return item[matchKey] === file[matchKey];
  })[0];
}
function removeFileItem(file, fileList) {
  var matchKey = file.uid !== void 0 ? "uid" : "name";
  var removed = fileList.filter(function(item) {
    return item[matchKey] !== file[matchKey];
  });
  if (removed.length === fileList.length) {
    return null;
  }
  return removed;
}
var extname = function extname2() {
  var url2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var temp = url2.split("/");
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [""])[0];
};
var isImageFileType = function isImageFileType2(type4) {
  return type4.indexOf("image/") === 0;
};
var isImageUrl = function isImageUrl2(file) {
  if (file.type && !file.thumbUrl) {
    return isImageFileType(file.type);
  }
  var url2 = file.thumbUrl || file.url || "";
  var extension = extname(url2);
  if (/^data:image\//.test(url2) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url2)) {
    return false;
  }
  if (extension) {
    return false;
  }
  return true;
};
var MEASURE_SIZE = 200;
function previewImage(file) {
  return new Promise(function(resolve) {
    if (!file.type || !isImageFileType(file.type)) {
      resolve("");
      return;
    }
    var canvas = document.createElement("canvas");
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.onload = function() {
      var width = img.width, height = img.height;
      var drawWidth = MEASURE_SIZE;
      var drawHeight = MEASURE_SIZE;
      var offsetX = 0;
      var offsetY = 0;
      if (width > height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      var dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      resolve(dataURL);
    };
    img.src = window.URL.createObjectURL(file);
  });
}
var listItemProps = function listItemProps2() {
  return {
    prefixCls: String,
    locale: {
      type: Object,
      default: void 0
    },
    file: Object,
    items: Array,
    listType: String,
    isImgUrl: Function,
    showRemoveIcon: {
      type: Boolean,
      default: void 0
    },
    showDownloadIcon: {
      type: Boolean,
      default: void 0
    },
    showPreviewIcon: {
      type: Boolean,
      default: void 0
    },
    removeIcon: Function,
    downloadIcon: Function,
    previewIcon: Function,
    iconRender: Function,
    actionIconRender: Function,
    itemRender: Function,
    onPreview: Function,
    onClose: Function,
    onDownload: Function,
    progress: Object
  };
};
var ListItem = defineComponent({
  name: "ListItem",
  inheritAttrs: false,
  props: listItemProps(),
  setup: function setup158(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var showProgress = ref(false);
    var progressRafRef = ref();
    onMounted(function() {
      progressRafRef.value = setTimeout(function() {
        showProgress.value = true;
      }, 300);
    });
    onBeforeUnmount(function() {
      clearTimeout(progressRafRef.value);
    });
    var _useConfigInject = useConfigInject("upload", props2), rootPrefixCls = _useConfigInject.rootPrefixCls;
    var transitionProps = computed(function() {
      return getTransitionProps("".concat(rootPrefixCls.value, "-fade"));
    });
    return function() {
      var _infoUploadingClass, _listContainerNameCla;
      var _a2, _b;
      var prefixCls2 = props2.prefixCls, locale2 = props2.locale, listType = props2.listType, file = props2.file, items = props2.items, progressProps3 = props2.progress, _props$iconRender = props2.iconRender, iconRender = _props$iconRender === void 0 ? slots.iconRender : _props$iconRender, _props$actionIconRend = props2.actionIconRender, actionIconRender = _props$actionIconRend === void 0 ? slots.actionIconRender : _props$actionIconRend, _props$itemRender = props2.itemRender, itemRender2 = _props$itemRender === void 0 ? slots.itemRender : _props$itemRender, isImgUrl = props2.isImgUrl, showPreviewIcon = props2.showPreviewIcon, showRemoveIcon = props2.showRemoveIcon, showDownloadIcon = props2.showDownloadIcon, _props$previewIcon = props2.previewIcon, customPreviewIcon = _props$previewIcon === void 0 ? slots.previewIcon : _props$previewIcon, _props$removeIcon = props2.removeIcon, customRemoveIcon = _props$removeIcon === void 0 ? slots.removeIcon : _props$removeIcon, _props$downloadIcon = props2.downloadIcon, customDownloadIcon = _props$downloadIcon === void 0 ? slots.downloadIcon : _props$downloadIcon, onPreview = props2.onPreview, onDownload = props2.onDownload, onClose = props2.onClose;
      var className = attrs.class, style2 = attrs.style;
      var spanClassName = "".concat(prefixCls2, "-span");
      var iconNode = iconRender({
        file
      });
      var icon = createVNode("div", {
        "class": "".concat(prefixCls2, "-text-icon")
      }, [iconNode]);
      if (listType === "picture" || listType === "picture-card") {
        if (file.status === "uploading" || !file.thumbUrl && !file.url) {
          var _uploadingClassName;
          var uploadingClassName = (_uploadingClassName = {}, _defineProperty$R(_uploadingClassName, "".concat(prefixCls2, "-list-item-thumbnail"), true), _defineProperty$R(_uploadingClassName, "".concat(prefixCls2, "-list-item-file"), file.status !== "uploading"), _uploadingClassName);
          icon = createVNode("div", {
            "class": uploadingClassName
          }, [iconNode]);
        } else {
          var _aClassName;
          var thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? createVNode("img", {
            "src": file.thumbUrl || file.url,
            "alt": file.name,
            "class": "".concat(prefixCls2, "-list-item-image")
          }, null) : iconNode;
          var aClassName = (_aClassName = {}, _defineProperty$R(_aClassName, "".concat(prefixCls2, "-list-item-thumbnail"), true), _defineProperty$R(_aClassName, "".concat(prefixCls2, "-list-item-file"), isImgUrl && !isImgUrl(file)), _aClassName);
          icon = createVNode("a", {
            "class": aClassName,
            "onClick": function onClick2(e2) {
              return onPreview(file, e2);
            },
            "href": file.url || file.thumbUrl,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }, [thumbnail]);
        }
      }
      var infoUploadingClass = (_infoUploadingClass = {}, _defineProperty$R(_infoUploadingClass, "".concat(prefixCls2, "-list-item"), true), _defineProperty$R(_infoUploadingClass, "".concat(prefixCls2, "-list-item-").concat(file.status), true), _defineProperty$R(_infoUploadingClass, "".concat(prefixCls2, "-list-item-list-type-").concat(listType), true), _infoUploadingClass);
      var linkProps = typeof file.linkProps === "string" ? JSON.parse(file.linkProps) : file.linkProps;
      var removeIcon = showRemoveIcon ? actionIconRender({
        customIcon: customRemoveIcon ? customRemoveIcon({
          file
        }) : createVNode(DeleteOutlined$1, null, null),
        callback: function callback() {
          return onClose(file);
        },
        prefixCls: prefixCls2,
        title: locale2.removeFile
      }) : null;
      var downloadIcon = showDownloadIcon && file.status === "done" ? actionIconRender({
        customIcon: customDownloadIcon ? customDownloadIcon({
          file
        }) : createVNode(DownloadOutlined$1, null, null),
        callback: function callback() {
          return onDownload(file);
        },
        prefixCls: prefixCls2,
        title: locale2.downloadFile
      }) : null;
      var downloadOrDelete = listType !== "picture-card" && createVNode("span", {
        "key": "download-delete",
        "class": ["".concat(prefixCls2, "-list-item-card-actions"), {
          picture: listType === "picture"
        }]
      }, [downloadIcon, removeIcon]);
      var listItemNameClass = "".concat(prefixCls2, "-list-item-name");
      var preview = file.url ? [createVNode("a", _objectSpread2$2(_objectSpread2$2({
        "key": "view",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "class": listItemNameClass,
        "title": file.name
      }, linkProps), {}, {
        "href": file.url,
        "onClick": function onClick2(e2) {
          return onPreview(file, e2);
        }
      }), [file.name]), downloadOrDelete] : [createVNode("span", {
        "key": "view",
        "class": listItemNameClass,
        "onClick": function onClick2(e2) {
          return onPreview(file, e2);
        },
        "title": file.name
      }, [file.name]), downloadOrDelete];
      var previewStyle = {
        pointerEvents: "none",
        opacity: 0.5
      };
      var previewIcon = showPreviewIcon ? createVNode("a", {
        "href": file.url || file.thumbUrl,
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": file.url || file.thumbUrl ? void 0 : previewStyle,
        "onClick": function onClick2(e2) {
          return onPreview(file, e2);
        },
        "title": locale2.previewFile
      }, [customPreviewIcon ? customPreviewIcon({
        file
      }) : createVNode(EyeOutlined$1, null, null)]) : null;
      var actions = listType === "picture-card" && file.status !== "uploading" && createVNode("span", {
        "class": "".concat(prefixCls2, "-list-item-actions")
      }, [previewIcon, file.status === "done" && downloadIcon, removeIcon]);
      var message;
      if (file.response && typeof file.response === "string") {
        message = file.response;
      } else {
        message = ((_a2 = file.error) === null || _a2 === void 0 ? void 0 : _a2.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale2.uploadError;
      }
      var iconAndPreview = createVNode("span", {
        "class": spanClassName
      }, [icon, preview]);
      var dom = createVNode("div", {
        "class": infoUploadingClass
      }, [createVNode("div", {
        "class": "".concat(prefixCls2, "-list-item-info")
      }, [iconAndPreview]), actions, showProgress.value && createVNode(Transition$1, transitionProps.value, {
        default: function _default7() {
          return [withDirectives(createVNode("div", {
            "class": "".concat(prefixCls2, "-list-item-progress")
          }, ["percent" in file ? createVNode(Progress, _objectSpread2$2(_objectSpread2$2({}, progressProps3), {}, {
            "type": "line",
            "percent": file.percent
          }), null) : null]), [[vShow, file.status === "uploading"]])];
        }
      })]);
      var listContainerNameClass = (_listContainerNameCla = {}, _defineProperty$R(_listContainerNameCla, "".concat(prefixCls2, "-list-").concat(listType, "-container"), true), _defineProperty$R(_listContainerNameCla, "".concat(className), !!className), _listContainerNameCla);
      var item = file.status === "error" ? createVNode(Tooltip, {
        "title": message,
        "getPopupContainer": function getPopupContainer(node) {
          return node.parentNode;
        }
      }, {
        default: function _default7() {
          return [dom];
        }
      }) : dom;
      return createVNode("div", {
        "class": listContainerNameClass,
        "style": style2,
        "ref": ref
      }, [itemRender2 ? itemRender2({
        originNode: item,
        file,
        fileList: items,
        actions: {
          download: onDownload.bind(null, file),
          preview: onPreview.bind(null, file),
          remove: onClose.bind(null, file)
        }
      }) : item]);
    };
  }
});
var HackSlot = function HackSlot2(_2, _ref) {
  var slots = _ref.slots;
  var _a2;
  return filterEmpty((_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots))[0];
};
var UploadList = defineComponent({
  name: "AUploadList",
  props: initDefaultProps$1(uploadListProps(), {
    listType: "text",
    progress: {
      strokeWidth: 2,
      showInfo: false
    },
    showRemoveIcon: true,
    showDownloadIcon: false,
    showPreviewIcon: true,
    previewFile: previewImage,
    isImageUrl,
    items: [],
    appendActionVisible: true
  }),
  setup: function setup159(props2, _ref2) {
    var slots = _ref2.slots, expose = _ref2.expose;
    var motionAppear = ref(false);
    var instance2 = getCurrentInstance();
    onMounted(function() {
      motionAppear.value == true;
    });
    watchEffect(function() {
      if (props2.listType !== "picture" && props2.listType !== "picture-card") {
        return;
      }
      (props2.items || []).forEach(function(file) {
        if (typeof document === "undefined" || typeof window === "undefined" || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== void 0) {
          return;
        }
        file.thumbUrl = "";
        if (props2.previewFile) {
          props2.previewFile(file.originFileObj).then(function(previewDataUrl) {
            file.thumbUrl = previewDataUrl || "";
            instance2.update();
          });
        }
      });
    });
    var onInternalPreview = function onInternalPreview2(file, e2) {
      if (!props2.onPreview) {
        return;
      }
      e2 === null || e2 === void 0 ? void 0 : e2.preventDefault();
      return props2.onPreview(file);
    };
    var onInternalDownload = function onInternalDownload2(file) {
      if (typeof props2.onDownload === "function") {
        props2.onDownload(file);
      } else if (file.url) {
        window.open(file.url);
      }
    };
    var onInternalClose = function onInternalClose2(file) {
      var _a2;
      (_a2 = props2.onRemove) === null || _a2 === void 0 ? void 0 : _a2.call(props2, file);
    };
    var internalIconRender = function internalIconRender2(_ref3) {
      var file = _ref3.file;
      var iconRender = props2.iconRender || slots.iconRender;
      if (iconRender) {
        return iconRender({
          file,
          listType: props2.listType
        });
      }
      var isLoading = file.status === "uploading";
      var fileIcon = props2.isImageUrl && props2.isImageUrl(file) ? createVNode(PictureTwoTone$1, null, null) : createVNode(FileTwoTone$1, null, null);
      var icon = isLoading ? createVNode(LoadingOutlined$1, null, null) : createVNode(PaperClipOutlined$1, null, null);
      if (props2.listType === "picture") {
        icon = isLoading ? createVNode(LoadingOutlined$1, null, null) : fileIcon;
      } else if (props2.listType === "picture-card") {
        icon = isLoading ? props2.locale.uploading : fileIcon;
      }
      return icon;
    };
    var actionIconRender = function actionIconRender2(opt) {
      var customIcon = opt.customIcon, callback = opt.callback, prefixCls3 = opt.prefixCls, title = opt.title;
      var btnProps = {
        type: "text",
        size: "small",
        title,
        onClick: function onClick2() {
          callback();
        },
        class: "".concat(prefixCls3, "-list-item-card-actions-btn")
      };
      if (isValidElement(customIcon)) {
        return createVNode(Button$2, btnProps, {
          icon: function icon() {
            return customIcon;
          }
        });
      }
      return createVNode(Button$2, btnProps, {
        default: function _default7() {
          return [createVNode("span", null, [customIcon])];
        }
      });
    };
    expose({
      handlePreview: onInternalPreview,
      handleDownload: onInternalDownload
    });
    var _useConfigInject = useConfigInject("upload", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var listClassNames = computed(function() {
      var _ref4;
      return _ref4 = {}, _defineProperty$R(_ref4, "".concat(prefixCls2.value, "-list"), true), _defineProperty$R(_ref4, "".concat(prefixCls2.value, "-list-").concat(props2.listType), true), _defineProperty$R(_ref4, "".concat(prefixCls2.value, "-list-rtl"), direction2.value === "rtl"), _ref4;
    });
    var transitionGroupProps = computed(function() {
      return _extends$2(_extends$2(_extends$2({}, collapseMotion$1("".concat(prefixCls2.value, "-").concat(props2.listType === "picture-card" ? "animate-inline" : "animate"))), getTransitionGroupProps("".concat(prefixCls2.value, "-").concat(props2.listType === "picture-card" ? "animate-inline" : "animate"))), {
        class: listClassNames.value,
        appear: motionAppear.value
      });
    });
    return function() {
      var listType = props2.listType, locale2 = props2.locale, isImgUrl = props2.isImageUrl, _props$items = props2.items, items = _props$items === void 0 ? [] : _props$items, showPreviewIcon = props2.showPreviewIcon, showRemoveIcon = props2.showRemoveIcon, showDownloadIcon = props2.showDownloadIcon, removeIcon = props2.removeIcon, previewIcon = props2.previewIcon, downloadIcon = props2.downloadIcon, progress = props2.progress, appendAction = props2.appendAction, itemRender2 = props2.itemRender, appendActionVisible = props2.appendActionVisible;
      var appendActionDom = appendAction === null || appendAction === void 0 ? void 0 : appendAction();
      return createVNode(TransitionGroup, _objectSpread2$2(_objectSpread2$2({}, transitionGroupProps.value), {}, {
        "tag": "div"
      }), {
        default: function _default7() {
          return [items.map(function(file) {
            var key2 = file.uid;
            return createVNode(ListItem, {
              "key": key2,
              "locale": locale2,
              "prefixCls": prefixCls2.value,
              "file": file,
              "items": items,
              "progress": progress,
              "listType": listType,
              "isImgUrl": isImgUrl,
              "showPreviewIcon": showPreviewIcon,
              "showRemoveIcon": showRemoveIcon,
              "showDownloadIcon": showDownloadIcon,
              "onPreview": onInternalPreview,
              "onDownload": onInternalDownload,
              "onClose": onInternalClose,
              "removeIcon": removeIcon,
              "previewIcon": previewIcon,
              "downloadIcon": downloadIcon,
              "itemRender": itemRender2
            }, _extends$2(_extends$2({}, slots), {
              iconRender: internalIconRender,
              actionIconRender
            }));
          }), appendAction ? withDirectives(createVNode(HackSlot, {
            "key": "__ant_upload_appendAction"
          }, {
            default: function _default8() {
              return appendActionDom;
            }
          }), [[vShow, !!appendActionVisible]]) : null];
        }
      });
    };
  }
});
var __awaiter = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var LIST_IGNORE = "__LIST_IGNORE_".concat(Date.now(), "__");
var Upload$1 = defineComponent({
  name: "AUpload",
  inheritAttrs: false,
  props: initDefaultProps$1(uploadProps2(), {
    type: "select",
    multiple: false,
    action: "",
    data: {},
    accept: "",
    showUploadList: true,
    listType: "text",
    disabled: false,
    supportServerRender: true
  }),
  setup: function setup160(props2, _ref) {
    var _this = this;
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var formItemContext = useInjectFormItemContext();
    var _useMergedState = useMergedState(props2.defaultFileList || [], {
      value: toRef(props2, "fileList"),
      postState: function postState(list) {
        var timestamp = Date.now();
        return (list !== null && list !== void 0 ? list : []).map(function(file, index2) {
          if (!file.uid && !Object.isFrozen(file)) {
            file.uid = "__AUTO__".concat(timestamp, "_").concat(index2, "__");
          }
          return file;
        });
      }
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedFileList = _useMergedState2[0], setMergedFileList = _useMergedState2[1];
    var dragState = ref("drop");
    var upload2 = ref();
    onMounted(function() {
      devWarning(props2.fileList !== void 0 || attrs.value === void 0, "Upload", "`value` is not a valid prop, do you mean `fileList`?");
      devWarning(props2.transformFile === void 0, "Upload", "`transformFile` is deprecated. Please use `beforeUpload` directly.");
      devWarning(props2.remove === void 0, "Upload", "`remove` props is deprecated. Please use `remove` event.");
    });
    var onInternalChange = function onInternalChange2(file, changedFileList, event) {
      var _a2, _b;
      var cloneList = _toConsumableArray(changedFileList);
      if (props2.maxCount === 1) {
        cloneList = cloneList.slice(-1);
      } else if (props2.maxCount) {
        cloneList = cloneList.slice(0, props2.maxCount);
      }
      setMergedFileList(cloneList);
      var changeInfo = {
        file,
        fileList: cloneList
      };
      if (event) {
        changeInfo.event = event;
      }
      (_a2 = props2["onUpdate:fileList"]) === null || _a2 === void 0 ? void 0 : _a2.call(props2, changeInfo.fileList);
      (_b = props2.onChange) === null || _b === void 0 ? void 0 : _b.call(props2, changeInfo);
      formItemContext.onFieldChange();
    };
    var mergedBeforeUpload = function mergedBeforeUpload2(file, fileListArgs) {
      return __awaiter(_this, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee() {
        var beforeUpload, transformFile, parsedFile, result;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                beforeUpload = props2.beforeUpload, transformFile = props2.transformFile;
                parsedFile = file;
                if (!beforeUpload) {
                  _context.next = 13;
                  break;
                }
                _context.next = 5;
                return beforeUpload(file, fileListArgs);
              case 5:
                result = _context.sent;
                if (!(result === false)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", false);
              case 8:
                delete file[LIST_IGNORE];
                if (!(result === LIST_IGNORE)) {
                  _context.next = 12;
                  break;
                }
                Object.defineProperty(file, LIST_IGNORE, {
                  value: true,
                  configurable: true
                });
                return _context.abrupt("return", false);
              case 12:
                if (_typeof$2(result) === "object" && result) {
                  parsedFile = result;
                }
              case 13:
                if (!transformFile) {
                  _context.next = 17;
                  break;
                }
                _context.next = 16;
                return transformFile(parsedFile);
              case 16:
                parsedFile = _context.sent;
              case 17:
                return _context.abrupt("return", parsedFile);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
    var onBatchStart = function onBatchStart2(batchFileInfoList) {
      var filteredFileInfoList = batchFileInfoList.filter(function(info) {
        return !info.file[LIST_IGNORE];
      });
      if (!filteredFileInfoList.length) {
        return;
      }
      var objectFileList = filteredFileInfoList.map(function(info) {
        return file2Obj(info.file);
      });
      var newFileList = _toConsumableArray(mergedFileList.value);
      objectFileList.forEach(function(fileObj) {
        newFileList = updateFileList(fileObj, newFileList);
      });
      objectFileList.forEach(function(fileObj, index2) {
        var triggerFileObj = fileObj;
        if (!filteredFileInfoList[index2].parsedFile) {
          var originFileObj = fileObj.originFileObj;
          var clone3;
          try {
            clone3 = new File([originFileObj], originFileObj.name, {
              type: originFileObj.type
            });
          } catch (e2) {
            clone3 = new Blob([originFileObj], {
              type: originFileObj.type
            });
            clone3.name = originFileObj.name;
            clone3.lastModifiedDate = new Date();
            clone3.lastModified = new Date().getTime();
          }
          clone3.uid = fileObj.uid;
          triggerFileObj = clone3;
        } else {
          fileObj.status = "uploading";
        }
        onInternalChange(triggerFileObj, newFileList);
      });
    };
    var onSuccess = function onSuccess2(response, file, xhr) {
      try {
        if (typeof response === "string") {
          response = JSON.parse(response);
        }
      } catch (e2) {
      }
      if (!getFileItem(file, mergedFileList.value)) {
        return;
      }
      var targetItem = file2Obj(file);
      targetItem.status = "done";
      targetItem.percent = 100;
      targetItem.response = response;
      targetItem.xhr = xhr;
      var nextFileList = updateFileList(targetItem, mergedFileList.value);
      onInternalChange(targetItem, nextFileList);
    };
    var onProgress = function onProgress2(e2, file) {
      if (!getFileItem(file, mergedFileList.value)) {
        return;
      }
      var targetItem = file2Obj(file);
      targetItem.status = "uploading";
      targetItem.percent = e2.percent;
      var nextFileList = updateFileList(targetItem, mergedFileList.value);
      onInternalChange(targetItem, nextFileList, e2);
    };
    var onError = function onError2(error, response, file) {
      if (!getFileItem(file, mergedFileList.value)) {
        return;
      }
      var targetItem = file2Obj(file);
      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = "error";
      var nextFileList = updateFileList(targetItem, mergedFileList.value);
      onInternalChange(targetItem, nextFileList);
    };
    var handleRemove = function handleRemove2(file) {
      var currentFile;
      var mergedRemove = props2.onRemove || props2.remove;
      Promise.resolve(typeof mergedRemove === "function" ? mergedRemove(file) : mergedRemove).then(function(ret) {
        var _a2, _b;
        if (ret === false) {
          return;
        }
        var removedFileList = removeFileItem(file, mergedFileList.value);
        if (removedFileList) {
          currentFile = _extends$2(_extends$2({}, file), {
            status: "removed"
          });
          (_a2 = mergedFileList.value) === null || _a2 === void 0 ? void 0 : _a2.forEach(function(item) {
            var matchKey = currentFile.uid !== void 0 ? "uid" : "name";
            if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) {
              item.status = "removed";
            }
          });
          (_b = upload2.value) === null || _b === void 0 ? void 0 : _b.abort(currentFile);
          onInternalChange(currentFile, removedFileList);
        }
      });
    };
    var onFileDrop = function onFileDrop2(e2) {
      var _a2;
      dragState.value = e2.type;
      if (e2.type === "drop") {
        (_a2 = props2.onDrop) === null || _a2 === void 0 ? void 0 : _a2.call(props2, e2);
      }
    };
    expose({
      onBatchStart,
      onSuccess,
      onProgress,
      onError,
      fileList: mergedFileList,
      upload: upload2
    });
    var _useConfigInject = useConfigInject("upload", props2), prefixCls2 = _useConfigInject.prefixCls, direction2 = _useConfigInject.direction;
    var _useLocaleReceiver = useLocaleReceiver("Upload", defaultLocale.Upload, computed(function() {
      return props2.locale;
    })), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    var renderUploadList = function renderUploadList2(button, buttonVisible) {
      var removeIcon = props2.removeIcon, previewIcon = props2.previewIcon, downloadIcon = props2.downloadIcon, previewFile = props2.previewFile, onPreview = props2.onPreview, onDownload = props2.onDownload, disabled = props2.disabled, isImageUrl3 = props2.isImageUrl, progress = props2.progress, itemRender2 = props2.itemRender, iconRender = props2.iconRender, showUploadList = props2.showUploadList;
      var _ref2 = typeof showUploadList === "boolean" ? {} : showUploadList, showDownloadIcon = _ref2.showDownloadIcon, showPreviewIcon = _ref2.showPreviewIcon, showRemoveIcon = _ref2.showRemoveIcon;
      return showUploadList ? createVNode(UploadList, {
        "listType": props2.listType,
        "items": mergedFileList.value,
        "previewFile": previewFile,
        "onPreview": onPreview,
        "onDownload": onDownload,
        "onRemove": handleRemove,
        "showRemoveIcon": !disabled && showRemoveIcon,
        "showPreviewIcon": showPreviewIcon,
        "showDownloadIcon": showDownloadIcon,
        "removeIcon": removeIcon,
        "previewIcon": previewIcon,
        "downloadIcon": downloadIcon,
        "iconRender": iconRender,
        "locale": locale2.value,
        "isImageUrl": isImageUrl3,
        "progress": progress,
        "itemRender": itemRender2,
        "appendActionVisible": buttonVisible,
        "appendAction": button
      }, _extends$2({}, slots)) : button === null || button === void 0 ? void 0 : button();
    };
    return function() {
      var _classNames2;
      var _a2, _b, _c;
      var listType = props2.listType, disabled = props2.disabled, type4 = props2.type;
      var rcUploadProps = _extends$2(_extends$2({
        onBatchStart,
        onError,
        onProgress,
        onSuccess
      }, props2), {
        id: (_a2 = props2.id) !== null && _a2 !== void 0 ? _a2 : formItemContext.id.value,
        prefixCls: prefixCls2.value,
        beforeUpload: mergedBeforeUpload,
        onChange: void 0
      });
      delete rcUploadProps.remove;
      if (!slots.default || disabled) {
        delete rcUploadProps.id;
      }
      if (type4 === "drag") {
        var _classNames;
        var dragCls = classNames(prefixCls2.value, (_classNames = {}, _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-drag"), true), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-drag-uploading"), mergedFileList.value.some(function(file) {
          return file.status === "uploading";
        })), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-drag-hover"), dragState.value === "dragover"), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-disabled"), disabled), _defineProperty$R(_classNames, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _classNames), attrs.class);
        return createVNode("span", null, [createVNode("div", {
          "class": dragCls,
          "onDrop": onFileDrop,
          "onDragover": onFileDrop,
          "onDragleave": onFileDrop,
          "style": attrs.style
        }, [createVNode(Upload$2, _objectSpread2$2(_objectSpread2$2({}, rcUploadProps), {}, {
          "ref": upload2,
          "class": "".concat(prefixCls2.value, "-btn")
        }), _objectSpread2$2({
          default: function _default7() {
            return [createVNode("div", {
              "class": "".concat(prefixCls2, "-drag-container")
            }, [(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)])];
          }
        }, slots))]), renderUploadList()]);
      }
      var uploadButtonCls = classNames(prefixCls2.value, (_classNames2 = {}, _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-select"), true), _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-select-").concat(listType), true), _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-disabled"), disabled), _defineProperty$R(_classNames2, "".concat(prefixCls2.value, "-rtl"), direction2.value === "rtl"), _classNames2));
      var children = flattenChildren((_c = slots.default) === null || _c === void 0 ? void 0 : _c.call(slots));
      var renderUploadButton = function renderUploadButton2(uploadButtonStyle) {
        return createVNode("div", {
          "class": uploadButtonCls,
          "style": uploadButtonStyle
        }, [createVNode(Upload$2, _objectSpread2$2(_objectSpread2$2({}, rcUploadProps), {}, {
          "ref": upload2
        }), slots)]);
      };
      if (listType === "picture-card") {
        return createVNode("span", {
          "class": classNames("".concat(prefixCls2.value, "-picture-card-wrapper"), attrs.class)
        }, [renderUploadList(renderUploadButton, !!(children && children.length))]);
      }
      return createVNode("span", {
        "class": attrs.class
      }, [renderUploadButton(children && children.length ? void 0 : {
        display: "none"
      }), renderUploadList()]);
    };
  }
});
var __rest = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var Dragger = defineComponent({
  name: "AUploadDragger",
  inheritAttrs: false,
  props: uploadProps2(),
  setup: function setup161(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    return function() {
      var height = props2.height, restProps = __rest(props2, ["height"]);
      var style2 = attrs.style, restAttrs = __rest(attrs, ["style"]);
      var draggerProps = _extends$2(_extends$2(_extends$2({}, restProps), restAttrs), {
        type: "drag",
        style: _extends$2(_extends$2({}, style2), {
          height: typeof height === "number" ? "".concat(height, "px") : height
        })
      });
      return createVNode(Upload$1, draggerProps, slots);
    };
  }
});
var Upload = _extends$2(Upload$1, {
  Dragger,
  LIST_IGNORE,
  install: function install8(app) {
    app.component(Upload$1.name, Upload$1);
    app.component(Dragger.name, Dragger);
    return app;
  }
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject$2(o2) {
  return Object.prototype.toString.call(o2) === "[object Object]";
}
function isPlainObject$1(o2) {
  var ctor, prot;
  if (isObject$2(o2) === false)
    return false;
  ctor = o2.constructor;
  if (ctor === void 0)
    return true;
  prot = ctor.prototype;
  if (isObject$2(prot) === false)
    return false;
  if (prot.hasOwnProperty("isPrototypeOf") === false) {
    return false;
  }
  return true;
}
function t() {
  return t = Object.assign || function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var r2 = arguments[t2];
      for (var n2 in r2)
        Object.prototype.hasOwnProperty.call(r2, n2) && (e2[n2] = r2[n2]);
    }
    return e2;
  }, t.apply(this, arguments);
}
function r(e2, t2) {
  if (e2 == null)
    return {};
  var r2, n2, i2 = {}, o2 = Object.keys(e2);
  for (n2 = 0; n2 < o2.length; n2++)
    t2.indexOf(r2 = o2[n2]) >= 0 || (i2[r2] = e2[r2]);
  return i2;
}
const n = { silent: false, logLevel: "warn" }, i = ["validator"], o = Object.prototype, a = o.toString, s = o.hasOwnProperty, u = /^\s*function (\w+)/;
function l(e2) {
  var t2;
  const r2 = (t2 = e2 == null ? void 0 : e2.type) !== null && t2 !== void 0 ? t2 : e2;
  if (r2) {
    const e3 = r2.toString().match(u);
    return e3 ? e3[1] : "";
  }
  return "";
}
const c = isPlainObject$1, f = (e2) => e2;
let d = f;
const p = (e2, t2) => s.call(e2, t2), y = Number.isInteger || function(e2) {
  return typeof e2 == "number" && isFinite(e2) && Math.floor(e2) === e2;
}, v = Array.isArray || function(e2) {
  return a.call(e2) === "[object Array]";
}, h = (e2) => a.call(e2) === "[object Function]", b = (e2) => c(e2) && p(e2, "_vueTypes_name"), g = (e2) => c(e2) && (p(e2, "type") || ["_vueTypes_name", "validator", "default", "required"].some((t2) => p(e2, t2)));
function O(e2, t2) {
  return Object.defineProperty(e2.bind(t2), "__original", { value: e2 });
}
function m(e2, t2, r2 = false) {
  let n2, i2 = true, o2 = "";
  n2 = c(e2) ? e2 : { type: e2 };
  const a2 = b(n2) ? n2._vueTypes_name + " - " : "";
  if (g(n2) && n2.type !== null) {
    if (n2.type === void 0 || n2.type === true)
      return i2;
    if (!n2.required && t2 === void 0)
      return i2;
    v(n2.type) ? (i2 = n2.type.some((e3) => m(e3, t2, true) === true), o2 = n2.type.map((e3) => l(e3)).join(" or ")) : (o2 = l(n2), i2 = o2 === "Array" ? v(t2) : o2 === "Object" ? c(t2) : o2 === "String" || o2 === "Number" || o2 === "Boolean" || o2 === "Function" ? function(e3) {
      if (e3 == null)
        return "";
      const t3 = e3.constructor.toString().match(u);
      return t3 ? t3[1] : "";
    }(t2) === o2 : t2 instanceof n2.type);
  }
  if (!i2) {
    const e3 = `${a2}value "${t2}" should be of type "${o2}"`;
    return r2 === false ? (d(e3), false) : e3;
  }
  if (p(n2, "validator") && h(n2.validator)) {
    const e3 = d, o3 = [];
    if (d = (e4) => {
      o3.push(e4);
    }, i2 = n2.validator(t2), d = e3, !i2) {
      const e4 = (o3.length > 1 ? "* " : "") + o3.join("\n* ");
      return o3.length = 0, r2 === false ? (d(e4), i2) : e4;
    }
  }
  return i2;
}
function j(e2, t2) {
  const r2 = Object.defineProperties(t2, { _vueTypes_name: { value: e2, writable: true }, isRequired: { get() {
    return this.required = true, this;
  } }, def: { value(e3) {
    return e3 === void 0 ? (p(this, "default") && delete this.default, this) : h(e3) || m(this, e3, true) === true ? (this.default = v(e3) ? () => [...e3] : c(e3) ? () => Object.assign({}, e3) : e3, this) : (d(`${this._vueTypes_name} - invalid default value: "${e3}"`), this);
  } } }), { validator: n2 } = r2;
  return h(n2) && (r2.validator = O(n2, r2)), r2;
}
function _(e2, t2) {
  const r2 = j(e2, t2);
  return Object.defineProperty(r2, "validate", { value(e3) {
    return h(this.validator) && d(`${this._vueTypes_name} - calling .validate() will overwrite the current custom validator function. Validator info:
${JSON.stringify(this)}`), this.validator = O(e3, this), this;
  } });
}
function T(e2, t2, n2) {
  const o2 = function(e3) {
    const t3 = {};
    return Object.getOwnPropertyNames(e3).forEach((r2) => {
      t3[r2] = Object.getOwnPropertyDescriptor(e3, r2);
    }), Object.defineProperties({}, t3);
  }(t2);
  if (o2._vueTypes_name = e2, !c(n2))
    return o2;
  const { validator: a2 } = n2, s2 = r(n2, i);
  if (h(a2)) {
    let { validator: e3 } = o2;
    e3 && (e3 = (l2 = (u2 = e3).__original) !== null && l2 !== void 0 ? l2 : u2), o2.validator = O(e3 ? function(t3) {
      return e3.call(this, t3) && a2.call(this, t3);
    } : a2, o2);
  }
  var u2, l2;
  return Object.assign(o2, s2);
}
function $(e2) {
  return e2.replace(/^(?!\s*$)/gm, "  ");
}
const w = () => _("any", {}), P = () => _("function", { type: Function }), x = () => _("boolean", { type: Boolean }), E = () => _("string", { type: String }), N = () => _("number", { type: Number }), q = () => _("array", { type: Array }), A = () => _("object", { type: Object }), V = () => j("integer", { type: Number, validator: (e2) => y(e2) }), S = () => j("symbol", { validator: (e2) => typeof e2 == "symbol" });
function k(e2, t2 = "custom validation failed") {
  if (typeof e2 != "function")
    throw new TypeError("[VueTypes error]: You must provide a function as argument");
  return j(e2.name || "<<anonymous function>>", { type: null, validator(r2) {
    const n2 = e2(r2);
    return n2 || d(`${this._vueTypes_name} - ${t2}`), n2;
  } });
}
function D(e2) {
  if (!v(e2))
    throw new TypeError("[VueTypes error]: You must provide an array as argument.");
  const t2 = `oneOf - value should be one of "${e2.join('", "')}".`, r2 = e2.reduce((e3, t3) => {
    if (t3 != null) {
      const r3 = t3.constructor;
      e3.indexOf(r3) === -1 && e3.push(r3);
    }
    return e3;
  }, []);
  return j("oneOf", { type: r2.length > 0 ? r2 : void 0, validator(r3) {
    const n2 = e2.indexOf(r3) !== -1;
    return n2 || d(t2), n2;
  } });
}
function L(e2) {
  if (!v(e2))
    throw new TypeError("[VueTypes error]: You must provide an array as argument");
  let t2 = false, r2 = [];
  for (let n3 = 0; n3 < e2.length; n3 += 1) {
    const i2 = e2[n3];
    if (g(i2)) {
      if (b(i2) && i2._vueTypes_name === "oneOf" && i2.type) {
        r2 = r2.concat(i2.type);
        continue;
      }
      if (h(i2.validator) && (t2 = true), i2.type === true || !i2.type) {
        d('oneOfType - invalid usage of "true" or "null" as types.');
        continue;
      }
      r2 = r2.concat(i2.type);
    } else
      r2.push(i2);
  }
  r2 = r2.filter((e3, t3) => r2.indexOf(e3) === t3);
  const n2 = r2.length > 0 ? r2 : null;
  return j("oneOfType", t2 ? { type: n2, validator(t3) {
    const r3 = [], n3 = e2.some((e3) => {
      const n4 = m(b(e3) && e3._vueTypes_name === "oneOf" ? e3.type || null : e3, t3, true);
      return typeof n4 == "string" && r3.push(n4), n4 === true;
    });
    return n3 || d(`oneOfType - provided value does not match any of the ${r3.length} passed-in validators:
${$(r3.join("\n"))}`), n3;
  } } : { type: n2 });
}
function F(e2) {
  return j("arrayOf", { type: Array, validator(t2) {
    let r2 = "";
    const n2 = t2.every((t3) => (r2 = m(e2, t3, true), r2 === true));
    return n2 || d(`arrayOf - value validation error:
${$(r2)}`), n2;
  } });
}
function Y(e2) {
  return j("instanceOf", { type: e2 });
}
function B(e2) {
  return j("objectOf", { type: Object, validator(t2) {
    let r2 = "";
    const n2 = Object.keys(t2).every((n3) => (r2 = m(e2, t2[n3], true), r2 === true));
    return n2 || d(`objectOf - value validation error:
${$(r2)}`), n2;
  } });
}
function I(e2) {
  const t2 = Object.keys(e2), r2 = t2.filter((t3) => {
    var r3;
    return !((r3 = e2[t3]) === null || r3 === void 0 || !r3.required);
  }), n2 = j("shape", { type: Object, validator(n3) {
    if (!c(n3))
      return false;
    const i2 = Object.keys(n3);
    if (r2.length > 0 && r2.some((e3) => i2.indexOf(e3) === -1)) {
      const e3 = r2.filter((e4) => i2.indexOf(e4) === -1);
      return d(e3.length === 1 ? `shape - required property "${e3[0]}" is not defined.` : `shape - required properties "${e3.join('", "')}" are not defined.`), false;
    }
    return i2.every((r3) => {
      if (t2.indexOf(r3) === -1)
        return this._vueTypes_isLoose === true || (d(`shape - shape definition does not include a "${r3}" property. Allowed keys: "${t2.join('", "')}".`), false);
      const i3 = m(e2[r3], n3[r3], true);
      return typeof i3 == "string" && d(`shape - "${r3}" property validation error:
 ${$(i3)}`), i3 === true;
    });
  } });
  return Object.defineProperty(n2, "_vueTypes_isLoose", { writable: true, value: false }), Object.defineProperty(n2, "loose", { get() {
    return this._vueTypes_isLoose = true, this;
  } }), n2;
}
const J = ["name", "validate", "getter"], M = /* @__PURE__ */ (() => {
  var e2, t2;
  return t2 = e2 = class {
    static get any() {
      return w();
    }
    static get func() {
      return P().def(this.defaults.func);
    }
    static get bool() {
      return x().def(this.defaults.bool);
    }
    static get string() {
      return E().def(this.defaults.string);
    }
    static get number() {
      return N().def(this.defaults.number);
    }
    static get array() {
      return q().def(this.defaults.array);
    }
    static get object() {
      return A().def(this.defaults.object);
    }
    static get integer() {
      return V().def(this.defaults.integer);
    }
    static get symbol() {
      return S();
    }
    static extend(e3) {
      if (v(e3))
        return e3.forEach((e4) => this.extend(e4)), this;
      const { name: t3, validate: n2 = false, getter: i2 = false } = e3, o2 = r(e3, J);
      if (p(this, t3))
        throw new TypeError(`[VueTypes error]: Type "${t3}" already defined`);
      const { type: a2 } = o2;
      if (b(a2))
        return delete o2.type, Object.defineProperty(this, t3, i2 ? { get: () => T(t3, a2, o2) } : { value(...e4) {
          const r2 = T(t3, a2, o2);
          return r2.validator && (r2.validator = r2.validator.bind(r2, ...e4)), r2;
        } });
      let s2;
      return s2 = i2 ? { get() {
        const e4 = Object.assign({}, o2);
        return n2 ? _(t3, e4) : j(t3, e4);
      }, enumerable: true } : { value(...e4) {
        const r2 = Object.assign({}, o2);
        let i3;
        return i3 = n2 ? _(t3, r2) : j(t3, r2), r2.validator && (i3.validator = r2.validator.bind(i3, ...e4)), i3;
      }, enumerable: true }, Object.defineProperty(this, t3, s2);
    }
  }, e2.defaults = {}, e2.sensibleDefaults = void 0, e2.config = n, e2.custom = k, e2.oneOf = D, e2.instanceOf = Y, e2.oneOfType = L, e2.arrayOf = F, e2.objectOf = B, e2.shape = I, e2.utils = { validate: (e3, t3) => m(t3, e3, true) === true, toType: (e3, t3, r2 = false) => r2 ? _(e3, t3) : j(e3, t3) }, t2;
})();
function R(e2 = { func: () => {
}, bool: true, string: "", number: 0, array: () => [], object: () => ({}), integer: 0 }) {
  var r2, n2;
  return n2 = r2 = class extends M {
    static get sensibleDefaults() {
      return t({}, this.defaults);
    }
    static set sensibleDefaults(r3) {
      this.defaults = r3 !== false ? t({}, r3 !== true ? r3 : e2) : {};
    }
  }, r2.defaults = t({}, e2), n2;
}
class z extends R() {
}
function createContext(context2, key2, options = {}) {
  const { readonly: readonly$1 = true, reactivity = true } = options;
  const reactiveContext = reactive(context2);
  const provideContext = readonly$1 && readonly(reactiveContext) || reactiveContext;
  provide(key2, reactivity ? provideContext : context2);
  return {
    reactiveContext
  };
}
function useContext(key2, defaultVal = {}) {
  return inject(key2, defaultVal);
}
const key$4 = Symbol();
function createAppContextProvider(context2) {
  return createContext(context2, key$4);
}
function useAppContextProvider() {
  return useContext(key$4);
}
const prefixCls = "fbu";
var _export_sfc$1 = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key2, val] of props2) {
    target[key2] = val;
  }
  return target;
};
const _sfc_main$R = defineComponent({
  name: "FbuAppProvider",
  components: {
    ConfigProvider: ConfigProvider$1
  },
  inheritAttrs: false,
  props: {
    csp: A(),
    autoInsertSpaceInButton: z.bool.def(false),
    locale: z.any,
    renderEmpty: z.func.def(void 0)
  },
  setup(props2) {
    const getProviderProps = computed(() => {
      const { csp, autoInsertSpaceInButton, locale: locale2, renderEmpty: renderEmpty2 } = props2;
      return __spreadValues({ csp, autoInsertSpaceInButton, locale: locale2 }, renderEmpty2 ? { renderEmpty: renderEmpty2 } : {});
    });
    createAppContextProvider({ prefixCls });
    return {
      getProviderProps
    };
  }
});
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConfigProvider = resolveComponent("ConfigProvider");
  return openBlock(), createBlock(_component_ConfigProvider, normalizeProps(guardReactiveProps(_ctx.getProviderProps)), createSlots({ _: 2 }, [
    renderList(Object.keys(_ctx.$slots), (slot) => {
      return {
        name: slot,
        fn: withCtx(() => [
          renderSlot(_ctx.$slots, slot)
        ])
      };
    })
  ]), 1040);
}
var AppProvider = /* @__PURE__ */ _export_sfc$1(_sfc_main$R, [["render", _sfc_render$I]]);
const withInstall$1 = (comp) => {
  const c2 = comp;
  c2.install = function(app) {
    app.component(c2.displayName || c2.name, comp);
  };
  return comp;
};
var index$9 = withInstall$1(AppProvider);
function usePrefixCls(name2) {
  const appContextProvider = useAppContextProvider();
  const prefixClass = appContextProvider.prefixCls || prefixCls;
  return `${prefixClass}-${name2}`;
}
var FbuButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$Q = defineComponent({
  name: "FbuButton",
  components: {
    Button: Button$2
  },
  props: {
    type: E().def("default"),
    color: z.oneOf(["success", "error", "warning", "secondary", ""]).def(""),
    loading: L([Boolean, Object]),
    disabled: z.bool.def(false),
    size: E().def("middle"),
    onClick: P().def(() => {
    }),
    ghost: z.bool.def(false)
  },
  inheritAttrs: false,
  setup(props2, { attrs }) {
    const prefixCls2 = usePrefixCls("button");
    const buttonClass = computed(() => {
      const { color, disabled, ghost, type: type4 } = props2;
      return {
        [`${prefixCls2}-${color}`]: !!color,
        [`${prefixCls2}-ghost`]: ghost,
        [`${prefixCls2}-${type4}`]: !!type4,
        "is-disabled": disabled
      };
    });
    const buttonProps3 = computed(() => {
      return __spreadValues(__spreadValues({}, attrs), props2);
    });
    return {
      prefixCls: prefixCls2,
      buttonProps: buttonProps3,
      buttonClass
    };
  }
});
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = resolveComponent("Button");
  return openBlock(), createBlock(_component_Button, mergeProps(_ctx.buttonProps, {
    class: [_ctx.prefixCls, _ctx.buttonClass],
    onClick: _ctx.onClick
  }), createSlots({ _: 2 }, [
    renderList(Object.keys(_ctx.$slots), (slot) => {
      return {
        name: slot,
        fn: withCtx(() => [
          renderSlot(_ctx.$slots, slot, {}, void 0, true)
        ])
      };
    })
  ]), 1040, ["class", "onClick"]);
}
var Button = /* @__PURE__ */ _export_sfc$1(_sfc_main$Q, [["render", _sfc_render$H], ["__scopeId", "data-v-53bcb03e"]]);
const _sfc_main$P = defineComponent({
  name: "FbuPopconfirmButton",
  components: {
    Popconfirm: Popconfirm$1,
    FbuButton: Button
  },
  inheritAttrs: false,
  props: {
    enable: {
      type: Boolean,
      default: true
    }
  },
  setup(props2, { attrs, slots }) {
    return () => {
      const bindValues = __spreadValues({}, unref(attrs));
      Reflect.deleteProperty(bindValues, "icon");
      const btnBind = __spreadValues({}, bindValues);
      Reflect.deleteProperty(btnBind, "title");
      if (btnBind.disabled)
        btnBind.color = "";
      const Button$12 = h$2(Button, btnBind, { default: () => {
        var _a2;
        return (_a2 = slots == null ? void 0 : slots.default) == null ? void 0 : _a2.call(slots);
      } });
      if (!props2.enable) {
        return Button$12;
      }
      return h$2(Popconfirm$1, bindValues, __spreadProps(__spreadValues({}, slots), { default: () => Button$12 }));
    };
  }
});
Button.install = function(app) {
  app.component(Button.name, Button);
  app.component(_sfc_main$P.name, _sfc_main$P);
  return app;
};
var DateRangePicker_vue_vue_type_style_index_0_lang = "";
const _sfc_main$O = defineComponent({
  name: "FbuDateRangePicker",
  components: {
    RangePicker
  },
  props: {
    startTime: z.string.def(""),
    endTime: z.string.def(""),
    value: q().def(["", ""]),
    showDefaultDateTime: z.bool.def(false),
    showTime: z.bool.def(true)
  },
  emits: ["update:startTime", "update:endTime", "update:value", "change"],
  setup(props2, { emit }) {
    const prefixCls2 = usePrefixCls("date-range-picker");
    const dateFormat = computed(() => props2.showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD");
    const innerValue = ref([void 0, void 0]);
    if (props2.showDefaultDateTime) {
      const defaultValue = getDefaultDateTime();
      emitDates([
        dayjs(defaultValue[0]).format(dateFormat.value),
        dayjs(defaultValue[1]).format(dateFormat.value)
      ]);
    }
    watch([() => props2.value, () => props2.startTime, () => props2.endTime], () => {
      const { startTime, endTime, value } = props2;
      if (value && value.length) {
        innerValue.value = [
          value[0] && dayjs(value[0]) || void 0,
          value[1] && dayjs(value[1]) || void 0
        ];
      } else if (startTime && endTime) {
        innerValue.value = [dayjs(startTime), dayjs(endTime)];
      } else {
        innerValue.value = [void 0, void 0];
      }
    });
    function getDefaultDateTime() {
      const now2 = dayjs();
      const defaultStart = now2.subtract(6, "month").hour(0).minute(0).second(0);
      const defaultEnd = now2.hour(23).minute(59).second(59);
      const defaultValue = [defaultStart, defaultEnd];
      return defaultValue;
    }
    function emitDates(dates) {
      emit("change", dates);
      emit("update:startTime", dates && dates[0] || "");
      emit("update:endTime", dates && dates[1] || "");
      emit("update:value", dates || []);
    }
    function changeHandler(dates) {
      emitDates(dates);
    }
    return {
      dateFormat,
      innerValue,
      prefixCls: prefixCls2,
      changeHandler
    };
  }
});
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RangePicker = resolveComponent("RangePicker");
  return openBlock(), createBlock(_component_RangePicker, mergeProps(_ctx.$attrs, {
    value: _ctx.innerValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.innerValue = $event),
    class: [_ctx.prefixCls],
    format: _ctx.dateFormat,
    "value-format": _ctx.dateFormat,
    "show-time": _ctx.showTime,
    onChange: _ctx.changeHandler
  }), null, 16, ["value", "class", "format", "value-format", "show-time", "onChange"]);
}
var DateRangePicker$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$O, [["render", _sfc_render$G]]);
var DateRangePicker = withInstall$1(DateRangePicker$1);
function transformOptions(options, optionLabelValueProp = { label: "label", value: "value" }) {
  return (options || []).map((item) => __spreadValues({
    label: item[optionLabelValueProp.label],
    value: item[optionLabelValueProp.value]
  }, item));
}
const _sfc_main$N = defineComponent({
  name: "FbuRadioGroup",
  components: {
    RadioGroup: RadioGroup$1
  },
  props: {
    buttonStyle: z.oneOf(["outline", "solid"]).def("solid"),
    disabled: z.bool.def(false),
    name: z.string,
    value: z.any,
    options: z.arrayOf(A()).def([]),
    lvMap: A().def({
      label: "label",
      value: "value"
    }),
    optionType: z.oneOf(["default", "button"]).def("button"),
    size: z.oneOf(["large", "small", "default"]).def("default")
  },
  emits: ["update:value"],
  setup(props2, { emit }) {
    const prefixCls2 = usePrefixCls("radio-group");
    const getGroupProps = computed(() => {
      const { buttonStyle, disabled, name: name2, optionType, size, options, lvMap } = props2;
      const innerOptions = transformOptions(options, lvMap);
      return { buttonStyle, disabled, name: name2, optionType, size, options: innerOptions };
    });
    const getClass2 = computed(() => {
      const len = props2.options.length;
      const colSize = len <= 3 ? "normal" : len <= 6 ? "middle" : "large";
      return [prefixCls2, "radio-col-" + colSize];
    });
    const innerValue = computed({
      get: () => props2.value,
      set: (val) => {
        emit("update:value", val);
      }
    });
    return {
      getGroupProps,
      innerValue,
      getClass: getClass2
    };
  }
});
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioGroup = resolveComponent("RadioGroup", true);
  return openBlock(), createBlock(_component_RadioGroup, mergeProps({
    value: _ctx.innerValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.innerValue = $event),
    class: _ctx.getClass
  }, _ctx.getGroupProps), null, 16, ["value", "class"]);
}
var RadioGroup = /* @__PURE__ */ _export_sfc$1(_sfc_main$N, [["render", _sfc_render$F]]);
var radioGroup = withInstall$1(RadioGroup);
const PAGE_SIZE_OPTIONS = ["20", "50", "100", "200"];
const PAGE_SIZE = 20;
const usePaginationProps = {
  defaultPageSize: N().def(PAGE_SIZE),
  pageSizeOptions: q().def(PAGE_SIZE_OPTIONS),
  showTotal: P().def((total3) => `\u5171${total3}\u6761\uFF1A`),
  showSizeChanger: z.bool.def(true),
  hideOnSinglePage: z.bool.def(false),
  prevText: z.string.def("< \u4E0A\u4E00\u9875"),
  nextText: z.string.def("\u4E0B\u4E00\u9875 >"),
  total: z.integer.def(0)
};
const defPrev = "< \u4E0A\u4E00\u9875";
const defNext = "\u4E0B\u4E00\u9875 >";
function itemRender({
  type: type4,
  originalElement,
  prevText = defPrev,
  nextText = defNext
}) {
  if (type4 === "prev") {
    originalElement.children = [createTextVNode(prevText)];
    return originalElement;
  } else if (type4 === "next") {
    originalElement.children = [createTextVNode(nextText)];
    return originalElement;
  }
  return originalElement;
}
var FbuPagination_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$M = defineComponent({
  name: "FbuPagination",
  components: {
    Pagination: Pagination$1
  },
  inheritAttrs: false,
  props: __spreadProps(__spreadValues({}, usePaginationProps), {
    current: z.number.def(1),
    pageSize: z.oneOf([20, 50, 100, 200]).def(PAGE_SIZE)
  }),
  emits: ["update:current", "update:pageSize", "change", "showSizeChange"],
  setup(props2, { slots, emit }) {
    const prefixCls2 = usePrefixCls("pagination");
    const getSlots = Object.keys(slots).filter((slot) => slot !== "itemRender");
    const currentState = ref(props2.current);
    const pageSizeState = ref(props2.pageSize);
    const innerCurrent = computed({
      get: () => currentState.value,
      set: (val) => {
        emitCurrent(val);
      }
    });
    const innerPageSize = computed({
      get: () => pageSizeState.value,
      set: (val) => {
        emitPageSize(val);
      }
    });
    watch(() => props2.current, (val) => {
      currentState.value = val;
    });
    watch(() => props2.pageSize, (val) => {
      pageSizeState.value = val;
    });
    function emitCurrent(val) {
      emit("update:current", val);
      currentState.value = val;
    }
    function emitPageSize(size) {
      emit("update:pageSize", size);
      pageSizeState.value = size;
    }
    function changeHandler(page, pageSize2) {
      emit("change", page, pageSize2);
    }
    function showSizeChangeHandler(current2, size) {
      emit("showSizeChange", current2, size);
    }
    return {
      prefixCls: prefixCls2,
      getSlots,
      innerCurrent,
      innerPageSize,
      changeHandler,
      showSizeChangeHandler,
      itemRender
    };
  }
});
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pagination = resolveComponent("Pagination");
  return openBlock(), createBlock(_component_Pagination, {
    class: normalizeClass([_ctx.prefixCls]),
    "default-page-size": _ctx.defaultPageSize,
    "page-size-options": _ctx.pageSizeOptions,
    "show-total": _ctx.showTotal,
    "show-size-changer": _ctx.showSizeChanger,
    "hide-on-single-page": _ctx.hideOnSinglePage,
    total: _ctx.total,
    current: _ctx.innerCurrent,
    "onUpdate:current": _cache[0] || (_cache[0] = ($event) => _ctx.innerCurrent = $event),
    pageSize: _ctx.innerPageSize,
    "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event) => _ctx.innerPageSize = $event),
    onChange: _ctx.changeHandler,
    onShowSizeChange: _ctx.showSizeChangeHandler,
    "item-render": _ctx.itemRender
  }, createSlots({ _: 2 }, [
    renderList(_ctx.getSlots, (item) => {
      return {
        name: item,
        fn: withCtx((data6) => [
          renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})), void 0, true)
        ])
      };
    })
  ]), 1032, ["class", "default-page-size", "page-size-options", "show-total", "show-size-changer", "hide-on-single-page", "total", "current", "pageSize", "onChange", "onShowSizeChange", "item-render"]);
}
var Pagination = /* @__PURE__ */ _export_sfc$1(_sfc_main$M, [["render", _sfc_render$E], ["__scopeId", "data-v-5cfeccb1"]]);
var index$8 = withInstall$1(Pagination);
var FbuModal_vue_vue_type_style_index_0_scoped_true_lang = "";
const iconCompMap = {
  success: {
    name: "CheckCircleFilled",
    class: "modal-icon-success"
  },
  info: {
    name: "InfoCircleFilled",
    class: "modal-icon-info"
  },
  warning: {
    name: "ExclamationCircleFilled",
    class: "modal-icon-warning"
  },
  error: {
    name: "CloseCircleFilled",
    class: "modal-icon-error"
  }
};
const _sfc_main$L = defineComponent({
  name: "FbuModal",
  inheritAttrs: false,
  props: {
    visible: z.bool.def(false),
    icon: z.oneOf(["success", "info", "warning", "error"]).def("info"),
    title: z.string.def(""),
    subTitle: z.string.def(""),
    desc: z.string.def(""),
    width: z.oneOfType([String, z.integer]).def(360),
    cancelText: z.string.def("\u53D6\u6D88"),
    cancelButtonProps: A().def({ color: "secondary" }),
    okButtonProps: A(),
    okText: z.string.def("\u786E\u5B9A"),
    okType: E().def("primary"),
    confirmLoading: z.bool.def(false),
    showOkBtn: z.bool.def(true),
    showCancelBtn: z.bool.def(false),
    maskClosable: z.bool.def(false),
    onOk: P()
  },
  emits: ["update:visible", "ok", "cancel"],
  components: {
    Modal: Modal$1,
    FbuButton: Button,
    InfoCircleFilled: InfoCircleFilled$1,
    CloseCircleFilled: CloseCircleFilled$1,
    CheckCircleFilled: CheckCircleFilled$1,
    ExclamationCircleFilled: ExclamationCircleFilled$1
  },
  setup(props2, { slots, emit }) {
    const getSlots = Object.keys(slots).filter((item) => item !== "default" && item !== "footer");
    const iconComp = computed(() => {
      return props2.icon ? iconCompMap[props2.icon] : iconCompMap.info;
    });
    const innerVisible = computed({
      get: () => props2.visible,
      set: (visible) => {
        emitVisible(visible);
      }
    });
    function emitVisible(visible) {
      emit("update:visible", visible);
    }
    function handleCancel() {
      emit("cancel");
      emitVisible(false);
    }
    function handleConfirm() {
      if (props2.onOk) {
        emit("ok");
      } else {
        emitVisible(false);
      }
    }
    return {
      innerVisible,
      getSlots,
      iconComp,
      handleCancel,
      handleConfirm
    };
  }
});
const _hoisted_1$t = { class: "flex feedback-object" };
const _hoisted_2$a = { class: "feedback-object-icon" };
const _hoisted_3$6 = { class: "feedback-object-content" };
const _hoisted_4$2 = { class: "object-content-text" };
const _hoisted_5$2 = { class: "object-content-desc" };
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_fbu_button = resolveComponent("fbu-button");
  const _component_Modal = resolveComponent("Modal");
  return openBlock(), createBlock(_component_Modal, mergeProps({
    visible: _ctx.innerVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event) => _ctx.innerVisible = $event)
  }, _ctx.$attrs, {
    title: _ctx.title,
    width: _ctx.width,
    "mask-closable": _ctx.maskClosable,
    centered: "",
    onCancel: _ctx.handleCancel
  }), createSlots({
    footer: withCtx(() => [
      renderSlot(_ctx.$slots, "footer", {}, () => [
        _ctx.showCancelBtn ? (openBlock(), createBlock(_component_fbu_button, mergeProps({
          key: 0,
          onClick: _ctx.handleCancel
        }, _ctx.cancelButtonProps), {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.cancelText), 1)
          ]),
          _: 1
        }, 16, ["onClick"])) : createCommentVNode("", true),
        _ctx.showOkBtn ? (openBlock(), createBlock(_component_fbu_button, mergeProps({
          key: 1,
          onClick: _ctx.handleConfirm,
          type: _ctx.okType,
          loading: _ctx.confirmLoading
        }, _ctx.okButtonProps), {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.okText), 1)
          ]),
          _: 1
        }, 16, ["onClick", "type", "loading"])) : createCommentVNode("", true)
      ], true)
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, () => [
        createElementVNode("div", _hoisted_1$t, [
          createElementVNode("div", _hoisted_2$a, [
            (openBlock(), createBlock(resolveDynamicComponent(_ctx.iconComp.name), {
              class: normalizeClass(["object-icon-inner", _ctx.iconComp.class])
            }, null, 8, ["class"]))
          ]),
          createElementVNode("div", _hoisted_3$6, [
            createElementVNode("p", _hoisted_4$2, toDisplayString(_ctx.subTitle), 1),
            createElementVNode("p", _hoisted_5$2, toDisplayString(_ctx.desc), 1)
          ])
        ])
      ], true)
    ]),
    _: 2
  }, [
    renderList(_ctx.getSlots, (item) => {
      return {
        name: item,
        fn: withCtx((data6) => [
          renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})), void 0, true)
        ])
      };
    })
  ]), 1040, ["visible", "title", "width", "mask-closable", "onCancel"]);
}
var Modal = /* @__PURE__ */ _export_sfc$1(_sfc_main$L, [["render", _sfc_render$D], ["__scopeId", "data-v-23dad012"]]);
var FbuModal = withInstall$1(Modal);
var StatusCode;
(function(StatusCode2) {
  StatusCode2["UNAUTHORIZED_401"] = "401";
  StatusCode2["FORBIDDEN_403"] = "403";
  StatusCode2["NOT_FOUND_404"] = "404";
  StatusCode2["INTERNAL_SERVER_ERROR_500"] = "500";
})(StatusCode || (StatusCode = {}));
var _sfc_main$K = defineComponent({
  name: "FbuResult",
  props: {
    status: E().def("404"),
    title: z.string.def(""),
    subTitle: z.string.def("")
  },
  setup(props2, {
    slots
  }) {
    const statusDataMap = {};
    statusDataMap[StatusCode.NOT_FOUND_404] = {
      status: "404",
      title: "404",
      subTitle: "\u62B1\u6B49\uFF0C\u60A8\u8BBF\u95EE\u7684\u9875\u9762\u4E0D\u5B58\u5728\uFF01"
    };
    statusDataMap[StatusCode.UNAUTHORIZED_401] = {
      status: "403",
      title: "401",
      subTitle: "\u62B1\u6B49\uFF0C\u60A8\u6CA1\u6709\u8BBF\u95EE\u6B64\u9875\u9762\u7684\u6743\u9650\uFF01"
    };
    statusDataMap[StatusCode.FORBIDDEN_403] = {
      status: "403",
      title: "403",
      subTitle: "\u62B1\u6B49\uFF0C\u60A8\u6CA1\u6709\u8BBF\u95EE\u6B64\u9875\u9762\u7684\u6743\u9650\uFF01"
    };
    statusDataMap[StatusCode.INTERNAL_SERVER_ERROR_500] = {
      status: "500",
      title: "500",
      subTitle: "\u62B1\u6B49\uFF0C\u670D\u52A1\u5668\u5D29\u6E83\u4E86\uFF01"
    };
    const sp = new URLSearchParams(location.search);
    const getStatus = computed(() => sp.get("status") || props2.status);
    const getStatusData = computed(() => statusDataMap[getStatus.value] || {
      status: props2.status,
      title: props2.title,
      subTitle: props2.subTitle
    });
    return () => {
      const {
        status,
        title,
        subTitle
      } = getStatusData.value;
      return createVNode(Result$1, {
        "status": status,
        "title": title,
        "sub-title": subTitle
      }, slots);
    };
  },
  components: {}
});
var index$7 = withInstall$1(_sfc_main$K);
var SvgIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$J = defineComponent({
  name: "FbuSvgIcon",
  props: {
    prefix: z.string.def("icon"),
    name: z.string.isRequired,
    size: z.oneOfType([String, Number]).def(14)
  },
  setup(props2) {
    const symbolId = computed(() => `#${props2.prefix}-${props2.name}`);
    const sizeStyle = computed(() => {
      const { size } = props2;
      const sizeVal = typeof size === "number" ? `${size}px` : size;
      return {
        width: sizeVal,
        height: sizeVal
      };
    });
    return {
      symbolId,
      sizeStyle
    };
  }
});
const _hoisted_1$s = ["xlink:href"];
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    class: "svg-icon",
    style: normalizeStyle(_ctx.sizeStyle),
    "aria-hidden": "true"
  }, [
    createElementVNode("use", { "xlink:href": _ctx.symbolId }, null, 8, _hoisted_1$s)
  ], 4);
}
var SvgIcon$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$J, [["render", _sfc_render$C], ["__scopeId", "data-v-0441f39e"]]);
var SvgIcon = withInstall$1(SvgIcon$1);
const useQRCodeProps = {
  rendererOpts: {
    quality: 0.95
  },
  width: 160,
  errorCorrectionLevel: "H"
};
function useQRCode(text, options = __spreadValues({
  type: "image/webp"
}, useQRCodeProps)) {
  const innerText = ref(text);
  const result = ref("");
  watch(innerText, async (newVal) => {
    if (newVal === "") {
      return;
    }
    try {
      result.value = await toDataURL(newVal, options);
    } catch (error) {
      console.log("\u751F\u6210\u4E8C\u7EF4\u7801\u5931\u8D25\uFF1A" + error);
    }
  }, {
    immediate: true
  });
  return result;
}
function roundedImage(ctx, x2, y2, width, height, radius) {
  ctx.beginPath();
  ctx.moveTo(x2 + radius, y2);
  ctx.lineTo(x2 + width - radius, y2);
  ctx.quadraticCurveTo(x2 + width, y2, x2 + width, y2 + radius);
  ctx.lineTo(x2 + width, y2 + height - radius);
  ctx.quadraticCurveTo(x2 + width, y2 + height, x2 + width - radius, y2 + height);
  ctx.lineTo(x2 + radius, y2 + height);
  ctx.quadraticCurveTo(x2, y2 + height, x2, y2 + height - radius);
  ctx.lineTo(x2, y2 + radius);
  ctx.quadraticCurveTo(x2, y2, x2 + radius, y2);
  ctx.closePath();
}
function drawLogo(canvasEl, { src, crossOrigin = "Anonymous", type: type4 = "circle", size = 40, shadow = true }) {
  if (typeof src !== "string" || src.trim() === "") {
    return;
  }
  const ctx = canvasEl.getContext("2d");
  if (!ctx) {
    return;
  }
  const offset3 = 6;
  const image = new Image();
  image.onload = function() {
    const w2 = image.naturalWidth;
    const h2 = image.naturalHeight;
    if (shadow) {
      ctx.shadowColor = "#00000026";
      ctx.shadowBlur = 10;
    }
    if (type4 === "default") {
      const dx = (canvasEl.width - size) / 2;
      const dy = (canvasEl.height - size) / 2;
      ctx.drawImage(image, 0, 0, w2, h2, dx, dy, size, size);
    } else if (type4 === "rect") {
      const roundedSize = size + offset3;
      const sx = (canvasEl.width - roundedSize) / 2;
      const sy = (canvasEl.height - roundedSize) / 2;
      const isx = sx + offset3 / 2;
      const isy = sy + offset3 / 2;
      ctx.save();
      roundedImage(ctx, sx, sy, roundedSize, roundedSize, 5);
      ctx.fillStyle = "white";
      ctx.fill();
      roundedImage(ctx, isx, isy, size, size, 5);
      ctx.clip();
      ctx.drawImage(image, isx, isy, size, size);
      ctx.restore();
    } else {
      const roundedSize = size + offset3;
      const sx = canvasEl.width / 2;
      const sy = canvasEl.height / 2;
      ctx.save();
      ctx.beginPath();
      ctx.arc(sx, sy, roundedSize / 2, 0, Math.PI * 2, false);
      ctx.closePath();
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.beginPath();
      ctx.arc(sx, sy, size / 2, 0, Math.PI * 2, false);
      ctx.closePath();
      ctx.clip();
      ctx.drawImage(image, sx - size / 2, sy - size / 2, size, size);
      ctx.restore();
    }
  };
  image.crossOrigin = crossOrigin;
  image.src = src;
}
const _sfc_main$I = defineComponent({
  name: "FbuQrCode",
  emits: ["created"],
  props: {
    text: z.string.def(""),
    options: A().def(__spreadValues({}, useQRCodeProps)),
    tag: z.oneOf(["canvas", "img", "svg"]).def("canvas"),
    logo: A().def(() => ({ src: "" }))
  },
  setup(props2, { emit }) {
    const qrCodeRef = ref(null);
    onMounted(() => {
      watch(props2, (newProps) => {
        nextTick(async () => {
          await createQRCode(newProps.text);
          emit("created");
        });
      }, {
        immediate: true,
        deep: true
      });
    });
    async function createQRCode(text) {
      var _a2;
      const { tag, options } = props2;
      try {
        if (tag === "canvas") {
          await QRCode.toCanvas(qrCodeRef.value, text, options);
          drawLogo(qrCodeRef.value, props2.logo);
        } else if (tag === "img") {
          const src = await QRCode.toDataURL(text, options);
          qrCodeRef.value.src = src;
        } else {
          const string3 = await QRCode.toString(text, options);
          const doc = new DOMParser().parseFromString(string3, "image/svg+xml");
          const svg = doc.querySelector("svg");
          if (svg) {
            const { attributes: attributes2, childNodes } = svg;
            Object.keys(attributes2).forEach((k2) => {
              var _a3;
              (_a3 = qrCodeRef.value) == null ? void 0 : _a3.setAttribute(attributes2[k2].name, attributes2[k2].value);
            });
            const nodes = [];
            childNodes.forEach((node) => {
              nodes.push(node.cloneNode(true));
            });
            (_a2 = qrCodeRef.value) == null ? void 0 : _a2.append(...nodes);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
    return {
      qrCodeRef
    };
  }
});
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), { ref: "qrCodeRef" }, null, 512);
}
var QrCode = /* @__PURE__ */ _export_sfc$1(_sfc_main$I, [["render", _sfc_render$B]]);
var index$6 = withInstall$1(QrCode);
const useBarcodeProps = {
  width: 2,
  height: 50,
  lineColor: "#555b74",
  fontSize: 18
};
function useBarcode(text, options = __spreadValues({}, useBarcodeProps)) {
  const innerText = ref(text);
  const result = ref("");
  watch(innerText, (newVal) => {
    if (newVal === "") {
      return;
    }
    let img = document.createElement("img");
    JsBarcode(img, newVal, options);
    result.value = img.src;
    img = null;
  }, {
    immediate: true
  });
  return result;
}
const _sfc_main$H = defineComponent({
  name: "FbuBarcode",
  emits: ["created"],
  props: {
    text: z.string.def(""),
    options: A().def(__spreadValues({}, useBarcodeProps)),
    tag: z.oneOf(["canvas", "img", "svg"]).def("img")
  },
  setup(props2, { emit }) {
    const barcodeRef = ref(null);
    onMounted(() => {
      watch(props2, (newProps) => {
        nextTick(async () => {
          await createBarcode(newProps.text);
          emit("created");
        });
      }, {
        immediate: true,
        deep: true
      });
    });
    async function createBarcode(text) {
      const { options } = props2;
      try {
        JsBarcode(barcodeRef.value, text, options);
      } catch (error) {
        console.error(error);
      }
    }
    return {
      barcodeRef
    };
  }
});
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), { ref: "barcodeRef" }, null, 512);
}
var Barcode = /* @__PURE__ */ _export_sfc$1(_sfc_main$H, [["render", _sfc_render$A]]);
var index$5 = withInstall$1(Barcode);
var FbuDescriptions_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$G = defineComponent({
  name: "FbuDescriptions",
  inheritAttrs: false,
  props: {
    items: q().def(() => []),
    bordered: z.bool.def(false),
    title: E(),
    column: z.number.def(4)
  },
  components: {
    Descriptions: Descriptions$1,
    DescriptionsItem: Descriptions$1.Item
  },
  setup(_2, { slots }) {
    const getDescSlots = Object.keys(slots).filter((slot) => slot === "extra" || slot === "title");
    const prefixCls2 = usePrefixCls("descriptions");
    return {
      getDescSlots,
      prefixCls: prefixCls2
    };
  }
});
const _hoisted_1$r = { key: 1 };
const _hoisted_2$9 = { key: 1 };
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DescriptionsItem = resolveComponent("DescriptionsItem");
  const _component_Descriptions = resolveComponent("Descriptions");
  return openBlock(), createBlock(_component_Descriptions, mergeProps({
    class: [_ctx.prefixCls],
    title: _ctx.title,
    bordered: _ctx.bordered,
    column: _ctx.column
  }, _ctx.$attrs), createSlots({
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
        return openBlock(), createBlock(_component_DescriptionsItem, mergeProps({
          key: item.label
        }, item.props), {
          label: withCtx(() => [
            item.slot ? renderSlot(_ctx.$slots, `${item.slot}Label`, normalizeProps(mergeProps({ key: 0 }, item)), () => [
              createTextVNode(toDisplayString(item.label), 1)
            ], true) : (openBlock(), createElementBlock("span", _hoisted_1$r, toDisplayString(item.label), 1))
          ]),
          default: withCtx(() => [
            item.slot ? renderSlot(_ctx.$slots, item.slot, normalizeProps(mergeProps({ key: 0 }, item)), () => [
              createTextVNode(toDisplayString(item.value), 1)
            ], true) : (openBlock(), createElementBlock("span", _hoisted_2$9, toDisplayString(item.value), 1))
          ]),
          _: 2
        }, 1040);
      }), 128))
    ]),
    _: 2
  }, [
    renderList(_ctx.getDescSlots, (slot) => {
      return {
        name: slot,
        fn: withCtx(() => [
          renderSlot(_ctx.$slots, slot, {}, void 0, true)
        ])
      };
    })
  ]), 1040, ["class", "title", "bordered", "column"]);
}
var FbuDescriptions = /* @__PURE__ */ _export_sfc$1(_sfc_main$G, [["render", _sfc_render$z], ["__scopeId", "data-v-45113f7f"]]);
var index$4 = withInstall$1(FbuDescriptions);
function debounce(fn, wait = 200, immediate = true) {
  let timeout = null;
  return function(...args) {
    const later = () => {
      timeout = null;
      if (immediate !== true) {
        fn.apply(this, args);
      }
    };
    if (timeout) {
      clearTimeout(timeout);
    }
    if (immediate && timeout === null) {
      fn.apply(this, args);
    }
    timeout = setTimeout(later, wait);
  };
}
var IconUpDown = () => {
  return createVNode("svg", {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "currentColor"
  }, [createVNode("path", {
    "d": "M5.52062 11.182C5.32536 10.9867 5.00878 10.9867 4.81351 11.182C4.61825 11.3772 4.61825 11.6938 4.81351 11.8891L7.64194 14.7175C7.8372 14.9128 8.15379 14.9128 8.34905 14.7175L11.1775 11.8891C11.3727 11.6938 11.3727 11.3772 11.1775 11.182C10.9822 10.9867 10.6656 10.9867 10.4704 11.182L7.99549 13.6568L5.52062 11.182Z"
  }, null), createVNode("path", {
    "d": "M11.1775 4.85355C11.3727 4.65829 11.3727 4.34171 11.1775 4.14645L8.34905 1.31802C8.15379 1.12276 7.8372 1.12276 7.64194 1.31802L4.81351 4.14645C4.61825 4.34171 4.61825 4.65829 4.81351 4.85355C5.00878 5.04882 5.32536 5.04882 5.52062 4.85355L7.99549 2.37868L10.4704 4.85355C10.6656 5.04882 10.9822 5.04882 11.1775 4.85355Z"
  }, null)]);
};
const _sfc_main$F = defineComponent({
  name: "FbuSelect",
  inheritAttrs: false,
  props: {
    value: L([]).isRequired,
    allowClear: x().def(true),
    options: q(),
    showSearch: {
      type: Boolean,
      default: void 0
    },
    filterOption: L([
      Boolean,
      P()
    ]).def(true),
    showArrow: {
      type: Boolean,
      default: true
    },
    notFoundContent: E(),
    fetching: x().def(false),
    remote: x().def(false),
    labelValueProp: A().def({
      label: "label",
      value: "value"
    }),
    mode: E(),
    maxTagCount: N().def(1),
    maxTagTextLength: N().def(7)
  },
  components: {
    Select: Select$1,
    Spin,
    LoadingOutlined: LoadingOutlined$1,
    IconUpDown
  },
  emits: ["update:value", "search"],
  setup(props2, { emit, attrs }) {
    const prefixCls2 = usePrefixCls("select");
    const innerValue = computed({
      get: () => props2.value,
      set: (newVal) => {
        emit("update:value", newVal);
      }
    });
    const innerOptions = computed(() => transformOptions(props2.options, props2.labelValueProp));
    const searchHandler = debounce((value) => {
      emit("search", value);
    }, 300);
    const isMultipleMode = computed(() => props2.mode === "multiple" || props2.mode === "tags");
    const getSelectProps = computed(() => {
      const { remote: isRemote, mode, maxTagCount, maxTagTextLength } = props2;
      return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, attrs), {
        showSearch: isRemote || props2.showSearch,
        filterOption: isRemote ? false : props2.filterOption,
        showArrow: isRemote ? false : props2.showArrow,
        notFoundContent: isRemote ? props2.fetching ? void 0 : null : props2.notFoundContent
      }), isRemote ? { onSearch: searchHandler } : {}), {
        mode,
        maxTagCount,
        maxTagTextLength
      });
    });
    return {
      innerValue,
      prefixCls: prefixCls2,
      innerOptions,
      searchHandler,
      getSelectProps,
      isMultipleMode
    };
  }
});
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingOutlined = resolveComponent("LoadingOutlined");
  const _component_IconUpDown = resolveComponent("IconUpDown");
  const _component_Spin = resolveComponent("Spin");
  const _component_Select = resolveComponent("Select");
  return openBlock(), createBlock(_component_Select, mergeProps({
    value: _ctx.innerValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.innerValue = $event),
    class: [_ctx.prefixCls, _ctx.isMultipleMode && "is-multiple"],
    "allow-clear": _ctx.allowClear,
    options: _ctx.innerOptions
  }, _ctx.getSelectProps), createSlots({ _: 2 }, [
    renderList(Object.keys(_ctx.$slots), (slot) => {
      return {
        name: slot,
        fn: withCtx((data6) => [
          renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})))
        ])
      };
    }),
    _ctx.fetching || _ctx.isMultipleMode ? {
      name: "suffixIcon",
      fn: withCtx(() => [
        _ctx.fetching ? (openBlock(), createBlock(_component_LoadingOutlined, {
          key: 0,
          spin: ""
        })) : (openBlock(), createBlock(_component_IconUpDown, { key: 1 }))
      ])
    } : void 0,
    _ctx.fetching ? {
      name: "notFoundContent",
      fn: withCtx(() => [
        createVNode(_component_Spin, { size: "small" })
      ])
    } : void 0
  ]), 1040, ["value", "class", "allow-clear", "options"]);
}
var FbuSelect$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$F, [["render", _sfc_render$y]]);
var FbuSelect = withInstall$1(FbuSelect$1);
var FbuPreview_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$E = defineComponent({
  name: "FbuPreview",
  inheritAttrs: false,
  props: {
    imgList: {
      type: Array
    }
  },
  components: {
    Image: Image$2,
    ImageGroup: Image$2.PreviewGroup
  },
  setup(props2) {
    const prefixCls2 = usePrefixCls("preview");
    const getImgList = computed(() => {
      const { imgList } = props2;
      if (!imgList) {
        return [];
      }
      const width = 120;
      return imgList.map((item) => {
        if (typeof item === "string") {
          return {
            src: item,
            width
          };
        }
        return Object.assign({ width }, item);
      });
    });
    return {
      prefixCls: prefixCls2,
      getImgList
    };
  }
});
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = resolveComponent("Image");
  const _component_ImageGroup = resolveComponent("ImageGroup");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.prefixCls])
  }, [
    createVNode(_component_ImageGroup, null, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, () => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.getImgList, (item) => {
            return openBlock(), createBlock(_component_Image, mergeProps(item, {
              key: item.src
            }), createSlots({ _: 2 }, [
              item.placeholder ? {
                name: "placeholder",
                fn: withCtx(() => [
                  createVNode(_component_Image, mergeProps(item, {
                    src: item.placeholder,
                    preview: false
                  }), null, 16, ["src"])
                ])
              } : void 0
            ]), 1040);
          }), 128))
        ], true)
      ]),
      _: 3
    })
  ], 2);
}
var FbuPreview = /* @__PURE__ */ _export_sfc$1(_sfc_main$E, [["render", _sfc_render$x], ["__scopeId", "data-v-9c6489f4"]]);
var ImageViewer_vue_vue_type_style_index_0_scoped_true_lang = "";
const MAX_SCALE = 4;
const SCALE_INCREMENTAL = 0.1;
const _sfc_main$D = defineComponent({
  name: "ImageViewer",
  props: {
    show: x().def(false),
    index: V().def(0),
    imgList: q().def(() => [])
  },
  emits: ["update:show"],
  components: {
    CloseOutlined: CloseOutlined$1,
    LeftOutlined: LeftOutlined$1,
    RightOutlined: RightOutlined$1,
    RedoOutlined: RedoOutlined$1,
    RotateLeftOutlined: RotateLeftOutlined$1,
    RotateRightOutlined: RotateRightOutlined$1,
    ZoomInOutlined: ZoomInOutlined$1,
    ZoomOutOutlined: ZoomOutOutlined$1
  },
  setup(props2, { emit, expose }) {
    const prefixCls2 = usePrefixCls("image-viewer");
    const visible = ref(props2.show);
    const loading = ref(false);
    const currentSrc = ref("");
    const currentIndex = ref(0);
    const currentScale = ref(1);
    const prevDisabled = computed(() => currentIndex.value <= 0);
    const nextDisabled = computed(() => currentIndex.value >= props2.imgList.length - 1);
    const imageStyle = ref({});
    const initialized = ref(false);
    const containerRef = ref(null);
    const imgState = ref({
      naturalW: 0,
      naturalH: 0,
      width: 0,
      height: 0,
      left: 0,
      top: 0,
      rotate: 0
    });
    const isMouseDown = ref(false);
    const mdOffset = { x: 0, y: 0 };
    const currentRotate = ref(0);
    const zoomInDisabled = computed(() => currentScale.value >= MAX_SCALE);
    const zoomOutDisabled = computed(() => currentScale.value <= 1 / MAX_SCALE);
    let zoomCenterPos = null;
    watch(() => props2.show, (show) => {
      visible.value = show;
    });
    watch(visible, (show) => {
      emit("update:show", show);
      if (show) {
        initViewer();
        showImage(props2.index);
      } else {
        destroyViewer();
      }
    }, { immediate: true });
    watch(() => props2.index, (index2) => {
      currentIndex.value = index2;
    });
    watch(currentIndex, (index2) => {
      showImage(index2);
    });
    watch(imgState, (state) => {
      setImgStyle(state);
    }, { deep: true });
    function initViewer() {
      if (initialized.value) {
        return;
      }
      document.documentElement.classList.add("is-hidden");
      window.addEventListener("resize", reset, false);
      initialized.value = true;
    }
    function destroyViewer() {
      document.documentElement.classList.remove("is-hidden");
      window.removeEventListener("resize", reset, false);
      initialized.value = false;
    }
    function initState() {
      currentScale.value = 1;
      currentRotate.value = 0;
      zoomCenterPos = null;
    }
    function showImage(index2 = 0) {
      currentIndex.value = Math.min(props2.imgList.length, index2);
      const curSrc = props2.imgList[currentIndex.value];
      initImgStyle();
      loadImage(curSrc).then(({ w: w2, h: h2 }) => {
        setTimeout(() => {
          const stylesData = adjustImageDisplayMetrics(w2, h2);
          imgState.value = Object.assign({ naturalW: w2, naturalH: h2, withTransition: true }, stylesData);
          currentSrc.value = curSrc;
        }, 0);
      }).catch((err) => {
        console.log(err);
      });
    }
    function initImgStyle() {
      const $container = containerRef.value;
      const width = $container ? $container.offsetWidth : window.innerWidth;
      const height = $container ? $container.offsetHeight : window.innerHeight;
      initState();
      Object.assign(imgState.value, {
        width: 0,
        height: 0,
        left: width / 2,
        top: height / 2,
        rotate: 0,
        withTransition: false
      });
    }
    function loadImage(url2) {
      return new Promise((resolve, reject) => {
        loading.value = true;
        const metricsImg = (img) => {
          loading.value = false;
          return {
            w: img.width,
            h: img.height
          };
        };
        const imgObj = new Image();
        imgObj.src = url2;
        if (imgObj.complete) {
          resolve(metricsImg(imgObj));
        } else {
          imgObj.onload = () => {
            resolve(metricsImg(imgObj));
          };
          imgObj.onerror = () => {
            loading.value = false;
            reject("image load error");
          };
        }
      });
    }
    function adjustImageDisplayMetrics(naturalWidth, naturalHeight) {
      const $viewer = containerRef.value;
      if (!$viewer) {
        return {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        };
      }
      const aspectRatio = naturalWidth / naturalHeight;
      let viewerWidth = $viewer.offsetWidth;
      let viewerHeight = $viewer.offsetHeight;
      let width = viewerWidth;
      let height = viewerHeight;
      if (viewerHeight * aspectRatio > viewerWidth) {
        height = viewerWidth / aspectRatio;
      } else {
        width = viewerHeight * aspectRatio;
      }
      width = Math.min(width * 0.9, naturalWidth);
      height = Math.min(height * 0.9, naturalHeight);
      const left = (viewerWidth - width) / 2;
      const top = (viewerHeight - height) / 2;
      return {
        width,
        height,
        left,
        top
      };
    }
    function setImgStyle(styleObject) {
      const { width, height, left, top, rotate, withTransition } = styleObject;
      const styles = {
        width: width + "px",
        height: height + "px",
        marginLeft: left + "px",
        marginTop: top + "px",
        maxWidth: "none !important",
        position: "absolute",
        transform: `rotate(${rotate}deg)`
      };
      if (withTransition) {
        styles.transition = "all .3s";
      }
      imageStyle.value = styles;
    }
    function handleClose() {
      visible.value = false;
    }
    function handleMousewheel(e2) {
      const delta = getWheelDelta(e2);
      let scale = 0;
      if (delta > 0) {
        scale = currentScale.value + SCALE_INCREMENTAL;
      } else {
        scale = currentScale.value - SCALE_INCREMENTAL;
      }
      scalingImage(scale, e2.pageX, e2.pageY);
    }
    function handleZoom(zoom) {
      let scale = 0;
      if (zoom === 1) {
        scale = currentScale.value + 0.3;
      } else {
        scale = currentScale.value - 0.3;
      }
      const x2 = zoomCenterPos ? zoomCenterPos.x : window.innerWidth / 2;
      const y2 = zoomCenterPos ? zoomCenterPos.y : window.innerHeight / 2;
      scalingImage(scale, x2, y2);
    }
    function scalingImage(scale, x2, y2) {
      scale = scale > MAX_SCALE ? MAX_SCALE : 1 / MAX_SCALE > scale ? 1 / MAX_SCALE : scale;
      currentScale.value = scale;
      zoomCenterPos = { x: x2, y: y2 };
      const metrics = imgState.value;
      const increW = metrics.naturalW * scale;
      const increH = metrics.naturalH * scale;
      const offsetWidth = increW - metrics.width;
      const offsetHeight = increH - metrics.height;
      metrics.left -= offsetWidth * ((x2 - metrics.left) / metrics.width);
      metrics.top -= offsetHeight * ((y2 - metrics.top) / metrics.height);
      metrics.width = increW;
      metrics.height = increH;
      metrics.withTransition = true;
    }
    function getWheelDelta(e2) {
      var delta = 0;
      if (e2.wheelDelta) {
        delta = e2.wheelDelta;
      } else {
        delta = -e2.detail * 40;
      }
      return delta;
    }
    function handleMousedown(e2) {
      isMouseDown.value = true;
      mdOffset.x = e2.pageX - imgState.value.left;
      mdOffset.y = e2.pageY - imgState.value.top;
    }
    function handleMousemove(e2) {
      if (isMouseDown.value) {
        const left = e2.pageX - mdOffset.x;
        const top = e2.pageY - mdOffset.y;
        const metrics = imgState.value;
        metrics.left = left;
        metrics.top = top;
        metrics.withTransition = false;
      }
    }
    function handleMouseup() {
      isMouseDown.value = false;
    }
    function handlePrev() {
      if (prevDisabled.value) {
        return;
      }
      currentIndex.value--;
    }
    function handleNext() {
      if (nextDisabled.value) {
        return;
      }
      currentIndex.value++;
    }
    function handleRotate(direction2) {
      if (direction2 === 1) {
        currentRotate.value += 90;
      } else {
        currentRotate.value -= 90;
      }
      imgState.value.rotate = currentRotate.value;
      imgState.value.withTransition = true;
    }
    function handleReset() {
      reset();
    }
    function reset() {
      const { naturalW, naturalH } = imgState.value;
      const stylesData = adjustImageDisplayMetrics(naturalW, naturalH);
      Object.assign(imgState.value, stylesData, { rotate: 0, withTransition: true });
      initState();
    }
    expose({
      visible,
      reset,
      close: () => handleClose(),
      prev: () => handlePrev(),
      next: () => handleNext(),
      setRotate: (direction2) => handleRotate(direction2)
    });
    return {
      prefixCls: prefixCls2,
      visible,
      loading,
      currentSrc,
      imageStyle,
      prevDisabled,
      nextDisabled,
      containerRef,
      zoomInDisabled,
      zoomOutDisabled,
      handleClose,
      handleMousewheel,
      handleMousedown,
      handleMousemove,
      handleMouseup,
      handlePrev,
      handleNext,
      handleReset,
      handleRotate,
      handleZoom
    };
  }
});
const _hoisted_1$q = ["src"];
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseOutlined = resolveComponent("CloseOutlined");
  const _component_LeftOutlined = resolveComponent("LeftOutlined");
  const _component_RightOutlined = resolveComponent("RightOutlined");
  const _component_RedoOutlined = resolveComponent("RedoOutlined");
  const _component_RotateLeftOutlined = resolveComponent("RotateLeftOutlined");
  const _component_RotateRightOutlined = resolveComponent("RotateRightOutlined");
  const _component_ZoomInOutlined = resolveComponent("ZoomInOutlined");
  const _component_ZoomOutOutlined = resolveComponent("ZoomOutOutlined");
  return _ctx.visible ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(`${_ctx.prefixCls}-wrap`)
  }, [
    createElementVNode("div", {
      class: normalizeClass(`${_ctx.prefixCls}-overlay`)
    }, null, 2),
    createElementVNode("div", {
      class: normalizeClass(`${_ctx.prefixCls}`)
    }, [
      createElementVNode("div", {
        class: normalizeClass(`${_ctx.prefixCls}-header`)
      }, [
        createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClose && _ctx.handleClose(...args)),
          class: normalizeClass(`${_ctx.prefixCls}-close`)
        }, [
          createVNode(_component_CloseOutlined)
        ], 2)
      ], 2),
      createElementVNode("div", {
        ref: "containerRef",
        class: normalizeClass(`${_ctx.prefixCls}-container`),
        onWheel: _cache[9] || (_cache[9] = (...args) => _ctx.handleMousewheel && _ctx.handleMousewheel(...args)),
        onMousewheel: _cache[10] || (_cache[10] = (...args) => _ctx.handleMousewheel && _ctx.handleMousewheel(...args)),
        onDOMMouseScroll: _cache[11] || (_cache[11] = (...args) => _ctx.handleMousewheel && _ctx.handleMousewheel(...args)),
        onMousedown: _cache[12] || (_cache[12] = (...args) => _ctx.handleMousedown && _ctx.handleMousedown(...args)),
        onMousemove: _cache[13] || (_cache[13] = (...args) => _ctx.handleMousemove && _ctx.handleMousemove(...args)),
        onMouseup: _cache[14] || (_cache[14] = (...args) => _ctx.handleMouseup && _ctx.handleMouseup(...args))
      }, [
        createElementVNode("img", {
          class: normalizeClass([_ctx.loading && `is-loading`, `${_ctx.prefixCls}-img`]),
          src: _ctx.currentSrc,
          style: normalizeStyle(_ctx.imageStyle),
          onDragstart: _cache[1] || (_cache[1] = withModifiers(() => {
          }, ["prevent"]))
        }, null, 46, _hoisted_1$q),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(`${_ctx.prefixCls}-loading`)
        }, null, 2), [
          [vShow, _ctx.loading]
        ]),
        createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = (...args) => _ctx.handlePrev && _ctx.handlePrev(...args)),
          class: normalizeClass([_ctx.prevDisabled && `is-disabled`, `${_ctx.prefixCls}-btn`, `${_ctx.prefixCls}-btn--prev`])
        }, [
          createVNode(_component_LeftOutlined)
        ], 2),
        createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = (...args) => _ctx.handleNext && _ctx.handleNext(...args)),
          class: normalizeClass([_ctx.nextDisabled && `is-disabled`, `${_ctx.prefixCls}-btn`, `${_ctx.prefixCls}-btn--next`])
        }, [
          createVNode(_component_RightOutlined)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(`${_ctx.prefixCls}-action-btns`)
        }, [
          createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = (...args) => _ctx.handleReset && _ctx.handleReset(...args)),
            class: normalizeClass([`${_ctx.prefixCls}-btn`, `${_ctx.prefixCls}-btn--recovery`])
          }, [
            createVNode(_component_RedoOutlined)
          ], 2),
          createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event) => _ctx.handleRotate(2)),
            class: normalizeClass([`${_ctx.prefixCls}-btn`, `${_ctx.prefixCls}-btn--rotate`])
          }, [
            createVNode(_component_RotateLeftOutlined)
          ], 2),
          createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event) => _ctx.handleRotate(1)),
            class: normalizeClass([`${_ctx.prefixCls}-btn`, `${_ctx.prefixCls}-btn--rotate`])
          }, [
            createVNode(_component_RotateRightOutlined)
          ], 2),
          createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event) => _ctx.handleZoom(1)),
            class: normalizeClass([
              _ctx.zoomInDisabled && `is-disabled`,
              `${_ctx.prefixCls}-btn`,
              `${_ctx.prefixCls}-btn--rotate`
            ])
          }, [
            createVNode(_component_ZoomInOutlined)
          ], 2),
          createElementVNode("div", {
            onClick: _cache[8] || (_cache[8] = ($event) => _ctx.handleZoom(2)),
            class: normalizeClass([
              _ctx.zoomOutDisabled && `is-disabled`,
              `${_ctx.prefixCls}-btn`,
              `${_ctx.prefixCls}-btn--rotate`
            ])
          }, [
            createVNode(_component_ZoomOutOutlined)
          ], 2)
        ], 2)
      ], 34)
    ], 2)
  ], 2)) : createCommentVNode("", true);
}
var ImageViewer = /* @__PURE__ */ _export_sfc$1(_sfc_main$D, [["render", _sfc_render$w], ["__scopeId", "data-v-9d9c4d1e"]]);
let instance = null;
function createImageViewer(options) {
  var _a2;
  const container = document.createElement("div");
  const props2 = {};
  Object.assign(props2, { index: 0, show: true }, options);
  instance = createVNode(ImageViewer, props2);
  render(instance, container);
  document.body.appendChild(container);
  const exposed = (_a2 = instance.component) == null ? void 0 : _a2.exposed;
  if (exposed) {
    watch(exposed.visible, (visible) => {
      if (!visible) {
        container.remove();
      }
    });
  }
  return exposed;
}
FbuPreview.createImageViewer = createImageViewer;
var index$3 = withInstall$1(FbuPreview);
function useCountdown(count) {
  const countRef = ref(count);
  let timer = null;
  const isStarted = ref(false);
  function stop2() {
    isStarted.value = false;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function reset() {
    countRef.value = count;
    stop2();
  }
  function reStart() {
    reset();
    start2();
  }
  function countdown() {
    if (unref(countRef) === 0) {
      reset();
    } else {
      timer = setTimeout(() => {
        countRef.value -= 1;
        countdown();
      }, 1e3);
    }
  }
  function start2() {
    if (unref(isStarted) || !!timer) {
      return;
    }
    isStarted.value = true;
    countdown();
  }
  return {
    isStarted,
    countRef,
    reset,
    start: start2,
    reStart
  };
}
const _sfc_main$C = defineComponent({
  name: "FbuCountdown",
  inheritAttrs: false,
  props: {
    control: L([Number, String, Object, Array, Boolean]).def(true),
    count: N().def(60),
    beforeStart: P()
  },
  components: {
    FbuButton: Button
  },
  setup(props2) {
    const { countRef, isStarted, start: start2, reset } = useCountdown(props2.count);
    const getBtnTxt = computed(() => {
      return unref(isStarted) ? `(${unref(countRef)})S\u540E\u91CD\u65B0\u83B7\u53D6` : "\u83B7\u53D6\u9A8C\u8BC1\u7801";
    });
    const loading = ref(false);
    watchEffect(() => {
      if (props2.control === false || props2.control === void 0) {
        reset();
      }
    });
    async function handleClick() {
      if (unref(isStarted)) {
        return;
      }
      const { beforeStart } = props2;
      if (typeof beforeStart === "function") {
        loading.value = true;
        try {
          const canStart = await beforeStart();
          canStart && start2();
        } finally {
          loading.value = false;
        }
      } else {
        start2();
      }
    }
    return {
      countRef,
      isStarted,
      getBtnTxt,
      loading,
      handleClick
    };
  }
});
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_fbu_button = resolveComponent("fbu-button");
  return openBlock(), createBlock(_component_fbu_button, mergeProps(_ctx.$attrs, {
    disabled: _ctx.isStarted,
    loading: _ctx.loading,
    onClick: _ctx.handleClick
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ count: _ctx.countRef, isStarted: _ctx.isStarted })), () => [
        createTextVNode(toDisplayString(_ctx.getBtnTxt), 1)
      ])
    ]),
    _: 3
  }, 16, ["disabled", "loading", "onClick"]);
}
var CountDown = /* @__PURE__ */ _export_sfc$1(_sfc_main$C, [["render", _sfc_render$v]]);
const defaultChangeEvent = "change";
function useFormItem({
  props: props2,
  key: key2 = "value",
  changeEvent = defaultChangeEvent,
  emitData = ref([])
}) {
  const instance2 = getCurrentInstance();
  const innerState = reactive({
    value: props2[key2]
  });
  const immutableState = readonly(innerState);
  watchEffect(() => {
    innerState.value = props2[key2];
  });
  function setState2(value) {
    innerState.value = value;
  }
  const state = computed({
    get: () => innerState.value,
    set: (value) => {
      if (immutableState.value === value) {
        return;
      }
      innerState.value = value;
      nextTick(() => {
        var _a2;
        (_a2 = instance2 == null ? void 0 : instance2.emit) == null ? void 0 : _a2.call(instance2, changeEvent, value, ...toRaw(unref(emitData)) || []);
      });
    }
  });
  return [state, setState2, immutableState];
}
useFormItem.DEFAULT_CHANGE_EVENT = defaultChangeEvent;
var CountdownInput_vue_vue_type_style_index_0_lang = "";
const _sfc_main$B = defineComponent({
  name: "FbuCountdownInput",
  inheritAttrs: false,
  props: {
    value: E().def(""),
    count: N().def(60),
    sendApi: P()
  },
  emits: ["update:value", defaultChangeEvent],
  components: {
    Input,
    CountDown
  },
  setup(props2, { slots, emit }) {
    const prefixCls2 = usePrefixCls("countdown-input");
    const getSlots = Object.keys(slots).filter((slot) => slot !== "addonAfter");
    const [state] = useFormItem({ props: props2 });
    watchEffect(() => {
      emit("update:value", state.value);
    });
    return {
      prefixCls: prefixCls2,
      getSlots,
      state
    };
  }
});
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CountDown = resolveComponent("CountDown");
  const _component_Input = resolveComponent("Input");
  return openBlock(), createBlock(_component_Input, mergeProps(_ctx.$attrs, {
    class: [_ctx.prefixCls],
    value: _ctx.state,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.state = $event)
  }), createSlots({
    addonAfter: withCtx(() => [
      createVNode(_component_CountDown, {
        count: _ctx.count,
        control: _ctx.state,
        "before-start": _ctx.sendApi
      }, null, 8, ["count", "control", "before-start"])
    ]),
    _: 2
  }, [
    renderList(_ctx.getSlots, (slot) => {
      return {
        name: slot,
        fn: withCtx((data6) => [
          renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})))
        ])
      };
    })
  ]), 1040, ["class", "value"]);
}
var CountdownInput = /* @__PURE__ */ _export_sfc$1(_sfc_main$B, [["render", _sfc_render$u]]);
CountDown.install = function(app) {
  app.component(CountDown.name, CountDown);
  app.component(CountdownInput.name, CountdownInput);
  return app;
};
const _sfc_main$A = defineComponent({
  name: "FbuApiTreeSelect",
  components: {
    TreeSelect: TreeSelect$1,
    LoadingOutlined: LoadingOutlined$1
  },
  inheritAttrs: false,
  emits: [defaultChangeEvent, "treedata-change", "update:value"],
  props: {
    value: L([String, q()]),
    api: P(),
    params: A(),
    resultField: E().def("list"),
    allowClear: x().def(true),
    placeholder: E().def("\u8BF7\u9009\u62E9")
  },
  setup(props2, { emit, attrs }) {
    const prefixCls2 = usePrefixCls("api-tree-select");
    const treeData = ref([]);
    const loading = ref(false);
    const isLoaded = ref(false);
    const [state] = useFormItem({ props: props2 });
    const getAttrs = computed(() => {
      return __spreadValues(__spreadValues({}, props2.api ? { treeData: treeData.value } : {}), attrs);
    });
    fetch();
    watch(() => props2.params, () => {
      !unref(isLoaded) && fetch();
    }, { deep: true });
    function handleChange2(...args) {
      emit("update:value", args[0]);
      emit("change", ...args);
    }
    async function fetch() {
      const { api: api2 } = props2;
      if (typeof api2 !== "function") {
        return;
      }
      loading.value = true;
      treeData.value = [];
      let result;
      try {
        result = await api2(props2.params);
      } catch (err) {
        console.log(err);
      }
      loading.value = false;
      if (!result) {
        return;
      }
      if (!Array.isArray(result)) {
        result = result[props2.resultField];
      }
      treeData.value = result || [];
      isLoaded.value = true;
      emit("treedata-change", treeData.value);
    }
    return {
      prefixCls: prefixCls2,
      state,
      getAttrs,
      loading,
      handleChange: handleChange2
    };
  }
});
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingOutlined = resolveComponent("LoadingOutlined");
  const _component_TreeSelect = resolveComponent("TreeSelect");
  return openBlock(), createBlock(_component_TreeSelect, mergeProps({
    value: _ctx.state,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.state = $event),
    "allow-clear": _ctx.allowClear,
    placeholder: _ctx.placeholder
  }, _ctx.getAttrs, {
    class: [_ctx.prefixCls],
    onChange: _ctx.handleChange
  }), createSlots({ _: 2 }, [
    renderList(Object.keys(_ctx.$slots), (slot) => {
      return {
        name: slot,
        fn: withCtx((data6) => [
          renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})))
        ])
      };
    }),
    _ctx.loading ? {
      name: "suffixIcon",
      fn: withCtx(() => [
        createVNode(_component_LoadingOutlined, { spin: "" })
      ])
    } : void 0
  ]), 1040, ["value", "allow-clear", "placeholder", "class", "onChange"]);
}
var ApiTreeSelect$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$A, [["render", _sfc_render$t]]);
var ApiTreeSelect = withInstall$1(ApiTreeSelect$1);
const _sfc_main$z = defineComponent({
  name: "FbuApiCascader",
  inheritAttrs: false,
  components: {
    Cascader: Cascader$1,
    LoadingOutlined: LoadingOutlined$1
  },
  props: {
    value: q().def([]),
    api: P(),
    resultField: E().def("list"),
    numberToString: x().def(false),
    fieldNames: A().def({
      label: "label",
      value: "value",
      children: "children"
    }),
    params: A().def({}),
    asyncFetchChildrenParamkey: E().def("parent_id"),
    placeholder: E().def("\u8BF7\u9009\u62E9"),
    checkIsLeaf: P()
  },
  emits: [defaultChangeEvent, "update:value"],
  setup(props2, { emit }) {
    const prefixCls2 = usePrefixCls("api-cascader");
    const options = ref([]);
    const loading = ref(false);
    const emitData = ref([]);
    const [state] = useFormItem({ props: props2, emitData });
    const data6 = ref([]);
    const spin = createVNode("div", { style: { textAlign: "center" } }, [
      createVNode(Spin, { size: "small" })
    ]);
    initData();
    watch(() => props2.params, () => {
      initData();
    }, { deep: true });
    watch(data6, (newData) => {
      if (Array.isArray(newData)) {
        options.value = generateOptions(newData);
      }
    }, { deep: true });
    function generateOptions(data22) {
      const { numberToString, checkIsLeaf, fieldNames } = props2;
      return data22.reduce((result, cur) => {
        const value = cur[fieldNames.value];
        const item = __spreadProps(__spreadValues({}, cur), {
          label: cur[fieldNames.label],
          value: numberToString ? `${value}` : value,
          isLeaf: typeof checkIsLeaf === "function" ? checkIsLeaf(cur) : false
        });
        const children = cur[fieldNames.children];
        if (children) {
          item.children = generateOptions(children);
        }
        result.push(item);
        return result;
      }, []);
    }
    async function initData() {
      const { api: api2 } = props2;
      if (typeof api2 !== "function") {
        return;
      }
      loading.value = true;
      data6.value = [];
      try {
        let result = await api2(props2.params);
        if (!result) {
          return;
        }
        if (!Array.isArray(result)) {
          result = result[props2.resultField];
        }
        data6.value = result || [];
      } catch (e2) {
        console.error(e2);
      } finally {
        loading.value = false;
      }
    }
    async function loadChildrenData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      const { api: api2 } = props2;
      if (typeof api2 !== "function") {
        return;
      }
      targetOption.loading = true;
      try {
        const result = await api2(__spreadValues({
          [props2.asyncFetchChildrenParamkey]: targetOption.value
        }, props2.params));
        if (Array.isArray(result)) {
          targetOption.children = generateOptions(result);
          return;
        }
        if (props2.resultField) {
          targetOption.children = generateOptions(result[props2.resultField] || []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        targetOption.loading = false;
      }
    }
    function handleChange2(value, ...args) {
      emit("update:value", value);
      emitData.value = args;
    }
    return {
      prefixCls: prefixCls2,
      loading,
      options,
      state,
      spin,
      loadChildrenData,
      handleChange: handleChange2
    };
  }
});
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingOutlined = resolveComponent("LoadingOutlined");
  const _component_Cascader = resolveComponent("Cascader");
  return openBlock(), createBlock(_component_Cascader, {
    value: _ctx.state,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.state = $event),
    class: normalizeClass([_ctx.prefixCls]),
    "change-on-select": true,
    "load-data": _ctx.loadChildrenData,
    options: _ctx.options,
    placeholder: _ctx.placeholder,
    onChange: _ctx.handleChange,
    "not-found-content": _ctx.spin
  }, createSlots({ _: 2 }, [
    _ctx.loading ? {
      name: "suffixIcon",
      fn: withCtx(() => [
        createVNode(_component_LoadingOutlined, { spin: "" })
      ])
    } : void 0
  ]), 1032, ["value", "class", "load-data", "options", "placeholder", "onChange", "not-found-content"]);
}
var ApiCascader$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$z, [["render", _sfc_render$s]]);
var ApiCascader = withInstall$1(ApiCascader$1);
var ApiRadioGroup_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$y = defineComponent({
  name: "FbuApiRadioGroup",
  components: {
    RadioGroup: RadioGroup$1,
    Spin
  },
  props: {
    api: P(),
    params: A().def(() => ({})),
    resultField: E().def("list"),
    buttonStyle: z.oneOf(["outline", "solid"]).def("solid"),
    value: z.any,
    fieldNames: A().def({ label: "label", value: "value" }),
    optionType: z.oneOf(["default", "button"]).def("button"),
    size: z.oneOf(["large", "small", "default"]).def("default")
  },
  emits: [defaultChangeEvent, "update:value", "options-change"],
  setup(props2, { emit, attrs }) {
    const prefixCls2 = usePrefixCls("radio-group");
    const [state] = useFormItem({ props: props2 });
    const getGroupProps = computed(() => {
      const { buttonStyle, optionType, size } = props2;
      return __spreadValues({ buttonStyle, optionType, size }, attrs);
    });
    const options = ref([]);
    const loading = ref(false);
    fetch();
    watch(() => props2.params, () => {
      fetch();
    }, { deep: true });
    const getClass2 = computed(() => {
      const len = options.value.length;
      const colSize = len <= 3 ? "normal" : len <= 6 ? "middle" : "large";
      return [prefixCls2, "radio-col-" + colSize];
    });
    async function fetch() {
      const { api: api2 } = props2;
      if (typeof api2 !== "function") {
        return;
      }
      options.value = [];
      loading.value = true;
      try {
        let result = await api2(props2.params);
        if (!result) {
          return;
        }
        if (!Array.isArray(result)) {
          result = result[props2.resultField];
        }
        options.value = transformOptions(result || [], props2.fieldNames);
        emit("options-change", unref(options));
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    }
    function handleChange2(e2) {
      const target = e2.target;
      emit("update:value", target.value);
    }
    return {
      getClass: getClass2,
      getGroupProps,
      state,
      options,
      loading,
      handleChange: handleChange2
    };
  }
});
const _hoisted_1$p = { class: "radio-group-container" };
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Spin = resolveComponent("Spin");
  const _component_RadioGroup = resolveComponent("RadioGroup");
  return openBlock(), createElementBlock("div", _hoisted_1$p, [
    _ctx.loading ? (openBlock(), createBlock(_component_Spin, {
      key: 0,
      size: "small"
    })) : (openBlock(), createBlock(_component_RadioGroup, mergeProps({
      key: 1,
      value: _ctx.state,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.state = $event),
      class: _ctx.getClass,
      options: _ctx.options
    }, _ctx.getGroupProps, { onChange: _ctx.handleChange }), null, 16, ["value", "class", "options", "onChange"]))
  ]);
}
var ApiRadioGroup$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$y, [["render", _sfc_render$r], ["__scopeId", "data-v-ac79006a"]]);
var ApiRadioGroup = withInstall$1(ApiRadioGroup$1);
var ApiSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$x = defineComponent({
  name: "FbuApiSelect",
  inheritAttrs: false,
  props: {
    value: L([]),
    allowClear: x().def(true),
    api: P(),
    resultField: E().def("records"),
    numberToString: x().def(false),
    fieldNames: A().def({ label: "label", value: "value" }),
    params: A().def({}),
    immediate: x().def(true),
    alwaysLoad: x().def(false),
    placeholder: E().def("\u8BF7\u9009\u62E9"),
    options: q().def(() => []),
    mode: E(),
    maxTagCount: N().def(1),
    maxTagTextLength: N().def(18),
    showArrow: x().def(true),
    showCheckBox: x().def(true),
    showSearch: x().def(false),
    optionFilterProp: E().def("label"),
    labelJoinValue: x().def(false),
    valueJoinLabel: x().def(false),
    labelFormat: P(),
    showCheckAll: x().def(false),
    checkAllText: E().def("\u5168\u9009")
  },
  components: {
    Select: Select$1,
    Spin,
    LoadingOutlined: LoadingOutlined$1,
    IconUpDown,
    Checkbox,
    VNodes: (_2, { attrs }) => {
      return attrs.vnodes;
    },
    SelectOption
  },
  emits: [defaultChangeEvent, "update:value", "search", "options-change"],
  setup(props2, { emit }) {
    const prefixCls2 = usePrefixCls("api-select");
    const loading = ref(false);
    const emitData = ref([]);
    const [state] = useFormItem({ props: props2, emitData });
    const options = ref(props2.options || []);
    const isFirstLoaded = ref(true);
    watchEffect(() => {
      props2.immediate && !props2.alwaysLoad && fetch();
    });
    watch(() => props2.options, (newOptions) => {
      options.value = newOptions;
    });
    watch(() => props2.params, () => {
      !unref(isFirstLoaded) && fetch();
    }, { deep: true });
    const innerOptions = computed(() => {
      const { fieldNames, numberToString, labelJoinValue, valueJoinLabel, labelFormat } = props2;
      const { label, value } = fieldNames;
      const getLabelText = (option2) => {
        if (typeof labelFormat === "function") {
          return labelFormat(option2);
        }
        return labelJoinValue ? `${option2[label]}[${option2[value]}]` : valueJoinLabel ? `${option2[value]}[${option2[label]}]` : option2[label];
      };
      return unref(options).map((item) => {
        return __spreadProps(__spreadValues({}, item), {
          disabled: item.disabled,
          label: getLabelText(item),
          value: numberToString && `${item[value]}` || item[value]
        });
      });
    });
    function unique(arr, key2) {
      const res = new Map();
      return arr.filter((a2) => !res.has(a2[key2]) && res.set(a2[key2], 1));
    }
    const innerOptionsFilterDisabled = computed(() => unique(innerOptions.value.filter((item) => !item.disabled), "value"));
    const isMultipleMode = computed(() => props2.mode === "multiple" || props2.mode === "tags");
    const getTitle = computed(() => {
      if (unref(isMultipleMode) && Array.isArray(state.value)) {
        return state.value.map((item) => {
          var _a2;
          return (_a2 = innerOptions.value.find((item1) => item1.value == item)) == null ? void 0 : _a2.label;
        }).join(";");
      } else {
        return "";
      }
    });
    const checkAll = ref(false);
    const indeterminate = ref(false);
    const onCheckAllChange = (e2) => {
      indeterminate.value = false;
      if (e2.target.checked) {
        state.value = innerOptionsFilterDisabled.value.map((item) => item.value);
      } else {
        state.value = [];
      }
    };
    const handleClickAllParent = (e2) => {
      if (e2.target.classList.contains("ant-checkbox-input")) {
        return;
      }
      onCheckAllChange({ target: { checked: !checkAll.value } });
    };
    watch(state, (val) => {
      if (isMultipleMode.value) {
        indeterminate.value = !!(val == null ? void 0 : val.length) && (val == null ? void 0 : val.length) < innerOptionsFilterDisabled.value.length;
        checkAll.value = (val == null ? void 0 : val.length) === innerOptionsFilterDisabled.value.length;
      }
    });
    const computedShowSearch = computed(() => {
      if (props2.showSearch) {
        return props2.showSearch;
      }
      return unref(innerOptions).length >= 6;
    });
    async function fetch() {
      var _a2;
      const { api: api2 } = props2;
      if (typeof api2 !== "function") {
        return;
      }
      options.value = [];
      loading.value = true;
      try {
        let result = await api2(props2.params);
        if (!result) {
          return;
        }
        if (!Array.isArray(result)) {
          result = result[props2.resultField];
        }
        options.value = result || [];
        emit("options-change", result.slice(0));
        if (isMultipleMode.value) {
          state.value = (_a2 = state.value) == null ? void 0 : _a2.slice(0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    }
    function handleChange2(value, ...args) {
      emit("update:value", value);
      emitData.value = args;
    }
    function handleVisibleChange(open2) {
      if (open2) {
        if (props2.alwaysLoad) {
          fetch();
        } else if (!props2.immediate && unref(isFirstLoaded)) {
          fetch();
          isFirstLoaded.value = false;
        }
      }
    }
    function maxTagPlaceholder(omittedValues) {
      return h$2(Tooltip, {
        overlayClassName: "custom-max-tag-tooltip"
      }, {
        default: () => h$2("span", { class: "custom-max-tag-placeholder" }, [
          `+ ${omittedValues.length} ...`
        ]),
        title: () => h$2("ul", null, omittedValues.map((item) => h$2("li", null, item.label)))
      });
    }
    return {
      prefixCls: prefixCls2,
      loading,
      state,
      innerOptions,
      handleChange: handleChange2,
      handleVisibleChange,
      isMultipleMode,
      getTitle,
      computedShowSearch,
      checkAll,
      indeterminate,
      onCheckAllChange,
      handleClickAllParent,
      maxTagPlaceholder
    };
  }
});
const _hoisted_1$o = { style: { "margin-inline-start": "4px" } };
const _hoisted_2$8 = { style: { "margin-inline-start": "4px" } };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingOutlined = resolveComponent("LoadingOutlined");
  const _component_IconUpDown = resolveComponent("IconUpDown");
  const _component_Spin = resolveComponent("Spin");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_v_nodes = resolveComponent("v-nodes");
  const _component_Select = resolveComponent("Select");
  return openBlock(), createBlock(_component_Select, mergeProps({
    value: _ctx.state,
    "onUpdate:value": _cache[4] || (_cache[4] = ($event) => _ctx.state = $event)
  }, _ctx.$attrs, {
    class: [_ctx.prefixCls, "fbu-select", _ctx.isMultipleMode && "is-multiple"],
    "allow-clear": _ctx.allowClear,
    options: _ctx.innerOptions,
    placeholder: _ctx.placeholder,
    mode: _ctx.mode,
    "max-tag-count": _ctx.maxTagCount,
    "max-tag-text-length": _ctx.maxTagTextLength,
    "show-arrow": _ctx.showArrow,
    "show-search": _ctx.computedShowSearch,
    "option-filter-prop": _ctx.optionFilterProp,
    "max-tag-placeholder": _ctx.maxTagPlaceholder,
    "dropdown-class-name": "api-select-dropdown",
    onChange: _ctx.handleChange,
    onDropdownVisibleChange: _ctx.handleVisibleChange
  }), createSlots({ _: 2 }, [
    renderList(Object.keys(_ctx.$slots), (slot) => {
      return {
        name: slot,
        fn: withCtx((data6) => [
          renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})), void 0, true)
        ])
      };
    }),
    _ctx.loading || _ctx.isMultipleMode ? {
      name: "suffixIcon",
      fn: withCtx(() => [
        _ctx.loading ? (openBlock(), createBlock(_component_LoadingOutlined, {
          key: 0,
          spin: ""
        })) : (openBlock(), createBlock(_component_IconUpDown, { key: 1 }))
      ])
    } : void 0,
    _ctx.loading ? {
      name: "notFoundContent",
      fn: withCtx(() => [
        createVNode(_component_Spin, { size: "small" })
      ])
    } : void 0,
    _ctx.showCheckBox && ["multiple", "tags"].includes(_ctx.mode + "") ? {
      name: "option",
      fn: withCtx(({ value, label, disabled }) => [
        createVNode(_component_Checkbox, {
          disabled,
          checked: _ctx.state && Array.isArray(_ctx.state) && _ctx.state.includes(value)
        }, null, 8, ["disabled", "checked"]),
        createElementVNode("span", _hoisted_1$o, toDisplayString(label), 1)
      ])
    } : void 0,
    _ctx.isMultipleMode && _ctx.showCheckAll ? {
      name: "dropdownRender",
      fn: withCtx(({ menuNode: menu }) => [
        _ctx.innerOptions.length ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "ant-select-item ant-select-item-option",
          style: { "width": "100%" },
          onMousedown: _cache[2] || (_cache[2] = (e2) => e2.preventDefault()),
          onClick: _cache[3] || (_cache[3] = (...args) => _ctx.handleClickAllParent && _ctx.handleClickAllParent(...args))
        }, [
          createVNode(_component_Checkbox, {
            checked: _ctx.checkAll,
            "onUpdate:checked": _cache[0] || (_cache[0] = ($event) => _ctx.checkAll = $event),
            indeterminate: _ctx.indeterminate,
            onChange: _ctx.onCheckAllChange,
            style: { "display": "flex" },
            onClickCapture: _cache[1] || (_cache[1] = (e2) => e2.stopPropagation())
          }, null, 8, ["checked", "indeterminate", "onChange"]),
          createElementVNode("span", _hoisted_2$8, toDisplayString(_ctx.checkAllText), 1)
        ], 32)) : createCommentVNode("", true),
        createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"])
      ])
    } : void 0
  ]), 1040, ["value", "class", "allow-clear", "options", "placeholder", "mode", "max-tag-count", "max-tag-text-length", "show-arrow", "show-search", "option-filter-prop", "max-tag-placeholder", "onChange", "onDropdownVisibleChange"]);
}
var ApiSelect$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$x, [["render", _sfc_render$q], ["__scopeId", "data-v-7773d8a4"]]);
var ApiSelect = withInstall$1(ApiSelect$1);
var _sfc_main$w = defineComponent({
  name: "FbuHelpTooltip",
  inheritAttrs: false,
  components: {
    Tooltip,
    QuestionCircleOutlined: QuestionCircleOutlined$1
  },
  props: {
    text: w(),
    placement: D(["top", "left", "right", "bottom", "topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]).def("top"),
    color: E(),
    fontSize: N().def(12),
    maxWidth: N().def(450),
    showIndex: x().def(true)
  },
  setup(props2) {
    const prefixCls2 = usePrefixCls("help-tooltip");
    const getPopupContainer = (trigger2) => {
      var _a2;
      return (_a2 = trigger2.parentElement) != null ? _a2 : document.body;
    };
    const overlayStyle = computed(() => {
      return {
        maxWidth: props2.maxWidth + "px"
      };
    });
    const tooltipStyle = computed(() => {
      return {
        fontSize: props2.fontSize + "px"
      };
    });
    return {
      prefixCls: prefixCls2,
      overlayStyle,
      tooltipStyle,
      getPopupContainer
    };
  }
});
var HelpTooltip_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$n = { key: 1 };
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuestionCircleOutlined = resolveComponent("QuestionCircleOutlined");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createBlock(_component_Tooltip, {
    "auto-adjust-overflow": true,
    placement: _ctx.placement,
    color: _ctx.color,
    "get-popup-container": _ctx.getPopupContainer,
    "overlay-style": _ctx.overlayStyle
  }, {
    title: withCtx(() => [
      renderSlot(_ctx.$slots, "title", {}, () => [
        createElementVNode("div", {
          class: "title-container",
          style: normalizeStyle(_ctx.tooltipStyle)
        }, [
          Array.isArray(_ctx.text) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.text, (item, idx) => {
            return openBlock(), createElementBlock("p", { key: item }, toDisplayString(_ctx.showIndex ? `${idx + 1}\u3001${item}` : item), 1);
          }), 128)) : (openBlock(), createElementBlock("p", _hoisted_1$n, toDisplayString(_ctx.text), 1))
        ], 4)
      ], true)
    ]),
    default: withCtx(() => [
      createElementVNode("span", {
        class: normalizeClass([_ctx.prefixCls])
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createVNode(_component_QuestionCircleOutlined)
        ], true)
      ], 2)
    ]),
    _: 3
  }, 8, ["placement", "color", "get-popup-container", "overlay-style"]);
}
var HelpTooltip = /* @__PURE__ */ _export_sfc$1(_sfc_main$w, [["render", _sfc_render$p], ["__scopeId", "data-v-36bafbfe"]]);
var FbuHelpTooltip = withInstall$1(HelpTooltip);
const useProps$2 = {
  model: A().def(() => ({})),
  hideRequiredMark: x().def(false),
  labelCol: A(),
  layout: D(["horizontal", "vertical", "inline"]).def("vertical"),
  wrapperCol: A(),
  colon: x().def(true),
  labelAlign: E().def("left"),
  rowProps: A(),
  labelWith: L([String, Number]).def(0),
  fieldMapToTime: {
    type: Array,
    default: () => []
  },
  fieldMapToRangeValue: {
    type: Array,
    default: () => []
  },
  schemes: q().def(() => []),
  mergeDynamicData: A().def(() => null),
  baseRowStyle: A(),
  baseColProps: A(),
  autoSetPlaceHolder: x().def(true),
  autoSubmitOnEnter: x().def(true),
  submitOnReset: x(),
  size: w().def("default"),
  disabled: x(),
  rulesMessageJoinLabel: x().def(false),
  showActionButtonGroup: x().def(true),
  actionColOptions: A(),
  showResetButton: x().def(true),
  autoFocusFirstItem: x(),
  resetButtonOptions: A(),
  showSubmitButton: x().def(true),
  submitButtonOptions: A(),
  resetFunc: P(),
  submitFunc: P(),
  tableAction: A(),
  transformDateFunc: P().def((date4) => {
    var _a2, _b;
    return (_b = (_a2 = date4 == null ? void 0 : date4.format) == null ? void 0 : _a2.call(date4, "YYYY-MM-DD HH:mm:ss")) != null ? _b : date4;
  }),
  validateTrigger: E().def("change"),
  showSearchSolution: x().def(false),
  searchSolutionProps: A().def(() => ({})),
  showAdvanced: x().def(false),
  autoAdvancedLines: N().def(3),
  t: P(),
  simple: x().def(true),
  defaultExpandedAdvanced: x().def(false),
  splitFields: q().def(() => []),
  customSplitFunc: P(),
  showFieldSettings: x().def(false),
  cacheName: E(),
  showAdvancedButton: x().def(true),
  enableCount: x().def(false),
  count: N().def(60),
  control: L([Number, String, Object, Array, Boolean]).def(true)
};
var SelectInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$v = defineComponent({
  name: "FbuSelectInput",
  inheritAttrs: false,
  components: {
    Input,
    InputGroup: Input.Group,
    FbuSelect
  },
  props: {
    value: A().def(() => ["", ""]),
    selectProps: A().def(() => ({ options: [] })),
    inputProps: A().def(() => ({}))
  },
  emits: ["change", "update:value"],
  setup(props2, { emit }) {
    const prefixCls2 = usePrefixCls("input-group");
    const innerSelectValue = computed({
      get: () => props2.value[0],
      set: (value) => {
        emitChange([value, unref(innerInputValue)]);
      }
    });
    const innerInputValue = computed({
      get: () => props2.value[1],
      set: (value) => {
        emitChange([unref(innerSelectValue), value]);
      }
    });
    const getSelectBinds = computed(() => {
      return __spreadProps(__spreadValues({
        allowClear: false,
        placeholder: "\u8BF7\u9009\u62E9"
      }, props2.selectProps), {
        options: transformOptions(props2.selectProps.options, props2.selectProps.fieldNames)
      });
    });
    const getInputBinds = computed(() => {
      return __spreadValues({
        allowClear: true
      }, props2.inputProps);
    });
    function emitChange(value) {
      emit("update:value", value);
      emit("change", value);
    }
    return {
      prefixCls: prefixCls2,
      innerSelectValue,
      innerInputValue,
      getSelectBinds,
      getInputBinds
    };
  }
});
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FbuSelect = resolveComponent("FbuSelect");
  const _component_Input = resolveComponent("Input");
  const _component_InputGroup = resolveComponent("InputGroup");
  return openBlock(), createBlock(_component_InputGroup, {
    compact: "",
    class: normalizeClass([_ctx.prefixCls])
  }, {
    default: withCtx(() => [
      createVNode(_component_FbuSelect, mergeProps({
        value: _ctx.innerSelectValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.innerSelectValue = $event)
      }, _ctx.getSelectBinds), null, 16, ["value"]),
      createVNode(_component_Input, mergeProps({
        value: _ctx.innerInputValue,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event) => _ctx.innerInputValue = $event)
      }, _ctx.getInputBinds), createSlots({ _: 2 }, [
        renderList(Object.keys(_ctx.$slots), (slot) => {
          return {
            name: slot,
            fn: withCtx((data6) => [
              renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})), void 0, true)
            ])
          };
        })
      ]), 1040, ["value"])
    ]),
    _: 3
  }, 8, ["class"]);
}
var SelectInput$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$v, [["render", _sfc_render$o], ["__scopeId", "data-v-9876f8a4"]]);
var SelectInput = withInstall$1(SelectInput$1);
var IconSearch = () => {
  return createVNode("svg", {
    "width": "14",
    "height": "14",
    "viewBox": "0 0 14 14",
    "fill": "currentColor"
  }, [createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M10.8832 11.5019C9.72885 12.5125 8.21716 13.1249 6.56243 13.1249C2.9381 13.1249 0 10.1868 0 6.56246C0 2.93811 2.9381 0 6.56243 0C10.1868 0 13.1249 2.93811 13.1249 6.56246C13.1249 8.21717 12.5124 9.72883 11.5019 10.8832L13.8719 13.2531C14.0427 13.424 14.0427 13.701 13.8719 13.8719C13.701 14.0427 13.424 14.0427 13.2531 13.8719L10.8832 11.5019ZM12.2499 6.56246C12.2499 9.70356 9.70351 12.2499 6.56243 12.2499C3.42134 12.2499 0.87499 9.70356 0.87499 6.56246C0.87499 3.42136 3.42134 0.874994 6.56243 0.874994C9.70351 0.874994 12.2499 3.42136 12.2499 6.56246Z"
  }, null)]);
};
const toString$1 = Object.prototype.toString;
function isDef(v2) {
  return v2 !== void 0 && v2 !== null;
}
function isUnDef(v2) {
  return v2 === void 0 || v2 === null;
}
function isObject$1(v2) {
  return Object(v2) === v2;
}
function isPlainObject(v2) {
  return is(v2, "Object");
}
function is(v2, t2) {
  return toString$1.call(v2) === `[object ${t2}]`;
}
function isNumber$1(v2) {
  return typeof v2 === "number" && Number.isFinite(v2);
}
function isString$1(v2) {
  return typeof v2 === "string";
}
function isFunction$1(v2) {
  return typeof v2 === "function";
}
function isArray$1(v2) {
  return Array.isArray(v2);
}
function isBoolean(v2) {
  return typeof v2 === "boolean";
}
function isNull(v2) {
  return typeof v2 === null;
}
function isDeepEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (a2 !== null && b2 !== null && typeof a2 === "object" && typeof b2 === "object") {
    const aCtor = a2.constructor;
    const bCtor = b2.constructor;
    if (aCtor !== bCtor) {
      return false;
    }
    if (aCtor === Array) {
      const aLen = a2.length;
      if (aLen !== b2.length) {
        return false;
      }
      for (let i2 = 0; i2 < aLen; i2++) {
        if (isDeepEqual(a2[i2], b2[i2]) !== true) {
          return false;
        }
      }
      return true;
    }
    if (aCtor === Map) {
      const aSize = a2.size;
      if (aSize !== b2.size) {
        return false;
      }
      for (const [k2] of a2) {
        if (b2.has(k2) !== true) {
          return false;
        }
      }
      for (const [k2, v2] of a2) {
        if (isDeepEqual(v2, b2.get(k2)) !== true) {
          return false;
        }
      }
      return true;
    }
    if (aCtor === Set) {
      const aSize = a2.size;
      if (aSize !== b2.size) {
        return false;
      }
      const i2 = a2.entries();
      for (const [k2] of i2) {
        if (b2.has(k2) !== true) {
          return false;
        }
      }
      return true;
    }
    if (a2.buffer !== void 0 && a2.buffer !== null && a2.buffer.constructor === ArrayBuffer) {
      const aLen = a2.length;
      if (aLen !== b2.length) {
        return false;
      }
      for (let i2 = 0; i2 < aLen; i2++) {
        if (a2[i2] !== b2[i2]) {
          return false;
        }
      }
      return true;
    }
    if (aCtor === RegExp) {
      return a2.source === b2.source && a2.flags === b2.flags;
    }
    if (a2.valueOf !== Object.prototype.valueOf) {
      return a2.valueOf() === b2.valueOf();
    }
    if (a2.toString !== Object.prototype.toString) {
      return a2.toString() === b2.toString();
    }
    const aKeys = Object.keys(a2);
    if (aKeys.length !== Object.keys(b2).length) {
      return false;
    }
    for (const k2 of aKeys) {
      if (isDeepEqual(a2[k2], b2[k2]) !== true) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function onlyUnique(arr) {
  return [...new Set(arr)];
}
function uniqBy(arr, predicate) {
  const cb = typeof predicate === "function" ? predicate : (o2) => o2[predicate];
  return [
    ...arr.reduce((map, item) => {
      const key2 = item === null || item === void 0 ? item : cb(item);
      map.has(key2) || map.set(key2, item);
      return map;
    }, new Map()).values()
  ];
}
const registeredList = [];
function documentClickHandler(evt) {
  const targetEl = evt.target;
  if (targetEl === null || targetEl.nodeType === 8 || targetEl.classList.contains("no-pointer-events")) {
    return;
  }
  for (const targetObj of registeredList) {
    if (targetObj.el.contains(targetEl) === false || document.body === targetEl) {
      targetObj.onClickOutside(evt);
    }
  }
}
function checkRegistered(target) {
  return registeredList.some((item) => item.el === target.el);
}
function addClickOutside(target) {
  if (checkRegistered(target) === false) {
    registeredList.push(target);
  }
  if (registeredList.length === 1) {
    document.addEventListener("click", documentClickHandler, false);
  }
}
function removeClickOutside(target) {
  const removeIndex = registeredList.findIndex((item) => item.el === target.el);
  if (removeIndex > -1) {
    registeredList.splice(removeIndex, 1);
  }
  if (registeredList.length === 0) {
    document.removeEventListener("click", documentClickHandler, false);
  }
}
const clickOutside = {
  mounted(el, binding) {
    addClickOutside({
      el,
      onClickOutside: binding.value
    });
  },
  beforeUnmount(el, binding) {
    removeClickOutside({ el, onClickOutside: binding.value });
  }
};
var ClickOutside = {
  name: "clickOutside",
  definition: clickOutside
};
function css$1(el, css2) {
  Object.keys(css2).forEach((prop) => {
    el.style[prop] = css2[prop];
  });
}
function boundingRect(el) {
  const rect = el.getBoundingClientRect();
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height
  };
}
function style(el, property2) {
  return window.getComputedStyle(el).getPropertyValue(property2);
}
function getViewportOffset(element) {
  const doc = document.documentElement;
  const docScrollLeft = doc.scrollLeft;
  const docScrollTop = doc.scrollTop;
  const docClientLeft = doc.clientLeft;
  const docClientTop = doc.clientTop;
  const pageXOffset2 = window.pageXOffset;
  const pageYOffset2 = window.pageYOffset;
  const box = element.getBoundingClientRect();
  const { left: retLeft, top: rectTop, width: rectWidth, height: rectHeight } = box;
  const scrollLeft = (pageXOffset2 || docScrollLeft) - (docClientLeft || 0);
  const scrollTop = (pageYOffset2 || docScrollTop) - (docClientTop || 0);
  const offsetLeft = retLeft + pageXOffset2;
  const offsetTop = rectTop + pageYOffset2;
  const left = offsetLeft - scrollLeft;
  const top = offsetTop - scrollTop;
  const clientWidth = window.document.documentElement.clientWidth;
  const clientHeight = window.document.documentElement.clientHeight;
  return {
    left,
    top,
    right: clientWidth - rectWidth - left,
    bottom: clientHeight - rectHeight - top,
    rightIncludeBody: clientWidth - left,
    bottomIncludeBody: clientHeight - top
  };
}
const isNodeOverflow = (container) => {
  const scrollWidth = container.scrollWidth;
  const offsetWidth = container.clientWidth;
  const range3 = document.createRange();
  range3.setStart(container, 0);
  range3.setEnd(container, container.childNodes.length);
  const rangeWidth = range3.getBoundingClientRect().width;
  const paddingLeft = Number.parseInt(window.getComputedStyle(container).getPropertyValue("paddingLeft"), 10) || 0;
  const paddingRight = Number.parseInt(window.getComputedStyle(container).getPropertyValue("paddingRight"), 10) || 0;
  const padding = paddingLeft + paddingRight;
  if (rangeWidth + padding > offsetWidth || scrollWidth > offsetWidth) {
    return true;
  }
  return false;
};
var TdEllipsis$1 = defineComponent({
  name: "TdEllipsis",
  props: {
    tooltipContent: {
      type: [String, Number, Function]
    },
    placement: String,
    getPopupContainer: Function,
    tooltipProps: Object,
    overlayClassName: String
  },
  setup(props2) {
    const root2 = ref();
    const isOverflow = ref(false);
    const ellipsisClasses = computed(() => [`td-text-ellipsis`]);
    const innerEllipsisClassName = computed(() => props2.overlayClassName);
    const onTriggerMouseenter = () => {
      if (!root2.value)
        return;
      isOverflow.value = isNodeOverflow(root2.value);
    };
    const onTriggerMouseleave = () => {
      isOverflow.value = isNodeOverflow(root2.value);
    };
    const onMouseAround = debounce((e2) => {
      e2.type === "mouseleave" ? onTriggerMouseleave() : onTriggerMouseenter();
    }, 80);
    return {
      root: root2,
      isOverflow,
      ellipsisClasses,
      innerEllipsisClassName,
      onMouseAround
    };
  },
  render() {
    const cellNode = this.$slots.default && this.$slots.default();
    const ellipsisContent = createVNode("div", {
      "ref": "root",
      "class": this.ellipsisClasses,
      "onMouseenter": this.onMouseAround,
      "onMouseleave": this.onMouseAround
    }, [cellNode]);
    let content = null;
    const tooltipProps3 = this.tooltipProps;
    if (this.isOverflow) {
      const rProps = __spreadValues({
        destroyTooltipOnHide: true,
        getPopupContainer: this.getPopupContainer || (() => document.body),
        placement: this.placement,
        overlayClassName: this.innerEllipsisClassName
      }, tooltipProps3);
      content = createVNode(Tooltip, rProps, {
        title: () => {
          return typeof this.tooltipContent === "function" ? this.tooltipContent(h$2) : this.tooltipContent;
        },
        default: () => ellipsisContent
      });
    } else {
      content = ellipsisContent;
    }
    return content;
  }
});
const _sfc_main$u = defineComponent({
  name: "FbuExpandedSelect",
  inheritAttrs: false,
  props: {
    value: q().def(() => []),
    allowClear: x().def(false),
    api: P(),
    resultField: E().def("records"),
    numberToString: x().def(false),
    fieldNames: A().def({ label: "label", value: "value" }),
    params: A().def({}),
    immediate: x().def(true),
    alwaysLoad: x().def(false),
    placeholder: E().def("\u8BF7\u9009\u62E9"),
    options: q().def(() => []),
    showArrow: x().def(true),
    showSearch: x().def(true),
    searchInputProps: A(),
    optionFilterProp: E().def("label"),
    showEmpty: x().def(true),
    emptyProps: A(),
    tokenSeparators: E().def(";"),
    checkAllText: E().def("\u5168\u9009"),
    position: E().def("left"),
    maxTagCount: N().def(1),
    maxTagTextLength: N().def(7)
  },
  components: {
    Select: Select$1,
    Spin,
    LoadingOutlined: LoadingOutlined$1,
    IconUpDown,
    Checkbox,
    CheckboxGroup: Checkbox.Group,
    Input,
    IconSearch,
    Empty: Empty$2,
    TdEllipsis: TdEllipsis$1
  },
  emits: [defaultChangeEvent, "update:value", "search", "options-change"],
  directives: {
    [ClickOutside.name]: ClickOutside.definition
  },
  setup(props2, { emit }) {
    const prefixCls2 = usePrefixCls("expanded-select");
    const loading = ref(false);
    const emitData = ref([]);
    const [state] = useFormItem({ props: props2, emitData });
    const options = ref(props2.options || []);
    const isFirstLoaded = ref(true);
    const checkedList = ref([]);
    const searchValue = ref("");
    const searchFn = debounce(search, 200, false);
    const filterVal = ref("");
    const innerValue = ref(void 0);
    const selectorElRef = ref();
    const opened = ref(false);
    const title = ref("");
    const innerPositionRef = ref(props2.position);
    const stateAll = reactive({
      indeterminate: false,
      checkAll: false
    });
    const tooltipProps3 = {
      align: { offset: [0, 8] },
      getPopupContainer: (trigger2) => {
        var _a2;
        return (_a2 = trigger2.parentElement) != null ? _a2 : document.body;
      },
      destroyTooltipOnHide: true
    };
    watchEffect(() => {
      props2.immediate && !props2.alwaysLoad && fetch();
    });
    watch(() => props2.options, (newOptions) => {
      options.value = newOptions;
    });
    watch(() => props2.params, () => {
      !unref(isFirstLoaded) && fetch();
    }, { deep: true });
    const getStyle2 = computed(() => {
      return innerPositionRef.value === "left" ? {
        left: "0",
        right: "auto"
      } : innerPositionRef.value === "right" ? {
        right: "0",
        left: "auto"
      } : {
        left: "50%",
        marginLeft: "-370px"
      };
    });
    watch(searchValue, searchFn);
    const innerOptions = computed(() => {
      const { fieldNames, numberToString, optionFilterProp } = props2;
      const { label, value } = fieldNames;
      let resList = unref(options).map((item) => {
        return __spreadProps(__spreadValues({}, item), {
          show: item.show === void 0 ? true : item.show,
          label: item[label],
          value: numberToString && `${item[value]}` || item[value]
        });
      });
      if (filterVal.value) {
        resList.forEach((item) => item.show = item[optionFilterProp || "label"].toLowerCase().includes(filterVal.value));
      }
      return resList;
    });
    const visibleInnerOptions = computed(() => {
      return unref(innerOptions).filter((item) => item.show);
    });
    watch([checkedList, options], ([list]) => {
      innerValue.value = unref(options).filter((item) => list.includes(item[props2.fieldNames.value])).map((item) => item[props2.fieldNames.label]);
      const visibleList = unref(visibleInnerOptions).map((item) => item.value);
      const checkedLength = checkedList.value.filter((value) => visibleList.includes(value)).length;
      stateAll.indeterminate = !!checkedLength && checkedLength < visibleInnerOptions.value.length;
      stateAll.checkAll = !!checkedLength && checkedLength === visibleInnerOptions.value.length;
      title.value = innerValue.value.join(props2.tokenSeparators);
    });
    watch(visibleInnerOptions, (list) => {
      const visibleValueList = list.map((item) => item.value);
      const checkedLength = checkedList.value.filter((value) => visibleValueList.includes(value)).length;
      stateAll.indeterminate = !!checkedLength && checkedLength < list.length;
      stateAll.checkAll = !!checkedLength && checkedLength === list.length;
    });
    watch(state, (list) => {
      checkedList.value = list;
    }, {
      immediate: true
    });
    watch(opened, handleVisibleChange);
    const isEmpty = computed(() => {
      return unref(innerOptions).every((item) => item.show === false) && !unref(loading) && props2.showEmpty;
    });
    async function fetch() {
      const { api: api2 } = props2;
      if (typeof api2 !== "function") {
        return;
      }
      options.value = [];
      loading.value = true;
      try {
        let result = await api2(props2.params);
        if (!result) {
          return;
        }
        if (!Array.isArray(result)) {
          result = result[props2.resultField];
        }
        options.value = result || [];
        emit("options-change", result.slice(0));
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    }
    function handleChange2() {
      var _a2;
      if (unref(innerValue)) {
        checkedList.value = ((_a2 = unref(innerValue)) == null ? void 0 : _a2.map((item) => {
          var _a3;
          return (_a3 = innerOptions.value.find((item1) => item1.label == item)) == null ? void 0 : _a3.value;
        }).filter(Boolean)) || [];
        onChange3(checkedList.value);
      } else {
        checkedList.value = [];
        onChange3([]);
      }
    }
    function updatePopoverPosition() {
      const triggerEl = selectorElRef.value.$el;
      if (!triggerEl) {
        return;
      }
      const innerWidth2 = window.innerWidth;
      const triggerRect = triggerEl.getBoundingClientRect();
      const popoverRect = { width: 740 };
      if (triggerRect.left + popoverRect.width > innerWidth2) {
        innerPositionRef.value = "right";
      } else {
        innerPositionRef.value = "left";
      }
    }
    function handleClick() {
      updatePopoverPosition();
      if (unref(opened)) {
        opened.value = false;
      } else {
        opened.value = true;
      }
    }
    function handleVisibleChange(open2) {
      if (open2) {
        if (props2.alwaysLoad) {
          fetch();
        } else if (!props2.immediate && unref(isFirstLoaded)) {
          fetch();
          isFirstLoaded.value = false;
        }
      }
    }
    const onCheckAllChange = (e2) => {
      stateAll.indeterminate = false;
      checkedList.value = e2.target.checked ? innerOptions.value.filter((item) => item.show === true).map((item) => item.value) : [];
      state.value = checkedList.value;
    };
    function onChange3(checkedData) {
      const allCheckedList = onlyUnique([...checkedList.value, ...checkedData]);
      state.value = allCheckedList;
      emit("update:value", allCheckedList);
    }
    function search(val) {
      val = val.trim();
      filterVal.value = val.toLowerCase();
    }
    function handleWheel(e2) {
      const targetElm = e2.currentTarget;
      const scrollTop = targetElm.scrollTop;
      if (e2.deltaY < 0 && scrollTop === 0) {
        e2.preventDefault();
      } else if (e2.deltaY > 0 && scrollTop + targetElm.offsetHeight >= targetElm.scrollHeight) {
        e2.preventDefault();
      }
    }
    function maxTagPlaceholder(omittedValues) {
      return h$2(Tooltip, {
        overlayClassName: "custom-max-tag-tooltip"
      }, {
        default: () => h$2("span", { class: "custom-max-tag-placeholder" }, [
          `+ ${omittedValues.length} ...`
        ]),
        title: () => h$2("ul", null, omittedValues.map((item) => h$2("li", null, item.label)))
      });
    }
    return __spreadProps(__spreadValues({}, toRefs(stateAll)), {
      onCheckAllChange,
      selectorElRef,
      innerValue,
      prefixCls: prefixCls2,
      loading,
      innerOptions,
      handleChange: handleChange2,
      handleVisibleChange,
      checkedList,
      onChange: onChange3,
      searchValue,
      simpleImage: Empty$2.PRESENTED_IMAGE_SIMPLE,
      handleWheel,
      handleClick,
      opened,
      isEmpty,
      getStyle: getStyle2,
      title,
      tooltipProps: tooltipProps3,
      maxTagPlaceholder
    });
  }
});
const _hoisted_1$m = { class: "check-all-wrapper" };
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingOutlined = resolveComponent("LoadingOutlined");
  const _component_IconUpDown = resolveComponent("IconUpDown");
  const _component_Select = resolveComponent("Select");
  const _component_IconSearch = resolveComponent("IconSearch");
  const _component_Input = resolveComponent("Input");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_TdEllipsis = resolveComponent("TdEllipsis");
  const _component_CheckboxGroup = resolveComponent("CheckboxGroup");
  const _component_Spin = resolveComponent("Spin");
  const _component_Empty = resolveComponent("Empty");
  const _directive_clickOutside = resolveDirective("clickOutside");
  return withDirectives((openBlock(), createElementBlock("div", {
    class: normalizeClass(`${_ctx.prefixCls}-container`)
  }, [
    createVNode(_component_Select, mergeProps({
      ref: "selectorElRef",
      value: _ctx.innerValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.innerValue = $event),
      class: [_ctx.prefixCls, "fbu-select", "is-multiple"],
      "allow-clear": _ctx.allowClear,
      placeholder: _ctx.placeholder,
      "show-arrow": _ctx.showArrow,
      "show-search": false,
      "dropdown-match-select-width": false,
      open: false,
      "max-tag-count": _ctx.maxTagCount,
      "max-tag-text-length": _ctx.maxTagTextLength,
      "max-tag-placeholder": _ctx.maxTagPlaceholder,
      title: _ctx.title
    }, _ctx.$attrs, {
      mode: "multiple",
      onDeselect: _ctx.handleChange,
      onClick: _ctx.handleClick
    }), createSlots({
      suffixIcon: withCtx(() => [
        _ctx.loading ? (openBlock(), createBlock(_component_LoadingOutlined, {
          key: 0,
          spin: ""
        })) : (openBlock(), createBlock(_component_IconUpDown, { key: 1 }))
      ]),
      _: 2
    }, [
      renderList(Object.keys(_ctx.$slots), (slot) => {
        return {
          name: slot,
          fn: withCtx((data6) => [
            renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})))
          ])
        };
      })
    ]), 1040, ["value", "class", "allow-clear", "placeholder", "show-arrow", "max-tag-count", "max-tag-text-length", "max-tag-placeholder", "title", "onDeselect", "onClick"]),
    createVNode(Transition$2, { name: "slide-up" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          class: normalizeClass(`${_ctx.prefixCls}-dropdown`),
          style: normalizeStyle(_ctx.getStyle)
        }, [
          createVNode(_component_Input, mergeProps({
            class: `${_ctx.prefixCls}-dropdown__input`,
            style: { "width": "284px" },
            "allow-clear": true
          }, _ctx.searchInputProps, {
            value: _ctx.searchValue,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event) => _ctx.searchValue = $event),
            onChange: _cache[2] || (_cache[2] = (e2) => e2.stopPropagation())
          }), {
            prefix: withCtx(() => [
              createVNode(_component_IconSearch)
            ]),
            _: 1
          }, 16, ["class", "value"]),
          createElementVNode("div", _hoisted_1$m, [
            createVNode(_component_Checkbox, {
              checked: _ctx.checkAll,
              "onUpdate:checked": _cache[3] || (_cache[3] = ($event) => _ctx.checkAll = $event),
              indeterminate: _ctx.indeterminate,
              onChange: _ctx.onCheckAllChange
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.checkAllText), 1)
              ]),
              _: 1
            }, 8, ["checked", "indeterminate", "onChange"])
          ]),
          createElementVNode("div", {
            class: normalizeClass(`${_ctx.prefixCls}-dropdown__checkbox-wrapper`),
            onWheel: _cache[5] || (_cache[5] = (...args) => _ctx.handleWheel && _ctx.handleWheel(...args))
          }, [
            createVNode(_component_CheckboxGroup, {
              class: normalizeClass(`${_ctx.prefixCls}-dropdown__checkbox-group`),
              value: _ctx.checkedList,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event) => _ctx.checkedList = $event),
              onChange: _ctx.onChange
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.innerOptions, (item) => {
                  return withDirectives((openBlock(), createElementBlock("div", {
                    key: item.value,
                    class: normalizeClass([`${_ctx.prefixCls}-dropdown__check-item`, item.disabled && "is-disabled"])
                  }, [
                    createVNode(_component_TdEllipsis, {
                      "tooltip-props": _ctx.tooltipProps,
                      "tooltip-content": item.label
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_Checkbox, {
                          value: item.value,
                          disabled: item.disabled
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"])
                      ]),
                      _: 2
                    }, 1032, ["tooltip-props", "tooltip-content"])
                  ], 2)), [
                    [vShow, item.show]
                  ]);
                }), 128))
              ]),
              _: 1
            }, 8, ["class", "value", "onChange"])
          ], 34),
          _ctx.loading ? (openBlock(), createBlock(_component_Spin, {
            key: 0,
            size: "small"
          })) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "notFoundContent", {}, () => [
            _ctx.isEmpty ? (openBlock(), createBlock(_component_Empty, {
              key: 0,
              image: _ctx.simpleImage
            }, null, 8, ["image"])) : createCommentVNode("", true)
          ])
        ], 6), [
          [vShow, _ctx.opened]
        ])
      ]),
      _: 3
    })
  ], 2)), [
    [_directive_clickOutside, () => _ctx.opened = false]
  ]);
}
var ExpandedSelect$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$u, [["render", _sfc_render$n]]);
var ExpandedSelect = withInstall$1(ExpandedSelect$1);
const componentMap$1 = new Map();
componentMap$1.set("Input", Input);
componentMap$1.set("InputGroup", Input.Group);
componentMap$1.set("InputPassword", Input.Password);
componentMap$1.set("InputSearch", Input.Search);
componentMap$1.set("InputTextArea", Input.TextArea);
componentMap$1.set("InputNumber", InputNumber$1);
componentMap$1.set("AutoComplete", AutoComplete$1);
componentMap$1.set("SelectInput", SelectInput);
componentMap$1.set("Select", Select$1);
componentMap$1.set("ExpandedSelect", ExpandedSelect);
componentMap$1.set("FbuSelect", FbuSelect);
componentMap$1.set("ApiSelect", ApiSelect);
componentMap$1.set("TreeSelect", TreeSelect$1);
componentMap$1.set("ApiTreeSelect", ApiTreeSelect);
componentMap$1.set("ApiRadioGroup", ApiRadioGroup);
componentMap$1.set("Switch", Switch$1);
componentMap$1.set("RadioGroup", radioGroup);
componentMap$1.set("Checkbox", Checkbox);
componentMap$1.set("CheckboxGroup", Checkbox.Group);
componentMap$1.set("ApiCascader", ApiCascader);
componentMap$1.set("Cascader", Cascader$1);
componentMap$1.set("Slider", Slider$1);
componentMap$1.set("Rate", Rate$1);
componentMap$1.set("DatePicker", DatePicker$1);
componentMap$1.set("MonthPicker", DatePicker$1.MonthPicker);
componentMap$1.set("RangePicker", DatePicker$1.RangePicker);
componentMap$1.set("WeekPicker", DatePicker$1.WeekPicker);
componentMap$1.set("DateRangePicker", DateRangePicker);
componentMap$1.set("TimePicker", TimePicker$1);
componentMap$1.set("InputCountDown", CountdownInput);
componentMap$1.set("Upload", Upload);
function add$1(compName, component) {
  componentMap$1.set(compName, component);
}
function del$1(compName) {
  componentMap$1.delete(compName);
}
function formatToDate(date4 = void 0, format3 = "YYYY-MM-DD HH:mm:ss") {
  return dayjs(date4).format(format3);
}
const dateAdapter = dayjs;
const DATE_TYPE = ["DatePicker", "MonthPicker", "WeekPicker", "TimePicker"];
const dateItemType = [...DATE_TYPE, "RangePicker", "DateRangePicker"];
function setComponentRuleType(rule, component, valueFormat) {
  if (["DatePicker", "MonthPicker", "WeekPicker", "TimePicker"].includes(component)) {
    rule.type = valueFormat ? "string" : "object";
  } else if (["RangePicker", "Upload", "CheckboxGroup", "TimePicker", "DateRangePicker"].includes(component)) {
    rule.type = "array";
  } else if (["InputNumber"].includes(component)) {
    rule.type = "number";
  }
}
function handleInputNumberValue(component, val) {
  if (!component)
    return val;
  if (["Input", "InputPassword", "InputSearch", "InputTextArea"].includes(component)) {
    return val && isNumber$1(val) ? `${val}` : val;
  }
  return val;
}
function createPlaceholderMessage$1(component) {
  if (component.includes("Input") || component.includes("Complete")) {
    return "\u8BF7\u8F93\u5165";
  }
  if (component.includes("RangePicker") || component.includes("DateRangePicker")) {
    return;
  }
  if (component.includes("Picker") || component.includes("Select") || component.includes("Cascader") || component.includes("Checkbox") || component.includes("Radio") || component.includes("Switch")) {
    return "\u8BF7\u9009\u62E9";
  }
  return "";
}
function getSlot2(slots, slot = "default", data6) {
  if (!slots || !Reflect.has(slots, slot)) {
    return null;
  }
  const slotFn = slots[slot];
  if (!slotFn || !isFunction$1(slotFn)) {
    console.error(`${slot} is not a function!`);
    return null;
  }
  return slotFn(data6);
}
const toString2 = Object.prototype.toString;
function cloneDeep(source, cache2 = new WeakMap()) {
  if (typeof source !== "object" || source === null) {
    return source;
  }
  const resCache = cache2.get(source);
  if (resCache) {
    return resCache;
  }
  const dataType2 = toString2.call(source).slice(8, -1).toLowerCase();
  const ctor = source.constructor;
  let res = null;
  switch (dataType2) {
    case "number":
    case "string":
      res = new ctor(source);
      break;
    case "boolean":
    case "date":
      res = new ctor(source - 0);
      break;
    case "regexp":
      res = new ctor(source.source, source.flags);
      break;
    case "set":
    case "map":
    case "array":
    case "object":
      try {
        res = new ctor();
      } catch (_2) {
        res = source;
      }
      break;
    default:
      res = source;
  }
  if (dataType2 === "set") {
    source.forEach((x2) => {
      res.add(cloneDeep(x2, cache2));
    });
  } else if (dataType2 === "map") {
    Array.from(source.entries()).forEach((k2, v2) => {
      res.set(k2, cloneDeep(v2, cache2));
    });
  } else if (dataType2 === "array" || dataType2 === "object") {
    const oKeys = Reflect.ownKeys(source);
    for (const k2 of oKeys) {
      res[k2] = cloneDeep(source[k2], cache2);
    }
  }
  cache2.set(source, res);
  return res;
}
function classify(v2) {
  const classifyRE = /(?:^|[-_])(\w)/gi;
  return v2.replace(classifyRE, (m2) => m2.toUpperCase()).replace(/[_-]/, "");
}
function splitValueByWhiteSpace(values, includeKeys = []) {
  if (typeof values !== "object" || values === null || includeKeys.length === 0) {
    return values;
  }
  includeKeys == null ? void 0 : includeKeys.forEach((key2) => {
    const value = values[key2];
    if (typeof value === "string") {
      values[key2] = value ? value.trim().split(/,+|\s+/).filter(Boolean) : void 0;
    }
  });
  return values;
}
function useItemLabelWidth(schemeRef, formPropsRef) {
  return computed(() => {
    const schemeItem = unref(schemeRef);
    const { labelCol = {}, wrapperCol = {} } = schemeItem.itemProps || {};
    const { labelWidth, disabledLabelWidth } = schemeItem;
    const {
      labelWidth: globalLabelWidth,
      labelCol: globalLabelCol,
      wrapperCol: globWrapperCol
    } = unref(formPropsRef);
    if (!globalLabelWidth && !labelWidth && !globalLabelCol || disabledLabelWidth) {
      labelCol.style = {
        textAlign: "left"
      };
      return { labelCol, wrapperCol };
    }
    let width = labelWidth || globalLabelWidth;
    const col = __spreadValues(__spreadValues({}, globalLabelCol), labelCol);
    const wrapCol = __spreadValues(__spreadValues({}, globWrapperCol), wrapperCol);
    if (width) {
      width = isNumber$1(width) ? `${width}px` : width;
    }
    return {
      labelCol: __spreadValues({ style: { width } }, col),
      wrapperCol: __spreadValues({ style: { width: `calc(100% - ${width})` } }, wrapCol)
    };
  });
}
function _isSlot$8(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
var _sfc_main$t = defineComponent({
  name: "FormItem",
  inheritAttrs: false,
  props: {
    scheme: A().def(),
    formProps: A().def(() => ({})),
    allDefaultValues: A().def(() => ({})),
    formModel: A().def(() => ({})),
    setFormModel: P().def(),
    tableAction: A(),
    formActions: A(),
    isAdvanced: x().def(false),
    isShowAdvanced: x().def(false)
  },
  setup(props2, {
    slots
  }) {
    const {
      scheme,
      formProps: formProps3
    } = toRefs(props2);
    const itemLabelWidthProp = useItemLabelWidth(scheme, formProps3);
    const getValues = computed(() => {
      const {
        allDefaultValues,
        formModel,
        scheme: scheme2
      } = props2;
      const {
        mergeDynamicData
      } = props2.formProps;
      return {
        field: scheme2.field,
        model: formModel,
        values: __spreadValues(__spreadValues(__spreadValues({}, mergeDynamicData), allDefaultValues), formModel),
        scheme: scheme2
      };
    });
    const getComponentsProps = computed(() => {
      var _a2;
      const {
        scheme: scheme2,
        tableAction,
        formModel,
        formActions
      } = props2;
      let {
        componentProps = {}
      } = scheme2;
      if (isFunction$1(componentProps)) {
        componentProps = (_a2 = componentProps({
          scheme: scheme2,
          tableAction,
          formModel,
          formActions
        })) != null ? _a2 : {};
      }
      return componentProps;
    });
    const getDisable = computed(() => {
      const {
        disabled: globDisabled
      } = props2.formProps;
      const {
        dynamicDisabled
      } = props2.scheme;
      const {
        disabled: itemDisabled = false
      } = unref(getComponentsProps);
      let disabled = !!globDisabled || itemDisabled;
      if (isBoolean(dynamicDisabled)) {
        disabled = dynamicDisabled;
      }
      if (isFunction$1(dynamicDisabled)) {
        disabled = dynamicDisabled(unref(getValues));
      }
      return disabled;
    });
    function getShow() {
      const {
        show,
        ifShow,
        advanced = false
      } = props2.scheme;
      const {
        isShowAdvanced
      } = props2;
      const itemIsAdvanced = isShowAdvanced ? advanced : false;
      let isShow = true;
      let isIfShow = true;
      if (isBoolean(show)) {
        isShow = show;
      }
      if (isBoolean(ifShow)) {
        isIfShow = ifShow;
      }
      if (isFunction$1(show)) {
        isShow = show(unref(getValues));
      }
      if (isFunction$1(ifShow)) {
        isIfShow = ifShow(unref(getValues));
      }
      if (itemIsAdvanced) {
        isShow = props2.isAdvanced && isShow;
      }
      return {
        isShow,
        isIfShow
      };
    }
    function handleRules() {
      var _a2;
      const {
        rules: defRules = [],
        component,
        rulesMessageJoinLabel,
        label,
        dynamicRules,
        required: required4
      } = props2.scheme;
      if (isFunction$1(dynamicRules)) {
        return dynamicRules(unref(getValues));
      }
      let rules2 = cloneDeep(defRules);
      const {
        rulesMessageJoinLabel: globalRulesMessageJoinLabel
      } = props2.formProps;
      const joinLabel = Reflect.has(props2.scheme, "rulesMessageJoinLabel") ? rulesMessageJoinLabel : globalRulesMessageJoinLabel;
      const defaultMsg = createPlaceholderMessage$1(component) + `${joinLabel ? label : ""}`;
      function validator(rule, value) {
        const msg = rule.message || defaultMsg;
        if (value === void 0 || isNull(value)) {
          return Promise.reject(msg);
        } else if (Array.isArray(value) && value.length === 0) {
          return Promise.reject(msg);
        } else if (typeof value === "string" && value.trim() === "") {
          return Promise.reject(msg);
        } else if (typeof value === "object" && Reflect.has(value, "checked") && Reflect.has(value, "halfChecked") && Array.isArray(value.checked) && Array.isArray(value.halfChecked) && value.checked.length === 0 && value.halfChecked.length === 0) {
          return Promise.reject(msg);
        }
        return Promise.resolve();
      }
      const getRequired = isFunction$1(required4) ? required4(unref(getValues)) : required4;
      if ((!rules2 || rules2.length === 0) && getRequired) {
        rules2 = [{
          required: getRequired,
          validator
        }];
      }
      const requiredRuleIndex = rules2.findIndex((rule) => Reflect.has(rule, "required") && !Reflect.has(rule, "validator"));
      if (requiredRuleIndex !== -1) {
        const rule = rules2[requiredRuleIndex];
        const {
          isShow
        } = getShow();
        if (!isShow) {
          rule.required = false;
        }
        if (component) {
          if (!Reflect.has(rule, "type")) {
            rule.type = component === "InputNumber" ? "number" : "string";
          }
          rule.message = rule.message || defaultMsg;
          if (component.includes("Input") || component.includes("Textarea")) {
            rule.whitespace = true;
          }
          const valueFormat = (_a2 = unref(getComponentsProps)) == null ? void 0 : _a2.valueFormat;
          setComponentRuleType(rule, component, valueFormat);
        }
      }
      const characterInx = rules2.findIndex((val) => val.max);
      if (characterInx !== -1 && !rules2[characterInx].validator) {
        rules2[characterInx].message = rules2[characterInx].message || `\u5B57\u7B26\u6570\u5E94\u5C11\u4E8E${rules2[characterInx].max}\u4F4D`;
      }
      return rules2;
    }
    function renderComponent() {
      var _a2;
      const {
        renderComponentContent,
        component,
        field,
        changeEvent = "change",
        valueField
      } = props2.scheme;
      const isCheck = component && ["Switch", "Checkbox"].includes(component);
      const eventKey = `on${classify(changeEvent)}`;
      const on2 = {
        [eventKey]: (...args) => {
          const [e2] = args;
          if (propsData[eventKey]) {
            propsData[eventKey](...args);
          }
          const target = e2 ? e2.target : null;
          const value = target ? isCheck ? target.checked : target.value : e2;
          props2.setFormModel(field, value);
        }
      };
      const Comp = componentMap$1.get(component);
      const {
        autoSetPlaceHolder,
        size
      } = props2.formProps;
      const propsData = __spreadProps(__spreadValues({
        allowClear: true,
        getPopupContainer: (trigger2) => trigger2.parentNode,
        size
      }, unref(getComponentsProps)), {
        disabled: unref(getDisable)
      });
      const isCreatePlaceholder = !propsData.disabled && autoSetPlaceHolder;
      if (isCreatePlaceholder && component !== "RangePicker" && component) {
        propsData.placeholder = ((_a2 = unref(getComponentsProps)) == null ? void 0 : _a2.placeholder) || createPlaceholderMessage$1(component);
      }
      propsData.codeField = field;
      propsData.formValues = unref(getValues);
      const bindValue = {
        [valueField || (isCheck ? "checked" : "value")]: props2.formModel[field]
      };
      const compAttr = __spreadValues(__spreadValues(__spreadValues({}, propsData), on2), bindValue);
      if (!renderComponentContent) {
        return createVNode(Comp, compAttr, null);
      }
      const compSlot = isFunction$1(renderComponentContent) ? __spreadValues({}, renderComponentContent(unref(getValues))) : {
        default: () => renderComponentContent
      };
      return createVNode(Comp, compAttr, _isSlot$8(compSlot) ? compSlot : {
        default: () => [compSlot]
      });
    }
    function renderLabelHelpMessage() {
      const {
        label,
        helpMessage,
        helpComponentProps,
        subLabel
      } = props2.scheme;
      const renderLabel = subLabel ? createVNode("span", null, [label, createTextVNode(" "), createVNode("span", {
        "class": "text-secondary"
      }, [subLabel])]) : label;
      const getHelpMessage = isFunction$1(helpMessage) ? helpMessage(unref(getValues)) : helpMessage;
      if (!getHelpMessage || Array.isArray(getHelpMessage) && getHelpMessage.length === 0) {
        return renderLabel;
      }
      return createVNode("span", null, [renderLabel, createVNode(FbuHelpTooltip, mergeProps({
        "placement": "top",
        "text": getHelpMessage
      }, helpComponentProps), null)]);
    }
    function renderItem() {
      const {
        itemProps,
        slot,
        render: render11,
        field,
        suffix,
        itemRest
      } = props2.scheme;
      const {
        labelCol,
        wrapperCol
      } = unref(itemLabelWidthProp);
      const {
        colon
      } = props2.formProps;
      const getContent = () => {
        return slot ? getSlot2(slots, slot, unref(getValues)) : render11 ? render11(unref(getValues)) : renderComponent();
      };
      const showSuffix = !!suffix;
      const getSuffix = isFunction$1(suffix) ? suffix(unref(getValues)) : suffix;
      const labelSlot = slots[`${field}Label`];
      return createVNode(Form$1.Item, mergeProps({
        "name": field,
        "colon": colon,
        "class": {
          "suffix-item": showSuffix
        }
      }, itemProps, {
        "rules": handleRules(),
        "labelCol": labelCol,
        "wrapperCol": wrapperCol
      }), {
        label: () => labelSlot ? labelSlot({
          scheme: props2.scheme,
          values: unref(getValues)
        }) : createVNode("span", null, [renderLabelHelpMessage()]),
        default: () => createVNode("div", {
          "style": "display:flex; align-items: center"
        }, [createVNode("div", {
          "style": "flex:1;"
        }, [itemRest ? createVNode(Form$1.ItemRest, null, {
          default: () => [createTextVNode(" "), getContent()]
        }) : getContent()]), showSuffix && createVNode("span", {
          "class": "suffix"
        }, [getSuffix])])
      });
    }
    return () => {
      let _slot;
      const {
        colProps: colProps3 = {
          span: 6
        },
        colSlot,
        renderColContent,
        component
      } = props2.scheme;
      if (!componentMap$1.has(component)) {
        return null;
      }
      const {
        baseColProps = {}
      } = props2.formProps;
      const realColProps = __spreadValues(__spreadValues({}, baseColProps), colProps3);
      const {
        isIfShow,
        isShow
      } = getShow();
      const values = unref(getValues);
      const getContent = () => {
        return colSlot ? getSlot2(slots, colSlot, values) : renderColContent ? renderColContent(values) : renderItem();
      };
      return isIfShow && withDirectives(createVNode(Col, realColProps, _isSlot$8(_slot = getContent()) ? _slot : {
        default: () => [_slot]
      }), [[vShow, isShow]]);
    };
  }
});
const set = (obj, path, value) => {
  let pathArr = [];
  if (Array.isArray(path) !== true) {
    pathArr = path.toString().match(/[^.[\]]+/g) || [];
  }
  pathArr.slice(0, -1).reduce((a2, c2, i2) => Object(a2[c2]) === a2[c2] ? a2[c2] : a2[c2] = Math.abs(pathArr[i2 + 1]) >> 0 === +pathArr[i2 + 1] ? [] : {}, obj)[pathArr[pathArr.length - 1]] = value;
  return obj;
};
function omit(obj, paths) {
  if (!isPlainObject(obj)) {
    return {};
  }
  const objKeys = Object.keys(obj);
  if (objKeys.length === 0) {
    return {};
  }
  const pathsArr = isArray$1(paths) ? paths : [paths];
  const retObj = __spreadValues({}, obj);
  pathsArr.forEach((path) => {
    Reflect.deleteProperty(retObj, path);
  });
  return retObj;
}
function get(obj, paths) {
  if (!isPlainObject(obj)) {
    return;
  }
  const pathsArr = isArray$1(paths) ? paths : paths.match(/[^.]+/g);
  return (pathsArr || []).reduce((o2, cur) => (o2 || {})[cur], obj);
}
function useFormValues({
  defaultValueRef,
  getSchemes,
  formModel,
  getProps
}) {
  function handleFormValues(values) {
    var _a2, _b;
    if (!isObject$1(values)) {
      return {};
    }
    const schemesFieldList = new Set(unref(getSchemes).map((item) => item.field));
    const { splitFields = [], customSplitFunc, showFieldSettings } = unref(getProps);
    const res = {};
    for (const item of Object.entries(values)) {
      let [, value] = item;
      const [key2] = item;
      if (!schemesFieldList.has(key2) && showFieldSettings) {
        continue;
      }
      if (!key2 || isArray$1(value) && value.length === 0 || isFunction$1(value)) {
        continue;
      }
      const transformDateFunc = unref(getProps).transformDateFunc;
      if (isObject$1(value)) {
        value = transformDateFunc == null ? void 0 : transformDateFunc(value);
      }
      if (isArray$1(value) && ((_a2 = value[0]) == null ? void 0 : _a2.format) && ((_b = value[1]) == null ? void 0 : _b.format)) {
        value = value.map((item2) => transformDateFunc == null ? void 0 : transformDateFunc(item2));
      }
      if (isString$1(value)) {
        value = value.trim();
      }
      set(res, key2, value);
    }
    const resultValue = handleRangeValue(res);
    if (typeof customSplitFunc === "function") {
      return customSplitFunc(resultValue) || resultValue;
    }
    return splitValueByWhiteSpace(resultValue, splitFields);
  }
  function handleRangeValue(values) {
    const fieldMapToRangeValue = unref(getProps).fieldMapToRangeValue;
    if (!fieldMapToRangeValue || !Array.isArray(fieldMapToRangeValue)) {
      return values;
    }
    for (const [field, [field0, field1], format3 = null] of fieldMapToRangeValue) {
      if (!field || !field0 || !field1 || !values[field]) {
        continue;
      }
      const [value1, value2] = values[field];
      values[field0] = format3 ? format3(value1, field0) : value1;
      values[field1] = format3 ? format3(value2, field1) : value2;
      Reflect.deleteProperty(values, field);
    }
    return handleRangeTimeValue(values);
  }
  function handleRangeTimeValue(values) {
    const fieldMapToTime = unref(getProps).fieldMapToTime;
    if (!fieldMapToTime || !Array.isArray(fieldMapToTime)) {
      return values;
    }
    for (const [
      field,
      [startTimeKey, endTimeKey],
      format3 = "YYYY-MM-DD HH:mm:ss"
    ] of fieldMapToTime) {
      if (!field || !startTimeKey || !endTimeKey || !values[field]) {
        continue;
      }
      const [startTime, endTime] = values[field];
      values[startTimeKey] = startTime ? dateAdapter(startTime).format(format3) : void 0;
      values[endTimeKey] = endTime ? dateAdapter(endTime).format(format3) : void 0;
      Reflect.deleteProperty(values, field);
    }
    return values;
  }
  function initDefaultModel() {
    const schemes = unref(getSchemes);
    const obj = {};
    schemes.forEach((item) => {
      const { defaultValue } = item;
      if (isDef(defaultValue)) {
        obj[item.field] = defaultValue;
        if (isUnDef(formModel[item.field])) {
          formModel[item.field] = cloneDeep(defaultValue);
        }
      }
    });
    defaultValueRef.value = obj;
  }
  return {
    handleFormValues,
    initDefaultModel
  };
}
async function useAutoFocus({
  getSchemes,
  getProps,
  formElRef,
  isInitedDefault
}) {
  watchEffect(async () => {
    if (unref(isInitedDefault) || !unref(getProps).autoFocusFirstItem) {
      return;
    }
    await nextTick();
    const schemes = unref(getSchemes);
    const formEl = unref(formElRef);
    const el = formEl == null ? void 0 : formEl.$el;
    if (!formEl || !el || !schemes || schemes.length === 0) {
      return;
    }
    const firstItem = schemes[0];
    if (!firstItem.component.includes("Input")) {
      return;
    }
    const inputEl = el.querySelector(".ant-row:first-child input");
    if (!inputEl)
      return;
    inputEl == null ? void 0 : inputEl.focus();
  });
}
function objForEach(obj, fn) {
  if (isPlainObject(obj) === false) {
    return;
  }
  for (const key2 in obj) {
    if (Reflect.has(obj, key2)) {
      fn.call(null, obj[key2], key2);
    }
  }
}
function merge2(...args) {
  const result = {};
  function assignValue2(val, key2) {
    if (isPlainObject(result[key2]) && isPlainObject(val)) {
      result[key2] = merge2(result[key2], val);
    } else if (isPlainObject(val)) {
      result[key2] = merge2({}, val);
    } else if (Array.isArray(val)) {
      result[key2] = val.slice();
    } else {
      result[key2] = val;
    }
  }
  for (let i2 = 0, l2 = args.length; i2 < l2; i2++) {
    objForEach(args[i2], assignValue2);
  }
  return result;
}
function mitt(all) {
  all = all || new Map();
  return {
    all,
    on(type4, handler4) {
      const handlers = all.get(type4);
      if (handlers) {
        handlers.push(handler4);
      } else {
        all.set(type4, [handler4]);
      }
    },
    off(type4, handler4) {
      const handlers = all.get(type4);
      if (handlers) {
        if (handler4) {
          handlers.splice(handlers.indexOf(handler4) >>> 0, 1);
        } else {
          all.set(type4, []);
        }
      }
    },
    emit(type4, evt) {
      let handlers = all.get(type4);
      if (handlers) {
        handlers.slice().map((handler4) => {
          handler4(evt);
        });
      }
      handlers = all.get("*");
      if (handlers) {
        handlers.slice().map((handler4) => {
          handler4(type4, evt);
        });
      }
    },
    clear() {
      all == null ? void 0 : all.clear();
    }
  };
}
const key$3 = Symbol();
const emitter = mitt();
const listenerReset = (callback) => {
  emitter.on(key$3, callback);
};
const notifyReset = () => {
  emitter.emit(key$3);
};
function useFormEvents({
  emit,
  getProps,
  formModel,
  getSchemes,
  defaultValueRef,
  formElRef,
  schemesRef,
  handleFormValues
}) {
  async function resetFields() {
    const { resetFunc, submitOnReset } = unref(getProps);
    resetFunc && isFunction$1(resetFunc) && await resetFunc();
    const formEl = unref(formElRef);
    if (!formEl)
      return;
    Object.keys(formModel).forEach((key2) => {
      formModel[key2] = cloneDeep(defaultValueRef.value[key2]);
    });
    nextTick(() => clearValidate2());
    notifyReset();
    emit("reset", toRaw(formModel));
    submitOnReset && handleSubmit();
  }
  async function setFieldsValue(values) {
    const validKeys = [];
    Object.keys(values).forEach((key2) => {
      const scheme = unref(getSchemes).find((item) => item.field === key2);
      if (scheme) {
        const value = handleInputNumberValue(scheme == null ? void 0 : scheme.component, values[key2]);
        if (itemIsDateType(key2)) {
          if (Array.isArray(value)) {
            const arr = [];
            for (const ele of value) {
              arr.push(ele ? dateAdapter(ele) : null);
            }
            formModel[key2] = arr;
          } else {
            const { componentProps } = scheme || {};
            let _props = componentProps;
            if (typeof componentProps === "function") {
              _props = _props({ formModel });
            }
            formModel[key2] = value ? (_props == null ? void 0 : _props.valueFormat) ? value : dateAdapter(value) : null;
          }
        } else {
          formModel[key2] = value;
        }
        validKeys.push(key2);
      }
    });
    validateFields(validKeys).catch(() => {
    });
  }
  async function removeSchemeByFiled(fields) {
    const schemeList = cloneDeep(unref(getSchemes));
    if (!fields) {
      return;
    }
    const fieldList = isString$1(fields) ? [fields] : fields;
    for (const field of fieldList) {
      _removeSchemeByFiled(field, schemeList);
    }
    schemesRef.value = schemeList;
  }
  function _removeSchemeByFiled(field, schemeList) {
    if (isString$1(field)) {
      const index2 = schemeList.findIndex((scheme) => scheme.field === field);
      if (index2 !== -1) {
        delete formModel[field];
        schemeList.splice(index2, 1);
      }
    }
  }
  async function appendSchemeByField(scheme, prefixField, first = false) {
    const schemeList = cloneDeep(unref(getSchemes));
    const index2 = schemeList.findIndex((scheme2) => scheme2.field === prefixField);
    if (!prefixField || index2 === -1 || first) {
      first ? schemeList.unshift(scheme) : schemeList.push(scheme);
      schemesRef.value = schemeList;
      return;
    }
    if (index2 !== -1) {
      schemeList.splice(index2 + 1, 0, scheme);
    }
    schemesRef.value = schemeList;
  }
  async function resetScheme(data6) {
    let updateData = [];
    if (isObject$1(data6)) {
      updateData.push(data6);
    }
    if (isArray$1(data6)) {
      updateData = [...data6];
    }
    const hasField = updateData.every((item) => Reflect.has(item, "field") && item.field);
    if (!hasField) {
      console.error("scheme\u5FC5\u987B\u8981\u6709field\u5B57\u6BB5\uFF0C\u4E14\u4E0D\u80FD\u4E3A\u7A7A");
      return;
    }
    schemesRef.value = updateData;
  }
  async function updateScheme(data6) {
    let updateData = [];
    if (isObject$1(data6)) {
      updateData.push(data6);
    }
    if (isArray$1(data6)) {
      updateData = [...data6];
    }
    const hasField = updateData.every((item) => Reflect.has(item, "field") && item.field);
    if (!hasField) {
      console.error("scheme\u5FC5\u987B\u8981\u6709field\u5B57\u6BB5");
      return;
    }
    const scheme = [];
    updateData.forEach((item) => {
      unref(getSchemes).forEach((val) => {
        if (val.field === item.field) {
          const newScheme = merge2(val, item);
          scheme.push(newScheme);
        } else {
          scheme.push(val);
        }
      });
    });
    schemesRef.value = uniqBy(scheme, "field");
  }
  function getFieldsValue() {
    const formEl = unref(formElRef);
    if (!formEl)
      return {};
    return handleFormValues(toRaw(unref(formModel)));
  }
  function itemIsDateType(key2) {
    return unref(getSchemes).some((item) => {
      return item.field === key2 ? dateItemType.includes(item.component) : false;
    });
  }
  async function validateFields(nameList) {
    var _a2;
    return await ((_a2 = unref(formElRef)) == null ? void 0 : _a2.validateFields(nameList));
  }
  async function validate(nameList) {
    var _a2;
    return await ((_a2 = unref(formElRef)) == null ? void 0 : _a2.validate(nameList));
  }
  async function clearValidate2(name2) {
    var _a2;
    await ((_a2 = unref(formElRef)) == null ? void 0 : _a2.clearValidate(name2));
  }
  async function scrollToField(name2, options) {
    var _a2;
    await ((_a2 = unref(formElRef)) == null ? void 0 : _a2.scrollToField(name2, options));
  }
  async function handleSubmit(e2) {
    e2 && e2.preventDefault();
    const { submitFunc } = unref(getProps);
    if (submitFunc && isFunction$1(submitFunc)) {
      await submitFunc();
      return;
    }
    const formEl = unref(formElRef);
    if (!formEl)
      return;
    try {
      const values = await validate();
      const res = handleFormValues(values);
      emit("submit", res);
    } catch (error) {
      throw new Error(error);
    }
  }
  return {
    handleSubmit,
    clearValidate: clearValidate2,
    validate,
    validateFields,
    getFieldsValue,
    updateScheme,
    resetScheme,
    appendSchemeByField,
    removeSchemeByFiled,
    resetFields,
    setFieldsValue,
    scrollToField
  };
}
const key$2 = Symbol();
function createFormContextProvider(context2) {
  return createContext(context2, key$2, { reactivity: false });
}
function useFormContextProvider() {
  return useContext(key$2);
}
function useAdvanced(getProps) {
  const isAdvanced = ref(unref(getProps).defaultExpandedAdvanced || !unref(getProps).showAdvancedButton || false);
  const { autoAdvancedLines } = unref(getProps);
  const ifShowAdvanced = computed(() => {
    var _a2;
    return unref(getProps).showAdvanced || ((_a2 = getProps.value.schemes || []) == null ? void 0 : _a2.length) > 12;
  });
  function updateAdvanced(schemes) {
    if (ifShowAdvanced.value === false || !autoAdvancedLines) {
      return;
    }
    const SPAN_PER_LINE = 24;
    const SPAN_TOTAL = autoAdvancedLines * SPAN_PER_LINE;
    let accSpans = 0;
    for (let i2 = 0; i2 < schemes.length; i2++) {
      const scheme = schemes[i2];
      if (accSpans === SPAN_TOTAL) {
        scheme.advanced = true;
      } else {
        scheme.advanced = false;
        accSpans = accSpans + (scheme.colProps && scheme.colProps.span || 6);
      }
    }
  }
  function toggleAdvanced() {
    isAdvanced.value = !isAdvanced.value;
  }
  function handleToggleAdvanced() {
    toggleAdvanced();
  }
  function sortAdvancedSchemes(schemes) {
    const advancedSchemes = [];
    const defSchemes = [];
    for (const scheme of schemes) {
      if (scheme.advanced === true) {
        advancedSchemes.push(scheme);
        continue;
      }
      defSchemes.push(scheme);
    }
    return [...defSchemes, ...advancedSchemes];
  }
  return {
    isAdvanced,
    handleToggleAdvanced,
    sortAdvancedSchemes,
    updateAdvanced,
    toggleAdvanced
  };
}
const STORAGE_VALUE_PREFIX = "fbu";
var ValueType;
(function(ValueType2) {
  ValueType2["DATE"] = "date";
  ValueType2["EXPR"] = "expr";
  ValueType2["NUMB"] = "numb";
  ValueType2["BOOL"] = "bool";
  ValueType2["STRN"] = "strn";
  ValueType2["OBJT"] = "objt";
})(ValueType || (ValueType = {}));
function prefixValueType(type4) {
  return `${STORAGE_VALUE_PREFIX}${type4}|`;
}
const ValueTypeWithPrefix = {
  P_DATE: "",
  P_EXPR: "",
  P_NUMB: "",
  P_BOOL: "",
  P_STRN: "",
  P_OBJT: ""
};
Object.keys(ValueType).forEach((key2) => {
  ValueTypeWithPrefix["P_" + key2] = prefixValueType(ValueType[key2]);
});
function encode(value) {
  if (Object.prototype.toString.call(value) === "[object Date]") {
    return ValueTypeWithPrefix.P_DATE + value.toISOString();
  }
  if (Object.prototype.toString.call(value) === "[object RegExp]") {
    return ValueTypeWithPrefix.P_EXPR + value.source;
  }
  if (typeof value === "number") {
    return ValueTypeWithPrefix.P_NUMB + value;
  }
  if (typeof value === "boolean") {
    return ValueTypeWithPrefix.P_BOOL + (value ? "1" : "0");
  }
  if (typeof value === "string") {
    return ValueTypeWithPrefix.P_STRN + value;
  }
  if (typeof value === "function") {
    return ValueTypeWithPrefix.P_STRN + value.toString();
  }
  if (value === Object(value)) {
    return ValueTypeWithPrefix.P_OBJT + JSON.stringify(value);
  }
  return value;
}
function decode(value) {
  if (!value.startsWith(STORAGE_VALUE_PREFIX)) {
    return value;
  }
  const typeLen = STORAGE_VALUE_PREFIX.length + 5;
  const type4 = value.slice(0, typeLen);
  const source = value.substring(typeLen);
  switch (type4) {
    case ValueTypeWithPrefix.P_DATE:
      return new Date(source);
    case ValueTypeWithPrefix.P_EXPR:
      return new RegExp(source);
    case ValueTypeWithPrefix.P_NUMB:
      return Number(source);
    case ValueTypeWithPrefix.P_BOOL:
      return Boolean(source === "1");
    case ValueTypeWithPrefix.P_STRN:
      return "" + source;
    case ValueTypeWithPrefix.P_OBJT:
      return JSON.parse(source);
    default:
      return value;
  }
}
class BaseStorage {
  constructor(type4 = "local", useExpire = false) {
    __publicField(this, "webStorage");
    __publicField(this, "useExpire");
    this.webStorage = window[`${type4}Storage`];
    this.useExpire = useExpire;
  }
  getLength() {
    return this.webStorage.length;
  }
  isEmpty() {
    return this.webStorage.length === 0;
  }
  get(key2) {
    const item = this.webStorage.getItem(key2);
    if (!item) {
      return null;
    }
    const data6 = decode(item);
    if (this.useExpire) {
      const { value, expires } = data6;
      if (isUnDef(expires) || expires >= Date.now()) {
        return value;
      }
      this.remove(key2);
      return null;
    } else {
      return data6;
    }
  }
  set(key2, value, expires = null) {
    let data6 = value;
    if (this.useExpire) {
      data6 = {
        value,
        time: Date.now(),
        expires: !isUnDef(expires) ? Date.now() + expires * 1e3 : null
      };
    }
    try {
      this.webStorage.setItem(key2, encode(data6));
      return true;
    } catch (e2) {
      console.log(e2);
      return false;
    }
  }
  has(key2) {
    return this.webStorage.getItem(key2) !== null;
  }
  getKey(index2) {
    return this.webStorage.key(index2);
  }
  getIndex(index2) {
    const key2 = this.getKey(index2);
    return key2 && this.get(key2) || null;
  }
  getAll() {
    const res = {}, len = this.webStorage.length;
    for (let i2 = 0; i2 < len; i2++) {
      const k2 = this.getKey(i2);
      if (k2) {
        res[k2] = this.get(k2);
      }
    }
    return res;
  }
  getAllKeys() {
    const keys2 = [];
    const len = this.webStorage.length;
    for (let i2 = 0; i2 < len; i2++) {
      const k2 = this.getKey(i2);
      k2 && keys2.push(k2);
    }
    return keys2;
  }
  remove(key2) {
    this.webStorage.removeItem(key2);
  }
  clear() {
    this.webStorage.clear();
  }
}
const storageProxy = new BaseStorage();
const tableCacheKeyPrefix$2 = "FBU_FORM_FIELD_SETTING_";
const getCacheKeyName = (key2) => `${tableCacheKeyPrefix$2}${key2}`;
function useFieldSettings({ getProps }) {
  const { cacheName, showFieldSettings } = unref(getProps);
  const computedAllSchemes = computed(() => {
    return (unref(getProps).schemes || []).filter((item) => {
      if (typeof item.ifShow === "boolean") {
        return item.ifShow;
      }
      return true;
    });
  });
  const schemeSettingModalRef = ref();
  const computedEnableFieldSetting = computed(() => unref(getProps).showFieldSettings);
  const visibleSchemesRef = ref([]);
  const initVisibleSchemes = () => {
    var _a2;
    const cachedSchemes = getSchemesCache();
    if (!showFieldSettings || !cacheName || !cachedSchemes) {
      visibleSchemesRef.value = ((_a2 = computedAllSchemes.value) == null ? void 0 : _a2.map(({ label, field, fixedVisible }) => ({
        label,
        field,
        fixedVisible,
        visible: true
      }))) || [];
      return;
    }
    if (Array.isArray(cachedSchemes)) {
      const allKeys = computedAllSchemes.value.map((item) => item.field);
      visibleSchemesRef.value = cachedSchemes.filter((item) => allKeys.includes(item.field));
    }
  };
  const setVisibleSchemes = (schemes) => {
    visibleSchemesRef.value = schemes.slice(0);
    setSchemesCache(schemes);
  };
  const getTrueVisibleSchemes = (schemes) => {
    const schemeKeys = visibleSchemesRef.value.map((scheme) => scheme.field);
    const filterdSchemes = schemes.filter((scheme) => scheme.fixedVisible || schemeKeys.includes(scheme.field));
    filterdSchemes.sort((prev2, next2) => {
      return schemeKeys.indexOf(prev2.field) - schemeKeys.indexOf(next2.field);
    });
    return filterdSchemes;
  };
  const openSchemeSettingModal = () => {
    var _a2;
    (_a2 = schemeSettingModalRef.value) == null ? void 0 : _a2.openModal((computedAllSchemes.value || []).map(({ label, field, fixedVisible }) => ({
      label,
      field,
      fixedVisible,
      visible: true
    })), visibleSchemesRef.value);
  };
  function getSchemesCache() {
    return cacheName ? storageProxy.get(getCacheKeyName(cacheName)) : null;
  }
  function setSchemesCache(schemes) {
    return cacheName && storageProxy.set(getCacheKeyName(cacheName), schemes);
  }
  onMounted(() => {
    initVisibleSchemes();
  });
  return {
    computedEnableFieldSetting,
    visibleSchemesRef,
    setVisibleSchemes,
    getTrueVisibleSchemes,
    schemeSettingModalRef,
    openSchemeSettingModal,
    initVisibleSchemes
  };
}
var searchIcon = "data:image/svg+xml;base64,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";
var resetIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjIgNS42NTc1OUMxMC4wNzQ3IDUuODAxODYgMTAuMTUxIDYuMDI3NzQgMTAuMzM4MiA2LjA2NjRMMTQuMDU0NSA2LjgzNDAyQzE0LjEzMTcgNi44NDk5NyAxNC4xOTYxIDYuNzc0NDUgMTQuMTY4MiA2LjcwMDcxTDEyLjgxNzEgMy4xMjkyM0MxMi43NTA0IDIuOTUyODIgMTIuNTE5OCAyLjkxMTAzIDEyLjM5NTQgMy4wNTI3OUwxMS43NDU5IDMuNzkyOTNDMTEuNjc4MSAzLjg3MDIyIDExLjU2MjkgMy44ODMxOSAxMS40Nzc3IDMuODI1NjVDMTAuNTMyMiAzLjE4NzE4IDkuNDM0MTMgMi44MDQ2NyA4LjI5MTE4IDIuNzE5NzRDNi45OTY3MSAyLjYyMzU0IDUuNzAyNzkgMi45MTMzNiA0LjU3MzAzIDMuNTUyNTVDMy40NDMyOCA0LjE5MTczIDIuNTI4NDQgNS4xNTE1NyAxLjk0NDE5IDYuMzEwNjlDMS4zNTk5NSA3LjQ2OTgxIDEuMTMyNTQgOC43NzYxNSAxLjI5MDczIDEwLjA2NDVDMS40NDg5MiAxMS4zNTI5IDEuOTg1NjEgMTIuNTY1NCAyLjgzMjkxIDEzLjU0ODdDMy42ODAyMiAxNC41MzIxIDQuODAwMSAxNS4yNDIxIDYuMDUwOTIgMTUuNTg5QzcuMzAxNzUgMTUuOTM1OSA4LjYyNzM1IDE1LjkwNCA5Ljg2MDEgMTUuNDk3NkMxMC45MTkyIDE1LjE0ODMgMTEuODY4OSAxNC41MzYgMTIuNjIyMiAxMy43MjE3QzEyLjgyNzQgMTMuNSAxMi43ODM2IDEzLjE1NDUgMTIuNTQ1NSAxMi45Njg2QzEyLjMwNzUgMTIuNzgyNiAxMS45NjU3IDEyLjgyNyAxMS43NTY5IDEzLjA0NTNDMTEuMTM5NCAxMy42OTA4IDEwLjM3MTEgMTQuMTc3MyA5LjUxNzU1IDE0LjQ1ODdDOC40OTAyNiAxNC43OTc1IDcuMzg1NTkgMTQuODI0IDYuMzQzMjQgMTQuNTM0OUM1LjMwMDg4IDE0LjI0NTkgNC4zNjc2NSAxMy42NTQyIDMuNjYxNTYgMTIuODM0N0MyLjk1NTQ3IDEyLjAxNTMgMi41MDgyNCAxMS4wMDQ4IDIuMzc2NDEgOS45MzEyMUMyLjI0NDU5IDguODU3NTcgMi40MzQwOSA3Ljc2ODk2IDIuOTIwOTYgNi44MDMwMkMzLjQwNzgzIDUuODM3MDkgNC4xNzAyIDUuMDM3MjIgNS4xMTE2NiA0LjUwNDU3QzYuMDUzMTIgMy45NzE5MiA3LjEzMTM5IDMuNzMwNCA4LjIxMDEyIDMuODEwNTZDOS4xMjM3NCAzLjg3ODQ2IDEwLjAwMjkgNC4xNzQ1MiAxMC43Njg1IDQuNjY4MTVDMTAuODY4MSA0LjczMjM4IDEwLjg4NDcgNC44Njk3MyAxMC44MDY5IDQuOTU5MkwxMC4yIDUuNjU3NTlaIiBmaWxsPSIjMDA1YWU4Ii8+Cjwvc3ZnPgo=";
var IconReset = () => {
  return createVNode("svg", {
    "width": "14",
    "height": "14",
    "viewBox": "0 0 14 14",
    "fill": "currentColor"
  }, [createVNode("path", {
    "d": "M9.20005 3.15759C9.07468 3.30186 9.151 3.52774 9.33818 3.5664L13.0545 4.33402C13.1317 4.34997 13.1961 4.27445 13.1682 4.20071L11.8171 0.629227C11.7504 0.452817 11.5198 0.411025 11.3954 0.552794L10.7459 1.29293C10.6781 1.37022 10.5629 1.38319 10.4777 1.32565C9.53217 0.687177 8.43413 0.304675 7.29118 0.219739C5.99671 0.123543 4.70279 0.413362 3.57303 1.05255C2.44328 1.69173 1.52844 2.65157 0.944193 3.81069C0.359949 4.96981 0.132543 6.27615 0.290734 7.56451C0.448925 8.85287 0.985608 10.0654 1.83291 11.0487C2.68022 12.0321 3.8001 12.7421 5.05092 13.089C6.30175 13.4359 7.62735 13.404 8.8601 12.9976C9.91921 12.6483 10.8689 12.036 11.6222 11.2217C11.8274 11 11.7836 10.6545 11.5455 10.4686C11.3075 10.2826 10.9657 10.327 10.7569 10.5453C10.1394 11.1908 9.37112 11.6773 8.51755 11.9587C7.49026 12.2975 6.38559 12.324 5.34324 12.0349C4.30088 11.7459 3.36765 11.1542 2.66156 10.3347C1.95547 9.51527 1.50824 8.50484 1.37641 7.43121C1.24459 6.35757 1.43409 5.26896 1.92096 4.30302C2.40783 3.33709 3.1702 2.53722 4.11166 2.00457C5.05312 1.47192 6.13139 1.2304 7.21012 1.31056C8.12374 1.37846 9.00294 1.67452 9.76852 2.16815C9.86814 2.23238 9.88468 2.36973 9.80693 2.4592L9.20005 3.15759Z"
  }, null)]);
};
const _sfc_main$s = defineComponent({
  name: "FbuDropdown",
  components: {
    Dropdown: Dropdown$2,
    Menu,
    MenuItem: Menu.Item,
    MenuDivider: Menu.Divider,
    Popconfirm: Popconfirm$1
  },
  inheritAttrs: false,
  props: {
    dropMenuList: q().def(() => []),
    popconfirm: Boolean,
    trigger: q().def(() => ["click"]),
    selectedKeys: q().def(() => [])
  },
  emits: ["update:selectedKeys", "menuEvent"],
  setup(props2, { emit }) {
    const innerSelectedKeysRef = computed({
      get: () => props2.selectedKeys,
      set: (selectedKeys) => {
        emit("update:selectedKeys", selectedKeys);
      }
    });
    function handleClickMenu(item) {
      var _a2;
      emit("menuEvent", item);
      (_a2 = item.onClick) == null ? void 0 : _a2.call(item);
    }
    const getPopConfirmAttrs = computed(() => {
      return (attrs) => {
        const originAttrs = __spreadValues({}, attrs);
        Reflect.deleteProperty(originAttrs, "confirm");
        Reflect.deleteProperty(originAttrs, "cancel");
        if (!attrs.onConfirm && attrs.confirm && isFunction$1(attrs.confirm))
          originAttrs["onConfirm"] = attrs.confirm;
        if (!attrs.onCancel && attrs.cancel && isFunction$1(attrs.cancel))
          originAttrs["onCancel"] = attrs.cancel;
        return originAttrs;
      };
    });
    const getAttr = (key2) => ({ key: key2 });
    return {
      innerSelectedKeysRef,
      handleClickMenu,
      getPopConfirmAttrs,
      getAttr
    };
  }
});
const _hoisted_1$l = { style: { "display": "inline-block" } };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Popconfirm = resolveComponent("Popconfirm");
  const _component_MenuItem = resolveComponent("MenuItem");
  const _component_MenuDivider = resolveComponent("MenuDivider");
  const _component_Menu = resolveComponent("Menu");
  const _component_Dropdown = resolveComponent("Dropdown", true);
  return openBlock(), createBlock(_component_Dropdown, mergeProps(_ctx.$attrs, { trigger: _ctx.trigger }), {
    overlay: withCtx(() => [
      createVNode(_component_Menu, {
        "selected-keys": _ctx.innerSelectedKeysRef,
        "onUpdate:selected-keys": _cache[0] || (_cache[0] = ($event) => _ctx.innerSelectedKeysRef = $event)
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dropMenuList, (item) => {
            return openBlock(), createElementBlock(Fragment, {
              key: `${item.event}`
            }, [
              createVNode(_component_MenuItem, mergeProps(_ctx.getAttr(item.event), {
                onClick: ($event) => _ctx.handleClickMenu(item),
                disabled: item.disabled
              }), {
                default: withCtx(() => [
                  _ctx.popconfirm && item.popConfirm ? (openBlock(), createBlock(_component_Popconfirm, mergeProps({ key: 0 }, _ctx.getPopConfirmAttrs(item.popConfirm), {
                    disabled: item.disabled
                  }), createSlots({
                    default: withCtx(() => [
                      createElementVNode("div", null, [
                        _ctx.$slots.itemIcon ? renderSlot(_ctx.$slots, "itemIcon", normalizeProps(mergeProps({ key: 0 }, item))) : createCommentVNode("", true),
                        createElementVNode("span", {
                          class: normalizeClass(_ctx.$slots.itemIcon && `ml-10`)
                        }, toDisplayString(item.text), 3)
                      ])
                    ]),
                    _: 2
                  }, [
                    item.popConfirm.icon ? {
                      name: "icon",
                      fn: withCtx(() => [
                        renderSlot(_ctx.$slots, "itemPopconfirmIcon", normalizeProps(guardReactiveProps(item)))
                      ])
                    } : void 0
                  ]), 1040, ["disabled"])) : renderSlot(_ctx.$slots, "menuItem", normalizeProps(mergeProps({ key: 1 }, item)), () => [
                    _ctx.$slots.itemIcon ? renderSlot(_ctx.$slots, "itemIcon", normalizeProps(mergeProps({ key: 0 }, item))) : createCommentVNode("", true),
                    createElementVNode("span", {
                      class: normalizeClass(_ctx.$slots.itemIcon && `ml-10`)
                    }, toDisplayString(item.text), 3)
                  ])
                ]),
                _: 2
              }, 1040, ["onClick", "disabled"]),
              item.divider ? (openBlock(), createBlock(_component_MenuDivider, {
                key: `d-${item.event}`
              })) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ]),
        _: 3
      }, 8, ["selected-keys"])
    ]),
    default: withCtx(() => [
      createElementVNode("span", _hoisted_1$l, [
        renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 16, ["trigger"]);
}
var Dropdown = /* @__PURE__ */ _export_sfc$1(_sfc_main$s, [["render", _sfc_render$m]]);
var FbuDropdown = withInstall$1(Dropdown);
var IconDelete = () => {
  return createVNode("svg", {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "currentColor"
  }, [createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M8 0C9.38071 0 10.5 1.11929 10.5 2.5H15.5C15.7761 2.5 16 2.72386 16 3C16 3.27614 15.7761 3.5 15.5 3.5H0.5C0.223858 3.5 0 3.27614 0 3C0 2.72386 0.223858 2.5 0.5 2.5H5.5C5.5 1.11929 6.61929 0 8 0ZM6.5 2.5H9.5C9.5 1.67157 8.82843 1 8 1C7.17157 1 6.5 1.67157 6.5 2.5Z"
  }, null), createVNode("path", {
    "d": "M8 7.25C7.72386 7.25 7.5 7.47386 7.5 7.75V12.75C7.5 13.0261 7.72386 13.25 8 13.25C8.27614 13.25 8.5 13.0261 8.5 12.75V7.75C8.5 7.47386 8.27614 7.25 8 7.25Z"
  }, null), createVNode("path", {
    "d": "M10.5 7.75C10.5 7.47386 10.7239 7.25 11 7.25C11.2761 7.25 11.5 7.47386 11.5 7.75V12.75C11.5 13.0261 11.2761 13.25 11 13.25C10.7239 13.25 10.5 13.0261 10.5 12.75V7.75Z"
  }, null), createVNode("path", {
    "d": "M5 7.25C4.72386 7.25 4.5 7.47386 4.5 7.75V12.75C4.5 13.0261 4.72386 13.25 5 13.25C5.27614 13.25 5.5 13.0261 5.5 12.75V7.75C5.5 7.47386 5.27614 7.25 5 7.25Z"
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M1 6.5C1 5.39543 1.89543 4.5 3 4.5H13C14.1046 4.5 15 5.39543 15 6.5V14C15 15.1046 14.1046 16 13 16H3C1.89543 16 1 15.1046 1 14V6.5ZM2 6.5C2 5.94772 2.44772 5.5 3 5.5H13C13.5523 5.5 14 5.94772 14 6.5V14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14V6.5Z"
  }, null)]);
};
let buf, bufIdx = 0;
const hexBytes = Array.from(Array(256), (_2, k2) => (k2 + 256).toString(16).slice(1));
const MAX_BUFF_SIZE = 4096;
function uuid() {
  if (buf === void 0 || bufIdx + 16 > MAX_BUFF_SIZE) {
    bufIdx = 0;
    buf = crypto.getRandomValues(new Uint8Array(MAX_BUFF_SIZE));
  }
  const useBuf = buf.slice(bufIdx, bufIdx += 16);
  useBuf[6] = useBuf[6] & 15 | 64;
  useBuf[8] = useBuf[8] & 63 | 128;
  const res = [];
  for (let i2 = 0; i2 < 16; i2++) {
    res.push(hexBytes[useBuf[i2]]);
    if (i2 === 3 || i2 === 5 || i2 === 7 || i2 === 9) {
      res.push("-");
    }
  }
  return res.join("");
}
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c2) => (c2 ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c2 / 4).toString(16));
}
function convertUndefinedToString(data6) {
  if (!(isArray$1(data6) || isPlainObject(data6))) {
    return;
  }
  Object.keys(data6).forEach((key2) => {
    const value = data6[key2];
    if (typeof value === "undefined") {
      data6[key2] = "undefined";
    } else if (isPlainObject(value) || isArray$1(value)) {
      convertUndefinedToString(value);
    }
  });
}
function revertUndefinedString(data6) {
  if (!(isArray$1(data6) || isPlainObject(data6))) {
    return;
  }
  Object.keys(data6).forEach((key2) => {
    const value = data6[key2];
    if (value === "undefined") {
      data6[key2] = void 0;
    } else if (isPlainObject(value) || isArray$1(value)) {
      revertUndefinedString(value);
    }
  });
}
function useSearchSolution(props2) {
  const solutionList = ref([]);
  const loadingRef = ref(false);
  const getCollectionName = computed(() => {
    return props2.collectionName || `${location.origin}${location.pathname}`;
  });
  const solutionListComputed = computed(() => {
    const { fieldNames } = props2;
    const { text, event, id } = fieldNames;
    return unref(solutionList).map((item) => {
      return __spreadProps(__spreadValues({}, item), {
        id: item[id],
        label: item[text],
        value: item[event]
      });
    });
  });
  function getSolutionListFromLocal() {
    const collectionName = unref(getCollectionName);
    const localSolution = storageProxy.get(collectionName);
    return isArray$1(localSolution) && localSolution || [];
  }
  function setSolutionListToLocal(solutionList2, reload = true) {
    storageProxy.set(unref(getCollectionName), solutionList2);
    reload && fetchSolution();
  }
  async function fetchSolution() {
    const { api: api2, afterFetch } = props2;
    if (typeof api2 !== "function") {
      solutionList.value = getSolutionListFromLocal();
      return;
    }
    solutionList.value = [];
    loadingRef.value = true;
    try {
      let result = await api2(__spreadProps(__spreadValues({}, props2.params), { name: unref(getCollectionName) }));
      if (!result) {
        return;
      }
      if (!isArray$1(result)) {
        result = result[props2.resultField];
      }
      if (afterFetch && isFunction$1(afterFetch)) {
        result = await afterFetch(0, result) || result;
      }
      solutionList.value = result || [];
    } catch (err) {
      console.error("Get search solution error: " + err.message);
    } finally {
      loadingRef.value = false;
    }
  }
  async function deleteSolution(id) {
    const { delApi, afterFetch } = props2;
    if (typeof delApi !== "function") {
      const localSolutionList = getSolutionListFromLocal();
      const foundIndex = localSolutionList.findIndex((item) => item.id == id);
      if (foundIndex > -1) {
        localSolutionList.splice(foundIndex, 1);
        setSolutionListToLocal(localSolutionList, false);
      }
      return;
    }
    await delApi({ id, name: unref(getCollectionName) });
    if (afterFetch && isFunction$1(afterFetch)) {
      await afterFetch(1, id);
    }
  }
  async function saveSolution(solution) {
    const { saveApi, afterFetch, fieldNames } = props2;
    if (typeof saveApi !== "function") {
      const localSolutionList = getSolutionListFromLocal();
      const found = localSolutionList.find((item) => item.text == solution.text);
      if (found) {
        if (solution.id) {
          found.event = solution.event;
          setSolutionListToLocal(localSolutionList);
        } else {
          throw new Error("\u8BE5\u67E5\u8BE2\u65B9\u6848\u540D\u5B57\u5DF2\u5B58\u5728\uFF0C\u8BF7\u66F4\u6362");
        }
      } else {
        solution.id = uuidv4();
        localSolutionList.push(solution);
        setSolutionListToLocal(localSolutionList);
      }
      return;
    }
    await saveApi({
      name: unref(getCollectionName),
      [fieldNames.text]: solution.text,
      [fieldNames.event]: solution.event
    });
    if (afterFetch && isFunction$1(afterFetch)) {
      await afterFetch(2, solution);
    }
    fetchSolution();
  }
  function parseSolution(solution) {
    try {
      const solutionData = JSON.parse(solution.event);
      revertUndefinedString(solutionData);
      return solutionData;
    } catch (err) {
      console.error("Parse search solution error: " + err.message);
    }
    return null;
  }
  return {
    solutionListComputed,
    getCollectionName,
    loadingRef,
    fetchSolution,
    deleteSolution,
    saveSolution,
    parseSolution
  };
}
const _sfc_main$r = defineComponent({
  components: {
    FbuModal,
    Form: Form$1,
    FormItem: Form$1.Item,
    Input
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:visible", "ok"],
  setup(props2, { emit }) {
    const { t: t2 } = useFormContextProvider();
    const innerVisible = computed({
      get: () => props2.visible,
      set: (show) => {
        emit("update:visible", show);
      }
    });
    const formRef = ref();
    const formState = reactive({
      solutionName: ""
    });
    const handleOk = () => {
      var _a2;
      (_a2 = formRef.value) == null ? void 0 : _a2.validateFields().then((values) => {
        emit("ok", values.solutionName);
      }).catch((info) => {
        console.log("Validate Failed:", info);
      });
    };
    const handleClose = () => {
      var _a2;
      formState.solutionName = "";
      (_a2 = formRef.value) == null ? void 0 : _a2.clearValidate();
    };
    return {
      innerVisible,
      formState,
      handleOk,
      formRef,
      handleClose,
      t: t2
    };
  }
});
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = resolveComponent("Input");
  const _component_FormItem = resolveComponent("FormItem");
  const _component_Form = resolveComponent("Form");
  const _component_fbu_modal = resolveComponent("fbu-modal");
  return openBlock(), createBlock(_component_fbu_modal, {
    visible: _ctx.innerVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event) => _ctx.innerVisible = $event),
    title: _ctx.t("\u4FDD\u5B58\u4E3A\u67E5\u8BE2\u65B9\u6848"),
    "ok-text": _ctx.t("\u4FDD\u5B58"),
    "show-cancel-btn": true,
    "confirm-loading": _ctx.confirmLoading,
    width: 400,
    onOk: _ctx.handleOk,
    afterClose: _ctx.handleClose
  }, {
    default: withCtx(() => [
      createVNode(_component_Form, {
        ref: "formRef",
        model: _ctx.formState,
        hideRequiredMark: true,
        style: { "padding": "0 20px" },
        layout: "vertical"
      }, {
        default: withCtx(() => [
          createVNode(_component_FormItem, {
            label: _ctx.t("\u67E5\u8BE2\u65B9\u6848\u540D\u79F0"),
            name: "solutionName",
            rules: [{ required: true, message: _ctx.t("\u8BF7\u8F93\u5165\u67E5\u8BE2\u65B9\u6848\u540D\u79F0\uFF0C\u9650\u52367\u4E2A\u5B57\u7B26\u4EE5\u5185!"), max: 7 }],
            style: { "margin-bottom": "10px" }
          }, {
            default: withCtx(() => [
              createVNode(_component_Input, {
                value: _ctx.formState.solutionName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.formState.solutionName = $event),
                placeholder: _ctx.t("\u8BF7\u8F93\u5165\u67E5\u8BE2\u65B9\u6848\u540D\u79F0\uFF0C\u9650\u52367\u4E2A\u5B57\u7B26\u4EE5\u5185!")
              }, null, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label", "rules"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title", "ok-text", "confirm-loading", "onOk", "afterClose"]);
}
var SolutionSaveDialog = /* @__PURE__ */ _export_sfc$1(_sfc_main$r, [["render", _sfc_render$l]]);
const getIcon = (iconType) => {
  if (iconType === "success") {
    return createVNode(CheckCircleFilled$1, {
      "class": "modal-icon-success"
    }, null);
  } else if (iconType === "info") {
    return createVNode(InfoCircleFilled$1, {
      "class": "modal-icon-info"
    }, null);
  } else if (iconType === "warning") {
    return createVNode(ExclamationCircleFilled$1, {
      "class": "modal-icon-warning"
    }, null);
  } else {
    return createVNode(CloseCircleFilled$1, {
      "class": "modal-icon-error"
    }, null);
  }
};
const getModalContent = (content) => {
  if (typeof content === "string") {
    return createVNode("div", {
      "innerHTML": `<div>${content}</div>`
    }, null);
  }
  return content;
};
const createConfirm = (opts) => {
  const iconType = opts.iconType;
  Reflect.deleteProperty(opts, "iconType");
  return Modal$1.confirm(__spreadValues({
    centered: true,
    icon: getIcon(iconType)
  }, opts));
};
const createModalOptions = (opts, iconType) => {
  return __spreadProps(__spreadValues({
    okText: "\u786E \u5B9A",
    centered: true
  }, opts), {
    icon: getIcon(iconType),
    content: getModalContent(opts.content)
  });
};
const createSuccessModal = (opts) => {
  return Modal$1.success(createModalOptions(opts, "success"));
};
const createInfoModal = (opts) => {
  return Modal$1.info(createModalOptions(opts, "info"));
};
const createErrorModal = (opts) => {
  return Modal$1.error(createModalOptions(opts, "error"));
};
const createWarningModal = (opts) => {
  return Modal$1.warning(createModalOptions(opts, "warning"));
};
AntMessage.config({
  top: "30px",
  duration: 2,
  maxCount: 1
});
AntNotification.config({
  placement: "topRight",
  top: "30px",
  duration: 3
});
function useMessage() {
  return {
    createMessage: AntMessage,
    notification: AntNotification,
    createConfirm,
    createSuccessModal,
    createInfoModal,
    createErrorModal,
    createWarningModal,
    destroyAllModal: Modal$1.destroyAll
  };
}
function promiseTimeout(promises, delay = 1e3) {
  const pTimeout = () => new Promise((resolve) => setTimeout(resolve, delay, "timeout"));
  return Promise.all([...promises, pTimeout()]);
}
var FormActionsSearchSolution_vue_vue_type_style_index_0_lang = "";
const _sfc_main$q = defineComponent({
  name: "SearchSolution",
  components: {
    FbuButton: Button,
    FbuDropdown,
    DownOutlined: DownOutlined$1,
    CloseCircleOutlined: CloseCircleOutlined$1,
    IconDelete,
    Popconfirm: Popconfirm$1,
    SolutionSaveDialog
  },
  props: {
    collectionName: E().def(""),
    switchButtonProps: A().def(() => ({})),
    saveButtonProps: A().def(() => ({})),
    api: P(),
    delApi: P(),
    saveApi: P(),
    params: A().def({}),
    resultField: E().def("list"),
    fieldNames: A().def({ id: "id", text: "label", event: "value" })
  },
  setup(props2) {
    const { setFieldsValue, formModel, defaultValueRef, resetAction, submitAction, t: t2 } = useFormContextProvider();
    const selectedKeys = ref([]);
    const selectedText = ref("");
    const getSolutionSwitchBtnBinds = computed(() => {
      return Object.assign({ text: "\u8BF7\u9009\u62E9\u67E5\u8BE2\u65B9\u6848" }, props2.switchButtonProps);
    });
    const getSolutionSaveBtnBinds = computed(() => {
      return Object.assign({ text: "\u4FDD\u5B58\u4E3A\u67E5\u8BE2\u65B9\u6848" }, props2.saveButtonProps);
    });
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const popconfirmVisibleSet = ref({});
    const { createMessage } = useMessage();
    const handleError = (error) => {
      createMessage.error(error);
    };
    const handleSuccess = (message) => {
      createMessage.success(t2(message));
    };
    const { solutionListComputed, fetchSolution, deleteSolution, saveSolution, parseSolution } = useSearchSolution(props2);
    function handleMenuEvent(item) {
      selectedKeys.value.splice(0, 1, item.event);
      selectedText.value = item.text;
      const parsedSolution = parseSolution(item);
      Object.keys(toRaw(formModel)).forEach((key2) => {
        if (Reflect.has(parsedSolution, key2) === false) {
          parsedSolution[key2] = defaultValueRef.value[key2] || void 0;
        }
      });
      parsedSolution && setFieldsValue(parsedSolution);
      submitAction();
    }
    function clearSelectedKeys() {
      selectedKeys.value.splice(0, 1);
      selectedText.value = "";
    }
    listenerReset(clearSelectedKeys);
    function handleSolutionClear() {
      resetAction();
    }
    function handleSolutionSave() {
      showSaveDialog();
    }
    function showSaveDialog() {
      dialogVisible.value = true;
    }
    function hideSaveDialog() {
      dialogVisible.value = false;
    }
    async function handleOk(solutionName) {
      const eventData = cloneDeep(toRaw(formModel));
      convertUndefinedToString(eventData);
      try {
        confirmLoading.value = true;
        await promiseTimeout([
          saveSolution({
            text: solutionName,
            event: JSON.stringify(eventData)
          })
        ]);
        handleSuccess("\u67E5\u8BE2\u65B9\u6848\u4FDD\u5B58\u6210\u529F\uFF01");
        hideSaveDialog();
      } catch (err) {
        console.log("Save search solution error: " + err.message);
        handleError(err.message || "\u67E5\u8BE2\u65B9\u6848\u4FDD\u5B58\u5931\u8D25\uFF01");
      } finally {
        confirmLoading.value = false;
      }
    }
    async function handleSolutionDelete(id, name2) {
      try {
        await promiseTimeout([deleteSolution(id)]);
        handleSuccess("\u67E5\u8BE2\u65B9\u6848\u5220\u9664\u6210\u529F\uFF01");
        fetchSolution();
        hideSaveDialog();
        if (name2 == selectedText.value) {
          handleSolutionClear();
        }
      } catch (err) {
        console.log("Delete search solution error: " + err.message);
        handleError(err.message || "\u67E5\u8BE2\u65B9\u6848\u5220\u9664\u5931\u8D25\uFF01");
      }
    }
    function handleVisibleChange(visible, id) {
      popconfirmVisibleSet.value[id] = visible;
    }
    onMounted(() => {
      fetchSolution();
    });
    return {
      solutionListComputed,
      selectedKeys,
      handleMenuEvent,
      selectedText,
      getSolutionSwitchBtnBinds,
      getSolutionSaveBtnBinds,
      dialogVisible,
      handleSolutionSave,
      handleSolutionClear,
      handleOk,
      handleSolutionDelete,
      handleVisibleChange,
      popconfirmVisibleSet,
      confirmLoading,
      t: t2
    };
  }
});
const _hoisted_1$k = { class: "search-solution-wrapper" };
const _hoisted_2$7 = { class: "solution-item" };
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseCircleOutlined = resolveComponent("CloseCircleOutlined");
  const _component_DownOutlined = resolveComponent("DownOutlined");
  const _component_fbu_button = resolveComponent("fbu-button");
  const _component_IconDelete = resolveComponent("IconDelete");
  const _component_Popconfirm = resolveComponent("Popconfirm");
  const _component_fbu_dropdown = resolveComponent("fbu-dropdown");
  const _component_SolutionSaveDialog = resolveComponent("SolutionSaveDialog");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$k, [
      createVNode(_component_fbu_dropdown, {
        dropMenuList: _ctx.solutionListComputed,
        selectedKeys: _ctx.selectedKeys,
        onMenuEvent: _ctx.handleMenuEvent
      }, {
        menuItem: withCtx(({ text, id }) => [
          createElementVNode("div", _hoisted_2$7, [
            createElementVNode("span", null, toDisplayString(text), 1),
            createVNode(_component_Popconfirm, {
              title: _ctx.t(`\u786E\u8BA4\u5220\u9664\u3010{text}\u3011\u5417\uFF1F`, { text }),
              overlayStyle: { width: "300px" },
              cancelButtonProps: { class: ["is-secondary"], type: "primary", size: "middle" },
              cancelType: "primary",
              okButtonProps: { danger: true, size: "middle" },
              okType: "primary",
              okText: _ctx.t("\u5220\u9664"),
              onConfirm: ($event) => _ctx.handleSolutionDelete(id, text),
              onVisibleChange: (visible) => {
                _ctx.handleVisibleChange(visible, id);
              }
            }, {
              default: withCtx(() => [
                createElementVNode("span", {
                  class: normalizeClass(["icon-delete", _ctx.popconfirmVisibleSet[id] && "is-visible"]),
                  onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                  }, ["stop"]))
                }, [
                  createVNode(_component_IconDelete)
                ], 2)
              ]),
              _: 2
            }, 1032, ["title", "okText", "onConfirm", "onVisibleChange"])
          ])
        ]),
        default: withCtx(() => [
          createVNode(_component_fbu_button, mergeProps({
            class: "btn-search-solution",
            color: "secondary",
            style: { "width": "152px", "text-align": "left" }
          }, _ctx.getSolutionSwitchBtnBinds), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.selectedText || _ctx.getSolutionSwitchBtnBinds.text) + " ", 1),
              _ctx.selectedKeys.length ? (openBlock(), createBlock(_component_CloseCircleOutlined, {
                key: 0,
                onClick: withModifiers(_ctx.handleSolutionClear, ["stop"])
              }, null, 8, ["onClick"])) : createCommentVNode("", true),
              createVNode(_component_DownOutlined)
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }, 8, ["dropMenuList", "selectedKeys", "onMenuEvent"]),
      createVNode(_component_fbu_button, mergeProps({
        color: "secondary",
        style: { "margin-left": "10px" }
      }, _ctx.getSolutionSaveBtnBinds, { onClick: _ctx.handleSolutionSave }), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.getSolutionSaveBtnBinds.text), 1)
        ]),
        _: 1
      }, 16, ["onClick"])
    ]),
    createVNode(_component_SolutionSaveDialog, {
      visible: _ctx.dialogVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event) => _ctx.dialogVisible = $event),
      confirmLoading: _ctx.confirmLoading,
      onOk: _ctx.handleOk
    }, null, 8, ["visible", "confirmLoading", "onOk"])
  ], 64);
}
var FormActionsSearchSolution = /* @__PURE__ */ _export_sfc$1(_sfc_main$q, [["render", _sfc_render$k]]);
var FormActions_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$p = defineComponent({
  name: "FormActions",
  inheritAttrs: false,
  components: {
    Col,
    FormItem,
    FbuButton: Button,
    LoadingOutlined: LoadingOutlined$1,
    FormActionsSearchSolution,
    IconSearch,
    IconReset,
    DownOutlined: DownOutlined$1,
    UpOutlined: UpOutlined$1
  },
  props: {
    showActionButtonGroup: x().def(true),
    showResetButton: x().def(true),
    showSubmitButton: x().def(true),
    resetButtonOptions: A().def(() => ({})),
    submitButtonOptions: A().def(() => ({})),
    actionColOptions: A().def(() => ({})),
    actionSpan: N().def(15),
    loading: x().def(false),
    showSearchSolution: x().def(false),
    searchSolutionProps: A().def(() => ({})),
    showAdvanced: x().def(false),
    isAdvanced: x().def(false),
    count: N().def(60),
    control: L([Number, String, Object, Array, Boolean]).def(true),
    enableCount: x().def(false)
  },
  emits: ["toggle-advanced", "countdown-change"],
  setup(props2, { emit, expose }) {
    const contextInjections = useFormContextProvider();
    const { countRef, isStarted, start: start2, reset } = useCountdown(props2.count);
    expose({
      start: () => {
        if (props2.enableCount) {
          start2();
        }
      }
    });
    watchEffect(() => {
      if (props2.control === false || props2.control === void 0) {
        reset();
      }
    });
    watch(isStarted, (val) => {
      emit("countdown-change", val, countRef.value);
    });
    const getActionColBinds = computed(() => {
      const { actionColOptions, actionSpan } = props2;
      const actionColProps = __spreadValues({
        style: { textAlign: "left" },
        span: actionSpan
      }, actionColOptions);
      return actionColProps;
    });
    const getResetBtnBinds = computed(() => {
      return Object.assign({ text: "\u91CD\u7F6E" }, props2.resetButtonOptions);
    });
    const getSubmitBtnBinds = computed(() => {
      return Object.assign({ text: "\u67E5\u8BE2" }, props2.submitButtonOptions);
    });
    const toggleAdvanced = () => {
      emit("toggle-advanced");
    };
    const handleSubmitClick = () => {
      var _a2;
      (_a2 = contextInjections.submitAction) == null ? void 0 : _a2.call(contextInjections);
    };
    return __spreadProps(__spreadValues({
      getActionColBinds,
      getResetBtnBinds,
      getSubmitBtnBinds
    }, contextInjections), {
      searchIcon,
      resetIcon,
      toggleAdvanced,
      isStarted,
      countRef,
      handleSubmitClick,
      contextInjections
    });
  }
});
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingOutlined = resolveComponent("LoadingOutlined");
  const _component_IconSearch = resolveComponent("IconSearch");
  const _component_fbu_button = resolveComponent("fbu-button");
  const _component_FormActionsSearchSolution = resolveComponent("FormActionsSearchSolution");
  const _component_IconReset = resolveComponent("IconReset");
  const _component_UpOutlined = resolveComponent("UpOutlined");
  const _component_DownOutlined = resolveComponent("DownOutlined");
  const _component_FormItem = resolveComponent("FormItem");
  const _component_Col = resolveComponent("Col");
  return _ctx.showActionButtonGroup ? (openBlock(), createBlock(_component_Col, normalizeProps(mergeProps({ key: 0 }, _ctx.getActionColBinds)), {
    default: withCtx(() => {
      var _a2, _b;
      return [
        createElementVNode("div", {
          style: normalizeStyle([{ "width": "100%" }, { textAlign: (_b = (_a2 = _ctx.getActionColBinds) == null ? void 0 : _a2.style) == null ? void 0 : _b.textAlign }])
        }, [
          createVNode(_component_FormItem, { style: { "margin-bottom": "0", "margin-top": "4px" } }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "submitBefore", {}, void 0, true),
              _ctx.showSubmitButton ? (openBlock(), createBlock(_component_fbu_button, mergeProps({
                key: 0,
                type: "primary",
                class: "mr-10",
                disabled: _ctx.enableCount && _ctx.isStarted
              }, _ctx.getSubmitBtnBinds, { onClick: _ctx.submitAction }), {
                icon: withCtx(() => [
                  _ctx.loading ? (openBlock(), createBlock(_component_LoadingOutlined, {
                    key: 0,
                    spin: ""
                  })) : (openBlock(), createBlock(_component_IconSearch, { key: 1 }))
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(_ctx.getSubmitBtnBinds.text) + toDisplayString(_ctx.enableCount && _ctx.isStarted ? `(${_ctx.countRef}S)` : ""), 1)
                ]),
                _: 1
              }, 16, ["disabled", "onClick"])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "resetBefore", normalizeProps(guardReactiveProps(_ctx.contextInjections)), void 0, true),
              _ctx.showSearchSolution ? (openBlock(), createBlock(_component_FormActionsSearchSolution, normalizeProps(mergeProps({ key: 1 }, _ctx.searchSolutionProps)), null, 16)) : createCommentVNode("", true),
              _ctx.showResetButton ? (openBlock(), createBlock(_component_fbu_button, mergeProps({
                key: 2,
                type: "primary",
                ghost: "",
                class: "mr-10",
                disabled: _ctx.enableCount && _ctx.isStarted
              }, _ctx.getResetBtnBinds, { onClick: _ctx.resetAction }), {
                icon: withCtx(() => [
                  createVNode(_component_IconReset)
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(_ctx.getResetBtnBinds.text), 1)
                ]),
                _: 1
              }, 16, ["disabled", "onClick"])) : createCommentVNode("", true),
              _ctx.showAdvanced ? (openBlock(), createBlock(_component_fbu_button, {
                key: 3,
                class: "advance-button",
                type: "link",
                onClick: _ctx.toggleAdvanced
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(!_ctx.isAdvanced ? _ctx.t("\u5C55\u5F00\u9AD8\u7EA7\u67E5\u8BE2") : _ctx.t("\u6536\u8D77\u9AD8\u7EA7\u67E5\u8BE2")) + " ", 1),
                  _ctx.isAdvanced ? (openBlock(), createBlock(_component_UpOutlined, { key: 0 })) : (openBlock(), createBlock(_component_DownOutlined, { key: 1 }))
                ]),
                _: 1
              }, 8, ["onClick"])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "advancedAfter", {}, void 0, true)
            ]),
            _: 3
          })
        ], 4)
      ];
    }),
    _: 3
  }, 16)) : createCommentVNode("", true);
}
var FormActions = /* @__PURE__ */ _export_sfc$1(_sfc_main$p, [["render", _sfc_render$j], ["__scopeId", "data-v-16cfb5ea"]]);
var SettingIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$o = defineComponent({
  setup() {
    return {};
  }
});
const _withScopeId$1 = (n2) => (pushScopeId("data-v-429e668e"), n2 = n2(), popScopeId(), n2);
const _hoisted_1$j = { class: "column-setting-icon" };
const _hoisted_2$6 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M10.0002 7C10.0002 8.65685 8.65702 10 7.00017 10C5.34331 10 4.00017 8.65685 4.00017 7C4.00017 5.34315 5.34331 4 7.00017 4C8.65702 4 10.0002 5.34315 10.0002 7ZM9.00017 7C9.00017 5.89543 8.10474 5 7.00017 5C5.8956 5 5.00017 5.89543 5.00017 7C5.00017 8.10457 5.8956 9 7.00017 9C8.10474 9 9.00017 8.10457 9.00017 7Z" }),
  /* @__PURE__ */ createElementVNode("path", { d: "M7.00017 0.25L13.0623 3.625V10.375L7.00017 13.75L0.937988 10.375V3.625L7.00017 0.25ZM1.93799 4.2128V9.7872L7.00017 12.6055L12.0623 9.7872V4.2128L7.00017 1.39453L1.93799 4.2128Z" })
], -1));
const _hoisted_3$5 = [
  _hoisted_2$6
];
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1$j, _hoisted_3$5);
}
var SettingIcon = /* @__PURE__ */ _export_sfc$1(_sfc_main$o, [["render", _sfc_render$i], ["__scopeId", "data-v-429e668e"]]);
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source), true).forEach(function(key2) {
        _defineProperty(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key2 = sourceKeys[i2];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key2, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key2 = sourceSymbolKeys[i2];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var version = "1.14.0";
function userAgent(pattern4) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern4);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector) {
  if (!selector)
    return;
  selector[0] === ">" && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_2) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx)
        break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name2, state) {
  if (el && name2) {
    if (el.classList) {
      el.classList[state ? "add" : "remove"](name2);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name2 + " ", " ");
      el.className = (className + (state ? " " + name2 : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop, val) {
  var style2 = el && el.style;
  if (style2) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style2) && prop.indexOf("webkit") === -1) {
        prop = "-webkit-" + prop;
      }
      style2[prop] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i2 = 0, n2 = list.length;
    if (iterator) {
      for (; i2 < n2; i2++) {
        iterator(list[i2], i2);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window)
    return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top -= containerRect.top + parseInt(css(container, "border-top-width"));
          left -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top,
    left,
    bottom,
    right,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent2 = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent2) {
    var parentSideVal = getRect(parent2)[parentSide], visible = void 0;
    if (parentSide === "top" || parentSide === "left") {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible)
      return parent2;
    if (parent2 === getWindowScrollingElement())
      break;
    parent2 = getParentAutoScrollElement(parent2, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i2 = 0, children = el.children;
  while (i2 < children.length) {
    if (children[i2].style.display !== "none" && children[i2] !== Sortable.ghost && (includeDragEl || children[i2] !== Sortable.dragged) && closest(children[i2], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i2];
      }
      currentChild++;
    }
    i2++;
  }
  return null;
}
function lastChild(el, selector) {
  var last2 = el.lastElementChild;
  while (last2 && (last2 === Sortable.ghost || css(last2, "display") === "none" || selector && !matches(last2, selector))) {
    last2 = last2.previousElementSibling;
  }
  return last2 || null;
}
function index$2(el, selector) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i2 in arr) {
    if (!arr.hasOwnProperty(i2))
      continue;
    for (var key2 in obj) {
      if (obj.hasOwnProperty(key2) && obj[key2] === arr[i2][key2])
        return Number(i2);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect)
    return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body)
          return getWindowScrollingElement();
        if (gotSelf || includeSelf)
          return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key2 in src) {
      if (src.hasOwnProperty(key2)) {
        dst[key2] = src[key2];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x2, y2) {
  el.scrollLeft += x2;
  el.scrollTop += y2;
}
function clone2(el) {
  var Polymer = window.Polymer;
  var $2 = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($2) {
    return $2(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
var expando = "Sortable" + new Date().getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation)
        return;
      var children = [].slice.call(this.el.children);
      children.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost)
          return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function")
          callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state) {
        var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function")
          callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function")
            callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    for (var option2 in defaults) {
      if (defaults.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults[option2];
      }
    }
    plugins.forEach(function(p2) {
      if (p2.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault)
        return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2))
        continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name2, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function")
        return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name2));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name2, value) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name2] === "function") {
        modifiedValue = plugin.optionListeners[name2].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name2 = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable)
    return;
  var evt, options = sortable.options, onName = "on" + name2.charAt(0).toUpperCase() + name2.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name2, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name2, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name2, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded = ["evt"];
var pluginEvent2 = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data6 = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name2) {
      _dispatchEvent({
        sortable,
        name: name2,
        originalEvent
      });
    }
  }, data6));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists)
    return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x2, y2) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable))
      return;
    var rect = getRect(sortable), insideHorizontally = x2 >= rect.left - threshold && x2 <= rect.right + threshold, insideVertically = y2 >= rect.top - threshold && y2 <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i2 in evt) {
        if (evt.hasOwnProperty(i2)) {
          event[i2] = evt[i2];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: false,
    invertedSwapThreshold: null,
    removeCloneOnHide: true,
    direction: function direction2() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name2 in defaults2) {
    !(name2 in options) && (options[name2] = defaults2[name2]);
  }
  _prepareGroup(options);
  for (var fn in this) {
    if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
      this[fn] = this[fn].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on(el, "pointerdown", this._onTapStart);
  } else {
    on(el, "mousedown", this._onTapStart);
    on(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, "dragover", this);
    on(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = {
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable)
      return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type4 = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type4) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index$2(target);
    oldDraggableIndex = index$2(target, options.draggable);
    if (typeof filter === "function") {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent2("filter", _this, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter) {
      filter = filter.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent2("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent2("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mouseup", _this._onDrop);
      on(ownerDocument, "touchend", _this._onDrop);
      on(ownerDocument, "touchcancel", _this._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent2("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on(ownerDocument, "mouseup", _this._disableDelayedDrag);
        on(ownerDocument, "touchend", _this._disableDelayedDrag);
        on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e2) {
    var touch = e2.touches ? e2.touches[0] : e2;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on(document, "touchmove", this._onTouchMove);
      } else {
        on(document, "mousemove", this._onTouchMove);
      }
    } else {
      on(dragEl, "dragend", this);
      on(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent2("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent2 = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent2)
          break;
        parent2 = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent2) {
        do {
          if (parent2[expando]) {
            var inserted = void 0;
            inserted = parent2[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent2
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent2;
        } while (parent2 = parent2.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document)
            ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent2("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent2("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone2(dragEl);
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent2("clone", _this);
      if (Sortable.eventCanceled)
        return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this._onDrop);
      off(document, "touchend", _this._onDrop);
      off(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, "selectstart", _this);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
    if (_silent)
      return;
    function dragOverEvent(name2, extra) {
      pluginEvent2(name2, _this, _objectSpread2({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove3(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index$2(dragEl);
      newDraggableIndex = index$2(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled)
      return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled)
        return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction2 = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction2 = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction2 !== 0) {
          var dragIndex = index$2(dragEl);
          do {
            dragIndex -= direction2;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction2 === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction2;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction2 === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index$2(dragEl);
    newDraggableIndex = index$2(dragEl, options.draggable);
    pluginEvent2("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index$2(dragEl);
    newDraggableIndex = index$2(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent2("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  toArray: function toArray2() {
    var order = [], el, children = this.el.children, i2 = 0, n2 = children.length, options = this.options;
    for (; i2 < n2; i2++) {
      el = children[i2];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i2) {
      var el = rootEl2.children[i2];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  option: function option(name2, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name2];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name2, value);
      if (typeof modifiedValue !== "undefined") {
        options[name2] = modifiedValue;
      } else {
        options[name2] = value;
      }
      if (name2 === "group") {
        _prepareGroup(options);
      }
    }
  },
  destroy: function destroy3() {
    pluginEvent2("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent2("hideClone", this);
      if (Sortable.eventCanceled)
        return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent2("showClone", this);
      if (Sortable.eventCanceled)
        return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index$2(dragEl) < index$2(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i2 = str.length, sum2 = 0;
  while (i2--) {
    sum2 += str.charCodeAt(i2);
  }
  return sum2.toString(36);
}
function _saveInputCheckedState(root2) {
  savedInputChecked.length = 0;
  var inputs = root2.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on,
  off,
  css,
  find,
  is: function is2(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend,
  throttle,
  closest,
  toggleClass,
  clone: clone2,
  index: index$2,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array)
    plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils)
      Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y2 = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x2, y2);
      touchEvt$1 = evt;
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x2 !== lastAutoScrollX || y2 !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x2, y2), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x2;
          lastAutoScrollY = y2;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll)
    return;
  var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y2 = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right - x2) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x2) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y2) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y2) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i2 = 0; i2 <= layersOut; i2++) {
        if (!autoScrolls[i2]) {
          autoScrolls[i2] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval(function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent)
    return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
var SchemeSettingModal_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$i = { class: "checkbox-list-wrapper" };
const _hoisted_2$5 = { style: { "margin-block-end": "12px" } };
const _hoisted_3$4 = { class: "selected-schemes-wrapper" };
const _hoisted_4$1 = { style: { "color": "#2e3a59", "font-weight": "600" } };
const _hoisted_5$1 = ["data-field"];
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  emits: ["save"],
  setup(__props, { expose, emit }) {
    const { t: t2 } = useFormContextProvider();
    const innerVisible = ref(false);
    const allSchemesRef = ref([]);
    const schemesRef = ref([]);
    const visibleKeysRef = ref([]);
    const maybeVisibleSchemes = ref([]);
    const schemesListRef = ref();
    const optionsRef = computed(() => {
      return allSchemesRef.value.map(({ field, label, fixedVisible }) => ({
        label,
        value: field,
        disabled: fixedVisible
      }));
    });
    const state = reactive({
      indeterminate: true,
      checkAll: false
    });
    const onCheckAllChange = (e2) => {
      state.indeterminate = false;
      visibleKeysRef.value = e2.target.checked ? optionsRef.value.map((item) => item.value) : optionsRef.value.filter((item) => item.disabled).map((item) => item.value);
      maybeVisibleSchemes.value = e2.target.checked ? allSchemesRef.value.map(({ field, label }) => ({ field, label, visible: true })) : allSchemesRef.value.filter((item) => item.fixedVisible).map(({ field, label }) => ({ field, label, visible: true }));
    };
    const updateMaybeVisibleSchemes = (keys2) => {
      if (keys2.length === 0) {
        maybeVisibleSchemes.value = [];
      }
      maybeVisibleSchemes.value = maybeVisibleSchemes.value.filter((item) => keys2.includes(item.field));
      const maybeKeys = maybeVisibleSchemes.value.map((item) => item.field);
      const restKeys = keys2.filter((k2) => maybeKeys.includes(k2) === false);
      const allSchemes = allSchemesRef.value;
      restKeys.forEach((k2) => {
        maybeVisibleSchemes.value.push(allSchemes.find((item) => item.field === k2));
      });
    };
    watch(visibleKeysRef, (val) => {
      state.indeterminate = !!val.length && val.length < optionsRef.value.length;
      state.checkAll = val.length === optionsRef.value.length;
      updateMaybeVisibleSchemes(val);
    });
    const openModal = (schemes, visibleSchemes) => {
      allSchemesRef.value = schemes.slice(0);
      schemesRef.value = visibleSchemes;
      visibleKeysRef.value = visibleSchemes.map((item) => item.field);
      innerVisible.value = true;
      maybeVisibleSchemes.value = visibleSchemes.map(({ label, field }) => ({
        label,
        field,
        visible: true
      }));
      console.log(maybeVisibleSchemes.value);
    };
    const handleCancel = () => {
      innerVisible.value = false;
    };
    const handleDefaultSetting = () => {
      visibleKeysRef.value = allSchemesRef.value.map((item) => item.field);
      maybeVisibleSchemes.value = allSchemesRef.value.map(({ label, field }) => ({
        label,
        field,
        visible: true
      }));
      nextTick(() => {
        sortjsIns.sort(visibleKeysRef.value);
      });
    };
    const handleSave = () => {
      emit("save", maybeVisibleSchemes.value);
      handleCancel();
    };
    let isBinded = false;
    function draggableModal() {
      if (isBinded) {
        return;
      }
      isBinded = true;
      const modalNode = document.querySelector(".scheme-setting-modal");
      const modalWrapper = modalNode.parentElement;
      const modalHeaderNode = modalNode.querySelector(".ant-modal-header");
      const cursor = style(modalHeaderNode, "cursor");
      const contain = style(modalNode, "contain");
      const { left, top } = boundingRect(modalNode);
      css$1(modalNode, {
        position: "absolute",
        left: left + "px",
        top: top + "px"
      });
      modalHeaderNode.addEventListener("mousedown", onMouseDown2, false);
      function onMouseDown2() {
        css$1(modalNode, { contain: "layout" });
        css$1(modalHeaderNode, { cursor: "move", userSelect: "none" });
        document.addEventListener("mousemove", onMouseMove3, false);
        document.addEventListener("mouseup", onMouseUp2, false);
      }
      function onMouseMove3(e2) {
        const { width, height } = boundingRect(modalNode);
        const { movementX, movementY } = e2;
        const bodyClientWidth = modalWrapper.clientWidth;
        const bodyClientHeight = modalWrapper.clientHeight;
        const getStyle2 = getComputedStyle(modalNode);
        const curLeft = Number.parseInt(getStyle2.getPropertyValue("left"));
        const curTop = Number.parseInt(getStyle2.getPropertyValue("top"));
        const nextLeft = curLeft + movementX;
        const nextTop = curTop + movementY;
        const left2 = Math.max(0, Math.min(bodyClientWidth - width, nextLeft));
        const top2 = Math.max(0, Math.min(bodyClientHeight - height, nextTop));
        css$1(modalNode, {
          left: left2 + "px",
          top: top2 + "px"
        });
      }
      function onMouseUp2() {
        css$1(modalHeaderNode, { cursor });
        css$1(modalNode, { contain });
        document.removeEventListener("mousemove", onMouseMove3);
        document.removeEventListener("mouseup", onMouseUp2);
      }
    }
    var sortjsIns;
    let inited = false;
    function setupSortablejs() {
      if (inited)
        return;
      nextTick(() => {
        const el = unref(schemesListRef);
        if (!el)
          return;
        sortjsIns = Sortable.create(unref(el), {
          animation: 500,
          delay: 400,
          delayOnTouchOnly: true,
          handle: "li",
          draggable: "li",
          onEnd: (evt) => {
            const { oldIndex: oldIndex2, newIndex: newIndex2 } = evt;
            if (isUnDef(oldIndex2) || isUnDef(newIndex2) || oldIndex2 === newIndex2) {
              return;
            }
            const columns2 = maybeVisibleSchemes.value;
            if (oldIndex2 > newIndex2) {
              columns2.splice(newIndex2, 0, columns2[oldIndex2]);
              columns2.splice(oldIndex2 + 1, 1);
            } else {
              columns2.splice(newIndex2 + 1, 0, columns2[oldIndex2]);
              columns2.splice(oldIndex2, 1);
            }
          }
        });
        inited = true;
      });
    }
    watch(innerVisible, (visible) => {
      if (visible) {
        nextTick(() => {
          draggableModal();
          setupSortablejs();
        });
      }
    });
    expose({
      openModal
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Modal$1), {
        class: "scheme-setting-modal not-draggble-modal",
        visible: innerVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event) => innerVisible.value = $event),
        title: unref(t2)("\u67E5\u8BE2\u6761\u4EF6\u8BBE\u7F6E"),
        width: 780,
        "mask-closable": false,
        "body-style": { maxHeight: "560px", overflowY: "auto" },
        centered: "",
        onCancel: handleCancel
      }, {
        footer: withCtx(() => [
          renderSlot(_ctx.$slots, "footer", {}, () => [
            createVNode(unref(Button), {
              type: "primary",
              ghost: "",
              onClick: handleCancel
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("\u53D6\u6D88")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(Button), {
              type: "primary",
              onClick: handleDefaultSetting
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("\u6062\u590D\u9ED8\u8BA4\u8BBE\u7F6E")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(Button), {
              type: "primary",
              onClick: handleSave
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("\u4FDD\u5B58")), 1)
              ]),
              _: 1
            })
          ], true)
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$i, [
            createElementVNode("div", _hoisted_2$5, [
              createVNode(unref(Checkbox), {
                checked: unref(state).checkAll,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event) => unref(state).checkAll = $event),
                indeterminate: unref(state).indeterminate,
                onChange: onCheckAllChange
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("\u5168\u9009")), 1)
                ]),
                _: 1
              }, 8, ["checked", "indeterminate"])
            ]),
            createVNode(unref(CheckboxGroup), {
              value: visibleKeysRef.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event) => visibleKeysRef.value = $event),
              options: unref(optionsRef)
            }, null, 8, ["value", "options"])
          ]),
          createElementVNode("div", _hoisted_3$4, [
            createElementVNode("div", _hoisted_4$1, toDisplayString(unref(t2)("\u5DF2\u9009\u67E5\u8BE2\u6761\u4EF6\uFF08\u957F\u6309\u62D6\u52A8\u53EF\u8C03\u6574\u4F4D\u7F6E\uFF09")), 1),
            createElementVNode("ul", {
              ref_key: "schemesListRef",
              ref: schemesListRef,
              style: { "margin-block-start": "8px" }
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(maybeVisibleSchemes.value, (scheme) => {
                return openBlock(), createElementBlock("li", {
                  key: scheme.field,
                  "data-field": scheme.field
                }, toDisplayString(scheme.label), 9, _hoisted_5$1);
              }), 128))
            ], 512)
          ])
        ]),
        _: 3
      }, 8, ["visible", "title"]);
    };
  }
});
var SchemeSettingModal = /* @__PURE__ */ _export_sfc$1(_sfc_main$n, [["__scopeId", "data-v-d67a2f22"]]);
const _sfc_main$m = defineComponent({
  name: "FbuForm",
  components: {
    Form: Form$1,
    Row: Row$2,
    FormItem: _sfc_main$t,
    FormActions,
    Col,
    Button: Button$2,
    SettingIcon,
    SchemeSettingModal
  },
  props: __spreadValues({}, useProps$2),
  inheritAttrs: false,
  setup(props2, { attrs, slots, emit }) {
    var _a2;
    const prefixCls2 = usePrefixCls("form");
    const formElRef = ref(null);
    const formModel = reactive({});
    const defaultValueRef = ref({});
    const settingPropsRef = ref({});
    const initializedDefaultRef = ref(false);
    const getProps = computed(() => {
      return Object.assign({}, props2, unref(settingPropsRef));
    });
    const getBindValue = computed(() => {
      return __spreadValues(__spreadValues(__spreadValues({}, attrs), props2), unref(getProps));
    });
    const getRowProps = computed(() => {
      const {
        baseRowStyle = {},
        rowProps: rowProps3 = {
          type: "flex",
          gutter: [{ md: 8, lg: 16, xl: 60 }, {}]
        }
      } = unref(getProps);
      return __spreadValues({
        style: baseRowStyle
      }, rowProps3);
    });
    const {
      isAdvanced,
      handleToggleAdvanced,
      sortAdvancedSchemes,
      updateAdvanced,
      toggleAdvanced
    } = useAdvanced(getProps);
    const showAdvancedRef = ref(getProps.value.showAdvanced === true || ((_a2 = getProps.value.schemes || []) == null ? void 0 : _a2.length) > 12);
    const formActionsRef = ref();
    const getFormActionsProps = computed(() => {
      return __spreadProps(__spreadValues({}, getProps.value), {
        isAdvanced: isAdvanced.value,
        showAdvanced: getProps.value.showAdvancedButton && showAdvancedRef.value
      });
    });
    const {
      computedEnableFieldSetting,
      schemeSettingModalRef,
      openSchemeSettingModal,
      getTrueVisibleSchemes,
      setVisibleSchemes,
      initVisibleSchemes
    } = useFieldSettings({ getProps, formModel });
    const schemesRef = ref(unref(getProps).schemes || []);
    const getSchemes = computed(() => {
      const schemes = sortAdvancedSchemes(unref(schemesRef));
      updateAdvanced(schemes);
      for (const scheme of schemes) {
        const { defaultValue, component } = scheme;
        if (defaultValue && dateItemType.includes(component)) {
          if (!Array.isArray(defaultValue)) {
            scheme.defaultValue = dateAdapter(defaultValue);
          } else {
            const def = [];
            defaultValue.forEach((item) => {
              def.push(dateAdapter(item));
            });
            scheme.defaultValue = def;
          }
        }
      }
      if (computedEnableFieldSetting.value) {
        const trueVisibleSchemes = getTrueVisibleSchemes(schemes);
        updateAdvanced(trueVisibleSchemes);
        return trueVisibleSchemes;
      }
      return schemes;
    });
    const getSlots = Object.keys(slots).filter((slot) => slot !== "formHeader" && slot !== "formFooter");
    const t2 = (key2, ...args) => {
      if (!key2) {
        return "";
      }
      const tFn = unref(getProps).t;
      if (typeof tFn === "function") {
        return tFn(key2, ...args);
      } else {
        return key2;
      }
    };
    const { initDefaultModel, handleFormValues } = useFormValues({
      defaultValueRef,
      getSchemes,
      getProps,
      formModel
    });
    useAutoFocus({ getSchemes, getProps, formElRef, isInitedDefault: initializedDefaultRef });
    const {
      handleSubmit,
      clearValidate: clearValidate2,
      validate,
      validateFields,
      getFieldsValue,
      updateScheme,
      resetScheme,
      appendSchemeByField,
      removeSchemeByFiled,
      resetFields,
      setFieldsValue,
      scrollToField
    } = useFormEvents({
      emit,
      getProps,
      getSchemes,
      formModel,
      formElRef,
      schemesRef,
      handleFormValues,
      defaultValueRef
    });
    const handleCountDown = (isStarted, count) => {
      emit("countdown-change", isStarted, count);
    };
    createFormContextProvider({
      resetAction: resetFields,
      submitAction: handleSubmit,
      getFieldsValue,
      setFieldsValue,
      formModel,
      defaultValueRef,
      t: t2
    });
    watch(() => unref(getProps).model, () => {
      const { model } = unref(getProps);
      if (!model)
        return;
      setFieldsValue(model);
    }, {
      immediate: true
    });
    watch(() => unref(getProps).schemes, (schemes) => {
      initVisibleSchemes();
      resetScheme(schemes || []);
    });
    watch(() => getSchemes.value, (scheme) => {
      if (Array.isArray(scheme)) {
        showAdvancedRef.value = scheme.length > 12;
      }
      if (!unref(initializedDefaultRef) && (scheme == null ? void 0 : scheme.length)) {
        initDefaultModel();
        initializedDefaultRef.value = true;
      }
    });
    async function setProps(formProps3) {
      settingPropsRef.value = merge2(unref(settingPropsRef) || {}, formProps3);
    }
    function setFormModel(key2, value) {
      formModel[key2] = value;
      const { validateTrigger } = unref(getBindValue);
      if (!validateTrigger || validateTrigger === "change") {
        validateFields([key2]).catch(() => {
        });
      }
    }
    const formActions = {
      clearValidate: clearValidate2,
      validate,
      validateFields,
      getFieldsValue,
      updateScheme,
      resetScheme,
      appendSchemeByField,
      removeSchemeByFiled,
      resetFields,
      setFieldsValue,
      scrollToField,
      setProps,
      submit: handleSubmit,
      toggleAdvanced,
      startCountDown: () => {
        var _a3;
        (_a3 = formActionsRef.value) == null ? void 0 : _a3.start();
      }
    };
    function handleKeyPressEnter(e2) {
      const { autoSubmitOnEnter } = props2;
      if (!autoSubmitOnEnter) {
        return;
      }
      const target = e2.target;
      const tagName = target && target.tagName.toLowerCase();
      if (e2.key === "Enter" && tagName && tagName === "input") {
        handleSubmit();
      }
    }
    function handleSaveSchemes(newSchemes) {
      const keys2 = [];
      newSchemes.forEach((item) => {
        var _a3;
        keys2.push(item.field);
        const orginScheme = (_a3 = schemesRef.value) == null ? void 0 : _a3.find((s2) => s2.field === item.field);
        if (orginScheme && orginScheme.defaultValue !== void 0 && defaultValueRef.value[item.field] === void 0) {
          defaultValueRef.value[item.field] = cloneDeep(orginScheme.defaultValue);
          formModel[item.field] = cloneDeep(orginScheme.defaultValue);
        }
      });
      const hideSchems = getSchemes.value.filter((item) => keys2.includes(item.field) === false);
      if (hideSchems.length) {
        hideSchems.forEach((scheme) => {
          formModel[scheme.field] = cloneDeep(defaultValueRef.value[scheme.field]);
        });
      }
      setVisibleSchemes(newSchemes);
      emit("update-schemes", newSchemes);
    }
    initDefaultModel();
    onMounted(() => {
      emit("register", formActions);
    });
    return __spreadProps(__spreadValues({
      prefixCls: prefixCls2,
      formElRef,
      formModel,
      getBindValue,
      getProps,
      handleKeyPressEnter,
      getRowProps,
      getSchemes,
      getSlots,
      setFormModel,
      formActions,
      defaultValueRef
    }, formActions), {
      getFormActionsProps,
      handleToggleAdvanced,
      isAdvanced,
      t: t2,
      schemeSettingModalRef,
      openSchemeSettingModal,
      setVisibleSchemes,
      handleSaveSchemes,
      showAdvancedRef,
      emit,
      handleCountDown,
      formActionsRef
    });
  }
});
const _hoisted_1$h = {
  class: "form-actions-extra",
  style: { "display": "flex" }
};
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FormItem = resolveComponent("FormItem");
  const _component_Row = resolveComponent("Row");
  const _component_FormActions = resolveComponent("FormActions");
  const _component_SettingIcon = resolveComponent("SettingIcon");
  const _component_Button = resolveComponent("Button");
  const _component_Col = resolveComponent("Col");
  const _component_SchemeSettingModal = resolveComponent("SchemeSettingModal");
  const _component_Form = resolveComponent("Form");
  return openBlock(), createBlock(_component_Form, mergeProps({ ref: "formElRef" }, _ctx.getBindValue, {
    class: [_ctx.prefixCls, _ctx.simple && `${_ctx.prefixCls}--simple`],
    model: _ctx.formModel,
    onKeypress: withKeys(_ctx.handleKeyPressEnter, ["enter"])
  }), {
    default: withCtx(() => [
      createVNode(_component_Row, normalizeProps(guardReactiveProps(_ctx.getRowProps)), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "formHeader"),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.getSchemes, (scheme) => {
            return openBlock(), createBlock(_component_FormItem, {
              key: scheme.field,
              scheme,
              formProps: _ctx.getProps,
              formModel: _ctx.formModel,
              setFormModel: _ctx.setFormModel,
              tableAction: _ctx.tableAction,
              formActions: _ctx.formActions,
              defaultValues: _ctx.defaultValueRef,
              isAdvanced: _ctx.isAdvanced,
              "is-show-advanced": _ctx.showAdvancedRef
            }, createSlots({ _: 2 }, [
              renderList(_ctx.getSlots, (slot) => {
                return {
                  name: slot,
                  fn: withCtx((data6) => [
                    renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(data6 || {})))
                  ])
                };
              })
            ]), 1032, ["scheme", "formProps", "formModel", "setFormModel", "tableAction", "formActions", "defaultValues", "isAdvanced", "is-show-advanced"]);
          }), 128)),
          renderSlot(_ctx.$slots, "formFooter")
        ]),
        _: 3
      }, 16),
      createVNode(_component_Row, mergeProps(_ctx.getRowProps, { justify: "space-between" }), {
        default: withCtx(() => [
          createVNode(_component_FormActions, mergeProps({ ref: "formActionsRef" }, _ctx.getFormActionsProps, {
            onToggleAdvanced: _ctx.handleToggleAdvanced,
            onCountdownChange: _ctx.handleCountDown
          }), createSlots({ _: 2 }, [
            renderList(["resetBefore", "submitBefore", "advancedAfter"], (item) => {
              return {
                name: item,
                fn: withCtx((data6) => [
                  renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})))
                ])
              };
            })
          ]), 1040, ["onToggleAdvanced", "onCountdownChange"]),
          createVNode(_component_Col, null, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$h, [
                renderSlot(_ctx.$slots, "afterActions"),
                _ctx.showFieldSettings ? (openBlock(), createBlock(_component_Button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  style: { "display": "flex", "align-items": "center", "column-gap": "4px", "padding": "0 8px" },
                  onClick: _ctx.openSchemeSettingModal
                }, {
                  icon: withCtx(() => [
                    createVNode(_component_SettingIcon)
                  ]),
                  default: withCtx(() => [
                    createTextVNode(" " + toDisplayString(_ctx.t("\u67E5\u8BE2\u6761\u4EF6\u8BBE\u7F6E")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])) : createCommentVNode("", true)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 16),
      createVNode(_component_SchemeSettingModal, {
        ref: "schemeSettingModalRef",
        onSave: _ctx.handleSaveSchemes
      }, null, 8, ["onSave"])
    ]),
    _: 3
  }, 16, ["class", "model", "onKeypress"]);
}
var FbuForm$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$m, [["render", _sfc_render$h]]);
function useComponentRegister$1(compName, comp) {
  add$1(compName, comp);
  onUnmounted(() => {
    if (getCurrentInstance()) {
      del$1(compName);
    }
  });
}
function getDynamicProps(props2) {
  const ret = {};
  Object.keys(props2).map((key2) => {
    ret[key2] = unref(props2[key2]);
  });
  return ret;
}
function useForm(props2) {
  const formRef = ref(null);
  const loadedRef = ref(false);
  async function getForm() {
    const form = unref(formRef);
    if (!form) {
      console.error("\u8868\u5355\u5B9E\u4F8B\u5FC5\u987B\u5148\u7ED1\u5B9A\uFF0C\u518D\u4F7F\u7528!");
    }
    await nextTick();
    return form;
  }
  function register3(instance2) {
    onUnmounted(() => {
      formRef.value = null;
      loadedRef.value = null;
    });
    if (unref(loadedRef) && instance2 === unref(formRef))
      return;
    formRef.value = instance2;
    loadedRef.value = true;
    watch(() => props2, () => {
      props2 && instance2.setProps(getDynamicProps(props2));
    }, {
      immediate: true,
      deep: true
    });
  }
  const methods = {
    scrollToField: async (name2, options) => {
      const form = await getForm();
      form.scrollToField(name2, options);
    },
    setProps: async (formProps3) => {
      const form = await getForm();
      form.setProps(formProps3);
    },
    updateScheme: async (data6) => {
      const form = await getForm();
      form.updateScheme(data6);
    },
    resetScheme: async (data6) => {
      const form = await getForm();
      form.resetScheme(data6);
    },
    clearValidate: async (name2) => {
      const form = await getForm();
      form.clearValidate(name2);
    },
    resetFields: async () => {
      getForm().then(async (form) => {
        await form.resetFields();
      });
    },
    removeSchemeByFiled: async (field) => {
      var _a2;
      (_a2 = unref(formRef)) == null ? void 0 : _a2.removeSchemeByFiled(field);
    },
    getFieldsValue: () => {
      var _a2;
      return (_a2 = unref(formRef)) == null ? void 0 : _a2.getFieldsValue();
    },
    setFieldsValue: async (values) => {
      const form = await getForm();
      form.setFieldsValue(values);
    },
    appendSchemeByField: async (scheme, prefixField, first) => {
      const form = await getForm();
      form.appendSchemeByField(scheme, prefixField, first);
    },
    submit: async () => {
      const form = await getForm();
      return form.submit();
    },
    validate: async (nameList) => {
      const form = await getForm();
      return form.validate(nameList);
    },
    validateFields: async (nameList) => {
      const form = await getForm();
      return form.validateFields(nameList);
    },
    async toggleAdvanced() {
      const form = await getForm();
      return form.toggleAdvanced();
    },
    startCountDown: async () => {
      const form = await getForm();
      form == null ? void 0 : form.startCountDown();
    }
  };
  return [register3, methods];
}
var FbuForm = withInstall$1(FbuForm$1);
const tableCacheKeyPrefix$1 = "TABLE_CACHE_";
function useTableCache$1(propsRef) {
  const cacheKey = computed(() => {
    const name2 = unref(propsRef).cacheName;
    return name2 ? tableCacheKeyPrefix$1 + name2 : "";
  });
  const cacheEnable = computed(() => unref(propsRef).cacheEnable);
  const getPageSizeCacheKey = computed(() => {
    const key2 = unref(cacheKey);
    return key2 ? key2 + "_PAGE_SIZE" : "";
  });
  const getTableInnerColumnsCacheKey = computed(() => {
    const key2 = unref(cacheKey);
    return key2 ? key2 + "_INNER_COLUMNS" : "";
  });
  function getCachedColumns() {
    if (unref(cacheEnable)) {
      return storageProxy.get(unref(cacheKey));
    }
    return null;
  }
  function setCachedColumns(columns2) {
    const key2 = unref(cacheKey);
    if (unref(cacheEnable) && key2) {
      return storageProxy.set(key2, columns2);
    }
  }
  function getCachedTableInnerColumns() {
    if (unref(cacheEnable)) {
      return storageProxy.get(unref(getTableInnerColumnsCacheKey));
    }
    return null;
  }
  function setCachedTableInnerColumns(innerColumnsMap) {
    const key2 = unref(getTableInnerColumnsCacheKey);
    if (unref(cacheEnable) && key2) {
      return storageProxy.set(key2, innerColumnsMap);
    }
  }
  function setPaginationPageSizeCache(pageSize2) {
    const key2 = unref(getPageSizeCacheKey);
    if (unref(cacheEnable) && key2) {
      return storageProxy.set(key2, pageSize2);
    }
  }
  function getPaginationPageSizeCache() {
    const key2 = unref(getPageSizeCacheKey);
    if (unref(cacheEnable) && key2) {
      return storageProxy.get(key2);
    }
    return null;
  }
  return {
    getCachedColumns,
    setCachedColumns,
    setPaginationPageSizeCache,
    getPaginationPageSizeCache,
    getCachedTableInnerColumns,
    setCachedTableInnerColumns
  };
}
function clearCachedColumns() {
  const allKeys = storageProxy.getAllKeys();
  allKeys.forEach((key2) => {
    if (key2.startsWith(tableCacheKeyPrefix$1)) {
      storageProxy.remove(key2);
    }
  });
}
function usePagination$1(props2) {
  const innerConfig = ref({});
  const show = ref(true);
  const { getPaginationPageSizeCache, setPaginationPageSizeCache } = useTableCache$1(props2);
  watch(() => unref(props2).pagination, (newPagination) => {
    if (isPlainObject(newPagination)) {
      innerConfig.value = __spreadValues(__spreadValues({}, unref(innerConfig)), newPagination);
    }
  });
  const getPaginationInfo = computed(() => {
    const { pagination } = unref(props2);
    if (pagination === false || unref(show) === false) {
      return false;
    }
    const pageSizeCached = getPaginationPageSizeCache();
    return __spreadValues(__spreadValues({
      current: 1,
      pageSize: pageSizeCached || PAGE_SIZE,
      size: "default",
      defaultPageSize: pageSizeCached || PAGE_SIZE,
      showTotal: (total3) => `\u5171${total3}\u6761\uFF1A`,
      showSizeChanger: true,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
      itemRender,
      showQuickJumper: false,
      position: ["bottomLeft"],
      total: 0
    }, isPlainObject(pagination) ? pagination : {}), unref(innerConfig));
  });
  const getPaginationBinds = function() {
    return unref(getPaginationInfo);
  };
  function setPaginationConfig(pagination) {
    const paginationInfo = unref(getPaginationInfo);
    innerConfig.value = __spreadValues(__spreadValues({}, isPlainObject(paginationInfo) ? paginationInfo : {}), pagination);
    if (pagination.pageSize) {
      setPaginationPageSizeCache(pagination.pageSize);
    }
  }
  const getShowPagination = function() {
    return unref(show);
  };
  async function setShowPagination(visible) {
    show.value = visible;
  }
  return {
    getPaginationInfo,
    getPaginationBinds,
    setPaginationConfig,
    getShowPagination,
    setShowPagination
  };
}
const componentMap = new Map();
componentMap.set("Input", Input);
componentMap.set("InputNumber", InputNumber$1);
componentMap.set("Select", Select$1);
componentMap.set("ApiSelect", ApiSelect);
componentMap.set("ApiTreeSelect", ApiTreeSelect);
componentMap.set("Switch", Switch$1);
componentMap.set("Checkbox", Checkbox);
componentMap.set("Cascader", Cascader$1);
componentMap.set("DatePicker", DatePicker$1);
componentMap.set("DateRangePicker", DateRangePicker);
componentMap.set("TimePicker", TimePicker$1);
function add(compName, component) {
  componentMap.set(compName, component);
}
function del(compName) {
  componentMap.delete(compName);
}
const CellComponent = ({
  component = "Input",
  rule = true,
  ruleMessage,
  popoverVisible,
  getPopupContainer
}, { attrs }) => {
  const Comp = componentMap.get(component);
  const DefaultComp = h$2(Comp, attrs);
  if (!rule) {
    return DefaultComp;
  }
  return h$2(Popover$1, __spreadValues({
    overlayClassName: "edit-cell-rule-popover",
    visible: !!popoverVisible
  }, getPopupContainer ? { getPopupContainer } : {}), {
    default: () => DefaultComp,
    content: () => ruleMessage
  });
};
const key$1 = Symbol("fbu-table");
function createTableContext$1(instance2) {
  provide(key$1, instance2);
}
function useTableContext$1() {
  return inject(key$1);
}
function createPlaceholderMessage(component) {
  if (component.includes("Input")) {
    return "\u8BF7\u8F93\u5165";
  }
  if (component.includes("Picker") || component.includes("Select") || component.includes("Cascader") || component.includes("Checkbox") || component.includes("Radio") || component.includes("Switch")) {
    return "\u8BF7\u9009\u62E9";
  }
  return "";
}
function tree2List(treeArr, childrenFieldName = "children", reserveChildren = false) {
  if (treeArr.length === 0) {
    return [];
  }
  let result = [];
  treeArr.forEach((item) => {
    const tmp = __spreadValues({}, item);
    result.push(tmp);
    const children = tmp.children;
    if (reserveChildren === false) {
      Reflect.deleteProperty(tmp, childrenFieldName || "children");
    }
    if (children && children.length) {
      result = result.concat(tree2List(children, childrenFieldName, reserveChildren));
    }
  });
  return result;
}
var EditableCell_vue_vue_type_style_index_0_lang = "";
const _sfc_main$l = defineComponent({
  name: "EditableCell",
  components: { FormOutlined: FormOutlined$1, CloseOutlined: CloseOutlined$1, CheckOutlined: CheckOutlined$1, CellComponent, ASpin: Spin },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: ""
    },
    record: {
      type: Object
    },
    column: {
      type: Object,
      default: () => ({})
    },
    index: Number
  },
  setup(props2) {
    const table = useTableContext$1();
    const isEdit = ref(false);
    const elRef = ref();
    const ruleVisible = ref(false);
    const ruleMessage = ref("");
    const optionsRef = ref([]);
    const currentValueRef = ref(props2.value);
    const defaultValueRef = ref(props2.value);
    const spinning = ref(false);
    const prefixCls2 = usePrefixCls("editable-cell");
    const getComponent3 = computed(() => {
      var _a2;
      return ((_a2 = props2.column) == null ? void 0 : _a2.editComponent) || "Input";
    });
    const getRule = computed(() => {
      var _a2;
      return !!((_a2 = props2.column) == null ? void 0 : _a2.editRule);
    });
    const getRuleVisible = computed(() => {
      return !!unref(ruleMessage) && unref(ruleVisible);
    });
    const getIsCheckComp = computed(() => {
      const component = unref(getComponent3);
      return ["Checkbox", "Switch"].includes(component);
    });
    const getComponentProps = computed(() => {
      var _a2, _b;
      const compProps = (_b = (_a2 = props2.column) == null ? void 0 : _a2.editComponentProps) != null ? _b : {};
      const isCheckValue = unref(getIsCheckComp);
      const valueField = isCheckValue ? "checked" : "value";
      const val = unref(currentValueRef);
      const value = isCheckValue ? isNumber$1(val) && isBoolean(val) ? val : !!val : val;
      const newCompProps = __spreadValues({}, compProps);
      Reflect.deleteProperty(newCompProps, "onChange");
      return __spreadProps(__spreadValues({
        size: "small",
        getPopupContainer: () => {
          var _a3;
          return (_a3 = unref(table == null ? void 0 : table.wrapRef.value)) != null ? _a3 : document.body;
        },
        getCalendarContainer: () => {
          var _a3;
          return (_a3 = unref(table == null ? void 0 : table.wrapRef.value)) != null ? _a3 : document.body;
        },
        placeholder: createPlaceholderMessage(unref(getComponent3))
      }, newCompProps), {
        [valueField]: value
      });
    });
    const getValues = computed(() => {
      var _a2, _b;
      const { editComponentProps, editValueMap } = props2.column;
      const value = unref(currentValueRef);
      if (editValueMap && isFunction$1(editValueMap)) {
        return editValueMap(value);
      }
      const component = unref(getComponent3);
      if (!component.includes("Select")) {
        return value;
      }
      const options = (_a2 = editComponentProps == null ? void 0 : editComponentProps.options) != null ? _a2 : unref(optionsRef) || [];
      const option2 = options.find((item) => `${item.value}` === `${value}`);
      return (_b = option2 == null ? void 0 : option2.label) != null ? _b : value;
    });
    const getWrapperStyle = computed(() => {
      if (unref(getIsCheckComp) || unref(getRowEditable)) {
        return {};
      }
      return {
        width: "calc(100% - 48px)"
      };
    });
    const getWrapperClass = computed(() => {
      const { align = "center" } = props2.column;
      return `edit-cell-align-${align}`;
    });
    const getRowEditable = computed(() => {
      const { editable } = props2.record || {};
      return !!editable;
    });
    watchEffect(() => {
      defaultValueRef.value = props2.value;
      currentValueRef.value = props2.value;
    });
    watchEffect(() => {
      const { editable } = props2.column;
      if (isBoolean(editable) || isBoolean(unref(getRowEditable))) {
        isEdit.value = !!editable || unref(getRowEditable);
      }
    });
    function handleEdit() {
      var _a2;
      if (unref(getRowEditable) || unref((_a2 = props2.column) == null ? void 0 : _a2.editRow))
        return;
      ruleMessage.value = "";
      isEdit.value = true;
      nextTick(() => {
        var _a3;
        const el = unref(elRef);
        (_a3 = el == null ? void 0 : el.focus) == null ? void 0 : _a3.call(el);
      });
    }
    async function handleChange2(e2) {
      var _a2, _b, _c;
      const component = unref(getComponent3);
      if (!e2) {
        currentValueRef.value = e2;
      } else if ((e2 == null ? void 0 : e2.target) && Reflect.has(e2.target, "value")) {
        currentValueRef.value = e2.target.value;
      } else if (component === "Checkbox") {
        currentValueRef.value = e2.target.checked;
      } else if (isString$1(e2) || isBoolean(e2) || isNumber$1(e2)) {
        currentValueRef.value = e2;
      }
      const onChange3 = (_b = (_a2 = props2.column) == null ? void 0 : _a2.editComponentProps) == null ? void 0 : _b.onChange;
      if (onChange3 && isFunction$1(onChange3))
        onChange3(...arguments);
      (_c = table.emit) == null ? void 0 : _c.call(table, "edit-change", {
        column: props2.column,
        value: unref(currentValueRef),
        record: toRaw(props2.record)
      });
      handleSubmiRule();
    }
    async function handleSubmiRule() {
      const { column, record } = props2;
      const { editRule } = column;
      const currentValue = unref(currentValueRef);
      if (editRule) {
        if (isBoolean(editRule) && !currentValue && !isNumber$1(currentValue)) {
          ruleVisible.value = true;
          const component = unref(getComponent3);
          ruleMessage.value = createPlaceholderMessage(component);
          return false;
        }
        if (isFunction$1(editRule)) {
          const res = await editRule(currentValue, record);
          if (res) {
            ruleMessage.value = res;
            ruleVisible.value = true;
            return false;
          } else {
            ruleMessage.value = "";
            return true;
          }
        }
      }
      ruleMessage.value = "";
      return true;
    }
    async function handleSubmit(needEmit = true, valid = true) {
      var _a2;
      if (valid) {
        const isPass = await handleSubmiRule();
        if (!isPass)
          return false;
      }
      const { column, index: index2, record } = props2;
      if (!record)
        return false;
      const { key: key2, dataIndex } = column;
      const value = unref(currentValueRef);
      if (!key2 && !dataIndex)
        return;
      const dataKey = dataIndex || key2;
      if (!record.editable) {
        const { getBindValues } = table;
        const { beforeEditSubmit, columns: columns2 } = unref(getBindValues);
        if (beforeEditSubmit && isFunction$1(beforeEditSubmit)) {
          spinning.value = true;
          const keys2 = (columns2 || []).map((_column) => _column.dataIndex).filter((field) => !!field);
          let result = true;
          try {
            result = await beforeEditSubmit({
              record: JSON.parse(JSON.stringify(record, keys2)),
              index: index2,
              key: key2,
              value
            });
          } catch (e2) {
            result = false;
          } finally {
            spinning.value = false;
          }
          if (result === false) {
            return;
          }
        }
      }
      set(record, dataKey, value);
      needEmit && ((_a2 = table.emit) == null ? void 0 : _a2.call(table, "edit-end", { record, index: index2, key: key2, value }));
      isEdit.value = false;
    }
    async function handleEnter() {
      var _a2;
      if ((_a2 = props2.column) == null ? void 0 : _a2.editRow) {
        return;
      }
      handleSubmit();
    }
    function handleSubmitClick() {
      handleSubmit();
    }
    function handleCancel() {
      var _a2;
      isEdit.value = false;
      currentValueRef.value = defaultValueRef.value;
      const { column, index: index2, record } = props2;
      const { key: key2, dataIndex } = column;
      (_a2 = table.emit) == null ? void 0 : _a2.call(table, "edit-cancel", {
        record,
        index: index2,
        key: dataIndex || key2,
        value: unref(currentValueRef)
      });
    }
    function onClickOutside() {
      var _a2;
      if (((_a2 = props2.column) == null ? void 0 : _a2.editable) || unref(getRowEditable)) {
        return;
      }
      const component = unref(getComponent3);
      if (component.includes("Input")) {
        handleCancel();
      }
    }
    function handleOptionsChange(options) {
      var _a2, _b;
      const { replaceFields } = (_b = (_a2 = props2.column) == null ? void 0 : _a2.editComponentProps) != null ? _b : {};
      const component = unref(getComponent3);
      if (component === "ApiTreeSelect") {
        const { title = "title", value = "value", children = "children" } = replaceFields || {};
        let listOptions = tree2List(options, children);
        listOptions = listOptions.map((item) => {
          return {
            label: item[title],
            value: item[value]
          };
        });
        optionsRef.value = listOptions;
      } else {
        optionsRef.value = options;
      }
    }
    function initCbs(cbs, handle) {
      var _a2;
      if (props2.record) {
        isArray$1(props2.record[cbs]) ? (_a2 = props2.record[cbs]) == null ? void 0 : _a2.push(handle) : props2.record[cbs] = [handle];
      }
    }
    if (props2.record) {
      initCbs("submitCbs", handleSubmit);
      initCbs("validCbs", handleSubmiRule);
      initCbs("cancelCbs", handleCancel);
      if (props2.column.dataIndex) {
        if (!props2.record.editValueRefs)
          props2.record.editValueRefs = {};
        props2.record.editValueRefs[props2.column.dataIndex] = currentValueRef;
      }
      props2.record.onCancelEdit = () => {
        var _a2, _b;
        isArray$1((_a2 = props2.record) == null ? void 0 : _a2.cancelCbs) && ((_b = props2.record) == null ? void 0 : _b.cancelCbs.forEach((fn) => fn()));
      };
      props2.record.onSubmitEdit = async () => {
        var _a2, _b, _c, _d, _e;
        if (isArray$1((_a2 = props2.record) == null ? void 0 : _a2.submitCbs)) {
          if (!((_c = (_b = props2.record) == null ? void 0 : _b.onValid) == null ? void 0 : _c.call(_b)))
            return;
          const submitFns = ((_d = props2.record) == null ? void 0 : _d.submitCbs) || [];
          submitFns.forEach((fn) => fn(false, false));
          (_e = table.emit) == null ? void 0 : _e.call(table, "edit-row-end");
          return true;
        }
      };
    }
    return {
      isEdit,
      prefixCls: prefixCls2,
      handleEdit,
      currentValueRef,
      handleSubmit,
      handleChange: handleChange2,
      handleCancel,
      elRef,
      getComponent: getComponent3,
      getRule,
      onClickOutside,
      ruleMessage,
      getRuleVisible,
      getComponentProps,
      handleOptionsChange,
      getWrapperStyle,
      getWrapperClass,
      getRowEditable,
      getValues,
      handleEnter,
      handleSubmitClick,
      spinning
    };
  }
});
const _hoisted_1$g = ["title"];
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2;
  const _component_FormOutlined = resolveComponent("FormOutlined");
  const _component_CellComponent = resolveComponent("CellComponent");
  const _component_CheckOutlined = resolveComponent("CheckOutlined");
  const _component_CloseOutlined = resolveComponent("CloseOutlined");
  const _component_a_spin = resolveComponent("a-spin");
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.prefixCls)
  }, [
    withDirectives(createElementVNode("div", {
      class: normalizeClass({ [`${_ctx.prefixCls}__normal`]: true, "ellipsis-cell": _ctx.column.ellipsis }),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleEdit && _ctx.handleEdit(...args))
    }, [
      createElementVNode("div", {
        class: "cell-content",
        title: _ctx.column.ellipsis ? (_a2 = _ctx.getValues) != null ? _a2 : "" : ""
      }, toDisplayString(_ctx.getValues || _ctx.getValues === 0 ? _ctx.getValues : "\xA0"), 9, _hoisted_1$g),
      !_ctx.column.editRow ? (openBlock(), createBlock(_component_FormOutlined, {
        key: 0,
        class: normalizeClass(`${_ctx.prefixCls}__normal-icon`)
      }, null, 8, ["class"])) : createCommentVNode("", true)
    ], 2), [
      [vShow, !_ctx.isEdit]
    ]),
    _ctx.isEdit ? (openBlock(), createBlock(_component_a_spin, {
      key: 0,
      spinning: _ctx.spinning
    }, {
      default: withCtx(() => [
        withDirectives((openBlock(), createElementBlock("div", {
          class: normalizeClass(`${_ctx.prefixCls}__wrapper`)
        }, [
          createVNode(_component_CellComponent, mergeProps(_ctx.getComponentProps, {
            component: _ctx.getComponent,
            style: _ctx.getWrapperStyle,
            popoverVisible: _ctx.getRuleVisible,
            rule: _ctx.getRule,
            ruleMessage: _ctx.ruleMessage,
            class: _ctx.getWrapperClass,
            ref: "elRef",
            onChange: _ctx.handleChange,
            onOptionsChange: _ctx.handleOptionsChange,
            onPressEnter: _ctx.handleEnter
          }), null, 16, ["component", "style", "popoverVisible", "rule", "ruleMessage", "class", "onChange", "onOptionsChange", "onPressEnter"]),
          !_ctx.getRowEditable ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(`${_ctx.prefixCls}__action`)
          }, [
            createVNode(_component_CheckOutlined, {
              class: normalizeClass(`${_ctx.prefixCls}__icon`),
              onClick: _ctx.handleSubmitClick
            }, null, 8, ["class", "onClick"]),
            createVNode(_component_CloseOutlined, {
              class: normalizeClass(`${_ctx.prefixCls}__icon `),
              onClick: _ctx.handleCancel
            }, null, 8, ["class", "onClick"])
          ], 2)) : createCommentVNode("", true)
        ], 2)), [
          [_directive_click_outside, _ctx.onClickOutside]
        ])
      ]),
      _: 1
    }, 8, ["spinning"])) : createCommentVNode("", true)
  ], 2);
}
var EditableCell = /* @__PURE__ */ _export_sfc$1(_sfc_main$l, [["render", _sfc_render$g]]);
function renderEditCell(column) {
  return ({ text: value, record, index: index2 }) => {
    record.onValid = async () => {
      if (isArray$1(record == null ? void 0 : record.validCbs)) {
        const validFns = ((record == null ? void 0 : record.validCbs) || []).map((fn) => fn());
        const res = await Promise.all(validFns);
        return res.every((item) => !!item);
      } else {
        return false;
      }
    };
    record.onEdit = async (edit, submit = false) => {
      var _a2, _b;
      if (!submit) {
        record.editable = edit;
      }
      if (!edit && submit) {
        if (!await record.onValid())
          return false;
        const res = await ((_a2 = record.onSubmitEdit) == null ? void 0 : _a2.call(record));
        if (res) {
          record.editable = false;
          return true;
        }
        return false;
      }
      if (!edit && !submit) {
        (_b = record.onCancelEdit) == null ? void 0 : _b.call(record);
      }
      return true;
    };
    return h$2(EditableCell, {
      value,
      record,
      column,
      index: index2
    });
  };
}
const ROW_KEY$1 = "key";
const FETCH_SETTING$1 = {
  pageField: "pageIndex",
  sizeField: "pageSize",
  listField: "records",
  totalField: "total"
};
const DEFAULT_SIZE$1 = "default";
const DEFAULT_SORT_FN$1 = (sortInfo) => {
  const { field, order } = sortInfo;
  if (field && order) {
    return {
      field,
      order
    };
  } else {
    return {};
  }
};
const DEFAULT_FILTER_FN$1 = (data6) => {
  return data6;
};
const DEFAULT_ALIGN$1 = "left";
const INDEX_COLUMN_FLAG$1 = "INDEX";
const ACTION_COLUMN_FLAG$1 = "ACTION";
const SETTING_COLUMN_INDEX$1 = "SETTING";
function handleItem$1(item, ellipsis) {
  const { key: key2, dataIndex, children } = item;
  item.align = item.align || DEFAULT_ALIGN$1;
  if (ellipsis) {
    if (!key2) {
      item.key = dataIndex;
    }
    if (!isBoolean(item.ellipsis)) {
      Object.assign(item, {
        ellipsis
      });
    }
  }
  if (children && children.length) {
    handleChildren$1(children, !!ellipsis);
  }
}
function handleChildren$1(children, ellipsis) {
  if (!children)
    return;
  children.forEach((item) => {
    const { children: children2 } = item;
    handleItem$1(item, ellipsis);
    handleChildren$1(children2, ellipsis);
  });
}
function handleIndexColumn$1(propsRef, getPaginationRef, columns2, startIndex) {
  const { showIndexColumn, indexColumnProps, isTreeTable } = unref(propsRef);
  if (unref(isTreeTable)) {
    return;
  }
  let pushIndexColumns = false;
  columns2.forEach(() => {
    const indIndex = columns2.findIndex((column) => column.flag === INDEX_COLUMN_FLAG$1);
    if (showIndexColumn) {
      pushIndexColumns = indIndex === -1;
    } else if (!showIndexColumn && indIndex !== -1) {
      columns2.splice(indIndex, 1);
    }
  });
  if (!pushIndexColumns)
    return;
  const isFixedLeft = columns2.some((item) => item.fixed === "left");
  columns2.unshift(__spreadValues(__spreadValues({
    flag: INDEX_COLUMN_FLAG$1,
    width: 60,
    title: "\u5E8F\u53F7",
    align: "center",
    disabled: true,
    dataIndex: INDEX_COLUMN_FLAG$1,
    customRender: ({ index: _i }) => {
      const index2 = startIndex.value + _i;
      const getPagination = unref(getPaginationRef);
      if (isBoolean(getPagination)) {
        return `${index2 + 1}`;
      }
      const { current: current2 = 1, pageSize: pageSize2 = PAGE_SIZE } = getPagination;
      return ((current2 < 1 ? 1 : current2) - 1) * pageSize2 + index2 + 1;
    }
  }, isFixedLeft ? {
    fixed: "left"
  } : {}), indexColumnProps));
}
function handleActionColumn$1(propsRef, columns2) {
  const { actionColumn } = unref(propsRef);
  if (!actionColumn)
    return;
  const hasIndex = columns2.findIndex((column) => column.flag === ACTION_COLUMN_FLAG$1);
  if (hasIndex === -1) {
    columns2.push(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, columns2[hasIndex]), {
      fixed: "right"
    }), actionColumn), {
      flag: ACTION_COLUMN_FLAG$1
    }));
  }
}
function handleSettingColumn$1(propsRef, columns2) {
  const { showSettingColumn, settingColumnProps } = unref(propsRef);
  if (!showSettingColumn || columns2.length === 0) {
    return;
  }
  const isFixedRight = columns2.some((item) => item.fixed === "right");
  columns2.push(__spreadValues(__spreadValues({
    width: 50,
    title: "",
    align: "center",
    flag: SETTING_COLUMN_INDEX$1
  }, isFixedRight ? {
    fixed: "right"
  } : {}), settingColumnProps));
}
function useColumns$2(propsRef, getPaginationRef, emit, startIndex) {
  const {
    getCachedColumns,
    setCachedColumns,
    getCachedTableInnerColumns,
    setCachedTableInnerColumns
  } = useTableCache$1(propsRef);
  const columnsRef = ref(initColumnsWithLocalCache(cloneDeep(unref(propsRef).columns) || []));
  let cacheColumns = cloneDeep(unref(columnsRef)) || [];
  let mutationColumns = cloneDeep(unref(propsRef).columns);
  const innerColumnsCheckedMap = reactive({});
  const innerColumnsMap = reactive(initInnerColumnsMap(columnsRef.value));
  const getColumnsRef = computed(() => {
    const columns2 = cloneDeep(unref(columnsRef));
    handleIndexColumn$1(propsRef, getPaginationRef, columns2, startIndex);
    handleActionColumn$1(propsRef, columns2);
    if (!columns2) {
      return [];
    }
    handleSettingColumn$1(propsRef, columns2);
    const { ellipsis } = unref(propsRef);
    columns2.forEach((item) => {
      const { customRender } = item;
      handleItem$1(item, Reflect.has(item, "ellipsis") ? !!item.ellipsis : !!ellipsis && !customRender);
    });
    return columns2;
  });
  function isIfShow(column) {
    const ifShow = column.ifShow;
    let isIfShow2 = true;
    if (isBoolean(ifShow)) {
      isIfShow2 = ifShow;
    }
    if (isFunction$1(ifShow)) {
      isIfShow2 = ifShow(column);
    }
    return isIfShow2;
  }
  const getViewColumns = computed(() => {
    const viewColumns = sortFixedColumn$1(unref(getColumnsRef));
    const columns2 = cloneDeep(viewColumns);
    return columns2.filter((column) => {
      return isIfShow(column);
    }).map((column) => {
      const {
        customRender,
        format: format3 = normalizeCell$1,
        edit,
        editRow,
        flag,
        ellipsis,
        customEllipsis
      } = column;
      const isDefaultAction = [
        INDEX_COLUMN_FLAG$1,
        ACTION_COLUMN_FLAG$1,
        SETTING_COLUMN_INDEX$1
      ].includes(flag);
      if (!customRender && !edit && !isDefaultAction) {
        column.customRender = ({ text, record, index: index2 }) => {
          if (ellipsis) {
            const params = { column, record, text, index: index2 };
            let content = isFunction$1(customEllipsis) ? customEllipsis(h$2, params) : void 0;
            if (typeof customEllipsis === "object" && isFunction$1(customEllipsis.content)) {
              content = customEllipsis.content(h$2, params);
            }
            let tooltipProps3 = {};
            if (typeof customEllipsis === "object") {
              tooltipProps3 = "props" in customEllipsis ? customEllipsis.props : customEllipsis || void 0;
            }
            const formattedText = format3 ? formatCell$1(text, format3, record, index2) : text;
            content = content ? content : formattedText;
            return h$2(TdEllipsis$1, {
              placement: "top",
              tooltipContent: content && (() => content),
              tooltipProps: tooltipProps3
            }, { default: () => formattedText });
          } else if (format3) {
            return h$2("span", formatCell$1(text, format3, record, index2));
          }
        };
      }
      if ((edit || editRow) && !isDefaultAction) {
        column.customRender = renderEditCell(column);
      }
      return column;
    });
  });
  watch(() => unref(propsRef).columns, (columns2) => {
    if (isArray$1(columns2)) {
      columnsRef.value = initColumnsWithLocalCache(cloneDeep(columns2) || []);
      cacheColumns = cloneDeep(unref(columnsRef)) || [];
      mutationColumns = cloneDeep(columns2);
    }
  });
  watch(columnsRef, (columns2) => {
    setCachedColumns(columns2.map((item) => __spreadProps(__spreadValues({}, item), { innerColumns: void 0 })));
  }, {
    deep: true
  });
  watch(innerColumnsMap, (columnsMap) => {
    setCachedTableInnerColumns(columnsMap);
    nextTick(() => {
      emitInnerColumnsCheckedList();
    });
  }, {
    deep: true
  });
  function initColumnsWithLocalCache(columns2) {
    const cachedColumns = getCachedColumns();
    if (isArray$1(cachedColumns)) {
      cachedColumns.forEach((item) => {
        const found = columns2.find((col) => col.dataIndex === item.dataIndex);
        if (found && isPlainObject(found)) {
          const { title, fixed, disabled } = found;
          Object.assign(found, item, { title, fixed, disabled });
        }
      });
      handleIndexColumn$1(propsRef, getPaginationRef, columns2, startIndex);
      columns2.sort((prev2, next2) => {
        return cachedColumns.findIndex((item) => item.dataIndex === prev2.dataIndex) - cachedColumns.findIndex((item) => item.dataIndex === next2.dataIndex);
      });
    } else {
      handleIndexColumn$1(propsRef, getPaginationRef, columns2, startIndex);
    }
    return columns2;
  }
  function setCacheColumnsByField(dataIndex, value) {
    if (!dataIndex || !value) {
      return;
    }
    cacheColumns == null ? void 0 : cacheColumns.forEach((item) => {
      if (item.dataIndex === dataIndex) {
        Object.assign(item, value);
        return;
      }
    });
  }
  function setColumns(columnList) {
    const columns2 = cloneDeep(columnList);
    if (!isArray$1(columns2))
      return;
    if (columns2.length <= 0) {
      columnsRef.value = [];
      return;
    }
    const firstColumn = columns2[0];
    const cacheKeys = cacheColumns.map((item) => item.dataIndex);
    const currentColumnKeys = unref(columnsRef).map((item) => item.dataIndex);
    if (!isString$1(firstColumn)) {
      columnsRef.value = columns2;
    } else {
      const columnKeys = columns2;
      const newColumns = [];
      cacheColumns.forEach((item) => {
        newColumns.push(__spreadProps(__spreadValues({}, item), {
          defaultHidden: !columnKeys.includes(item.dataIndex || item.key)
        }));
      });
      if (!isDeepEqual(cacheKeys, columns2)) {
        const sortArr = cacheKeys.length === columns2.length ? columnKeys : currentColumnKeys;
        newColumns.sort((prev2, next2) => {
          return sortArr.indexOf(prev2.dataIndex) - sortArr.indexOf(next2.dataIndex);
        });
      }
      if (propsRef.value.enableResponseWhenAllFixed) {
        if (newColumns.some((item) => item.fixed === void 0 && !item.defaultHidden) === false) {
          const mainField = newColumns.find((item) => item.mainField);
          if (mainField) {
            mainField.fixed = void 0;
            mainField.width = void 0;
          }
        }
      }
      columnsRef.value = newColumns;
    }
  }
  function getColumns(opt) {
    const { ignoreIndex, ignoreAction, ignoreSetting, sort: sort2 } = opt || {};
    let columns2 = toRaw(unref(getColumnsRef));
    if (ignoreIndex) {
      columns2 = columns2.filter((item) => item.flag !== INDEX_COLUMN_FLAG$1);
    }
    if (ignoreAction) {
      columns2 = columns2.filter((item) => item.flag !== ACTION_COLUMN_FLAG$1);
    }
    if (ignoreSetting) {
      columns2 = columns2.filter((item) => item.flag !== SETTING_COLUMN_INDEX$1);
    }
    if (sort2) {
      columns2 = sortFixedColumn$1(columns2);
    }
    return columns2;
  }
  function getCacheColumns() {
    return cacheColumns;
  }
  function getMutationColumns() {
    const returnColumns = mutationColumns.slice(0);
    handleIndexColumn$1(propsRef, getPaginationRef, returnColumns, startIndex);
    return returnColumns;
  }
  function resetColumns() {
    const columns2 = getMutationColumns();
    setColumns(columns2);
    cacheColumns = cloneDeep(columns2);
  }
  function handleResizeColumn(width, col) {
    const found = unref(columnsRef).find((item) => item.dataIndex === col.dataIndex);
    if (found) {
      found.width = width;
      setCacheColumnsByField(found.dataIndex, found);
    }
    emit("resize-column", width, col);
  }
  function initInnerColumnsMap(columns2) {
    const innerColumnsMapCache = getCachedTableInnerColumns() || {};
    const innerColumnsMap2 = {};
    columns2.forEach((column) => {
      const innerColumns = column.innerColumns || [];
      const innerColumnsCache = innerColumnsMapCache[column.dataIndex];
      if (Array.isArray(innerColumns) && innerColumns.length > 0) {
        const newInnerColumns = innerColumns.slice(0).map((item) => __spreadProps(__spreadValues({}, item), {
          ifShow: item.alwaysShow || isUnDef(item.ifShow) ? true : item.ifShow
        }));
        if (innerColumnsCache) {
          innerColumnsCache.forEach((item) => {
            var _a2;
            const found = newInnerColumns.find((innerItem) => innerItem.dataIndex === item.dataIndex);
            if (found && !found.alwaysShow) {
              found.ifShow = (_a2 = item.ifShow) != null ? _a2 : true;
            }
          });
        }
        innerColumnsMap2[column.dataIndex] = newInnerColumns;
        const checkedList = newInnerColumns.filter((item) => item.ifShow).map((item) => item.dataIndex);
        const checkedMap = {
          checkedList,
          indeterminate: checkedList.length > 0 && checkedList.length < newInnerColumns.length
        };
        innerColumnsCheckedMap[column.dataIndex] = checkedMap;
      }
    });
    return innerColumnsMap2;
  }
  function emitInnerColumnsCheckedList() {
    emit("inner-columns-checked-list", Object.keys(innerColumnsCheckedMap).map((key2) => innerColumnsCheckedMap[key2].checkedList).flat(1));
  }
  onMounted(() => {
    emitInnerColumnsCheckedList();
  });
  return {
    getColumnsRef,
    getCacheColumns,
    getColumns,
    setColumns,
    getViewColumns,
    setCacheColumnsByField,
    handleResizeColumn,
    getMutationColumns,
    resetColumns,
    innerColumnsMap,
    innerColumnsCheckedMap
  };
}
function sortFixedColumn$1(columns2) {
  const fixedLeftColumns = [];
  const fixedRightColumns = [];
  const defColumns = [];
  for (const column of columns2) {
    if (column.fixed === "left") {
      fixedLeftColumns.push(column);
      continue;
    }
    if (column.fixed === "right") {
      fixedRightColumns.push(column);
      continue;
    }
    defColumns.push(column);
  }
  return [...fixedLeftColumns, ...defColumns, ...fixedRightColumns].filter((item) => !item.defaultHidden);
}
function formatCell$1(text, format3, record, index2) {
  if (!format3) {
    return text;
  }
  if (isFunction$1(format3)) {
    return format3(text, record, index2);
  }
  try {
    const DATE_FORMAT_PREFIX = "date|";
    if (isString$1(format3) && format3.startsWith(DATE_FORMAT_PREFIX)) {
      const dateFormat = format3.replace(DATE_FORMAT_PREFIX, "");
      if (!dateFormat) {
        return text;
      }
      return formatToDate(text, dateFormat);
    }
    if (format3 instanceof Map) {
      return format3.get(text);
    }
  } catch (error) {
    return text;
  }
}
function normalizeCell$1(text) {
  return isUnDef(text) || text === "" ? "--" : text;
}
function useDataSource$1(propsRef, tableData, {
  getPaginationInfo,
  setPagination,
  setLoading,
  getFieldsValue,
  clearSelectedRowKeys,
  getTabData,
  setEmptyTextAfterFetch,
  setEmptyInFetching,
  startCountDown
}, emit) {
  const dataSourceRef = ref([]);
  const rawDataSourceRef = ref([]);
  const searchState = reactive({
    sortInfo: {},
    filterInfo: {}
  });
  const setSearchStateSortInfo = (sortInfo) => {
    searchState.sortInfo = sortInfo;
  };
  watchEffect(() => {
    tableData.value = unref(dataSourceRef);
  });
  watch(() => unref(propsRef).dataSource, (data6) => {
    if (!isFunction$1(unref(propsRef).api) && data6) {
      dataSourceRef.value = data6;
    }
  }, {
    immediate: true
  });
  const getAutoCreateKeyRef = computed(() => {
    const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
    return autoCreateKey && !rowKey2;
  });
  const getRowKeyRef = computed(() => {
    return unref(getAutoCreateKeyRef) ? ROW_KEY$1 : unref(propsRef).rowKey;
  });
  const getDataSourceRef = computed(() => {
    const dataSource = unref(dataSourceRef);
    if (!dataSource || dataSource.length === 0) {
      return [];
    }
    if (unref(getAutoCreateKeyRef)) {
      const firstItem = dataSource[0];
      if (firstItem && Reflect.has(firstItem, ROW_KEY$1) === false) {
        const data6 = cloneDeep(dataSource);
        setRowRecordsKey(data6);
        dataSourceRef.value = data6;
      }
    }
    return unref(dataSourceRef);
  });
  function setRowRecordsKey(rows) {
    const { childrenColumnName } = unref(propsRef);
    rows.forEach((row) => {
      row[ROW_KEY$1] = uuid();
      const children = row[childrenColumnName || "children"];
      if (children && children.length) {
        setRowRecordsKey(children);
      }
    });
  }
  function handleTableChange(pagination, filters, sorter) {
    const { clearSelectOnPageChange, sortFn, filterFn } = unref(propsRef);
    if (clearSelectOnPageChange) {
      clearSelectedRowKeys();
    }
    setPagination(pagination);
    const params = {};
    if (sorter && isFunction$1(sortFn)) {
      const sortInfo = sortFn(sorter);
      searchState.sortInfo = sortInfo;
      params.sortInfo = sortInfo;
    }
    if (filters && isFunction$1(filterFn)) {
      const filterInfo = filterFn(filters);
      searchState.filterInfo = filterInfo;
      params.filterInfo = filterInfo;
    }
    fetch(params);
  }
  async function fetch(params) {
    var _a2, _b, _c;
    const {
      api: api2,
      searchInfo,
      defSort,
      fetchSetting,
      beforeFetch,
      afterFetch,
      useSearchForm,
      emptyInFetching,
      emptyAfterFetch
    } = unref(propsRef);
    if (!isFunction$1(api2)) {
      return;
    }
    try {
      setLoading(true);
      if (emptyInFetching && isFunction$1(emptyInFetching)) {
        setEmptyInFetching(emptyInFetching());
      } else {
        setEmptyInFetching();
      }
      const { pageField, sizeField, listField, totalField } = Object.assign({}, FETCH_SETTING$1, fetchSetting);
      let pageParams = {};
      const paginationInfo = unref(getPaginationInfo);
      if (isBoolean(paginationInfo)) {
        pageParams = {};
      } else {
        const { current: current2 = 1, pageSize: pageSize2 = 20 } = paginationInfo;
        pageParams[pageField] = params && params.page || current2;
        pageParams[sizeField] = pageSize2;
      }
      const { sortInfo = {}, filterInfo } = searchState;
      let payload = merge2(pageParams, useSearchForm ? getFieldsValue() : {}, searchInfo, (_a2 = params == null ? void 0 : params.searchInfo) != null ? _a2 : {}, defSort, sortInfo, filterInfo, (_b = params == null ? void 0 : params.sortInfo) != null ? _b : {}, (_c = params == null ? void 0 : params.filterInfo) != null ? _c : {}, getTabData());
      if (beforeFetch && isFunction$1(beforeFetch)) {
        payload = await beforeFetch(payload) || payload;
      }
      const res = await api2(payload);
      rawDataSourceRef.value = res;
      const isArrayResult = Array.isArray(res);
      let resultData = isArrayResult ? res : get(res, listField);
      const resultTotal = isArrayResult ? 0 : get(res, totalField);
      if (resultTotal) {
        const currentTotalPage = Math.ceil(resultTotal / payload.pageSize);
        if (payload.current > currentTotalPage) {
          setPagination({
            current: currentTotalPage
          });
          return await fetch(params);
        }
      }
      if (afterFetch && isFunction$1(afterFetch)) {
        resultData = await afterFetch(resultData) || resultData;
      }
      dataSourceRef.value = resultData;
      setPagination({
        total: resultTotal || 0
      });
      if (params && params.page) {
        setPagination({
          current: params.page || 1
        });
      }
      emit("fetch-success", {
        data: unref(resultData),
        total: resultTotal,
        result: unref(rawDataSourceRef)
      });
      startCountDown();
      if (!resultData || resultData.length === 0) {
        if (emptyAfterFetch && isFunction$1(emptyAfterFetch)) {
          setEmptyTextAfterFetch(emptyAfterFetch());
        } else {
          setEmptyTextAfterFetch();
        }
        emit("set-empty-after-fetch");
      }
      return resultData;
    } catch (error) {
      if (emptyAfterFetch && isFunction$1(emptyAfterFetch)) {
        setEmptyTextAfterFetch(emptyAfterFetch());
      } else {
        setEmptyTextAfterFetch();
      }
      emit("set-empty-after-fetch");
      emit("fetch-error", error);
      dataSourceRef.value = [];
      setPagination({
        total: 0
      });
    } finally {
      setLoading(false);
    }
  }
  async function reload(opt) {
    return await fetch(opt);
  }
  onMounted(() => {
    setTimeout(() => {
      unref(propsRef).immediate && fetch();
    }, 16);
  });
  function updateTableData(index2, key2, value) {
    const record = unref(dataSourceRef)[index2];
    if (record) {
      record[key2] = value;
    }
    return record;
  }
  function updateTableDataRecord(rowKey2, record) {
    const foundRow = findTableDataRecord(rowKey2);
    if (foundRow) {
      for (const field in foundRow) {
        if (Reflect.has(record, field)) {
          foundRow[field] = record[field];
        }
      }
      return foundRow;
    }
  }
  function deleteTableDataRecord(rowKey2) {
    const dataSource = unref(dataSourceRef);
    if (!dataSource || dataSource.length === 0) {
      return;
    }
    const keyName = unref(getRowKeyRef);
    if (!rowKey2 || !keyName) {
      return;
    }
    const getKey2 = (record) => isFunction$1(keyName) ? keyName(record) : keyName;
    const rowKeys = !isArray$1(rowKey2) ? [rowKey2] : rowKey2;
    const { childrenColumnName = "children" } = unref(propsRef);
    for (const key2 of rowKeys) {
      doDelete(dataSource, key2);
    }
    function doDelete(items, key2) {
      for (let i2 = 0; i2 < items.length; i2++) {
        const item = items[i2];
        if (item[getKey2(item)] === key2) {
          items.splice(i2, 1);
          break;
        } else {
          const children = item[childrenColumnName];
          if (children && children.length) {
            doDelete(children, key2);
          }
        }
      }
    }
  }
  function insertTableDataRecord(record, index2) {
    const len = unref(dataSourceRef).length;
    const insertPos = Math.min(Math.max(0, index2 || len), len);
    unref(dataSourceRef).splice(insertPos, 0, record);
    return record;
  }
  function findTableDataRecord(rowKey2) {
    const dataSource = unref(dataSourceRef);
    if (!dataSource || dataSource.length === 0) {
      return;
    }
    const { childrenColumnName } = unref(propsRef);
    const keyName = unref(getRowKeyRef);
    if (!rowKey2 || !keyName) {
      return;
    }
    const getKey2 = (record) => isFunction$1(keyName) ? keyName(record) : keyName;
    function traversal(items) {
      for (const item of items) {
        if (item[getKey2(item)] === rowKey2) {
          return item;
        }
        const children = item[childrenColumnName || "children"];
        if (children && children.length) {
          items.push(...children);
        }
      }
    }
    return traversal(dataSource);
  }
  function setTableData(values) {
    dataSourceRef.value = values;
  }
  function getDataSource() {
    return unref(dataSourceRef);
  }
  function getRawDataSource() {
    return unref(rawDataSourceRef);
  }
  return {
    getDataSourceRef,
    handleTableChange,
    updateTableData,
    updateTableDataRecord,
    deleteTableDataRecord,
    insertTableDataRecord,
    setTableData,
    getDataSource,
    getRawDataSource,
    getRowKeyRef,
    getAutoCreateKeyRef,
    fetch,
    reload,
    findTableDataRecord,
    setSearchStateSortInfo
  };
}
function useLoading$1(props2) {
  const innerLoading = ref();
  watchEffect(() => {
    innerLoading.value = unref(props2).loading;
  });
  const getLoading = computed(() => {
    return props2.value.enableLoading ? unref(innerLoading) : false;
  });
  function setLoading(loading) {
    innerLoading.value = loading;
  }
  return {
    getLoading,
    setLoading
  };
}
function useRowSelection$1(propsRef, tableData, emit, isVirtual, virtualDataKeys, dataSourceLimit) {
  const selectedRowKeysRef = ref([]);
  const selectedRowsRef = ref([]);
  const getRowKeyRef = computed(() => {
    const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
    return rowKey2 || autoCreateKey && ROW_KEY$1 || "";
  });
  watch(() => {
    var _a2;
    return (_a2 = unref(propsRef).rowSelection) == null ? void 0 : _a2.selectedRowKeys;
  }, (v2) => {
    isArray$1(v2) && setSelectedRowKeys(v2);
  }, {
    immediate: true
  });
  watch(() => unref(selectedRowKeysRef), () => {
    nextTick(() => {
      const { rowSelection } = unref(propsRef);
      if (rowSelection) {
        const { onChange: onChange3 } = rowSelection;
        if (onChange3 && isFunction$1(onChange3)) {
          onChange3(getSelectRowKeys(), getSelectRows());
        }
      }
      emit("selection-change", {
        keys: getSelectRowKeys(),
        rows: getSelectRows()
      });
    });
  }, { deep: true });
  const selectedRowKeyDiff = (selectedRowKeys) => {
    const keys2 = Array.from(new Set([...selectedRowKeysRef.value, ...selectedRowKeys]));
    const showKeys = keys2.filter((key2) => virtualDataKeys.value.includes(key2));
    if (showKeys.length > selectedRowKeys.length) {
      const cancelKey = showKeys.find((k2) => !selectedRowKeys.includes(k2));
      setSelectedRowKeys(keys2.filter((key2) => key2 != cancelKey));
      return;
    }
    setSelectedRowKeys(keys2);
  };
  let selectAllFlag = false;
  const getRowSelectionRef = computed(() => {
    const { rowSelection } = unref(propsRef);
    if (!rowSelection) {
      return null;
    }
    return __spreadProps(__spreadValues({}, rowSelection), {
      selectedRowKeys: unref(selectedRowKeysRef),
      onChange: (selectedRowKeys) => {
        if (selectAllFlag)
          return selectAllFlag = false;
        if (isVirtual.value && dataSourceLimit.value > 200)
          return selectedRowKeyDiff(selectedRowKeys);
        setSelectedRowKeys(selectedRowKeys);
      },
      onSelectAll(selected, ...oth) {
        if (typeof rowSelection.onSelectAll === "function")
          rowSelection.onSelectAll(selected, ...oth);
        if (!isVirtual.value)
          return;
        selectAllFlag = true;
        if (!selected)
          return setSelectedRowKeys([]);
        setTimeout(() => {
          const rowKey2 = unref(getRowKeyRef);
          const getRowKey = (record) => isFunction$1(rowKey2) ? rowKey2(record) : record[rowKey2];
          setSelectedRowKeys(tableData.value.map((d2) => getRowKey(d2)));
        }, 0);
      }
    });
  });
  function setSelectedRowKeys(rowKeys) {
    selectedRowKeysRef.value = rowKeys;
    const { childrenColumnName } = unref(propsRef);
    const rowKey2 = unref(getRowKeyRef);
    const getRowKey = (record) => isFunction$1(rowKey2) ? rowKey2(record) : record[rowKey2];
    const allRows = toRaw(unref(tableData)).concat(toRaw(unref(selectedRowsRef)));
    const allSelectedRows = [];
    for (const row of allRows) {
      if (rowKeys.includes(getRowKey(row))) {
        allSelectedRows.push(row);
        const children = row[childrenColumnName || "children"];
        if (children && children.length) {
          allRows.push(...children);
        }
      }
    }
    const trueSelectedRows = [];
    rowKeys.forEach((key2) => {
      const found = allSelectedRows.find((item) => getRowKey(item) === key2);
      found && trueSelectedRows.push(found);
    });
    selectedRowsRef.value = trueSelectedRows;
  }
  function getSelectRows() {
    return unref(selectedRowsRef);
  }
  function getSelectRowKeys() {
    return unref(selectedRowKeysRef);
  }
  function clearSelectedRowKeys() {
    selectedRowKeysRef.value = [];
    selectedRowsRef.value = [];
  }
  function deleteSelectRowByKey(key2) {
    const index2 = unref(selectedRowKeysRef).findIndex((item) => item === key2);
    if (index2 > -1) {
      unref(selectedRowKeysRef).splice(index2, 1);
    }
  }
  function getRowSelection() {
    return unref(getRowSelectionRef);
  }
  return {
    getRowSelectionRef,
    setSelectedRowKeys,
    getSelectRows,
    getSelectRowKeys,
    clearSelectedRowKeys,
    deleteSelectRowByKey,
    getRowSelection
  };
}
function getKey$1(record, rowKey2, autoCreateKey) {
  if (!rowKey2 || autoCreateKey) {
    return record[ROW_KEY$1];
  }
  if (isString$1(rowKey2)) {
    return record[rowKey2];
  }
  if (isFunction$1(rowKey2)) {
    return record[rowKey2(record)];
  }
  return null;
}
function useCustomRow$1(propsRef, {
  setSelectedRowKeys,
  getSelectRowKeys,
  getAutoCreateKeyRef,
  clearSelectedRowKeys,
  emit
}) {
  const customRow = (record, index2) => {
    return {
      onClick: (e2) => {
        e2 == null ? void 0 : e2.stopPropagation();
        function handleClick() {
          var _a2;
          const { rowSelection, rowKey: rowKey2, clickToRowSelect } = unref(propsRef);
          if (!rowSelection || !clickToRowSelect) {
            return;
          }
          const keys2 = getSelectRowKeys();
          const key2 = getKey$1(record, rowKey2, unref(getAutoCreateKeyRef));
          if (!key2) {
            return;
          }
          const isCheckbox = rowSelection.type === "checkbox";
          if (isCheckbox) {
            const tr = (_a2 = e2.composedPath) == null ? void 0 : _a2.call(e2).find((dom) => dom.tagName === "TR");
            if (!tr) {
              return;
            }
            const checkBox = tr.querySelector("input[type=checkbox]");
            if (!checkBox || checkBox.hasAttribute("disabled")) {
              return;
            }
            if (!keys2.includes(key2)) {
              setSelectedRowKeys([...keys2, key2]);
              return;
            }
            const keyIndex = keys2.findIndex((item) => item === key2);
            keys2.splice(keyIndex, 1);
            setSelectedRowKeys(keys2);
            return;
          }
          const isRadio = rowSelection.type === "radio";
          if (isRadio) {
            if (!keys2.includes(key2)) {
              if (keys2.length) {
                clearSelectedRowKeys();
              }
              setSelectedRowKeys([key2]);
              return;
            }
            clearSelectedRowKeys();
          }
        }
        handleClick();
        emit("row-click", record, index2, e2);
      },
      onDblclick: (event) => {
        emit("row-dbClick", record, index2, event);
      },
      onContextmenu: (event) => {
        emit("row-contextmenu", record, index2, event);
      },
      onMouseenter: (event) => {
        emit("row-mouseenter", record, index2, event);
      },
      onMouseleave: (event) => {
        emit("row-mouseleave", record, index2, event);
      }
    };
  };
  return {
    customRow
  };
}
function useTableStyle$1(propsRef, prefixCls2) {
  const { striped, rowClassName } = unref(propsRef);
  function getRowClassName(record, index2) {
    const classNames2 = [];
    if (striped && index2 % 2 === 1) {
      classNames2.push(`${prefixCls2}-row-striped`);
    }
    if (rowClassName && isFunction$1(rowClassName)) {
      classNames2.push(rowClassName(record, index2));
    }
    return classNames2.filter(Boolean).join(" ");
  }
  return {
    getRowClassName
  };
}
var TableTitle_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const _sfc_main$k = defineComponent({
  name: "HeaderTitle",
  inheritAttrs: false,
  props: {
    title: L([E(), P()]),
    helpMessage: L([E(), q()])
  },
  components: {
    FbuHelpTooltip
  },
  setup(props2) {
    const prefixCls2 = usePrefixCls("table-title");
    const { getSelectRows } = useTableContext$1();
    const getTitle = computed(() => {
      const { title } = props2;
      return isFunction$1(title) && title({ selectRows: getSelectRows() }) || title;
    });
    return {
      prefixCls: prefixCls2,
      getTitle
    };
  }
});
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FbuHelpTooltip = resolveComponent("FbuHelpTooltip");
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(_ctx.prefixCls)
  }, [
    createElementVNode("span", null, toDisplayString(_ctx.getTitle), 1),
    _ctx.helpMessage ? (openBlock(), createBlock(_component_FbuHelpTooltip, {
      key: 0,
      text: _ctx.helpMessage
    }, null, 8, ["text"])) : createCommentVNode("", true)
  ], 2);
}
var TableTitle$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$k, [["render", _sfc_render$f], ["__scopeId", "data-v-4fedf77a"]]);
var TableTitleAction_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const _sfc_main$j = defineComponent({
  name: "FbuTableTitleAction",
  inheritAttrs: false,
  components: {
    PopconfirmButton: _sfc_main$P,
    SvgIcon
  },
  props: {
    actions: q().def(() => [])
  },
  setup(props2) {
    function isIfShow(action) {
      const ifShow = action.ifShow;
      let isIfShow2 = true;
      if (isBoolean(ifShow)) {
        isIfShow2 = ifShow;
      }
      if (isFunction$1(ifShow)) {
        isIfShow2 = ifShow(action);
      }
      return isIfShow2;
    }
    const getActions = computed(() => {
      return (props2.actions || []).filter((action) => {
        return isIfShow(action);
      }).map((action) => {
        const { popConfirm } = action;
        return __spreadProps(__spreadValues(__spreadValues({
          type: "primary",
          size: "middle",
          ghost: true
        }, action), popConfirm || {}), {
          onConfirm: popConfirm == null ? void 0 : popConfirm.confirm,
          onCancel: popConfirm == null ? void 0 : popConfirm.cancel,
          onClick: () => {
            var _a2;
            (_a2 = action.onClick) == null ? void 0 : _a2.call(action, action);
          },
          enable: !!popConfirm
        });
      });
    });
    return {
      getActions
    };
  }
});
const _hoisted_1$f = { class: "title-action-wrap" };
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SvgIcon = resolveComponent("SvgIcon");
  const _component_PopconfirmButton = resolveComponent("PopconfirmButton");
  return openBlock(), createElementBlock("div", _hoisted_1$f, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.getActions, (action) => {
      return openBlock(), createBlock(_component_PopconfirmButton, mergeProps({
        key: `${action.label}`,
        class: "action-button mr-10"
      }, action), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "actionIcon", normalizeProps(guardReactiveProps(action)), () => [
            action.icon && !action.loading ? (openBlock(), createBlock(_component_SvgIcon, {
              key: 0,
              class: "action-icon",
              name: action.icon
            }, null, 8, ["name"])) : createCommentVNode("", true)
          ], true),
          action.label ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(action.label), 1)
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 2
      }, 1040);
    }), 128))
  ]);
}
var FbuTableTitleAction = /* @__PURE__ */ _export_sfc$1(_sfc_main$j, [["render", _sfc_render$e], ["__scopeId", "data-v-5ea5824a"]]);
var TableTabs_vue_vue_type_style_index_0_lang$1 = "";
const _sfc_main$i = defineComponent({
  name: "TableTabs",
  components: {
    Tabs,
    TabPane: Tabs.TabPane
  },
  inheritAttrs: false,
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["update:value", "tab-click"],
  setup(props2, { emit }) {
    const innerActivedKey = computed({
      get: () => props2.value,
      set: (key2) => {
        emit("update:value", key2);
      }
    });
    const handleTabClick = (activeKey) => {
      emit("tab-click", activeKey);
    };
    return {
      innerActivedKey,
      handleTabClick
    };
  }
});
const _hoisted_1$e = {
  key: 0,
  class: "table-tabs-wrapper"
};
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TabPane = resolveComponent("TabPane");
  const _component_Tabs = resolveComponent("Tabs");
  return _ctx.tabs && _ctx.tabs.length ? (openBlock(), createElementBlock("div", _hoisted_1$e, [
    createVNode(_component_Tabs, {
      activeKey: _ctx.innerActivedKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event) => _ctx.innerActivedKey = $event),
      size: "small",
      onTabClick: _ctx.handleTabClick
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab) => {
          return openBlock(), createBlock(_component_TabPane, {
            key: tab.key,
            tab: tab.label
          }, null, 8, ["tab"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey", "onTabClick"])
  ])) : createCommentVNode("", true);
}
var TableTabs$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$i, [["render", _sfc_render$d]]);
var TableHeader_vue_vue_type_style_index_0_lang$1 = "";
const _sfc_main$h = defineComponent({
  name: "TableHeader",
  components: {
    Divider: Divider$1,
    TableTitle: TableTitle$1,
    TableTitleAction: FbuTableTitleAction,
    Pagination: Pagination$1,
    TableTabs: TableTabs$1
  },
  props: {
    title: L([E(), P()]),
    tableSetting: A(),
    showSettingColumn: Boolean,
    titleHelpMessage: L([E(), q()]),
    titleActions: q()
  },
  emits: ["columns-change"],
  setup(_2, { emit }) {
    const prefixCls2 = usePrefixCls("table-header");
    const { getPaginationRef, setPagination, getBindValues, reload } = useTableContext$1();
    const pagination = computed(() => getPaginationRef());
    const paginationBinds = computed(() => {
      const paginationInfo = unref(pagination);
      return isPlainObject(paginationInfo) && paginationInfo || {};
    });
    const showPagination = computed(() => {
      return false;
    });
    const topTabs = computed(() => unref(getBindValues).topTabs);
    function handleColumnChange(data6) {
      emit("columns-change", data6);
    }
    function handlePaginationChange(current2, pageSize2) {
      setPagination({ current: current2, pageSize: pageSize2 });
      reload();
    }
    return __spreadValues({
      prefixCls: prefixCls2,
      handleColumnChange,
      showPagination,
      paginationBinds,
      handlePaginationChange,
      getBindValues
    }, unref(topTabs));
  }
});
const _hoisted_1$d = {
  key: 0,
  style: { "margin": "5px" }
};
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableTabs = resolveComponent("TableTabs");
  const _component_TableTitleAction = resolveComponent("TableTitleAction");
  const _component_TableTitle = resolveComponent("TableTitle");
  const _component_Pagination = resolveComponent("Pagination");
  const _component_Divider = resolveComponent("Divider");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([`${_ctx.prefixCls}-wrap`]),
    style: { "width": "100%" }
  }, [
    _ctx.$slots.headerTop ? (openBlock(), createElementBlock("div", _hoisted_1$d, [
      renderSlot(_ctx.$slots, "headerTop")
    ])) : createCommentVNode("", true),
    _ctx.$slots.headerTabs ? renderSlot(_ctx.$slots, "headerTabs", { key: 1 }) : createCommentVNode("", true),
    !_ctx.$slots.headerTabs && _ctx.getBindValues.sticky ? (openBlock(), createBlock(_component_TableTabs, {
      key: 2,
      value: _ctx.activedKey,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.activedKey = $event),
      tabs: _ctx.tabs,
      onTabClick: _ctx.handleTabClick
    }, null, 8, ["value", "tabs", "onTabClick"])) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass([`${_ctx.prefixCls}`, !_ctx.getBindValues.sticky && _ctx.getBindValues.pagination && `not-sticky`])
    }, [
      _ctx.titleActions ? (openBlock(), createBlock(_component_TableTitleAction, {
        key: 0,
        actions: _ctx.titleActions
      }, null, 8, ["actions"])) : createCommentVNode("", true),
      _ctx.$slots.tableTitle ? renderSlot(_ctx.$slots, "tableTitle", { key: 1 }) : createCommentVNode("", true),
      !_ctx.$slots.tableTitle && _ctx.title ? (openBlock(), createBlock(_component_TableTitle, {
        key: 2,
        helpMessage: _ctx.titleHelpMessage,
        title: _ctx.title
      }, null, 8, ["helpMessage", "title"])) : createCommentVNode("", true),
      _ctx.showPagination ? (openBlock(), createBlock(_component_Pagination, mergeProps({
        key: 3,
        class: _ctx.titleActions && _ctx.titleActions.length && "is-absolute",
        style: { marginLeft: "auto" }
      }, Object(_ctx.paginationBinds), { onChange: _ctx.handlePaginationChange }), null, 16, ["class", "onChange"])) : createCommentVNode("", true),
      createElementVNode("div", {
        class: normalizeClass(`${_ctx.prefixCls}__toolbar`)
      }, [
        renderSlot(_ctx.$slots, "toolbar"),
        _ctx.$slots.toolbar && _ctx.showSettingColumn ? (openBlock(), createBlock(_component_Divider, {
          key: 0,
          type: "vertical"
        })) : createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2);
}
var TableHeader$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$h, [["render", _sfc_render$c]]);
function useTableHeader$1(propsRef, slots, handlers) {
  const getHeaderProps = computed(() => {
    const { title, titleHelpMessage, showSettingColumn, tableSetting, titleActions } = unref(propsRef);
    const hideTitle = !slots.tableTitle && !title && !slots.toolbar && !showSettingColumn && !titleActions;
    if (hideTitle) {
      return {};
    }
    return {
      title: hideTitle ? null : () => h$2(TableHeader$1, {
        title,
        titleHelpMessage,
        showSettingColumn,
        tableSetting,
        titleActions,
        onColumnsChange: handlers.onColumnsChange
      }, __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, slots.toolbar ? {
        toolbar: () => {
          var _a2;
          return (_a2 = slots.toolbar) == null ? void 0 : _a2.call(slots);
        }
      } : {}), slots.tableTitle ? {
        tableTitle: () => {
          var _a2;
          return (_a2 = slots.tableTitle) == null ? void 0 : _a2.call(slots);
        }
      } : {}), slots.headerTop ? {
        headerTop: () => {
          var _a2;
          return (_a2 = slots.headerTop) == null ? void 0 : _a2.call(slots);
        }
      } : {}), slots.headerTabs ? {
        headerTabs: () => {
          var _a2;
          return (_a2 = slots.headerTabs) == null ? void 0 : _a2.call(slots);
        }
      } : {}))
    };
  });
  return { getHeaderProps };
}
function useTableExpand$1(propsRef, tableData, emit) {
  const expandedRowKeysRef = ref([]);
  const getRowKeyRef = computed(() => {
    const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
    return rowKey2 || autoCreateKey && ROW_KEY$1 || "";
  });
  const getExpandedBindsRef = computed(() => {
    const { isTreeTable } = unref(propsRef);
    if (!isTreeTable) {
      return {};
    }
    return {
      expandedRowKeys: unref(expandedRowKeysRef),
      onExpandedRowsChange: (expandedRows) => {
        expandedRowKeysRef.value = expandedRows;
        emit("expanded-rows-change", expandedRows);
      }
    };
  });
  function getAllKeys2(data6) {
    const result = [];
    const { childrenColumnName } = unref(propsRef);
    const rowKey2 = unref(getRowKeyRef);
    const getRowKey = (record) => isFunction$1(rowKey2) ? rowKey2(record) : record[rowKey2];
    toRaw(data6 || unref(tableData)).forEach((item) => {
      result.push(getRowKey(item));
      const children = item[childrenColumnName || "children"];
      if (children && (children == null ? void 0 : children.length)) {
        result.push(...getAllKeys2(children));
      }
    });
    return result;
  }
  function getExpandedKeys() {
    return unref(expandedRowKeysRef);
  }
  function expandRows(keys2) {
    expandedRowKeysRef.value = [...unref(expandedRowKeysRef), ...keys2];
  }
  function expandAll() {
    expandedRowKeysRef.value = getAllKeys2();
  }
  function collapseAll() {
    expandedRowKeysRef.value = [];
  }
  return {
    getRowKeyRef,
    getExpandedBindsRef,
    expandRows,
    expandAll,
    collapseAll,
    getExpandedKeys
  };
}
function useTableScroll(propsRef, tableElRef, columnsRef, rowSelectionRef, getDataSourceRef, wrapRef, formRef) {
  const tableHeightRef = ref(167);
  const debounceRedoHeight = debounce(redoHeight, 100);
  const getCanResize = computed(() => {
    const { canResize, scroll } = unref(propsRef);
    return canResize && !(scroll || {}).y;
  });
  watch(() => {
    var _a2;
    return [unref(getCanResize), (_a2 = unref(getDataSourceRef)) == null ? void 0 : _a2.length];
  }, () => {
    redoHeight();
  }, {
    flush: "post"
  });
  function redoHeight() {
    nextTick(() => {
      calcTableHeight();
    });
  }
  function setHeight(height) {
    tableHeightRef.value = height;
  }
  let paginationEl;
  let footerEl;
  let bodyEl;
  async function calcTableHeight() {
    var _a2, _b, _c, _d, _e, _f, _g;
    const { resizeHeightOffset, pagination, maxHeight, isCanResizeParent } = unref(propsRef);
    const tableData = unref(getDataSourceRef);
    const table = unref(tableElRef);
    if (!table)
      return;
    const tableEl = table.$el;
    if (!tableEl)
      return;
    if (!bodyEl) {
      bodyEl = tableEl.querySelector(".ant-table-body");
      if (!bodyEl) {
        return;
      }
    }
    const hasScrollBarY = bodyEl.scrollHeight > bodyEl.clientHeight;
    const hasScrollBarX = bodyEl.scrollWidth > bodyEl.clientWidth;
    if (hasScrollBarY) {
      tableEl.classList.contains("hide-scrollbar-y") && tableEl.classList.remove("hide-scrollbar-y");
    } else {
      !tableEl.classList.contains("hide-scrollbar-y") && tableEl.classList.add("hide-scrollbar-y");
    }
    if (hasScrollBarX) {
      tableEl.classList.contains("hide-scrollbar-x") && tableEl.classList.remove("hide-scrollbar-x");
    } else {
      !tableEl.classList.contains("hide-scrollbar-x") && tableEl.classList.add("hide-scrollbar-x");
    }
    bodyEl.style.height = "unset";
    if (!unref(getCanResize) || tableData.length === 0)
      return;
    await nextTick();
    const headEl = tableEl.querySelector(".ant-table-thead ");
    if (!headEl)
      return;
    let paginationHeight = 10;
    if (pagination) {
      paginationEl = tableEl.querySelector(".ant-pagination");
      if (paginationEl) {
        const offsetHeight = paginationEl.offsetHeight;
        paginationHeight += offsetHeight || 0;
      } else {
        paginationHeight += 28;
      }
    }
    let footerHeight = 0;
    if (!isBoolean(pagination)) {
      if (!footerEl) {
        footerEl = tableEl.querySelector(".ant-table-footer");
      } else {
        const offsetHeight = footerEl.offsetHeight;
        footerHeight += offsetHeight || 0;
      }
    }
    let headerHeight = 0;
    if (headEl) {
      headerHeight = headEl.offsetHeight;
    }
    let bottomIncludeBody = 0;
    if (unref(wrapRef) && isCanResizeParent) {
      const tablePadding = 12;
      const formMargin = 16;
      let paginationMargin = 10;
      const wrapHeight = (_b = (_a2 = unref(wrapRef)) == null ? void 0 : _a2.offsetHeight) != null ? _b : 0;
      let formHeight = (_d = (_c = unref(formRef)) == null ? void 0 : _c.$el.offsetHeight) != null ? _d : 0;
      if (formHeight) {
        formHeight += formMargin;
      }
      if (isBoolean(pagination) && !pagination) {
        paginationMargin = 0;
      }
      const headerCellHeight = (_f = (_e = tableEl.querySelector(".ant-table-title")) == null ? void 0 : _e.offsetHeight) != null ? _f : 0;
      bottomIncludeBody = wrapHeight - formHeight - headerCellHeight - tablePadding - paginationMargin;
    } else {
      bottomIncludeBody = getViewportOffset(headEl).bottomIncludeBody;
    }
    let height = bottomIncludeBody - (resizeHeightOffset || 0) - paginationHeight - footerHeight - headerHeight;
    height = (_g = height > maxHeight ? maxHeight : height) != null ? _g : height;
    setHeight(height);
  }
  const calcTableHeightDebounce = debounce(calcTableHeight, 280);
  onMounted(() => {
    calcTableHeight();
    nextTick(() => {
      debounceRedoHeight();
    });
    window.addEventListener("resize", calcTableHeightDebounce);
  });
  onUnmounted(() => {
    window.removeEventListener("resize", calcTableHeightDebounce);
  });
  const getScrollX = computed(() => {
    var _a2, _b;
    let width = 0;
    if (unref(rowSelectionRef)) {
      width += 60;
    }
    const NORMAL_WIDTH = 150;
    const columns2 = unref(columnsRef).filter((item) => !item.defaultHidden);
    columns2.forEach((item) => {
      width += Number.parseInt(item.width) || 0;
    });
    const unsetWidthColumns = columns2.filter((item) => !Reflect.has(item, "width"));
    const len = unsetWidthColumns.length;
    if (len !== 0) {
      width += len * NORMAL_WIDTH;
    }
    const table = unref(tableElRef);
    const tableWidth = (_b = (_a2 = table == null ? void 0 : table.$el) == null ? void 0 : _a2.offsetWidth) != null ? _b : 0;
    return tableWidth > width ? "100%" : width;
  });
  const getScrollRef = computed(() => {
    const tableHeight = unref(tableHeightRef);
    const { canResize, scroll, size, resizeFlow, enableResponseNumber = 6 } = unref(propsRef);
    const tableData = unref(getDataSourceRef);
    const cellHeight = size === "default" ? 64 : size === "middle" ? 55 : size === "small" ? 46 : 64;
    const yScroll = resizeFlow ? (tableHeight || 0) < tableData.length * cellHeight ? tableHeight : null : tableHeight;
    const newScroll = Object.assign({}, scroll);
    newScroll.x = columnsRef.value.filter((item) => !item.defaultHidden).length <= enableResponseNumber ? "100%" : newScroll.x;
    return __spreadValues({
      x: unref(getScrollX),
      y: canResize ? yScroll : null,
      scrollToFirstRowOnChange: false
    }, newScroll);
  });
  return {
    getScrollX,
    getScrollRef,
    redoHeight
  };
}
function useTableForm$1(propsRef, slots, fetch, getLoading) {
  const getFormProps = computed(() => {
    const { formConfig, cacheName } = unref(propsRef);
    const { submitButtonOptions } = formConfig || {};
    return __spreadProps(__spreadValues({}, formConfig), {
      submitButtonOptions: __spreadProps(__spreadValues({}, submitButtonOptions), { loading: unref(getLoading) }),
      cacheName
    });
  });
  const getFormSlotKeys = computed(() => {
    const keys2 = Object.keys(slots);
    return keys2.filter((item) => item.startsWith("form-"));
  });
  function replaceFormSlotKey(key2) {
    var _a2, _b;
    return (_b = (_a2 = key2 == null ? void 0 : key2.replace) == null ? void 0 : _a2.call(key2, /form-/, "")) != null ? _b : "";
  }
  function handleSearchInfoChange(info) {
    const { handleSearchInfoFn } = unref(propsRef);
    if (handleSearchInfoFn && isFunction$1(handleSearchInfoFn)) {
      info = handleSearchInfoFn(info) || info;
    }
    fetch({ searchInfo: info, page: 1 });
  }
  function handleUpdateSchemes(newSchemes) {
    const { handleSchemeChangeFn, fetchOnSchemeChanged } = unref(propsRef);
    if (!fetchOnSchemeChanged) {
      return;
    }
    if (handleSchemeChangeFn && isFunction$1(handleSchemeChangeFn)) {
      handleSchemeChangeFn(newSchemes);
    }
    setTimeout(() => {
      fetch({ page: 1 });
    }, 10);
  }
  return {
    getFormProps,
    replaceFormSlotKey,
    getFormSlotKeys,
    handleSearchInfoChange,
    handleUpdateSchemes
  };
}
function useTableScrollTo(tableElRef, getDataSourceRef) {
  let bodyEl;
  async function findTargetRowToScroll(targetRowData) {
    var _a2;
    const { id } = targetRowData;
    const targetRowEl = bodyEl == null ? void 0 : bodyEl.querySelector(`[data-row-key="${id}"]`);
    await nextTick();
    bodyEl == null ? void 0 : bodyEl.scrollTo({
      top: (_a2 = targetRowEl == null ? void 0 : targetRowEl.offsetTop) != null ? _a2 : 0,
      behavior: "smooth"
    });
  }
  function scrollTo2(pos) {
    const table = unref(tableElRef);
    if (!table)
      return;
    const tableEl = table.$el;
    if (!tableEl)
      return;
    if (!bodyEl) {
      bodyEl = tableEl.querySelector(".ant-table-body");
      if (!bodyEl)
        return;
    }
    const dataSource = unref(getDataSourceRef);
    if (!dataSource)
      return;
    if (pos === "top") {
      findTargetRowToScroll(dataSource[0]);
    } else if (pos === "bottom") {
      findTargetRowToScroll(dataSource[dataSource.length - 1]);
    } else {
      const targetRowData = dataSource.find((data6) => data6.id === pos);
      if (targetRowData) {
        findTargetRowToScroll(targetRowData);
      } else {
        console.warn(`id: ${pos} doesn't exist`);
      }
    }
  }
  return { scrollTo: scrollTo2 };
}
function useTableTabs$1(props2, fetch, emit) {
  const activedKey = ref();
  const tabs = ref();
  const fetchOnChanged = ref(true);
  watch(() => props2.value.topTabs, () => {
    const { topTabsActivedKey, topTabs } = unref(props2);
    activedKey.value = topTabsActivedKey || topTabs && topTabs[0].key;
    tabs.value = topTabs;
  }, {
    immediate: true
  });
  watch(() => props2.value.topTabsActivedKey, (key2) => {
    activedKey.value = key2;
  });
  watch(activedKey, (newKey, oldKey) => {
    if (!fetchOnChanged.value) {
      return;
    }
    const { topTabsFetchParamkey } = unref(props2);
    if (topTabsFetchParamkey) {
      if (newKey !== void 0 && oldKey === void 0) {
        unref(props2).searchInfo = __spreadProps(__spreadValues({}, unref(props2).searchInfo || {}), {
          [topTabsFetchParamkey]: newKey === -1 ? void 0 : newKey
        });
      } else {
        fetch({ searchInfo: { [topTabsFetchParamkey]: newKey === -1 ? void 0 : newKey } });
      }
    }
  }, { immediate: true });
  function handleTabClick(activeKey) {
    emit("tab-click", activeKey);
  }
  function getTabData() {
    const { topTabsFetchParamkey } = unref(props2);
    const tabKey = unref(activedKey);
    return topTabsFetchParamkey ? { [topTabsFetchParamkey]: tabKey === -1 ? void 0 : tabKey } : {};
  }
  function resetActivedKey() {
    activedKey.value = props2.value.topTabs && props2.value.topTabs[0].key;
    fetchOnChanged.value = false;
    nextTick(() => {
      fetchOnChanged.value = true;
    });
  }
  return {
    tabs,
    activedKey,
    handleTabClick,
    getTabData,
    resetActivedKey
  };
}
function useTableSticky(props2, tableElRef, setProps, getPaginationInfo) {
  function postionSticky() {
    var _a2;
    const { sticky, canResize, settingColumnProps, columns: columns2, stickyTitle } = unref(props2);
    if (!sticky || canResize) {
      return;
    }
    const table = unref(tableElRef);
    if (!table) {
      return;
    }
    const tableEl = table.$el;
    const stickyElm = tableEl.querySelector(".ant-table-sticky-holder");
    if (stickyElm && stickyTitle) {
      stickyTableTitle(tableEl);
      return;
    }
    const columnSettingElm = tableEl.querySelector(".fbu-table-settings");
    if (!stickyElm || !columnSettingElm) {
      return;
    }
    const foundSettingColumn = (columns2 || []).find((column) => column.flag === SETTING_COLUMN_INDEX$1);
    const settingsColumnData = settingColumnProps || foundSettingColumn || {};
    css$1(columnSettingElm, {
      position: "static",
      right: ~~((+(settingsColumnData.width || 50) - 16) / 2) + "px",
      bottom: (stickyElm.offsetHeight - columnSettingElm.offsetHeight) / 2 + "px"
    });
    (_a2 = stickyElm.querySelector("tr:first-child th:last-child")) == null ? void 0 : _a2.appendChild(columnSettingElm);
    if (stickyTitle) {
      stickyTableTitle(tableEl);
    }
  }
  function stickyTableTitle(tableEl) {
    const tableTitleElm = tableEl.querySelector(".ant-table-title");
    if (!tableTitleElm) {
      return;
    }
    const { sticky } = unref(props2);
    const stickyTop = isPlainObject(sticky) ? sticky.offsetHeader || 0 : 0;
    const calcSticky = () => {
      setProps({ sticky: { offsetHeader: stickyTop + tableTitleElm.offsetHeight } });
    };
    css$1(tableTitleElm, {
      position: "sticky",
      top: stickyTop + "px",
      background: "#fff",
      zIndex: 4
    });
    calcSticky();
    watch(() => {
      if (typeof getPaginationInfo.value !== "boolean") {
        return getPaginationInfo.value.total;
      }
    }, () => {
      nextTick(() => {
        calcSticky();
      });
    });
  }
  onMounted(() => {
    setTimeout(() => {
      nextTick(postionSticky);
    }, 50);
  });
}
function useDragScroll(tableElRef, propsRef, columns2) {
  const isDragging = ref(false);
  const isLongPressed = ref(false);
  const scrollLeft = ref(0);
  const dragStartPosition = ref([0, 0]);
  const initialScrollLeft = ref(0);
  const maximumScrollLeft = ref(0);
  const maxDiffX = 10;
  const maxDiffY = 10;
  const longPressDelayInMs = propsRef.value.draggableScrollDelay || 1500;
  const offsetXAtLeft = ref(0);
  const offsetXAtRight = ref(0);
  let timer = void 0;
  let cancelListeners = null;
  const getTBody = () => {
    var _a2;
    return (_a2 = tableElRef.value) == null ? void 0 : _a2.$el.querySelector(".ant-table-body");
  };
  watch(isLongPressed, () => {
    var _a2;
    (_a2 = getTBody()) == null ? void 0 : _a2.classList.toggle("is-long-pressed");
  });
  watch(scrollLeft, (value) => {
    const tbody = getTBody();
    if (tbody) {
      tbody.scrollLeft = value;
    }
  });
  const fixedLeftWidthRef = computed(() => {
    let width = unref(columns2).filter((column) => column.fixed === "left").reduce((sum2, column) => {
      sum2 += Number.parseInt(column.width || "", 10) || 150;
      return sum2;
    }, 0);
    if (unref(propsRef).rowSelection) {
      width = width + 60;
    }
    return width;
  });
  const fixedRightWidthRef = computed(() => {
    const width = unref(columns2).filter((column) => column.fixed === "right").reduce((sum2, column) => {
      sum2 += Number.parseInt(column.width || "", 10) || 150;
      return sum2;
    }, 0);
    return width;
  });
  const onWheel = (e2) => {
    if (!maximumScrollLeft.value) {
      getInitialPosition();
    }
    const pageX = e2.pageX;
    if (maximumScrollLeft.value <= 0 || pageX <= offsetXAtLeft.value + (fixedLeftWidthRef.value || 100) || pageX >= offsetXAtRight.value - (fixedRightWidthRef.value || 100)) {
      return;
    }
    e2.preventDefault();
    let currentScrollLeft = scrollLeft.value + Math.max(e2.deltaY || e2.deltaX);
    currentScrollLeft = Math.max(0, Math.min(currentScrollLeft, maximumScrollLeft.value));
    scrollLeft.value = currentScrollLeft;
  };
  const getInitialPosition = () => {
    if (tableElRef.value) {
      const tbodyEl = getTBody();
      const { scrollLeft: scrollLeft2, scrollWidth, clientWidth } = tbodyEl;
      initialScrollLeft.value = scrollLeft2;
      maximumScrollLeft.value = scrollWidth - clientWidth;
      if (propsRef.value.horizontalScrollUsingWheel) {
        const boundingRect2 = tbodyEl.getBoundingClientRect();
        offsetXAtLeft.value = boundingRect2.left;
        offsetXAtRight.value = boundingRect2.right;
      }
    }
  };
  const clearLongPressTimer = () => {
    clearTimeout(timer);
    timer = void 0;
  };
  const startLongPressTimer = () => {
    clearLongPressTimer();
    timer = window.setTimeout(() => {
      isLongPressed.value = true;
    }, longPressDelayInMs);
  };
  const handleMoveStart = (e2) => {
    isDragging.value = true;
    dragStartPosition.value = [e2.clientX, e2.clientY];
    getInitialPosition();
    startLongPressTimer();
    window.addEventListener("mousemove", handleMouseMove, false);
    window.addEventListener("mouseup", handleMouseUp, false);
    window.addEventListener("contextmenu", handleMouseUp, false);
  };
  const handleMouseMove = (e2) => {
    if (isDragging.value) {
      const diffX = e2.clientX - dragStartPosition.value[0];
      const diffY = e2.clientY - dragStartPosition.value[1];
      if ((diffX >= maxDiffX || diffY >= maxDiffY) && !isLongPressed.value) {
        return clearLongPressTimer();
      }
      if (isLongPressed.value) {
        let currentScrollLeft = initialScrollLeft.value + diffX;
        currentScrollLeft = Math.max(0, Math.min(currentScrollLeft, maximumScrollLeft.value));
        scrollLeft.value = currentScrollLeft;
      }
    }
  };
  const handleMouseUp = () => {
    isDragging.value = false;
    isLongPressed.value = false;
    clearLongPressTimer();
    window.removeEventListener("mousemove", handleMouseMove, false);
    window.removeEventListener("mouseup", handleMouseUp, false);
    window.removeEventListener("contextmenu", handleMouseUp, false);
  };
  const initializeWheelListener = () => {
    var _a2, _b, _c;
    const { horizontalScrollUsingWheel } = propsRef.value;
    (_a2 = tableElRef.value) == null ? void 0 : _a2.$el.addEventListener("mousedown", handleMoveStart, false);
    horizontalScrollUsingWheel && ((_b = tableElRef.value) == null ? void 0 : _b.$el.addEventListener("wheel", onWheel, false));
    const resizeObserver = new ResizeObserver(() => {
      maximumScrollLeft.value = 0;
    });
    resizeObserver.observe((_c = tableElRef.value) == null ? void 0 : _c.$el);
    return () => {
      var _a3, _b2;
      (_a3 = tableElRef.value) == null ? void 0 : _a3.$el.removeEventListener("mousedown", handleMoveStart, false);
      horizontalScrollUsingWheel && ((_b2 = tableElRef.value) == null ? void 0 : _b2.$el.removeEventListener("wheel", onWheel, false));
      resizeObserver.disconnect();
    };
  };
  onMounted(() => {
    if (propsRef.value.draggableScroll) {
      nextTick(() => {
        cancelListeners = initializeWheelListener();
      });
    }
  });
  onBeforeUnmount(() => {
    cancelListeners && cancelListeners();
  });
  return {
    scrollLeft,
    handleMoveStart
  };
}
var ScrollDirection;
(function(ScrollDirection2) {
  ScrollDirection2["up"] = "up";
  ScrollDirection2["down"] = "down";
})(ScrollDirection || (ScrollDirection = {}));
const useVirtual = (props2, dataSource, isVirtualList, tableElRef, emit, startIndex) => {
  const rowHeight = ref(props2.rowHeight);
  const scrollHeight = computed(() => {
    const { maxHeight, scroll } = props2;
    if (maxHeight)
      return maxHeight;
    if (scroll && scroll.y)
      return scroll.y;
    return 716;
  });
  const virtualData = ref([]);
  const virtualDoms = {
    pillar: document.createElement("div"),
    tableEl: null,
    tableBody: null,
    tableContent: null
  };
  const coef = computed(() => Math.ceil(scrollHeight.value / rowHeight.value) + props2.virtualOffset);
  const offsetStore = {
    pillarHeight: 0,
    scrollTop: 0,
    index: 0
  };
  const offsetContent = (top) => {
    if (top > 1)
      top = top - top % rowHeight.value;
    virtualDoms.tableContent.style.transform = `translateY(${top}px)`;
  };
  const computedPillarHeight = (len) => {
    const pillarHeight = (len - coef.value) * rowHeight.value;
    offsetStore.pillarHeight = pillarHeight < 0 ? 0 : pillarHeight;
    virtualDoms.pillar.style.height = `${offsetStore.pillarHeight}px`;
  };
  function computedRowHeight() {
    if (!virtualDoms.tableContent)
      return;
    nextTick(() => {
      const tr = virtualDoms.tableContent.querySelector(".ant-table-row-level-0");
      rowHeight.value = (tr == null ? void 0 : tr.clientHeight) || rowHeight.value;
      computedPillarHeight(dataSource.value.length);
      virtualScrollFunc();
    });
  }
  watch(() => dataSource.value, (val) => {
    if (!isVirtualList.value)
      return;
    computedRowHeight();
    virtualData.value = val.slice(0, coef.value);
    if (virtualDoms.tableBody) {
      virtualDoms.tableBody.scrollTo(0, 0);
      offsetContent(0);
    }
  });
  const offsetDataSource = (start2, end, direction2) => {
    startIndex.value = start2;
    let temp = dataSource.value.slice(start2, end);
    if (temp.length >= coef.value) {
      virtualData.value = temp;
      if (direction2 === ScrollDirection.down)
        offsetContent(offsetStore.scrollTop);
      return;
    }
    if (direction2 === ScrollDirection.down || start2 >= dataSource.value.length) {
      const s2 = dataSource.value.length - coef.value;
      startIndex.value = s2;
      temp = dataSource.value.slice(s2);
      offsetContent(offsetStore.pillarHeight);
    } else if (direction2 === ScrollDirection.up) {
      temp = dataSource.value.slice(0, coef.value);
      startIndex.value = 0;
    }
    virtualData.value = temp;
  };
  function virtualScrollFunc() {
    const { scrollTop } = virtualDoms.tableBody;
    offsetStore.scrollTop = scrollTop;
    const index2 = Math.floor(offsetStore.scrollTop / rowHeight.value);
    const direction2 = index2 >= offsetStore.index ? ScrollDirection.down : ScrollDirection.up;
    emit({ scrollTop, direction: direction2 });
    if (dataSource.value.length < coef.value + 5) {
      virtualData.value = dataSource.value;
      virtualDoms.pillar.style.height = "0px";
      return;
    }
    if (direction2 === ScrollDirection.down) {
      offsetDataSource(index2, index2 + coef.value, ScrollDirection.down);
    } else {
      const topOffset = index2 - props2.virtualOffset;
      const newindex = topOffset <= 0 ? 0 : topOffset;
      offsetDataSource(newindex, index2 + coef.value, ScrollDirection.up);
      const top = newindex === 0 ? 0 : offsetStore.scrollTop - rowHeight.value * props2.virtualOffset;
      offsetContent(top);
    }
    offsetStore.index = index2;
    if (offsetStore.scrollTop < 1)
      offsetContent(0);
  }
  const virtualScrollHandler = virtualScrollFunc;
  function initVirtualDoms() {
    const tableEl = tableElRef.value.$el;
    Object.assign(virtualDoms, {
      tableEl,
      tableBody: tableEl.querySelector(".ant-table-body"),
      tableContent: tableEl.querySelector(".ant-table-body table")
    });
  }
  function initVirtual() {
    virtualDoms.tableBody.appendChild(virtualDoms.pillar);
    virtualDoms.tableContent.style.transform = `translateY(0)`;
    virtualDoms.tableBody.addEventListener("scroll", virtualScrollHandler);
  }
  const virtualSetup = () => {
    if (!isVirtualList.value)
      return;
    initVirtualDoms();
    initVirtual();
    computedRowHeight();
  };
  const unVirtual = () => {
    if (!isVirtualList.value)
      return;
    virtualDoms.tableBody.removeEventListener("scroll", virtualScrollHandler);
  };
  const virtualScrollToTop = () => {
    var _a2;
    if (!virtualDoms.tableBody)
      return;
    (_a2 = virtualDoms.tableBody) == null ? void 0 : _a2.scrollTo(0, 0);
  };
  const virtualScrollToBottom = () => {
    var _a2;
    if (!virtualDoms.tableBody)
      return;
    (_a2 = virtualDoms.tableBody) == null ? void 0 : _a2.scrollTo(0, 999999999);
  };
  const switchPillar = (show) => {
    virtualDoms.pillar.style.display = show ? "block" : "none";
  };
  return {
    virtualData,
    virtualSetup,
    unVirtual,
    virtualScrollToTop,
    virtualScrollToBottom,
    switchPillar,
    computedRowHeight
  };
};
const useProps$1 = {
  clickToRowSelect: x().def(false),
  isTreeTable: Boolean,
  tableSetting: A().def({}),
  showTableSetting: x().def(false),
  inset: x().def(true),
  sortFn: P().def(() => DEFAULT_SORT_FN$1),
  filterFn: P().def(() => DEFAULT_FILTER_FN$1),
  autoCreateKey: x().def(true),
  striped: x().def(true),
  indentSize: N().def(20),
  api: P(),
  beforeFetch: P(),
  afterFetch: P(),
  handleSearchInfoFn: P(),
  fetchSetting: A().def(() => FETCH_SETTING$1),
  immediate: x().def(true),
  emptyDataIsShowTable: x().def(true),
  searchInfo: A(),
  defSort: A(),
  useSearchForm: x(),
  formConfig: A(),
  columns: q().def([]),
  showIndexColumn: x().def(true),
  indexColumnProps: A(),
  actionColumn: A(),
  ellipsis: x().def(true),
  canResize: x().def(false),
  isCanResizeParent: x().def(false),
  clearSelectOnPageChange: x().def(true),
  resizeHeightOffset: N().def(0),
  rowSelection: L([]).def(() => ({ type: "checkbox" })),
  title: L([]),
  titleHelpMessage: L([E(), q()]),
  maxHeight: N(),
  dataSource: A(),
  rowKey: L([String, P()]),
  bordered: x().def(false),
  pagination: L([Boolean, A()]),
  loading: x().def(false),
  rowClassName: P(),
  scroll: A(),
  beforeEditSubmit: P(),
  size: E().def(DEFAULT_SIZE$1),
  cacheName: E(),
  cacheEnable: x().def(true),
  titleActions: q(),
  showSettingColumn: x().def(true),
  fixTitleEmpty: x().def(false),
  topTabs: q(),
  topTabsActivedKey: L([String, Number]).def(""),
  topTabsFetchParamkey: E(),
  sticky: L([
    Boolean,
    A()
  ]).def(false),
  stickyTitle: x().def(false),
  showScrollBtns: x().def(false),
  resizeFlow: x().def(true),
  customPagination: x().def(false),
  customPaginationSizeChangerSuffix: E().def("\u6761/\u9875"),
  settingColumnProps: A().def({}),
  draggableScroll: x().def(true),
  draggableScrollDelay: N().def(1500),
  horizontalScrollUsingWheel: x().def(false),
  rowHeight: N().def(40),
  virtualList: x().def(false),
  virtualOffset: N().def(2),
  customMaxPageSize: N().def(1500),
  enableResponseWhenAllFixed: x().def(false),
  enableResponseNumber: N().def(6),
  emptyText: E(),
  t: P(),
  enableLoading: x().def(false),
  fetchOnSchemeChanged: x().def(true),
  handleSchemeChangeFn: P(),
  emptyAfterFetch: P(),
  emptyInFetching: P(),
  enableProgressLoading: x().def(false)
};
var ColumnSettingIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$g = defineComponent({
  setup() {
    return {};
  }
});
const _withScopeId = (n2) => (pushScopeId("data-v-24561516"), n2 = n2(), popScopeId(), n2);
const _hoisted_1$c = { class: "column-setting-icon" };
const _hoisted_2$4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M10.0002 7C10.0002 8.65685 8.65702 10 7.00017 10C5.34331 10 4.00017 8.65685 4.00017 7C4.00017 5.34315 5.34331 4 7.00017 4C8.65702 4 10.0002 5.34315 10.0002 7ZM9.00017 7C9.00017 5.89543 8.10474 5 7.00017 5C5.8956 5 5.00017 5.89543 5.00017 7C5.00017 8.10457 5.8956 9 7.00017 9C8.10474 9 9.00017 8.10457 9.00017 7Z" }),
  /* @__PURE__ */ createElementVNode("path", { d: "M7.00017 0.25L13.0623 3.625V10.375L7.00017 13.75L0.937988 10.375V3.625L7.00017 0.25ZM1.93799 4.2128V9.7872L7.00017 12.6055L12.0623 9.7872V4.2128L7.00017 1.39453L1.93799 4.2128Z" })
], -1));
const _hoisted_3$3 = [
  _hoisted_2$4
];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1$c, _hoisted_3$3);
}
var ColumnSettingIcon = /* @__PURE__ */ _export_sfc$1(_sfc_main$g, [["render", _sfc_render$b], ["__scopeId", "data-v-24561516"]]);
var ColumnDragIcon = () => {
  return createVNode("svg", {
    "width": "16",
    "height": "14",
    "viewBox": "0 0 16 14",
    "fill": "currentColor"
  }, [createVNode("path", {
    "d": "M4.97882 3.63102C5.0975 3.761 5.25856 3.82599 5.41963 3.82599C5.56374 3.82599 5.71067 3.7723 5.8237 3.66775C6.06954 3.44169 6.08367 3.06023 5.86044 2.81722L3.45295 0.186496C3.22689 -0.0621652 2.79456 -0.0621652 2.5685 0.186496L0.158188 2.81722C-0.0678677 3.06305 -0.0509134 3.44452 0.194922 3.66775C0.440757 3.8938 0.8194 3.87685 1.04546 3.63102L2.41309 2.13905V11.413L1.04546 9.92101C0.8194 9.67517 0.440757 9.66104 0.194922 9.88427C-0.0509134 10.1103 -0.065042 10.4918 0.158188 10.7348L2.5685 13.3655L2.57698 13.374C2.59394 13.391 2.61654 13.4079 2.63632 13.4249L2.67023 13.4531C2.69283 13.4701 2.71827 13.4814 2.74652 13.4955C2.755 13.5012 2.76348 13.5068 2.77478 13.5125C2.80586 13.5266 2.83977 13.5351 2.87368 13.5435L2.89063 13.5492C2.93019 13.5577 2.96975 13.5633 3.01214 13.5633C3.05452 13.5633 3.09691 13.5577 3.13364 13.5492L3.1506 13.5435C3.1845 13.5351 3.21841 13.5266 3.2495 13.5125C3.25797 13.5096 3.26645 13.5012 3.27775 13.4983C3.30318 13.4842 3.32862 13.4729 3.35405 13.456C3.36535 13.4475 3.37665 13.439 3.38796 13.4277L3.44729 13.3768L3.45577 13.3684L5.86609 10.7376C6.09214 10.4918 6.07519 10.1103 5.82935 9.8871C5.58352 9.66105 5.20488 9.678 4.97882 9.92383L3.61118 11.4158V2.13905L4.97882 3.63102ZM15.2785 3.08001H7.6491C7.25915 3.08001 6.94268 2.76353 6.94268 2.37358C6.94268 1.98364 7.25915 1.66716 7.6491 1.66716H15.2785C15.6684 1.66716 15.9849 1.98364 15.9849 2.37358C15.9849 2.76353 15.6684 3.08001 15.2785 3.08001ZM15.2926 7.45983H7.66323C7.27328 7.45983 6.95681 7.14335 6.95681 6.75341C6.95681 6.36346 7.27328 6.04698 7.66323 6.04698H15.2926C15.6825 6.04698 15.999 6.36346 15.999 6.75341C15.999 7.14335 15.6825 7.45983 15.2926 7.45983ZM15.2926 11.8397H7.66323C7.27328 11.8397 6.95681 11.5232 6.95681 11.1332C6.95681 10.7433 7.27328 10.4268 7.66323 10.4268H15.2926C15.6825 10.4268 15.999 10.7433 15.999 11.1332C15.999 11.5232 15.6825 11.8397 15.2926 11.8397Z"
  }, null)]);
};
var ColumnSettingInTable_vue_vue_type_style_index_0_lang = "";
const _sfc_main$f = defineComponent({
  name: "ColumnSetting",
  components: {
    Popover: Popover$1,
    Tooltip,
    Checkbox,
    CheckboxGroup: Checkbox.Group,
    ColumnSettingIcon,
    RedoOutlined: RedoOutlined$1,
    ColumnDragIcon
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: Object,
      default: null
    },
    extra: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["columns-change"],
  setup(_2, { emit, attrs }) {
    const table = useTableContext$1();
    const defaultRowSelection = omit(table.getRowSelection(), "selectedRowKeys");
    let inited = false;
    const plainOptions = ref([]);
    const plainSortOptions = ref([]);
    const columnListRef = ref(null);
    const state = reactive({
      checkAll: true,
      checkedList: [],
      defaultCheckList: []
    });
    const checkIndex = ref(false);
    const checkSelect = ref(false);
    const prefixCls2 = usePrefixCls("fbu-column-setting");
    const getValues = computed(() => {
      return unref(table == null ? void 0 : table.getBindValues) || {};
    });
    const innerColumnsMap = computed(() => {
      return table.innerColumnsMap || {};
    });
    watchEffect(() => {
      const columns2 = table.getColumns();
      if (columns2.length && !state.isInit) {
        init();
      }
    });
    watchEffect(() => {
      const values = unref(getValues);
      checkIndex.value = !!values.showIndexColumn;
      checkSelect.value = !!values.rowSelection;
    });
    function getColumns() {
      const ret = [];
      table.getColumns({ ignoreAction: true, ignoreSetting: true }).forEach((item) => {
        ret.push(__spreadValues({
          label: item.title || item.customTitle,
          value: item.dataIndex || item.title
        }, item));
      });
      return ret;
    }
    function init() {
      const columns2 = getColumns();
      const checkList = table.getColumns({ ignoreAction: true, ignoreSetting: true }).map((item) => {
        if (item.defaultHidden) {
          return "";
        }
        return item.dataIndex || item.title;
      }).filter(Boolean);
      if (!plainOptions.value.length) {
        plainOptions.value = columns2;
        state.defaultCheckList = checkList;
        plainSortOptions.value = columns2;
      } else {
        unref(plainOptions).forEach((item) => {
          const findItem2 = columns2.find((col) => col.dataIndex === item.dataIndex);
          if (findItem2) {
            item.fixed = findItem2.fixed;
          }
        });
      }
      state.isInit = true;
      state.checkedList = checkList;
      state.checkAll = plainOptions.value.length === checkList.length;
    }
    function onCheckAllChange(e2) {
      const checkList = plainSortOptions.value.map((item) => item.value);
      const target = e2.target;
      const checked = target.checked || indeterminate.value;
      nextTick(() => {
        if (checked) {
          state.checkedList = checkList;
          setColumns(checkList);
        } else {
          state.checkedList = plainSortOptions.value.filter((item) => !!item.disabled).map((item) => item.value);
          setColumns(state.checkedList);
        }
        changeInnerColumnsCheckedIfCheckedAllChange({
          target: { checked }
        });
      });
    }
    const indeterminate = computed(() => {
      const len = plainOptions.value.length;
      let checkedLen = state.checkedList.length;
      return checkedLen > 0 && checkedLen < len || !checkInnerColumnsAllChecked();
    });
    function onChange3(checkedList) {
      const len = plainOptions.value.length;
      state.checkAll = checkedList.length === len;
      const sortList = unref(plainSortOptions).map((item) => item.value);
      checkedList.sort((prev2, next2) => {
        return sortList.indexOf(prev2) - sortList.indexOf(next2);
      });
      setColumns(checkedList);
    }
    function reset() {
      state.checkAll = true;
      const mutationColumns = table.getMutationColumns();
      const columns2 = transformOptions(mutationColumns, {
        label: "title",
        value: "dataIndex"
      });
      state.checkedList = mutationColumns.map((item) => item.dataIndex || "");
      plainOptions.value = columns2;
      plainSortOptions.value = columns2;
      table.resetColumns();
      setColumns(mutationColumns, true);
      changeInnerColumnsCheckedIfCheckedAllChange({ target: { checked: true } });
    }
    function handleVisibleChange() {
      if (inited)
        return;
      nextTick(() => {
        const columnListEl = unref(columnListRef);
        if (!columnListEl)
          return;
        const el = columnListEl.$el;
        if (!el)
          return;
        Sortable.create(unref(el), {
          animation: 500,
          delay: 400,
          delayOnTouchOnly: true,
          dataIdAttr: "data-id",
          handle: ".table-column-drag-icon:not(.is-disabled)",
          draggable: ".fbu-fbu-column-setting__check-item:not(.is-disabled)",
          onEnd: (evt) => {
            const { oldIndex: oldIndex2, newIndex: newIndex2 } = evt;
            if (isUnDef(oldIndex2) || isUnDef(newIndex2) || oldIndex2 === newIndex2) {
              return;
            }
            const columns2 = getColumns();
            if (oldIndex2 > newIndex2) {
              columns2.splice(newIndex2, 0, columns2[oldIndex2]);
              columns2.splice(oldIndex2 + 1, 1);
            } else {
              columns2.splice(newIndex2 + 1, 0, columns2[oldIndex2]);
              columns2.splice(oldIndex2, 1);
            }
            plainSortOptions.value = columns2;
            setColumns(columns2);
          }
        });
        inited = true;
      });
    }
    function handleIndexCheckChange(e2) {
      table.setProps({
        showIndexColumn: e2.target.checked
      });
    }
    function handleSelectCheckChange(e2) {
      table.setProps({
        rowSelection: e2.target.checked ? defaultRowSelection : void 0
      });
    }
    function handleColumnFixed(item, fixed) {
      var _a2;
      if (!state.checkedList.includes(item.dataIndex) || item.disabled)
        return;
      const columns2 = getColumns();
      const isFixed = item.fixed === fixed ? false : fixed;
      const index2 = columns2.findIndex((col) => col.dataIndex === item.dataIndex);
      if (index2 !== -1) {
        columns2[index2].fixed = isFixed;
        if (!columns2[index2].width) {
          columns2[index2].width = 100;
        }
      }
      item.fixed = isFixed;
      if (isFixed && !item.width) {
        item.width = 100;
      }
      (_a2 = table.setCacheColumnsByField) == null ? void 0 : _a2.call(table, item.dataIndex, { fixed: isFixed });
      setColumns(columns2);
    }
    function setColumns(columns2, isOnlyEmit = false) {
      if (!isOnlyEmit) {
        table.setColumns(columns2);
      }
      const data6 = unref(plainOptions).map((col) => {
        const visible = columns2.findIndex((c2) => c2 === col.value || typeof c2 !== "string" && c2.dataIndex === col.value) !== -1;
        return { dataIndex: col.value, fixed: col.fixed, visible };
      });
      emit("columns-change", data6);
    }
    function getParentContainer(node) {
      var _a2;
      return (_a2 = node == null ? void 0 : node.parentNode) != null ? _a2 : document.body;
    }
    function getPopupContainer() {
      return isFunction$1(attrs.getPopupContainer) ? attrs.getPopupContainer() : getParentContainer();
    }
    function changeInnerColumnsCheckedIfCheckedAllChange(e2) {
      const columns2 = getColumns();
      columns2.forEach((item) => {
        handleColumnChange(e2, item);
      });
    }
    function handleColumnChange(e2, column) {
      const target = e2.target;
      let checked = target.checked;
      const innerCheckedMap = table.innerColumnsCheckedMap[column.dataIndex];
      const innerColumnMap = table.innerColumnsMap[column.dataIndex];
      nextTick(() => {
        if (innerCheckedMap && innerColumnMap) {
          if (innerCheckedMap.indeterminate) {
            checked = true;
            if (!state.checkedList.includes(column.dataIndex)) {
              state.checkedList.push(column.dataIndex);
            }
            onChange3(state.checkedList.slice(0));
          }
          const alwaysShowList = innerColumnMap.filter((item) => item.alwaysShow).map((item) => item.dataIndex);
          innerCheckedMap.checkedList = checked ? innerColumnMap.map((item) => item.dataIndex) : alwaysShowList;
          innerCheckedMap.indeterminate = checked ? false : alwaysShowList.length > 0;
          innerColumnMap.forEach((item) => {
            item.ifShow = item.alwaysShow ? true : checked;
          });
        }
      });
    }
    function checkInnerColumnsAllChecked() {
      let checkedAll = true;
      const checkedMap = table.innerColumnsCheckedMap;
      Object.keys(checkedMap).forEach((key2) => {
        if (checkedMap[key2].checkedList.length !== (table.innerColumnsMap[key2] || []).length) {
          checkedAll = false;
        }
      });
      return checkedAll;
    }
    function handleInnerColumnChange(e2, item, column) {
      const target = e2.target;
      item.ifShow = target.checked;
      const checkedMap = table.innerColumnsCheckedMap[column.dataIndex];
      nextTick(() => {
        var _a2;
        const checkedListLength = checkedMap.checkedList.length;
        checkedMap.indeterminate = checkedListLength > 0 && checkedListLength < ((_a2 = column.innerColumns || []) == null ? void 0 : _a2.length);
        if (checkedListLength === 0) {
          state.checkedList = state.checkedList.filter((col) => col !== column.dataIndex);
          onChange3(state.checkedList.slice(0));
        } else if (checkedListLength > 0) {
          if (!state.checkedList.includes(column.dataIndex)) {
            state.checkedList.push(column.dataIndex);
          }
          onChange3(state.checkedList.slice(0));
        }
      });
    }
    return __spreadProps(__spreadValues({}, toRefs(state)), {
      indeterminate,
      onCheckAllChange,
      onChange: onChange3,
      plainOptions,
      plainSortOptions,
      reset,
      prefixCls: prefixCls2,
      columnListRef,
      handleVisibleChange,
      checkIndex,
      checkSelect,
      handleIndexCheckChange,
      handleSelectCheckChange,
      defaultRowSelection,
      handleColumnFixed,
      getPopupContainer,
      innerColumnsMap,
      handleInnerColumnChange,
      innerColumnsCheckedMap: table.innerColumnsCheckedMap,
      handleColumnChange
    });
  }
});
const _hoisted_1$b = { class: "checkbox-list-wrap" };
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_RedoOutlined = resolveComponent("RedoOutlined");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_ColumnDragIcon = resolveComponent("ColumnDragIcon");
  const _component_CheckboxGroup = resolveComponent("CheckboxGroup");
  const _component_ColumnSettingIcon = resolveComponent("ColumnSettingIcon");
  const _component_Popover = resolveComponent("Popover");
  return openBlock(), createBlock(_component_Tooltip, { placement: "top" }, {
    title: withCtx(() => [
      createElementVNode("span", null, toDisplayString(_ctx.title || "\u5217\u8BBE\u7F6E"), 1)
    ]),
    default: withCtx(() => [
      createVNode(_component_Popover, {
        placement: "bottomRight",
        trigger: "click",
        onVisibleChange: _ctx.handleVisibleChange,
        arrowPointAtCenter: true,
        overlayClassName: `${_ctx.prefixCls}__cloumn-list`,
        getPopupContainer: _ctx.getPopupContainer
      }, {
        title: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(`${_ctx.prefixCls}__popover-title`)
          }, [
            createVNode(_component_Checkbox, {
              indeterminate: _ctx.indeterminate,
              checked: _ctx.checkAll,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event) => _ctx.checkAll = $event),
              onChange: _ctx.onCheckAllChange
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.extra.settingColumnShow || "\u5168\u9009"), 1)
              ]),
              _: 1
            }, 8, ["indeterminate", "checked", "onChange"]),
            createVNode(_component_Tooltip, {
              title: _ctx.extra.reset || "\u91CD\u7F6E"
            }, {
              default: withCtx(() => [
                createElementVNode("div", {
                  class: "btn-redo",
                  onClick: _cache[1] || (_cache[1] = (...args) => _ctx.reset && _ctx.reset(...args))
                }, [
                  createVNode(_component_RedoOutlined)
                ])
              ]),
              _: 1
            }, 8, ["title"])
          ], 2)
        ]),
        content: withCtx(() => [
          createElementVNode("div", _hoisted_1$b, [
            createVNode(_component_CheckboxGroup, {
              ref: "columnListRef",
              name: "columnListCheckbox",
              value: _ctx.checkedList,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event) => _ctx.checkedList = $event),
              onChange: _ctx.onChange
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.plainSortOptions.filter((item) => !("ifShow" in item && !item.ifShow)), (item) => {
                  var _a2;
                  return openBlock(), createElementBlock("div", {
                    key: item.value,
                    class: normalizeClass([`${_ctx.prefixCls}__check-item`, item.disabled && "is-disabled"])
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass([`${_ctx.prefixCls}__check-item-parent`])
                    }, [
                      createVNode(_component_Checkbox, {
                        value: item.value,
                        indeterminate: (_a2 = _ctx.innerColumnsCheckedMap[item.dataIndex]) == null ? void 0 : _a2.indeterminate,
                        disabled: item.disabled,
                        onChange: ($event) => _ctx.handleColumnChange($event, item)
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "indeterminate", "disabled", "onChange"]),
                      !item.disabled ? (openBlock(), createBlock(_component_ColumnDragIcon, {
                        key: 0,
                        class: normalizeClass(["table-column-drag-icon", item.disabled && "is-disabled"])
                      }, null, 8, ["class"])) : createCommentVNode("", true)
                    ], 2),
                    _ctx.innerColumnsMap[item.dataIndex] ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: normalizeClass([`${_ctx.prefixCls}__check-item-children`])
                    }, [
                      createVNode(_component_CheckboxGroup, {
                        value: _ctx.innerColumnsCheckedMap[item.dataIndex].checkedList,
                        "onUpdate:value": ($event) => _ctx.innerColumnsCheckedMap[item.dataIndex].checkedList = $event
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.innerColumnsMap[item.dataIndex], (item1) => {
                            return openBlock(), createElementBlock("div", {
                              key: item1.title
                            }, [
                              createVNode(_component_Checkbox, {
                                disabled: item1.alwaysShow,
                                value: item1.dataIndex,
                                onChange: ($event) => _ctx.handleInnerColumnChange($event, item1, item)
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(item1.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled", "value", "onChange"])
                            ]);
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value"])
                    ], 2)) : createCommentVNode("", true)
                  ], 2);
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ])
        ]),
        default: withCtx(() => [
          createVNode(_component_ColumnSettingIcon, normalizeProps(guardReactiveProps(_ctx.$attrs)), null, 16)
        ]),
        _: 1
      }, 8, ["onVisibleChange", "overlayClassName", "getPopupContainer"])
    ]),
    _: 1
  });
}
var ColumnSetting = /* @__PURE__ */ _export_sfc$1(_sfc_main$f, [["render", _sfc_render$a]]);
function easeout(startPos, endPos, rate, callback) {
  if (startPos === endPos) {
    return;
  }
  if (startPos < 1) {
    callback(endPos, true);
    return;
  }
  requestAnimationFrame(() => {
    const nextPos = startPos + (endPos - startPos) / (rate || 2);
    callback(nextPos, false);
    easeout(nextPos, endPos, rate, callback);
  });
}
function animationVerticalScrollTo(el, opts = {
  toPos: 0,
  rate: 2
}) {
  easeout(el.scrollTop, opts.toPos, opts.rate, (pos) => {
    el.scrollTop = pos;
  });
}
function animationHorizontalScrollTo(el, opts = {
  toPos: 0,
  rate: 2
}) {
  easeout(el.scrollLeft, opts.toPos, opts.rate, (pos) => {
    el.scrollLeft = pos;
  });
}
function animationBasedDuration(b2, e2, d2, p2, c2) {
  if (d2 <= 0) {
    if (b2 !== e2) {
      c2(e2, true);
    }
    return;
  }
  p2 = p2 || performance.now();
  requestAnimationFrame((nowTime) => {
    const frameTime = Math.max(nowTime - p2, 16);
    const nextPos = b2 + (e2 - b2) / d2 * frameTime;
    c2(nextPos, false);
    animationBasedDuration(nextPos, e2, d2 - frameTime, nowTime, c2);
  });
}
function animationVerticalScrollToUsingDuration(el, opts = {
  toPos: 0,
  duration: 250
}) {
  animationBasedDuration(el.scrollTop, opts.toPos, opts.duration, 0, (nextPos) => {
    el.scrollTop = nextPos;
  });
}
function animationHorizontalScrollToUsingDuration(el, opts = {
  toPos: 0,
  duration: 250
}) {
  animationBasedDuration(el.scrollLeft, opts.toPos, opts.duration, 0, (nextPos) => {
    el.scrollLeft = nextPos;
  });
}
var scrollTo = {
  easeout,
  animationBasedDuration,
  animationVerticalScrollTo,
  animationHorizontalScrollTo,
  animationVerticalScrollToUsingDuration,
  animationHorizontalScrollToUsingDuration
};
var TableScrollBtns_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const _sfc_main$e = defineComponent({
  name: "TableScrollBtns",
  components: {
    LeftOutlined: LeftOutlined$1,
    RightOutlined: RightOutlined$1
  },
  props: {
    scrollX: {
      type: [String, Number, Boolean]
    }
  },
  setup(props2) {
    const { wrapRef, getBindValues } = useTableContext$1();
    const isVisible2 = ref(false);
    const leftIsDisabled = ref(true);
    const rightIsDisabled = ref(false);
    const PX_IN_PER_SCROLL = 100;
    let longPressTimer;
    let raf3;
    const containerScrollEventInitialized = ref(false);
    const getScrollContainer = () => {
      var _a2, _b;
      const scrollContainer = ((_a2 = wrapRef.value) == null ? void 0 : _a2.querySelector(".ant-table-content")) || ((_b = wrapRef.value) == null ? void 0 : _b.querySelector(".ant-table-body"));
      if (scrollContainer && containerScrollEventInitialized.value === false) {
        scrollContainer.addEventListener("scroll", debounce(checkScrollBtnIsDisabled, 200, false));
        containerScrollEventInitialized.value = true;
      }
      return scrollContainer;
    };
    const checkScrollBarVisible = () => {
      const scrollContainer = getScrollContainer();
      if (!scrollContainer) {
        return;
      }
      isVisible2.value = scrollContainer.scrollWidth > scrollContainer.clientWidth;
    };
    const debouncedHandleResize = debounce(() => {
      checkScrollBarVisible();
      checkScrollBtnIsDisabled();
    }, 100, false);
    const resizeObserver = new ResizeObserver(() => {
      debouncedHandleResize();
    });
    watch(() => props2.scrollX, () => {
      nextTick(checkScrollBarVisible);
      nextTick(checkScrollBtnIsDisabled);
    }, {
      immediate: true
    });
    onMounted(() => {
      wrapRef.value && resizeObserver.observe(wrapRef.value);
      window.addEventListener("mouseup", handleMouseup);
    });
    onBeforeUnmount(() => {
      wrapRef.value && resizeObserver.unobserve(wrapRef.value);
      resizeObserver.disconnect();
    });
    function checkScrollBtnIsDisabled() {
      const scrollContainer = getScrollContainer();
      if (!scrollContainer) {
        return;
      }
      leftIsDisabled.value = (scrollContainer == null ? void 0 : scrollContainer.scrollLeft) === 0;
      rightIsDisabled.value = scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.clientWidth;
    }
    function setContainerScrollLeft(scollSize, useAnimation = true) {
      const scrollContainer = getScrollContainer();
      if (!scrollContainer) {
        return;
      }
      if (useAnimation === false) {
        scrollContainer.scrollLeft = scrollContainer.scrollLeft + scollSize;
        return;
      }
      scrollTo.animationBasedDuration(scrollContainer.scrollLeft, scrollContainer.scrollLeft + scollSize, 150, 0, (pos, ended) => {
        scrollContainer.scrollLeft = pos;
        if (ended) {
          checkScrollBtnIsDisabled();
        }
      });
    }
    function handleBtnClick(direction2) {
      if (direction2 === "left") {
        setContainerScrollLeft(-PX_IN_PER_SCROLL);
      } else if (direction2 === "right") {
        setContainerScrollLeft(+PX_IN_PER_SCROLL);
      }
    }
    function handleMouseup() {
      clearTimeout(longPressTimer);
      window.cancelAnimationFrame(raf3);
    }
    function handleMousedown(direction2) {
      longPressTimer = window.setTimeout(() => {
        raf3 = window.requestAnimationFrame(function rafCb() {
          setContainerScrollLeft(direction2 === "left" ? -3 : 3, false);
          raf3 = window.requestAnimationFrame(rafCb);
        });
        suppressClickEvent();
      }, 1e3);
    }
    function suppressClickEvent() {
      document.addEventListener("click", function suppressEvent(e2) {
        document.removeEventListener("click", suppressEvent, true);
        e2.preventDefault();
        e2.stopImmediatePropagation();
        e2.stopPropagation();
      }, true);
    }
    return {
      isVisible: isVisible2,
      leftIsDisabled,
      rightIsDisabled,
      handleBtnClick,
      handleMouseup,
      handleMousedown,
      getBindValues
    };
  }
});
const _hoisted_1$a = { class: "table-scroll-btns" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftOutlined = resolveComponent("LeftOutlined");
  const _component_RightOutlined = resolveComponent("RightOutlined");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$a, [
    createElementVNode("div", {
      class: normalizeClass(["table-scroll-btn", _ctx.leftIsDisabled && `table-scroll-btn--is-disabled`]),
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.handleBtnClick("left")),
      onMouseup: _cache[1] || (_cache[1] = (...args) => _ctx.handleMouseup && _ctx.handleMouseup(...args)),
      onMousedown: _cache[2] || (_cache[2] = ($event) => _ctx.handleMousedown("left"))
    }, [
      createVNode(_component_LeftOutlined)
    ], 34),
    createElementVNode("div", {
      class: normalizeClass(["table-scroll-btn", _ctx.rightIsDisabled && `table-scroll-btn--is-disabled`]),
      onClick: _cache[3] || (_cache[3] = ($event) => _ctx.handleBtnClick("right")),
      onMouseup: _cache[4] || (_cache[4] = (...args) => _ctx.handleMouseup && _ctx.handleMouseup(...args)),
      onMousedown: _cache[5] || (_cache[5] = ($event) => _ctx.handleMousedown("right"))
    }, [
      createVNode(_component_RightOutlined)
    ], 34)
  ], 512)), [
    [vShow, _ctx.getBindValues.showScrollBtns && _ctx.scrollX !== "100%" && _ctx.isVisible]
  ]);
}
var TableScrollBtns$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$e, [["render", _sfc_render$9], ["__scopeId", "data-v-58b7e7b9"]]);
const _hoisted_1$9 = { class: "custom-pagination-wrapper" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  props: {
    afterSuffix: {
      type: String,
      default: ""
    },
    max: {
      type: Number,
      default: 1500
    }
  },
  setup(__props) {
    const { getPaginationInfo, setPagination, reload } = useTableContext$1();
    const pageSizeRef = ref(20);
    const getTotal = computed(() => {
      const paginationInfo = unref(getPaginationInfo.value);
      return typeof paginationInfo === "object" ? paginationInfo.total : 0;
    });
    watch(getPaginationInfo, (pagination) => {
      if (typeof pagination == "object") {
        pageSizeRef.value = pagination.pageSize;
      }
    }, { immediate: true });
    function handlePaginationChange(current2, pageSize2) {
      setPagination({ current: current2, pageSize: pageSize2 });
      pageSizeRef.value = pageSize2;
      reload({ page: current2 });
    }
    function handlePageSizeChange() {
      pageSizeRef.value = pageSizeRef.value ? pageSizeRef.value : 20;
      const paginationInfo = unref(getPaginationInfo.value);
      if (typeof paginationInfo === "object") {
        if (paginationInfo.pageSize !== pageSizeRef.value) {
          let current2 = paginationInfo.current;
          const newCurrent = Math.floor((paginationInfo.total - 1) / pageSizeRef.value) + 1;
          current2 = current2 > newCurrent ? newCurrent : current2;
          setPagination({
            pageSize: pageSizeRef.value,
            current: current2
          });
          reload({
            page: current2
          });
        }
      }
    }
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$9, [
        createVNode(unref(Pagination$1), mergeProps(unref(getPaginationInfo), { onChange: handlePaginationChange }), null, 16),
        createVNode(unref(InputNumber$1), {
          value: pageSizeRef.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event) => pageSizeRef.value = $event),
          controls: false,
          max: __props.max,
          min: 1,
          "addon-after": __props.afterSuffix,
          bordered: false,
          onPressEnter: handlePageSizeChange,
          onBlur: handlePageSizeChange
        }, null, 8, ["value", "max", "addon-after"])
      ], 512)), [
        [vShow, unref(getTotal)]
      ]);
    };
  }
});
function _isSlot$7(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
var SortDirection$1;
(function(SortDirection2) {
  SortDirection2["ASC"] = "asc";
  SortDirection2["DESC"] = "desc";
})(SortDirection$1 || (SortDirection$1 = {}));
var ThCustomSorter$1 = defineComponent({
  name: "ThCustomSorter",
  props: {
    title: String,
    dropdownProps: Object,
    customSorterList: {
      type: Array
    },
    customSorterFetchKey: {
      type: String,
      default: "sorter"
    }
  },
  setup(props2) {
    const {
      reload,
      emit,
      setSearchStateSortInfo
    } = useTableContext$1();
    const dropMenuList = ref(cloneDeep(props2.customSorterList));
    const computedSortOrder = computed(() => {
      var _a2;
      return (_a2 = dropMenuList.value.filter((item) => !!item.sortOrder)[0]) == null ? void 0 : _a2.sortOrder;
    });
    const prefixCls2 = usePrefixCls("table-column");
    const innerSelectedKeysRef = ref([]);
    const clearSortOrder = () => {
      dropMenuList.value.forEach((item) => {
        item.sortOrder = void 0;
      });
    };
    const onClickMenu = debounce((event) => {
      innerSelectedKeysRef.value = [event.sortBy];
      let sortOrder = event.sortOrder;
      if (sortOrder) {
        sortOrder = sortOrder === "asc" ? "desc" : void 0;
      } else {
        sortOrder = "asc";
      }
      clearSortOrder();
      event.sortOrder = sortOrder;
      if (event.onClick) {
        event.onClick(event);
        return;
      }
      if (props2.customSorterFetchKey && sortOrder) {
        const sortInfo = {
          sortName: event.sortBy,
          sort: event.sortOrder
        };
        setSearchStateSortInfo(sortInfo);
        reload({
          searchInfo: sortInfo
        });
      } else {
        setSearchStateSortInfo({});
        reload();
      }
      emit && emit("sort-change", event);
    }, 100, false);
    const visible = ref(false);
    function RenderSorter(props3) {
      const upNode = createVNode(CaretUpOutlined$1, {
        "class": [`${prefixCls2}-sorter-up`, {
          active: props3.sortOrder === SortDirection$1.ASC
        }]
      }, null);
      const downNode = createVNode(CaretDownOutlined$1, {
        "class": [`${prefixCls2}-sorter-down`, {
          active: props3.sortOrder === SortDirection$1.DESC
        }]
      }, null);
      return createVNode("span", {
        "class": [`${prefixCls2}-sorter`, `${prefixCls2}-sorter-full`]
      }, [createVNode("span", {
        "class": `${prefixCls2}-sorter-inner`
      }, [upNode, downNode])]);
    }
    return () => {
      let _slot;
      const renderMenuList = createVNode(Menu, null, _isSlot$7(_slot = dropMenuList.value.map((item) => {
        return createVNode(Menu.Item, {
          "key": item.sortBy,
          "onClick": () => onClickMenu(item)
        }, {
          default: () => [createVNode("div", {
            "class": "sorter-menu-title"
          }, [createVNode(RenderSorter, {
            "sortOrder": item.sortOrder
          }, null), createVNode("span", null, [item.label])])]
        });
      })) ? _slot : {
        default: () => [_slot]
      });
      const renderTitleSorter = createVNode("div", {
        "class": `${prefixCls2}-sorters`
      }, [createVNode("span", {
        "class": `${prefixCls2}-title`
      }, [props2.title]), createVNode(Dropdown$2, mergeProps(props2.dropdownProps, {
        "visible": visible.value,
        "onUpdate:visible": ($event) => visible.value = $event,
        "trigger": ["click"]
      }), {
        overlay: () => {
          return renderMenuList;
        },
        default: () => createVNode(RenderSorter, {
          "sortOrder": computedSortOrder.value
        }, null)
      })]);
      return renderTitleSorter;
    };
  }
});
function useEmpty$1(propsRef) {
  const EMPTY_TEXT_BEFORE_FETCH = "\u8BF7\u641C\u7D22";
  const EMPTY_TEXT_AFTER_FETCH = "\u6682\u65E0\u641C\u7D22\u7ED3\u679C\uFF0C\u8BF7\u8C03\u6574\u641C\u7D22\u6761\u4EF6";
  const EMPTY_TEXT_IN_LOADING = "\u641C\u7D22\u4E2D...";
  const { t: t2 } = propsRef.value;
  const emptyTextRef = ref("");
  const setEmptyText = (text) => {
    emptyTextRef.value = text;
  };
  const setEmptyTextAfterFetch = (text) => {
    emptyTextRef.value = text || t2 && t2(EMPTY_TEXT_AFTER_FETCH) || EMPTY_TEXT_AFTER_FETCH;
  };
  const setEmptyInFetching = (text) => {
    emptyTextRef.value = text || t2 && t2(EMPTY_TEXT_IN_LOADING) || EMPTY_TEXT_IN_LOADING;
  };
  watch(() => unref(propsRef).emptyText, (text) => {
    emptyTextRef.value = text || t2 && t2(EMPTY_TEXT_BEFORE_FETCH) || EMPTY_TEXT_BEFORE_FETCH;
  }, { immediate: true });
  return {
    emptyTextRef,
    setEmptyText,
    setEmptyTextAfterFetch,
    setEmptyInFetching
  };
}
const _sfc_main$c = defineComponent({
  name: "FbuTable",
  components: {
    Table,
    FbuForm,
    ColumnSetting,
    TableScrollBtns: TableScrollBtns$1,
    TableTabs: TableTabs$1,
    TableSummary,
    CustomPagination: _sfc_main$d,
    ThCustomSorter: ThCustomSorter$1,
    Empty: Empty$2
  },
  props: __spreadValues({}, useProps$1),
  emits: [
    "fetch-success",
    "fetch-error",
    "selection-change",
    "register",
    "row-click",
    "row-dbClick",
    "row-contextmenu",
    "row-mouseenter",
    "row-mouseleave",
    "edit-end",
    "edit-cancel",
    "edit-row-end",
    "edit-change",
    "expanded-rows-change",
    "change",
    "columns-change",
    "resize-column",
    "tab-click",
    "formRest",
    "sort-change",
    "virtual-scroll",
    "set-empty-after-fetch",
    "inner-columns-checked-list"
  ],
  setup(props2, { attrs, emit, slots, expose }) {
    const tableElRef = ref(null);
    const tableData = ref([]);
    const wrapRef = ref(null);
    const formRef = ref(null);
    const innerPropsRef = ref();
    const prefixCls2 = usePrefixCls("table");
    const [registerForm, formActions] = useForm();
    const getProps = computed(() => {
      return __spreadValues(__spreadValues({}, props2), unref(innerPropsRef));
    });
    const startIndex = ref(0);
    const { getLoading, setLoading } = useLoading$1(getProps);
    const dataSourceLimit = ref(0);
    const isVirtualList = computed(() => {
      const { virtualList, maxHeight, scroll } = props2;
      return virtualList && !!(maxHeight || scroll && scroll.y);
    });
    const virtualDataKeys = computed(() => {
      if (!isVirtualList.value)
        return [];
      return virtualData.value.map((v2) => v2.key);
    });
    const { emptyTextRef, setEmptyText, setEmptyTextAfterFetch, setEmptyInFetching } = useEmpty$1(getProps);
    const {
      getPaginationInfo,
      getPaginationBinds,
      setPaginationConfig,
      setShowPagination,
      getShowPagination
    } = usePagination$1(getProps);
    const {
      getRowSelection,
      getRowSelectionRef,
      getSelectRows,
      clearSelectedRowKeys,
      getSelectRowKeys,
      deleteSelectRowByKey,
      setSelectedRowKeys
    } = useRowSelection$1(getProps, tableData, emit, isVirtualList, virtualDataKeys, dataSourceLimit);
    const { activedKey, tabs, handleTabClick, getTabData, resetActivedKey } = useTableTabs$1(getProps, () => {
      return fetch();
    }, emit);
    const handleReset = () => {
      resetActivedKey();
      emit("formRest");
    };
    const {
      handleTableChange: onTableChange,
      getDataSourceRef,
      getDataSource,
      getRawDataSource,
      setTableData,
      updateTableDataRecord,
      deleteTableDataRecord,
      insertTableDataRecord,
      findTableDataRecord,
      fetch,
      getRowKeyRef,
      reload,
      getAutoCreateKeyRef,
      updateTableData,
      setSearchStateSortInfo
    } = useDataSource$1(getProps, tableData, {
      getPaginationInfo,
      setLoading,
      setPagination: setPaginationConfig,
      getFieldsValue: formActions.getFieldsValue,
      clearSelectedRowKeys,
      getTabData,
      setEmptyTextAfterFetch,
      setEmptyInFetching,
      startCountDown: () => {
        var _a2;
        try {
          if ((_a2 = getProps.value.formConfig) == null ? void 0 : _a2.enableCount) {
            formActions.startCountDown();
          }
        } catch {
        }
      }
    }, emit);
    function handleTableChange(pagination, filter, sorter, extra) {
      onTableChange(pagination, filter, sorter);
      emit("change", pagination, filter, sorter, extra);
    }
    const {
      getViewColumns,
      getColumns,
      setCacheColumnsByField,
      setColumns,
      getColumnsRef,
      getCacheColumns,
      handleResizeColumn,
      getMutationColumns,
      resetColumns,
      innerColumnsMap,
      innerColumnsCheckedMap
    } = useColumns$2(getProps, getPaginationInfo, emit, startIndex);
    const { getScrollX, getScrollRef, redoHeight } = useTableScroll(getProps, tableElRef, getColumnsRef, getRowSelectionRef, getDataSourceRef, wrapRef, formRef);
    const { scrollTo: scrollTo2 } = useTableScrollTo(tableElRef, getDataSourceRef);
    const { customRow } = useCustomRow$1(getProps, {
      setSelectedRowKeys,
      getSelectRowKeys,
      clearSelectedRowKeys,
      getAutoCreateKeyRef,
      emit
    });
    const { getRowClassName } = useTableStyle$1(getProps, prefixCls2);
    const { getExpandedBindsRef, expandAll, expandRows, collapseAll } = useTableExpand$1(getProps, tableData, emit);
    const columnsChangeSubs = [];
    const handlers = {
      onColumnsChange: (data6) => {
        emit("columns-change", data6);
        columnsChangeSubs.forEach((fn) => typeof fn === "function" && fn());
      }
    };
    const { getHeaderProps } = useTableHeader$1(getProps, slots, handlers);
    const {
      getFormProps,
      replaceFormSlotKey,
      getFormSlotKeys,
      handleSearchInfoChange,
      handleUpdateSchemes
    } = useTableForm$1(getProps, slots, fetch, getLoading);
    useTableSticky(getProps, tableElRef, setProps, getPaginationInfo);
    useDragScroll(tableElRef, getProps, getViewColumns);
    const getBindValues = computed(() => {
      let propsData = __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, attrs), {
        customRow
      }), unref(getProps)), unref(getHeaderProps)), {
        scroll: unref(getScrollRef),
        loading: unref(getLoading),
        tableLayout: "fixed",
        rowSelection: unref(getRowSelectionRef),
        rowKey: unref(getRowKeyRef),
        columns: toRaw(unref(getViewColumns)),
        pagination: toRaw(unref(getPaginationInfo)),
        onResizeColumn: handleResizeColumn,
        topTabs: {
          activedKey,
          tabs,
          handleTabClick
        }
      }), unref(getExpandedBindsRef));
      Reflect.deleteProperty(propsData, "class");
      Reflect.deleteProperty(propsData, "onChange");
      return propsData;
    });
    const scrolls = computed(() => {
      const s2 = Object.assign({}, unref(getScrollRef));
      if (isVirtualList.value && dataSourceLimit.value <= 200) {
        s2.y = void 0;
      }
      return s2;
    });
    const dataSource = computed(() => {
      const list = unref(getDataSourceRef);
      dataSourceLimit.value = list.length;
      return list;
    });
    const emitVirtualScroll = (prop) => emit("virtual-scroll", prop);
    const {
      virtualData,
      virtualSetup,
      unVirtual,
      virtualScrollToTop,
      virtualScrollToBottom,
      switchPillar,
      computedRowHeight
    } = useVirtual(props2, dataSource, isVirtualList, tableElRef, emitVirtualScroll, startIndex);
    function switichDataSource(is3, len) {
      if (is3 && len > 200)
        return virtualData.value;
      startIndex.value = 0;
      return dataSource.value;
    }
    columnsChangeSubs.push(computedRowHeight);
    onMounted(async () => {
      await nextTick();
      virtualSetup();
    });
    onUnmounted(() => unVirtual());
    watch(() => dataSourceLimit.value, (len) => {
      switchPillar(len > 200);
    });
    const getWrapperClass = computed(() => {
      const values = unref(getBindValues);
      return [
        prefixCls2,
        attrs.class,
        {
          [`${prefixCls2}-form-container`]: values.useSearchForm,
          [`${prefixCls2}--inset`]: values.inset,
          [`${prefixCls2}--no-title-empty`]: values.fixTitleEmpty,
          [`${prefixCls2}--no-pagination`]: values.customPagination,
          ["fbu-table--if-empty"]: !dataSource.value || !dataSource.value.length
        }
      ];
    });
    const getEmptyDataIsShowTable = computed(() => {
      const { emptyDataIsShowTable, useSearchForm } = unref(getProps);
      if (emptyDataIsShowTable || !useSearchForm) {
        return true;
      }
      return !!unref(getDataSourceRef).length;
    });
    function setProps(props22) {
      innerPropsRef.value = __spreadValues(__spreadValues({}, unref(innerPropsRef)), props22);
    }
    const tableAction = {
      reload,
      getSelectRows,
      clearSelectedRowKeys,
      getSelectRowKeys,
      deleteSelectRowByKey,
      setPagination: setPaginationConfig,
      setTableData,
      updateTableDataRecord,
      deleteTableDataRecord,
      insertTableDataRecord,
      findTableDataRecord,
      redoHeight,
      setSelectedRowKeys,
      setColumns,
      setLoading,
      getLoading: () => getLoading,
      getDataSource,
      getRawDataSource,
      setProps,
      getRowSelection,
      getPaginationRef: getPaginationBinds,
      getColumns,
      getCacheColumns,
      getMutationColumns,
      resetColumns,
      emit,
      updateTableData,
      setShowPagination,
      getShowPagination,
      setCacheColumnsByField,
      expandAll,
      expandRows,
      collapseAll,
      scrollTo: scrollTo2,
      getSize: () => {
        return unref(getBindValues).size;
      },
      virtualScrollToTop,
      virtualScrollToBottom,
      setEmptyText
    };
    createTableContext$1(__spreadProps(__spreadValues({}, tableAction), {
      wrapRef,
      getBindValues,
      getPaginationInfo,
      setSearchStateSortInfo,
      innerColumnsMap,
      innerColumnsCheckedMap
    }));
    expose(tableAction);
    emit("register", tableAction, formActions);
    return {
      formRef,
      tableElRef,
      getBindValues,
      getLoading,
      registerForm,
      handleSearchInfoChange,
      getEmptyDataIsShowTable,
      handleTableChange,
      getRowClassName,
      wrapRef,
      tableAction,
      redoHeight,
      getFormProps,
      replaceFormSlotKey,
      getFormSlotKeys,
      getWrapperClass,
      columns: getViewColumns,
      SETTING_COLUMN_INDEX: SETTING_COLUMN_INDEX$1,
      getScrollX,
      activedKey,
      tabs,
      handleTabClick,
      getScrollRef,
      handleReset,
      getPaginationInfo,
      dataSource,
      virtualData,
      isVirtualList,
      scrolls,
      handlers,
      switichDataSource,
      simpleImage: Empty$2.PRESENTED_IMAGE_SIMPLE,
      emptyText: emptyTextRef,
      handleUpdateSchemes
    };
  }
});
const _hoisted_1$8 = { class: "fbu-table-wrapper" };
const _hoisted_2$3 = {
  key: 0,
  class: "fbu-table-top"
};
const _hoisted_3$2 = ["title"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FbuForm = resolveComponent("FbuForm");
  const _component_TableTabs = resolveComponent("TableTabs");
  const _component_Empty = resolveComponent("Empty");
  const _component_TableSummary = resolveComponent("TableSummary");
  const _component_ColumnSetting = resolveComponent("ColumnSetting");
  const _component_ThCustomSorter = resolveComponent("ThCustomSorter");
  const _component_Table = resolveComponent("Table");
  const _component_TableScrollBtns = resolveComponent("TableScrollBtns");
  const _component_CustomPagination = resolveComponent("CustomPagination");
  return openBlock(), createElementBlock("div", {
    ref: "wrapRef",
    class: normalizeClass(_ctx.getWrapperClass)
  }, [
    _ctx.getBindValues.useSearchForm ? (openBlock(), createBlock(_component_FbuForm, mergeProps({
      key: 0,
      ref: "formRef",
      submitOnReset: ""
    }, _ctx.getFormProps, {
      tableAction: _ctx.tableAction,
      onRegister: _ctx.registerForm,
      onSubmit: _ctx.handleSearchInfoChange,
      onReset: _ctx.handleReset,
      onUpdateSchemes: _ctx.handleUpdateSchemes
    }), createSlots({ _: 2 }, [
      renderList(_ctx.getFormSlotKeys, (item) => {
        return {
          name: _ctx.replaceFormSlotKey(item),
          fn: withCtx((data6) => [
            renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})))
          ])
        };
      })
    ]), 1040, ["tableAction", "onRegister", "onSubmit", "onReset", "onUpdateSchemes"])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_1$8, [
      _ctx.$slots.tableTop ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
        renderSlot(_ctx.$slots, "tableTop")
      ])) : createCommentVNode("", true),
      !_ctx.getBindValues.sticky && !_ctx.$slots.headerTabs ? (openBlock(), createBlock(_component_TableTabs, {
        key: 1,
        value: _ctx.activedKey,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.activedKey = $event),
        tabs: _ctx.tabs,
        onTabClick: _ctx.handleTabClick
      }, null, 8, ["value", "tabs", "onTabClick"])) : createCommentVNode("", true),
      withDirectives(createVNode(_component_Table, mergeProps({ ref: "tableElRef" }, _ctx.getBindValues, {
        rowClassName: _ctx.getRowClassName,
        onChange: _ctx.handleTableChange,
        dataSource: _ctx.switichDataSource(_ctx.isVirtualList, _ctx.dataSource.length),
        scroll: _ctx.scrolls
      }), createSlots({
        emptyText: withCtx(() => [
          createVNode(_component_Empty, {
            image: _ctx.simpleImage,
            description: _ctx.emptyText
          }, null, 8, ["image", "description"])
        ]),
        summary: withCtx(() => [
          createVNode(_component_TableSummary, null, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "summary")
            ]),
            _: 3
          })
        ]),
        headerCell: withCtx(({ column, title }) => [
          column && column.flag === _ctx.SETTING_COLUMN_INDEX ? (openBlock(), createBlock(_component_ColumnSetting, mergeProps({ key: 0 }, _ctx.getBindValues.tableSetting.setting || {}, {
            onColumnsChange: _ctx.handlers.onColumnsChange,
            style: { "display": "block" }
          }), null, 16, ["onColumnsChange"])) : column && column.customSorter ? (openBlock(), createBlock(_component_ThCustomSorter, {
            key: 1,
            title,
            "custom-sorter-fetch-key": column.customSorterFetchKey,
            "custom-sorter-list": column.customSorter
          }, null, 8, ["title", "custom-sorter-fetch-key", "custom-sorter-list"])) : renderSlot(_ctx.$slots, "headerCell", normalizeProps(mergeProps({ key: 2 }, { column, title })), () => [
            createElementVNode("span", { title }, toDisplayString(title), 9, _hoisted_3$2)
          ])
        ]),
        _: 2
      }, [
        renderList(Object.keys(_ctx.$slots).filter((slot) => slot !== "summary" && slot !== "headerCell" && slot !== "emptyText"), (item) => {
          return {
            name: item,
            fn: withCtx((data6) => [
              renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})))
            ])
          };
        })
      ]), 1040, ["rowClassName", "onChange", "dataSource", "scroll"]), [
        [vShow, _ctx.getEmptyDataIsShowTable]
      ]),
      createVNode(_component_TableScrollBtns, {
        scrollX: _ctx.getScrollRef.x
      }, null, 8, ["scrollX"]),
      _ctx.customPagination ? (openBlock(), createBlock(_component_CustomPagination, {
        key: 2,
        max: _ctx.customMaxPageSize,
        "after-suffix": _ctx.customPaginationSizeChangerSuffix
      }, null, 8, ["max", "after-suffix"])) : createCommentVNode("", true)
    ])
  ], 2);
}
var FbuTable = /* @__PURE__ */ _export_sfc$1(_sfc_main$c, [["render", _sfc_render$8]]);
var TableImages_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$b = defineComponent({
  name: "FbuTableImages",
  props: {
    imgList: q().def(() => []),
    size: N().def(40),
    simple: x().def(false),
    showBadge: x().def(false),
    srcPrefix: E().def("")
  },
  inheritAttrs: false,
  components: {
    Badge,
    Image: Image$2,
    PreviewGroup: Image$2.PreviewGroup
  },
  setup() {
    const prefixCls2 = usePrefixCls("table-images");
    return {
      prefixCls: prefixCls2
    };
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = resolveComponent("Image");
  const _component_PreviewGroup = resolveComponent("PreviewGroup");
  const _component_Badge = resolveComponent("Badge");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.prefixCls)
  }, [
    _ctx.simple ? (openBlock(), createBlock(_component_Badge, {
      key: 0,
      count: !_ctx.showBadge || _ctx.imgList.length <= 1 ? 0 : _ctx.imgList.length
    }, {
      default: withCtx(() => [
        createVNode(_component_PreviewGroup, null, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.imgList, (img, index2) => {
              return openBlock(), createBlock(_component_Image, {
                key: img,
                width: index2 === 0 ? _ctx.size : 0,
                src: `${_ctx.srcPrefix}${img}`,
                style: normalizeStyle({ display: index2 === 0 ? "" : "none" })
              }, null, 8, ["width", "src", "style"]);
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["count"])) : (openBlock(), createBlock(_component_PreviewGroup, { key: 1 }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.imgList, (img) => {
          return openBlock(), createBlock(_component_Image, {
            key: img,
            width: _ctx.size,
            src: `${_ctx.srcPrefix}${img}`
          }, null, 8, ["width", "src"]);
        }), 128))
      ]),
      _: 1
    }))
  ], 2);
}
var FbuTableImages = /* @__PURE__ */ _export_sfc$1(_sfc_main$b, [["render", _sfc_render$7], ["__scopeId", "data-v-4bf9f2b5"]]);
var TableAction_vue_vue_type_style_index_0_lang = "";
const _sfc_main$a = defineComponent({
  name: "FbuTableAction",
  components: {
    PopconfirmButton: _sfc_main$P,
    CaretDownOutlined: CaretDownOutlined$1,
    Tooltip,
    FbuDropdown
  },
  props: {
    actions: q(),
    dropDownActions: q(),
    divider: x().def(false),
    outside: x(),
    stopButtonPropagation: x().def(false),
    moreButtonText: E().def("\u66F4\u591A"),
    direction: E().def("horizontal")
  },
  setup(props2) {
    const prefixCls2 = usePrefixCls("table-action");
    let table = {};
    if (!props2.outside) {
      table = useTableContext$1();
    }
    function isIfShow(action) {
      const ifShow = action.ifShow;
      let isIfShow2 = true;
      if (isBoolean(ifShow)) {
        isIfShow2 = ifShow;
      }
      if (isFunction$1(ifShow)) {
        isIfShow2 = ifShow(action);
      }
      return isIfShow2;
    }
    const getActions = computed(() => {
      return (toRaw(props2.actions) || []).filter((action) => {
        return isIfShow(action);
      }).map((action) => {
        const { popConfirm } = action;
        return __spreadProps(__spreadValues(__spreadValues({
          getPopupContainer: () => {
            var _a2;
            return (_a2 = unref(table == null ? void 0 : table.wrapRef.value)) != null ? _a2 : document.body;
          },
          type: "link",
          size: "small"
        }, action), popConfirm || {}), {
          onConfirm: popConfirm == null ? void 0 : popConfirm.confirm,
          onCancel: popConfirm == null ? void 0 : popConfirm.cancel,
          enable: !!popConfirm
        });
      });
    });
    const getDropdownList = computed(() => {
      const list = (toRaw(props2.dropDownActions) || []).filter((action) => {
        return isIfShow(action);
      });
      return list.map((action) => {
        const { label, popConfirm } = action;
        return __spreadProps(__spreadValues(__spreadValues({}, action), popConfirm), {
          onConfirm: popConfirm == null ? void 0 : popConfirm.confirm,
          onCancel: popConfirm == null ? void 0 : popConfirm.cancel,
          text: label
        });
      });
    });
    const getAlign = computed(() => {
      var _a2, _b;
      const columns2 = ((_a2 = table == null ? void 0 : table.getColumns) == null ? void 0 : _a2.call(table)) || [];
      const actionColumn = columns2.find((item) => item.flag === ACTION_COLUMN_FLAG$1);
      return (_b = actionColumn == null ? void 0 : actionColumn.align) != null ? _b : "left";
    });
    function getTooltip(data6) {
      return __spreadValues({
        getPopupContainer: () => {
          var _a2;
          return (_a2 = unref(table == null ? void 0 : table.wrapRef.value)) != null ? _a2 : document.body;
        },
        placement: "bottom"
      }, isString$1(data6) ? { title: data6 } : data6);
    }
    function onCellClick(e2) {
      if (!props2.stopButtonPropagation)
        return;
      const path = e2.composedPath();
      const isInButton = path.find((ele) => {
        var _a2;
        return ((_a2 = ele.tagName) == null ? void 0 : _a2.toUpperCase()) === "BUTTON";
      });
      isInButton && e2.stopPropagation();
    }
    return { prefixCls: prefixCls2, getActions, getDropdownList, getAlign, onCellClick, getTooltip };
  }
});
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PopconfirmButton = resolveComponent("PopconfirmButton");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_CaretDownOutlined = resolveComponent("CaretDownOutlined");
  const _component_fbu_button = resolveComponent("fbu-button");
  const _component_FbuDropdown = resolveComponent("FbuDropdown");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.prefixCls, _ctx.getAlign, _ctx.direction]),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onCellClick && _ctx.onCellClick(...args))
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.getActions, (action) => {
      return openBlock(), createElementBlock(Fragment, {
        key: action.label
      }, [
        action.tooltip ? (openBlock(), createBlock(_component_Tooltip, normalizeProps(mergeProps({ key: 0 }, _ctx.getTooltip(action.tooltip))), {
          default: withCtx(() => [
            createVNode(_component_PopconfirmButton, normalizeProps(guardReactiveProps(action)), {
              default: withCtx(() => [
                _ctx.$slots.actionIcon && !action.loading ? renderSlot(_ctx.$slots, "actionIcon", mergeProps({
                  key: 0,
                  class: "mr-10"
                }, action)) : createCommentVNode("", true),
                action.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(action.label), 1)
                ], 64)) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1040)
          ]),
          _: 2
        }, 1040)) : (openBlock(), createBlock(_component_PopconfirmButton, normalizeProps(mergeProps({ key: 1 }, action)), {
          default: withCtx(() => [
            _ctx.$slots.actionIcon && !action.loading ? renderSlot(_ctx.$slots, "actionIcon", mergeProps({
              key: 0,
              class: "mr-10"
            }, action)) : createCommentVNode("", true),
            action.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(action.label), 1)
            ], 64)) : createCommentVNode("", true)
          ]),
          _: 2
        }, 1040))
      ], 64);
    }), 128)),
    _ctx.dropDownActions && _ctx.getDropdownList.length > 0 ? (openBlock(), createBlock(_component_FbuDropdown, {
      key: 0,
      trigger: ["click"],
      dropMenuList: _ctx.getDropdownList,
      overlayClassName: "actions-more-dropdown",
      popconfirm: ""
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "more"),
        !_ctx.$slots.more ? (openBlock(), createBlock(_component_fbu_button, {
          key: 0,
          class: "more-btn",
          type: "link",
          size: "small"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.moreButtonText) + " ", 1),
            createVNode(_component_CaretDownOutlined, {
              class: "icon-more",
              style: { "font-size": "12px", "vertical-align": "-2px" }
            })
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["dropMenuList"])) : createCommentVNode("", true)
  ], 2);
}
var FbuTableAction = /* @__PURE__ */ _export_sfc$1(_sfc_main$a, [["render", _sfc_render$6]]);
function useComponentRegister(compName, comp) {
  add(compName, comp);
  onUnmounted(() => {
    if (getCurrentInstance()) {
      del(compName);
    }
  });
}
function useTable$1(tableProps3) {
  const tableRef = ref(null);
  const loadedRef = ref(false);
  const formRef = ref(null);
  let stopWatch;
  function register3(instance2, formInstance) {
    onUnmounted(() => {
      tableRef.value = null;
      loadedRef.value = null;
    });
    if (unref(loadedRef) && instance2 === unref(tableRef)) {
      return;
    }
    tableRef.value = instance2;
    formRef.value = formInstance;
    tableProps3 && instance2.setProps(getDynamicProps(tableProps3));
    loadedRef.value = true;
    stopWatch == null ? void 0 : stopWatch();
    stopWatch = watch(() => tableProps3, () => {
      tableProps3 && instance2.setProps(getDynamicProps(tableProps3));
    }, {
      immediate: true,
      deep: true
    });
  }
  function getTableInstance() {
    const table = unref(tableRef);
    if (!table) {
      console.error("\u8BF7\u5148\u7ED1\u5B9A\u8868\u683C\u5B9E\u4F8B!");
    }
    return table;
  }
  const methods = {
    reload: async (opt) => {
      return await getTableInstance().reload(opt);
    },
    setProps: (props2) => {
      getTableInstance().setProps(props2);
    },
    redoHeight: () => {
      getTableInstance().redoHeight();
    },
    setLoading: (loading) => {
      getTableInstance().setLoading(loading);
    },
    getLoading: () => {
      return getTableInstance().getLoading();
    },
    getDataSource: () => {
      return getTableInstance().getDataSource();
    },
    getRawDataSource: () => {
      return getTableInstance().getRawDataSource();
    },
    getColumns: ({ ignoreIndex = false } = {}) => {
      const columns2 = getTableInstance().getColumns({ ignoreIndex }) || [];
      return toRaw(columns2);
    },
    setColumns: (columns2) => {
      getTableInstance().setColumns(columns2);
    },
    setTableData: (values) => {
      return getTableInstance().setTableData(values);
    },
    setPagination: (info) => {
      return getTableInstance().setPagination(info);
    },
    deleteSelectRowByKey: (key2) => {
      getTableInstance().deleteSelectRowByKey(key2);
    },
    getSelectRowKeys: () => {
      return toRaw(getTableInstance().getSelectRowKeys());
    },
    getSelectRows: () => {
      return toRaw(getTableInstance().getSelectRows());
    },
    clearSelectedRowKeys: () => {
      getTableInstance().clearSelectedRowKeys();
    },
    setSelectedRowKeys: (keys2) => {
      getTableInstance().setSelectedRowKeys(keys2);
    },
    getPaginationRef: () => {
      return getTableInstance().getPaginationRef();
    },
    getSize: () => {
      return toRaw(getTableInstance().getSize());
    },
    updateTableData: (index2, key2, value) => {
      return getTableInstance().updateTableData(index2, key2, value);
    },
    deleteTableDataRecord: (rowKey2) => {
      return getTableInstance().deleteTableDataRecord(rowKey2);
    },
    insertTableDataRecord: (record, index2) => {
      return getTableInstance().insertTableDataRecord(record, index2);
    },
    updateTableDataRecord: (rowKey2, record) => {
      return getTableInstance().updateTableDataRecord(rowKey2, record);
    },
    findTableDataRecord: (rowKey2) => {
      return getTableInstance().findTableDataRecord(rowKey2);
    },
    getRowSelection: () => {
      return toRaw(getTableInstance().getRowSelection());
    },
    getCacheColumns: () => {
      return toRaw(getTableInstance().getCacheColumns());
    },
    getForm: () => {
      return unref(formRef);
    },
    setShowPagination: async (show) => {
      getTableInstance().setShowPagination(show);
    },
    getShowPagination: () => {
      return toRaw(getTableInstance().getShowPagination());
    },
    expandAll: () => {
      getTableInstance().expandAll();
    },
    collapseAll: () => {
      getTableInstance().collapseAll();
    },
    expandRows: (keys2) => {
      getTableInstance().expandRows(keys2);
    },
    scrollTo: (pos) => {
      getTableInstance().scrollTo(pos);
    },
    getMutationColumns: () => {
      return getTableInstance().getMutationColumns();
    },
    resetColumns: () => {
      getTableInstance().resetColumns();
    },
    setEmptyText: (text) => {
      getTableInstance().setEmptyText(text);
    }
  };
  return [register3, methods];
}
FbuTable.Summary = TableSummary;
FbuTable.SummaryRow = TableSummaryRow;
FbuTable.SummaryCell = TableSummaryCell;
FbuTable.install = function(app) {
  app.component(FbuTable.name, FbuTable);
  app.component(FbuTableImages.name, FbuTableImages);
  app.component(FbuTableTitleAction.name, FbuTableTitleAction);
  app.component(FbuTableAction.name, FbuTableAction);
  return app;
};
var _a;
const isClient = typeof window !== "undefined";
isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function resolveUnref(r2) {
  return typeof r2 === "function" ? r2() : unref(r2);
}
function identity(arg) {
  return arg;
}
function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
function tryOnMounted(fn, sync = true) {
  if (getCurrentInstance())
    onMounted(fn);
  else if (sync)
    fn();
  else
    nextTick(fn);
}
function unrefElement(elRef) {
  var _a2;
  const plain = resolveUnref(elRef);
  return (_a2 = plain == null ? void 0 : plain.$el) != null ? _a2 : plain;
}
const defaultWindow = isClient ? window : void 0;
isClient ? window.document : void 0;
isClient ? window.navigator : void 0;
isClient ? window.location : void 0;
function useSupported(callback, sync = false) {
  const isSupported = ref();
  const update = () => isSupported.value = Boolean(callback());
  update();
  tryOnMounted(update, sync);
  return isSupported;
}
const _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
const globalKey = "__vueuse_ssr_handlers__";
_global[globalKey] = _global[globalKey] || {};
_global[globalKey];
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function useResizeObserver(target, callback, options = {}) {
  const _a2 = options, { window: window2 = defaultWindow } = _a2, observerOptions = __objRest$2(_a2, ["window"]);
  let observer;
  const isSupported = useSupported(() => window2 && "ResizeObserver" in window2);
  const cleanup2 = () => {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  const stopWatch = watch(() => unrefElement(target), (el) => {
    cleanup2();
    if (isSupported.value && window2 && el) {
      observer = new ResizeObserver(callback);
      observer.observe(el, observerOptions);
    }
  }, { immediate: true, flush: "post" });
  const stop2 = () => {
    cleanup2();
    stopWatch();
  };
  tryOnScopeDispose(stop2);
  return {
    isSupported,
    stop: stop2
  };
}
var SwipeDirection;
(function(SwipeDirection2) {
  SwipeDirection2["UP"] = "UP";
  SwipeDirection2["RIGHT"] = "RIGHT";
  SwipeDirection2["DOWN"] = "DOWN";
  SwipeDirection2["LEFT"] = "LEFT";
  SwipeDirection2["NONE"] = "NONE";
})(SwipeDirection || (SwipeDirection = {}));
var __defProp2 = Object.defineProperty;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key2, value) => key2 in obj ? __defProp2(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __spreadValues2 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp2.call(b2, prop))
      __defNormalProp2(a2, prop, b2[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b2)) {
      if (__propIsEnum2.call(b2, prop))
        __defNormalProp2(a2, prop, b2[prop]);
    }
  return a2;
};
const _TransitionPresets = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
__spreadValues2({
  linear: identity
}, _TransitionPresets);
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn2 = (val, key2) => hasOwnProperty.call(val, key2);
const isArray = Array.isArray;
const isFunction2 = (val) => typeof val === "function";
const isString2 = (val) => typeof val === "string";
const isObject2 = (val) => val !== null && typeof val === "object";
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray$3(value) ? value : [value];
}
function fromPairs(pairs) {
  var index2 = -1, length = pairs == null ? 0 : pairs.length, result = {};
  while (++index2 < length) {
    var pair = pairs[index2];
    result[pair[0]] = pair[1];
  }
  return result;
}
const isUndefined = (val) => val === void 0;
const isNumber = (val) => typeof val === "number";
const isStringNumber = (val) => {
  if (!isString2(val)) {
    return false;
  }
  return !Number.isNaN(Number(val));
};
function addUnit(value, defaultUnit = "px") {
  if (!value)
    return "";
  if (isNumber(value) || isStringNumber(value)) {
    return `${value}${defaultUnit}`;
  } else if (isString2(value)) {
    return value;
  }
}
let scrollBarWidth;
const getScrollBarWidth = (namespace) => {
  var _a2;
  if (!isClient)
    return 0;
  if (scrollBarWidth !== void 0)
    return scrollBarWidth;
  const outer = document.createElement("div");
  outer.className = `${namespace}-scrollbar__wrap`;
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.position = "absolute";
  outer.style.top = "-9999px";
  document.body.appendChild(outer);
  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = "scroll";
  const inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  const widthWithScroll = inner.offsetWidth;
  (_a2 = outer.parentNode) == null ? void 0 : _a2.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;
  return scrollBarWidth;
};
/*! Element Plus Icons Vue v2.1.0 */
var export_helper_default = (sfc, props2) => {
  let target = sfc.__vccOpts || sfc;
  for (let [key2, val] of props2)
    target[key2] = val;
  return target;
};
var arrow_right_vue_vue_type_script_lang_default = {
  name: "ArrowRight"
};
var _hoisted_110 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, _hoisted_210 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
}, null, -1), _hoisted_310 = [
  _hoisted_210
];
function _sfc_render10(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_110, _hoisted_310);
}
var arrow_right_default = /* @__PURE__ */ export_helper_default(arrow_right_vue_vue_type_script_lang_default, [["render", _sfc_render10], ["__file", "arrow-right.vue"]]);
var sort_down_vue_vue_type_script_lang_default = {
  name: "SortDown"
};
var _hoisted_1242 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, _hoisted_2242 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M576 96v709.568L333.312 562.816A32 32 0 1 0 288 608l297.408 297.344A32 32 0 0 0 640 882.688V96a32 32 0 0 0-64 0z"
}, null, -1), _hoisted_3241 = [
  _hoisted_2242
];
function _sfc_render242(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1242, _hoisted_3241);
}
var sort_down_default = /* @__PURE__ */ export_helper_default(sort_down_vue_vue_type_script_lang_default, [["render", _sfc_render242], ["__file", "sort-down.vue"]]);
var sort_up_vue_vue_type_script_lang_default = {
  name: "SortUp"
};
var _hoisted_1243 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, _hoisted_2243 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M384 141.248V928a32 32 0 1 0 64 0V218.56l242.688 242.688A32 32 0 1 0 736 416L438.592 118.656A32 32 0 0 0 384 141.248z"
}, null, -1), _hoisted_3242 = [
  _hoisted_2243
];
function _sfc_render243(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1243, _hoisted_3242);
}
var sort_up_default = /* @__PURE__ */ export_helper_default(sort_up_vue_vue_type_script_lang_default, [["render", _sfc_render243], ["__file", "sort-up.vue"]]);
const epPropKey = "__epPropKey";
const definePropType = (val) => val;
const isEpProp = (val) => isObject2(val) && !!val[epPropKey];
const buildProp = (prop, key2) => {
  if (!isObject2(prop) || isEpProp(prop))
    return prop;
  const { values, required: required4, default: defaultValue, type: type4, validator } = prop;
  const _validator = values || validator ? (val) => {
    let valid = false;
    let allowedValues = [];
    if (values) {
      allowedValues = Array.from(values);
      if (hasOwn2(prop, "default")) {
        allowedValues.push(defaultValue);
      }
      valid || (valid = allowedValues.includes(val));
    }
    if (validator)
      valid || (valid = validator(val));
    if (!valid && allowedValues.length > 0) {
      const allowValuesText = [...new Set(allowedValues)].map((value) => JSON.stringify(value)).join(", ");
      warn(`Invalid prop: validation failed${key2 ? ` for prop "${key2}"` : ""}. Expected one of [${allowValuesText}], got value ${JSON.stringify(val)}.`);
    }
    return valid;
  } : void 0;
  const epProp = {
    type: type4,
    required: !!required4,
    validator: _validator,
    [epPropKey]: true
  };
  if (hasOwn2(prop, "default"))
    epProp.default = defaultValue;
  return epProp;
};
const buildProps = (props2) => fromPairs(Object.entries(props2).map(([key2, option2]) => [
  key2,
  buildProp(option2, key2)
]));
const withInstall2 = (main, extra) => {
  main.install = (app) => {
    for (const comp of [main, ...Object.values(extra != null ? extra : {})]) {
      app.component(comp.name, comp);
    }
  };
  if (extra) {
    for (const [key2, comp] of Object.entries(extra)) {
      main[key2] = comp;
    }
  }
  return main;
};
const rAF = (fn) => isClient ? window.requestAnimationFrame(fn) : setTimeout(fn, 16);
const cAF = (handle) => isClient ? window.cancelAnimationFrame(handle) : clearTimeout(handle);
const mutable = (val) => val;
var English = {
  name: "en",
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Clear",
      defaultLabel: "color picker",
      description: "current color is {color}. press enter to select a new color."
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
      monthTablePrompt: "Use the arrow keys and enter to select the month",
      yearTablePrompt: "Use the arrow keys and enter to select the year",
      selectedDate: "Selected date",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      weeksFull: {
        sun: "Sunday",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    inputNumber: {
      decrease: "decrease number",
      increase: "increase number"
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    dropdown: {
      toggleDropdown: "Toggle Dropdown"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: "",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages",
      deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
    },
    dialog: {
      close: "Close this dialog"
    },
    drawer: {
      close: "Close this dialog"
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input",
      close: "Close this dialog"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    slider: {
      defaultLabel: "slider between {min} and {max}",
      defaultRangeStartLabel: "pick start value",
      defaultRangeEndLabel: "pick end value"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }
  }
};
const buildTranslator = (locale2) => (path, option2) => translate(path, option2, unref(locale2));
const translate = (path, option2, locale2) => get$1(locale2, path, path).replace(/\{(\w+)\}/g, (_2, key2) => {
  var _a2;
  return `${(_a2 = option2 == null ? void 0 : option2[key2]) != null ? _a2 : `{${key2}}`}`;
});
const buildLocaleContext = (locale2) => {
  const lang = computed(() => unref(locale2).name);
  const localeRef = isRef(locale2) ? locale2 : ref(locale2);
  return {
    lang,
    locale: localeRef,
    t: buildTranslator(locale2)
  };
};
const localeContextKey = Symbol("localeContextKey");
const useLocale = (localeOverrides) => {
  const locale2 = localeOverrides || inject(localeContextKey, ref());
  return buildLocaleContext(computed(() => locale2.value || English));
};
const defaultNamespace = "el";
const statePrefix = "is-";
const _bem = (namespace, block, blockSuffix, element, modifier) => {
  let cls = `${namespace}-${block}`;
  if (blockSuffix) {
    cls += `-${blockSuffix}`;
  }
  if (element) {
    cls += `__${element}`;
  }
  if (modifier) {
    cls += `--${modifier}`;
  }
  return cls;
};
const namespaceContextKey = Symbol("namespaceContextKey");
const useGetDerivedNamespace = (namespaceOverrides) => {
  const derivedNamespace = namespaceOverrides || (getCurrentInstance() ? inject(namespaceContextKey, ref(defaultNamespace)) : ref(defaultNamespace));
  const namespace = computed(() => {
    return unref(derivedNamespace) || defaultNamespace;
  });
  return namespace;
};
const useNamespace = (block, namespaceOverrides) => {
  const namespace = useGetDerivedNamespace(namespaceOverrides);
  const b2 = (blockSuffix = "") => _bem(namespace.value, block, blockSuffix, "", "");
  const e2 = (element) => element ? _bem(namespace.value, block, "", element, "") : "";
  const m2 = (modifier) => modifier ? _bem(namespace.value, block, "", "", modifier) : "";
  const be = (blockSuffix, element) => blockSuffix && element ? _bem(namespace.value, block, blockSuffix, element, "") : "";
  const em = (element, modifier) => element && modifier ? _bem(namespace.value, block, "", element, modifier) : "";
  const bm = (blockSuffix, modifier) => blockSuffix && modifier ? _bem(namespace.value, block, blockSuffix, "", modifier) : "";
  const bem = (blockSuffix, element, modifier) => blockSuffix && element && modifier ? _bem(namespace.value, block, blockSuffix, element, modifier) : "";
  const is3 = (name2, ...args) => {
    const state = args.length >= 1 ? args[0] : true;
    return name2 && state ? `${statePrefix}${name2}` : "";
  };
  const cssVar = (object4) => {
    const styles = {};
    for (const key2 in object4) {
      if (object4[key2]) {
        styles[`--${namespace.value}-${key2}`] = object4[key2];
      }
    }
    return styles;
  };
  const cssVarBlock = (object4) => {
    const styles = {};
    for (const key2 in object4) {
      if (object4[key2]) {
        styles[`--${namespace.value}-${block}-${key2}`] = object4[key2];
      }
    }
    return styles;
  };
  const cssVarName = (name2) => `--${namespace.value}-${name2}`;
  const cssVarBlockName = (name2) => `--${namespace.value}-${block}-${name2}`;
  return {
    namespace,
    b: b2,
    e: e2,
    m: m2,
    be,
    em,
    bm,
    bem,
    is: is3,
    cssVar,
    cssVarName,
    cssVarBlock,
    cssVarBlockName
  };
};
const defaultIdInjection = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
};
const ID_INJECTION_KEY = Symbol("elIdInjection");
const useIdInjection = () => {
  return getCurrentInstance() ? inject(ID_INJECTION_KEY, defaultIdInjection) : defaultIdInjection;
};
const useId = (deterministicId) => {
  const idInjection = useIdInjection();
  const namespace = useGetDerivedNamespace();
  const idRef = computed(() => unref(deterministicId) || `${namespace.value}-id-${idInjection.prefix}-${idInjection.current++}`);
  return idRef;
};
var _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key2, val] of props2) {
    target[key2] = val;
  }
  return target;
};
const iconProps = buildProps({
  size: {
    type: definePropType([Number, String])
  },
  color: {
    type: String
  }
});
const __default__$2 = defineComponent({
  name: "ElIcon",
  inheritAttrs: false
});
const _sfc_main$9 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$2), {
  props: iconProps,
  setup(__props) {
    const props2 = __props;
    const ns = useNamespace("icon");
    const style2 = computed(() => {
      const { size, color } = props2;
      if (!size && !color)
        return {};
      return {
        fontSize: isUndefined(size) ? void 0 : addUnit(size),
        "--color": color
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("i", mergeProps({
        class: unref(ns).b(),
        style: unref(style2)
      }, _ctx.$attrs), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var Icon2 = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/icon/src/icon.vue"]]);
const ElIcon = withInstall2(Icon2);
const BAR_MAP = {
  vertical: {
    offset: "offsetHeight",
    scroll: "scrollTop",
    scrollSize: "scrollHeight",
    size: "height",
    key: "vertical",
    axis: "Y",
    client: "clientY",
    direction: "top"
  },
  horizontal: {
    offset: "offsetWidth",
    scroll: "scrollLeft",
    scrollSize: "scrollWidth",
    size: "width",
    key: "horizontal",
    axis: "X",
    client: "clientX",
    direction: "left"
  }
};
const _hoisted_1$7 = {
  viewBox: "0 0 79 86",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$2 = ["id"];
const _hoisted_3$1 = ["stop-color"];
const _hoisted_4 = ["stop-color"];
const _hoisted_5 = ["id"];
const _hoisted_6 = ["stop-color"];
const _hoisted_7 = ["stop-color"];
const _hoisted_8 = ["id"];
const _hoisted_9 = {
  id: "Illustrations",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_10 = {
  id: "B-type",
  transform: "translate(-1268.000000, -535.000000)"
};
const _hoisted_11 = {
  id: "Group-2",
  transform: "translate(1268.000000, 535.000000)"
};
const _hoisted_12 = ["fill"];
const _hoisted_13 = ["fill"];
const _hoisted_14 = {
  id: "Group-Copy",
  transform: "translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"
};
const _hoisted_15 = ["fill"];
const _hoisted_16 = ["fill"];
const _hoisted_17 = ["fill"];
const _hoisted_18 = ["fill"];
const _hoisted_19 = ["fill"];
const _hoisted_20 = {
  id: "Rectangle-Copy-17",
  transform: "translate(53.000000, 45.000000)"
};
const _hoisted_21 = ["fill", "xlink:href"];
const _hoisted_22 = ["fill", "mask"];
const _hoisted_23 = ["fill"];
const __default__$1 = defineComponent({
  name: "ImgEmpty"
});
const _sfc_main$8 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$1), {
  setup(__props) {
    const ns = useNamespace("empty");
    const id = useId();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1$7, [
        createElementVNode("defs", null, [
          createElementVNode("linearGradient", {
            id: `linearGradient-1-${unref(id)}`,
            x1: "38.8503086%",
            y1: "0%",
            x2: "61.1496914%",
            y2: "100%"
          }, [
            createElementVNode("stop", {
              "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-1")})`,
              offset: "0%"
            }, null, 8, _hoisted_3$1),
            createElementVNode("stop", {
              "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-4")})`,
              offset: "100%"
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_2$2),
          createElementVNode("linearGradient", {
            id: `linearGradient-2-${unref(id)}`,
            x1: "0%",
            y1: "9.5%",
            x2: "100%",
            y2: "90.5%"
          }, [
            createElementVNode("stop", {
              "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-1")})`,
              offset: "0%"
            }, null, 8, _hoisted_6),
            createElementVNode("stop", {
              "stop-color": `var(${unref(ns).cssVarBlockName("fill-color-6")})`,
              offset: "100%"
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_5),
          createElementVNode("rect", {
            id: `path-3-${unref(id)}`,
            x: "0",
            y: "0",
            width: "17",
            height: "36"
          }, null, 8, _hoisted_8)
        ]),
        createElementVNode("g", _hoisted_9, [
          createElementVNode("g", _hoisted_10, [
            createElementVNode("g", _hoisted_11, [
              createElementVNode("path", {
                id: "Oval-Copy-2",
                d: "M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z",
                fill: `var(${unref(ns).cssVarBlockName("fill-color-3")})`
              }, null, 8, _hoisted_12),
              createElementVNode("polygon", {
                id: "Rectangle-Copy-14",
                fill: `var(${unref(ns).cssVarBlockName("fill-color-7")})`,
                transform: "translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) ",
                points: "13 58 53 58 42 45 2 45"
              }, null, 8, _hoisted_13),
              createElementVNode("g", _hoisted_14, [
                createElementVNode("polygon", {
                  id: "Rectangle-Copy-10",
                  fill: `var(${unref(ns).cssVarBlockName("fill-color-7")})`,
                  transform: "translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) ",
                  points: "2.84078316e-14 3 18 3 23 7 5 7"
                }, null, 8, _hoisted_15),
                createElementVNode("polygon", {
                  id: "Rectangle-Copy-11",
                  fill: `var(${unref(ns).cssVarBlockName("fill-color-5")})`,
                  points: "-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"
                }, null, 8, _hoisted_16),
                createElementVNode("rect", {
                  id: "Rectangle-Copy-12",
                  fill: `url(#linearGradient-1-${unref(id)})`,
                  transform: "translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) ",
                  x: "38",
                  y: "7",
                  width: "17",
                  height: "36"
                }, null, 8, _hoisted_17),
                createElementVNode("polygon", {
                  id: "Rectangle-Copy-13",
                  fill: `var(${unref(ns).cssVarBlockName("fill-color-2")})`,
                  transform: "translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) ",
                  points: "24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"
                }, null, 8, _hoisted_18)
              ]),
              createElementVNode("rect", {
                id: "Rectangle-Copy-15",
                fill: `url(#linearGradient-2-${unref(id)})`,
                x: "13",
                y: "45",
                width: "40",
                height: "36"
              }, null, 8, _hoisted_19),
              createElementVNode("g", _hoisted_20, [
                createElementVNode("use", {
                  id: "Mask",
                  fill: `var(${unref(ns).cssVarBlockName("fill-color-8")})`,
                  transform: "translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) ",
                  "xlink:href": `#path-3-${unref(id)}`
                }, null, 8, _hoisted_21),
                createElementVNode("polygon", {
                  id: "Rectangle-Copy",
                  fill: `var(${unref(ns).cssVarBlockName("fill-color-9")})`,
                  mask: `url(#mask-4-${unref(id)})`,
                  transform: "translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) ",
                  points: "7 0 24 0 20 18 7 16.5"
                }, null, 8, _hoisted_22)
              ]),
              createElementVNode("polygon", {
                id: "Rectangle-Copy-18",
                fill: `var(${unref(ns).cssVarBlockName("fill-color-2")})`,
                transform: "translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) ",
                points: "62 45 79 45 70 58 53 58"
              }, null, 8, _hoisted_23)
            ])
          ])
        ])
      ]);
    };
  }
}));
var ImgEmpty = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/empty/src/img-empty.vue"]]);
const emptyProps = buildProps({
  image: {
    type: String,
    default: ""
  },
  imageSize: Number,
  description: {
    type: String,
    default: ""
  }
});
const _hoisted_1$6 = ["src"];
const _hoisted_2$1 = { key: 1 };
const __default__ = defineComponent({
  name: "ElEmpty"
});
const _sfc_main$7 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__), {
  props: emptyProps,
  setup(__props) {
    const props2 = __props;
    const { t: t2 } = useLocale();
    const ns = useNamespace("empty");
    const emptyDescription = computed(() => props2.description || t2("el.table.emptyText"));
    const imageStyle = computed(() => ({
      width: addUnit(props2.imageSize)
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(ns).b())
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(ns).e("image")),
          style: normalizeStyle(unref(imageStyle))
        }, [
          _ctx.image ? (openBlock(), createElementBlock("img", {
            key: 0,
            src: _ctx.image,
            ondragstart: "return false"
          }, null, 8, _hoisted_1$6)) : renderSlot(_ctx.$slots, "image", { key: 1 }, () => [
            createVNode(ImgEmpty)
          ])
        ], 6),
        createElementVNode("div", {
          class: normalizeClass(unref(ns).e("description"))
        }, [
          _ctx.$slots.description ? renderSlot(_ctx.$slots, "description", { key: 0 }) : (openBlock(), createElementBlock("p", _hoisted_2$1, toDisplayString(unref(emptyDescription)), 1))
        ], 2),
        _ctx.$slots.default ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(ns).e("bottom"))
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)) : createCommentVNode("v-if", true)
      ], 2);
    };
  }
}));
var Empty3 = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__file", "/home/runner/work/element-plus/element-plus/packages/components/empty/src/empty.vue"]]);
const ElEmpty = withInstall2(Empty3);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i2 = 0; i2 < newInputs.length; i2++) {
    if (!isEqual(newInputs[i2], lastInputs[i2])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var cache2 = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache2 && cache2.lastThis === this && isEqual2(newArgs, cache2.lastArgs)) {
      return cache2.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache2 = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache2 = null;
  };
  return memoized;
}
const useCache = () => {
  const vm = getCurrentInstance();
  const props2 = vm.proxy.$props;
  return computed(() => {
    const _getItemStyleCache = (_2, __, ___) => ({});
    return props2.perfMode ? memoize(_getItemStyleCache) : memoizeOne(_getItemStyleCache);
  });
};
const DEFAULT_DYNAMIC_LIST_ITEM_SIZE = 50;
const ITEM_RENDER_EVT = "itemRendered";
const SCROLL_EVT = "scroll";
const FORWARD = "forward";
const BACKWARD = "backward";
const AUTO_ALIGNMENT = "auto";
const SMART_ALIGNMENT = "smart";
const START_ALIGNMENT = "start";
const CENTERED_ALIGNMENT = "center";
const END_ALIGNMENT = "end";
const HORIZONTAL = "horizontal";
const VERTICAL = "vertical";
const RTL = "rtl";
const RTL_OFFSET_NAG = "negative";
const RTL_OFFSET_POS_ASC = "positive-ascending";
const RTL_OFFSET_POS_DESC = "positive-descending";
const ScrollbarDirKey = {
  [HORIZONTAL]: "left",
  [VERTICAL]: "top"
};
const SCROLLBAR_MIN_SIZE = 20;
const itemSize = buildProp({
  type: definePropType([Number, Function]),
  required: true
});
const estimatedItemSize = buildProp({
  type: Number
});
const cache = buildProp({
  type: Number,
  default: 2
});
const direction = buildProp({
  type: String,
  values: ["ltr", "rtl"],
  default: "ltr"
});
const initScrollOffset = buildProp({
  type: Number,
  default: 0
});
const total2 = buildProp({
  type: Number,
  required: true
});
const layout = buildProp({
  type: String,
  values: ["horizontal", "vertical"],
  default: VERTICAL
});
const virtualizedProps = buildProps({
  className: {
    type: String,
    default: ""
  },
  containerElement: {
    type: definePropType([String, Object]),
    default: "div"
  },
  data: {
    type: definePropType(Array),
    default: () => mutable([])
  },
  direction,
  height: {
    type: [String, Number],
    required: true
  },
  innerElement: {
    type: [String, Object],
    default: "div"
  },
  style: {
    type: definePropType([Object, String, Array])
  },
  useIsScrolling: {
    type: Boolean,
    default: false
  },
  width: {
    type: [Number, String],
    required: false
  },
  perfMode: {
    type: Boolean,
    default: true
  },
  scrollbarAlwaysOn: {
    type: Boolean,
    default: false
  }
});
const virtualizedListProps = buildProps(__spreadValues({
  cache,
  estimatedItemSize,
  layout,
  initScrollOffset,
  total: total2,
  itemSize
}, virtualizedProps));
const scrollbarSize = {
  type: Number,
  default: 6
};
const startGap = { type: Number, default: 0 };
const endGap = { type: Number, default: 2 };
const virtualizedGridProps = buildProps(__spreadValues({
  columnCache: cache,
  columnWidth: itemSize,
  estimatedColumnWidth: estimatedItemSize,
  estimatedRowHeight: estimatedItemSize,
  initScrollLeft: initScrollOffset,
  initScrollTop: initScrollOffset,
  itemKey: {
    type: definePropType(Function),
    default: ({
      columnIndex,
      rowIndex
    }) => `${rowIndex}:${columnIndex}`
  },
  rowCache: cache,
  rowHeight: itemSize,
  totalColumn: total2,
  totalRow: total2,
  hScrollbarSize: scrollbarSize,
  vScrollbarSize: scrollbarSize,
  scrollbarStartGap: startGap,
  scrollbarEndGap: endGap,
  role: String
}, virtualizedProps));
const virtualizedScrollbarProps = buildProps({
  alwaysOn: Boolean,
  class: String,
  layout,
  total: total2,
  ratio: {
    type: Number,
    required: true
  },
  clientSize: {
    type: Number,
    required: true
  },
  scrollFrom: {
    type: Number,
    required: true
  },
  scrollbarSize,
  startGap,
  endGap,
  visible: Boolean
});
const getScrollDir = (prev2, cur) => prev2 < cur ? FORWARD : BACKWARD;
const isRTL = (dir) => dir === RTL;
let cachedRTLResult = null;
function getRTLOffsetType(recalculate = false) {
  if (cachedRTLResult === null || recalculate) {
    const outerDiv = document.createElement("div");
    const outerStyle = outerDiv.style;
    outerStyle.width = "50px";
    outerStyle.height = "50px";
    outerStyle.overflow = "scroll";
    outerStyle.direction = "rtl";
    const innerDiv = document.createElement("div");
    const innerStyle = innerDiv.style;
    innerStyle.width = "100px";
    innerStyle.height = "100px";
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);
    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = RTL_OFFSET_POS_DESC;
    } else {
      outerDiv.scrollLeft = 1;
      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = RTL_OFFSET_NAG;
      } else {
        cachedRTLResult = RTL_OFFSET_POS_ASC;
      }
    }
    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }
  return cachedRTLResult;
}
function renderThumbStyle({ move, size, bar }, layout2) {
  const style2 = {};
  const translate2 = `translate${bar.axis}(${move}px)`;
  style2[bar.size] = size;
  style2.transform = translate2;
  style2.msTransform = translate2;
  style2.webkitTransform = translate2;
  if (layout2 === "horizontal") {
    style2.height = "100%";
  } else {
    style2.width = "100%";
  }
  return style2;
}
const ScrollBar = defineComponent({
  name: "ElVirtualScrollBar",
  props: virtualizedScrollbarProps,
  emits: ["scroll", "start-move", "stop-move"],
  setup(props2, { emit }) {
    const GAP = computed(() => props2.startGap + props2.endGap);
    const nsVirtualScrollbar = useNamespace("virtual-scrollbar");
    const nsScrollbar = useNamespace("scrollbar");
    const trackRef = ref();
    const thumbRef = ref();
    let frameHandle = null;
    let onselectstartStore = null;
    const state = reactive({
      isDragging: false,
      traveled: 0
    });
    const bar = computed(() => BAR_MAP[props2.layout]);
    const trackSize = computed(() => props2.clientSize - unref(GAP));
    const trackStyle = computed(() => ({
      position: "absolute",
      width: `${HORIZONTAL === props2.layout ? trackSize.value : props2.scrollbarSize}px`,
      height: `${HORIZONTAL === props2.layout ? props2.scrollbarSize : trackSize.value}px`,
      [ScrollbarDirKey[props2.layout]]: "2px",
      right: "2px",
      bottom: "2px",
      borderRadius: "4px"
    }));
    const thumbSize = computed(() => {
      const ratio = props2.ratio;
      const clientSize = props2.clientSize;
      if (ratio >= 100) {
        return Number.POSITIVE_INFINITY;
      }
      if (ratio >= 50) {
        return ratio * clientSize / 100;
      }
      const SCROLLBAR_MAX_SIZE = clientSize / 3;
      return Math.floor(Math.min(Math.max(ratio * clientSize, SCROLLBAR_MIN_SIZE), SCROLLBAR_MAX_SIZE));
    });
    const thumbStyle = computed(() => {
      if (!Number.isFinite(thumbSize.value)) {
        return {
          display: "none"
        };
      }
      const thumb = `${thumbSize.value}px`;
      const style2 = renderThumbStyle({
        bar: bar.value,
        size: thumb,
        move: state.traveled
      }, props2.layout);
      return style2;
    });
    const totalSteps = computed(() => Math.floor(props2.clientSize - thumbSize.value - unref(GAP)));
    const attachEvents = () => {
      window.addEventListener("mousemove", onMouseMove3);
      window.addEventListener("mouseup", onMouseUp2);
      const thumbEl = unref(thumbRef);
      if (!thumbEl)
        return;
      onselectstartStore = document.onselectstart;
      document.onselectstart = () => false;
      thumbEl.addEventListener("touchmove", onMouseMove3);
      thumbEl.addEventListener("touchend", onMouseUp2);
    };
    const detachEvents = () => {
      window.removeEventListener("mousemove", onMouseMove3);
      window.removeEventListener("mouseup", onMouseUp2);
      document.onselectstart = onselectstartStore;
      onselectstartStore = null;
      const thumbEl = unref(thumbRef);
      if (!thumbEl)
        return;
      thumbEl.removeEventListener("touchmove", onMouseMove3);
      thumbEl.removeEventListener("touchend", onMouseUp2);
    };
    const onThumbMouseDown = (e2) => {
      e2.stopImmediatePropagation();
      if (e2.ctrlKey || [1, 2].includes(e2.button)) {
        return;
      }
      state.isDragging = true;
      state[bar.value.axis] = e2.currentTarget[bar.value.offset] - (e2[bar.value.client] - e2.currentTarget.getBoundingClientRect()[bar.value.direction]);
      emit("start-move");
      attachEvents();
    };
    const onMouseUp2 = () => {
      state.isDragging = false;
      state[bar.value.axis] = 0;
      emit("stop-move");
      detachEvents();
    };
    const onMouseMove3 = (e2) => {
      const { isDragging } = state;
      if (!isDragging)
        return;
      if (!thumbRef.value || !trackRef.value)
        return;
      const prevPage = state[bar.value.axis];
      if (!prevPage)
        return;
      cAF(frameHandle);
      const offset3 = (trackRef.value.getBoundingClientRect()[bar.value.direction] - e2[bar.value.client]) * -1;
      const thumbClickPosition = thumbRef.value[bar.value.offset] - prevPage;
      const distance = offset3 - thumbClickPosition;
      frameHandle = rAF(() => {
        state.traveled = Math.max(props2.startGap, Math.min(distance, totalSteps.value));
        emit("scroll", distance, totalSteps.value);
      });
    };
    const clickTrackHandler = (e2) => {
      const offset3 = Math.abs(e2.target.getBoundingClientRect()[bar.value.direction] - e2[bar.value.client]);
      const thumbHalf = thumbRef.value[bar.value.offset] / 2;
      const distance = offset3 - thumbHalf;
      state.traveled = Math.max(0, Math.min(distance, totalSteps.value));
      emit("scroll", distance, totalSteps.value);
    };
    watch(() => props2.scrollFrom, (v2) => {
      if (state.isDragging)
        return;
      state.traveled = Math.ceil(v2 * totalSteps.value);
    });
    onBeforeUnmount(() => {
      detachEvents();
    });
    return () => {
      return h$2("div", {
        role: "presentation",
        ref: trackRef,
        class: [
          nsVirtualScrollbar.b(),
          props2.class,
          (props2.alwaysOn || state.isDragging) && "always-on"
        ],
        style: trackStyle.value,
        onMousedown: withModifiers(clickTrackHandler, ["stop", "prevent"]),
        onTouchstartPrevent: onThumbMouseDown
      }, h$2("div", {
        ref: thumbRef,
        class: nsScrollbar.e("thumb"),
        style: thumbStyle.value,
        onMousedown: onThumbMouseDown
      }, []));
    };
  }
});
const useGridWheel = ({ atXEndEdge, atXStartEdge, atYEndEdge, atYStartEdge }, onWheelDelta) => {
  let frameHandle = null;
  let xOffset = 0;
  let yOffset = 0;
  const hasReachedEdge = (x2, y2) => {
    const xEdgeReached = x2 <= 0 && atXStartEdge.value || x2 >= 0 && atXEndEdge.value;
    const yEdgeReached = y2 <= 0 && atYStartEdge.value || y2 >= 0 && atYEndEdge.value;
    return xEdgeReached && yEdgeReached;
  };
  const onWheel = (e2) => {
    cAF(frameHandle);
    let x2 = e2.deltaX;
    let y2 = e2.deltaY;
    if (Math.abs(x2) > Math.abs(y2)) {
      y2 = 0;
    } else {
      x2 = 0;
    }
    if (e2.shiftKey && y2 !== 0) {
      x2 = y2;
      y2 = 0;
    }
    if (hasReachedEdge(xOffset, yOffset) && hasReachedEdge(xOffset + x2, yOffset + y2))
      return;
    xOffset += x2;
    yOffset += y2;
    e2.preventDefault();
    frameHandle = rAF(() => {
      onWheelDelta(xOffset, yOffset);
      xOffset = 0;
      yOffset = 0;
    });
  };
  return {
    hasReachedEdge,
    onWheel
  };
};
const createGrid = ({
  name: name2,
  clearCache,
  getColumnPosition,
  getColumnStartIndexForOffset,
  getColumnStopIndexForStartIndex,
  getEstimatedTotalHeight: getEstimatedTotalHeight2,
  getEstimatedTotalWidth: getEstimatedTotalWidth2,
  getColumnOffset,
  getRowOffset,
  getRowPosition,
  getRowStartIndexForOffset,
  getRowStopIndexForStartIndex,
  initCache,
  injectToInstance,
  validateProps
}) => {
  return defineComponent({
    name: name2 != null ? name2 : "ElVirtualList",
    props: virtualizedGridProps,
    emits: [ITEM_RENDER_EVT, SCROLL_EVT],
    setup(props2, { emit, expose, slots }) {
      const ns = useNamespace("vl");
      validateProps(props2);
      const instance2 = getCurrentInstance();
      const cache2 = ref(initCache(props2, instance2));
      injectToInstance == null ? void 0 : injectToInstance(instance2, cache2);
      const windowRef = ref();
      const hScrollbar = ref();
      const vScrollbar = ref();
      const innerRef = ref(null);
      const states = ref({
        isScrolling: false,
        scrollLeft: isNumber(props2.initScrollLeft) ? props2.initScrollLeft : 0,
        scrollTop: isNumber(props2.initScrollTop) ? props2.initScrollTop : 0,
        updateRequested: false,
        xAxisScrollDir: FORWARD,
        yAxisScrollDir: FORWARD
      });
      const getItemStyleCache = useCache();
      const parsedHeight = computed(() => Number.parseInt(`${props2.height}`, 10));
      const parsedWidth = computed(() => Number.parseInt(`${props2.width}`, 10));
      const columnsToRender = computed(() => {
        const { totalColumn, totalRow, columnCache } = props2;
        const { isScrolling, xAxisScrollDir, scrollLeft } = unref(states);
        if (totalColumn === 0 || totalRow === 0) {
          return [0, 0, 0, 0];
        }
        const startIndex = getColumnStartIndexForOffset(props2, scrollLeft, unref(cache2));
        const stopIndex = getColumnStopIndexForStartIndex(props2, startIndex, scrollLeft, unref(cache2));
        const cacheBackward = !isScrolling || xAxisScrollDir === BACKWARD ? Math.max(1, columnCache) : 1;
        const cacheForward = !isScrolling || xAxisScrollDir === FORWARD ? Math.max(1, columnCache) : 1;
        return [
          Math.max(0, startIndex - cacheBackward),
          Math.max(0, Math.min(totalColumn - 1, stopIndex + cacheForward)),
          startIndex,
          stopIndex
        ];
      });
      const rowsToRender = computed(() => {
        const { totalColumn, totalRow, rowCache } = props2;
        const { isScrolling, yAxisScrollDir, scrollTop } = unref(states);
        if (totalColumn === 0 || totalRow === 0) {
          return [0, 0, 0, 0];
        }
        const startIndex = getRowStartIndexForOffset(props2, scrollTop, unref(cache2));
        const stopIndex = getRowStopIndexForStartIndex(props2, startIndex, scrollTop, unref(cache2));
        const cacheBackward = !isScrolling || yAxisScrollDir === BACKWARD ? Math.max(1, rowCache) : 1;
        const cacheForward = !isScrolling || yAxisScrollDir === FORWARD ? Math.max(1, rowCache) : 1;
        return [
          Math.max(0, startIndex - cacheBackward),
          Math.max(0, Math.min(totalRow - 1, stopIndex + cacheForward)),
          startIndex,
          stopIndex
        ];
      });
      const estimatedTotalHeight = computed(() => getEstimatedTotalHeight2(props2, unref(cache2)));
      const estimatedTotalWidth = computed(() => getEstimatedTotalWidth2(props2, unref(cache2)));
      const windowStyle = computed(() => {
        var _a2;
        return [
          {
            position: "relative",
            overflow: "hidden",
            WebkitOverflowScrolling: "touch",
            willChange: "transform"
          },
          {
            direction: props2.direction,
            height: isNumber(props2.height) ? `${props2.height}px` : props2.height,
            width: isNumber(props2.width) ? `${props2.width}px` : props2.width
          },
          (_a2 = props2.style) != null ? _a2 : {}
        ];
      });
      const innerStyle = computed(() => {
        const width = `${unref(estimatedTotalWidth)}px`;
        const height = `${unref(estimatedTotalHeight)}px`;
        return {
          height,
          pointerEvents: unref(states).isScrolling ? "none" : void 0,
          width
        };
      });
      const emitEvents = () => {
        const { totalColumn, totalRow } = props2;
        if (totalColumn > 0 && totalRow > 0) {
          const [
            columnCacheStart,
            columnCacheEnd,
            columnVisibleStart,
            columnVisibleEnd
          ] = unref(columnsToRender);
          const [rowCacheStart, rowCacheEnd, rowVisibleStart, rowVisibleEnd] = unref(rowsToRender);
          emit(ITEM_RENDER_EVT, {
            columnCacheStart,
            columnCacheEnd,
            rowCacheStart,
            rowCacheEnd,
            columnVisibleStart,
            columnVisibleEnd,
            rowVisibleStart,
            rowVisibleEnd
          });
        }
        const {
          scrollLeft,
          scrollTop,
          updateRequested,
          xAxisScrollDir,
          yAxisScrollDir
        } = unref(states);
        emit(SCROLL_EVT, {
          xAxisScrollDir,
          scrollLeft,
          yAxisScrollDir,
          scrollTop,
          updateRequested
        });
      };
      const onScroll = (e2) => {
        const {
          clientHeight,
          clientWidth,
          scrollHeight,
          scrollLeft,
          scrollTop,
          scrollWidth
        } = e2.currentTarget;
        const _states = unref(states);
        if (_states.scrollTop === scrollTop && _states.scrollLeft === scrollLeft) {
          return;
        }
        let _scrollLeft = scrollLeft;
        if (isRTL(props2.direction)) {
          switch (getRTLOffsetType()) {
            case RTL_OFFSET_NAG:
              _scrollLeft = -scrollLeft;
              break;
            case RTL_OFFSET_POS_DESC:
              _scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        }
        states.value = __spreadProps(__spreadValues({}, _states), {
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight)),
          updateRequested: true,
          xAxisScrollDir: getScrollDir(_states.scrollLeft, _scrollLeft),
          yAxisScrollDir: getScrollDir(_states.scrollTop, scrollTop)
        });
        nextTick(() => resetIsScrolling());
        onUpdated2();
        emitEvents();
      };
      const onVerticalScroll = (distance, totalSteps) => {
        const height = unref(parsedHeight);
        const offset3 = (estimatedTotalHeight.value - height) / totalSteps * distance;
        scrollTo2({
          scrollTop: Math.min(estimatedTotalHeight.value - height, offset3)
        });
      };
      const onHorizontalScroll = (distance, totalSteps) => {
        const width = unref(parsedWidth);
        const offset3 = (estimatedTotalWidth.value - width) / totalSteps * distance;
        scrollTo2({
          scrollLeft: Math.min(estimatedTotalWidth.value - width, offset3)
        });
      };
      const { onWheel } = useGridWheel({
        atXStartEdge: computed(() => states.value.scrollLeft <= 0),
        atXEndEdge: computed(() => states.value.scrollLeft >= estimatedTotalWidth.value - unref(parsedWidth)),
        atYStartEdge: computed(() => states.value.scrollTop <= 0),
        atYEndEdge: computed(() => states.value.scrollTop >= estimatedTotalHeight.value - unref(parsedHeight))
      }, (x2, y2) => {
        var _a2, _b, _c, _d;
        (_b = (_a2 = hScrollbar.value) == null ? void 0 : _a2.onMouseUp) == null ? void 0 : _b.call(_a2);
        (_d = (_c = vScrollbar.value) == null ? void 0 : _c.onMouseUp) == null ? void 0 : _d.call(_c);
        const width = unref(parsedWidth);
        const height = unref(parsedHeight);
        scrollTo2({
          scrollLeft: Math.min(states.value.scrollLeft + x2, estimatedTotalWidth.value - width),
          scrollTop: Math.min(states.value.scrollTop + y2, estimatedTotalHeight.value - height)
        });
      });
      const scrollTo2 = ({
        scrollLeft = states.value.scrollLeft,
        scrollTop = states.value.scrollTop
      }) => {
        scrollLeft = Math.max(scrollLeft, 0);
        scrollTop = Math.max(scrollTop, 0);
        const _states = unref(states);
        if (scrollTop === _states.scrollTop && scrollLeft === _states.scrollLeft) {
          return;
        }
        states.value = __spreadProps(__spreadValues({}, _states), {
          xAxisScrollDir: getScrollDir(_states.scrollLeft, scrollLeft),
          yAxisScrollDir: getScrollDir(_states.scrollTop, scrollTop),
          scrollLeft,
          scrollTop,
          updateRequested: true
        });
        nextTick(() => resetIsScrolling());
        onUpdated2();
        emitEvents();
      };
      const scrollToItem = (rowIndex = 0, columnIdx = 0, alignment = AUTO_ALIGNMENT) => {
        const _states = unref(states);
        columnIdx = Math.max(0, Math.min(columnIdx, props2.totalColumn - 1));
        rowIndex = Math.max(0, Math.min(rowIndex, props2.totalRow - 1));
        const scrollBarWidth2 = getScrollBarWidth(ns.namespace.value);
        const _cache = unref(cache2);
        const estimatedHeight = getEstimatedTotalHeight2(props2, _cache);
        const estimatedWidth = getEstimatedTotalWidth2(props2, _cache);
        scrollTo2({
          scrollLeft: getColumnOffset(props2, columnIdx, alignment, _states.scrollLeft, _cache, estimatedWidth > props2.width ? scrollBarWidth2 : 0),
          scrollTop: getRowOffset(props2, rowIndex, alignment, _states.scrollTop, _cache, estimatedHeight > props2.height ? scrollBarWidth2 : 0)
        });
      };
      const getItemStyle = (rowIndex, columnIndex) => {
        const { columnWidth, direction: direction2, rowHeight } = props2;
        const itemStyleCache = getItemStyleCache.value(clearCache && columnWidth, clearCache && rowHeight, clearCache && direction2);
        const key2 = `${rowIndex},${columnIndex}`;
        if (hasOwn2(itemStyleCache, key2)) {
          return itemStyleCache[key2];
        } else {
          const [, left] = getColumnPosition(props2, columnIndex, unref(cache2));
          const _cache = unref(cache2);
          const rtl2 = isRTL(direction2);
          const [height, top] = getRowPosition(props2, rowIndex, _cache);
          const [width] = getColumnPosition(props2, columnIndex, _cache);
          itemStyleCache[key2] = {
            position: "absolute",
            left: rtl2 ? void 0 : `${left}px`,
            right: rtl2 ? `${left}px` : void 0,
            top: `${top}px`,
            height: `${height}px`,
            width: `${width}px`
          };
          return itemStyleCache[key2];
        }
      };
      const resetIsScrolling = () => {
        states.value.isScrolling = false;
        nextTick(() => {
          getItemStyleCache.value(-1, null, null);
        });
      };
      onMounted(() => {
        if (!isClient)
          return;
        const { initScrollLeft, initScrollTop } = props2;
        const windowElement = unref(windowRef);
        if (windowElement) {
          if (isNumber(initScrollLeft)) {
            windowElement.scrollLeft = initScrollLeft;
          }
          if (isNumber(initScrollTop)) {
            windowElement.scrollTop = initScrollTop;
          }
        }
        emitEvents();
      });
      const onUpdated2 = () => {
        const { direction: direction2 } = props2;
        const { scrollLeft, scrollTop, updateRequested } = unref(states);
        const windowElement = unref(windowRef);
        if (updateRequested && windowElement) {
          if (direction2 === RTL) {
            switch (getRTLOffsetType()) {
              case RTL_OFFSET_NAG: {
                windowElement.scrollLeft = -scrollLeft;
                break;
              }
              case RTL_OFFSET_POS_ASC: {
                windowElement.scrollLeft = scrollLeft;
                break;
              }
              default: {
                const { clientWidth, scrollWidth } = windowElement;
                windowElement.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
              }
            }
          } else {
            windowElement.scrollLeft = Math.max(0, scrollLeft);
          }
          windowElement.scrollTop = Math.max(0, scrollTop);
        }
      };
      const { resetAfterColumnIndex, resetAfterRowIndex, resetAfter } = instance2.proxy;
      expose({
        windowRef,
        innerRef,
        getItemStyleCache,
        scrollTo: scrollTo2,
        scrollToItem,
        states,
        resetAfterColumnIndex,
        resetAfterRowIndex,
        resetAfter
      });
      const renderScrollbars = () => {
        const {
          scrollbarAlwaysOn,
          scrollbarStartGap,
          scrollbarEndGap,
          totalColumn,
          totalRow
        } = props2;
        const width = unref(parsedWidth);
        const height = unref(parsedHeight);
        const estimatedWidth = unref(estimatedTotalWidth);
        const estimatedHeight = unref(estimatedTotalHeight);
        const { scrollLeft, scrollTop } = unref(states);
        const horizontalScrollbar = h$2(ScrollBar, {
          ref: hScrollbar,
          alwaysOn: scrollbarAlwaysOn,
          startGap: scrollbarStartGap,
          endGap: scrollbarEndGap,
          class: ns.e("horizontal"),
          clientSize: width,
          layout: "horizontal",
          onScroll: onHorizontalScroll,
          ratio: width * 100 / estimatedWidth,
          scrollFrom: scrollLeft / (estimatedWidth - width),
          total: totalRow,
          visible: true
        });
        const verticalScrollbar = h$2(ScrollBar, {
          ref: vScrollbar,
          alwaysOn: scrollbarAlwaysOn,
          startGap: scrollbarStartGap,
          endGap: scrollbarEndGap,
          class: ns.e("vertical"),
          clientSize: height,
          layout: "vertical",
          onScroll: onVerticalScroll,
          ratio: height * 100 / estimatedHeight,
          scrollFrom: scrollTop / (estimatedHeight - height),
          total: totalColumn,
          visible: true
        });
        return {
          horizontalScrollbar,
          verticalScrollbar
        };
      };
      const renderItems = () => {
        var _a2;
        const [columnStart, columnEnd] = unref(columnsToRender);
        const [rowStart, rowEnd] = unref(rowsToRender);
        const { data: data6, totalColumn, totalRow, useIsScrolling, itemKey: itemKey2 } = props2;
        const children = [];
        if (totalRow > 0 && totalColumn > 0) {
          for (let row = rowStart; row <= rowEnd; row++) {
            for (let column = columnStart; column <= columnEnd; column++) {
              children.push((_a2 = slots.default) == null ? void 0 : _a2.call(slots, {
                columnIndex: column,
                data: data6,
                key: itemKey2({ columnIndex: column, data: data6, rowIndex: row }),
                isScrolling: useIsScrolling ? unref(states).isScrolling : void 0,
                style: getItemStyle(row, column),
                rowIndex: row
              }));
            }
          }
        }
        return children;
      };
      const renderInner = () => {
        const Inner = resolveDynamicComponent(props2.innerElement);
        const children = renderItems();
        return [
          h$2(Inner, {
            style: unref(innerStyle),
            ref: innerRef
          }, !isString2(Inner) ? {
            default: () => children
          } : children)
        ];
      };
      const renderWindow = () => {
        const Container = resolveDynamicComponent(props2.containerElement);
        const { horizontalScrollbar, verticalScrollbar } = renderScrollbars();
        const Inner = renderInner();
        return h$2("div", {
          key: 0,
          class: ns.e("wrapper"),
          role: props2.role
        }, [
          h$2(Container, {
            class: props2.className,
            style: unref(windowStyle),
            onScroll,
            onWheel,
            ref: windowRef
          }, !isString2(Container) ? { default: () => Inner } : Inner),
          horizontalScrollbar,
          verticalScrollbar
        ]);
      };
      return renderWindow;
    }
  });
};
const FixedSizeGrid = createGrid({
  name: "ElFixedSizeGrid",
  getColumnPosition: ({ columnWidth }, index2) => [
    columnWidth,
    index2 * columnWidth
  ],
  getRowPosition: ({ rowHeight }, index2) => [
    rowHeight,
    index2 * rowHeight
  ],
  getEstimatedTotalHeight: ({ totalRow, rowHeight }) => rowHeight * totalRow,
  getEstimatedTotalWidth: ({ totalColumn, columnWidth }) => columnWidth * totalColumn,
  getColumnOffset: ({ totalColumn, columnWidth, width }, columnIndex, alignment, scrollLeft, _2, scrollBarWidth2) => {
    width = Number(width);
    const lastColumnOffset = Math.max(0, totalColumn * columnWidth - width);
    const maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    const minOffset = Math.max(0, columnIndex * columnWidth - width + scrollBarWidth2 + columnWidth);
    if (alignment === "smart") {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        alignment = AUTO_ALIGNMENT;
      } else {
        alignment = CENTERED_ALIGNMENT;
      }
    }
    switch (alignment) {
      case START_ALIGNMENT:
        return maxOffset;
      case END_ALIGNMENT:
        return minOffset;
      case CENTERED_ALIGNMENT: {
        const middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
        if (middleOffset < Math.ceil(width / 2)) {
          return 0;
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset;
        } else {
          return middleOffset;
        }
      }
      case AUTO_ALIGNMENT:
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getRowOffset: ({ rowHeight, height, totalRow }, rowIndex, align, scrollTop, _2, scrollBarWidth2) => {
    height = Number(height);
    const lastRowOffset = Math.max(0, totalRow * rowHeight - height);
    const maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    const minOffset = Math.max(0, rowIndex * rowHeight - height + scrollBarWidth2 + rowHeight);
    if (align === SMART_ALIGNMENT) {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = AUTO_ALIGNMENT;
      } else {
        align = CENTERED_ALIGNMENT;
      }
    }
    switch (align) {
      case START_ALIGNMENT:
        return maxOffset;
      case END_ALIGNMENT:
        return minOffset;
      case CENTERED_ALIGNMENT: {
        const middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
        if (middleOffset < Math.ceil(height / 2)) {
          return 0;
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset;
        } else {
          return middleOffset;
        }
      }
      case AUTO_ALIGNMENT:
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getColumnStartIndexForOffset: ({ columnWidth, totalColumn }, scrollLeft) => Math.max(0, Math.min(totalColumn - 1, Math.floor(scrollLeft / columnWidth))),
  getColumnStopIndexForStartIndex: ({ columnWidth, totalColumn, width }, startIndex, scrollLeft) => {
    const left = startIndex * columnWidth;
    const visibleColumnsCount = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(totalColumn - 1, startIndex + visibleColumnsCount - 1));
  },
  getRowStartIndexForOffset: ({ rowHeight, totalRow }, scrollTop) => Math.max(0, Math.min(totalRow - 1, Math.floor(scrollTop / rowHeight))),
  getRowStopIndexForStartIndex: ({ rowHeight, totalRow, height }, startIndex, scrollTop) => {
    const top = startIndex * rowHeight;
    const numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(totalRow - 1, startIndex + numVisibleRows - 1));
  },
  initCache: () => void 0,
  clearCache: true,
  validateProps: ({ columnWidth, rowHeight }) => {
  }
});
const { max: max3, min: min3, floor } = Math;
const ACCESS_SIZER_KEY_MAP = {
  column: "columnWidth",
  row: "rowHeight"
};
const ACCESS_LAST_VISITED_KEY_MAP = {
  column: "lastVisitedColumnIndex",
  row: "lastVisitedRowIndex"
};
const getItemFromCache = (props2, index2, gridCache, type4) => {
  const [cachedItems, sizer, lastVisited] = [
    gridCache[type4],
    props2[ACCESS_SIZER_KEY_MAP[type4]],
    gridCache[ACCESS_LAST_VISITED_KEY_MAP[type4]]
  ];
  if (index2 > lastVisited) {
    let offset3 = 0;
    if (lastVisited >= 0) {
      const item = cachedItems[lastVisited];
      offset3 = item.offset + item.size;
    }
    for (let i2 = lastVisited + 1; i2 <= index2; i2++) {
      const size = sizer(i2);
      cachedItems[i2] = {
        offset: offset3,
        size
      };
      offset3 += size;
    }
    gridCache[ACCESS_LAST_VISITED_KEY_MAP[type4]] = index2;
  }
  return cachedItems[index2];
};
const bs = (props2, gridCache, low, high, offset3, type4) => {
  while (low <= high) {
    const mid = low + floor((high - low) / 2);
    const currentOffset = getItemFromCache(props2, mid, gridCache, type4).offset;
    if (currentOffset === offset3) {
      return mid;
    } else if (currentOffset < offset3) {
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }
  return max3(0, low - 1);
};
const es = (props2, gridCache, idx, offset3, type4) => {
  const total3 = type4 === "column" ? props2.totalColumn : props2.totalRow;
  let exponent = 1;
  while (idx < total3 && getItemFromCache(props2, idx, gridCache, type4).offset < offset3) {
    idx += exponent;
    exponent *= 2;
  }
  return bs(props2, gridCache, floor(idx / 2), min3(idx, total3 - 1), offset3, type4);
};
const findItem = (props2, gridCache, offset3, type4) => {
  const [cache2, lastVisitedIndex] = [
    gridCache[type4],
    gridCache[ACCESS_LAST_VISITED_KEY_MAP[type4]]
  ];
  const lastVisitedItemOffset = lastVisitedIndex > 0 ? cache2[lastVisitedIndex].offset : 0;
  if (lastVisitedItemOffset >= offset3) {
    return bs(props2, gridCache, 0, lastVisitedIndex, offset3, type4);
  }
  return es(props2, gridCache, max3(0, lastVisitedIndex), offset3, type4);
};
const getEstimatedTotalHeight = ({ totalRow }, { estimatedRowHeight, lastVisitedRowIndex, row }) => {
  let sizeOfVisitedRows = 0;
  if (lastVisitedRowIndex >= totalRow) {
    lastVisitedRowIndex = totalRow - 1;
  }
  if (lastVisitedRowIndex >= 0) {
    const item = row[lastVisitedRowIndex];
    sizeOfVisitedRows = item.offset + item.size;
  }
  const unvisitedItems = totalRow - lastVisitedRowIndex - 1;
  const sizeOfUnvisitedItems = unvisitedItems * estimatedRowHeight;
  return sizeOfVisitedRows + sizeOfUnvisitedItems;
};
const getEstimatedTotalWidth = ({ totalColumn }, { column, estimatedColumnWidth, lastVisitedColumnIndex }) => {
  let sizeOfVisitedColumns = 0;
  if (lastVisitedColumnIndex > totalColumn) {
    lastVisitedColumnIndex = totalColumn - 1;
  }
  if (lastVisitedColumnIndex >= 0) {
    const item = column[lastVisitedColumnIndex];
    sizeOfVisitedColumns = item.offset + item.size;
  }
  const unvisitedItems = totalColumn - lastVisitedColumnIndex - 1;
  const sizeOfUnvisitedItems = unvisitedItems * estimatedColumnWidth;
  return sizeOfVisitedColumns + sizeOfUnvisitedItems;
};
const ACCESS_ESTIMATED_SIZE_KEY_MAP = {
  column: getEstimatedTotalWidth,
  row: getEstimatedTotalHeight
};
const getOffset = (props2, index2, alignment, scrollOffset, cache2, type4, scrollBarWidth2) => {
  const [size, estimatedSizeAssociates] = [
    type4 === "row" ? props2.height : props2.width,
    ACCESS_ESTIMATED_SIZE_KEY_MAP[type4]
  ];
  const item = getItemFromCache(props2, index2, cache2, type4);
  const estimatedSize = estimatedSizeAssociates(props2, cache2);
  const maxOffset = max3(0, min3(estimatedSize - size, item.offset));
  const minOffset = max3(0, item.offset - size + scrollBarWidth2 + item.size);
  if (alignment === SMART_ALIGNMENT) {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      alignment = AUTO_ALIGNMENT;
    } else {
      alignment = CENTERED_ALIGNMENT;
    }
  }
  switch (alignment) {
    case START_ALIGNMENT: {
      return maxOffset;
    }
    case END_ALIGNMENT: {
      return minOffset;
    }
    case CENTERED_ALIGNMENT: {
      return Math.round(minOffset + (maxOffset - minOffset) / 2);
    }
    case AUTO_ALIGNMENT:
    default: {
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }
    }
  }
};
const DynamicSizeGrid = createGrid({
  name: "ElDynamicSizeGrid",
  getColumnPosition: (props2, idx, cache2) => {
    const item = getItemFromCache(props2, idx, cache2, "column");
    return [item.size, item.offset];
  },
  getRowPosition: (props2, idx, cache2) => {
    const item = getItemFromCache(props2, idx, cache2, "row");
    return [item.size, item.offset];
  },
  getColumnOffset: (props2, columnIndex, alignment, scrollLeft, cache2, scrollBarWidth2) => getOffset(props2, columnIndex, alignment, scrollLeft, cache2, "column", scrollBarWidth2),
  getRowOffset: (props2, rowIndex, alignment, scrollTop, cache2, scrollBarWidth2) => getOffset(props2, rowIndex, alignment, scrollTop, cache2, "row", scrollBarWidth2),
  getColumnStartIndexForOffset: (props2, scrollLeft, cache2) => findItem(props2, cache2, scrollLeft, "column"),
  getColumnStopIndexForStartIndex: (props2, startIndex, scrollLeft, cache2) => {
    const item = getItemFromCache(props2, startIndex, cache2, "column");
    const maxOffset = scrollLeft + props2.width;
    let offset3 = item.offset + item.size;
    let stopIndex = startIndex;
    while (stopIndex < props2.totalColumn - 1 && offset3 < maxOffset) {
      stopIndex++;
      offset3 += getItemFromCache(props2, startIndex, cache2, "column").size;
    }
    return stopIndex;
  },
  getEstimatedTotalHeight,
  getEstimatedTotalWidth,
  getRowStartIndexForOffset: (props2, scrollTop, cache2) => findItem(props2, cache2, scrollTop, "row"),
  getRowStopIndexForStartIndex: (props2, startIndex, scrollTop, cache2) => {
    const { totalRow, height } = props2;
    const item = getItemFromCache(props2, startIndex, cache2, "row");
    const maxOffset = scrollTop + height;
    let offset3 = item.size + item.offset;
    let stopIndex = startIndex;
    while (stopIndex < totalRow - 1 && offset3 < maxOffset) {
      stopIndex++;
      offset3 += getItemFromCache(props2, stopIndex, cache2, "row").size;
    }
    return stopIndex;
  },
  injectToInstance: (instance2, cache2) => {
    const resetAfter = ({ columnIndex, rowIndex }, forceUpdate) => {
      var _a2, _b;
      forceUpdate = isUndefined(forceUpdate) ? true : forceUpdate;
      if (isNumber(columnIndex)) {
        cache2.value.lastVisitedColumnIndex = Math.min(cache2.value.lastVisitedColumnIndex, columnIndex - 1);
      }
      if (isNumber(rowIndex)) {
        cache2.value.lastVisitedRowIndex = Math.min(cache2.value.lastVisitedRowIndex, rowIndex - 1);
      }
      (_a2 = instance2.exposed) == null ? void 0 : _a2.getItemStyleCache.value(-1, null, null);
      if (forceUpdate)
        (_b = instance2.proxy) == null ? void 0 : _b.$forceUpdate();
    };
    const resetAfterColumnIndex = (columnIndex, forceUpdate) => {
      resetAfter({
        columnIndex
      }, forceUpdate);
    };
    const resetAfterRowIndex = (rowIndex, forceUpdate) => {
      resetAfter({
        rowIndex
      }, forceUpdate);
    };
    Object.assign(instance2.proxy, {
      resetAfterColumnIndex,
      resetAfterRowIndex,
      resetAfter
    });
  },
  initCache: ({
    estimatedColumnWidth = DEFAULT_DYNAMIC_LIST_ITEM_SIZE,
    estimatedRowHeight = DEFAULT_DYNAMIC_LIST_ITEM_SIZE
  }) => {
    const cache2 = {
      column: {},
      estimatedColumnWidth,
      estimatedRowHeight,
      lastVisitedColumnIndex: -1,
      lastVisitedRowIndex: -1,
      row: {}
    };
    return cache2;
  },
  clearCache: false,
  validateProps: ({ columnWidth, rowHeight }) => {
  }
});
var SortOrder$1 = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "asc";
  SortOrder2["DESC"] = "desc";
  return SortOrder2;
})(SortOrder$1 || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["CENTER"] = "center";
  Alignment2["RIGHT"] = "right";
  return Alignment2;
})(Alignment || {});
var FixedDir$1 = /* @__PURE__ */ ((FixedDir2) => {
  FixedDir2["LEFT"] = "left";
  FixedDir2["RIGHT"] = "right";
  return FixedDir2;
})(FixedDir$1 || {});
const oppositeOrderMap = {
  ["asc"]: "desc",
  ["desc"]: "asc"
};
const placeholderSign = Symbol("placeholder");
const calcColumnStyle = (column, fixedColumn, fixed) => {
  var _a2;
  const flex = __spreadValues({
    flexGrow: 0,
    flexShrink: 0
  }, fixed ? {} : {
    flexGrow: column.flexGrow || 0,
    flexShrink: column.flexShrink || 1
  });
  if (!fixed) {
    flex.flexShrink = 1;
  }
  const style2 = __spreadProps(__spreadValues(__spreadValues({}, (_a2 = column.style) != null ? _a2 : {}), flex), {
    flexBasis: "auto",
    width: column.width
  });
  if (!fixedColumn) {
    if (column.maxWidth)
      style2.maxWidth = column.maxWidth;
    if (column.minWidth)
      style2.minWidth = column.minWidth;
  }
  return style2;
};
function useColumns$1(props2, columns2, fixed) {
  const visibleColumns = computed(() => {
    return unref(columns2).filter((column) => !column.hidden);
  });
  const fixedColumnsOnLeft = computed(() => unref(visibleColumns).filter((column) => column.fixed === "left" || column.fixed === true));
  const fixedColumnsOnRight = computed(() => unref(visibleColumns).filter((column) => column.fixed === "right"));
  const normalColumns = computed(() => unref(visibleColumns).filter((column) => !column.fixed));
  const mainColumns = computed(() => {
    const ret = [];
    unref(fixedColumnsOnLeft).forEach((column) => {
      ret.push(__spreadProps(__spreadValues({}, column), {
        placeholderSign
      }));
    });
    unref(normalColumns).forEach((column) => {
      ret.push(column);
    });
    unref(fixedColumnsOnRight).forEach((column) => {
      ret.push(__spreadProps(__spreadValues({}, column), {
        placeholderSign
      }));
    });
    return ret;
  });
  const hasFixedColumns = computed(() => {
    return unref(fixedColumnsOnLeft).length || unref(fixedColumnsOnRight).length;
  });
  const columnsStyles = computed(() => {
    const _columns = unref(columns2);
    return _columns.reduce((style2, column) => {
      style2[column.key] = calcColumnStyle(column, unref(fixed), props2.fixed);
      return style2;
    }, {});
  });
  const columnsTotalWidth = computed(() => {
    return unref(visibleColumns).reduce((width, column) => width + column.width, 0);
  });
  const getColumn2 = (key2) => {
    return unref(columns2).find((column) => column.key === key2);
  };
  const getColumnStyle = (key2) => {
    return unref(columnsStyles)[key2];
  };
  const updateColumnWidth = (column, width) => {
    column.width = width;
  };
  function onColumnSorted(e2) {
    var _a2;
    const { key: key2 } = e2.currentTarget.dataset;
    if (!key2)
      return;
    const { sortState, sortBy } = props2;
    let order = SortOrder$1.ASC;
    if (isObject2(sortState)) {
      order = oppositeOrderMap[sortState[key2]];
    } else {
      order = oppositeOrderMap[sortBy.order];
    }
    (_a2 = props2.onColumnSort) == null ? void 0 : _a2.call(props2, { column: getColumn2(key2), key: key2, order });
  }
  return {
    columns: columns2,
    columnsStyles,
    columnsTotalWidth,
    fixedColumnsOnLeft,
    fixedColumnsOnRight,
    hasFixedColumns,
    mainColumns,
    normalColumns,
    visibleColumns,
    getColumn: getColumn2,
    getColumnStyle,
    updateColumnWidth,
    onColumnSorted
  };
}
const useScrollbar = (props2, {
  mainTableRef,
  leftTableRef,
  rightTableRef,
  onMaybeEndReached
}) => {
  const scrollPos = ref({ scrollLeft: 0, scrollTop: 0 });
  function doScroll(params) {
    var _a2, _b, _c;
    const { scrollTop } = params;
    (_a2 = mainTableRef.value) == null ? void 0 : _a2.scrollTo(params);
    (_b = leftTableRef.value) == null ? void 0 : _b.scrollToTop(scrollTop);
    (_c = rightTableRef.value) == null ? void 0 : _c.scrollToTop(scrollTop);
  }
  function scrollTo2(params) {
    scrollPos.value = params;
    doScroll(params);
  }
  function scrollToTop(scrollTop) {
    scrollPos.value.scrollTop = scrollTop;
    doScroll(unref(scrollPos));
  }
  function scrollToLeft(scrollLeft) {
    var _a2, _b;
    scrollPos.value.scrollLeft = scrollLeft;
    (_b = (_a2 = mainTableRef.value) == null ? void 0 : _a2.scrollTo) == null ? void 0 : _b.call(_a2, unref(scrollPos));
  }
  function onScroll(params) {
    var _a2;
    scrollTo2(params);
    (_a2 = props2.onScroll) == null ? void 0 : _a2.call(props2, params);
  }
  function onVerticalScroll({ scrollTop }) {
    const { scrollTop: currentScrollTop } = unref(scrollPos);
    if (scrollTop !== currentScrollTop)
      scrollToTop(scrollTop);
  }
  function scrollToRow(row, strategy = "auto") {
    var _a2;
    (_a2 = mainTableRef.value) == null ? void 0 : _a2.scrollToRow(row, strategy);
  }
  watch(() => unref(scrollPos).scrollTop, (cur, prev2) => {
    if (cur > prev2)
      onMaybeEndReached();
  });
  return {
    scrollPos,
    scrollTo: scrollTo2,
    scrollToLeft,
    scrollToTop,
    scrollToRow,
    onScroll,
    onVerticalScroll
  };
};
const useRow = (props2, { mainTableRef, leftTableRef, rightTableRef }) => {
  const vm = getCurrentInstance();
  const { emit } = vm;
  const isResetting = shallowRef(false);
  const hoveringRowKey = shallowRef(null);
  const expandedRowKeys = ref(props2.defaultExpandedRowKeys || []);
  const lastRenderedRowIndex = ref(-1);
  const resetIndex = shallowRef(null);
  const rowHeights = ref({});
  const pendingRowHeights = ref({});
  const leftTableHeights = shallowRef({});
  const mainTableHeights = shallowRef({});
  const rightTableHeights = shallowRef({});
  const isDynamic = computed(() => isNumber(props2.estimatedRowHeight));
  function onRowsRendered(params) {
    var _a2;
    (_a2 = props2.onRowsRendered) == null ? void 0 : _a2.call(props2, params);
    if (params.rowCacheEnd > unref(lastRenderedRowIndex)) {
      lastRenderedRowIndex.value = params.rowCacheEnd;
    }
  }
  function onRowHovered({ hovered, rowKey: rowKey2 }) {
    hoveringRowKey.value = hovered ? rowKey2 : null;
  }
  function onRowExpanded({
    expanded,
    rowData,
    rowIndex,
    rowKey: rowKey2
  }) {
    var _a2, _b;
    const _expandedRowKeys = [...unref(expandedRowKeys)];
    const currentKeyIndex = _expandedRowKeys.indexOf(rowKey2);
    if (expanded) {
      if (currentKeyIndex === -1)
        _expandedRowKeys.push(rowKey2);
    } else {
      if (currentKeyIndex > -1)
        _expandedRowKeys.splice(currentKeyIndex, 1);
    }
    expandedRowKeys.value = _expandedRowKeys;
    emit("update:expandedRowKeys", _expandedRowKeys);
    (_a2 = props2.onRowExpand) == null ? void 0 : _a2.call(props2, {
      expanded,
      rowData,
      rowIndex,
      rowKey: rowKey2
    });
    (_b = props2.onExpandedRowsChange) == null ? void 0 : _b.call(props2, _expandedRowKeys);
  }
  const flushingRowHeights = debounce$1(() => {
    var _a2, _b, _c, _d;
    isResetting.value = true;
    rowHeights.value = __spreadValues(__spreadValues({}, unref(rowHeights)), unref(pendingRowHeights));
    resetAfterIndex(unref(resetIndex), false);
    pendingRowHeights.value = {};
    resetIndex.value = null;
    (_a2 = mainTableRef.value) == null ? void 0 : _a2.forceUpdate();
    (_b = leftTableRef.value) == null ? void 0 : _b.forceUpdate();
    (_c = rightTableRef.value) == null ? void 0 : _c.forceUpdate();
    (_d = vm.proxy) == null ? void 0 : _d.$forceUpdate();
    isResetting.value = false;
  }, 0);
  function resetAfterIndex(index2, forceUpdate = false) {
    if (!unref(isDynamic))
      return;
    [mainTableRef, leftTableRef, rightTableRef].forEach((tableRef) => {
      const table = unref(tableRef);
      if (table)
        table.resetAfterRowIndex(index2, forceUpdate);
    });
  }
  function resetHeights(rowKey2, height, rowIdx) {
    const resetIdx = unref(resetIndex);
    if (resetIdx === null) {
      resetIndex.value = rowIdx;
    } else {
      if (resetIdx > rowIdx) {
        resetIndex.value = rowIdx;
      }
    }
    pendingRowHeights.value[rowKey2] = height;
  }
  function onRowHeightChange({ rowKey: rowKey2, height, rowIndex }, fixedDir) {
    if (!fixedDir) {
      mainTableHeights.value[rowKey2] = height;
    } else {
      if (fixedDir === FixedDir$1.RIGHT) {
        rightTableHeights.value[rowKey2] = height;
      } else {
        leftTableHeights.value[rowKey2] = height;
      }
    }
    const maximumHeight = Math.max(...[leftTableHeights, rightTableHeights, mainTableHeights].map((records) => records.value[rowKey2] || 0));
    if (unref(rowHeights)[rowKey2] !== maximumHeight) {
      resetHeights(rowKey2, maximumHeight, rowIndex);
      flushingRowHeights();
    }
  }
  return {
    hoveringRowKey,
    expandedRowKeys,
    lastRenderedRowIndex,
    isDynamic,
    isResetting,
    rowHeights,
    resetAfterIndex,
    onRowExpanded,
    onRowHovered,
    onRowsRendered,
    onRowHeightChange
  };
};
const useData = (props2, { expandedRowKeys, lastRenderedRowIndex, resetAfterIndex }) => {
  const depthMap = ref({});
  const flattenedData = computed(() => {
    const depths = {};
    const { data: data22, rowKey: rowKey2 } = props2;
    const _expandedRowKeys = unref(expandedRowKeys);
    if (!_expandedRowKeys || !_expandedRowKeys.length)
      return data22;
    const array4 = [];
    const keysSet = /* @__PURE__ */ new Set();
    _expandedRowKeys.forEach((x2) => keysSet.add(x2));
    let copy = data22.slice();
    copy.forEach((x2) => depths[x2[rowKey2]] = 0);
    while (copy.length > 0) {
      const item = copy.shift();
      array4.push(item);
      if (keysSet.has(item[rowKey2]) && Array.isArray(item.children) && item.children.length > 0) {
        copy = [...item.children, ...copy];
        item.children.forEach((child) => depths[child[rowKey2]] = depths[item[rowKey2]] + 1);
      }
    }
    depthMap.value = depths;
    return array4;
  });
  const data6 = computed(() => {
    const { data: data22, expandColumnKey: expandColumnKey2 } = props2;
    return expandColumnKey2 ? unref(flattenedData) : data22;
  });
  watch(data6, (val, prev2) => {
    if (val !== prev2) {
      lastRenderedRowIndex.value = -1;
      resetAfterIndex(0, true);
    }
  });
  return {
    data: data6,
    depthMap
  };
};
const sumReducer = (sum2, num) => sum2 + num;
const sum = (listLike) => {
  return isArray(listLike) ? listLike.reduce(sumReducer, 0) : listLike;
};
const tryCall = (fLike, params, defaultRet = {}) => {
  return isFunction2(fLike) ? fLike(params) : fLike != null ? fLike : defaultRet;
};
const enforceUnit = (style2) => {
  ["width", "maxWidth", "minWidth", "height"].forEach((key2) => {
    style2[key2] = addUnit(style2[key2]);
  });
  return style2;
};
const componentToSlot = (ComponentLike) => isVNode(ComponentLike) ? (props2) => h$2(ComponentLike, props2) : ComponentLike;
const useStyles = (props2, {
  columnsTotalWidth,
  data: data6,
  fixedColumnsOnLeft,
  fixedColumnsOnRight
}) => {
  const bodyWidth = computed(() => {
    const { fixed, width, vScrollbarSize } = props2;
    const ret = width - vScrollbarSize;
    return fixed ? Math.max(Math.round(unref(columnsTotalWidth)), ret) : ret;
  });
  const headerWidth = computed(() => unref(bodyWidth) + (props2.fixed ? props2.vScrollbarSize : 0));
  const mainTableHeight = computed(() => {
    const { height = 0, maxHeight = 0, footerHeight: footerHeight2, hScrollbarSize } = props2;
    if (maxHeight > 0) {
      const _fixedRowsHeight = unref(fixedRowsHeight);
      const _rowsHeight = unref(rowsHeight);
      const _headerHeight = unref(headerHeight);
      const total3 = _headerHeight + _fixedRowsHeight + _rowsHeight + hScrollbarSize;
      return Math.min(total3, maxHeight - footerHeight2);
    }
    return height - footerHeight2;
  });
  const rowsHeight = computed(() => {
    const { rowHeight, estimatedRowHeight } = props2;
    const _data = unref(data6);
    if (isNumber(estimatedRowHeight)) {
      return _data.length * estimatedRowHeight;
    }
    return _data.length * rowHeight;
  });
  const fixedTableHeight = computed(() => {
    const { maxHeight } = props2;
    const tableHeight = unref(mainTableHeight);
    if (isNumber(maxHeight) && maxHeight > 0)
      return tableHeight;
    const totalHeight = unref(rowsHeight) + unref(headerHeight) + unref(fixedRowsHeight);
    return Math.min(tableHeight, totalHeight);
  });
  const mapColumn = (column) => column.width;
  const leftTableWidth = computed(() => sum(unref(fixedColumnsOnLeft).map(mapColumn)));
  const rightTableWidth = computed(() => sum(unref(fixedColumnsOnRight).map(mapColumn)));
  const headerHeight = computed(() => sum(props2.headerHeight));
  const fixedRowsHeight = computed(() => {
    var _a2;
    return (((_a2 = props2.fixedData) == null ? void 0 : _a2.length) || 0) * props2.rowHeight;
  });
  const windowHeight = computed(() => {
    return unref(mainTableHeight) - unref(headerHeight) - unref(fixedRowsHeight);
  });
  const rootStyle = computed(() => {
    const { style: style2 = {}, height, width } = props2;
    return enforceUnit(__spreadProps(__spreadValues({}, style2), {
      height,
      width
    }));
  });
  const footerHeight = computed(() => enforceUnit({ height: props2.footerHeight }));
  const emptyStyle = computed(() => ({
    top: addUnit(unref(headerHeight)),
    bottom: addUnit(props2.footerHeight),
    width: addUnit(props2.width)
  }));
  return {
    bodyWidth,
    fixedTableHeight,
    mainTableHeight,
    leftTableWidth,
    rightTableWidth,
    headerWidth,
    rowsHeight,
    windowHeight,
    footerHeight,
    emptyStyle,
    rootStyle,
    headerHeight
  };
};
const useAutoResize = (props2) => {
  const sizer = ref();
  const width$ = ref(0);
  const height$ = ref(0);
  let resizerStopper;
  onMounted(() => {
    resizerStopper = useResizeObserver(sizer, ([entry]) => {
      const { width, height } = entry.contentRect;
      const { paddingLeft, paddingRight, paddingTop, paddingBottom } = getComputedStyle(entry.target);
      const left = Number.parseInt(paddingLeft) || 0;
      const right = Number.parseInt(paddingRight) || 0;
      const top = Number.parseInt(paddingTop) || 0;
      const bottom = Number.parseInt(paddingBottom) || 0;
      width$.value = width - left - right;
      height$.value = height - top - bottom;
    }).stop;
  });
  onBeforeUnmount(() => {
    resizerStopper == null ? void 0 : resizerStopper();
  });
  watch([width$, height$], ([width, height]) => {
    var _a2;
    (_a2 = props2.onResize) == null ? void 0 : _a2.call(props2, {
      width,
      height
    });
  });
  return {
    sizer,
    width: width$,
    height: height$
  };
};
function useTable(props2) {
  const mainTableRef = ref();
  const leftTableRef = ref();
  const rightTableRef = ref();
  const {
    columns: columns2,
    columnsStyles,
    columnsTotalWidth,
    fixedColumnsOnLeft,
    fixedColumnsOnRight,
    hasFixedColumns,
    mainColumns,
    onColumnSorted
  } = useColumns$1(props2, toRef(props2, "columns"), toRef(props2, "fixed"));
  const {
    scrollTo: scrollTo2,
    scrollToLeft,
    scrollToTop,
    scrollToRow,
    onScroll,
    onVerticalScroll,
    scrollPos
  } = useScrollbar(props2, {
    mainTableRef,
    leftTableRef,
    rightTableRef,
    onMaybeEndReached
  });
  const {
    expandedRowKeys,
    hoveringRowKey,
    lastRenderedRowIndex,
    isDynamic,
    isResetting,
    rowHeights,
    resetAfterIndex,
    onRowExpanded,
    onRowHeightChange,
    onRowHovered,
    onRowsRendered
  } = useRow(props2, {
    mainTableRef,
    leftTableRef,
    rightTableRef
  });
  const { data: data6, depthMap } = useData(props2, {
    expandedRowKeys,
    lastRenderedRowIndex,
    resetAfterIndex
  });
  const {
    bodyWidth,
    fixedTableHeight,
    mainTableHeight,
    leftTableWidth,
    rightTableWidth,
    headerWidth,
    rowsHeight,
    windowHeight,
    footerHeight,
    emptyStyle,
    rootStyle,
    headerHeight
  } = useStyles(props2, {
    columnsTotalWidth,
    data: data6,
    fixedColumnsOnLeft,
    fixedColumnsOnRight
  });
  const isScrolling = shallowRef(false);
  const containerRef = ref();
  const showEmpty = computed(() => {
    const noData = unref(data6).length === 0;
    return isArray(props2.fixedData) ? props2.fixedData.length === 0 && noData : noData;
  });
  function getRowHeight(rowIndex) {
    const { estimatedRowHeight, rowHeight, rowKey: rowKey2 } = props2;
    if (!estimatedRowHeight)
      return rowHeight;
    return unref(rowHeights)[unref(data6)[rowIndex][rowKey2]] || estimatedRowHeight;
  }
  function onMaybeEndReached() {
    const { onEndReached } = props2;
    if (!onEndReached)
      return;
    const { scrollTop } = unref(scrollPos);
    const _totalHeight = unref(rowsHeight);
    const clientHeight = unref(windowHeight);
    const heightUntilEnd = _totalHeight - (scrollTop + clientHeight) + props2.hScrollbarSize;
    if (unref(lastRenderedRowIndex) >= 0 && _totalHeight === scrollTop + unref(mainTableHeight) - unref(headerHeight)) {
      onEndReached(heightUntilEnd);
    }
  }
  watch(() => props2.expandedRowKeys, (val) => expandedRowKeys.value = val, {
    deep: true
  });
  return {
    columns: columns2,
    containerRef,
    mainTableRef,
    leftTableRef,
    rightTableRef,
    isDynamic,
    isResetting,
    isScrolling,
    hoveringRowKey,
    hasFixedColumns,
    columnsStyles,
    columnsTotalWidth,
    data: data6,
    expandedRowKeys,
    depthMap,
    fixedColumnsOnLeft,
    fixedColumnsOnRight,
    mainColumns,
    bodyWidth,
    emptyStyle,
    rootStyle,
    headerWidth,
    footerHeight,
    mainTableHeight,
    fixedTableHeight,
    leftTableWidth,
    rightTableWidth,
    showEmpty,
    getRowHeight,
    onColumnSorted,
    onRowHovered,
    onRowExpanded,
    onRowsRendered,
    onRowHeightChange,
    scrollTo: scrollTo2,
    scrollToLeft,
    scrollToTop,
    scrollToRow,
    onScroll,
    onVerticalScroll
  };
}
const TableV2InjectionKey = Symbol("tableV2");
const classType = String;
const columns = {
  type: definePropType(Array),
  required: true
};
const fixedDataType = {
  type: definePropType(Array)
};
const dataType = __spreadProps(__spreadValues({}, fixedDataType), {
  required: true
});
const expandColumnKey = String;
const expandKeys = {
  type: definePropType(Array),
  default: () => mutable([])
};
const requiredNumber = {
  type: Number,
  required: true
};
const rowKey = {
  type: definePropType([String, Number, Symbol]),
  default: "id"
};
const styleType = {
  type: definePropType(Object)
};
const tableV2RowProps = buildProps({
  class: String,
  columns,
  columnsStyles: {
    type: definePropType(Object),
    required: true
  },
  depth: Number,
  expandColumnKey,
  estimatedRowHeight: __spreadProps(__spreadValues({}, virtualizedGridProps.estimatedRowHeight), {
    default: void 0
  }),
  isScrolling: Boolean,
  onRowExpand: {
    type: definePropType(Function)
  },
  onRowHover: {
    type: definePropType(Function)
  },
  onRowHeightChange: {
    type: definePropType(Function)
  },
  rowData: {
    type: definePropType(Object),
    required: true
  },
  rowEventHandlers: {
    type: definePropType(Object)
  },
  rowIndex: {
    type: Number,
    required: true
  },
  rowKey,
  style: {
    type: definePropType(Object)
  }
});
const requiredNumberType = {
  type: Number,
  required: true
};
const tableV2HeaderProps = buildProps({
  class: String,
  columns,
  fixedHeaderData: {
    type: definePropType(Array)
  },
  headerData: {
    type: definePropType(Array),
    required: true
  },
  headerHeight: {
    type: definePropType([Number, Array]),
    default: 50
  },
  rowWidth: requiredNumberType,
  rowHeight: {
    type: Number,
    default: 50
  },
  height: requiredNumberType,
  width: requiredNumberType
});
const tableV2GridProps = buildProps({
  columns,
  data: dataType,
  fixedData: fixedDataType,
  estimatedRowHeight: tableV2RowProps.estimatedRowHeight,
  width: requiredNumber,
  height: requiredNumber,
  headerWidth: requiredNumber,
  headerHeight: tableV2HeaderProps.headerHeight,
  bodyWidth: requiredNumber,
  rowHeight: requiredNumber,
  cache: virtualizedListProps.cache,
  useIsScrolling: Boolean,
  scrollbarAlwaysOn: virtualizedGridProps.scrollbarAlwaysOn,
  scrollbarStartGap: virtualizedGridProps.scrollbarStartGap,
  scrollbarEndGap: virtualizedGridProps.scrollbarEndGap,
  class: classType,
  style: styleType,
  containerStyle: styleType,
  getRowHeight: {
    type: definePropType(Function),
    required: true
  },
  rowKey: tableV2RowProps.rowKey,
  onRowsRendered: {
    type: definePropType(Function)
  },
  onScroll: {
    type: definePropType(Function)
  }
});
const tableV2Props = buildProps({
  cache: tableV2GridProps.cache,
  estimatedRowHeight: tableV2RowProps.estimatedRowHeight,
  rowKey,
  headerClass: {
    type: definePropType([
      String,
      Function
    ])
  },
  headerProps: {
    type: definePropType([
      Object,
      Function
    ])
  },
  headerCellProps: {
    type: definePropType([
      Object,
      Function
    ])
  },
  headerHeight: tableV2HeaderProps.headerHeight,
  footerHeight: {
    type: Number,
    default: 0
  },
  rowClass: {
    type: definePropType([String, Function])
  },
  rowProps: {
    type: definePropType([Object, Function])
  },
  rowHeight: {
    type: Number,
    default: 50
  },
  cellProps: {
    type: definePropType([
      Object,
      Function
    ])
  },
  columns,
  data: dataType,
  dataGetter: {
    type: definePropType(Function)
  },
  fixedData: fixedDataType,
  expandColumnKey: tableV2RowProps.expandColumnKey,
  expandedRowKeys: expandKeys,
  defaultExpandedRowKeys: expandKeys,
  class: classType,
  fixed: Boolean,
  style: {
    type: definePropType(Object)
  },
  width: requiredNumber,
  height: requiredNumber,
  maxHeight: Number,
  useIsScrolling: Boolean,
  indentSize: {
    type: Number,
    default: 12
  },
  iconSize: {
    type: Number,
    default: 12
  },
  hScrollbarSize: virtualizedGridProps.hScrollbarSize,
  vScrollbarSize: virtualizedGridProps.vScrollbarSize,
  scrollbarAlwaysOn: virtualizedScrollbarProps.alwaysOn,
  sortBy: {
    type: definePropType(Object),
    default: () => ({})
  },
  sortState: {
    type: definePropType(Object),
    default: void 0
  },
  onColumnSort: {
    type: definePropType(Function)
  },
  onExpandedRowsChange: {
    type: definePropType(Function)
  },
  onEndReached: {
    type: definePropType(Function)
  },
  onRowExpand: tableV2RowProps.onRowExpand,
  onScroll: tableV2GridProps.onScroll,
  onRowsRendered: tableV2GridProps.onRowsRendered,
  rowEventHandlers: tableV2RowProps.rowEventHandlers
});
const TableV2Cell = (props2, {
  slots
}) => {
  var _a2;
  const {
    cellData,
    style: style2
  } = props2;
  const displayText = ((_a2 = cellData == null ? void 0 : cellData.toString) == null ? void 0 : _a2.call(cellData)) || "";
  return createVNode("div", {
    "class": props2.class,
    "title": displayText,
    "style": style2
  }, [slots.default ? slots.default(props2) : displayText]);
};
TableV2Cell.displayName = "ElTableV2Cell";
TableV2Cell.inheritAttrs = false;
const HeaderCell = (props2, {
  slots
}) => {
  var _a2, _b;
  return slots.default ? slots.default(props2) : createVNode("div", {
    "class": props2.class,
    "title": (_a2 = props2.column) == null ? void 0 : _a2.title
  }, [(_b = props2.column) == null ? void 0 : _b.title]);
};
HeaderCell.displayName = "ElTableV2HeaderCell";
HeaderCell.inheritAttrs = false;
const tableV2HeaderRowProps = buildProps({
  class: String,
  columns,
  columnsStyles: {
    type: definePropType(Object),
    required: true
  },
  headerIndex: Number,
  style: { type: definePropType(Object) }
});
const TableV2HeaderRow = defineComponent({
  name: "ElTableV2HeaderRow",
  props: tableV2HeaderRowProps,
  setup(props2, {
    slots
  }) {
    return () => {
      const {
        columns: columns2,
        columnsStyles,
        headerIndex,
        style: style2
      } = props2;
      let Cells = columns2.map((column, columnIndex) => {
        return slots.cell({
          columns: columns2,
          column,
          columnIndex,
          headerIndex,
          style: columnsStyles[column.key]
        });
      });
      if (slots.header) {
        Cells = slots.header({
          cells: Cells.map((node) => {
            if (isArray(node) && node.length === 1) {
              return node[0];
            }
            return node;
          }),
          columns: columns2,
          headerIndex
        });
      }
      return createVNode("div", {
        "class": props2.class,
        "style": style2,
        "role": "row"
      }, [Cells]);
    };
  }
});
const COMPONENT_NAME$3 = "ElTableV2Header";
const TableV2Header = defineComponent({
  name: COMPONENT_NAME$3,
  props: tableV2HeaderProps,
  setup(props2, {
    slots,
    expose
  }) {
    const ns = useNamespace("table-v2");
    const headerRef = ref();
    const headerStyle = computed(() => enforceUnit({
      width: props2.width,
      height: props2.height
    }));
    const rowStyle = computed(() => enforceUnit({
      width: props2.rowWidth,
      height: props2.height
    }));
    const headerHeights = computed(() => castArray(unref(props2.headerHeight)));
    const scrollToLeft = (left) => {
      const headerEl = unref(headerRef);
      nextTick(() => {
        (headerEl == null ? void 0 : headerEl.scroll) && headerEl.scroll({
          left
        });
      });
    };
    const renderFixedRows = () => {
      const fixedRowClassName = ns.e("fixed-header-row");
      const {
        columns: columns2,
        fixedHeaderData,
        rowHeight
      } = props2;
      return fixedHeaderData == null ? void 0 : fixedHeaderData.map((fixedRowData, fixedRowIndex) => {
        var _a2;
        const style2 = enforceUnit({
          height: rowHeight,
          width: "100%"
        });
        return (_a2 = slots.fixed) == null ? void 0 : _a2.call(slots, {
          class: fixedRowClassName,
          columns: columns2,
          rowData: fixedRowData,
          rowIndex: -(fixedRowIndex + 1),
          style: style2
        });
      });
    };
    const renderDynamicRows = () => {
      const dynamicRowClassName = ns.e("dynamic-header-row");
      const {
        columns: columns2
      } = props2;
      return unref(headerHeights).map((rowHeight, rowIndex) => {
        var _a2;
        const style2 = enforceUnit({
          width: "100%",
          height: rowHeight
        });
        return (_a2 = slots.dynamic) == null ? void 0 : _a2.call(slots, {
          class: dynamicRowClassName,
          columns: columns2,
          headerIndex: rowIndex,
          style: style2
        });
      });
    };
    expose({
      scrollToLeft
    });
    return () => {
      if (props2.height <= 0)
        return;
      return createVNode("div", {
        "ref": headerRef,
        "class": props2.class,
        "style": unref(headerStyle),
        "role": "rowgroup"
      }, [createVNode("div", {
        "style": unref(rowStyle),
        "class": ns.e("header")
      }, [renderDynamicRows(), renderFixedRows()])]);
    };
  }
});
const useTableRow = (props2) => {
  const {
    isScrolling
  } = inject(TableV2InjectionKey);
  const measured = ref(false);
  const rowRef = ref();
  const measurable = computed(() => {
    return isNumber(props2.estimatedRowHeight) && props2.rowIndex >= 0;
  });
  const doMeasure = (isInit = false) => {
    const $rowRef = unref(rowRef);
    if (!$rowRef)
      return;
    const {
      columns: columns2,
      onRowHeightChange,
      rowKey: rowKey2,
      rowIndex,
      style: style2
    } = props2;
    const {
      height
    } = $rowRef.getBoundingClientRect();
    measured.value = true;
    nextTick(() => {
      if (isInit || height !== Number.parseInt(style2.height)) {
        const firstColumn = columns2[0];
        const isPlaceholder = (firstColumn == null ? void 0 : firstColumn.placeholderSign) === placeholderSign;
        onRowHeightChange == null ? void 0 : onRowHeightChange({
          rowKey: rowKey2,
          height,
          rowIndex
        }, firstColumn && !isPlaceholder && firstColumn.fixed);
      }
    });
  };
  const eventHandlers = computed(() => {
    const {
      rowData,
      rowIndex,
      rowKey: rowKey2,
      onRowHover
    } = props2;
    const handlers = props2.rowEventHandlers || {};
    const eventHandlers2 = {};
    Object.entries(handlers).forEach(([eventName, handler4]) => {
      if (isFunction2(handler4)) {
        eventHandlers2[eventName] = (event) => {
          handler4({
            event,
            rowData,
            rowIndex,
            rowKey: rowKey2
          });
        };
      }
    });
    if (onRowHover) {
      [{
        name: "onMouseleave",
        hovered: false
      }, {
        name: "onMouseenter",
        hovered: true
      }].forEach(({
        name: name2,
        hovered
      }) => {
        const existedHandler = eventHandlers2[name2];
        eventHandlers2[name2] = (event) => {
          onRowHover({
            event,
            hovered,
            rowData,
            rowIndex,
            rowKey: rowKey2
          });
          existedHandler == null ? void 0 : existedHandler(event);
        };
      });
    }
    return eventHandlers2;
  });
  const onExpand = (expanded) => {
    const {
      onRowExpand,
      rowData,
      rowIndex,
      rowKey: rowKey2
    } = props2;
    onRowExpand == null ? void 0 : onRowExpand({
      expanded,
      rowData,
      rowIndex,
      rowKey: rowKey2
    });
  };
  onMounted(() => {
    if (unref(measurable)) {
      doMeasure(true);
    }
  });
  return {
    isScrolling,
    measurable,
    measured,
    rowRef,
    eventHandlers,
    onExpand
  };
};
const COMPONENT_NAME$2 = "ElTableV2TableRow";
const TableV2Row = defineComponent({
  name: COMPONENT_NAME$2,
  props: tableV2RowProps,
  setup(props2, {
    expose,
    slots,
    attrs
  }) {
    const {
      eventHandlers,
      isScrolling,
      measurable,
      measured,
      rowRef,
      onExpand
    } = useTableRow(props2);
    expose({
      onExpand
    });
    return () => {
      const {
        columns: columns2,
        columnsStyles,
        expandColumnKey: expandColumnKey2,
        depth,
        rowData,
        rowIndex,
        style: style2
      } = props2;
      let ColumnCells = columns2.map((column, columnIndex) => {
        const expandable = isArray(rowData.children) && rowData.children.length > 0 && column.key === expandColumnKey2;
        return slots.cell({
          column,
          columns: columns2,
          columnIndex,
          depth,
          style: columnsStyles[column.key],
          rowData,
          rowIndex,
          isScrolling: unref(isScrolling),
          expandIconProps: expandable ? {
            rowData,
            rowIndex,
            onExpand
          } : void 0
        });
      });
      if (slots.row) {
        ColumnCells = slots.row({
          cells: ColumnCells.map((node) => {
            if (isArray(node) && node.length === 1) {
              return node[0];
            }
            return node;
          }),
          style: style2,
          columns: columns2,
          depth,
          rowData,
          rowIndex,
          isScrolling: unref(isScrolling)
        });
      }
      if (unref(measurable)) {
        const _a2 = style2 || {}, {
          height
        } = _a2, exceptHeightStyle = __objRest(_a2, [
          "height"
        ]);
        const _measured = unref(measured);
        return createVNode("div", mergeProps({
          "ref": rowRef,
          "class": props2.class,
          "style": _measured ? style2 : exceptHeightStyle,
          "role": "row"
        }, attrs, unref(eventHandlers)), [ColumnCells]);
      }
      return createVNode("div", mergeProps(attrs, {
        "ref": rowRef,
        "class": props2.class,
        "style": style2,
        "role": "row"
      }, unref(eventHandlers)), [ColumnCells]);
    };
  }
});
const SortIcon = (props2) => {
  const {
    sortOrder
  } = props2;
  return createVNode(ElIcon, {
    "size": 14,
    "class": props2.class
  }, {
    default: () => [sortOrder === SortOrder$1.ASC ? createVNode(sort_up_default, null, null) : createVNode(sort_down_default, null, null)]
  });
};
const ExpandIcon = (props2) => {
  const {
    expanded,
    expandable,
    onExpand,
    style: style2,
    size
  } = props2;
  const expandIconProps = {
    onClick: expandable ? () => onExpand(!expanded) : void 0,
    class: props2.class
  };
  return createVNode(ElIcon, mergeProps(expandIconProps, {
    "size": size,
    "style": style2
  }), {
    default: () => [createVNode(arrow_right_default, null, null)]
  });
};
const COMPONENT_NAME$1 = "ElTableV2Grid";
const useTableGrid = (props2) => {
  const headerRef = ref();
  const bodyRef = ref();
  const totalHeight = computed(() => {
    const {
      data: data6,
      rowHeight,
      estimatedRowHeight
    } = props2;
    if (estimatedRowHeight) {
      return;
    }
    return data6.length * rowHeight;
  });
  const fixedRowHeight = computed(() => {
    const {
      fixedData,
      rowHeight
    } = props2;
    return ((fixedData == null ? void 0 : fixedData.length) || 0) * rowHeight;
  });
  const headerHeight = computed(() => sum(props2.headerHeight));
  const gridHeight = computed(() => {
    const {
      height
    } = props2;
    return Math.max(0, height - unref(headerHeight) - unref(fixedRowHeight));
  });
  const hasHeader = computed(() => {
    return unref(headerHeight) + unref(fixedRowHeight) > 0;
  });
  const itemKey2 = ({
    data: data6,
    rowIndex
  }) => data6[rowIndex][props2.rowKey];
  function onItemRendered({
    rowCacheStart,
    rowCacheEnd,
    rowVisibleStart,
    rowVisibleEnd
  }) {
    var _a2;
    (_a2 = props2.onRowsRendered) == null ? void 0 : _a2.call(props2, {
      rowCacheStart,
      rowCacheEnd,
      rowVisibleStart,
      rowVisibleEnd
    });
  }
  function resetAfterRowIndex(index2, forceUpdate2) {
    var _a2;
    (_a2 = bodyRef.value) == null ? void 0 : _a2.resetAfterRowIndex(index2, forceUpdate2);
  }
  function scrollTo2(leftOrOptions, top) {
    const header$ = unref(headerRef);
    const body$ = unref(bodyRef);
    if (!header$ || !body$)
      return;
    if (isObject2(leftOrOptions)) {
      header$.scrollToLeft(leftOrOptions.scrollLeft);
      body$.scrollTo(leftOrOptions);
    } else {
      header$.scrollToLeft(leftOrOptions);
      body$.scrollTo({
        scrollLeft: leftOrOptions,
        scrollTop: top
      });
    }
  }
  function scrollToTop(scrollTop) {
    var _a2;
    (_a2 = unref(bodyRef)) == null ? void 0 : _a2.scrollTo({
      scrollTop
    });
  }
  function scrollToRow(row, strategy) {
    var _a2;
    (_a2 = unref(bodyRef)) == null ? void 0 : _a2.scrollToItem(row, 1, strategy);
  }
  function forceUpdate() {
    var _a2, _b;
    (_a2 = unref(bodyRef)) == null ? void 0 : _a2.$forceUpdate();
    (_b = unref(headerRef)) == null ? void 0 : _b.$forceUpdate();
  }
  return {
    bodyRef,
    forceUpdate,
    fixedRowHeight,
    gridHeight,
    hasHeader,
    headerHeight,
    headerRef,
    totalHeight,
    itemKey: itemKey2,
    onItemRendered,
    resetAfterRowIndex,
    scrollTo: scrollTo2,
    scrollToTop,
    scrollToRow
  };
};
const TableGrid = defineComponent({
  name: COMPONENT_NAME$1,
  props: tableV2GridProps,
  setup(props2, {
    slots,
    expose
  }) {
    const {
      ns
    } = inject(TableV2InjectionKey);
    const {
      bodyRef,
      fixedRowHeight,
      gridHeight,
      hasHeader,
      headerRef,
      headerHeight,
      totalHeight,
      forceUpdate,
      itemKey: itemKey2,
      onItemRendered,
      resetAfterRowIndex,
      scrollTo: scrollTo2,
      scrollToTop,
      scrollToRow
    } = useTableGrid(props2);
    expose({
      forceUpdate,
      totalHeight,
      scrollTo: scrollTo2,
      scrollToTop,
      scrollToRow,
      resetAfterRowIndex
    });
    const getColumnWidth = () => props2.bodyWidth;
    return () => {
      const {
        cache: cache2,
        columns: columns2,
        data: data6,
        fixedData,
        useIsScrolling,
        scrollbarAlwaysOn,
        scrollbarEndGap,
        scrollbarStartGap,
        style: style2,
        rowHeight,
        bodyWidth,
        estimatedRowHeight,
        headerWidth,
        height,
        width,
        getRowHeight,
        onScroll
      } = props2;
      const isDynamicRowEnabled = isNumber(estimatedRowHeight);
      const Grid = isDynamicRowEnabled ? DynamicSizeGrid : FixedSizeGrid;
      const _headerHeight = unref(headerHeight);
      return createVNode("div", {
        "role": "table",
        "class": [ns.e("table"), props2.class],
        "style": style2
      }, [createVNode(Grid, {
        "ref": bodyRef,
        "data": data6,
        "useIsScrolling": useIsScrolling,
        "itemKey": itemKey2,
        "columnCache": 0,
        "columnWidth": isDynamicRowEnabled ? getColumnWidth : bodyWidth,
        "totalColumn": 1,
        "totalRow": data6.length,
        "rowCache": cache2,
        "rowHeight": isDynamicRowEnabled ? getRowHeight : rowHeight,
        "width": width,
        "height": unref(gridHeight),
        "class": ns.e("body"),
        "role": "rowgroup",
        "scrollbarStartGap": scrollbarStartGap,
        "scrollbarEndGap": scrollbarEndGap,
        "scrollbarAlwaysOn": scrollbarAlwaysOn,
        "onScroll": onScroll,
        "onItemRendered": onItemRendered,
        "perfMode": false
      }, {
        default: (params) => {
          var _a2;
          const rowData = data6[params.rowIndex];
          return (_a2 = slots.row) == null ? void 0 : _a2.call(slots, __spreadProps(__spreadValues({}, params), {
            columns: columns2,
            rowData
          }));
        }
      }), unref(hasHeader) && createVNode(TableV2Header, {
        "ref": headerRef,
        "class": ns.e("header-wrapper"),
        "columns": columns2,
        "headerData": data6,
        "headerHeight": props2.headerHeight,
        "fixedHeaderData": fixedData,
        "rowWidth": headerWidth,
        "rowHeight": rowHeight,
        "width": width,
        "height": Math.min(_headerHeight + unref(fixedRowHeight), height)
      }, {
        dynamic: slots.header,
        fixed: slots.row
      })]);
    };
  }
});
function _isSlot$6(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
const MainTable = (props2, {
  slots
}) => {
  const _a2 = props2, {
    mainTableRef
  } = _a2, rest = __objRest(_a2, [
    "mainTableRef"
  ]);
  return createVNode(TableGrid, mergeProps({
    "ref": mainTableRef
  }, rest), _isSlot$6(slots) ? slots : {
    default: () => [slots]
  });
};
function _isSlot$5(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
const LeftTable$1 = (props2, {
  slots
}) => {
  if (!props2.columns.length)
    return;
  const _a2 = props2, {
    leftTableRef
  } = _a2, rest = __objRest(_a2, [
    "leftTableRef"
  ]);
  return createVNode(TableGrid, mergeProps({
    "ref": leftTableRef
  }, rest), _isSlot$5(slots) ? slots : {
    default: () => [slots]
  });
};
function _isSlot$4(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
const LeftTable = (props2, {
  slots
}) => {
  if (!props2.columns.length)
    return;
  const _a2 = props2, {
    rightTableRef
  } = _a2, rest = __objRest(_a2, [
    "rightTableRef"
  ]);
  return createVNode(TableGrid, mergeProps({
    "ref": rightTableRef
  }, rest), _isSlot$4(slots) ? slots : {
    default: () => [slots]
  });
};
function _isSlot$3(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
const RowRenderer = (props2, {
  slots
}) => {
  const {
    columns: columns2,
    columnsStyles,
    depthMap,
    expandColumnKey: expandColumnKey2,
    expandedRowKeys,
    estimatedRowHeight,
    hasFixedColumns,
    hoveringRowKey,
    rowData,
    rowIndex,
    style: style2,
    isScrolling,
    rowProps: rowProps3,
    rowClass,
    rowKey: rowKey2,
    rowEventHandlers,
    ns,
    onRowHovered,
    onRowExpanded
  } = props2;
  const rowKls = tryCall(rowClass, {
    columns: columns2,
    rowData,
    rowIndex
  }, "");
  const additionalProps = tryCall(rowProps3, {
    columns: columns2,
    rowData,
    rowIndex
  });
  const _rowKey = rowData[rowKey2];
  const depth = depthMap[_rowKey] || 0;
  const canExpand = Boolean(expandColumnKey2);
  const isFixedRow = rowIndex < 0;
  const kls = [ns.e("row"), rowKls, {
    [ns.e(`row-depth-${depth}`)]: canExpand && rowIndex >= 0,
    [ns.is("expanded")]: canExpand && expandedRowKeys.includes(_rowKey),
    [ns.is("hovered")]: !isScrolling && _rowKey === hoveringRowKey,
    [ns.is("fixed")]: !depth && isFixedRow,
    [ns.is("customized")]: Boolean(slots.row)
  }];
  const onRowHover = hasFixedColumns ? onRowHovered : void 0;
  const _rowProps = __spreadProps(__spreadValues({}, additionalProps), {
    columns: columns2,
    columnsStyles,
    class: kls,
    depth,
    expandColumnKey: expandColumnKey2,
    estimatedRowHeight: isFixedRow ? void 0 : estimatedRowHeight,
    isScrolling,
    rowIndex,
    rowData,
    rowKey: _rowKey,
    rowEventHandlers,
    style: style2
  });
  return createVNode(TableV2Row, mergeProps(_rowProps, {
    "onRowHover": onRowHover,
    "onRowExpand": onRowExpanded
  }), _isSlot$3(slots) ? slots : {
    default: () => [slots]
  });
};
const CellRenderer = ({
  columns: columns2,
  column,
  columnIndex,
  depth,
  expandIconProps,
  isScrolling,
  rowData,
  rowIndex,
  style: style2,
  expandedRowKeys,
  ns,
  cellProps: _cellProps,
  expandColumnKey: expandColumnKey2,
  indentSize,
  iconSize,
  rowKey: rowKey2
}, {
  slots
}) => {
  const cellStyle = enforceUnit(style2);
  if (column.placeholderSign === placeholderSign) {
    return createVNode("div", {
      "class": ns.em("row-cell", "placeholder"),
      "style": cellStyle
    }, null);
  }
  const {
    cellRenderer,
    dataKey,
    dataGetter
  } = column;
  const columnCellRenderer = componentToSlot(cellRenderer);
  const CellComponent2 = columnCellRenderer || slots.default || ((props2) => createVNode(TableV2Cell, props2, null));
  const cellData = isFunction2(dataGetter) ? dataGetter({
    columns: columns2,
    column,
    columnIndex,
    rowData,
    rowIndex
  }) : get$1(rowData, dataKey != null ? dataKey : "");
  const extraCellProps = tryCall(_cellProps, {
    cellData,
    columns: columns2,
    column,
    columnIndex,
    rowIndex,
    rowData
  });
  const cellProps = {
    class: ns.e("cell-text"),
    columns: columns2,
    column,
    columnIndex,
    cellData,
    isScrolling,
    rowData,
    rowIndex
  };
  const Cell3 = CellComponent2(cellProps);
  const kls = [ns.e("row-cell"), column.class, column.align === Alignment.CENTER && ns.is("align-center"), column.align === Alignment.RIGHT && ns.is("align-right")];
  const expandable = rowIndex >= 0 && expandColumnKey2 && column.key === expandColumnKey2;
  const expanded = rowIndex >= 0 && expandedRowKeys.includes(rowData[rowKey2]);
  let IconOrPlaceholder;
  const iconStyle = `margin-inline-start: ${depth * indentSize}px;`;
  if (expandable) {
    if (isObject2(expandIconProps)) {
      IconOrPlaceholder = createVNode(ExpandIcon, mergeProps(expandIconProps, {
        "class": [ns.e("expand-icon"), ns.is("expanded", expanded)],
        "size": iconSize,
        "expanded": expanded,
        "style": iconStyle,
        "expandable": true
      }), null);
    } else {
      IconOrPlaceholder = createVNode("div", {
        "style": [iconStyle, `width: ${iconSize}px; height: ${iconSize}px;`].join(" ")
      }, null);
    }
  }
  return createVNode("div", mergeProps({
    "class": kls,
    "style": cellStyle
  }, extraCellProps, {
    "role": "cell"
  }), [IconOrPlaceholder, Cell3]);
};
CellRenderer.inheritAttrs = false;
function _isSlot$2(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
const HeaderRenderer = ({
  columns: columns2,
  columnsStyles,
  headerIndex,
  style: style2,
  headerClass,
  headerProps,
  ns
}, {
  slots
}) => {
  const param = {
    columns: columns2,
    headerIndex
  };
  const kls = [ns.e("header-row"), tryCall(headerClass, param, ""), {
    [ns.is("customized")]: Boolean(slots.header)
  }];
  const extraProps = __spreadProps(__spreadValues({}, tryCall(headerProps, param)), {
    columnsStyles,
    class: kls,
    columns: columns2,
    headerIndex,
    style: style2
  });
  return createVNode(TableV2HeaderRow, extraProps, _isSlot$2(slots) ? slots : {
    default: () => [slots]
  });
};
const HeaderCellRenderer = (props2, {
  slots
}) => {
  const {
    column,
    ns,
    style: style2,
    onColumnSorted
  } = props2;
  const cellStyle = enforceUnit(style2);
  if (column.placeholderSign === placeholderSign) {
    return createVNode("div", {
      "class": ns.em("header-row-cell", "placeholder"),
      "style": cellStyle
    }, null);
  }
  const {
    headerCellRenderer,
    headerClass,
    sortable
  } = column;
  const cellProps = __spreadProps(__spreadValues({}, props2), {
    class: ns.e("header-cell-text")
  });
  const cellRenderer = componentToSlot(headerCellRenderer) || slots.default || ((props22) => createVNode(HeaderCell, props22, null));
  const Cell3 = cellRenderer(cellProps);
  const {
    sortBy,
    sortState,
    headerCellProps
  } = props2;
  let sorting, sortOrder;
  if (sortState) {
    const order = sortState[column.key];
    sorting = Boolean(oppositeOrderMap[order]);
    sortOrder = sorting ? order : SortOrder$1.ASC;
  } else {
    sorting = column.key === sortBy.key;
    sortOrder = sorting ? sortBy.order : SortOrder$1.ASC;
  }
  const cellKls = [ns.e("header-cell"), tryCall(headerClass, props2, ""), column.align === Alignment.CENTER && ns.is("align-center"), column.align === Alignment.RIGHT && ns.is("align-right"), sortable && ns.is("sortable")];
  const cellWrapperProps = __spreadProps(__spreadValues({}, tryCall(headerCellProps, props2)), {
    onClick: column.sortable ? onColumnSorted : void 0,
    class: cellKls,
    style: cellStyle,
    ["data-key"]: column.key
  });
  return createVNode("div", mergeProps(cellWrapperProps, {
    "role": "columnheader"
  }), [Cell3, sortable && createVNode(SortIcon, {
    "class": [ns.e("sort-icon"), sorting && ns.is("sorting")],
    "sortOrder": sortOrder
  }, null)]);
};
const Footer$1 = (props2, {
  slots
}) => {
  var _a2;
  return createVNode("div", {
    "class": props2.class,
    "style": props2.style
  }, [(_a2 = slots.default) == null ? void 0 : _a2.call(slots)]);
};
Footer$1.displayName = "ElTableV2Footer";
const Footer = (props2, {
  slots
}) => {
  return createVNode("div", {
    "class": props2.class,
    "style": props2.style
  }, [slots.default ? slots.default() : createVNode(ElEmpty, null, null)]);
};
Footer.displayName = "ElTableV2Empty";
const Overlay = (props2, {
  slots
}) => {
  var _a2;
  return createVNode("div", {
    "class": props2.class,
    "style": props2.style
  }, [(_a2 = slots.default) == null ? void 0 : _a2.call(slots)]);
};
Overlay.displayName = "ElTableV2Overlay";
function _isSlot$1(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
const COMPONENT_NAME = "ElTableV2";
const TableV2 = defineComponent({
  name: COMPONENT_NAME,
  props: tableV2Props,
  setup(props2, {
    slots,
    expose
  }) {
    const ns = useNamespace("table-v2");
    const {
      columnsStyles,
      fixedColumnsOnLeft,
      fixedColumnsOnRight,
      mainColumns,
      mainTableHeight,
      fixedTableHeight,
      leftTableWidth,
      rightTableWidth,
      data: data6,
      depthMap,
      expandedRowKeys,
      hasFixedColumns,
      hoveringRowKey,
      mainTableRef,
      leftTableRef,
      rightTableRef,
      isDynamic,
      isResetting,
      isScrolling,
      bodyWidth,
      emptyStyle,
      rootStyle,
      headerWidth,
      footerHeight,
      showEmpty,
      scrollTo: scrollTo2,
      scrollToLeft,
      scrollToTop,
      scrollToRow,
      getRowHeight,
      onColumnSorted,
      onRowHeightChange,
      onRowHovered,
      onRowExpanded,
      onRowsRendered,
      onScroll,
      onVerticalScroll
    } = useTable(props2);
    expose({
      scrollTo: scrollTo2,
      scrollToLeft,
      scrollToTop,
      scrollToRow
    });
    provide(TableV2InjectionKey, {
      ns,
      isResetting,
      hoveringRowKey,
      isScrolling
    });
    return () => {
      const {
        cache: cache2,
        cellProps,
        estimatedRowHeight,
        expandColumnKey: expandColumnKey2,
        fixedData,
        headerHeight,
        headerClass,
        headerProps,
        headerCellProps,
        sortBy,
        sortState,
        rowHeight,
        rowClass,
        rowEventHandlers,
        rowKey: rowKey2,
        rowProps: rowProps3,
        scrollbarAlwaysOn,
        indentSize,
        iconSize,
        useIsScrolling,
        vScrollbarSize,
        width
      } = props2;
      const _data = unref(data6);
      const mainTableProps = {
        cache: cache2,
        class: ns.e("main"),
        columns: unref(mainColumns),
        data: _data,
        fixedData,
        estimatedRowHeight,
        bodyWidth: unref(bodyWidth) + vScrollbarSize,
        headerHeight,
        headerWidth: unref(headerWidth),
        height: unref(mainTableHeight),
        mainTableRef,
        rowKey: rowKey2,
        rowHeight,
        scrollbarAlwaysOn,
        scrollbarStartGap: 2,
        scrollbarEndGap: vScrollbarSize,
        useIsScrolling,
        width,
        getRowHeight,
        onRowsRendered,
        onScroll
      };
      const leftColumnsWidth = unref(leftTableWidth);
      const _fixedTableHeight = unref(fixedTableHeight);
      const leftTableProps = {
        cache: cache2,
        class: ns.e("left"),
        columns: unref(fixedColumnsOnLeft),
        data: _data,
        estimatedRowHeight,
        leftTableRef,
        rowHeight,
        bodyWidth: leftColumnsWidth,
        headerWidth: leftColumnsWidth,
        headerHeight,
        height: _fixedTableHeight,
        rowKey: rowKey2,
        scrollbarAlwaysOn,
        scrollbarStartGap: 2,
        scrollbarEndGap: vScrollbarSize,
        useIsScrolling,
        width: leftColumnsWidth,
        getRowHeight,
        onScroll: onVerticalScroll
      };
      const rightColumnsWidth = unref(rightTableWidth);
      const rightColumnsWidthWithScrollbar = rightColumnsWidth + vScrollbarSize;
      const rightTableProps = {
        cache: cache2,
        class: ns.e("right"),
        columns: unref(fixedColumnsOnRight),
        data: _data,
        estimatedRowHeight,
        rightTableRef,
        rowHeight,
        bodyWidth: rightColumnsWidthWithScrollbar,
        headerWidth: rightColumnsWidthWithScrollbar,
        headerHeight,
        height: _fixedTableHeight,
        rowKey: rowKey2,
        scrollbarAlwaysOn,
        scrollbarStartGap: 2,
        scrollbarEndGap: vScrollbarSize,
        width: rightColumnsWidthWithScrollbar,
        style: `--${unref(ns.namespace)}-table-scrollbar-size: ${vScrollbarSize}px`,
        useIsScrolling,
        getRowHeight,
        onScroll: onVerticalScroll
      };
      const _columnsStyles = unref(columnsStyles);
      const tableRowProps = {
        ns,
        depthMap: unref(depthMap),
        columnsStyles: _columnsStyles,
        expandColumnKey: expandColumnKey2,
        expandedRowKeys: unref(expandedRowKeys),
        estimatedRowHeight,
        hasFixedColumns: unref(hasFixedColumns),
        hoveringRowKey: unref(hoveringRowKey),
        rowProps: rowProps3,
        rowClass,
        rowKey: rowKey2,
        rowEventHandlers,
        onRowHovered,
        onRowExpanded,
        onRowHeightChange
      };
      const tableCellProps = {
        cellProps,
        expandColumnKey: expandColumnKey2,
        indentSize,
        iconSize,
        rowKey: rowKey2,
        expandedRowKeys: unref(expandedRowKeys),
        ns
      };
      const tableHeaderProps = {
        ns,
        headerClass,
        headerProps,
        columnsStyles: _columnsStyles
      };
      const tableHeaderCellProps = {
        ns,
        sortBy,
        sortState,
        headerCellProps,
        onColumnSorted
      };
      const tableSlots = {
        row: (props22) => createVNode(RowRenderer, mergeProps(props22, tableRowProps), {
          row: slots.row,
          cell: (props3) => {
            let _slot;
            return slots.cell ? createVNode(CellRenderer, mergeProps(props3, tableCellProps, {
              "style": _columnsStyles[props3.column.key]
            }), _isSlot$1(_slot = slots.cell(props3)) ? _slot : {
              default: () => [_slot]
            }) : createVNode(CellRenderer, mergeProps(props3, tableCellProps, {
              "style": _columnsStyles[props3.column.key]
            }), null);
          }
        }),
        header: (props22) => createVNode(HeaderRenderer, mergeProps(props22, tableHeaderProps), {
          header: slots.header,
          cell: (props3) => {
            let _slot2;
            return slots["header-cell"] ? createVNode(HeaderCellRenderer, mergeProps(props3, tableHeaderCellProps, {
              "style": _columnsStyles[props3.column.key]
            }), _isSlot$1(_slot2 = slots["header-cell"](props3)) ? _slot2 : {
              default: () => [_slot2]
            }) : createVNode(HeaderCellRenderer, mergeProps(props3, tableHeaderCellProps, {
              "style": _columnsStyles[props3.column.key]
            }), null);
          }
        })
      };
      const rootKls = [props2.class, ns.b(), ns.e("root"), {
        [ns.is("dynamic")]: unref(isDynamic)
      }];
      const footerProps = {
        class: ns.e("footer"),
        style: unref(footerHeight)
      };
      return createVNode("div", {
        "class": rootKls,
        "style": unref(rootStyle)
      }, [createVNode(MainTable, mainTableProps, _isSlot$1(tableSlots) ? tableSlots : {
        default: () => [tableSlots]
      }), createVNode(LeftTable$1, leftTableProps, _isSlot$1(tableSlots) ? tableSlots : {
        default: () => [tableSlots]
      }), createVNode(LeftTable, rightTableProps, _isSlot$1(tableSlots) ? tableSlots : {
        default: () => [tableSlots]
      }), slots.footer && createVNode(Footer$1, footerProps, {
        default: slots.footer
      }), unref(showEmpty) && createVNode(Footer, {
        "class": ns.e("empty"),
        "style": unref(emptyStyle)
      }, {
        default: slots.empty
      }), slots.overlay && createVNode(Overlay, {
        "class": ns.e("overlay")
      }, {
        default: slots.overlay
      })]);
    };
  }
});
const autoResizerProps = buildProps({
  disableWidth: Boolean,
  disableHeight: Boolean,
  onResize: {
    type: definePropType(Function)
  }
});
const AutoResizer = defineComponent({
  name: "ElAutoResizer",
  props: autoResizerProps,
  setup(props2, {
    slots
  }) {
    const ns = useNamespace("auto-resizer");
    const {
      height,
      width,
      sizer
    } = useAutoResize(props2);
    const style2 = {
      width: "100%",
      height: "100%"
    };
    return () => {
      var _a2;
      return createVNode("div", {
        "ref": sizer,
        "class": ns.b(),
        "style": style2
      }, [(_a2 = slots.default) == null ? void 0 : _a2.call(slots, {
        height: height.value,
        width: width.value
      })]);
    };
  }
});
withInstall2(TableV2);
const ElAutoResizer = withInstall2(AutoResizer);
const tableCacheKeyPrefix = "VIRTUAL_TABLE_CACHE_";
function useTableCache(propsRef) {
  const cacheKey = computed(() => {
    const name2 = unref(propsRef).cacheName;
    return name2 ? tableCacheKeyPrefix + name2 : "";
  });
  const cacheEnable = computed(() => unref(propsRef).cacheEnable) && !!unref(propsRef).cacheName;
  const getPageSizeCacheKey = computed(() => {
    return unref(cacheKey) + "_PAGE_SIZE";
  });
  function getCachedColumns() {
    if (unref(cacheEnable)) {
      return storageProxy.get(unref(cacheKey));
    }
    return null;
  }
  function setCachedColumns(columns2) {
    const key2 = unref(cacheKey);
    if (unref(cacheEnable) && key2) {
      return storageProxy.set(key2, columns2);
    }
  }
  function setPaginationPageSizeCache(pageSize2) {
    const key2 = unref(getPageSizeCacheKey);
    if (unref(cacheEnable) && key2) {
      return storageProxy.set(key2, pageSize2);
    }
  }
  function getPaginationPageSizeCache() {
    if (unref(cacheEnable)) {
      return storageProxy.get(unref(getPageSizeCacheKey));
    }
    return null;
  }
  return {
    getCachedColumns,
    setCachedColumns,
    setPaginationPageSizeCache,
    getPaginationPageSizeCache
  };
}
function usePagination(props2) {
  const innerConfig = ref({});
  const show = ref(true);
  const { getPaginationPageSizeCache, setPaginationPageSizeCache } = useTableCache(props2);
  watch(() => unref(props2).pagination, (newPagination) => {
    if (isPlainObject(newPagination)) {
      innerConfig.value = __spreadValues(__spreadValues({}, unref(innerConfig)), newPagination);
    }
  });
  const getPaginationInfo = computed(() => {
    const { pagination } = unref(props2);
    if (pagination === false || unref(show) === false) {
      return false;
    }
    const pageSizeCached = getPaginationPageSizeCache();
    return __spreadValues(__spreadValues({
      current: 1,
      pageSize: pageSizeCached || PAGE_SIZE,
      size: "default",
      defaultPageSize: pageSizeCached || PAGE_SIZE,
      showTotal: (total3) => `\u5171${total3}\u6761\uFF1A`,
      showSizeChanger: true,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
      itemRender,
      showQuickJumper: false,
      position: ["bottomLeft"],
      total: 0
    }, isPlainObject(pagination) ? pagination : {}), unref(innerConfig));
  });
  const getPaginationBinds = function() {
    return unref(getPaginationInfo);
  };
  function setPaginationConfig(pagination) {
    const paginationInfo = unref(getPaginationInfo);
    innerConfig.value = __spreadValues(__spreadValues({}, isPlainObject(paginationInfo) ? paginationInfo : {}), pagination);
    if (pagination.pageSize) {
      setPaginationPageSizeCache(pagination.pageSize);
    }
  }
  const getShowPagination = function() {
    return unref(show);
  };
  async function setShowPagination(visible) {
    show.value = visible;
  }
  return {
    getPaginationInfo,
    getPaginationBinds,
    setPaginationConfig,
    getShowPagination,
    setShowPagination
  };
}
const ROW_KEY = "key";
const FETCH_SETTING = {
  pageField: "pageIndex",
  sizeField: "pageSize",
  listField: "records",
  totalField: "total"
};
const DEFAULT_SIZE = "default";
const DEFAULT_SORT_FN = (sortInfo) => {
  const { field, order } = sortInfo;
  if (field && order) {
    return {
      field,
      order
    };
  } else {
    return {};
  }
};
const DEFAULT_FILTER_FN = (data6) => {
  return data6;
};
const DEFAULT_ALIGN = "left";
const INDEX_COLUMN_FLAG = "INDEX";
const ACTION_COLUMN_FLAG = "ACTION";
const SETTING_COLUMN_INDEX = "SETTING";
var FixedDir;
(function(FixedDir2) {
  FixedDir2["LEFT"] = "left";
  FixedDir2["RIGHT"] = "right";
})(FixedDir || (FixedDir = {}));
var TdEllipsis = defineComponent({
  name: "TdEllipsis",
  props: {
    tooltipContent: {
      type: [String, Number, Function]
    },
    placement: String,
    getPopupContainer: Function,
    tooltipProps: Object,
    overlayClassName: String
  },
  setup(props2) {
    const root2 = ref();
    const isOverflow = ref(false);
    const ellipsisClasses = computed(() => [`td-text-ellipsis`]);
    const innerEllipsisClassName = computed(() => props2.overlayClassName);
    const onTriggerMouseenter = () => {
      if (!root2.value)
        return;
      isOverflow.value = isNodeOverflow(root2.value);
    };
    const onTriggerMouseleave = () => {
      isOverflow.value = isNodeOverflow(root2.value);
    };
    const onMouseAround = debounce((e2) => {
      e2.type === "mouseleave" ? onTriggerMouseleave() : onTriggerMouseenter();
    }, 80);
    return {
      root: root2,
      isOverflow,
      ellipsisClasses,
      innerEllipsisClassName,
      onMouseAround
    };
  },
  render() {
    const cellNode = this.$slots.default && this.$slots.default();
    const ellipsisContent = createVNode("div", {
      "ref": "root",
      "class": this.ellipsisClasses,
      "onMouseenter": this.onMouseAround,
      "onMouseleave": this.onMouseAround
    }, [cellNode]);
    let content = null;
    const tooltipProps3 = this.tooltipProps;
    if (this.isOverflow) {
      const rProps = __spreadValues({
        destroyTooltipOnHide: true,
        getPopupContainer: this.getPopupContainer || (() => document.body),
        placement: this.placement,
        overlayClassName: this.innerEllipsisClassName
      }, tooltipProps3);
      content = createVNode(Tooltip, rProps, {
        title: () => {
          return typeof this.tooltipContent === "function" ? this.tooltipContent(h$2) : this.tooltipContent;
        },
        default: () => ellipsisContent
      });
    } else {
      content = ellipsisContent;
    }
    return content;
  }
});
function handleItem(item, ellipsis) {
  const { key: key2, dataIndex, children } = item;
  item.align = item.align || DEFAULT_ALIGN;
  if (ellipsis) {
    if (!key2) {
      item.key = dataIndex;
    }
    if (!isBoolean(item.ellipsis)) {
      Object.assign(item, {
        ellipsis
      });
    }
  }
  if (children && children.length) {
    handleChildren(children, !!ellipsis);
  }
}
function handleChildren(children, ellipsis) {
  if (!children)
    return;
  children.forEach((item) => {
    const { children: children2 } = item;
    handleItem(item, ellipsis);
    handleChildren(children2, ellipsis);
  });
}
function handleIndexColumn(propsRef, getPaginationRef, columns2) {
  const { showIndexColumn, indexColumnProps, isTreeTable } = unref(propsRef);
  if (unref(isTreeTable)) {
    return;
  }
  let pushIndexColumns = false;
  columns2.forEach(() => {
    const indIndex = columns2.findIndex((column) => column.flag === INDEX_COLUMN_FLAG);
    if (showIndexColumn) {
      pushIndexColumns = indIndex === -1;
    } else if (!showIndexColumn && indIndex !== -1) {
      columns2.splice(indIndex, 1);
    }
  });
  if (!pushIndexColumns)
    return;
  const isFixedLeft = columns2.some((item) => item.fixed === "left");
  columns2.unshift(__spreadProps(__spreadValues(__spreadValues({
    flag: INDEX_COLUMN_FLAG,
    width: 60,
    title: "\u5E8F\u53F7",
    align: "center",
    disabled: true,
    key: INDEX_COLUMN_FLAG,
    dataKey: INDEX_COLUMN_FLAG,
    cellRenderer: ({ rowIndex }) => {
      const getPagination = unref(getPaginationRef);
      if (isBoolean(getPagination)) {
        return `${rowIndex + 1}`;
      }
      const { current: current2 = 1, pageSize: pageSize2 = PAGE_SIZE } = getPagination;
      return ((current2 < 1 ? 1 : current2) - 1) * pageSize2 + rowIndex + 1;
    }
  }, isFixedLeft ? {
    fixed: FixedDir.LEFT
  } : {}), indexColumnProps), {
    sortable: false
  }));
}
function handleActionColumn(propsRef, columns2) {
  const { actionColumn } = unref(propsRef);
  if (!actionColumn)
    return;
  const hasIndex = columns2.findIndex((column) => column.flag === ACTION_COLUMN_FLAG);
  if (hasIndex === -1) {
    columns2.push(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, columns2[hasIndex]), {
      fixed: FixedDir.RIGHT
    }), actionColumn), {
      flag: ACTION_COLUMN_FLAG
    }));
  }
}
function handleSettingColumn(propsRef, columns2) {
  const { showSettingColumn, settingColumnProps } = unref(propsRef);
  if (!showSettingColumn || columns2.length > 0) {
    return;
  }
  const isFixedRight = columns2.some((item) => item.fixed === "right");
  columns2.push(__spreadValues(__spreadValues({
    width: 50,
    title: "",
    align: "center",
    flag: SETTING_COLUMN_INDEX
  }, isFixedRight ? {
    fixed: FixedDir.RIGHT
  } : {}), settingColumnProps));
}
function handleSelectionColumn(propsRef, getRowSelectionRef, getSelectRowKeys, setSelectedRowKeys, getDataSourceRef, columns2) {
  const rowSelection = unref(getRowSelectionRef);
  if (!rowSelection || columns2.length <= 0) {
    return;
  }
  const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
  const useRowKey = rowKey2 || autoCreateKey && ROW_KEY || "";
  const getRowKey = (record) => isFunction$1(useRowKey) ? useRowKey(record) : record[useRowKey];
  const isFixedLeft = columns2.some((item) => item.fixed === "left");
  const SelectionCell = ({
    value,
    intermediate = false,
    onChange: onChange3,
    disabled
  }) => {
    return h$2(Checkbox, {
      onChange: onChange3,
      checked: value,
      indeterminate: intermediate,
      disabled
    });
  };
  const emitRowSelectionChange = (rowDataList, checked) => {
    var _a2;
    const newKeys = rowDataList.map((row) => getRowKey(row));
    const currentKeys = (_a2 = getSelectRowKeys()) == null ? void 0 : _a2.slice(0);
    if (checked) {
      setSelectedRowKeys(onlyUnique([...currentKeys, ...newKeys]));
    } else {
      setSelectedRowKeys(currentKeys.filter((item) => !newKeys.includes(item)));
    }
  };
  const checkboxPropsMap = computed(() => {
    const map = new Map();
    const getCheckboxProps = rowSelection.getCheckboxProps;
    getDataSourceRef.value.forEach((record) => {
      const key2 = getRowKey(record);
      const checkboxProps3 = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
      map.set(key2, checkboxProps3);
    });
    return map;
  });
  columns2.unshift(__spreadProps(__spreadValues({
    width: rowSelection.columnWidth && Number(rowSelection.columnWidth) || 60,
    align: "center",
    disabled: true,
    key: "selection",
    sortable: false,
    resizable: false
  }, isFixedLeft ? {
    fixed: FixedDir.LEFT
  } : {}), {
    cellRenderer: ({ rowData }) => {
      const onChange3 = (value) => {
        rowData.checked = value.target.checked;
        emitRowSelectionChange([rowData], value.target.checked);
      };
      const { getCheckboxProps } = rowSelection;
      const checkboxProps3 = typeof getCheckboxProps == "function" ? getCheckboxProps(rowData) : {};
      return h$2(Checkbox, __spreadProps(__spreadValues({}, isPlainObject(checkboxProps3) ? checkboxProps3 : {}), {
        onChange: onChange3,
        onClick: (event) => {
          event.stopPropagation();
        },
        checked: rowData.checked,
        style: {
          fontSize: 0
        }
      }));
    },
    headerCellRenderer: ({}) => {
      const _data = unref(getDataSourceRef);
      const onChange3 = (value) => {
        const checked = value.target.checked;
        const resultArr = [];
        getDataSourceRef.value = _data.map((row) => {
          var _a2;
          if (!((_a2 = checkboxPropsMap.value.get(getRowKey(row))) == null ? void 0 : _a2.disabled)) {
            row.checked = checked;
            resultArr.push(row);
          }
          return row;
        });
        emitRowSelectionChange(resultArr, checked);
      };
      const allDisabledData = _data.map((record) => {
        const key2 = getRowKey(record);
        const checkboxProps3 = checkboxPropsMap.value.get(key2) || {};
        return __spreadValues({}, checkboxProps3);
      }).filter(({ disabled }) => disabled);
      const allDisabled = !!allDisabledData.length && allDisabledData.length === _data.length;
      const allDisabledAndChecked = allDisabled && allDisabledData.every(({ checked }) => checked);
      const allDisabledSomeChecked = allDisabled && allDisabledData.some(({ checked }) => checked);
      const allSelected = _data.length > 0 && _data.filter((row) => {
        var _a2;
        return !((_a2 = checkboxPropsMap.value.get(getRowKey(row))) == null ? void 0 : _a2.disabled);
      }).every((row) => row.checked);
      const containsChecked = _data.filter((row) => {
        var _a2;
        return !((_a2 = checkboxPropsMap.value.get(getRowKey(row))) == null ? void 0 : _a2.disabled);
      }).some((row) => row.checked);
      return h$2(SelectionCell, {
        onChange: onChange3,
        value: !allDisabled ? allSelected : allDisabledAndChecked,
        intermediate: !allDisabled ? containsChecked && !allSelected : !allDisabledAndChecked && allDisabledSomeChecked,
        disabled: _data.length === 0 || allDisabled
      });
    }
  }));
}
function useColumns(propsRef, {
  getPaginationRef,
  getRowSelectionRef,
  getDataSourceRef,
  getSelectRowKeys,
  setSelectedRowKeys,
  emit
}) {
  const { getCachedColumns, setCachedColumns } = useTableCache(propsRef);
  const columnsRef = ref(initColumnsWithLocalCache(cloneDeep(unref(propsRef).columns) || []));
  let cacheColumns = cloneDeep(unref(columnsRef)) || [];
  let mutationColumns = cloneDeep(unref(propsRef).columns);
  const NORMAL_WIDTH = 150;
  const getColumnsRef = computed(() => {
    const columns2 = cloneDeep(unref(columnsRef));
    handleIndexColumn(propsRef, getPaginationRef, columns2);
    handleActionColumn(propsRef, columns2);
    if (!columns2) {
      return [];
    }
    handleSettingColumn(propsRef, columns2);
    handleSelectionColumn(propsRef, getRowSelectionRef, getSelectRowKeys, setSelectedRowKeys, getDataSourceRef, columns2);
    const { ellipsis } = unref(propsRef);
    columns2.forEach((item) => {
      var _a2;
      const { customRender, cellRenderer } = item;
      item.dataKey = item.dataIndex;
      item.key = (_a2 = item.key) != null ? _a2 : item.dataIndex;
      if (!Reflect.has(item, "width")) {
        Reflect.set(item, "width", NORMAL_WIDTH);
      }
      handleItem(item, Reflect.has(item, "ellipsis") ? !!item.ellipsis : !!ellipsis && !(customRender || cellRenderer));
    });
    return columns2;
  });
  function isIfShow(column) {
    const ifShow = column.ifShow;
    let isIfShow2 = true;
    if (isBoolean(ifShow)) {
      isIfShow2 = ifShow;
    }
    if (isFunction$1(ifShow)) {
      isIfShow2 = ifShow(column);
    }
    return isIfShow2;
  }
  const getViewColumns = computed(() => {
    const viewColumns = sortFixedColumn(unref(getColumnsRef));
    const columns2 = cloneDeep(viewColumns);
    return columns2.filter((column) => {
      return isIfShow(column);
    }).map((column) => {
      const {
        customRender,
        cellRenderer,
        format: format3 = normalizeCell,
        flag,
        ellipsis,
        customEllipsis
      } = column;
      const isDefaultAction = [
        INDEX_COLUMN_FLAG,
        ACTION_COLUMN_FLAG,
        SETTING_COLUMN_INDEX
      ].includes(flag);
      if (!(customRender || cellRenderer) && !isDefaultAction) {
        column.cellRenderer = ({ cellData: text, rowData: record, rowIndex: index2, column: column2 }) => {
          if (ellipsis) {
            const params = { column: column2, record, text, index: index2 };
            let content = isFunction$1(customEllipsis) ? customEllipsis(h$2, params) : void 0;
            if (typeof customEllipsis === "object" && isFunction$1(customEllipsis.content)) {
              content = customEllipsis.content(h$2, params);
            }
            let tooltipProps3 = {};
            if (typeof customEllipsis === "object") {
              tooltipProps3 = "props" in customEllipsis ? customEllipsis.props : customEllipsis || void 0;
            }
            const formattedText = format3 ? formatCell(text, format3, record, index2) : text;
            content = content ? content : formattedText;
            return h$2(TdEllipsis, {
              placement: "top",
              tooltipContent: content && (() => content),
              tooltipProps: tooltipProps3
            }, { default: () => formattedText });
          } else if (format3) {
            return h$2("span", formatCell(text, format3, record, index2));
          }
        };
      }
      if (customRender) {
        column.cellRenderer = ({ cellData: text, rowData: record, rowIndex: index2, column: column2 }) => {
          return customRender({
            value: text,
            text,
            record,
            index: index2,
            column: column2
          });
        };
      }
      return column;
    });
  });
  watch(() => unref(propsRef).columns, (columns2) => {
    if (isArray$1(columns2)) {
      columnsRef.value = initColumnsWithLocalCache(cloneDeep(columns2) || []);
      cacheColumns = cloneDeep(unref(columnsRef)) || [];
      mutationColumns = cloneDeep(columns2);
    }
  });
  watch(columnsRef, (columns2) => {
    setCachedColumns(columns2);
  }, {
    deep: true
  });
  function initColumnsWithLocalCache(columns2) {
    const cachedColumns = getCachedColumns();
    if (isArray$1(cachedColumns)) {
      cachedColumns.forEach((item) => {
        const found = columns2.find((col) => col.dataIndex === item.dataIndex);
        if (found && isPlainObject(found)) {
          const { title, fixed } = found;
          Object.assign(found, item, { title, fixed });
        }
      });
      handleIndexColumn(propsRef, getPaginationRef, columns2);
      columns2.sort((prev2, next2) => {
        return cachedColumns.findIndex((item) => item.dataIndex === prev2.dataIndex) - cachedColumns.findIndex((item) => item.dataIndex === next2.dataIndex);
      });
    } else {
      handleIndexColumn(propsRef, getPaginationRef, columns2);
    }
    return columns2;
  }
  function setCacheColumnsByField(dataIndex, value) {
    if (!dataIndex || !value) {
      return;
    }
    cacheColumns == null ? void 0 : cacheColumns.forEach((item) => {
      if (item.dataIndex === dataIndex) {
        Object.assign(item, value);
        return;
      }
    });
  }
  function setColumns(columnList) {
    const columns2 = cloneDeep(columnList);
    if (!isArray$1(columns2))
      return;
    if (columns2.length <= 0) {
      columnsRef.value = [];
      return;
    }
    const firstColumn = columns2[0];
    const cacheKeys = cacheColumns.map((item) => item.dataIndex);
    const currentColumnKeys = unref(columnsRef).map((item) => item.dataIndex);
    if (!isString$1(firstColumn)) {
      columnsRef.value = columns2;
    } else {
      const columnKeys = columns2;
      const newColumns = [];
      cacheColumns.forEach((item) => {
        newColumns.push(__spreadProps(__spreadValues({}, item), {
          defaultHidden: !columnKeys.includes(item.dataIndex || item.key)
        }));
      });
      if (!isDeepEqual(cacheKeys, columns2)) {
        const sortArr = cacheKeys.length === columns2.length ? columnKeys : currentColumnKeys;
        newColumns.sort((prev2, next2) => {
          return sortArr.indexOf(prev2.dataIndex) - sortArr.indexOf(next2.dataIndex);
        });
      }
      columnsRef.value = newColumns;
    }
  }
  function getColumns(opt) {
    const { ignoreIndex, ignoreAction, ignoreSetting, sort: sort2 } = opt || {};
    let columns2 = toRaw(unref(getColumnsRef));
    if (ignoreIndex) {
      columns2 = columns2.filter((item) => item.flag !== INDEX_COLUMN_FLAG);
    }
    if (ignoreAction) {
      columns2 = columns2.filter((item) => item.flag !== ACTION_COLUMN_FLAG);
    }
    if (ignoreSetting) {
      columns2 = columns2.filter((item) => item.flag !== SETTING_COLUMN_INDEX);
    }
    if (sort2) {
      columns2 = sortFixedColumn(columns2);
    }
    return columns2;
  }
  function getCacheColumns() {
    return cacheColumns;
  }
  function getMutationColumns() {
    const returnColumns = mutationColumns.slice(0);
    handleIndexColumn(propsRef, getPaginationRef, returnColumns);
    return returnColumns;
  }
  function resetColumns() {
    const columns2 = getMutationColumns();
    setColumns(columns2);
    cacheColumns = cloneDeep(columns2);
  }
  function handleResizeColumn(width, col) {
    const found = unref(columnsRef).find((item) => item.dataIndex === col.dataIndex);
    if (found) {
      found.width = width;
      setCacheColumnsByField(found.dataIndex, found);
    }
    emit("resize-column", width, col);
  }
  return {
    getColumnsRef,
    getCacheColumns,
    getColumns,
    setColumns,
    getViewColumns,
    setCacheColumnsByField,
    handleResizeColumn,
    getMutationColumns,
    resetColumns
  };
}
function sortFixedColumn(columns2) {
  const fixedLeftColumns = [];
  const fixedRightColumns = [];
  const defColumns = [];
  for (const column of columns2) {
    if (column.fixed === "left") {
      fixedLeftColumns.push(column);
      continue;
    }
    if (column.fixed === "right") {
      fixedRightColumns.push(column);
      continue;
    }
    defColumns.push(column);
  }
  return [...fixedLeftColumns, ...defColumns, ...fixedRightColumns].filter((item) => !item.defaultHidden);
}
function formatCell(text, format3, record, index2) {
  if (!format3) {
    return text;
  }
  if (isFunction$1(format3)) {
    return format3(text, record, index2);
  }
  try {
    const DATE_FORMAT_PREFIX = "date|";
    if (isString$1(format3) && format3.startsWith(DATE_FORMAT_PREFIX)) {
      const dateFormat = format3.replace(DATE_FORMAT_PREFIX, "");
      if (!dateFormat) {
        return text;
      }
      return formatToDate(text, dateFormat);
    }
    if (format3 instanceof Map) {
      return format3.get(text);
    }
  } catch (error) {
    return text;
  }
}
function normalizeCell(text) {
  return isUnDef(text) || text === "" ? "--" : text;
}
function useDataSource(propsRef, tableData, {
  getPaginationInfo,
  setPagination,
  setLoading,
  getFieldsValue,
  clearSelectedRowKeys,
  setEmptyTextAfterFetch,
  setEmptyInFetching,
  checkSelectedStatus,
  getTabData
}, emit) {
  const dataSourceRef = ref([]);
  const rawDataSourceRef = ref([]);
  const searchState = reactive({
    sortInfo: {},
    filterInfo: {}
  });
  const setSearchStateSortInfo = (sortInfo) => {
    searchState.sortInfo = sortInfo;
  };
  watchEffect(() => {
    tableData.value = unref(dataSourceRef);
  });
  const { rowSelection } = unref(propsRef);
  const initRowChecked = (data6) => {
    if (rowSelection) {
      data6.forEach((item) => {
        item.checked = checkSelectedStatus(item);
      });
    }
  };
  watch(() => unref(propsRef).dataSource, (data6) => {
    if (!isFunction$1(unref(propsRef).api) && data6) {
      initRowChecked(data6);
      dataSourceRef.value = data6;
    }
  }, {
    immediate: true
  });
  const getAutoCreateKeyRef = computed(() => {
    const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
    return autoCreateKey && !rowKey2;
  });
  const getRowKeyRef = computed(() => {
    return unref(getAutoCreateKeyRef) ? ROW_KEY : unref(propsRef).rowKey;
  });
  const getDataSourceRef = computed(() => {
    const dataSource = unref(dataSourceRef);
    if (!dataSource || dataSource.length === 0) {
      return [];
    }
    if (unref(getAutoCreateKeyRef)) {
      const firstItem = dataSource[0];
      if (firstItem && Reflect.has(firstItem, ROW_KEY) === false) {
        const data6 = cloneDeep(dataSource);
        setRowRecordsKey(data6);
        dataSourceRef.value = data6;
      }
    }
    return unref(dataSourceRef);
  });
  function setRowRecordsKey(rows) {
    const { childrenColumnName } = unref(propsRef);
    rows.forEach((row) => {
      row[ROW_KEY] = uuid();
      const children = row[childrenColumnName || "children"];
      if (children && children.length) {
        setRowRecordsKey(children);
      }
    });
  }
  function handleTableChange(pagination, filters, sorter) {
    const { clearSelectOnPageChange, sortFn, filterFn } = unref(propsRef);
    if (clearSelectOnPageChange) {
      clearSelectedRowKeys();
    }
    setPagination(pagination);
    const params = {};
    if (sorter && isFunction$1(sortFn)) {
      const sortInfo = sortFn(sorter);
      searchState.sortInfo = sortInfo;
      params.sortInfo = sortInfo;
    }
    if (filters && isFunction$1(filterFn)) {
      const filterInfo = filterFn(filters);
      searchState.filterInfo = filterInfo;
      params.filterInfo = filterInfo;
    }
    fetch(params);
  }
  function handleColumnSort(sortResult) {
    const { sortFn } = unref(propsRef);
    const { column, key: key2, order } = sortResult;
    const params = {};
    if (sortResult && isFunction$1(sortFn)) {
      const sortInfo = sortFn({ column, field: key2, order, columnKey: column.key });
      searchState.sortInfo = sortInfo;
      params.sortInfo = sortInfo;
    }
    fetch(params);
  }
  async function fetch(params) {
    var _a2, _b, _c;
    const {
      api: api2,
      searchInfo,
      defSort,
      fetchSetting,
      beforeFetch,
      afterFetch,
      useSearchForm,
      emptyInFetching,
      emptyAfterFetch
    } = unref(propsRef);
    if (!isFunction$1(api2)) {
      return;
    }
    try {
      setLoading(true);
      if (emptyInFetching && isFunction$1(emptyInFetching)) {
        setEmptyInFetching(emptyInFetching());
      } else {
        setEmptyInFetching();
      }
      const { pageField, sizeField, listField, totalField } = Object.assign({}, FETCH_SETTING, fetchSetting);
      let pageParams = {};
      const paginationInfo = unref(getPaginationInfo);
      if (isBoolean(paginationInfo)) {
        pageParams = {};
      } else {
        const { current: current2 = 1, pageSize: pageSize2 = 20 } = paginationInfo;
        pageParams[pageField] = params && params.page || current2;
        pageParams[sizeField] = pageSize2;
      }
      const { sortInfo = {}, filterInfo } = searchState;
      let payload = merge2(pageParams, useSearchForm ? getFieldsValue() : {}, searchInfo, (_a2 = params == null ? void 0 : params.searchInfo) != null ? _a2 : {}, defSort, sortInfo, filterInfo, (_b = params == null ? void 0 : params.sortInfo) != null ? _b : {}, (_c = params == null ? void 0 : params.filterInfo) != null ? _c : {}, getTabData());
      if (beforeFetch && isFunction$1(beforeFetch)) {
        payload = await beforeFetch(payload) || payload;
      }
      const res = await api2(payload);
      rawDataSourceRef.value = res;
      const isArrayResult = Array.isArray(res);
      let resultData = isArrayResult ? res : get(res, listField);
      const resultTotal = isArrayResult ? 0 : get(res, totalField);
      if (resultTotal) {
        const currentTotalPage = Math.ceil(resultTotal / payload.pageSize);
        if (payload.current > currentTotalPage) {
          setPagination({
            current: currentTotalPage
          });
          return await fetch(params);
        }
      }
      if (afterFetch && isFunction$1(afterFetch)) {
        resultData = await afterFetch(resultData) || resultData;
      }
      initRowChecked(resultData);
      dataSourceRef.value = resultData;
      setPagination({
        total: resultTotal || 0
      });
      if (params && params.page) {
        setPagination({
          current: params.page || 1
        });
      }
      emit("fetch-success", {
        data: unref(resultData),
        total: resultTotal,
        result: unref(rawDataSourceRef)
      });
      if (!resultData || resultData.length === 0) {
        if (emptyAfterFetch && isFunction$1(emptyAfterFetch)) {
          setEmptyTextAfterFetch(emptyAfterFetch());
        } else {
          setEmptyTextAfterFetch();
        }
        emit("set-empty-after-fetch");
      }
      return resultData;
    } catch (error) {
      if (emptyAfterFetch && isFunction$1(emptyAfterFetch)) {
        setEmptyTextAfterFetch(emptyAfterFetch());
      } else {
        setEmptyTextAfterFetch();
      }
      emit("set-empty-after-fetch");
      emit("fetch-error", error);
      dataSourceRef.value = [];
      setPagination({
        total: 0
      });
    } finally {
      setLoading(false);
    }
  }
  async function reload(opt) {
    return await fetch(opt);
  }
  onMounted(() => {
    setTimeout(() => {
      unref(propsRef).immediate && fetch();
    }, 16);
  });
  function updateTableData(index2, key2, value) {
    const record = dataSourceRef.value[index2];
    if (record) {
      dataSourceRef.value[index2][key2] = value;
    }
    return dataSourceRef.value[index2];
  }
  function updateTableDataRecord(rowKey2, record) {
    const foundRow = findTableDataRecord(rowKey2);
    if (foundRow) {
      for (const field in foundRow) {
        if (Reflect.has(record, field)) {
          foundRow[field] = record[field];
        }
      }
      return foundRow;
    }
  }
  function deleteTableDataRecord(rowKey2) {
    const dataSource = unref(dataSourceRef);
    if (!dataSource || dataSource.length === 0) {
      return;
    }
    const keyName = unref(getRowKeyRef);
    if (!rowKey2 || !keyName) {
      return;
    }
    const getKey2 = (record) => isFunction$1(keyName) ? keyName(record) : record[keyName];
    const rowKeys = !isArray$1(rowKey2) ? [rowKey2] : rowKey2;
    const { childrenColumnName = "children" } = unref(propsRef);
    for (const key2 of rowKeys) {
      doDelete(dataSource, key2);
    }
    function doDelete(items, key2) {
      for (let i2 = 0; i2 < items.length; i2++) {
        const item = items[i2];
        if (getKey2(item) === key2) {
          items.splice(i2, 1);
          break;
        } else {
          const children = item[childrenColumnName];
          if (children && children.length) {
            doDelete(children, key2);
          }
        }
      }
    }
  }
  function insertTableDataRecord(record, index2) {
    const len = unref(dataSourceRef).length;
    const insertPos = Math.min(Math.max(0, index2 || len), len);
    unref(dataSourceRef).splice(insertPos, 0, record);
    return record;
  }
  function findTableDataRecord(rowKey2) {
    const dataSource = unref(dataSourceRef);
    if (!dataSource || dataSource.length === 0) {
      return;
    }
    const { childrenColumnName } = unref(propsRef);
    const keyName = unref(getRowKeyRef);
    if (!rowKey2 || !keyName) {
      return;
    }
    const getKey2 = (record) => isFunction$1(keyName) ? keyName(record) : record[keyName];
    function traversal(items) {
      for (const item of items) {
        if (getKey2(item) === rowKey2) {
          return item;
        }
        const children = item[childrenColumnName || "children"];
        if (children && children.length) {
          items.push(...children);
        }
      }
    }
    return traversal(dataSource);
  }
  function setTableData(values) {
    dataSourceRef.value = values;
  }
  function getDataSource() {
    return unref(dataSourceRef);
  }
  function getRawDataSource() {
    return unref(rawDataSourceRef);
  }
  return {
    dataSourceRef,
    getDataSourceRef,
    handleTableChange,
    updateTableData,
    updateTableDataRecord,
    deleteTableDataRecord,
    insertTableDataRecord,
    setTableData,
    getDataSource,
    getRawDataSource,
    getRowKeyRef,
    getAutoCreateKeyRef,
    fetch,
    reload,
    findTableDataRecord,
    setSearchStateSortInfo,
    handleColumnSort
  };
}
function useLoading(props2) {
  const innerLoading = ref();
  watchEffect(() => {
    innerLoading.value = unref(props2).loading;
  });
  const getLoading = computed(() => {
    return props2.value.enableLoading ? unref(innerLoading) : false;
  });
  function setLoading(loading) {
    innerLoading.value = loading;
  }
  return {
    getLoading,
    setLoading
  };
}
function useRowSelection(propsRef, tableData, emit) {
  const selectedRowKeysRef = ref([]);
  const selectedRowsRef = ref([]);
  const getRowKeyRef = computed(() => {
    const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
    return rowKey2 || autoCreateKey && ROW_KEY || "";
  });
  function getRowKey(record) {
    const rowKey2 = unref(getRowKeyRef);
    return isFunction$1(rowKey2) ? rowKey2(record) : record[rowKey2];
  }
  function checkSelectedStatus(record) {
    return selectedRowKeysRef.value.includes(getRowKey(record));
  }
  const updateTableDataCheckedStatus = (newKeys, oldKeys) => {
    const dataMap = tableData.value.reduce((res, cur) => {
      res[getRowKey(cur)] = cur;
      return res;
    }, {});
    const delKeys = oldKeys.filter((key2) => !newKeys.includes(key2));
    newKeys.forEach((key2) => {
      dataMap[key2] && (dataMap[key2].checked = true);
    });
    delKeys.forEach((key2) => {
      dataMap[key2] && (dataMap[key2].checked = false);
    });
  };
  watch(() => {
    var _a2;
    return (_a2 = unref(propsRef).rowSelection) == null ? void 0 : _a2.selectedRowKeys;
  }, (v2) => {
    isArray$1(v2) && setSelectedRowKeys(v2);
  }, {
    immediate: true
  });
  watch(selectedRowKeysRef, (newKeys, oldKeys) => {
    nextTick(() => {
      const { rowSelection } = unref(propsRef);
      if (rowSelection) {
        const { onChange: onChange3 } = rowSelection;
        if (onChange3 && isFunction$1(onChange3)) {
          onChange3(getSelectRowKeys(), getSelectRows());
        }
      }
      updateTableDataCheckedStatus(newKeys, oldKeys);
      emit("selection-change", {
        keys: getSelectRowKeys(),
        rows: getSelectRows()
      });
    });
  }, { deep: true });
  const getRowSelectionRef = computed(() => {
    const { rowSelection } = unref(propsRef);
    if (!rowSelection) {
      return null;
    }
    return __spreadProps(__spreadValues({}, rowSelection), {
      selectedRowKeys: unref(selectedRowKeysRef),
      onChange: (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
      }
    });
  });
  function setSelectedRowKeys(rowKeys) {
    selectedRowKeysRef.value = rowKeys;
    const { childrenColumnName } = unref(propsRef);
    const rowKey2 = unref(getRowKeyRef);
    const getRowKey2 = (record) => isFunction$1(rowKey2) ? rowKey2(record) : record[rowKey2];
    const allRows = toRaw(unref(tableData)).concat(toRaw(unref(selectedRowsRef)));
    const allSelectedRows = [];
    for (const row of allRows) {
      if (rowKeys.includes(getRowKey2(row))) {
        allSelectedRows.push(row);
        const children = row[childrenColumnName || "children"];
        if (children && children.length) {
          allRows.push(...children);
        }
      }
    }
    const trueSelectedRows = [];
    rowKeys.forEach((key2) => {
      const found = allSelectedRows.find((item) => getRowKey2(item) === key2);
      found && trueSelectedRows.push(found);
    });
    selectedRowsRef.value = trueSelectedRows;
  }
  function getSelectRows() {
    return unref(selectedRowsRef);
  }
  function getSelectRowKeys() {
    return unref(selectedRowKeysRef);
  }
  function clearSelectedRowKeys() {
    selectedRowKeysRef.value = [];
    selectedRowsRef.value = [];
  }
  function deleteSelectRowByKey(key2) {
    const index2 = unref(selectedRowKeysRef).findIndex((item) => item === key2);
    if (index2 > -1) {
      unref(selectedRowKeysRef).splice(index2, 1);
    }
  }
  function getRowSelection() {
    return unref(getRowSelectionRef);
  }
  return {
    selectedRowKeysRef,
    getRowSelectionRef,
    setSelectedRowKeys,
    getSelectRows,
    getSelectRowKeys,
    clearSelectedRowKeys,
    deleteSelectRowByKey,
    getRowSelection,
    checkSelectedStatus
  };
}
function getKey(record, rowKey2, autoCreateKey) {
  if (!rowKey2 || autoCreateKey) {
    return record[ROW_KEY];
  }
  if (isString$1(rowKey2)) {
    return record[rowKey2];
  }
  if (isFunction$1(rowKey2)) {
    return record[rowKey2(record)];
  }
  return null;
}
function useCustomRow(propsRef, {
  setSelectedRowKeys,
  getSelectRowKeys,
  getAutoCreateKeyRef,
  clearSelectedRowKeys,
  emit
}) {
  const customRow = {
    onClick: ({ event: e2, rowData: record, rowIndex: index2 }) => {
      e2 == null ? void 0 : e2.stopPropagation();
      function handleClick() {
        var _a2, _b;
        const { rowSelection, rowKey: rowKey2, clickToRowSelect } = unref(propsRef);
        if (!rowSelection || !clickToRowSelect) {
          return;
        }
        const keys2 = (_a2 = getSelectRowKeys()) == null ? void 0 : _a2.slice(0);
        const key2 = getKey(record, rowKey2, unref(getAutoCreateKeyRef));
        if (!key2) {
          return;
        }
        const isCheckbox = rowSelection.type !== "checkbox";
        if (isCheckbox) {
          const tr = (_b = e2.composedPath) == null ? void 0 : _b.call(e2).find((dom) => dom.role === "row");
          if (!tr) {
            return;
          }
          const checkBox = tr.querySelector("input[type=checkbox]");
          if (!checkBox || checkBox.hasAttribute("disabled")) {
            return;
          }
          if (!keys2.includes(key2)) {
            setSelectedRowKeys([...keys2, key2]);
            return;
          }
          const keyIndex = keys2.findIndex((item) => item === key2);
          keys2.splice(keyIndex, 1);
          setSelectedRowKeys(keys2);
          return;
        }
        const isRadio = rowSelection.type === "radio";
        if (isRadio) {
          if (!keys2.includes(key2)) {
            if (keys2.length) {
              clearSelectedRowKeys();
            }
            setSelectedRowKeys([key2]);
            return;
          }
          clearSelectedRowKeys();
        }
      }
      handleClick();
      emit("row-click", record, index2, e2);
    },
    onDblclick: ({ event, rowData: record, rowIndex: index2 }) => {
      emit("row-dbClick", record, index2, event);
    },
    onContextmenu: ({ event, rowData: record, rowIndex: index2 }) => {
      emit("row-contextmenu", record, index2, event);
    },
    onMouseenter: ({ event, rowData: record, rowIndex: index2 }) => {
      emit("row-mouseenter", record, index2, event);
    },
    onMouseleave: ({ event, rowData: record, rowIndex: index2 }) => {
      emit("row-mouseleave", record, index2, event);
    }
  };
  return {
    rowEventHandlers: customRow
  };
}
function useTableStyle(propsRef, prefixCls2) {
  const { striped, rowClassName } = unref(propsRef);
  function getRowClassName(record, index2) {
    const classNames2 = [];
    if (striped && index2 % 2 === 1) {
      classNames2.push(`${prefixCls2}-row-striped`);
    }
    if (rowClassName && isFunction$1(rowClassName)) {
      classNames2.push(rowClassName(record, index2));
    }
    return classNames2.filter(Boolean).join(" ");
  }
  return {
    getRowClassName
  };
}
function useTableExpand(propsRef, tableData, emit) {
  const expandedRowKeysRef = ref([]);
  const getRowKeyRef = computed(() => {
    const { autoCreateKey, rowKey: rowKey2 } = unref(propsRef);
    return rowKey2 || autoCreateKey && ROW_KEY || "";
  });
  const getExpandedBindsRef = computed(() => {
    const { isTreeTable, expandColumnKey: expandColumnKey2 } = unref(propsRef);
    if (!isTreeTable) {
      return {};
    }
    return {
      expandColumnKey: expandColumnKey2,
      expandedRowKeys: unref(expandedRowKeysRef),
      onExpandedRowsChange: (expandedRows) => {
        expandedRowKeysRef.value = expandedRows;
        emit("expanded-rows-change", expandedRows);
      }
    };
  });
  function getAllKeys2(data6) {
    const result = [];
    const { childrenColumnName } = unref(propsRef);
    const rowKey2 = unref(getRowKeyRef);
    const getRowKey = (record) => isFunction$1(rowKey2) ? rowKey2(record) : record[rowKey2];
    toRaw(data6 || unref(tableData)).forEach((item) => {
      result.push(getRowKey(item));
      const children = item[childrenColumnName || "children"];
      if (children && (children == null ? void 0 : children.length)) {
        result.push(...getAllKeys2(children));
      }
    });
    return result;
  }
  function getExpandedKeys() {
    return unref(expandedRowKeysRef);
  }
  function expandRows(keys2) {
    expandedRowKeysRef.value = [...unref(expandedRowKeysRef), ...keys2];
  }
  function expandAll() {
    expandedRowKeysRef.value = getAllKeys2();
  }
  function collapseAll() {
    expandedRowKeysRef.value = [];
  }
  return {
    getRowKeyRef,
    getExpandedBindsRef,
    expandRows,
    expandAll,
    collapseAll,
    getExpandedKeys
  };
}
const key = Symbol("fbu-table");
function createTableContext(instance2) {
  provide(key, instance2);
}
function useTableContext() {
  return inject(key);
}
function useTableForm(propsRef, slots, fetch, getLoading) {
  const getFormProps = computed(() => {
    const { formConfig, cacheName } = unref(propsRef);
    const { submitButtonOptions } = formConfig || {};
    return __spreadProps(__spreadValues({}, formConfig), {
      submitButtonOptions: __spreadProps(__spreadValues({}, submitButtonOptions), { loading: unref(getLoading) }),
      cacheName
    });
  });
  const getFormSlotKeys = computed(() => {
    const keys2 = Object.keys(slots);
    return keys2.filter((item) => item.startsWith("form-"));
  });
  function replaceFormSlotKey(key2) {
    var _a2, _b;
    return (_b = (_a2 = key2 == null ? void 0 : key2.replace) == null ? void 0 : _a2.call(key2, /form-/, "")) != null ? _b : "";
  }
  function handleSearchInfoChange(info) {
    const { handleSearchInfoFn } = unref(propsRef);
    if (handleSearchInfoFn && isFunction$1(handleSearchInfoFn)) {
      info = handleSearchInfoFn(info) || info;
    }
    fetch({ searchInfo: info, page: 1 });
  }
  function handleUpdateSchemes(newSchemes) {
    const { handleSchemeChangeFn, fetchOnSchemeChanged } = unref(propsRef);
    if (!fetchOnSchemeChanged) {
      return;
    }
    if (handleSchemeChangeFn && isFunction$1(handleSchemeChangeFn)) {
      handleSchemeChangeFn(newSchemes);
    }
    setTimeout(() => {
      fetch({ page: 1 });
    }, 10);
  }
  return {
    getFormProps,
    replaceFormSlotKey,
    getFormSlotKeys,
    handleSearchInfoChange,
    handleUpdateSchemes
  };
}
const useProps = {
  clickToRowSelect: x().def(false),
  isTreeTable: Boolean,
  tableSetting: A().def({}),
  showTableSetting: x().def(false),
  inset: x().def(true),
  sortFn: P().def(() => DEFAULT_SORT_FN),
  filterFn: P().def(() => DEFAULT_FILTER_FN),
  autoCreateKey: x().def(true),
  striped: x().def(true),
  indentSize: N().def(20),
  api: P(),
  beforeFetch: P(),
  afterFetch: P(),
  handleSearchInfoFn: P(),
  fetchSetting: A().def(() => FETCH_SETTING),
  immediate: x().def(true),
  emptyDataIsShowTable: x().def(true),
  searchInfo: A(),
  defSort: A(),
  useSearchForm: x(),
  formConfig: A(),
  columns: q().def([]),
  showIndexColumn: x().def(true),
  indexColumnProps: A(),
  actionColumn: A(),
  ellipsis: x().def(true),
  canResize: x().def(false),
  isCanResizeParent: x().def(false),
  clearSelectOnPageChange: x().def(true),
  resizeHeightOffset: N().def(0),
  rowSelection: L([]).def(() => ({ type: "checkbox" })),
  title: L([]),
  titleHelpMessage: L([E(), q()]),
  maxHeight: N(),
  dataSource: A(),
  rowKey: L([String, P()]),
  bordered: x().def(false),
  pagination: L([Boolean, A()]),
  loading: x().def(false),
  rowClassName: P(),
  scroll: A(),
  size: E().def(DEFAULT_SIZE),
  cacheName: E(),
  cacheEnable: x().def(true),
  titleActions: q(),
  showSettingColumn: x().def(true),
  fixTitleEmpty: x().def(false),
  topTabs: q(),
  topTabsActivedKey: L([String, Number]).def(""),
  topTabsFetchParamkey: E(),
  sticky: L([
    Boolean,
    A()
  ]).def(false),
  stickyTitle: x().def(false),
  showScrollBtns: x().def(false),
  resizeFlow: x().def(true),
  customPagination: x().def(false),
  customPaginationSizeChangerSuffix: E().def("\u6761/\u9875"),
  settingColumnProps: A().def({}),
  draggableScroll: x().def(false),
  draggableScrollDelay: N().def(1500),
  horizontalScrollUsingWheel: x().def(false),
  customMaxPageSize: N().def(1500),
  emptyText: E(),
  t: P(),
  enableLoading: x().def(false),
  fetchOnSchemeChanged: x().def(true),
  handleSchemeChangeFn: P(),
  cache: N().def(2),
  estimatedRowHeight: N(),
  hScrollbarSize: N().def(10),
  vScrollbarSize: N().def(10),
  scrollbarAlwaysOn: x().def(true),
  height: N().def(800),
  headerHeight: N().def(36),
  rowHeight: N().def(32),
  emptyAfterFetch: P(),
  emptyInFetching: P(),
  fixedHeight: x().def(false)
};
const _hoisted_1$5 = { class: "custom-pagination-wrapper" };
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  props: {
    afterSuffix: {
      type: String,
      default: ""
    },
    max: {
      type: Number,
      default: 1500
    }
  },
  setup(__props) {
    const { getPaginationInfo, getBindValues, clearSelectedRowKeys, setPagination, reload } = useTableContext();
    const pageSizeRef = ref(20);
    const getTotal = computed(() => {
      const paginationInfo = unref(getPaginationInfo.value);
      return typeof paginationInfo === "object" ? paginationInfo.total : 0;
    });
    watch(getPaginationInfo, (pagination) => {
      if (typeof pagination == "object") {
        pageSizeRef.value = pagination.pageSize;
      }
    }, { immediate: true });
    function handlePaginationChange(current2, pageSize2) {
      if (getBindValues.value.clearSelectOnPageChange) {
        clearSelectedRowKeys();
      }
      setPagination({ current: current2, pageSize: pageSize2 });
      pageSizeRef.value = pageSize2;
      reload({ page: current2 });
    }
    function handlePageSizeChange() {
      if (getBindValues.value.clearSelectOnPageChange) {
        clearSelectedRowKeys();
      }
      pageSizeRef.value = pageSizeRef.value ? pageSizeRef.value : 20;
      const paginationInfo = unref(getPaginationInfo.value);
      if (typeof paginationInfo === "object") {
        if (paginationInfo.pageSize !== pageSizeRef.value) {
          let current2 = paginationInfo.current;
          const newCurrent = Math.floor((paginationInfo.total - 1) / pageSizeRef.value) + 1;
          current2 = current2 > newCurrent ? newCurrent : current2;
          setPagination({
            pageSize: pageSizeRef.value,
            current: current2
          });
          reload({
            page: current2
          });
        }
      }
    }
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$5, [
        createVNode(unref(Pagination$1), mergeProps(unref(getPaginationInfo), { onChange: handlePaginationChange }), null, 16),
        createVNode(unref(InputNumber$1), {
          value: pageSizeRef.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event) => pageSizeRef.value = $event),
          controls: false,
          max: __props.max,
          min: 1,
          "addon-after": __props.afterSuffix,
          bordered: false,
          onPressEnter: handlePageSizeChange,
          onBlur: handlePageSizeChange
        }, null, 8, ["value", "max", "addon-after"])
      ], 512)), [
        [vShow, unref(getTotal)]
      ]);
    };
  }
});
const clearFns = [];
const registerClearFn = (clearFn) => {
  clearFns.push(clearFn);
};
const clearOtherSorterState = (selfClear) => {
  clearFns.forEach((clear) => {
    if (clear !== selfClear) {
      clear();
    }
  });
};
function _isSlot(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
var SortDirection;
(function(SortDirection2) {
  SortDirection2["ASC"] = "asc";
  SortDirection2["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));
var ThCustomSorter = defineComponent({
  name: "ThCustomSorter",
  props: {
    title: String,
    dropdownProps: Object,
    customSorterList: {
      type: Array
    },
    customSorterFetchKey: {
      type: String,
      default: "sorter"
    },
    customSorterRender: {
      type: Function
    }
  },
  setup(props2) {
    const {
      reload,
      emit,
      setSearchStateSortInfo
    } = useTableContext();
    const dropMenuList = ref(cloneDeep(props2.customSorterList));
    const computedSortOrder = computed(() => {
      var _a2;
      return (_a2 = dropMenuList.value.filter((item) => !!item.sortOrder)[0]) == null ? void 0 : _a2.sortOrder;
    });
    const prefixCls2 = usePrefixCls("table-column");
    const innerSelectedKeysRef = ref([]);
    const clearSortOrder = () => {
      dropMenuList.value.forEach((item) => {
        item.sortOrder = void 0;
      });
    };
    registerClearFn(clearSortOrder);
    const onClickMenu = debounce((event) => {
      innerSelectedKeysRef.value = [event.sortBy];
      let sortOrder = event.sortOrder;
      if (sortOrder) {
        sortOrder = sortOrder === "asc" ? "desc" : void 0;
      } else {
        sortOrder = "asc";
      }
      clearSortOrder();
      clearOtherSorterState(clearSortOrder);
      event.sortOrder = sortOrder;
      if (event.onClick) {
        event.onClick(event);
        return;
      }
      if (props2.customSorterFetchKey && sortOrder) {
        const sortInfo = {
          sortName: event.sortBy,
          sort: event.sortOrder
        };
        setSearchStateSortInfo(sortInfo);
        reload({
          searchInfo: sortInfo
        });
      } else {
        setSearchStateSortInfo({});
        reload();
      }
      emit && emit("sort-change", event);
    }, 100, false);
    const visible = ref(false);
    function RenderSorter(props3) {
      const upNode = createVNode(CaretUpOutlined$1, {
        "class": [`${prefixCls2}-sorter-up`, {
          active: props3.sortOrder === SortDirection.ASC
        }]
      }, null);
      const downNode = createVNode(CaretDownOutlined$1, {
        "class": [`${prefixCls2}-sorter-down`, {
          active: props3.sortOrder === SortDirection.DESC
        }]
      }, null);
      return createVNode("span", {
        "class": [`${prefixCls2}-sorter`, `${prefixCls2}-sorter-full`]
      }, [createVNode("span", {
        "class": `${prefixCls2}-sorter-inner`
      }, [upNode, downNode])]);
    }
    return () => {
      let _slot;
      const renderMenuList = createVNode(Menu, null, _isSlot(_slot = dropMenuList.value.map((item) => {
        return createVNode(Menu.Item, {
          "key": item.sortBy,
          "onClick": () => onClickMenu(item)
        }, {
          default: () => [createVNode("div", {
            "class": "sorter-menu-title"
          }, [createVNode(RenderSorter, {
            "sortOrder": item.sortOrder
          }, null), createVNode("span", null, [item.label])])]
        });
      })) ? _slot : {
        default: () => [_slot]
      });
      const renderTitleSorter = dropMenuList.value.length > 1 ? createVNode("div", {
        "class": `${prefixCls2}-sorters`
      }, [props2.customSorterRender ? props2.customSorterRender(props2.title) : createVNode("span", {
        "class": `${prefixCls2}-title`
      }, [props2.title]), createVNode(Dropdown$2, mergeProps(props2.dropdownProps, {
        "visible": visible.value,
        "onUpdate:visible": ($event) => visible.value = $event,
        "trigger": ["click"]
      }), {
        overlay: () => {
          return renderMenuList;
        },
        default: () => createVNode(RenderSorter, {
          "sortOrder": computedSortOrder.value
        }, null)
      })]) : createVNode("div", {
        "class": `${prefixCls2}-sorters`
      }, [props2.customSorterRender ? props2.customSorterRender(props2.title) : createVNode("span", {
        "class": `${prefixCls2}-title`
      }, [props2.title]), createVNode("span", {
        "onClick": () => onClickMenu(dropMenuList.value[0])
      }, [createVNode(RenderSorter, {
        "sortOrder": computedSortOrder.value
      }, null)])]);
      return renderTitleSorter;
    };
  }
});
function useEmpty(propsRef) {
  const EMPTY_TEXT_BEFORE_FETCH = "\u8BF7\u641C\u7D22";
  const EMPTY_TEXT_AFTER_FETCH = "\u6682\u65E0\u641C\u7D22\u7ED3\u679C\uFF0C\u8BF7\u8C03\u6574\u641C\u7D22\u6761\u4EF6";
  const EMPTY_TEXT_IN_LOADING = "\u641C\u7D22\u4E2D...";
  const { t: t2 } = propsRef.value;
  const emptyTextRef = ref("");
  const setEmptyText = (text) => {
    emptyTextRef.value = text;
  };
  const setEmptyTextAfterFetch = (text) => {
    emptyTextRef.value = text || t2 && t2(EMPTY_TEXT_AFTER_FETCH) || EMPTY_TEXT_AFTER_FETCH;
  };
  const setEmptyInFetching = (text) => {
    emptyTextRef.value = text || t2 && t2(EMPTY_TEXT_IN_LOADING) || EMPTY_TEXT_IN_LOADING;
  };
  watch(() => unref(propsRef).emptyText, (text) => {
    emptyTextRef.value = text || t2 && t2(EMPTY_TEXT_BEFORE_FETCH) || EMPTY_TEXT_BEFORE_FETCH;
  }, { immediate: true });
  return {
    emptyTextRef,
    setEmptyText,
    setEmptyTextAfterFetch,
    setEmptyInFetching
  };
}
var TableTitle_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$5 = defineComponent({
  name: "HeaderTitle",
  inheritAttrs: false,
  props: {
    title: L([E(), P()]),
    helpMessage: L([E(), q()])
  },
  components: {
    FbuHelpTooltip
  },
  setup(props2) {
    const prefixCls2 = usePrefixCls("table-title");
    const { getSelectRows } = useTableContext();
    const getTitle = computed(() => {
      const { title } = props2;
      return isFunction$1(title) && title({ selectRows: getSelectRows() }) || title;
    });
    return {
      prefixCls: prefixCls2,
      getTitle
    };
  }
});
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FbuHelpTooltip = resolveComponent("FbuHelpTooltip");
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(_ctx.prefixCls)
  }, [
    createElementVNode("span", null, toDisplayString(_ctx.getTitle), 1),
    _ctx.helpMessage ? (openBlock(), createBlock(_component_FbuHelpTooltip, {
      key: 0,
      text: _ctx.helpMessage
    }, null, 8, ["text"])) : createCommentVNode("", true)
  ], 2);
}
var TableTitle = /* @__PURE__ */ _export_sfc$1(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-9a1bb828"]]);
var TableTitleAction_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$4 = defineComponent({
  name: "FbuTableTitleAction",
  inheritAttrs: false,
  components: {
    PopconfirmButton: _sfc_main$P,
    SvgIcon
  },
  props: {
    actions: q().def(() => [])
  },
  setup(props2) {
    function isIfShow(action) {
      const ifShow = action.ifShow;
      let isIfShow2 = true;
      if (isBoolean(ifShow)) {
        isIfShow2 = ifShow;
      }
      if (isFunction$1(ifShow)) {
        isIfShow2 = ifShow(action);
      }
      return isIfShow2;
    }
    const getActions = computed(() => {
      return (props2.actions || []).filter((action) => {
        return isIfShow(action);
      }).map((action) => {
        const { popConfirm } = action;
        return __spreadProps(__spreadValues(__spreadValues({
          type: "primary",
          size: "middle",
          ghost: true
        }, action), popConfirm || {}), {
          onConfirm: popConfirm == null ? void 0 : popConfirm.confirm,
          onCancel: popConfirm == null ? void 0 : popConfirm.cancel,
          onClick: () => {
            var _a2;
            (_a2 = action.onClick) == null ? void 0 : _a2.call(action, action);
          },
          enable: !!popConfirm
        });
      });
    });
    return {
      getActions
    };
  }
});
const _hoisted_1$4 = { class: "title-action-wrap" };
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SvgIcon = resolveComponent("SvgIcon");
  const _component_PopconfirmButton = resolveComponent("PopconfirmButton");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.getActions, (action) => {
      return openBlock(), createBlock(_component_PopconfirmButton, mergeProps({
        key: `${action.label}`,
        class: "action-button mr-10"
      }, action), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "actionIcon", normalizeProps(guardReactiveProps(action)), () => [
            action.icon && !action.loading ? (openBlock(), createBlock(_component_SvgIcon, {
              key: 0,
              class: "action-icon",
              name: action.icon
            }, null, 8, ["name"])) : createCommentVNode("", true)
          ], true),
          action.label ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(action.label), 1)
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 2
      }, 1040);
    }), 128))
  ]);
}
var TableTitleAction = /* @__PURE__ */ _export_sfc$1(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-505fe846"]]);
var TableHeader_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3 = defineComponent({
  name: "TableHeader",
  components: {
    Divider: Divider$1,
    TableTitle,
    TableTitleAction
  },
  props: {
    title: L([E(), P()]),
    tableSetting: A(),
    showSettingColumn: Boolean,
    titleHelpMessage: L([E(), q()]),
    titleActions: q()
  },
  emits: ["columns-change"],
  setup(_2, { emit }) {
    const prefixCls2 = usePrefixCls("table-header");
    const { getBindValues } = useTableContext();
    function handleColumnChange(data6) {
      emit("columns-change", data6);
    }
    return {
      prefixCls: prefixCls2,
      handleColumnChange,
      getBindValues
    };
  }
});
const _hoisted_1$3 = {
  key: 0,
  style: { "margin": "5px" }
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableTitleAction = resolveComponent("TableTitleAction");
  const _component_TableTitle = resolveComponent("TableTitle");
  const _component_Divider = resolveComponent("Divider");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([`${_ctx.prefixCls}-wrap`]),
    style: { "width": "100%", "min-height": "36px", "padding-block-end": "8px" }
  }, [
    _ctx.$slots.headerTop ? (openBlock(), createElementBlock("div", _hoisted_1$3, [
      renderSlot(_ctx.$slots, "headerTop")
    ])) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass([`${_ctx.prefixCls}`, !_ctx.getBindValues.sticky && _ctx.getBindValues.pagination && `not-sticky`])
    }, [
      _ctx.titleActions ? (openBlock(), createBlock(_component_TableTitleAction, {
        key: 0,
        actions: _ctx.titleActions
      }, null, 8, ["actions"])) : createCommentVNode("", true),
      _ctx.$slots.tableTitle ? renderSlot(_ctx.$slots, "tableTitle", { key: 1 }) : createCommentVNode("", true),
      !_ctx.$slots.tableTitle && _ctx.title ? (openBlock(), createBlock(_component_TableTitle, {
        key: 2,
        helpMessage: _ctx.titleHelpMessage,
        title: _ctx.title
      }, null, 8, ["helpMessage", "title"])) : createCommentVNode("", true),
      createElementVNode("div", {
        class: normalizeClass(`${_ctx.prefixCls}__toolbar`)
      }, [
        renderSlot(_ctx.$slots, "toolbar"),
        _ctx.$slots.toolbar && _ctx.showSettingColumn ? (openBlock(), createBlock(_component_Divider, {
          key: 0,
          type: "vertical"
        })) : createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2);
}
var TableHeader = /* @__PURE__ */ _export_sfc$1(_sfc_main$3, [["render", _sfc_render$3]]);
function useTableHeader(propsRef, slots, handlers) {
  const getHeaderProps = computed(() => {
    const { title, titleHelpMessage, showSettingColumn, tableSetting, titleActions } = unref(propsRef);
    const hideTitle = !slots.tableTitle && !title && !slots.toolbar && !showSettingColumn && !titleActions;
    return {
      hideTitle,
      title,
      titleHelpMessage,
      showSettingColumn,
      tableSetting,
      titleActions,
      onColumnsChange: handlers.onColumnsChange,
      slots: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, slots.toolbar ? {
        toolbar: () => {
          var _a2;
          return (_a2 = slots.toolbar) == null ? void 0 : _a2.call(slots);
        }
      } : {}), slots.tableTitle ? {
        tableTitle: () => {
          var _a2;
          return (_a2 = slots.tableTitle) == null ? void 0 : _a2.call(slots);
        }
      } : {}), slots.headerTop ? {
        headerTop: () => {
          var _a2;
          return (_a2 = slots.headerTop) == null ? void 0 : _a2.call(slots);
        }
      } : {}), slots.headerTabs ? {
        headerTabs: () => {
          var _a2;
          return (_a2 = slots.headerTabs) == null ? void 0 : _a2.call(slots);
        }
      } : {})
    };
  });
  return { getHeaderProps };
}
function useWindowSize(options = {}) {
  const {
    initialWidth = Number.POSITIVE_INFINITY,
    initialHeight = Number.POSITIVE_INFINITY,
    fixedHeight = false
  } = options;
  const width = ref(initialWidth);
  const height = ref(initialHeight);
  const update = () => {
    if (window) {
      width.value = window.innerWidth;
      height.value = window.innerHeight;
    }
  };
  if (!fixedHeight) {
    update();
    onMounted(update);
    window.addEventListener("resize", update, { passive: true });
  }
  return { width, height };
}
function useTableTabs(props2, fetch, emit) {
  const activedKey = ref();
  const tabs = ref();
  const fetchOnChanged = ref(true);
  const tabsElHeight = ref(45);
  const setTabsElHeight = (height) => {
    tabsElHeight.value = height;
  };
  watch(() => props2.value.topTabs, () => {
    const { topTabsActivedKey, topTabs } = unref(props2);
    activedKey.value = topTabsActivedKey || topTabs && topTabs[0].key;
    tabs.value = topTabs;
  }, {
    immediate: true
  });
  watch(() => props2.value.topTabsActivedKey, (key2) => {
    activedKey.value = key2;
  });
  watch(activedKey, (newKey, oldKey) => {
    if (!fetchOnChanged.value) {
      return;
    }
    const { topTabsFetchParamkey } = unref(props2);
    if (topTabsFetchParamkey) {
      if (newKey !== void 0 && oldKey === void 0) {
        unref(props2).searchInfo = __spreadProps(__spreadValues({}, unref(props2).searchInfo || {}), {
          [topTabsFetchParamkey]: newKey === -1 ? void 0 : newKey
        });
      } else {
        fetch({ searchInfo: { [topTabsFetchParamkey]: newKey === -1 ? void 0 : newKey } });
      }
    }
  }, { immediate: true });
  function handleTabClick(activeKey) {
    emit("tab-click", activeKey);
  }
  function getTabData() {
    const { topTabsFetchParamkey } = unref(props2);
    const tabKey = unref(activedKey);
    return topTabsFetchParamkey ? { [topTabsFetchParamkey]: tabKey === -1 ? void 0 : tabKey } : {};
  }
  function resetActivedKey() {
    activedKey.value = props2.value.topTabs && props2.value.topTabs[0].key;
    fetchOnChanged.value = false;
    nextTick(() => {
      fetchOnChanged.value = true;
    });
  }
  return {
    tabs,
    activedKey,
    handleTabClick,
    getTabData,
    resetActivedKey,
    setTabsElHeight,
    tabsElHeight
  };
}
var TableTabs_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2 = defineComponent({
  name: "TableTabs",
  components: {
    Tabs,
    TabPane: Tabs.TabPane
  },
  inheritAttrs: false,
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["update:value", "tab-click", "tab-height-change"],
  setup(props2, { emit }) {
    const tabElRef = ref();
    const innerActivedKey = computed({
      get: () => props2.value,
      set: (key2) => {
        emit("update:value", key2);
      }
    });
    const handleTabClick = (activeKey) => {
      emit("tab-click", activeKey);
    };
    onMounted(() => {
      if (tabElRef.value) {
        emit("tab-height-change", tabElRef.value.clientHeight);
      }
    });
    return {
      innerActivedKey,
      handleTabClick,
      tabElRef
    };
  }
});
const _hoisted_1$2 = {
  key: 0,
  ref: "tabElRef",
  class: "table-tabs-wrapper"
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TabPane = resolveComponent("TabPane");
  const _component_Tabs = resolveComponent("Tabs");
  return _ctx.tabs && _ctx.tabs.length ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
    createVNode(_component_Tabs, {
      activeKey: _ctx.innerActivedKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event) => _ctx.innerActivedKey = $event),
      size: "small",
      onTabClick: _ctx.handleTabClick
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tabs, (tab) => {
          return openBlock(), createBlock(_component_TabPane, {
            key: tab.key,
            tab: tab.label
          }, null, 8, ["tab"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey", "onTabClick"])
  ], 512)) : createCommentVNode("", true);
}
var TableTabs = /* @__PURE__ */ _export_sfc$1(_sfc_main$2, [["render", _sfc_render$2]]);
var TableScrollBtns_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$1 = defineComponent({
  name: "TableScrollBtns",
  components: {
    LeftOutlined: LeftOutlined$1,
    RightOutlined: RightOutlined$1
  },
  props: {
    scrollX: {
      type: [String, Number, Boolean]
    }
  },
  setup(_2, { expose }) {
    const { wrapRef, getBindValues, scrollToLeft } = useTableContext();
    const isVisible2 = ref(false);
    const leftIsDisabled = ref(true);
    const rightIsDisabled = ref(false);
    const PX_IN_PER_SCROLL = 100;
    let longPressTimer;
    let raf3;
    const lastScrollLeft = ref(0);
    const maxScrollLeft = ref(0);
    expose({
      updateScrollLeft: (scrollLeft) => {
        lastScrollLeft.value = scrollLeft;
        checkScrollBtnIsDisabled();
      }
    });
    const updateMaxScrollLeft = () => {
      var _a2;
      const elTableV2Main = (_a2 = wrapRef.value) == null ? void 0 : _a2.querySelector(".el-table-v2__main .el-table-v2__body>div");
      maxScrollLeft.value = elTableV2Main.scrollWidth - elTableV2Main.clientWidth;
    };
    const getScrollContainer = () => {
      var _a2;
      const scrollBar = (_a2 = wrapRef.value) == null ? void 0 : _a2.querySelector(".el-virtual-scrollbar.el-vl__horizontal");
      const scrollThumb = scrollBar == null ? void 0 : scrollBar.querySelector(".el-scrollbar__thumb");
      return { scrollThumb, scrollBar };
    };
    const checkScrollBarVisible = () => {
      const { scrollThumb } = getScrollContainer();
      if (!scrollThumb) {
        isVisible2.value = false;
        return;
      }
      isVisible2.value = !!scrollThumb && scrollThumb.style.display !== "none";
    };
    const debouncedHandleResize = debounce(() => {
      updateMaxScrollLeft();
      checkScrollBarVisible();
      checkScrollBtnIsDisabled();
    }, 100, false);
    const resizeObserver = new ResizeObserver(() => {
      debouncedHandleResize();
    });
    onMounted(() => {
      wrapRef.value && resizeObserver.observe(wrapRef.value);
      window.addEventListener("mouseup", handleMouseup);
      nextTick(checkScrollBarVisible);
      nextTick(checkScrollBtnIsDisabled);
    });
    onBeforeUnmount(() => {
      wrapRef.value && resizeObserver.unobserve(wrapRef.value);
      resizeObserver.disconnect();
    });
    function checkScrollBtnIsDisabled() {
      const { scrollBar } = getScrollContainer();
      if (!scrollBar) {
        return;
      }
      leftIsDisabled.value = lastScrollLeft.value === 0;
      rightIsDisabled.value = lastScrollLeft.value >= maxScrollLeft.value || maxScrollLeft.value - lastScrollLeft.value <= 0;
    }
    function setContainerScrollLeft(scollSize) {
      const scrollLeft = lastScrollLeft.value + scollSize;
      scrollToLeft(Math.max(0, Math.min(scrollLeft, maxScrollLeft.value)));
    }
    function handleBtnClick(direction2) {
      if (direction2 === "left") {
        if (leftIsDisabled.value) {
          return;
        }
        setContainerScrollLeft(-PX_IN_PER_SCROLL);
      } else if (direction2 === "right") {
        if (rightIsDisabled.value) {
          return;
        }
        setContainerScrollLeft(+PX_IN_PER_SCROLL);
      }
    }
    function handleMouseup() {
      clearTimeout(longPressTimer);
      window.cancelAnimationFrame(raf3);
    }
    function handleMousedown(direction2) {
      longPressTimer = window.setTimeout(() => {
        raf3 = window.requestAnimationFrame(function rafCb() {
          setContainerScrollLeft(direction2 === "left" ? -3 : 3);
          raf3 = window.requestAnimationFrame(rafCb);
        });
        suppressClickEvent();
      }, 1e3);
    }
    function suppressClickEvent() {
      document.addEventListener("click", function suppressEvent(e2) {
        document.removeEventListener("click", suppressEvent, true);
        e2.preventDefault();
        e2.stopImmediatePropagation();
        e2.stopPropagation();
      }, true);
    }
    return {
      isVisible: isVisible2,
      leftIsDisabled,
      rightIsDisabled,
      handleBtnClick,
      handleMouseup,
      handleMousedown,
      getBindValues
    };
  }
});
const _hoisted_1$1 = { class: "table-scroll-btns" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftOutlined = resolveComponent("LeftOutlined");
  const _component_RightOutlined = resolveComponent("RightOutlined");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("div", {
      class: normalizeClass(["table-scroll-btn", _ctx.leftIsDisabled && `table-scroll-btn--is-disabled`]),
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.handleBtnClick("left")),
      onMouseup: _cache[1] || (_cache[1] = (...args) => _ctx.handleMouseup && _ctx.handleMouseup(...args)),
      onMousedown: _cache[2] || (_cache[2] = ($event) => _ctx.handleMousedown("left"))
    }, [
      createVNode(_component_LeftOutlined)
    ], 34),
    createElementVNode("div", {
      class: normalizeClass(["table-scroll-btn", _ctx.rightIsDisabled && `table-scroll-btn--is-disabled`]),
      onClick: _cache[3] || (_cache[3] = ($event) => _ctx.handleBtnClick("right")),
      onMouseup: _cache[4] || (_cache[4] = (...args) => _ctx.handleMouseup && _ctx.handleMouseup(...args)),
      onMousedown: _cache[5] || (_cache[5] = ($event) => _ctx.handleMousedown("right"))
    }, [
      createVNode(_component_RightOutlined)
    ], 34)
  ], 512)), [
    [vShow, _ctx.getBindValues.showScrollBtns && _ctx.scrollX !== "100%" && _ctx.isVisible]
  ]);
}
var TableScrollBtns = /* @__PURE__ */ _export_sfc$1(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-4d1c6599"]]);
const _sfc_main = defineComponent({
  name: "FbuVirtualTable",
  components: {
    TableV2,
    FbuForm,
    CustomPagination: _sfc_main$6,
    ThCustomSorter,
    Empty: Empty$2,
    ElAutoResizer,
    Spin,
    TableHeader,
    TableTabs,
    TableScrollBtns
  },
  props: __spreadValues({}, useProps),
  emits: [
    "fetch-success",
    "fetch-error",
    "selection-change",
    "register",
    "row-click",
    "row-dbClick",
    "row-contextmenu",
    "row-mouseenter",
    "row-mouseleave",
    "edit-end",
    "edit-cancel",
    "edit-row-end",
    "edit-change",
    "expanded-rows-change",
    "change",
    "columns-change",
    "resize-column",
    "tab-click",
    "formRest",
    "sort-change",
    "virtual-scroll",
    "set-empty-after-fetch",
    "customer-scroll"
  ],
  setup(props2, { attrs, emit, slots, expose }) {
    const tableElRef = ref(null);
    const tableData = ref([]);
    const wrapRef = ref(null);
    const formRef = ref(null);
    const innerPropsRef = ref();
    const prefixCls2 = usePrefixCls("table");
    const [registerForm, formActions] = useForm();
    const getProps = computed(() => {
      return __spreadValues(__spreadValues({}, props2), unref(innerPropsRef));
    });
    const showTableTitle = computed(() => {
      const { title, showSettingColumn, titleActions } = unref(props2);
      return !slots.tableTitle && !title && !slots.toolbar && !showSettingColumn && !titleActions;
    });
    const { getLoading, setLoading } = useLoading(getProps);
    const { emptyTextRef, setEmptyText, setEmptyTextAfterFetch, setEmptyInFetching } = useEmpty(getProps);
    const {
      getPaginationInfo,
      getPaginationBinds,
      setPaginationConfig,
      setShowPagination,
      getShowPagination
    } = usePagination(getProps);
    const {
      getRowSelection,
      getRowSelectionRef,
      getSelectRows,
      clearSelectedRowKeys,
      getSelectRowKeys,
      deleteSelectRowByKey,
      setSelectedRowKeys,
      checkSelectedStatus
    } = useRowSelection(getProps, tableData, emit);
    const {
      activedKey,
      tabs,
      tabsElHeight,
      setTabsElHeight,
      handleTabClick,
      getTabData,
      resetActivedKey
    } = useTableTabs(getProps, () => {
      return fetch();
    }, emit);
    const handleReset = () => {
      resetActivedKey();
      emit("formRest");
    };
    const {
      handleTableChange: onTableChange,
      getDataSourceRef,
      dataSourceRef,
      getDataSource,
      getRawDataSource,
      setTableData,
      updateTableDataRecord,
      deleteTableDataRecord,
      insertTableDataRecord,
      findTableDataRecord,
      fetch,
      getRowKeyRef,
      reload,
      getAutoCreateKeyRef,
      updateTableData,
      setSearchStateSortInfo
    } = useDataSource(getProps, tableData, {
      getPaginationInfo,
      checkSelectedStatus,
      setLoading,
      setPagination: setPaginationConfig,
      getFieldsValue: formActions.getFieldsValue,
      clearSelectedRowKeys,
      setEmptyTextAfterFetch,
      setEmptyInFetching,
      getTabData
    }, emit);
    function handleTableChange(pagination, filter, sorter, extra) {
      onTableChange(pagination, filter, sorter);
      emit("change", pagination, filter, sorter, extra);
    }
    const {
      getViewColumns,
      getColumns,
      setCacheColumnsByField,
      setColumns,
      getCacheColumns,
      handleResizeColumn,
      getMutationColumns,
      resetColumns
    } = useColumns(getProps, {
      getPaginationRef: getPaginationInfo,
      getRowSelectionRef,
      getDataSourceRef: dataSourceRef,
      emit,
      getSelectRowKeys,
      setSelectedRowKeys
    });
    const { rowEventHandlers } = useCustomRow(getProps, {
      setSelectedRowKeys,
      getSelectRowKeys,
      clearSelectedRowKeys,
      getAutoCreateKeyRef,
      emit
    });
    const { getRowClassName } = useTableStyle(getProps, prefixCls2);
    const { getExpandedBindsRef, expandAll, expandRows, collapseAll } = useTableExpand(getProps, tableData, emit);
    const columnsChangeSubs = [];
    const handlers = {
      onColumnsChange: (data6) => {
        emit("columns-change", data6);
        columnsChangeSubs.forEach((fn) => typeof fn === "function" && fn());
      }
    };
    const { getHeaderProps } = useTableHeader(getProps, slots, handlers);
    const {
      getFormProps,
      replaceFormSlotKey,
      getFormSlotKeys,
      handleSearchInfoChange,
      handleUpdateSchemes
    } = useTableForm(getProps, slots, fetch, getLoading);
    const getBindValues = computed(() => {
      const rowKey2 = unref(getRowKeyRef);
      let propsData = __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, attrs), {
        rowEventHandlers
      }), unref(getProps)), {
        tableLayout: "fixed"
      }), unref(getRowSelectionRef)), {
        rowKey: typeof rowKey2 === "string" ? rowKey2 : void 0,
        onResizeColumn: handleResizeColumn
      }), unref(getExpandedBindsRef)), {
        topTabs: {
          activedKey,
          tabs,
          handleTabClick
        }
      });
      Reflect.deleteProperty(propsData, "onScroll");
      Reflect.deleteProperty(propsData, "class");
      Reflect.deleteProperty(propsData, "onChange");
      return propsData;
    });
    const getWrapperClass = computed(() => {
      var _a2;
      const values = unref(getBindValues);
      return [
        prefixCls2,
        attrs.class,
        "fbu-virtual-table",
        {
          [`${prefixCls2}-form-container`]: values.useSearchForm,
          [`${prefixCls2}--inset`]: values.inset,
          [`${prefixCls2}--no-title-empty`]: values.fixTitleEmpty,
          [`${prefixCls2}--no-pagination`]: values.customPagination,
          [`fbu-virtual-table--if-empty`]: ((_a2 = tableData.value) == null ? void 0 : _a2.length) === 0
        }
      ];
    });
    const getEmptyDataIsShowTable = computed(() => {
      const { emptyDataIsShowTable, useSearchForm } = unref(getProps);
      if (emptyDataIsShowTable || !useSearchForm) {
        return true;
      }
      return !!unref(getDataSourceRef).length;
    });
    function setProps(props22) {
      innerPropsRef.value = __spreadValues(__spreadValues({}, unref(innerPropsRef)), props22);
    }
    const tableAction = {
      reload,
      getSelectRows,
      clearSelectedRowKeys,
      getSelectRowKeys,
      deleteSelectRowByKey,
      setPagination: setPaginationConfig,
      setTableData,
      updateTableDataRecord,
      deleteTableDataRecord,
      insertTableDataRecord,
      findTableDataRecord,
      setSelectedRowKeys,
      setColumns,
      setLoading,
      getLoading: () => getLoading,
      getDataSource,
      getRawDataSource,
      setProps,
      getRowSelection,
      getPaginationRef: getPaginationBinds,
      getColumns,
      getCacheColumns,
      getMutationColumns,
      resetColumns,
      emit,
      updateTableData,
      setShowPagination,
      getShowPagination,
      setCacheColumnsByField,
      expandAll,
      expandRows,
      collapseAll,
      getSize: () => {
        return unref(getBindValues).size;
      },
      setEmptyText,
      scrollToTop: (scrollTop) => {
        var _a2;
        (_a2 = tableElRef.value) == null ? void 0 : _a2.scrollToTop(scrollTop);
      },
      scrollToRow: (row, strategy) => {
        var _a2;
        (_a2 = tableElRef.value) == null ? void 0 : _a2.scrollToRow(row, strategy);
      },
      scrollTo: (pos) => {
        var _a2;
        (_a2 = tableElRef.value) == null ? void 0 : _a2.scrollTo(pos);
      },
      scrollToLeft: (scrollLeft) => {
        var _a2;
        (_a2 = tableElRef.value) == null ? void 0 : _a2.scrollToLeft(scrollLeft);
      }
    };
    createTableContext(__spreadProps(__spreadValues({}, tableAction), {
      wrapRef,
      getBindValues,
      getPaginationInfo,
      setSearchStateSortInfo
    }));
    expose(tableAction);
    emit("register", tableAction, formActions);
    const { height: realHeight } = useWindowSize({
      initialHeight: props2.height || 800,
      fixedHeight: props2.fixedHeight
    });
    const tableScrollBtnsRef = ref();
    const handleScroll = (scrollParams) => {
      var _a2;
      emit("customer-scroll", scrollParams);
      if (tableScrollBtnsRef.value) {
        (_a2 = tableScrollBtnsRef.value) == null ? void 0 : _a2.updateScrollLeft(scrollParams.scrollLeft);
      }
    };
    return {
      formRef,
      tableElRef,
      getBindValues,
      getLoading,
      registerForm,
      handleSearchInfoChange,
      getEmptyDataIsShowTable,
      handleTableChange,
      getRowClassName,
      wrapRef,
      tableAction,
      getFormProps,
      replaceFormSlotKey,
      getFormSlotKeys,
      getWrapperClass,
      columns: toRaw(unref(getViewColumns)),
      SETTING_COLUMN_INDEX,
      handleReset,
      getPaginationInfo,
      handlers,
      simpleImage: Empty$2.PRESENTED_IMAGE_SIMPLE,
      emptyText: emptyTextRef,
      handleUpdateSchemes,
      getDataSourceRef,
      tableData,
      showTableTitle,
      getHeaderProps,
      realHeight,
      activedKey,
      tabs,
      handleTabClick,
      setTabsElHeight,
      tabsElHeight,
      handleScroll,
      tableScrollBtnsRef
    };
  }
});
const _hoisted_1 = { class: "fbu-table-wrapper" };
const _hoisted_2 = {
  key: 0,
  class: "fbu-table-top"
};
const _hoisted_3 = ["title"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FbuForm = resolveComponent("FbuForm");
  const _component_TableTabs = resolveComponent("TableTabs");
  const _component_TableHeader = resolveComponent("TableHeader");
  const _component_Empty = resolveComponent("Empty");
  const _component_ThCustomSorter = resolveComponent("ThCustomSorter");
  const _component_TableV2 = resolveComponent("TableV2");
  const _component_ElAutoResizer = resolveComponent("ElAutoResizer");
  const _component_TableScrollBtns = resolveComponent("TableScrollBtns");
  const _component_CustomPagination = resolveComponent("CustomPagination");
  const _component_Spin = resolveComponent("Spin");
  return openBlock(), createElementBlock("div", {
    ref: "wrapRef",
    class: normalizeClass(_ctx.getWrapperClass)
  }, [
    _ctx.getBindValues.useSearchForm ? (openBlock(), createBlock(_component_FbuForm, mergeProps({
      key: 0,
      ref: "formRef",
      submitOnReset: ""
    }, _ctx.getFormProps, {
      tableAction: _ctx.tableAction,
      onRegister: _ctx.registerForm,
      onSubmit: _ctx.handleSearchInfoChange,
      onReset: _ctx.handleReset,
      onUpdateSchemes: _ctx.handleUpdateSchemes
    }), createSlots({ _: 2 }, [
      renderList(_ctx.getFormSlotKeys, (item) => {
        return {
          name: _ctx.replaceFormSlotKey(item),
          fn: withCtx((data6) => [
            renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})))
          ])
        };
      })
    ]), 1040, ["tableAction", "onRegister", "onSubmit", "onReset", "onUpdateSchemes"])) : createCommentVNode("", true),
    createVNode(_component_Spin, { spinning: _ctx.getLoading }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1, [
          _ctx.$slots.tableTop ? (openBlock(), createElementBlock("div", _hoisted_2, [
            renderSlot(_ctx.$slots, "tableTop")
          ])) : createCommentVNode("", true),
          createVNode(_component_TableTabs, {
            value: _ctx.activedKey,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => _ctx.activedKey = $event),
            tabs: _ctx.tabs,
            onTabClick: _ctx.handleTabClick,
            onTabHeightChange: _ctx.setTabsElHeight
          }, null, 8, ["value", "tabs", "onTabClick", "onTabHeightChange"]),
          !_ctx.getHeaderProps.hideTitle ? (openBlock(), createBlock(_component_TableHeader, normalizeProps(mergeProps({ key: 1 }, _ctx.getHeaderProps)), createSlots({ _: 2 }, [
            renderList(Object.keys(_ctx.getHeaderProps.slots), (slotName) => {
              return {
                name: slotName,
                fn: withCtx((data6) => [
                  renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(data6 || {})))
                ])
              };
            })
          ]), 1040)) : createCommentVNode("", true),
          createVNode(_component_ElAutoResizer, {
            style: normalizeStyle({ height: `${_ctx.realHeight - 60 - _ctx.tabsElHeight}px` })
          }, {
            default: withCtx(({ height, width }) => [
              withDirectives(createVNode(_component_TableV2, mergeProps({ ref: "tableElRef" }, _ctx.getBindValues, {
                "row-class": ({ rowData, rowIndex }) => _ctx.getRowClassName(rowData, rowIndex),
                data: _ctx.tableData,
                columns: _ctx.columns,
                width,
                height,
                onScroll: _ctx.handleScroll
              }), createSlots({
                empty: withCtx(() => [
                  createVNode(_component_Empty, {
                    image: _ctx.simpleImage,
                    description: _ctx.emptyText
                  }, null, 8, ["image", "description"])
                ]),
                cell: withCtx(({ cellData, column, rowData, rowIndex }) => [
                  renderSlot(_ctx.$slots, "bodyCell", normalizeProps(guardReactiveProps({ text: cellData, record: rowData, index: rowIndex, column })))
                ]),
                "header-cell": withCtx(({ column }) => [
                  column && column.customSorter ? (openBlock(), createBlock(_component_ThCustomSorter, {
                    key: 0,
                    title: column.title,
                    "custom-sorter-render": column.customSorterRender,
                    "custom-sorter-fetch-key": column.customSorterFetchKey,
                    "custom-sorter-list": column.customSorter
                  }, null, 8, ["title", "custom-sorter-render", "custom-sorter-fetch-key", "custom-sorter-list"])) : renderSlot(_ctx.$slots, "headerCell", normalizeProps(mergeProps({ key: 1 }, { column })), () => [
                    createElementVNode("span", {
                      title: column.title
                    }, toDisplayString(column.title), 9, _hoisted_3)
                  ])
                ]),
                _: 2
              }, [
                renderList(Object.keys(_ctx.$slots).filter((slot) => slot !== "headerCell" && slot !== "empty" && slot !== "cell"), (item) => {
                  return {
                    name: item,
                    fn: withCtx((data6) => [
                      renderSlot(_ctx.$slots, item, normalizeProps(guardReactiveProps(data6 || {})))
                    ])
                  };
                })
              ]), 1040, ["row-class", "data", "columns", "width", "height", "onScroll"]), [
                [vShow, _ctx.getEmptyDataIsShowTable]
              ])
            ]),
            _: 3
          }, 8, ["style"]),
          createVNode(_component_TableScrollBtns, { ref: "tableScrollBtnsRef" }, null, 512),
          _ctx.customPagination ? (openBlock(), createBlock(_component_CustomPagination, {
            key: 2,
            max: _ctx.customMaxPageSize,
            "after-suffix": _ctx.customPaginationSizeChangerSuffix
          }, null, 8, ["max", "after-suffix"])) : createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["spinning"])
  ], 2);
}
var FbuVirtaulTable = /* @__PURE__ */ _export_sfc$1(_sfc_main, [["render", _sfc_render]]);
var SortOrder;
(function(SortOrder2) {
  SortOrder2["ASC"] = "asc";
  SortOrder2["DESC"] = "desc";
})(SortOrder || (SortOrder = {}));
function useVirtualTable(tableProps3) {
  const tableRef = ref(null);
  const loadedRef = ref(false);
  const formRef = ref(null);
  let stopWatch;
  function register3(instance2, formInstance) {
    onUnmounted(() => {
      tableRef.value = null;
      loadedRef.value = null;
    });
    if (unref(loadedRef) && instance2 === unref(tableRef)) {
      return;
    }
    tableRef.value = instance2;
    formRef.value = formInstance;
    tableProps3 && instance2.setProps(getDynamicProps(tableProps3));
    loadedRef.value = true;
    stopWatch == null ? void 0 : stopWatch();
    stopWatch = watch(() => tableProps3, () => {
      tableProps3 && instance2.setProps(getDynamicProps(tableProps3));
    }, {
      immediate: true,
      deep: true
    });
  }
  function getTableInstance() {
    const table = unref(tableRef);
    if (!table) {
      console.error("\u8BF7\u5148\u7ED1\u5B9A\u8868\u683C\u5B9E\u4F8B!");
    }
    return table;
  }
  const methods = {
    reload: async (opt) => {
      return await getTableInstance().reload(opt);
    },
    setProps: (props2) => {
      getTableInstance().setProps(props2);
    },
    setLoading: (loading) => {
      getTableInstance().setLoading(loading);
    },
    getLoading: () => {
      return getTableInstance().getLoading();
    },
    getDataSource: () => {
      return getTableInstance().getDataSource();
    },
    getRawDataSource: () => {
      return getTableInstance().getRawDataSource();
    },
    getColumns: ({ ignoreIndex = false } = {}) => {
      const columns2 = getTableInstance().getColumns({ ignoreIndex }) || [];
      return toRaw(columns2);
    },
    setColumns: (columns2) => {
      getTableInstance().setColumns(columns2);
    },
    setTableData: (values) => {
      return getTableInstance().setTableData(values);
    },
    setPagination: (info) => {
      return getTableInstance().setPagination(info);
    },
    deleteSelectRowByKey: (key2) => {
      getTableInstance().deleteSelectRowByKey(key2);
    },
    getSelectRowKeys: () => {
      return toRaw(getTableInstance().getSelectRowKeys());
    },
    getSelectRows: () => {
      return toRaw(getTableInstance().getSelectRows());
    },
    clearSelectedRowKeys: () => {
      getTableInstance().clearSelectedRowKeys();
    },
    setSelectedRowKeys: (keys2) => {
      getTableInstance().setSelectedRowKeys(keys2);
    },
    getPaginationRef: () => {
      return getTableInstance().getPaginationRef();
    },
    getSize: () => {
      return toRaw(getTableInstance().getSize());
    },
    updateTableData: (index2, key2, value) => {
      return getTableInstance().updateTableData(index2, key2, value);
    },
    deleteTableDataRecord: (rowKey2) => {
      return getTableInstance().deleteTableDataRecord(rowKey2);
    },
    insertTableDataRecord: (record, index2) => {
      return getTableInstance().insertTableDataRecord(record, index2);
    },
    updateTableDataRecord: (rowKey2, record) => {
      return getTableInstance().updateTableDataRecord(rowKey2, record);
    },
    findTableDataRecord: (rowKey2) => {
      return getTableInstance().findTableDataRecord(rowKey2);
    },
    getRowSelection: () => {
      return toRaw(getTableInstance().getRowSelection());
    },
    getCacheColumns: () => {
      return toRaw(getTableInstance().getCacheColumns());
    },
    getForm: () => {
      return unref(formRef);
    },
    setShowPagination: async (show) => {
      getTableInstance().setShowPagination(show);
    },
    getShowPagination: () => {
      return toRaw(getTableInstance().getShowPagination());
    },
    expandAll: () => {
      getTableInstance().expandAll();
    },
    collapseAll: () => {
      getTableInstance().collapseAll();
    },
    expandRows: (keys2) => {
      getTableInstance().expandRows(keys2);
    },
    scrollTo: (pos) => {
      getTableInstance().scrollTo(pos);
    },
    getMutationColumns: () => {
      return getTableInstance().getMutationColumns();
    },
    resetColumns: () => {
      getTableInstance().resetColumns();
    },
    setEmptyText: (text) => {
      getTableInstance().setEmptyText(text);
    },
    scrollToTop: (scrollTop) => {
      getTableInstance().scrollToTop(scrollTop);
    },
    scrollToRow: (row, strategy) => {
      getTableInstance().scrollToRow(row, strategy);
    },
    scrollToLeft: (scrollLeft) => {
      getTableInstance().scrollToLeft(scrollLeft);
    }
  };
  return [register3, methods];
}
FbuVirtaulTable.install = function(app) {
  app.component(FbuVirtaulTable.name, FbuVirtaulTable);
  return app;
};
var components = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  FbuAppProvider: index$9,
  FbuButton: Button,
  PopconfirmButton: _sfc_main$P,
  FbuDateRangePicker: DateRangePicker,
  FbuRadioGroup: radioGroup,
  FbuPagination: index$8,
  FbuModal,
  FbuResult: index$7,
  FbuSvgIcon: SvgIcon,
  FbuQrcode: index$6,
  FbuBarcode: index$5,
  FbuDescriptions: index$4,
  FbuSelect,
  FbuPreview: index$3,
  createImageViewer,
  FbuCountdown: CountDown,
  FbuApiTreeSelect: ApiTreeSelect,
  FbuApiCascader: ApiCascader,
  FbuApiRadioGroup: ApiRadioGroup,
  FbuApiSelect: ApiSelect,
  FbuHelpTooltip,
  FbuForm,
  useComponentRegister: useComponentRegister$1,
  useForm,
  FbuSelectInput: SelectInput,
  FbuDropdown,
  FbuTable,
  useTable: useTable$1,
  useTableComponentRegister: useComponentRegister,
  clearCachedColumns,
  FbuTableSummary: TableSummary,
  FbuTableSummaryRow: TableSummaryRow,
  FbuTableSummaryCell: TableSummaryCell,
  FbuExpandedSelect: ExpandedSelect,
  FbuVirtualTable: FbuVirtaulTable,
  useVirtualTable,
  get FixedDir() {
    return FixedDir;
  }
});
var index$1 = "";
async function changeDayjsLocale(locale2) {
  dayjs.locale(locale2);
}
const hooks = {
  useMessage,
  useContext,
  usePrefixCls,
  useQRCode,
  useBarcode
};
function setupGlobalHooks(app) {
  app.config.globalProperties.fbuHooks = hooks;
}
var Ripple = "";
function position(e2) {
  return {
    x: e2.clientX,
    y: e2.clientY
  };
}
function stop(e2) {
  e2.stopPropagation();
}
function start(e2) {
  const el = e2.currentTarget;
  const ctx = el.__rippleCtx;
  if (ctx.modifiers.stop === true) {
    stop(e2);
  }
  if (ctx.enable === true) {
    showRipple(e2, el, ctx);
  }
}
function showRipple(e2, el, ctx) {
  const elPosition = style(el, "position");
  if (elPosition === "static") {
    css$1(el, { position: "relative" });
  }
  const rippleWrapNode = document.createElement("span");
  const rippleNode = document.createElement("span");
  const { left, top, width, height } = boundingRect(el);
  const pos = position(e2);
  const diameter = Math.sqrt(width * width + height * height);
  const radius = diameter / 2;
  const centerX = (width - diameter) / 2 + "px";
  const centerY = (height - diameter) / 2 + "px";
  const leftX = (ctx.modifiers.center ? centerX : pos.x - left - radius) + "px";
  const topY = (ctx.modifiers.center ? centerY : pos.y - top - radius) + "px";
  rippleWrapNode.classList.add("ripple-wrap");
  rippleNode.classList.add("ripple");
  css$1(rippleNode, {
    width: diameter + "px",
    height: diameter + "px",
    opacity: 0,
    transform: `translate3d(${leftX}, ${topY}, 0) scale3d(.2, .2, 1)`
  });
  rippleWrapNode.appendChild(rippleNode);
  el.appendChild(rippleWrapNode);
  el.__timer = setTimeout(() => {
    rippleNode.classList.add("ripple--enter");
    rippleNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
    rippleNode.style.opacity = "0.2";
    el.__timer = setTimeout(() => {
      rippleNode.classList.remove("ripple--enter");
      rippleNode.classList.add("ripple--leave");
      rippleNode.style.opacity = "0";
      el.__timer = setTimeout(() => {
        rippleWrapNode.remove();
        el.style.position = elPosition;
      }, 275);
    }, 250);
  }, 50);
}
function updateModifers(ctx, binding) {
  const { modifiers } = binding;
  ctx.modifiers = {
    stop: modifiers.stop,
    center: modifiers.center
  };
}
const ripple = {
  beforeMount(el, binding) {
    const ctx = {
      enable: binding.value !== false,
      modifiers: {}
    };
    updateModifers(ctx, binding);
    el.__rippleCtx = ctx;
    el.addEventListener("click", start, false);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      const ctx = el.__rippleCtx;
      ctx.enable = binding.value !== false;
      if (ctx.enable && isObject$1(binding.value)) {
        updateModifers(ctx, binding);
      }
    }
  },
  unmounted(el) {
    clearTimeout(el.__timer);
    el.removeEventListener("click", start);
    Reflect.deleteProperty(el, "__rippleCtx");
  }
};
var Rippple = {
  name: "ripple",
  definition: ripple
};
const focus = (el, binding) => {
  if (binding.value) {
    el.focus();
  }
};
var InputFocus = {
  name: "focus",
  definition: focus
};
const draggable = {
  mounted(el) {
    const positionStr = style(el, "position");
    if (positionStr === "static") {
      return;
    }
    const cursor = style(el, "cursor");
    const contain = style(el, "contain");
    const { width, height } = boundingRect(el);
    css$1(el, { position: "absolute" });
    el.addEventListener("mousedown", onMouseDown2, false);
    function onMouseDown2() {
      css$1(el, { cursor: "move", userSelect: "none", contain: "strict" });
      document.addEventListener("mousemove", onMouseMove3, false);
      document.addEventListener("mouseup", onMouseUp2, false);
    }
    function onMouseMove3(e2) {
      const { movementX, movementY } = e2;
      const bodyClientWidth = document.body.clientWidth;
      const bodyClientHeight = document.body.clientHeight;
      const getStyle2 = getComputedStyle(el);
      const curLeft = Number.parseInt(getStyle2.getPropertyValue("left"));
      const curTop = Number.parseInt(getStyle2.getPropertyValue("top"));
      const nextLeft = curLeft + movementX;
      const nextTop = curTop + movementY;
      const left = Math.max(0, Math.min(bodyClientWidth - width, nextLeft));
      const top = Math.max(0, Math.min(bodyClientHeight - height, nextTop));
      css$1(el, {
        left: left + "px",
        top: top + "px"
      });
    }
    function onMouseUp2() {
      css$1(el, { cursor, contain });
      document.removeEventListener("mousemove", onMouseMove3);
      document.removeEventListener("mouseup", onMouseUp2);
    }
  }
};
var Draggable = {
  name: "draggable",
  definition: draggable
};
const directives = [Rippple, InputFocus, Draggable, ClickOutside];
function setupDirectives(app) {
  directives.forEach((directive) => {
    app.directive(prefixCls + "" + directive.name.replace(/^\w/, (m2) => m2.toUpperCase()), directive.definition);
  });
}
const install9 = function(app) {
  Object.keys(components).forEach((key2) => {
    const component = components[key2];
    if (component.install) {
      app.use(component);
    }
  });
  setupGlobalHooks(app);
  setupDirectives(app);
  return app;
};
var index = {
  install: install9
};
export { ApiCascader as FbuApiCascader, ApiRadioGroup as FbuApiRadioGroup, ApiSelect as FbuApiSelect, ApiTreeSelect as FbuApiTreeSelect, index$9 as FbuAppProvider, index$5 as FbuBarcode, Button as FbuButton, CountDown as FbuCountdown, DateRangePicker as FbuDateRangePicker, index$4 as FbuDescriptions, FbuDropdown, ExpandedSelect as FbuExpandedSelect, FbuForm, FbuHelpTooltip, FbuModal, index$8 as FbuPagination, index$3 as FbuPreview, index$6 as FbuQrcode, radioGroup as FbuRadioGroup, index$7 as FbuResult, FbuSelect, SelectInput as FbuSelectInput, SvgIcon as FbuSvgIcon, FbuTable, TableSummary as FbuTableSummary, TableSummaryCell as FbuTableSummaryCell, TableSummaryRow as FbuTableSummaryRow, FbuVirtaulTable as FbuVirtualTable, FixedDir, _sfc_main$P as PopconfirmButton, changeDayjsLocale, clearCachedColumns, createImageViewer, index as default, hooks, install9 as install, useComponentRegister$1 as useComponentRegister, useForm, useTable$1 as useTable, useComponentRegister as useTableComponentRegister, useVirtualTable };
